
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1911"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1911"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.8" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("3Tvfn", function(module, exports) {

$parcel$export(module.exports, "defineCustomElements", () => Rr);

var $696Z8 = parcelRequire("696Z8");
const i$p = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ce321a0739c785b655c6483c94ace4248f7adcbb",
            class: "market-accessory",
            size: this.size
        }, (0, $696Z8.h)("slot", {
            key: "4190735a507d572868ad9f54da6a6039a66794e5"
        }));
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;justify-content:center;align-items:center}:host(:focus-visible){border-radius:var(--core-radius-66)}:host([size="icon"]){width:var(--accessory-icon-variant-medium-size-width);height:var(--accessory-icon-variant-medium-size-height)}:host([size="image"]){width:var(--accessory-medium-size-width);height:var(--accessory-medium-size-height)}:host ::slotted(.market-icon){}:host ::slotted(img){-o-object-fit:cover;object-fit:cover;width:100%;height:100%}:host([size="icon"]) ::slotted(img){border-radius:var(--accessory-background-radius)}:host([size="image"]) ::slotted(img){border-radius:var(--accessory-background-radius)}';
    }
}, [
    257,
    "market-accessory",
    {
        size: [
            1
        ]
    }
]), c$x = i$p;
const s$v = "chevron-down", a$u = "chevron-down", r$i = "chevron-down", g$d = "ellipsis-horizontal", b$c = 8, n$H = 240, o$n = 100, h$h = 160, e$j = "rgb(0, 106, 255)", t$c = 599, c$w = "rgb(102, 74, 46)", i$o = "rgb(153, 8, 56)", v$9 = "rgb(25, 128, 42)", x$a = "rgb(255, 159, 64)", d$m = "rgb(0, 178, 59)", l$t = 8, w$9 = "rgb(242, 91, 61)", p$c = "rgb(217, 54, 176)", C$5 = "rgb(135, 22, 217)", S$a = "rgb(204, 0, 35)", T$7 = "rgb(38, 147, 255)", z$6 = "rgb(166, 124, 83)", f$e = "rgb(18, 191, 148)", j$b = "Cash Sans Text", k$7 = 14, m$a = "Cash Sans Text", q$4 = 16, u$j = "rgb(255, 191, 0)", y$b = "x", A$7 = 240, B$5 = 160, D$9 = 240, E$6 = 160, F$5 = 240, G$4 = 160, H$5 = 6, I$4 = 8, J$2 = 26, K$3 = 2, L$5 = 2, M$7 = "chevron-right", N$5 = "chevron-right", O$8 = 4, R$5 = 320;
let n$G;
function l$s(l2) {
    return new Proxy((n2)=>n2, {
        apply: (l3, o2, i2)=>Reflect.apply(null != n$G ? n$G : l3, o2, i2)
    })(l2);
}
const o$m = (l2)=>{
    n$G = l2;
};
function i$n(n2, o2) {
    var i2, t;
    return (null === (t = null === (i2 = null == n2 ? void 0 : n2.tagName) || void 0 === i2 ? void 0 : i2.toLowerCase) || void 0 === t ? void 0 : t.call(i2)) === l$s(o2);
}
const h$g = {
    large: "2",
    medium: "3",
    small: "4"
}, l$r = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(a2){
        super(), false !== a2 && this.__registerHost(), this.__attachShadow(), this.marketAccordionItemExpandedChange = (0, $696Z8.createEvent)(this, "marketAccordionItemExpandedChange", 7), this.expanded = false, this.disabled = false, this.size = "medium";
    }
    marketAccordionToggleHandler(a2) {
        a2.stopPropagation(), this.setExpanded(!this.expanded);
    }
    setExpanded(a2) {
        if (a2 !== this.expanded) {
            const { defaultPrevented: t2 } = this.marketAccordionItemExpandedChange.emit({
                expanded: a2
            });
            t2 || (this.expanded = a2, this.customTrigger && (this.customTrigger.expanded = a2));
        }
        return Promise.resolve();
    }
    setDisabled(a2) {
        return this.disabled = a2, Promise.resolve();
    }
    getAccordionIcon() {
        switch(this.size){
            case "small":
                return s$v;
            case "large":
                return r$i;
            default:
                return a$u;
        }
    }
    componentWillLoad() {
        this.customTrigger = this.el.querySelector('[slot="custom-trigger"]'), this.customTrigger && (this.customTrigger.expanded = this.expanded);
    }
    render() {
        const a2 = "h" + h$g[this.size], t2 = l$s("market-icon");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "f46df366e96e2b290c66104eb4acd62c54418c30",
            class: "market-accordion-item"
        }, this.customTrigger ? (0, $696Z8.h)("slot", {
            name: "custom-trigger"
        }) : (0, $696Z8.h)(a2, null, (0, $696Z8.h)("button", {
            id: this.name + "__button",
            type: "button",
            "aria-expanded": this.expanded,
            "aria-controls": this.name + "__content",
            "aria-disabled": this.disabled,
            disabled: this.disabled,
            onClick: ()=>this.setExpanded(!this.expanded)
        }, (0, $696Z8.h)("slot", {
            name: "label"
        }), (0, $696Z8.h)(t2, {
            name: this.getAccordionIcon()
        }))), (0, $696Z8.h)("div", {
            key: "26603411edb59a8160ac9306e47a656c24f82067",
            id: this.name + "__content",
            class: "accordion-content",
            role: "region",
            "aria-labelledby": this.name + "__button",
            hidden: !this.expanded
        }, (0, $696Z8.h)("slot", {
            key: "8125805872ddfcaea79120380c8ff4c9a27d4c5c"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host{display:block;box-shadow:inset     0     calc(var(--accordion-heading-30-variant-separator-size) * -1)     0     var(--accordion-heading-30-variant-separator-color)}:host .market-icon{transition-duration:var(         --accordion-normal-state-accessory-transition-duration,         var(--core-animation-exit-transition-slow-speed-duration)       )}:host .accordion-content[hidden]{display:none}button{all:unset;display:flex;justify-content:space-between;align-items:center;width:100%;color:var(--accordion-normal-state-content-color);cursor:pointer}button:focus-visible{border-radius:var(--core-radius-66);outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color)}button:hover{color:var(--accordion-hover-state-content-color)}button:active{color:var(--accordion-pressed-state-content-color)}:host([expanded]) .market-icon{transform:rotate(-180deg)}:host([expanded]) .accordion-content{display:block}:host([disabled]) button{color:var(--accordion-disabled-state-content-color);cursor:not-allowed;pointer-events:none}h2{margin:0;font-weight:var(--accordion-heading-30-variant-text-weight);font-size:var(--accordion-heading-30-variant-text-size);font-family:var(--accordion-heading-30-variant-text-font-family)}h2 button{padding:var(--accordion-heading-30-variant-vertical-padding)       var(--accordion-heading-30-variant-horizontal-padding)}h2+.accordion-content{padding-bottom:var(--accordion-heading-30-variant-vertical-padding)}h2 .market-icon{width:var(--accordion-heading-30-variant-expanded-phase-icon-width);height:var(--accordion-heading-30-variant-expanded-phase-icon-height)}h3{margin:0;font-weight:var(--accordion-heading-20-variant-text-weight);font-size:var(--accordion-heading-20-variant-text-size);font-family:var(--accordion-heading-20-variant-text-font-family)}h3 button{padding:var(--accordion-heading-20-variant-vertical-padding)       var(--accordion-heading-20-variant-horizontal-padding)}h3+.accordion-content{padding-bottom:var(--accordion-heading-20-variant-vertical-padding)}h3 .market-icon{width:var(--accordion-heading-20-variant-expanded-phase-icon-width);height:var(--accordion-heading-20-variant-expanded-phase-icon-height)}h4{margin:0;font-weight:var(--accordion-heading-10-variant-text-weight);font-size:var(--accordion-heading-10-variant-text-size);font-family:var(--accordion-heading-10-variant-text-font-family)}h4 button{padding:var(--accordion-heading-10-variant-vertical-padding)       var(--accordion-heading-10-variant-horizontal-padding)}h4+.accordion-content{padding-bottom:var(--accordion-heading-10-variant-vertical-padding)}h4 .market-icon{width:var(--accordion-heading-10-variant-expanded-phase-icon-width);height:var(--accordion-heading-10-variant-expanded-phase-icon-height)}:host([size="medium"]) svg{width:20px;height:20px}:host([size="small"]) svg{width:16px;height:16px}';
    }
}, [
    257,
    "market-accordion-item",
    {
        name: [
            513
        ],
        expanded: [
            1540
        ],
        disabled: [
            1540
        ],
        size: [
            513
        ],
        customTrigger: [
            32
        ],
        setExpanded: [
            64
        ],
        setDisabled: [
            64
        ]
    },
    [
        [
            0,
            "marketAccordionToggled",
            "marketAccordionToggleHandler"
        ]
    ]
]), g$c = l$r;
function r$h(r2) {
    return (null == r2 ? void 0 : r2.tagName) === l$s("market-checkbox").toUpperCase();
}
function o$l(r2) {
    return (null == r2 ? void 0 : r2.tagName) === l$s("market-radio").toUpperCase();
}
function t$b(r2) {
    return (null == r2 ? void 0 : r2.tagName) === l$s("market-row").toUpperCase();
}
function e$i(r2) {
    return (null == r2 ? void 0 : r2.tagName) === l$s("market-toggle").toUpperCase();
}
const n$F = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketCardSelected = (0, $696Z8.createEvent)(this, "marketCardSelected", 7), this.marketCardDeselected = (0, $696Z8.createEvent)(this, "marketCardDeselected", 7), this.selected = false, this.disabled = false, this.transient = false;
    }
    handleRowSelection(t2) {
        this.select(), t2.stopPropagation();
    }
    handleRowDeselection(t2) {
        this.deselect(), t2.stopPropagation();
    }
    async select() {
        var t2, e2;
        this.selected = true, await (null === (t2 = this.rowEl) || void 0 === t2 ? void 0 : t2.silentlySelect());
        const { defaultPrevented: a2 } = this.marketCardSelected.emit({
            value: this.value
        });
        a2 && (this.selected = false, await (null === (e2 = this.rowEl) || void 0 === e2 ? void 0 : e2.silentlyDeselect()));
    }
    async deselect() {
        var t2, e2;
        this.selected = false, await (null === (t2 = this.rowEl) || void 0 === t2 ? void 0 : t2.silentlyDeselect());
        const { defaultPrevented: a2 } = this.marketCardDeselected.emit({
            value: this.value
        });
        a2 && (this.selected = true, await (null === (e2 = this.rowEl) || void 0 === e2 ? void 0 : e2.silentlySelect()));
    }
    async silentlySelect() {
        var t2;
        return this.selected = true, await (null === (t2 = this.rowEl) || void 0 === t2 ? void 0 : t2.silentlySelect()), Promise.resolve();
    }
    async silentlyDeselect() {
        var t2;
        return this.selected = false, await (null === (t2 = this.rowEl) || void 0 === t2 ? void 0 : t2.silentlyDeselect()), Promise.resolve();
    }
    isContentEditable(t2) {
        return [
            "input",
            "textarea"
        ].some((e2)=>t2.tagName.includes(e2)) || t2.isContentEditable;
    }
    handleClick(t2) {
        this.isContentEditable(t2.target) || this.disabled || this.transient || this.rowEl || (this.selected ? this.deselect() : this.select());
    }
    handleKeydown(t2) {
        this.isContentEditable(t2.target) || "Enter" !== t2.key && " " !== t2.key || (t2.preventDefault(), this.rowEl ? this.rowEl.click() : this.el.click());
    }
    removeRowTabIndex() {
        this.rowEl && requestAnimationFrame(()=>{
            var t2;
            this.rowEl.removeAttribute("tabIndex");
            const e2 = null === (t2 = this.rowEl.shadowRoot) || void 0 === t2 ? void 0 : t2.querySelector('[part="container"]');
            e2 && e2.removeAttribute("tabIndex");
        });
    }
    syncRowAttributes() {
        this.rowEl && (this.rowEl.interactive = true, this.rowEl.selected = this.selected, this.removeRowTabIndex());
    }
    handleSlotChangeDefault() {
        this.rowEl = function(t2) {
            return (null == t2 ? void 0 : t2.children) ? [
                ...t2.children
            ].find(t$b) : null;
        }(this.el), this.el.classList.toggle("has-slotted-row", !!this.rowEl), this.syncRowAttributes();
    }
    componentDidRender() {
        this.removeRowTabIndex();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "a57225213ab23175a911512427b569a1f6deb3de",
            "aria-selected": "" + this.selected,
            class: "market-action-card",
            onClick: this.handleClick.bind(this),
            onKeydown: this.handleKeydown.bind(this),
            role: "option",
            tabindex: this.disabled ? null : "0"
        }, (0, $696Z8.h)("slot", {
            key: "d701fdd227fcd215d648fb7cf6100ea06f140b16",
            onSlotchange: ()=>this.handleSlotChangeDefault()
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--focus-ring-color:color-mix(in srgb, var(--action-card-focus-ring-color) 100%, transparent);display:block;padding:var(--action-card-padding-vertical-size) var(--action-card-padding-horizontal-size);border-radius:var(--action-card-border-radius);background-color:var(--action-card-background-color);box-shadow:inset     0     0     0     var(--action-card-normal-state-unselected-value-border-width)     var(--action-card-normal-state-unselected-value-border-color);opacity:var(--action-card-normal-state-content-opacity);cursor:pointer}:host(:hover){background-color:var(--action-card-hover-state-unselected-value-background-color);box-shadow:inset       0       0       0       var(--action-card-hover-state-unselected-value-border-width)       var(--action-card-hover-state-unselected-value-border-color)}:host(:active){background-color:var(--action-card-active-state-unselected-value-background-color);box-shadow:inset       0       0       0       var(--action-card-active-state-unselected-value-border-width)       var(--action-card-active-state-unselected-value-border-color)}:host([disabled]){box-shadow:inset       0       0       0       var(--action-card-disabled-state-unselected-value-border-width)       var(--action-card-disabled-state-unselected-value-border-color);opacity:var(--action-card-disabled-state-content-opacity)}:host([selected]){box-shadow:inset       0       0       0       var(--action-card-normal-state-selected-value-border-width)       var(--action-card-normal-state-selected-value-border-color)}:host([selected]:hover){background-color:var(--action-card-hover-state-selected-value-background-color);box-shadow:inset       0       0       0       var(--action-card-hover-state-selected-value-border-width)       var(--action-card-hover-state-selected-value-border-color)}:host([selected]:active){background-color:var(--action-card-active-state-selected-value-background-color);box-shadow:inset       0       0       0       var(--action-card-active-state-selected-value-border-width)       var(--action-card-active-state-selected-value-border-color)}:host([selected][disabled]){box-shadow:inset       0       0       0       var(--action-card-disabled-state-selected-value-border-width)       var(--action-card-disabled-state-selected-value-border-color)}:host(.has-slotted-row){padding:0 var(--row-background-horizontal-outset-padding)}:host(.has-slotted-row) ::slotted(.market-row){--row-normal-variant-hover-state-text-color:var(--row-normal-variant-normal-state-text-color);--row-normal-variant-hover-state-subtext-color:var(--row-normal-variant-normal-state-subtext-color);--row-normal-variant-hover-state-side-text-primary-color:var(--row-normal-variant-normal-state-side-text-primary-color);--row-normal-variant-hover-state-side-text-secondary-color:var(--row-normal-variant-normal-state-side-text-secondary-color);--row-normal-variant-selected-state-text-color:var(--row-normal-variant-normal-state-text-color);--row-normal-variant-selected-state-subtext-color:var(--row-normal-variant-normal-state-subtext-color);--row-normal-variant-selected-state-side-text-primary-color:var(--row-normal-variant-normal-state-side-text-primary-color);--row-normal-variant-selected-state-side-text-secondary-color:var(--row-normal-variant-normal-state-side-text-secondary-color);--row-normal-variant-pressed-state-text-color:var(--row-normal-variant-normal-state-text-color);--row-normal-variant-pressed-state-subtext-color:var(--row-normal-variant-normal-state-subtext-color);--row-normal-variant-pressed-state-side-text-primary-color:var(--row-normal-variant-normal-state-side-text-primary-color);--row-normal-variant-pressed-state-side-text-secondary-color:var(--row-normal-variant-normal-state-side-text-secondary-color);padding-right:calc(           var(--action-card-padding-horizontal-size) -           var(--row-normal-variant-background-horizontal-outset-padding)         );padding-left:calc(           var(--action-card-padding-horizontal-size) -           var(--row-normal-variant-background-horizontal-outset-padding)         );background-color:transparent}:host(:focus-visible){outline:var(--action-card-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--action-card-focus-ring-buffer-size)}";
    }
}, [
    257,
    "market-action-card",
    {
        selected: [
            1540
        ],
        disabled: [
            516
        ],
        value: [
            513
        ],
        transient: [
            4
        ],
        select: [
            64
        ],
        deselect: [
            64
        ],
        silentlySelect: [
            64
        ],
        silentlyDeselect: [
            64
        ]
    },
    [
        [
            0,
            "marketRowSelected",
            "handleRowSelection"
        ],
        [
            0,
            "marketRowDeselected",
            "handleRowDeselection"
        ]
    ]
]), l$q = n$F;
const a$t = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.size = "large";
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "bd0464dfe8ceef867367682e947c4b259104ab6a",
            class: "market-activity-indicator"
        }, (0, $696Z8.h)("svg", {
            key: "de27c5f6117b9fefc06c2516861bc0b89b88c31b",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "c2899af64c27c86f1032ecd20121bada6fe9e13c",
            "clip-rule": "evenodd",
            "fill-rule": "evenodd",
            d: "M21.3333 12C21.3333 6.84534 17.1547 2.66667 12 2.66667V0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12H2.66667C2.66667 17.1547 6.84534 21.3333 12 21.3333C17.1547 21.3333 21.3333 17.1547 21.3333 12Z"
        })));
    }
    static get style() {
        return ':root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:inline-block;overflow:hidden;width:var(--icon-width, 48px);height:var(--icon-height, 48px)}:host([size="small"]){--icon-width:var(--spinner-small-size-width, 24px);--icon-height:var(--spinner-small-size-height, 24px)}:host([size="large"]){--icon-width:var(--spinner-large-size-width, 48px);--icon-height:var(--spinner-large-size-height, 48px)}:host([size="x-large"]){--icon-width:var(--spinner-xlarge-size-width, 80px);--icon-height:var(--spinner-xlarge-size-height, 80px)}:host([size="xx-large"]){--icon-width:var(--spinner-xxlarge-size-width, 136px);--icon-height:var(--spinner-xxlarge-size-height, 136px)}:host svg{width:100%;height:100%;fill:currentcolor;animation:market-activity-indicator-rotation     var(--animation-infinite-duration)     var(--animation-infinite-iteration-count)     var(--animation-infinite-timing-function)}';
    }
}, [
    1,
    "market-activity-indicator",
    {
        size: [
            513
        ]
    }
]), n$E = a$t;
const e$h = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(r2){
        super(), false !== r2 && this.__registerHost(), this.__attachShadow(), this.value = 0, this.max = 1;
    }
    render() {
        const r2 = this.max > 0 ? this.max : 1, a2 = this.value > 0 ? Math.min(this.value, this.max) : 0, t2 = a2 / r2 * 100;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "61e07b33b68f0fea7810d5924e8a63b4f6af87a3",
            class: "market-activity-indicator-bar",
            role: "progressbar",
            "aria-valuenow": a2,
            "aria-valuemin": "0",
            "aria-valuemax": r2,
            "aria-valuetext": t2 + "%"
        }, (0, $696Z8.h)("progress", {
            key: "fda630a69882437f906a0cc5827af8a61746d338",
            value: a2,
            max: r2
        }, (0, $696Z8.h)("div", {
            key: "0b5ce28682aea994116a707e34b784e6dbe89069",
            class: "progress-bar"
        }, (0, $696Z8.h)("span", {
            key: "eb5a9381955d887d76eda7ea30327acbca9f5e60",
            style: {
                width: t2 + "%"
            }
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--activity-indicator-bar-height:4px;--activity-indicator-bar-border-radius:6px;--activity-indicator-bar-bar-color:var(--core-fill-40-color);--activity-indicator-bar-value-color:var(--core-emphasis-fill-color);display:block;height:var(--activity-indicator-bar-height)}progress{display:block;width:100%;height:100%;border:none;border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-bar-color);-webkit-appearance:none;-moz-appearance:none;appearance:none}progress[value]::-webkit-progress-value{border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-value-color)}progress[value]::-webkit-progress-bar,progress:not([value])::-webkit-progress-bar{border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-bar-color)}progress[value]::-moz-progress-bar{border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-value-color)}progress:not([value])::-moz-progress-bar{visibility:hidden}.progress-bar{width:100%;height:100%;border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-bar-color)}.progress-bar>span{display:block;height:100%;border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-value-color);text-indent:-9999px}";
    }
}, [
    1,
    "market-activity-indicator-bar",
    {
        value: [
            2
        ],
        max: [
            2
        ]
    }
]), s$u = e$h;
function t$a(...t2) {
    return t2.reduce((t3, e)=>{
        if ("string" == typeof e) t3.push(e);
        else if ("object" == typeof e) for (const o of Object.keys(e))e[o] && t3.push(o);
        return t3;
    }, []).join(" ");
}
var r$g, t$9 = new Uint8Array(16);
function o$k() {
    if (!r$g && !(r$g = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return r$g(t$9);
}
for(var n$D = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, e$g = [], i$m = 0; i$m < 256; ++i$m)e$g.push((i$m + 256).toString(16).substr(1));
function f$d(r2) {
    var t2 = (r2 = r2 || {}).random || (r2.rng || o$k)();
    return t2[6] = 15 & t2[6] | 64, t2[8] = 63 & t2[8] | 128, function(r3) {
        var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, o2 = (e$g[r3[t3 + 0]] + e$g[r3[t3 + 1]] + e$g[r3[t3 + 2]] + e$g[r3[t3 + 3]] + "-" + e$g[r3[t3 + 4]] + e$g[r3[t3 + 5]] + "-" + e$g[r3[t3 + 6]] + e$g[r3[t3 + 7]] + "-" + e$g[r3[t3 + 8]] + e$g[r3[t3 + 9]] + "-" + e$g[r3[t3 + 10]] + e$g[r3[t3 + 11]] + e$g[r3[t3 + 12]] + e$g[r3[t3 + 13]] + e$g[r3[t3 + 14]] + e$g[r3[t3 + 15]]).toLowerCase();
        if (!function(r4) {
            return "string" == typeof r4 && n$D.test(r4);
        }(o2)) throw TypeError("Stringified UUID is invalid");
        return o2;
    }(t2);
}
const c$v = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketBannerDismissed = (0, $696Z8.createEvent)(this, "marketBannerDismissed", 7), this.variant = "info", this.dismissable = false, this.dismissButtonAriaLabel = "Dismiss", this.iconImageTitle = "", this.hasTitle = false, this.hasAction = false, this.iconImageTitleId = f$d();
    }
    renderIcon() {
        return "success" === this.variant ? (0, $696Z8.h)("svg", {
            role: "img",
            "aria-labelledby": this.iconImageTitleId,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("title", {
            id: this.iconImageTitleId
        }, this.iconImageTitle || "Success"), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12ZM5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5C8.14 5 5 8.14 5 12ZM8.71005 10.8L11 13.09L15.3101 8.80005L16.72 10.21L11.72 15.21C11.52 15.4 11.27 15.5 11.01 15.5C10.75 15.5 10.5 15.41 10.3 15.21L7.30005 12.21L8.71005 10.8Z"
        })) : "info" === this.variant ? (0, $696Z8.h)("svg", {
            role: "img",
            "aria-labelledby": this.iconImageTitleId,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("title", {
            id: this.iconImageTitleId
        }, this.iconImageTitle || "Info"), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19ZM11 10.5V17H13V10.5H11ZM13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z"
        })) : "insight" === this.variant ? (0, $696Z8.h)("svg", {
            role: "img",
            "aria-labelledby": this.iconImageTitleId,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("title", {
            id: this.iconImageTitleId
        }, this.iconImageTitle || "Insight"), (0, $696Z8.h)("path", {
            d: "M11 23.1701V15.0001H3.07996L13 0.830078V9.00008H20.92L11 23.1701ZM6.91996 13.0001H13V16.8301L17.08 11.0001H11V7.17008L6.91996 13.0001Z"
        })) : "warning" === this.variant ? (0, $696Z8.h)("svg", {
            role: "img",
            "aria-labelledby": this.iconImageTitleId,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("title", {
            id: this.iconImageTitleId
        }, this.iconImageTitle || "Warning"), (0, $696Z8.h)("path", {
            d: "M11 9.00005H13V14.5H11V9.00005Z"
        }), (0, $696Z8.h)("path", {
            d: "M12 18C12.6904 18 13.25 17.4404 13.25 16.75C13.25 16.0596 12.6904 15.5 12 15.5C11.3096 15.5 10.75 16.0596 10.75 16.75C10.75 17.4404 11.3096 18 12 18Z"
        }), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.866 2.17944C12.6874 1.87004 12.3573 1.67944 12 1.67944C11.6427 1.67944 11.3126 1.87004 11.134 2.17944L1.13397 19.5C0.955342 19.8094 0.955342 20.1905 1.13397 20.5C1.31261 20.8094 1.64273 21 2 21H22C22.3573 21 22.6874 20.8094 22.866 20.5C23.0447 20.1905 23.0447 19.8094 22.866 19.5L12.866 2.17944ZM12 4.67944L20.268 19H3.73205L12 4.67944Z"
        })) : (0, $696Z8.h)("svg", {
            role: "img",
            "aria-labelledby": this.iconImageTitleId,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("title", {
            id: this.iconImageTitleId
        }, this.iconImageTitle || "Critical"), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21ZM12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5ZM12 17C12.6904 17 13.25 16.4404 13.25 15.75C13.25 15.0596 12.6904 14.5 12 14.5C11.3096 14.5 10.75 15.0596 10.75 15.75C10.75 16.4404 11.3096 17 12 17ZM11 7H13V13.5H11V7Z"
        }));
    }
    handleTitleSlotChange() {
        this.hasTitle = !!this.el.querySelector('[slot="title"]');
    }
    handleActionSlotChange() {
        this.hasAction = !!this.el.querySelector('[slot="action"]');
    }
    componentWillLoad() {
        this.handleTitleSlotChange(), this.handleActionSlotChange();
    }
    dismiss() {
        const { defaultPrevented: t2 } = this.marketBannerDismissed.emit();
        t2 || this.el.remove();
    }
    render() {
        const t2 = l$s("market-accessory");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "86cd70453071baa6af3f0ab31f8406d0fed38c71",
            class: "market-banner",
            role: "region",
            "aria-label": "Announcement"
        }, (0, $696Z8.h)("span", {
            key: "a7a74a512a93415f56cebcbf7f8d7e68edda7423",
            class: "icon-container"
        }, (0, $696Z8.h)("slot", {
            key: "c04634e431570f707694e46d01b16644b6edee52",
            name: "icon"
        }, (0, $696Z8.h)(t2, {
            key: "b84077a7101acf639bec4d285a3db629d879e44b"
        }, this.renderIcon()))), (0, $696Z8.h)("div", {
            key: "20661728e8cd83b0da68e233084936211029912d",
            class: t$a("main", {
                "has-title": this.hasTitle
            })
        }, (0, $696Z8.h)("section", {
            key: "aaf799d392b96ecccc6bff73846099a0be7727bb"
        }, (0, $696Z8.h)("header", {
            key: "dd563286ea9a51f0732837c0457e674e1e2070ba",
            class: "title"
        }, (0, $696Z8.h)("slot", {
            key: "5f073b724bf6135f1f45f2d970a9bf3cedfa5536",
            name: "title",
            onSlotchange: ()=>this.handleTitleSlotChange()
        })), (0, $696Z8.h)("slot", {
            key: "4d54ed708a3f9f62b910740d7b10325a2b81a7bb"
        })), (0, $696Z8.h)("nav", {
            key: "6aef96bcf28ec475635808b94e114431135930ad",
            class: t$a("actions", {
                hidden: !this.hasAction
            })
        }, (0, $696Z8.h)("slot", {
            key: "2f94aaf6297152fd4b3d43ea51a75f892d3db423",
            name: "action",
            onSlotchange: ()=>this.handleActionSlotChange()
        }))), this.dismissable && (0, $696Z8.h)("nav", {
            key: "5fe71733d802b4f8e572f04b4081510dd03a36a5",
            class: "dismiss-container"
        }, (0, $696Z8.h)("button", {
            key: "e6f3b36172b55b9c8948791eb0617701fbcea4a7",
            type: "button",
            "aria-label": this.dismissButtonAriaLabel,
            onClick: ()=>this.dismiss()
        }, (0, $696Z8.h)("svg", {
            key: "16745506bb3fac09e30508fb0f0149044a82976b",
            role: "presentation",
            "aria-hidden": "true",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "f758b771e2e3b80fe21ade93a850426d733f3f8b",
            d: "M6.71004 18.71L12 13.41L17.29 18.71L18.71 17.29L13.41 12L18.71 6.71004L17.29 5.29004L12 10.59L6.71004 5.29004L5.29004 6.71004L10.59 12L5.29004 17.29L6.71004 18.71Z"
        })))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;-moz-column-gap:var(--banner-icon-spacing);column-gap:var(--banner-icon-spacing);align-items:flex-start;width:100%;padding:var(--banner-vertical-padding) var(--banner-horizontal-padding);border-width:var(--banner-border-width);border-style:solid;border-radius:var(--banner-border-radius);font-weight:var(--banner-text-weight);font-size:var(--banner-text-size);line-height:var(--banner-text-leading);letter-spacing:var(--banner-text-tracking);text-transform:var(--banner-text-case)}.icon-container,.dismiss-container{display:flex;flex-shrink:0;align-items:center}.dismiss-container button{display:flex;justify-content:center;align-items:center;margin:0;padding:0;border:none;background-color:transparent;cursor:pointer;transition:opacity var(--core-animation-enter-transition-moderate-speed-duration);-webkit-appearance:none;-moz-appearance:none;appearance:none}.dismiss-container button svg{fill:var(--banner-dismiss-button-normal-state-color)}.dismiss-container button:active svg{fill:var(--banner-dismiss-button-pressed-state-color)}.main{display:flex;flex-grow:1;flex-wrap:wrap;gap:var(--banner-multiline-spacing) var(--banner-content-spacing)}.main.has-title{flex-direction:column}.main.has-title .actions{justify-content:unset}::slotted([slot="title"]){margin:0;font-weight:var(--banner-title-weight);font-size:var(--banner-title-size);font-family:inherit;line-height:var(--banner-title-leading);letter-spacing:var(--banner-title-tracking);text-transform:var(--banner-title-case)}section{flex-grow:1}nav{display:flex;flex-wrap:wrap;justify-content:flex-end}nav.hidden{display:none}::slotted(a),::slotted(button){margin:0;padding:0;border:none;background-color:transparent;font-weight:var(--banner-button-text-weight);font-size:var(--banner-button-text-size);font-family:inherit;line-height:var(--banner-button-text-leading);letter-spacing:var(--banner-button-text-tracking);text-decoration:underline;text-transform:var(--banner-button-text-case);cursor:pointer;transition:opacity var(--core-animation-enter-transition-moderate-speed-duration);text-underline-offset:2px;text-decoration-thickness:1px}::slotted(a:hover),::slotted(button:hover){opacity:var(--text-link-hover-state-opacity)}::slotted(a:active),::slotted(button:active){opacity:var(--text-link-pressed-state-opacity)}::slotted([slot="action"]:not(:last-child):focus-visible)::after{outline:none}::slotted([slot="action"]){display:flex;justify-content:center;align-items:center}::slotted([slot="action"]:not(:last-child)){margin-right:calc(var(--banner-button-spacing) * 2 + var(--banner-button-separator-width))}::slotted([slot="action"]:not(:last-child))::after{content:"";display:inline-block;width:var(--banner-button-separator-width);height:var(--banner-button-separator-height);margin-right:calc(-1 * var(--banner-button-spacing) - var(--banner-button-separator-width));margin-left:var(--banner-button-spacing);background-color:var(--banner-button-separator-color);opacity:var(--banner-button-separator-opacity);pointer-events:none}:host([variant="info"]){border-color:var(--banner-info-variant-border-color);background-color:var(--banner-info-variant-background-color);color:var(--banner-info-variant-text-color)}:host([variant="info"]) .icon-container svg,:host([variant="info"]) ::slotted([slot="icon"]){fill:var(--banner-info-variant-icon-color)}:host([variant="info"]) ::slotted(a){color:var(--banner-info-variant-text-link-text-color)}:host([variant="info"]) ::slotted(button){color:var(--banner-info-variant-button-text-color)}:host([variant="success"]){border-color:var(--banner-success-variant-border-color);background-color:var(--banner-success-variant-background-color);color:var(--banner-success-variant-text-color)}:host([variant="success"]) .icon-container svg,:host([variant="success"]) ::slotted([slot="icon"]){fill:var(--banner-success-variant-icon-color)}:host([variant="success"]) ::slotted(a){color:var(--banner-success-variant-text-link-text-color)}:host([variant="success"]) ::slotted(button){color:var(--banner-success-variant-button-text-color)}:host([variant="warning"]){border-color:var(--banner-warning-variant-border-color);background-color:var(--banner-warning-variant-background-color);color:var(--banner-warning-variant-text-color)}:host([variant="warning"]) .icon-container svg,:host([variant="warning"]) ::slotted([slot="icon"]){fill:var(--banner-warning-variant-icon-color)}:host([variant="warning"]) ::slotted(a){color:var(--banner-warning-variant-text-link-text-color)}:host([variant="warning"]) ::slotted(button){color:var(--banner-warning-variant-button-text-color)}:host([variant="critical"]){border-color:var(--banner-critical-variant-border-color);background-color:var(--banner-critical-variant-background-color);color:var(--banner-critical-variant-text-color)}:host([variant="critical"]) .icon-container svg,:host([variant="critical"]) ::slotted([slot="icon"]){fill:var(--banner-critical-variant-icon-color)}:host([variant="critical"]) ::slotted(a){color:var(--banner-critical-variant-text-color)}:host([variant="critical"]) ::slotted(button){color:var(--banner-critical-variant-button-text-color)}:host([variant="insight"]){border-color:var(--banner-insight-variant-border-color);background-color:var(--banner-insight-variant-background-color);color:var(--banner-insight-variant-text-color)}:host([variant="insight"]) .icon-container svg,:host([variant="insight"]) ::slotted([slot="icon"]){fill:var(--banner-insight-variant-icon-color)}:host([variant="insight"]) ::slotted(a){color:var(--banner-insight-variant-text-link-text-color)}:host([variant="insight"]) ::slotted(button){color:var(--banner-insight-variant-button-text-color)}';
    }
}, [
    257,
    "market-banner",
    {
        variant: [
            513
        ],
        dismissable: [
            516
        ],
        dismissButtonAriaLabel: [
            513,
            "dismiss-button-aria-label"
        ],
        iconImageTitle: [
            1,
            "icon-image-title"
        ],
        hasTitle: [
            32
        ],
        hasAction: [
            32
        ]
    }
]), d$l = c$v;
const e$f = [
    "modal-full",
    "modal-partial",
    "blade",
    "dialog",
    "sheet"
], a$s = {
    "modal-full": {
        veil: true
    },
    "modal-partial": {
        veil: true
    },
    blade: {
        veil: false
    },
    dialog: {
        veil: true
    },
    sheet: {
        veil: true
    }
}, i$l = ()=>e$f.map((e2)=>l$s(`market-${e2}`)).join(",");
function n$C(e2) {
    const a2 = e2.querySelector("main, .main"), i2 = e2.querySelector(l$s("market-header"));
    if (a2 && i2 && !i2.compact) {
        let l2 = null;
        const e3 = (n2 = ()=>{
            if (a2.scrollTop > 0) {
                if (!i2.compact) {
                    if (null === l2) {
                        const e4 = i2.shadowRoot.querySelector(".heading"), a3 = getComputedStyle(e4);
                        l2 = Number.parseInt(a3.height, 10) + Number.parseInt(a3.marginTop, 10);
                    }
                    a2.style.paddingTop = `${l2}px`, i2.compact = true;
                }
            } else i2.compact && (a2.style.paddingTop = "", i2.compact = false);
        }, o = [], t = null, r = function() {
            for(var l3 = arguments.length, e4 = new Array(l3), a3 = 0; a3 < l3; a3++)e4[a3] = arguments[a3];
            o = e4, t || (t = requestAnimationFrame(function() {
                t = null, n2.apply(void 0, o);
            }));
        }, r.cancel = function() {
            t && (cancelAnimationFrame(t), t = null);
        }, r);
        a2.addEventListener("scroll", e3, {
            passive: true
        });
    }
    var n2, o, t, r;
}
/*!
* tabbable 6.3.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var n$B = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
], t$8 = n$B.join(","), e$e = "undefined" == typeof Element, r$f = e$e ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, o$j = !e$e && Element.prototype.getRootNode ? function(n2) {
    var t2;
    return null == n2 || null === (t2 = n2.getRootNode) || void 0 === t2 ? void 0 : t2.call(n2);
} : function(n2) {
    return null == n2 ? void 0 : n2.ownerDocument;
}, i$k = function(n2, t2) {
    var e2;
    void 0 === t2 && (t2 = true);
    var r2 = null == n2 || null === (e2 = n2.getAttribute) || void 0 === e2 ? void 0 : e2.call(n2, "inert");
    return "" === r2 || "true" === r2 || t2 && n2 && i$k(n2.parentNode);
}, u$i = function(n2, e2, o2) {
    if (i$k(n2)) return [];
    var u2 = Array.prototype.slice.apply(n2.querySelectorAll(t$8));
    return e2 && r$f.call(n2, t$8) && u2.unshift(n2), u2.filter(o2);
}, a$r = function(n2, e2, o2) {
    for(var u2 = [], c2 = Array.from(n2); c2.length;){
        var f2 = c2.shift();
        if (!i$k(f2, false)) {
            if ("SLOT" === f2.tagName) {
                var l2 = f2.assignedElements(), s2 = a$r(l2.length ? l2 : f2.children, true, o2);
                o2.flatten ? u2.push.apply(u2, s2) : u2.push({
                    scopeParent: f2,
                    candidates: s2
                });
            } else {
                r$f.call(f2, t$8) && o2.filter(f2) && (e2 || !n2.includes(f2)) && u2.push(f2);
                var v2 = f2.shadowRoot || "function" == typeof o2.getShadowRoot && o2.getShadowRoot(f2), d2 = !i$k(v2, false) && (!o2.shadowRootFilter || o2.shadowRootFilter(f2));
                if (v2 && d2) {
                    var b2 = a$r(true === v2 ? f2.children : v2.children, true, o2);
                    o2.flatten ? u2.push.apply(u2, b2) : u2.push({
                        scopeParent: f2,
                        candidates: b2
                    });
                } else c2.unshift.apply(c2, f2.children);
            }
        }
    }
    return u2;
}, c$u = function(n2) {
    return !isNaN(parseInt(n2.getAttribute("tabindex"), 10));
}, f$c = function(n2) {
    if (!n2) throw new Error("No node provided");
    return n2.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(n2.tagName) || function(n3) {
        var t2, e2 = null == n3 || null === (t2 = n3.getAttribute) || void 0 === t2 ? void 0 : t2.call(n3, "contenteditable");
        return "" === e2 || "true" === e2;
    }(n2)) && !c$u(n2) ? 0 : n2.tabIndex;
}, l$p = function(n2, t2) {
    return n2.tabIndex === t2.tabIndex ? n2.documentOrder - t2.documentOrder : n2.tabIndex - t2.tabIndex;
}, s$t = function(n2) {
    return "INPUT" === n2.tagName;
}, v$8 = function(n2) {
    var t2 = n2.getBoundingClientRect();
    return 0 === t2.width && 0 === t2.height;
}, d$k = function(n2, t2) {
    return !(t2.disabled || i$k(t2) || function(n3) {
        return s$t(n3) && "hidden" === n3.type;
    }(t2) || function(n3, t3) {
        var e2 = t3.displayCheck, i2 = t3.getShadowRoot;
        if ("full-native" === e2 && "checkVisibility" in n3) return !n3.checkVisibility({
            checkOpacity: false,
            opacityProperty: false,
            contentVisibilityAuto: true,
            visibilityProperty: true,
            checkVisibilityCSS: true
        });
        if ("hidden" === getComputedStyle(n3).visibility) return true;
        var u2 = r$f.call(n3, "details>summary:first-of-type");
        if (r$f.call(u2 ? n3.parentElement : n3, "details:not([open]) *")) return true;
        if (e2 && "full" !== e2 && "full-native" !== e2 && "legacy-full" !== e2) {
            if ("non-zero-area" === e2) return v$8(n3);
        } else {
            if ("function" == typeof i2) {
                for(var a2 = n3; n3;){
                    var c2 = n3.parentElement, f2 = o$j(n3);
                    if (c2 && !c2.shadowRoot && true === i2(c2)) return v$8(n3);
                    n3 = n3.assignedSlot ? n3.assignedSlot : c2 || f2 === n3.ownerDocument ? c2 : f2.host;
                }
                n3 = a2;
            }
            if (function(n4) {
                var t4, e3, r2, i3, u3 = n4 && o$j(n4), a3 = null === (t4 = u3) || void 0 === t4 ? void 0 : t4.host, c3 = false;
                if (u3 && u3 !== n4) for(c3 = !!(null !== (e3 = a3) && void 0 !== e3 && null !== (r2 = e3.ownerDocument) && void 0 !== r2 && r2.contains(a3) || null != n4 && null !== (i3 = n4.ownerDocument) && void 0 !== i3 && i3.contains(n4)); !c3 && a3;){
                    var f3, l2, s2;
                    c3 = !(null === (l2 = a3 = null === (f3 = u3 = o$j(a3)) || void 0 === f3 ? void 0 : f3.host) || void 0 === l2 || null === (s2 = l2.ownerDocument) || void 0 === s2 || !s2.contains(a3));
                }
                return c3;
            }(n3)) return !n3.getClientRects().length;
            if ("legacy-full" !== e2) return true;
        }
        return false;
    }(t2, n2) || function(n3) {
        return "DETAILS" === n3.tagName && Array.prototype.slice.apply(n3.children).some(function(n4) {
            return "SUMMARY" === n4.tagName;
        });
    }(t2) || function(n3) {
        if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(n3.tagName)) for(var t3 = n3.parentElement; t3;){
            if ("FIELDSET" === t3.tagName && t3.disabled) {
                for(var e2 = 0; e2 < t3.children.length; e2++){
                    var o2 = t3.children.item(e2);
                    if ("LEGEND" === o2.tagName) return !!r$f.call(t3, "fieldset[disabled] *") || !o2.contains(n3);
                }
                return true;
            }
            t3 = t3.parentElement;
        }
        return false;
    }(t2));
}, b$b = function(n2, t2) {
    return !(function(n3) {
        return function(n4) {
            return s$t(n4) && "radio" === n4.type;
        }(n3) && !function(n4) {
            if (!n4.name) return true;
            var t3, e2 = n4.form || o$j(n4), r2 = function(n5) {
                return e2.querySelectorAll('input[type="radio"][name="' + n5 + '"]');
            };
            if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t3 = r2(window.CSS.escape(n4.name));
            else try {
                t3 = r2(n4.name);
            } catch (n5) {
                return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", n5.message), false;
            }
            var i2 = function(n5, t4) {
                for(var e3 = 0; e3 < n5.length; e3++)if (n5[e3].checked && n5[e3].form === t4) return n5[e3];
            }(t3, n4.form);
            return !i2 || i2 === n4;
        }(n3);
    }(t2) || f$c(t2) < 0 || !d$k(n2, t2));
}, p$b = function(n2) {
    var t2 = parseInt(n2.getAttribute("tabindex"), 10);
    return !!(isNaN(t2) || t2 >= 0);
}, y$a = function(n2) {
    var t2 = [], e2 = [];
    return n2.forEach(function(n3, r2) {
        var o2 = !!n3.scopeParent, i2 = o2 ? n3.scopeParent : n3, u2 = function(n4, t3) {
            var e3 = f$c(n4);
            return e3 < 0 && t3 && !c$u(n4) ? 0 : e3;
        }(i2, o2), a2 = o2 ? y$a(n3.candidates) : i2;
        0 === u2 ? o2 ? t2.push.apply(t2, a2) : t2.push(i2) : e2.push({
            documentOrder: r2,
            tabIndex: u2,
            item: n3,
            isScope: o2,
            content: a2
        });
    }), e2.sort(l$p).reduce(function(n3, t3) {
        return t3.isScope ? n3.push.apply(n3, t3.content) : n3.push(t3.content), n3;
    }, []).concat(t2);
}, w$8 = function(n2, e2) {
    if (e2 = e2 || {}, !n2) throw new Error("No node provided");
    return false !== r$f.call(n2, t$8) && b$b(e2, n2);
}, h$f = n$B.concat("iframe").join(","), m$9 = function(n2, t2) {
    if (t2 = t2 || {}, !n2) throw new Error("No node provided");
    return false !== r$f.call(n2, h$f) && d$k(t2, n2);
};
/*!
* focus-trap 7.6.6
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ function E$5(n2, t2) {
    (null == t2 || t2 > n2.length) && (t2 = n2.length);
    for(var e2 = 0, r2 = Array(t2); e2 < t2; e2++)r2[e2] = n2[e2];
    return r2;
}
function O$7(n2, t2, e2) {
    return (t2 = function(n3) {
        var t3 = function(n4, t4) {
            if ("object" != typeof n4 || !n4) return n4;
            var e3 = n4[Symbol.toPrimitive];
            if (void 0 !== e3) {
                var r2 = e3.call(n4, t4);
                if ("object" != typeof r2) return r2;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(n4);
        }(n3, "string");
        return "symbol" == typeof t3 ? t3 : t3 + "";
    }(t2)) in n2 ? Object.defineProperty(n2, t2, {
        value: e2,
        enumerable: true,
        configurable: true,
        writable: true
    }) : n2[t2] = e2, n2;
}
function S$9(n2, t2) {
    var e2 = Object.keys(n2);
    if (Object.getOwnPropertySymbols) {
        var r2 = Object.getOwnPropertySymbols(n2);
        t2 && (r2 = r2.filter(function(t3) {
            return Object.getOwnPropertyDescriptor(n2, t3).enumerable;
        })), e2.push.apply(e2, r2);
    }
    return e2;
}
function k$6(n2) {
    for(var t2 = 1; t2 < arguments.length; t2++){
        var e2 = null != arguments[t2] ? arguments[t2] : {};
        t2 % 2 ? S$9(Object(e2), true).forEach(function(t3) {
            O$7(n2, t3, e2[t3]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n2, Object.getOwnPropertyDescriptors(e2)) : S$9(Object(e2)).forEach(function(t3) {
            Object.defineProperty(n2, t3, Object.getOwnPropertyDescriptor(e2, t3));
        });
    }
    return n2;
}
var T$6 = function(n2) {
    return "Tab" === (null == n2 ? void 0 : n2.key) || 9 === (null == n2 ? void 0 : n2.keyCode);
}, A$6 = function(n2) {
    return T$6(n2) && !n2.shiftKey;
}, F$4 = function(n2) {
    return T$6(n2) && n2.shiftKey;
}, j$a = function(n2) {
    return setTimeout(n2, 0);
}, N$4 = function(n2) {
    for(var t2 = arguments.length, e2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)e2[r2 - 1] = arguments[r2];
    return "function" == typeof n2 ? n2.apply(void 0, e2) : n2;
}, g$b = function(n2) {
    return n2.target.shadowRoot && "function" == typeof n2.composedPath ? n2.composedPath()[0] : n2.target;
}, P$7 = [], D$8 = function(n2, t2) {
    var e2, r2 = (null == t2 ? void 0 : t2.document) || document, o2 = (null == t2 ? void 0 : t2.trapStack) || P$7, i2 = k$6({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: A$6,
        isKeyBackward: F$4
    }, t2), c2 = {
        containers: [],
        containerGroups: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        delayInitialFocusTimer: void 0,
        recentNavEvent: void 0
    }, l2 = function(n3, t3, e3) {
        return n3 && void 0 !== n3[t3] ? n3[t3] : i2[e3 || t3];
    }, s2 = function(n3, t3) {
        var e3 = "function" == typeof (null == t3 ? void 0 : t3.composedPath) ? t3.composedPath() : void 0;
        return c2.containerGroups.findIndex(function(t4) {
            var r3 = t4.container, o3 = t4.tabbableNodes;
            return r3.contains(n3) || (null == e3 ? void 0 : e3.includes(r3)) || o3.find(function(t5) {
                return t5 === n3;
            });
        });
    }, v2 = function(n3) {
        var t3, e3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o3 = e3.hasFallback, u2 = void 0 !== o3 && o3, a2 = e3.params, c3 = i2[n3];
        if ("function" == typeof c3 && (c3 = c3.apply(void 0, function(n4) {
            if (Array.isArray(n4)) return E$5(n4);
        }(t3 = void 0 === a2 ? [] : a2) || function(n4) {
            if ("undefined" != typeof Symbol && null != n4[Symbol.iterator] || null != n4["@@iterator"]) return Array.from(n4);
        }(t3) || function(n4, t4) {
            if (n4) {
                if ("string" == typeof n4) return E$5(n4, t4);
                var e4 = ({}).toString.call(n4).slice(8, -1);
                return "Object" === e4 && n4.constructor && (e4 = n4.constructor.name), "Map" === e4 || "Set" === e4 ? Array.from(n4) : "Arguments" === e4 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e4) ? E$5(n4, t4) : void 0;
            }
        }(t3) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }())), true === c3 && (c3 = void 0), !c3) {
            if (void 0 === c3 || false === c3) return c3;
            throw new Error("`".concat(n3, "` was specified but was not a node, or did not return a node"));
        }
        var f2 = c3;
        if ("string" == typeof c3) {
            try {
                f2 = r2.querySelector(c3);
            } catch (t4) {
                throw new Error("`".concat(n3, '` appears to be an invalid selector; error="').concat(t4.message, '"'));
            }
            if (!f2 && !u2) throw new Error("`".concat(n3, "` as selector refers to no known node"));
        }
        return f2;
    }, h2 = function() {
        var n3 = v2("initialFocus", {
            hasFallback: true
        });
        if (false === n3) return false;
        if (void 0 === n3 || n3 && !m$9(n3, i2.tabbableOptions)) {
            if (s2(r2.activeElement) >= 0) n3 = r2.activeElement;
            else {
                var t3 = c2.tabbableGroups[0];
                n3 = t3 && t3.firstTabbableNode || v2("fallbackFocus");
            }
        } else null === n3 && (n3 = v2("fallbackFocus"));
        if (!n3) throw new Error("Your focus-trap needs to have at least one focusable element");
        return n3;
    }, O2 = function() {
        if (c2.containerGroups = c2.containers.map(function(n3) {
            var t3 = function(n4, t4) {
                var e4;
                return e4 = (t4 = t4 || {}).getShadowRoot ? a$r([
                    n4
                ], t4.includeContainer, {
                    filter: b$b.bind(null, t4),
                    flatten: false,
                    getShadowRoot: t4.getShadowRoot,
                    shadowRootFilter: p$b
                }) : u$i(n4, t4.includeContainer, b$b.bind(null, t4)), y$a(e4);
            }(n3, i2.tabbableOptions), e3 = function(n4, t4) {
                return (t4 = t4 || {}).getShadowRoot ? a$r([
                    n4
                ], t4.includeContainer, {
                    filter: d$k.bind(null, t4),
                    flatten: true,
                    getShadowRoot: t4.getShadowRoot
                }) : u$i(n4, t4.includeContainer, d$k.bind(null, t4));
            }(n3, i2.tabbableOptions), r3 = t3.length > 0 ? t3[0] : void 0, o3 = t3.length > 0 ? t3[t3.length - 1] : void 0, c3 = e3.find(function(n4) {
                return w$8(n4);
            }), l3 = e3.slice().reverse().find(function(n4) {
                return w$8(n4);
            }), s3 = !!t3.find(function(n4) {
                return f$c(n4) > 0;
            });
            return {
                container: n3,
                tabbableNodes: t3,
                focusableNodes: e3,
                posTabIndexesFound: s3,
                firstTabbableNode: r3,
                lastTabbableNode: o3,
                firstDomTabbableNode: c3,
                lastDomTabbableNode: l3,
                nextTabbableNode: function(n4) {
                    var r4 = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], o4 = t3.indexOf(n4);
                    return o4 < 0 ? r4 ? e3.slice(e3.indexOf(n4) + 1).find(function(n5) {
                        return w$8(n5);
                    }) : e3.slice(0, e3.indexOf(n4)).reverse().find(function(n5) {
                        return w$8(n5);
                    }) : t3[o4 + (r4 ? 1 : -1)];
                }
            };
        }), c2.tabbableGroups = c2.containerGroups.filter(function(n3) {
            return n3.tabbableNodes.length > 0;
        }), c2.tabbableGroups.length <= 0 && !v2("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (c2.containerGroups.find(function(n3) {
            return n3.posTabIndexesFound;
        }) && c2.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }, S2 = function(n3) {
        var t3 = n3.activeElement;
        if (t3) return t3.shadowRoot && null !== t3.shadowRoot.activeElement ? S2(t3.shadowRoot) : t3;
    }, D2 = function(n3) {
        false !== n3 && n3 !== S2(document) && (n3 && n3.focus ? (n3.focus({
            preventScroll: !!i2.preventScroll
        }), c2.mostRecentlyFocusedNode = n3, function(n4) {
            return n4.tagName && "input" === n4.tagName.toLowerCase() && "function" == typeof n4.select;
        }(n3) && n3.select()) : D2(h2()));
    }, I2 = function(n3) {
        var t3 = v2("setReturnFocus", {
            params: [
                n3
            ]
        });
        return t3 || false !== t3 && n3;
    }, C2 = function(n3) {
        var t3 = n3.target, e3 = n3.event, r3 = n3.isBackward, o3 = void 0 !== r3 && r3;
        t3 = t3 || g$b(e3), O2();
        var u2 = null;
        if (c2.tabbableGroups.length > 0) {
            var a2 = s2(t3, e3), l3 = a2 >= 0 ? c2.containerGroups[a2] : void 0;
            if (a2 < 0) u2 = o3 ? c2.tabbableGroups[c2.tabbableGroups.length - 1].lastTabbableNode : c2.tabbableGroups[0].firstTabbableNode;
            else if (o3) {
                var d2 = c2.tabbableGroups.findIndex(function(n4) {
                    return t3 === n4.firstTabbableNode;
                });
                if (d2 < 0 && (l3.container === t3 || m$9(t3, i2.tabbableOptions) && !w$8(t3, i2.tabbableOptions) && !l3.nextTabbableNode(t3, false)) && (d2 = a2), d2 >= 0) {
                    var b2 = c2.tabbableGroups[0 === d2 ? c2.tabbableGroups.length - 1 : d2 - 1];
                    u2 = f$c(t3) >= 0 ? b2.lastTabbableNode : b2.lastDomTabbableNode;
                } else T$6(e3) || (u2 = l3.nextTabbableNode(t3, false));
            } else {
                var p2 = c2.tabbableGroups.findIndex(function(n4) {
                    return t3 === n4.lastTabbableNode;
                });
                if (p2 < 0 && (l3.container === t3 || m$9(t3, i2.tabbableOptions) && !w$8(t3, i2.tabbableOptions) && !l3.nextTabbableNode(t3)) && (p2 = a2), p2 >= 0) {
                    var y2 = c2.tabbableGroups[p2 === c2.tabbableGroups.length - 1 ? 0 : p2 + 1];
                    u2 = f$c(t3) >= 0 ? y2.firstTabbableNode : y2.firstDomTabbableNode;
                } else T$6(e3) || (u2 = l3.nextTabbableNode(t3));
            }
        } else u2 = v2("fallbackFocus");
        return u2;
    }, x = function(n3) {
        var t3 = g$b(n3);
        s2(t3, n3) >= 0 || (N$4(i2.clickOutsideDeactivates, n3) ? e2.deactivate({
            returnFocus: i2.returnFocusOnDeactivate
        }) : N$4(i2.allowOutsideClick, n3) || n3.preventDefault());
    }, R = function(n3) {
        var t3 = g$b(n3), e3 = s2(t3, n3) >= 0;
        if (e3 || t3 instanceof Document) e3 && (c2.mostRecentlyFocusedNode = t3);
        else {
            var r3;
            n3.stopImmediatePropagation();
            var o3 = true;
            if (c2.mostRecentlyFocusedNode) {
                if (f$c(c2.mostRecentlyFocusedNode) > 0) {
                    var u2 = s2(c2.mostRecentlyFocusedNode), a2 = c2.containerGroups[u2].tabbableNodes;
                    if (a2.length > 0) {
                        var l3 = a2.findIndex(function(n4) {
                            return n4 === c2.mostRecentlyFocusedNode;
                        });
                        l3 >= 0 && (i2.isKeyForward(c2.recentNavEvent) ? l3 + 1 < a2.length && (r3 = a2[l3 + 1], o3 = false) : l3 - 1 >= 0 && (r3 = a2[l3 - 1], o3 = false));
                    }
                } else c2.containerGroups.some(function(n4) {
                    return n4.tabbableNodes.some(function(n5) {
                        return f$c(n5) > 0;
                    });
                }) || (o3 = false);
            } else o3 = false;
            o3 && (r3 = C2({
                target: c2.mostRecentlyFocusedNode,
                isBackward: i2.isKeyBackward(c2.recentNavEvent)
            })), D2(r3 || c2.mostRecentlyFocusedNode || h2());
        }
        c2.recentNavEvent = void 0;
    }, L = function(n3) {
        (i2.isKeyForward(n3) || i2.isKeyBackward(n3)) && function(n4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            c2.recentNavEvent = n4;
            var e3 = C2({
                event: n4,
                isBackward: t3
            });
            e3 && (T$6(n4) && n4.preventDefault(), D2(e3));
        }(n3, i2.isKeyBackward(n3));
    }, U = function(n3) {
        var t3;
        "Escape" !== (null == (t3 = n3) ? void 0 : t3.key) && "Esc" !== (null == t3 ? void 0 : t3.key) && 27 !== (null == t3 ? void 0 : t3.keyCode) || false === N$4(i2.escapeDeactivates, n3) || (n3.preventDefault(), e2.deactivate());
    }, B = function(n3) {
        var t3 = g$b(n3);
        s2(t3, n3) >= 0 || N$4(i2.clickOutsideDeactivates, n3) || N$4(i2.allowOutsideClick, n3) || (n3.preventDefault(), n3.stopImmediatePropagation());
    }, M = function() {
        if (c2.active) return function(n3, t3) {
            if (n3.length > 0) {
                var e3 = n3[n3.length - 1];
                e3 !== t3 && e3._setPausedState(true);
            }
            var r3 = n3.indexOf(t3);
            -1 === r3 || n3.splice(r3, 1), n3.push(t3);
        }(o2, e2), c2.delayInitialFocusTimer = i2.delayInitialFocus ? j$a(function() {
            D2(h2());
        }) : D2(h2()), r2.addEventListener("focusin", R, true), r2.addEventListener("mousedown", x, {
            capture: true,
            passive: false
        }), r2.addEventListener("touchstart", x, {
            capture: true,
            passive: false
        }), r2.addEventListener("click", B, {
            capture: true,
            passive: false
        }), r2.addEventListener("keydown", L, {
            capture: true,
            passive: false
        }), r2.addEventListener("keydown", U), e2;
    }, V = function() {
        if (c2.active) return r2.removeEventListener("focusin", R, true), r2.removeEventListener("mousedown", x, true), r2.removeEventListener("touchstart", x, true), r2.removeEventListener("click", B, true), r2.removeEventListener("keydown", L, true), r2.removeEventListener("keydown", U), e2;
    }, G = "undefined" != typeof window && "MutationObserver" in window ? new MutationObserver(function(n3) {
        n3.some(function(n4) {
            return Array.from(n4.removedNodes).some(function(n5) {
                return n5 === c2.mostRecentlyFocusedNode;
            });
        }) && D2(h2());
    }) : void 0, Y = function() {
        G && (G.disconnect(), c2.active && !c2.paused && c2.containers.map(function(n3) {
            G.observe(n3, {
                subtree: true,
                childList: true
            });
        }));
    };
    return e2 = {
        get active () {
            return c2.active;
        },
        get paused () {
            return c2.paused;
        },
        activate: function(n3) {
            if (c2.active) return this;
            var t3 = l2(n3, "onActivate"), e3 = l2(n3, "onPostActivate"), o3 = l2(n3, "checkCanFocusTrap");
            o3 || O2(), c2.active = true, c2.paused = false, c2.nodeFocusedBeforeActivation = S2(r2), null == t3 || t3();
            var i3 = function() {
                o3 && O2(), M(), Y(), null == e3 || e3();
            };
            return o3 ? (o3(c2.containers.concat()).then(i3, i3), this) : (i3(), this);
        },
        deactivate: function(n3) {
            if (!c2.active) return this;
            var t3 = k$6({
                onDeactivate: i2.onDeactivate,
                onPostDeactivate: i2.onPostDeactivate,
                checkCanReturnFocus: i2.checkCanReturnFocus
            }, n3);
            clearTimeout(c2.delayInitialFocusTimer), c2.delayInitialFocusTimer = void 0, V(), c2.active = false, c2.paused = false, Y(), function(n4, t4) {
                var e3 = n4.indexOf(t4);
                -1 !== e3 && n4.splice(e3, 1), n4.length > 0 && !n4[n4.length - 1]._isManuallyPaused() && n4[n4.length - 1]._setPausedState(false);
            }(o2, e2);
            var r3 = l2(t3, "onDeactivate"), u2 = l2(t3, "onPostDeactivate"), a2 = l2(t3, "checkCanReturnFocus"), f2 = l2(t3, "returnFocus", "returnFocusOnDeactivate");
            null == r3 || r3();
            var s3 = function() {
                j$a(function() {
                    f2 && D2(I2(c2.nodeFocusedBeforeActivation)), null == u2 || u2();
                });
            };
            return f2 && a2 ? (a2(I2(c2.nodeFocusedBeforeActivation)).then(s3, s3), this) : (s3(), this);
        },
        pause: function(n3) {
            return c2.active ? (c2.manuallyPaused = true, this._setPausedState(true, n3)) : this;
        },
        unpause: function(n3) {
            return c2.active ? (c2.manuallyPaused = false, o2[o2.length - 1] !== this ? this : this._setPausedState(false, n3)) : this;
        },
        updateContainerElements: function(n3) {
            var t3 = [].concat(n3).filter(Boolean);
            return c2.containers = t3.map(function(n4) {
                return "string" == typeof n4 ? r2.querySelector(n4) : n4;
            }), c2.active && O2(), Y(), this;
        }
    }, Object.defineProperties(e2, {
        _isManuallyPaused: {
            value: function() {
                return c2.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function(n3, t3) {
                if (c2.paused === n3) return this;
                if (c2.paused = n3, n3) {
                    var e3 = l2(t3, "onPause"), r3 = l2(t3, "onPostPause");
                    null == e3 || e3(), V(), Y(), null == r3 || r3();
                } else {
                    var o3 = l2(t3, "onUnpause"), i3 = l2(t3, "onPostUnpause");
                    null == o3 || o3(), O2(), M(), Y(), null == i3 || i3();
                }
                return this;
            }
        }
    }), e2.updateContainerElements(n2), e2;
};
function I$3(n2) {
    return "function" == typeof n2.setFocus;
}
const C$4 = ({ activateOptions: n2, el: t2, options: e2 })=>{
    let r2 = [];
    "undefined" != typeof window && (window.trapStack ? r2 = window.trapStack : window.trapStack = r2);
    try {
        return D$8(t2, Object.assign(Object.assign({
            allowOutsideClick: true,
            document: document,
            escapeDeactivates: false
        }, e2), {
            tabbableOptions: Object.assign({
                getShadowRoot: true
            }, null == e2 ? void 0 : e2.tabbableOptions),
            trapStack: r2
        })).activate(n2);
    } catch (n3) {
        console.warn(n3);
    }
};
const p$a = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7), this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7), this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7), this.type = "blade", this.hidden = false, this.animationDuration = n$H, this.animationEnterDuration = n$H, this.animationExitDuration = h$h, this.trapFocus = false, this.skipAnimation = false;
    }
    reenableAnimation() {
        this.skipAnimation = false;
    }
    headerNavigateEventHandler(t2) {
        const { detail: a2, target: i2 } = t2;
        "close" === a2.action && i2.closest(i$l()) === this.el && this.dismiss();
    }
    dismiss(t2) {
        const { defaultPrevented: a2 } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (null == t2 ? void 0 : t2.origin) || this.el
        });
        return a2 || (this.hidden = true, this.dismissTimeout = setTimeout(()=>{
            this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
                dialog: this.el,
                type: this.type,
                origin: this.el
            });
        }, this.animationExitDuration)), Promise.resolve();
    }
    onTrapFocusChanged(t2, a2) {
        t2 !== a2 && (t2 ? this.activateFocusTrap() : this.deactivateFocusTrap());
    }
    activateFocusTrap(t2, a2) {
        return this.focusTrap ? (this.focusTrap.activate(null != a2 ? a2 : {}), this.trapFocus || (this.trapFocus = true)) : this.focusTrap = C$4({
            activateOptions: a2,
            el: this.el,
            options: t2
        }), Promise.resolve();
    }
    deactivateFocusTrap(t2) {
        return this.focusTrap && (this.focusTrap.deactivate(Object.assign({
            returnFocus: true,
            checkCanReturnFocus: (t3)=>new Promise((a2)=>{
                    I$3(t3) ? t3.setFocus() : a2();
                })
        }, t2)), this.focusTrap = void 0), Promise.resolve();
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            }), this.trapFocus && this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    componentWillLoad() {
        const t2 = this.el.querySelector(l$s("market-header"));
        t2 && (t2.showNavigation = true), this.hidden && (this.skipAnimation = true), n$C(this.el);
    }
    disconnectedCallback() {
        clearTimeout(this.connectedCallbackTimeout), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
            dialog: this.el,
            type: this.type,
            origin: this.el
        })), this.deactivateFocusTrap();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "664ec5b4e942c4b466d53f7aa035f5ef19811bcb",
            role: "dialog",
            class: t$a("market-blade", {
                "skip-animation": this.skipAnimation
            })
        }, (0, $696Z8.h)("slot", {
            key: "d7f7af5879ba76a601ecc54643d467002c19b827"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            hidden: [
                {
                    reenableAnimation: 0
                }
            ],
            trapFocus: [
                {
                    onTrapFocusChanged: 0
                }
            ]
        };
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main),:host ::slotted(.main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{position:fixed;top:0;right:0;width:100%;max-width:var(--modal-blade-maximum-width-size);height:100vh;padding-top:var(--modal-blade-regular-vertical-size-class-vertical-padding);padding-bottom:var(--modal-blade-regular-vertical-size-class-vertical-padding);background-color:var(--modal-blade-background-color);box-shadow:var(--elevation-20-shadow);animation-name:market-slide-left-enter;animation-duration:var(       --blade-animation-enter-transition-duration,       var(--core-animation-enter-transition-moderate-speed-duration)     );animation-timing-function:var(       --blade-animation-enter-transition-easing,       var(--core-animation-enter-transition-easing)     );animation-fill-mode:forwards}:host ::slotted(*){padding-right:var(--modal-blade-regular-horizontal-size-class-horizontal-padding);padding-left:var(--modal-blade-regular-horizontal-size-class-horizontal-padding)}:host([hidden]){animation-name:market-slide-left-exit;animation-duration:var(         --blade-animation-exit-transition-duration,         var(--core-animation-exit-transition-moderate-speed-duration)       );animation-timing-function:var(         --blade-animation-exit-transition-easing,         var(--core-animation-exit-transition-easing)       )}:host([hidden].skip-animation){transform:translateX(100%);animation:none}@media only screen and (width >= 1200px){:host{max-width:var(--modal-blade-wide-viewport-width-size);padding-top:var(--modal-blade-wide-viewport-padding-top-size);padding-bottom:var(--modal-blade-wide-viewport-padding-bottom-size)}::slotted(*){padding-right:var(--modal-blade-wide-viewport-padding-right-size);padding-left:var(--modal-blade-wide-viewport-padding-left-size)}}";
    }
}, [
    257,
    "market-blade",
    {
        hidden: [
            1540
        ],
        dialogID: [
            513,
            "data-dialog-id"
        ],
        index: [
            514,
            "data-dialog-index"
        ],
        animationDuration: [
            2,
            "animation-duration"
        ],
        animationEnterDuration: [
            2,
            "animation-enter-duration"
        ],
        animationExitDuration: [
            2,
            "animation-exit-duration"
        ],
        trapFocus: [
            1028,
            "trap-focus"
        ],
        dismiss: [
            64
        ],
        activateFocusTrap: [
            64
        ],
        deactivateFocusTrap: [
            64
        ]
    },
    [
        [
            0,
            "marketHeaderNavigate",
            "headerNavigateEventHandler"
        ]
    ],
    {
        hidden: [
            {
                reenableAnimation: 0
            }
        ],
        trapFocus: [
            {
                onTrapFocusChanged: 0
            }
        ]
    }
]), u$h = p$a;
const a$q = (a2, n2)=>{
    const o2 = new MutationObserver(()=>{
        const o3 = ((a3)=>a3.getAttributeNames().filter((a4)=>a4.startsWith("aria-")).reduce((n3, o4)=>{
                const e2 = a3.getAttribute(o4);
                return null !== e2 && (n3[o4] = e2), n3;
            }, {}))(a2);
        return n2(o3);
    });
    return o2.observe(a2, {
        attributes: true
    }), o2;
}, n$A = (a2)=>{
    var n2;
    const o2 = a2.querySelector("label:not([slot])") || (null === (n2 = a2.getRootNode().host) || void 0 === n2 ? void 0 : n2.querySelector("label:not([slot])"));
    return (null == o2 ? void 0 : o2.innerHTML) || a2.getAttribute("name") || void 0;
}, o$i = /* @__PURE__ */ new WeakMap(), e$d = (a2)=>{
    var n2;
    const e2 = (a3)=>null !== a3 && "" !== a3.trim();
    let t2;
    const l = a2.getAttribute("aria-labelledby");
    if (e2(l)) {
        const a3 = null === (n2 = document.getElementById(l)) || void 0 === n2 ? void 0 : n2.textContent;
        t2 = t2 || a3;
    }
    const r = a2.getAttribute("aria-label");
    return e2(r) ? (t2 = t2 || r, o$i.set(a2, t2), a2.removeAttribute("aria-label")) : t2 = t2 || o$i.get(a2), t2 || a2.getAttribute("name") || void 0;
}, t$7 = (a2, { expanded: n2, popoverId: o2 })=>{
    a2.setAttribute("aria-expanded", n2), a2.setAttribute("aria-controls", o2);
};
const s$s = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(r2){
        super(), false !== r2 && this.__registerHost(), this.__attachShadow(), this.caret = "none", this.disabled = false, this.focused = false, this.iconOnly = false, this.isLoading = false, this.rank = "secondary", this.size = "medium", this.type = "button", this.variant = "regular", this.handleImplicitSubmission = ()=>{
            if ("submit" === this.type) {
                const r3 = this.el.closest("form");
                if (r3) {
                    const t2 = document.createElement("button");
                    t2.type = this.type, t2.style.display = "none", r3.appendChild(t2), t2.click(), t2.remove();
                }
            }
        }, this.onMutationObserved = (r3)=>{
            this.ariaAttributes = r3;
        };
    }
    focusedChangeHandler(r2) {
        this.innerTag && r2 && this.innerTag.focus();
    }
    handleClick(r2) {
        (this.disabled || this.isLoading) && r2.stopImmediatePropagation();
    }
    setFocus(r2 = true) {
        return this.disabled || (this.focused = r2, !r2 && this.innerTag && this.innerTag.blur()), Promise.resolve();
    }
    convertSvgHexToCurrentColor(r2) {
        ("svg" === r2.tagName ? [
            r2
        ] : [
            ...r2.querySelectorAll("svg")
        ]).forEach((r3)=>{
            const t2 = r3.querySelectorAll('[fill="#7B61FF"], [fill="#7b61ff"]'), a2 = r3.querySelectorAll('[stroke="#7B61FF"], [stroke="#7b61ff"]');
            t2.forEach((r4)=>{
                r4.setAttribute("fill", "currentColor");
            }), a2.forEach((r4)=>{
                r4.setAttribute("stroke", "currentColor");
            });
        });
    }
    handleSlotChange() {
        var r2, t2, a2, o2;
        const n2 = this.el.querySelector('[slot="icon"]'), e2 = !!n2;
        e2 && this.convertSvgHexToCurrentColor(n2);
        const i2 = null !== (t2 = null === (r2 = this.el.textContent) || void 0 === r2 ? void 0 : r2.trim()) && void 0 !== t2 ? t2 : "", s2 = null !== (o2 = null === (a2 = null == n2 ? void 0 : n2.textContent) || void 0 === a2 ? void 0 : a2.trim()) && void 0 !== o2 ? o2 : "";
        this.iconOnly = e2 && !(i2.length > s2.length);
    }
    componentWillLoad() {
        this.mutationObserver = a$q(this.el, this.onMutationObserved), this.handleSlotChange();
    }
    render() {
        const { caret: r2, disabled: t2, href: n2, innerTabindex: e2, isLoading: s2, target: l2, type: c2, rel: d, download: u, ariaAttributes: v, handleImplicitSubmission: b } = this, m = void 0 === n2 ? "button" : "a", h = "button" === m ? {
            type: c2,
            disabled: t2
        } : {
            href: n2,
            target: l2,
            rel: d,
            download: u
        }, k = l$s("market-activity-indicator"), g = l$s("market-icon");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "9640d61dee7de39a76bcd38d35b337e5b4f03f6e",
            class: "market-button",
            onClick: b
        }, (0, $696Z8.h)(m, Object.assign({
            key: "7b57144fc75a6f9012255180e9157649421b6dbe",
            class: "inner-tag"
        }, h, v, {
            tabindex: t2 ? -1 : e2,
            onFocus: ()=>{
                this.focused = true;
            },
            onBlur: ()=>{
                this.focused = false;
            },
            ref: (r3)=>this.innerTag = r3
        }), (0, $696Z8.h)("slot", {
            key: "28f8817b1be18676d014f1b5a3640a662c31f2f3",
            name: "icon",
            onSlotchange: ()=>this.handleSlotChange()
        }), (0, $696Z8.h)("span", {
            key: "4eb14ad43732a1000489a9729b6da51adb9498b0",
            class: "button-text",
            part: "button-text"
        }, (0, $696Z8.h)("slot", {
            key: "5c9f0ce1a53cea1b6d4ad7c2d957fc9f7a6fae72",
            onSlotchange: ()=>this.handleSlotChange()
        })), "down" === r2 && (0, $696Z8.h)(g, {
            key: "eb65f10d6c2f7ed1f3b9ae0afab9c06cf2992b85",
            name: "expand"
        }), "up" === r2 && (0, $696Z8.h)(g, {
            key: "7886b76a7da513435799d3a57ef559bb45c953b2",
            name: "collapse"
        })), s2 && (0, $696Z8.h)(k, {
            key: "7c60302c9a3f245c2425112c5badcb0a2fe7b444",
            size: "small"
        }));
    }
    disconnectedCallback() {
        var r2;
        null === (r2 = this.mutationObserver) || void 0 === r2 || r2.disconnect();
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            focused: [
                {
                    focusedChangeHandler: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);--focus-ring-color:color-mix(in srgb, var(--button-focus-ring-color) 100%, transparent);position:relative;display:inline-block;transition:background-color color var(--transition-duration)}.inner-tag{display:inline-flex;justify-content:center;align-items:center;width:100%;border:none;background-color:transparent;color:inherit;outline:none;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-align:center;text-decoration:none;cursor:pointer}.inner-tag:focus-visible{outline:var(--button-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--button-focus-ring-buffer-size)}::slotted([slot="icon"]){position:relative;display:flex;color:inherit;fill:currentcolor;stroke:inherit}.market-activity-indicator{position:absolute;top:50%;left:50%;line-height:0;opacity:0;transform:translate(-50%, -50%)}:host([is-loading]){pointer-events:none}:host([is-loading]) .inner-tag{opacity:0}:host([is-loading]) .market-activity-indicator{opacity:1}:host([size="small"]){--button-small-size-minimum-width:var(--button-small-size-minimum-height);border-radius:var(--button-small-size-border-radius);font-weight:var(--button-small-size-text-weight);font-size:var(--button-small-size-text-size);line-height:var(--button-small-size-text-leading);letter-spacing:var(--button-small-size-text-tracking)}:host([size="small"]) .inner-tag{-moz-column-gap:var(--button-small-size-content-spacing);column-gap:var(--button-small-size-content-spacing);min-width:var(--button-small-size-minimum-width);min-height:var(--button-small-size-minimum-height);border-radius:var(--button-small-size-border-radius)}:host([size="small"][rank="primary"]) .inner-tag{padding:var(--button-small-size-primary-rank-vertical-padding)       var(--button-small-size-primary-rank-horizontal-padding)}:host([size="small"][rank="primary"]) svg,:host([size="small"][rank="primary"]) ::slotted([slot="icon"]){margin:calc(         (var(--button-small-size-minimum-height) - var(--accessory-icon-variant-size)) / 2         - var(--button-small-size-primary-rank-vertical-padding)       ) 0}:host([size="small"][rank="secondary"]) .inner-tag{padding:var(--button-small-size-secondary-rank-vertical-padding)       var(--button-small-size-secondary-rank-horizontal-padding)}:host([size="small"][rank="secondary"]) svg,:host([size="small"][rank="secondary"]) ::slotted([slot="icon"]){margin:calc(         (var(--button-small-size-minimum-height) - var(--accessory-icon-variant-size)) / 2         - var(--button-small-size-secondary-rank-vertical-padding)       ) 0}:host([size="small"][rank="tertiary"]) .inner-tag{padding:var(--button-small-size-tertiary-rank-vertical-padding)       var(--button-small-size-tertiary-rank-horizontal-padding)}:host([size="small"][rank="tertiary"]) svg,:host([size="small"][rank="tertiary"]) ::slotted([slot="icon"]){margin:calc(         (var(--button-small-size-minimum-height) - var(--accessory-icon-variant-size)) / 2         - var(--button-small-size-tertiary-rank-vertical-padding)       ) 0}:host([size="small"][icon-only]:not([caret])) .inner-tag,:host([size="small"][icon-only][caret="none"]) .inner-tag{padding:var(--icon-button-small-size-padding-size)}:host([size="small"][icon-only]) .button-text{display:none}:host([size="medium"]){--button-medium-size-minimum-width:var(--button-medium-size-minimum-height);border-radius:var(--button-medium-size-border-radius);font-weight:var(--button-medium-size-text-weight);font-size:var(--button-medium-size-text-size);line-height:var(--button-medium-size-text-leading);letter-spacing:var(--button-medium-size-text-tracking)}:host([size="medium"]) .inner-tag{-moz-column-gap:var(--button-medium-size-content-spacing);column-gap:var(--button-medium-size-content-spacing);min-width:var(--button-medium-size-minimum-width);min-height:var(--button-medium-size-minimum-height);border-radius:var(--button-medium-size-border-radius)}:host([size="medium"][rank="primary"]) .inner-tag{padding:var(--button-medium-size-primary-rank-vertical-padding)       var(--button-medium-size-primary-rank-horizontal-padding)}:host([size="medium"][rank="secondary"]) .inner-tag{padding:var(--button-medium-size-secondary-rank-vertical-padding)       var(--button-medium-size-secondary-rank-horizontal-padding)}:host([size="medium"][rank="tertiary"]) .inner-tag{padding:var(--button-medium-size-tertiary-rank-vertical-padding)       var(--button-medium-size-tertiary-rank-horizontal-padding)}:host([size="medium"][icon-only]:not([caret])) .inner-tag,:host([size="medium"][icon-only][caret="none"]) .inner-tag{padding:var(--icon-button-medium-size-padding-size)}:host([size="medium"][icon-only]) .button-text{display:none}:host([size="large"]){--button-large-size-minimum-width:var(--button-large-size-minimum-height);border-radius:var(--button-large-size-border-radius);font-weight:var(--button-large-size-text-weight);font-size:var(--button-large-size-text-size);line-height:var(--button-large-size-text-leading);letter-spacing:var(--button-large-size-text-tracking)}:host([size="large"]) .inner-tag{-moz-column-gap:var(--button-large-size-content-spacing);column-gap:var(--button-large-size-content-spacing);min-width:var(--button-large-size-minimum-width);min-height:var(--button-large-size-minimum-height);border-radius:var(--button-large-size-border-radius)}:host([size="large"][rank="primary"]) .inner-tag{padding:var(--button-large-size-primary-rank-vertical-padding)       var(--button-large-size-primary-rank-horizontal-padding)}:host([size="large"][rank="secondary"]) .inner-tag{padding:var(--button-large-size-secondary-rank-vertical-padding)       var(--button-large-size-secondary-rank-horizontal-padding)}:host([size="large"][rank="tertiary"]) .inner-tag{padding:var(--button-large-size-tertiary-rank-vertical-padding)       var(--button-large-size-tertiary-rank-horizontal-padding)}:host([size="large"][icon-only]:not([caret])) .inner-tag,:host([size="large"][icon-only][caret="none"]) .inner-tag{padding:var(--icon-button-large-size-padding-size)}:host([size="large"][icon-only]) .button-text{display:none}:host([rank="primary"]){background-color:var(--button-normal-variant-primary-rank-normal-state-background-color);color:var(--button-normal-variant-primary-rank-normal-state-label-color)}:host([rank="primary"][icon-only]){color:var(--icon-button-primary-rank-normal-state-icon-color)}@media (hover: hover){:host([rank="primary"]:hover){background-color:var(--button-normal-variant-primary-rank-hover-state-background-color);color:var(--button-normal-variant-primary-rank-hover-state-label-color)}:host([rank="primary"][icon-only]:hover){color:var(--icon-button-primary-rank-hover-state-icon-color)}}:host([rank="primary"]:active){background-color:var(--button-normal-variant-primary-rank-pressed-state-background-color);color:var(--button-normal-variant-primary-rank-pressed-state-label-color)}:host([rank="primary"][icon-only]:active){color:var(--icon-button-primary-rank-pressed-state-icon-color)}:host([rank="primary"][disabled]){background-color:var(--button-normal-variant-primary-rank-disabled-state-background-color);color:var(--button-normal-variant-primary-rank-disabled-state-label-color)}:host([rank="primary"][icon-only][disabled]){color:var(--icon-button-primary-rank-disabled-state-icon-color)}:host([rank="secondary"]){background-color:var(--button-normal-variant-secondary-rank-normal-state-background-color);color:var(--button-normal-variant-secondary-rank-normal-state-label-color)}:host([rank="secondary"][icon-only]){color:var(--icon-button-secondary-rank-normal-state-icon-color)}@media (hover: hover){:host([rank="secondary"]:hover){background-color:var(--button-normal-variant-secondary-rank-hover-state-background-color);color:var(--button-normal-variant-secondary-rank-hover-state-label-color)}:host([rank="secondary"][icon-only]:hover){color:var(--icon-button-secondary-rank-hover-state-icon-color)}}:host([rank="secondary"]:active){background-color:var(--button-normal-variant-secondary-rank-pressed-state-background-color);color:var(--button-normal-variant-secondary-rank-pressed-state-label-color)}:host([rank="secondary"][icon-only]:active){color:var(--icon-button-secondary-rank-pressed-state-icon-color)}:host([rank="secondary"][disabled]){background-color:var(--button-normal-variant-secondary-rank-disabled-state-background-color);color:var(--button-normal-variant-secondary-rank-disabled-state-label-color)}:host([rank="secondary"][icon-only][disabled]){color:var(--icon-button-secondary-rank-disabled-state-icon-color)}:host([rank="tertiary"]){background-color:var(--button-normal-variant-tertiary-rank-normal-state-background-color);color:var(--button-normal-variant-tertiary-rank-normal-state-label-color)}:host([rank="tertiary"]) .button-text{display:inline-block;line-height:100%;text-decoration-line:underline;text-decoration-thickness:var(--button-tertiary-rank-underline);text-decoration-style:solid;text-underline-offset:var(--button-tertiary-rank-underline-offset, 2px)}@container style(--button-tertiary-rank-underline: 0px){:host([rank="tertiary"]) .button-text{text-decoration-line:none}}:host([rank="tertiary"][icon-only]){color:var(--icon-button-tertiary-rank-normal-state-icon-color)}:host([rank="tertiary"][focused]){background-color:var(--button-normal-variant-tertiary-rank-focus-state-background-color);color:var(--button-normal-variant-tertiary-rank-focus-state-label-color)}:host([rank="tertiary"][icon-only][focused]){color:var(--icon-button-tertiary-rank-focus-state-icon-color)}@media (hover: hover){:host([rank="tertiary"]:hover){background-color:var(--button-normal-variant-tertiary-rank-hover-state-background-color);color:var(--button-normal-variant-tertiary-rank-hover-state-label-color)}:host([rank="tertiary"][icon-only]:hover){color:var(--icon-button-tertiary-rank-hover-state-icon-color)}}:host([rank="tertiary"]:active){background-color:var(--button-normal-variant-tertiary-rank-pressed-state-background-color);color:var(--button-normal-variant-tertiary-rank-pressed-state-label-color)}:host([rank="tertiary"][icon-only]:active){color:var(--icon-button-tertiary-rank-pressed-state-icon-color)}:host([rank="tertiary"][disabled]){background-color:var(--button-normal-variant-tertiary-rank-disabled-state-background-color);color:var(--button-normal-variant-tertiary-rank-disabled-state-label-color)}:host([rank="tertiary"][icon-only][disabled]){color:var(--icon-button-tertiary-rank-disabled-state-icon-color)}:host([variant="destructive"][rank="primary"]){background-color:var(--button-destructive-variant-primary-rank-normal-state-background-color);color:var(--button-destructive-variant-primary-rank-normal-state-label-color)}@media (hover: hover){:host([variant="destructive"][rank="primary"]:hover){background-color:var(--button-destructive-variant-primary-rank-hover-state-background-color);color:var(--button-destructive-variant-primary-rank-hover-state-label-color)}}:host([variant="destructive"][rank="primary"]:active){background-color:var(--button-destructive-variant-primary-rank-pressed-state-background-color);color:var(--button-destructive-variant-primary-rank-pressed-state-label-color)}:host([variant="destructive"][rank="primary"][disabled]){background-color:var(--button-destructive-variant-primary-rank-disabled-state-background-color);color:var(--button-destructive-variant-primary-rank-disabled-state-label-color)}:host([variant="destructive"][rank="secondary"]){background-color:var(--button-destructive-variant-secondary-rank-normal-state-background-color);color:var(--button-destructive-variant-secondary-rank-normal-state-label-color)}@media (hover: hover){:host([variant="destructive"][rank="secondary"]:hover){background-color:var(--button-destructive-variant-secondary-rank-hover-state-background-color);color:var(--button-destructive-variant-secondary-rank-hover-state-label-color)}}:host([variant="destructive"][rank="secondary"]:active){background-color:var(--button-destructive-variant-secondary-rank-pressed-state-background-color);color:var(--button-destructive-variant-secondary-rank-pressed-state-label-color)}:host([variant="destructive"][rank="secondary"][disabled]){background-color:var(--button-destructive-variant-secondary-rank-disabled-state-background-color);color:var(--button-destructive-variant-secondary-rank-disabled-state-label-color)}:host([variant="destructive"][rank="tertiary"]){background-color:var(--button-destructive-variant-tertiary-rank-normal-state-background-color);color:var(--button-destructive-variant-tertiary-rank-normal-state-label-color)}@media (hover: hover){:host([variant="destructive"][rank="tertiary"]:hover){background-color:var(--button-destructive-variant-tertiary-rank-hover-state-background-color);color:var(--button-destructive-variant-tertiary-rank-hover-state-label-color)}}:host([variant="destructive"][rank="tertiary"]:active){background-color:var(--button-destructive-variant-tertiary-rank-pressed-state-background-color);color:var(--button-destructive-variant-tertiary-rank-pressed-state-label-color)}:host([variant="destructive"][rank="tertiary"][disabled]){background-color:var(--button-destructive-variant-tertiary-rank-disabled-state-background-color);color:var(--button-destructive-variant-tertiary-rank-disabled-state-label-color)}';
    }
}, [
    257,
    "market-button",
    {
        caret: [
            1
        ],
        disabled: [
            516
        ],
        download: [
            1
        ],
        focused: [
            1540
        ],
        href: [
            1
        ],
        iconOnly: [
            1540,
            "icon-only"
        ],
        innerTabindex: [
            2,
            "inner-tabindex"
        ],
        isLoading: [
            516,
            "is-loading"
        ],
        rank: [
            513
        ],
        rel: [
            1
        ],
        size: [
            513
        ],
        target: [
            1
        ],
        type: [
            513
        ],
        variant: [
            513
        ],
        ariaAttributes: [
            32
        ],
        setFocus: [
            64
        ]
    },
    [
        [
            2,
            "click",
            "handleClick"
        ]
    ],
    {
        focused: [
            {
                focusedChangeHandler: 0
            }
        ]
    }
]), l$o = s$s;
const e$c = Object.freeze([
    l$s("market-button"),
    l$s("market-link"),
    l$s("market-filter-button")
]);
const l$n = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketButtonDropdownOpened = (0, $696Z8.createEvent)(this, "marketButtonDropdownOpened", 7), this.marketButtonDropdownClosed = (0, $696Z8.createEvent)(this, "marketButtonDropdownClosed", 7), this.interaction = "click", this.disabled = false, this.noCaret = false, this.popoverPlacement = "bottom-end", this.popoverStrategy = "absolute", this.persistListSelections = false, this.dropdownIsActive = false, this.onMutationObserved = (t3)=>{
            this.ariaAttributes = t3;
        };
    }
    dropdownOpenedEventHandler(t2) {
        t2.target === this.el && (this.dropdownIsActive = true, this.setCaret(), this.marketButtonDropdownOpened.emit());
    }
    dropdownClosedEventHandler(t2) {
        t2.target === this.el && (this.dropdownIsActive = false, this.setCaret(), this.marketButtonDropdownClosed.emit());
    }
    syncTriggerDisabledState() {
        this.slottedButton && (this.slottedButton.disabled = this.disabled);
    }
    setCaret() {
        !this.noCaret && function(t2) {
            return t2.tagName.toLowerCase() === l$s("market-button");
        }(this.slottedButton) && (this.slottedButton.caret = this.dropdownIsActive ? "up" : "down");
    }
    registerTrigger() {
        this.slottedButton = this.el.querySelector(e$c.join(",")), this.syncTriggerDisabledState(), this.setCaret();
    }
    componentWillLoad() {
        this.mutationObserver = a$q(this.el, this.onMutationObserved);
    }
    disconnectedCallback() {
        var t2;
        null === (t2 = this.mutationObserver) || void 0 === t2 || t2.disconnect(), this.mutationObserver = null;
    }
    componentWillRender() {
        const t2 = l$s("market-list"), e2 = this.el.querySelector(t2), s2 = this.el.querySelector('[slot="content"]');
        e2 && (e2.interactive = true, e2.transient = !this.persistListSelections), this.slottedButton && (s2.id || (s2.id = "popover-" + f$d()), t$7(this.slottedButton, {
            expanded: "" + this.dropdownIsActive,
            popoverId: s2.id
        }));
    }
    render() {
        const t2 = l$s("market-dropdown"), e2 = l$s("market-popover");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ba37adcff51d0c63b26fd758695b0d202008ba7b",
            class: "market-button-dropdown"
        }, (0, $696Z8.h)(t2, {
            key: "dd4e0018519b8c849b5c9221003f3d2e0be16659",
            interaction: this.interaction,
            "popover-strategy": this.popoverStrategy,
            "popover-placement": this.popoverPlacement,
            disabled: this.disabled
        }, (0, $696Z8.h)("slot", {
            key: "aee76f9c12f32b497230e644d7ed5f56ecdecd70",
            name: "trigger",
            slot: "trigger",
            onSlotchange: ()=>this.registerTrigger()
        }), (0, $696Z8.h)(e2, {
            key: "4af109ace06612d8bf779ac834cdf789385a87f6",
            slot: "popover",
            part: "popover"
        }, (0, $696Z8.h)("slot", {
            key: "bc097304e5c591985b0e16670ad4a250345e001e",
            name: "content"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            disabled: [
                {
                    syncTriggerDisabledState: 0
                }
            ]
        };
    }
    static get style() {
        return ":host{display:inline-block}market-dropdown,.market-dropdown{width:100%}svg{fill:transparent}";
    }
}, [
    257,
    "market-button-dropdown",
    {
        interaction: [
            1
        ],
        disabled: [
            516
        ],
        noCaret: [
            4,
            "no-caret"
        ],
        popoverPlacement: [
            1,
            "popover-placement"
        ],
        popoverStrategy: [
            1,
            "popover-strategy"
        ],
        persistListSelections: [
            4,
            "persist-list"
        ],
        dropdownIsActive: [
            32
        ],
        ariaAttributes: [
            32
        ]
    },
    [
        [
            0,
            "marketDropdownOpened",
            "dropdownOpenedEventHandler"
        ],
        [
            0,
            "marketDropdownClosed",
            "dropdownClosedEventHandler"
        ]
    ],
    {
        disabled: [
            {
                syncTriggerDisabledState: 0
            }
        ]
    }
]), c$t = l$n;
function n$z() {
    return new Promise((n2)=>{
        (null === window || void 0 === window ? void 0 : window.requestAnimationFrame) ? window.requestAnimationFrame(()=>n2()) : n2();
    });
}
var t$6 = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, e$b = "object" == typeof self && self && self.Object === Object && self, n$y = t$6 || e$b || Function("return this")(), o$h = n$y.Symbol, l$m = Object.prototype, c$s = l$m.hasOwnProperty, r$e = l$m.toString, a$p = o$h ? o$h.toStringTag : void 0, u$g = Object.prototype.toString, b$a = o$h ? o$h.toStringTag : void 0;
function f$b(t2) {
    return null == t2 ? void 0 === t2 ? "[object Undefined]" : "[object Null]" : b$a && b$a in Object(t2) ? function(t3) {
        var e2 = c$s.call(t3, a$p), n2 = t3[a$p];
        try {
            t3[a$p] = void 0;
            var o2 = true;
        } catch (t4) {}
        var l2 = r$e.call(t3);
        return o2 && (e2 ? t3[a$p] = n2 : delete t3[a$p]), l2;
    }(t2) : function(t3) {
        return u$g.call(t3);
    }(t2);
}
function i$j(t2) {
    return null != t2 && "object" == typeof t2;
}
function j$9(t2) {
    var e2 = typeof t2;
    return null != t2 && ("object" == e2 || "function" == e2);
}
function s$r(s2) {
    return "symbol" == typeof s2 || i$j(s2) && "[object Symbol]" == f$b(s2);
}
var i$i = /\s/, o$g = /^\s+/;
var e$a = /^[-+]0x[0-9a-f]+$/i, u$f = /^0b[01]+$/i, a$o = /^0o[0-7]+$/i, f$a = parseInt;
function c$r(t2) {
    if ("number" == typeof t2) return t2;
    if (s$r(t2)) return NaN;
    if (j$9(t2)) {
        var c2 = "function" == typeof t2.valueOf ? t2.valueOf() : t2;
        t2 = j$9(c2) ? c2 + "" : c2;
    }
    if ("string" != typeof t2) return 0 === t2 ? t2 : +t2;
    var v2;
    t2 = (v2 = t2) ? v2.slice(0, function(r2) {
        for(var t3 = r2.length; t3-- && i$i.test(r2.charAt(t3)););
        return t3;
    }(v2) + 1).replace(o$g, "") : v2;
    var s2 = u$f.test(t2);
    return s2 || a$o.test(t2) ? f$a(t2.slice(2), s2 ? 2 : 8) : e$a.test(t2) ? NaN : +t2;
}
var v$7 = function() {
    return n$y.Date.now();
}, s$q = Math.max, m$8 = Math.min;
function d$j(t2, n2, i2) {
    var o2 = true, e2 = true;
    if ("function" != typeof t2) throw new TypeError("Expected a function");
    return j$9(i2) && (o2 = "leading" in i2 ? !!i2.leading : o2, e2 = "trailing" in i2 ? !!i2.trailing : e2), function(t3, n3, i3) {
        var o3, e3, u2, a2, f2, d2, p = 0, l = false, y = false, T = true;
        if ("function" != typeof t3) throw new TypeError("Expected a function");
        function g(r2) {
            var n4 = o3, i4 = e3;
            return o3 = e3 = void 0, p = r2, a2 = t3.apply(i4, n4);
        }
        function x(r2) {
            var t4 = r2 - d2;
            return void 0 === d2 || t4 >= n3 || t4 < 0 || y && r2 - p >= u2;
        }
        function h() {
            var r2 = v$7();
            if (x(r2)) return b(r2);
            f2 = setTimeout(h, function(r3) {
                var t4 = n3 - (r3 - d2);
                return y ? m$8(t4, u2 - (r3 - p)) : t4;
            }(r2));
        }
        function b(r2) {
            return f2 = void 0, T && o3 ? g(r2) : (o3 = e3 = void 0, a2);
        }
        function w() {
            var r2 = v$7(), t4 = x(r2);
            if (o3 = arguments, e3 = this, d2 = r2, t4) {
                if (void 0 === f2) return function(r3) {
                    return p = r3, f2 = setTimeout(h, n3), l ? g(r3) : a2;
                }(d2);
                if (y) return clearTimeout(f2), f2 = setTimeout(h, n3), g(d2);
            }
            return void 0 === f2 && (f2 = setTimeout(h, n3)), a2;
        }
        return n3 = c$r(n3) || 0, j$9(i3) && (l = !!i3.leading, u2 = (y = "maxWait" in i3) ? s$q(c$r(i3.maxWait) || 0, n3) : u2, T = "trailing" in i3 ? !!i3.trailing : T), w.cancel = function() {
            void 0 !== f2 && clearTimeout(f2), p = 0, o3 = d2 = e3 = f2 = void 0;
        }, w.flush = function() {
            return void 0 === f2 ? a2 : b(v$7());
        }, w;
    }(t2, n2, {
        leading: o2,
        maxWait: n2,
        trailing: e2
    });
}
const d$i = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.alignment = "right", this.popoverStrategy = "absolute", this._sortedButtonEls = {
            overflow: [],
            visible: []
        }, this._buttonEls = [], this._observers = {}, this.throttledHandleResize = d$j(this.handleResize.bind(this), 16);
    }
    getComputedWidth(t2) {
        return Number.parseFloat(window.getComputedStyle(t2).width);
    }
    async findButtonCutoffIndex() {
        if ("stack" === this.alignment) return this._buttonEls.length;
        const t2 = this.getComputedWidth(this.el), e2 = document.createElement("div");
        e2.style.width = "auto", e2.style.position = "absolute", e2.style.visibility = "hidden", this.el.shadowRoot.appendChild(e2);
        let o2 = 0, s2 = 0;
        for (const i2 of this._buttonEls){
            if (2 === o2) break;
            const n2 = o2 + 1 === this._buttonEls.length ? 0 : b$c + 48, r2 = i2.cloneNode(true);
            r2.style.display = "block", e2.appendChild(r2), await n$z();
            const c2 = this.getComputedWidth(e2);
            if (e2.removeChild(r2), s2 += (o2 > 0 ? b$c : 0) + c2, s2 + n2 >= t2) break;
            ++o2;
        }
        return this.el.shadowRoot.removeChild(e2), e2.remove(), o2;
    }
    sortVisibleAndOverflowButtons() {
        this._sortedButtonEls = {
            visible: this._buttonEls.slice(0, this._buttonCutoffIndex),
            overflow: this._buttonEls.slice(this._buttonCutoffIndex)
        }, this._sortedButtonEls.visible.forEach((t2)=>{
            "overflow-buttons" === t2.getAttribute("slot") && t2.removeAttribute("slot");
        }), this._sortedButtonEls.overflow.forEach((t2)=>{
            "overflow-buttons" !== t2.getAttribute("slot") && t2.setAttribute("slot", "overflow-buttons");
        });
    }
    async handleResize(t2 = 0) {
        if (!this.getComputedWidth(this.el)) return t2 < 30 ? (await n$z(), void await this.handleResize(t2 + 1)) : (console.warn("market-button-group: Failed to measure width after max retries. Displaying all buttons."), this._buttonCutoffIndex = this._buttonEls.length, this.sortVisibleAndOverflowButtons(), void (this.el.style.visibility = ""));
        const e2 = await this.findButtonCutoffIndex();
        e2 !== this._buttonCutoffIndex && (this._buttonCutoffIndex = e2, await n$z(), this.sortVisibleAndOverflowButtons()), this.el.style.visibility = "";
    }
    registerSlottedButtons() {
        const t2 = l$s("market-button");
        this._buttonEls = [
            ...this.el.querySelectorAll(t2)
        ];
    }
    observeContent(t2) {
        this._observers.content || (this._observers.content = new ResizeObserver(this.throttledHandleResize), this._observers.content.observe(t2));
    }
    connectedCallback() {
        this._observers.host || (this._observers.host = new ResizeObserver(this.throttledHandleResize), this._observers.host.observe(this.el));
    }
    componentWillLoad() {
        this.el.style.visibility = "hidden", this.registerSlottedButtons(), this.handleResize();
    }
    disconnectedCallback() {
        Object.entries(this._observers).forEach(([t2, e2])=>{
            e2 && (e2.disconnect(), this._observers[t2] = void 0);
        });
    }
    render() {
        const t2 = l$s("market-button-dropdown"), e2 = l$s("market-button"), i2 = l$s("market-icon");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "349118ad3a81ed1167fa7eed1cb2d9a8cd9a8b12",
            class: "market-button-group"
        }, (0, $696Z8.h)("div", {
            key: "122c5a531778a05cbb9921559b7990e5aba4b260",
            class: "content",
            ref: (t3)=>this.observeContent(t3)
        }, (0, $696Z8.h)("slot", {
            key: "6f66923e8a2b23dc3707123219be83498b63c4dc",
            onSlotchange: ()=>this.registerSlottedButtons()
        }), this._sortedButtonEls.overflow.length > 0 && (0, $696Z8.h)(t2, {
            key: "a24268d3788548e6139962492616ffde4f26f646",
            "no-caret": true,
            "popover-strategy": this.popoverStrategy
        }, (0, $696Z8.h)(e2, {
            key: "95e7d1ec793a15320961a2a81a725fbb26dc36ec",
            slot: "trigger"
        }, (0, $696Z8.h)(i2, {
            key: "e86defd8b337506e96c37b419377829de99efb0d",
            slot: "icon",
            name: g$d
        })), (0, $696Z8.h)("div", {
            key: "d8d0b19334169fd17954a89b2f365546e4502d02",
            slot: "content"
        }, (0, $696Z8.h)("slot", {
            key: "b853f441f9ce38c41e4ec1977ec9062ef4ca71f1",
            name: "overflow-buttons",
            slot: "overflow-buttons"
        })))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;flex-grow:1}.content{display:flex;flex:1;flex-flow:row nowrap;gap:var(--button-group-spacing)}:host([alignment="right"]) .content{flex-direction:row-reverse}:host([alignment="left"]) .content{justify-content:flex-start}:host([alignment="split"]) .content{flex-direction:row-reverse;justify-content:flex-end}:host([alignment="split"]) .content ::slotted(.market-button:first-of-type){margin-left:auto}:host([alignment="fill"]) .content{flex-direction:row-reverse}:host([alignment="fill"]) .content ::slotted(.market-button){flex:1}:host([alignment="stack"]) .content{flex-direction:column}[slot="content"]{display:flex;flex-direction:column;gap:var(--button-group-spacing)}::slotted([slot="overflow-buttons"]){width:100%}';
    }
}, [
    257,
    "market-button-group",
    {
        alignment: [
            513
        ],
        popoverStrategy: [
            1,
            "popover-strategy"
        ],
        _sortedButtonEls: [
            32
        ]
    }
]), h$e = d$i;
const l$l = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketCheckboxValueChange = (0, $696Z8.createEvent)(this, "marketCheckboxValueChange", 7), this.checked = false, this.disabled = false, this.indeterminate = false, this.invalid = false, this.focused = false, this.hovered = false, this.active = false, this.ariaAttributesHash = 0;
    }
    setSelection(e2, { silent: o2 = false } = {}) {
        const { marketCheckboxValueChange: r2, checked: a2, innerInput: t2 } = this;
        if ("boolean" != typeof e2) return Promise.resolve();
        if (this.indeterminate = false, a2 === e2) return Promise.resolve();
        if (!o2) {
            const { defaultPrevented: o3 } = r2.emit({
                current: e2,
                previous: a2
            });
            if (o3) return Promise.resolve();
        }
        return this.checked = e2, t2 && (t2.checked = e2), Promise.resolve();
    }
    setIndeterminate(e2) {
        return this.indeterminate = e2, Promise.resolve();
    }
    setValue(e2) {
        return console.warn("market-checkbox's setValue() method has been deprecated. Use setSelection() instead.", this.el), this.setSelection(e2), Promise.resolve();
    }
    setActive(e2) {
        return this.active = e2, Promise.resolve();
    }
    setHover(e2) {
        return this.hovered = e2, Promise.resolve();
    }
    setDisabled(e2) {
        return this.disabled = e2, Promise.resolve();
    }
    setFocus(e2 = true) {
        return this.disabled || (this.focused = e2), Promise.resolve();
    }
    handleClick(e2) {
        e2.preventDefault(), this.disabled || (this.setFocus(), this.setSelection(!this.checked));
    }
    getCheckedState() {
        return this.indeterminate ? "indeterminate" : this.checked;
    }
    componentWillLoad() {
        "undefined" != typeof MutationObserver && (this.mutationObserver = a$q(this.el, ()=>{
            (this.el.hasAttribute("aria-label") || this.el.hasAttribute("aria-labelledby")) && this.ariaAttributesHash++;
        }));
    }
    componentDidRender() {
        this.innerInput || (this.innerInput = this.el.shadowRoot.querySelector("input"));
    }
    disconnectedCallback() {
        var e2;
        null === (e2 = this.mutationObserver) || void 0 === e2 || e2.disconnect();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "b01f946c03869fd77384528b12765ec760490e88",
            class: "market-checkbox",
            onBlur: ()=>{
                this.setFocus(false);
            },
            onClick: this.handleClick,
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("input", {
            key: "cef5bf95f6f92701b00f296c15db81b84f2f1e61",
            ref: (e2)=>this.innerInput = e2,
            type: "checkbox",
            "aria-label": e$d(this.el),
            checked: this.checked,
            indeterminate: this.indeterminate,
            disabled: this.disabled
        }), this.checked && !this.indeterminate && (0, $696Z8.h)("svg", {
            key: "5cd99726b91ceec0c4550b623395ff64fe2ba8ff",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "check"
        }, (0, $696Z8.h)("path", {
            key: "93458fe0e8846fce79613c6486fb7030bc7cd077",
            d: "M6 10L8.85714 13L14 7",
            stroke: "white",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })), this.indeterminate && (0, $696Z8.h)("svg", {
            key: "203b02645449f9e01831015c79d568c3a89420bb",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "indeterminate"
        }, (0, $696Z8.h)("path", {
            key: "80b38653c7fbf3a06a6d04470464ddeb145d580c",
            d: "M6 10H14",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--checkbox-offset:calc(-1 * var(--checkbox-border-size));--focus-ring-color:color-mix(in srgb, var(--checkbox-focus-ring-color) 100%, transparent);position:relative;display:inline-block;width:var(--checkbox-width);height:var(--checkbox-height);border:var(--checkbox-border-size) solid var(--checkbox-normal-state-normal-validity-unchecked-value-border-color);border-radius:var(--checkbox-border-radius);background-color:var(--checkbox-normal-state-normal-validity-unchecked-value-background-color)}input{position:absolute;top:var(--checkbox-offset);left:var(--checkbox-offset);width:var(--checkbox-width);height:var(--checkbox-height);margin:0;border-radius:var(--checkbox-border-radius);background:transparent;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}input:focus-visible{outline:var(--checkbox-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--checkbox-focus-ring-buffer-size)}svg{position:absolute;top:var(--checkbox-offset);left:var(--checkbox-offset);pointer-events:none}:host(:hover),:host([hovered]){border-color:var(--checkbox-hover-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-hover-state-normal-validity-unchecked-value-background-color)}:host([focused]){border-color:var(--checkbox-focus-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-focus-state-normal-validity-unchecked-value-background-color)}:host(:active),:host([active]){border-color:var(--checkbox-pressed-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-pressed-state-normal-validity-unchecked-value-background-color)}:host([checked]){border-color:var(--checkbox-normal-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-normal-state-normal-validity-checked-value-background-color)}:host([checked]) path{stroke:var(--checkbox-normal-state-normal-validity-checked-value-icon-color)}:host([checked]:hover),:host([checked][hovered]){border-color:var(--checkbox-hover-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-hover-state-normal-validity-checked-value-background-color)}:host([checked]:hover) path,:host([checked][hovered]) path{stroke:var(--checkbox-hover-state-normal-validity-checked-value-icon-color)}:host([checked][focused]){border-color:var(--checkbox-focus-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-focus-state-normal-validity-checked-value-background-color)}:host([checked][focused]) path{stroke:var(--checkbox-focus-state-normal-validity-checked-value-icon-color)}:host([checked]:active),:host([checked][active]){border-color:var(--checkbox-pressed-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-pressed-state-normal-validity-checked-value-background-color)}:host([checked]:active) path,:host([checked][active]) path{stroke:var(--checkbox-pressed-state-normal-validity-checked-value-icon-color)}:host([indeterminate]){border-color:var(--checkbox-normal-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-normal-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate]) path{stroke:var(--checkbox-normal-state-normal-validity-indeterminate-value-icon-color)}:host([indeterminate]:hover),:host([indeterminate][hovered]){border-color:var(--checkbox-hover-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-hover-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate]:hover) path,:host([indeterminate][hovered]) path{stroke:var(--checkbox-hover-state-normal-validity-indeterminate-value-icon-color)}:host([indeterminate][focused]){border-color:var(--checkbox-focus-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-focus-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate][focused]) path{stroke:var(--checkbox-focus-state-normal-validity-indeterminate-value-icon-color)}:host([indeterminate]:active),:host([indeterminate][active]){border-color:var(--checkbox-pressed-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-pressed-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate]:active) path,:host([indeterminate][active]) path{stroke:var(--checkbox-pressed-state-normal-validity-indeterminate-value-icon-color)}:host([invalid]){border-color:var(--checkbox-normal-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-normal-state-invalid-validity-unchecked-value-background-color)}:host([invalid]:hover){border-color:var(--checkbox-hover-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-hover-state-invalid-validity-unchecked-value-background-color)}:host([invalid][focused]){border-color:var(--checkbox-focus-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-focus-state-invalid-validity-unchecked-value-background-color)}:host([invalid]:active){border-color:var(--checkbox-pressed-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-pressed-state-invalid-validity-unchecked-value-background-color)}:host([invalid][checked]){border-color:var(--checkbox-normal-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-normal-state-invalid-validity-checked-value-background-color)}:host([invalid][checked]) path{stroke:var(--checkbox-normal-state-invalid-validity-checked-value-icon-color)}:host([invalid][checked]:hover){border-color:var(--checkbox-hover-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-hover-state-invalid-validity-checked-value-background-color)}:host([invalid][checked]:hover) path{stroke:var(--checkbox-hover-state-invalid-validity-checked-value-icon-color)}:host([invalid][checked][focused]){border-color:var(--checkbox-focus-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-focus-state-invalid-validity-checked-value-background-color)}:host([invalid][checked][focused]) path{stroke:var(--checkbox-focus-state-invalid-validity-checked-value-icon-color)}:host([invalid][checked]:active){border-color:var(--checkbox-pressed-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-pressed-state-invalid-validity-checked-value-background-color)}:host([invalid][checked]:active) path{stroke:var(--checkbox-pressed-state-invalid-validity-checked-value-icon-color)}:host([invalid][indeterminate]){border-color:var(--checkbox-normal-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-normal-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]) path{stroke:var(--checkbox-normal-state-invalid-validity-indeterminate-value-icon-color)}:host([invalid][indeterminate]:hover){border-color:var(--checkbox-hover-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-hover-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]:hover) path{stroke:var(--checkbox-hover-state-invalid-validity-indeterminate-value-icon-color)}:host([invalid][indeterminate][focused]){border-color:var(--checkbox-focus-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-focus-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]:active){border-color:var(--checkbox-pressed-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-pressed-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]:active) path{stroke:var(--checkbox-pressed-state-invalid-validity-indeterminate-value-icon-color)}:host([disabled]){border-color:var(--checkbox-disabled-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-disabled-state-normal-validity-unchecked-value-background-color);cursor:not-allowed}:host([disabled]) input{cursor:not-allowed}:host([checked][disabled]){border-color:var(--checkbox-disabled-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-disabled-state-normal-validity-checked-value-background-color)}:host([checked][disabled]) path{stroke:var(--checkbox-disabled-state-normal-validity-checked-value-icon-color)}:host([indeterminate][disabled]){border-color:var(--checkbox-disabled-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-disabled-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate][disabled]) path{stroke:var(--checkbox-disabled-state-normal-validity-indeterminate-value-icon-color)}";
    }
}, [
    1,
    "market-checkbox",
    {
        checked: [
            1540
        ],
        disabled: [
            1540
        ],
        indeterminate: [
            1540
        ],
        invalid: [
            516
        ],
        focused: [
            1540
        ],
        hovered: [
            1540
        ],
        active: [
            1540
        ],
        ariaAttributesHash: [
            32
        ],
        setSelection: [
            64
        ],
        setIndeterminate: [
            64
        ],
        setValue: [
            64
        ],
        setActive: [
            64
        ],
        setHover: [
            64
        ],
        setDisabled: [
            64
        ],
        setFocus: [
            64
        ]
    }
]), n$x = l$l;
const a$n = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketChoiceButtonSelected = (0, $696Z8.createEvent)(this, "marketChoiceButtonSelected", 7), this.marketChoiceButtonDeselected = (0, $696Z8.createEvent)(this, "marketChoiceButtonDeselected", 7), this.disabled = false, this.selected = false, this.size = "medium";
    }
    onClick(e2) {
        if (this.disabled) return void e2.stopImmediatePropagation();
        const { defaultPrevented: t2 } = this.selected ? this.marketChoiceButtonDeselected.emit() : this.marketChoiceButtonSelected.emit();
        t2 || (this.selected = !this.selected);
    }
    render() {
        const { disabled: e2 } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "58dc327ff12f9cd950c8c9b8e5b9e4a1c8398a9b",
            class: "market-choice-button",
            tabindex: e2 ? -1 : void 0,
            onClick: (e3)=>{
                this.onClick(e3);
            }
        }, (0, $696Z8.h)("button", {
            key: "f458ddbbe9b852683e70962e6c431d00476cf5eb",
            "aria-disabled": e2
        }, (0, $696Z8.h)("slot", {
            key: "153f1b90e3b29cb8784ccdfc92ec4c549a90a52d"
        }), (0, $696Z8.h)("slot", {
            key: "e59116c5891043e590d80a43f0060ed1fc503c1c",
            name: "secondary-text"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);--focus-ring-color:color-mix(in srgb, var(--choice-button-focus-ring-color) 100%, transparent);position:relative;display:inline-block;border-radius:var(--choice-button-border-radius);background-color:var(--choice-button-unselected-value-normal-state-background-color);color:var(--choice-button-unselected-value-normal-state-label-color);cursor:pointer;transition:background-color color var(--transition-duration)}button{display:inline-flex;justify-content:center;align-items:center;box-sizing:border-box;width:100%;margin:0;padding:0;border:none;border-radius:var(--choice-button-border-radius);background-color:transparent;color:inherit;outline:none;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-align:center;cursor:inherit}button:focus-visible{outline:var(--choice-button-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--choice-button-focus-ring-buffer-size)}::slotted([slot="secondary-text"]){cursor:inherit}:host([size="medium"]) button{-moz-column-gap:var(--choice-button-medium-size-content-spacing);column-gap:var(--choice-button-medium-size-content-spacing);padding:var(--choice-button-medium-size-vertical-padding) var(--choice-button-medium-size-horizontal-padding);font-weight:var(--choice-button-medium-size-text-primary-weight);font-size:var(--choice-button-medium-size-text-primary-size);line-height:var(--choice-button-medium-size-text-primary-leading);letter-spacing:var(--choice-button-medium-size-text-primary-tracking);text-transform:var(--choice-button-medium-size-text-primary-case)}:host([size="medium"]) ::slotted([slot="secondary-text"]){font-weight:var(--choice-button-medium-size-text-secondary-weight);font-size:var(--choice-button-medium-size-text-secondary-size);line-height:var(--choice-button-medium-size-text-secondary-leading);letter-spacing:var(--choice-button-medium-size-text-secondary-tracking);text-transform:var(--choice-button-medium-size-text-secondary-case)}:host([size="small"]) button{-moz-column-gap:var(--choice-button-small-size-content-spacing);column-gap:var(--choice-button-small-size-content-spacing);padding:var(--choice-button-small-size-vertical-padding) var(--choice-button-small-size-horizontal-padding);font-weight:var(--choice-button-small-size-text-primary-weight);font-size:var(--choice-button-small-size-text-primary-size);line-height:var(--choice-button-small-size-text-primary-leading);letter-spacing:var(--choice-button-small-size-text-primary-tracking);text-transform:var(--choice-button-small-size-text-primary-case)}:host([size="small"]) ::slotted([slot="secondary-text"]){font-weight:var(--choice-button-small-size-text-secondary-weight);font-size:var(--choice-button-small-size-text-secondary-size);line-height:var(--choice-button-small-size-text-secondary-leading);letter-spacing:var(--choice-button-small-size-text-secondary-tracking);text-transform:var(--choice-button-small-size-text-secondary-case)}:host([size="large"]) button{-moz-column-gap:var(--choice-button-large-size-content-spacing);column-gap:var(--choice-button-large-size-content-spacing);padding:var(--choice-button-large-size-vertical-padding) var(--choice-button-large-size-horizontal-padding);font-weight:var(--choice-button-large-size-text-primary-weight);font-size:var(--choice-button-large-size-text-primary-size);line-height:var(--choice-button-large-size-text-primary-leading);letter-spacing:var(--choice-button-large-size-text-primary-tracking);text-transform:var(--choice-button-large-size-text-primary-case)}:host([size="large"]) ::slotted([slot="secondary-text"]){font-weight:var(--choice-button-large-size-text-secondary-weight);font-size:var(--choice-button-large-size-text-secondary-size);line-height:var(--choice-button-large-size-text-secondary-leading);letter-spacing:var(--choice-button-large-size-text-secondary-tracking);text-transform:var(--choice-button-large-size-text-secondary-case)}@media (hover: hover){:host(:hover){background-color:var(--choice-button-unselected-value-hover-state-background-color);color:var(--choice-button-unselected-value-hover-state-label-color)}}:host(:active){background-color:var(--choice-button-unselected-value-pressed-state-background-color);color:var(--choice-button-unselected-value-pressed-state-label-color)}:host([disabled]){background-color:var(--choice-button-unselected-value-disabled-state-background-color);color:var(--choice-button-unselected-value-disabled-state-label-color)}:host([selected]){background-color:var(--choice-button-selected-value-normal-state-background-color);color:var(--choice-button-selected-value-normal-state-label-color)}@media (hover: hover){:host([selected]:hover){background-color:var(--choice-button-selected-value-hover-state-background-color);color:var(--choice-button-selected-value-hover-state-label-color)}}:host([selected]:active){background-color:var(--choice-button-selected-value-pressed-state-background-color);color:var(--choice-button-selected-value-pressed-state-label-color)}:host([selected][disabled]){background-color:var(--choice-button-selected-value-disabled-state-background-color);color:var(--choice-button-selected-value-disabled-state-label-color)}';
    }
}, [
    257,
    "market-choice-button",
    {
        disabled: [
            516
        ],
        selected: [
            1540
        ],
        size: [
            513
        ]
    }
]), n$w = a$n;
const r$d = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketCodeCopied = (0, $696Z8.createEvent)(this, "marketCodeCopied", 7), this.disabled = false, this.focused = false, this.code = "", this.codeChars = [];
    }
    componentWillLoad() {
        var t2, o2;
        const e2 = this.el.querySelector("[slot=code]"), a2 = null !== (t2 = null == e2 ? void 0 : e2.textContent) && void 0 !== t2 ? t2 : "";
        this.code = a2.replaceAll(/\s/g, ""), this.initCodeChars(this.code), this.copyButton = document.createElement("button"), Object.assign(this.copyButton, {
            slot: "actions",
            type: "button",
            tabIndex: this.disabled ? -1 : 0,
            onclick: ()=>this.copyToClipboard()
        });
        const i2 = this.el.querySelector("[slot=copy-text]");
        i2 ? (this.copyButton.textContent = null !== (o2 = i2.textContent) && void 0 !== o2 ? o2 : "Copy", i2.insertAdjacentElement("afterend", this.copyButton)) : (this.copyButton.textContent = "Copy", null == e2 || e2.insertAdjacentElement("afterend", this.copyButton));
    }
    initCodeChars(t2) {
        const o2 = t2.length, e2 = (0, $696Z8.h)("span", {
            class: "code-char"
        });
        if (4 !== o2 && o2 % 4 == 0) for(let i2 = 0; i2 < o2; i2++)i2 % 4 == 0 && this.codeChars.push(e2), this.codeChars.push((0, $696Z8.h)("span", {
            class: "code-char"
        }, t2[i2]));
        else {
            this.codeChars.push(e2);
            for(let e3 = 0; e3 < o2; e3++)this.codeChars.push((0, $696Z8.h)("span", {
                class: "code-char"
            }, t2[e3]));
        }
        this.codeChars.push(e2);
    }
    copyToClipboard() {
        navigator.clipboard.writeText(this.code), this.marketCodeCopied.emit();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "fb3bb355ce6264500c2b1fe1da85de6329d51b2c",
            class: "market-code-display",
            tabIndex: this.disabled ? null : 0,
            "aria-label": this.code
        }, (0, $696Z8.h)("span", {
            key: "3d259ad051fba1321f7b3ff01f37b1dc1532d15e",
            class: "code-container"
        }, this.codeChars), (0, $696Z8.h)("span", {
            key: "a855aaf825506ad3e45bd7a18154dc844f716d0a",
            class: "actions-container"
        }, (0, $696Z8.h)("slot", {
            key: "35381e7adf67e38a2ba81cf799b2d80bda841151",
            name: "actions"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;justify-content:space-between;align-items:center;width:-moz-min-content;width:min-content;min-width:var(--code-display-width, 320px);min-height:var(--code-display-height, 48px);margin:var(--code-display-margin, 12px);padding:var(--code-display-padding-vertical, 12px)     var(--code-display-padding-right, 16px)     var(--code-display-padding-vertical, 12px)     var(--code-display-zero-value, 0);border-radius:var(--code-display-border-radius, 6px);background-color:var(--code-display-background-color, var(--core-fill-40-color));font-weight:var(--code-display-code-font-weight, var(--core-type-bold-weight));font-size:var(--code-display-code-font-size, var(--core-type-heading-20-size));font-family:var(--code-display-font-family, var(--core-type-font-family));font-feature-settings:"tnum"}:host(:not([disabled])) button:hover,:host ::slotted(button:hover),:host ::slotted(a:hover){color:var(--text-link-normal-variant-hover-state-color)}:host(:not([disabled])) button:active,:host ::slotted(button:active),:host ::slotted(a:active){color:var(--text-link-normal-variant-pressed-state-color)}:host([disabled]){color:var(--code-display-disabled-text-color, var(--core-text-30-color));}:host([disabled]) ::slotted(button),:host ::slotted(a){color:var(--text-link-normal-variant-disabled-state-color)}:host .code-container{display:flex;flex-grow:2;justify-content:space-between;min-width:var(--code-display-code-container-min-width, 269px)}:host .code-char{flex-basis:100%;font-family:var(--core-type-mono-font-family, monospace);text-align:center}:host .actions-container{display:flex;justify-content:center;align-items:center}:host .actions-container ::slotted([slot="actions"]:not(:last-child)){margin-right:var(--code-display-extra-actions-margin-right, 25px)}:host .actions-container ::slotted([slot="actions"]:not(:last-child))::after{content:"";display:inline-block;width:var(--code-display-button-separator-width, 1px);height:var(--code-display-button-separator-height, 8px);margin-right:var(--code-display-separator-margin-right, -13px);margin-left:var(--code-display-button-content-spacing, 12px);background-color:var(--code-display-button-separator-color, var(--core-fill-10-color));opacity:var(--code-display-button-separator-opacity, 0.3);pointer-events:none}:host button,:host ::slotted(button),:host ::slotted(a){margin:var(--code-display-zero-value, 0);padding:var(--code-display-zero-value, 0);border:none;background-color:transparent;color:var(--text-link-normal-variant-normal-state-color);font-weight:var(--code-display-button-font-weight, var(--core-type-semibold-weight));font-size:var(--code-display-button-font-size, var(--core-type-paragraph-20-size));font-family:inherit;line-height:var(--code-display-button-line-height, var(--core-type-paragraph-20-leading));text-decoration:none;cursor:pointer}@media only screen and (width <= 320px){:host{flex-wrap:wrap;width:100%;min-width:var(--code-display-zero-value, 0)}:host .code-container{min-width:var(--code-display-zero-value, 0)}}';
    }
}, [
    257,
    "market-code-display",
    {
        disabled: [
            516
        ],
        focused: [
            516
        ]
    }
]), n$v = r$d;
const l$k = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketCodeInputValueChange = (0, $696Z8.createEvent)(this, "marketCodeInputValueChange", 7), this.type = "number", this.length = 4, this.focused = false, this.value = "", this.readonly = false, this.invalid = false, this.disabled = false;
    }
    valueChangeHandler(t2) {
        const e2 = this.sanitizeValue(t2);
        this.value !== e2 && (this.value = e2), this.setInputsFromValue(this.value);
    }
    setFocus(t2 = true) {
        var e2;
        return this.focused = t2, t2 ? this.focusFirstEmptyInput() : null === (e2 = this.el.shadowRoot.activeElement) || void 0 === e2 || e2.blur(), Promise.resolve();
    }
    isNumber(t2) {
        return /^\d+$/.test(t2);
    }
    isValidChar(t2) {
        return !/\s/.test(t2) && ([
            "text",
            "password"
        ].includes(this.type) || this.isNumber(t2));
    }
    focusFirstEmptyInput() {
        const t2 = this.el.shadowRoot.querySelectorAll("input");
        let e2;
        t2.forEach((t3)=>{
            t3.value || e2 || (e2 = t3);
        }), e2 || (e2 = t2[this.length - 1]), e2.focus();
    }
    initCode(t2) {
        if (t2) {
            if (this._code = [
                ...t2
            ], this._code.length < this.length) {
                const t3 = Array.from({
                    length: this.length - this._code.length
                }).fill("");
                this._code = [
                    ...this._code,
                    ...t3
                ];
            } else this._code.length > this.length && (this._code = this._code.slice(0, this.length));
        } else this._code = Array.from({
            length: this.length
        }).fill("");
    }
    sanitizeValue(t2) {
        return [
            ...t2
        ].filter((t3)=>this.isValidChar(t3)).join("").slice(0, this.length);
    }
    getValueFromInputs() {
        let t2 = "";
        return this.el.shadowRoot.querySelectorAll("input").forEach((e2)=>{
            t2 += e2.value;
        }), t2;
    }
    setInputsFromValue(t2) {
        this.el.shadowRoot.querySelectorAll("input").forEach((e2, o2)=>{
            const s2 = t2[o2 - 1];
            e2.value = t2[o2] || "", 0 === o2 || s2 ? e2.removeAttribute("tabindex") : e2.tabIndex = -1;
        });
    }
    spreadChars(t2) {
        const { target: e2, data: o2 } = t2, s2 = o2 || e2.value;
        if (!s2) return;
        const i2 = this.sanitizeValue(s2);
        i2 ? this.insertChars(e2, [
            ...i2
        ]) : e2.value = "";
    }
    insertChars(t2, e2) {
        const { nextElementSibling: o2 } = t2, [s2, ...i2] = e2;
        t2.value = s2, null == o2 || o2.focus(), o2 && i2.length > 0 && this.insertChars(o2, i2);
    }
    updateValue() {
        const t2 = this.value, e2 = this.sanitizeValue(this.getValueFromInputs());
        if (t2 !== e2) {
            const { defaultPrevented: o2 } = this.marketCodeInputValueChange.emit({
                code: e2
            });
            o2 ? this.setInputsFromValue(t2) : this.value = e2;
        }
    }
    onInput(t2) {
        this.spreadChars(t2), this.updateValue();
    }
    onFocus(t2) {
        const { target: e2 } = t2;
        this.focused = true, e2.value ? e2.select() : this.focusFirstEmptyInput();
    }
    onBlur() {
        this.focused = false;
    }
    onKeyDown(t2) {
        const { target: e2, key: o2 } = t2, { value: s2, previousElementSibling: i2, nextElementSibling: r2 } = e2;
        switch(o2){
            case "ArrowLeft":
                t2.preventDefault(), null == i2 || i2.select();
                break;
            case "ArrowRight":
                t2.preventDefault(), null == r2 || r2.select();
                break;
            case "Backspace":
                s2 || null == i2 || i2.select();
        }
    }
    onKeyUp(t2) {
        const { target: e2 } = t2, { value: o2 } = e2;
        o2.length > 1 ? this.spreadChars(t2) : this.isValidChar(o2) || (e2.value = "", e2.focus());
    }
    onHostClick() {
        this.el.shadowRoot.activeElement || this.setFocus();
    }
    componentWillLoad() {
        this.valueChangeHandler(this.value), this.initCode(this.value);
    }
    render() {
        const t2 = [];
        return this._code.forEach((e2, o2)=>{
            t2.push((0, $696Z8.h)("input", {
                required: true,
                type: "password" === this.type ? "password" : "text",
                inputmode: "number" === this.type ? "numeric" : null,
                autocomplete: 0 === o2 ? "one-time-code" : null,
                value: e2,
                maxlength: o2 === this.length - 1 ? "1" : null,
                readOnly: this.readonly,
                disabled: this.disabled,
                "aria-label": `Digit ${o2 + 1} of ${this.length}`,
                placeholder: "\u25CF",
                tabindex: this._code[o2 - 1] || 0 === o2 ? null : -1,
                onFocus: (t3)=>this.onFocus(t3),
                onBlur: ()=>this.onBlur(),
                onInput: (t3)=>this.onInput(t3),
                onKeyDown: (t3)=>this.onKeyDown(t3),
                onKeyUp: (t3)=>this.onKeyUp(t3)
            }));
        }), (0, $696Z8.h)((0, $696Z8.Host), {
            key: "4ad58bbee8e93d97a2348401c35c9e1399b81d90",
            class: "market-code-input",
            name: this.name,
            onClick: ()=>this.onHostClick()
        }, (0, $696Z8.h)("span", {
            key: "b7eaa722be18ca2fb4080238bc5c20d60a5ccd56",
            class: "code-input-container",
            role: "group",
            "aria-label": this.length + "-digit verification code"
        }, t2), (0, $696Z8.h)("slot", {
            key: "697e5f125895b40beb9c73c5418b61fae6059c92",
            name: "trailing-accessory"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    valueChangeHandler: 0
                }
            ]
        };
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host input,:host ::slotted(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color);}:host::after{content:"";position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)         var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([readonly]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([disabled]) ::slotted(.market-accessory),:host([disabled]) ::slotted(img[slot*="accessory"]),:host([disabled]) ::slotted(svg[slot*="accessory"]),:host([disabled]) ::slotted(div[slot*="accessory"]){--field-disabled-state-accessory-opacity:var(--row-disabled-state-leading-accessory-opacity);opacity:var(--field-disabled-state-accessory-opacity)}:host([value=""]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=""])) ::slotted(label),:host([value=""][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=""]):hover) ::slotted(label),:host([value=""][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=""][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=""])[disabled]) ::slotted(label),:host([value=""][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{display:flex;align-items:center;height:var(--input-code-height, 64px)}:host input{font-weight:var(--input-code-font-weight, var(--core-type-bold-weight));font-family:var(--core-type-mono-font-family, monospace);text-align:center}:host input:-webkit-autofill,:host input:-webkit-autofill:hover,:host input:-webkit-autofill:focus{box-shadow:0 0 0 calc(var(--input-code-height, 64px) / 2) var(--field-normal-state-background-color) inset}:host input::-moz-placeholder{color:var(--input-code-placeholder-color, var(--core-fill-30-color));font-size:var(--input-code-placeholder-font-size, 24px)}:host input::placeholder{color:var(--input-code-placeholder-color, var(--core-fill-30-color));font-size:var(--input-code-placeholder-font-size, 24px)}.code-input-container{display:flex;justify-content:center;width:100%;height:100%}.code-input-container::before,.code-input-container::after{content:"";flex-basis:100%;pointer-events:none}::slotted([slot="trailing-accessory"]){margin-right:var(--input-code-trailing-accessory-spacing, 12px)}`;
    }
}, [
    257,
    "market-code-input",
    {
        type: [
            513
        ],
        name: [
            1
        ],
        length: [
            2
        ],
        focused: [
            1540
        ],
        value: [
            1537
        ],
        readonly: [
            516
        ],
        invalid: [
            516
        ],
        disabled: [
            516
        ],
        _code: [
            32
        ],
        setFocus: [
            64
        ]
    },
    void 0,
    {
        value: [
            {
                valueChangeHandler: 0
            }
        ]
    }
]), a$m = l$k;
const { min: e$9, max: r$c, floor: t$5, round: n$u } = Math;
function u$e(e2, r2, n2) {
    let u2 = e2, o2 = r2, s2 = n2;
    u2 = u2 / 360 * 6, o2 /= 100, s2 /= 100;
    const c2 = t$5(u2), a2 = u2 - c2, d2 = s2 * (1 - o2), i2 = s2 * (1 - a2 * o2), l2 = s2 * (1 - (1 - a2) * o2), f = c2 % 6;
    return [
        255 * [
            s2,
            i2,
            d2,
            d2,
            l2,
            s2
        ][f],
        255 * [
            l2,
            s2,
            s2,
            i2,
            d2,
            d2
        ][f],
        255 * [
            d2,
            d2,
            l2,
            s2,
            s2,
            i2
        ][f]
    ];
}
function o$f(e2, r2, t2) {
    return u$e(e2, r2, t2).map((e3)=>n$u(e3).toString(16).padStart(2, "0"));
}
function s$p(t2, n2, u2) {
    let o2 = t2, s2 = n2, c2 = u2;
    o2 /= 255, s2 /= 255, c2 /= 255;
    const a2 = e$9(o2, s2, c2), d2 = r$c(o2, s2, c2), i2 = d2 - a2;
    let l2, f;
    if (0 === i2) l2 = f = 0;
    else {
        f = i2 / d2;
        const e2 = ((d2 - o2) / 6 + i2 / 2) / i2, r2 = ((d2 - s2) / 6 + i2 / 2) / i2, t3 = ((d2 - c2) / 6 + i2 / 2) / i2;
        o2 === d2 ? l2 = t3 - r2 : s2 === d2 ? l2 = 1 / 3 + e2 - t3 : c2 === d2 && (l2 = 2 / 3 + r2 - e2), l2 < 0 ? l2 += 1 : l2 > 1 && (l2 -= 1);
    }
    return [
        360 * l2,
        100 * f,
        100 * d2
    ];
}
function c$q(e2, r2, t2) {
    let n2 = r2, u2 = t2;
    n2 /= 100, u2 /= 100, n2 *= u2 < 0.5 ? u2 : 1 - u2;
    const o2 = 2 * n2 / (u2 + n2) * 100, s2 = 100 * (u2 + n2);
    return [
        e2,
        Number.isNaN(o2) ? 0 : o2,
        s2
    ];
}
function a$l(e2) {
    const r2 = e2.match(/.{2}/g).map((e3)=>Number.parseInt(e3, 16));
    return s$p(r2[0], r2[1], r2[2]);
}
function d$h(e2) {
    return e2.map((e3)=>{
        const r2 = Number(e3);
        return Number.isNaN(e3) ? void 0 : r2;
    });
}
function i$h(e2) {
    const r2 = {
        rgba: /^rgba?\D+([\d.]+)(%?)\D+([\d.]+)(%?)\D+([\d.]+)(%?)\D*?(([\d.]+)(%?)|$)/i,
        hsla: /^hsla?\D+([\d.]+)\D+([\d.]+)\D+([\d.]+)\D*?(([\d.]+)(%?)|$)/i,
        hsva: /^hsva?\D+([\d.]+)\D+([\d.]+)\D+([\d.]+)\D*?(([\d.]+)(%?)|$)/i,
        hexa: /^#?(([\da-f]{3,4})|([\da-f]{6})|([\da-f]{8}))$/i
    };
    for (const [t2, n2] of Object.entries(r2)){
        const r3 = n2.exec(e2);
        if (r3) switch(t2){
            case "rgba":
                {
                    const e3 = d$h(r3);
                    let n3 = e3[1], u2 = e3[3], o2 = e3[5], c2 = e3[8];
                    if (n3 = "%" === r3[2] ? n3 / 100 * 255 : n3, u2 = "%" === r3[4] ? u2 / 100 * 255 : u2, o2 = "%" === r3[6] ? o2 / 100 * 255 : o2, c2 = "%" === r3[9] ? c2 / 100 : c2, n3 > 255 || u2 > 255 || o2 > 255 || c2 < 0 || c2 > 1) break;
                    return {
                        values: [
                            ...s$p(n3, u2, o2),
                            c2
                        ],
                        a: c2,
                        colorType: t2
                    };
                }
            case "hexa":
                {
                    let [, e3] = r3;
                    4 !== e3.length && 3 !== e3.length || (e3 = [
                        ...e3
                    ].map((e4)=>e4 + e4).join(""));
                    const n3 = e3.slice(0, 6);
                    let u2 = e3.slice(6);
                    return u2 = u2 ? Number.parseInt(u2, 16) / 255 : void 0, {
                        values: [
                            ...a$l(n3),
                            u2
                        ],
                        a: u2,
                        colorType: t2
                    };
                }
            case "hsla":
                {
                    const e3 = d$h(r3), n3 = e3[1], u2 = e3[2], o2 = e3[3];
                    let s2 = e3[5];
                    if (s2 = "%" === r3[6] ? s2 / 100 : s2, n3 > 360 || u2 > 100 || o2 > 100 || s2 < 0 || s2 > 1) break;
                    return {
                        values: [
                            ...c$q(n3, u2, o2),
                            s2
                        ],
                        a: s2,
                        colorType: t2
                    };
                }
            case "hsva":
                {
                    const e3 = d$h(r3), n3 = e3[1], u2 = e3[2], o2 = e3[3];
                    let s2 = e3[5];
                    if (s2 = "%" === r3[6] ? s2 / 100 : s2, n3 > 360 || u2 > 100 || o2 > 100 || s2 < 0 || s2 > 1) break;
                    return {
                        values: [
                            n3,
                            u2,
                            o2,
                            s2
                        ],
                        a: s2,
                        colorType: t2
                    };
                }
        }
    }
    return {
        values: null,
        colorType: null
    };
}
function l$j(e2) {
    if (e2.startsWith("var(")) {
        if ("undefined" != typeof document) {
            const r2 = document.createElement("div");
            r2.style.color = e2, document.body.appendChild(r2);
            const t2 = getComputedStyle(r2).color;
            document.body.removeChild(r2);
            const n2 = t2.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
            if (n2) return (299 * Number.parseInt(n2[1], 10) + 587 * Number.parseInt(n2[2], 10) + 114 * Number.parseInt(n2[3], 10)) / 1e3 > 165.75;
        }
        return false;
    }
    if (e2.startsWith("#")) {
        const r2 = e2.slice(1);
        return (299 * Number.parseInt(r2.slice(0, 2), 16) + 587 * Number.parseInt(r2.slice(2, 4), 16) + 114 * Number.parseInt(r2.slice(4, 6), 16)) / 1e3 > 165.75;
    }
    if (e2.startsWith("rgb")) {
        const r2 = e2.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
        if (r2) return (299 * Number.parseInt(r2[1], 10) + 587 * Number.parseInt(r2[2], 10) + 114 * Number.parseInt(r2[3], 10)) / 1e3 > 165.75;
    }
    return false;
}
const n$t = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketColorPickerValueChange = (0, $696Z8.createEvent)(this, "marketColorPickerValueChange", 7);
    }
    gradientValueChange(t2) {
        const { detail: e2 } = t2, { defaultPrevented: i2 } = this.marketColorPickerValueChange.emit({
            value: e2.value,
            prevValue: this.value
        });
        i2 || (this.value = e2.value, this.inputValue = e2.value, this.swatchList && (this.swatchList.value = this.value), this.colorInput && (this.colorInput.value = this.inputValue));
    }
    swatchValueChange(t2) {
        const { detail: e2 } = t2, { defaultPrevented: i2 } = this.marketColorPickerValueChange.emit({
            value: e2.value,
            prevValue: this.value
        });
        i2 || (this.inputValue = this.formatInputValue(e2.value), this.value = e2.value, this.gradientPicker && (this.gradientPicker.value = this.value), this.colorInput && (this.colorInput.value = this.inputValue));
    }
    inputValueChange(t2) {
        const { detail: e2 } = t2, { defaultPrevented: i2 } = this.marketColorPickerValueChange.emit({
            value: e2.value,
            prevValue: this.value
        });
        i2 || (this.value = e2.value, this.gradientPicker && (this.gradientPicker.value = this.value), this.swatchList && (this.swatchList.value = this.value));
    }
    formatInputValue(t2) {
        const e2 = i$h(t2);
        return e2.colorType && "hexa" !== e2.colorType ? "#" + o$f(e2.values[0], e2.values[1], e2.values[2]).join("") : t2;
    }
    setSubcomponentValues() {
        this.gradientPicker = this.el.querySelector(l$s("market-color-picker-gradient")), this.swatchList = this.el.querySelector(l$s("market-color-swatch-list")), this.colorInput = this.el.querySelector(l$s("market-color-picker-input")), this.gradientPicker && (this.gradientPicker.value = this.value), this.swatchList && (this.swatchList.value = this.value), this.colorInput && (this.colorInput.value = this.inputValue);
    }
    handleSlotChange() {
        this.setSubcomponentValues();
    }
    componentWillLoad() {
        this.inputValue = this.formatInputValue(this.value);
    }
    componentDidLoad() {
        this.setSubcomponentValues();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "3420d4396bc964350cdcc5c73f72d2a501f71cb7",
            class: "market-color-picker"
        }, (0, $696Z8.h)("slot", {
            key: "a7c5fbf559e2d19fecec18d10b445ebd35e7b67c",
            onSlotchange: ()=>this.handleSlotChange()
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host{display:flex;flex-direction:column;gap:var(--color-picker-vertical-spacing)}";
    }
}, [
    257,
    "market-color-picker",
    {
        value: [
            1537
        ],
        inputValue: [
            32
        ]
    },
    [
        [
            0,
            "marketColorPickerGradientValueChange",
            "gradientValueChange"
        ],
        [
            0,
            "marketColorSwatchListValueChange",
            "swatchValueChange"
        ],
        [
            0,
            "marketColorPickerInputValueChange",
            "inputValueChange"
        ]
    ]
]), c$p = n$t;
function n$s(n2) {
    return Boolean(null == n2 ? void 0 : n2.changedTouches);
}
function o$e(o2) {
    return {
        x: n$s(o2) ? o2.changedTouches[0].clientX : o2.clientX,
        y: n$s(o2) ? o2.changedTouches[0].clientY : o2.clientY
    };
}
const p$9 = "primary-pointer", u$d = "secondary-pointer", g$a = [
    50,
    50
], m$7 = [
    95,
    10
], v$6 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketColorPickerGradientValueChange = (0, $696Z8.createEvent)(this, "marketColorPickerGradientValueChange", 7), this.secondaryPointerCoordinates = m$7, this.boundOnDragMove = this.onDragMove.bind(this), this.boundOnDragEnd = this.onDragEnd.bind(this), this.throttledUpdatePointerOnDrag = d$j(this.updatePointerOnDrag.bind(this), 16);
    }
    onDragStart(t2, e2) {
        if (t2.preventDefault(), t2.stopPropagation(), !n$s(t2) && 0 !== t2.button) return;
        const i2 = o$e(t2);
        this.updatePointerOnDrag(i2.x, i2.y, e2), this.draggablePointer = e2, document.addEventListener("mousemove", this.boundOnDragMove), document.addEventListener("mouseup", this.boundOnDragEnd), document.addEventListener("touchmove", this.boundOnDragMove, {
            passive: false
        }), document.addEventListener("touchend", this.boundOnDragEnd, {
            passive: false
        });
    }
    onDragMove(t2) {
        t2.preventDefault();
        const e2 = o$e(t2);
        this.throttledUpdatePointerOnDrag(e2.x, e2.y, this.draggablePointer);
    }
    onDragEnd(t2) {
        t2.preventDefault(), this.draggablePointer = null, document.removeEventListener("mousemove", this.boundOnDragMove), document.removeEventListener("mouseup", this.boundOnDragEnd), document.removeEventListener("touchmove", this.boundOnDragMove), document.removeEventListener("touchend", this.boundOnDragEnd);
    }
    updatePointerOnDrag(t2, e2, i2) {
        const r2 = i2.parentElement;
        if (!r2) return;
        const s2 = r2.getBoundingClientRect();
        let a2 = (t2 - s2.left) / s2.width, o2 = (e2 - s2.top) / s2.height;
        a2 = Math.max(Math.min(a2, 1), 0), o2 = Math.max(Math.min(o2, 1), 0), this.setPointerCoordinates({
            pointer: i2,
            x: 100 * a2,
            y: 100 * o2
        });
    }
    setPointerCoordinates(t2) {
        const { pointer: e2, x: i2, y: r2 = 50, emitEvent: s2 = true, colorType: a2 = "" } = t2, o2 = e2.offsetWidth / 2;
        e2.style.left = `calc(${i2}% - ${o2}px)`, e2.id === p$9 ? this.setPrimaryGradientColor(i2 / 100, s2) : e2.id === u$d && (e2.style.top = `calc(${r2}% - ${o2}px)`, this.setSecondaryGradientColor(i2 / 100, r2 / 100, s2, a2));
    }
    setPrimaryGradientColor(t2, e2 = true) {
        this.primaryHue = 360 * t2, this.primaryPointer.style.background = `hsl(${this.primaryHue}, 100%, 50%)`, this.updateSecondaryGradient(e2);
    }
    setSecondaryGradientColor(t2, e2, i2 = true, r2 = "") {
        const s2 = 100 * t2, a2 = 100 - 100 * e2;
        let o2, n2;
        "rgba" === r2 ? (o2 = u$e(this.primaryHue, s2, a2), n2 = `rgb(${o2[0]}, ${o2[1]}, ${o2[2]})`) : (o2 = o$f(this.primaryHue, s2, a2), n2 = "#" + o2.join("")), this.secondaryPointer.style.background = n2, this.secondaryPointerCoordinates = [
            t2,
            e2
        ], i2 && this.marketColorPickerGradientValueChange.emit({
            value: n2
        });
    }
    updateSecondaryGradient(t2 = true) {
        this.el.shadowRoot.querySelector(".secondary-gradient").style.background = `
      linear-gradient(to top, rgb(0, 0, 0), transparent),
      linear-gradient(to left, hsl(${this.primaryHue}, 100%, 50%), rgb(255, 255, 255))
    `, this.setSecondaryGradientColor(...this.secondaryPointerCoordinates, t2);
    }
    updateGradientsByValue() {
        const t2 = i$h(this.value);
        if (t2.values && this.primaryPointer && this.secondaryPointer) {
            const e2 = {
                pointer: this.secondaryPointer,
                x: t2.values[1],
                y: 100 - t2.values[2],
                colorType: t2.colorType,
                emitEvent: false
            };
            return this.setPointerCoordinates({
                pointer: this.primaryPointer,
                x: 100 * t2.values[0] / 360,
                emitEvent: false
            }), this.setPointerCoordinates(e2), true;
        }
        return false;
    }
    setInitialPointers() {
        const t2 = [
            g$a,
            m$7
        ];
        [
            this.primaryPointer,
            this.secondaryPointer
        ].forEach((e2, i2)=>{
            this.setPointerCoordinates({
                pointer: e2,
                x: t2[i2][0],
                y: t2[i2][1],
                emitEvent: false
            });
        });
    }
    componentDidLoad() {
        this.primaryPointer = this.el.shadowRoot.querySelector("#" + p$9), this.secondaryPointer = this.el.shadowRoot.querySelector("#" + u$d), this.updateGradientsByValue() || this.setInitialPointers();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "a3f97a9e7b01392d75da533ba3edcd97fe2c90ff",
            class: "market-color-picker-gradient"
        }, (0, $696Z8.h)("slot", {
            key: "351e53194da901e05a1e60987bc7212305312229"
        }), (0, $696Z8.h)("div", {
            key: "0a6c18fda445a8dc2cefaa611d7cbb7b17bc9453",
            class: "primary-gradient",
            role: "input",
            onMouseDown: (t2)=>this.onDragStart(t2, this.primaryPointer),
            onTouchStart: (t2)=>this.onDragStart(t2, this.primaryPointer)
        }, (0, $696Z8.h)("div", {
            key: "ddea8f9865b7f8a16575af0c936f1da44df8b825",
            id: p$9,
            class: "pointer"
        })), (0, $696Z8.h)("div", {
            key: "60b948f8792c6580afa34a7a378d4fd332bfb7c6",
            class: "secondary-gradient",
            role: "input",
            onMouseDown: (t2)=>this.onDragStart(t2, this.secondaryPointer),
            onTouchStart: (t2)=>this.onDragStart(t2, this.secondaryPointer)
        }, (0, $696Z8.h)("div", {
            key: "d8bf40d83b91d8626bd2770413a5ff2df49933e8",
            id: u$d,
            class: "pointer"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    updateGradientsByValue: 0
                }
            ]
        };
    }
    static get style() {
        return ":host{--primary-gradient-height:var(--color-picker-adjustments-hue-min-height);--gradient-border-radius:var(--color-picker-adjustments-hue-radius);--gradient-margin:var(--color-picker-vertical-spacing);--secondary-gradient-height:calc(var(--color-picker-adjustments-saturation-brightness-min-height) * 1px);--gradient-pointer-width:12px;--gradient-pointer-height:12px;--gradient-pointer-border:2px white solid;--gradient-pointer-border-radius:50%;display:block}.primary-gradient{position:relative;width:100%;height:var(--primary-gradient-height);border-radius:var(--gradient-border-radius);background:linear-gradient(       to right,       hsl(0deg 100% 50%),       hsl(60deg 100% 50%),       hsl(120deg 100% 50%),       hsl(180deg 100% 50%),       hsl(240deg 100% 50%),       hsl(300deg 100% 50%),       hsl(0deg 100% 50%)     )}.secondary-gradient{position:relative;width:100%;height:var(--secondary-gradient-height);margin-top:var(--gradient-margin);border-radius:var(--gradient-border-radius)}.pointer{position:absolute;z-index:2;width:var(--gradient-pointer-width);height:var(--gradient-pointer-height);border:var(--gradient-pointer-border);border-radius:var(--gradient-pointer-border-radius);box-shadow:var(--elevation-20-shadow)}#primary-pointer{top:calc(50% - 8px)}";
    }
}, [
    257,
    "market-color-picker-gradient",
    {
        value: [
            1
        ]
    },
    void 0,
    {
        value: [
            {
                updateGradientsByValue: 0
            }
        ]
    }
]), b$9 = v$6;
const n$r = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketColorPickerInputValueChange = (0, $696Z8.createEvent)(this, "marketColorPickerInputValueChange", 7);
    }
    displayLeadingAccessory() {
        const t2 = l$s("market-color-swatch");
        return i$h(this.value).values ? (0, $696Z8.h)(t2, {
            value: this.value,
            disabled: true
        }) : (0, $696Z8.h)("div", {
            class: "color-picker-input-icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M17 4.17004C17.72 4.17004 18.45 4.45004 19 5.00004C20.1 6.10004 20.1 7.90004 19 9.00004L17 11L8 20H4V16L13 7.00004L15 5.00004C15.55 4.45004 16.28 4.17004 17 4.17004ZM17.01 6.17004C16.88 6.17004 16.63 6.20004 16.42 6.41004L15.84 7.01004L17.01 8.18004L17.6 7.59004C17.81 7.37004 17.84 7.13004 17.84 7.00004C17.84 6.87004 17.82 6.62004 17.6 6.41004C17.38 6.20004 17.14 6.17004 17.01 6.17004ZM6 18H7.17L15.58 9.59004L14.41 8.42004L6 16.83V18ZM12 18.0001H20V20.0001H12V18.0001Z"
        })));
    }
    inputValueChange(e2) {
        const { detail: t2 } = e2, r2 = this.value;
        this.formatAndUpdateValue(t2.value);
        const { defaultPrevented: i2 } = this.marketColorPickerInputValueChange.emit({
            prevValue: r2,
            value: this.value
        });
        i2 && (this.value = r2);
    }
    formatAndUpdateValue(e2 = this.value) {
        if (!e2) return;
        let t2 = e2;
        "#" !== t2[0] && (t2 = "#" + t2), this.value = t2;
    }
    componentWillLoad() {
        this.formatAndUpdateValue();
    }
    render() {
        const t2 = l$s("market-input-text");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "4c584dc557c869b77da25584bdc7d22b28c26009",
            class: "market-color-picker-input"
        }, (0, $696Z8.h)(t2, {
            key: "35372a683c43b10f0bff739af28d88a312b84a5f",
            value: this.value,
            id: "color-picker-input-text",
            maxlength: 7
        }, (0, $696Z8.h)("div", {
            key: "f0f23575dde4f47843340376f20b4dffbc76fc9e",
            slot: "leading-accessory"
        }, this.displayLeadingAccessory()), (0, $696Z8.h)("label", {
            key: "1f3dfafeafc65ad10002bcf5ba37848a332730c2",
            htmlFor: "color-picker-input-text"
        }, (0, $696Z8.h)("slot", {
            key: "31d9184dab3c72c71578a08e50f2dfd8ba00efaf",
            name: "label"
        }, "Hex")), (0, $696Z8.h)("slot", {
            key: "2d3e909b21965f0dcc7c9771812709034055251b"
        })));
    }
    static get style() {
        return ":host{display:block}.market-color-swatch{vertical-align:middle;margin:var(--color-picker-input-icon-vertical-spacing, 12px) 0}.color-picker-input-icon{display:flex;justify-content:center;align-items:center;width:var(--color-picker-input-width, 40px);height:var(--color-picker-input-height, 40px);margin:12px 0;border-radius:var(--color-picker-icon-border-radius, calc(var(--core-radius-10) * 1px));background-color:var(--color-picker-icon-background-color, var(--core-fill-40-color))}.color-picker-input-icon svg path{fill:var(--core-fill-10-color)}";
    }
}, [
    257,
    "market-color-picker-input",
    {
        value: [
            1537
        ]
    },
    [
        [
            0,
            "marketInputValueChange",
            "inputValueChange"
        ]
    ]
]), s$o = n$r;
const c$o = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketColorSwatchSelectedChange = (0, $696Z8.createEvent)(this, "marketColorSwatchSelectedChange", 7), this.value = e$j, this.selected = false;
    }
    toggleSelection() {
        if (this.disabled) return;
        const e2 = !this.selected, t2 = {
            value: this.value,
            selected: e2
        }, { defaultPrevented: o2 } = this.marketColorSwatchSelectedChange.emit(t2);
        o2 || (this.selected = e2);
    }
    render() {
        const e2 = l$j(this.value) ? "checkmark-icon bright-background" : "checkmark-icon";
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "9c018edd3795c17c69f9159b8f96e2ed5eaa3c9e",
            class: "market-color-swatch",
            role: "listitem",
            onClick: ()=>this.toggleSelection(),
            style: {
                "--swatch-color": this.value
            }
        }, (0, $696Z8.h)("div", {
            key: "e875933cad4184e30853dd4c6c6ad7cd49221bf7",
            class: "inner-circle"
        }), (0, $696Z8.h)("svg", {
            key: "9683c3d42063e523d146e4c3360ac453e92f0dab",
            class: e2,
            width: "18",
            height: "12",
            viewBox: "0 0 18 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "41e5eeb32214f7a8ea8e501bea0c389f2cc63d5d",
            d: "M6.7 11.7C6.96 11.7 7.21 11.6 7.41 11.41L17.41 1.41L16 0L6.7 9.29L1.41 4L0 5.41L6 11.41C6.19 11.6 6.44 11.7 6.7 11.7Z"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host{position:relative;display:inline-block;width:40px;height:40px;border-radius:50%;background-color:var(--swatch-color);box-shadow:inset 0 0 0 1px rgb(0 0 0 / 15%);transition:box-shadow     var(--core-animation-enter-transition-moderate-speed-duration)     var(--core-animation-enter-transition-easing)}:host .inner-circle{position:absolute;top:50%;left:50%;width:0;height:0;border:0;border-radius:50%;background-color:white;box-shadow:0 0 0 0 rgb(0 0 0 / 15%);transition:width       var(--core-animation-enter-transition-moderate-speed-duration)       var(--core-animation-enter-transition-easing),       height       var(--core-animation-enter-transition-moderate-speed-duration)       var(--core-animation-enter-transition-easing),       box-shadow       var(--core-animation-enter-transition-moderate-speed-duration)       var(--core-animation-enter-transition-easing),       border       var(--core-animation-enter-transition-fast-speed-duration)       var(--core-animation-enter-transition-easing);transform:translate(-50%, -50%)}:host .checkmark-icon{position:absolute;top:50%;left:50%;opacity:0;transition:opacity var(--core-animation-enter-transition-moderate-speed-duration) ease-out;transform:translate(-50%, -50%)}:host(:hover:not([disabled])) .inner-circle{width:8px;height:8px;box-shadow:0 0 0 1px rgb(0 0 0 / 15%)}:host([selected]){box-shadow:inset 0 0 0 2px var(--color-picker-swatch-selected-state-border-color, #006aff)}:host([selected]) .inner-circle,:host([selected]:hover) .inner-circle{width:32px;height:32px;border:2px solid white;background-color:transparent;box-shadow:inset 0 0 0 1px rgb(0 0 0 / 15%)}:host([selected]) .checkmark-icon{opacity:1}:host(:active:not([disabled])) .inner-circle,:host([selected]:active) .inner-circle{width:16px;height:16px;border:0;background-color:white;box-shadow:0 0 0 1px rgb(0 0 0 / 15%)}:host([selected]:active:not([disabled])) .checkmark-icon{opacity:0}.checkmark-icon path{fill:var(--core-text-10-dark-mode-color)}.checkmark-icon.bright-background path{fill:var(--core-text-10-light-mode-color)}:host(:hover:not([disabled])) .inner-circle,:host(:active:not([disabled])) .inner-circle{transition:width var(--core-animation-exit-transition-moderate-speed-duration),     height var(--core-animation-exit-transition-moderate-speed-duration),     box-shadow var(--core-animation-exit-transition-moderate-speed-duration),     border var(--core-animation-exit-transition-fast-speed-duration)}";
    }
}, [
    1,
    "market-color-swatch",
    {
        value: [
            513
        ],
        name: [
            513
        ],
        disabled: [
            516
        ],
        selected: [
            1540
        ]
    }
]);
const s$n = c$o;
const E$4 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketColorSwatchListValueChange = (0, $696Z8.createEvent)(this, "marketColorSwatchListValueChange", 7);
    }
    valueWatcher() {
        this.setSelectionFromValue();
    }
    colorSwatchSelectedEventHandler(t2) {
        this.handleItemSelectedEvent(t2.detail);
    }
    handleItemSelectedEvent(t2) {
        const e2 = t2.selected ? t2.value : "";
        if (this.value === e2) return;
        const { defaultPrevented: a2 } = this.marketColorSwatchListValueChange.emit({
            value: e2,
            prevValue: this.value
        });
        a2 || (this.value = e2);
    }
    setSelectionFromValue() {
        let t2 = [
            ...this.el.querySelectorAll(l$s("market-color-swatch"))
        ];
        0 === t2.length && (t2 = [
            ...this.el.shadowRoot.querySelectorAll(l$s("market-color-swatch"))
        ]), t2.forEach((t3)=>t3.selected = this.value === t3.value);
    }
    handleSlotChange() {
        this.setSelectionFromValue();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "11c312833be18cf818def34c641bd0ebd9d40b74",
            class: "market-color-swatch-list",
            role: "list"
        }, (0, $696Z8.h)("slot", {
            key: "f01a29312baca18a3e568ec5ab4b3f8d82257cc9",
            onSlotchange: ()=>this.handleSlotChange()
        }, [
            i$o,
            S$a,
            w$9,
            x$a,
            u$j,
            z$6,
            c$w,
            v$9,
            d$m,
            f$e,
            e$j,
            T$7,
            C$5,
            p$c
        ].map((t2)=>(0, $696Z8.h)("market-color-swatch", {
                value: t2
            }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    valueWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ":host{display:grid;grid-template-columns:repeat(auto-fill, var(--color-swatch-width, 40px));gap:var(--color-swatch-list-spacing, 16px)}";
    }
}, [
    257,
    "market-color-swatch-list",
    {
        value: [
            1537
        ]
    },
    [
        [
            0,
            "marketColorSwatchSelectedChange",
            "colorSwatchSelectedEventHandler"
        ]
    ],
    {
        value: [
            {
                valueWatcher: 0
            }
        ]
    }
]), x$9 = E$4;
const d$g = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(o2){
        super(), false !== o2 && this.__registerHost(), this.__attachShadow();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "0f4a8a96e25747ead84011665edc70c142d75b87",
            class: "market-content-card"
        }, (0, $696Z8.h)("slot", {
            key: "0f37d14cffecf4dda883ef7364a541fd2ddd13a4"
        }));
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:block;padding:var(--content-card-padding-vertical-size) var(--content-card-padding-horizontal-size);border:var(--content-card-border-width) solid var(--content-card-border-color);border-radius:var(--content-card-border-radius);background-color:var(--content-card-background-color)}";
    }
}, [
    257,
    "market-content-card"
]), c$n = d$g;
const h$d = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketContextContentsChanged = (0, $696Z8.createEvent)(this, "marketContextContentsChanged", 7), this.marketContextEmptied = (0, $696Z8.createEvent)(this, "marketContextEmptied", 7), this.noVeil = false, this.hidden = false, this.animationEnterDuration = n$H, this.animationExitDuration = h$h, this.stack = [], this.totalCount = 0, this.dialogMeta = {};
    }
    currentDialogWatcher(t2) {
        this.stack.push(t2), this.stack = [
            ...this.stack
        ];
    }
    stackWatcher(t2) {
        t2.forEach((t3)=>{
            this.dialogMeta[t3.type].count += 1, this.totalCount += 1;
        }), 0 === t2.length && (this.hidden = true, this.stackWatcherTimeout = setTimeout(()=>{
            this.marketContextEmptied.emit();
        }, this.animationExitDuration)), this.setContextVeil();
    }
    doesStackContainDialogThatRequiresVeil(t2) {
        return Object.entries(a$s).filter(([, t3])=>t3.veil).map(([t3])=>l$s("market-" + t3)).includes(t2.tagName.toLowerCase());
    }
    setContextVeil() {
        this.el.hasAttribute("no-veil") || 0 === this.stack.length || (this.noVeil = !this.stack.some((t2)=>this.doesStackContainDialogThatRequiresVeil(t2.el)));
    }
    stackHasDialog(t2) {
        return this.stack.some((e2)=>e2.el === t2);
    }
    modalLoadedEventHandler(t2) {
        const e2 = t2.detail.dialog, i2 = t2.detail.type;
        if (e2.parentElement !== this.el) return;
        if (this.stackHasDialog(e2)) return;
        const o2 = this.generateDialogID(i2);
        e2.dialogID = o2, e2.id = e2.id || o2, this.currentDialog = {
            el: e2,
            type: i2,
            dialogID: e2.dialogID,
            id: e2.id,
            index: this.stack.length,
            indexOfType: this.dialogMeta[i2].count + 1
        }, this.marketContextContentsChanged.emit({
            action: "marketNewDialogOpened",
            currentDialog: this.currentDialog,
            stack: this.stack
        });
    }
    dialogDismissedEventHandler(t2) {
        t2.defaultPrevented || t2.target.parentElement === this.el && this.close(t2.detail.dialog.dialogID);
    }
    generateDialogID(t2) {
        return `${t2}-${this.dialogMeta[t2].count + 1}`;
    }
    getDialogByID(t2) {
        return this.stack.find((e2)=>e2.dialogID === t2);
    }
    open(t2) {
        return 0 === this.stack.length && (this.noVeil = !this.doesStackContainDialogThatRequiresVeil(t2)), this.el.appendChild(t2), Promise.resolve();
    }
    close(t2) {
        let e2;
        const i2 = this.stack.indexOf(e2);
        if (t2 ? (e2 = this.stack.find((e3)=>e3.dialogID === t2), e2 || console.warn(`Tried to close dialog with data-dialog-id "${t2}" but none were found`)) : e2 = this.currentDialog, e2) {
            if ("dialog" === e2.type && e2.el.persistent) return Promise.resolve();
            this.closeTimeout = setTimeout(()=>{
                var t3;
                "function" == typeof (null === (t3 = null == e2 ? void 0 : e2.el) || void 0 === t3 ? void 0 : t3.remove) && e2.el.remove(), this.stack.splice(i2, 1), this.stack = [
                    ...this.stack
                ], this.marketContextContentsChanged.emit({
                    action: "marketDialogClosed",
                    currentDialog: e2,
                    stack: this.stack
                });
            }, e2.el.animationExitDuration);
        }
        return Promise.resolve();
    }
    closeCurrent() {
        return this.close(), Promise.resolve();
    }
    connectedCallback() {
        e$f.forEach((t2)=>{
            this.dialogMeta[t2] = {
                count: 0
            };
        });
    }
    disconnectedCallback() {
        clearTimeout(this.stackWatcherTimeout), clearTimeout(this.closeTimeout);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "1032055a62ec1880fc739005c750b440d1af9fbd",
            class: "market-context " + (this.noVeil ? "no-veil" : "")
        }, (0, $696Z8.h)("slot", {
            key: "305da5db1cd5c7482580897621b5da3bb168cace"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            currentDialog: [
                {
                    currentDialogWatcher: 0
                }
            ],
            stack: [
                {
                    stackWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:absolute;display:grid;justify-items:center;width:100vw;height:100%;animation:var(--core-animation-enter-transition-moderate-speed-duration)     market-fade-in     forwards     var(--core-animation-enter-transition-easing)}:host([hidden]){opacity:0;animation-name:market-fade-out;animation-duration:var(--core-animation-exit-transition-moderate-speed-duration);animation-timing-function:var(--core-animation-exit-transition-easing)}:host>*{pointer-events:auto}:host(:not(.no-veil)){background-color:var(--core-surface-overlay-color);opacity:1;pointer-events:auto}:host(.no-veil){pointer-events:none}@media screen and (width >= 800px){::slotted(.market-modal-partial){align-self:center;margin:var(--modal-partial-vertical-screen-buffer-size) var(--modal-partial-horizontal-screen-buffer-size)}}::slotted(.market-dialog){align-self:center;width:calc(100% - (2 * var(--modal-dialog-horizontal-screen-buffer-size, 16px)))}";
    }
}, [
    257,
    "market-context",
    {
        currentDialog: [
            1040
        ],
        noVeil: [
            1028,
            "no-veil"
        ],
        hidden: [
            1540
        ],
        animationEnterDuration: [
            2,
            "animation-enter-duration"
        ],
        animationExitDuration: [
            2,
            "animation-exit-duration"
        ],
        stack: [
            32
        ],
        totalCount: [
            32
        ],
        dialogMeta: [
            32
        ],
        open: [
            64
        ],
        close: [
            64
        ],
        closeCurrent: [
            64
        ]
    },
    [
        [
            0,
            "marketDialogLoaded",
            "modalLoadedEventHandler"
        ],
        [
            0,
            "marketDialogDismissed",
            "dialogDismissedEventHandler"
        ]
    ],
    {
        currentDialog: [
            {
                currentDialogWatcher: 0
            }
        ],
        stack: [
            {
                stackWatcher: 0
            }
        ]
    }
]), u$c = h$d;
const c$m = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketContextManagerActivated = (0, $696Z8.createEvent)(this, "marketContextManagerActivated", 7), this.marketContextManagerDeactivated = (0, $696Z8.createEvent)(this, "marketContextManagerDeactivated", 7), this.active = false, this.stack = [];
    }
    initChildListObserver() {
        const t2 = ()=>{
            this.stack = [
                ...this.el.children
            ], this.currentContext = this.stack.length > 0 ? this.stack.at(-1) : null;
        };
        t2(), this.childListObserver || (this.childListObserver = new MutationObserver(t2)), this.childListObserver.observe(this.el, {
            childList: true
        });
    }
    async getCurrentContext() {
        for(; !this.currentContext;)await n$z();
        return this.currentContext;
    }
    contextEmptiedEventHandler({ target: t2 }) {
        "function" == typeof (null == t2 ? void 0 : t2.remove) && t2.remove(), this.stack.splice(this.stack.indexOf(t2), 1), 0 === this.stack.length && this.deactivate();
    }
    windowKeydown(t2) {
        var e2, o2;
        if ("Escape" === t2.key || "Esc" === t2.key) {
            const t3 = null === (e2 = this.currentContext) || void 0 === e2 ? void 0 : e2.currentDialog;
            "function" == typeof (null === (o2 = null == t3 ? void 0 : t3.el) || void 0 === o2 ? void 0 : o2.dismiss) && t3.el.dismiss({
                origin: this.el
            });
        }
    }
    async open(t2, e2) {
        let o2 = e2;
        this.currentContext && !t2 || (o2 = true), o2 && this.createNewContext(), await this.currentContext.open(t2);
    }
    close(t2) {
        return this.currentContext.close(t2), Promise.resolve();
    }
    createNewContext() {
        return this.activate(), this.el.appendChild(document.createElement(l$s("market-context"))), this.currentContext = this.el.lastElementChild, Promise.resolve();
    }
    deactivate() {
        return this.active = false, this.marketContextManagerDeactivated.emit(), Promise.resolve();
    }
    activate() {
        return this.active || (this.active = true, this.marketContextManagerActivated.emit()), Promise.resolve();
    }
    handleMouseEvents(t2) {
        var e2, o2;
        if ("mousedown" === t2.type) this.mouseDownEl = t2.target.tagName;
        else if ("mouseup" === t2.type && this.mouseDownEl === t2.target.tagName && t2.target.tagName.toLowerCase() === l$s("market-context") && !t2.target.classList.contains("no-veil")) {
            const t3 = null === (e2 = this.currentContext) || void 0 === e2 ? void 0 : e2.currentDialog;
            "function" == typeof (null === (o2 = null == t3 ? void 0 : t3.el) || void 0 === o2 ? void 0 : o2.dismiss) && t3.el.dismiss({
                origin: this.el
            });
        }
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "6fae0fd5f1459fa14f6e9bd802eb183076a1a801",
            class: "market-context-manager",
            onMouseDown: (t2)=>this.handleMouseEvents(t2),
            onMouseUp: (t2)=>this.handleMouseEvents(t2)
        }, (0, $696Z8.h)("slot", {
            key: "3c09704c7308eceb5a6bbd7d7bc113d28e1bd876"
        }));
    }
    connectedCallback() {
        this.initChildListObserver();
    }
    disconnectedCallback() {
        var t2;
        null === (t2 = this.childListObserver) || void 0 === t2 || t2.disconnect();
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:fixed;top:0;left:0;z-index:-1000;display:block;overflow:hidden;width:100vw;height:100%;opacity:0}:host([active]){z-index:1000;opacity:1;pointer-events:none}";
    }
}, [
    257,
    "market-context-manager",
    {
        active: [
            1540
        ],
        currentContext: [
            32
        ],
        stack: [
            32
        ],
        open: [
            64
        ],
        close: [
            64
        ],
        createNewContext: [
            64
        ],
        deactivate: [
            64
        ],
        activate: [
            64
        ]
    },
    [
        [
            0,
            "marketContextEmptied",
            "contextEmptiedEventHandler"
        ],
        [
            8,
            "keydown",
            "windowKeydown"
        ]
    ]
]), d$f = c$m;
var t$4;
!function(t2) {
    t2.TODAY = "today", t2.YESTERDAY = "yesterday", t2.THIS_WEEK = "this-week", t2.LAST_WEEK = "last-week", t2.THIS_MONTH = "this-month", t2.LAST_MONTH = "last-month", t2.THIS_YEAR = "this-year", t2.LAST_YEAR = "last-year", t2.PAY_PERIOD = "pay-period", t2.CUSTOM = "custom";
}(t$4 || (t$4 = {}));
function e$8(t2) {
    return e$8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e2) {
        return typeof e2;
    } : function(e2) {
        return e2 && "function" == typeof Symbol && e2.constructor === Symbol && e2 !== Symbol.prototype ? "symbol" : typeof e2;
    }, e$8(t2);
}
function t$3(e2) {
    if (null === e2 || true === e2 || false === e2) return NaN;
    var t2 = Number(e2);
    return isNaN(t2) ? t2 : t2 < 0 ? Math.ceil(t2) : Math.floor(t2);
}
function n$q(e2, t2) {
    if (t2.length < e2) throw new TypeError(e2 + " argument" + (e2 > 1 ? "s" : "") + " required, but only " + t2.length + " present");
}
function o$d(t2) {
    n$q(1, arguments);
    var o2 = Object.prototype.toString.call(t2);
    return t2 instanceof Date || "object" === e$8(t2) && "[object Date]" === o2 ? new Date(t2.getTime()) : "number" == typeof t2 || "[object Number]" === o2 ? new Date(t2) : ("string" != typeof t2 && "[object String]" !== o2 || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
var r$b = {};
function a$k() {
    return r$b;
}
function a$j(a2) {
    n$q(1, arguments);
    var t2 = o$d(a2);
    return t2.setHours(0, 0, 0, 0), t2;
}
function t$2(n2, t2) {
    n$q(2, arguments);
    var s2 = a$j(n2), u2 = a$j(t2);
    return s2.getTime() === u2.getTime();
}
function s$m(a2, t2) {
    n$q(2, arguments);
    var s2 = o$d(a2), u2 = o$d(t2);
    return s2.getTime() > u2.getTime();
}
function u$b(a2, t2) {
    n$q(2, arguments);
    var s2 = o$d(a2), u2 = o$d(t2);
    return s2.getTime() < u2.getTime();
}
function y$9(e2, t2) {
    n$q(2, arguments);
    var a2 = o$d(e2), i2 = t$3(t2);
    if (isNaN(i2)) return /* @__PURE__ */ new Date(NaN);
    if (!i2) return a2;
    var s2 = a2.getDate(), n2 = new Date(a2.getTime());
    return n2.setMonth(a2.getMonth() + i2 + 1, 0), s2 >= n2.getDate() ? n2 : (a2.setFullYear(n2.getFullYear(), n2.getMonth(), s2), a2);
}
function k$5(e2, t2) {
    var a2, i2, s2, n2, r2, d2, u2, m2;
    n$q(1, arguments);
    var b2 = a$k(), f2 = t$3(null !== (a2 = null !== (i2 = null !== (s2 = null !== (n2 = null == t2 ? void 0 : t2.weekStartsOn) && void 0 !== n2 ? n2 : null == t2 || null === (r2 = t2.locale) || void 0 === r2 || null === (d2 = r2.options) || void 0 === d2 ? void 0 : d2.weekStartsOn) && void 0 !== s2 ? s2 : b2.weekStartsOn) && void 0 !== i2 ? i2 : null === (u2 = b2.locale) || void 0 === u2 || null === (m2 = u2.options) || void 0 === m2 ? void 0 : m2.weekStartsOn) && void 0 !== a2 ? a2 : 0);
    if (!(f2 >= 0 && f2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var v2 = o$d(e2), y2 = v2.getDay(), k2 = (y2 < f2 ? 7 : 0) + y2 - f2;
    return v2.setDate(v2.getDate() - k2), v2.setHours(0, 0, 0, 0), v2;
}
function p$8(e2) {
    n$q(1, arguments);
    var t2 = o$d(e2);
    return t2.setDate(1), t2.setHours(0, 0, 0, 0), t2;
}
function g$9(e2) {
    n$q(1, arguments);
    var t2 = o$d(e2), a2 = /* @__PURE__ */ new Date(0);
    return a2.setFullYear(t2.getFullYear(), 0, 1), a2.setHours(0, 0, 0, 0), a2;
}
function w$7(e2, t2) {
    var a2, i2, s2, n2, r2, d2, u2, m2;
    n$q(1, arguments);
    var b2 = a$k(), f2 = t$3(null !== (a2 = null !== (i2 = null !== (s2 = null !== (n2 = null == t2 ? void 0 : t2.weekStartsOn) && void 0 !== n2 ? n2 : null == t2 || null === (r2 = t2.locale) || void 0 === r2 || null === (d2 = r2.options) || void 0 === d2 ? void 0 : d2.weekStartsOn) && void 0 !== s2 ? s2 : b2.weekStartsOn) && void 0 !== i2 ? i2 : null === (u2 = b2.locale) || void 0 === u2 || null === (m2 = u2.options) || void 0 === m2 ? void 0 : m2.weekStartsOn) && void 0 !== a2 ? a2 : 0);
    if (!(f2 >= 0 && f2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var v2 = o$d(e2), y2 = v2.getDay(), k2 = 6 + (y2 < f2 ? -7 : 0) - (y2 - f2);
    return v2.setDate(v2.getDate() + k2), v2.setHours(23, 59, 59, 999), v2;
}
function D$7(e2) {
    n$q(1, arguments);
    var t2 = o$d(e2), a2 = t2.getMonth();
    return t2.setFullYear(t2.getFullYear(), a2 + 1, 0), t2.setHours(0, 0, 0, 0), t2;
}
function x$8(e2) {
    n$q(1, arguments);
    var t2 = o$d(e2), a2 = t2.getFullYear();
    return t2.setFullYear(a2 + 1, 0, 0), t2.setHours(0, 0, 0, 0), t2;
}
let S$8 = class S {
    constructor(){
        this.date = "", this.year = null, this.selected = false, this.selection = "none", this.today = false, this.disabled = false;
    }
};
const M$6 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketDateRangeChanged = (0, $696Z8.createEvent)(this, "marketDateRangeChanged", 7), this.marketMenuSelectionChanged = (0, $696Z8.createEvent)(this, "marketMenuSelectionChanged", 7), this.selectionType = "single", this.displayMenu = false, this.mobileMenuPosition = "top", this.excludeMenuItems = "", this.timeframe = "present", this.locale = navigator.language || "en-US", this.withInputs = "", this.invalid = false, this.disableViewToggle = false, this.yearViewActive = false, this.displayedWeekdays = [], this.yearViewYearsList = [], this.yearViewMonthList = [];
    }
    resetMenu() {
        var e2, t2;
        if (this.presetMenuOption && this.displayMenu) {
            const a2 = null === (e2 = this.el.shadowRoot) || void 0 === e2 ? void 0 : e2.querySelector("market-date-picker-menu");
            (null === (t2 = null == a2 ? void 0 : a2.shadowRoot) || void 0 === t2 ? void 0 : t2.querySelectorAll("market-row")).forEach((e3)=>{
                e3.getAttribute("value") === this.presetMenuOption && e3.click();
            });
        }
        return Promise.resolve();
    }
    buildWeekdays() {
        this.displayedWeekdays = [];
        const e2 = k$5(/* @__PURE__ */ new Date(), {
            weekStartsOn: this.getLocaleFirstDayOfWeek()
        });
        let t2;
        for(let a2 = 0; a2 < 7; a2++)t2 = e2.toLocaleDateString(this.locale, {
            weekday: "short"
        }), this.locale.startsWith("en-") && (t2 = t2.slice(0, -1)), this.displayedWeekdays.push(t2), e2.setDate(e2.getDate() + 1);
    }
    getFirstDayOfWeek() {
        const e2 = [
            "sunday",
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday"
        ].indexOf(this.weekStartsOn);
        return -1 === e2 ? this.getLocaleFirstDayOfWeek() : e2;
    }
    getLocaleFirstDayOfWeek() {
        var e2, t2, a2, i2, s2;
        const n2 = new Intl.Locale(this.locale);
        return (null !== (s2 = null !== (t2 = null === (e2 = null == n2 ? void 0 : n2.weekInfo) || void 0 === e2 ? void 0 : e2.firstDay) && void 0 !== t2 ? t2 : null === (i2 = null === (a2 = null == n2 ? void 0 : n2.getWeekInfo) || void 0 === a2 ? void 0 : a2.call(n2)) || void 0 === i2 ? void 0 : i2.firstDay) && void 0 !== s2 ? s2 : 0) % 7;
    }
    addHoveredDateRangeStyling(e2, t2) {
        if (!this.hoveredDate) return;
        const a2 = new Date(this.selectedStartDate);
        this.selectedStartDate && !this.selectedEndDate && u$b(e2, this.hoveredDate) && s$m(e2, a2) && (t2.selection = "range-middle"), t$2(this.hoveredDate, e2) && (t2.selection = !this.selectedStartDate || this.selectedStartDate && this.selectedEndDate || !s$m(this.hoveredDate, a2) ? "range-first" : "range-last");
    }
    addDateSelectionAttributes(e2, t2, a2, i2) {
        e2.date && (a2 && t$2(t2, a2) && (e2.selected = true, e2.selection = "single" === this.selectionType ? "single" : "range-first"), "range" === this.selectionType && (this.addHoveredDateRangeStyling(t2, e2), a2 && i2 && s$m(t2, a2) && u$b(t2, i2) && (e2.selected = true, e2.selection = "range-middle"), i2 && t$2(t2, i2) && (e2.selected = true, e2.selection = "range-last")));
    }
    buildCalendar() {
        const e2 = /* @__PURE__ */ new Date(), t2 = new Date(this.displayedDate), a2 = new Date(t2.getFullYear(), t2.getMonth(), 1), i2 = this.getLocaleFirstDayOfWeek();
        0 === a2.getDay() && 1 === i2 ? a2.setDate(a2.getDate() - 6) : a2.setDate(a2.getDate() - (a2.getDay() - i2)), this.days = [];
        const s2 = this.selectedStartDate && new Date(this.selectedStartDate), n2 = this.selectedEndDate && new Date(this.selectedEndDate);
        for(let r2 = 0; r2 < 42; r2++){
            const r3 = new S$8();
            if (r3.year = a2.getFullYear(), r3.month = a2.getMonth(), a2.getFullYear() === t2.getFullYear() && a2.getMonth() === t2.getMonth() && (r3.date = "" + a2.getDate()), t$2(a2, e2) && (r3.today = true), this.addDateSelectionAttributes(r3, a2, s2, n2), r3.date && this.isDateDisabled && (r3.disabled = this.isDateDisabled(a2)), "future" === this.timeframe && u$b(a2, e2) && !t$2(a2, e2) && (r3.disabled = true), "past" === this.timeframe && s$m(a2, e2) && !t$2(a2, e2) && (r3.disabled = true), this.days.push(r3), a2.setDate(a2.getDate() + 1), a2.getDay() === 0 + i2 && a2.getMonth() !== t2.getMonth()) break;
        }
    }
    clearDateSelections() {
        this.selectedStartDate = null, this.selectedEndDate = null;
    }
    navigateMonth(e2) {
        const t2 = new Date(this.displayedDate);
        this.displayedDate = new Date(t2.getFullYear(), t2.getMonth() + e2, 1).toISOString();
    }
    dateInputDateSet({ detail: { date: e2, input: t2 } }) {
        const [a2, i2] = e2.split("T"), [s2, n2, r2] = a2.split("-").map(Number);
        this.displayedDate = "" + new Date(s2, n2 - 1, 1);
        const [d2, o2] = "date-and-time" === this.withInputs ? i2.split(":").map(Number) : [];
        this._selectDate({
            day: r2,
            month: n2 - 1,
            year: s2,
            hour: d2,
            minute: o2,
            input: t2
        });
    }
    selectDate({ detail: { date: e2 } }) {
        "day" === e2.type ? this._selectDate({
            day: e2.day
        }) : this.updateDisplayedHeader(e2.type, e2.day);
    }
    hoverDate({ detail: { date: e2 } }) {
        const t2 = new Date(this.displayedDate);
        this.hoveredDate = new Date(t2.getFullYear(), t2.getMonth(), e2.day);
    }
    mousedOutDate() {
        this.hoveredDate = null;
    }
    selectMenuRow(e2) {
        const t2 = e2.detail.menuSelection;
        if (!t2) return;
        this.marketMenuSelectionChanged.emit({
            menuSelection: t2
        });
        const a2 = this.selectedStartDate, i2 = this.selectedEndDate;
        this._setMenuRowOption(t2), t2 !== t$4.CUSTOM && this.marketDateRangeChanged.emit({
            prevStartDate: a2,
            prevEndDate: i2,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            menuSelection: t2
        });
    }
    setInvalidState({ detail: { invalid: e2 } }) {
        this.invalid = e2;
    }
    _setMenuRowOption(e2) {
        const t2 = /* @__PURE__ */ new Date(), a2 = this.getFirstDayOfWeek();
        switch(e2){
            case t$4.TODAY:
                this.clearDateSelections(), this.selectedStartDate = t2.toISOString();
                break;
            case t$4.YESTERDAY:
                this.clearDateSelections(), this.selectedStartDate = (function() {
                    var e3 = /* @__PURE__ */ new Date(), t3 = e3.getFullYear(), a3 = e3.getMonth(), i2 = e3.getDate(), s2 = /* @__PURE__ */ new Date(0);
                    return s2.setFullYear(t3, a3, i2 - 1), s2.setHours(0, 0, 0, 0), s2;
                })().toISOString();
                break;
            case t$4.THIS_WEEK:
                this.selectedStartDate = k$5(t2, {
                    weekStartsOn: a2
                }).toISOString(), "range" === this.selectionType && (this.selectedEndDate = w$7(t2, {
                    weekStartsOn: a2
                }).toISOString());
                break;
            case t$4.LAST_WEEK:
                {
                    const e3 = function(e4, t3) {
                        return n$q(2, arguments), function(e5, t4) {
                            return n$q(2, arguments), function(e6, t5) {
                                n$q(2, arguments);
                                var a3 = o$d(e6), i2 = t$3(t5);
                                return isNaN(i2) ? /* @__PURE__ */ new Date(NaN) : i2 ? (a3.setDate(a3.getDate() + i2), a3) : a3;
                            }(e5, 7 * t$3(t4));
                        }(e4, -t$3(t3));
                    }(t2, 1);
                    this.selectedStartDate = k$5(e3, {
                        weekStartsOn: a2
                    }).toISOString(), "range" === this.selectionType && (this.selectedEndDate = w$7(e3, {
                        weekStartsOn: a2
                    }).toISOString());
                    break;
                }
            case t$4.THIS_MONTH:
                this.selectedStartDate = p$8(t2).toISOString(), "range" === this.selectionType && (this.selectedEndDate = D$7(t2).toISOString());
                break;
            case t$4.LAST_MONTH:
                {
                    const e3 = function(e4, t3) {
                        return n$q(2, arguments), y$9(e4, -t$3(t3));
                    }(t2, 1);
                    this.selectedStartDate = p$8(e3).toISOString(), "range" === this.selectionType && (this.selectedEndDate = D$7(e3).toISOString());
                    break;
                }
            case t$4.THIS_YEAR:
                this.selectedStartDate = g$9(t2).toISOString(), "range" === this.selectionType && (this.selectedEndDate = x$8(t2).toISOString());
                break;
            case t$4.LAST_YEAR:
                {
                    const e3 = function(e4, t3) {
                        return n$q(2, arguments), function(e5, t4) {
                            return n$q(2, arguments), y$9(e5, 12 * t$3(t4));
                        }(e4, -t$3(t3));
                    }(t2, 1);
                    this.selectedStartDate = g$9(e3).toISOString(), "range" === this.selectionType && (this.selectedEndDate = x$8(e3).toISOString());
                    break;
                }
            case t$4.PAY_PERIOD:
                {
                    const e3 = new Date(this.payPeriodStartDate), t3 = new Date(this.payPeriodEndDate);
                    this.selectedStartDate = a$j(e3).toISOString(), this.selectedEndDate = (function(e4) {
                        n$q(1, arguments);
                        var t4 = o$d(e4);
                        return t4.setHours(23, 59, 59, 999), t4;
                    })(t3).toISOString();
                    break;
                }
        }
        e2 !== t$4.CUSTOM && (this.displayedDate = this.selectedStartDate);
    }
    _selectDate(e2) {
        var t2;
        const a2 = this.selectedStartDate, i2 = this.selectedEndDate, s2 = new Date(this.displayedDate), n2 = null !== (t2 = e2.month) && void 0 !== t2 ? t2 : s2.getMonth(), o2 = new Date(e2.year || s2.getFullYear(), n2, e2.day || s2.getDate(), e2.hour || s2.getHours(), e2.minute || s2.getMinutes()).toISOString();
        this.displayMenu && !t$2(new Date(this.selectedStartDate), new Date(o2)) && this.el.shadowRoot.querySelector(l$s("market-date-picker-menu"))._selectCustomRow(), "single" === this.selectionType ? (this.clearDateSelections(), this.selectedStartDate = o2) : this.selectedStartDate && !this.selectedEndDate && o2 >= this.selectedStartDate ? this.selectedEndDate = o2 : e2.input ? ("start" === e2.input && (this.selectedStartDate = o2), "end" === e2.input && (this.selectedEndDate = o2)) : (this.clearDateSelections(), this.selectedStartDate = o2), this.marketDateRangeChanged.emit({
            prevStartDate: a2,
            prevEndDate: i2,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            menuSelection: t$4.CUSTOM
        });
    }
    toggleCaret() {
        this.yearViewActive = !this.yearViewActive;
    }
    validateDisplayedDate(e2) {
        "" + new Date(e2) == "Invalid Date" && (this.displayedDate = /* @__PURE__ */ new Date().toISOString());
    }
    buildInitialYearView() {
        this.validateDisplayedDate(this.displayedDate);
        const e2 = new Date(this.displayedDate).getFullYear();
        this.yearViewYearsList = [
            "" + (e2 - 1),
            "" + e2,
            "" + (e2 + 1)
        ];
        for(let e3 = 0; e3 < 12; e3++){
            const t2 = new Date(2024, e3).toLocaleDateString(this.locale, {
                month: "short"
            });
            this.yearViewMonthList.push(t2);
        }
    }
    updateDisplayedYearList(e2) {
        this.yearViewYearsList = this.yearViewYearsList.map((t2)=>"" + (Number(t2) + e2));
    }
    updateDisplayedHeader(e2, t2) {
        var a2;
        let i2;
        if ("year" === e2 && (i2 = {
            year: t2
        }), "month" === e2) {
            const e3 = this.yearViewMonthList.indexOf(t2);
            i2 = {
                month: e3 >= 0 ? e3 : 0
            }, this.toggleCaret();
        }
        const s2 = new Date(this.displayedDate), n2 = null !== (a2 = null == i2 ? void 0 : i2.month) && void 0 !== a2 ? a2 : s2.getMonth(), r2 = new Date(i2.year || s2.getFullYear(), n2, 1).toISOString();
        this.displayedDate = r2;
    }
    getExcludedMenuItems() {
        return "range" === this.selectionType && this.payPeriodStartDate && this.payPeriodEndDate ? this.excludeMenuItems : [
            .../* @__PURE__ */ new Set([
                ...this.excludeMenuItems.split(","),
                t$4.PAY_PERIOD
            ])
        ].join(",");
    }
    componentWillLoad() {
        this.presetMenuOption && this._setMenuRowOption(this.presetMenuOption), this.buildInitialYearView(), this.datePickerLabel = "date-picker-label-" + f$d();
    }
    componentWillRender() {
        this.validateDisplayedDate(this.displayedDate), this.displayedMonth = new Date(this.displayedDate).toLocaleString(this.locale, {
            month: "short",
            year: "numeric"
        }), this.buildWeekdays(), this.buildCalendar();
    }
    render() {
        const e2 = l$s("market-date-picker-menu"), t2 = l$s("market-date-picker-date"), a2 = l$s("market-date-picker-input-date"), n2 = l$s("market-button"), o2 = l$s("market-icon"), l2 = l$s("market-divider");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "1027529c62a87bbc55789cfc3b5758b62baeb305",
            class: "market-date-picker"
        }, this.displayMenu && (0, $696Z8.h)("list-view", {
            key: "39ab2d1aadc933f02222ce864bb85fd7d55e9e5a"
        }, (0, $696Z8.h)(e2, {
            key: "41e4104faf84926f4116ec2d1e06d6f7f0f855b8",
            timeframe: this.timeframe,
            excludeMenuItems: this.getExcludedMenuItems(),
            presetMenuOption: this.presetMenuOption
        }, (0, $696Z8.h)("slot", {
            key: "76fe9935cfc22925b534a95f060512325fc721dc",
            name: t$4.TODAY,
            slot: t$4.TODAY
        }, "Today"), (0, $696Z8.h)("slot", {
            key: "7304494c43fc9a2fcb187534313c70352b3c437a",
            name: t$4.YESTERDAY,
            slot: t$4.YESTERDAY
        }, "Yesterday"), (0, $696Z8.h)("slot", {
            key: "b8382c2c56883bafa8cbd8a054f1e24a4f85fa1c",
            name: t$4.THIS_WEEK,
            slot: t$4.THIS_WEEK
        }, "This week"), (0, $696Z8.h)("slot", {
            key: "bd57d9f07389a1f4c2bf9c50284617c2fffeaa9e",
            name: t$4.LAST_WEEK,
            slot: t$4.LAST_WEEK
        }, "Last week"), (0, $696Z8.h)("slot", {
            key: "1640fe3db63e211d30af6720af27a464c480606a",
            name: t$4.THIS_MONTH,
            slot: t$4.THIS_MONTH
        }, "This month"), (0, $696Z8.h)("slot", {
            key: "e5cbd4d11a2e6afa4b29c266b6098fde93dc6267",
            name: t$4.LAST_MONTH,
            slot: t$4.LAST_MONTH
        }, "Last month"), (0, $696Z8.h)("slot", {
            key: "704588a3a8bbd12bb1c955ef055151757fdf2221",
            name: t$4.THIS_YEAR,
            slot: t$4.THIS_YEAR
        }, "This year"), (0, $696Z8.h)("slot", {
            key: "1c5e569592123a69f937822e3783fd53843f8a4d",
            name: t$4.LAST_YEAR,
            slot: t$4.LAST_YEAR
        }, "Last year"), (0, $696Z8.h)("slot", {
            key: "831953e4de5b9cad2275d27758aadef5f94ef638",
            name: t$4.PAY_PERIOD,
            slot: t$4.PAY_PERIOD
        }, "Pay period"), (0, $696Z8.h)("slot", {
            key: "f3b131ce00b37faacdc619b6f552366f103c25ec",
            name: t$4.CUSTOM,
            slot: t$4.CUSTOM
        }, "Custom"))), (0, $696Z8.h)("calendar", {
            key: "ca6a885b3a6c2221bc922fadb0275e806e734ab3"
        }, (0, $696Z8.h)("header", {
            key: "e3c3fdadf81e55cc5f955c13c945cf8c007c9786"
        }, (0, $696Z8.h)("nav", {
            key: "fd0b7f4964233ae123eedadedb28adb844e05da3"
        }, !this.yearViewActive && (0, $696Z8.h)(n2, {
            key: "6adf04096523183196378d2038667a72cd661ae3",
            class: "left-nav",
            size: "small",
            "aria-label": "Previous month",
            onClick: ()=>this.navigateMonth(-1)
        }, (0, $696Z8.h)(o2, {
            key: "e8b4f4748f1fb8e6d2322cfea1e33dda49fa0062",
            slot: "icon",
            name: "arrow-left"
        })), !this.disableViewToggle && (0, $696Z8.h)(n2, {
            key: "9c0cb7d44cff673dd1129af650f1d7517301e569",
            class: "year-view-button",
            "aria-label": "Toggle year view",
            onClick: ()=>this.toggleCaret(),
            caret: this.yearViewActive ? "up" : "down",
            rank: "tertiary"
        }, (0, $696Z8.h)("h2", {
            key: "4f4e1b2cd7a3a33c16abbc621c38c75a1808585d",
            id: this.datePickerLabel
        }, this.displayedMonth)), this.disableViewToggle && (0, $696Z8.h)("h2", {
            key: "a00a4f28d3ad1611c776ecbd3fb5004d2523fb34",
            id: this.datePickerLabel
        }, this.displayedMonth), !this.yearViewActive && (0, $696Z8.h)(n2, {
            key: "26f53548c55037ac67ac641256b1a139c762b95a",
            size: "small",
            "aria-label": "Next month",
            onClick: ()=>this.navigateMonth(1)
        }, (0, $696Z8.h)(o2, {
            key: "821695b13adc3e691da8c78400690a6565cbfc9d",
            slot: "icon",
            name: "arrow-right"
        })))), !this.yearViewActive && (0, $696Z8.h)("month-view", {
            key: "26d35147d8f0281a2fce71b20f9a07b9b80c430f",
            role: "grid",
            "aria-labelledby": this.datePickerLabel
        }, this.displayedWeekdays.map((e3)=>(0, $696Z8.h)(t2, {
                class: "weekday-header",
                disabled: true,
                day: e3
            })), this.days.map((e3)=>(0, $696Z8.h)(t2, {
                disabled: e3.disabled,
                selection: e3.selection,
                today: e3.today,
                selected: e3.selected,
                day: e3.date || null,
                type: "day"
            }))), this.yearViewActive && (0, $696Z8.h)("year-view", {
            key: "6384d178e57b1ad7f618c81373f9ae74aae3f6df",
            "aria-labelledby": this.datePickerLabel
        }, (0, $696Z8.h)("year-section", {
            key: "6953aaaedd936ed43230b61a873d51e5f2a59726"
        }, (0, $696Z8.h)(n2, {
            key: "6b4e47399ef6930e5ad525cbc70910da4ea1b4a2",
            size: "small",
            rank: "tertiary",
            "aria-label": "Previous year",
            onClick: ()=>this.updateDisplayedYearList(-1)
        }, (0, $696Z8.h)(o2, {
            key: "8b2d6b1457415d93d9ee74038edcebf0b95eb655",
            slot: "icon",
            name: "chevron-left"
        })), this.yearViewYearsList.map((e3)=>(0, $696Z8.h)(t2, {
                day: e3,
                type: "year"
            })), (0, $696Z8.h)(n2, {
            key: "02b476acc251f208ecda7439757fa078ac6bef99",
            size: "small",
            rank: "tertiary",
            "aria-label": "Next year",
            onClick: ()=>this.updateDisplayedYearList(1)
        }, (0, $696Z8.h)(o2, {
            key: "bc7a8087599985ae0917fb1ad763610080e7aa9b",
            slot: "icon",
            name: "chevron-right"
        }))), (0, $696Z8.h)(l2, {
            key: "c4b9fa47aa79d2ec3c407a47105998daf0f35848",
            size: "thin"
        }), (0, $696Z8.h)("month-section", {
            key: "7271331803e013580b9659b7ce9d4bdd2538d547",
            role: "grid"
        }, this.yearViewMonthList.map((e3)=>(0, $696Z8.h)(t2, {
                day: e3,
                type: "month"
            })))), this.withInputs && (0, $696Z8.h)(a2, {
            key: "a319e0e865e127b998bb1de664aef4bcab9b2703",
            class: "date-input-top-margin",
            range: "range" === this.selectionType,
            isDateDisabled: this.isDateDisabled,
            selectedStartDate: this.selectedStartDate,
            selectedEndDate: this.selectedEndDate,
            withTime: "date-and-time" === this.withInputs,
            timeframe: this.timeframe
        }, (0, $696Z8.h)("slot", {
            key: "eed9a32a4b03c8e99d2fcca894291a5e1ff6a740",
            name: "start-date",
            slot: "start-date"
        }, "range" === this.selectionType ? "Start " : "", "Date"), (0, $696Z8.h)("slot", {
            key: "774dbaee64958d24d1063b14982264d087955203",
            name: "end-date",
            slot: "end-date"
        }, "End Date"), (0, $696Z8.h)("slot", {
            key: "ba567d9acf115d8baed44e9e6bc6669511812157",
            name: "start-time",
            slot: "start-time"
        }, "range" === this.selectionType ? "Start " : "", "Time"), (0, $696Z8.h)("slot", {
            key: "083ba9a9a6baddfd8786b2a1c9c4f33756c20878",
            name: "end-time",
            slot: "end-time"
        }, "End Time"), (0, $696Z8.h)("slot", {
            key: "015560006496f57c70c910d63d494f761042767d",
            name: "range-error",
            slot: "range-error"
        }, "Enter a valid date range"))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host{display:flex}@media only screen and (width <= 800px){:host([mobile-menu-position="top"]){flex-direction:column}:host([mobile-menu-position="top"]) list-view{margin-bottom:var(--date-picker-menu-vertical-spacing)}:host([mobile-menu-position="bottom"]){flex-direction:column-reverse}:host([mobile-menu-position="bottom"]) list-view{margin-top:var(--date-picker-menu-vertical-spacing)}}header{height:var(--date-picker-header-minimum-height);margin-bottom:var(--date-picker-header-vertical-spacing)}nav{display:flex;justify-content:space-between;align-items:center}:host([year-view-active]) nav{justify-content:center}[id^="date-picker-label-"]{margin:0}.year-view-button{color:var(--date-picker-month-year-label-color, var(--core-text-10-color))}.year-view-button:hover,.year-view-button:active{background-color:transparent;color:var(--core-emphasis-text-color)}.year-view-button::part(button-text){border-bottom:none;line-height:unset;text-decoration-line:none}.year-view-button:hover::part(button-text),.year-view-button:active::part(button-text){text-decoration-line:underline}.caret{margin-left:var(--date-picker-header-button-padding)}:host([year-view-active]) .caret{transform:rotate(-180deg)}calendar{min-width:var(--date-picker-minimum-width)}month-view{display:grid;grid-template-columns:repeat(7, 1fr);grid-auto-rows:1fr;gap:var(--date-picker-grid-item-vertical-padding) var(--date-picker-grid-item-horizontal-padding);box-sizing:border-box}year-section{display:flex;gap:var(--date-picker-grid-item-year-button-vertical-padding, 0)     var(--date-picker-grid-item-year-button-horizontal-padding, 12.5px);box-sizing:border-box}year-section .market-icon{width:var(--date-picker-grid-item-year-button-icon-size, var(--accessory-icon-variant-medium-size-height))}month-section{display:grid;grid-template-rows:repeat(3, 1fr);grid-template-columns:repeat(4, 1fr);gap:var(--date-picker-grid-item-month-button-vertical-padding, 16px)     var(--date-picker-grid-item-month-button-horizontal-padding, 26.67px);box-sizing:border-box}';
    }
}, [
    257,
    "market-date-picker",
    {
        selectionType: [
            1,
            "selection-type"
        ],
        selectedStartDate: [
            1537,
            "selected-start-date"
        ],
        selectedEndDate: [
            1537,
            "selected-end-date"
        ],
        payPeriodStartDate: [
            1,
            "pay-period-start-date"
        ],
        payPeriodEndDate: [
            1,
            "pay-period-end-date"
        ],
        presetMenuOption: [
            1,
            "preset-menu-option"
        ],
        displayMenu: [
            4,
            "display-menu"
        ],
        mobileMenuPosition: [
            513,
            "mobile-menu-position"
        ],
        excludeMenuItems: [
            1,
            "exclude-menu-items"
        ],
        timeframe: [
            1
        ],
        weekStartsOn: [
            1,
            "week-starts-on"
        ],
        isDateDisabled: [
            16
        ],
        locale: [
            1
        ],
        displayedDate: [
            1025,
            "displayed-date"
        ],
        withInputs: [
            513,
            "with-inputs"
        ],
        invalid: [
            1540
        ],
        disableViewToggle: [
            516,
            "disable-view-toggle"
        ],
        yearViewActive: [
            1540,
            "year-view-active"
        ],
        displayedMonth: [
            32
        ],
        displayedWeekdays: [
            32
        ],
        yearViewYearsList: [
            32
        ],
        hoveredDate: [
            32
        ],
        resetMenu: [
            64
        ]
    },
    [
        [
            0,
            "marketDatePickerInputDateSet",
            "dateInputDateSet"
        ],
        [
            0,
            "marketDatePickerDateSelected",
            "selectDate"
        ],
        [
            0,
            "marketDatePickerDateMousedOver",
            "hoverDate"
        ],
        [
            0,
            "marketDatePickerDateMousedOut",
            "mousedOutDate"
        ],
        [
            0,
            "marketDatePickerMenuSelectionChanged",
            "selectMenuRow"
        ],
        [
            0,
            "marketDatePickerInputDateInvalidStateChanged",
            "setInvalidState"
        ]
    ]
]), O$6 = M$6;
const d$e = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketDatePickerDateSelected = (0, $696Z8.createEvent)(this, "marketDatePickerDateSelected", 7), this.marketDatePickerDateMousedOver = (0, $696Z8.createEvent)(this, "marketDatePickerDateMousedOver", 7), this.marketDatePickerDateMousedOut = (0, $696Z8.createEvent)(this, "marketDatePickerDateMousedOut", 7), this.disabled = false, this.selection = "none", this.today = false, this.selected = false;
    }
    handleInteraction(e2) {
        var t2;
        if (this.disabled || 0 === (null === (t2 = this.day) || void 0 === t2 ? void 0 : t2.length)) return void e2.stopImmediatePropagation();
        const r2 = e2 instanceof KeyboardEvent && "keydown" === e2.type && "Enter" === e2.key;
        ("click" === e2.type || r2) && this.marketDatePickerDateSelected.emit({
            date: this.el
        }), "mouseover" === e2.type && this.marketDatePickerDateMousedOver.emit({
            date: this.el
        }), "mouseout" === e2.type && this.marketDatePickerDateMousedOut.emit();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "cb93515184e0a9425ffb81429b16cb2267e011c6",
            class: "market-date-picker-date",
            role: this.disabled || !this.day ? void 0 : "button",
            tabindex: this.disabled || !this.day ? -1 : 0,
            "aria-disabled": this.disabled,
            "aria-pressed": this.selected ? "true" : "false",
            onClick: (e2)=>{
                this.handleInteraction(e2);
            },
            onmouseover: (e2)=>{
                this.handleInteraction(e2);
            },
            onmouseout: (e2)=>{
                this.handleInteraction(e2);
            },
            onkeydown: (e2)=>{
                this.handleInteraction(e2);
            }
        }, (0, $696Z8.h)("div", {
            key: "d138551895ed2cb9c68ef6e3a5ad8da4ed006af9",
            class: "market-date-picker-date-inner-container"
        }, this.day));
    }
    get el() {
        return this;
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host(:not([day])){border-width:0 !important;border-radius:0 !important;background-color:rgb(0 0 0 / 0%) !important;color:rgb(0 0 0 / 0%) !important;pointer-events:none !important;}:host{--date-picker-date-range-first-selection-border-radius:var(--date-picker-date-border-radius)     0     0     var(--date-picker-date-border-radius);--date-picker-date-range-last-selection-border-radius:0     var(--date-picker-date-border-radius)     var(--date-picker-date-border-radius)     0;position:relative;display:inline-flex;flex-direction:row;justify-content:center;align-items:center;width:100%;padding:0;font-size:var(--date-picker-weekdays-font-size);line-height:var(--date-picker-weekdays-font-leading);text-align:center}:host([disabled]){color:var(--date-picker-date-text-unselected-selection-disabled-state-color);cursor:not-allowed}:host(.weekday-header){color:var(--date-picker-weekdays-color-color);cursor:auto}:host(:not([selection='range-middle'])){border-radius:var(--date-picker-date-border-radius)}:host([selection='none']:not([disabled])){color:var(--date-picker-date-text-unselected-selection-normal-state-color)}:host([selection='range-first']){border-radius:var(--date-picker-date-range-first-selection-border-radius);background:linear-gradient(         to right,         transparent 50%,         var(--date-picker-date-background-range-middle-selection-normal-state-color) 50%       )}:host([selection='range-middle']){background-color:var(--date-picker-date-background-range-middle-selection-normal-state-color)}:host([selection='range-last']){border-radius:var(--date-picker-date-range-last-selection-border-radius);background:linear-gradient(         to right,         var(--date-picker-date-background-range-middle-selection-normal-state-color) 50%,         transparent 50%       )}:host(:hover[selection='range-first']:not([selected]):not([today])),:host(:active[selection='range-first']:not([selected]):not([today])){border-radius:var(--date-picker-date-range-first-selection-border-radius)}:host([selection='range-middle'][disabled][today]){border-color:var(--date-picker-date-border-disabled-state-color-color)}:host(:hover[selection='range-last']:not([selected]):not([today])),:host(:active[selection='range-last']:not([selected]):not([today])){border-radius:var(--date-picker-date-range-last-selection-border-radius)}:host([today]){box-sizing:border-box;font-weight:var(--date-picker-today-font-weight)}:host([today]:not([disabled])){border-color:var(--date-picker-today-border-color-color)}:host([today][disabled]){color:var(--date-picker-today-label-disabled-state-color-color)}:host(:hover:not([disabled])){cursor:pointer}:host(:hover:not([disabled]):not([selected])){background:initial;background-color:var(--date-picker-date-background-unselected-selection-hover-state-color);color:var(--date-picker-date-text-unselected-selection-hover-state-color)}:host(:active:not([disabled]):not([selected])){background:initial;background-color:var(--date-picker-date-background-unselected-selection-pressed-state-color);color:var(--date-picker-date-text-unselected-selection-pressed-state-color)}:host(:focus-visible){outline:none}:host(:focus-visible) .market-date-picker-date-inner-container{z-index:2;outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color)}.market-date-picker-date-inner-container{display:flex;justify-content:center;align-items:center;width:100%;min-width:var(--date-picker-grid-item-width);height:var(--date-picker-grid-item-height);border-radius:var(--date-picker-date-border-radius)}:host([today]) .market-date-picker-date-inner-container{box-sizing:border-box;border-width:var(--date-picker-today-border-width);border-style:solid}:host([selection="single"][selected]) .market-date-picker-date-inner-container,:host([selection="range-first"][selected]) .market-date-picker-date-inner-container,:host([selection="range-last"][selected]) .market-date-picker-date-inner-container{background-color:var(--date-picker-date-background-single-selection-normal-state-color);color:var(--date-picker-date-text-single-selection-disabled-state-color)}:host([selection="single"][disabled][selected]) .market-date-picker-date-inner-container,:host([selection="range-first"][disabled][selected]) .market-date-picker-date-inner-container,:host([selection="range-last"][disabled][selected]) .market-date-picker-date-inner-container{background-color:var(--date-picker-date-background-single-selection-disabled-state-color);color:var(--date-picker-date-text-single-selection-disabled-state-color)}`;
    }
}, [
    1,
    "market-date-picker-date",
    {
        disabled: [
            516
        ],
        selection: [
            513
        ],
        today: [
            516
        ],
        selected: [
            516
        ],
        day: [
            513
        ],
        type: [
            513
        ]
    }
]), s$l = d$e;
function r$a(n2) {
    var e2 = new Date(Date.UTC(n2.getFullYear(), n2.getMonth(), n2.getDate(), n2.getHours(), n2.getMinutes(), n2.getSeconds(), n2.getMilliseconds()));
    return e2.setUTCFullYear(n2.getFullYear()), n2.getTime() - e2.getTime();
}
var i$g = 6e4, o$c = 36e5, u$a = 1e3;
function d$d(a2, r2) {
    return n$q(2, arguments), function(a3, r3) {
        n$q(2, arguments);
        var i2 = o$d(a3).getTime(), o2 = t$3(r3);
        return new Date(i2 + o2);
    }(a2, -t$3(r2));
}
function s$k(t2) {
    n$q(1, arguments);
    var a2 = o$d(t2), r2 = a2.getUTCDay(), i2 = (r2 < 1 ? 7 : 0) + r2 - 1;
    return a2.setUTCDate(a2.getUTCDate() - i2), a2.setUTCHours(0, 0, 0, 0), a2;
}
function h$c(t2) {
    n$q(1, arguments);
    var a2 = o$d(t2), r2 = a2.getUTCFullYear(), i2 = /* @__PURE__ */ new Date(0);
    i2.setUTCFullYear(r2 + 1, 0, 4), i2.setUTCHours(0, 0, 0, 0);
    var o2 = s$k(i2), u2 = /* @__PURE__ */ new Date(0);
    u2.setUTCFullYear(r2, 0, 4), u2.setUTCHours(0, 0, 0, 0);
    var d2 = s$k(u2);
    return a2.getTime() >= o2.getTime() ? r2 + 1 : a2.getTime() >= d2.getTime() ? r2 : r2 - 1;
}
function l$i(t2) {
    n$q(1, arguments);
    var a2 = o$d(t2), r2 = s$k(a2).getTime() - (function(e2) {
        n$q(1, arguments);
        var t3 = h$c(e2), a3 = /* @__PURE__ */ new Date(0);
        return a3.setUTCFullYear(t3, 0, 4), a3.setUTCHours(0, 0, 0, 0), s$k(a3);
    })(a2).getTime();
    return Math.round(r2 / 6048e5) + 1;
}
function m$6(r2, i2) {
    var o2, u2, d2, s2, h2, l2, m2, f2;
    n$q(1, arguments);
    var c2 = a$k(), v2 = t$3(null !== (o2 = null !== (u2 = null !== (d2 = null !== (s2 = null == i2 ? void 0 : i2.weekStartsOn) && void 0 !== s2 ? s2 : null == i2 || null === (h2 = i2.locale) || void 0 === h2 || null === (l2 = h2.options) || void 0 === l2 ? void 0 : l2.weekStartsOn) && void 0 !== d2 ? d2 : c2.weekStartsOn) && void 0 !== u2 ? u2 : null === (m2 = c2.locale) || void 0 === m2 || null === (f2 = m2.options) || void 0 === f2 ? void 0 : f2.weekStartsOn) && void 0 !== o2 ? o2 : 0);
    if (!(v2 >= 0 && v2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var g2 = o$d(r2), w2 = g2.getUTCDay(), y2 = (w2 < v2 ? 7 : 0) + w2 - v2;
    return g2.setUTCDate(g2.getUTCDate() - y2), g2.setUTCHours(0, 0, 0, 0), g2;
}
function f$9(r2, i2) {
    var o2, u2, d2, s2, h2, l2, f2, c2;
    n$q(1, arguments);
    var v2 = o$d(r2), g2 = v2.getUTCFullYear(), w2 = a$k(), y2 = t$3(null !== (o2 = null !== (u2 = null !== (d2 = null !== (s2 = null == i2 ? void 0 : i2.firstWeekContainsDate) && void 0 !== s2 ? s2 : null == i2 || null === (h2 = i2.locale) || void 0 === h2 || null === (l2 = h2.options) || void 0 === l2 ? void 0 : l2.firstWeekContainsDate) && void 0 !== d2 ? d2 : w2.firstWeekContainsDate) && void 0 !== u2 ? u2 : null === (f2 = w2.locale) || void 0 === f2 || null === (c2 = f2.options) || void 0 === c2 ? void 0 : c2.firstWeekContainsDate) && void 0 !== o2 ? o2 : 1);
    if (!(y2 >= 1 && y2 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var b2 = /* @__PURE__ */ new Date(0);
    b2.setUTCFullYear(g2 + 1, 0, y2), b2.setUTCHours(0, 0, 0, 0);
    var p2 = m$6(b2, i2), M2 = /* @__PURE__ */ new Date(0);
    M2.setUTCFullYear(g2, 0, y2), M2.setUTCHours(0, 0, 0, 0);
    var P2 = m$6(M2, i2);
    return v2.getTime() >= p2.getTime() ? g2 + 1 : v2.getTime() >= P2.getTime() ? g2 : g2 - 1;
}
function c$l(r2, i2) {
    n$q(1, arguments);
    var o2 = o$d(r2), u2 = m$6(o2, i2).getTime() - (function(e2, r3) {
        var i3, o3, u3, d2, s2, h2, l2, c2;
        n$q(1, arguments);
        var v2 = a$k(), g2 = t$3(null !== (i3 = null !== (o3 = null !== (u3 = null !== (d2 = null == r3 ? void 0 : r3.firstWeekContainsDate) && void 0 !== d2 ? d2 : null == r3 || null === (s2 = r3.locale) || void 0 === s2 || null === (h2 = s2.options) || void 0 === h2 ? void 0 : h2.firstWeekContainsDate) && void 0 !== u3 ? u3 : v2.firstWeekContainsDate) && void 0 !== o3 ? o3 : null === (l2 = v2.locale) || void 0 === l2 || null === (c2 = l2.options) || void 0 === c2 ? void 0 : c2.firstWeekContainsDate) && void 0 !== i3 ? i3 : 1), w2 = f$9(e2, r3), y2 = /* @__PURE__ */ new Date(0);
        return y2.setUTCFullYear(w2, 0, g2), y2.setUTCHours(0, 0, 0, 0), m$6(y2, r3);
    })(o2, i2).getTime();
    return Math.round(u2 / 6048e5) + 1;
}
var v$5 = function(n2, e2) {
    switch(n2){
        case "P":
            return e2.date({
                width: "short"
            });
        case "PP":
            return e2.date({
                width: "medium"
            });
        case "PPP":
            return e2.date({
                width: "long"
            });
        default:
            return e2.date({
                width: "full"
            });
    }
}, g$8 = function(n2, e2) {
    switch(n2){
        case "p":
            return e2.time({
                width: "short"
            });
        case "pp":
            return e2.time({
                width: "medium"
            });
        case "ppp":
            return e2.time({
                width: "long"
            });
        default:
            return e2.time({
                width: "full"
            });
    }
}, w$6 = {
    p: g$8,
    P: function(n2, e2) {
        var t2, a2 = n2.match(/(P+)(p+)?/) || [], r2 = a2[1], i2 = a2[2];
        if (!i2) return v$5(n2, e2);
        switch(r2){
            case "P":
                t2 = e2.dateTime({
                    width: "short"
                });
                break;
            case "PP":
                t2 = e2.dateTime({
                    width: "medium"
                });
                break;
            case "PPP":
                t2 = e2.dateTime({
                    width: "long"
                });
                break;
            default:
                t2 = e2.dateTime({
                    width: "full"
                });
        }
        return t2.replace("{{date}}", v$5(r2, e2)).replace("{{time}}", g$8(i2, e2));
    }
}, y$8 = [
    "D",
    "DD"
], b$8 = [
    "YY",
    "YYYY"
];
function p$7(n2) {
    return -1 !== y$8.indexOf(n2);
}
function M$5(n2) {
    return -1 !== b$8.indexOf(n2);
}
function P$6(n2, e2, t2) {
    if ("YYYY" === n2) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e2, "`) for formatting years to the input `").concat(t2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if ("YY" === n2) throw new RangeError("Use `yy` instead of `YY` (in `".concat(e2, "`) for formatting years to the input `").concat(t2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if ("D" === n2) throw new RangeError("Use `d` instead of `D` (in `".concat(e2, "`) for formatting days of the month to the input `").concat(t2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if ("DD" === n2) throw new RangeError("Use `dd` instead of `DD` (in `".concat(e2, "`) for formatting days of the month to the input `").concat(t2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var W$6 = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function D$6(n2) {
    return function() {
        var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t2 = e2.width ? String(e2.width) : n2.defaultWidth;
        return n2.formats[t2] || n2.formats[n2.defaultWidth];
    };
}
var k$4 = {
    date: D$6({
        formats: {
            full: "EEEE, MMMM do, y",
            long: "MMMM do, y",
            medium: "MMM d, y",
            short: "MM/dd/yyyy"
        },
        defaultWidth: "full"
    }),
    time: D$6({
        formats: {
            full: "h:mm:ss a zzzz",
            long: "h:mm:ss a z",
            medium: "h:mm:ss a",
            short: "h:mm a"
        },
        defaultWidth: "full"
    }),
    dateTime: D$6({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: "{{date}}, {{time}}",
            short: "{{date}}, {{time}}"
        },
        defaultWidth: "full"
    })
}, Y$3 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function S$7(n2) {
    return function(e2, t2) {
        var a2;
        if ("formatting" === (null != t2 && t2.context ? String(t2.context) : "standalone") && n2.formattingValues) {
            var r2 = n2.defaultFormattingWidth || n2.defaultWidth, i2 = null != t2 && t2.width ? String(t2.width) : r2;
            a2 = n2.formattingValues[i2] || n2.formattingValues[r2];
        } else {
            var o2 = n2.defaultWidth, u2 = null != t2 && t2.width ? String(t2.width) : n2.defaultWidth;
            a2 = n2.values[u2] || n2.values[o2];
        }
        return a2[n2.argumentCallback ? n2.argumentCallback(e2) : e2];
    };
}
function j$8(n2) {
    return function(e2) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a2 = t2.width, r2 = e2.match(a2 && n2.matchPatterns[a2] || n2.matchPatterns[n2.defaultMatchWidth]);
        if (!r2) return null;
        var i2, o2 = r2[0], u2 = a2 && n2.parsePatterns[a2] || n2.parsePatterns[n2.defaultParseWidth], d2 = Array.isArray(u2) ? function(n3) {
            for(var e3 = 0; e3 < n3.length; e3++)if (n3[e3].test(o2)) return e3;
        }(u2) : function(n3) {
            for(var e3 in n3)if (n3.hasOwnProperty(e3) && n3[e3].test(o2)) return e3;
        }(u2);
        return i2 = n2.valueCallback ? n2.valueCallback(d2) : d2, {
            value: i2 = t2.valueCallback ? t2.valueCallback(i2) : i2,
            rest: e2.slice(o2.length)
        };
    };
}
var T$5, A$5 = {
    code: "en-US",
    formatDistance: function(n2, e2, t2) {
        var a2, r2 = W$6[n2];
        return a2 = "string" == typeof r2 ? r2 : 1 === e2 ? r2.one : r2.other.replace("{{count}}", e2.toString()), null != t2 && t2.addSuffix ? t2.comparison && t2.comparison > 0 ? "in " + a2 : a2 + " ago" : a2;
    },
    formatLong: k$4,
    formatRelative: function(n2) {
        return Y$3[n2];
    },
    localize: {
        ordinalNumber: function(n2) {
            var e2 = Number(n2), t2 = e2 % 100;
            if (t2 > 20 || t2 < 10) switch(t2 % 10){
                case 1:
                    return e2 + "st";
                case 2:
                    return e2 + "nd";
                case 3:
                    return e2 + "rd";
            }
            return e2 + "th";
        },
        era: S$7({
            values: {
                narrow: [
                    "B",
                    "A"
                ],
                abbreviated: [
                    "BC",
                    "AD"
                ],
                wide: [
                    "Before Christ",
                    "Anno Domini"
                ]
            },
            defaultWidth: "wide"
        }),
        quarter: S$7({
            values: {
                narrow: [
                    "1",
                    "2",
                    "3",
                    "4"
                ],
                abbreviated: [
                    "Q1",
                    "Q2",
                    "Q3",
                    "Q4"
                ],
                wide: [
                    "1st quarter",
                    "2nd quarter",
                    "3rd quarter",
                    "4th quarter"
                ]
            },
            defaultWidth: "wide",
            argumentCallback: function(n2) {
                return n2 - 1;
            }
        }),
        month: S$7({
            values: {
                narrow: [
                    "J",
                    "F",
                    "M",
                    "A",
                    "M",
                    "J",
                    "J",
                    "A",
                    "S",
                    "O",
                    "N",
                    "D"
                ],
                abbreviated: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                wide: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ]
            },
            defaultWidth: "wide"
        }),
        day: S$7({
            values: {
                narrow: [
                    "S",
                    "M",
                    "T",
                    "W",
                    "T",
                    "F",
                    "S"
                ],
                short: [
                    "Su",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa"
                ],
                abbreviated: [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat"
                ],
                wide: [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ]
            },
            defaultWidth: "wide"
        }),
        dayPeriod: S$7({
            values: {
                narrow: {
                    am: "a",
                    pm: "p",
                    midnight: "mi",
                    noon: "n",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                },
                abbreviated: {
                    am: "AM",
                    pm: "PM",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                },
                wide: {
                    am: "a.m.",
                    pm: "p.m.",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                }
            },
            defaultWidth: "wide",
            formattingValues: {
                narrow: {
                    am: "a",
                    pm: "p",
                    midnight: "mi",
                    noon: "n",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                },
                abbreviated: {
                    am: "AM",
                    pm: "PM",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                },
                wide: {
                    am: "a.m.",
                    pm: "p.m.",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                }
            },
            defaultFormattingWidth: "wide"
        })
    },
    match: {
        ordinalNumber: (T$5 = {
            matchPattern: /^(\d+)(th|st|nd|rd)?/i,
            parsePattern: /\d+/i,
            valueCallback: function(n2) {
                return parseInt(n2, 10);
            }
        }, function(n2) {
            var e2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, t2 = n2.match(T$5.matchPattern);
            if (!t2) return null;
            var a2 = t2[0], r2 = n2.match(T$5.parsePattern);
            if (!r2) return null;
            var i2 = T$5.valueCallback ? T$5.valueCallback(r2[0]) : r2[0];
            return {
                value: i2 = e2.valueCallback ? e2.valueCallback(i2) : i2,
                rest: n2.slice(a2.length)
            };
        }),
        era: j$8({
            matchPatterns: {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                any: [
                    /^b/i,
                    /^(a|c)/i
                ]
            },
            defaultParseWidth: "any"
        }),
        quarter: j$8({
            matchPatterns: {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                any: [
                    /1/i,
                    /2/i,
                    /3/i,
                    /4/i
                ]
            },
            defaultParseWidth: "any",
            valueCallback: function(n2) {
                return n2 + 1;
            }
        }),
        month: j$8({
            matchPatterns: {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                narrow: [
                    /^j/i,
                    /^f/i,
                    /^m/i,
                    /^a/i,
                    /^m/i,
                    /^j/i,
                    /^j/i,
                    /^a/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ],
                any: [
                    /^ja/i,
                    /^f/i,
                    /^mar/i,
                    /^ap/i,
                    /^may/i,
                    /^jun/i,
                    /^jul/i,
                    /^au/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ]
            },
            defaultParseWidth: "any"
        }),
        day: j$8({
            matchPatterns: {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                narrow: [
                    /^s/i,
                    /^m/i,
                    /^t/i,
                    /^w/i,
                    /^t/i,
                    /^f/i,
                    /^s/i
                ],
                any: [
                    /^su/i,
                    /^m/i,
                    /^tu/i,
                    /^w/i,
                    /^th/i,
                    /^f/i,
                    /^sa/i
                ]
            },
            defaultParseWidth: "any"
        }),
        dayPeriod: j$8({
            matchPatterns: {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            },
            defaultMatchWidth: "any",
            parsePatterns: {
                any: {
                    am: /^a/i,
                    pm: /^p/i,
                    midnight: /^mi/i,
                    noon: /^no/i,
                    morning: /morning/i,
                    afternoon: /afternoon/i,
                    evening: /evening/i,
                    night: /night/i
                }
            },
            defaultParseWidth: "any"
        })
    },
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function S$6(t2) {
    if (n$q(1, arguments), !function(t3) {
        return n$q(1, arguments), t3 instanceof Date || "object" === e$8(t3) && "[object Date]" === Object.prototype.toString.call(t3);
    }(t2) && "number" != typeof t2) return false;
    var e2 = o$d(t2);
    return !isNaN(Number(e2));
}
function q$3(t2, e2) {
    for(var n2 = t2 < 0 ? "-" : "", r2 = "" + Math.abs(t2); r2.length < e2;)r2 = "0" + r2;
    return n2 + r2;
}
var G$3 = {
    G: function(t2, e2, n2) {
        var r2 = t2.getUTCFullYear() > 0 ? 1 : 0;
        switch(e2){
            case "G":
            case "GG":
            case "GGG":
                return n2.era(r2, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return n2.era(r2, {
                    width: "narrow"
                });
            default:
                return n2.era(r2, {
                    width: "wide"
                });
        }
    },
    y: function(t2, e2, n2) {
        if ("yo" === e2) {
            var r2 = t2.getUTCFullYear();
            return n2.ordinalNumber(r2 > 0 ? r2 : 1 - r2, {
                unit: "year"
            });
        }
        return function(t3, e3) {
            var n3 = t3.getUTCFullYear(), r3 = n3 > 0 ? n3 : 1 - n3;
            return q$3("yy" === e3 ? r3 % 100 : r3, e3.length);
        }(t2, e2);
    },
    Y: function(t2, e2, n2, r2) {
        var a2 = f$9(t2, r2), i2 = a2 > 0 ? a2 : 1 - a2;
        return "YY" === e2 ? q$3(i2 % 100, 2) : "Yo" === e2 ? n2.ordinalNumber(i2, {
            unit: "year"
        }) : q$3(i2, e2.length);
    },
    R: function(t2, e2) {
        return q$3(h$c(t2), e2.length);
    },
    u: function(t2, e2) {
        return q$3(t2.getUTCFullYear(), e2.length);
    },
    Q: function(t2, e2, n2) {
        var r2 = Math.ceil((t2.getUTCMonth() + 1) / 3);
        switch(e2){
            case "Q":
                return r2 + "";
            case "QQ":
                return q$3(r2, 2);
            case "Qo":
                return n2.ordinalNumber(r2, {
                    unit: "quarter"
                });
            case "QQQ":
                return n2.quarter(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return n2.quarter(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n2.quarter(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    q: function(t2, e2, n2) {
        var r2 = Math.ceil((t2.getUTCMonth() + 1) / 3);
        switch(e2){
            case "q":
                return r2 + "";
            case "qq":
                return q$3(r2, 2);
            case "qo":
                return n2.ordinalNumber(r2, {
                    unit: "quarter"
                });
            case "qqq":
                return n2.quarter(r2, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return n2.quarter(r2, {
                    width: "narrow",
                    context: "standalone"
                });
            default:
                return n2.quarter(r2, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    M: function(t2, e2, n2) {
        var r2 = t2.getUTCMonth();
        switch(e2){
            case "M":
            case "MM":
                return function(t3, e3) {
                    var n3 = t3.getUTCMonth();
                    return "M" === e3 ? n3 + 1 + "" : q$3(n3 + 1, 2);
                }(t2, e2);
            case "Mo":
                return n2.ordinalNumber(r2 + 1, {
                    unit: "month"
                });
            case "MMM":
                return n2.month(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return n2.month(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n2.month(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    L: function(t2, e2, n2) {
        var r2 = t2.getUTCMonth();
        switch(e2){
            case "L":
                return r2 + 1 + "";
            case "LL":
                return q$3(r2 + 1, 2);
            case "Lo":
                return n2.ordinalNumber(r2 + 1, {
                    unit: "month"
                });
            case "LLL":
                return n2.month(r2, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return n2.month(r2, {
                    width: "narrow",
                    context: "standalone"
                });
            default:
                return n2.month(r2, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    w: function(t2, e2, n2, r2) {
        var a2 = c$l(t2, r2);
        return "wo" === e2 ? n2.ordinalNumber(a2, {
            unit: "week"
        }) : q$3(a2, e2.length);
    },
    I: function(t2, e2, n2) {
        var r2 = l$i(t2);
        return "Io" === e2 ? n2.ordinalNumber(r2, {
            unit: "week"
        }) : q$3(r2, e2.length);
    },
    d: function(t2, e2, n2) {
        return "do" === e2 ? n2.ordinalNumber(t2.getUTCDate(), {
            unit: "date"
        }) : function(t3, e3) {
            return q$3(t3.getUTCDate(), e3.length);
        }(t2, e2);
    },
    D: function(t2, e2, n2) {
        var r2 = function(t3) {
            n$q(1, arguments);
            var e3 = o$d(t3), n3 = e3.getTime();
            e3.setUTCMonth(0, 1), e3.setUTCHours(0, 0, 0, 0);
            var r3 = e3.getTime();
            return Math.floor((n3 - r3) / 864e5) + 1;
        }(t2);
        return "Do" === e2 ? n2.ordinalNumber(r2, {
            unit: "dayOfYear"
        }) : q$3(r2, e2.length);
    },
    E: function(t2, e2, n2) {
        var r2 = t2.getUTCDay();
        switch(e2){
            case "E":
            case "EE":
            case "EEE":
                return n2.day(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return n2.day(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return n2.day(r2, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return n2.day(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    e: function(t2, e2, n2, r2) {
        var a2 = t2.getUTCDay(), i2 = (a2 - r2.weekStartsOn + 8) % 7 || 7;
        switch(e2){
            case "e":
                return i2 + "";
            case "ee":
                return q$3(i2, 2);
            case "eo":
                return n2.ordinalNumber(i2, {
                    unit: "day"
                });
            case "eee":
                return n2.day(a2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return n2.day(a2, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return n2.day(a2, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return n2.day(a2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    c: function(t2, e2, n2, r2) {
        var a2 = t2.getUTCDay(), i2 = (a2 - r2.weekStartsOn + 8) % 7 || 7;
        switch(e2){
            case "c":
                return i2 + "";
            case "cc":
                return q$3(i2, e2.length);
            case "co":
                return n2.ordinalNumber(i2, {
                    unit: "day"
                });
            case "ccc":
                return n2.day(a2, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return n2.day(a2, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return n2.day(a2, {
                    width: "short",
                    context: "standalone"
                });
            default:
                return n2.day(a2, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    i: function(t2, e2, n2) {
        var r2 = t2.getUTCDay(), a2 = 0 === r2 ? 7 : r2;
        switch(e2){
            case "i":
                return a2 + "";
            case "ii":
                return q$3(a2, e2.length);
            case "io":
                return n2.ordinalNumber(a2, {
                    unit: "day"
                });
            case "iii":
                return n2.day(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return n2.day(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return n2.day(r2, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return n2.day(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    a: function(t2, e2, n2) {
        var r2 = t2.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(e2){
            case "a":
            case "aa":
                return n2.dayPeriod(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return n2.dayPeriod(r2, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return n2.dayPeriod(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n2.dayPeriod(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    b: function(t2, e2, n2) {
        var r2, a2 = t2.getUTCHours();
        switch(r2 = 12 === a2 ? "noon" : 0 === a2 ? "midnight" : a2 / 12 >= 1 ? "pm" : "am", e2){
            case "b":
            case "bb":
                return n2.dayPeriod(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return n2.dayPeriod(r2, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return n2.dayPeriod(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n2.dayPeriod(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    B: function(t2, e2, n2) {
        var r2, a2 = t2.getUTCHours();
        switch(r2 = a2 >= 17 ? "evening" : a2 >= 12 ? "afternoon" : a2 >= 4 ? "morning" : "night", e2){
            case "B":
            case "BB":
            case "BBB":
                return n2.dayPeriod(r2, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return n2.dayPeriod(r2, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n2.dayPeriod(r2, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    h: function(t2, e2, n2) {
        if ("ho" === e2) {
            var r2 = t2.getUTCHours() % 12;
            return 0 === r2 && (r2 = 12), n2.ordinalNumber(r2, {
                unit: "hour"
            });
        }
        return function(t3, e3) {
            return q$3(t3.getUTCHours() % 12 || 12, e3.length);
        }(t2, e2);
    },
    H: function(t2, e2, n2) {
        return "Ho" === e2 ? n2.ordinalNumber(t2.getUTCHours(), {
            unit: "hour"
        }) : function(t3, e3) {
            return q$3(t3.getUTCHours(), e3.length);
        }(t2, e2);
    },
    K: function(t2, e2, n2) {
        var r2 = t2.getUTCHours() % 12;
        return "Ko" === e2 ? n2.ordinalNumber(r2, {
            unit: "hour"
        }) : q$3(r2, e2.length);
    },
    k: function(t2, e2, n2) {
        var r2 = t2.getUTCHours();
        return 0 === r2 && (r2 = 24), "ko" === e2 ? n2.ordinalNumber(r2, {
            unit: "hour"
        }) : q$3(r2, e2.length);
    },
    m: function(t2, e2, n2) {
        return "mo" === e2 ? n2.ordinalNumber(t2.getUTCMinutes(), {
            unit: "minute"
        }) : function(t3, e3) {
            return q$3(t3.getUTCMinutes(), e3.length);
        }(t2, e2);
    },
    s: function(t2, e2, n2) {
        return "so" === e2 ? n2.ordinalNumber(t2.getUTCSeconds(), {
            unit: "second"
        }) : function(t3, e3) {
            return q$3(t3.getUTCSeconds(), e3.length);
        }(t2, e2);
    },
    S: function(t2, e2) {
        return function(t3, e3) {
            var n2 = e3.length, r2 = t3.getUTCMilliseconds();
            return q$3(Math.floor(r2 * Math.pow(10, n2 - 3)), e3.length);
        }(t2, e2);
    },
    X: function(t2, e2, n2, r2) {
        var a2 = (r2._originalDate || t2).getTimezoneOffset();
        if (0 === a2) return "Z";
        switch(e2){
            case "X":
                return Q$2(a2);
            case "XXXX":
            case "XX":
                return T$4(a2);
            default:
                return T$4(a2, ":");
        }
    },
    x: function(t2, e2, n2, r2) {
        var a2 = (r2._originalDate || t2).getTimezoneOffset();
        switch(e2){
            case "x":
                return Q$2(a2);
            case "xxxx":
            case "xx":
                return T$4(a2);
            default:
                return T$4(a2, ":");
        }
    },
    O: function(t2, e2, n2, r2) {
        var a2 = (r2._originalDate || t2).getTimezoneOffset();
        switch(e2){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + L$4(a2, ":");
            default:
                return "GMT" + T$4(a2, ":");
        }
    },
    z: function(t2, e2, n2, r2) {
        var a2 = (r2._originalDate || t2).getTimezoneOffset();
        switch(e2){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + L$4(a2, ":");
            default:
                return "GMT" + T$4(a2, ":");
        }
    },
    t: function(t2, e2, n2, r2) {
        return q$3(Math.floor((r2._originalDate || t2).getTime() / 1e3), e2.length);
    },
    T: function(t2, e2, n2, r2) {
        return q$3((r2._originalDate || t2).getTime(), e2.length);
    }
};
function L$4(t2, e2) {
    var n2 = t2 > 0 ? "-" : "+", r2 = Math.abs(t2), a2 = Math.floor(r2 / 60), i2 = r2 % 60;
    return 0 === i2 ? n2 + (a2 + "") : n2 + (a2 + "") + e2 + q$3(i2, 2);
}
function Q$2(t2, e2) {
    return t2 % 60 == 0 ? (t2 > 0 ? "-" : "+") + q$3(Math.abs(t2) / 60, 2) : T$4(t2, e2);
}
function T$4(t2, e2) {
    var n2 = e2 || "", r2 = t2 > 0 ? "-" : "+", a2 = Math.abs(t2);
    return r2 + q$3(Math.floor(a2 / 60), 2) + n2 + q$3(a2 % 60, 2);
}
var R$4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, B$4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, O$5 = /^'([^]*?)'?$/, $$3 = /''/g, z$5 = /[a-zA-Z]/;
var j$7 = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
}, X$2 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Y$2 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Z$2 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function F$3(t2) {
    return t2 ? parseInt(t2) : 1;
}
function H$4(t2) {
    return t2 && parseFloat(t2.replace(",", ".")) || 0;
}
var P$5 = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function W$5(t2) {
    return t2 % 400 == 0 || t2 % 4 == 0 && t2 % 100 != 0;
}
const C$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDatePickerInputDateSet = (0, $696Z8.createEvent)(this, "marketDatePickerInputDateSet", 7), this.marketDatePickerInputDateInvalidStateChanged = (0, $696Z8.createEvent)(this, "marketDatePickerInputDateInvalidStateChanged", 7), this.withTime = false, this.timeframe = "present", this.range = false, this.isRangeInvalid = false;
    }
    emitInvalidStateEvent() {
        this.marketDatePickerInputDateInvalidStateChanged.emit({
            invalid: this.isRangeInvalid
        });
    }
    formatDate(t2, e2 = false) {
        if (!t2) return "";
        const n2 = new Date(t2);
        return S$6(n2) ? function(t3, e3, n3) {
            var r2, a2, i2, u2, s2, h2, l2, w2, m2;
            n$q(2, arguments);
            var k2 = e3 + "", E2 = a$k(), M2 = null !== (r2 = E2.locale) && void 0 !== r2 ? r2 : A$5, N2 = t$3(null !== (a2 = null !== (i2 = E2.firstWeekContainsDate) && void 0 !== i2 ? i2 : null === (u2 = E2.locale) || void 0 === u2 || null === (s2 = u2.options) || void 0 === s2 ? void 0 : s2.firstWeekContainsDate) && void 0 !== a2 ? a2 : 1);
            if (!(N2 >= 1 && N2 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
            var I2 = t$3(null !== (h2 = null !== (l2 = E2.weekStartsOn) && void 0 !== l2 ? l2 : null === (w2 = E2.locale) || void 0 === w2 || null === (m2 = w2.options) || void 0 === m2 ? void 0 : m2.weekStartsOn) && void 0 !== h2 ? h2 : 0);
            if (!(I2 >= 0 && I2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
            if (!M2.localize) throw new RangeError("locale must contain localize property");
            if (!M2.formatLong) throw new RangeError("locale must contain formatLong property");
            var q2 = o$d(t3);
            if (!S$6(q2)) throw new RangeError("Invalid time value");
            var L2 = r$a(q2), Q2 = d$d(q2, L2), T2 = {
                firstWeekContainsDate: N2,
                weekStartsOn: I2,
                locale: M2,
                _originalDate: q2
            };
            return k2.match(B$4).map(function(t4) {
                var e4 = t4[0];
                return "p" === e4 || "P" === e4 ? (0, w$6[e4])(t4, M2.formatLong) : t4;
            }).join("").match(R$4).map(function(n4) {
                if ("''" === n4) return "'";
                var r3 = n4[0];
                if ("'" === r3) return function(t4) {
                    var e4 = t4.match(O$5);
                    return e4 ? e4[1].replace($$3, "'") : t4;
                }(n4);
                var a3 = G$3[r3];
                if (a3) return M$5(n4) && P$6(n4, e3, t3 + ""), p$7(n4) && P$6(n4, e3, t3 + ""), a3(Q2, n4, M2.localize, T2);
                if (r3.match(z$5)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + r3 + "`");
                return n4;
            }).join("");
        }(n2, e2 ? "HH:mm" : "yyyy-MM-dd") : "";
    }
    isInvalidDateForTimeframe(t2, e2 = /* @__PURE__ */ new Date()) {
        const n2 = "future" === this.timeframe && u$b(t2, e2) && !t$2(t2, e2), r2 = "past" === this.timeframe && s$m(t2, e2) && !t$2(t2, e2);
        return n2 || r2;
    }
    updateInvalidState(t2 = this.selectedStartDate, e2 = this.selectedEndDate) {
        this.isRangeInvalid = !(!this.isDateInvalid(t2) && !this.isDateInvalid(e2)) || !!e2 && s$m(new Date(t2), new Date(e2));
    }
    isDateInvalid(t2) {
        if (!t2) return false;
        const e2 = function(t3, e3) {
            n$q(1, arguments);
            var n2 = t$3(2);
            if (2 !== n2 && 1 !== n2 && 0 !== n2) throw new RangeError("additionalDigits must be 0, 1 or 2");
            if ("string" != typeof t3 && "[object String]" !== Object.prototype.toString.call(t3)) return /* @__PURE__ */ new Date(NaN);
            var r2, a2 = function(t4) {
                var e4, n3 = {}, r3 = t4.split(j$7.dateTimeDelimiter);
                if (r3.length > 2) return n3;
                if (/:/.test(r3[0]) ? e4 = r3[0] : (n3.date = r3[0], e4 = r3[1], j$7.timeZoneDelimiter.test(n3.date) && (n3.date = t4.split(j$7.timeZoneDelimiter)[0], e4 = t4.substr(n3.date.length, t4.length))), e4) {
                    var a3 = j$7.timezone.exec(e4);
                    a3 ? (n3.time = e4.replace(a3[1], ""), n3.timezone = a3[1]) : n3.time = e4;
                }
                return n3;
            }(t3);
            if (a2.date) {
                var i2 = function(t4, e4) {
                    var n3 = RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e4) + "})|(\\d{2}|[+-]\\d{" + (2 + e4) + "})$)"), r3 = t4.match(n3);
                    if (!r3) return {
                        year: NaN,
                        restDateString: ""
                    };
                    var a3 = r3[1] ? parseInt(r3[1]) : null, i3 = r3[2] ? parseInt(r3[2]) : null;
                    return {
                        year: null === i3 ? a3 : 100 * i3,
                        restDateString: t4.slice((r3[1] || r3[2]).length)
                    };
                }(a2.date, n2);
                r2 = function(t4, e4) {
                    if (null === e4) return /* @__PURE__ */ new Date(NaN);
                    var n3 = t4.match(X$2);
                    if (!n3) return /* @__PURE__ */ new Date(NaN);
                    var r3 = !!n3[4], a3 = F$3(n3[1]), i3 = F$3(n3[2]) - 1, u3 = F$3(n3[3]), c2 = F$3(n3[4]), s3 = F$3(n3[5]) - 1;
                    if (r3) return function(t5, e5, n4) {
                        return e5 >= 1 && e5 <= 53 && n4 >= 0 && n4 <= 6;
                    }(0, c2, s3) ? function(t5, e5, n4) {
                        var r4 = /* @__PURE__ */ new Date(0);
                        r4.setUTCFullYear(t5, 0, 4);
                        var a4 = 7 * (e5 - 1) + n4 + 1 - (r4.getUTCDay() || 7);
                        return r4.setUTCDate(r4.getUTCDate() + a4), r4;
                    }(e4, c2, s3) : /* @__PURE__ */ new Date(NaN);
                    var o3 = /* @__PURE__ */ new Date(0);
                    return function(t5, e5, n4) {
                        return e5 >= 0 && e5 <= 11 && n4 >= 1 && n4 <= (P$5[e5] || (W$5(t5) ? 29 : 28));
                    }(e4, i3, u3) && function(t5, e5) {
                        return e5 >= 1 && e5 <= (W$5(t5) ? 366 : 365);
                    }(e4, a3) ? (o3.setUTCFullYear(e4, i3, Math.max(a3, u3)), o3) : /* @__PURE__ */ new Date(NaN);
                }(i2.restDateString, i2.year);
            }
            if (!r2 || isNaN(r2.getTime())) return /* @__PURE__ */ new Date(NaN);
            var u2, s2 = r2.getTime(), o2 = 0;
            if (a2.time && (o2 = function(t4) {
                var e4 = t4.match(Y$2);
                if (!e4) return NaN;
                var n3 = H$4(e4[1]), r3 = H$4(e4[2]), a3 = H$4(e4[3]);
                return function(t5, e5, n4) {
                    return 24 === t5 ? 0 === e5 && 0 === n4 : n4 >= 0 && n4 < 60 && e5 >= 0 && e5 < 60 && t5 >= 0 && t5 < 25;
                }(n3, r3, a3) ? n3 * o$c + r3 * i$g + 1e3 * a3 : NaN;
            }(a2.time), isNaN(o2))) return /* @__PURE__ */ new Date(NaN);
            if (!a2.timezone) {
                var f2 = new Date(s2 + o2), h2 = /* @__PURE__ */ new Date(0);
                return h2.setFullYear(f2.getUTCFullYear(), f2.getUTCMonth(), f2.getUTCDate()), h2.setHours(f2.getUTCHours(), f2.getUTCMinutes(), f2.getUTCSeconds(), f2.getUTCMilliseconds()), h2;
            }
            return u2 = function(t4) {
                if ("Z" === t4) return 0;
                var e4 = t4.match(Z$2);
                if (!e4) return 0;
                var n3 = "+" === e4[1] ? -1 : 1, r3 = parseInt(e4[2]), a3 = e4[3] && parseInt(e4[3]) || 0;
                return function(t5, e5) {
                    return e5 >= 0 && e5 <= 59;
                }(0, a3) ? n3 * (r3 * o$c + a3 * i$g) : NaN;
            }(a2.timezone), new Date(isNaN(u2) ? NaN : s2 + o2 + u2);
        }(t2);
        return "" + e2 == "Invalid Date" || !(!this.isDateDisabled || !this.isDateDisabled(e2)) || !(!this.timeframe || !this.isInvalidDateForTimeframe(e2));
    }
    emitDateSetStart(t2) {
        this.emitDateSet(t2, "start");
    }
    emitDateSetEnd(t2) {
        this.emitDateSet(t2, "end");
    }
    emitDateSetStartTime(t2) {
        this.emitDateSet(t2, "start", true);
    }
    emitDateSetEndTime(t2) {
        this.emitDateSet(t2, "end", true);
    }
    emitDateSet(t2, e2, n2 = false) {
        t2.preventDefault(), t2.stopPropagation();
        const { value: r2 } = t2.target;
        let a2 = r2;
        this.withTime && (a2 = n2 ? `${this.formatDate("start" === e2 ? this.selectedStartDate : this.selectedEndDate)}T${r2.slice(0, 5)}` : `${r2}T${this.formatDate("start" === e2 ? this.selectedStartDate : this.selectedEndDate, true)}`);
        const i2 = a2.replace(/^0+/, "").length;
        10 !== i2 && 16 !== i2 || this.marketDatePickerInputDateSet.emit({
            date: a2,
            input: e2
        });
    }
    componentWillRender() {
        this.updateInvalidState();
    }
    render() {
        const t2 = l$s("market-input-text"), e2 = l$s("market-banner"), n2 = (t3)=>(0, $696Z8.h)("div", {
                key: "976c56795da33b101ca4cb8437b598438de3fac6",
                class: "input-wrapper " + ("start" === t3 ? "start-input" : "")
            }, "start" === t3 && i2("start"), "start" === t3 && this.withTime && c2("start"), "end" === t3 && i2("end"), "end" === t3 && this.withTime && c2("end")), i2 = (e3)=>(0, $696Z8.h)(t2, {
                key: "c8cd8c713f577e5c41e807d7acee5ef4d70783e8",
                type: "date",
                class: "date-input",
                name: "date-picker-date-" + e3,
                invalid: this.isRangeInvalid,
                value: this.formatDate("start" === e3 ? this.selectedStartDate : this.selectedEndDate),
                onInput: "start" === e3 ? this.emitDateSetStart.bind(this) : this.emitDateSetEnd.bind(this)
            }, (0, $696Z8.h)("label", {
                key: "ccb62036adb2cf62f3195e42c3407a4b62372ee3",
                htmlFor: "date-picker-" + e3
            }, (0, $696Z8.h)("slot", {
                key: "1b2fcc3ef29fa978aedfffff33b88991f2ad1352",
                name: e3 + "-date"
            }, this.range && ("start" === e3 ? "Start" : "End"), " Date"))), c2 = (e3)=>(0, $696Z8.h)(t2, {
                key: "448f877c3d13fb5f9c4573d989cf086ed60dd784",
                type: "time",
                class: "time-input",
                name: "date-picker-time-" + e3,
                invalid: this.isRangeInvalid,
                value: this.formatDate("start" === e3 ? this.selectedStartDate : this.selectedEndDate, true),
                onInput: "start" === e3 ? this.emitDateSetStartTime.bind(this) : this.emitDateSetEndTime.bind(this)
            }, (0, $696Z8.h)("label", {
                key: "368d0c32216fae49983ff1afdd66642a339abf92",
                htmlFor: "date-picker-time-" + e3
            }, (0, $696Z8.h)("slot", {
                key: "1ce93d8d2d2401d5c58c5a566920f5f272b43359",
                name: e3 + "-time"
            }, this.range && ("start" === e3 ? "Start" : "End"), " Time")));
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "6ba44c78ec304919120eb02d90e6d33edc95af34",
            class: "market-date-picker-input-date"
        }, this.range ? (0, $696Z8.h)("div", {
            class: "input-row"
        }, n2("start"), n2("end")) : (0, $696Z8.h)("div", null, n2("start")), this.isRangeInvalid && (0, $696Z8.h)(e2, {
            key: "eac2b0eb7853d50070550332dbed0b5c5b5a42a6",
            variant: "critical"
        }, (0, $696Z8.h)("slot", {
            key: "0da4a18dc091898915b7d8369de4265deb13f6f3",
            name: "range-error"
        }, "Enter a valid date range")));
    }
    static get watchers() {
        return {
            isRangeInvalid: [
                {
                    emitInvalidStateEvent: 0
                }
            ]
        };
    }
    static get style() {
        return ".input-row{display:flex;justify-content:space-around;margin-top:8px}.input-wrapper{display:flex;flex:1;flex-direction:column;align-items:flex-start}.start-input:not(:last-child){margin-right:16px}.time-input,.date-input{box-sizing:border-box;width:100%;margin-top:16px}.market-banner{margin-top:16px}";
    }
}, [
    257,
    "market-date-picker-input-date",
    {
        withTime: [
            4,
            "with-time"
        ],
        selectedStartDate: [
            1,
            "selected-start-date"
        ],
        selectedEndDate: [
            1,
            "selected-end-date"
        ],
        isDateDisabled: [
            16
        ],
        timeframe: [
            1
        ],
        range: [
            4
        ],
        isRangeInvalid: [
            32
        ]
    },
    void 0,
    {
        isRangeInvalid: [
            {
                emitInvalidStateEvent: 0
            }
        ]
    }
]), K$2 = C$3;
const o$b = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketDatePickerMenuSelectionChanged = (0, $696Z8.createEvent)(this, "marketDatePickerMenuSelectionChanged", 7), this.timeframe = "present", this.excludeMenuItems = "";
    }
    handleMarketListSelectionsDidChange(e2) {
        e2.stopPropagation(), this.marketDatePickerMenuSelectionChanged.emit({
            menuSelection: e2.detail.newSelectionValue
        });
    }
    _selectCustomRow() {
        const e2 = l$s("market-row");
        return this.el.shadowRoot.querySelectorAll(e2).forEach((e3)=>{
            e3.querySelector("slot").name === t$4.CUSTOM && e3.click();
        }), Promise.resolve();
    }
    render() {
        const e2 = l$s("market-list"), t2 = l$s("market-row"), a2 = this.excludeMenuItems.split(",");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "62360450f1bac96798dc4c6920388c236ec50424",
            class: "market-date-picker-menu"
        }, (0, $696Z8.h)(e2, {
            key: "4c5b0c385cbb061a6e34f9b67781fcabc7234489",
            interactive: true
        }, "past" !== this.timeframe && !a2.includes(t$4.TODAY) && (0, $696Z8.h)(t2, {
            key: "c7b43477ca87f7c45890f171948cfe4a72c986e5",
            value: t$4.TODAY,
            selected: this.presetMenuOption === t$4.TODAY
        }, (0, $696Z8.h)("slot", {
            key: "84466a9b16c61d87f2b677324d70ecb44329b60d",
            name: t$4.TODAY
        }, "Today")), "future" !== this.timeframe && !a2.includes(t$4.YESTERDAY) && (0, $696Z8.h)(t2, {
            key: "c667baac3dc20d2d315eabcfd201026ac6848648",
            value: t$4.YESTERDAY,
            selected: this.presetMenuOption === t$4.YESTERDAY
        }, (0, $696Z8.h)("slot", {
            key: "190fdf016aac550d09dd1033b630d6458a4d2a88",
            name: t$4.YESTERDAY
        }, "Yesterday")), "past" !== this.timeframe && !a2.includes(t$4.THIS_WEEK) && (0, $696Z8.h)(t2, {
            key: "6da58d2b162cbe597b2e92d6f11b92c44f4558f5",
            value: t$4.THIS_WEEK,
            selected: this.presetMenuOption === t$4.THIS_WEEK
        }, (0, $696Z8.h)("slot", {
            key: "f11c13e408657eb67522c745cd4017486ca8b59e",
            name: t$4.THIS_WEEK
        }, "This week")), "future" !== this.timeframe && !a2.includes(t$4.LAST_WEEK) && (0, $696Z8.h)(t2, {
            key: "d51f1aff9416f7dd66d8d98c559f9dc2a71d9233",
            value: t$4.LAST_WEEK,
            selected: this.presetMenuOption === t$4.LAST_WEEK
        }, (0, $696Z8.h)("slot", {
            key: "be1bd44aae7f55f60793fe635dabeb7a154ea149",
            name: t$4.LAST_WEEK
        }, "Last week")), "past" !== this.timeframe && !a2.includes(t$4.THIS_MONTH) && (0, $696Z8.h)(t2, {
            key: "f27d7f66c02ca0241a700aeb633f3a36897ea1f3",
            value: t$4.THIS_MONTH,
            selected: this.presetMenuOption === t$4.THIS_MONTH
        }, (0, $696Z8.h)("slot", {
            key: "1c447b0a7c90d006cb0cdc62c62df55b5564e308",
            name: t$4.THIS_MONTH
        }, "This month")), "future" !== this.timeframe && !a2.includes(t$4.LAST_MONTH) && (0, $696Z8.h)(t2, {
            key: "dbb716e53f06d408b84a82b140bb8f3c8c16d77b",
            value: t$4.LAST_MONTH,
            selected: this.presetMenuOption === t$4.LAST_MONTH
        }, (0, $696Z8.h)("slot", {
            key: "835b25cad3af797949599a8e0744f2af2d809674",
            name: t$4.LAST_MONTH
        }, "Last month")), "past" !== this.timeframe && !a2.includes(t$4.THIS_YEAR) && (0, $696Z8.h)(t2, {
            key: "63bcbdceccff6f6a42c4f8ea13985887c1c382c9",
            value: t$4.THIS_YEAR,
            selected: this.presetMenuOption === t$4.THIS_YEAR
        }, (0, $696Z8.h)("slot", {
            key: "55caeced1d375f246797dcc350c1d289c026fa63",
            name: t$4.THIS_YEAR
        }, "This year")), "future" !== this.timeframe && !a2.includes(t$4.LAST_YEAR) && (0, $696Z8.h)(t2, {
            key: "83b87409aec80a9fe43e18ad29399d966dabef8f",
            value: t$4.LAST_YEAR,
            selected: this.presetMenuOption === t$4.LAST_YEAR
        }, (0, $696Z8.h)("slot", {
            key: "1026b0ed92857c9232e665a4d1c4c310888b006d",
            name: t$4.LAST_YEAR
        }, "Last year")), "present" === this.timeframe && !a2.includes(t$4.PAY_PERIOD) && (0, $696Z8.h)(t2, {
            key: "37192166c6c442ca64a8ba1f9d2b09d9a4bc71e6",
            value: t$4.PAY_PERIOD,
            selected: this.presetMenuOption === t$4.PAY_PERIOD
        }, (0, $696Z8.h)("slot", {
            key: "8dbe2f112b600c3ba89ba93558e3a2c0132993eb",
            name: t$4.PAY_PERIOD
        }, "Pay period")), !a2.includes(t$4.CUSTOM) && (0, $696Z8.h)(t2, {
            key: "a86bcb5fa23ba74047bb0068c6072870773e7a1e",
            value: t$4.CUSTOM,
            selected: this.presetMenuOption === t$4.CUSTOM
        }, (0, $696Z8.h)("slot", {
            key: "9653433a5615753520cf900d925dbb9eb00d288c",
            name: t$4.CUSTOM
        }, "Custom"))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host{display:block;margin-right:var(--date-picker-menu-horizontal-spacing);font-weight:var(--date-picker-menu-text-weight);font-size:var(--date-picker-menu-text-size);line-height:var(--date-picker-menu-text-leading)}:host>.market-list>.market-row{min-height:var(--date-picker-menu-row-height);padding:0 12px}:host>.market-list>.market-row::part(container):focus-visible{outline:none}:host>.market-list>.market-row:focus-within{z-index:2;outline:var(--row-focus-ring-border-size) solid var(--row-normal-variant-focus-ring-color);outline-offset:var(--row-focus-ring-buffer-size)}:host>.market-list>.market-row::before{content:none}:host>.market-list>.market-row::part(container){padding-right:0;padding-left:0}:host>.market-list>.market-row[selected]{background-color:var(--date-picker-menu-row-background-selected-state-color, var(--core-emphasis-40-color));color:var(--date-picker-menu-row-label-selected-state-text-color)}@media only screen and (width <= 800px){:host{margin-right:0}:host>.market-list>.market-row{width:inherit}}";
    }
}, [
    257,
    "market-date-picker-menu",
    {
        timeframe: [
            513
        ],
        excludeMenuItems: [
            1,
            "exclude-menu-items"
        ],
        presetMenuOption: [
            1,
            "preset-menu-option"
        ],
        _selectCustomRow: [
            64
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "handleMarketListSelectionsDidChange"
        ]
    ]
]), n$p = o$b;
const c$k = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7), this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7), this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7), this.type = "dialog", this.hidden = false, this.isLoading = false, this.persistent = false, this.trapFocus = false, this.animationEnterDuration = A$7, this.animationExitDuration = B$5;
    }
    dismiss(t2) {
        if (!this.persistent) {
            const { defaultPrevented: a2 } = this.marketDialogDismissed.emit({
                dialog: this.el,
                type: this.type,
                origin: (null == t2 ? void 0 : t2.origin) || this.el
            });
            a2 || (this.hidden = true, this.dismissTimeout = setTimeout(()=>{
                this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
                    dialog: this.el,
                    type: this.type,
                    origin: this.el
                });
            }, this.animationExitDuration));
        }
        return Promise.resolve();
    }
    onTrapFocusChanged(t2, a2) {
        t2 !== a2 && (t2 ? this.activateFocusTrap() : this.deactivateFocusTrap());
    }
    activateFocusTrap(t2, a2) {
        return this.focusTrap ? (this.focusTrap.activate(null != a2 ? a2 : {}), this.trapFocus || (this.trapFocus = true)) : this.focusTrap = C$4({
            activateOptions: a2,
            el: this.el,
            options: t2
        }), Promise.resolve();
    }
    deactivateFocusTrap(t2) {
        return this.focusTrap && (this.focusTrap.deactivate(Object.assign({
            returnFocus: true,
            checkCanReturnFocus: (t3)=>new Promise((a2)=>{
                    I$3(t3) ? t3.setFocus() : a2();
                })
        }, t2)), this.focusTrap = void 0), Promise.resolve();
    }
    removeTopMarginOfFirstHeading() {
        const t2 = this.el.querySelectorAll("h1, h2, h3, h4, h5, h6");
        t2.length > 0 && (t2[0].style.marginTop = "0");
    }
    handleSlotchange() {
        this.removeTopMarginOfFirstHeading();
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            }), this.trapFocus && this.activateFocusTrap();
        }, this.animationEnterDuration), this.handleSlotchange();
    }
    disconnectedCallback() {
        this.deactivateFocusTrap(), clearTimeout(this.connectedCallbackTimeout), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
            dialog: this.el,
            type: this.type,
            origin: this.el
        }));
    }
    render() {
        const t2 = l$s("market-activity-indicator");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "e17c9df73c1b953170f1c68a9e065c1c5e1f1846",
            class: "market-dialog",
            role: "dialog"
        }, this.isLoading && (0, $696Z8.h)(t2, {
            key: "67f0ecb77379bba90314e3f3302798862a8245aa"
        }), (0, $696Z8.h)("slot", {
            key: "c87981cc914a4c738e9b1e17cf323c46d6f6e850",
            onSlotchange: this.handleSlotchange.bind(this)
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            trapFocus: [
                {
                    onTrapFocusChanged: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main),:host ::slotted(.main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{--modal-dialog-width:var(--modal-dialog-maximum-width-size);--modal-dialog-horizontal-padding-size:var(--modal-dialog-compact-horizontal-size-class-horizontal-padding);--modal-dialog-vertical-padding-size:var(--modal-dialog-compact-vertical-size-class-vertical-padding);width:var(--modal-dialog-width);max-width:var(--modal-dialog-width);padding:var(--modal-dialog-vertical-padding-size)     var(--modal-dialog-horizontal-padding-size);border-radius:var(--modal-dialog-border-radius);background-color:var(--modal-dialog-background-color);animation:var(--modal-dialog-animation-enter-transition-duration)     market-popup     forwards     var(--modal-dialog-animation-enter-transition-easing)}:host([hidden]){animation-name:market-popdown;animation-duration:var(--modal-dialog-animation-exit-transition-duration);animation-timing-function:var(--modal-dialog-animation-exit-transition-easing)}:host([value="loadingMode"]){display:flex;flex-direction:column}::slotted(.market-footer){padding-top:var(--modal-dialog-regular-vertical-size-class-vertical-padding)}.market-activity-indicator{align-self:flex-start;margin-bottom:var(--core-metrics-spacing-200)}@media only screen and (width >= 600px){:host{--modal-dialog-horizontal-padding-size:var(--modal-dialog-regular-horizontal-size-class-horizontal-padding);--modal-dialog-vertical-padding-size:var(--modal-dialog-regular-vertical-size-class-vertical-padding)}}@media only screen and (width >= 1200px){:host{--modal-dialog-horizontal-padding-size:var(--modal-dialog-wide-horizontal-size-class-horizontal-padding);--modal-dialog-vertical-padding-size:var(--modal-dialog-wide-vertical-size-class-vertical-padding, 32px)}}';
    }
}, [
    257,
    "market-dialog",
    {
        hidden: [
            1540
        ],
        dialogID: [
            513,
            "data-dialog-id"
        ],
        index: [
            514,
            "data-dialog-index"
        ],
        isLoading: [
            4,
            "is-loading"
        ],
        persistent: [
            516
        ],
        trapFocus: [
            1028,
            "trap-focus"
        ],
        animationEnterDuration: [
            2,
            "animation-enter-duration"
        ],
        animationExitDuration: [
            2,
            "animation-exit-duration"
        ],
        dismiss: [
            64
        ],
        activateFocusTrap: [
            64
        ],
        deactivateFocusTrap: [
            64
        ]
    },
    void 0,
    {
        trapFocus: [
            {
                onTrapFocusChanged: 0
            }
        ]
    }
]), h$b = c$k;
const d$c = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(i2){
        super(), false !== i2 && this.__registerHost(), this.__attachShadow(), this.margin = "medium", this.size = "thick";
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "2ea2acb8c819496d30e39f1fc9e243f5895b8f1d",
            class: "market-divider"
        });
    }
    static get style() {
        return ':host{--divider-thin-variant-height:1px;display:block;flex:none;height:var(--divider-height);border-radius:var(--divider-radius);background-color:var(--divider-fill-color)}:host([margin="large"]){margin:var(--divider-large-variant-vertical-padding) 0}:host([margin="medium"]){margin:var(--divider-medium-variant-vertical-padding) 0}:host([margin="small"]){margin:var(--divider-small-variant-vertical-padding) 0}:host([size="thin"]){height:var(--divider-thin-variant-height)}';
    }
}, [
    1,
    "market-divider",
    {
        margin: [
            513
        ],
        size: [
            513
        ]
    }
]), n$o = d$c;
const u$9 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketDragHandleDragStart = (0, $696Z8.createEvent)(this, "marketDragHandleDragStart", 7), this.marketDragHandleDragMove = (0, $696Z8.createEvent)(this, "marketDragHandleDragMove", 7), this.marketDragHandleDragEnd = (0, $696Z8.createEvent)(this, "marketDragHandleDragEnd", 7), this.boundOnDragMove = this.onDragMove.bind(this), this.boundOnDragEnd = this.onDragEnd.bind(this);
    }
    onDragStart(e2) {
        if (e2.preventDefault(), e2.stopPropagation(), !n$s(e2) && 0 !== e2.button) return;
        const { marketDragHandleDragStart: t2, boundOnDragMove: o2, boundOnDragEnd: a2 } = this, r2 = o$e(e2), { defaultPrevented: n2 } = t2.emit(r2);
        n2 || (document.addEventListener("mousemove", o2), document.addEventListener("mouseup", a2), document.addEventListener("touchmove", o2, {
            passive: false
        }), document.addEventListener("touchend", a2, {
            passive: false
        }));
    }
    onDragMove(e2) {
        e2.preventDefault();
        const { marketDragHandleDragMove: t2, boundOnDragMove: o2, boundOnDragEnd: a2 } = this, r2 = o$e(e2), { defaultPrevented: n2 } = t2.emit(r2);
        n2 && (document.removeEventListener("mousemove", o2), document.removeEventListener("mouseup", a2), document.removeEventListener("touchmove", o2), document.removeEventListener("touchend", a2));
    }
    onDragEnd(e2) {
        e2.preventDefault();
        const { marketDragHandleDragEnd: t2, boundOnDragMove: o2, boundOnDragEnd: a2 } = this, r2 = o$e(e2), { defaultPrevented: n2 } = t2.emit(r2);
        n2 || (document.removeEventListener("mousemove", o2), document.removeEventListener("mouseup", a2), document.removeEventListener("touchmove", o2), document.removeEventListener("touchend", a2));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "b4b6b235c7099bdc6971e482d83fdcbf856e1f16",
            class: "market-drag-handle",
            onMouseDown: (e2)=>this.onDragStart(e2),
            onTouchStart: (e2)=>this.onDragStart(e2),
            "aria-hidden": "true"
        }, (0, $696Z8.h)("svg", {
            key: "81f5adf38aaa6f61fcadc6ac0af8f39462be1e5d",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "f1708d3e603998da65db3eddff4f33643629ec6f",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M15 8C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4C13.8954 4 13 4.89543 13 6C13 7.10457 13.8954 8 15 8ZM15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14ZM11 18C11 19.1046 10.1046 20 9 20C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16C10.1046 16 11 16.8954 11 18ZM17 18C17 19.1046 16.1046 20 15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18ZM11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 10.8954 7.89543 10 9 10C10.1046 10 11 10.8954 11 12ZM11 6C11 7.10457 10.1046 8 9 8C7.89543 8 7 7.10457 7 6C7 4.89543 7.89543 4 9 4C10.1046 4 11 4.89543 11 6Z"
        })));
    }
    static get style() {
        return ":host{cursor:grab}:host(:active){cursor:grabbing}svg{display:block;fill:var(--drag-handle-normal-state-color, var(--core-fill-20-color))}:host(:hover) svg{fill:var(--drag-handle-hover-state-color, var(--core-fill-10-color))}";
    }
}, [
    1,
    "market-drag-handle"
]), c$j = u$9;
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value)=>key in obj ? __defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var __spreadValues$1 = (a2, b2)=>{
    for(var prop in b2 || (b2 = {}))if (__hasOwnProp$1.call(b2, prop)) __defNormalProp$1(a2, prop, b2[prop]);
    if (__getOwnPropSymbols$1) {
        for (var prop of __getOwnPropSymbols$1(b2))if (__propIsEnum$1.call(b2, prop)) __defNormalProp$1(a2, prop, b2[prop]);
    }
    return a2;
};
var __spreadProps = (a2, b2)=>__defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1) {
        for (var prop of __getOwnPropSymbols$1(source))if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const t$1 = [
    "start",
    "end"
], n$n = [
    "top",
    "right",
    "bottom",
    "left"
].reduce((n2, e2)=>n2.concat(e2, e2 + "-" + t$1[0], e2 + "-" + t$1[1]), []), e$7 = Math.min, o$a = Math.max, r$9 = Math.round, i$f = Math.floor, l$h = (t2)=>({
        x: t2,
        y: t2
    }), a$i = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
}, c$i = {
    start: "end",
    end: "start"
};
function s$j(t2, n2, r2) {
    return o$a(t2, e$7(n2, r2));
}
function u$8(t2, n2) {
    return "function" == typeof t2 ? t2(n2) : t2;
}
function f$8(t2) {
    return t2.split("-")[0];
}
function d$b(t2) {
    return t2.split("-")[1];
}
function m$5(t2) {
    return "x" === t2 ? "y" : "x";
}
function p$6(t2) {
    return "y" === t2 ? "height" : "width";
}
const y$7 = /* @__PURE__ */ new Set([
    "top",
    "bottom"
]);
function h$a(t2) {
    return y$7.has(f$8(t2)) ? "y" : "x";
}
function w$5(t2) {
    return m$5(h$a(t2));
}
function g$7(t2, n2, e2) {
    void 0 === e2 && (e2 = false);
    const o2 = d$b(t2), r2 = w$5(t2), i2 = p$6(r2);
    let l2 = "x" === r2 ? o2 === (e2 ? "end" : "start") ? "right" : "left" : "start" === o2 ? "bottom" : "top";
    return n2.reference[i2] > n2.floating[i2] && (l2 = R$3(l2)), [
        l2,
        R$3(l2)
    ];
}
function v$4(t2) {
    return t2.replace(/start|end/g, (t3)=>c$i[t3]);
}
const x$7 = [
    "left",
    "right"
], b$7 = [
    "right",
    "left"
], A$4 = [
    "top",
    "bottom"
], S$5 = [
    "bottom",
    "top"
];
function R$3(t2) {
    return t2.replace(/left|right|bottom|top/g, (t3)=>a$i[t3]);
}
function F$2(t2) {
    const { x: n2, y: e2, width: o2, height: r2 } = t2;
    return {
        width: o2,
        height: r2,
        top: e2,
        left: n2,
        right: n2 + o2,
        bottom: e2 + r2,
        x: n2,
        y: e2
    };
}
function k$3(t2, n2, e2) {
    let { reference: o2, floating: r2 } = t2;
    const i2 = h$a(n2), l2 = w$5(n2), a2 = p$6(l2), c2 = f$8(n2), s2 = "y" === i2, u2 = o2.x + o2.width / 2 - r2.width / 2, m2 = o2.y + o2.height / 2 - r2.height / 2, y2 = o2[a2] / 2 - r2[a2] / 2;
    let g2;
    switch(c2){
        case "top":
            g2 = {
                x: u2,
                y: o2.y - r2.height
            };
            break;
        case "bottom":
            g2 = {
                x: u2,
                y: o2.y + o2.height
            };
            break;
        case "right":
            g2 = {
                x: o2.x + o2.width,
                y: m2
            };
            break;
        case "left":
            g2 = {
                x: o2.x - r2.width,
                y: m2
            };
            break;
        default:
            g2 = {
                x: o2.x,
                y: o2.y
            };
    }
    switch(d$b(n2)){
        case "start":
            g2[l2] -= y2 * (e2 && s2 ? -1 : 1);
            break;
        case "end":
            g2[l2] += y2 * (e2 && s2 ? -1 : 1);
    }
    return g2;
}
async function P$4(t2, n2) {
    var e2;
    void 0 === n2 && (n2 = {});
    const { x: o2, y: r2, platform: i2, rects: l2, elements: a2, strategy: c2 } = t2, { boundary: s2 = "clippingAncestors", rootBoundary: f2 = "viewport", elementContext: d2 = "floating", altBoundary: m2 = false, padding: p2 = 0 } = u$8(n2, t2), y2 = function(t3) {
        return "number" != typeof t3 ? function(t4) {
            return __spreadValues$1({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }, t4);
        }(t3) : {
            top: t3,
            right: t3,
            bottom: t3,
            left: t3
        };
    }(p2), h2 = a2[m2 ? "floating" === d2 ? "reference" : "floating" : d2], w2 = F$2(await i2.getClippingRect({
        element: null == (e2 = await (null == i2.isElement ? void 0 : i2.isElement(h2))) || e2 ? h2 : h2.contextElement || await (null == i2.getDocumentElement ? void 0 : i2.getDocumentElement(a2.floating)),
        boundary: s2,
        rootBoundary: f2,
        strategy: c2
    })), g2 = "floating" === d2 ? {
        x: o2,
        y: r2,
        width: l2.floating.width,
        height: l2.floating.height
    } : l2.reference, v2 = await (null == i2.getOffsetParent ? void 0 : i2.getOffsetParent(a2.floating)), x2 = await (null == i2.isElement ? void 0 : i2.isElement(v2)) && await (null == i2.getScale ? void 0 : i2.getScale(v2)) || {
        x: 1,
        y: 1
    }, b2 = F$2(i2.convertOffsetParentRelativeRectToViewportRelativeRect ? await i2.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: a2,
        rect: g2,
        offsetParent: v2,
        strategy: c2
    }) : g2);
    return {
        top: (w2.top - b2.top + y2.top) / x2.y,
        bottom: (b2.bottom - w2.bottom + y2.bottom) / x2.y,
        left: (w2.left - b2.left + y2.left) / x2.x,
        right: (b2.right - w2.right + y2.right) / x2.x
    };
}
const C$2 = /* @__PURE__ */ new Set([
    "left",
    "top"
]);
function T$3() {
    return "undefined" != typeof window;
}
function D$5(t2) {
    return z$4(t2) ? (t2.nodeName || "").toLowerCase() : "#document";
}
function M$4(t2) {
    var n2;
    return (null == t2 || null == (n2 = t2.ownerDocument) ? void 0 : n2.defaultView) || window;
}
function O$4(t2) {
    var n2;
    return null == (n2 = (z$4(t2) ? t2.ownerDocument : t2.document) || window.document) ? void 0 : n2.documentElement;
}
function z$4(t2) {
    return !!T$3() && (t2 instanceof Node || t2 instanceof M$4(t2).Node);
}
function L$3(t2) {
    return !!T$3() && (t2 instanceof Element || t2 instanceof M$4(t2).Element);
}
function B$3(t2) {
    return !!T$3() && (t2 instanceof HTMLElement || t2 instanceof M$4(t2).HTMLElement);
}
function E$3(t2) {
    return !(!T$3() || "undefined" == typeof ShadowRoot) && (t2 instanceof ShadowRoot || t2 instanceof M$4(t2).ShadowRoot);
}
const I$2 = /* @__PURE__ */ new Set([
    "inline",
    "contents"
]);
function N$3(t2) {
    const { overflow: n2, overflowX: e2, overflowY: o2, display: r2 } = K$1(t2);
    return /auto|scroll|overlay|hidden|clip/.test(n2 + o2 + e2) && !I$2.has(r2);
}
const j$6 = /* @__PURE__ */ new Set([
    "table",
    "td",
    "th"
]);
function q$2(t2) {
    return j$6.has(D$5(t2));
}
const H$3 = [
    ":popover-open",
    ":modal"
];
function $$2(t2) {
    return H$3.some((n2)=>{
        try {
            return t2.matches(n2);
        } catch (t3) {
            return false;
        }
    });
}
const V$4 = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective"
], W$4 = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective",
    "filter"
], X$1 = [
    "paint",
    "layout",
    "strict",
    "content"
];
function Y$1(t2) {
    const n2 = _$5(), e2 = L$3(t2) ? K$1(t2) : t2;
    return V$4.some((t3)=>!!e2[t3] && "none" !== e2[t3]) || !!e2.containerType && "normal" !== e2.containerType || !n2 && !!e2.backdropFilter && "none" !== e2.backdropFilter || !n2 && !!e2.filter && "none" !== e2.filter || W$4.some((t3)=>(e2.willChange || "").includes(t3)) || X$1.some((t3)=>(e2.contain || "").includes(t3));
}
function _$5() {
    return !("undefined" == typeof CSS || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
const G$2 = /* @__PURE__ */ new Set([
    "html",
    "body",
    "#document"
]);
function J$1(t2) {
    return G$2.has(D$5(t2));
}
function K$1(t2) {
    return M$4(t2).getComputedStyle(t2);
}
function Q$1(t2) {
    return L$3(t2) ? {
        scrollLeft: t2.scrollLeft,
        scrollTop: t2.scrollTop
    } : {
        scrollLeft: t2.scrollX,
        scrollTop: t2.scrollY
    };
}
function U$1(t2) {
    if ("html" === D$5(t2)) return t2;
    const n2 = t2.assignedSlot || t2.parentNode || E$3(t2) && t2.host || O$4(t2);
    return E$3(n2) ? n2.host : n2;
}
function Z$1(t2) {
    const n2 = U$1(t2);
    return J$1(n2) ? t2.ownerDocument ? t2.ownerDocument.body : t2.body : B$3(n2) && N$3(n2) ? n2 : Z$1(n2);
}
function tt$1(t2, n2, e2) {
    var o2;
    void 0 === n2 && (n2 = []), void 0 === e2 && (e2 = true);
    const r2 = Z$1(t2), i2 = r2 === (null == (o2 = t2.ownerDocument) ? void 0 : o2.body), l2 = M$4(r2);
    if (i2) {
        const t3 = nt$1(l2);
        return n2.concat(l2, l2.visualViewport || [], N$3(r2) ? r2 : [], t3 && e2 ? tt$1(t3) : []);
    }
    return n2.concat(r2, tt$1(r2, [], e2));
}
function nt$1(t2) {
    return t2.parent && Object.getPrototypeOf(t2.parent) ? t2.frameElement : null;
}
function et$1(t2) {
    const n2 = K$1(t2);
    let e2 = parseFloat(n2.width) || 0, o2 = parseFloat(n2.height) || 0;
    const i2 = B$3(t2), l2 = i2 ? t2.offsetWidth : e2, a2 = i2 ? t2.offsetHeight : o2, c2 = r$9(e2) !== l2 || r$9(o2) !== a2;
    return c2 && (e2 = l2, o2 = a2), {
        width: e2,
        height: o2,
        $: c2
    };
}
function ot$1(t2) {
    return L$3(t2) ? t2 : t2.contextElement;
}
function rt$1(t2) {
    const n2 = ot$1(t2);
    if (!B$3(n2)) return l$h(1);
    const e2 = n2.getBoundingClientRect(), { width: o2, height: i2, $: a2 } = et$1(n2);
    let c2 = (a2 ? r$9(e2.width) : e2.width) / o2, s2 = (a2 ? r$9(e2.height) : e2.height) / i2;
    return c2 && Number.isFinite(c2) || (c2 = 1), s2 && Number.isFinite(s2) || (s2 = 1), {
        x: c2,
        y: s2
    };
}
const it$1 = l$h(0);
function lt$1(t2) {
    const n2 = M$4(t2);
    return _$5() && n2.visualViewport ? {
        x: n2.visualViewport.offsetLeft,
        y: n2.visualViewport.offsetTop
    } : it$1;
}
function at$1(t2, n2, e2, o2) {
    void 0 === n2 && (n2 = false), void 0 === e2 && (e2 = false);
    const r2 = t2.getBoundingClientRect(), i2 = ot$1(t2);
    let a2 = l$h(1);
    n2 && (o2 ? L$3(o2) && (a2 = rt$1(o2)) : a2 = rt$1(t2));
    const c2 = function(t3, n3, e3) {
        return void 0 === n3 && (n3 = false), !(!e3 || n3 && e3 !== M$4(t3)) && n3;
    }(i2, e2, o2) ? lt$1(i2) : l$h(0);
    let s2 = (r2.left + c2.x) / a2.x, u2 = (r2.top + c2.y) / a2.y, f2 = r2.width / a2.x, d2 = r2.height / a2.y;
    if (i2) {
        const t3 = M$4(i2), n3 = o2 && L$3(o2) ? M$4(o2) : o2;
        let e3 = t3, r3 = nt$1(e3);
        for(; r3 && o2 && n3 !== e3;){
            const t4 = rt$1(r3), n4 = r3.getBoundingClientRect(), o3 = K$1(r3), i3 = n4.left + (r3.clientLeft + parseFloat(o3.paddingLeft)) * t4.x, l2 = n4.top + (r3.clientTop + parseFloat(o3.paddingTop)) * t4.y;
            s2 *= t4.x, u2 *= t4.y, f2 *= t4.x, d2 *= t4.y, s2 += i3, u2 += l2, e3 = M$4(r3), r3 = nt$1(e3);
        }
    }
    return F$2({
        width: f2,
        height: d2,
        x: s2,
        y: u2
    });
}
function ct$1(t2, n2) {
    const e2 = Q$1(t2).scrollLeft;
    return n2 ? n2.left + e2 : at$1(O$4(t2)).left + e2;
}
function st$1(t2, n2) {
    const e2 = t2.getBoundingClientRect();
    return {
        x: e2.left + n2.scrollLeft - ct$1(t2, e2),
        y: e2.top + n2.scrollTop
    };
}
const ut$1 = /* @__PURE__ */ new Set([
    "absolute",
    "fixed"
]);
function ft$1(t2, n2, e2) {
    let r2;
    if ("viewport" === n2) r2 = function(t3, n3) {
        const e3 = M$4(t3), o2 = O$4(t3), r3 = e3.visualViewport;
        let i2 = o2.clientWidth, l2 = o2.clientHeight, a2 = 0, c2 = 0;
        if (r3) {
            i2 = r3.width, l2 = r3.height;
            const t4 = _$5();
            (!t4 || t4 && "fixed" === n3) && (a2 = r3.offsetLeft, c2 = r3.offsetTop);
        }
        const s2 = ct$1(o2);
        if (s2 <= 0) {
            const t4 = o2.ownerDocument, n4 = t4.body, e4 = getComputedStyle(n4), r4 = "CSS1Compat" === t4.compatMode && parseFloat(e4.marginLeft) + parseFloat(e4.marginRight) || 0, l3 = Math.abs(o2.clientWidth - n4.clientWidth - r4);
            l3 <= 25 && (i2 -= l3);
        } else s2 <= 25 && (i2 += s2);
        return {
            width: i2,
            height: l2,
            x: a2,
            y: c2
        };
    }(t2, e2);
    else if ("document" === n2) r2 = function(t3) {
        const n3 = O$4(t3), e3 = Q$1(t3), r3 = t3.ownerDocument.body, i2 = o$a(n3.scrollWidth, n3.clientWidth, r3.scrollWidth, r3.clientWidth), l2 = o$a(n3.scrollHeight, n3.clientHeight, r3.scrollHeight, r3.clientHeight);
        let a2 = -e3.scrollLeft + ct$1(t3);
        const c2 = -e3.scrollTop;
        return "rtl" === K$1(r3).direction && (a2 += o$a(n3.clientWidth, r3.clientWidth) - i2), {
            width: i2,
            height: l2,
            x: a2,
            y: c2
        };
    }(O$4(t2));
    else if (L$3(n2)) r2 = function(t3, n3) {
        const e3 = at$1(t3, true, "fixed" === n3), o2 = e3.top + t3.clientTop, r3 = e3.left + t3.clientLeft, i2 = B$3(t3) ? rt$1(t3) : l$h(1);
        return {
            width: t3.clientWidth * i2.x,
            height: t3.clientHeight * i2.y,
            x: r3 * i2.x,
            y: o2 * i2.y
        };
    }(n2, e2);
    else {
        const e3 = lt$1(t2);
        r2 = {
            x: n2.x - e3.x,
            y: n2.y - e3.y,
            width: n2.width,
            height: n2.height
        };
    }
    return F$2(r2);
}
function dt$1(t2, n2) {
    const e2 = U$1(t2);
    return !(e2 === n2 || !L$3(e2) || J$1(e2)) && ("fixed" === K$1(e2).position || dt$1(e2, n2));
}
function mt$1(t2, n2, e2) {
    const o2 = B$3(n2), r2 = O$4(n2), i2 = "fixed" === e2, a2 = at$1(t2, true, i2, n2);
    let c2 = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const s2 = l$h(0);
    function u2() {
        s2.x = ct$1(r2);
    }
    if (o2 || !o2 && !i2) {
        if (("body" !== D$5(n2) || N$3(r2)) && (c2 = Q$1(n2)), o2) {
            const t3 = at$1(n2, true, i2, n2);
            s2.x = t3.x + n2.clientLeft, s2.y = t3.y + n2.clientTop;
        } else r2 && u2();
    }
    i2 && !o2 && r2 && u2();
    const f2 = !r2 || o2 || i2 ? l$h(0) : st$1(r2, c2);
    return {
        x: a2.left + c2.scrollLeft - s2.x - f2.x,
        y: a2.top + c2.scrollTop - s2.y - f2.y,
        width: a2.width,
        height: a2.height
    };
}
function pt$1(t2) {
    return "static" === K$1(t2).position;
}
function yt$1(t2, n2) {
    if (!B$3(t2) || "fixed" === K$1(t2).position) return null;
    if (n2) return n2(t2);
    let e2 = t2.offsetParent;
    return O$4(t2) === e2 && (e2 = e2.ownerDocument.body), e2;
}
function ht$1(t2, n2) {
    const e2 = M$4(t2);
    if ($$2(t2)) return e2;
    if (!B$3(t2)) {
        let n3 = U$1(t2);
        for(; n3 && !J$1(n3);){
            if (L$3(n3) && !pt$1(n3)) return n3;
            n3 = U$1(n3);
        }
        return e2;
    }
    let o2 = yt$1(t2, n2);
    for(; o2 && q$2(o2) && pt$1(o2);)o2 = yt$1(o2, n2);
    return o2 && J$1(o2) && pt$1(o2) && !Y$1(o2) ? e2 : o2 || function(t3) {
        let n3 = U$1(t3);
        for(; B$3(n3) && !J$1(n3);){
            if (Y$1(n3)) return n3;
            if ($$2(n3)) return null;
            n3 = U$1(n3);
        }
        return null;
    }(t2) || e2;
}
const wt$1 = {
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t2) {
        let { elements: n2, rect: e2, offsetParent: o2, strategy: r2 } = t2;
        const i2 = "fixed" === r2, a2 = O$4(o2), c2 = !!n2 && $$2(n2.floating);
        if (o2 === a2 || c2 && i2) return e2;
        let s2 = {
            scrollLeft: 0,
            scrollTop: 0
        }, u2 = l$h(1);
        const f2 = l$h(0), d2 = B$3(o2);
        if ((d2 || !d2 && !i2) && (("body" !== D$5(o2) || N$3(a2)) && (s2 = Q$1(o2)), B$3(o2))) {
            const t3 = at$1(o2);
            u2 = rt$1(o2), f2.x = t3.x + o2.clientLeft, f2.y = t3.y + o2.clientTop;
        }
        const m2 = !a2 || d2 || i2 ? l$h(0) : st$1(a2, s2);
        return {
            width: e2.width * u2.x,
            height: e2.height * u2.y,
            x: e2.x * u2.x - s2.scrollLeft * u2.x + f2.x + m2.x,
            y: e2.y * u2.y - s2.scrollTop * u2.y + f2.y + m2.y
        };
    },
    getDocumentElement: O$4,
    getClippingRect: function(t2) {
        let { element: n2, boundary: r2, rootBoundary: i2, strategy: l2 } = t2;
        const a2 = [
            ..."clippingAncestors" === r2 ? $$2(n2) ? [] : function(t3, n3) {
                const e2 = n3.get(t3);
                if (e2) return e2;
                let o2 = tt$1(t3, [], false).filter((t4)=>L$3(t4) && "body" !== D$5(t4)), r3 = null;
                const i3 = "fixed" === K$1(t3).position;
                let l3 = i3 ? U$1(t3) : t3;
                for(; L$3(l3) && !J$1(l3);){
                    const n4 = K$1(l3), e3 = Y$1(l3);
                    e3 || "fixed" !== n4.position || (r3 = null), (i3 ? !e3 && !r3 : !e3 && "static" === n4.position && r3 && ut$1.has(r3.position) || N$3(l3) && !e3 && dt$1(t3, l3)) ? o2 = o2.filter((t4)=>t4 !== l3) : r3 = n4, l3 = U$1(l3);
                }
                return n3.set(t3, o2), o2;
            }(n2, this._c) : [].concat(r2),
            i2
        ], c2 = a2.reduce((t3, r3)=>{
            const i3 = ft$1(n2, r3, l2);
            return t3.top = o$a(i3.top, t3.top), t3.right = e$7(i3.right, t3.right), t3.bottom = e$7(i3.bottom, t3.bottom), t3.left = o$a(i3.left, t3.left), t3;
        }, ft$1(n2, a2[0], l2));
        return {
            width: c2.right - c2.left,
            height: c2.bottom - c2.top,
            x: c2.left,
            y: c2.top
        };
    },
    getOffsetParent: ht$1,
    getElementRects: async function(t2) {
        const n2 = this.getOffsetParent || ht$1, e2 = this.getDimensions, o2 = await e2(t2.floating);
        return {
            reference: mt$1(t2.reference, await n2(t2.floating), t2.strategy),
            floating: {
                x: 0,
                y: 0,
                width: o2.width,
                height: o2.height
            }
        };
    },
    getClientRects: function(t2) {
        return Array.from(t2.getClientRects());
    },
    getDimensions: function(t2) {
        const { width: n2, height: e2 } = et$1(t2);
        return {
            width: n2,
            height: e2
        };
    },
    getScale: rt$1,
    isElement: L$3,
    isRTL: function(t2) {
        return "rtl" === K$1(t2).direction;
    }
};
function gt$1(t2, n2) {
    return t2.x === n2.x && t2.y === n2.y && t2.width === n2.width && t2.height === n2.height;
}
function vt$1(t2, n2, r2, l2) {
    void 0 === l2 && (l2 = {});
    const { ancestorScroll: a2 = true, ancestorResize: c2 = true, elementResize: s2 = "function" == typeof ResizeObserver, layoutShift: u2 = "function" == typeof IntersectionObserver, animationFrame: f2 = false } = l2, d2 = ot$1(t2), m2 = a2 || c2 ? [
        ...d2 ? tt$1(d2) : [],
        ...tt$1(n2)
    ] : [];
    m2.forEach((t3)=>{
        a2 && t3.addEventListener("scroll", r2, {
            passive: true
        }), c2 && t3.addEventListener("resize", r2);
    });
    const p2 = d2 && u2 ? function(t3, n3) {
        let r3, l3 = null;
        const a3 = O$4(t3);
        function c3() {
            var t4;
            clearTimeout(r3), null == (t4 = l3) || t4.disconnect(), l3 = null;
        }
        return function s3(u3, f3) {
            void 0 === u3 && (u3 = false), void 0 === f3 && (f3 = 1), c3();
            const d3 = t3.getBoundingClientRect(), { left: m3, top: p3, width: y3, height: h3 } = d3;
            if (u3 || n3(), !y3 || !h3) return;
            const w3 = {
                rootMargin: -i$f(p3) + "px " + -i$f(a3.clientWidth - (m3 + y3)) + "px " + -i$f(a3.clientHeight - (p3 + h3)) + "px " + -i$f(m3) + "px",
                threshold: o$a(0, e$7(1, f3)) || 1
            };
            let g3 = true;
            function v2(n4) {
                const e2 = n4[0].intersectionRatio;
                if (e2 !== f3) {
                    if (!g3) return s3();
                    e2 ? s3(false, e2) : r3 = setTimeout(()=>{
                        s3(false, 1e-7);
                    }, 1e3);
                }
                1 !== e2 || gt$1(d3, t3.getBoundingClientRect()) || s3(), g3 = false;
            }
            try {
                l3 = new IntersectionObserver(v2, __spreadProps(__spreadValues$1({}, w3), {
                    root: a3.ownerDocument
                }));
            } catch (t4) {
                l3 = new IntersectionObserver(v2, w3);
            }
            l3.observe(t3);
        }(true), c3;
    }(d2, r2) : null;
    let y2, h2 = -1, w2 = null;
    s2 && (w2 = new ResizeObserver((t3)=>{
        let [e2] = t3;
        e2 && e2.target === d2 && w2 && (w2.unobserve(n2), cancelAnimationFrame(h2), h2 = requestAnimationFrame(()=>{
            var t4;
            null == (t4 = w2) || t4.observe(n2);
        })), r2();
    }), d2 && !f2 && w2.observe(d2), w2.observe(n2));
    let g2 = f2 ? at$1(t2) : null;
    return f2 && function n3() {
        const e2 = at$1(t2);
        g2 && !gt$1(g2, e2) && r2(), g2 = e2, y2 = requestAnimationFrame(n3);
    }(), r2(), ()=>{
        var t3;
        m2.forEach((t4)=>{
            a2 && t4.removeEventListener("scroll", r2), c2 && t4.removeEventListener("resize", r2);
        }), null == p2 || p2(), null == (t3 = w2) || t3.disconnect(), w2 = null, f2 && cancelAnimationFrame(y2);
    };
}
const xt$1 = function(t2) {
    return void 0 === t2 && (t2 = 0), {
        name: "offset",
        options: t2,
        async fn (n2) {
            var e2, o2;
            const { x: r2, y: i2, placement: l2, middlewareData: a2 } = n2, c2 = await async function(t3, n3) {
                const { placement: e3, platform: o3, elements: r3 } = t3, i3 = await (null == o3.isRTL ? void 0 : o3.isRTL(r3.floating)), l3 = f$8(e3), a3 = d$b(e3), c3 = "y" === h$a(e3), s2 = C$2.has(l3) ? -1 : 1, m2 = i3 && c3 ? -1 : 1, p2 = u$8(n3, t3);
                let { mainAxis: y2, crossAxis: w2, alignmentAxis: g2 } = "number" == typeof p2 ? {
                    mainAxis: p2,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: p2.mainAxis || 0,
                    crossAxis: p2.crossAxis || 0,
                    alignmentAxis: p2.alignmentAxis
                };
                return a3 && "number" == typeof g2 && (w2 = "end" === a3 ? -1 * g2 : g2), c3 ? {
                    x: w2 * m2,
                    y: y2 * s2
                } : {
                    x: y2 * s2,
                    y: w2 * m2
                };
            }(n2, t2);
            return l2 === (null == (e2 = a2.offset) ? void 0 : e2.placement) && null != (o2 = a2.arrow) && o2.alignmentOffset ? {} : {
                x: r2 + c2.x,
                y: i2 + c2.y,
                data: __spreadProps(__spreadValues$1({}, c2), {
                    placement: l2
                })
            };
        }
    };
}, bt$1 = function(t2) {
    return void 0 === t2 && (t2 = {}), {
        name: "autoPlacement",
        options: t2,
        async fn (e2) {
            var o2, r2, i2;
            const { rects: l2, middlewareData: a2, placement: c2, platform: s2, elements: m2 } = e2, _a = u$8(t2, e2), { crossAxis: p2 = false, alignment: y2, allowedPlacements: h2 = n$n, autoAlignment: w2 = true } = _a, x2 = __objRest(_a, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]), b2 = void 0 !== y2 || h2 === n$n ? function(t3, n2, e3) {
                return (t3 ? [
                    ...e3.filter((n3)=>d$b(n3) === t3),
                    ...e3.filter((n3)=>d$b(n3) !== t3)
                ] : e3.filter((t4)=>f$8(t4) === t4)).filter((e4)=>!t3 || d$b(e4) === t3 || !!n2 && v$4(e4) !== e4);
            }(y2 || null, w2, h2) : h2, A2 = await P$4(e2, x2), S2 = (null == (o2 = a2.autoPlacement) ? void 0 : o2.index) || 0, R2 = b2[S2];
            if (null == R2) return {};
            const F2 = g$7(R2, l2, await (null == s2.isRTL ? void 0 : s2.isRTL(m2.floating)));
            if (c2 !== R2) return {
                reset: {
                    placement: b2[0]
                }
            };
            const k2 = [
                A2[f$8(R2)],
                A2[F2[0]],
                A2[F2[1]]
            ], C2 = [
                ...(null == (r2 = a2.autoPlacement) ? void 0 : r2.overflows) || [],
                {
                    placement: R2,
                    overflows: k2
                }
            ], T2 = b2[S2 + 1];
            if (T2) return {
                data: {
                    index: S2 + 1,
                    overflows: C2
                },
                reset: {
                    placement: T2
                }
            };
            const D2 = C2.map((t3)=>{
                const n2 = d$b(t3.placement);
                return [
                    t3.placement,
                    n2 && p2 ? t3.overflows.slice(0, 2).reduce((t4, n3)=>t4 + n3, 0) : t3.overflows[0],
                    t3.overflows
                ];
            }).sort((t3, n2)=>t3[1] - n2[1]), M2 = (null == (i2 = D2.filter((t3)=>t3[2].slice(0, d$b(t3[0]) ? 2 : 3).every((t4)=>t4 <= 0))[0]) ? void 0 : i2[0]) || D2[0][0];
            return M2 !== c2 ? {
                data: {
                    index: S2 + 1,
                    overflows: C2
                },
                reset: {
                    placement: M2
                }
            } : {};
        }
    };
}, At$1 = function(t2) {
    return void 0 === t2 && (t2 = {}), {
        name: "shift",
        options: t2,
        async fn (n2) {
            const { x: e2, y: o2, placement: r2 } = n2, _a = u$8(t2, n2), { mainAxis: i2 = true, crossAxis: l2 = false, limiter: a2 = {
                fn: (t3)=>{
                    let { x: n3, y: e3 } = t3;
                    return {
                        x: n3,
                        y: e3
                    };
                }
            } } = _a, c2 = __objRest(_a, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]), d2 = {
                x: e2,
                y: o2
            }, p2 = await P$4(n2, c2), y2 = h$a(f$8(r2)), w2 = m$5(y2);
            let g2 = d2[w2], v2 = d2[y2];
            i2 && (g2 = s$j(g2 + p2["y" === w2 ? "top" : "left"], g2, g2 - p2["y" === w2 ? "bottom" : "right"])), l2 && (v2 = s$j(v2 + p2["y" === y2 ? "top" : "left"], v2, v2 - p2["y" === y2 ? "bottom" : "right"]));
            const x2 = a2.fn(__spreadProps(__spreadValues$1({}, n2), {
                [w2]: g2,
                [y2]: v2
            }));
            return __spreadProps(__spreadValues$1({}, x2), {
                data: {
                    x: x2.x - e2,
                    y: x2.y - o2,
                    enabled: {
                        [w2]: i2,
                        [y2]: l2
                    }
                }
            });
        }
    };
}, St$1 = function(t2) {
    return void 0 === t2 && (t2 = {}), {
        name: "flip",
        options: t2,
        async fn (n2) {
            var e2, o2;
            const { placement: r2, middlewareData: i2, rects: l2, initialPlacement: a2, platform: c2, elements: s2 } = n2, _a = u$8(t2, n2), { mainAxis: m2 = true, crossAxis: p2 = true, fallbackPlacements: y2, fallbackStrategy: w2 = "bestFit", fallbackAxisSideDirection: F2 = "none", flipAlignment: k2 = true } = _a, C2 = __objRest(_a, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            if (null != (e2 = i2.arrow) && e2.alignmentOffset) return {};
            const T2 = f$8(r2), D2 = h$a(a2), M2 = f$8(a2) === a2, O2 = await (null == c2.isRTL ? void 0 : c2.isRTL(s2.floating)), z2 = y2 || (M2 || !k2 ? [
                R$3(a2)
            ] : function(t3) {
                const n3 = R$3(t3);
                return [
                    v$4(t3),
                    n3,
                    v$4(n3)
                ];
            }(a2)), L2 = "none" !== F2;
            !y2 && L2 && z2.push(...function(t3, n3, e3, o3) {
                const r3 = d$b(t3);
                let i3 = function(t4, n4, e4) {
                    switch(t4){
                        case "top":
                        case "bottom":
                            return e4 ? n4 ? b$7 : x$7 : n4 ? x$7 : b$7;
                        case "left":
                        case "right":
                            return n4 ? A$4 : S$5;
                        default:
                            return [];
                    }
                }(f$8(t3), "start" === e3, o3);
                return r3 && (i3 = i3.map((t4)=>t4 + "-" + r3), n3 && (i3 = i3.concat(i3.map(v$4)))), i3;
            }(a2, k2, F2, O2));
            const B2 = [
                a2,
                ...z2
            ], E2 = await P$4(n2, C2), I2 = [];
            let N2 = (null == (o2 = i2.flip) ? void 0 : o2.overflows) || [];
            if (m2 && I2.push(E2[T2]), p2) {
                const t3 = g$7(r2, l2, O2);
                I2.push(E2[t3[0]], E2[t3[1]]);
            }
            if (N2 = [
                ...N2,
                {
                    placement: r2,
                    overflows: I2
                }
            ], !I2.every((t3)=>t3 <= 0)) {
                var j2, q2;
                const t3 = ((null == (j2 = i2.flip) ? void 0 : j2.index) || 0) + 1, n3 = B2[t3];
                if (n3 && ("alignment" !== p2 || D2 === h$a(n3) || N2.every((t4)=>h$a(t4.placement) !== D2 || t4.overflows[0] > 0))) return {
                    data: {
                        index: t3,
                        overflows: N2
                    },
                    reset: {
                        placement: n3
                    }
                };
                let e3 = null == (q2 = N2.filter((t4)=>t4.overflows[0] <= 0).sort((t4, n4)=>t4.overflows[1] - n4.overflows[1])[0]) ? void 0 : q2.placement;
                if (!e3) switch(w2){
                    case "bestFit":
                        {
                            var H2;
                            const t4 = null == (H2 = N2.filter((t5)=>{
                                if (L2) {
                                    const n4 = h$a(t5.placement);
                                    return n4 === D2 || "y" === n4;
                                }
                                return true;
                            }).map((t5)=>[
                                    t5.placement,
                                    t5.overflows.filter((t6)=>t6 > 0).reduce((t6, n4)=>t6 + n4, 0)
                                ]).sort((t5, n4)=>t5[1] - n4[1])[0]) ? void 0 : H2[0];
                            t4 && (e3 = t4);
                            break;
                        }
                    case "initialPlacement":
                        e3 = a2;
                }
                if (r2 !== e3) return {
                    reset: {
                        placement: e3
                    }
                };
            }
            return {};
        }
    };
}, Rt$1 = function(t2) {
    return void 0 === t2 && (t2 = {}), {
        name: "size",
        options: t2,
        async fn (n2) {
            var r2, i2;
            const { placement: l2, rects: a2, platform: c2, elements: s2 } = n2, _a = u$8(t2, n2), { apply: m2 = ()=>{} } = _a, p2 = __objRest(_a, [
                "apply"
            ]), y2 = await P$4(n2, p2), w2 = f$8(l2), g2 = d$b(l2), v2 = "y" === h$a(l2), { width: x2, height: b2 } = a2.floating;
            let A2, S2;
            "top" === w2 || "bottom" === w2 ? (A2 = w2, S2 = g2 === (await (null == c2.isRTL ? void 0 : c2.isRTL(s2.floating)) ? "start" : "end") ? "left" : "right") : (S2 = w2, A2 = "end" === g2 ? "top" : "bottom");
            const R2 = b2 - y2.top - y2.bottom, F2 = x2 - y2.left - y2.right;
            let k2 = e$7(b2 - y2[A2], R2), C2 = e$7(x2 - y2[S2], F2);
            if (null != (r2 = n2.middlewareData.shift) && r2.enabled.x && (C2 = F2), null != (i2 = n2.middlewareData.shift) && i2.enabled.y && (k2 = R2), !n2.middlewareData.shift && !g2) {
                const t3 = o$a(y2.left, 0), n3 = o$a(y2.right, 0), e2 = o$a(y2.top, 0), r3 = o$a(y2.bottom, 0);
                v2 ? C2 = x2 - 2 * (0 !== t3 || 0 !== n3 ? t3 + n3 : o$a(y2.left, y2.right)) : k2 = b2 - 2 * (0 !== e2 || 0 !== r3 ? e2 + r3 : o$a(y2.top, y2.bottom));
            }
            await m2(__spreadProps(__spreadValues$1({}, n2), {
                availableWidth: C2,
                availableHeight: k2
            }));
            const T2 = await c2.getDimensions(s2.floating);
            return x2 !== T2.width || b2 !== T2.height ? {
                reset: {
                    rects: true
                }
            } : {};
        }
    };
}, Ft$1 = (t2, n2, e2)=>{
    const o2 = /* @__PURE__ */ new Map(), r2 = __spreadValues$1({
        platform: wt$1
    }, e2), i2 = __spreadProps(__spreadValues$1({}, r2.platform), {
        _c: o2
    });
    return (async (t3, n3, e3)=>{
        const { placement: o3 = "bottom", strategy: r3 = "absolute", middleware: i3 = [], platform: l2 } = e3, a2 = i3.filter(Boolean), c2 = await (null == l2.isRTL ? void 0 : l2.isRTL(n3));
        let s2 = await l2.getElementRects({
            reference: t3,
            floating: n3,
            strategy: r3
        }), { x: u2, y: f2 } = k$3(s2, o3, c2), d2 = o3, m2 = {}, p2 = 0;
        for(let e4 = 0; e4 < a2.length; e4++){
            const { name: i4, fn: y2 } = a2[e4], { x: h2, y: w2, data: g2, reset: v2 } = await y2({
                x: u2,
                y: f2,
                initialPlacement: o3,
                placement: d2,
                strategy: r3,
                middlewareData: m2,
                rects: s2,
                platform: l2,
                elements: {
                    reference: t3,
                    floating: n3
                }
            });
            u2 = null != h2 ? h2 : u2, f2 = null != w2 ? w2 : f2, m2 = __spreadProps(__spreadValues$1({}, m2), {
                [i4]: __spreadValues$1(__spreadValues$1({}, m2[i4]), g2)
            }), v2 && p2 <= 50 && (p2++, "object" == typeof v2 && (v2.placement && (d2 = v2.placement), v2.rects && (s2 = true === v2.rects ? await l2.getElementRects({
                reference: t3,
                floating: n3,
                strategy: r3
            }) : v2.rects), { x: u2, y: f2 } = k$3(s2, d2, c2)), e4 = -1);
        }
        return {
            x: u2,
            y: f2,
            placement: d2,
            strategy: r3,
            middlewareData: m2
        };
    })(t2, n2, __spreadProps(__spreadValues$1({}, r2), {
        platform: i2
    }));
};
const b$6 = l$t, w$4 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDropdownOpened = (0, $696Z8.createEvent)(this, "marketDropdownOpened", 7), this.marketDropdownClosed = (0, $696Z8.createEvent)(this, "marketDropdownClosed", 7), this.interaction = "click", this.disabled = false, this.expanded = false, this.popoverPlacement = "bottom", this.popoverStrategy = "absolute", this.popoverDistance = 8, this.popoverConstrainWidth = false, this.floatingCleanup = null, this.floatingInitialized = false, this.onMutationObserved = (t3)=>{
            this.ariaAttributes = t3;
        };
    }
    windowClick(t2) {
        this.expanded && !t2.composedPath().includes(this.el) && this.closeDropdown();
    }
    onExpandedChange(t2, e2) {
        t2 !== e2 && (this.expanded ? (this.floatingInitialized || (this.initializeFloating(), this.floatingInitialized = true), this.openDropdown()) : this.closeDropdown());
    }
    syncDisabledState() {
        this.el.querySelectorAll(e$c.map((t2)=>l$s(t2)).join(",")).forEach((t2)=>{
            t2.disabled = this.disabled;
        });
    }
    toggleDropdown() {
        return this.expanded ? this.closeDropdown() : this.openDropdown();
    }
    openDropdown() {
        if (this.expanded) return Promise.resolve();
        const { defaultPrevented: t2 } = this.marketDropdownOpened.emit();
        return t2 || this.expanded || (this.expanded = true), Promise.resolve();
    }
    closeDropdown() {
        if (!this.expanded) return Promise.resolve();
        const { defaultPrevented: t2 } = this.marketDropdownClosed.emit();
        return !t2 && this.expanded && (this.expanded = false), Promise.resolve();
    }
    async updateDropdownPosition() {
        return await this.updateFloatingPosition(), Promise.resolve();
    }
    handleHoverInteractions(t2) {
        "mouseover" !== t2.type && "focus" !== t2.type || this.openDropdown(), "mouseout" !== t2.type && "blur" !== t2.type || this.closeDropdown();
    }
    async handleInteraction(t2) {
        if (this.disabled || "none" === this.interaction) return;
        "click" === this.interaction && "click" === t2.type && this.toggleDropdown(), "click" === this.interaction && t2 instanceof KeyboardEvent && "Enter" === t2.key && this.toggleDropdown(), "hover" === this.interaction && this.handleHoverInteractions(t2);
        const e2 = this.el.querySelector('[slot="trigger"]');
        "persistent" === this.interaction && "click" === t2.type && t2.composedPath().includes(e2) && this.toggleDropdown(), "persistent" === this.interaction && t2 instanceof KeyboardEvent && "Enter" === t2.key && t2.composedPath().includes(e2) && this.toggleDropdown(), t2 instanceof KeyboardEvent && "Escape" === t2.key && this.expanded && (this.closeDropdown(), t2.stopPropagation()), this.floatingInitialized && await this.updateFloatingPosition();
    }
    initializeFloating() {
        const { el: t2, floatingCleanup: e2 } = this;
        e2 && (e2(), this.floatingCleanup = null);
        const i2 = t2, o2 = t2.querySelector('[slot="popover"]');
        if (null === o2) return;
        const s2 = ()=>this.updateFloatingPosition();
        this.floatingCleanup = vt$1(i2, o2, s2), s2();
    }
    async computeAndApplyPosition(t2, e2, i2, o2, s2, n2) {
        e2.style.position = o2;
        const r2 = [
            xt$1({
                mainAxis: n2,
                crossAxis: s2
            }),
            St$1(),
            At$1({
                padding: b$6
            }),
            ...this.popoverConstrainWidth ? [
                Rt$1({
                    padding: b$6,
                    apply: ({ availableWidth: t3, elements: e3 })=>{
                        e3.floating.style.maxWidth = t3 + "px";
                    }
                })
            ] : []
        ], { x: c2, y: m2 } = await Ft$1(t2, e2, {
            placement: i2,
            strategy: o2,
            middleware: r2
        });
        Number.isNaN(c2) || Number.isNaN(m2) || Object.assign(e2.style, {
            left: c2 + "px",
            top: m2 + "px"
        });
    }
    async updateFloatingPosition() {
        const { el: t2, popoverPlacement: e2, popoverStrategy: i2, popoverSkidding: o2, popoverDistance: s2 } = this, n2 = t2, r2 = t2.querySelector('[slot="popover"]');
        null !== r2 && await this.computeAndApplyPosition(n2, r2, e2, i2, o2, s2);
    }
    updatePopoverConfig() {
        this.floatingInitialized && this.updateFloatingPosition();
    }
    connectedCallback() {
        this.el.isConnected && this.expanded && !this.floatingInitialized && (this.initializeFloating(), this.floatingInitialized = true);
    }
    disconnectedCallback() {
        var t2;
        this.el.isConnected || (this.floatingCleanup && (this.floatingCleanup(), this.floatingCleanup = null), null === (t2 = this.mutationObserver) || void 0 === t2 || t2.disconnect(), this.mutationObserver = null, this.floatingInitialized = false);
    }
    registerTrigger() {
        this.slottedTriggerEl = this.el.querySelector(e$c.join(",")), this.syncDisabledState();
    }
    componentWillLoad() {
        this.mutationObserver = a$q(this.el, this.onMutationObserved);
    }
    componentWillRender() {
        if (this.slottedTriggerEl) {
            const t2 = this.el.querySelector('[slot="popover"]');
            t2.id || (t2.id = "popover-" + f$d()), t$7(this.slottedTriggerEl, {
                expanded: "" + this.expanded,
                popoverId: t2.id
            });
        }
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ff9803b02af1fe3d5c2eecd7f0df5e8ff811cddd",
            class: "market-dropdown",
            expanded: this.expanded,
            onClick: (t2)=>{
                this.handleInteraction(t2);
            },
            onmouseover: (t2)=>{
                this.handleInteraction(t2);
            },
            onmouseout: (t2)=>{
                this.handleInteraction(t2);
            },
            onKeyDown: (t2)=>{
                this.handleInteraction(t2);
            },
            onFocus: (t2)=>{
                this.handleInteraction(t2);
            },
            onBlur: (t2)=>{
                this.handleInteraction(t2);
            }
        }, (0, $696Z8.h)("slot", {
            key: "6a1da8e0c8cdea1b4448b7b6a665fb08ccff71d4",
            name: "trigger",
            onSlotchange: ()=>this.registerTrigger()
        }), (0, $696Z8.h)("slot", {
            key: "d07de09116431a59e9e57f1689b5a2f90c124e07",
            name: "popover"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            expanded: [
                {
                    onExpandedChange: 0
                }
            ],
            disabled: [
                {
                    syncDisabledState: 0
                }
            ],
            popoverSkidding: [
                {
                    updatePopoverConfig: 0
                }
            ],
            popoverDistance: [
                {
                    updatePopoverConfig: 0
                }
            ]
        };
    }
    static get style() {
        return ':host{display:inline-block}:host ::slotted([slot="trigger"]){cursor:pointer !important;}:host([interaction="hover"]) ::slotted([slot="trigger"]){cursor:default !important;}:host ::slotted([slot="popover"]){position:fixed;z-index:99999;opacity:0;visibility:hidden !important;pointer-events:none}:host([expanded]) ::slotted([slot="popover"]){opacity:1;visibility:visible !important;pointer-events:auto}:host([expanded]) .\u{1F643}{visibility:hidden}@media (width >= 600px){:host ::slotted(.market-popover){max-width:400px}}';
    }
}, [
    257,
    "market-dropdown",
    {
        interaction: [
            513
        ],
        disabled: [
            516
        ],
        expanded: [
            1540
        ],
        popoverPlacement: [
            1,
            "popover-placement"
        ],
        popoverStrategy: [
            1,
            "popover-strategy"
        ],
        popoverSkidding: [
            2,
            "popover-skidding"
        ],
        popoverDistance: [
            2,
            "popover-distance"
        ],
        popoverConstrainWidth: [
            4,
            "popover-constrain-width"
        ],
        ariaAttributes: [
            32
        ],
        toggleDropdown: [
            64
        ],
        openDropdown: [
            64
        ],
        closeDropdown: [
            64
        ],
        updateDropdownPosition: [
            64
        ]
    },
    [
        [
            8,
            "click",
            "windowClick"
        ]
    ],
    {
        expanded: [
            {
                onExpandedChange: 0
            }
        ],
        disabled: [
            {
                syncDisabledState: 0
            }
        ],
        popoverSkidding: [
            {
                updatePopoverConfig: 0
            }
        ],
        popoverDistance: [
            {
                updatePopoverConfig: 0
            }
        ]
    }
]), y$6 = w$4;
const s$i = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.showActions = false, this.onActionsSlotChange = ()=>{
            this.showActions = !!this.el.querySelector('[slot="actions"]');
        };
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "503ba4c6c3f89ad723fd0d2ff8ea183c5d6fc588",
            class: "market-empty-state"
        }, (0, $696Z8.h)("slot", {
            key: "2ffba474a0de10527dd79c84a3c0a72b8b30f8b4"
        }), (0, $696Z8.h)("slot", {
            key: "ede905db8520585fd9c99a76f67c81c991df5706",
            name: "media"
        }), (0, $696Z8.h)("div", {
            key: "33897ccf78e37663fc64688bafc2e89f74bcb570",
            class: "text"
        }, (0, $696Z8.h)("slot", {
            key: "63870831fb40f06db28cb09502a55b275d0c94a3",
            name: "primary-text"
        }), (0, $696Z8.h)("slot", {
            key: "0561e55a1c1cf6dbc8499ba53a7cdd3ef50262e6",
            name: "secondary-text"
        })), (0, $696Z8.h)("div", {
            key: "e0d84b4fdde1ac9639740ee2734a2660e7fcebaa",
            class: {
                actions: true,
                hidden: !this.showActions
            }
        }, (0, $696Z8.h)("slot", {
            key: "4e6b3a4498ad23b43fd9c542579930ac3d3811c8",
            name: "actions",
            onSlotchange: this.onActionsSlotChange
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;flex-direction:column;gap:var(--empty-state-button-group-vertical-spacing);justify-content:center;align-items:center;width:100%;padding:var(--empty-state-vertical-padding) var(--empty-state-horizontal-padding);border-width:var(--empty-state-border-width);border-style:solid;border-color:var(--empty-state-border-color);border-radius:var(--empty-state-border-radius);background-color:var(--empty-state-background-color)}.text{display:flex;flex-direction:column;gap:var(--empty-state-paragraph-vertical-spacing);width:100%;max-width:var(--empty-state-text-maximum-width, 600px);margin:0 auto;text-align:center}.text ::slotted([slot="primary-text"]),.text ::slotted([slot="secondary-text"]){margin:0;font-family:inherit}.text ::slotted([slot="primary-text"]){color:var(--empty-state-heading-color);font-weight:var(--empty-state-heading-text-weight);font-size:var(--empty-state-heading-text-size);line-height:var(--empty-state-heading-text-leading)}.text ::slotted([slot="secondary-text"]){color:var(--empty-state-paragraph-color);font-weight:var(--empty-state-paragraph-text-weight);font-size:var(--empty-state-paragraph-text-size);line-height:var(--empty-state-paragraph-text-leading)}.actions{display:flex;flex-direction:row;gap:var(--empty-state-actions-spacing, var(--core-metrics-spacing-200));}.actions.hidden{display:none}';
    }
}, [
    257,
    "market-empty-state",
    {
        showActions: [
            32
        ]
    }
]), i$e = s$i;
const l$g = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.readonly = false, this.disabled = false, this.invalid = false, this.errorSlotId = f$d();
    }
    getSlottedInputs() {
        return [
            l$s("market-input-text"),
            l$s("market-input-password"),
            l$s("market-select"),
            l$s("market-textarea"),
            l$s("market-code-input")
        ].flatMap((e2)=>[
                ...this.el.getElementsByTagName(e2)
            ]);
    }
    getErrorSlot() {
        return this.el.querySelector('[slot="error"]');
    }
    getBottomAccessorySlot() {
        return this.el.querySelector('[slot="bottom-accessory"]');
    }
    getInputElAriaDescribedby() {
        const e2 = [];
        return this.getErrorSlot() && e2.push(this.errorSlotId + "-error"), this.getBottomAccessorySlot() && e2.push(this.errorSlotId + "-bottom-accessory"), e2.join(" ");
    }
    handleErrorAttributes() {
        const e2 = this.getErrorSlot();
        e2 && (e2.setAttribute("role", "alert"), e2.setAttribute("id", this.errorSlotId + "-error"));
    }
    handleBottomAccessoryAttributes() {
        const e2 = this.getBottomAccessorySlot();
        e2 && e2.setAttribute("id", this.errorSlotId + "-bottom-accessory");
    }
    render() {
        return this.getSlottedInputs().forEach((e2)=>{
            e2.name = this.name, e2.disabled = this.disabled, e2.invalid = this.invalid, e2.readonly = this.readonly;
            const t2 = this.getInputElAriaDescribedby();
            t2 && e2.setAttribute("aria-describedby", t2);
        }), (0, $696Z8.h)((0, $696Z8.Host), {
            key: "3e65209319f989e74bb4125fbee4782025d88bc6",
            class: "market-field"
        }, (0, $696Z8.h)("slot", {
            key: "d381d75386248eda4ad79baa8444a7fa700bd6a8"
        }), this.invalid && !this.disabled && (0, $696Z8.h)("div", {
            key: "55d107845968c5ac24e69eccff7bb1cfc9debf4b"
        }, (0, $696Z8.h)("slot", {
            key: "e40f3134b79ee21175558731decd72975910bb75",
            name: "error",
            onSlotchange: ()=>this.handleErrorAttributes()
        })), (0, $696Z8.h)("slot", {
            key: "ed942c6d77f567f42a50cc476dc07c29fde9c012",
            name: "bottom-accessory",
            onSlotchange: ()=>this.handleBottomAccessoryAttributes()
        }), (0, $696Z8.h)("slot", {
            key: "8b621f775db23d1536d030a22a1a6b5e2a7acc8c",
            name: "action"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--error-icon-height:16px;--error-icon-width:16px;--error-icon-offset:calc(calc(var(--field-error-message-text-leading) - var(--error-icon-height)) / 2);display:block;text-align:start}::slotted([slot]){margin-top:4px}::slotted([slot="error"]){display:block;color:var(--field-error-message-text-color);font-weight:var(--field-error-message-text-weight);font-size:var(--field-error-message-text-size);line-height:var(--field-error-message-text-leading);letter-spacing:var(--field-error-message-text-tracking)}::slotted([slot="error"])::before{content:"";display:inline-block;vertical-align:calc(-1 * var(--error-icon-offset));width:var(--error-icon-width);height:var(--error-icon-height);margin-right:calc(         var(--field-error-message-icon-padding, 2px) +         var(--field-error-message-icon-margin-right, 4px)       );margin-left:var(--field-error-message-icon-padding, 2px);background-color:var(--field-error-message-text-color);-webkit-mask:url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8 15.5C12.1333 15.5 15.5 12.1333 15.5 8C15.5 3.86667 12.1333 0.5 8 0.5C3.86667 0.5 0.5 3.86667 0.5 8C0.5 12.1333 3.86667 15.5 8 15.5ZM8 2.16667C11.2167 2.16667 13.8333 4.78333 13.8333 8C13.8333 11.2167 11.2167 13.8333 8 13.8333C4.78333 13.8333 2.16667 11.2167 2.16667 8C2.16667 4.78333 4.78333 2.16667 8 2.16667ZM8 12.1667C8.5753 12.1667 9.04167 11.7003 9.04167 11.125C9.04167 10.5497 8.5753 10.0833 8 10.0833C7.4247 10.0833 6.95833 10.5497 6.95833 11.125C6.95833 11.7003 7.4247 12.1667 8 12.1667ZM7.16667 3.83333H8.83333V9.25H7.16667V3.83333Z'/></svg>");mask:url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8 15.5C12.1333 15.5 15.5 12.1333 15.5 8C15.5 3.86667 12.1333 0.5 8 0.5C3.86667 0.5 0.5 3.86667 0.5 8C0.5 12.1333 3.86667 15.5 8 15.5ZM8 2.16667C11.2167 2.16667 13.8333 4.78333 13.8333 8C13.8333 11.2167 11.2167 13.8333 8 13.8333C4.78333 13.8333 2.16667 11.2167 2.16667 8C2.16667 4.78333 4.78333 2.16667 8 2.16667ZM8 12.1667C8.5753 12.1667 9.04167 11.7003 9.04167 11.125C9.04167 10.5497 8.5753 10.0833 8 10.0833C7.4247 10.0833 6.95833 10.5497 6.95833 11.125C6.95833 11.7003 7.4247 12.1667 8 12.1667ZM7.16667 3.83333H8.83333V9.25H7.16667V3.83333Z'/></svg>");-webkit-mask-size:cover;mask-size:cover}::slotted([slot="bottom-accessory"]){display:block;margin:var(--field-helper-text-vertical-spacing) var(--field-helper-text-horizontal-spacing);color:var(--field-helper-text-text-color);font-weight:var(--field-helper-text-weight);font-size:var(--field-helper-text-size);line-height:var(--field-helper-text-leading);letter-spacing:var(--field-helper-text-tracking)}::slotted([slot="action"]){display:block;padding:var(--field-action-vertical-padding-size) 0;color:var(--field-action-text-color);font-weight:var(--field-action-text-weight);font-size:var(--field-action-text-size);line-height:var(--field-action-text-leading);letter-spacing:var(--field-action-text-tracking);text-decoration:none;cursor:pointer}::slotted(button[slot="action"]){padding:0;border:none;background-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}`;
    }
}, [
    257,
    "market-field",
    {
        name: [
            513
        ],
        readonly: [
            516
        ],
        disabled: [
            516
        ],
        invalid: [
            516
        ]
    }
]), n$m = l$g;
const l$f = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketFileUploadValueChange = (0, $696Z8.createEvent)(this, "marketFileUploadValueChange", 7), this.accept = "", this.value = [], this.disabled = false, this.invalid = false, this.multiple = false, this.compact = false, this.deleteButtonAriaLabel = "Delete", this.isDraggingOver = false, this.handleButtonClick = ()=>{
            this.fileInputElement.click();
        };
    }
    watchValueHandler(t2) {
        Array.isArray(t2) && (this.files = this.multiple ? [
            ...t2
        ] : t2.slice(0, 1));
    }
    watchDisabledHandler() {
        this.slottedCompactButtons.forEach((t2)=>t2.disabled = this.disabled);
    }
    get hasSingleFileSelected() {
        return !this.multiple && 1 === this.files.length;
    }
    get slottedCompactButtons() {
        var t2;
        const e2 = /* @__PURE__ */ new Set([
            l$s("market-button"),
            l$s("market-link")
        ]);
        return [
            ...(null === (t2 = this.el.querySelector('[slot="compact-action"]')) || void 0 === t2 ? void 0 : t2.children) || []
        ].filter((t3)=>e2.has(t3.tagName.toLowerCase()));
    }
    draggingOver(t2) {
        this.disabled || this.hasSingleFileSelected || (this.isDraggingOver = true, t2.preventDefault());
    }
    endDrag(t2) {
        t2.preventDefault(), this.disabled || this.hasSingleFileSelected || (this.isDraggingOver = false, "drop" === t2.type && t2.dataTransfer && this.addFiles(t2.dataTransfer.files));
    }
    handleDeleteKeydown(t2, e2) {
        "Enter" !== t2.key || this.disabled || this.removeFile(e2);
    }
    removeFile(t2) {
        this.files.splice(t2, 1), this.files = [
            ...this.files
        ], this.emitFileChange();
    }
    labelContainerClassNames() {
        const t2 = [];
        return this.isDraggingOver && t2.push("is-dragging-over"), this.hasSingleFileSelected && t2.push("has-file-selected"), t2;
    }
    onInputChange(t2) {
        this.addFiles(t2.target.files), this.fileInputElement.value = "";
    }
    addFiles(t2) {
        t2 && (this.files = this.multiple ? [
            ...t2,
            ...this.files
        ] : [
            t2[0]
        ]), this.emitFileChange();
    }
    emitFileChange() {
        this.marketFileUploadValueChange.emit({
            value: this.files
        });
    }
    handleCompactSlotChange() {
        this.slottedCompactButtons.forEach((t2)=>{
            t2.removeEventListener("click", this.handleButtonClick), this.disabled || t2.addEventListener("click", this.handleButtonClick), t2.disabled = this.disabled;
        });
    }
    componentWillLoad() {
        this.files = this.value ? [
            ...this.value
        ] : [];
    }
    componentDidLoad() {
        this.handleCompactSlotChange();
    }
    renderFilesAsMarketRows() {
        const t2 = l$s("market-row"), e2 = l$s("market-accessory"), a2 = l$s("market-icon");
        return this.files.map((r2, i2)=>{
            var s2;
            const l2 = null === (s2 = this.fileMetadata) || void 0 === s2 ? void 0 : s2.find((t3)=>t3.filename === r2.name);
            let n2, c2 = r2.type.startsWith("image/") ? "picture" : "file", d = "delete";
            switch(this.fileSubtext){
                case "size":
                    n2 = ((t3, e3 = 2)=>{
                        if (!Number(t3)) return "0 bytes";
                        const a3 = e3 < 0 ? 0 : e3, o2 = Math.floor(Math.log(t3) / Math.log(1024));
                        return `${Number.parseFloat((t3 / Math.pow(1024, o2)).toFixed(a3))} ${[
                            "bytes",
                            "kB",
                            "MB",
                            "GB",
                            "TB"
                        ][o2]}`;
                    })(r2[this.fileSubtext]);
                    break;
                case "type":
                    n2 = r2[this.fileSubtext];
            }
            switch(null == l2 ? void 0 : l2.status){
                case "error":
                    c2 = "warning", d = "clear", n2 = null == l2 ? void 0 : l2.message;
                    break;
                case "loading":
                    c2 = "loading", d = "clear";
                    break;
                case "success":
                    c2 = "success";
            }
            return c2 = (null == l2 ? void 0 : l2.leadingIconName) || c2, (0, $696Z8.h)(t2, {
                disabled: this.disabled,
                interactive: true,
                transient: true,
                "data-index": i2,
                "data-status": null == l2 ? void 0 : l2.status
            }, (0, $696Z8.h)("label", {
                slot: "label"
            }, r2.name), n2 && (0, $696Z8.h)("p", {
                slot: "subtext"
            }, n2), (0, $696Z8.h)(e2, {
                slot: "leading-accessory",
                size: "image"
            }, (0, $696Z8.h)(a2, {
                name: c2,
                fidelity: 24
            })), (0, $696Z8.h)(e2, {
                slot: "trailing-accessory",
                size: "icon",
                tabindex: this.disabled ? -1 : 0,
                role: "button",
                "aria-label": this.deleteButtonAriaLabel,
                onKeyDown: (t3)=>this.handleDeleteKeydown(t3, i2),
                onClick: ()=>this.removeFile(i2)
            }, (0, $696Z8.h)(a2, {
                name: d,
                fidelity: 24
            })));
        });
    }
    render() {
        const t2 = l$s("market-list"), e2 = l$s("market-accessory"), a2 = l$s("market-icon"), i2 = l$s("market-field"), l2 = l$s("market-button"), n2 = this.renderFilesAsMarketRows(), c2 = this.multiple || 0 === n2.length, d = this.multiple && n2.length > 0;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "3477cde4e2d88b24fd8b078b3987b672e09b2179",
            class: "market-file-upload",
            ondragenter: (t3)=>this.draggingOver(t3),
            ondragover: (t3)=>this.draggingOver(t3),
            ondragleave: (t3)=>this.endDrag(t3),
            ondrop: (t3)=>this.endDrag(t3)
        }, (0, $696Z8.h)(i2, {
            key: "7be988c472e5b012fb120967a890b7f221682f36",
            disabled: this.disabled,
            invalid: this.invalid
        }, (0, $696Z8.h)("div", {
            key: "cb725280b10107b9e5e7410ce61dad145bca0064",
            class: "label-container " + this.labelContainerClassNames()
        }, !c2 && n2[0], c2 && (0, $696Z8.h)("label", {
            key: "de59c1bebbe7859ff2b8129637ad52f5fc7c759d"
        }, (0, $696Z8.h)("slot", {
            key: "b348c75070daf80629ede0371312ed0797037148"
        }, (0, $696Z8.h)(e2, {
            key: "c68ded7f23c541f00bc105c7b6146282a66d9f37",
            size: "image"
        }, (0, $696Z8.h)(a2, {
            key: "26e07dc7c5b7dcb8f8f74ee59b5097c8ae3dd325",
            name: "file",
            fidelity: 24
        })), (0, $696Z8.h)("span", {
            key: "4b34f025a80347850f1c52617fdcd5ef66b075ad"
        }, (0, $696Z8.h)("button", {
            key: "d7f87e336f6f8ed83adf6b99997a8ea6a6b0237b",
            onClick: ()=>this.handleButtonClick()
        }, "Choose a file"), " or drag and drop it here")), (0, $696Z8.h)("slot", {
            key: "87e8254e9166ff2b393dd9d169594a4f9bc057d2",
            name: "compact-action",
            onSlotchange: ()=>this.handleCompactSlotChange()
        }, (0, $696Z8.h)(l2, {
            key: "50328128e85678feca2b007d8134b781ebab8e20",
            rank: "primary",
            disabled: this.disabled,
            onClick: ()=>this.handleButtonClick()
        }, "Upload file")), (0, $696Z8.h)("input", {
            key: "38b858d8904f72ee92b51ad20980a6912b122bef",
            ref: (t3)=>this.fileInputElement = t3,
            onChange: (t3)=>this.onInputChange(t3),
            type: "file",
            name: "files[]",
            multiple: this.multiple,
            accept: this.accept,
            hidden: true
        }))), (0, $696Z8.h)("slot", {
            key: "b1256defe25c20fa1acc0600a527a4ab6060c78a",
            name: "bottom-accessory"
        }, (0, $696Z8.h)("small", {
            key: "17c1a9ff63fb738d177b71646fcc7e0136973d88",
            slot: "bottom-accessory"
        })), (0, $696Z8.h)("slot", {
            key: "a30d9bf4d3644c25b145d831bf4565567c64027a",
            name: "error"
        }, (0, $696Z8.h)("small", {
            key: "ad14576591eacbe03d6ebf4dfadfc89d0e6311a1",
            slot: "error"
        }))), d && (0, $696Z8.h)(t2, {
            key: "297cab39e8d3f1528878e142c30412f1d637eba7",
            interactive: true,
            transient: true
        }, n2));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    watchValueHandler: 0
                }
            ],
            disabled: [
                {
                    watchDisabledHandler: 0
                }
            ]
        };
    }
    static get style() {
        return ':root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}button,.market-button,::slotted(button),::slotted(.market-button),::slotted(.market-link){font-weight:var(--core-type-semibold-30-weight);font-size:var(--core-type-semibold-30-size);font-family:var(--core-type-semibold-30-font-family);line-height:var(--core-type-semibold-30-leading);letter-spacing:var(--core-type-semibold-30-tracking);text-transform:var(--core-type-semibold-30-case)}.label-container{border-width:var(--file-upload-border-width, 1px);border-style:var(--file-upload-normal-state-border-style, dashed);border-color:var(--file-upload-normal-state-border-color, var(--core-fill-30-color));border-radius:var(--file-upload-border-radius, 6px);transition:background-color border-color var(--core-animation-enter-transition-moderate-speed-duration)}.label-container>label{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:var(--file-upload-dropzone-vertical-padding, var(--core-metrics-spacing-400))       var(--file-upload-dropzone-horizontal-padding, var(--core-metrics-spacing-400));text-align:center;cursor:pointer}.label-container>label .market-icon{color:var(--file-upload-label-fill-color, var(--core-text-10-color))}.label-container>.market-row{margin:0}button,.market-button,::slotted(button),::slotted(.market-button),::slotted(.market-link){padding:0}slot:not([name="compact-action"]) button,slot:not([name="compact-action"]) .market-button,slot:not([name="compact-action"]) ::slotted(button),slot:not([name="compact-action"]) ::slotted(.market-button),slot:not([name="compact-action"]) ::slotted(.market-link){border:none;background-color:inherit;color:var(--file-upload-button-label-color, var(--button-normal-variant-tertiary-rank-normal-state-label-color));font-family:inherit;text-align:right;cursor:pointer}slot:not([name="compact-action"]) button,slot:not([name="compact-action"]) ::slotted(button){border-radius:1px;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:2px}.has-file-selected{border-style:var(--file-upload-file-selected-state-border-style, solid) !important;border-color:var(--file-upload-file-selected-state-border-color, var(--core-fill-30-color))}@media (hover: hover){:host(:hover) .label-container{border-style:var(--file-upload-hover-state-border-style, dashed);border-color:var(--file-upload-hover-state-border-color, var(--core-emphasis-fill-color));background-color:var(--file-upload-hover-state-background-color, var(--core-emphasis-40-color))}}:host(:active) .label-container,:host(:active) .is-dragging-over{border-style:var(--file-upload-active-state-border-style, dashed);border-color:var(--file-upload-active-state-border-color, var(--core-emphasis-fill-color));background-color:var(--file-upload-active-state-background-color, var(--core-emphasis-30-color))}:host([disabled]) .label-container{border-style:var(--file-upload-disabled-state-border-style, dashed);border-color:var(--file-upload-disabled-state-border-color, var(--field-disabled-state-border-color));background-color:var(--file-upload-disabled-state-background-color, var(--field-disabled-state-background-color));color:var(--file-upload-disabled-state-label-color, var(--field-disabled-state-empty-phase-label-color))}:host([disabled]) button,:host([disabled]) ::slotted(button),:host([disabled]) ::slotted(.market-button),:host([disabled]) ::slotted(.market-icon),:host([disabled]) ::slotted(.market-link),:host([disabled]) label .market-icon,:host([disabled]) label ::slotted(.market-icon){opacity:0.3}slot[name="compact-action"]{display:none}:host([compact]) slot[name="compact-action"]{display:block;width:100%}:host([compact]) slot:not([name="compact-action"]){display:none}:host([compact]) .label-container{border-style:unset;border-color:unset;background-color:unset}:host([compact]) .label-container>label{padding:0}:host([compact]) .market-button,:host([compact]) .market-link,:host([compact]) ::slotted(.market-button),:host([compact]) ::slotted(.market-link){width:100%}.market-list{margin-top:var(--file-upload-dropzone-vertical-margin, var(--core-metrics-spacing-100))}.market-accessory[slot="leading-accessory"]{border-radius:var(--file-upload-border-radius, 6px);background-color:var(--file-upload-leading-accessory-background-color, var(--core-fill-40-color))}.market-accessory[slot="trailing-accessory"]{cursor:pointer}.market-accessory[slot="trailing-accessory"] .market-icon{color:var(--file-upload-delete-fill-color, var(--core-fill-20-color))}[data-status]:not([data-status=""]) .market-accessory[slot="leading-accessory"]{background-color:unset}[data-status="error"] [slot="subtext"],[data-status="error"] .market-accessory[slot="leading-accessory"]{color:var(--file-upload-leading-accessory-error-color, var(--core-critical-fill-color))}:host([disabled]) [data-status="error"] [slot="subtext"]{opacity:0.3}[data-status="success"] .market-accessory[slot="leading-accessory"]{color:var(--file-upload-leading-accessory-success-color, var(--core-success-fill-color))}[data-status="loading"] .market-accessory[slot="leading-accessory"]{animation:market-file-upload-loading-rotation     var(--animation-infinite-duration)     var(--animation-infinite-iteration-count)     var(--animation-infinite-timing-function)}:host([invalid]) .label-container{border-color:var(--field-normal-state-invalid-validity-border-color)}::slotted([slot="bottom-accessory"]){color:var(--core-text-20-color)}';
    }
}, [
    257,
    "market-file-upload",
    {
        accept: [
            1
        ],
        value: [
            16
        ],
        disabled: [
            516
        ],
        invalid: [
            516
        ],
        multiple: [
            516
        ],
        compact: [
            516
        ],
        fileSubtext: [
            1,
            "file-subtext"
        ],
        fileMetadata: [
            16
        ],
        deleteButtonAriaLabel: [
            513,
            "delete-button-aria-label"
        ],
        isDraggingOver: [
            32
        ],
        files: [
            32
        ]
    },
    void 0,
    {
        value: [
            {
                watchValueHandler: 0
            }
        ],
        disabled: [
            {
                watchDisabledHandler: 0
            }
        ]
    }
]), n$l = l$f;
var o$9;
function n$k(r2) {
    return "" === r2 || null == r2 || Array.isArray(r2) && 0 === r2.length;
}
function a$h(r2) {
    var o2;
    if (!r2) return false;
    const n2 = null === (o2 = r2.tagName) || void 0 === o2 ? void 0 : o2.toLocaleLowerCase();
    return [
        l$s("market-checkbox").toLocaleLowerCase(),
        l$s("market-radio").toLocaleLowerCase(),
        l$s("market-toggle").toLocaleLowerCase()
    ].includes(n2);
}
function e$6(t2) {
    if (!t2.interactive || "drill" === t2.variant || Boolean(t2.href) || t2.interactive && t2.transient) return;
    const n2 = t2.querySelector('[slot="control"]');
    return n2 ? i$n(n2, "market-checkbox") ? o$9.CHECKBOX : i$n(n2, "market-radio") ? o$9.RADIO : i$n(n2, "market-toggle") ? o$9.SWITCH : void 0 : o$9.SELECTABLE_WITHOUT_CONTROL;
}
function i$d(n2) {
    if (i$n(n2, "market-action-card")) {
        const r2 = n2.querySelector(l$s("market-row"));
        return r2 ? e$6(r2) : o$9.SELECTABLE_WITHOUT_CONTROL;
    }
    if (i$n(n2, "market-row")) return e$6(n2);
}
!function(r2) {
    r2[r2.RADIO = 0] = "RADIO", r2[r2.CHECKBOX = 1] = "CHECKBOX", r2[r2.SWITCH = 2] = "SWITCH", r2[r2.SELECTABLE_WITHOUT_CONTROL = 3] = "SELECTABLE_WITHOUT_CONTROL";
}(o$9 || (o$9 = {}));
const u$7 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketFilterClosed = (0, $696Z8.createEvent)(this, "marketFilterClosed", 7), this.marketFilterOpened = (0, $696Z8.createEvent)(this, "marketFilterOpened", 7), this.marketFilterExpandedChanged = (0, $696Z8.createEvent)(this, "marketFilterExpandedChanged", 7), this.marketFilterValueDidChange = (0, $696Z8.createEvent)(this, "marketFilterValueDidChange", 7), this.focused = false, this.size = "medium", this.expanded = false, this.popoverPlacement = "bottom-start", this.popoverStrategy = "absolute", this.rowObservers = [], this.listValueObserver = null;
    }
    async getFilterType() {
        return Promise.resolve(this.filterType);
    }
    async setFocus(t2 = true) {
        return this.focused = await this.filterButtonEl.setFocus(t2), Promise.resolve(this.focused);
    }
    async __setAndEmitListValue(t2, e2) {
        return this.listEl ? (this.listEl.value = e2, this.marketFilterValueDidChange.emit({
            name: this.name,
            prevValue: null != t2 ? t2 : null,
            value: e2
        }), this.setDisplayValueFromSlottedElement(), Promise.resolve()) : Promise.reject(Error("No list found."));
    }
    async __setAndEmitDatePickerValue(t2) {
        if (!this.datePickerEl) return Promise.reject(Error("No date picker found."));
        const e2 = this.datePickerEl.selectedStartDate, i2 = this.datePickerEl.selectedEndDate, s2 = null == t2 ? void 0 : t2.startDate, a2 = null == t2 ? void 0 : t2.endDate;
        return this.datePickerEl.selectedStartDate = s2, this.datePickerEl.selectedEndDate = a2, this.marketFilterValueDidChange.emit({
            name: this.name,
            prevValue: {
                startDate: e2,
                endDate: i2
            },
            value: {
                startDate: s2,
                endDate: a2
            }
        }), this.setDisplayValueFromSlottedElement(), Promise.resolve();
    }
    handleListValueChange() {
        this.setDisplayValueFromSlottedElement();
    }
    handleListSelectionChange(t2) {
        var e2, i2, s2, a2;
        const { detail: o2, target: n2 } = t2, r2 = null !== (e2 = null == n2 ? void 0 : n2.multiselect) && void 0 !== e2 && e2, l2 = r2 ? o2.prevSelectionValues : null === (i2 = o2.prevSelectionValues) || void 0 === i2 ? void 0 : i2[0], d2 = r2 ? o2.currentSelectionValues : null === (s2 = o2.currentSelectionValues) || void 0 === s2 ? void 0 : s2[0];
        this.rawValue = d2, this.marketFilterValueDidChange.emit({
            name: this.name,
            prevValue: null != l2 ? l2 : null,
            value: null != d2 ? d2 : null
        }), (null === (a2 = this.listEl) || void 0 === a2 ? void 0 : a2.multiselect) || this.dropdownInteraction || (this.expanded = false);
    }
    handleDateRangeChange(t2) {
        const { startDate: e2, endDate: i2, prevStartDate: s2, prevEndDate: a2 } = t2.detail;
        this.setDisplayValueFromDateEvent(t2), this.marketFilterValueDidChange.emit({
            name: this.name,
            prevValue: {
                startDate: s2,
                endDate: a2
            },
            value: {
                startDate: e2,
                endDate: i2
            }
        });
    }
    handleDropdownOpened(t2) {
        if (t2.target !== this.el) return;
        const { defaultPrevented: e2 } = this.marketFilterExpandedChanged.emit(true);
        e2 || this.marketFilterOpened.emit().defaultPrevented ? t2.preventDefault() : this.dropdownInteraction || (this.expanded = true);
    }
    handleDropdownClosed(t2) {
        if (t2.target !== this.el) return;
        const { defaultPrevented: e2 } = this.marketFilterExpandedChanged.emit(false);
        e2 || this.marketFilterClosed.emit().defaultPrevented ? t2.preventDefault() : this.dropdownInteraction || (this.expanded = false);
    }
    handleDefaultSlotChange() {
        this.datePickerEl = this.el.querySelector(l$s("market-date-picker")), this.listEl = this.el.querySelector(l$s("market-list"));
        const t2 = "popover-" + f$d();
        this.datePickerEl ? (this.datePickerEl.id ? this.popoverId = this.datePickerEl.id : (this.datePickerEl.id = t2, this.popoverId = t2), this.filterType = "date", this.setDisplayValueFromSlottedElement()) : this.listEl && (this.listEl.interactive || (this.listEl.interactive = true), this.listEl.id ? this.popoverId = this.listEl.id : (this.listEl.id = t2, this.popoverId = t2), this.filterType = "list", this.initListValueObserver(), this.setDisplayValueFromSlottedElement());
    }
    initRowObservers() {
        const t2 = (t3)=>{
            "string" == typeof this.rawValue && t3.value === this.rawValue && (this.selectedDisplayValue = this.getTextContentOfRowWithValue(t3.value));
        };
        this.disconnectRowObservers(), this.el.querySelectorAll(`${l$s("market-list")} ${l$s("market-row")}`).forEach((e2)=>{
            const i2 = new MutationObserver(()=>t2(e2));
            i2.observe(e2, {
                characterData: true,
                subtree: true
            }), this.rowObservers.push(i2);
        });
    }
    disconnectRowObservers() {
        this.rowObservers.forEach((t2)=>t2.disconnect()), this.rowObservers = [];
    }
    initListValueObserver() {
        var t2;
        this.listEl && (null === (t2 = this.listValueObserver) || void 0 === t2 || t2.disconnect(), this.listValueObserver = new MutationObserver((t3)=>{
            t3.some((t4)=>"value" === t4.attributeName) && this.setDisplayValueFromSlottedElement();
        }), this.listValueObserver.observe(this.listEl, {
            attributes: true,
            attributeFilter: [
                "value"
            ]
        }));
    }
    getTextContentOfRowWithValue(t2) {
        var e2, i2;
        const s2 = l$s("market-row"), a2 = null === (e2 = this.listEl) || void 0 === e2 ? void 0 : e2.querySelector(`${s2}[value="${t2}"] [slot="label"]`);
        return null !== (i2 = null == a2 ? void 0 : a2.textContent) && void 0 !== i2 ? i2 : "";
    }
    setDisplayValueFromSlottedElement() {
        const t2 = this.el.querySelector('[slot="display-value"]');
        if (t2) this.selectedDisplayValue = t2.textContent;
        else if (this.listEl) {
            if (!this.listEl.value) return void (this.selectedDisplayValue = void 0);
            if (this.rawValue = this.listEl.value, this.listEl.multiselect) {
                const t3 = (()=>"string" == typeof this.listEl.value ? this.listEl.value.split(",").length : Array.isArray(this.listEl.value) ? this.listEl.value.length : void 0)();
                if (t3 > 1) return void (this.selectedDisplayValue = "" + t3);
            }
            this.selectedDisplayValue = this.getTextContentOfRowWithValue(this.listEl.value);
        } else this.datePickerEl && (this.selectedDisplayValue = this.formatDate({
            startDate: this.datePickerEl.selectedStartDate,
            endDate: this.datePickerEl.selectedEndDate
        }));
    }
    formatDate({ startDate: t2, endDate: e2 }) {
        var i2, s2;
        const a2 = t2 ? new Date(t2) : void 0, o2 = e2 ? new Date(e2) : void 0;
        if (!a2 && !o2) return "";
        const n2 = this.datePickerEl.locale, r2 = !(!a2 || !o2 || a2.getFullYear() !== o2.getFullYear()), l2 = null !== (i2 = null == a2 ? void 0 : a2.toLocaleDateString(n2, r2 && o2 ? {
            day: "numeric",
            month: "numeric"
        } : {
            dateStyle: "short"
        })) && void 0 !== i2 ? i2 : "", d2 = null !== (s2 = null == o2 ? void 0 : o2.toLocaleDateString(n2, {
            dateStyle: "short"
        })) && void 0 !== s2 ? s2 : "";
        return `${l2}${d2 ? "\u2013" + d2 : ""}`;
    }
    setDisplayValueFromDateEvent(t2) {
        var e2, i2, s2, a2;
        const { menuSelection: o2 } = t2.detail;
        if (o2 === t$4.CUSTOM) this.selectedDisplayValue = this.formatDate(t2.detail);
        else if (o2) {
            const t3 = null === (a2 = null === (s2 = null === (i2 = null === (e2 = this.datePickerEl) || void 0 === e2 ? void 0 : e2.shadowRoot) || void 0 === i2 ? void 0 : i2.querySelector(`${l$s("market-date-picker-menu")} slot[name="${o2}"]`)) || void 0 === s2 ? void 0 : s2.textContent) || void 0 === a2 ? void 0 : a2.trim();
            this.selectedDisplayValue = t3;
        }
    }
    connectedCallback() {
        this.initRowObservers(), this.handleDefaultSlotChange();
    }
    disconnectedCallback() {
        var t2;
        this.disconnectRowObservers(), null === (t2 = this.listValueObserver) || void 0 === t2 || t2.disconnect(), this.listValueObserver = null;
    }
    render() {
        var t2;
        const { datePickerEl: e2, disabled: i2, dropdownInteraction: o2, expanded: l2, handleDefaultSlotChange: h2, listEl: u2, popoverId: c2, popoverPlacement: v2, popoverStrategy: p, selectedDisplayValue: m, size: f } = this, b = null !== (t2 = null == u2 ? void 0 : u2.multiselect) && void 0 !== t2 && t2, k = !!e2, D = null != o2 ? o2 : k || b ? "persistent" : void 0, g = l$s("market-dropdown"), y = l$s("market-popover"), w = l$s("market-filter-button");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ba270794438fb6f716d9c2a00fb9075c730afa2e",
            class: "market-filter"
        }, (0, $696Z8.h)(g, {
            key: "16547d79a4be33dffd6e8e2d64d95a238175009d",
            class: "dropdown",
            disabled: i2,
            expanded: l2,
            interaction: D,
            popoverPlacement: v2,
            popoverStrategy: p
        }, (0, $696Z8.h)(w, {
            key: "ab1caf193ad6e28f98c869dd105fba2b2f2a3e95",
            active: l2,
            class: "filter-button",
            disabled: i2,
            ref: (t3)=>this.filterButtonEl = t3,
            slot: "trigger",
            size: f,
            popoverId: c2
        }, (0, $696Z8.h)("slot", {
            key: "0a41d015517c98c41ddfc566570bf04198323058",
            name: "label"
        }), !n$k(m) && (0, $696Z8.h)("span", {
            key: "05242d94392e0389f9a8b2258cdf83a625ba835f",
            slot: "feedback"
        }, (0, $696Z8.h)("slot", {
            key: "d54f1c2c99b8efbab7aac27eb025ecb882c84e37",
            name: "display-value"
        }, m))), (0, $696Z8.h)(y, {
            key: "51882ad483337fae9aed6f0c5054cea8b7b101d8",
            class: t$a({
                "date-popover": k
            }),
            slot: "popover",
            id: c2
        }, (0, $696Z8.h)("slot", {
            key: "0c386f72932713ada205cd9b5c79fcded53b1808",
            onSlotchange: h2.bind(this)
        }), (0, $696Z8.h)("slot", {
            key: "a9a3700cbcb176925a89cf97478bbd9d2823e618",
            name: "list",
            onSlotchange: h2.bind(this)
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:inline-block}.dropdown,.dropdown>.filter-button{width:100%}.date-popover{max-width:unset;max-height:unset}";
    }
}, [
    257,
    "market-filter",
    {
        name: [
            1
        ],
        disabled: [
            4
        ],
        focused: [
            1540
        ],
        size: [
            1
        ],
        expanded: [
            1540
        ],
        dropdownInteraction: [
            1,
            "dropdown-interaction"
        ],
        popoverPlacement: [
            1,
            "popover-placement"
        ],
        popoverStrategy: [
            1,
            "popover-strategy"
        ],
        selectedDisplayValue: [
            32
        ],
        getFilterType: [
            64
        ],
        setFocus: [
            64
        ],
        __setAndEmitListValue: [
            64
        ],
        __setAndEmitDatePickerValue: [
            64
        ]
    },
    [
        [
            0,
            "marketInternalListValueChange",
            "handleListValueChange"
        ],
        [
            0,
            "marketListSelectionsDidChange",
            "handleListSelectionChange"
        ],
        [
            0,
            "marketDateRangeChanged",
            "handleDateRangeChange"
        ],
        [
            0,
            "marketDropdownOpened",
            "handleDropdownOpened"
        ],
        [
            0,
            "marketDropdownClosed",
            "handleDropdownClosed"
        ]
    ]
]), c$h = u$7;
const l$e = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.size = "medium", this.disabled = false, this.focused = false, this.iconOnly = false, this.active = false;
    }
    handleClick(t2) {
        this.disabled && t2.stopImmediatePropagation();
    }
    handleDisabledChange(t2) {
        t2 && this.focused && (this.focused = false);
    }
    async setFocus(t2 = true) {
        return this.disabled ? Promise.resolve(false) : (this.focused = t2, this.focused ? this.buttonEl.focus() : this.buttonEl.blur(), Promise.resolve(this.focused));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "7bca0e50c7f4f6e21ba415806ad8e41c895ba803",
            class: "market-filter-button"
        }, (0, $696Z8.h)("button", {
            key: "b440c6d880b7c2473b1ea4540c40a2bdd31b9da6",
            "aria-disabled": this.disabled,
            disabled: this.disabled,
            ref: (t2)=>this.buttonEl = t2,
            "aria-expanded": "" + this.active,
            "aria-controls": this.popoverId,
            type: "button"
        }, (0, $696Z8.h)("svg", {
            key: "42a476e7cfdfd3b942a47316baf8e8471c1f53f3",
            width: "18",
            height: "12",
            viewBox: "0 0 18 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "40642c15aa278d390db4b076455255c293a31e13",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M0 0H18V2H0V0ZM15 5H3V7H15V5ZM12 10H6V12H12V10Z"
        })), (0, $696Z8.h)("span", {
            key: "7e7a1d487599ad100a01f9a153aaa587710e1a03",
            class: "label"
        }, (0, $696Z8.h)("slot", {
            key: "7ed2b5440af00b7b0c87e96cc59ec287d37208c3"
        })), (0, $696Z8.h)("slot", {
            key: "5c2cf13e5f9725c5832208f26232e3d922c7695a",
            name: "feedback"
        })));
    }
    static get watchers() {
        return {
            disabled: [
                {
                    handleDisabledChange: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--filter-button-normal-state-icon-color:var(--filter-button-normal-state-label-color);--filter-button-hover-state-icon-color:var(--filter-button-hover-state-label-color);--filter-button-pressed-state-icon-color:var(--filter-button-pressed-state-label-color);--filter-button-disabled-state-icon-color:var(--filter-button-disabled-state-label-color);--focus-ring-color:color-mix(in srgb, var(--core-focus-ring-color) 100%, transparent);display:inline-block;white-space:nowrap}button{display:inline-flex;gap:var(--filter-button-label-content-spacing);justify-content:center;align-items:center;width:100%;border:none;border-radius:var(--filter-button-border-radius);background-color:var(--filter-button-normal-state-background-color);color:var(--filter-button-normal-state-label-color);box-shadow:var(--filter-button-normal-state-border-color) 0 0 0 var(--filter-button-normal-state-border-size) inset;font-family:inherit;white-space:nowrap;cursor:pointer}button:focus{outline:none}button:focus-visible{outline:var(--core-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}button ::slotted([slot]){cursor:inherit}button ::slotted([slot="feedback"]){color:var(--filter-button-normal-state-feedback-color);white-space:nowrap}button svg{display:none;fill:var(--filter-button-normal-state-icon-color)}:host([icon-only]) .label{display:none}:host([icon-only]) svg{display:block}:host([size="medium"]) button{min-height:var(--filter-button-medium-size-minimum-height);padding:var(--filter-button-medium-size-label-vertical-padding)       var(--filter-button-medium-size-label-horizontal-padding);font-weight:var(--filter-button-medium-size-label-text-weight);font-size:var(--filter-button-medium-size-label-text-size);line-height:var(--filter-button-medium-size-label-text-leading);letter-spacing:var(--filter-button-medium-size-label-text-tracking);text-transform:var(--filter-button-medium-size-label-text-case)}:host([size="medium"]) ::slotted([slot="feedback"]){font-weight:var(--filter-button-medium-size-feedback-text-weight);font-size:var(--filter-button-medium-size-feedback-text-size);line-height:var(--filter-button-medium-size-feedback-text-leading);letter-spacing:var(--filter-button-medium-size-feedback-text-tracking);text-transform:var(--filter-button-medium-size-feedback-text-case)}:host([size="small"]) button{min-height:var(--filter-button-small-size-minimum-height);padding:var(--filter-button-small-size-label-vertical-padding)       var(--filter-button-small-size-label-horizontal-padding);font-weight:var(--filter-button-small-size-label-text-weight);font-size:var(--filter-button-small-size-label-text-size);line-height:var(--filter-button-small-size-label-text-leading);letter-spacing:var(--filter-button-small-size-label-text-tracking);text-transform:var(--filter-button-small-size-label-text-case)}:host([size="small"]) ::slotted([slot="feedback"]){font-weight:var(--filter-button-small-size-feedback-text-weight);font-size:var(--filter-button-small-size-feedback-text-size);line-height:var(--filter-button-small-size-feedback-text-leading);letter-spacing:var(--filter-button-small-size-feedback-text-tracking);text-transform:var(--filter-button-small-size-feedback-text-case)}:host(:hover) button{background-color:var(--filter-button-hover-state-background-color);color:var(--filter-button-hover-state-label-color);box-shadow:var(--filter-button-hover-state-border-color) 0 0 0 var(--filter-button-hover-state-border-size) inset}:host(:hover) ::slotted([slot="feedback"]){color:var(--filter-button-hover-state-feedback-color)}:host(:hover) svg{fill:var(--filter-button-hover-state-icon-color)}:host([active]) button,:host(:active) button{background-color:var(--filter-button-pressed-state-background-color);color:var(--filter-button-pressed-state-label-color);box-shadow:var(--filter-button-pressed-state-border-color) 0 0 0 var(--filter-button-pressed-state-border-size)       inset}:host([active]) ::slotted([slot="feedback"]),:host(:active) ::slotted([slot="feedback"]){color:var(--filter-button-pressed-state-feedback-color)}:host([active]) svg,:host(:active) svg{fill:var(--filter-button-pressed-state-icon-color)}:host([disabled]) button{background-color:var(--filter-button-disabled-state-background-color);color:var(--filter-button-disabled-state-label-color);box-shadow:var(--filter-button-disabled-state-border-color) 0 0 0 var(--filter-button-disabled-state-border-size)       inset}:host([disabled]) ::slotted([slot="feedback"]){color:var(--filter-button-disabled-state-feedback-color)}:host([disabled]) svg{fill:var(--filter-button-disabled-state-icon-color)}';
    }
}, [
    257,
    "market-filter-button",
    {
        size: [
            513
        ],
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        iconOnly: [
            516,
            "icon-only"
        ],
        active: [
            516
        ],
        popoverId: [
            1,
            "popover-id"
        ],
        ariaAttributes: [
            32
        ],
        setFocus: [
            64
        ]
    },
    [
        [
            2,
            "click",
            "handleClick"
        ]
    ],
    {
        disabled: [
            {
                handleDisabledChange: 0
            }
        ]
    }
]), a$g = l$e;
const d$a = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.size = "medium";
    }
    handleDropdownOpened(e2) {
        e2.target === this.el && (this.deselectFilter(), this.isDropdownActive = true);
    }
    handleDropdownClosed(e2) {
        e2.target === this.el && (this.isDropdownActive = false);
    }
    handleHeaderNavigate() {
        this.deselectFilter();
    }
    deselectFilter() {
        this.hasSelectedFilter = false;
    }
    handleOverflowFiltersSlotChange() {
        this.filterEls = this.el.querySelector('[slot="overflow-filters"]').assignedNodes(), this.createRowsFromFilters(), this.calculateFiltersWithSelectedValue();
    }
    createRowsFromFilters() {
        var e2, t2, i2, o2;
        if (!(null === (e2 = this.filterEls) || void 0 === e2 ? void 0 : e2.length)) return void (null === (t2 = this.filterRowEls) || void 0 === t2 || t2.forEach((e3)=>{
            e3.remove();
        }));
        const r2 = (null !== (i2 = this.filterRowEls) && void 0 !== i2 ? i2 : []).reduce((e3, t3)=>(e3[t3.value] = t3, e3), {}), s2 = /* @__PURE__ */ new Set(), l2 = {};
        this.filterEls.forEach((e3)=>{
            var t3;
            const i3 = e3.name;
            s2.add(i3);
            const o3 = r2[i3];
            if (o3) l2[i3] = o3;
            else {
                const e4 = document.createElement(l$s("market-row"));
                e4.variant = "drill", e4.interactive = true, e4.transient = true, e4.value = i3, e4.size = this.size, e4.addEventListener("click", async ()=>{
                    await this.handleFilterSelection(e4);
                }), l2[i3] = e4;
            }
            const n2 = null === (t3 = l2[i3]) || void 0 === t3 ? void 0 : t3.querySelector("label");
            null == n2 || n2.remove();
            const d2 = e3.querySelector("label");
            d2 && l2[i3].appendChild(d2.cloneNode(true)), e3.disabled && (l2[i3].disabled = true), l2[i3].setAttribute("slot", "filter-row");
        }), null === (o2 = this.filterRowEls) || void 0 === o2 || o2.forEach((e3)=>{
            s2.has(e3.value) || e3.remove();
        }), this.filterRowEls = [
            ...this.filterEls
        ].map(({ name: e3 })=>l2[e3]), this.filterRowEls.forEach((e3)=>{
            e3.setAttribute("slot", "filter-rows"), this.el.appendChild(e3);
        });
    }
    async handleFilterSelection(e2) {
        var t2, i2, o2;
        const r2 = e2.value;
        this.hasSelectedFilter = true;
        const s2 = this.filterEls.find((e3)=>e3.name === r2), l2 = s2.querySelector("label").cloneNode(true);
        switch(l2.setAttribute("slot", "filter-title"), null === (t2 = this.el.querySelector('[slot="filter-title"]')) || void 0 === t2 || t2.remove(), this.el.appendChild(l2), await s2.getFilterType()){
            case "date":
                {
                    const e3 = s2.querySelector(l$s("market-date-picker")).cloneNode(true);
                    e3.setAttribute("slot", "filter-options"), e3.addEventListener("marketDateRangeChanged", (e4)=>{
                        this.handleDatePickerFilterSelection(e4, s2);
                    }), null === (i2 = this.el.querySelector('[slot="filter-options"]')) || void 0 === i2 || i2.remove(), this.el.appendChild(e3);
                    break;
                }
            case "list":
                {
                    const e3 = s2.querySelector(l$s("market-list")), t3 = e3.cloneNode(true);
                    t3.setAttribute("slot", "filter-options"), t3.addEventListener("marketListSelectionsDidChange", (t4)=>{
                        this.handleListFilterSelection(t4, s2, e3);
                    }), t3.setAttribute("interactive", ""), e3.multiselect && l2.setAttribute("multiselect", ""), null === (o2 = this.el.querySelector('[slot="filter-options"]')) || void 0 === o2 || o2.remove(), this.el.appendChild(t3);
                    break;
                }
        }
    }
    async handleDatePickerFilterSelection(e2, t2) {
        const { startDate: i2, endDate: o2 } = e2.detail;
        await t2.__setAndEmitDatePickerValue({
            startDate: i2,
            endDate: o2
        }), this.calculateFiltersWithSelectedValue();
    }
    async handleListFilterSelection(e2, t2, i2) {
        const { detail: o2 } = e2, { currentSelectionValues: r2, prevSelectionValues: s2 } = o2, l2 = i2.multiselect, a2 = l2 ? s2 : s2[0], n2 = l2 ? r2 : r2[0];
        await t2.__setAndEmitListValue(a2, n2), i2.multiselect || this.deselectFilter(), this.calculateFiltersWithSelectedValue();
    }
    calculateFiltersWithSelectedValue() {
        this.filtersWithSelectedValue = [
            ...this.filterEls || []
        ].reduce((e2, t2)=>{
            const i2 = t2.querySelector(l$s("market-list"));
            if (!n$k(null == i2 ? void 0 : i2.value)) return e2 + 1;
            const o2 = t2.querySelector(l$s("market-date-picker"));
            return (null == o2 ? void 0 : o2.selectedStartDate) ? e2 + 1 : e2;
        }, 0);
    }
    componentDidLoad() {
        this.handleOverflowFiltersSlotChange();
    }
    render() {
        const { filtersWithSelectedValue: e2, handleOverflowFiltersSlotChange: t2, hasSelectedFilter: s2, isDropdownActive: n2, size: d2 } = this, c2 = l$s("market-button"), p2 = l$s("market-dropdown"), h = l$s("market-filter-button"), f = l$s("market-header"), v = l$s("market-list"), m = l$s("market-popover"), w = l$s("market-accessory");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "16fcb7812e38dff135b160f1445835c7dc28f887",
            class: t$a("market-filter-dropdown-menu", {
                "show-options": s2
            })
        }, (0, $696Z8.h)(p2, {
            key: "8db89cce9d7d1b2a40afdc5f7db43c40c5ca488f",
            interaction: "persistent",
            popoverPlacement: "bottom-end"
        }, (0, $696Z8.h)(h, {
            key: "5259c484fc23683cd86ebb31937740d0954e6e6d",
            active: n2,
            iconOnly: true,
            size: d2,
            slot: "trigger"
        }, e2 && (0, $696Z8.h)("span", {
            key: "b99f8fc5166f8662cb03572310fc4b198eb104cc",
            slot: "feedback"
        }, e2)), (0, $696Z8.h)(m, {
            key: "6cf5efcd67f62c6eb34b3ce6e22aa11d1dc4c189",
            class: "popover",
            slot: "popover"
        }, s2 ? (0, $696Z8.h)((0, $696Z8.Fragment), null, (0, $696Z8.h)(f, {
            class: "selection-header"
        }, (0, $696Z8.h)(c2, {
            rank: "secondary",
            size: "small",
            slot: "navigation"
        }, (0, $696Z8.h)(w, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 11.293C3.90237 11.6835 3.90237 12.3167 4.29289 12.7072L11.2929 19.7072L12.7071 18.293L7.41421 13.0001L19 13.0001V11.0001L7.41421 11.0001L12.7071 5.70718L11.2929 4.29297L4.29289 11.293Z"
        })))), (0, $696Z8.h)("slot", {
            name: "filter-title"
        })), (0, $696Z8.h)("div", {
            class: "filter-options-container"
        }, (0, $696Z8.h)("slot", {
            name: "filter-options"
        }))) : (0, $696Z8.h)(v, {
            class: "filter-list",
            interactive: true
        }, (0, $696Z8.h)("slot", {
            name: "filter-rows"
        })))), (0, $696Z8.h)("div", {
            key: "1704bcfda0fc7d8316f35289c4ac843e71d8c9d1",
            class: "overflow-filters"
        }, (0, $696Z8.h)("slot", {
            key: "71c4e82c834265a3b7beda3bbed409eab9a0691b",
            name: "overflow-filters",
            onSlotchange: t2.bind(this)
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}::slotted([slot="filter-title"]){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}.overflow-filters{overflow:hidden;height:0}.popover{display:flex;flex-direction:column}.selection-header::part(heading){--filter-overflow-heading-margin-top-size:var(--core-metrics-spacing-200);margin-top:var(--filter-overflow-heading-margin-top-size)}.filter-options-container{--filter-overflow-filter-options-container-margin-top-size:var(--core-metrics-spacing-100);display:flex;flex:1;overflow-y:auto;width:calc(       100% +       var(--modal-popover-wide-viewport-padding-left-size) +       var(--modal-popover-wide-viewport-padding-right-size)     );margin:var(--filter-overflow-filter-options-container-margin-top-size)     calc(var(--modal-popover-wide-viewport-padding-right-size) * -1)     calc(var(--modal-popover-wide-viewport-padding-bottom-size) * -1)     calc(var(--modal-popover-wide-viewport-padding-left-size) * -1);padding-left:var(--modal-popover-wide-viewport-padding-left-size)}.filter-options-container ::slotted(.market-list[slot="filter-options"]){width:calc(100% - var(--modal-popover-wide-viewport-padding-right-size))}.filter-options-container ::slotted(.market-list[slot="filter-options"])::after{content:"";display:block;width:100%;height:var(--core-metrics-spacing-100)}.filter-options-container ::slotted(.market-date-picker[slot="filter-options"]){width:auto;min-width:var(--date-picker-minimum-width);padding-right:var(--modal-popover-wide-viewport-padding-right-size)}.filter-options-container ::slotted(.market-date-picker[slot="filter-options"])::after{content:"";display:block;width:100%;height:var(--core-metrics-spacing-300)}.filter-options-container ::slotted(.market-date-picker[slot="filter-options"][display-menu]){height:calc(100%)}';
    }
}, [
    257,
    "market-filter-dropdown-menu",
    {
        size: [
            513
        ],
        filtersWithSelectedValue: [
            32
        ],
        hasSelectedFilter: [
            32
        ],
        isDropdownActive: [
            32
        ]
    },
    [
        [
            0,
            "marketDropdownOpened",
            "handleDropdownOpened"
        ],
        [
            0,
            "marketDropdownClosed",
            "handleDropdownClosed"
        ],
        [
            0,
            "marketHeaderNavigate",
            "handleHeaderNavigate"
        ]
    ]
]), c$g = d$a;
const m$4 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.maxVisibleFilters = 3, this._sortedFilterEls = {
            overflow: [],
            visible: []
        }, this._isSearchActive = false, this._willFocusOnFirstFilter = false, this._willDelayDropdownOpen = false, this._observers = {}, this._boundHandleInputSearchTabKeydown = this.handleInputSearchTabKeydown.bind(this), this._boundHandleInputSearchFocus = this.handleInputSearchFocus.bind(this), this.throttledHandleResize = d$j(this.handleResize.bind(this), 16);
    }
    maxVisibleFiltersWatcher() {
        this.handleResize();
    }
    marketInputSearchFocusHandler({ detail: t2 }) {
        this._isSearchActive = t2;
    }
    async marketInternalInputSearchCompactAnimationHandler(t2) {
        t2.stopPropagation(), await this.handleResize(), await n$z(), this._willDelayDropdownOpen = "animationstart" === t2.detail;
    }
    marketDropdownOpenedHandler(t2) {
        this._willDelayDropdownOpen && (this._willDelayDropdownOpen = false, t2.preventDefault(), setTimeout(async ()=>{
            var t3, i2, e2, s2, o2, r2;
            await n$z(), await (null === (e2 = null === (i2 = null === (t3 = this._dropdownMenuEl) || void 0 === t3 ? void 0 : t3.shadowRoot) || void 0 === i2 ? void 0 : i2.querySelector(l$s("market-dropdown"))) || void 0 === e2 ? void 0 : e2.updateDropdownPosition()), null === (r2 = null === (o2 = null === (s2 = this._dropdownMenuEl) || void 0 === s2 ? void 0 : s2.shadowRoot) || void 0 === o2 ? void 0 : o2.querySelector(l$s("market-dropdown"))) || void 0 === r2 || r2.openDropdown();
        }, 1.25 * o$n));
    }
    calculateOverflowButtonWidth(t2) {
        if (!(null == t2 ? void 0 : t2.length)) return 0;
        const i2 = t2.reduce((t3, i3)=>{
            const e3 = i3.querySelector(l$s("market-list"));
            if (null == e3 ? void 0 : e3.value) return t3 + 1;
            const s3 = i3.querySelector(l$s("market-date-picker"));
            return (null == s3 ? void 0 : s3.selectedStartDate) ? t3 + 1 : t3;
        }, 0);
        if (0 === i2) return 50;
        const e2 = document.createElement("canvas"), s2 = e2.getContext("2d");
        s2.font = "small" === t2[0].size ? `${k$7}px ${j$b}` : `${q$4}px ${m$a}`;
        const o2 = s2.measureText("" + i2).width;
        return e2.remove(), 58 + o2;
    }
    getComputedWidth(t2) {
        return Number.parseFloat(window.getComputedStyle(t2).width);
    }
    async findFilterCutoffIndex() {
        var t2, i2;
        if ((null !== (t2 = this.maxVisibleFilters) && void 0 !== t2 ? t2 : 3) <= 0) return 0;
        if ((null === window || void 0 === window ? void 0 : window.innerWidth) <= t$c && !this._isSearchActive) return 1;
        if (this._isSearchActive) return 0;
        const e2 = this.getComputedWidth(this.el), s2 = this._slottedInputSearchEl ? this.getComputedWidth(this._slottedInputSearchEl) + 8 : 0, o2 = document.createElement("div");
        o2.style.width = "auto", o2.style.position = "absolute", o2.style.visibility = "hidden", this.el.shadowRoot.appendChild(o2);
        let r2 = 0, l2 = 0;
        for (const t3 of this._filterEls){
            if (r2 === (null !== (i2 = this.maxVisibleFilters) && void 0 !== i2 ? i2 : 3)) break;
            const n2 = r2 + 1 === this._filterEls.length ? 0 : 8 + this.calculateOverflowButtonWidth(this._filterEls.slice(r2)), a2 = t3.cloneNode(true);
            a2.style.display = "block", o2.appendChild(a2), await n$z();
            const d2 = this.getComputedWidth(o2);
            if (o2.removeChild(a2), l2 += (r2 > 0 ? 8 : 0) + d2, s2 + l2 + n2 >= e2) break;
            ++r2;
        }
        return this.el.shadowRoot.removeChild(o2), o2.remove(), r2;
    }
    sortVisibleAndOverflowFilters() {
        this._sortedFilterEls = {
            visible: this._filterEls.slice(0, this._filterCutoffIndex),
            overflow: this._filterEls.slice(this._filterCutoffIndex)
        }, this._sortedFilterEls.visible.forEach((t2)=>{
            t2.style.display && t2.style.removeProperty("display"), "filters" !== t2.getAttribute("slot") && t2.setAttribute("slot", "filters");
        }), this._sortedFilterEls.overflow.forEach((t2)=>{
            "none" !== t2.style.display && (t2.style.display = "none"), "overflow-filters" !== t2.getAttribute("slot") && t2.setAttribute("slot", "overflow-filters");
        });
    }
    async handleResize() {
        if (!this.getComputedWidth(this.el)) return;
        const t2 = await this.findFilterCutoffIndex();
        if (t2 !== this._filterCutoffIndex && (this._filterCutoffIndex = t2, await n$z(), this.sortVisibleAndOverflowFilters(), this._dropdownMenuEl)) {
            const t3 = this._dropdownMenuEl.querySelector(l$s("market-dropdown"));
            (null == t3 ? void 0 : t3.expanded) && (null == t3 || t3.closeDropdown());
        }
        this.checkIfSearchShouldBeCompact();
    }
    async checkIfSearchShouldBeCompact() {
        var t2, i2;
        if (!this._slottedInputSearchEl || this._slottedInputSearchEl.hasAttribute("focused")) return;
        const e2 = (null === window || void 0 === window ? void 0 : window.innerWidth) <= t$c, s2 = !!(null === (t2 = this._filterEls) || void 0 === t2 ? void 0 : t2.length), o2 = this._filterEls.length > (null !== (i2 = this.maxVisibleFilters) && void 0 !== i2 ? i2 : 3), r2 = s2 && (e2 || o2);
        r2 !== this._slottedInputSearchEl.hasAttribute("compact") && (this._slottedInputSearchEl.getAttribute("focused") && await this._slottedInputSearchEl.setFocus(false), r2 ? this._slottedInputSearchEl.setAttribute("compact", "") : this._slottedInputSearchEl.removeAttribute("compact"));
    }
    handleInputSearchTabKeydown(t2) {
        var i2;
        "Tab" === t2.key && !t2.shiftKey && (null === (i2 = this._filterEls) || void 0 === i2 ? void 0 : i2.length) && (t2.preventDefault(), this._slottedInputSearchEl.blur(), this._willFocusOnFirstFilter = true);
    }
    handleInputSearchFocus() {
        var t2, i2;
        const e2 = null === (i2 = null === (t2 = this._dropdownMenuEl) || void 0 === t2 ? void 0 : t2.shadowRoot) || void 0 === i2 ? void 0 : i2.querySelector(l$s("market-dropdown"));
        (null == e2 ? void 0 : e2.hasAttribute("expanded")) && e2.closeDropdown();
    }
    registerSlottedInputSearch() {
        var t2, i2, e2, s2, o2, r2, l2, n2;
        null === (i2 = null === (t2 = this._slottedInputSearchEl) || void 0 === t2 ? void 0 : t2.removeEventListener) || void 0 === i2 || i2.call(t2, "keydown", this._boundHandleInputSearchTabKeydown), null === (s2 = null === (e2 = this._slottedInputSearchEl) || void 0 === e2 ? void 0 : e2.removeEventListener) || void 0 === s2 || s2.call(e2, "focus", this._boundHandleInputSearchFocus), this._slottedInputSearchEl = this.el.querySelector('[slot="search"]'), null === (r2 = null === (o2 = this._slottedInputSearchEl) || void 0 === o2 ? void 0 : o2.addEventListener) || void 0 === r2 || r2.call(o2, "keydown", this._boundHandleInputSearchTabKeydown), null === (n2 = null === (l2 = this._slottedInputSearchEl) || void 0 === l2 ? void 0 : l2.addEventListener) || void 0 === n2 || n2.call(l2, "focus", this._boundHandleInputSearchFocus), this.checkIfSearchShouldBeCompact();
    }
    registerSlottedFilters() {
        this._filterEls = [
            ...this.el.children
        ].filter((t2)=>i$n(t2, "market-filter"));
    }
    observeContent(t2) {
        this._observers.content || (this._observers.content = new ResizeObserver(this.throttledHandleResize), this._observers.content.observe(t2));
    }
    filtersOnSlotChangeHandler() {
        this.registerSlottedFilters(), this.handleResize();
    }
    connectedCallback() {
        this._observers.host || (this._observers.host = new ResizeObserver(this.throttledHandleResize), this._observers.host.observe(this.el));
    }
    componentWillLoad() {
        this.registerSlottedFilters(), this.registerSlottedInputSearch(), this.handleResize();
    }
    componentWillRender() {
        var t2, i2, e2;
        this._willFocusOnFirstFilter && (null === (e2 = null === (i2 = null === (t2 = this._filterEls) || void 0 === t2 ? void 0 : t2[0]) || void 0 === i2 ? void 0 : i2.setFocus) || void 0 === e2 || e2.call(i2), this._willFocusOnFirstFilter = false);
    }
    disconnectedCallback() {
        var t2, i2, e2, s2;
        Object.entries(this._observers).forEach(([t3, i3])=>{
            i3 && (i3.disconnect(), this._observers[t3] = void 0);
        }), null === (i2 = null === (t2 = this._slottedInputSearchEl) || void 0 === t2 ? void 0 : t2.removeEventListener) || void 0 === i2 || i2.call(t2, "keydown", this._boundHandleInputSearchTabKeydown), null === (s2 = null === (e2 = this._slottedInputSearchEl) || void 0 === e2 ? void 0 : e2.removeEventListener) || void 0 === s2 || s2.call(e2, "focus", this._boundHandleInputSearchFocus);
    }
    render() {
        var t2, i2;
        const o2 = null === (i2 = null === (t2 = this._filterEls) || void 0 === t2 ? void 0 : t2[0]) || void 0 === i2 ? void 0 : i2.size, r2 = l$s("market-filter-dropdown-menu");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "b7344de4260984f916541ff990021eecfe7cbab7",
            class: "market-filter-group"
        }, (0, $696Z8.h)("div", {
            key: "6f3f0585af991071b4c2ef9f22d4d05a1756b90b",
            class: "content",
            ref: (t3)=>this.observeContent(t3)
        }, (0, $696Z8.h)("slot", {
            key: "2c094a22f76daac67e65981824e41dc68d9211b8",
            name: "search",
            onSlotchange: ()=>this.registerSlottedInputSearch()
        }), (0, $696Z8.h)("slot", {
            key: "1abd0249521f900d86f79b361b97e5db9e3c77df",
            name: "filters",
            onSlotchange: ()=>this.filtersOnSlotChangeHandler()
        }), this._sortedFilterEls.overflow.length > 0 && (0, $696Z8.h)(r2, {
            key: "e0d2648b7458e130087d0fceb897f4f6aa73a9f8",
            class: "dropdown-menu",
            size: o2,
            ref: (t3)=>this._dropdownMenuEl = t3
        }, (0, $696Z8.h)("slot", {
            key: "285249a06b567211f40cc99fd71ebd019b0debae",
            name: "overflow-filters",
            slot: "overflow-filters"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            maxVisibleFilters: [
                {
                    maxVisibleFiltersWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--filter-group-margin:var(--core-metrics-spacing-200);--filter-group-search-width:280px;display:flex;margin:var(--filter-group-margin)}.content{--filter-group-button-spacing:var(--core-metrics-spacing-100);display:flex;flex:1;flex-flow:row nowrap;gap:var(--filter-group-button-spacing, var(--core-metrics-spacing-100))}::slotted([slot="search"]){max-width:var(--filter-group-search-width)}::slotted([slot="search"]:not([compact])){min-width:var(--filter-group-search-width)}::slotted([slot="search"][focused]){flex:1 1 var(--filter-group-search-width)}@media (width <= 599px){.content{justify-content:space-between}::slotted([slot="search"]){max-width:unset}::slotted([slot="search"][focused]){flex:1}::slotted([slot="filters"]){display:inline-flex;flex:1}}';
    }
}, [
    257,
    "market-filter-group",
    {
        maxVisibleFilters: [
            2,
            "max-visible-filters"
        ],
        _sortedFilterEls: [
            32
        ]
    },
    [
        [
            0,
            "marketInputSearchFocus",
            "marketInputSearchFocusHandler"
        ],
        [
            0,
            "marketInternalInputSearchCompactAnimation",
            "marketInternalInputSearchCompactAnimationHandler"
        ],
        [
            0,
            "marketDropdownOpened",
            "marketDropdownOpenedHandler"
        ]
    ],
    {
        maxVisibleFilters: [
            {
                maxVisibleFiltersWatcher: 0
            }
        ]
    }
]), p$5 = m$4;
const i$c = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "f00d47d9927cc6ed7eeece2f753f86c9b69a240b",
            class: "market-footer"
        }, (0, $696Z8.h)("slot", {
            key: "4175f8c702b6f1f1c517d9f0da356d9b88775423"
        }));
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;flex-wrap:wrap;justify-content:space-between;width:100%;padding:var(--footer-vertical-padding-size) 0}:host ::slotted(.market-button-group){width:100%}";
    }
}, [
    257,
    "market-footer"
]), n$j = i$c;
const d$9 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketHeaderNavigate = (0, $696Z8.createEvent)(this, "marketHeaderNavigate", 7), this.showNavigation = null, this.closeButtonAriaLabel = "Close", this.disableCloseButton = false, this.compact = false, this.hideCompactWayfinding = false, this.showActions = false, this.mutationObserver = null, this.boundHandleMutation = this.handleMutation.bind(this);
    }
    handleCompact() {
        if (this.compact) {
            const t2 = this.el.shadowRoot.querySelector(".grid .compact"), a2 = Number.parseInt(getComputedStyle(t2).height, 10);
            this.el.style.height = void 0 === a2 ? "" : a2 + "px";
        } else this.el.style.height = "";
    }
    handleSlottedNavigation() {
        const t2 = this.el.querySelector('[slot="navigation"]');
        t2 && (this.showNavigation = true, t2.addEventListener("click", this.handleSlottedNavClick.bind(this)));
    }
    handleSlottedActions() {
        const t2 = this.el.querySelector('[slot="actions"]');
        this.showActions = !!t2;
    }
    handleCloseButtonClick(t2) {
        this.marketHeaderNavigate.emit({
            event: t2,
            action: "close"
        });
    }
    handleSlottedNavClick(t2) {
        this.marketHeaderNavigate.emit({
            event: t2,
            action: "custom"
        });
    }
    componentWillRender() {
        var t2;
        this.checkForNavigation(), this.cloneDefaultHeadingToCompactHeading(), null === (t2 = this.mutationObserver) || void 0 === t2 || t2.disconnect(), this.mutationObserver = new MutationObserver(this.boundHandleMutation), this.mutationObserver.observe(this.el, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        var t2;
        null === (t2 = this.mutationObserver) || void 0 === t2 || t2.disconnect(), this.mutationObserver = null;
    }
    componentDidRender() {
        this.handleCompact();
    }
    handleMutation(t2) {
        let a2 = true;
        t2.forEach((t3)=>{
            "childList" === t3.type && t3.addedNodes.length > 0 && t3.addedNodes.forEach((t4)=>{
                "compact" === t4.slot && (a2 = false);
            });
        }), a2 && this.cloneDefaultHeadingToCompactHeading();
    }
    checkForNavigation() {
        const t2 = this.el.closest(`
      ${l$s("market-modal-full")},
      ${l$s("market-modal-partial")}
    `), a2 = this.el.querySelector('[slot="navigation"]');
        null === this.showNavigation && (this.showNavigation = !(!t2 && !a2));
    }
    cloneDefaultHeadingToCompactHeading() {
        const t2 = this.el.querySelectorAll('[slot="compact"]');
        for (const a3 of t2)this.el.removeChild(a3);
        const a2 = this.el.querySelector('[slot="wayfinding"]'), i2 = this.el.querySelector('[slot="subheading"]');
        if (a2 && !this.hideCompactWayfinding) {
            const t3 = a2.cloneNode(true);
            t3.slot = "compact", t3.classList.add("wayfinding"), this.el.appendChild(t3);
        }
        const e2 = [
            ...this.el.children
        ].filter((t3)=>!t3.getAttribute("slot"));
        if (this.compactTitle) {
            const t3 = e2[0].cloneNode(true);
            t3.textContent = this.compactTitle, t3.slot = "compact", this.el.appendChild(t3);
        } else for (const t3 of e2){
            const a3 = t3.cloneNode(true);
            a3.slot = "compact", this.el.appendChild(a3);
        }
        if (!a2 && i2) {
            const t3 = i2.cloneNode(true);
            t3.slot = "compact", t3.classList.add("subheading"), this.el.appendChild(t3);
        }
    }
    renderDefaultNavigation() {
        const t2 = l$s("market-button"), a2 = l$s("market-icon");
        return (0, $696Z8.h)(t2, {
            rank: "secondary",
            slot: "navigation",
            "aria-label": this.closeButtonAriaLabel,
            disabled: this.disableCloseButton,
            onClick: (t3)=>this.handleCloseButtonClick(t3)
        }, (0, $696Z8.h)(a2, {
            slot: "icon",
            name: y$b
        }));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "9cedcab22667390b824be349abe9521d969ae9ea",
            class: "market-header",
            "show-actions": this.showActions
        }, (0, $696Z8.h)("div", {
            key: "83d5053a77fbbc4e8623ead136468fb5b9b1bfdb",
            class: "grid"
        }, (0, $696Z8.h)("div", {
            key: "49f5538da84db5db45d2a8a17b158a6e148eb63c",
            class: "navigation"
        }, (0, $696Z8.h)("nav", {
            key: "a40d112caae4a7d50f8f11079a528afcf5959bca"
        }, (0, $696Z8.h)("slot", {
            key: "f9d1ba4082ae92b4e3246b599d0e934421211c06",
            name: "navigation",
            onSlotchange: ()=>this.handleSlottedNavigation()
        }, this.renderDefaultNavigation()))), (0, $696Z8.h)("div", {
            key: "634a2b88a619cef0a4b2114f0f151fe7d51976a2",
            class: "compact"
        }, (0, $696Z8.h)("slot", {
            key: "3416fc4fcefcbec6eb023a11cfd74bf5c76c74f0",
            name: "compact"
        })), (0, $696Z8.h)("div", {
            key: "a66d0c3060388018f1b9d090938a1fbec841458e",
            class: "actions"
        }, (0, $696Z8.h)("menu", {
            key: "ba63f9fb8ef7f61bf757af445a050caeb28c401c"
        }, (0, $696Z8.h)("slot", {
            key: "d2a0c47bde3379d0da43f1bf04f0ee0a25c60f73",
            name: "actions",
            onSlotchange: ()=>this.handleSlottedActions()
        })))), (0, $696Z8.h)("div", {
            key: "f9348406829c3c559f71e656e694440f4dac4cf7",
            class: "heading",
            part: "heading"
        }, (0, $696Z8.h)("slot", {
            key: "dbb0cbe5545943918ee725461750d804a4738290",
            name: "wayfinding"
        }), (0, $696Z8.h)("slot", {
            key: "46bab81cb02cd8e58729815d41ef81766890e66d"
        }), (0, $696Z8.h)("slot", {
            key: "e1f33cbe610b690e5d0dd57133401629eba5e691",
            name: "subheading"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            compact: [
                {
                    handleCompact: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}::slotted(.wayfinding),::slotted([slot="wayfinding"]),::slotted(.subheading),::slotted([slot="subheading"]){font-weight:var(--core-type-paragraph-20-weight);font-size:var(--core-type-paragraph-20-size);font-family:var(--core-type-paragraph-20-font-family);line-height:var(--core-type-paragraph-20-leading);letter-spacing:var(--core-type-paragraph-20-tracking);text-transform:var(--core-type-paragraph-20-case)}::slotted(.wayfinding) b,::slotted(.wayfinding) strong,::slotted([slot="wayfinding"]) b,::slotted([slot="wayfinding"]) strong,::slotted(.subheading) b,::slotted(.subheading) strong,::slotted([slot="subheading"]) b,::slotted([slot="subheading"]) strong{font-weight:var(--core-type-semibold-20-weight)}:host{--header-animation-duration:var(--core-animation-enter-transition-moderate-speed-duration);display:block}::slotted(*){margin:0}::slotted(.wayfinding),::slotted([slot="wayfinding"]){display:block;margin-bottom:var(--header-sub-text-spacing-bottom-size);color:var(--header-sub-text-text-color)}::slotted(.subheading),::slotted([slot="subheading"]){display:block;margin-top:var(--header-sub-text-spacing-bottom-size);color:var(--header-sub-text-text-color)}:host([show-navigation]) ::slotted([slot="compact"]:not(.wayfinding,.subheading)){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}nav{padding-right:var(--header-main-text-horizontal-spacing)}menu{display:none;grid-auto-flow:column;-moz-column-gap:var(--button-group-spacing);column-gap:var(--button-group-spacing);align-items:start;margin:0;padding-left:var(--header-main-text-horizontal-spacing)}:host([show-actions]) menu{display:grid}.grid{display:none}:host([show-actions]) .grid{display:grid;grid-template-columns:auto minmax(max-content, 1fr)}:host([show-navigation]) .grid{display:grid;grid-template-columns:minmax(max-content, 1fr) auto minmax(max-content, 1fr)}.navigation{display:none}:host([show-navigation]) .navigation{display:flex}.actions{display:flex;place-content:flex-end}.compact{display:flex;flex-direction:column;place-content:center}::slotted(p){margin-top:var(--header-bottom-padding-size)}::slotted(p[slot="compact"]){display:none}:host([show-navigation]) .compact{overflow:hidden;text-align:center;opacity:0;visibility:hidden;transition:opacity var(--header-animation-duration) ease-in-out,     visibility 0s linear var(--header-animation-duration)}:host([show-navigation]) .compact ::slotted([slot="compact"]){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.heading{display:block;transition:opacity var(--header-animation-duration) ease-in-out, visibility 0s}:host([show-navigation]) .heading{margin-top:var(--header-nav-icon-button-spacing-buttom-size)}:host([show-actions]:not([show-navigation])) .heading{display:none}:host([show-navigation][compact]) .compact{opacity:1;visibility:visible;transition:opacity var(--header-animation-duration) ease-in-out, visibility 0s}:host([show-navigation][compact]) .heading{opacity:0;visibility:hidden;transition:opacity var(--header-animation-duration) ease-in-out,       visibility 0s linear var(--header-animation-duration)}:host(.regular) .heading{max-width:var(--modal-full-fixed-layout-width);margin-right:auto;margin-left:auto}:host(.wide) .heading{max-width:1200px;margin-right:auto;margin-left:auto}';
    }
}, [
    257,
    "market-header",
    {
        showNavigation: [
            1540,
            "show-navigation"
        ],
        closeButtonAriaLabel: [
            513,
            "close-button-aria-label"
        ],
        disableCloseButton: [
            4,
            "disable-close-button"
        ],
        compact: [
            516
        ],
        compactTitle: [
            513,
            "compact-title"
        ],
        hideCompactWayfinding: [
            4,
            "hide-compact-wayfinding"
        ],
        showActions: [
            32
        ]
    },
    void 0,
    {
        compact: [
            {
                handleCompact: 0
            }
        ]
    }
]), c$f = d$9;
var d$8 = {
    core: {
        icon: {
            expand: {
                "fidelity:16": {
                    default: true,
                    asset: "chevron-down",
                    size: 16,
                    width: 16,
                    height: 16,
                    tintable: true
                }
            },
            collapse: {
                "fidelity:16": {
                    default: true,
                    asset: "chevron-up",
                    size: 16,
                    width: 16,
                    height: 16,
                    tintable: true
                }
            },
            continue: {
                "fidelity:16": {
                    default: true,
                    asset: "chevron-right",
                    size: 16,
                    width: 16,
                    height: 16,
                    tintable: true
                }
            },
            return: {
                "fidelity:16": {
                    default: true,
                    asset: "chevron-left",
                    size: 16,
                    width: 16,
                    height: 16,
                    tintable: true
                }
            },
            clear: {
                "fidelity:24": {
                    default: true,
                    asset: "x",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            close: {
                "fidelity:24": {
                    default: true,
                    asset: "x",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            add: {
                "fidelity:24": {
                    default: true,
                    asset: "plus",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            remove: {
                "fidelity:24": {
                    default: true,
                    asset: "minus",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            back: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-left",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            previous: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-left",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            forward: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-right",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            next: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-right",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            ascend: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-up",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            descend: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-down",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            more: {
                "fidelity:24": {
                    default: true,
                    asset: "ellipsis-horizontal",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            menu: {
                "fidelity:24": {
                    default: true,
                    asset: "hamburger-lines",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            loading: {
                "fidelity:24": {
                    default: true,
                    asset: "radial-spinner",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            search: {
                "fidelity:24": {
                    default: true,
                    asset: "magnifying-glass",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            drag: {
                "fidelity:24": {
                    default: true,
                    asset: "grip-dots-vertical",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            warn: {
                "fidelity:24": {
                    default: true,
                    asset: "exclamation-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            warning: {
                "fidelity:24": {
                    default: true,
                    asset: "exclamation-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            alert: {
                "fidelity:24": {
                    default: true,
                    asset: "exclamation-triangle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                },
                "fidelity:16": {
                    asset: "critical-badge-alert",
                    size: 16,
                    width: 16,
                    height: 16,
                    tintable: true
                }
            },
            attention: {
                "fidelity:24": {
                    default: true,
                    asset: "exclamation-triangle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            succeed: {
                "fidelity:24": {
                    default: true,
                    asset: "checkmark-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            success: {
                "fidelity:24": {
                    default: true,
                    asset: "checkmark-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            inform: {
                "fidelity:24": {
                    default: true,
                    asset: "i-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            info: {
                "fidelity:24": {
                    default: true,
                    asset: "i-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            deny: {
                "fidelity:24": {
                    default: true,
                    asset: "no-entry-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            denied: {
                "fidelity:24": {
                    default: true,
                    asset: "no-entry-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            cancel: {
                "fidelity:24": {
                    default: true,
                    asset: "x-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            cancelled: {
                "fidelity:24": {
                    default: true,
                    asset: "x-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            recommend: {
                "fidelity:24": {
                    default: true,
                    asset: "lightning-bolt",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            recommendation: {
                "fidelity:24": {
                    default: true,
                    asset: "lightning-bolt",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            refresh: {
                "fidelity:24": {
                    default: true,
                    asset: "dual-rotating-arrows",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            cycle: {
                "fidelity:24": {
                    default: true,
                    asset: "dual-rotating-arrows",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            delete: {
                "fidelity:24": {
                    default: true,
                    asset: "trashcan",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            checkmark: {
                "fidelity:24": {
                    asset: "check",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                },
                "fidelity:20": {
                    default: true,
                    asset: "checkmark",
                    size: 20,
                    width: 20,
                    height: 20,
                    tintable: true
                }
            },
            indeterminate: {
                "fidelity:20": {
                    default: true,
                    asset: "indeterminate-mark",
                    size: 20,
                    width: 20,
                    height: 20,
                    tintable: true
                }
            },
            help: {
                "fidelity:24": {
                    default: true,
                    asset: "question-mark-circle",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            show: {
                "fidelity:24": {
                    default: true,
                    asset: "eye",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            hide: {
                "fidelity:24": {
                    default: true,
                    asset: "eye-slash",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            filter: {
                "fidelity:24": {
                    default: true,
                    asset: "filter",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            file: {
                "fidelity:24": {
                    default: true,
                    asset: "dogeared-paper",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            look: {
                "fidelity:24": {
                    default: true,
                    asset: "binoculars",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            ascending: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-up",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            descending: {
                "fidelity:24": {
                    default: true,
                    asset: "arrow-down",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            unsorted: {
                "fidelity:24": {
                    default: true,
                    asset: "up-down",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            settings: {
                "fidelity:24": {
                    default: true,
                    asset: "sliders-horizontal",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            undo: {
                "fidelity:24": {
                    default: true,
                    asset: "cycle-backward",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            redo: {
                "fidelity:24": {
                    default: true,
                    asset: "cycle-forward",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            edit: {
                "fidelity:24": {
                    default: true,
                    asset: "pencil-writing",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            picture: {
                "fidelity:24": {
                    default: true,
                    asset: "image",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            "indicator-check-complete": {
                "fidelity:24": {
                    default: true,
                    asset: "indicator-check-complete",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            "indicator-check-incomplete": {
                "fidelity:24": {
                    default: true,
                    asset: "indicator-check-incomplete",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            "indicator-circle-active": {
                "fidelity:24": {
                    default: true,
                    asset: "indicator-circle-active",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            "indicator-circle-inactive": {
                "fidelity:24": {
                    default: true,
                    asset: "indicator-circle-inactive",
                    size: 24,
                    width: 24,
                    height: 24,
                    tintable: true
                }
            },
            "size:small": {
                width: 16,
                height: 16,
                ramp: {
                    "scale-1": 1,
                    "scale-2": 1,
                    "scale-3": 1,
                    "scale-4": 1,
                    "scale-5": 1,
                    "scale-6": 1.25,
                    "scale-7": 1.25,
                    "scale-8": 1.5,
                    "scale-9": 1.75,
                    "scale-10": 2,
                    "scale-11": 2.25,
                    "scale-12": 2.5
                }
            },
            "size:medium": {
                width: 24,
                height: 24,
                ramp: {
                    "scale-1": 0.917,
                    "scale-2": 0.917,
                    "scale-3": 1,
                    "scale-4": 1,
                    "scale-5": 1,
                    "scale-6": 1.167,
                    "scale-7": 1.167,
                    "scale-8": 1.333,
                    "scale-9": 1.5,
                    "scale-10": 1.667,
                    "scale-11": 1.833,
                    "scale-12": 2
                }
            },
            "size:large": {
                width: 40,
                height: 40,
                ramp: {
                    "scale-1": 0.8,
                    "scale-2": 0.8,
                    "scale-3": 0.8,
                    "scale-4": 1,
                    "scale-5": 1.2,
                    "scale-6": 1.25,
                    "scale-7": 1.25,
                    "scale-8": 1.4,
                    "scale-9": 1.45,
                    "scale-10": 1.6,
                    "scale-11": 1.8,
                    "scale-12": 2
                }
            }
        }
    }
};
function r$8(t2, e2) {
    return e2["fidelity:" + t2];
}
function o$8(t2, e2) {
    return e2 ? document.querySelector(`[data-name="${t2}"][data-fidelity="${e2}"]`) : document.querySelector(`[data-name="${t2}"]`);
}
const n$i = "#market-icon-sprite", h$9 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.tintable = true;
    }
    cloneSymbol(t2, e2, i2, a2) {
        this.el.querySelectorAll("svg").forEach((t3)=>t3.remove());
        const l2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        l2.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink"), l2.dataset.name = e2, l2.setAttribute("viewBox", null == t2 ? void 0 : t2.getAttribute("viewBox")), i2 && l2.setAttribute("width", "" + i2), a2 && l2.setAttribute("height", "" + a2), l2.innerHTML = t2.innerHTML, this.el.appendChild(l2);
    }
    getDimensions(t2, e2, i2) {
        var a2, l2, d2, r2;
        const o2 = (null == t2 ? void 0 : t2.getAttribute("viewBox").split(/\s/).map((t3)=>Number.parseInt(t3, 10))) || [];
        return {
            width: null !== (l2 = null !== (a2 = null == e2 ? void 0 : e2.width) && void 0 !== a2 ? a2 : o2[2]) && void 0 !== l2 ? l2 : i2,
            height: null !== (r2 = null !== (d2 = null == e2 ? void 0 : e2.height) && void 0 !== d2 ? d2 : o2[3]) && void 0 !== r2 ? r2 : i2
        };
    }
    componentWillLoad() {
        var t2;
        let e2, i2, a2, l2, h2;
        if (!document.querySelector(n$i)) {
            const t3 = document.createElement("div");
            t3.innerHTML = '<svg id="market-icon-sprite"><defs/><symbol id="market-icon-chevron-down-fidelity-16" viewBox="0 0 16 16" data-fidelity="16" data-name="chevron-down" data-tintable="true" data-width="16" data-height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.70715 11.7071C8.31663 12.0976 7.68346 12.0976 7.29294 11.7071L1.29294 5.7071L2.70715 4.29289L8.00005 9.58578L13.2929 4.29289L14.7072 5.70711L8.70715 11.7071Z" fill="currentColor"/></symbol><symbol id="market-icon-chevron-up-fidelity-16" viewBox="0 0 16 16" data-fidelity="16" data-name="chevron-up" data-tintable="true" data-width="16" data-height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.29285 4.29289C7.68337 3.90237 8.31654 3.90237 8.70706 4.29289L14.7071 10.2929L13.2928 11.7071L7.99995 6.41421L2.70706 11.7071L1.29285 10.2929L7.29285 4.29289Z" fill="currentColor"/></symbol><symbol id="market-icon-chevron-right-fidelity-16" viewBox="0 0 16 16" data-fidelity="16" data-name="chevron-right" data-tintable="true" data-width="16" data-height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7071 7.29285C12.0976 7.68337 12.0976 8.31654 11.7071 8.70706L5.70711 14.7071L4.29289 13.2928L9.58579 7.99995L4.29289 2.70706L5.70711 1.29285L11.7071 7.29285Z" fill="currentColor"/></symbol><symbol id="market-icon-chevron-left-fidelity-16" viewBox="0 0 16 16" data-fidelity="16" data-name="chevron-left" data-tintable="true" data-width="16" data-height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 7.29285C3.90237 7.68337 3.90237 8.31654 4.29289 8.70706L10.2929 14.7071L11.7071 13.2928L6.41421 7.99995L11.7071 2.70706L10.2929 1.29285L4.29289 7.29285Z" fill="currentColor"/></symbol><symbol id="market-icon-x-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="x" data-tintable="true" data-width="24" data-height="24"><path d="M19.7069 5.70691L13.4139 11.9999L19.7069 18.2928L18.2928 19.7069L11.9999 13.4139L5.70691 19.7069L4.29285 18.2928L10.5858 11.9999L4.29285 5.70691L5.70691 4.29285L11.9999 10.5858L18.2928 4.29285L19.7069 5.70691Z" fill="currentColor"/></symbol><symbol id="market-icon-plus-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="plus" data-tintable="true" data-width="24" data-height="24"><path d="M13 11.0049H20V13.0049H13V20.0049H11V13.0049H4V11.0049H11V4.00488H13V11.0049Z" fill="currentColor"/></symbol><symbol id="market-icon-minus-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="minus" data-tintable="true" data-width="24" data-height="24"><path d="M20 13H4V11H20V13Z" fill="currentColor"/></symbol><symbol id="market-icon-arrow-left-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="arrow-left" data-tintable="true" data-width="24" data-height="24"><path d="M12.2074 5.20654L6.41445 10.9995H20.0004V12.9995H6.41445L12.2074 18.7925L10.7934 20.2065L3.29336 12.7065C2.90288 12.316 2.90285 11.683 3.29336 11.2925L10.7934 3.79248L12.2074 5.20654Z" fill="currentColor"/></symbol><symbol id="market-icon-arrow-right-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="arrow-right" data-tintable="true" data-width="24" data-height="24"><path d="M20.7075 11.2925C20.8949 11.4799 21.0004 11.7345 21.0005 11.9995C21.0005 12.2645 20.8948 12.519 20.7075 12.7065L13.2075 20.2065L11.7935 18.7925L17.5864 12.9995H4.00049V10.9995H17.5864L11.7935 5.20654L13.2075 3.79248L20.7075 11.2925Z" fill="currentColor"/></symbol><symbol id="market-icon-arrow-up-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="arrow-up" data-tintable="true" data-width="24" data-height="24"><path d="M11.9999 3.00049C12.2652 3.00049 12.5194 3.10592 12.707 3.29346L20.207 10.7935L18.7929 12.2075L12.9999 6.41455V20.0005H10.9999V6.41455L5.20697 12.2075L3.79291 10.7935L11.2929 3.29346L11.3661 3.22705C11.5441 3.08122 11.7678 3.00049 11.9999 3.00049Z" fill="currentColor"/></symbol><symbol id="market-icon-arrow-down-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="arrow-down" data-tintable="true" data-width="24" data-height="24"><path d="M13 17.5864L18.793 11.7935L20.207 13.2075L12.707 20.7075C12.3166 21.0977 11.6834 21.0977 11.293 20.7075L3.79297 13.2075L5.20703 11.7935L11 17.5864V4.00049H13V17.5864Z" fill="currentColor"/></symbol><symbol id="market-icon-ellipsis-horizontal-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="ellipsis-horizontal" data-tintable="true" data-width="24" data-height="24"><path d="M19 10C20.104 10 21 10.896 21 12C21 13.104 20.104 14 19 14C17.896 14 17 13.104 17 12C17 10.896 17.896 10 19 10Z" fill="currentColor"/><path d="M12 10C13.104 10 14 10.896 14 12C14 13.104 13.104 14 12 14C10.896 14 10 13.104 10 12C10 10.896 10.896 10 12 10Z" fill="currentColor"/><path d="M7 12C7 10.896 6.104 10 5 10C3.896 10 3 10.896 3 12C3 13.104 3.896 14 5 14C6.104 14 7 13.104 7 12Z" fill="currentColor"/></symbol><symbol id="market-icon-hamburger-lines-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="hamburger-lines" data-tintable="true" data-width="24" data-height="24"><path d="M20.5 20H3.5V18H20.5V20Z" fill="currentColor"/><path d="M20.5 13H3.5V11H20.5V13Z" fill="currentColor"/><path d="M20.5 6H3.5V4H20.5V6Z" fill="currentColor"/></symbol><symbol id="market-icon-radial-spinner-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="radial-spinner" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 12C19 8.13401 15.866 5 12 5V3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12H5C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12Z" fill="currentColor"/></symbol><symbol id="market-icon-magnifying-glass-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="magnifying-glass" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.11531 5.11531C7.93575 2.29488 12.5087 2.29491 15.3292 5.11531C17.9096 7.69576 18.1267 11.7413 15.9854 14.5714L21.2071 19.793L19.793 21.2071L14.5714 15.9854C11.7413 18.1267 7.69576 17.9096 5.11531 15.3292C2.29491 12.5087 2.29488 7.93575 5.11531 5.11531ZM13.9151 6.52938C11.8757 4.49002 8.56876 4.48999 6.52938 6.52938C4.48999 8.56876 4.49002 11.8757 6.52938 13.9151C8.56878 15.9545 11.8757 15.9545 13.9151 13.9151C15.9545 11.8757 15.9545 8.56878 13.9151 6.52938Z" fill="currentColor"/></symbol><symbol id="market-icon-grip-dots-vertical-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="grip-dots-vertical" data-tintable="true" data-width="24" data-height="24"><path d="M9 4C10.1046 4 11 4.89543 11 6C11 7.10457 10.1046 8 9 8C7.89543 8 7 7.10457 7 6C7 4.89543 7.89543 4 9 4Z" fill="currentColor"/><path d="M9 10C10.1046 10 11 10.8954 11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 10.8954 7.89543 10 9 10Z" fill="currentColor"/><path d="M9 16C10.1046 16 11 16.8954 11 18C11 19.1046 10.1046 20 9 20C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16Z" fill="currentColor"/><path d="M15 4C16.1046 4 17 4.89543 17 6C17 7.10457 16.1046 8 15 8C13.8954 8 13 7.10457 13 6C13 4.89543 13.8954 4 15 4Z" fill="currentColor"/><path d="M15 10C16.1046 10 17 10.8954 17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10Z" fill="currentColor"/><path d="M15 16C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16Z" fill="currentColor"/></symbol><symbol id="market-icon-exclamation-circle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="exclamation-circle" data-tintable="true" data-width="24" data-height="24"><path d="M13.0002 7.00022V12.5002H11.0002V7.00022H13.0002Z" fill="currentColor"/><path d="M12.0002 17.5002C12.8286 17.5002 13.5002 16.8286 13.5002 16.0002C13.5002 15.1718 12.8286 14.5002 12.0002 14.5002C11.1718 14.5002 10.5002 15.1718 10.5002 16.0002C10.5002 16.8286 11.1718 17.5002 12.0002 17.5002Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92893 4.92893C8.83418 1.02369 15.1663 1.02369 19.0715 4.92893C22.9768 8.83418 22.9768 15.1663 19.0715 19.0715C15.1663 22.9768 8.83418 22.9768 4.92893 19.0715C1.02369 15.1663 1.02369 8.83417 4.92893 4.92893ZM17.6574 6.34299C14.5333 3.2188 9.46719 3.2188 6.34299 6.34299C3.2188 9.46719 3.2188 14.5333 6.34299 17.6574C9.46719 20.7816 14.5333 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299Z" fill="currentColor"/></symbol><symbol id="market-icon-exclamation-triangle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="exclamation-triangle" data-tintable="true" data-width="24" data-height="24"><path d="M12 15C12.8284 15.0001 13.5 15.6716 13.5 16.5C13.5 17.3284 12.8284 17.9999 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15Z" fill="currentColor"/><path d="M13 13.5H11V9H13V13.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C12.3512 2.00003 12.6767 2.18425 12.8574 2.48535L23.3574 19.9854C23.5427 20.2943 23.5476 20.6797 23.3701 20.9932C23.1926 21.3064 22.8601 21.5 22.5 21.5H1.49998C1.13987 21.5 0.807432 21.3064 0.629867 20.9932C0.452361 20.6797 0.457204 20.2943 0.642562 19.9854L11.1426 2.48535L11.2168 2.37793C11.405 2.14097 11.6927 2 12 2ZM3.26659 19.5H20.7334L12 4.94336L3.26659 19.5Z" fill="currentColor"/></symbol><symbol id="market-icon-critical-badge-alert-fidelity-16" viewBox="0 0 16 16" data-fidelity="16" data-name="critical-badge-alert" data-tintable="true" data-width="16" data-height="16"><path d="M9 3V8.5H7V3H9Z" fill="currentColor"/><path d="M8 13C8.82843 13 9.5 12.3284 9.5 11.5C9.5 10.6716 8.82843 10 8 10C7.17157 10 6.5 10.6716 6.5 11.5C6.5 12.3284 7.17157 13 8 13Z" fill="currentColor"/></symbol><symbol id="market-icon-checkmark-circle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="checkmark-circle" data-tintable="true" data-width="24" data-height="24"><path d="M17.2586 9.15014L11.2586 16.1501C11.0686 16.3718 10.7917 16.4997 10.4998 16.4997C10.2079 16.4997 9.93092 16.3717 9.74099 16.1501L6.74099 12.6501L8.25856 11.3494L10.4998 13.9636L15.741 7.84935L17.2586 9.15014Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92849 4.92846C8.83365 1.02329 15.1658 1.02343 19.0711 4.92846C22.9763 8.8337 22.9763 15.1658 19.0711 19.071C15.1658 22.9763 8.83373 22.9763 4.92849 19.071C1.02346 15.1658 1.02332 8.83362 4.92849 4.92846ZM17.657 6.34252C14.5328 3.21854 9.46667 3.2184 6.34255 6.34252C3.21843 9.46664 3.21858 14.5328 6.34255 17.657C9.46674 20.7812 14.5328 20.7812 17.657 17.657C20.7812 14.5328 20.7812 9.46671 17.657 6.34252Z" fill="currentColor"/></symbol><symbol id="market-icon-i-circle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="i-circle" data-tintable="true" data-width="24" data-height="24"><path d="M13.0002 17.0002H11.0002V11.5002H13.0002V17.0002Z" fill="currentColor"/><path d="M12.0002 6.50022C12.8286 6.50022 13.5002 7.17179 13.5002 8.00022C13.5002 8.82865 12.8286 9.50022 12.0002 9.50022C11.1718 9.50022 10.5002 8.82865 10.5002 8.00022C10.5002 7.17179 11.1718 6.50022 12.0002 6.50022Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92893 4.92893C8.83417 1.02369 15.1663 1.02369 19.0715 4.92893C22.9768 8.83418 22.9768 15.1663 19.0715 19.0715C15.1663 22.9768 8.83418 22.9768 4.92893 19.0715C1.02369 15.1663 1.02369 8.83418 4.92893 4.92893ZM17.6574 6.34299C14.5333 3.2188 9.46719 3.2188 6.34299 6.34299C3.2188 9.46719 3.2188 14.5333 6.34299 17.6574C9.46719 20.7816 14.5333 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299Z" fill="currentColor"/></symbol><symbol id="market-icon-no-entry-circle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="no-entry-circle" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92892 4.92893C8.83416 1.02369 15.1663 1.02369 19.0715 4.92893C22.9767 8.83418 22.9767 15.1663 19.0715 19.0715C15.1663 22.9768 8.83416 22.9768 4.92892 19.0715C1.02368 15.1663 1.02368 8.83418 4.92892 4.92893ZM7.09591 18.3176C10.2344 20.7604 14.7726 20.5423 17.6574 17.6574C20.5423 14.7726 20.7604 10.2344 18.3176 7.09592L7.09591 18.3176ZM16.9035 5.68186C13.7651 3.24 9.22747 3.45851 6.34298 6.34299C3.45849 9.22748 3.23999 13.7651 5.68185 16.9035L16.9035 5.68186Z" fill="currentColor"/></symbol><symbol id="market-icon-x-circle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="x-circle" data-tintable="true" data-width="24" data-height="24"><path d="M16.7072 8.70725L13.4143 12.0002L16.7072 15.2932L15.2932 16.7073L12.0002 13.4143L8.70724 16.7073L7.29317 15.2932L10.5861 12.0002L7.29317 8.70725L8.70724 7.29319L12.0002 10.5862L15.2932 7.29319L16.7072 8.70725Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92892 4.92893C8.83416 1.02369 15.1663 1.02369 19.0715 4.92893C22.9767 8.83418 22.9767 15.1663 19.0715 19.0715C15.1663 22.9768 8.83416 22.9768 4.92892 19.0715C1.02367 15.1663 1.02367 8.83418 4.92892 4.92893ZM17.6574 6.34299C14.5332 3.2188 9.46717 3.2188 6.34298 6.34299C3.21879 9.46719 3.21878 14.5333 6.34298 17.6574C9.46717 20.7816 14.5332 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299Z" fill="currentColor"/></symbol><symbol id="market-icon-lightning-bolt-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="lightning-bolt" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.904 1.30638C14.2593 0.937255 14.8362 0.896445 15.24 1.21165C15.6437 1.52722 15.7437 2.09692 15.4714 2.53099L11.7644 8.43528L19.3269 11.0544C19.6492 11.1661 19.8928 11.4346 19.9724 11.7663C20.052 12.0979 19.9569 12.4474 19.7204 12.6931L10.0954 22.6931C9.74001 23.0622 9.16228 23.1034 8.75853 22.7878C8.35501 22.4722 8.25586 21.9025 8.52806 21.4685L12.2341 15.5632L4.67259 12.945C4.35037 12.8334 4.10668 12.5647 4.02708 12.2331C3.94753 11.9016 4.04273 11.5521 4.27904 11.3064L13.904 1.30638ZM6.80443 11.5661L15.2224 14.4812L17.1941 12.4324L8.77611 9.51731L6.80443 11.5661Z" fill="currentColor"/></symbol><symbol id="market-icon-dual-rotating-arrows-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="dual-rotating-arrows" data-tintable="true" data-width="24" data-height="24"><path d="M22 13.5C22 16.8137 19.3137 19.5 16 19.5H7.41406L10.207 22.293L8.79297 23.707L4.29297 19.207C3.90244 18.8165 3.90244 18.1835 4.29297 17.793L8.79297 13.293L10.207 14.707L7.41406 17.5H16C18.2091 17.5 20 15.7091 20 13.5V11H22V13.5Z" fill="currentColor"/><path d="M19.707 4.79297C20.0975 5.18348 20.0975 5.8165 19.707 6.20703L15.207 10.707L13.793 9.29297L16.5859 6.5H8C5.79089 6.5 4.00004 8.2909 4 10.5V13H2V10.5C2.00004 7.18633 4.68632 4.5 8 4.5H16.5859L13.793 1.70703L15.207 0.292969L19.707 4.79297Z" fill="currentColor"/></symbol><symbol id="market-icon-trashcan-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="trashcan" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 8H19.4258L18.4971 20.0771C18.4568 20.5979 18.0224 21 17.5 21H6.5C5.97761 21 5.54322 20.5979 5.50293 20.0771L4.57422 8H3V6H21V8ZM7.42578 19H16.5742L17.4199 8H6.58008L7.42578 19Z" fill="currentColor"/><path d="M12 2C13.1728 2 14.075 2.29432 14.6973 2.60547C15.0067 2.76017 15.2447 2.91837 15.4121 3.04395C15.4957 3.10665 15.5624 3.16129 15.6113 3.2041C15.6356 3.22536 15.656 3.24395 15.6719 3.25879C15.6798 3.26622 15.6866 3.27368 15.6924 3.2793C15.6953 3.28211 15.6988 3.28477 15.7012 3.28711L15.7041 3.29004L15.7061 3.29102L14.2939 4.70801L14.3047 4.71875C14.3047 4.71875 14.3012 4.71544 14.2949 4.70996C14.2814 4.69814 14.254 4.6744 14.2129 4.64355C14.1304 4.58165 13.9932 4.48978 13.8027 4.39453C13.425 4.20567 12.8272 4 12 4C11.1728 4 10.575 4.20567 10.1973 4.39453C10.0068 4.48978 9.86965 4.58165 9.78711 4.64355C9.746 4.6744 9.71859 4.69814 9.70508 4.70996C9.69882 4.71544 9.69531 4.71875 9.69531 4.71875L9.70605 4.70801L8.29395 3.29199L8.29883 3.28711C8.3012 3.28477 8.30471 3.28211 8.30762 3.2793C8.31342 3.27368 8.3202 3.26622 8.32812 3.25879C8.34396 3.24395 8.36438 3.22536 8.38867 3.2041C8.43761 3.16129 8.50429 3.10665 8.58789 3.04395C8.75534 2.91837 8.99332 2.76017 9.30273 2.60547C9.92502 2.29432 10.8272 2 12 2Z" fill="currentColor"/></symbol><symbol id="market-icon-check-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="check" data-tintable="true" data-width="24" data-height="24"><path d="M22.7573 5.6499L10.7573 19.6499C10.5673 19.8715 10.2905 19.9995 9.99854 19.9995C9.70678 19.9994 9.42963 19.8714 9.23975 19.6499L3.23975 12.6499L4.75732 11.3491L9.99854 17.4634L21.2397 4.34912L22.7573 5.6499Z" fill="currentColor"/></symbol><symbol id="market-icon-checkmark-fidelity-20" viewBox="0 0 20 20" data-fidelity="20" data-name="checkmark" data-tintable="true" data-width="20" data-height="20"><path d="M16.2559 7.15527L9.75586 14.6553C9.56646 14.8737 9.29109 14.9993 9.00195 15C8.71292 15.0006 8.43741 14.8757 8.24707 14.6582L4.74707 10.6582L6.25293 9.3418L8.99609 12.4766L14.7441 5.84473L16.2559 7.15527Z" fill="currentColor"/></symbol><symbol id="market-icon-indeterminate-mark-fidelity-20" viewBox="0 0 20 20" data-fidelity="20" data-name="indeterminate-mark" data-tintable="true" data-width="20" data-height="20"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 11H6V9H14V11Z" fill="currentColor"/></symbol><symbol id="market-icon-question-mark-circle-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="question-mark-circle" data-tintable="true" data-width="24" data-height="24"><path d="M12.0002 15.0002C12.8282 15.0002 13.5002 15.6722 13.5002 16.5002C13.5002 17.3282 12.8282 18.0002 12.0002 18.0002C11.1722 18.0002 10.5002 17.3282 10.5002 16.5002C10.5002 15.6722 11.1722 15.0002 12.0002 15.0002Z" fill="currentColor"/><path d="M12.0002 5.75022C14 5.75025 15.5001 7.27933 15.5002 9.21018C15.5002 10.1919 15.0958 11.0185 14.4279 11.5959C14.0169 11.9512 13.5257 12.196 13.0002 12.342V13.2502H11.0002V10.5608L11.9377 10.5022C12.4658 10.4693 12.8685 10.3 13.1203 10.0823C13.353 9.88088 13.5002 9.6051 13.5002 9.21018C13.5001 8.38761 12.8991 7.75025 12.0002 7.75022C11.1019 7.75025 10.4232 8.40143 10.2326 9.39768L8.26779 9.02268C8.58994 7.3367 9.90547 5.75025 12.0002 5.75022Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92892 4.92893C8.83416 1.02369 15.1663 1.02369 19.0715 4.92893C22.9767 8.83418 22.9767 15.1663 19.0715 19.0715C15.1663 22.9768 8.83416 22.9768 4.92892 19.0715C1.02368 15.1663 1.02368 8.83418 4.92892 4.92893ZM17.6574 6.34299C14.5332 3.2188 9.46718 3.2188 6.34298 6.34299C3.21879 9.46719 3.21879 14.5333 6.34298 17.6574C9.46718 20.7816 14.5332 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299Z" fill="currentColor"/></symbol><symbol id="market-icon-eye-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="eye" data-tintable="true" data-width="24" data-height="24"><path d="M11.9996 10C13.1041 10 13.9996 10.8954 13.9996 12C13.9996 13.1046 13.1041 14 11.9996 14C10.8952 13.9998 9.99957 13.1045 9.99957 12C9.99957 10.8955 10.8952 10.0002 11.9996 10Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9996 6C14.3914 6 16.5313 7.0177 18.1509 8.11328C19.7794 9.21488 20.9695 10.4545 21.4839 11.0303C21.9797 11.5851 21.9797 12.4149 21.4839 12.9697C20.9695 13.5455 19.7794 14.7851 18.1509 15.8867C16.5313 16.9823 14.3914 18 11.9996 18C9.60775 17.9999 7.46781 16.9823 5.8482 15.8867C4.21969 14.7851 3.02958 13.5454 2.5152 12.9697C2.01967 12.4149 2.01967 11.5851 2.5152 11.0303L2.7398 10.7852C3.33447 10.1473 4.42327 9.07723 5.8482 8.11328C7.46781 7.01769 9.60775 6.00009 11.9996 6ZM11.9996 8C10.1664 8.00009 8.4205 8.78883 6.9693 9.77051C5.81129 10.5539 4.89704 11.4249 4.34625 12C4.89704 12.5751 5.81129 13.4461 6.9693 14.2295C8.4205 15.2112 10.1664 15.9999 11.9996 16C13.8328 16 15.5786 15.2112 17.0298 14.2295C18.1875 13.4464 19.101 12.5751 19.6519 12C19.101 11.4249 18.1875 10.5536 17.0298 9.77051C15.5786 8.78885 13.8328 8 11.9996 8Z" fill="currentColor"/></symbol><symbol id="market-icon-eye-slash-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="eye-slash" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7313 5.18311L17.4256 7.65186C17.6775 7.8025 17.9197 7.9572 18.1512 8.11377C19.7798 9.21547 20.9698 10.4551 21.4842 11.0308C21.9799 11.5856 21.9799 12.4154 21.4842 12.9702C20.9697 13.546 19.7796 14.7857 18.1512 15.8872C16.5316 16.9828 14.3916 18.0005 11.9998 18.0005C10.7292 18.0005 9.53036 17.7113 8.44222 17.2778L5.73128 20.1831L4.26839 18.8179L6.57308 16.3472C6.32175 16.1968 6.07942 16.0434 5.84847 15.8872C4.2199 14.7855 3.02989 13.5459 2.51546 12.9702C2.01983 12.4155 2.02 11.5856 2.51546 11.0308L2.74007 10.7856C3.33472 10.1478 4.42357 9.0777 5.84847 8.11377C7.46809 7.01816 9.60797 6.00055 11.9998 6.00049C13.27 6.00049 14.4686 6.28894 15.5565 6.72217L18.2684 3.81787L19.7313 5.18311ZM9.93147 15.6812C10.6002 15.8814 11.2933 16.0005 11.9998 16.0005C13.833 16.0005 15.5789 15.2116 17.0301 14.23C18.1877 13.4469 19.1013 12.5756 19.6522 12.0005C19.1013 11.4254 18.1879 10.5542 17.0301 9.771C16.7086 9.5535 16.3724 9.34588 16.0242 9.15381L9.93147 15.6812ZM11.9998 8.00049C10.1666 8.00056 8.42079 8.7893 6.96956 9.771C5.81159 10.5544 4.8973 11.4254 4.34651 12.0005C4.89735 12.5756 5.81148 13.4466 6.96956 14.23C7.29081 14.4473 7.62757 14.6533 7.97542 14.8452L14.0672 8.31787C13.399 8.11792 12.7059 8.00049 11.9998 8.00049Z" fill="currentColor"/></symbol><symbol id="market-icon-filter-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="filter" data-tintable="true" data-width="24" data-height="24"><path d="M15.5 19H8.5V17H15.5V19Z" fill="currentColor"/><path d="M19 13H5V11H19V13Z" fill="currentColor"/><path d="M22.5 7H1.5V5H22.5V7Z" fill="currentColor"/></symbol><symbol id="market-icon-dogeared-paper-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="dogeared-paper" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9993 2.5C12.2637 2.5 12.518 2.60455 12.7054 2.79102L19.2356 9.29102L19.3431 9.41699C19.4388 9.55049 19.5004 9.7065 19.5218 9.87109C19.9137 12.8864 20.9522 16.1627 19.9778 20.71C19.8789 21.1708 19.4707 21.5 18.9993 21.5H4.99931C4.69756 21.4998 4.41171 21.3635 4.22196 21.1289C4.03217 20.8941 3.95852 20.5853 4.02177 20.29C4.72668 16.9999 4.26516 14.55 3.82646 11.9805C3.38478 9.39353 2.97086 6.69437 4.04423 3.20605C4.17329 2.78664 4.56053 2.50023 4.99931 2.5H11.9993ZM5.76005 4.5C5.08508 7.17349 5.39928 9.30841 5.79814 11.6445C6.18571 13.9146 6.65125 16.3776 6.19364 19.5H18.1722C18.7241 16.1752 18.0915 13.7573 17.6643 11H12.0003C11.4481 10.9999 11.0003 10.5522 11.0003 10L10.9993 4.5H5.76005ZM13.0003 9H16.1077L12.9993 5.90625L13.0003 9Z" fill="currentColor"/></symbol><symbol id="market-icon-binoculars-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="binoculars" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.9043 4.14735C16.2755 3.7293 17.8567 4.19602 18.8818 5.62782L18.8848 5.63172L23.001 11.4393C23.6299 12.3245 23.9999 13.4047 24 14.5731C24 17.588 21.5374 20.0173 18.5176 20.0175C15.5171 20.0175 13.0677 17.6196 13.0361 14.6317L12.9727 13.7929C12.9684 13.7511 12.964 13.706 12.959 13.6581C12.9302 13.3831 12.89 13.0176 12.8438 12.6532C12.813 12.4108 12.7174 12.2763 12.6133 12.1932C12.4991 12.1022 12.3026 12.0184 12 12.0184C11.6974 12.0184 11.5009 12.1022 11.3867 12.1932C11.2826 12.2763 11.187 12.4108 11.1562 12.6532C11.11 13.0176 11.0698 13.3831 11.041 13.6581C11.036 13.706 11.0316 13.7511 11.0273 13.7929L10.9639 14.6317C10.9323 17.6196 8.48287 20.0175 5.48242 20.0175C2.46265 20.0173 0 17.588 0 14.5731C0.000145563 13.4047 0.371039 12.3245 1 11.4393L5.11523 5.63172L5.11816 5.62782C6.14332 4.19604 7.72448 3.72931 9.0957 4.14735C10.459 4.56305 11.4997 5.8244 11.5 7.51746C11.5 7.54252 11.499 7.56864 11.4971 7.59364L11.3076 10.0907C11.5339 10.0429 11.7662 10.0184 12 10.0184C12.2335 10.0184 12.4654 10.0431 12.6914 10.0907L12.5029 7.59364C12.501 7.56863 12.5 7.54253 12.5 7.51746C12.5003 5.82438 13.541 4.56306 14.9043 4.14735ZM5.48242 11.1288C3.55121 11.129 2.00038 12.6793 2 14.5731C2 16.4672 3.55098 18.0173 5.48242 18.0175C7.41405 18.0175 8.96582 16.4674 8.96582 14.5731C8.96544 12.6792 7.41382 11.1288 5.48242 11.1288ZM18.5176 11.1288C16.5862 11.1288 15.0345 12.6792 15.0342 14.5731C15.0342 16.4674 16.5859 18.0175 18.5176 18.0175C20.449 18.0173 22 16.4672 22 14.5731C21.9996 12.6793 20.4488 11.129 18.5176 11.1288ZM8.5127 6.06043C7.99194 5.9017 7.28795 6.03243 6.74414 6.79188L5.07617 9.14442C5.21034 9.13463 5.3458 9.1288 5.48242 9.12879C6.94498 9.12879 8.27599 9.70056 9.26074 10.6307L9.49902 7.4911C9.48883 6.70092 9.03531 6.21992 8.5127 6.06043ZM17.2559 6.79188C16.712 6.03241 16.0081 5.9017 15.4873 6.06043C14.9647 6.21992 14.5112 6.7009 14.501 7.4911L14.7393 10.6307C15.724 9.70055 17.055 9.12879 18.5176 9.12879C18.6542 9.1288 18.7897 9.13463 18.9238 9.14442L17.2559 6.79188Z" fill="currentColor"/></symbol><symbol id="market-icon-up-down-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="up-down" data-tintable="true" data-width="24" data-height="24"><path d="M18.4999 4.5V16.5859L21.2928 13.793L22.7069 15.207L18.2069 19.707C18.0194 19.8946 17.7651 20 17.4999 20C17.2678 20 17.044 19.9193 16.8661 19.7734L16.7928 19.707L12.2928 15.207L13.7069 13.793L16.4999 16.5859V4.5H18.4999Z" fill="currentColor"/><path d="M6.49988 4C6.76509 4 7.01937 4.10544 7.20691 4.29297L11.7069 8.79297L10.2928 10.207L7.49988 7.41406V19.5H5.49988V7.41406L2.70691 10.207L1.29285 8.79297L5.79285 4.29297L5.86609 4.22656C6.04404 4.08073 6.26779 4 6.49988 4Z" fill="currentColor"/></symbol><symbol id="market-icon-sliders-horizontal-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="sliders-horizontal" data-tintable="true" data-width="24" data-height="24"><path d="M19 16H22V18H19V21H17V13H19V16Z" fill="currentColor"/><path d="M15 18H2V16H15V18Z" fill="currentColor"/><path d="M11 6H22V8H11V11H9V3H11V6Z" fill="currentColor"/><path d="M7 8H2V6H7V8Z" fill="currentColor"/></symbol><symbol id="market-icon-cycle-backward-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="cycle-backward" data-tintable="true" data-width="24" data-height="24"><path d="M9.20731 4.20703L6.41434 7H15.0003C18.59 7.0002 21.5003 9.91025 21.5003 13.5C21.5003 17.0897 18.59 19.9998 15.0003 20H11.5003V18H15.0003C17.4854 17.9998 19.5003 15.9852 19.5003 13.5C19.5003 11.0148 17.4854 9.0002 15.0003 9H6.41434L9.20731 11.793L7.79324 13.207L3.29324 8.70703C2.90273 8.31652 2.90275 7.6835 3.29324 7.29297L7.79324 2.79297L9.20731 4.20703Z" fill="currentColor"/></symbol><symbol id="market-icon-cycle-forward-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="cycle-forward" data-tintable="true" data-width="24" data-height="24"><path d="M21.2074 7.29297C21.5977 7.68345 21.5977 8.31656 21.2074 8.70703L16.7074 13.207L15.2933 11.793L18.0863 9H9.50037C7.01508 9.00002 5.00037 11.0147 5.00037 13.5C5.00038 15.9853 7.01509 18 9.50037 18H13.0004V20H9.50037C5.91052 20 3.00038 17.0898 3.00037 13.5C3.00037 9.91014 5.91051 7.00002 9.50037 7H18.0863L15.2933 4.20703L16.7074 2.79297L21.2074 7.29297Z" fill="currentColor"/></symbol><symbol id="market-icon-pencil-writing-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="pencil-writing" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.3992 3.2097C14.7876 2.90757 15.3468 2.93207 15.7078 3.28099L19.2693 6.72337C19.4653 6.91289 19.5752 7.17434 19.574 7.447C19.5727 7.71968 19.4602 7.98001 19.2625 8.16771L9.18823 17.7253C9.08874 17.8197 8.97043 17.8923 8.84156 17.9392L8.67554 17.9997H19.9998V19.9997H2.99976C2.67357 19.9997 2.36757 19.8401 2.18042 19.573C1.99353 19.3059 1.94888 18.9643 2.0603 18.6579L4.0603 13.1579L4.1062 13.0515C4.15801 12.9482 4.22705 12.8541 4.31128 12.7742L14.324 3.27415L14.3992 3.2097ZM5.85816 14.0632L4.67066 17.3279L7.9607 16.1316L17.1277 7.43529L15.0056 5.38353L5.85816 14.0632Z" fill="currentColor"/></symbol><symbol id="market-icon-image-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="image" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4316 9.67773C11.7977 9.42433 12.293 9.44176 12.6406 9.73145L18.6406 14.7314C18.964 15.001 19.0837 15.445 18.9404 15.8408C18.797 16.2365 18.4209 16.5 18 16.5H6C5.57909 16.5 5.20298 16.2365 5.05957 15.8408C4.91626 15.445 5.03601 15.001 5.35938 14.7314L11.3594 9.73145L11.4316 9.67773ZM8.7627 14.5H15.2373L12 11.8018L8.7627 14.5Z" fill="currentColor"/><path d="M7 7.5C7.82843 7.5 8.5 8.17157 8.5 9C8.5 9.82843 7.82843 10.5 7 10.5C6.17157 10.5 5.5 9.82843 5.5 9C5.5 8.17157 6.17157 7.5 7 7.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.5 3.5C22.0523 3.5 22.5 3.94772 22.5 4.5V19.5C22.5 20.0523 22.0523 20.5 21.5 20.5H2.5C1.94772 20.5 1.5 20.0523 1.5 19.5V4.5C1.5 3.94772 1.94772 3.5 2.5 3.5H21.5ZM3.5 18.5H20.5V5.5H3.5V18.5Z" fill="currentColor"/></symbol><symbol id="market-icon-indicator-check-complete-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="indicator-check-complete" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5C16.4183 3.5 20 7.08172 20 11.5C20 15.9183 16.4183 19.5 12 19.5C7.58172 19.5 4 15.9183 4 11.5C4 7.08172 7.58172 3.5 12 3.5ZM10.7998 12.6709L9.00684 10.5801L7.79297 11.6201L10.1934 14.4199L10.2529 14.4834C10.4003 14.6215 10.5956 14.7001 10.7998 14.7002C11.0333 14.7002 11.2552 14.5972 11.4072 14.4199L16.207 8.82031L14.9932 7.7793L10.7998 12.6709Z" fill="currentColor"/></symbol><symbol id="market-icon-indicator-check-incomplete-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="indicator-check-incomplete" data-tintable="true" data-width="24" data-height="24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="currentColor"/></symbol><symbol id="market-icon-indicator-circle-active-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="indicator-circle-active" data-tintable="true" data-width="24" data-height="24"><circle cx="12" cy="12" r="6" stroke="currentColor" stroke-width="4"/></symbol><symbol id="market-icon-indicator-circle-inactive-fidelity-24" viewBox="0 0 24 24" data-fidelity="24" data-name="indicator-circle-inactive" data-tintable="true" data-width="24" data-height="24"><circle cx="12" cy="12" r="4" fill="currentColor"/></symbol></svg>\n';
            const e3 = t3.querySelector(n$i);
            e3.style.display = "none", document.body.append(e3), t3.remove();
        }
        const s2 = d$8.core.icon[this.name];
        s2 ? (a2 = function(t3) {
            const e3 = Object.keys(t3).filter((t4)=>t4.includes("fidelity")).find((e4)=>t3[e4].default ? t3[e4].size : null);
            return e3 ? t3[e3].size : void 0;
        }(s2), i2 = function(t3, e3) {
            return !!r$8(t3, e3);
        }(this.fidelity, s2) ? this.fidelity : a2, l2 = r$8(i2, s2), e2 = null == l2 ? void 0 : l2.asset) : (e2 = this.name, h2 = o$8(e2, this.fidelity), a2 = Number.parseInt(null == h2 ? void 0 : h2.dataset.fidelity, 10), i2 = function(t3, e3) {
            return !!o$8(t3, e3);
        }(e2, this.fidelity) ? this.fidelity : a2), h2 = o$8(e2, i2);
        const { width: c2, height: C } = this.getDimensions(h2, l2, i2);
        h2 && this.cloneSymbol(h2, e2, c2, C), this.width = c2, this.height = C, this.tintable = null === (t2 = null == l2 ? void 0 : l2.tintable) || void 0 === t2 || t2;
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "c67ab19847ebe46bec0ff7d5d69de9b407742252",
            class: "market-icon",
            tintable: this.tintable,
            style: {
                "--icon-width": this.width + "px",
                "--icon-height": this.height + "px"
            }
        }, (0, $696Z8.h)("slot", {
            key: "e6a93674c3da1ac955a3606963d1833384033527"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return '@property --icon-width{syntax:"<length>";inherits:false;initial-value:24px}@property --icon-height{syntax:"<length>";inherits:false;initial-value:24px}:host{display:inline-block;width:var(--icon-width);height:var(--icon-height);color:inherit}:host([tintable]) ::slotted(svg){fill:currentcolor}:host([tintable]) ::slotted(svg) path,:host([tintable]) ::slotted(svg) circle,:host([tintable]) ::slotted(svg) rect,:host([tintable]) ::slotted(svg) polygon,:host([tintable]) ::slotted(svg) ellipse,:host([tintable]) ::slotted(svg) line,:host([tintable]) ::slotted(svg) polyline{fill:inherit}::slotted(svg){display:block;width:100%;height:100%}';
    }
}, [
    257,
    "market-icon",
    {
        name: [
            513
        ],
        fidelity: [
            514
        ]
    }
]), s$h = h$9;
const n$h = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "8affdc43a2a623c439ca239d257a4e5127c5f76b"
        }, (0, $696Z8.h)("slot", {
            key: "d3425b6c26239524067478d389c4fa42b4897d9f"
        }), (0, $696Z8.h)("slot", {
            key: "a0b3a0ace75deff470ca111c8e91baedd600c033",
            name: "trailing-accessory"
        }));
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;justify-content:space-between;align-items:center}";
    }
}, [
    257,
    "market-inline-section-header"
]), i$b = n$h;
const a$f = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.variant = "info";
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "629c5aaa83f5185a953e714c14aeb054403d3b62",
            class: "market-inline-status"
        }, (0, $696Z8.h)("slot", {
            key: "6fbedfa49361c7737a0a4db86dafce3d6242df7f",
            name: "icon"
        }, "info" === this.variant && (0, $696Z8.h)("svg", {
            class: "icon",
            width: "20",
            height: "20",
            viewBox: "-2 -2 26 26",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19ZM11 10.5V17H13V10.5H11ZM13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z"
        })), "success" === this.variant && (0, $696Z8.h)("svg", {
            class: "icon",
            width: "20",
            height: "20",
            viewBox: "-2 -2 26 26",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12ZM5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5C8.14 5 5 8.14 5 12ZM8.71005 10.8L11 13.09L15.3101 8.80005L16.72 10.21L11.72 15.21C11.52 15.4 11.27 15.5 11.01 15.5C10.75 15.5 10.5 15.41 10.3 15.21L7.30005 12.21L8.71005 10.8Z"
        })), "warning" === this.variant && (0, $696Z8.h)("svg", {
            class: "icon",
            width: "20",
            height: "20",
            viewBox: "-2 -2 26 26",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M11 9.00005H13V14.5H11V9.00005Z"
        }), (0, $696Z8.h)("path", {
            d: "M12 18C12.6904 18 13.25 17.4404 13.25 16.75C13.25 16.0596 12.6904 15.5 12 15.5C11.3096 15.5 10.75 16.0596 10.75 16.75C10.75 17.4404 11.3096 18 12 18Z"
        }), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.866 2.17944C12.6874 1.87004 12.3573 1.67944 12 1.67944C11.6427 1.67944 11.3126 1.87004 11.134 2.17944L1.13397 19.5C0.955342 19.8094 0.955342 20.1905 1.13397 20.5C1.31261 20.8094 1.64273 21 2 21H22C22.3573 21 22.6874 20.8094 22.866 20.5C23.0447 20.1905 23.0447 19.8094 22.866 19.5L12.866 2.17944ZM12 4.67944L20.268 19H3.73205L12 4.67944Z"
        })), "critical" === this.variant && (0, $696Z8.h)("svg", {
            class: "icon",
            width: "20",
            height: "20",
            viewBox: "-2 -2 26 26",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21ZM12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5ZM12 17C12.6904 17 13.25 16.4404 13.25 15.75C13.25 15.0596 12.6904 14.5 12 14.5C11.3096 14.5 10.75 15.0596 10.75 15.75C10.75 16.4404 11.3096 17 12 17ZM11 7H13V13.5H11V7Z"
        }))), (0, $696Z8.h)("slot", {
            key: "d3478a1e4afde8edeb48eec3c4384e6951ba6fae"
        }));
    }
    static get style() {
        return ':host{display:flex;align-items:flex-start;font-weight:var(--inline-status-normal-size-text-weight);font-size:var(--inline-status-normal-size-text-size);font-family:var(--inline-status-normal-size-text-font-family);line-height:var(--inline-status-normal-size-text-leading);letter-spacing:var(--inline-status-normal-size-text-tracking);text-transform:var(--inline-status-normal-size-text-case)}:host .icon,:host ::slotted([slot="icon"]){flex-shrink:0;margin-right:var(--inline-status-normal-size-spacing-horizontal)}:host([variant="info"]){color:var(--core-text-20-color)}:host([variant="info"]) .icon,:host([variant="info"]) ::slotted([slot="icon"]){fill:var(--core-fill-20-color)}:host([variant="critical"]){color:var(--inline-status-error-variant-icon-color)}:host([variant="critical"]) .icon,:host([variant="critical"]) ::slotted([slot="icon"]){fill:var(--inline-status-error-variant-text-color)}:host([variant="success"]){color:var(--inline-status-success-variant-icon-color)}:host([variant="success"]) .icon,:host([variant="success"]) ::slotted([slot="icon"]){fill:var(--inline-status-success-variant-text-color)}:host([variant="warning"]){color:var(--inline-status-warning-variant-icon-color)}:host([variant="warning"]) .icon,:host([variant="warning"]) ::slotted([slot="icon"]){fill:var(--inline-status-warning-variant-icon-color)}';
    }
}, [
    257,
    "market-inline-status",
    {
        variant: [
            513
        ]
    }
]), o$7 = a$f;
function t(t2) {
    const o = t2.closest("form");
    if (o) {
        const t3 = o.querySelector('[type="submit"]:not(disabled)');
        t3 && t3.click();
    }
}
const a$e = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.size = "large", this.type = "password";
    }
    async setFocus(e2 = true) {
        this.disabled || this.readonly || (this.focused = e2, await this.marketInputText.setFocus(e2));
    }
    registerSlottedInput() {
        var e2;
        this.slottedInput = this.el.querySelector("input[slot=input]"), this.slottedInput && (null === (e2 = this.marketInputText) || void 0 === e2 ? void 0 : e2.registerSlottedInput) && this.marketInputText.registerSlottedInput(this.slottedInput);
    }
    togglePasswordVisibility(e2) {
        this.type = "password" === this.type ? "text" : "password", e2.stopPropagation();
    }
    handleKeyDown(e2) {
        "Enter" !== e2.key || e2.isComposing || t(this.el);
    }
    renderSvgHidden() {
        return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M16.5481 17.9609L16.55 17.96L19.3 20.71L20.71 19.3L18.31 16.9C19.81 15.78 21.06 14.27 21.91 12.43C22.03 12.16 22.03 11.85 21.91 11.59C20.03 7.52004 16.23 5.00004 12 5.00004C10.39 5.00004 8.85 5.37004 7.45 6.04004L4.71 3.29004L3.29361 4.70643L14.0183 15.4311L14.02 15.43L15.01 16.42L15.008 16.4208L16.5481 17.9609ZM11.49 10.07L13.93 12.51C13.97 12.35 14 12.18 14 12C14 10.9 13.1 10 12 10C11.82 10 11.65 10.03 11.49 10.07ZM15.43 14.02L16.86 15.45C18.09 14.6 19.14 13.43 19.89 12C18.28 8.90004 15.29 7.00004 12 7.00004C10.95 7.00004 9.94 7.21004 8.99 7.58004L9.98 8.57004C10.57 8.22004 11.26 8.00004 12 8.00004C14.21 8.00004 16 9.79004 16 12C16 12.74 15.79 13.43 15.43 14.02Z"
        }), (0, $696Z8.h)("path", {
            d: "M11.7512 15.9924L8.0076 12.2488C8.13092 14.2606 9.73948 15.8691 11.7512 15.9924Z"
        }), (0, $696Z8.h)("path", {
            d: "M5.61696 9.8582C5.03307 10.4841 4.52321 11.2015 4.11 12C5.72 15.1 8.71 17 12 17C12.244 17 12.4859 16.9887 12.7254 16.9666L14.4639 18.7052C13.6686 18.8984 12.8439 19 12 19C7.77 19 3.97 16.48 2.09 12.42C1.97 12.16 1.97 11.85 2.09 11.58C2.63958 10.3904 3.35638 9.33864 4.19985 8.44109L5.61696 9.8582Z"
        }));
    }
    renderSvgVisible() {
        return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M2.09 11.58C3.97 7.52 7.77 5 12 5C16.23 5 20.03 7.52 21.91 11.58C22.03 11.84 22.03 12.15 21.91 12.42C20.03 16.48 16.23 19 12 19C7.77 19 3.97 16.48 2.09 12.42C1.97 12.16 1.97 11.85 2.09 11.58ZM4.11 12C5.72 15.1 8.71 17 12 17C15.29 17 18.28 15.1 19.89 12C18.28 8.9 15.29 7 12 7C8.71 7 5.72 8.9 4.11 12ZM8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12Z"
        }));
    }
    render() {
        const e2 = l$s("market-input-text"), t2 = l$s("market-accessory");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "4f2ba32b990cff6bd8ba6f3d325cbefad88d7c97",
            class: "market-input-password",
            onKeyDown: (e3)=>{
                this.handleKeyDown(e3);
            }
        }, (0, $696Z8.h)(e2, {
            key: "35d07d344c03fc9253df124d2c02d6c75b3e43ef",
            type: this.type,
            ref: (e3)=>this.marketInputText = e3,
            onBlur: ()=>{},
            onClick: ()=>{},
            onFocus: ()=>{},
            inputId: this.inputId,
            name: this.name,
            placeholder: this.placeholder,
            maxlength: this.maxlength,
            minlength: this.minlength,
            size: this.size,
            value: this.value,
            readonly: this.readonly,
            required: this.required,
            disabled: this.disabled,
            invalid: this.invalid,
            autocomplete: this.autocomplete,
            inputmode: this.inputmode
        }, (0, $696Z8.h)("slot", {
            key: "7d22039b47e221b4ec3ac55ecbabeab59b95503f"
        }), (0, $696Z8.h)("slot", {
            key: "ae0866e43a9e8558e89dc07ae6953ee2c9b3e80a",
            name: "input",
            onSlotchange: ()=>this.registerSlottedInput(),
            slot: this.slottedInput ? "input" : ""
        }), (0, $696Z8.h)(t2, {
            key: "57ddbf92a09ccfcbb2ec045a548667e6d9dc6134",
            slot: "trailing-accessory",
            size: "image"
        }, (0, $696Z8.h)("button", {
            key: "76086f9933fd77aeda8db8dc2d06d5007ff3142d",
            class: "toggle",
            onClick: (e3)=>{
                this.togglePasswordVisibility(e3);
            },
            onKeyDown: (e3)=>{
                e3.stopPropagation();
            }
        }, "password" === this.type && this.renderSvgHidden(), "text" === this.type && this.renderSvgVisible()))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--focus-ring-color:color-mix(in srgb, var(--core-focus-ring-color) 100%, transparent);display:block}:host ::slotted(input:focus-visible){outline:none}.toggle{display:flex;flex-shrink:0;justify-content:center;align-items:center;width:100%;height:100%;margin:0;border:none;background:transparent;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.toggle svg{display:block;fill:var(--core-text-20-color)}.toggle:focus-visible{border-radius:var(--core-radius-10);outline:var(--core-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:calc(var(--core-focus-ring-border-size) * -1)}";
    }
}, [
    257,
    "market-input-password",
    {
        inputId: [
            1,
            "input-id"
        ],
        name: [
            1
        ],
        value: [
            1
        ],
        placeholder: [
            1
        ],
        maxlength: [
            2
        ],
        minlength: [
            2
        ],
        size: [
            513
        ],
        readonly: [
            4
        ],
        required: [
            4
        ],
        disabled: [
            4
        ],
        focused: [
            1028
        ],
        invalid: [
            4
        ],
        autocomplete: [
            8
        ],
        inputmode: [
            1
        ],
        type: [
            32
        ],
        setFocus: [
            64
        ]
    }
]), l$d = a$e;
var e$5;
function a$d(a2) {
    switch(a2){
        case "":
        case true:
        case e$5.ON:
        case e$5.TRUE:
            return e$5.ON;
        case false:
        case e$5.OFF:
        case e$5.FALSE:
            return e$5.OFF;
        default:
            return a2;
    }
}
!function(e2) {
    e2.TRUE = "true", e2.FALSE = "false", e2.ON = "on", e2.OFF = "off";
}(e$5 || (e$5 = {}));
const h$8 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketInputSearchCleared = (0, $696Z8.createEvent)(this, "marketInputSearchCleared", 7), this.marketInputSearchValueChange = (0, $696Z8.createEvent)(this, "marketInputSearchValueChange", 7), this.marketInputSearchFocus = (0, $696Z8.createEvent)(this, "marketInputSearchFocus", 7), this.marketInternalInputSearchCompactAnimation = (0, $696Z8.createEvent)(this, "marketInternalInputSearchCompactAnimation", 7), this.marketInputSearchDidLoad = (0, $696Z8.createEvent)(this, "marketInputSearchDidLoad", 7), this.internals = this.attachInternals(), this.value = "", this.placeholder = "", this.size = "medium", this.variant = "medium", this.disabled = false, this.focused = false, this.autofocus = false, this.autocomplete = true, this.inputAriaLabel = "Search", this.clearButtonAriaLabel = "Clear", this.searchIconButtonAriaLabel = "Search icon", this.compact = false, this.boundHandleValueChange = null, this.boundHandleFocus = null, this.boundHandleBlur = null, this.boundHandleKeyDown = null;
    }
    focusedWatcher(t2, e2) {
        t2 !== e2 && t2 && this.nativeInputEl.focus();
    }
    disabledWatcher(t2) {
        t2 && this.focused && this.setFocus(false);
    }
    autocompleteWatcher(t2) {
        this._autocomplete = a$d(t2);
    }
    handleMarketDialogLoaded() {
        this.autofocus && this.setFocus();
    }
    setFocus(t2 = true) {
        if (this.disabled && t2 || this.focused === t2) return Promise.resolve();
        const { defaultPrevented: e2 } = this.marketInputSearchFocus.emit(t2);
        return e2 || (this.focused = t2, !t2 && this.nativeInputEl && this.nativeInputEl.blur()), Promise.resolve();
    }
    clearInput() {
        return this.marketInputSearchCleared.emit().defaultPrevented || "" === this.value || this.marketInputSearchValueChange.emit({
            current: "",
            prevValue: this.value,
            originalEvent: null,
            value: ""
        }).defaultPrevented || (this.value = ""), Promise.resolve();
    }
    async handleClearButtonClicked() {
        await this.clearInput(), this.clearButtonClicked = true;
    }
    handleValueChange(t2) {
        const e2 = t2.target;
        if (!e2) return;
        const { defaultPrevented: a2 } = this.marketInputSearchValueChange.emit({
            current: e2.value,
            prevValue: this.value,
            originalEvent: t2,
            value: e2.value
        });
        a2 ? t2.preventDefault() : (this.updateElementInternals(), this.value = e2.value);
    }
    handleAnimation(t2) {
        this.compact && ("market-input-search-compact-enter" === t2.animationName && "animationstart" === t2.type && this.focused ? (this.marketInternalInputSearchCompactAnimation.emit(t2.type), window.requestAnimationFrame(()=>{
            var t3;
            null === (t3 = this.nativeInputEl) || void 0 === t3 || t3.focus();
        })) : "market-input-search-compact-exit" === t2.animationName && "animationend" === t2.type && this.marketInternalInputSearchCompactAnimation.emit(t2.type));
    }
    handleAccessoryClicked(t2, e2) {
        e2 && (t2.stopPropagation(), this.setFocus(false));
    }
    handleKeyDown(t2) {
        "Enter" !== t2.key || t2.isComposing || t(this.el);
    }
    registerSlottedInput(t2) {
        var e2;
        this.slottedInputEl = t2 || this.el.querySelector("input[slot=input]") || (null === (e2 = this.el.getRootNode().host) || void 0 === e2 ? void 0 : e2.querySelector("input[slot=input]")), this.slottedInputEl && (this.boundHandleValueChange = (t3)=>this.handleValueChange(t3), this.boundHandleFocus = ()=>this.setFocus(), this.boundHandleBlur = ()=>this.setFocus(false), this.boundHandleKeyDown = (t3)=>this.handleKeyDown(t3), this.slottedInputEl.addEventListener("input", this.boundHandleValueChange), this.slottedInputEl.addEventListener("focus", this.boundHandleFocus), this.slottedInputEl.addEventListener("blur", this.boundHandleBlur), this.slottedInputEl.addEventListener("keydown", this.boundHandleKeyDown), this.nativeInputEl = this.slottedInputEl);
    }
    removeSlottedInputListeners() {
        this.slottedInputEl && (this.boundHandleValueChange && this.slottedInputEl.removeEventListener("input", this.boundHandleValueChange), this.boundHandleFocus && this.slottedInputEl.removeEventListener("focus", this.boundHandleFocus), this.boundHandleBlur && this.slottedInputEl.removeEventListener("blur", this.boundHandleBlur), this.boundHandleKeyDown && this.slottedInputEl.removeEventListener("keydown", this.boundHandleKeyDown));
    }
    disconnectedCallback() {
        this.removeSlottedInputListeners();
    }
    updateSharedInputProps() {
        const t2 = Object.assign({}, this.sharedProps);
        this.sharedProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this._autocomplete && {
            autocomplete: this._autocomplete
        }), this.autofocus && {
            autofocus: this.autofocus
        }), this.disabled && {
            disabled: this.disabled
        }), this.maxlength >= 0 && {
            maxlength: this.maxlength
        }), this.name && {
            name: this.name
        }), this.placeholder && {
            placeholder: this.placeholder
        }), void 0 !== this.value && {
            value: this.value
        }), this.slottedInputEl && [
            .../* @__PURE__ */ new Set([
                ...Object.keys(t2),
                ...Object.keys(this.sharedProps)
            ])
        ].forEach((t3)=>{
            if (t3 in this.sharedProps) {
                const e2 = true === this.sharedProps[t3] ? "" : this.sharedProps[t3];
                "value" === t3 ? this.slottedInputEl.value = e2 : false === e2 ? this.slottedInputEl.removeAttribute(t3) : this.slottedInputEl.setAttribute(t3, e2);
            } else this.slottedInputEl.removeAttribute(t3);
        });
    }
    updateElementInternals() {
        var t2, e2, a2, i2;
        this.internals && (null === (e2 = (t2 = this.internals).setFormValue) || void 0 === e2 || e2.call(t2, this.value), this.nativeInputEl && (null === (i2 = (a2 = this.internals).setValidity) || void 0 === i2 || i2.call(a2, this.nativeInputEl.validity, this.nativeInputEl.validationMessage)));
    }
    componentWillLoad() {
        this.el.classList.add("preload"), this.autocompleteWatcher(this.autocomplete), this.registerSlottedInput(), this.updateSharedInputProps(), this.updateElementInternals();
    }
    componentWillUpdate() {
        this.updateSharedInputProps(), this.updateElementInternals();
    }
    componentDidLoad() {
        this.el.classList.remove("preload"), this.marketInputSearchDidLoad.emit(), this.autofocus && !this.focused && this.setFocus();
    }
    render() {
        const t2 = this.compact && this.focused, e2 = this.el.querySelector("input:focus") ? -1 : void 0, a2 = l$s("market-accessory");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ca1c27f84d26cbb53a02f69e583931b21604fa4b",
            class: "market-input-search",
            onAnimationEnd: (t3)=>this.handleAnimation(t3),
            onAnimationStart: (t3)=>this.handleAnimation(t3),
            onBlur: ()=>{
                var t3;
                this.clearButtonClicked ? (null === (t3 = this.nativeInputEl) || void 0 === t3 || t3.focus(), this.clearButtonClicked = false) : this.setFocus(false);
            },
            onClick: (t3)=>{
                t3.stopPropagation(), this.setFocus();
            },
            onFocus: ()=>this.setFocus(),
            tabindex: e2
        }, (0, $696Z8.h)("button", {
            key: "eb486d9f8a8f9a50e171d2ce2f587281d9219d96",
            class: t$a("leading-accessory", {
                "is-back-icon": t2
            }),
            "aria-label": this.searchIconButtonAriaLabel,
            onClick: (e3)=>this.handleAccessoryClicked(e3, t2),
            "aria-hidden": t2 ? "false" : "true",
            tabindex: t2 ? "0" : "-1"
        }, (0, $696Z8.h)("slot", {
            key: "98ab223cc1bfa849a49bfcb9f0f81d7cdf9add99",
            name: "leading-accessory"
        }, (0, $696Z8.h)(a2, {
            key: "f133419b8c4970d2e732dcf1380d0f2cc750ed79",
            size: "icon",
            tabindex: "-1",
            "aria-hidden": "true"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", t2 ? {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 11.2929C3.90237 11.6834 3.90237 12.3166 4.29289 12.7071L11.2929 19.7071L12.7071 18.2929L7.41421 13L19 13V11H7.41421L12.7071 5.70712L11.2929 4.29291L4.29289 11.2929Z"
        } : {
            d: "M10.5 17.4998C12.07 17.4998 13.52 16.9698 14.68 16.0998L18.79 20.2098L20.2 18.7998L16.09 14.6898C16.97 13.5198 17.49 12.0798 17.49 10.5098C17.49 6.64983 14.35 3.50983 10.49 3.50983C6.62999 3.50983 3.48999 6.64983 3.48999 10.5098C3.48999 14.3698 6.63999 17.4998 10.5 17.4998ZM10.5 5.49983C13.26 5.49983 15.5 7.73983 15.5 10.4998C15.5 13.2598 13.26 15.4998 10.5 15.4998C7.73999 15.4998 5.49999 13.2598 5.49999 10.4998C5.49999 7.73983 7.73999 5.49983 10.5 5.49983Z"
        }))))), (0, $696Z8.h)("div", {
            key: "dc3255a766003454e15f050e5dace91115ce611d",
            class: "input-container"
        }, (0, $696Z8.h)("slot", {
            key: "174081a615eca749cefd7b86decd56171e65b5ea",
            name: "input",
            onSlotchange: ()=>this.registerSlottedInput()
        }, !this.slottedInputEl && (0, $696Z8.h)("input", Object.assign({
            key: "35cc2750fc4d131b1de288e73f4564b2c1f87a31",
            "aria-label": this.inputAriaLabel,
            onInput: (t3)=>this.handleValueChange(t3),
            onKeyDown: (t3)=>{
                this.handleKeyDown(t3);
            },
            part: "native-input",
            ref: (t3)=>this.nativeInputEl = t3,
            type: "text"
        }, this.sharedProps)))), (0, $696Z8.h)("slot", {
            key: "50b3a112a86ff432f629170ce544b1784a9fcea6",
            name: "trailing-accessory"
        }), (0, $696Z8.h)("button", {
            key: "489a8d0850ca5a547f6c0eeb065f4cdeb3a1896b",
            "aria-label": this.clearButtonAriaLabel,
            class: t$a("clear-button", {
                hidden: !this.value || this.disabled
            }),
            onClick: this.handleClearButtonClicked.bind(this),
            tabindex: "0"
        }, (0, $696Z8.h)("svg", {
            key: "bab760b1b4c7f176cc3d92f6b21c2c706828b696",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "fbad167a73e865248c49daa32cf8b1d60c1074b2",
            d: "M6.71004 18.71L12 13.41L17.29 18.71L18.71 17.29L13.41 12L18.71 6.71004L17.29 5.29004L12 10.59L6.71004 5.29004L5.29004 6.71004L10.59 12L5.29004 17.29L6.71004 18.71Z"
        }))));
    }
    static get formAssociated() {
        return true;
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            focused: [
                {
                    focusedWatcher: 0
                }
            ],
            disabled: [
                {
                    disabledWatcher: 0
                }
            ],
            autocomplete: [
                {
                    autocompleteWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-grow:1;flex-direction:row;align-items:center;border-radius:var(--search-border-radius);background-color:var(--search-normal-state-background-color, var(--field-normal-state-background-color));color:var(--search-normal-state-input-color);box-shadow:inset 0 0 0 var(--search-border-size) var(--search-normal-state-border-color);font-weight:var(--search-input-weight);font-size:var(--search-input-size);font-family:var(--search-input-font-family);line-height:var(--search-input-leading);letter-spacing:var(--search-input-tracking);text-transform:var(--search-input-case);cursor:text;transition-property:flex, padding}:host(:hover){box-shadow:inset 0 0 0 var(--search-border-size) var(--search-normal-state-border-color)}:host([focused]){box-shadow:inset 0 0 0 var(--search-focused-state-border-size) var(--search-focused-state-border-color)}:host([size="medium"]),:host([variant="medium"]){gap:var(--search-large-size-spacing-horizontal);padding:var(--search-large-size-padding-vertical) var(--search-large-size-padding-horizontal)}:host([size="small"]),:host([variant="small"]){gap:var(--search-normal-size-spacing-horizontal);padding:var(--search-normal-size-padding-vertical) var(--search-normal-size-padding-horizontal)}input,::slotted(input){display:block;width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;outline:none;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;text-transform:inherit}input::-moz-placeholder,::slotted(input::-moz-placeholder){color:var(--search-hint-text-color)}input::placeholder,::slotted(input::placeholder){color:var(--search-hint-text-color)}button{display:flex;justify-content:center;align-items:center;margin:0;padding:0;border:none;background-color:transparent;cursor:pointer}button svg{display:block;color:inherit;fill:currentcolor}.input-container{flex:1}.leading-accessory{color:var(--search-normal-state-leading-icon-color)}.clear-button{color:var(--search-normal-state-trailing-icon-color)}.hidden{display:none}:host([compact]:not([focused])){flex:0;cursor:pointer;transition-timing-function:var(--core-animation-exit-transition-easing);transition-duration:var(--core-animation-exit-transition-fast-speed-duration);animation-name:market-input-search-compact-exit;animation-duration:var(--core-animation-exit-transition-fast-speed-duration)}:host([compact]:not([focused])) .leading-accessory{pointer-events:none}:host([compact]:not([focused])) .input-container{position:absolute;width:0;pointer-events:none}:host([compact]:not([focused])) ::slotted([slot="trailing-accessory"]),:host([compact]:not([focused])) .clear-button{display:none}:host([size="medium"][compact]:not([focused])),:host([variant="medium"][compact]:not([focused])){padding:var(--search-large-size-padding-vertical)}:host([size="small"][compact]:not([focused])),:host([variant="small"][compact]:not([focused])){padding:var(--search-normal-size-padding-vertical)}:host([compact][focused]){flex:1;transition-timing-function:var(--core-animation-enter-transition-easing);transition-duration:var(--core-animation-enter-transition-fast-speed-duration);animation-name:market-input-search-compact-enter;animation-duration:var(--core-animation-enter-transition-fast-speed-duration)}:host([compact]:not([focused]):hover){border-color:var(--core-fill-30-color);background-color:var(--core-fill-40-color)}:host(:not([value=""])) ::slotted([slot="trailing-accessory"]){display:none}:host([disabled]){color:var(--search-disabled-state-input-color);box-shadow:inset 0 0 0 var(--search-border-size) var(--search-disabled-state-border-color);cursor:not-allowed}:host([disabled]) .leading-accessory{color:var(--search-disabled-state-leading-icon-color)}:host([disabled]) .clear-button{color:var(--search-disabled-state-trailing-icon-color)}:host(.preload){transition:none !important;}input:-webkit-autofill,::slotted(input:-webkit-autofill){box-shadow:0 0 0 var(--search-input-leading) var(--search-normal-state-background-color) inset !important;-webkit-text-fill-color:var(--search-normal-state-input-color) !important;caret-color:var(--search-normal-state-input-color)}:host input:-webkit-autofill,:host ::slotted(input:-webkit-autofill){animation-name:market-input-autofill-start}:host input:not(:-webkit-autofill),:host ::slotted(input:not(:-webkit-autofill)){animation-name:market-input-autofill-cancel}.input-container:focus-visible,input:focus-visible,::slotted(input:focus-visible){outline:none}';
    }
}, [
    321,
    "market-input-search",
    {
        value: [
            1537
        ],
        placeholder: [
            1
        ],
        maxlength: [
            2
        ],
        size: [
            513
        ],
        variant: [
            513
        ],
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        autofocus: [
            4
        ],
        autocomplete: [
            8
        ],
        name: [
            1
        ],
        inputAriaLabel: [
            1,
            "input-aria-label"
        ],
        clearButtonAriaLabel: [
            1,
            "clear-button-aria-label"
        ],
        searchIconButtonAriaLabel: [
            1,
            "search-icon-button-aria-label"
        ],
        compact: [
            4
        ],
        setFocus: [
            64
        ],
        clearInput: [
            64
        ]
    },
    [
        [
            8,
            "marketDialogLoaded",
            "handleMarketDialogLoaded"
        ]
    ],
    {
        focused: [
            {
                focusedWatcher: 0
            }
        ],
        disabled: [
            {
                disabledWatcher: 0
            }
        ],
        autocomplete: [
            {
                autocompleteWatcher: 0
            }
        ]
    }
]), d$7 = h$8;
const h$7 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketInputValueChange = (0, $696Z8.createEvent)(this, "marketInputValueChange", 7), this.marketInputDidLoad = (0, $696Z8.createEvent)(this, "marketInputDidLoad", 7), this.internals = this.attachInternals(), this.type = "text", this.value = "", this.size = "large", this.readonly = false, this.disabled = false, this.focused = false, this.invalid = false, this.autofocus = false, this.autocomplete = true, this.autovalidate = false, this.autofilled = false, this.sharedProps = {}, this.hasLeadingAccessory = false, this.hasTrailingAccessory = false;
    }
    focusedChangeHandler(t2) {
        this.nativeInput && t2 && this.nativeInput.focus();
    }
    autocompleteWatcher(t2) {
        this._autocomplete = a$d(t2);
    }
    handleMarketDialogLoaded() {
        this.autofocus && this.setFocus();
    }
    valueDidChange(t2) {
        this.marketInputValueChange.emit({
            value: t2.target.value,
            originalEvent: t2
        }).defaultPrevented ? (t2.target.value = this.value, t2.preventDefault()) : (this.value = t2.target.value, this.updateElementInternals(), (this.autovalidate || this.validatingThroughSubmission) && (this.invalid = !this.nativeInput.checkValidity())), this.autofilled = false;
    }
    handleAutofill(t2) {
        "market-input-autofill-start" === t2.animationName ? this.autofilled = true : "market-input-autofill-cancel" !== t2.animationName || this.value || (this.autofilled = false);
    }
    handleKeyDown(t2) {
        "Enter" !== t2.key || t2.isComposing || ("trigger" === this.el.slot ? t2.preventDefault() : t(this.el));
    }
    handleSubmissionInvalid(t2) {
        t2.preventDefault(), this.validatingThroughSubmission = true, this.invalid = !this.nativeInput.checkValidity();
    }
    setFocus(t2 = true) {
        return this.readonly || this.disabled || (this.focused = t2, !t2 && this.nativeInput && this.nativeInput.blur()), Promise.resolve();
    }
    getInputElement() {
        return Promise.resolve(this.nativeInput);
    }
    registerSlottedInput(t2) {
        var e2;
        return this.slottedInput = t2 || this.el.querySelector("input[slot=input]") || (null === (e2 = this.el.getRootNode().host) || void 0 === e2 ? void 0 : e2.querySelector("input[slot=input]")), this.slottedInput && (this.slottedInput.addEventListener("input", (t3)=>this.valueDidChange(t3)), this.slottedInput.addEventListener("focus", ()=>this.setFocus()), this.slottedInput.addEventListener("blur", ()=>this.focused = false), this.slottedInput.addEventListener("animationstart", (t3)=>this.handleAutofill(t3)), this.nativeInput = this.slottedInput), Promise.resolve();
    }
    updateSharedInputProps() {
        const t2 = Object.assign({}, this.sharedProps);
        this.sharedProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.inputId && {
            id: this.inputId
        }), this.name && {
            name: this.name
        }), this.type && {
            type: this.type
        }), this.placeholder && {
            placeholder: this.placeholder
        }), this.maxlength >= 0 && {
            maxlength: this.maxlength
        }), this.minlength >= 0 && {
            minlength: this.minlength
        }), this.step && {
            step: this.step
        }), this.min && {
            min: this.min
        }), this.max && {
            max: this.max
        }), this.pattern && {
            pattern: this.pattern
        }), void 0 !== this.value && {
            value: this.value
        }), this.readonly && {
            readonly: this.readonly
        }), this.required && {
            required: this.required
        }), this.disabled && {
            disabled: this.disabled
        }), this.autofocus && {
            autofocus: this.autofocus
        }), this.inputmode && {
            inputmode: this.inputmode
        }), this._autocomplete && {
            autocomplete: this._autocomplete
        }), this.ariaAttributes), {
            "aria-label": n$A(this.el)
        }), this.slottedInput && [
            .../* @__PURE__ */ new Set([
                ...Object.keys(t2),
                ...Object.keys(this.sharedProps)
            ])
        ].forEach((t3)=>{
            t3 in this.sharedProps ? this.slottedInput.setAttribute(t3, true === this.sharedProps[t3] ? "" : this.sharedProps[t3]) : this.slottedInput.removeAttribute(t3);
        });
    }
    updateElementInternals() {
        var t2, e2, i2, s2;
        this.internals && (null === (e2 = (t2 = this.internals).setFormValue) || void 0 === e2 || e2.call(t2, this.value), this.nativeInput && (null === (s2 = (i2 = this.internals).setValidity) || void 0 === s2 || s2.call(i2, this.nativeInput.validity, this.nativeInput.validationMessage)));
    }
    componentWillLoad() {
        this.hasLeadingAccessory = !![
            ...this.el.children
        ].some((t2)=>"leading-accessory" === t2.slot), this.hasTrailingAccessory = !![
            ...this.el.children
        ].some((t2)=>"trailing-accessory" === t2.slot), this.mutationObserver = a$q(this.el, (t2)=>{
            this.ariaAttributes = t2;
        }), this.registerSlottedInput(), this.autocompleteWatcher(this.autocomplete), this.updateSharedInputProps(), this.updateElementInternals();
    }
    componentDidLoad() {
        this.marketInputDidLoad.emit({
            input: this.nativeInput
        }), this.autofocus && !this.focused && this.setFocus();
    }
    componentWillUpdate() {
        this.updateSharedInputProps(), this.updateElementInternals();
    }
    disconnectedCallback() {
        var t2;
        null === (t2 = this.mutationObserver) || void 0 === t2 || t2.disconnect();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "b1cb9258a2b3e3c33941c4ecbe02aa5d2ddccbf9",
            class: "market-input-text",
            onBlur: ()=>{
                this.focused = false;
            },
            onClick: ()=>{
                this.setFocus();
            },
            onFocus: ()=>{
                this.setFocus();
            },
            onKeyDown: (t2)=>{
                this.handleKeyDown(t2);
            },
            onInvalid: (t2)=>{
                this.handleSubmissionInvalid(t2);
            }
        }, (0, $696Z8.h)("slot", {
            key: "9b255f96e626da613050b946d14e3dca642d2343",
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            key: "5fdbed28694f877e7dfe041c7e74e646fe6972ec",
            class: t$a("label-input-container", {
                "has-leading-accessory": this.hasLeadingAccessory,
                "has-trailing-accessory": this.hasTrailingAccessory
            })
        }, (0, $696Z8.h)("slot", {
            key: "67b45a942a5cd090eaf63a1efbbf1abf450f5aa1"
        }), (0, $696Z8.h)("slot", {
            key: "44431e2f76d05259cde555fc005ad226c7e5d84b",
            name: "input",
            onSlotchange: ()=>this.registerSlottedInput()
        }, !this.slottedInput && (0, $696Z8.h)("input", Object.assign({
            key: "7a943cd5391aa91f495ce6b67d7899049315811e",
            part: "native-input",
            ref: (t2)=>this.nativeInput = t2,
            onInput: (t2)=>this.valueDidChange(t2),
            onAnimationStart: (t2)=>this.handleAutofill(t2)
        }, this.sharedProps)))), (0, $696Z8.h)("slot", {
            key: "5b41025cf3f01d468589907e3764dae47f60e35e",
            name: "trailing-accessory"
        }));
    }
    static get formAssociated() {
        return true;
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            focused: [
                {
                    focusedChangeHandler: 0
                }
            ],
            autocomplete: [
                {
                    autocompleteWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host input,:host ::slotted(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color);}:host::after{content:"";position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)         var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([readonly]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([disabled]) ::slotted(.market-accessory),:host([disabled]) ::slotted(img[slot*="accessory"]),:host([disabled]) ::slotted(svg[slot*="accessory"]),:host([disabled]) ::slotted(div[slot*="accessory"]){--field-disabled-state-accessory-opacity:var(--row-disabled-state-leading-accessory-opacity);opacity:var(--field-disabled-state-accessory-opacity)}:host([value=""]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=""])) ::slotted(label),:host([value=""][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=""]):hover) ::slotted(label),:host([value=""][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=""][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=""])[disabled]) ::slotted(label),:host([value=""][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{--field-accessory-horizontal-spacing-size:16px;--field-size-small-accessory-horizontal-spacing-size:12px;--field-size-large-image-accessory-outer-spacing-size:12px;--field-size-medium-image-accessory-outer-spacing-size:4px;--field-size-large-button-accessory-outer-spacing-size:12px;--field-size-medium-button-accessory-outer-spacing-size:4px;--field-size-large-tooltip-accessory-horizontal-spacing-size:5px;--field-size-large-tooltip-accessory-vertical-spacing-size:-1px;--field-size-small-tooltip-accessory-horizontal-spacing-size:1px}:host ::slotted([slot="leading-accessory"]){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot="leading-accessory"][size="image"]){margin-left:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot="leading-accessory"]){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)       var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot="leading-accessory"][size="small"]){margin-left:var(--field-size-large-button-accessory-outer-spacing-size)}:host ::slotted([slot="trailing-accessory"]){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot="trailing-accessory"][size="image"]){margin-right:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot="trailing-accessory"]){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)       var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot="trailing-accessory"][size="small"]){margin-right:var(--field-size-large-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot="leading-accessory"][size="image"]){margin-left:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot="leading-accessory"][size="small"]){margin-left:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot="trailing-accessory"][size="image"]){margin-right:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot="trailing-accessory"][size="small"]){margin-right:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='small']) ::slotted([slot="leading-accessory"]),:host([size='small']) ::slotted([slot="trailing-accessory"]){margin-right:var(--field-size-small-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-accessory-horizontal-spacing-size)}:host([size='small']) ::slotted(.market-tooltip[slot="leading-accessory"]),:host([size='small']) ::slotted(.market-tooltip[slot="trailing-accessory"]){margin-right:var(--field-size-small-tooltip-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-tooltip-accessory-horizontal-spacing-size)}:host .label-input-container.has-leading-accessory{padding-left:0 !important;}:host .label-input-container.has-trailing-accessory{padding-right:0 !important;}:host{--field-input-animation-speed:var(--core-animation-enter-transition-moderate-speed-duration);--field-input-label-translate:12px;--field-empty-phase-label-text-size-unitless:16;--field-float-phase-label-text-size-unitless:14;--field-size-medium-float-phase-vertical-padding-size:12px;--field-size-medium-float-phase-horizontal-padding-size:16px;--field-size-small-float-phase-vertical-padding-size:9px;--field-size-small-float-phase-horizontal-padding-size:12px;display:flex;align-items:center}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{flex-grow:1;padding:var(--field-float-phase-vertical-padding-size) var(--field-float-phase-horizontal-padding-size)}:host([size='medium']) .label-input-container,:host([size='medium'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-medium-float-phase-vertical-padding-size)       var(--field-size-medium-float-phase-horizontal-padding-size)}:host([size='small']) .label-input-container,:host([size='small'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-small-float-phase-vertical-padding-size)       var(--field-size-small-float-phase-horizontal-padding-size)}:host ::slotted(label){display:block;min-height:var(--field-empty-phase-label-text-leading);font-weight:var(--field-empty-phase-label-text-weight);font-size:var(--field-empty-phase-label-text-size);line-height:var(--field-empty-phase-label-text-leading);letter-spacing:var(--field-empty-phase-label-text-tracking);transition:all var(--field-input-animation-speed);transform:translateY(var(--field-input-label-translate));transform-origin:0 0}:host(:not([value=""])) ::slotted(label),:host([value=""]:not([focused])[autofilled]) ::slotted(label),:host([focused]) ::slotted(label){font-weight:var(--field-float-phase-label-text-weight);transform:scale(         calc(var(--field-float-phase-label-text-size-unitless) / var(--field-empty-phase-label-text-size-unitless))       )}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){opacity:0}:host([focused]) input,:host([focused]) ::slotted(input),:host([focused]) textarea,:host([focused]) ::slotted(textarea),:host(:not([value=''])) input,:host(:not([value=''])) ::slotted(input),:host(:not([value=''])) textarea,:host(:not([value=''])) ::slotted(textarea){opacity:1}:host([size='small']) ::slotted(label),:host([size='medium']) ::slotted(label){position:absolute;overflow:hidden;width:1px;height:1px;white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%)}:host([size='small']) input,:host([size='small']) ::slotted(input),:host([size='small']) textarea,:host([size='small']) ::slotted(textarea),:host([size='medium']) input,:host([size='medium']) ::slotted(input),:host([size='medium']) textarea,:host([size='medium']) ::slotted(textarea){opacity:1}:host input::-webkit-outer-spin-button,:host input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none;appearance:none}:host input[type="number"]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}input[type="time"]::-webkit-inner-spin-button,input[type="time"]::-webkit-outer-spin-button,input[type="time"]::-webkit-clear-button,input[type="time"]::-webkit-calendar-picker-indicator{display:none}input[type="date"]::-webkit-calendar-picker-indicator,input[type="time"]::-webkit-calendar-picker-indicator{display:none}input[type="date"]::-webkit-inner-spin-button,input[type="time"]::-webkit-inner-spin-button,input[type="date"]::-webkit-clear-button,input[type="time"]::-webkit-clear-button{display:none;margin:0;-webkit-appearance:none;appearance:none}:host ::slotted(input:focus-visible){outline:none}:host([value=""]) input,:host([value=""]) ::slotted(input){color:var(--field-placeholder-text-color)}:host input:-webkit-autofill,:host ::slotted(input:-webkit-autofill){animation-name:market-input-autofill-start;animation-duration:var(--core-animation-enter-transition-fast-speed-duration)}:host input:not(:-webkit-autofill),:host ::slotted(input:not(:-webkit-autofill)){animation-name:market-input-autofill-cancel;animation-duration:var(--core-animation-enter-transition-fast-speed-duration)}:host input::-webkit-date-and-time-value{text-align:left}:host ::slotted(input::-webkit-date-and-time-value){text-align:left}`;
    }
}, [
    321,
    "market-input-text",
    {
        type: [
            513
        ],
        inputId: [
            1,
            "input-id"
        ],
        name: [
            1
        ],
        value: [
            1537
        ],
        placeholder: [
            1
        ],
        maxlength: [
            2
        ],
        minlength: [
            2
        ],
        size: [
            513
        ],
        step: [
            1
        ],
        min: [
            1
        ],
        max: [
            1
        ],
        pattern: [
            1
        ],
        required: [
            4
        ],
        readonly: [
            516
        ],
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        invalid: [
            1540
        ],
        inputmode: [
            1
        ],
        autofocus: [
            4
        ],
        autocomplete: [
            8
        ],
        autovalidate: [
            4
        ],
        autofilled: [
            1540
        ],
        ariaAttributes: [
            32
        ],
        setFocus: [
            64
        ],
        getInputElement: [
            64
        ],
        registerSlottedInput: [
            64
        ]
    },
    [
        [
            8,
            "marketDialogLoaded",
            "handleMarketDialogLoaded"
        ]
    ],
    {
        focused: [
            {
                focusedChangeHandler: 0
            }
        ],
        autocomplete: [
            {
                autocompleteWatcher: 0
            }
        ]
    }
]), p$4 = h$7;
const s$g = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.destructive = false, this.disabled = false, this.onMutationObserved = (e3)=>{
            this.ariaAttributes = e3;
        };
    }
    componentWillLoad() {
        this.mutationObserver = a$q(this.el, this.onMutationObserved);
    }
    handleClick(e2) {
        this.disabled && (e2.preventDefault(), e2.stopPropagation());
    }
    render() {
        const { disabled: e2, handleClick: t2, href: r2, target: o2, ariaAttributes: s2, rel: l2, download: a2 } = this, d = void 0 === r2 ? "button" : "a";
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "1b73ec9a468de9bb4bb920dbcdef634fe87fc79c",
            class: "market-link",
            onClick: t2,
            onKeyDown: t2
        }, (0, $696Z8.h)(d, Object.assign({
            key: "441eb4b2303df492a02e0f2bba506c15c8bd4fd0"
        }, "a" === d ? {
            href: r2,
            target: o2,
            rel: l2,
            download: a2
        } : {
            disabled: e2
        }, s2, {
            "aria-disabled": e2 ? "true" : null,
            tabindex: e2 ? "-1" : null
        }), (0, $696Z8.h)("slot", {
            key: "889784cee1ff7c43fecdf88d0d098a3040dfe5f1"
        })));
    }
    disconnectedCallback() {
        var e2;
        null === (e2 = this.mutationObserver) || void 0 === e2 || e2.disconnect();
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}a,button{--text-link-focus-ring-border-size:var(--button-focus-ring-border-size);--text-link-focus-ring-buffer-size:var(--button-focus-ring-buffer-size);--text-link-focus-ring-color:var(--button-focus-ring-color);--focus-ring-color:color-mix(in srgb, var(--text-link-focus-ring-color) 100%, transparent)}a:focus-visible,button:focus-visible{border-radius:1px;outline:var(--text-link-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--text-link-focus-ring-buffer-size)}:host{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);--link-internal-underline-size:var(--text-link-standalone-style-normal-state-underline-size);display:inline}a,button{display:inline;margin:0;padding:0;border:none;background:none;color:var(--text-link-normal-variant-color);font-weight:var(--text-link-medium-size-text-weight);font-size:inherit;font-family:inherit;line-height:1;letter-spacing:inherit;text-align:inherit;cursor:pointer;transition:color var(--transition-duration);text-decoration-line:underline;text-decoration-thickness:var(--link-internal-underline-size);text-decoration-style:solid;text-underline-offset:var(--text-link-standalone-style-underline-offset, 2px)}@container style(--link-internal-underline-size: 0px){a,button{text-decoration-line:none}}@media (hover: hover){a:hover,button:hover{color:var(--text-link-normal-variant-hover-state-color)}:host:has(a:hover),:host:has(button:hover){--link-internal-underline-size:var(--text-link-standalone-style-hover-state-underline-size)}}a:active,button:active{color:var(--text-link-normal-variant-pressed-state-color)}:host:has(a:active),:host:has(button:active){--link-internal-underline-size:var(--text-link-standalone-style-pressed-state-underline-size)}:host([disabled]){--link-internal-underline-size:var(--text-link-standalone-style-disabled-state-underline-size)}:host([disabled]) a,:host([disabled]) button{color:var(--text-link-normal-variant-disabled-state-color)}:host([highlight="underline"]){--link-internal-underline-size:var(--text-link-inline-style-normal-state-underline-size)}:host([highlight="underline"])[disabled]{--link-internal-underline-size:var(--text-link-inline-style-disabled-state-underline-size)}@media (hover: hover){:host([highlight="underline"]):has(a:hover,button:hover){--link-internal-underline-size:var(--text-link-inline-style-hover-state-underline-size)}}@media (hover: hover){:host([destructive]) a:hover,:host([destructive]) button:hover{color:var(--text-link-destructive-variant-hover-state-color)}}:host([destructive]) a,:host([destructive]) button{color:var(--text-link-destructive-variant-color)}:host([destructive]) a:active,:host([destructive]) button:active{color:var(--text-link-destructive-variant-pressed-state-color)}:host([destructive][disabled]) a,:host([destructive][disabled]) button{color:var(--text-link-destructive-variant-disabled-state-color)}::slotted(svg){fill:currentcolor}';
    }
}, [
    257,
    "market-link",
    {
        href: [
            1
        ],
        target: [
            1
        ],
        rel: [
            1
        ],
        destructive: [
            516
        ],
        disabled: [
            516
        ],
        download: [
            1
        ],
        highlight: [
            520
        ],
        ariaAttributes: [
            32
        ]
    }
]), l$c = s$g;
function r$7(r2) {
    return Math.max(...[
        ...r2.querySelectorAll("*")
    ].map((r3)=>Number.parseFloat(window.getComputedStyle(r3).zIndex)).filter((r3)=>!Number.isNaN(r3)), 0);
}
async function n$g(t2, e2) {
    const o2 = getComputedStyle(t2), { transitionProperty: n2 } = o2, r2 = n2.split(", ");
    return Promise.all(Object.keys(e2).map((o3)=>{
        const n3 = e2[o3];
        return new Promise((e3)=>{
            n3 || e3(), n3 === t2.style[o3] && e3(), r2.includes(o3) || (t2.style[o3] = n3, e3());
            const a2 = (n4)=>{
                n4.propertyName === o3 && (t2.removeEventListener("transitionend", a2), e3());
            };
            t2.addEventListener("transitionend", a2), t2.style[o3] = n3;
        });
    }));
}
function r$6(t2) {
    const e2 = null == t2 ? void 0 : t2.tagName.toLowerCase();
    return Boolean(t2 && e2 === l$s("market-table-v2-row"));
}
function a$c(t2) {
    const e2 = null == t2 ? void 0 : t2.tagName.toLowerCase();
    return Boolean(t2 && e2 === l$s("market-table-v2-group"));
}
function l$b(t2) {
    return Boolean(t2 && void 0 !== t2.dragEnabled);
}
const i$a = Math.min(1e3 / 60), s$f = l$s("market-table-v2-group");
let c$e = class c {
    constructor(t2, e2){
        this.el = t2, this.anchor = (null == e2 ? void 0 : e2.anchor) || "none";
    }
    async start(o2) {
        this.canceled = false;
        const { x: l2, y: i2 } = o2;
        this.startCoords = this.previousCoords = o2;
        const { el: s2, anchor: c2 } = this, h = a$c(s2) ? s2.querySelector('[slot="parent"]') : s2, { top: d, right: m, left: p, width: g, height: b } = u$6(h), f = s2.parentElement, w = document.elementsFromPoint(l2, i2)[0], x = h.cloneNode(true);
        if (x.classList.add("market-drag-clone", "market-drag-transitioning"), this.source = f, this.target = w, this.clone = x, !s2.dispatchEvent(new CustomEvent("marketDragStart", {
            bubbles: true,
            cancelable: true,
            detail: Object.assign(Object.assign({}, o2), {
                el: s2,
                source: f,
                target: w,
                clone: x
            })
        }))) return void (this.canceled = true);
        this.scrollParent = function(t2) {
            let e2 = t2.parentElement;
            for(; e2 !== document.documentElement;){
                const { overflowY: t3, overflowX: o3 } = getComputedStyle(e2), n2 = /(auto|scroll)/.test(t3) && e2.scrollHeight > e2.offsetHeight, r2 = /(auto|scroll)/.test(o3) && e2.scrollWidth > e2.offsetWidth;
                if (n2 || r2) return e2;
                e2 = e2.parentElement;
            }
            return document.documentElement;
        }(s2), s2.classList.add("market-drag-placeholder"), Object.assign(x.style, {
            position: "fixed",
            opacity: 0,
            transitionProperty: "none"
        }), document.body.append(x), await n$z();
        const { width: v, height: k } = u$6(x);
        Object.assign(x.style, {
            opacity: "",
            width: `${g}px`,
            height: `${b}px`,
            top: `${d}px`,
            left: "right" === c2 ? "auto" : `${p}px`,
            right: "left" === c2 ? "auto" : window.innerWidth - m + "px",
            zIndex: `${r$7(document.body) + 1}`
        }), await n$z(), x.style.transitionProperty = "", r$6(x) && x.querySelector("market-table-v2-cell").classList.add("market-drag-clone-first-cell"), x.style.setProperty("--market-drag-clone-shadow-opacity", "1"), n$g(x, {
            top: `${d + (b - k) / 2}px`,
            height: `${k}px`,
            width: "none" === c2 ? `${g}px` : `${v}px`
        }).then(()=>{
            x.classList.remove("market-drag-transitioning");
        });
    }
    move(t2) {
        const { el: e2, clone: o2, source: n2, target: r2, startCoords: a2, previousCoords: l2, canceled: i2 } = this, { x: s2, y: c2 } = t2;
        if (i2) return;
        if (!o2) return;
        if (s2 === l2.x && c2 === l2.y) return;
        this.previousCoords = t2;
        const u2 = [
            ...document.elementsFromPoint(s2, c2)
        ].find((t3)=>!o2.contains(t3));
        u2 !== r2 && (null == r2 || r2.dispatchEvent(new CustomEvent("marketDragLeave", {
            bubbles: true,
            detail: {
                x: s2,
                y: c2,
                el: e2,
                source: n2,
                target: r2,
                clone: o2
            }
        })), null == u2 || u2.dispatchEvent(new CustomEvent("marketDragEnter", {
            bubbles: true,
            detail: {
                x: s2,
                y: c2,
                el: e2,
                source: n2,
                target: u2,
                clone: o2
            }
        })), this.target = u2), null == u2 || u2.dispatchEvent(new CustomEvent("marketDragMove", {
            bubbles: true,
            detail: {
                x: s2,
                y: c2,
                el: e2,
                source: n2,
                target: u2,
                clone: o2
            }
        })), Object.assign(o2.style, {
            transform: `translate(${s2 - a2.x}px, ${c2 - a2.y}px)`
        }), this.scroll();
    }
    async end(t2) {
        if (this.canceled) return;
        const { el: o2, source: l2, clone: i2, anchor: c2, scrollInterval: h } = this, { x: d, y: m } = t2;
        if (clearInterval(h), !i2) return;
        const p = [
            ...document.elementsFromPoint(d, m)
        ].find((t3)=>!i2.contains(t3));
        !o2.dispatchEvent(new CustomEvent("marketDragEnd", {
            bubbles: true,
            cancelable: true,
            detail: {
                x: d,
                y: m,
                el: o2,
                source: l2,
                target: p,
                clone: i2
            }
        })) || null == p || p.dispatchEvent(new CustomEvent("marketDragDrop", {
            bubbles: true,
            cancelable: false,
            detail: {
                x: d,
                y: m,
                el: o2,
                source: l2,
                target: p,
                clone: i2
            }
        }));
        const g = function(t3, e2) {
            let o3, n2 = t3;
            for(; n2 !== document.body;){
                const t4 = n2.closest(e2);
                t4 && (o3 = t4), n2 = n2.parentElement;
            }
            return o3;
        }(o2, `${s$f}[collapsed]`), b = g && g !== o2, f = b ? g.querySelector('[slot="parent"]') : a$c(o2) ? o2.querySelector('[slot="parent"]') : o2;
        await n$z();
        const { top: w, right: x, left: v, width: k, height: y } = u$6(f), { top: $, right: C, left: M, width: j, height: E } = u$6(i2), D = "left" === c2 ? M - v : C - x, O = $ - w;
        Object.assign(i2.style, {
            pointerEvents: "none",
            transitionProperty: "none",
            top: `${w}px`,
            left: "right" === c2 ? "auto" : `${v}px`,
            right: "left" === c2 ? "auto" : window.innerWidth - x + "px",
            width: `${j}px`,
            height: `${E}px`,
            transform: `translate(${D}px, ${O}px)`
        }), await n$z(), i2.style.transitionProperty = "", r$6(i2) && r$6(f) && i2.querySelector("market-table-v2-cell").classList.remove("market-drag-clone-first-cell"), i2.classList.add("market-drag-released", "market-drag-transitioning"), b && i2.classList.add("market-drag-into-collapsed-group"), i2.style.removeProperty("--market-drag-clone-shadow-opacity"), await n$z(), await n$g(i2, {
            width: `${k}px`,
            height: `${y}px`,
            transform: D || O ? "translate(0, 0)" : null
        }), o2.classList.remove("market-drag-placeholder"), i2.remove(), null == o2 || o2.dispatchEvent(new CustomEvent("marketDragComplete", {
            bubbles: true,
            cancelable: false,
            detail: {
                x: d,
                y: m,
                el: o2,
                source: l2,
                target: p,
                clone: i2
            }
        }));
    }
    scroll() {
        const { clone: t2, scrollParent: e2, scrollInterval: o2 } = this;
        clearInterval(o2);
        const { bottom: n2, top: r2, right: a2, left: l2 } = u$6(t2), { bottom: s2, top: c2, right: h, left: d } = function(t3) {
            const { top: e3, right: o3, bottom: n3, left: r3 } = u$6(t3);
            return t3 === document.documentElement ? {
                top: 0,
                right: window.innerWidth,
                bottom: window.innerHeight,
                left: 0
            } : {
                top: e3,
                right: o3,
                bottom: n3,
                left: r3
            };
        }(e2), m = n2 - s2, p = r2 - c2, g = m > 0 ? Math.min(m / 4, 24) : p < 0 ? Math.max(p / 4, -24) : 0, b = a2 - h, f = l2 - d, w = b > 0 ? Math.min(b / 4, 24) : f < 0 ? Math.max(f / 4, -24) : 0;
        0 === g && 0 === w || (this.scrollInterval = setInterval(()=>{
            e2.scrollBy({
                top: g,
                left: w
            });
        }, i$a));
    }
    destroy() {
        this.el = null, this.clone = null, this.source = null, this.target = null, this.startCoords = null, this.canceled = null, this.scrollParent = null, this.scrollInterval = null, this.anchor = null;
    }
};
function u$6(t2) {
    const e2 = t2.getBoundingClientRect();
    return {
        top: Math.round(e2.top),
        right: Math.round(e2.right),
        bottom: Math.round(e2.bottom),
        left: Math.round(e2.left),
        width: Math.round(e2.width),
        height: Math.round(e2.height)
    };
}
var a$b;
function o$6(e2) {
    return Boolean(e2 && [
        "internal",
        "external"
    ].includes(e2.reorderable));
}
let i$9 = class i {
    static createCursor() {
        const e2 = document.createElement("div");
        return e2.classList.add("market-drag-cursor"), e2;
    }
    constructor({ el: e2, accepts: r2, event: t2, mode: n2 }){
        this.el = e2, this.accepts = r2, this.event = t2, this.mode = n2;
    }
    isValidDrag(r2, t2, n2) {
        const { el: a2, accepts: i2 } = this, l2 = null == t2 ? void 0 : t2.closest('[reorderable="internal"], [reorderable="external"]'), s = null == n2 ? void 0 : n2.closest('[reorderable="internal"], [reorderable="external"]');
        if (!l$b(r2)) return false;
        if (!o$6(l2)) return false;
        if (!o$6(s)) return false;
        if (r2.closest(i2.join(",")) !== r2) return false;
        if (a2 !== l2 && a2 !== s) return false;
        if (l2 !== s) {
            const e2 = "external" === l2.reorderable && "external" === s.reorderable, r3 = (function(e3, r4) {
                let t3 = e3;
                for(; t3;){
                    if (t3.contains(r4)) return t3;
                    t3 = t3.parentElement;
                }
                return null;
            })(l2, s).closest('[reorderable="internal"], [reorderable="external"]');
            if (!e2 && !r3) return false;
        }
        return true;
    }
    dragMove(e2) {
        var o2, i2;
        const { el: l2, accepts: s, tableGroupExpandTimeout: u } = this, { y: c, el: d, source: f, target: m } = e2.detail, { cursor: h } = a$b;
        if (!this.isValidDrag(d, f, m)) return;
        if (clearTimeout(u), null === (o2 = h.parentElement) || void 0 === o2 || o2.classList.remove("market-drag-cursor-parent"), m === l2) return l2.append(h), void l2.classList.add("market-drag-cursor-parent");
        const p = m.closest(s.join(","));
        if (p && p !== d) {
            if (a$c(p)) {
                const e3 = [
                    ...p.children
                ].find((e4)=>r$6(e4) && "parent" === e4.slot), { top: a2, height: o3 } = e3.getBoundingClientRect();
                if (p.collapsible && p.collapsed) {
                    const i3 = Math.round(a2 + o3 / 3), l3 = Math.round(a2 + 2 * o3 / 3);
                    if (c < i3) p.before(h);
                    else if (c > l3) p.after(h);
                    else {
                        e3.after(h);
                        const a3 = [
                            ...p.children
                        ].filter((e4)=>(r$6(e4) || a$c(e4)) && !e4.slot);
                        a3.length > 0 && (this.tableGroupExpandTimeout = setTimeout(async ()=>{
                            await p.setCollapsed(false), await n$z(), e3.after(h);
                        }, 300));
                    }
                } else c < Math.round(a2 + o3 / 2) ? p.before(h) : e3.after(h);
            } else {
                const { top: e3, height: r2 } = p.getBoundingClientRect();
                c < Math.round(e3 + r2 / 2) ? p.before(h) : p.after(h);
            }
            null === (i2 = h.parentElement) || void 0 === i2 || i2.classList.add("market-drag-cursor-parent");
        }
    }
    dragLeave() {
        var e2;
        const { tableGroupExpandTimeout: r2 } = this, { cursor: t2 } = a$b;
        null === (e2 = t2.parentElement) || void 0 === e2 || e2.classList.remove("market-drag-cursor-parent"), t2.remove(), clearTimeout(r2);
    }
    dragEnd(e2) {
        const { el: r2, accepts: t2, event: n2, tableGroupExpandTimeout: o2 } = this, { el: i2, source: s } = e2.detail, { cursor: u } = a$b;
        clearTimeout(o2);
        const c = u.parentElement;
        if (!this.isValidDrag(i2, s, c)) return;
        if ((null == s ? void 0 : s.closest('[reorderable="internal"], [reorderable="external"]')) === (null == c ? void 0 : c.closest('[reorderable="internal"], [reorderable="external"]'))) return;
        e2.stopImmediatePropagation();
        const d = l$a(r2, t2).indexOf(i2), { defaultPrevented: f } = n2.emit({
            item: i2,
            oldIndex: d,
            newIndex: -1
        });
        f && (e2.preventDefault(), u.remove());
    }
    async dragDrop(e2) {
        const { el: r2, accepts: t2, event: n2, mode: o2, tableGroupExpandTimeout: i2 } = this, { el: s, source: u } = e2.detail, { cursor: c } = a$b;
        clearTimeout(i2);
        const d = c.parentElement;
        if (r2 !== d) return;
        if (!this.isValidDrag(s, u, d)) return;
        if (e2.stopImmediatePropagation(), null == d || d.classList.remove("market-drag-cursor-parent"), [
            c.previousElementSibling,
            c.nextElementSibling
        ].includes(s)) return void c.remove();
        const f = l$a(d, t2), m = f.indexOf(s), h = [
            ...f
        ];
        m >= 0 && h.splice(m, 1);
        const p = h.indexOf(c.previousElementSibling) + 1;
        if (p === m) return void c.remove();
        const v = document.createElement("div");
        s.replaceWith(v), c.replaceWith(s), await new Promise((e3)=>s.addEventListener("marketDragComplete", e3, {
                once: true
            })), "framework" === o2 && v.replaceWith(s);
        const { defaultPrevented: g } = n2.emit({
            item: s,
            oldIndex: m,
            newIndex: p
        });
        g && "default" === o2 && v.replaceWith(s), v.remove();
    }
    destroy() {
        a$b.cursor.remove(), clearTimeout(this.tableGroupExpandTimeout), this.el = null, this.accepts = null, this.event = null, this.mode = null, this.tableGroupExpandTimeout = null;
    }
};
function l$a(r2, t2) {
    return [
        ...r2.children
    ].filter((r3)=>t2.some((e2)=>r3.matches(e2)) && l$b(r3));
}
i$9.cursor = (a$b = i$9).createCursor();
function o$5(r2) {
    if (!j$9(r2)) return false;
    var o2 = f$b(r2);
    return "[object Function]" == o2 || "[object GeneratorFunction]" == o2 || "[object AsyncFunction]" == o2 || "[object Proxy]" == o2;
}
var c$d, u$5 = n$y["__core-js_shared__"], e$4 = (c$d = /[^.]+$/.exec(u$5 && u$5.keys && u$5.keys.IE_PROTO || "")) ? "Symbol(src)_1." + c$d : "", i$8 = Function.prototype.toString;
function a$a(n2) {
    if (null != n2) {
        try {
            return i$8.call(n2);
        } catch (n3) {}
        try {
            return n2 + "";
        } catch (n3) {}
    }
    return "";
}
var s$e = /^\[object .+?Constructor\]$/, f$7 = RegExp("^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function b$5(t2, r2) {
    var c2 = function(n2, t3) {
        return null == n2 ? void 0 : n2[t3];
    }(t2, r2);
    return function(t3) {
        var r3;
        return !(!j$9(t3) || (r3 = t3, e$4 && e$4 in r3)) && (o$5(t3) ? f$7 : s$e).test(a$a(t3));
    }(c2) ? c2 : void 0;
}
var n$f = Array.isArray;
function s$d(r2) {
    return "number" == typeof r2 && r2 > -1 && r2 % 1 == 0 && r2 <= 9007199254740991;
}
function o$4(a2) {
    return i$j(a2) && "[object Arguments]" == f$b(a2);
}
var u$4 = Object.prototype, c$c = u$4.hasOwnProperty, i$7 = u$4.propertyIsEnumerable, f$6 = o$4(/* @__PURE__ */ function() {
    return arguments;
}()) ? o$4 : function(t2) {
    return i$j(t2) && c$c.call(t2, "callee") && !i$7.call(t2, "callee");
}, b$4 = b$5(n$y, "Map");
var r$5 = /^(?:0|[1-9]\d*)$/;
function i$6(t2, n2) {
    var i2 = typeof t2;
    return !!(n2 = null == n2 ? 9007199254740991 : n2) && ("number" == i2 || "symbol" != i2 && r$5.test(t2)) && t2 > -1 && t2 % 1 == 0 && t2 < n2;
}
function s$c(t2, n2) {
    return t2 === n2 || t2 != t2 && n2 != n2;
}
var u$3 = b$5(Object, "create"), o$3 = Object.prototype.hasOwnProperty, e$3 = Object.prototype.hasOwnProperty;
function h$6(t2) {
    var n2 = -1, r2 = null == t2 ? 0 : t2.length;
    for(this.clear(); ++n2 < r2;){
        var i2 = t2[n2];
        this.set(i2[0], i2[1]);
    }
}
function a$9(t2, n2) {
    for(var r2 = t2.length; r2--;)if (s$c(t2[r2][0], n2)) return r2;
    return -1;
}
h$6.prototype.clear = function() {
    this.__data__ = u$3 ? u$3(null) : {}, this.size = 0;
}, h$6.prototype.delete = function(t2) {
    var n2 = this.has(t2) && delete this.__data__[t2];
    return this.size -= n2 ? 1 : 0, n2;
}, h$6.prototype.get = function(t2) {
    var n2 = this.__data__;
    if (u$3) {
        var r2 = n2[t2];
        return "__lodash_hash_undefined__" === r2 ? void 0 : r2;
    }
    return o$3.call(n2, t2) ? n2[t2] : void 0;
}, h$6.prototype.has = function(t2) {
    var n2 = this.__data__;
    return u$3 ? void 0 !== n2[t2] : e$3.call(n2, t2);
}, h$6.prototype.set = function(t2, n2) {
    var r2 = this.__data__;
    return this.size += this.has(t2) ? 0 : 1, r2[t2] = u$3 && void 0 === n2 ? "__lodash_hash_undefined__" : n2, this;
};
var f$5 = Array.prototype.splice;
function v$3(t2) {
    var n2 = -1, r2 = null == t2 ? 0 : t2.length;
    for(this.clear(); ++n2 < r2;){
        var i2 = t2[n2];
        this.set(i2[0], i2[1]);
    }
}
function c$b(t2, n2) {
    var r2, i2, s2 = t2.__data__;
    return ("string" == (i2 = typeof (r2 = n2)) || "number" == i2 || "symbol" == i2 || "boolean" == i2 ? "__proto__" !== r2 : null === r2) ? s2["string" == typeof n2 ? "string" : "hash"] : s2.map;
}
function l$9(t2) {
    var n2 = -1, r2 = null == t2 ? 0 : t2.length;
    for(this.clear(); ++n2 < r2;){
        var i2 = t2[n2];
        this.set(i2[0], i2[1]);
    }
}
function _$4(t2, n2) {
    for(var r2 = -1, i2 = n2.length, s2 = t2.length; ++r2 < i2;)t2[s2 + r2] = n2[r2];
    return t2;
}
v$3.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
}, v$3.prototype.delete = function(t2) {
    var n2 = this.__data__, r2 = a$9(n2, t2);
    return !(r2 < 0 || (r2 == n2.length - 1 ? n2.pop() : f$5.call(n2, r2, 1), --this.size, 0));
}, v$3.prototype.get = function(t2) {
    var n2 = this.__data__, r2 = a$9(n2, t2);
    return r2 < 0 ? void 0 : n2[r2][1];
}, v$3.prototype.has = function(t2) {
    return a$9(this.__data__, t2) > -1;
}, v$3.prototype.set = function(t2, n2) {
    var r2 = this.__data__, i2 = a$9(r2, t2);
    return i2 < 0 ? (++this.size, r2.push([
        t2,
        n2
    ])) : r2[i2][1] = n2, this;
}, l$9.prototype.clear = function() {
    this.size = 0, this.__data__ = {
        hash: new h$6(),
        map: new (b$4 || v$3)(),
        string: new h$6()
    };
}, l$9.prototype.delete = function(t2) {
    var n2 = c$b(this, t2).delete(t2);
    return this.size -= n2 ? 1 : 0, n2;
}, l$9.prototype.get = function(t2) {
    return c$b(this, t2).get(t2);
}, l$9.prototype.has = function(t2) {
    return c$b(this, t2).has(t2);
}, l$9.prototype.set = function(t2, n2) {
    var r2 = c$b(this, t2), i2 = r2.size;
    return r2.set(t2, n2), this.size += r2.size == i2 ? 0 : 1, this;
};
var i$5 = b$5(n$y, "WeakMap");
function f$4(e2) {
    return null != e2 && s$d(e2.length) && !o$5(e2);
}
var p$3 = Object.prototype;
function b$3(e2) {
    var t2 = e2 && e2.constructor;
    return e2 === ("function" == typeof t2 && t2.prototype || p$3);
}
var j$5 = exports && !exports.nodeType && exports, m$3 = j$5 && true && module && !module.nodeType && module, v$2 = m$3 && m$3.exports === j$5 ? n$y.Buffer : void 0, d$6 = (v$2 ? v$2.isBuffer : void 0) || function() {
    return false;
}, l$8 = {};
l$8["[object Float32Array]"] = l$8["[object Float64Array]"] = l$8["[object Int8Array]"] = l$8["[object Int16Array]"] = l$8["[object Int32Array]"] = l$8["[object Uint8Array]"] = l$8["[object Uint8ClampedArray]"] = l$8["[object Uint16Array]"] = l$8["[object Uint32Array]"] = true, l$8["[object Arguments]"] = l$8["[object Array]"] = l$8["[object ArrayBuffer]"] = l$8["[object Boolean]"] = l$8["[object DataView]"] = l$8["[object Date]"] = l$8["[object Error]"] = l$8["[object Function]"] = l$8["[object Map]"] = l$8["[object Number]"] = l$8["[object Object]"] = l$8["[object RegExp]"] = l$8["[object Set]"] = l$8["[object String]"] = l$8["[object WeakMap]"] = false;
var x$6, w$3 = exports && !exports.nodeType && exports, y$5 = w$3 && true && module && !module.nodeType && module, O$3 = y$5 && y$5.exports === w$3 && t$6.process, M$3 = function() {
    try {
        return y$5 && y$5.require && y$5.require("util").types || O$3 && O$3.binding && O$3.binding("util");
    } catch (e2) {}
}(), g$6 = M$3 && M$3.isTypedArray, S$4 = g$6 ? (x$6 = g$6, function(e2) {
    return x$6(e2);
}) : function(e2) {
    return i$j(e2) && s$d(e2.length) && !!l$8[f$b(e2)];
}, h$5 = /* @__PURE__ */ function(e2, t2) {
    return function(r2) {
        return e2(t2(r2));
    };
}(Object.keys, Object), k$2 = Object.prototype.hasOwnProperty;
function D$4(e2) {
    if (!b$3(e2)) return h$5(e2);
    var t2 = [];
    for(var r2 in Object(e2))k$2.call(e2, r2) && "constructor" != r2 && t2.push(r2);
    return t2;
}
var P$3 = b$5(n$y, "DataView"), V$3 = b$5(n$y, "Promise"), W$3 = b$5(n$y, "Set"), _$3 = "[object Map]", A$3 = "[object Promise]", B$2 = "[object Set]", N$2 = "[object WeakMap]", q$1 = "[object DataView]", z$3 = a$a(P$3), C$1 = a$a(b$4), E$2 = a$a(V$3), F$1 = a$a(W$3), G$1 = a$a(i$5), H$2 = f$b;
(P$3 && H$2(new P$3(new ArrayBuffer(1))) != q$1 || b$4 && H$2(new b$4()) != _$3 || V$3 && H$2(V$3.resolve()) != A$3 || W$3 && H$2(new W$3()) != B$2 || i$5 && H$2(new i$5()) != N$2) && (H$2 = function(e2) {
    var t2 = f$b(e2), o2 = "[object Object]" == t2 ? e2.constructor : void 0, n2 = o2 ? a$a(o2) : "";
    if (n2) switch(n2){
        case z$3:
            return q$1;
        case C$1:
            return _$3;
        case E$2:
            return A$3;
        case F$1:
            return B$2;
        case G$1:
            return N$2;
    }
    return t2;
});
var _$2 = Object.prototype.hasOwnProperty;
function p$2(t2) {
    return f$4(t2) ? function(t3) {
        var n2 = n$f(t3), e2 = !n2 && f$6(t3), i2 = !n2 && !e2 && d$6(t3), o2 = !n2 && !e2 && !i2 && S$4(t3), f2 = n2 || e2 || i2 || o2, c2 = f2 ? function(r2, t4) {
            for(var n3 = -1, e3 = Array(r2); ++n3 < r2;)e3[n3] = t4(n3);
            return e3;
        }(t3.length, String) : [], s2 = c2.length;
        for(var h2 in t3)!_$2.call(t3, h2) || f2 && ("length" == h2 || i2 && ("offset" == h2 || "parent" == h2) || o2 && ("buffer" == h2 || "byteLength" == h2 || "byteOffset" == h2) || i$6(h2, s2)) || c2.push(h2);
        return c2;
    }(t2) : D$4(t2);
}
function w$2(r2) {
    var n2 = this.__data__ = new v$3(r2);
    this.size = n2.size;
}
w$2.prototype.clear = function() {
    this.__data__ = new v$3(), this.size = 0;
}, w$2.prototype.delete = function(r2) {
    var t2 = this.__data__, n2 = t2.delete(r2);
    return this.size = t2.size, n2;
}, w$2.prototype.get = function(r2) {
    return this.__data__.get(r2);
}, w$2.prototype.has = function(r2) {
    return this.__data__.has(r2);
}, w$2.prototype.set = function(r2, e2) {
    var i2 = this.__data__;
    if (i2 instanceof v$3) {
        var a2 = i2.__data__;
        if (!b$4 || a2.length < 199) return a2.push([
            r2,
            e2
        ]), this.size = ++i2.size, this;
        i2 = this.__data__ = new l$9(a2);
    }
    return i2.set(r2, e2), this.size = i2.size, this;
};
var d$5 = Object.prototype.propertyIsEnumerable, m$2 = Object.getOwnPropertySymbols, y$4 = m$2 ? function(r2) {
    return null == r2 ? [] : (r2 = Object(r2), function(t2) {
        for(var n2 = -1, e2 = null == t2 ? 0 : t2.length, i2 = 0, a2 = []; ++n2 < e2;){
            var u2 = t2[n2];
            d$5.call(r2, u2) && (a2[i2++] = u2);
        }
        return a2;
    }(m$2(r2)));
} : function() {
    return [];
};
function g$5(r2) {
    return function(r3, t2, n2) {
        var i2 = p$2(r3);
        return n$f(r3) ? i2 : _$4(i2, n2(r3));
    }(r2, 0, y$4);
}
var O$2 = n$y.Uint8Array;
function A$2(r2) {
    var t2 = -1, e2 = null == r2 ? 0 : r2.length;
    for(this.__data__ = new l$9(); ++t2 < e2;)this.add(r2[t2]);
}
function S$3(r2, t2) {
    for(var n2 = -1, e2 = null == r2 ? 0 : r2.length; ++n2 < e2;)if (t2(r2[n2], n2, r2)) return true;
    return false;
}
function k$1(r2, t2) {
    return r2.has(t2);
}
function M$2(r2, t2, n2, e2, i2, a2) {
    var u2 = 1 & n2, o2 = r2.length, f2 = t2.length;
    if (o2 != f2 && !(u2 && f2 > o2)) return false;
    var c2 = a2.get(r2), s2 = a2.get(t2);
    if (c2 && s2) return c2 == t2 && s2 == r2;
    var v2 = -1, b2 = true, h2 = 2 & n2 ? new A$2() : void 0;
    for(a2.set(r2, t2), a2.set(t2, r2); ++v2 < o2;){
        var j2 = r2[v2], l2 = t2[v2];
        if (e2) var _2 = u2 ? e2(l2, j2, v2, t2, r2, a2) : e2(j2, l2, v2, r2, t2, a2);
        if (void 0 !== _2) {
            if (_2) continue;
            b2 = false;
            break;
        }
        if (h2) {
            if (!S$3(t2, function(r3, t3) {
                if (!k$1(h2, t3) && (j2 === r3 || i2(j2, r3, n2, e2, a2))) return h2.push(t3);
            })) {
                b2 = false;
                break;
            }
        } else if (j2 !== l2 && !i2(j2, l2, n2, e2, a2)) {
            b2 = false;
            break;
        }
    }
    return a2.delete(r2), a2.delete(t2), b2;
}
function x$5(r2) {
    var t2 = -1, n2 = Array(r2.size);
    return r2.forEach(function(r3, e2) {
        n2[++t2] = [
            e2,
            r3
        ];
    }), n2;
}
function B$1(r2) {
    var t2 = -1, n2 = Array(r2.size);
    return r2.forEach(function(r3) {
        n2[++t2] = r3;
    }), n2;
}
A$2.prototype.add = A$2.prototype.push = function(r2) {
    return this.__data__.set(r2, "__lodash_hash_undefined__"), this;
}, A$2.prototype.has = function(r2) {
    return this.__data__.has(r2);
};
var D$3 = o$h ? o$h.prototype : void 0, E$1 = D$3 ? D$3.valueOf : void 0, L$2 = Object.prototype.hasOwnProperty, N$1 = "[object Arguments]", P$2 = "[object Array]", R$2 = "[object Object]", T$2 = Object.prototype.hasOwnProperty;
function V$2(r2, t2, n2, e2, a2) {
    return r2 === t2 || (null == r2 || null == t2 || !i$j(r2) && !i$j(t2) ? r2 != r2 && t2 != t2 : function(r3, t3, n3, e3, a3, o2) {
        var f2 = n$f(r3), c2 = n$f(t3), s2 = f2 ? P$2 : H$2(r3), h2 = c2 ? P$2 : H$2(t3), j2 = (s2 = s2 == N$1 ? R$2 : s2) == R$2, _2 = (h2 = h2 == N$1 ? R$2 : h2) == R$2, p2 = s2 == h2;
        if (p2 && d$6(r3)) {
            if (!d$6(t3)) return false;
            f2 = true, j2 = false;
        }
        if (p2 && !j2) return o2 || (o2 = new w$2()), f2 || S$4(r3) ? M$2(r3, t3, n3, e3, a3, o2) : function(r4, t4, n4, e4, a4, u2, o3) {
            switch(n4){
                case "[object DataView]":
                    if (r4.byteLength != t4.byteLength || r4.byteOffset != t4.byteOffset) return false;
                    r4 = r4.buffer, t4 = t4.buffer;
                case "[object ArrayBuffer]":
                    return !(r4.byteLength != t4.byteLength || !u2(new O$2(r4), new O$2(t4)));
                case "[object Boolean]":
                case "[object Date]":
                case "[object Number]":
                    return s$c(+r4, +t4);
                case "[object Error]":
                    return r4.name == t4.name && r4.message == t4.message;
                case "[object RegExp]":
                case "[object String]":
                    return r4 == t4 + "";
                case "[object Map]":
                    var f3 = x$5;
                case "[object Set]":
                    if (f3 || (f3 = B$1), r4.size != t4.size && !(1 & e4)) return false;
                    var c3 = o3.get(r4);
                    if (c3) return c3 == t4;
                    e4 |= 2, o3.set(r4, t4);
                    var s3 = M$2(f3(r4), f3(t4), e4, a4, u2, o3);
                    return o3.delete(r4), s3;
                case "[object Symbol]":
                    if (E$1) return E$1.call(r4) == E$1.call(t4);
            }
            return false;
        }(r3, t3, s2, n3, e3, a3, o2);
        if (!(1 & n3)) {
            var d2 = j2 && T$2.call(r3, "__wrapped__"), m2 = _2 && T$2.call(t3, "__wrapped__");
            if (d2 || m2) {
                var y2 = d2 ? r3.value() : r3, A2 = m2 ? t3.value() : t3;
                return o2 || (o2 = new w$2()), a3(y2, A2, n3, e3, o2);
            }
        }
        return !!p2 && (o2 || (o2 = new w$2()), function(r4, t4, n4, e4, i2, a4) {
            var u2 = 1 & n4, o3 = g$5(r4), f3 = o3.length;
            if (f3 != g$5(t4).length && !u2) return false;
            for(var c3 = f3; c3--;){
                var s3 = o3[c3];
                if (!(u2 ? s3 in t4 : L$2.call(t4, s3))) return false;
            }
            var v2 = a4.get(r4), b2 = a4.get(t4);
            if (v2 && b2) return v2 == t4 && b2 == r4;
            var h3 = true;
            a4.set(r4, t4), a4.set(t4, r4);
            for(var j3 = u2; ++c3 < f3;){
                var l2 = r4[s3 = o3[c3]], _3 = t4[s3];
                if (e4) var p3 = u2 ? e4(_3, l2, s3, t4, r4, a4) : e4(l2, _3, s3, r4, t4, a4);
                if (!(void 0 === p3 ? l2 === _3 || i2(l2, _3, n4, e4, a4) : p3)) {
                    h3 = false;
                    break;
                }
                j3 || (j3 = "constructor" == s3);
            }
            if (h3 && !j3) {
                var w2 = r4.constructor, d3 = t4.constructor;
                w2 == d3 || !("constructor" in r4) || !("constructor" in t4) || "function" == typeof w2 && w2 instanceof w2 && "function" == typeof d3 && d3 instanceof d3 || (h3 = false);
            }
            return a4.delete(r4), a4.delete(t4), h3;
        }(r3, t3, n3, e3, a3, o2));
    }(r2, t2, n2, e2, V$2, a2));
}
var e$2 = o$h ? o$h.prototype : void 0, a$8 = e$2 ? e$2.toString : void 0;
function s$b(n2) {
    if ("string" == typeof n2) return n2;
    if (n$f(n2)) return function(r2, n3) {
        for(var t3 = -1, u2 = null == r2 ? 0 : r2.length, i2 = Array(u2); ++t3 < u2;)i2[t3] = n3(r2[t3], t3, r2);
        return i2;
    }(n2, s$b) + "";
    if (s$r(n2)) return a$8 ? a$8.call(n2) : "";
    var t2 = n2 + "";
    return "0" == t2 && 1 / n2 == -1 / 0 ? "-0" : t2;
}
var c$a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l$7 = /^\w*$/;
function v$1(n2, t2) {
    if (n$f(n2)) return false;
    var i2 = typeof n2;
    return !("number" != i2 && "symbol" != i2 && "boolean" != i2 && null != n2 && !s$r(n2)) || l$7.test(n2) || !c$a.test(n2) || null != t2 && n2 in Object(t2);
}
function p$1(r2, n2) {
    if ("function" != typeof r2 || null != n2 && "function" != typeof n2) throw new TypeError("Expected a function");
    var t2 = function() {
        var u2 = arguments, i2 = n2 ? n2.apply(this, u2) : u2[0], o2 = t2.cache;
        if (o2.has(i2)) return o2.get(i2);
        var f2 = r2.apply(this, u2);
        return t2.cache = o2.set(i2, f2) || o2, f2;
    };
    return t2.cache = new (p$1.Cache || l$9)(), t2;
}
p$1.Cache = l$9;
var m$1, b$2, y$3, j$4 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, d$4 = /\\(\\)?/g, h$4 = (m$1 = function(r2) {
    var n2 = [];
    return 46 === r2.charCodeAt(0) && n2.push(""), r2.replace(j$4, function(r3, t2, u2, i2) {
        n2.push(u2 ? i2.replace(d$4, "$1") : t2 || r3);
    }), n2;
}, b$2 = p$1(m$1, function(r2) {
    return 500 === y$3.size && y$3.clear(), r2;
}), y$3 = b$2.cache, b$2);
function g$4(n2, t2) {
    return n$f(n2) ? n2 : v$1(n2, t2) ? [
        n2
    ] : h$4(function(r2) {
        return null == r2 ? "" : s$b(r2);
    }(n2));
}
function w$1(r2) {
    if ("string" == typeof r2 || s$r(r2)) return r2;
    var n2 = r2 + "";
    return "0" == n2 && 1 / r2 == -1 / 0 ? "-0" : n2;
}
function O$1(r2, n2) {
    for(var t2 = 0, u2 = (n2 = g$4(n2, r2)).length; null != r2 && t2 < u2;)r2 = r2[w$1(n2[t2++])];
    return t2 && t2 == u2 ? r2 : void 0;
}
function $$1(r2, n2) {
    return null != r2 && n2 in Object(r2);
}
function x$4(u2, i2) {
    return null != u2 && function(u3, i3, f2) {
        for(var e2 = -1, a2 = (i3 = g$4(i3, u3)).length, s2 = false; ++e2 < a2;){
            var c2 = w$1(i3[e2]);
            if (!(s2 = null != u3 && f2(u3, c2))) break;
            u3 = u3[c2];
        }
        return s2 || ++e2 != a2 ? s2 : !!(a2 = null == u3 ? 0 : u3.length) && s$d(a2) && i$6(c2, a2) && (n$f(u3) || f$6(u3));
    }(u2, i2, $$1);
}
function n$e(n2) {
    return n2;
}
function R$1(t2) {
    return t2 != t2;
}
function V$1(t2, e2) {
    return !(null == t2 || !t2.length) && function(t3, e3) {
        return e3 == e3 ? function(t4, e4) {
            for(var i2 = -1, s2 = t4.length; ++i2 < s2;)if (t4[i2] === e4) return i2;
            return -1;
        }(t3, e3) : function(t4, e4) {
            for(var i2 = t4.length, s2 = -1; ++s2 < i2;)if (e4(t4[s2], s2, t4)) return s2;
            return -1;
        }(t3, R$1);
    }(t2, e2) > -1;
}
function L$1(t2) {
    return t2 == t2 && !j$9(t2);
}
function H$1(t2, e2) {
    return function(i2) {
        return null != i2 && i2[t2] === e2 && (void 0 !== e2 || t2 in Object(i2));
    };
}
var j$3 = W$3 && 1 / B$1(new W$3([
    ,
    -0
]))[1] == 1 / 0 ? function(t2) {
    return new W$3(t2);
} : function() {};
function M$1(t2, e2) {
    return t2 && t2.length ? function(t3, e3) {
        var i2 = -1, s2 = V$1, r2 = t3.length, n2 = true, o2 = [], l2 = o2;
        if (r2 >= 200) {
            var a2 = e3 ? null : j$3(t3);
            if (a2) return B$1(a2);
            n2 = false, s2 = k$1, l2 = new A$2();
        } else l2 = e3 ? [] : o2;
        t: for(; ++i2 < r2;){
            var h2 = t3[i2], c2 = e3 ? e3(h2) : h2;
            if (h2 = 0 !== h2 ? h2 : 0, n2 && c2 == c2) {
                for(var d2 = l2.length; d2--;)if (l2[d2] === c2) continue t;
                e3 && l2.push(c2), o2.push(h2);
            } else s2(l2, c2, void 0) || (l2 !== o2 && l2.push(c2), o2.push(h2));
        }
        return o2;
    }(t2, function(t3) {
        return "function" == typeof t3 ? t3 : null == t3 ? n$e : "object" == typeof t3 ? n$f(t3) ? function(t4, e3) {
            return v$1(t4) && L$1(e3) ? H$1(w$1(t4), e3) : function(i2) {
                var s2 = function(t5, e4) {
                    var i3 = null == t5 ? void 0 : O$1(t5, e4);
                    return void 0 === i3 ? void 0 : i3;
                }(i2, t4);
                return void 0 === s2 && s2 === e3 ? x$4(i2, t4) : V$2(e3, s2, 3);
            };
        }(t3[0], t3[1]) : function(t4) {
            var e3 = function(t5) {
                for(var e4 = p$2(t5), i2 = e4.length; i2--;){
                    var s2 = e4[i2], r2 = t5[s2];
                    e4[i2] = [
                        s2,
                        r2,
                        L$1(r2)
                    ];
                }
                return e4;
            }(t4);
            return 1 == e3.length && e3[0][2] ? H$1(e3[0][0], e3[0][1]) : function(i2) {
                return i2 === t4 || function(t5, e4, i3) {
                    var s2 = i3.length, r2 = s2;
                    if (null == t5) return !r2;
                    for(t5 = Object(t5); s2--;){
                        var n2 = i3[s2];
                        if (n2[2] ? n2[1] !== t5[n2[0]] : !(n2[0] in t5)) return false;
                    }
                    for(; ++s2 < r2;){
                        var o2 = (n2 = i3[s2])[0], l2 = t5[o2], a2 = n2[1];
                        if (n2[2]) {
                            if (void 0 === l2 && !(o2 in t5)) return false;
                        } else {
                            var h2 = new w$2();
                            if (!V$2(a2, l2, 3, void 0, h2)) return false;
                        }
                    }
                    return true;
                }(i2, 0, e3);
            };
        }(t3) : function(t4) {
            return v$1(t4) ? /* @__PURE__ */ function(t5) {
                return function(e3) {
                    return null == e3 ? void 0 : e3[t5];
                };
            }(w$1(t4)) : /* @__PURE__ */ function(t5) {
                return function(e3) {
                    return O$1(e3, t5);
                };
            }(t4);
        }(t3);
    }(e2)) : [];
}
const A$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketListSelectionsDidChange = (0, $696Z8.createEvent)(this, "marketListSelectionsDidChange", 7), this.marketListSlotChange = (0, $696Z8.createEvent)(this, "marketListSlotChange", 7), this.marketListItemsReordered = (0, $696Z8.createEvent)(this, "marketListItemsReordered", 3), this.marketListItemsFiltered = (0, $696Z8.createEvent)(this, "marketListItemsFiltered", 7), this.marketInternalListValueChange = (0, $696Z8.createEvent)(this, "marketInternalListValueChange", 7), this.observers = {}, this.value = "", this.interactive = false, this.transient = false, this.multiselect = false, this.filterStrategy = "textcontent", this.reorderable = "off", this.reorderMode = "default", this.hideSelectableCount = false, this.hasSearch = false, this.selections = /* @__PURE__ */ new Set();
    }
    reorderableWatcher() {
        this.setReorderable();
    }
    valueWatcher() {
        this.marketInternalListValueChange.emit(), this.setSelectionsFromValue();
    }
    hideSelectableCountWatcher() {
        this.injectCountOnControlRow();
    }
    rowSelectedEventHandler(t2) {
        this.handleItemSelectedEvent(t2.target);
    }
    rowDeselectedEventHandler(t2) {
        this.handleItemDeselectedEvent(t2.target);
    }
    cardSelectedEventHandler(t2) {
        this.handleItemSelectedEvent(t2.target);
    }
    cardDeselectedEventHandler(t2) {
        this.handleItemDeselectedEvent(t2.target);
    }
    marketInputSearchValueChangeEventHander({ detail: t2 }) {
        this.filterItems(t2.value);
    }
    getEventSelectionDetails() {
        const t2 = (()=>"string" == typeof this.value ? this.value ? this.value.split(",").filter((t3)=>!n$k(t3)) : [] : Array.isArray(this.value) ? this.value.filter((t3)=>!n$k(t3)) : this.value)(), e2 = M$1([
            ...this.selections
        ].filter((t3)=>t3 !== this.controlRow), (t3)=>t3.value), i2 = e2.reduce((t3, e3)=>(n$k(e3.value) || t3.push(e3.value), t3), []);
        return {
            currentSelections: e2,
            currentSelectionValues: i2,
            prevSelectionValues: t2
        };
    }
    handleItemSelectedEvent(t2) {
        t2 === this.controlRow ? this.selectAllItems() : this.selectItem(t2);
        const { currentSelections: e2, currentSelectionValues: i2, prevSelectionValues: s2 } = this.getEventSelectionDetails();
        this.value = i2.join(","), this.marketListSelectionsDidChange.emit({
            newSelection: t2,
            newSelectionValue: t2.value,
            newDeselection: null,
            newDeselectionValue: null,
            currentSelections: e2,
            currentSelectionValues: i2,
            prevSelectionValues: s2
        });
    }
    handleItemDeselectedEvent(t2) {
        if (!this.selections.has(t2)) return;
        t2 === this.controlRow ? (()=>{
            var t3, e3;
            return (null !== (e3 = null === (t3 = this.filteredItems) || void 0 === t3 ? void 0 : t3.visible) && void 0 !== e3 ? e3 : this.items).filter((t4)=>t4 !== this.controlRow).filter((t4)=>!t4.disabled).every((t4)=>!t4.selected);
        })() ? this.selectAllItems() : this.deselectAllItems() : this.deselectItem(t2);
        const { currentSelections: e2, currentSelectionValues: i2, prevSelectionValues: s2 } = this.getEventSelectionDetails();
        this.value = i2.join(","), this.marketListSelectionsDidChange.emit({
            newSelection: null,
            newSelectionValue: null,
            newDeselection: t2,
            newDeselectionValue: t2.value,
            currentSelections: e2,
            currentSelectionValues: i2,
            prevSelectionValues: s2
        });
    }
    selectItem(t2) {
        this.interactive && (this.multiselect ? this.selections.add(t2) : (this.deselectItems([
            t2
        ]), this.selections = /* @__PURE__ */ new Set([
            t2
        ])));
    }
    selectAllItems() {
        var t2;
        if (!this.items || !this.interactive || !this.multiselect) return;
        const e2 = ((null === (t2 = this.filteredItems) || void 0 === t2 ? void 0 : t2.visible) || this.items).filter((t3)=>!t3.disabled);
        this.selections = /* @__PURE__ */ new Set([
            ...this.selections.values(),
            ...e2
        ]);
    }
    deselectItem(t2) {
        this.selections.delete(t2);
    }
    deselectItems(t2) {
        this.items && this.items.forEach((e2)=>{
            !t2.includes(e2) && e2.selected && e2.deselect();
        });
    }
    deselectAllItems() {
        var t2, e2;
        if (!this.selections || !this.interactive) return;
        const i2 = new Set(null !== (e2 = null === (t2 = this.filteredItems) || void 0 === t2 ? void 0 : t2.visible) && void 0 !== e2 ? e2 : this.items), s2 = [
            ...this.selections
        ].filter((t3)=>t3.disabled || !i2.has(t3));
        this.selections = new Set(s2);
    }
    syncListInteractiveWithItems() {
        this.items.length > 0 && (this.items[0].tagName === l$s("market-action-card").toUpperCase() || this.items[0].tagName === l$s("market-row").toUpperCase() && true === this.items[0].interactive) && !this.interactive && (this.interactive = true);
    }
    processItems() {
        this.items.forEach((t2)=>{
            if (t2.tagName === l$s("market-action-card").toUpperCase()) {
                t2.transient = this.transient;
                const e2 = t2.querySelector(l$s("market-row"));
                e2 && this.setRowProperties(e2);
            } else this.setRowProperties(t2);
        });
    }
    getCurrentSelectionValues() {
        return Array.isArray(this.value) ? new Set(this.value) : new Set(this.multiselect ? this.value.split(",") : [
            this.value
        ]);
    }
    setRowProperties(t2) {
        t2.interactive = this.interactive, t2.transient = this.transient, t2.togglable = this.multiselect;
    }
    setSelectionsFromValue() {
        var t2;
        if (this.value || "" === this.value) {
            const e2 = this.getCurrentSelectionValues();
            null === (t2 = this.items) || void 0 === t2 || t2.forEach((t3)=>{
                t3 !== this.controlRow && (!n$k(this.value) && e2.has(t3.value) ? (t3.silentlySelect(), this.selectItem(t3)) : (t3.silentlyDeselect(), this.deselectItem(t3)));
            });
        }
    }
    setSelectionsFromRowAttributes() {
        const t2 = /* @__PURE__ */ new Set();
        this.items.forEach((e2)=>{
            e2.selected && t2.add(e2);
        }), this.selections = t2;
    }
    setListAndItemsRoles() {
        const t2 = this.items.map((t3)=>i$d(t3));
        t2.every((t3)=>t3 === o$9.CHECKBOX) || t2.every((t3)=>t3 === o$9.RADIO) || t2.every((t3)=>t3 === o$9.SWITCH) || t2.every((t3)=>t3 === o$9.SELECTABLE_WITHOUT_CONTROL) ? (this.el.setAttribute("role", "listbox"), this.items.forEach((t3)=>{
            t3.setAttribute("role", "option");
        }), this.el.setAttribute("aria-multiselectable", this.multiselect ? "true" : "false")) : (this.el.setAttribute("role", "list"), this.items.forEach((t3)=>{
            t3.setAttribute("role", "listitem");
        })), this.value ? this.setSelectionsFromValue() : this.setSelectionsFromRowAttributes();
    }
    setInternalState() {
        this.items = [
            ...this.el.children
        ].filter((t2)=>{
            const e2 = t2.tagName.toLowerCase();
            return e2 === l$s("market-row").toLowerCase() || e2 === l$s("market-action-card").toLowerCase();
        }), 0 !== this.items.length && (this.syncListInteractiveWithItems(), this.processItems(), this.setListAndItemsRoles(), this.value ? this.setSelectionsFromValue() : this.setSelectionsFromRowAttributes());
    }
    async syncControlRowWithSelections() {
        var t2, e2;
        if (!this.controlRow) return;
        const i2 = this.controlRow.querySelector('[slot="control"]'), s2 = i2.tagName.toLowerCase() === l$s("market-checkbox"), r2 = (null !== (e2 = null === (t2 = this.filteredItems) || void 0 === t2 ? void 0 : t2.visible) && void 0 !== e2 ? e2 : this.items).filter((t3)=>t3 !== this.controlRow);
        switch(r2.every((t3)=>t3.selected) ? "checked" : r2.some((t3)=>t3.selected) ? "indeterminate" : "unchecked"){
            case "unchecked":
                this.deselectItem(this.controlRow), await this.controlRow.silentlyDeselect(), await n$z(), i2.removeAttribute("indeterminate");
                break;
            case "checked":
                await this.controlRow.silentlySelect(), this.selectItem(this.controlRow), i2.removeAttribute("indeterminate");
                break;
            case "indeterminate":
                s2 ? (await this.controlRow.silentlySelect(), this.selectItem(this.controlRow), await n$z(), i2.setAttribute("indeterminate", "")) : (await this.controlRow.silentlyDeselect(), this.deselectItem(this.controlRow));
        }
        this.injectCountOnControlRow();
    }
    injectCountOnControlRow() {
        if (!this.controlRow) return;
        const t2 = this.controlRow.querySelector('.count[slot="trailing-accessory"]');
        if (this.hideSelectableCount) return void (t2 && this.controlRow.removeChild(t2));
        const e2 = this.filteredItems.visible.filter((t3)=>!t3.disabled).length;
        if (t2) t2.textContent = "" + e2;
        else {
            const t3 = document.createElement("span");
            t3.classList.add("count"), t3.setAttribute("slot", "trailing-accessory"), t3.textContent = "" + e2, this.controlRow.appendChild(t3);
        }
    }
    filterItems(t2) {
        var e2;
        const i2 = this.items.reduce((e3, i3)=>{
            var s2, r2, n2, o2, l2, a2, h2, c2, d2, u2, f2;
            if ("control-row" === i3.getAttribute("slot")) return e3;
            if (!t2) return e3.visible.push(i3), e3;
            if ("function" == typeof this.filterStrategy) {
                if (this.filterStrategy({
                    item: i3,
                    label: null !== (r2 = null === (s2 = i3.querySelector('[slot="label"]')) || void 0 === s2 ? void 0 : s2.textContent) && void 0 !== r2 ? r2 : "",
                    query: t2,
                    textContent: null !== (n2 = i3.textContent) && void 0 !== n2 ? n2 : "",
                    value: i3.value
                })) return e3.visible.push(i3), e3;
            } else if ("textcontent" === (null === (l2 = null === (o2 = this.filterStrategy) || void 0 === o2 ? void 0 : o2.toLocaleLowerCase) || void 0 === l2 ? void 0 : l2.call(o2))) {
                if ((null !== (a2 = null == i3 ? void 0 : i3.textContent) && void 0 !== a2 ? a2 : "").search(RegExp(t2, "i")) >= 0) return e3.visible.push(i3), e3;
            } else if ("label" === (null === (c2 = null === (h2 = this.filterStrategy) || void 0 === h2 ? void 0 : h2.toLocaleLowerCase) || void 0 === c2 ? void 0 : c2.call(h2))) {
                const s3 = i3.querySelector('[slot="label"]');
                if ((null === (d2 = null == s3 ? void 0 : s3.textContent) || void 0 === d2 ? void 0 : d2.search(RegExp(t2, "i"))) >= 0) return e3.visible.push(i3), e3;
            } else if ("value" === (null === (f2 = null === (u2 = this.filterStrategy) || void 0 === u2 ? void 0 : u2.toLocaleLowerCase) || void 0 === f2 ? void 0 : f2.call(u2)) && (i3.value + "").search(RegExp(t2)) >= 0) return e3.visible.push(i3), e3;
            return e3.hidden.push(i3), e3;
        }, {
            visible: [],
            hidden: [],
            visibleSelected: [],
            selected: []
        });
        requestAnimationFrame(()=>{
            var t3;
            if (i2.visible.forEach((t4)=>t4.classList.remove("hidden")), i2.hidden.forEach((t4)=>t4.classList.add("hidden")), this.items.forEach((t4)=>t4.classList.remove("hide-bottom-border")), i2.visible.length > 0) {
                const t4 = i2.visible.at(-1);
                null == t4 || t4.classList.add("hide-bottom-border");
            }
            null === (t3 = this.controlRow) || void 0 === t3 || t3.classList.toggle("hidden", 0 === i2.visible.length);
        }), (this.filteredItems || !this.filteredItems && t2) && this.marketListItemsFiltered.emit({
            items: i2.visible,
            prevItems: null === (e2 = this.filteredItems) || void 0 === e2 ? void 0 : e2.visible
        }), this.filteredItems = i2, this.updateSelectedItemsInFilteredItems();
    }
    updateSelectedItemsInFilteredItems() {
        this.filteredItems && (this.filteredItems.selected = this.items.filter((t2)=>"control-row" !== t2.getAttribute("slot") && t2.selected), this.filteredItems.visibleSelected = this.filteredItems.visible.filter((t2)=>"control-row" !== t2.getAttribute("slot") && t2.selected));
    }
    handleSearchSlotchange() {
        var t2;
        this.inputSearchEl = this.el.querySelector('[slot="search"]'), this.hasSearch = !!this.inputSearchEl, this.filterItems(null === (t2 = this.inputSearchEl) || void 0 === t2 ? void 0 : t2.value);
    }
    defaultSlotchangeHandler() {
        var t2;
        this.setInternalState(), this.filterItems(null === (t2 = this.inputSearchEl) || void 0 === t2 ? void 0 : t2.value), this.setReorderable(), this.marketListSlotChange.emit();
    }
    controlRowSlotchangeHandler() {
        if (!this.interactive || !this.multiselect) return;
        const t2 = this.el.querySelector('[slot="control-row"]'), e2 = null == t2 ? void 0 : t2.querySelector('[slot="control"]');
        this.controlRow = a$h(e2) ? t2 : void 0;
    }
    setEmptyStateVisibility() {
        var t2, e2;
        const i2 = this.el.querySelector('[slot="empty-state"]') || this.el.shadowRoot.querySelector(l$s("market-empty-state")), s2 = (null === (t2 = this.inputSearchEl) || void 0 === t2 ? void 0 : t2.value) && !(null === (e2 = this.filteredItems) || void 0 === e2 ? void 0 : e2.visible.length);
        null == i2 || i2.classList.toggle("hidden", !s2);
    }
    initItemDisabledAttributeObserver() {
        this.observers.itemDisabledAttribute || (this.observers.itemDisabledAttribute = new MutationObserver((t2)=>{
            for (const e2 of t2)e2.target.parentElement === this.el && "attributes" === e2.type && "disabled" === e2.attributeName && this.injectCountOnControlRow();
        }), this.observers.itemDisabledAttribute.observe(this.el, {
            attributes: true,
            attributeFilter: [
                "disabled"
            ],
            childList: true,
            subtree: true
        }));
    }
    connectedCallback() {
        this.syncControlRowWithSelections();
    }
    componentWillLoad() {
        var t2;
        this.setInternalState(), this.filterItems(null === (t2 = this.inputSearchEl) || void 0 === t2 ? void 0 : t2.value);
    }
    componentWillRender() {
        this.syncListInteractiveWithItems(), this.processItems(), this.setListAndItemsRoles(), this.updateSelectedItemsInFilteredItems(), this.controlRowSlotchangeHandler(), this.syncControlRowWithSelections(), this.setEmptyStateVisibility();
    }
    componentDidLoad() {
        this.initItemDisabledAttributeObserver();
    }
    disconnectedCallback() {
        var t2;
        null === (t2 = this.observers.itemDisabledAttribute) || void 0 === t2 || t2.disconnect();
    }
    handleKeydown(t2) {
        switch(t2.key){
            case "ArrowDown":
                this.handleArrowDown(t2);
                break;
            case "ArrowUp":
                this.handleArrowUp(t2);
        }
    }
    handleArrowDown(t2) {
        const e2 = this.el.querySelector(":focus"), i2 = [
            ...this.items
        ].indexOf(e2);
        if (-1 !== i2) {
            for(let t3 = i2 + 1; t3 < this.items.length; t3++)if (!this.items[t3].disabled) {
                this.items[t3].focus();
                break;
            }
            t2.preventDefault();
        }
    }
    handleArrowUp(t2) {
        const e2 = this.el.querySelector(":focus"), i2 = [
            ...this.items
        ].indexOf(e2);
        if (-1 !== i2) {
            for(let t3 = i2 - 1; t3 >= 0; t3--)if (!this.items[t3].disabled) {
                this.items[t3].focus();
                break;
            }
            t2.preventDefault();
        }
    }
    async focusRowAtIndex(t2) {
        const e2 = this.items[t2];
        return e2 ? (e2.focus(), Promise.resolve()) : Promise.reject(Error(`Row at index ${t2} not found`));
    }
    setReorderable() {
        const { el: t2, items: e2, controlRow: i2, reorderable: s2, reorderMode: r2, reorder: n2, marketListItemsReordered: l2 } = this;
        "off" === s2 ? (null == n2 || n2.destroy(), this.reorder = null) : n2 || (this.reorder = new i$9({
            el: t2,
            accepts: [
                l$s("market-row") + ':not([slot="control"])'
            ],
            event: l2,
            mode: r2
        })), null == e2 || e2.forEach((t3)=>{
            l$b(t3) && t3 !== i2 && (t3.dragEnabled = "off" !== s2);
        });
    }
    onDragMove(t2) {
        var e2;
        null === (e2 = this.reorder) || void 0 === e2 || e2.dragMove(t2);
    }
    onDragLeave() {
        var t2;
        null === (t2 = this.reorder) || void 0 === t2 || t2.dragLeave();
    }
    onDragEnd(t2) {
        var e2;
        null === (e2 = this.reorder) || void 0 === e2 || e2.dragEnd(t2);
    }
    onDragDrop(t2) {
        var e2;
        null === (e2 = this.reorder) || void 0 === e2 || e2.dragDrop(t2);
    }
    componentDidRender() {
        this.setReorderable();
    }
    render() {
        var t2;
        const e2 = l$s("market-empty-state");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "dee5ee3d9b57d8df742ff1a34e966844ca8c5a78",
            class: "market-list",
            "aria-labelledby": this.name,
            "has-search": this.hasSearch,
            onKeydown: (t3)=>this.handleKeydown(t3),
            onMarketDragMove: (t3)=>this.onDragMove(t3),
            onMarketDragLeave: ()=>this.onDragLeave(),
            onMarketDragEnd: (t3)=>this.onDragEnd(t3),
            onMarketDragDrop: (t3)=>this.onDragDrop(t3)
        }, (0, $696Z8.h)("slot", {
            key: "7aec156bd87a51248405ed6905839a41cf56e04b",
            name: "search",
            onSlotchange: ()=>this.handleSearchSlotchange()
        }), (0, $696Z8.h)("slot", {
            key: "fe27ba416a7250112e211c0fcd435681661ceefe",
            name: "control-row",
            onSlotchange: ()=>this.controlRowSlotchangeHandler()
        }), (0, $696Z8.h)("slot", {
            key: "111ae6c93d019c4caab86cf6427523fc71335676",
            onSlotchange: ()=>this.defaultSlotchangeHandler()
        }), (0, $696Z8.h)("slot", {
            key: "ddcc58b59bc01350daee6d19c2c8faaab62fa254",
            name: "empty-state"
        }, (0, $696Z8.h)(e2, {
            key: "603f4c62819fa2b78c615dfdeeebd244236cc245",
            class: "hidden"
        }, (0, $696Z8.h)("svg", {
            key: "2e9d7fa815947f9288fb260c7651a7699e2bf4b7",
            height: "40",
            slot: "media",
            viewBox: "0 0 40 40",
            width: "40",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "b4e26b06817a8322864bd3168a92c348f5d57400",
            d: "M34.4667 17.2L28.1 10.8333H26.6667C26.6667 9.45 25.55 8.33333 24.1667 8.33333C22.7834 8.33333 21.6667 9.45 21.6667 10.8333H18.3334C18.3334 9.45 17.2167 8.33333 15.8334 8.33333C14.45 8.33333 13.3334 9.45 13.3334 10.8333H11.9L5.53337 17.2C4.11671 18.6167 3.33337 20.5 3.33337 22.5C3.33337 26.6333 6.70004 30 10.8334 30C14.8 30 18.0167 26.9 18.2834 23.0167C18.8167 23.2167 19.4 23.3333 20 23.3333C20.6 23.3333 21.1834 23.2167 21.7167 23.0167C21.9834 26.9 25.2 30 29.1667 30C33.3 30 36.6667 26.6333 36.6667 22.5C36.6667 20.5 35.8834 18.6167 34.4667 17.2ZM10.8334 26.6667C8.53337 26.6667 6.66671 24.8 6.66671 22.5C6.66671 21.3833 7.10004 20.3333 7.88337 19.55C8.66671 18.7667 9.71671 18.3333 10.8334 18.3333C13.1334 18.3333 15 20.2 15 22.5C15 24.8 13.1334 26.6667 10.8334 26.6667ZM15.35 16.55C14.4667 15.8833 13.4334 15.3833 12.3 15.15L13.2667 14.1667H17.2334C16.3834 14.7333 15.7167 15.5667 15.35 16.55ZM20 20C19.0834 20 18.3334 19.25 18.3334 18.3333C18.3334 17.4167 19.0834 16.6667 20 16.6667C20.9167 16.6667 21.6667 17.4167 21.6667 18.3333C21.6667 19.25 20.9167 20 20 20ZM22.75 14.1667H26.7167L27.7 15.15C26.5667 15.3833 25.5334 15.8833 24.65 16.55C24.2834 15.5667 23.6167 14.7333 22.75 14.1667ZM29.1667 26.6667C26.8667 26.6667 25 24.8 25 22.5C25 20.2 26.8667 18.3333 29.1667 18.3333C30.2834 18.3333 31.3334 18.7667 32.1167 19.55C32.9 20.3333 33.3334 21.3833 33.3334 22.5C33.3334 24.8 31.4667 26.6667 29.1667 26.6667Z",
            fill: "var(--core-text-10-color)",
            "fill-opacity": "0.9"
        })), (0, $696Z8.h)("h3", {
            key: "6c1ea2ac233e6cde512b6153713b328f3636f154",
            slot: "primary-text"
        }, (0, $696Z8.h)("slot", {
            key: "644c62c1d586e59d9c380da1c60f9a9c11c64524",
            name: "empty-state-primary-text"
        }, "No search results for \u201C", null === (t2 = this.inputSearchEl) || void 0 === t2 ? void 0 : t2.value, "\u201D")), (0, $696Z8.h)("p", {
            key: "58e1cab3ed43ea9de1e811eebca1bc6b304b7734",
            slot: "secondary-text"
        }, (0, $696Z8.h)("slot", {
            key: "3a78c5c1d06cd1da83e5a6bbb60f5940cb250055",
            name: "empty-state-secondary-text"
        }, "Try a different search.")))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            reorderable: [
                {
                    reorderableWatcher: 0
                }
            ],
            value: [
                {
                    valueWatcher: 0
                }
            ],
            hideSelectableCount: [
                {
                    hideSelectableCountWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:block}::slotted(.market-action-card){margin-bottom:var(--core-metrics-spacing-200)}::slotted(.market-input-search){margin-bottom:var(--core-metrics-spacing-100)}.hidden,::slotted(.hidden){display:none}::slotted(.market-row.hide-bottom-border)::before{display:none}::slotted(.market-row:focus){z-index:1}.market-empty-state,::slotted(.market-empty-state){padding-right:0;padding-left:0;border:0}::slotted(.market-drag-cursor){--drag-cursor-height:4px;position:relative;z-index:2;display:block;height:0;outline:calc(var(--drag-cursor-height) / 2) solid var(--core-emphasis-fill-color);pointer-events:none}";
    }
}, [
    257,
    "market-list",
    {
        value: [
            1537
        ],
        interactive: [
            1028
        ],
        transient: [
            4
        ],
        multiselect: [
            516
        ],
        name: [
            1
        ],
        filterStrategy: [
            1,
            "filter-strategy"
        ],
        reorderable: [
            513
        ],
        reorderMode: [
            1,
            "reorder-mode"
        ],
        hideSelectableCount: [
            516,
            "hide-selectable-count"
        ],
        hasSearch: [
            32
        ],
        items: [
            32
        ],
        selections: [
            32
        ],
        filteredItems: [
            32
        ],
        focusRowAtIndex: [
            64
        ]
    },
    [
        [
            0,
            "marketRowSelected",
            "rowSelectedEventHandler"
        ],
        [
            0,
            "marketRowDeselected",
            "rowDeselectedEventHandler"
        ],
        [
            0,
            "marketCardSelected",
            "cardSelectedEventHandler"
        ],
        [
            0,
            "marketCardDeselected",
            "cardDeselectedEventHandler"
        ],
        [
            0,
            "marketInputSearchValueChange",
            "marketInputSearchValueChangeEventHander"
        ]
    ],
    {
        reorderable: [
            {
                reorderableWatcher: 0
            }
        ],
        value: [
            {
                valueWatcher: 0
            }
        ],
        hideSelectableCount: [
            {
                hideSelectableCountWatcher: 0
            }
        ]
    }
]), W$2 = A$1;
const u$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7), this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7), this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7), this.type = "modal-full", this.hidden = false, this.layout = "regular", this.trapFocus = false, this.animationEnterDuration = D$9, this.animationExitDuration = E$6;
    }
    layoutWatcher() {
        this.repositionHeader();
    }
    headerNavigateEventHandler(t2) {
        const { detail: a2, target: o2 } = t2;
        "close" === a2.action && o2.closest(i$l()) === this.el && this.dismiss();
    }
    repositionHeader() {
        const t2 = this.el.querySelector(l$s("market-header"));
        if (t2) switch(t2.classList.remove("regular", "wide"), this.layout){
            case "regular":
                t2.classList.add("regular");
                break;
            case "wide":
                t2.classList.add("wide");
        }
    }
    dismiss(t2) {
        const { defaultPrevented: a2 } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (null == t2 ? void 0 : t2.origin) || this.el
        });
        return a2 || (this.hidden = true, this.dismissTimeout = setTimeout(()=>{
            this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
                dialog: this.el,
                type: this.type,
                origin: this.el
            });
        }, this.animationExitDuration)), Promise.resolve();
    }
    onTrapFocusChanged(t2, a2) {
        t2 !== a2 && (t2 ? this.activateFocusTrap() : this.deactivateFocusTrap());
    }
    activateFocusTrap(t2, a2) {
        return this.focusTrap ? (this.focusTrap.activate(null != a2 ? a2 : {}), this.trapFocus || (this.trapFocus = true)) : this.focusTrap = C$4({
            activateOptions: a2,
            el: this.el,
            options: t2
        }), Promise.resolve();
    }
    deactivateFocusTrap(t2) {
        return this.focusTrap && (this.focusTrap.deactivate(Object.assign({
            returnFocus: true,
            checkCanReturnFocus: (t3)=>new Promise((a2)=>{
                    I$3(t3) ? t3.setFocus() : a2();
                })
        }, t2)), this.focusTrap = void 0), Promise.resolve();
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            }), this.trapFocus && this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    componentWillLoad() {
        n$C(this.el);
    }
    disconnectedCallback() {
        this.deactivateFocusTrap(), clearTimeout(this.connectedCallbackTimeout), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
            dialog: this.el,
            type: this.type,
            origin: this.el
        }));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "6f9a63dc8b9ac041a9dc641f9806b3ca4a942c11",
            class: "market-modal-full",
            role: "dialog"
        }, (0, $696Z8.h)("slot", {
            key: "550d5c8809a80ceb22b855c805178d2072599a31",
            onSlotchange: ()=>this.repositionHeader()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            layout: [
                {
                    layoutWatcher: 0
                }
            ],
            trapFocus: [
                {
                    onTrapFocusChanged: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main),:host ::slotted(.main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{position:absolute;top:0;left:0;width:100%;height:100%;padding-top:var(--modal-full-vertical-padding-size);padding-bottom:var(--modal-full-vertical-padding-size);background-color:var(--modal-full-background-color);animation:var(--modal-full-animation-enter-transition-duration)     market-slideup     forwards     var(--modal-full-animation-enter-transition-easing)}:host ::slotted(*:not(.market-popover)){padding-right:var(--modal-full-horizontal-padding-size);padding-left:var(--modal-full-horizontal-padding-size)}:host([hidden]){animation-name:market-slidedown;animation-duration:var(--modal-full-animation-exit-transition-duration);animation-timing-function:var(--modal-full-animation-exit-transition-easing)}:host{--modal-full-wide-layout-width:1200px;--regular-modal-main-horizontal-padding:calc((100vw - var(--modal-full-fixed-layout-width)) / 2);--wide-modal-main-horizontal-padding:calc((100vw - var(--modal-full-wide-layout-width)) / 2)}@media (width >= 648px){:host([layout="regular"])>:not(.market-header,.market-footer),:host([layout="regular"]) ::slotted(main),:host([layout="regular"]) ::slotted(.main){padding:0 var(--regular-modal-main-horizontal-padding)}}@media (width >= 1280px){:host([layout="wide"])>:not(.market-header,.market-footer),:host([layout="wide"]) ::slotted(main),:host([layout="wide"]) ::slotted(.main){padding:0 var(--wide-modal-main-horizontal-padding)}}';
    }
}, [
    257,
    "market-modal-full",
    {
        hidden: [
            1540
        ],
        dialogID: [
            513,
            "data-dialog-id"
        ],
        index: [
            514,
            "data-dialog-index"
        ],
        layout: [
            513
        ],
        trapFocus: [
            1028,
            "trap-focus"
        ],
        animationEnterDuration: [
            2,
            "animation-enter-duration"
        ],
        animationExitDuration: [
            2,
            "animation-exit-duration"
        ],
        dismiss: [
            64
        ],
        activateFocusTrap: [
            64
        ],
        deactivateFocusTrap: [
            64
        ]
    },
    [
        [
            0,
            "marketHeaderNavigate",
            "headerNavigateEventHandler"
        ]
    ],
    {
        layout: [
            {
                layoutWatcher: 0
            }
        ],
        trapFocus: [
            {
                onTrapFocusChanged: 0
            }
        ]
    }
]), f$3 = u$2;
const h$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7), this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7), this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7), this.type = "modal-partial", this.hidden = false, this.trapFocus = false, this.animationEnterDuration = F$5, this.animationExitDuration = G$4;
    }
    headerNavigateEventHandler(t2) {
        const { detail: a2, target: i2 } = t2;
        "close" === a2.action && i2.closest(i$l()) === this.el && this.dismiss();
    }
    dismiss(t2) {
        const { defaultPrevented: a2 } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (null == t2 ? void 0 : t2.origin) || this.el
        });
        return a2 || (this.hidden = true, this.dismissTimeout = setTimeout(()=>{
            this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
                dialog: this.el,
                type: this.type,
                origin: this.el
            });
        }, this.animationExitDuration)), Promise.resolve();
    }
    onTrapFocusChanged(t2, a2) {
        t2 !== a2 && (t2 ? this.activateFocusTrap() : this.deactivateFocusTrap());
    }
    activateFocusTrap(t2, a2) {
        return this.focusTrap ? (this.focusTrap.activate(null != a2 ? a2 : {}), this.trapFocus || (this.trapFocus = true)) : this.focusTrap = C$4({
            el: this.el,
            options: t2,
            activateOptions: a2
        }), Promise.resolve();
    }
    deactivateFocusTrap(t2 = {}) {
        return this.focusTrap && (this.focusTrap.deactivate(Object.assign({
            returnFocus: true,
            checkCanReturnFocus: (t3)=>new Promise((a2)=>{
                    I$3(t3) ? t3.setFocus() : a2();
                })
        }, t2)), this.focusTrap = void 0), Promise.resolve();
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            }), this.trapFocus && this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    componentWillLoad() {
        n$C(this.el);
    }
    disconnectedCallback() {
        this.deactivateFocusTrap(), clearTimeout(this.connectedCallbackTimeout), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = void 0, this.marketDialogDidDismiss.emit({
            dialog: this.el,
            type: this.type,
            origin: this.el
        }));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "a7961804573ca9f5a11524f3ca25910a52e1ce3a",
            class: "market-modal-partial",
            role: "dialog"
        }, (0, $696Z8.h)("slot", {
            key: "6b783daa35cadc879004163f48d381f52d971f8e"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            trapFocus: [
                {
                    onTrapFocusChanged: 0
                }
            ]
        };
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main),:host ::slotted(.main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{position:absolute;top:0;left:0;width:100%;height:100%;padding-top:var(--modal-full-vertical-padding-size);padding-bottom:var(--modal-full-vertical-padding-size);background-color:var(--modal-full-background-color);animation:var(--modal-full-animation-enter-transition-duration)     market-slideup     forwards     var(--modal-full-animation-enter-transition-easing)}:host ::slotted(*:not(.market-popover)){padding-right:var(--modal-full-horizontal-padding-size);padding-left:var(--modal-full-horizontal-padding-size)}:host([hidden]){animation-name:market-slidedown;animation-duration:var(--modal-full-animation-exit-transition-duration);animation-timing-function:var(--modal-full-animation-exit-transition-easing)}@media (width >= 800px){:host{top:0;left:auto;width:var(--modal-partial-width);height:auto;max-height:calc(100vh - var(--modal-partial-vertical-screen-buffer-size) * 2);padding-top:var(--modal-partial-vertical-padding-size);padding-bottom:var(--modal-partial-vertical-padding-size);border-radius:var(--modal-partial-border-radius);animation:var(--modal-partial-animation-enter-transition-duration)       market-popup       forwards       var(--modal-partial-animation-enter-transition-easing)}:host ::slotted(*){padding-right:var(--modal-partial-horizontal-padding-size);padding-left:var(--modal-partial-horizontal-padding-size)}:host([hidden]){animation-name:market-popdown;animation-duration:var(--modal-partial-animation-exit-transition-duration);animation-timing-function:var(--modal-partial-animation-exit-transition-easing)}}";
    }
}, [
    257,
    "market-modal-partial",
    {
        hidden: [
            1540
        ],
        dialogID: [
            513,
            "data-dialog-id"
        ],
        index: [
            514,
            "data-dialog-index"
        ],
        trapFocus: [
            1028,
            "trap-focus"
        ],
        animationEnterDuration: [
            2,
            "animation-enter-duration"
        ],
        animationExitDuration: [
            2,
            "animation-exit-duration"
        ],
        dismiss: [
            64
        ],
        activateFocusTrap: [
            64
        ],
        deactivateFocusTrap: [
            64
        ]
    },
    [
        [
            0,
            "marketHeaderNavigate",
            "headerNavigateEventHandler"
        ]
    ],
    {
        trapFocus: [
            {
                onTrapFocusChanged: 0
            }
        ]
    }
]), f$2 = h$3;
const g$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(a2){
        super(), false !== a2 && this.__registerHost(), this.__attachShadow(), this.marketPaginationPageSizeChange = (0, $696Z8.createEvent)(this, "marketPaginationPageSizeChange", 7), this.marketPaginationNavigation = (0, $696Z8.createEvent)(this, "marketPaginationNavigation", 7), this.disabled = false;
    }
    changePageSize(a2) {
        a2.stopPropagation();
        const { detail: e2 } = a2;
        this.marketPaginationPageSizeChange.emit(e2);
    }
    navigatePage(a2) {
        a2.stopPropagation();
        const { detail: e2 } = a2;
        this.marketPaginationNavigation.emit(e2);
    }
    render() {
        const a2 = l$s("market-pagination-page-size"), e2 = l$s("market-pagination-nav");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "b26300e6c6bbd883f838a90f268c7da4c713bb0c",
            class: "market-pagination"
        }, this.pageSizeOptions && (0, $696Z8.h)(a2, {
            key: "37bfcf121164db0195d75d1c6d069bd8388a3110",
            value: this.pageSize,
            pageSizeOptions: this.pageSizeOptions,
            disabled: this.disabled
        }, (0, $696Z8.h)("slot", {
            key: "063b5b7b858ebace63715b39809a3fc80547a9f8",
            name: "page-size-label",
            slot: "page-size-label"
        }, "Results per page"), (0, $696Z8.h)("slot", {
            key: "e901312ba4c6651c5deddbd89219a2f2e0ce6a30",
            name: "page-size-feedback",
            slot: "page-size-feedback"
        }, this.pageSize)), (0, $696Z8.h)(e2, {
            key: "0357d61070a9a80c9e9084935515ac895f7136cd",
            currentPage: this.currentPage,
            disabled: this.disabled,
            totalPages: this.totalPages,
            pageSize: this.pageSize,
            hasNextPage: this.hasNextPage,
            hasPreviousPage: this.hasPreviousPage
        }, (0, $696Z8.h)("slot", {
            key: "0885cd911fe98e21a9b50ae7bbd92e5296cca4b8",
            name: "nav-label",
            slot: "nav-label"
        }, "Page"), (0, $696Z8.h)("slot", {
            key: "f73b81752d51d08cbc3c811c1a4be6ea697b94c6",
            name: "nav-feedback",
            slot: "nav-feedback"
        }, this.currentPage, " of ", this.totalPages)));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host{display:flex;flex-direction:column;align-items:stretch}.market-button-dropdown{display:flex;flex-direction:column;align-items:stretch}.market-button-dropdown .market-filter-button{display:block}.market-pagination-page-size+.market-pagination-nav{margin-top:var(--pagination-nav-vertical-margin)}@media only screen and (width >= 600px){.market-pagination-page-size+.market-pagination-nav{margin-top:0;margin-left:var(--pagination-nav-horizontal-margin)}}.market-pagination-nav nav{display:flex;-moz-column-gap:var(--pagination-nav-content-spacing);column-gap:var(--pagination-nav-content-spacing);justify-content:space-between}.market-pagination-nav nav .market-button-dropdown{flex-grow:1}@media only screen and (width >= 600px){:host{flex-direction:row;justify-content:space-between}.market-pagination-nav:only-child{margin-left:auto}}";
    }
}, [
    257,
    "market-pagination",
    {
        currentPage: [
            2,
            "current-page"
        ],
        disabled: [
            516
        ],
        totalPages: [
            2,
            "total-pages"
        ],
        hasNextPage: [
            4,
            "has-next-page"
        ],
        hasPreviousPage: [
            4,
            "has-previous-page"
        ],
        pageSize: [
            1,
            "page-size"
        ],
        pageSizeOptions: [
            1,
            "page-size-options"
        ]
    },
    [
        [
            0,
            "marketInternalPaginationPageSizeChange",
            "changePageSize"
        ],
        [
            0,
            "marketInternalPaginationNavigation",
            "navigatePage"
        ]
    ]
]), r$4 = g$3;
const c$9 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.marketInternalPaginationNavigation = (0, $696Z8.createEvent)(this, "marketInternalPaginationNavigation", 7), this.disabled = false;
    }
    listSelectionEventHandler(e2) {
        const { newSelectionValue: a2 } = e2.detail;
        this.marketInternalPaginationNavigation.emit({
            page: a2,
            prevPage: "" + this.currentPage,
            pageSize: this.pageSize
        });
    }
    handlePrev() {
        false !== this.hasPreviousPage && 1 !== this.currentPage && this.marketInternalPaginationNavigation.emit({
            page: "" + (this.currentPage - 1),
            prevPage: "" + this.currentPage,
            pageSize: this.pageSize
        });
    }
    handleNext() {
        false === this.hasNextPage || this.totalPages && this.currentPage === this.totalPages || this.marketInternalPaginationNavigation.emit({
            page: "" + (this.currentPage + 1),
            prevPage: "" + this.currentPage,
            pageSize: this.pageSize
        });
    }
    get pageList() {
        return this.totalPages > 20 ? Array.from({
            length: Math.floor(this.totalPages / 10)
        }).map((e2, a2)=>10 * (a2 + 1)) : Array.from({
            length: this.totalPages
        }).map((e2, a2)=>a2 + 1);
    }
    render() {
        const e2 = !!this.totalPages, a2 = this.currentPage > 1 || this.hasPreviousPage, t2 = this.currentPage < this.totalPages || this.hasNextPage, d2 = l$s("market-button"), c2 = l$s("market-button-dropdown"), l2 = l$s("market-filter-button"), o2 = l$s("market-list"), b = l$s("market-row"), r = l$s("market-accessory");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "7ffd13c345d639ba0800f03fd092e1d506bc18de",
            class: "market-pagination-nav"
        }, (0, $696Z8.h)("nav", {
            key: "3ac41e4ffea7b8a9ec6d55cc4d0a1dbc106a77fb"
        }, (0, $696Z8.h)(d2, {
            key: "a5ce29b7fbe6902779ea2c26802c692d5efadba9",
            size: "small",
            disabled: this.disabled || !a2,
            onClick: ()=>this.handlePrev()
        }, (0, $696Z8.h)(r, {
            key: "b47ca8a54a8dd2ea303bb1c6e86bb68985f43118",
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            key: "074fc837f43dc29500b5007616cd36ec89270d4a",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "2b2a52d90b1bd4021ce3b0dfaf69ebe55e7d3569",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 11.293C3.90237 11.6835 3.90237 12.3167 4.29289 12.7072L11.2929 19.7072L12.7071 18.293L7.41421 13.0001L19 13.0001V11.0001L7.41421 11.0001L12.7071 5.70718L11.2929 4.29297L4.29289 11.293Z"
        })))), e2 && (0, $696Z8.h)(c2, {
            key: "5f2ebad63617b5b6f3440f303fc27e165f1b1ed3",
            disabled: this.disabled,
            "no-caret": true,
            "popover-placement": "bottom-end",
            "persist-list": true
        }, (0, $696Z8.h)(l2, {
            key: "8b4ea4f938caafc5f8008ebf6e45c1bdb93a8a4f",
            size: "small",
            slot: "trigger"
        }, (0, $696Z8.h)("span", {
            key: "072fdb9b99ff529f9211d57dd182e71ec3728a0e"
        }, (0, $696Z8.h)("slot", {
            key: "d074a7da5e79338a6a77f1a1041b76bdf7c7a352",
            name: "nav-label"
        }, "Page")), (0, $696Z8.h)("span", {
            key: "83ad0622a24676a5d728c0b531cf9739167c86ee",
            slot: "feedback"
        }, (0, $696Z8.h)("slot", {
            key: "69b77f04f64b0e10d3af02bc479f1d8f0c074dcb",
            name: "nav-feedback"
        }, this.currentPage, " of ", this.totalPages))), (0, $696Z8.h)(o2, {
            key: "c45bd2a1679aac6e908d4f7918910d8963a9deed",
            slot: "content"
        }, this.pageList.map((e3)=>(0, $696Z8.h)(b, {
                key: "pageNav_" + e3,
                selected: this.currentPage === e3,
                value: "" + e3
            }, e3)))), (0, $696Z8.h)(d2, {
            key: "dcfa8cb1cb0beb6b59e549778fa6315f312937af",
            size: "small",
            disabled: this.disabled || !t2,
            onClick: ()=>this.handleNext()
        }, (0, $696Z8.h)(r, {
            key: "2e72e0ac2611c2a2973607903730fdda19b21510",
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            key: "531ddb504e874561e15c7e8ab0ac6e1e7289b6ce",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "bb721da06ae723009b40d94f9805b30bc7ed9014",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M19.7071 11.293C20.0976 11.6835 20.0976 12.3167 19.7071 12.7072L12.7071 19.7072L11.2929 18.293L16.5858 13.0001L5 13.0001L5 11.0001L16.5858 11.0001L11.2929 5.70718L12.7071 4.29297L19.7071 11.293Z"
        }))))));
    }
    get el() {
        return this;
    }
}, [
    260,
    "market-pagination-nav",
    {
        currentPage: [
            2,
            "current-page"
        ],
        disabled: [
            516
        ],
        totalPages: [
            2,
            "total-pages"
        ],
        hasNextPage: [
            4,
            "has-next-page"
        ],
        hasPreviousPage: [
            4,
            "has-previous-page"
        ],
        pageSize: [
            1,
            "page-size"
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "listSelectionEventHandler"
        ]
    ]
]), l$6 = c$9;
const o$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.marketInternalPaginationPageSizeChange = (0, $696Z8.createEvent)(this, "marketInternalPaginationPageSizeChange", 7), this.disabled = false;
    }
    listSelectionEventHander(e2) {
        const { newSelectionValue: t2 } = e2.detail;
        this.marketInternalPaginationPageSizeChange.emit({
            value: t2
        });
    }
    render() {
        const e2 = l$s("market-button-dropdown"), t2 = l$s("market-filter-button"), a2 = l$s("market-list"), n2 = l$s("market-row");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "42207cf91502689d605d4ccfaa39d756c8c542e0",
            class: "market-pagination-page-size"
        }, (0, $696Z8.h)(e2, {
            key: "ddccb09a0da16a4580643aef2f650943d936a438",
            "no-caret": true,
            "popover-placement": "bottom-start",
            "persist-list": true,
            disabled: this.disabled
        }, (0, $696Z8.h)(t2, {
            key: "cb10fabfb95a859b9adbd7e83d2af78b1e97544c",
            size: "small",
            slot: "trigger"
        }, (0, $696Z8.h)("span", {
            key: "5d777446c1ff81a9131fb2e257765ac35fe8a54a"
        }, (0, $696Z8.h)("slot", {
            key: "62d869de3d1ec4cd135de8d61db349c344a5add2",
            name: "page-size-label"
        }, "Results per page")), (0, $696Z8.h)("span", {
            key: "eabbc341f15c99efb1fcd96606a2dd319b7413db",
            slot: "feedback"
        }, (0, $696Z8.h)("slot", {
            key: "778d3316752834871bb22230eab3d0d9777b032f",
            name: "page-size-feedback"
        }, this.value))), (0, $696Z8.h)(a2, {
            key: "cd4bd238700310bd8aeb05ddeb970d32692b5f37",
            value: this.value,
            slot: "content"
        }, this.pageSizeOptions.split(",").map((e3)=>(0, $696Z8.h)(n2, {
                key: "pageSize_" + e3,
                selected: this.value === e3,
                value: e3
            }, e3)))));
    }
    get el() {
        return this;
    }
}, [
    260,
    "market-pagination-page-size",
    {
        disabled: [
            516
        ],
        value: [
            1
        ],
        pageSizeOptions: [
            1,
            "page-size-options"
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "listSelectionEventHander"
        ]
    ]
]), c$8 = o$2;
const l$5 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(r2){
        super(), false !== r2 && this.__registerHost(), this.__attachShadow(), this.variant = "normal", this.size = "medium", this.indicator = false, this.interactive = false;
    }
    renderIndicator() {
        const r2 = l$s("market-accessory");
        return (0, $696Z8.h)(r2, null, (0, $696Z8.h)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("circle", "medium" === this.size ? {
            cx: "8",
            cy: "8",
            r: "5"
        } : {
            cx: "8",
            cy: "8",
            r: "4"
        })));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "af5194f1faa7e75f4d9e40d13947eb9f02244878",
            class: "market-pill"
        }, (0, $696Z8.h)("slot", {
            key: "db0893b85bb7a99310c5503adb6aef62568cbf76",
            name: "icon"
        }, this.indicator && this.renderIndicator()), (0, $696Z8.h)("slot", {
            key: "4cf4066804480eed66331588b539384fb9391930"
        }));
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:inline-flex;justify-content:center;align-items:center;border-radius:var(--pill-normal-size-corner-radius);outline:solid var(--pill-emphasis-variant-border-width) var(--pill-emphasis-variant-border-color);white-space:nowrap}:host svg,:host ::slotted([slot="icon"]){color:inherit;fill:currentcolor;stroke:inherit}:host([interactive]){cursor:pointer}:host([size="medium"]){gap:var(--pill-normal-size-spacing-horizontal);padding:var(--pill-normal-size-padding-vertical-size) var(--pill-normal-size-padding-horizontal-size);font-weight:var(--pill-normal-size-text-weight);font-size:var(--pill-normal-size-text-size);line-height:var(--pill-normal-size-text-leading);letter-spacing:var(--pill-normal-size-text-tracking)}:host([size="small"]){gap:var(--pill-compact-size-spacing-horizontal);padding:var(--pill-compact-size-padding-vertical-size) var(--pill-compact-size-padding-horizontal-size);font-weight:var(--pill-compact-size-text-weight);font-size:var(--pill-compact-size-text-size);line-height:var(--pill-compact-size-text-leading);letter-spacing:var(--pill-compact-size-text-tracking)}:host([variant="normal"]){background-color:var(--pill-normal-variant-background-color);color:var(--pill-normal-variant-text-color)}:host([variant="emphasis"]){background-color:var(--pill-emphasis-variant-background-color);color:var(--pill-emphasis-variant-text-color)}:host([variant="success"]){background-color:var(--pill-success-variant-background-color);color:var(--pill-success-variant-text-color)}:host([variant="warning"]){background-color:var(--pill-warning-variant-background-color);color:var(--pill-warning-variant-text-color)}:host([variant="critical"]){background-color:var(--pill-critical-variant-background-color);color:var(--pill-critical-variant-text-color)}:host([variant="insight"]){background-color:var(--pill-insight-variant-background-color);color:var(--pill-insight-variant-text-color)}:host([variant="alpha"]){background-color:var(--pill-alpha-variant-background-color);color:var(--pill-alpha-variant-text-color)}:host([variant="beta"]){background-color:var(--pill-beta-variant-background-color);color:var(--pill-beta-variant-text-color)}@media (hover: hover){:host([variant="normal"][interactive]:hover){background-color:var(--pill-normal-variant-pressed-state-background-color)}:host([variant="emphasis"][interactive]:hover){background-color:var(--pill-emphasis-variant-pressed-state-background-color)}:host([variant="success"][interactive]:hover){background-color:var(--pill-success-variant-pressed-state-background-color)}:host([variant="warning"][interactive]:hover){background-color:var(--pill-warning-variant-pressed-state-background-color)}:host([variant="critical"][interactive]:hover){background-color:var(--pill-critical-variant-pressed-state-background-color)}:host([variant="insight"][interactive]:hover){background-color:var(--pill-insight-variant-pressed-state-background-color)}:host([variant="alpha"][interactive]:hover){background-color:var(--pill-alpha-variant-pressed-state-background-color)}:host([variant="beta"][interactive]:hover){background-color:var(--pill-beta-variant-pressed-state-background-color)}}:host([variant="normal"][interactive]:active){background-color:var(--pill-normal-variant-pressed-state-background-color)}:host([variant="emphasis"][interactive]:active){background-color:var(--pill-emphasis-variant-pressed-state-background-color)}:host([variant="success"][interactive]:active){background-color:var(--pill-success-variant-pressed-state-background-color)}:host([variant="warning"][interactive]:active){background-color:var(--pill-warning-variant-pressed-state-background-color)}:host([variant="critical"][interactive]:active){background-color:var(--pill-critical-variant-pressed-state-background-color)}:host([variant="insight"][interactive]:active){background-color:var(--pill-insight-variant-pressed-state-background-color)}:host([variant="alpha"][interactive]:active){background-color:var(--pill-alpha-variant-pressed-state-background-color)}:host([variant="beta"][interactive]:active){background-color:var(--pill-beta-variant-pressed-state-background-color)}';
    }
}, [
    257,
    "market-pill",
    {
        variant: [
            513
        ],
        size: [
            513
        ],
        indicator: [
            516
        ],
        interactive: [
            516
        ]
    }
]), n$d = l$5;
const s$a = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(o2){
        super(), false !== o2 && this.__registerHost(), this.__attachShadow();
    }
    initInteractiveList() {
        const o2 = this.el.querySelector("slot");
        let e2;
        e2 = o2 ? o2.assignedElements().filter((o3)=>o3.localName === l$s("market-list")) : [].slice.call(this.el.querySelectorAll(l$s("market-list"))), e2 && e2.forEach((o3)=>{
            o3.interactive = true;
        });
    }
    render() {
        return this.initInteractiveList(), (0, $696Z8.h)((0, $696Z8.Host), {
            key: "1fc282f1036459960923541d9206a3e1fee93661",
            class: "market-popover"
        }, (0, $696Z8.h)("slot", {
            key: "4c2aa48b04334d27ec871e8e9eb0d27563d776f4"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:inline-block;overflow-y:auto;min-width:var(--modal-popover-wide-viewport-min-width-size);max-height:var(--modal-popover-wide-viewport-max-height-size);padding:var(--modal-popover-wide-viewport-padding-right-size)     var(--modal-popover-wide-viewport-padding-right-size)     var(--modal-popover-wide-viewport-padding-right-size)     var(--modal-popover-wide-viewport-padding-left-size);border-radius:var(--modal-popover-border-radius);background-color:var(--modal-popover-background-color);box-shadow:var(--elevation-30-shadow)}@media (width >= 600px){:host{width:auto}}::slotted(.market-list){display:block;width:100%;height:100%;margin-bottom:calc(var(--modal-popover-wide-viewport-padding-bottom-size) - var(--popover-padding, 24px))}::slotted(.market-list:not([has-search])){margin:calc(var(--popover-content-vertical-padding, 8px) - var(--popover-padding, 24px)) 0}";
    }
}, [
    257,
    "market-popover"
]), d$3 = s$a;
var e$1, n$c, a$7, i$4 = Date.now, u$1 = function() {
    try {
        var t2 = b$5(Object, "defineProperty");
        return t2({}, "", {}), t2;
    } catch (r2) {}
}(), o$1 = u$1 ? function(r2, t2) {
    var e2;
    return u$1(r2, "toString", {
        configurable: true,
        enumerable: false,
        value: (e2 = t2, function() {
            return e2;
        }),
        writable: true
    });
} : n$e, c$7 = (e$1 = o$1, n$c = 0, a$7 = 0, function() {
    var r2 = i$4(), t2 = 16 - (r2 - a$7);
    if (a$7 = r2, t2 > 0) {
        if (++n$c >= 800) return arguments[0];
    } else n$c = 0;
    return e$1.apply(void 0, arguments);
}), f$1 = Math.max;
function s$9(r2, t2, e2) {
    return t2 = f$1(void 0 === t2 ? r2.length - 1 : t2, 0), function() {
        for(var n2 = arguments, a2 = -1, i2 = f$1(n2.length - t2, 0), u2 = Array(i2); ++a2 < i2;)u2[a2] = n2[t2 + a2];
        a2 = -1;
        for(var o2 = Array(t2 + 1); ++a2 < t2;)o2[a2] = n2[a2];
        return o2[t2] = e2(u2), function(r3, t3, e3) {
            switch(e3.length){
                case 0:
                    return r3.call(t3);
                case 1:
                    return r3.call(t3, e3[0]);
                case 2:
                    return r3.call(t3, e3[0], e3[1]);
                case 3:
                    return r3.call(t3, e3[0], e3[1], e3[2]);
            }
            return r3.apply(t3, e3);
        }(r2, this, o2);
    };
}
var b$1 = Object.prototype.hasOwnProperty;
function x$3(t2, e2, r2) {
    var o2 = t2[e2];
    b$1.call(t2, e2) && s$c(o2, r2) && (void 0 !== r2 || e2 in t2) || function(t3, e3, r3) {
        "__proto__" == e3 && u$1 ? u$1(t3, e3, {
            configurable: true,
            enumerable: true,
            value: r3,
            writable: true
        }) : t3[e3] = r3;
    }(t2, e2, r2);
}
var P$1 = o$h ? o$h.isConcatSpreadable : void 0;
function S$2(t2) {
    return n$f(t2) || f$6(t2) || !!(P$1 && t2 && t2[P$1]);
}
function W$1(t2) {
    return null != t2 && t2.length ? function(t3, e2, r2, o2, i2) {
        var n2 = -1, a2 = t3.length;
        for(r2 || (r2 = S$2), i2 || (i2 = []); ++n2 < a2;){
            var s2 = t3[n2];
            r2(s2) ? _$4(i2, s2) : i2[i2.length] = s2;
        }
        return i2;
    }(t2) : [];
}
function y$2(t2, e2, r2) {
    if (!j$9(t2)) return t2;
    for(var o2 = -1, i2 = (e2 = g$4(e2, t2)).length, n2 = i2 - 1, c2 = t2; null != c2 && ++o2 < i2;){
        var l2 = w$1(e2[o2]), d2 = r2;
        if ("__proto__" === l2 || "constructor" === l2 || "prototype" === l2) return t2;
        if (o2 != n2) {
            var u2 = c2[l2];
            d2 = void 0, d2 = j$9(u2) ? u2 : i$6(e2[o2 + 1]) ? [] : {};
        }
        x$3(c2, l2, d2), c2 = c2[l2];
    }
    return t2;
}
var _$1 = function(t2) {
    return c$7(s$9(t2, void 0, W$1), t2 + "");
}(function(t2, e2) {
    return null == t2 ? {} : function(t3, e3) {
        return function(t4, e4, r2) {
            for(var o2 = -1, i2 = e4.length, n2 = {}; ++o2 < i2;){
                var s2 = e4[o2], l2 = O$1(t4, s2);
                r2(0, s2) && y$2(n2, g$4(s2, t4), l2);
            }
            return n2;
        }(t3, e3, function(e4, r2) {
            return x$4(t3, r2);
        });
    }(t2, e2);
});
const j$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.compact = false, this.connectorless = false, this.interactive = false, this.orientation = "vertical", this.reversed = false, this.size = "medium";
    }
    marketProgressTrackerStepClickEventHandler(t2) {
        const { defaultPrevented: e2, detail: { index: r2 } } = t2;
        e2 || void 0 === this.currentStepIndex || (this.currentStepIndex = r2);
    }
    currentStepIndexWatcher() {
        this.updateStepState();
    }
    reversedWatcher() {
        this.updateStepState();
    }
    otherPropsWatcher(t2, e2) {
        this.propagatePropsToSteps({
            [e2]: t2
        });
    }
    get stepEls() {
        return [
            ...this.el.children
        ].filter((t2)=>i$n(t2, "market-progress-tracker-step"));
    }
    updateStepState() {
        var t2;
        const { connectorless: e2, currentStepIndex: r2, reversed: o2, stepEls: i2 } = this, n2 = o2 ? [
            ...i2
        ].reverse() : i2;
        n2.forEach((t3, e3)=>{
            t3.dataset.stepIndex = "" + e3;
        }), void 0 !== r2 && n2.forEach((t3, e3)=>{
            t3.completed = e3 < r2, t3.active = e3 === r2;
        });
        const a2 = null !== (t2 = null != r2 ? r2 : n2.findIndex((t3)=>t3.active)) && void 0 !== t2 ? t2 : -1;
        i2.forEach((t3, r3)=>{
            t3.connector = r3 < i2.length - 1 ? e2 ? null : o2 && r3 >= i2.length - a2 - 1 || !o2 && r3 < a2 ? "active" : "inactive" : e2 ? null : "hidden";
        });
    }
    propagatePropsToSteps(t2) {
        this.stepEls.forEach((e2)=>{
            var r2, o2, i2, n2, a2;
            e2.compact = null !== (r2 = null == t2 ? void 0 : t2.compact) && void 0 !== r2 ? r2 : e2.compact, e2.indicator = null !== (o2 = null == t2 ? void 0 : t2.indicator) && void 0 !== o2 ? o2 : e2.indicator, e2.interactive = null !== (i2 = null == t2 ? void 0 : t2.interactive) && void 0 !== i2 ? i2 : e2.interactive, e2.orientation = null !== (n2 = null == t2 ? void 0 : t2.orientation) && void 0 !== n2 ? n2 : e2.orientation, e2.size = null !== (a2 = null == t2 ? void 0 : t2.size) && void 0 !== a2 ? a2 : e2.size;
        });
    }
    handleDefaultSlotChange() {
        this.propagatePropsToSteps(_$1(this, "compact", "indicator", "interactive", "orientation", "size")), this.updateStepState();
    }
    connectedCallback() {
        this.propagatePropsToSteps(_$1(this, "compact", "indicator", "interactive", "orientation", "size")), this.updateStepState();
    }
    render() {
        const { handleDefaultSlotChange: t2, interactive: e2 } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "45fa746b221d5a181ba6fc64a1a5733ac8c05814",
            class: "market-progress-tracker",
            role: e2 ? "tablist" : "list"
        }, (0, $696Z8.h)("slot", {
            key: "7f9476f263aa2d77fa96f9d4ad2a2e76016bf3a1",
            onSlotchange: t2.bind(this)
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            currentStepIndex: [
                {
                    currentStepIndexWatcher: 0
                }
            ],
            reversed: [
                {
                    reversedWatcher: 0
                }
            ],
            compact: [
                {
                    otherPropsWatcher: 0
                }
            ],
            indicator: [
                {
                    otherPropsWatcher: 0
                }
            ],
            interactive: [
                {
                    otherPropsWatcher: 0
                }
            ],
            orientation: [
                {
                    otherPropsWatcher: 0
                }
            ],
            size: [
                {
                    otherPropsWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;flex-direction:column;margin:0;padding:0;list-style:none}:host([orientation="horizontal"]){flex-direction:row}:host([orientation="horizontal"][size="small"]:not([compact],[interactive])){gap:var(--tracker-horizontal-orientation-connectors-density-small-size-current-state-step-spacing)}:host([orientation="horizontal"][size="medium"]:not([compact],[interactive])){gap:var(--tracker-horizontal-orientation-connectors-density-medium-size-current-state-step-spacing)}:host([orientation="horizontal"][size="large"]:not([compact],[interactive])){gap:var(--tracker-horizontal-orientation-connectors-density-large-size-current-state-step-spacing)}:host([orientation="horizontal"][size="small"][compact]:not([interactive])){gap:var(--tracker-horizontal-orientation-compact-density-small-size-current-state-step-spacing)}:host([orientation="horizontal"][size="medium"][compact]:not([interactive])){gap:var(--tracker-horizontal-orientation-compact-density-medium-size-current-state-step-spacing)}:host([orientation="horizontal"][size="large"][compact]:not([interactive])){gap:var(--tracker-horizontal-orientation-compact-density-large-size-current-state-step-spacing)}:host([orientation="horizontal"][compact][interactive]){gap:0}';
    }
}, [
    257,
    "market-progress-tracker",
    {
        compact: [
            4
        ],
        connectorless: [
            4
        ],
        currentStepIndex: [
            1538,
            "current-step-index"
        ],
        indicator: [
            1
        ],
        interactive: [
            4
        ],
        orientation: [
            1
        ],
        reversed: [
            4
        ],
        size: [
            513
        ]
    },
    [
        [
            0,
            "marketProgressTrackerStepClick",
            "marketProgressTrackerStepClickEventHandler"
        ]
    ],
    {
        currentStepIndex: [
            {
                currentStepIndexWatcher: 0
            }
        ],
        reversed: [
            {
                reversedWatcher: 0
            }
        ],
        compact: [
            {
                otherPropsWatcher: 0
            }
        ],
        indicator: [
            {
                otherPropsWatcher: 0
            }
        ],
        interactive: [
            {
                otherPropsWatcher: 0
            }
        ],
        orientation: [
            {
                otherPropsWatcher: 0
            }
        ],
        size: [
            {
                otherPropsWatcher: 0
            }
        ]
    }
]), I$1 = j$2;
const s$8 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketProgressTrackerStepClick = (0, $696Z8.createEvent)(this, "marketProgressTrackerStepClick", 7), this.active = false, this.compact = false, this.completed = false, this.indicator = "circle", this.interactive = false, this.orientation = "vertical", this.size = "medium";
    }
    updateDefaultIcon() {
        const { active: o2, completed: e2, el: r2, indicator: i2, orientation: a2 } = this, c2 = [
            ...r2.children
        ].some((t2)=>"icon" === t2.slot);
        this.defaultIcon = c2 ? null : function({ active: o3, completed: e3, indicator: r3, orientation: i3 }) {
            if ("vertical" === i3) {
                if ("check" === r3) return e3 ? (0, $696Z8.h)("svg", {
                    class: "default-icon checked-icon",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("path", {
                    d: "M5.88683 7.62327L5.71005 7.4465L5.53327 7.62327L4.12327 9.03327L3.9465 9.21005L4.12327 9.38683L7.12327 12.3868C7.37411 12.6377 7.68955 12.75 8.01005 12.75C8.33627 12.75 8.64735 12.6239 8.89224 12.3913L8.89229 12.3914L8.89683 12.3868L13.8968 7.38683L14.0736 7.21005L13.8968 7.03327L12.4868 5.62327L12.3105 5.44691L12.1337 5.62286L8.00046 9.73691L5.88683 7.62327ZM0.25 9C0.25 4.16807 4.16807 0.25 9 0.25C13.8319 0.25 17.75 4.16807 17.75 9C17.75 13.8319 13.8319 17.75 9 17.75C4.16807 17.75 0.25 13.8319 0.25 9Z"
                })) : (0, $696Z8.h)("svg", {
                    class: "default-icon unchecked-icon",
                    width: "18",
                    height: "18",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
                }));
                if ("circle" === r3) return o3 ? (0, $696Z8.h)("svg", {
                    class: "default-icon active-circle-icon",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("circle", {
                    cx: "9",
                    cy: "9",
                    r: "7",
                    "stroke-width": "4"
                })) : (0, $696Z8.h)("svg", {
                    class: "default-icon inactive-circle-icon",
                    width: "8",
                    height: "8",
                    viewBox: "0 0 8 8",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("path", {
                    d: "M0 4a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
                }));
            } else if ("horizontal" === i3) {
                if ("check" === r3) return e3 ? (0, $696Z8.h)("svg", {
                    class: "default-icon small-checked-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0 8C0 3.58222 3.58222 0 8 0C12.4178 0 16 3.58222 16 8C16 12.4178 12.4178 16 8 16C3.58222 16 0 12.4178 0 8ZM5.0756 6.93338L7.11115 8.96893L10.9423 5.1556L12.1956 6.40893L7.75116 10.8534C7.57338 11.0223 7.35115 11.1112 7.12004 11.1112C6.88893 11.1112 6.66671 11.0312 6.48893 10.8534L3.82227 8.18671L5.0756 6.93338Z"
                })) : (0, $696Z8.h)("svg", {
                    class: "default-icon small-unchecked-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M8 14.2222C11.4364 14.2222 14.2222 11.4364 14.2222 8C14.2222 4.56356 11.4364 1.77778 8 1.77778C4.56356 1.77778 1.77778 4.56356 1.77778 8C1.77778 11.4364 4.56356 14.2222 8 14.2222ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                }));
                if ("circle" === r3) return o3 ? (0, $696Z8.h)("svg", {
                    class: "default-icon small-active-circle-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("circle", {
                    cx: "8",
                    cy: "8",
                    r: "6",
                    "stroke-opacity": "0.9",
                    "stroke-width": "4"
                })) : (0, $696Z8.h)("svg", {
                    class: "default-icon small-inactive-circle-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, $696Z8.h)("circle", {
                    cx: "8",
                    cy: "8",
                    r: "4"
                }));
            }
        }({
            active: o2,
            completed: e2,
            indicator: i2,
            orientation: a2
        });
    }
    handleClick() {
        const { el: t2, interactive: o2, marketProgressTrackerStepClick: e2, name: r2 } = this;
        o2 && e2.emit({
            index: void 0 === t2.dataset.stepIndex ? null : Number.parseInt(t2.dataset.stepIndex, 10),
            name: null != r2 ? r2 : null
        });
    }
    connectedCallback() {
        this.updateDefaultIcon();
    }
    render() {
        const { defaultIcon: o2, handleClick: e2, interactive: r2, orientation: a2, updateDefaultIcon: s2 } = this, p2 = l$s("market-accessory"), d2 = ()=>(0, $696Z8.h)((0, $696Z8.Fragment), null, (0, $696Z8.h)("div", {
                class: t$a("icon", {
                    "custom-icon": !o2
                }),
                part: "icon"
            }, (0, $696Z8.h)("slot", {
                name: "icon",
                onSlotchange: s2.bind(this)
            }, (0, $696Z8.h)(p2, null, o2))), (0, $696Z8.h)("div", {
                class: "content",
                part: "content"
            }, (0, $696Z8.h)("slot", {
                name: "label"
            }), (0, $696Z8.h)("slot", {
                name: "subtext"
            }), (0, $696Z8.h)("slot", null)));
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-progress-tracker-step",
            role: "horizontal" === a2 ? "presentation" : "listitem"
        }, "horizontal" === a2 ? (0, $696Z8.h)(r2 ? "button" : "div", {
            class: r2 ? "button" : "label",
            onClick: r2 ? e2.bind(this) : null,
            part: r2 ? "button" : null,
            role: r2 ? "tab" : "listitem"
        }, d2()) : d2());
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            active: [
                {
                    updateDefaultIcon: 0
                }
            ],
            completed: [
                {
                    updateDefaultIcon: 0
                }
            ],
            indicator: [
                {
                    updateDefaultIcon: 0
                }
            ],
            orientation: [
                {
                    updateDefaultIcon: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host([orientation="horizontal"][size="large"]) ::slotted([slot="label"]),:host([orientation="vertical"][size="large"]) ::slotted([slot="label"]){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}::slotted([slot="subtext"]){font-weight:var(--core-type-paragraph-10-weight);font-size:var(--core-type-paragraph-10-size);font-family:var(--core-type-paragraph-10-font-family);line-height:var(--core-type-paragraph-10-leading);letter-spacing:var(--core-type-paragraph-10-tracking);text-transform:var(--core-type-paragraph-10-case)}::slotted([slot="subtext"]) b,::slotted([slot="subtext"]) strong{font-weight:var(--core-type-semibold-10-weight)}:host([orientation="vertical"][size="small"]) ::slotted([slot="label"]){font-weight:var(--core-type-medium-20-weight);font-size:var(--core-type-medium-20-size);font-family:var(--core-type-medium-20-font-family);line-height:var(--core-type-medium-20-leading);letter-spacing:var(--core-type-medium-20-tracking);text-transform:var(--core-type-medium-20-case)}:host([orientation="horizontal"][size="small"]) ::slotted([slot="label"]){font-weight:var(--core-type-semibold-10-weight);font-size:var(--core-type-semibold-10-size);font-family:var(--core-type-semibold-10-font-family);line-height:var(--core-type-semibold-10-leading);letter-spacing:var(--core-type-semibold-10-tracking);text-transform:var(--core-type-semibold-10-case)}:host([orientation="horizontal"][size="medium"]) ::slotted([slot="label"]),:host([orientation="vertical"][size="medium"]) ::slotted([slot="label"]){font-weight:var(--core-type-semibold-30-weight);font-size:var(--core-type-semibold-30-size);font-family:var(--core-type-semibold-30-font-family);line-height:var(--core-type-semibold-30-leading);letter-spacing:var(--core-type-semibold-30-tracking);text-transform:var(--core-type-semibold-30-case)}.button,.label{display:flex;grid-area:button;gap:var(--progress-tracker-horizontal-label-spacing, var(--core-metrics-spacing-100));border:0;background:transparent;color:inherit}.button{border-radius:var(--progress-tracker-horizontal-button-border-radius, 6px);cursor:pointer}.button:active,.button:hover:active{background-color:var(--progress-tracker-horizontal-button-pressed-background-color, var(--core-emphasis-40-color));color:var(--progress-tracker-horizontal-button-pressed-text-color, var(--core-text-10-color))}.button:focus-visible{outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}:host([compact]) .button{padding-right:var(--progress-tracker-horizontal-compact-button-padding-right, var(--core-metrics-spacing-100));padding-left:var(--progress-tracker-horizontal-compact-button-padding-left, var(--core-metrics-spacing-100))}:host([compact]:not([connector])) .button{padding-right:var(--progress-tracker-horizontal-compact-button-padding-right, 6px);padding-left:var(--progress-tracker-horizontal-compact-button-padding-left, 6px)}:host([compact]:not([connector])) .button:hover,:host([compact]:not([connector])) .button:active,:host([compact]:not([connector])) .button:focus{margin-right:-2px;margin-left:-2px;padding-right:var(--progress-tracker-horizontal-compact-button-padding-right, var(--core-metrics-spacing-100));padding-left:var(--progress-tracker-horizontal-compact-button-padding-left, var(--core-metrics-spacing-100))}:host([size="small"]:not([compact])) .button{padding-right:var(--progress-tracker-horizontal-small-size-button-padding-right, var(--core-metrics-spacing-100));padding-left:var(--progress-tracker-horizontal-small-size-button-padding-left, var(--core-metrics-spacing-100))}:host([size="medium"]:not([compact])) .button{padding-right:var(--progress-tracker-horizontal-medium-size-button-padding-right, var(--core-metrics-spacing-150));padding-left:var(--progress-tracker-horizontal-medium-size-button-padding-left, var(--core-metrics-spacing-150))}:host([size="large"]:not([compact])) .button{padding-right:var(--progress-tracker-horizontal-large-size-button-padding-right, var(--core-metrics-spacing-200));padding-left:var(--progress-tracker-horizontal-large-size-button-padding-left, var(--core-metrics-spacing-200))}@media (hover: hover){.button:hover{background-color:var(--progress-tracker-horizontal-button-hover-background-color, var(--core-fill-40-color));color:var(--progress-tracker-horizontal-button-hover-text-color, var(--core-text-10-color))}.button:active,.button:hover:active{background-color:var(--progress-tracker-horizontal-button-pressed-background-color, var(--core-emphasis-40-color));color:var(--progress-tracker-horizontal-button-pressed-text-color, var(--core-text-10-color))}:host([compact]:not([connector])) .button{z-index:0}:host([compact]:not([connector])) .button:hover{z-index:1;margin-right:-2px;margin-left:-2px;padding-right:var(--progress-tracker-horizontal-compact-button-padding-right, var(--core-metrics-spacing-100));padding-left:var(--progress-tracker-horizontal-compact-button-padding-left, var(--core-metrics-spacing-100))}}:host([orientation="horizontal"]){--connector-color:var(--progress-tracker-horizontal-connector-color, var(--core-fill-30-color));--connector-radius:var(--progress-tracker-horizontal-connector-radius, var(--divider-radius));--active-connector-color:var(--progress-tracker-horizontal-active-connector-color, var(--core-fill-10-color))}:host([orientation="vertical"]){--connector-color:var(--progress-tracker-vertical-connector-color, var(--core-fill-30-color));--connector-radius:var(--progress-tracker-vertical-connector-radius, 0);--active-connector-color:var(--progress-tracker-vertical-active-connector-color, var(--core-fill-10-color))}:host::after{content:"";display:none;grid-area:connector;place-self:center center;border-radius:var(--connector-radius);pointer-events:none}:host([connector="inactive"])::after{display:flex;background-color:var(--connector-color)}:host([connector="active"])::after{display:flex;background-color:var(--active-connector-color)}:host([orientation="vertical"])::after{width:var(--progress-tracker-vertical-connector-size, 2px);height:100%}:host([orientation="horizontal"])::after{width:100%;height:var(--progress-tracker-horizontal-connector-size, 2px)}.content{display:flex;flex-shrink:0;flex-direction:column;grid-area:content;align-items:flex-start}.content ::slotted([slot="label"]){color:inherit;cursor:inherit}:host([orientation="vertical"][size="small"]) .content ::slotted([slot="label"]){margin:3px 0 0}:host([orientation="vertical"][size="medium"]) .content ::slotted([slot="label"]){margin:2px 0 0}:host([orientation="vertical"][size="large"]) .content ::slotted([slot="label"]){margin:1px 0 0}.content ::slotted([slot="subtext"]){margin:0;color:var(--progress-tracker-subtext-color, var(--core-text-20-color))}.content ::slotted(p:first-of-type){margin-top:0}.content ::slotted(p:last-of-type){margin-bottom:0}:host([orientation="horizontal"]) .content{align-self:center;white-space:nowrap}:host([orientation="horizontal"]) .content ::slotted(:not([slot="icon"],[slot="label"])){display:none}:host([orientation="vertical"]) .content{gap:var(--progress-tracker-line-spacing, var(--core-metrics-spacing-25));padding-bottom:var(--progress-tracker-content-padding-bottom-size, var(--core-metrics-spacing-200))}:host([orientation="horizontal"][compact]:not([active])) .content{display:none}:host([orientation="horizontal"]) .content ::slotted(:not([slot="label"])){display:none}:host([orientation="horizontal"]:not([active],[completed])){color:var(--progress-tracker-horizontal-inactive-text-color, var(--core-text-20-color))}:host([orientation="horizontal"][active]),:host([orientation="horizontal"][completed]){color:var(--progress-tracker-horizontal-active-text-color, var(--core-text-10-color))}:host([orientation="horizontal"][connector="active"]),:host([orientation="horizontal"][connector="inactive"]){grid-template-areas:"button connector"}:host([orientation="horizontal"]:not([connector])),:host([orientation="horizontal"][connector="hidden"]){grid-template-areas:"button";grid-template-columns:auto}:host([orientation="horizontal"][connector="active"]:not([compact])),:host([orientation="horizontal"][connector="inactive"]:not([compact])){grid-template-columns:auto     minmax(       var(--tracker-horizontal-orientation-compact-density-small-size-current-state-connector-width),       var(--tracker-horizontal-orientation-regular-density-small-size-current-state-connector-width)     )}:host([orientation="horizontal"][connector="active"][compact]),:host([orientation="horizontal"][connector="inactive"][compact]){grid-template-columns:auto     minmax(       auto,       var(--tracker-horizontal-orientation-compact-density-small-size-current-state-connector-width)     )}:host([orientation="horizontal"][size="small"]){grid-template-rows:minmax(var(--progress-tracker-horizontal-small-size-height, 34px), 1fr)}:host([orientation="horizontal"][size="medium"]){grid-template-rows:minmax(var(--progress-tracker-horizontal-medium-size-height, 40px), 1fr)}:host([orientation="horizontal"][size="large"]){grid-template-rows:minmax(var(--progress-tracker-horizontal-large-size-height, 42px), 1fr)}:host([orientation="horizontal"][size="small"][connector]:not([compact],[interactive])){gap:var(--tracker-horizontal-orientation-connectors-density-small-size-current-state-step-spacing)}:host([orientation="horizontal"][size="medium"][connector]:not([compact],[interactive])){gap:var(--tracker-horizontal-orientation-connectors-density-medium-size-current-state-step-spacing)}:host([orientation="horizontal"][size="large"][connector]:not([compact],[interactive])){gap:var(--tracker-horizontal-orientation-connectors-density-large-size-current-state-step-spacing)}:host([orientation="horizontal"][size="small"][compact][connector]:not([interactive])){gap:var(--tracker-horizontal-orientation-compact-density-small-size-current-state-step-spacing)}:host([orientation="horizontal"][size="medium"][compact][connector]:not([interactive])){gap:var(--tracker-horizontal-orientation-compact-density-medium-size-current-state-step-spacing)}:host([orientation="horizontal"][size="large"][compact][connector]:not([interactive])){gap:var(--tracker-horizontal-orientation-compact-density-large-size-current-state-step-spacing)}:host([orientation="horizontal"][interactive]){gap:0}:host([orientation="horizontal"]){--default-icon-fill-color:var(--progress-tracker-horizontal-default-icon-fill-color, var(--core-fill-30-color));--custom-icon-fill-color:var(--progress-tracker-horizontal-custom-icon-fill-color, var(--core-fill-20-color));--active-icon-fill-color:var(--progress-tracker-horizontal-active-icon-fill-color, var(--core-fill-10-color));--completed-icon-fill-color:var(       --progress-tracker-horizontal-completed-icon-fill-color,       var(--core-fill-10-color)     )}:host([orientation="vertical"]){--default-icon-fill-color:var(--progress-tracker-vertical-default-icon-fill-color, var(--core-fill-30-color));--custom-icon-fill-color:var(--progress-tracker-vertical-custom-icon-fill-color, var(--core-fill-20-color));--active-icon-fill-color:var(--progress-tracker-vertical-active-icon-fill-color, var(--core-fill-10-color));--completed-icon-fill-color:var(       --progress-tracker-vertical-completed-icon-fill-color,       var(--core-fill-10-color)     )}.icon{display:flex;grid-area:icon;justify-content:center;align-items:center;align-self:center;fill:var(--default-icon-fill-color)}.icon.custom-icon{fill:var(--custom-icon-fill-color)}:host([active]) .icon{fill:var(--active-icon-fill-color)}:host([completed]) .icon{fill:var(--completed-icon-fill-color)}:host([orientation="horizontal"]) .icon{min-width:var(--progress-tracker-horizontal-icon-width, var(--core-metrics-spacing-200));min-height:var(--progress-tracker-horizontal-icon-height, var(--core-metrics-spacing-200))}:host([orientation="vertical"]) .icon{flex:0 0 var(--progress-tracker-vertical-icon-width, var(--accessory-icon-variant-medium-size-width));max-width:var(--progress-tracker-vertical-icon-width, var(--accessory-icon-variant-medium-size-width));max-height:var(--progress-tracker-vertical-icon-height, 28px)}:host(:not([completed],[active])) .default-icon.active-circle-icon,:host(:not([completed],[active])) .default-icon.small-active-circle-icon{fill:none;stroke:var(--default-icon-fill-color)}:host([active]) .default-icon.active-circle-icon,:host([active]) .default-icon.small-active-circle-icon{fill:none;stroke:var(--active-icon-fill-color)}:host([completed]) .default-icon.active-circle-icon,:host([completed]) .default-icon.small-active-circle-icon{fill:none;stroke:var(--completed-icon-fill-color)}@media (hover: hover){:host(:not([completed],[active])) .button:hover .icon,:host(:not([completed],[active])) .button:hover .default-icon,:host(:not([completed],[active])) .button:active .icon,:host(:not([completed],[active])) .button:active .default-icon{fill:var(--progress-tracker-horizontal-hover-icon-fill-color, var(--core-fill-10-color))}:host(:not([completed],[active])) .button:hover .default-icon.active-circle-icon,:host(:not([completed],[active])) .button:hover .default-icon.small-active-circle-icon,:host(:not([completed],[active])) .button:active .default-icon.active-circle-icon,:host(:not([completed],[active])) .button:active .default-icon.small-active-circle-icon{fill:none;stroke:var(--progress-tracker-horizontal-hover-icon-fill-color, var(--core-fill-10-color))}}:host([orientation="vertical"]){grid-template-rows:var(--progress-tracker-step-vertical-icon-height, 28px) auto;grid-template-columns:var(--progress-tracker-step-vertical-icon-width, var(--accessory-icon-variant-medium-size-width))     auto;gap:0 var(--core-metrics-spacing-200);align-self:flex-start;color:var(--progress-tracker-vertical-text-color, var(--core-text-10-color))}:host([orientation="vertical"][connector]){grid-template-areas:"icon content"     "connector content"}:host([orientation="vertical"]:not([connector])){grid-template-areas:"icon content"     ". content"}:host{display:inline-grid}';
    }
}, [
    257,
    "market-progress-tracker-step",
    {
        active: [
            516
        ],
        compact: [
            516
        ],
        connector: [
            513
        ],
        completed: [
            516
        ],
        indicator: [
            1
        ],
        interactive: [
            516
        ],
        name: [
            1
        ],
        orientation: [
            513
        ],
        size: [
            513
        ],
        defaultIcon: [
            32
        ]
    },
    void 0,
    {
        active: [
            {
                updateDefaultIcon: 0
            }
        ],
        completed: [
            {
                updateDefaultIcon: 0
            }
        ],
        indicator: [
            {
                updateDefaultIcon: 0
            }
        ],
        orientation: [
            {
                updateDefaultIcon: 0
            }
        ]
    }
]), p = s$8;
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var __spreadValues = (a2, b2)=>{
    for(var prop in b2 || (b2 = {}))if (__hasOwnProp.call(b2, prop)) __defNormalProp(a2, prop, b2[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b2))if (__propIsEnum.call(b2, prop)) __defNormalProp(a2, prop, b2[prop]);
    }
    return a2;
};
var r$3, o, n$b, l$4, c$6, a$6, f, u;
function d$2() {
    if (o) return r$3;
    o = 1;
    const t2 = Object.freeze([
        [],
        [
            4,
            16
        ],
        [
            4,
            20
        ],
        [
            4,
            24
        ],
        [
            4,
            28
        ],
        [
            4,
            32
        ],
        [
            4,
            20,
            36
        ],
        [
            4,
            22,
            40
        ],
        [
            4,
            24,
            44
        ],
        [
            4,
            26,
            48
        ],
        [
            4,
            28,
            52
        ],
        [
            4,
            30,
            56
        ],
        [
            4,
            32,
            60
        ],
        [
            4,
            24,
            44,
            64
        ],
        [
            4,
            24,
            46,
            68
        ],
        [
            4,
            24,
            48,
            72
        ],
        [
            4,
            28,
            52,
            76
        ],
        [
            4,
            28,
            54,
            80
        ],
        [
            4,
            28,
            56,
            84
        ],
        [
            4,
            32,
            60,
            88
        ],
        [
            4,
            26,
            48,
            70,
            92
        ],
        [
            4,
            24,
            48,
            72,
            96
        ],
        [
            4,
            28,
            52,
            76,
            100
        ],
        [
            4,
            26,
            52,
            78,
            104
        ],
        [
            4,
            30,
            56,
            82,
            108
        ],
        [
            4,
            28,
            56,
            84,
            112
        ],
        [
            4,
            32,
            60,
            88,
            116
        ],
        [
            4,
            24,
            48,
            72,
            96,
            120
        ],
        [
            4,
            28,
            52,
            76,
            100,
            124
        ],
        [
            4,
            24,
            50,
            76,
            102,
            128
        ],
        [
            4,
            28,
            54,
            80,
            106,
            132
        ],
        [
            4,
            32,
            58,
            84,
            110,
            136
        ],
        [
            4,
            28,
            56,
            84,
            112,
            140
        ],
        [
            4,
            32,
            60,
            88,
            116,
            144
        ],
        [
            4,
            28,
            52,
            76,
            100,
            124,
            148
        ],
        [
            4,
            22,
            48,
            74,
            100,
            126,
            152
        ],
        [
            4,
            26,
            52,
            78,
            104,
            130,
            156
        ],
        [
            4,
            30,
            56,
            82,
            108,
            134,
            160
        ],
        [
            4,
            24,
            52,
            80,
            108,
            136,
            164
        ],
        [
            4,
            28,
            56,
            84,
            112,
            140,
            168
        ]
    ]), i2 = Object.freeze({
        LOW: [
            19,
            34,
            55,
            80,
            108,
            136,
            156,
            194,
            232,
            274,
            324,
            370,
            428,
            461,
            523,
            589,
            647,
            721,
            795,
            861,
            932,
            1006,
            1094,
            1174,
            1276,
            1370,
            1468,
            1531,
            1631,
            1735,
            1843,
            1955,
            2071,
            2191,
            2306,
            2434,
            2566,
            2702,
            2812,
            2956
        ],
        MEDIUM: [
            16,
            28,
            44,
            64,
            86,
            108,
            124,
            154,
            182,
            216,
            254,
            290,
            334,
            365,
            415,
            453,
            507,
            563,
            627,
            669,
            714,
            782,
            860,
            914,
            1e3,
            1062,
            1128,
            1193,
            1267,
            1373,
            1455,
            1541,
            1631,
            1725,
            1812,
            1914,
            1992,
            2102,
            2216,
            2334
        ],
        QUARTER: [
            13,
            22,
            34,
            48,
            62,
            76,
            88,
            110,
            132,
            154,
            180,
            206,
            244,
            261,
            295,
            325,
            367,
            397,
            445,
            485,
            512,
            568,
            614,
            664,
            718,
            754,
            808,
            871,
            911,
            985,
            1033,
            1115,
            1171,
            1231,
            1286,
            1354,
            1426,
            1502,
            1582,
            1666
        ],
        HIGH: [
            9,
            16,
            26,
            36,
            46,
            60,
            66,
            86,
            100,
            122,
            140,
            158,
            180,
            197,
            223,
            253,
            283,
            313,
            341,
            385,
            406,
            442,
            464,
            514,
            538,
            596,
            628,
            661,
            701,
            745,
            793,
            845,
            901,
            961,
            986,
            1054,
            1096,
            1142,
            1222,
            1276
        ]
    }), s2 = Object.freeze({
        NUMERIC: "NUMERIC",
        ALPHANUMERIC: "ALPHANUMERIC",
        KANJI: "KANJI",
        BYTE: "BYTE"
    }), e2 = Object.freeze({
        LOW: "LOW",
        MEDIUM: "MEDIUM",
        QUARTER: "QUARTER",
        HIGH: "HIGH"
    });
    class h2 {
        constructor(t3){
            this.length = t3, this.content = new Uint8Array(t3), this.byte = 0, this.bit = 0;
        }
        get bitsLeft() {
            return 8 * (this.length - this.byte) - this.bit;
        }
        get bytesLeft() {
            return 0 === this.bit ? this.length - this.byte : this.length - this.byte - 1;
        }
        codeForAlphaNUMERICal(t3) {
            for(let i3 = 0; i3 < 45; i3++)if ("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:"[i3] === t3) return i3;
        }
        completeByte() {
            0 !== this.bit && (this.bit = 0, this.byte++);
        }
        nextPutAlphaNUMERIC(t3) {
            for(let i3 = 1; i3 < t3.length; i3 += 2)this.nextPutBits(45 * this.codeForAlphaNUMERICal(t3[i3 - 1]) + this.codeForAlphaNUMERICal(t3[i3]), 11);
            t3.length % 2 == 1 && this.nextPutBits(this.codeForAlphaNUMERICal(t3[t3.length - 1]), 6);
        }
        nextPutBits(t3, i3) {
            if (0 === i3) return;
            let s3 = this.bit + i3;
            if (s3 < 8) this.content[this.byte] = this.content[this.byte] | t3 << 8 - s3, this.bit += i3;
            else if (8 === s3) this.content[this.byte] = this.content[this.byte] | t3, this.byte++, this.bit = 0;
            else {
                s3 -= 8;
                let i4 = t3 >> s3;
                this.content[this.byte] = this.content[this.byte] | i4, i4 = t3 - (i4 << s3), this.byte++, this.bit = 0, this.nextPutBits(i4, s3);
            }
        }
        nextPutByte(t3) {
            t3.forEach((t4)=>{
                this.nextPutBits(t4, 8);
            });
        }
        nextPutCompleteByte(t3) {
            this.completeByte(), this.content[this.byte] = t3, this.byte++;
        }
        nextPutKanji(t3) {
            for(let i3 = 0; i3 < t3.length; i3++){
                let s3 = t3.charCodeAt(i3);
                s3 -= s3 <= 40956 ? 33088 : 49472;
                let e3 = s3 % 256;
                this.nextPutBits((s3 - e3) / 256 * 192 + e3, 13);
            }
        }
        nextPutNumeric(t3) {
            const i3 = [];
            for(let s3 = 0; s3 < t3.length; s3++)i3.push(t3.charCodeAt(s3) - 48);
            for(let s3 = 2; s3 < t3.length; s3 += 3)this.nextPutBits(100 * i3[s3 - 2] + 10 * i3[s3 - 1] + i3[s3], 10);
            switch(t3.length % 3){
                case 0:
                    break;
                case 1:
                    this.nextPutBits(i3[t3.length - 1], 4);
                    break;
                case 2:
                    this.nextPutBits(10 * i3[t3.length - 2] + i3[t3.length - 1], 7);
            }
        }
    }
    class n2 {
        static withAll(t3, i3, s3) {
            const e3 = [];
            if (void 0 === s3) for(let s4 = 0; s4 < i3; s4++)e3.push(Array(t3));
            else for(let h3 = 0; h3 < i3; h3++)e3.push(Array(t3).fill(s3));
            return new this(e3);
        }
        constructor(t3){
            this.content = t3;
        }
        at(t3, i3) {
            return this.content[i3][t3];
        }
        copy() {
            return new this.constructor(this.content.map((t3)=>t3.slice()));
        }
        fill(t3, i3, s3, e3, h3) {
            for(let r2 = i3; r2 < i3 + e3; r2++){
                let i4 = this.content[r2];
                for(let e4 = t3; e4 < t3 + s3; e4++)i4[e4] = h3;
            }
        }
        get height() {
            return this.content.length;
        }
        put(t3, i3, s3) {
            return this.content[i3][t3] = s3;
        }
        get width() {
            return this.content[0].length;
        }
    }
    class l2 extends n2 {
        static forIntegerArray(t3, i3, s3) {
            const e3 = [];
            for(let h3 = 0; h3 < i3; h3++){
                let i4 = s3[h3];
                const r2 = [];
                for(let s4 = t3 - 1; s4 >= 0; s4--)i4 % 2 == 1 ? (r2.unshift(true), i4--) : r2.unshift(false), i4 /= 2;
                e3.push(r2);
            }
            return new this(e3);
        }
        asIntegerArray() {
            return this.content.map((t3)=>{
                let i3 = 0;
                return t3.forEach((t4)=>{
                    i3 *= 2, true === t4 && i3++;
                }), i3;
            });
        }
        bitAt(t3, i3) {
            return this.at(t3, i3) ? 1 : 0;
        }
        fillAlignmentPatternAt(t3, i3) {
            for(let s3 = 0; s3 < 4; s3++)this.content[i3][t3 + s3] = true, this.content[i3 + 4][t3 + s3 + 1] = true, this.content[i3 + 1 + s3][t3] = true, this.content[i3 + s3][t3 + 4] = true;
            this.content[i3 + 2][t3 + 2] = true;
        }
        fillFinderPatternAt(t3, i3) {
            for(let s3 = 0; s3 < 6; s3++)this.content[i3][t3 + s3] = true, this.content[i3 + 6][t3 + s3 + 1] = true, this.content[i3 + 1 + s3][t3] = true, this.content[i3 + s3][t3 + 6] = true;
            this.fill(t3 + 2, i3 + 2, 3, 3, true);
        }
    }
    class c2 extends n2 {
        static chunkingAt(t3, i3) {
            return ({
                LOW: [
                    [
                        [
                            1,
                            26,
                            19
                        ]
                    ],
                    [
                        [
                            1,
                            44,
                            34
                        ]
                    ],
                    [
                        [
                            1,
                            70,
                            55
                        ]
                    ],
                    [
                        [
                            1,
                            100,
                            80
                        ]
                    ],
                    [
                        [
                            1,
                            134,
                            108
                        ]
                    ],
                    [
                        [
                            2,
                            86,
                            68
                        ]
                    ],
                    [
                        [
                            2,
                            98,
                            78
                        ]
                    ],
                    [
                        [
                            2,
                            121,
                            97
                        ]
                    ],
                    [
                        [
                            2,
                            146,
                            116
                        ]
                    ],
                    [
                        [
                            2,
                            86,
                            68
                        ],
                        [
                            2,
                            87,
                            69
                        ]
                    ],
                    [
                        [
                            4,
                            101,
                            81
                        ]
                    ],
                    [
                        [
                            2,
                            116,
                            92
                        ],
                        [
                            2,
                            117,
                            93
                        ]
                    ],
                    [
                        [
                            4,
                            133,
                            107
                        ]
                    ],
                    [
                        [
                            3,
                            145,
                            115
                        ],
                        [
                            1,
                            146,
                            116
                        ]
                    ],
                    [
                        [
                            5,
                            109,
                            87
                        ],
                        [
                            1,
                            110,
                            88
                        ]
                    ],
                    [
                        [
                            5,
                            122,
                            98
                        ],
                        [
                            1,
                            123,
                            99
                        ]
                    ],
                    [
                        [
                            1,
                            135,
                            107
                        ],
                        [
                            5,
                            136,
                            108
                        ]
                    ],
                    [
                        [
                            5,
                            150,
                            120
                        ],
                        [
                            1,
                            151,
                            121
                        ]
                    ],
                    [
                        [
                            3,
                            141,
                            113
                        ],
                        [
                            4,
                            142,
                            114
                        ]
                    ],
                    [
                        [
                            3,
                            135,
                            107
                        ],
                        [
                            5,
                            136,
                            108
                        ]
                    ],
                    [
                        [
                            4,
                            144,
                            116
                        ],
                        [
                            4,
                            145,
                            117
                        ]
                    ],
                    [
                        [
                            2,
                            139,
                            111
                        ],
                        [
                            7,
                            140,
                            112
                        ]
                    ],
                    [
                        [
                            4,
                            151,
                            121
                        ],
                        [
                            5,
                            152,
                            122
                        ]
                    ],
                    [
                        [
                            6,
                            147,
                            117
                        ],
                        [
                            4,
                            148,
                            118
                        ]
                    ],
                    [
                        [
                            8,
                            132,
                            106
                        ],
                        [
                            4,
                            133,
                            107
                        ]
                    ],
                    [
                        [
                            10,
                            142,
                            114
                        ],
                        [
                            2,
                            143,
                            115
                        ]
                    ],
                    [
                        [
                            8,
                            152,
                            122
                        ],
                        [
                            4,
                            153,
                            123
                        ]
                    ],
                    [
                        [
                            3,
                            147,
                            117
                        ],
                        [
                            10,
                            148,
                            118
                        ]
                    ],
                    [
                        [
                            7,
                            146,
                            116
                        ],
                        [
                            7,
                            147,
                            117
                        ]
                    ],
                    [
                        [
                            5,
                            145,
                            115
                        ],
                        [
                            10,
                            146,
                            116
                        ]
                    ],
                    [
                        [
                            13,
                            145,
                            115
                        ],
                        [
                            3,
                            146,
                            116
                        ]
                    ],
                    [
                        [
                            17,
                            145,
                            115
                        ]
                    ],
                    [
                        [
                            17,
                            145,
                            115
                        ],
                        [
                            1,
                            146,
                            116
                        ]
                    ],
                    [
                        [
                            13,
                            145,
                            115
                        ],
                        [
                            6,
                            146,
                            116
                        ]
                    ],
                    [
                        [
                            12,
                            151,
                            121
                        ],
                        [
                            7,
                            152,
                            122
                        ]
                    ],
                    [
                        [
                            6,
                            151,
                            121
                        ],
                        [
                            14,
                            152,
                            122
                        ]
                    ],
                    [
                        [
                            17,
                            152,
                            122
                        ],
                        [
                            4,
                            153,
                            123
                        ]
                    ],
                    [
                        [
                            4,
                            152,
                            122
                        ],
                        [
                            18,
                            153,
                            123
                        ]
                    ],
                    [
                        [
                            20,
                            147,
                            117
                        ],
                        [
                            4,
                            148,
                            118
                        ]
                    ],
                    [
                        [
                            19,
                            148,
                            118
                        ],
                        [
                            6,
                            149,
                            119
                        ]
                    ]
                ],
                HIGH: [
                    [
                        [
                            1,
                            26,
                            9
                        ]
                    ],
                    [
                        [
                            1,
                            44,
                            16
                        ]
                    ],
                    [
                        [
                            2,
                            35,
                            13
                        ]
                    ],
                    [
                        [
                            4,
                            25,
                            9
                        ]
                    ],
                    [
                        [
                            2,
                            33,
                            11
                        ],
                        [
                            2,
                            34,
                            12
                        ]
                    ],
                    [
                        [
                            4,
                            43,
                            15
                        ]
                    ],
                    [
                        [
                            4,
                            39,
                            13
                        ],
                        [
                            1,
                            40,
                            14
                        ]
                    ],
                    [
                        [
                            4,
                            40,
                            14
                        ],
                        [
                            2,
                            41,
                            15
                        ]
                    ],
                    [
                        [
                            4,
                            36,
                            12
                        ],
                        [
                            4,
                            37,
                            13
                        ]
                    ],
                    [
                        [
                            6,
                            43,
                            15
                        ],
                        [
                            2,
                            44,
                            16
                        ]
                    ],
                    [
                        [
                            3,
                            36,
                            12
                        ],
                        [
                            8,
                            37,
                            13
                        ]
                    ],
                    [
                        [
                            7,
                            42,
                            14
                        ],
                        [
                            4,
                            43,
                            15
                        ]
                    ],
                    [
                        [
                            12,
                            33,
                            11
                        ],
                        [
                            4,
                            34,
                            12
                        ]
                    ],
                    [
                        [
                            11,
                            36,
                            12
                        ],
                        [
                            5,
                            37,
                            13
                        ]
                    ],
                    [
                        [
                            11,
                            36,
                            12
                        ],
                        [
                            7,
                            37,
                            13
                        ]
                    ],
                    [
                        [
                            3,
                            45,
                            15
                        ],
                        [
                            13,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            2,
                            42,
                            14
                        ],
                        [
                            17,
                            43,
                            15
                        ]
                    ],
                    [
                        [
                            2,
                            42,
                            14
                        ],
                        [
                            19,
                            43,
                            15
                        ]
                    ],
                    [
                        [
                            9,
                            39,
                            13
                        ],
                        [
                            16,
                            40,
                            14
                        ]
                    ],
                    [
                        [
                            15,
                            43,
                            15
                        ],
                        [
                            10,
                            44,
                            16
                        ]
                    ],
                    [
                        [
                            19,
                            46,
                            16
                        ],
                        [
                            6,
                            47,
                            17
                        ]
                    ],
                    [
                        [
                            34,
                            37,
                            13
                        ]
                    ],
                    [
                        [
                            16,
                            45,
                            15
                        ],
                        [
                            14,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            30,
                            46,
                            16
                        ],
                        [
                            2,
                            47,
                            17
                        ]
                    ],
                    [
                        [
                            22,
                            45,
                            15
                        ],
                        [
                            13,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            33,
                            46,
                            16
                        ],
                        [
                            4,
                            47,
                            17
                        ]
                    ],
                    [
                        [
                            12,
                            45,
                            15
                        ],
                        [
                            28,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            11,
                            45,
                            15
                        ],
                        [
                            31,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            19,
                            45,
                            15
                        ],
                        [
                            26,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            23,
                            45,
                            15
                        ],
                        [
                            25,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            23,
                            45,
                            15
                        ],
                        [
                            28,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            19,
                            45,
                            15
                        ],
                        [
                            35,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            11,
                            45,
                            15
                        ],
                        [
                            46,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            59,
                            46,
                            16
                        ],
                        [
                            1,
                            47,
                            17
                        ]
                    ],
                    [
                        [
                            22,
                            45,
                            15
                        ],
                        [
                            41,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            2,
                            45,
                            15
                        ],
                        [
                            64,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            24,
                            45,
                            15
                        ],
                        [
                            46,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            42,
                            45,
                            15
                        ],
                        [
                            32,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            10,
                            45,
                            15
                        ],
                        [
                            67,
                            46,
                            16
                        ]
                    ],
                    [
                        [
                            20,
                            45,
                            15
                        ],
                        [
                            61,
                            46,
                            16
                        ]
                    ]
                ],
                MEDIUM: [
                    [
                        [
                            1,
                            26,
                            16
                        ]
                    ],
                    [
                        [
                            1,
                            44,
                            28
                        ]
                    ],
                    [
                        [
                            1,
                            70,
                            44
                        ]
                    ],
                    [
                        [
                            2,
                            50,
                            32
                        ]
                    ],
                    [
                        [
                            2,
                            67,
                            43
                        ]
                    ],
                    [
                        [
                            4,
                            43,
                            27
                        ]
                    ],
                    [
                        [
                            4,
                            49,
                            31
                        ]
                    ],
                    [
                        [
                            2,
                            60,
                            38
                        ],
                        [
                            2,
                            61,
                            39
                        ]
                    ],
                    [
                        [
                            3,
                            58,
                            36
                        ],
                        [
                            2,
                            59,
                            37
                        ]
                    ],
                    [
                        [
                            4,
                            69,
                            43
                        ],
                        [
                            1,
                            70,
                            44
                        ]
                    ],
                    [
                        [
                            1,
                            80,
                            50
                        ],
                        [
                            4,
                            81,
                            51
                        ]
                    ],
                    [
                        [
                            6,
                            58,
                            36
                        ],
                        [
                            2,
                            59,
                            37
                        ]
                    ],
                    [
                        [
                            8,
                            59,
                            37
                        ],
                        [
                            1,
                            60,
                            38
                        ]
                    ],
                    [
                        [
                            4,
                            64,
                            40
                        ],
                        [
                            5,
                            65,
                            41
                        ]
                    ],
                    [
                        [
                            5,
                            65,
                            41
                        ],
                        [
                            5,
                            66,
                            42
                        ]
                    ],
                    [
                        [
                            7,
                            73,
                            45
                        ],
                        [
                            3,
                            74,
                            46
                        ]
                    ],
                    [
                        [
                            10,
                            74,
                            46
                        ],
                        [
                            1,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            9,
                            69,
                            43
                        ],
                        [
                            4,
                            70,
                            44
                        ]
                    ],
                    [
                        [
                            3,
                            70,
                            44
                        ],
                        [
                            11,
                            71,
                            45
                        ]
                    ],
                    [
                        [
                            3,
                            67,
                            41
                        ],
                        [
                            13,
                            68,
                            42
                        ]
                    ],
                    [
                        [
                            17,
                            68,
                            42
                        ]
                    ],
                    [
                        [
                            17,
                            74,
                            46
                        ]
                    ],
                    [
                        [
                            4,
                            75,
                            47
                        ],
                        [
                            14,
                            76,
                            48
                        ]
                    ],
                    [
                        [
                            6,
                            73,
                            45
                        ],
                        [
                            14,
                            74,
                            46
                        ]
                    ],
                    [
                        [
                            8,
                            75,
                            47
                        ],
                        [
                            13,
                            76,
                            48
                        ]
                    ],
                    [
                        [
                            19,
                            74,
                            46
                        ],
                        [
                            4,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            22,
                            73,
                            45
                        ],
                        [
                            3,
                            74,
                            46
                        ]
                    ],
                    [
                        [
                            3,
                            73,
                            45
                        ],
                        [
                            23,
                            74,
                            46
                        ]
                    ],
                    [
                        [
                            21,
                            73,
                            45
                        ],
                        [
                            7,
                            74,
                            46
                        ]
                    ],
                    [
                        [
                            19,
                            75,
                            47
                        ],
                        [
                            10,
                            76,
                            48
                        ]
                    ],
                    [
                        [
                            2,
                            74,
                            46
                        ],
                        [
                            29,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            10,
                            74,
                            46
                        ],
                        [
                            23,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            14,
                            74,
                            46
                        ],
                        [
                            21,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            14,
                            74,
                            46
                        ],
                        [
                            23,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            12,
                            75,
                            47
                        ],
                        [
                            26,
                            76,
                            48
                        ]
                    ],
                    [
                        [
                            6,
                            75,
                            47
                        ],
                        [
                            34,
                            76,
                            48
                        ]
                    ],
                    [
                        [
                            29,
                            74,
                            46
                        ],
                        [
                            14,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            13,
                            74,
                            46
                        ],
                        [
                            32,
                            75,
                            47
                        ]
                    ],
                    [
                        [
                            40,
                            75,
                            47
                        ],
                        [
                            7,
                            76,
                            48
                        ]
                    ],
                    [
                        [
                            18,
                            75,
                            47
                        ],
                        [
                            31,
                            76,
                            48
                        ]
                    ]
                ],
                QUARTER: [
                    [
                        [
                            1,
                            26,
                            13
                        ]
                    ],
                    [
                        [
                            1,
                            44,
                            22
                        ]
                    ],
                    [
                        [
                            2,
                            35,
                            17
                        ]
                    ],
                    [
                        [
                            2,
                            50,
                            24
                        ]
                    ],
                    [
                        [
                            2,
                            33,
                            15
                        ],
                        [
                            2,
                            34,
                            16
                        ]
                    ],
                    [
                        [
                            4,
                            43,
                            19
                        ]
                    ],
                    [
                        [
                            2,
                            32,
                            14
                        ],
                        [
                            4,
                            33,
                            15
                        ]
                    ],
                    [
                        [
                            4,
                            40,
                            18
                        ],
                        [
                            2,
                            41,
                            19
                        ]
                    ],
                    [
                        [
                            4,
                            36,
                            16
                        ],
                        [
                            4,
                            37,
                            17
                        ]
                    ],
                    [
                        [
                            6,
                            43,
                            19
                        ],
                        [
                            2,
                            44,
                            20
                        ]
                    ],
                    [
                        [
                            4,
                            50,
                            22
                        ],
                        [
                            4,
                            51,
                            23
                        ]
                    ],
                    [
                        [
                            4,
                            46,
                            20
                        ],
                        [
                            6,
                            47,
                            21
                        ]
                    ],
                    [
                        [
                            8,
                            44,
                            20
                        ],
                        [
                            4,
                            45,
                            21
                        ]
                    ],
                    [
                        [
                            11,
                            36,
                            16
                        ],
                        [
                            5,
                            37,
                            17
                        ]
                    ],
                    [
                        [
                            5,
                            54,
                            24
                        ],
                        [
                            7,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            15,
                            43,
                            19
                        ],
                        [
                            2,
                            44,
                            20
                        ]
                    ],
                    [
                        [
                            1,
                            50,
                            22
                        ],
                        [
                            15,
                            51,
                            23
                        ]
                    ],
                    [
                        [
                            17,
                            50,
                            22
                        ],
                        [
                            1,
                            51,
                            23
                        ]
                    ],
                    [
                        [
                            17,
                            47,
                            21
                        ],
                        [
                            4,
                            48,
                            22
                        ]
                    ],
                    [
                        [
                            15,
                            54,
                            24
                        ],
                        [
                            5,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            17,
                            50,
                            22
                        ],
                        [
                            6,
                            51,
                            23
                        ]
                    ],
                    [
                        [
                            7,
                            54,
                            24
                        ],
                        [
                            16,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            11,
                            54,
                            24
                        ],
                        [
                            14,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            11,
                            54,
                            24
                        ],
                        [
                            16,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            7,
                            54,
                            24
                        ],
                        [
                            22,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            28,
                            50,
                            22
                        ],
                        [
                            6,
                            51,
                            23
                        ]
                    ],
                    [
                        [
                            8,
                            53,
                            23
                        ],
                        [
                            26,
                            54,
                            24
                        ]
                    ],
                    [
                        [
                            4,
                            54,
                            24
                        ],
                        [
                            31,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            1,
                            53,
                            23
                        ],
                        [
                            37,
                            54,
                            24
                        ]
                    ],
                    [
                        [
                            15,
                            54,
                            24
                        ],
                        [
                            25,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            42,
                            54,
                            24
                        ],
                        [
                            1,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            10,
                            54,
                            24
                        ],
                        [
                            35,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            29,
                            54,
                            24
                        ],
                        [
                            19,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            44,
                            54,
                            24
                        ],
                        [
                            7,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            39,
                            54,
                            24
                        ],
                        [
                            14,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            46,
                            54,
                            24
                        ],
                        [
                            10,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            49,
                            54,
                            24
                        ],
                        [
                            10,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            48,
                            54,
                            24
                        ],
                        [
                            14,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            43,
                            54,
                            24
                        ],
                        [
                            22,
                            55,
                            25
                        ]
                    ],
                    [
                        [
                            34,
                            54,
                            24
                        ],
                        [
                            34,
                            55,
                            25
                        ]
                    ]
                ]
            })[t3][i3 - 1];
        }
        static fromGF256Alpha(t3) {
            return [
                1,
                2,
                4,
                8,
                16,
                32,
                64,
                128,
                29,
                58,
                116,
                232,
                205,
                135,
                19,
                38,
                76,
                152,
                45,
                90,
                180,
                117,
                234,
                201,
                143,
                3,
                6,
                12,
                24,
                48,
                96,
                192,
                157,
                39,
                78,
                156,
                37,
                74,
                148,
                53,
                106,
                212,
                181,
                119,
                238,
                193,
                159,
                35,
                70,
                140,
                5,
                10,
                20,
                40,
                80,
                160,
                93,
                186,
                105,
                210,
                185,
                111,
                222,
                161,
                95,
                190,
                97,
                194,
                153,
                47,
                94,
                188,
                101,
                202,
                137,
                15,
                30,
                60,
                120,
                240,
                253,
                231,
                211,
                187,
                107,
                214,
                177,
                127,
                254,
                225,
                223,
                163,
                91,
                182,
                113,
                226,
                217,
                175,
                67,
                134,
                17,
                34,
                68,
                136,
                13,
                26,
                52,
                104,
                208,
                189,
                103,
                206,
                129,
                31,
                62,
                124,
                248,
                237,
                199,
                147,
                59,
                118,
                236,
                197,
                151,
                51,
                102,
                204,
                133,
                23,
                46,
                92,
                184,
                109,
                218,
                169,
                79,
                158,
                33,
                66,
                132,
                21,
                42,
                84,
                168,
                77,
                154,
                41,
                82,
                164,
                85,
                170,
                73,
                146,
                57,
                114,
                228,
                213,
                183,
                115,
                230,
                209,
                191,
                99,
                198,
                145,
                63,
                126,
                252,
                229,
                215,
                179,
                123,
                246,
                241,
                255,
                227,
                219,
                171,
                75,
                150,
                49,
                98,
                196,
                149,
                55,
                110,
                220,
                165,
                87,
                174,
                65,
                130,
                25,
                50,
                100,
                200,
                141,
                7,
                14,
                28,
                56,
                112,
                224,
                221,
                167,
                83,
                166,
                81,
                162,
                89,
                178,
                121,
                242,
                249,
                239,
                195,
                155,
                43,
                86,
                172,
                69,
                138,
                9,
                18,
                36,
                72,
                144,
                61,
                122,
                244,
                245,
                247,
                243,
                251,
                235,
                203,
                139,
                11,
                22,
                44,
                88,
                176,
                125,
                250,
                233,
                207,
                131,
                27,
                54,
                108,
                216,
                173,
                71,
                142
            ][t3];
        }
        static polynomial(t3) {
            if (this.polynomials.length >= t3) return this.polynomials[t3 - 1];
            let i3 = this.polynomials[this.polynomials.length - 1];
            for(let s3 = this.polynomials.length; s3 < t3; s3++){
                let t4 = new Uint8Array(2);
                t4[1] = s3, i3 = this.product(i3, t4), this.polynomials.push(i3);
            }
            return i3;
        }
        static product(t3, i3) {
            let s3 = new Uint8Array(t3.length + i3.length - 1);
            return t3.forEach((t4, e3)=>{
                i3.forEach((i4, h3)=>{
                    let r2 = e3 + h3;
                    s3[r2] = this.fromGF256Alpha((t4 + i4) % 255) ^ s3[r2];
                });
            }), s3.map((t4)=>this.toGF256Alpha(t4));
        }
        static quotient(t3, i3) {
            let s3 = new Uint8Array(t3.length + i3.length - 1);
            for(let i4 = 0; i4 < t3.length; i4++)s3[i4] = t3[i4];
            for(let e3 = 0; e3 < t3.length; e3++){
                let t4 = s3[e3];
                0 !== t4 && (t4 = this.toGF256Alpha(t4), i3.forEach((i4, h3)=>{
                    let r2 = e3 + h3;
                    s3[r2] = this.fromGF256Alpha((t4 + i4) % 255) ^ s3[r2];
                }));
            }
            return s3.slice(s3.length - i3.length + 1);
        }
        static toGF256Alpha(t3) {
            return [
                0,
                0,
                1,
                25,
                2,
                50,
                26,
                198,
                3,
                223,
                51,
                238,
                27,
                104,
                199,
                75,
                4,
                100,
                224,
                14,
                52,
                141,
                239,
                129,
                28,
                193,
                105,
                248,
                200,
                8,
                76,
                113,
                5,
                138,
                101,
                47,
                225,
                36,
                15,
                33,
                53,
                147,
                142,
                218,
                240,
                18,
                130,
                69,
                29,
                181,
                194,
                125,
                106,
                39,
                249,
                185,
                201,
                154,
                9,
                120,
                77,
                228,
                114,
                166,
                6,
                191,
                139,
                98,
                102,
                221,
                48,
                253,
                226,
                152,
                37,
                179,
                16,
                145,
                34,
                136,
                54,
                208,
                148,
                206,
                143,
                150,
                219,
                189,
                241,
                210,
                19,
                92,
                131,
                56,
                70,
                64,
                30,
                66,
                182,
                163,
                195,
                72,
                126,
                110,
                107,
                58,
                40,
                84,
                250,
                133,
                186,
                61,
                202,
                94,
                155,
                159,
                10,
                21,
                121,
                43,
                78,
                212,
                229,
                172,
                115,
                243,
                167,
                87,
                7,
                112,
                192,
                247,
                140,
                128,
                99,
                13,
                103,
                74,
                222,
                237,
                49,
                197,
                254,
                24,
                227,
                165,
                153,
                119,
                38,
                184,
                180,
                124,
                17,
                68,
                146,
                217,
                35,
                32,
                137,
                46,
                55,
                63,
                209,
                91,
                149,
                188,
                207,
                205,
                144,
                135,
                151,
                178,
                220,
                252,
                190,
                97,
                242,
                86,
                211,
                171,
                20,
                42,
                93,
                158,
                132,
                60,
                57,
                83,
                71,
                109,
                65,
                162,
                31,
                45,
                67,
                216,
                183,
                123,
                164,
                118,
                196,
                23,
                73,
                236,
                127,
                12,
                111,
                246,
                108,
                161,
                59,
                82,
                41,
                157,
                85,
                170,
                251,
                96,
                134,
                177,
                187,
                204,
                62,
                90,
                203,
                89,
                95,
                176,
                156,
                169,
                160,
                81,
                11,
                245,
                22,
                235,
                122,
                117,
                44,
                215,
                79,
                174,
                213,
                233,
                230,
                231,
                173,
                232,
                116,
                214,
                244,
                234,
                168,
                80,
                88,
                175
            ][t3];
        }
        static get masks() {
            return 0 === this.maskArray.length && [
                (t3, i3)=>(t3 + i3) % 2 == 0,
                (t3, i3)=>i3 % 2 == 0,
                (t3)=>t3 % 3 == 0,
                (t3, i3)=>(t3 + i3) % 3 == 0,
                (t3, i3)=>((i3 - i3 % 2) / 2 + (t3 - t3 % 3) / 3) % 2 == 0,
                (t3, i3)=>t3 * i3 % 2 + t3 * i3 % 3 == 0,
                (t3, i3)=>(t3 * i3 + t3 * i3 % 3) % 2 == 0,
                (t3, i3)=>(t3 * i3 % 3 + t3 + i3) % 2 == 0
            ].forEach((t3)=>{
                const i3 = [];
                for(let s3 = 0; s3 < 12; s3++){
                    const e3 = [];
                    for(let i4 = 0; i4 < 12; i4++)e3.push(t3(i4, s3));
                    i3.push(e3);
                }
                this.maskArray.push(new l2(i3));
            }), this.maskArray;
        }
        static for(t3, i3) {
            let s3 = this.instances[t3 + i3];
            if (void 0 === s3) {
                const e3 = 4 * i3 + 17, h3 = [];
                for(let t4 = 0; t4 < e3; t4++)h3.push(Array(e3).fill(this.AVAILABLE));
                s3 = new this(h3, t3, i3), this.instances[t3 + i3] = s3;
            }
            return s3;
        }
        constructor(t3, i3, s3){
            super(t3), this.errorCorrection = i3, this.version = s3, this.initialize();
        }
        initialize() {
            let t3 = 0;
            this.errorCorrection === e2.LOW ? 1 === this.version ? t3 = 3 : 2 === this.version ? t3 = 2 : 3 === this.version && (t3 = 1) : 1 === this.version && (t3 = this.errorCorrection === e2.MEDIUM ? 2 : 1), this.chunking = this.constructor.chunkingAt(this.errorCorrection, this.version);
            const i3 = [], s3 = [];
            let h3 = 0, r2 = 0;
            const o2 = [], n3 = [];
            let l3 = 0, c3 = 0;
            this.chunking.forEach((e3)=>{
                for(let a3 = 0; a3 < e3[0]; a3++){
                    let a4 = 0;
                    n3.push(8 * l3), l3 += e3[1];
                    const f3 = [], u3 = e3[2];
                    for(let t4 = 0; t4 < u3; t4++)f3.push({
                        chunk: c3,
                        byte: a4
                    }), a4++;
                    i3.push(f3), h3 = Math.max(h3, f3.length);
                    const d3 = [], g3 = e3[1] - u3;
                    for(let t4 = 0; t4 < g3; t4++)d3.push({
                        chunk: c3,
                        byte: a4
                    }), a4++;
                    s3.push(d3), r2 = Math.max(r2, d3.length), o2.push(g3 - t3), c3++;
                }
            }), this.chunkingOffsets = n3, this.errorCorrectionCapacity = o2;
            const f2 = [];
            for(let t4 = 0; t4 < h3; t4++)i3.forEach((i4)=>{
                i4.length > t4 && f2.push(i4[t4]);
            });
            for(let t4 = 0; t4 < r2; t4++)s3.forEach((i4)=>{
                i4.length > t4 && f2.push(i4[t4]);
            });
            const u2 = [];
            f2.forEach((t4)=>{
                const i4 = t4.byte, s4 = t4.chunk;
                for(let t5 = 0; t5 < 8; t5++)u2.push({
                    chunk: s4,
                    byte: i4,
                    bit: t5
                });
            });
            const d2 = this.width;
            this.fill(0, 0, 9, 9, this.constructor.AVOID), this.fill(d2 - 8, 0, 8, 9, this.constructor.AVOID), this.fill(0, d2 - 8, 9, 8, this.constructor.AVOID), this.version > 6 && (this.fill(d2 - 11, 0, 3, 6, this.constructor.AVOID), this.fill(0, d2 - 11, 6, 3, this.constructor.AVOID)), this.fill(9, 6, d2 - 17, 1, this.constructor.AVOID), this.fill(6, 9, 1, d2 - 17, this.constructor.AVOID);
            for (const t4 of a2.alignmentPatternPositions(this.version))this.fill(t4.x, t4.y, 5, 5, this.constructor.AVOID);
            let g2 = d2 - 2, v2 = d2;
            u2.forEach((t4)=>{
                do {
                    let t5, i4 = (g2 - g2 % 2) / 2 % 2 == 1;
                    6 === g2 ? (t5 = false, g2 = 5) : t5 = g2 < 6 ? g2 % 2 == 1 : g2 % 2 == 0, t5 ? g2-- : i4 ? 0 === v2 ? g2-- : (g2++, v2--) : v2 + 1 === d2 ? g2-- : (g2++, v2++);
                }while (this.at(g2, v2) === this.constructor.AVOID && g2 > -1);
                this.put(g2, v2, t4);
            });
        }
        codewordsFor(t3) {
            let i3 = 0;
            const s3 = [];
            return this.chunking.forEach((e3)=>{
                for(let h3 = 0; h3 < e3[0]; h3++){
                    const h4 = t3.slice(i3, i3 + e3[2]);
                    i3 += e3[2];
                    const r2 = this.constructor.quotient(h4, this.constructor.polynomial(e3[1] - e3[2]));
                    s3.push(...h4), s3.push(...r2);
                }
            }), s3;
        }
        dataFor(t3) {
            const i3 = [];
            t3.forEach((t4)=>{
                let s4 = t4;
                [
                    128,
                    64,
                    32,
                    16,
                    8,
                    4,
                    2,
                    1
                ].forEach((t5)=>{
                    s4 >= t5 ? (i3.push(true), s4 -= t5) : i3.push(false);
                });
            }), this.bits = i3;
            const s3 = this.content.length, e3 = l2.withAll(s3, s3, false);
            for(let t4 = 0; t4 < s3; t4++)for(let h3 = 0; h3 < s3; h3++){
                const s4 = this.at(h3, t4);
                this.isDataPixel(s4) && e3.put(h3, t4, i3[this.chunkingOffsets[s4.chunk] + 8 * s4.byte + s4.bit]);
            }
            return e3;
        }
        isDataPixel(t3) {
            return t3 !== this.constructor.AVOID && t3 !== this.constructor.AVAILABLE;
        }
        maskedDataFor(t3) {
            const i3 = t3.height;
            return this.constructor.masks.map((s3)=>{
                const e3 = l2.withAll(i3, i3);
                for(let h3 = 0; h3 < i3; h3++)for(let r2 = 0; r2 < i3; r2++){
                    let i4 = t3.at(h3, r2);
                    this.at(h3, r2) !== c2.AVOID && s3.at(h3 % 12, r2 % 12) && (i4 = !i4), e3.put(h3, r2, i4);
                }
                return e3;
            });
        }
        asIntegerArray() {
            return this.content.map((t3)=>{
                let i3 = 0;
                return t3.forEach((t4)=>{
                    i3 *= 2, this.isDataPixel(t4) && i3++;
                }), i3;
            });
        }
    }
    c2.AVAILABLE = "available", c2.AVOID = "avoid", c2.GENERATOR_FUNCTIONS = [
        (t3, i3)=>(t3 + i3) % 2 == 0,
        (t3, i3)=>i3 % 2 == 0,
        (t3)=>t3 % 3 == 0,
        (t3, i3)=>(t3 + i3) % 3 == 0,
        (t3, i3)=>((i3 - i3 % 2) / 2 + (t3 - t3 % 3) / 3) % 2 == 0,
        (t3, i3)=>t3 * i3 % 2 + t3 * i3 % 3 == 0,
        (t3, i3)=>(t3 * i3 + t3 * i3 % 3) % 2 == 0,
        (t3, i3)=>(t3 * i3 % 3 + t3 + i3) % 2 == 0
    ], c2.instances = {}, c2.maskArray = [], c2.polynomials = [
        new Uint8Array(2)
    ];
    class a2 {
        static alignmentPatternPositions(i3) {
            let s3 = t2[i3 - 1];
            if (0 === s3.length) return [];
            const e3 = [], h3 = s3[0];
            return s3.slice(1, s3.length - 1).forEach((t3)=>{
                e3.push({
                    x: h3,
                    y: t3
                }), e3.push({
                    x: t3,
                    y: h3
                });
            }), s3 = s3.slice(1), s3.forEach((t3)=>{
                s3.forEach((i4)=>{
                    e3.push({
                        x: i4,
                        y: t3
                    });
                });
            }), e3;
        }
        static finderPatternPositions(t3) {
            const i3 = 4 * t3 + 10;
            return [
                {
                    x: 0,
                    y: 0
                },
                {
                    x: 0,
                    y: i3
                },
                {
                    x: i3,
                    y: 0
                }
            ];
        }
        static timingPatternPositions(t3) {
            const i3 = [], s3 = 4 * t3 + 9;
            for(let t4 = 8; t4 < s3; t4 += 2)i3.push({
                x: t4,
                y: 6
            }), i3.push({
                x: 6,
                y: t4
            });
            return i3;
        }
        constructor(t3, i3){
            if (void 0 === t3 || 0 === t3.length) throw "no content to encode";
            this.content = t3, this.options = i3 || {}, "eci" in this.options && (this.eci = this.options.eci), "errorCorrection" in this.options && (this.errorCorrection = this.options.errorCorrection);
        }
        get alignmentPatternPositions() {
            return this.constructor.alignmentPatternPositions(this.version);
        }
        get dimension() {
            return 4 * this.version + 17;
        }
        get encoding() {
            return this._encoding;
        }
        set encoding(t3) {
            this._encoding = t3;
        }
        get finderPatternPositions() {
            return this.constructor.finderPatternPositions(this.version);
        }
        get hasEci() {
            return void 0 !== this.eci && 3 !== this.eci;
        }
        get hasAlignmentPattern() {
            return this.version > 1;
        }
        get timingPatternPositions() {
            return this.constructor.timingPatternPositions(this.version);
        }
    }
    return a2.MAX_VERSION = 40, r$3 = {
        ENCODING: s2,
        ERROR_CORRECTION: e2,
        BitWriter: h2,
        Matrix: n2,
        BooleanMatrix: l2,
        QRCodeMap: c2,
        QRCode: a2,
        QRCodeEncoder: class {
            constructor(t3, i3){
                this.code = new a2(t3, i3), this.encode();
            }
            encode() {
                this.initializeEncoding(), this.initializeVersion(), this.initializeCodewords(), this.initializeMapping(), this.initializeMasking();
            }
            initializeCodewords() {
                const t3 = new h2(i2[this.code.errorCorrection][this.code.version - 1]);
                switch(this.code.encoding){
                    case s2.NUMERIC:
                        t3.nextPutBits(1, 4), t3.nextPutBits(this.length, this.code.version < 10 ? 10 : this.code.version < 27 ? 12 : 14), t3.nextPutNumeric(this.code.content);
                        break;
                    case s2.ALPHANUMERIC:
                        t3.nextPutBits(2, 4), t3.nextPutBits(this.length, this.code.version < 10 ? 9 : this.code.version < 27 ? 11 : 13), t3.nextPutAlphaNUMERIC(this.code.content);
                        break;
                    case s2.KANJI:
                        t3.nextPutBits(8, 8), t3.nextPutBits(this.length, this.code.version < 10 ? 8 : this.code.version < 27 ? 10 : 12), t3.nextPutKanji(this.code.content);
                        break;
                    case s2.BYTE:
                        this.code.hasEci && (t3.nextPutBits(7, 4), this.code.eci < 128 ? (t3.nextPutBits(0, 1), t3.nextPutBits(this.code.eci, 7)) : this.code.eci < 16384 ? (t3.nextPutBits(2, 2), t3.nextPutBits(this.code.eci, 14)) : (t3.nextPutBits(6, 3), t3.nextPutBits(this.code.eci, 21))), t3.nextPutBits(4, 4), t3.nextPutBits(this.length, this.code.version < 10 ? 8 : 16), t3.nextPutByte(this.bytes);
                }
                t3.bitsLeft > 3 && t3.nextPutBits(0, 4);
                const e3 = t3.bytesLeft;
                for(let i3 = 0; i3 < e3; i3++)t3.nextPutCompleteByte(i3 % 2 == 0 ? 236 : 17);
                this.codewords = t3.content;
            }
            initializeEncoding() {
                if (this.code.hasEci) {
                    if (this.code.encoding = s2.BYTE, 3 === this.code.eci) {
                        this.length = this.code.content.length, this.bytes = [];
                        for(let t3 = 0; t3 < length; t3++)this.bytes.push(this.code.content.charCodeAt(t3) % 128);
                    } else if (25 === this.code.eci) this.bytes = this.toUtf16Bytes(this.code.content), this.length = this.bytes.length;
                    else if (26 === this.code.eci) this.bytes = this.toUtf8Bytes(this.code.content), this.length = this.bytes.length;
                    else {
                        this.length = this.code.content.length, this.bytes = [];
                        for(let t3 = 0; t3 < length; t3++)this.bytes.push(this.code.content.charCodeAt(t3) % 256);
                    }
                } else /^\d*$/.test(this.code.content) ? (this.code.encoding = s2.NUMERIC, this.length = this.code.content.length) : /^[A-Z\d\dA-Z $%*+-./:]+$/.test(this.code.content) ? (this.code.encoding = s2.ALPHANUMERIC, this.length = this.code.content.length) : /^[\u8140-\u9ffc\ue040-\uebbf]+$/.test(this.code.content) ? (this.code.encoding = s2.KANJI, this.length = this.code.content.length) : (this.code.encoding = s2.BYTE, this.bytes = this.toUtf8Bytes(this.code.content), this.length = this.bytes.length, this.code.eci = this.length === this.code.content.length ? 3 : 26);
            }
            initializeMapping() {
                this.map = c2.for(this.code.errorCorrection, this.code.version), this.mapCodewords = this.map.codewordsFor(this.codewords), this.mapData = this.map.dataFor(this.mapCodewords);
            }
            initializeMasking() {
                const t3 = this.map.maskedDataFor(this.mapData);
                let i3, s3, e3 = 1e6;
                t3.forEach((t4, h4)=>{
                    const r3 = this.penaltyForMatrix(t4);
                    r3 < e3 && (e3 = r3, i3 = t4, s3 = h4);
                }), this.lowestPenalty = e3;
                let h3 = [
                    1,
                    0,
                    3,
                    2
                ][this.errorCorrections.indexOf(this.code.errorCorrection)];
                h3 = 1024 * (8 * h3 + s3);
                let r2 = h3;
                for(let t4 = 14; t4 >= 10; t4--)r2 >= Math.pow(2, t4) && (r2 ^= 1335 * Math.pow(2, t4 - 10));
                h3 = h3 + r2 ^ 21522;
                const o2 = this.code.dimension;
                if ([
                    [
                        8,
                        0,
                        o2 - 1,
                        8
                    ],
                    [
                        8,
                        1,
                        o2 - 2,
                        8
                    ],
                    [
                        8,
                        2,
                        o2 - 3,
                        8
                    ],
                    [
                        8,
                        3,
                        o2 - 4,
                        8
                    ],
                    [
                        8,
                        4,
                        o2 - 5,
                        8
                    ],
                    [
                        8,
                        5,
                        o2 - 6,
                        8
                    ],
                    [
                        8,
                        7,
                        o2 - 7,
                        8
                    ],
                    [
                        8,
                        8,
                        o2 - 8,
                        8
                    ],
                    [
                        7,
                        8,
                        8,
                        o2 - 7
                    ],
                    [
                        5,
                        8,
                        8,
                        o2 - 6
                    ],
                    [
                        4,
                        8,
                        8,
                        o2 - 5
                    ],
                    [
                        3,
                        8,
                        8,
                        o2 - 4
                    ],
                    [
                        2,
                        8,
                        8,
                        o2 - 3
                    ],
                    [
                        1,
                        8,
                        8,
                        o2 - 2
                    ],
                    [
                        0,
                        8,
                        8,
                        o2 - 1
                    ]
                ].forEach((t4, s4)=>{
                    (Math.pow(2, s4) & h3) > 0 && (i3.put(t4[0], t4[1], true), i3.put(t4[2], t4[3], true));
                }), i3.put(8, o2 - 8, true), this.code.version > 6) {
                    let t4 = 4096 * this.code.version;
                    r2 = t4;
                    for(let t5 = 17; t5 >= 12; t5--)r2 >= Math.pow(2, t5) && (r2 ^= 7973 * Math.pow(2, t5 - 12));
                    t4 += r2;
                    let s4 = 0;
                    for(let e4 = 0; e4 < 6; e4++)for(let h4 = o2 - 11; h4 <= o2 - 9; h4++)(Math.pow(2, s4) & t4) > 0 && (i3.put(e4, h4, true), i3.put(h4, e4, true)), s4++;
                }
                this.code.data = i3;
            }
            initializeVersion() {
                if (this.errorCorrections.includes(this.code.errorCorrection)) {
                    let t3 = this.versionForLength(this.length, this.code.errorCorrection);
                    if (t3 > a2.MAX_VERSION) throw "This content is too long to be encoded for the specified error correction.";
                    this.code.version = t3;
                } else {
                    let t3 = this.errorCorrections.map((t4)=>this.versionForLength(this.length, t4)), i3 = t3[0];
                    if (i3 > a2.MAX_VERSION) throw "This string is too long to be encoded.";
                    this.code.version = i3;
                    for(let s3 = 3; s3 >= 0; s3--)if (t3[s3] === i3) return void (this.code.errorCorrection = this.errorCorrections[s3]);
                }
            }
            capacity(t3, i3) {
                return ({
                    NUMERIC: {
                        LOW: [
                            41,
                            77,
                            127,
                            187,
                            255,
                            322,
                            370,
                            461,
                            552,
                            652,
                            772,
                            883,
                            1022,
                            1101,
                            1250,
                            1408,
                            1548,
                            1725,
                            1903,
                            2061,
                            2232,
                            2409,
                            2620,
                            2812,
                            3057,
                            3283,
                            3517,
                            3669,
                            3909,
                            4158,
                            4417,
                            4686,
                            4965,
                            5253,
                            5529,
                            5836,
                            6153,
                            6479,
                            6743,
                            7089
                        ],
                        MEDIUM: [
                            34,
                            63,
                            101,
                            149,
                            202,
                            255,
                            293,
                            365,
                            432,
                            513,
                            604,
                            691,
                            796,
                            871,
                            991,
                            1082,
                            1212,
                            1346,
                            1500,
                            1600,
                            1708,
                            1872,
                            2059,
                            2188,
                            2395,
                            2544,
                            2701,
                            2857,
                            3035,
                            3289,
                            3486,
                            3693,
                            3909,
                            4134,
                            4343,
                            4588,
                            4775,
                            5039,
                            5313,
                            5596
                        ],
                        QUARTER: [
                            27,
                            48,
                            77,
                            111,
                            144,
                            178,
                            207,
                            259,
                            312,
                            364,
                            427,
                            489,
                            580,
                            621,
                            703,
                            775,
                            876,
                            948,
                            1063,
                            1159,
                            1224,
                            1358,
                            1468,
                            1588,
                            1718,
                            1804,
                            1933,
                            2085,
                            2181,
                            2358,
                            2473,
                            2670,
                            2805,
                            2949,
                            3081,
                            3244,
                            3417,
                            3599,
                            3791,
                            3993
                        ],
                        HIGH: [
                            17,
                            34,
                            58,
                            82,
                            106,
                            139,
                            154,
                            202,
                            235,
                            288,
                            331,
                            374,
                            427,
                            468,
                            530,
                            602,
                            674,
                            746,
                            813,
                            919,
                            969,
                            1056,
                            1108,
                            1228,
                            1286,
                            1425,
                            1501,
                            1581,
                            1677,
                            1782,
                            1897,
                            2022,
                            2157,
                            2301,
                            2361,
                            2524,
                            2625,
                            2735,
                            2927,
                            3057
                        ]
                    },
                    ALPHANUMERIC: {
                        LOW: [
                            25,
                            47,
                            77,
                            114,
                            154,
                            195,
                            224,
                            279,
                            335,
                            395,
                            468,
                            535,
                            619,
                            667,
                            758,
                            854,
                            938,
                            1046,
                            1153,
                            1249,
                            1352,
                            1460,
                            1588,
                            1704,
                            1853,
                            1990,
                            2132,
                            2223,
                            2369,
                            2520,
                            2677,
                            2840,
                            3009,
                            3183,
                            3351,
                            3537,
                            3729,
                            3927,
                            4087,
                            4296
                        ],
                        MEDIUM: [
                            20,
                            38,
                            61,
                            90,
                            122,
                            154,
                            178,
                            221,
                            262,
                            311,
                            366,
                            419,
                            483,
                            528,
                            600,
                            656,
                            734,
                            816,
                            909,
                            970,
                            1035,
                            1134,
                            1248,
                            1326,
                            1451,
                            1542,
                            1637,
                            1732,
                            1839,
                            1994,
                            2113,
                            2238,
                            2369,
                            2506,
                            2632,
                            2780,
                            2894,
                            3054,
                            3220,
                            3391
                        ],
                        QUARTER: [
                            16,
                            29,
                            47,
                            67,
                            87,
                            108,
                            125,
                            157,
                            189,
                            221,
                            259,
                            296,
                            352,
                            376,
                            426,
                            470,
                            531,
                            574,
                            644,
                            702,
                            742,
                            823,
                            890,
                            963,
                            1041,
                            1094,
                            1172,
                            1263,
                            1322,
                            1429,
                            1499,
                            1618,
                            1700,
                            1787,
                            1867,
                            1966,
                            2071,
                            2181,
                            2298,
                            2420
                        ],
                        HIGH: [
                            10,
                            20,
                            35,
                            50,
                            64,
                            84,
                            93,
                            122,
                            143,
                            174,
                            200,
                            227,
                            259,
                            283,
                            321,
                            365,
                            408,
                            452,
                            493,
                            557,
                            587,
                            640,
                            672,
                            744,
                            779,
                            864,
                            910,
                            958,
                            1016,
                            1080,
                            1150,
                            1226,
                            1307,
                            1394,
                            1431,
                            1530,
                            1591,
                            1658,
                            1774,
                            1852
                        ]
                    },
                    KANJI: {
                        LOW: [
                            10,
                            20,
                            32,
                            48,
                            65,
                            82,
                            95,
                            118,
                            141,
                            167,
                            198,
                            226,
                            262,
                            282,
                            320,
                            361,
                            397,
                            442,
                            488,
                            528,
                            572,
                            618,
                            672,
                            721,
                            784,
                            842,
                            902,
                            940,
                            1002,
                            1066,
                            1132,
                            1201,
                            1273,
                            1347,
                            1417,
                            1496,
                            1577,
                            1661,
                            1729,
                            1817
                        ],
                        MEDIUM: [
                            8,
                            16,
                            26,
                            38,
                            52,
                            65,
                            75,
                            93,
                            111,
                            131,
                            155,
                            177,
                            204,
                            223,
                            254,
                            277,
                            310,
                            345,
                            384,
                            410,
                            438,
                            480,
                            528,
                            561,
                            614,
                            652,
                            692,
                            732,
                            778,
                            843,
                            894,
                            947,
                            1002,
                            1060,
                            1113,
                            1176,
                            1224,
                            1292,
                            1362,
                            1435
                        ],
                        QUARTER: [
                            7,
                            12,
                            20,
                            28,
                            37,
                            45,
                            53,
                            66,
                            80,
                            93,
                            109,
                            125,
                            149,
                            159,
                            180,
                            198,
                            224,
                            243,
                            272,
                            297,
                            314,
                            348,
                            376,
                            407,
                            440,
                            462,
                            496,
                            534,
                            559,
                            604,
                            634,
                            684,
                            719,
                            756,
                            790,
                            832,
                            876,
                            923,
                            972,
                            1024
                        ],
                        HIGH: [
                            4,
                            8,
                            15,
                            21,
                            27,
                            36,
                            39,
                            52,
                            60,
                            74,
                            85,
                            96,
                            109,
                            120,
                            136,
                            154,
                            173,
                            191,
                            208,
                            235,
                            248,
                            270,
                            284,
                            315,
                            330,
                            365,
                            385,
                            405,
                            430,
                            457,
                            486,
                            518,
                            553,
                            590,
                            605,
                            647,
                            673,
                            701,
                            750,
                            784
                        ]
                    },
                    BYTE: {
                        LOW: [
                            17,
                            32,
                            53,
                            78,
                            106,
                            134,
                            154,
                            192,
                            230,
                            271,
                            321,
                            367,
                            425,
                            458,
                            520,
                            586,
                            644,
                            718,
                            792,
                            858,
                            929,
                            1003,
                            1091,
                            1171,
                            1273,
                            1367,
                            1465,
                            1528,
                            1628,
                            1732,
                            1840,
                            1952,
                            2068,
                            2188,
                            2303,
                            2431,
                            2563,
                            2699,
                            2809,
                            2953
                        ],
                        MEDIUM: [
                            14,
                            26,
                            42,
                            62,
                            84,
                            106,
                            122,
                            152,
                            180,
                            213,
                            251,
                            287,
                            331,
                            362,
                            412,
                            450,
                            504,
                            560,
                            624,
                            666,
                            711,
                            779,
                            857,
                            911,
                            997,
                            1059,
                            1125,
                            1190,
                            1264,
                            1370,
                            1452,
                            1538,
                            1628,
                            1722,
                            1809,
                            1911,
                            1989,
                            2099,
                            2213,
                            2331
                        ],
                        QUARTER: [
                            11,
                            20,
                            32,
                            46,
                            60,
                            74,
                            86,
                            108,
                            130,
                            151,
                            177,
                            203,
                            241,
                            258,
                            292,
                            322,
                            364,
                            394,
                            442,
                            482,
                            509,
                            565,
                            611,
                            661,
                            715,
                            751,
                            805,
                            868,
                            908,
                            982,
                            1030,
                            1112,
                            1168,
                            1228,
                            1283,
                            1351,
                            1423,
                            1499,
                            1579,
                            1663
                        ],
                        HIGH: [
                            7,
                            14,
                            24,
                            34,
                            44,
                            58,
                            64,
                            84,
                            98,
                            119,
                            137,
                            155,
                            177,
                            194,
                            220,
                            250,
                            280,
                            310,
                            338,
                            382,
                            403,
                            439,
                            461,
                            511,
                            535,
                            593,
                            625,
                            658,
                            698,
                            742,
                            790,
                            842,
                            898,
                            958,
                            983,
                            1051,
                            1093,
                            1139,
                            1219,
                            1273
                        ]
                    }
                })[t3][i3];
            }
            get errorCorrections() {
                return [
                    e2.LOW,
                    e2.MEDIUM,
                    e2.QUARTER,
                    e2.HIGH
                ];
            }
            penaltyForMatrix(t3) {
                let i3 = 0;
                const s3 = t3.content.length;
                let e3, h3, r2, o2, n3;
                for(let l4 = 0; l4 < s3 - 1; l4++){
                    e3 = t3.bitAt(0, l4), h3 = e3, r2 = 1, o2 = e3, n3 = e3;
                    for(let s4 = 1; s4 < 10; s4++)e3 = t3.bitAt(s4, l4), h3 === e3 ? t3.bitAt(s4, l4 + 1) === h3 && t3.bitAt(s4 - 1, l4 + 1) === h3 && (i3 += 3) : h3 = e3, o2 === e3 ? r2++ : (r2 > 4 && (i3 += r2 - 2), r2 = 1, o2 = e3), n3 = 2 * n3 + e3;
                    for(let c4 = 10; c4 < s3; c4++)e3 = t3.bitAt(c4, l4), h3 === e3 ? t3.bitAt(c4, l4 + 1) === h3 && t3.bitAt(c4 - 1, l4 + 1) === h3 && (i3 += 3) : h3 = e3, o2 === e3 ? r2++ : (r2 > 4 && (i3 += r2 - 2), r2 = 1, o2 = e3), n3 = (2 * n3 + e3) % 2048, 1488 !== n3 && 93 !== n3 || (i3 += 40);
                    r2 > 4 && (i3 += r2 - 2);
                }
                let l3 = s3 - 1;
                e3 = t3.bitAt(0, l3), r2 = 1, o2 = e3, n3 = e3;
                for(let s4 = 1; s4 < 10; s4++)e3 = t3.bitAt(s4, l3), o2 === e3 ? r2++ : (r2 > 4 && (i3 += r2 - 2), r2 = 1, o2 = e3), n3 = 2 * n3 + e3;
                for(let h4 = 10; h4 < s3; h4++)e3 = t3.bitAt(h4, l3), o2 === e3 ? r2++ : (r2 > 4 && (i3 += r2 - 2), r2 = 1, o2 = e3), n3 = (2 * n3 + e3) % 2048, 1488 !== n3 && 93 !== n3 || (i3 += 40);
                r2 > 4 && (i3 += r2 - 2);
                let c3 = 0;
                for(let h4 = 0; h4 < s3; h4++){
                    e3 = t3.bitAt(h4, 0), c3 += e3, r2 = 1, o2 = e3, n3 = e3;
                    for(let s4 = 1; s4 < 10; s4++)e3 = t3.bitAt(h4, s4), c3 += e3, o2 === e3 ? r2++ : (r2 > 4 && (i3 += r2 - 2), r2 = 1, o2 = e3), n3 = 2 * n3 + e3;
                    for(let l4 = 10; l4 < s3; l4++)e3 = t3.bitAt(h4, l4), c3 += e3, o2 === e3 ? r2++ : (r2 > 4 && (i3 += r2 - 2), r2 = 1, o2 = e3), n3 = (2 * n3 + e3) % 2048, 1488 !== n3 && 93 !== n3 || (i3 += 40);
                    r2 > 4 && (i3 += r2 - 2);
                }
                return i3 += Math.floor(10 * Math.abs(c3 / (s3 * s3) - 0.5)), i3;
            }
            toUtf16Bytes(t3) {
                const i3 = [];
                for(let s3 = 0; s3 < t3.length; s3++){
                    let e3 = t3.charCodeAt(s3), h3 = e3 % 256;
                    i3.push((e3 - h3) / 256), i3.push(h3);
                }
                return i3;
            }
            toUtf8Bytes(t3) {
                const i3 = [];
                let s3 = 0;
                for(let e3 = 0; e3 < t3.length; e3++){
                    let h3 = t3.charCodeAt(e3);
                    h3 < 128 ? i3[s3++] = h3 : h3 < 2048 ? (i3[s3++] = h3 >> 6 | 192, i3[s3++] = 63 & h3 | 128) : 55296 == (64512 & h3) && e3 + 1 < t3.length && 56320 == (64512 & t3.charCodeAt(e3 + 1)) ? (h3 = 65536 + ((1023 & h3) << 10) + (1023 & t3.charCodeAt(++e3)), i3[s3++] = h3 >> 18 | 240, i3[s3++] = h3 >> 12 & 63 | 128, i3[s3++] = h3 >> 6 & 63 | 128, i3[s3++] = 63 & h3 | 128) : (i3[s3++] = h3 >> 12 | 224, i3[s3++] = h3 >> 6 & 63 | 128, i3[s3++] = 63 & h3 | 128);
                }
                return i3;
            }
            versionForLength(t3, s3) {
                let e3;
                e3 = this.code.hasEci ? i2[s3] : this.capacity(this.code.encoding, s3);
                let h3 = e3.findIndex((i3)=>i3 >= t3);
                return -1 === h3 ? 100 : h3 + 1;
            }
        }
    };
}
function g$2() {
    if (l$4) return n$b;
    l$4 = 1;
    const { QRCode: t2, QRCodeEncoder: i2 } = d$2();
    class s2 extends i2 {
        encode() {
            this.initializeEncoding();
            for (const t3 of this.errorCorrections)if (this.code.errorCorrection = t3, this.initializeVersion(), !(this.code.version < this.minimumVersion) && (this.initializeCodewords(), this.initializeMapping(), this.initializeMasking(), this.lowestPenalty < this.constructor.PENALTY_FOR_NEGATIVE_CAPACITY)) return this.initializeTurtleData(), void this.initializeSvg();
            for(let i3 = Math.max(this.minimumVersion, this.code.version + 1); i3 <= t2.MAX_VERSION; i3++)if (this.code.version = i3, this.initializeCodewords(), this.initializeMapping(), this.initializeMasking(), this.lowestPenalty < this.constructor.PENALTY_FOR_NEGATIVE_CAPACITY) return this.initializeTurtleData(), void this.initializeSvg();
        }
        initializeSvg() {
            const t3 = this.svgOffset, i3 = this.svgDimension, s3 = this.svgForegroundStyle, e3 = this.svgBackgroundStyle, h2 = [];
            h2.push(this.svgTag(i3)), h2.push("<defs>"), h2.push(this.svgFinderPattern(s3)), h2.push("</defs>"), h2.push(this.svgBackground(e3, i3, 0 === t3 ? void 0 : t3 / 2)), this.svgFinderPatterns(h2, t3), this.svgTurtle(h2, s3, t3), h2.push("</svg>"), this.svg = h2.join("");
        }
        initializeTurtleData() {
            const t3 = this.code.data.copy();
            for (const i3 of this.code.timingPatternPositions)t3.put(i3.x, i3.y, true);
            for (const i3 of this.code.alignmentPatternPositions)t3.fillAlignmentPatternAt(i3.x, i3.y);
            this.turtleData = t3;
        }
        get inverted() {
            const t3 = this.code.options.invert;
            return void 0 !== t3 && t3;
        }
        get hasBorder() {
            const t3 = this.code.options.border;
            return void 0 !== t3 && t3;
        }
        get minimumVersion() {
            return 1;
        }
        async png() {
            if (void 0 !== this._png) return this._png;
            if (void 0 === this.svg) throw "no SVG to convert to PNG";
            const t3 = new Image(), i3 = new Blob([
                this.svg
            ], {
                type: "image/svg+xml;charset=utf-8"
            });
            t3.src = URL.createObjectURL(i3), await t3.decode();
            const s3 = this.svgDimension, e3 = document.createElement("canvas");
            return e3.width = s3, e3.height = s3, e3.getContext("2d").drawImage(t3, 0, 0, s3, s3), this._png = e3.toDataURL(), this._png;
        }
        svgBackground(t3, i3, s3) {
            return "" === t3 ? "" : void 0 === s3 ? `<rect ${t3} x="0" y="0" width="${i3}" height="${i3}" />` : `<rect ${t3} x="0" y="0" width="${i3}" height="${i3}" rx="${s3}" ry="${s3}" />`;
        }
        get svgBackgroundStyle() {
            const t3 = this.code.options.styleBackground;
            return void 0 !== t3 ? t3 : this.inverted ? 'fill="black"' : 'fill="white"';
        }
        get svgDimension() {
            return 2 * this.svgOffset + 8 * this.code.dimension;
        }
        svgFinderPattern(t3) {
            return `<path id="f" ${t3} fill-rule="evenodd" d="M 0 10 a10,10 0 0 1 10,-10 h36 a10,10 0 0 1 10,10 v36 a10,10 0 0 1 -10,10 h-36 a10,10 0 0 1 -10,-10 Z M 8 10 a2,2 0 0 1 2,-2 h36 a2,2 0 0 1 2,2 v36 a2,2 0 0 1 -2,2 h-36 a2,2 0 0 1 -2,-2 Z M 16 18 a2,2 0 0 1 2,-2 h20 a2,2 0 0 1 2,2 v20 a2,2 0 0 1 -2,2 h-20 a2,2 0 0 1 -2,-2 Z" />`;
        }
        svgFinderPatterns(t3, i3) {
            for (const s3 of this.code.finderPatternPositions)t3.push(`<use xlink:href="#f" x="${8 * s3.x + i3}" y="${8 * s3.y + i3}" />`);
        }
        get svgForegroundStyle() {
            const t3 = this.code.options.styleForeground;
            return void 0 !== t3 ? t3 : this.inverted ? 'fill="white"' : 'fill="black"';
        }
        get svgOffset() {
            return this.hasBorder ? 32 : 0;
        }
        svgTag(t3) {
            return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${t3}" height="${t3}" viewBox="0 0 ${t3} ${t3}">`;
        }
        svgTurtle(t3, i3, s3) {
            const h2 = this.code.dimension;
            for(let r2 = 0; r2 < h2; r2++)for(let o2 = 0; o2 < h2; o2++)this.turtleData.at(o2, r2) && t3.push(new e2(this.turtleData, i3, s3, o2, r2).element);
        }
    }
    s2.PENALTY_FOR_LEFTOVER_CAPACITY = [
        32,
        16,
        8,
        4,
        2,
        1
    ], s2.PENALTY_FOR_NEGATIVE_CAPACITY = 1e4;
    class e2 {
        constructor(t3, i3, s3, e3, h2){
            this.data = t3, this.dimension = t3.width, this.style = i3 || "", this.offset = s3 || 0, this.start = {
                x: e3,
                y: h2
            }, this.visitedLocations = /* @__PURE__ */ new Set(), this.generateElement(), this.clearVisited();
        }
        clearVisited() {
            this.visitedLocations.forEach((t3)=>{
                const i3 = this.fromLocation(t3);
                this.data.put(i3.x, i3.y, false);
            });
        }
        get element() {
            return this._element;
        }
        fromLocation(t3) {
            const i3 = t3 % this.dimension;
            return {
                x: i3,
                y: (t3 - i3) / this.dimension
            };
        }
        generateElement() {
            const t3 = this.start.x, i3 = this.start.y, s3 = "left";
            let e3 = t3, h2 = i3;
            const r2 = [];
            r2.push(s3);
            let o2 = "top";
            const n2 = /* @__PURE__ */ new Set(), l2 = /* @__PURE__ */ new Set(), c2 = /* @__PURE__ */ new Set(), a2 = /* @__PURE__ */ new Set();
            for(a2.add(this.toLocation(e3, h2)); e3 !== t3 || h2 !== i3 || o2 !== s3;){
                r2.push(o2);
                const t4 = this.toLocation(e3, h2);
                switch(this.visitLocation(t4), o2){
                    case "top":
                        n2.add(t4), this.hasPixelAtCoordinate(e3 + 1, h2) ? this.hasPixelAtCoordinate(e3 + 1, h2 - 1) ? (e3 += 1, h2 -= 1, o2 = "left") : e3 += 1 : o2 = "right";
                        break;
                    case "right":
                        l2.add(t4), this.hasPixelAtCoordinate(e3, h2 + 1) ? this.hasPixelAtCoordinate(e3 + 1, h2 + 1) ? (e3 += 1, h2 += 1, o2 = "top") : h2 += 1 : o2 = "bottom";
                        break;
                    case "bottom":
                        c2.add(t4), this.hasPixelAtCoordinate(e3 - 1, h2) ? this.hasPixelAtCoordinate(e3 - 1, h2 + 1) ? (e3 -= 1, h2 += 1, o2 = "right") : e3 -= 1 : o2 = "left";
                        break;
                    case "left":
                        a2.add(t4), this.hasPixelAtCoordinate(e3, h2 - 1) ? this.hasPixelAtCoordinate(e3 - 1, h2 - 1) ? (e3 -= 1, h2 -= 1, o2 = "bottom") : h2 -= 1 : o2 = "top";
                }
            }
            if (4 === r2.length) return void (this._element = `<rect ${this.style} x="${8 * t3 + this.offset}" y="${8 * i3 + this.offset}" width="8" height="8" rx="2" ry="2" />`);
            let f2 = [];
            f2.push(`M${8 * t3 + this.offset + 1} ${8 * i3 + this.offset + 4}`);
            let u2, d2 = r2[0];
            r2.push(d2);
            let g2 = 0;
            for(let t4 = 1; t4 < r2.length; t4++)u2 = d2, d2 = r2[t4], u2 === d2 ? g2 += 8 : "top" === u2 && "right" === d2 ? (0 !== g2 && (f2.push("h" + g2), g2 = 0), f2.push("a3,3 0 0 1 3,3")) : "right" === u2 && "bottom" === d2 ? (0 !== g2 && (f2.push("v" + g2), g2 = 0), f2.push("a3,3 0 0 1 -3,3")) : "bottom" === u2 && "left" === d2 ? (0 !== g2 && (f2.push("h-" + g2), g2 = 0), f2.push("a3,3 0 0 1 -3,-3")) : "left" === u2 && "top" === d2 ? (0 !== g2 && (f2.push("v-" + g2), g2 = 0), f2.push("a3,3 0 0 1 3,-3")) : "top" === u2 && "left" === d2 ? (f2.push("h" + (g2 + 5)), g2 = 5) : "right" === u2 && "top" === d2 ? (f2.push("v" + (g2 + 5)), g2 = 5) : "bottom" === u2 && "right" === d2 ? (f2.push("h-" + (g2 + 5)), g2 = 5) : "left" === u2 && "bottom" === d2 && (f2.push("v-" + (g2 + 5)), g2 = 5);
            g2 > 0 && f2.push("v-" + g2), f2.push("z");
            let v2 = /* @__PURE__ */ new Set(), m2 = /* @__PURE__ */ new Set();
            for(this.visitedLocations.forEach((t4)=>{
                n2.has(t4) || m2.add(t4 - this.dimension), a2.has(t4) || m2.add(t4 - 1), c2.has(t4) || m2.add(t4 + this.dimension), l2.has(t4) || m2.add(t4 + 1);
            }), m2 = [
                ...m2
            ].filter((t4)=>!this.hasVisitedLocation(t4)); m2.length > 0;){
                let t4 = [];
                m2.forEach((i4)=>{
                    this.hasPixelAtLocation(i4) ? (this.visitLocation(i4), t4.push(i4)) : v2.add(i4);
                }), m2 = /* @__PURE__ */ new Set(), t4.forEach((t5)=>{
                    m2.add(t5 - this.dimension), m2.add(t5 + this.dimension), m2.add(t5 + 1), m2.add(t5 - 1);
                }), m2 = [
                    ...m2
                ].filter((t5)=>!this.hasVisitedLocation(t5));
            }
            for(; v2.size > 0;){
                let t4, i4, s4;
                v2.forEach((r4)=>{
                    e3 = r4 % this.dimension, h2 = (r4 - e3) / this.dimension, (void 0 === t4 || h2 < s4 || h2 === s4 && e3 > i4) && (t4 = r4, i4 = e3, s4 = h2);
                }), f2.push(`M${8 * i4 + this.offset + 9} ${8 * s4 + this.offset - 1}`), e3 = i4, h2 = s4, o2 = "top";
                let r3 = 5;
                for(; e3 !== i4 || h2 !== s4 || "right" !== o2;){
                    const t5 = this.toLocation(e3, h2);
                    switch(v2.delete(t5), o2){
                        case "top":
                            this.hasPixelAtCoordinate(e3 - 1, h2 - 1) ? this.hasPixelAtCoordinate(e3 - 1, h2) ? (f2.push("h-" + (r3 + 5)), r3 = 5, o2 = "left") : (r3 += 8, e3--) : (r3 > 0 && f2.push("h-" + r3), f2.push("a3,3 0 0 1 -3,-3"), r3 = 0, o2 = "right", e3--, h2--);
                            break;
                        case "left":
                            this.hasPixelAtCoordinate(e3 - 1, h2 + 1) ? this.hasPixelAtCoordinate(e3, h2 + 1) ? (f2.push("v" + (r3 + 5)), r3 = 5, o2 = "bottom") : (r3 += 8, h2++) : (r3 > 0 && f2.push("v" + r3), f2.push("a3,3 0 0 1 -3,3"), r3 = 0, o2 = "top", e3--, h2++);
                            break;
                        case "bottom":
                            this.hasPixelAtCoordinate(e3 + 1, h2 + 1) ? this.hasPixelAtCoordinate(e3 + 1, h2) ? (f2.push("h" + (r3 + 5)), r3 = 5, o2 = "right") : (r3 += 8, e3++) : (r3 > 0 && f2.push("h" + r3), f2.push("a3,3 0 0 1 3,3"), r3 = 0, o2 = "left", e3++, h2++);
                            break;
                        case "right":
                            this.hasPixelAtCoordinate(e3 + 1, h2 - 1) ? this.hasPixelAtCoordinate(e3, h2 - 1) ? (f2.push("v-" + (r3 + 5)), r3 = 5, o2 = "top") : (r3 += 8, h2--) : (r3 > 0 && f2.push("v-" + r3), f2.push("a3,3 0 0 1 3,-3"), r3 = 0, o2 = "bottom", e3++, h2--);
                    }
                }
                f2.push("v-" + (r3 + 5)), f2.push("z");
            }
            this._element = `<path ${this.style} d="${f2.join("")}" />`;
        }
        hasPixelAtCoordinate(t3, i3) {
            return !(t3 >= this.dimension || t3 < 0 || i3 >= this.dimension || i3 < 0) && this.data.at(t3, i3);
        }
        hasPixelAtLocation(t3) {
            const i3 = t3 % this.dimension;
            return this.data.at(i3, (t3 - i3) / this.dimension);
        }
        hasVisitedCoordinate(t3, i3) {
            return this.hasVisitedLocation(this.toLocation(t3, i3));
        }
        hasVisitedLocation(t3) {
            return this.visitedLocations.has(t3);
        }
        toLocation(t3, i3) {
            return this.dimension * i3 + t3;
        }
        visitCoordinate(t3, i3) {
            this.visitLocation(this.toLocation(t3, i3));
        }
        visitLocation(t3) {
            this.visitedLocations.add(t3);
        }
    }
    return n$b = {
        SquareQRCodeEncoder: s2,
        Turtle: e2
    };
}
var v = u ? f : (u = 1, f = __spreadValues(__spreadValues(__spreadValues({}, function() {
    if (a$6) return c$6;
    a$6 = 1;
    const { Matrix: t2 } = d$2(), { SquareQRCodeEncoder: i2 } = g$2(), s2 = Object.freeze({
        AVAILABLE: "AVAILABLE",
        FALSE: "FALSE",
        TRUE: "TRUE",
        UNDECIDED: "UNDECIDED"
    });
    return c$6 = {
        MarketQRCodeEncoder: class extends i2 {
            static getJewel() {
                if (void 0 !== this.jewel) return this.jewel;
                const i3 = t2.withAll(9, 9, s2.UNDECIDED);
                i3.put(0, 0, s2.AVAILABLE), i3.put(0, 8, s2.AVAILABLE), i3.put(8, 0, s2.AVAILABLE), i3.put(8, 8, s2.AVAILABLE);
                for(let t3 = 0; t3 < 7; t3++)i3.put(t3 + 1, 0, s2.FALSE), i3.put(t3 + 1, 8, s2.FALSE), i3.put(0, t3 + 1, s2.FALSE), i3.put(8, t3 + 1, s2.FALSE);
                i3.put(3, 3, s2.FALSE), i3.put(3, 5, s2.FALSE), i3.put(5, 3, s2.FALSE), i3.put(5, 5, s2.FALSE);
                for(let t3 = 0; t3 < 6; t3++)i3.put(1 + t3, 1, s2.TRUE), i3.put(2 + t3, 7, s2.TRUE), i3.put(7, 1 + t3, s2.TRUE), i3.put(1, 2 + t3, s2.TRUE);
                return i3.put(4, 4, s2.TRUE), this.jewel = i3, i3;
            }
            initializeSvg() {
                const t3 = this.svgOffset, i3 = this.svgDimension, s3 = this.svgForegroundStyle, e2 = this.svgLogoStyle, h2 = [];
                h2.push(this.svgTag(i3)), h2.push("<defs>"), h2.push(this.svgFinderPattern(s3)), h2.push(this.svgLogo(e2)), h2.push("</defs>"), h2.push(this.svgBackground(this.svgBackgroundStyle, i3, 0 === t3 ? void 0 : 16)), this.svgFinderPatterns(h2, t3), this.svgTurtle(h2, s3, t3);
                const r2 = 4 * (this.code.dimension - 7) + t3;
                h2.push(`<use xlink:href="#s" x="${r2}" y="${r2}" />`), h2.push("</svg>"), this.svg = h2.join("");
            }
            initializeTurtleData() {
                super.initializeTurtleData();
                const t3 = (this.code.dimension - 9) / 2;
                this.turtleData.fill(t3, t3 + 1, 9, 7, false), this.turtleData.fill(t3 + 1, t3, 7, 1, false), this.turtleData.fill(t3 + 1, t3 + 8, 7, 1, false);
            }
            get isMonochrome() {
                const t3 = this.code.options.monochrome;
                return void 0 !== t3 && t3;
            }
            get minimumVersion() {
                return 2;
            }
            penaltyForMatrix(t3) {
                const i3 = this.map.errorCorrectionCapacity, e2 = i3.map(()=>/* @__PURE__ */ new Set()), h2 = this.constructor.getJewel(), r2 = (t3.content.length - 9) / 2;
                for(let i4 = 0; i4 < 9; i4++){
                    const o3 = i4 + r2;
                    for(let n2 = 0; n2 < 9; n2++){
                        const l2 = n2 + r2, c2 = this.map.at(l2, o3);
                        if (this.map.isDataPixel(c2)) switch(h2.at(n2, i4)){
                            case s2.FALSE:
                                false !== t3.at(l2, o3) && e2[c2.chunk].add(c2.byte);
                                break;
                            case s2.TRUE:
                                true !== t3.at(l2, o3) && e2[c2.chunk].add(c2.byte);
                                break;
                            case s2.UNDECIDED:
                                e2[c2.chunk].add(c2.byte);
                        }
                    }
                }
                let o2 = 0;
                return i3.forEach((t4, i4)=>{
                    const s3 = t4 - 2 * e2[i4].size;
                    s3 < 0 ? o2 += this.constructor.PENALTY_FOR_NEGATIVE_CAPACITY : s3 < this.constructor.PENALTY_FOR_LEFTOVER_CAPACITY.length && (o2 += this.constructor.PENALTY_FOR_LEFTOVER_CAPACITY[s3]);
                }), t3.at(r2, r2) || o2++, t3.at(r2, r2 + 8) || o2++, t3.at(r2 + 8, r2) || o2++, t3.at(r2 + 8, r2 + 8) || o2++, o2;
            }
            get svgForegroundStyle() {
                const t3 = this.code.options.styleForeground;
                return void 0 !== t3 ? t3 : this.inverted ? this.isMonochrome ? 'fill="white"' : 'fill="white" fill-opacity="0.95"' : this.isMonochrome ? 'fill="black"' : 'fill="black" fill-opacity="0.9"';
            }
            get svgLogoStyle() {
                if (this.isMonochrome) return this.svgForegroundStyle;
                const t3 = this.code.options.styleLogo;
                return void 0 !== t3 ? t3 : 'fill="#006AFF"';
            }
            svgLogo(t3) {
                return `<path id="s" ${t3} fill-rule="evenodd" d="M 0 9.8 C 0 3.92 3.92 0 9.8 0 L 46.2 0 C 52.08 0 56 3.92 56 9.8 L 56 46.2 C 56 52.08 52.08 56 46.2 56 L 9.8 56 C 3.92 56 0 52.08 0 46.2 Z M 11.2 14 C 11.2 12.32 12.32 11.2 14 11.2 L 42 11.2 C 43.68 11.2 44.8 12.32 44.8 14 L 44.8 42 C 44.8 43.68 43.68 44.8 42 44.8 L 14 44.8 C 12.32 44.8 11.2 43.68 11.2 42 Z M 21 22.4 C 21 21.7 21.7 21 22.4 21 L 33.6 21 C 34.3 21 35 21.7 35 22.4 L 35 33.6 C 35 34.3 34.3 35 33.6 35 L 22.4 35 C 21.7 35 21 34.3 21 33.6 Z" />`;
            }
            get svgOffset() {
                return this.hasBorder ? 48 : 0;
            }
        },
        JEWEL_VALUE: s2
    };
}()), d$2()), g$2()));
const m = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.content = "", this.border = false, this.monochrome = false;
    }
    render() {
        const t2 = this.content ? new v.MarketQRCodeEncoder(this.content, {
            border: this.border,
            styleBackground: this.border ? 'class="background"' : "",
            styleForeground: 'class="foreground"',
            styleLogo: 'class="logo"'
        }) : null;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "6194ef9fecf9e6a02fff1c4540b5c4a075b03944",
            class: "market-qrcode",
            "aria-hidden": "true"
        }, (0, $696Z8.h)("div", {
            key: "72af149064f5cc18df5e353a606f67c55bedd6b2",
            innerHTML: t2 ? t2.svg : "",
            style: void 0 === this.size ? null : {
                height: this.size + "px",
                width: this.size + "px"
            }
        }));
    }
    static get style() {
        return ":host{display:inline-block;box-sizing:border-box;border-radius:var(--qrcode-border-radius)}:host svg .foreground{fill:var(--qrcode-normal-variant-foreground-color)}:host svg .background{fill:var(--qrcode-normal-variant-background-color)}:host svg .logo{fill:var(--qrcode-normal-variant-icon-color)}:host([monochrome]) .foreground{fill:var(--qrcode-monochrome-variant-foreground-color)}:host([monochrome]) .background{fill:var(--qrcode-monochrome-variant-background-color)}:host([monochrome]) .logo{fill:var(--qrcode-monochrome-variant-icon-color)}:host([size]) svg{width:100%;height:100%}:host([border]){border:var(--qrcode-border-width) solid var(--qrcode-border-color)}";
    }
}, [
    1,
    "market-qrcode",
    {
        content: [
            513
        ],
        size: [
            514
        ],
        border: [
            4
        ],
        monochrome: [
            516
        ]
    }
]), b = m;
const s$7 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketRadioValueChange = (0, $696Z8.createEvent)(this, "marketRadioValueChange", 7), this.selected = false, this.disabled = false, this.invalid = false, this.focused = false, this.hovered = false, this.active = false, this.ariaAttributesHash = 0;
    }
    setSelection(e2, { silent: o2 = false } = {}) {
        const { marketRadioValueChange: r2, selected: a2, innerInput: t2 } = this;
        if ("boolean" != typeof e2) return Promise.resolve();
        if (a2 === e2) return Promise.resolve();
        if (!o2) {
            const { defaultPrevented: o3 } = r2.emit({
                current: e2,
                previous: a2
            });
            if (o3) return Promise.resolve();
        }
        return this.selected = e2, t2 && (t2.checked = e2), Promise.resolve();
    }
    setValue(e2) {
        return console.warn("market-radio's setValue() method has been deprecated. Use setSelection() instead.", this.el), this.setSelection(e2), Promise.resolve();
    }
    setActive(e2) {
        return this.active = e2, Promise.resolve();
    }
    setHover(e2) {
        return this.hovered = e2, Promise.resolve();
    }
    setDisabled(e2) {
        return this.disabled = e2, Promise.resolve();
    }
    setFocus(e2 = true) {
        return this.disabled || (this.focused = e2), Promise.resolve();
    }
    onFocus() {
        this.disabled || (this.focused = true, this.el.shadowRoot.querySelector("input").focus());
    }
    handleClick(e2) {
        e2.preventDefault(), this.disabled || this.selected || (this.setFocus(), this.setSelection(true));
    }
    componentWillLoad() {
        "undefined" != typeof MutationObserver && (this.mutationObserver = a$q(this.el, ()=>{
            (this.el.hasAttribute("aria-label") || this.el.hasAttribute("aria-labelledby")) && this.ariaAttributesHash++;
        }));
    }
    disconnectedCallback() {
        var e2;
        null === (e2 = this.mutationObserver) || void 0 === e2 || e2.disconnect();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "12560bc14732ae070275458c8c5bc80f4c6fcfdb",
            class: "market-radio",
            onBlur: ()=>{
                this.setFocus(false);
            },
            onClick: this.handleClick,
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("input", {
            key: "1336d08ad3948e717c1486848d0989e4e3d062ae",
            ref: (e2)=>this.innerInput = e2,
            type: "radio",
            "aria-label": e$d(this.el),
            checked: this.selected,
            disabled: this.disabled
        }), this.selected && (0, $696Z8.h)("svg", {
            key: "61402f43648b3e9d5322fa429530ac858434e867",
            width: "6",
            height: "6",
            viewBox: "0 0 6 6",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("circle", {
            key: "be7c6f4036efa5544f8cd0dae6b564d94496ab69",
            cx: "3",
            cy: "3",
            r: "3"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);--radio-offset:calc(-1 * var(--radio-border-size));--focus-ring-color:color-mix(in srgb, var(--radio-focus-ring-color) 100%, transparent);position:relative;display:inline-block;width:var(--radio-width);height:var(--radio-height);border:var(--radio-border-size) solid var(--radio-normal-state-normal-validity-unselected-value-border-color);border-radius:var(--radio-border-radius);background-color:var(--radio-normal-state-normal-validity-unselected-value-background-color)}input{position:absolute;top:var(--radio-offset);left:var(--radio-offset);width:var(--radio-width);height:var(--radio-height);margin:0;border-radius:var(--radio-border-radius);background:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}input:focus-visible{outline:var(--radio-focus-ring-border-size, var(--core-focus-ring-border-size)) solid var(--focus-ring-color);outline-offset:var(--radio-focus-ring-buffer-size)}svg{position:absolute;top:calc(50% - var(--radio-svg-radius));left:calc(50% - var(--radio-svg-radius));align-items:center;pointer-events:none}@media (hover: hover){:host(:hover),:host([hovered]){border-color:var(--radio-hover-state-normal-validity-unselected-value-border-color);background-color:var(--radio-hover-state-normal-validity-unselected-value-background-color)}}:host(:focus),:host([focused]){border-color:var(--radio-focus-state-normal-validity-unselected-value-border-color);background-color:var(--radio-focus-state-normal-validity-unselected-value-background-color)}:host(:active),:host([active]){border-color:var(--radio-pressed-state-normal-validity-unselected-value-border-color);background-color:var(--radio-pressed-state-normal-validity-unselected-value-background-color)}:host([invalid]){border-color:var(--radio-normal-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-normal-state-invalid-validity-unselected-value-background-color)}@media (hover: hover){:host([invalid]:hover),:host([invalid][hovered]){border-color:var(--radio-hover-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-hover-state-invalid-validity-unselected-value-background-color)}}:host([invalid]:focus),:host([invalid][focused]){border-color:var(--radio-focus-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-focus-state-invalid-validity-unselected-value-background-color)}:host([invalid]:active),:host([invalid][active]){border-color:var(--radio-pressed-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-pressed-state-invalid-validity-unselected-value-background-color)}:host([disabled]),:host([invalid][disabled]){border-color:var(--radio-disabled-state-normal-validity-unselected-value-border-color);background-color:var(--radio-disabled-state-normal-validity-unselected-value-background-color)}:host([selected]){border-color:var(--radio-normal-state-normal-validity-selected-value-border-color);background-color:var(--radio-normal-state-normal-validity-selected-value-background-color)}:host([selected]) svg{fill:var(--radio-normal-state-normal-validity-selected-value-icon-color)}@media (hover: hover){:host([selected]:hover),:host([selected][hovered]){border-color:var(--radio-hover-state-normal-validity-selected-value-border-color);background-color:var(--radio-hover-state-normal-validity-selected-value-background-color)}:host([selected]:hover) svg,:host([selected][hovered]) svg{fill:var(--radio-normal-state-normal-validity-selected-value-icon-color)}}:host([selected]:focus),:host([selected][focused]){border-color:var(--radio-focus-state-normal-validity-selected-value-border-color);background-color:var(--radio-focus-state-normal-validity-selected-value-background-color)}:host([selected]:focus) svg,:host([selected][focused]) svg{fill:var(--radio-focus-state-normal-validity-selected-value-icon-color)}:host([selected]:active),:host([selected][active]){border-color:var(--radio-pressed-state-normal-validity-selected-value-border-color);background-color:var(--radio-pressed-state-normal-validity-selected-value-background-color)}:host([selected]:active) svg,:host([selected][active]) svg{fill:var(--radio-pressed-state-normal-validity-selected-value-icon-color)}:host([invalid][selected]){border-color:var(--radio-normal-state-invalid-validity-selected-value-border-color);background-color:var(--radio-normal-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]) svg{fill:var(--radio-normal-state-invalid-validity-selected-value-icon-color)}@media (hover: hover){:host([invalid][selected]:hover),:host([invalid][selected][hovered]){border-color:var(--radio-hover-state-invalid-validity-selected-value-border-color);background-color:var(--radio-hover-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:hover) svg,:host([invalid][selected][hovered]) svg{fill:var(--radio-hover-state-invalid-validity-selected-value-icon-color)}}:host([invalid][selected]:focus),:host([invalid][selected][focused]){border-color:var(--radio-focus-state-invalid-validity-selected-value-border-color);background-color:var(--radio-focus-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:focus) svg,:host([invalid][selected][focused]) svg{fill:var(--radio-focus-state-invalid-validity-selected-value-icon-color)}:host([invalid][selected]:active),:host([invalid][selected][active]){border-color:var(--radio-pressed-state-invalid-validity-selected-value-border-color);background-color:var(--radio-pressed-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:active) svg,:host([invalid][selected][active]) svg{fill:var(--radio-pressed-state-invalid-validity-selected-value-icon-color)}:host([selected][disabled]),:host([selected][disabled][invalid]){border-color:var(--radio-disabled-state-normal-validity-selected-value-border-color);background-color:var(--radio-disabled-state-normal-validity-selected-value-background-color)}:host([selected][disabled]) svg,:host([selected][disabled][invalid]) svg{fill:var(--radio-disabled-state-normal-validity-selected-value-icon-color)}";
    }
}, [
    1,
    "market-radio",
    {
        selected: [
            1540
        ],
        disabled: [
            1540
        ],
        invalid: [
            516
        ],
        focused: [
            1540
        ],
        hovered: [
            1540
        ],
        active: [
            1540
        ],
        ariaAttributesHash: [
            32
        ],
        setSelection: [
            64
        ],
        setValue: [
            64
        ],
        setActive: [
            64
        ],
        setHover: [
            64
        ],
        setDisabled: [
            64
        ],
        setFocus: [
            64
        ]
    }
]), c$5 = s$7;
var z$2 = Object.prototype.hasOwnProperty;
function D$2(t2) {
    return r$h(t2) || o$l(t2) || e$i(t2);
}
const S$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketRowSelected = (0, $696Z8.createEvent)(this, "marketRowSelected", 7), this.marketRowDeselected = (0, $696Z8.createEvent)(this, "marketRowDeselected", 7), this.selected = false, this.disabled = false, this.size = "medium", this.interactive = false, this.transient = false, this.togglable = true, this.variant = "regular", this.destructive = false, this.controlPosition = "trailing", this.dragEnabled = false, this.dragHandlePosition = "trailing", this.hasSideText = false;
    }
    selectedWatcher(t2) {
        var e2;
        const o2 = (!t2 || !this.transient) && t2;
        this.selected = o2, null === (e2 = this.slottedControlEl) || void 0 === e2 || e2.setSelection(o2);
    }
    disabledWatcher(t2) {
        var e2;
        null === (e2 = this.slottedControlEl) || void 0 === e2 || e2.setDisabled(t2);
    }
    hrefWatcher(t2) {
        (function(t3) {
            if (null == t3) return true;
            if (f$4(t3) && (n$f(t3) || "string" == typeof t3 || "function" == typeof t3.splice || d$6(t3) || S$4(t3) || f$6(t3))) return !t3.length;
            var e2 = H$2(t3);
            if ("[object Map]" == e2 || "[object Set]" == e2) return !t3.size;
            if (b$3(t3)) return !D$4(t3).length;
            for(var o2 in t3)if (z$2.call(t3, o2)) return false;
            return true;
        })(t2) || (this.transient = true);
    }
    variantWatcher(t2) {
        "drill" === t2 && (this.interactive = true, this.transient = true);
    }
    async silentlySelect() {
        return this.selected = true, Promise.resolve();
    }
    async silentlyDeselect() {
        return this.selected = false, Promise.resolve();
    }
    select() {
        this.selected = true;
        const { defaultPrevented: t2 } = this.marketRowSelected.emit({
            value: this.value
        });
        return t2 && (this.selected = false), Promise.resolve();
    }
    deselect() {
        this.selected = false;
        const { defaultPrevented: t2 } = this.marketRowDeselected.emit({
            value: this.value
        });
        return t2 && (this.selected = true), Promise.resolve();
    }
    toggle() {
        return this.selected ? this.deselect() : this.select();
    }
    handleControlSlotChange() {
        var t2;
        if (this.querySlots(), this.slottedControlEl) {
            this.interactive = true, this.selectedWatcher(this.selected), this.disabledWatcher(this.disabled);
            const e2 = null === (t2 = this.el.querySelector('[slot="label"]')) || void 0 === t2 ? void 0 : t2.textContent;
            this.slottedControlEl.setAttribute("aria-label", e2);
        }
    }
    setControlActive(t2) {
        var e2, o2;
        null === (o2 = null === (e2 = this.slottedControlEl) || void 0 === e2 ? void 0 : e2.setActive) || void 0 === o2 || o2.call(e2, t2);
    }
    setControlHover(t2) {
        var e2, o2;
        null === (o2 = null === (e2 = this.slottedControlEl) || void 0 === e2 ? void 0 : e2.setHover) || void 0 === o2 || o2.call(e2, t2);
    }
    async handleClick(t2) {
        t2.target && (this.disabled || this.transient || !this.interactive || "A" === t2.target.tagName || "BUTTON" === t2.target.tagName || t2.target.tagName === l$s("market-button").toUpperCase() || t2.target.tagName === l$s("market-link").toUpperCase() || (this.togglable ? await this.toggle() : this.selected || await this.select(), "click" === t2.type && "mouse" === t2.pointerType && this.el.blur()));
    }
    handleKeydown(t2) {
        t2.target === this.el && (" " === t2.key && (t2.preventDefault(), this.el.click()), "Enter" === t2.key && this.el.click());
    }
    async onDragStart(t2) {
        t2.stopPropagation();
        const { el: e2, dragHandlePosition: o2 } = this, r2 = t2.detail, s2 = new c$e(e2, {
            anchor: "leading" === o2 ? "left" : "right"
        });
        this.drag = s2, await s2.start(r2);
    }
    onDragMove(t2) {
        t2.stopPropagation(), this.drag.move(t2.detail);
    }
    async onDragEnd(t2) {
        t2.stopPropagation();
        const e2 = t2.detail;
        await this.drag.end(e2), this.drag.destroy();
    }
    checkIfSideTextIsPresent() {
        const t2 = this.el.querySelector('[slot="side-label"], [slot="side-subtext"]');
        this.hasSideText = !!t2;
    }
    querySlots() {
        this.slottedControlEl = [
            ...this.el.querySelectorAll('[slot="control"]')
        ].find(D$2), this.checkIfSideTextIsPresent();
    }
    determineRowRole() {
        if (this.interactive && this.transient && !this.href) return "button";
    }
    connectedCallback() {
        this.querySlots(), this.selectedWatcher(this.selected), this.disabledWatcher(this.disabled), this.hrefWatcher(this.href), this.variantWatcher(this.variant);
    }
    componentWillLoad() {
        this.checkIfSideTextIsPresent();
    }
    async componentDidUpdate() {
        this.el.classList.contains("preload") && (await n$z(), this.el.classList.remove("preload"));
    }
    render() {
        const { controlPosition: t2, disabled: e2, href: o2, interactive: a2, selected: n2, slottedControlEl: v2, target: h2, variant: u2, hasSideText: b2, dragEnabled: m2, dragHandlePosition: p2, size: g2, el: w2 } = this, f2 = !a2 || e2 || v2 ? null : "0", x2 = void 0 === o2 ? "div" : "a", y2 = "a" === x2 ? {
            href: o2,
            target: h2
        } : {};
        y2.role = this.determineRowRole();
        const k2 = "leading" === t2, z2 = l$s("market-drag-handle"), D2 = l$s("market-icon"), S2 = "small" === g2 ? N$5 : M$7;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "11443cae1bfd82d20bf5fc2ee3fb077aacba240b",
            tabindex: f2,
            "aria-selected": "option" === w2.role ? "" + !!n2 : void 0,
            class: t$a("market-row", "preload", {
                "has-slotted-control": void 0 !== v2,
                "has-leading-control": k2
            }),
            onMouseDown: ()=>this.setControlActive(true),
            onMouseUp: ()=>this.setControlActive(false),
            onMouseEnter: ()=>this.setControlHover(true),
            onMouseLeave: ()=>this.setControlHover(false),
            onClick: (t3)=>this.handleClick(t3),
            onKeydown: (t3)=>this.handleKeydown(t3),
            onMarketDragHandleDragStart: (t3)=>this.onDragStart(t3),
            onMarketDragHandleDragMove: (t3)=>this.onDragMove(t3),
            onMarketDragHandleDragEnd: (t3)=>this.onDragEnd(t3)
        }, (0, $696Z8.h)(x2, Object.assign({
            key: "9307dd91b4ac9959fc384bc83319b675e16f5467",
            part: "container",
            class: "container",
            tabindex: f2
        }, y2), m2 && "leading" === p2 && (0, $696Z8.h)(z2, {
            key: "6cac4a404e4de0b76f4539183b5f731cded05517",
            part: "drag-handle"
        }), k2 && (0, $696Z8.h)("slot", {
            key: "33c3925409ace76c70f51cea083772ad7916cdc7",
            name: "control",
            onSlotchange: ()=>this.handleControlSlotChange()
        }), (0, $696Z8.h)("slot", {
            key: "5a1ca9bd33821a5dd18b316f92055d8b2fe93cde",
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            key: "b384796f1f868eb7977c9b1c906f82a2d82abdba",
            class: "main",
            part: "main"
        }, (0, $696Z8.h)("slot", {
            key: "42232347ce962d5adc26e9ce87d5e5b5432c05cc",
            name: "label"
        }), (0, $696Z8.h)("slot", {
            key: "89d5f2e5ca0bf5c1c48899b54d543785f2cfbf35",
            name: "subtext"
        }), (0, $696Z8.h)("slot", {
            key: "56712568739f73913283e8619937f06febd66ebe"
        })), (0, $696Z8.h)("div", {
            key: "891aad0abff83f654c084915b6353643ff5ce9bb",
            part: "side",
            class: t$a("side", {
                hidden: !b2
            })
        }, (0, $696Z8.h)("slot", {
            key: "9f69a964499bbaf125e0b03be06260c5d7b38ecc",
            name: "side-label",
            onSlotchange: ()=>this.checkIfSideTextIsPresent()
        }), (0, $696Z8.h)("slot", {
            key: "f6b59919a83cfe98cee113107777358f65db9cd3",
            name: "side-subtext",
            onSlotchange: ()=>this.checkIfSideTextIsPresent()
        })), (0, $696Z8.h)("slot", {
            key: "841fcc5813af63456195afff0039bc133f28a54f",
            name: "trailing-accessory"
        }), "regular" === u2 && !k2 && (0, $696Z8.h)("slot", {
            key: "0bacb003f4a99b81842c0d66e6d011e5cfb9ca45",
            name: "control",
            onSlotchange: ()=>this.handleControlSlotChange()
        }), "drill" === u2 && (0, $696Z8.h)(D2, {
            key: "a9db1af80d3ee059bd564ec943dff979ffef1d38",
            class: "drill-icon",
            name: S2
        }), m2 && "trailing" === p2 && (0, $696Z8.h)(z2, {
            key: "9fd56c950c79e57890180e09424595738178424d",
            part: "drag-handle"
        })));
    }
    static get delegatesFocus() {
        return true;
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            selected: [
                {
                    selectedWatcher: 0
                }
            ],
            disabled: [
                {
                    disabledWatcher: 0
                }
            ],
            href: [
                {
                    hrefWatcher: 0
                }
            ],
            variant: [
                {
                    variantWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--transition-duration:0.2s;--row-horizontal-spacing:16px;position:relative;display:block;margin:0 calc(-1 * var(--row-normal-variant-background-horizontal-outset-padding));background-color:var(--row-normal-variant-normal-state-background-color);transition:background-color var(--transition-duration)}:host::before{content:"";position:absolute;right:var(--row-normal-variant-background-horizontal-outset-padding);bottom:calc(-1 * var(--row-normal-variant-separator-height));left:var(--row-normal-variant-background-horizontal-outset-padding);display:block;height:var(--row-normal-variant-separator-height);background-color:var(--row-normal-variant-normal-state-separator-color)}:host(:last-of-type)::before{content:none}.container{display:flex;-moz-column-gap:var(--row-horizontal-spacing);column-gap:var(--row-horizontal-spacing);justify-content:space-between;align-items:center;height:100%;padding-right:var(--row-normal-variant-background-horizontal-outset-padding);padding-left:var(--row-normal-variant-background-horizontal-outset-padding);outline:none;text-decoration:none}.main{display:flex;flex-grow:2;flex-direction:column;min-width:0}.side{display:flex;flex-direction:column;text-align:right}.drill-icon{flex-shrink:0;fill:var(--row-normal-variant-normal-state-drill-color)}.hidden{display:none;}::slotted(*){cursor:inherit}::slotted([slot="label"]){display:block;margin:0;color:var(--row-normal-variant-normal-state-text-color)}::slotted([slot="subtext"]){display:block;margin:0;color:var(--row-normal-variant-normal-state-subtext-color)}::slotted([slot="side-label"]){display:block;margin:0;color:var(--row-normal-variant-normal-state-side-text-primary-color)}::slotted([slot="side-subtext"]){display:block;margin:0;color:var(--row-normal-variant-normal-state-side-text-secondary-color)}::slotted([slot="control"]),::slotted([slot="leading-accessory"]),::slotted([slot="trailing-accessory"]){flex-shrink:0}:host(.market-drag-placeholder)::before{content:"" !important;top:0;bottom:0;display:block !important;height:auto;background-color:var(--core-fill-50-color)}:host(.market-drag-placeholder) .market-drag-handle{pointer-events:none}:host(.market-drag-placeholder) *,:host(.market-drag-placeholder) ::slotted(*){opacity:0;pointer-events:none}:host(.market-drag-clone){--row-dragged-min-width:240px;width:-moz-fit-content;width:fit-content;min-width:var(--row-dragged-min-width);margin:0;border-radius:var(--row-normal-variant-background-radius);background-color:var(--core-surface-20-color);cursor:grabbing;transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:top, width, height}:host(.market-drag-clone)::after{content:"";position:absolute;inset:0;display:block;border-radius:var(--row-normal-variant-background-radius);box-shadow:var(--elevation-20-shadow);opacity:var(--market-drag-clone-shadow-opacity, 0);transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:opacity}:host(.market-drag-clone) .market-drag-handle{cursor:grabbing}:host(.market-drag-clone) ::slotted([slot="label"]){overflow:hidden;max-width:var(--row-dragged-min-width);text-overflow:ellipsis;white-space:nowrap}:host(.market-drag-clone) ::slotted(*:not([slot="label"],[slot="leading-accessory"])){display:none}:host(.market-drag-released){pointer-events:none;transition-property:top, width, height, transform}:host([size="small"]){min-height:var(--row-small-size-min-height, 40px);font-size:var(--row-small-size-text-size);line-height:var(--row-small-size-text-leading);letter-spacing:var(--row-small-size-text-tracking);text-transform:var(--row-small-size-text-case)}:host([size="small"]) .container{padding-top:var(--row-small-size-vertical-padding);padding-bottom:var(--row-small-size-vertical-padding)}:host([size="small"]) .main{gap:var(--row-small-size-text-vertical-spacing)}:host([size="small"]) .side{gap:var(--row-small-size-text-vertical-spacing)}:host([size="small"]) ::slotted([slot="label"]){font-weight:var(--row-small-size-text-weight);font-size:var(--row-small-size-text-size);line-height:var(--row-small-size-text-leading);letter-spacing:var(--row-small-size-text-tracking);text-transform:var(--row-small-size-text-case)}:host([size="small"]) ::slotted([slot="subtext"]){font-weight:var(--row-small-size-subtext-weight);font-size:var(--row-small-size-subtext-size);line-height:var(--row-small-size-subtext-leading);letter-spacing:var(--row-small-size-subtext-tracking);text-transform:var(--row-small-size-subtext-case)}:host([size="small"]) ::slotted([slot="side-label"]){font-weight:var(--row-small-size-side-text-primary-weight);font-size:var(--row-small-size-side-text-primary-size);line-height:var(--row-small-size-side-text-primary-leading);letter-spacing:var(--row-small-size-side-text-primary-tracking);text-transform:var(--row-small-size-side-text-primary-case)}:host([size="small"]) ::slotted([slot="side-subtext"]){font-weight:var(--row-small-size-side-text-secondary-weight);font-size:var(--row-small-size-side-text-secondary-size);line-height:var(--row-small-size-side-text-secondary-leading);letter-spacing:var(--row-small-size-side-text-secondary-tracking);text-transform:var(--row-small-size-side-text-secondary-case)}:host([size="medium"]){min-height:var(--row-medium-size-min-height, 56px);font-size:var(--row-medium-size-text-size);line-height:var(--row-medium-size-text-leading);letter-spacing:var(--row-medium-size-text-tracking);text-transform:var(--row-medium-size-text-case)}:host([size="medium"]) .container{padding-top:var(--row-medium-size-vertical-padding);padding-bottom:var(--row-medium-size-vertical-padding)}:host([size="medium"]) .main{gap:var(--row-medium-size-text-vertical-spacing)}:host([size="medium"]) .side{gap:var(--row-medium-size-text-vertical-spacing)}:host([size="medium"]) ::slotted([slot="label"]){font-weight:var(--row-medium-size-text-weight);font-size:var(--row-medium-size-text-size);line-height:var(--row-medium-size-text-leading);letter-spacing:var(--row-medium-size-text-tracking);text-transform:var(--row-medium-size-text-case)}:host([size="medium"]) ::slotted([slot="subtext"]){font-weight:var(--row-medium-size-subtext-weight);font-size:var(--row-medium-size-subtext-size);line-height:var(--row-medium-size-subtext-leading);letter-spacing:var(--row-medium-size-subtext-tracking);text-transform:var(--row-medium-size-subtext-case)}:host([size="medium"]) ::slotted([slot="side-label"]){font-weight:var(--row-medium-size-side-text-primary-weight);font-size:var(--row-medium-size-side-text-primary-size);line-height:var(--row-medium-size-side-text-primary-leading);letter-spacing:var(--row-medium-size-side-text-primary-tracking);text-transform:var(--row-medium-size-side-text-primary-case)}:host([size="medium"]) ::slotted([slot="side-subtext"]){font-weight:var(--row-medium-size-side-text-secondary-weight);font-size:var(--row-medium-size-side-text-secondary-size);line-height:var(--row-medium-size-side-text-secondary-leading);letter-spacing:var(--row-medium-size-side-text-secondary-tracking);text-transform:var(--row-medium-size-side-text-secondary-case)}:host([interactive]),:host([role="option"]){--focus-ring-color:color-mix(in srgb, var(--row-normal-variant-focus-ring-color) 100%, transparent);border-radius:var(--row-normal-variant-background-radius);outline:none;cursor:pointer}:host([interactive]) .drill-icon,:host([role="option"]) .drill-icon{color:var(--row-normal-variant-normal-state-drill-color)}.container:focus-visible,:host(:focus-visible) .container,:host(.pseudo-focus) .container{border-radius:var(--row-normal-variant-background-radius);outline:var(--row-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--row-focus-ring-buffer-size)}:host(.pseudo-focus){z-index:2}:host(.preload) ::slotted([slot="control"]){--row-slotted-control-transition:none}@media (hover: hover){:host([interactive]:not([destructive]):hover),:host([role="option"]:not([destructive]):hover){background-color:var(--row-normal-variant-hover-state-background-color)}:host([interactive]:not([destructive]):hover)::before,:host([role="option"]:not([destructive]):hover)::before{background-color:var(--row-normal-variant-hover-state-separator-color)}:host([interactive]:not([destructive]):hover) .drill-icon,:host([role="option"]:not([destructive]):hover) .drill-icon{color:var(--row-normal-variant-hover-state-drill-color)}:host([interactive]:not([destructive]):hover) ::slotted([slot="label"]),:host([role="option"]:not([destructive]):hover) ::slotted([slot="label"]){color:var(--row-normal-variant-hover-state-text-color)}:host([interactive]:not([destructive]):hover) ::slotted([slot="subtext"]),:host([role="option"]:not([destructive]):hover) ::slotted([slot="subtext"]){color:var(--row-normal-variant-hover-state-subtext-color)}:host([interactive]:not([destructive]):hover) ::slotted([slot="side-label"]),:host([role="option"]:not([destructive]):hover) ::slotted([slot="side-label"]){color:var(--row-normal-variant-hover-state-side-text-primary-color)}:host([interactive]:not([destructive]):hover) ::slotted([slot="side-subtext"]),:host([role="option"]:not([destructive]):hover) ::slotted([slot="side-subtext"]){color:var(--row-normal-variant-hover-state-side-text-secondary-color)}}:host([interactive][selected]:not(.has-slotted-control)),:host([role="option"][selected]:not(.has-slotted-control)){background-color:var(--row-normal-variant-selected-state-background-color)}:host([interactive][selected]:not(.has-slotted-control))::before,:host([role="option"][selected]:not(.has-slotted-control))::before{background-color:var(--row-normal-variant-selected-state-separator-color)}:host([interactive][selected]:not(.has-slotted-control)) .drill-icon,:host([role="option"][selected]:not(.has-slotted-control)) .drill-icon{color:var(--row-normal-variant-selected-state-drill-color)}:host([interactive][selected]:not(.has-slotted-control)) ::slotted([slot="label"]),:host([role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="label"]){color:var(--row-normal-variant-selected-state-text-color)}:host([interactive][selected]:not(.has-slotted-control)) ::slotted([slot="subtext"]),:host([role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="subtext"]){color:var(--row-normal-variant-selected-state-subtext-color)}:host([interactive][selected]:not(.has-slotted-control)) ::slotted([slot="side-label"]),:host([role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="side-label"]){color:var(--row-normal-variant-selected-state-side-text-primary-color)}:host([interactive][selected]:not(.has-slotted-control)) ::slotted([slot="side-subtext"]),:host([role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="side-subtext"]){color:var(--row-normal-variant-selected-state-side-text-secondary-color)}:host([interactive]:active:not([disabled])),:host([role="option"]:active:not([disabled])){background-color:var(--row-normal-variant-pressed-state-background-color)}:host([interactive]:active:not([disabled]))::before,:host([role="option"]:active:not([disabled]))::before{background-color:var(--row-normal-variant-pressed-state-separator-color)}:host([interactive]:active:not([disabled])) .drill-icon,:host([role="option"]:active:not([disabled])) .drill-icon{color:var(--row-normal-variant-pressed-state-drill-color)}:host([interactive]:active:not([disabled])) ::slotted([slot="label"]),:host([role="option"]:active:not([disabled])) ::slotted([slot="label"]){color:var(--row-normal-variant-pressed-state-text-color)}:host([interactive]:active:not([disabled])) ::slotted([slot="subtext"]),:host([role="option"]:active:not([disabled])) ::slotted([slot="subtext"]){color:var(--row-normal-variant-pressed-state-subtext-color)}:host([interactive]:active:not([disabled])) ::slotted([slot="side-label"]),:host([role="option"]:active:not([disabled])) ::slotted([slot="side-label"]){color:var(--row-normal-variant-pressed-state-side-text-primary-color)}:host([interactive]:active:not([disabled])) ::slotted([slot="side-subtext"]),:host([role="option"]:active:not([disabled])) ::slotted([slot="side-subtext"]){color:var(--row-normal-variant-pressed-state-side-text-secondary-color)}:host([interactive][disabled]),:host([role="option"][disabled]){background-color:var(--row-normal-variant-disabled-state-background-color);color:var(--row-normal-variant-disabled-state-text-color);pointer-events:none}:host([interactive][disabled])::before,:host([role="option"][disabled])::before{background-color:var(--row-normal-variant-disabled-state-separator-color)}:host([interactive][disabled]) .drill-icon,:host([role="option"][disabled]) .drill-icon{color:var(--row-normal-variant-disabled-state-drill-color)}:host([interactive][disabled]) ::slotted([slot="label"]),:host([role="option"][disabled]) ::slotted([slot="label"]){color:var(--row-normal-variant-disabled-state-text-color)}:host([interactive][disabled]) ::slotted([slot="subtext"]),:host([role="option"][disabled]) ::slotted([slot="subtext"]){color:var(--row-normal-variant-disabled-state-subtext-color)}:host([interactive][disabled]) ::slotted([slot="side-label"]),:host([role="option"][disabled]) ::slotted([slot="side-label"]){color:var(--row-normal-variant-disabled-state-side-text-primary-color)}:host([interactive][disabled]) ::slotted([slot="side-subtext"]),:host([role="option"][disabled]) ::slotted([slot="side-subtext"]){color:var(--row-normal-variant-disabled-state-side-text-secondary-color)}:host([interactive][disabled]) ::slotted(.market-accessory),:host([interactive][disabled]) ::slotted(img[slot*="accessory"]),:host([interactive][disabled]) ::slotted(svg[slot*="accessory"]),:host([interactive][disabled]) ::slotted(div[slot*="accessory"]),:host([role="option"][disabled]) ::slotted(.market-accessory),:host([role="option"][disabled]) ::slotted(img[slot*="accessory"]),:host([role="option"][disabled]) ::slotted(svg[slot*="accessory"]),:host([role="option"][disabled]) ::slotted(div[slot*="accessory"]){opacity:var(--row-disabled-state-leading-accessory-opacity)}:host([interactive][disabled]) ::slotted(.market-tooltip),:host([role="option"][disabled]) ::slotted(.market-tooltip){pointer-events:auto !important;}:host([slot="displayed-selection"]){pointer-events:none}:host([slot="displayed-selection"]) .container{padding:0}:host([slot="displayed-selection"]) .main{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host([slot="displayed-selection"]) ::slotted([slot="label"]){overflow:hidden;color:inherit;font-weight:var(--field-input-weight);font-size:inherit;line-height:inherit;text-overflow:ellipsis;white-space:nowrap}:host([slot="displayed-selection"]) .side{display:none}:host([slot="displayed-selection"]) ::slotted([slot="subtext"]),:host([slot="displayed-selection"]) ::slotted([slot="side-label"]),:host([slot="displayed-selection"]) ::slotted([slot="side-subtext"]),:host([slot="displayed-selection"]) ::slotted([slot="leading-accessory"]),:host([slot="displayed-selection"]) ::slotted([slot="trailing-accessory"]),:host([slot="displayed-selection"]) ::slotted([slot="control"]){display:none}:host([destructive]) ::slotted([slot="label"]){color:var(--row-destructive-variant-normal-state-text-color)}:host([destructive]) ::slotted([slot="subtext"]){color:var(--row-destructive-variant-normal-state-subtext-color)}:host([destructive]) ::slotted([slot="side-label"]){color:var(--row-destructive-variant-normal-state-side-text-primary-color)}:host([destructive]) ::slotted([slot="side-subtext"]){color:var(--row-destructive-variant-normal-state-side-text-secondary-color)}:host([destructive][role="option"]){border-radius:var(--row-destructive-variant-background-radius)}@media (hover: hover){:host([destructive][interactive]:hover),:host([destructive][role="option"]:hover){background-color:var(--row-destructive-variant-hover-state-background-color)}:host([destructive][interactive]:hover)::before,:host([destructive][role="option"]:hover)::before{background-color:var(--row-destructive-variant-hover-state-separator-color)}:host([destructive][interactive]:hover) .drill-icon,:host([destructive][role="option"]:hover) .drill-icon{fill:var(--row-destructive-variant-hover-state-drill-color)}:host([destructive][interactive]:hover) ::slotted([slot="label"]),:host([destructive][role="option"]:hover) ::slotted([slot="label"]){color:var(--row-destructive-variant-hover-state-text-color)}:host([destructive][interactive]:hover) ::slotted([slot="subtext"]),:host([destructive][role="option"]:hover) ::slotted([slot="subtext"]){color:var(--row-destructive-variant-hover-state-subtext-color)}:host([destructive][interactive]:hover) ::slotted([slot="side-label"]),:host([destructive][role="option"]:hover) ::slotted([slot="side-label"]){color:var(--row-destructive-variant-hover-state-side-text-primary-color)}:host([destructive][interactive]:hover) ::slotted([slot="side-subtext"]),:host([destructive][role="option"]:hover) ::slotted([slot="side-subtext"]){color:var(--row-destructive-variant-hover-state-side-text-secondary-color)}}:host([destructive][role="option"]:focus){background-color:var(--row-destructive-variant-focus-state-background-color)}:host([destructive][role="option"]:focus)::before{background-color:var(--row-destructive-variant-focus-state-separator-color)}:host([destructive][role="option"]:focus) .drill-icon{fill:var(--row-destructive-variant-focus-state-drill-color)}:host([destructive][role="option"]:focus) ::slotted([slot="label"]){color:var(--row-destructive-variant-focus-state-text-color)}:host([destructive][role="option"]:focus) ::slotted([slot="subtext"]){color:var(--row-destructive-variant-focus-state-subtext-color)}:host([destructive][role="option"]:focus) ::slotted([slot="side-label"]){color:var(--row-destructive-variant-focus-state-side-text-primary-color)}:host([destructive][role="option"]:focus) ::slotted([slot="side-subtext"]){color:var(--row-destructive-variant-focus-state-side-text-secondary-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control)){background-color:var(--row-destructive-variant-selected-state-background-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control))::before{background-color:var(--row-destructive-variant-selected-state-separator-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control)) .drill-icon{fill:var(--row-destructive-variant-selected-state-drill-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="label"]){color:var(--row-destructive-variant-selected-state-text-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="subtext"]){color:var(--row-destructive-variant-selected-state-subtext-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="side-label"]){color:var(--row-destructive-variant-selected-state-side-text-primary-color)}:host([destructive][role="option"][selected]:not(.has-slotted-control)) ::slotted([slot="side-subtext"]){color:var(--row-destructive-variant-selected-state-side-text-secondary-color)}:host([destructive][role="option"]:active){background-color:var(--row-destructive-variant-pressed-state-background-color)}:host([destructive][role="option"]:active)::before{background-color:var(--row-destructive-variant-pressed-state-separator-color)}:host([destructive][role="option"]:active) .drill-icon{fill:var(--row-destructive-variant-pressed-state-drill-color)}:host([destructive][role="option"]:active) ::slotted([slot="label"]){color:var(--row-destructive-variant-pressed-state-text-color)}:host([destructive][role="option"]:active) ::slotted([slot="subtext"]){color:var(--row-destructive-variant-pressed-state-subtext-color)}:host([destructive][role="option"]:active) ::slotted([slot="side-label"]){color:var(--row-destructive-variant-pressed-state-side-text-primary-color)}:host([destructive][role="option"]:active) ::slotted([slot="side-subtext"]){color:var(--row-destructive-variant-pressed-state-side-text-secondary-color)}:host([destructive][role="option"][disabled]){background-color:var(--row-destructive-variant-disabled-state-background-color);color:var(--row-destructive-variant-disabled-state-text-color);pointer-events:none}:host([destructive][role="option"][disabled])::before{background-color:var(--row-destructive-variant-disabled-state-separator-color)}:host([destructive][role="option"][disabled]) .drill-icon{fill:var(--row-destructive-variant-disabled-state-drill-color)}:host([destructive][role="option"][disabled]) ::slotted([slot="label"]){color:var(--row-destructive-variant-disabled-state-text-color)}:host([destructive][role="option"][disabled]) ::slotted([slot="subtext"]){color:var(--row-destructive-variant-disabled-state-subtext-color)}:host([destructive][role="option"][disabled]) ::slotted([slot="side-label"]){color:var(--row-destructive-variant-disabled-state-side-text-primary-color)}:host([destructive][role="option"][disabled]) ::slotted([slot="side-subtext"]){color:var(--row-destructive-variant-disabled-state-side-text-secondary-color)}';
    }
}, [
    273,
    "market-row",
    {
        selected: [
            1540
        ],
        value: [
            513
        ],
        disabled: [
            516
        ],
        size: [
            513
        ],
        interactive: [
            1540
        ],
        transient: [
            1540
        ],
        togglable: [
            4
        ],
        variant: [
            1
        ],
        destructive: [
            516
        ],
        controlPosition: [
            1,
            "control-position"
        ],
        href: [
            1
        ],
        target: [
            1
        ],
        dragEnabled: [
            516,
            "drag-enabled"
        ],
        dragHandlePosition: [
            513,
            "drag-handle-position"
        ],
        slottedControlEl: [
            32
        ],
        hasSideText: [
            32
        ],
        silentlySelect: [
            64
        ],
        silentlyDeselect: [
            64
        ],
        select: [
            64
        ],
        deselect: [
            64
        ],
        toggle: [
            64
        ]
    },
    void 0,
    {
        selected: [
            {
                selectedWatcher: 0
            }
        ],
        disabled: [
            {
                disabledWatcher: 0
            }
        ],
        href: [
            {
                hrefWatcher: 0
            }
        ],
        variant: [
            {
                variantWatcher: 0
            }
        ]
    }
]), j$1 = S$1;
const n$a = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketSegmentSelectedChanged = (0, $696Z8.createEvent)(this, "marketSegmentSelectedChanged", 7), this.disabled = false, this.selected = false, this.handleKeyDown = (e3)=>{
            " " !== e3.key && "Enter" !== e3.key || (e3.preventDefault(), this.selectSegment());
        };
    }
    setSelectedState(e2) {
        return this.selected = e2, Promise.resolve();
    }
    selectSegment() {
        return this.selected || this.disabled || this.marketSegmentSelectedChanged.emit(), Promise.resolve();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "35123c073ef89940a5f24e235f2d5037276a5d89",
            selected: this.selected,
            class: "market-segment",
            onClick: ()=>this.selectSegment(),
            onKeyDown: this.handleKeyDown,
            tabindex: this.disabled ? "-1" : "0"
        }, (0, $696Z8.h)("slot", {
            key: "21c0fbc02e746f1c29aec37877fab0ae5242852e"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--segmented-control-option-min-width:var(--core-small-size-minimum-height);display:flex;flex-direction:row;justify-content:center;align-items:center;min-width:var(--segmented-control-option-min-width);padding:var(--segmented-control-option-vertical-padding) var(--segmented-control-option-horizontal-padding);border-radius:var(--segmented-control-option-radius);color:var(--segmented-control-option-unselected-value-normal-state-label-color);font-weight:var(--segmented-control-option-label-weight);font-size:var(--segmented-control-option-label-size);line-height:var(--segmented-control-option-label-leading);letter-spacing:var(--segmented-control-option-label-tracking);text-align:center;cursor:pointer;transition:color var(--segmented-control-animation-duration)}:host(:hover){color:var(--segmented-control-option-unselected-value-hover-state-label-color)}:host(:active){color:var(--segmented-control-option-unselected-value-pressed-state-label-color)}:host([disabled]){background:var(--segmented-control-option-unselected-value-disabled-state-background-color);color:var(--segmented-control-option-unselected-value-disabled-state-label-color);cursor:not-allowed}:host([selected]){color:var(--segmented-control-option-selected-value-normal-state-label-color)}:host([selected]:hover){color:var(--segmented-control-option-selected-value-hover-state-label-color)}:host([selected]:active){color:var(--segmented-control-option-selected-value-pressed-state-label-color)}:host([selected][disabled]){color:var(--segmented-control-option-selected-value-disabled-state-label-color)}";
    }
}, [
    257,
    "market-segment",
    {
        disabled: [
            516
        ],
        value: [
            513
        ],
        selected: [
            32
        ],
        setSelectedState: [
            64
        ],
        selectSegment: [
            64
        ]
    }
]), i$3 = n$a;
const a$5 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketSegmentedSelectionDidChange = (0, $696Z8.createEvent)(this, "marketSegmentedSelectionDidChange", 7), this.value = "", this.disabled = false;
    }
    valueWatcher() {
        this.setSelectionsFromValue();
    }
    disabledChangeHandler() {
        var e2;
        null === (e2 = this.items) || void 0 === e2 || e2.forEach((e3)=>e3.disabled = this.disabled);
    }
    setSelectionsFromValue() {
        var e2;
        null === (e2 = this.items) || void 0 === e2 || e2.forEach((e3)=>{
            this.value === e3.value ? (e3.setSelectedState(true), this.setSliderPosition(e3)) : e3.setSelectedState(false);
        });
    }
    setInternalState() {
        this.items = this.el.querySelectorAll("" + l$s("market-segment")), this.selectedSlider = this.el.shadowRoot.getElementById("selected-slider"), this.items.length > 0 && (function(e2) {
            return "" === e2 || " " === e2 || null == e2;
        }(this.value) && (this.value = this.items[0].value), this.setSelectionsFromValue());
    }
    setSliderSize() {
        var e2;
        this.el.style.setProperty("--selected-slider-width", `calc(${100 / (null === (e2 = this.items) || void 0 === e2 ? void 0 : e2.length)}% - ${2 * O$8}px)`);
    }
    setSliderPosition(e2) {
        if (!e2) return void this.el.style.setProperty("--selected-slider-left", O$8 + "px");
        const t2 = [
            ...this.items
        ].indexOf(e2);
        this.el.style.setProperty("--selected-slider-left", `calc(${t2 / this.items.length * 100}% + ${O$8}px)`);
    }
    defaultSlotchangeHandler() {
        this.setInternalState(), this.setSliderSize();
    }
    marketSegmentSelectedEventHandler(e2) {
        const t2 = e2.target, s2 = this.el.querySelector(l$s("market-segment") + "[selected]");
        null == s2 || s2.setSelectedState(false), t2.setSelectedState(true), this.setSliderPosition(t2), this.marketSegmentedSelectionDidChange.emit({
            selectedSegment: t2,
            selectedSegmentValue: t2.value,
            deselectedSegment: s2,
            deselectedSegmentValue: null == s2 ? void 0 : s2.value
        });
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "af04a6adbc3ccd8d66e9e718cf6292fbaaf9624a",
            class: "market-segmented-control"
        }, (0, $696Z8.h)("slot", {
            key: "9857d03c0a244074868122c4a97ce30abae734d3",
            onSlotchange: ()=>this.defaultSlotchangeHandler()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    valueWatcher: 0
                }
            ],
            disabled: [
                {
                    disabledChangeHandler: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;display:inline-flex;flex-direction:row;gap:calc(var(--segmented-control-horizontal-padding) * 2);align-items:center;min-width:100%;padding:var(--segmented-control-vertical-padding) var(--segmented-control-horizontal-padding);border-radius:var(--segmented-control-radius);background:var(--segmented-control-normal-state-background-color)}:host([disabled]){background:var(--segmented-control-disabled-state-background-color)}::slotted(.market-segment){z-index:2;width:100%;height:100%}:host::before{content:"";position:absolute;left:var(--selected-slider-left);z-index:1;width:var(--selected-slider-width);height:calc(100% - var(--segmented-control-vertical-padding) * 2);border-radius:var(--segmented-control-option-radius);background:var(--segmented-control-option-selected-value-normal-state-background-color);box-shadow:var(--elevation-10-shadow);transition:left var(--segmented-control-animation-duration)}';
    }
}, [
    257,
    "market-segmented-control",
    {
        value: [
            1537
        ],
        disabled: [
            516
        ],
        items: [
            32
        ]
    },
    [
        [
            0,
            "marketSegmentSelectedChanged",
            "marketSegmentSelectedEventHandler"
        ]
    ],
    {
        value: [
            {
                valueWatcher: 0
            }
        ],
        disabled: [
            {
                disabledChangeHandler: 0
            }
        ]
    }
]), d$1 = a$5;
const y$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketSelectValueDidChange = (0, $696Z8.createEvent)(this, "marketSelectValueDidChange", 7), this.marketSelectOpened = (0, $696Z8.createEvent)(this, "marketSelectOpened", 7), this.marketSelectClosed = (0, $696Z8.createEvent)(this, "marketSelectClosed", 7), this.value = "", this.size = "large", this.readonly = false, this.disabled = false, this.focused = false, this.invalid = false, this.required = false, this.multiselect = false, this.popoverStrategy = "absolute", this.listIsActive = false, this.focusedRowIndex = -1, this.isKeyboardNavigating = false, this.hasLeadingAccessory = false, this.hasTrailingAccessory = false, this.rowsText = [], this.keypresses = [], this.debounceDelay = 250, this.setFocusOnMatch = /* @__PURE__ */ ((e3, t2)=>{
            let s2;
            return (...i2)=>{
                clearTimeout(s2), s2 = setTimeout(()=>{
                    s2 = void 0, e3.apply(void 0, i2);
                }, t2);
            };
        })(()=>{
            const e3 = this.keypresses.join("");
            this.isKeyboardNavigating = true;
            const t2 = [
                ...this.rowsText.slice(this.focusedRowIndex + 1),
                ...this.rowsText.slice(0, this.focusedRowIndex + 1)
            ].find((t3)=>t3.startsWith(e3)), s2 = this.rowsText.findIndex((e4)=>e4.startsWith(t2)), i2 = this.rows[s2];
            i2 && !i2.disabled && (this.focusedRowIndex = s2, this.listIsActive || this.multiselect || (this.value = i2.value, this.marketSelectValueDidChange.emit({
                value: this.value,
                newSelectedOption: i2,
                newDeselectedOption: null,
                currentSelectedOptions: [
                    i2
                ]
            }))), this.keypresses = [];
        }, this.debounceDelay), this.list = null, this.rows = null, this.popoverElement = null, this.hasInitialized = false, this.listObserver = null, this.boundHandleListSelection = this.handleListSelection.bind(this), this.boundHandleListItemsFiltered = this.handleListItemsFiltered.bind(this), this.boundHandleListKeyDown = this.handleListKeyDown.bind(this), this.boundHandleListClick = this.handleListClick.bind(this);
    }
    valueWatcher() {
        this.propagateValue();
    }
    multiselectWatcher() {
        this.list.multiselect = this.multiselect;
    }
    focusedRowIndexWatcher() {
        var e2;
        if (this.rows) {
            const t2 = this.rows[this.focusedRowIndex];
            this.rows.forEach((e3)=>e3.classList.remove("pseudo-focus")), t2 && this.isKeyboardNavigating && (null === (e2 = this.rows[this.focusedRowIndex]) || void 0 === e2 || e2.classList.add("pseudo-focus"), this.ensureRowVisibility(t2));
        }
    }
    ensureRowVisibility(e2) {
        if (!this.popoverElement || !e2) return;
        const t2 = e2.getBoundingClientRect(), s2 = this.popoverElement.getBoundingClientRect(), i2 = K$3 + 2 * L$5;
        t2.top < s2.top + i2 ? this.popoverElement.scrollTop -= s2.top + i2 - t2.top : t2.bottom > s2.bottom - i2 && (this.popoverElement.scrollTop += t2.bottom - (s2.bottom - i2));
    }
    handleListSelection({ detail: { currentSelectionValues: e2, currentSelections: t2, newDeselection: s2, newSelection: i2 } }) {
        const o2 = e2.join(",");
        this.value = o2, this.setFocusedRow(this.multiselect && s2 || i2), this.marketSelectValueDidChange.emit({
            value: o2,
            newSelectedOption: i2,
            newDeselectedOption: s2,
            currentSelectedOptions: t2
        });
    }
    handleListItemsFiltered() {
        window.requestAnimationFrame(()=>{
            this.listIsActive && this.updatePopper();
        });
    }
    windowClick(e2) {
        var t2;
        this.el.contains(e2.target) || (null === (t2 = this.popoverElement) || void 0 === t2 ? void 0 : t2.contains(e2.target)) || (this.focused = false, this.listIsActive && this.closeList());
    }
    getValues() {
        return Array.isArray(this.value) ? new Set(this.value) : new Set(this.multiselect ? this.value.split(",") : [
            this.value
        ]);
    }
    getValuesCount() {
        return this.getValues().size;
    }
    getMatchingRows() {
        if (null === this.rows) return [];
        {
            const e2 = this.getValues();
            return [
                ...this.rows
            ].filter((t2)=>e2.has(t2.value));
        }
    }
    get hasMultipleSelections() {
        return this.multiselect && this.getValues().size > 1;
    }
    getMultiselectDisplayValue() {
        const e2 = this.getValues();
        return e2.size > 1 ? e2.size + " selected" : "";
    }
    getDisplayedSelectionRow() {
        return this.el.querySelector(l$s("market-row") + '[slot="displayed-selection"]');
    }
    propagateValue() {
        if (!this.list || !this.rows) return;
        const e2 = this.getMatchingRows();
        0 === e2.length ? (this.list.value = this.value = "", this.focusedRowIndex = -1) : (this.list.value = this.value, this.setFocusedRow(e2[0])), this.displaySelection(e2);
    }
    displaySelection(e2 = []) {
        var t2, s2, i2;
        if (null === (s2 = null === (t2 = this.getDisplayedSelectionRow()) || void 0 === t2 ? void 0 : t2.remove) || void 0 === s2 || s2.call(t2), 1 === e2.length) {
            const t3 = e2[0].cloneNode(true);
            t3.interactive = false, t3.removeAttribute("tabindex"), t3.removeAttribute("role"), t3.removeAttribute("id"), t3.querySelectorAll("[id]").forEach((e3)=>e3.removeAttribute("id")), t3.classList.remove("pseudo-focus"), t3.setAttribute("slot", "displayed-selection"), t3.size = "small" === this.size ? "small" : "medium", this.el.append(t3);
        } else if (e2.length > 1) {
            const e3 = document.createElement("" + l$s("market-row"));
            e3.setAttribute("slot", "displayed-selection"), e3.innerText = this.getValuesCount().toLocaleString() + " ", e3.size = "small" === this.size ? "small" : "medium";
            const t3 = document.createElement("slot");
            t3.setAttribute("name", "selected-translation");
            const s3 = this.el.querySelector('[slot="selected-translation"]');
            t3.innerHTML = null !== (i2 = null == s3 ? void 0 : s3.innerHTML) && void 0 !== i2 ? i2 : "selected", e3.appendChild(t3), s3 && new MutationObserver(()=>{
                t3.innerHTML = null == s3 ? void 0 : s3.innerHTML;
            }).observe(s3, {
                characterData: true,
                subtree: true
            }), this.el.append(e3);
        }
    }
    initListObserver() {
        var e2;
        null === (e2 = this.listObserver) || void 0 === e2 || e2.disconnect(), this.listObserver = new MutationObserver(this.onListChange.bind(this)), this.listObserver.observe(this.list, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    onListChange() {
        this.initRows(), this.propagateValue(), this.updatePopper();
    }
    setFocusedRow(e2) {
        this.focusedRowIndex = Array.prototype.indexOf.call(this.rows, e2);
    }
    async openList() {
        var e2;
        if (this.listIsActive || !this.popoverElement) return Promise.resolve();
        this.isKeyboardNavigating = false, null === (e2 = this.rows) || void 0 === e2 || e2.forEach((e3)=>e3.classList.remove("pseudo-focus"));
        const t2 = this.el.closest(this.popoverContainer) || document.body;
        return Object.assign(this.popoverElement.style, {
            zIndex: "" + (r$7(t2) + 1),
            visibility: "hidden"
        }), this.moveListToPopover(), t2.append(this.popoverElement), this.initPopperListeners(), new Promise((e3)=>{
            setTimeout(()=>{
                this.updatePopper(), this.popoverElement.style.visibility = "visible", this.listIsActive = true, this.marketSelectOpened.emit(), e3();
            }, 50);
        });
    }
    closeList() {
        var e2, t2;
        return this.listIsActive ? (null === (e2 = this.popoverElement) || void 0 === e2 || e2.remove(), null === (t2 = this.cleanupPopperListeners) || void 0 === t2 || t2.call(this), this.moveListToSelect(), this.listIsActive = false, this.marketSelectClosed.emit(), Promise.resolve()) : Promise.resolve();
    }
    async toggleList() {
        this.listIsActive ? await this.closeList() : await this.openList();
    }
    handleTriggerKeyDown(e2) {
        switch(e2.key){
            case "ArrowDown":
                this.handleArrowKey(e2, 1);
                break;
            case "ArrowUp":
                this.handleArrowKey(e2, -1);
                break;
            case " ":
                this.handleSpacebar(e2);
                break;
            case "Enter":
                this.handleEnterKey();
                break;
            case "Escape":
                this.handleEscape();
                break;
            case "Tab":
                this.handleTab(e2);
                break;
            case "Home":
                this.handleHomeKey(e2);
                break;
            case "End":
                this.handleEndKey(e2);
                break;
            default:
                this.typeaheadHandler(e2);
        }
        e2.stopPropagation();
    }
    async handleArrowKey(e2, t2) {
        if (e2.preventDefault(), this.isKeyboardNavigating = true, this.listIsActive) {
            for(let e3 = this.focusedRowIndex + t2; e3 >= 0 && e3 < this.rows.length; e3 += t2)if (!this.rows[e3].disabled) {
                this.focusedRowIndex = e3;
                break;
            }
        } else await this.openList();
    }
    async handleSpacebar(e2) {
        var t2;
        e2.preventDefault(), this.listIsActive ? null === (t2 = this.rows[this.focusedRowIndex]) || void 0 === t2 || t2.toggle() : await this.openList();
    }
    handleEnterKey() {
        var e2;
        this.listIsActive ? (null === (e2 = this.rows[this.focusedRowIndex]) || void 0 === e2 || e2.select(), this.closeList()) : t(this.el);
    }
    handleEscape() {
        this.listIsActive && this.closeList();
    }
    handleTab(e2) {
        this.listIsActive ? e2.preventDefault() : this.focused = false;
    }
    handleHomeKey(e2) {
        this.listIsActive && (e2.preventDefault(), this.isKeyboardNavigating = true, this.focusedRowIndex = 0);
    }
    handleEndKey(e2) {
        this.listIsActive && (e2.preventDefault(), this.isKeyboardNavigating = true, this.focusedRowIndex = this.rows.length - 1);
    }
    handleListKeyDown(e2) {
        switch(e2.key){
            case "Enter":
                this.handleListEnter();
                break;
            case "Escape":
                this.handleEscape();
                break;
            case "Tab":
                this.handleTab(e2);
                break;
            case " ":
                this.handleListSpacebar(e2);
                break;
            default:
                this.typeaheadHandler(e2);
        }
        e2.stopPropagation();
    }
    handleListSpacebar(e2) {
        this.multiselect || e2.target.hasAttribute("slot", "search") || (e2.preventDefault(), this.closeList(), this.el.focus());
    }
    handleListEnter() {
        this.multiselect || (this.closeList(), this.el.focus());
    }
    typeaheadHandler(e2) {
        var t2;
        (null === (t2 = this.list) || void 0 === t2 ? void 0 : t2.hasAttribute("has-search")) || e2.key.length > 1 || e2.key.toUpperCase() === e2.key.toLowerCase() || (this.storeKeypresses(e2), this.setFocusOnMatch());
    }
    storeKeypresses(e2) {
        this.keypresses = [
            ...this.keypresses,
            e2.key
        ];
    }
    handleFocus() {
        this.readonly || this.disabled || (this.focused = true);
    }
    handleTriggerClick(e2) {
        e2.target.tagName.toLowerCase() !== l$s("market-tooltip") && (this.readonly || this.disabled || this.toggleList());
    }
    handleListClick() {
        this.multiselect || (this.closeList(), this.el.focus());
    }
    initPopperListeners() {
        const { el: e2, popoverElement: t2, updatePopper: s2 } = this;
        this.cleanupPopperListeners = vt$1(e2, t2, s2.bind(this));
    }
    updatePopper() {
        const { el: e2, popoverElement: t2, popoverStrategy: s2 } = this;
        Ft$1(e2, t2, {
            strategy: s2,
            middleware: [
                xt$1(8),
                bt$1({
                    allowedPlacements: [
                        "top",
                        "bottom"
                    ]
                }),
                Rt$1({
                    apply ({ rects: e3, availableHeight: s3 }) {
                        Object.assign(t2.style, {
                            width: e3.reference.width + "px",
                            maxHeight: Math.min(s3 - 8, 464) + "px"
                        });
                    }
                }),
                At$1({
                    padding: 8
                })
            ]
        }).then(({ x: e3, y: s3 })=>{
            Object.assign(t2.style, {
                left: e3 + "px",
                top: s3 + "px"
            });
        });
    }
    initPopover() {
        this.popoverElement = this.popoverElement || document.createElement(l$s("market-popover")), this.popoverElement.id = this.popoverId, this.popoverElement.style.position = this.popoverStrategy;
    }
    initList() {
        this.list = this.el.querySelector('[slot="list"]'), this.list.interactive = true, this.list.multiselect = this.multiselect, this.list.addEventListener("marketListSelectionsDidChange", this.boundHandleListSelection), this.list.addEventListener("marketListItemsFiltered", this.boundHandleListItemsFiltered), this.list.addEventListener("keydown", this.boundHandleListKeyDown), this.list.addEventListener("click", this.boundHandleListClick);
    }
    removeListListeners() {
        this.list && (this.list.removeEventListener("marketListSelectionsDidChange", this.boundHandleListSelection), this.list.removeEventListener("marketListItemsFiltered", this.boundHandleListItemsFiltered), this.list.removeEventListener("keydown", this.boundHandleListKeyDown), this.list.removeEventListener("click", this.boundHandleListClick));
    }
    initRows() {
        this.rows = this.list.querySelectorAll("" + l$s("market-row")), this.rows.forEach((e2)=>{
            e2.id || (e2.id = "market-row-" + f$d());
        }), this.rowsText = [
            ...this.rows
        ].map((e2)=>{
            const t2 = e2.textContent;
            return t2 ? t2.trim().toLowerCase() : "";
        }).filter((e2)=>"" !== e2);
    }
    moveListToPopover() {
        this.list.removeAttribute("slot"), this.popoverElement.append(this.list);
    }
    moveListToSelect() {
        this.list.setAttribute("slot", "list"), this.el.append(this.list);
    }
    registerSlottedAccessories() {
        const e2 = [
            ...this.el.children
        ].filter(function(e3) {
            return e3.matches('[slot="leading-accessory"]');
        }), t2 = [
            ...this.el.children
        ].filter(function(e3) {
            return e3.matches('[slot="trailing-accessory"]');
        });
        this.hasLeadingAccessory = e2.length > 0, this.hasTrailingAccessory = t2.length > 0;
    }
    componentWillLoad() {
        this.registerSlottedAccessories(), this.popoverId = this.popoverId || "popover-" + f$d();
    }
    connectedCallback() {
        this.hasInitialized && (this.initList(), this.initRows(), this.initListObserver(), this.propagateValue());
    }
    componentDidLoad() {
        this.initList(), this.initRows(), this.initPopover(), this.initListObserver(), this.propagateValue(), this.hasInitialized = true;
    }
    componentWillRender() {
        const { listIsActive: e2, list: t2 } = this;
        t2 && e2 && t2.removeAttribute("slot");
    }
    disconnectedCallback() {
        var e2;
        this.removeListListeners(), null === (e2 = this.listObserver) || void 0 === e2 || e2.disconnect(), this.closeList();
    }
    render() {
        const e2 = this.disabled ? null : "0";
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "96adb420c13777c9de6cea38cd127cf8887d08f9",
            class: "market-select",
            role: "combobox",
            "aria-label": n$A(this.el),
            "aria-expanded": "" + this.listIsActive,
            "aria-controls": this.popoverId,
            "aria-activedescendant": this.focusedRowIndex > -1 ? this.rows[this.focusedRowIndex].id : null,
            "aria-required": "" + this.required,
            tabindex: e2,
            onClick: (e3)=>{
                this.handleTriggerClick(e3);
            },
            onFocus: ()=>{
                this.handleFocus();
            },
            onKeyDown: (e3)=>{
                this.handleTriggerKeyDown(e3);
            }
        }, (0, $696Z8.h)("slot", {
            key: "e6be8ecfd44fc23b54789dd6551308e6874d904b",
            name: "leading-accessory",
            onSlotchange: ()=>this.registerSlottedAccessories()
        }), (0, $696Z8.h)("div", {
            key: "e172178e9a5300598595ed0d1de43fe39cdc75e2",
            class: t$a("label-input-container", {
                "has-leading-accessory": this.hasLeadingAccessory,
                "has-trailing-accessory": this.hasTrailingAccessory
            })
        }, (0, $696Z8.h)("slot", {
            key: "3d2b3a444392df10a7b0a27fffbd574119ff9b9b"
        }), (0, $696Z8.h)("slot", {
            key: "0a13c56c31587c56519d87c211ffd93e8845a2f8",
            name: "displayed-selection"
        }, (0, $696Z8.h)("div", {
            key: "b1db79169d4c5b825158ec9450aa608d44bcb9a5",
            class: "placeholder"
        }, this.placeholder))), (0, $696Z8.h)("slot", {
            key: "0ae33a23f38b92ee4b104b015195c595c01a0c16",
            name: "list"
        }), (0, $696Z8.h)("slot", {
            key: "6196d81ea0c1555cb68e5422b42e1913360ed813",
            name: "trailing-accessory",
            onSlotchange: ()=>this.registerSlottedAccessories()
        }), (0, $696Z8.h)("svg", {
            key: "bd110729cf6ab2c0b90c9ad48e8a81cc3342d141",
            class: "caret",
            width: "14",
            height: "8",
            viewBox: "0 0 14 8",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "127baa30cfd702eb6df80fa2c4102daa45d4c2c2",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.70715 7.70711C7.31663 8.09763 6.68346 8.09763 6.29294 7.70711L0.29294 1.70711L1.70715 0.292892L7.00005 5.58579L12.2929 0.292893L13.7072 1.70711L7.70715 7.70711Z",
            fill: "black"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    valueWatcher: 0
                }
            ],
            multiselect: [
                {
                    multiselectWatcher: 0
                }
            ],
            focusedRowIndex: [
                {
                    focusedRowIndexWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host input,:host ::slotted(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color);}:host::after{content:"";position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)         var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([readonly]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([disabled]) ::slotted(.market-accessory),:host([disabled]) ::slotted(img[slot*="accessory"]),:host([disabled]) ::slotted(svg[slot*="accessory"]),:host([disabled]) ::slotted(div[slot*="accessory"]){--field-disabled-state-accessory-opacity:var(--row-disabled-state-leading-accessory-opacity);opacity:var(--field-disabled-state-accessory-opacity)}:host([value=""]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=""])) ::slotted(label),:host([value=""][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=""]):hover) ::slotted(label),:host([value=""][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=""][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=""])[disabled]) ::slotted(label),:host([value=""][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{--field-accessory-horizontal-spacing-size:16px;--field-size-small-accessory-horizontal-spacing-size:12px;--field-size-large-image-accessory-outer-spacing-size:12px;--field-size-medium-image-accessory-outer-spacing-size:4px;--field-size-large-button-accessory-outer-spacing-size:12px;--field-size-medium-button-accessory-outer-spacing-size:4px;--field-size-large-tooltip-accessory-horizontal-spacing-size:5px;--field-size-large-tooltip-accessory-vertical-spacing-size:-1px;--field-size-small-tooltip-accessory-horizontal-spacing-size:1px}:host ::slotted([slot="leading-accessory"]){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot="leading-accessory"][size="image"]){margin-left:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot="leading-accessory"]){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)       var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot="leading-accessory"][size="small"]){margin-left:var(--field-size-large-button-accessory-outer-spacing-size)}:host ::slotted([slot="trailing-accessory"]){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot="trailing-accessory"][size="image"]){margin-right:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot="trailing-accessory"]){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)       var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot="trailing-accessory"][size="small"]){margin-right:var(--field-size-large-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot="leading-accessory"][size="image"]){margin-left:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot="leading-accessory"][size="small"]){margin-left:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot="trailing-accessory"][size="image"]){margin-right:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot="trailing-accessory"][size="small"]){margin-right:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='small']) ::slotted([slot="leading-accessory"]),:host([size='small']) ::slotted([slot="trailing-accessory"]){margin-right:var(--field-size-small-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-accessory-horizontal-spacing-size)}:host([size='small']) ::slotted(.market-tooltip[slot="leading-accessory"]),:host([size='small']) ::slotted(.market-tooltip[slot="trailing-accessory"]){margin-right:var(--field-size-small-tooltip-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-tooltip-accessory-horizontal-spacing-size)}:host .label-input-container.has-leading-accessory{padding-left:0 !important;}:host .label-input-container.has-trailing-accessory{padding-right:0 !important;}:host{--field-input-animation-speed:var(--core-animation-enter-transition-moderate-speed-duration);--field-input-label-translate:12px;--field-empty-phase-label-text-size-unitless:16;--field-float-phase-label-text-size-unitless:14;--field-size-medium-float-phase-vertical-padding-size:12px;--field-size-medium-float-phase-horizontal-padding-size:16px;--field-size-small-float-phase-vertical-padding-size:9px;--field-size-small-float-phase-horizontal-padding-size:12px;display:flex;align-items:center}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{flex-grow:1;padding:var(--field-float-phase-vertical-padding-size) var(--field-float-phase-horizontal-padding-size)}:host([size='medium']) .label-input-container,:host([size='medium'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-medium-float-phase-vertical-padding-size)       var(--field-size-medium-float-phase-horizontal-padding-size)}:host([size='small']) .label-input-container,:host([size='small'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-small-float-phase-vertical-padding-size)       var(--field-size-small-float-phase-horizontal-padding-size)}:host ::slotted(label){display:block;min-height:var(--field-empty-phase-label-text-leading);font-weight:var(--field-empty-phase-label-text-weight);font-size:var(--field-empty-phase-label-text-size);line-height:var(--field-empty-phase-label-text-leading);letter-spacing:var(--field-empty-phase-label-text-tracking);transition:all var(--field-input-animation-speed);transform:translateY(var(--field-input-label-translate));transform-origin:0 0}:host(:not([value=""])) ::slotted(label),:host([value=""]:not([focused])[autofilled]) ::slotted(label),:host([focused]) ::slotted(label){font-weight:var(--field-float-phase-label-text-weight);transform:scale(         calc(var(--field-float-phase-label-text-size-unitless) / var(--field-empty-phase-label-text-size-unitless))       )}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){opacity:0}:host([focused]) input,:host([focused]) ::slotted(input),:host([focused]) textarea,:host([focused]) ::slotted(textarea),:host(:not([value=''])) input,:host(:not([value=''])) ::slotted(input),:host(:not([value=''])) textarea,:host(:not([value=''])) ::slotted(textarea){opacity:1}:host([size='small']) ::slotted(label),:host([size='medium']) ::slotted(label){position:absolute;overflow:hidden;width:1px;height:1px;white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%)}:host([size='small']) input,:host([size='small']) ::slotted(input),:host([size='small']) textarea,:host([size='small']) ::slotted(textarea),:host([size='medium']) input,:host([size='medium']) ::slotted(input),:host([size='medium']) textarea,:host([size='medium']) ::slotted(textarea){opacity:1}:host{cursor:pointer}:host(:focus-visible){outline:none}.label-input-container{overflow:hidden}.caret{flex-shrink:0;margin-right:var(--field-float-phase-horizontal-padding-size);pointer-events:none;transition:transform var(--field-input-animation-speed)}.caret path{fill:var(--select-caret-color)}:host([aria-expanded="true"]) .caret{transform:rotate(180deg)}.placeholder{overflow:hidden;height:var(--field-input-leading);color:var(--field-placeholder-text-color);font-size:var(--field-input-size);line-height:var(--field-input-leading);text-overflow:ellipsis;white-space:nowrap;visibility:hidden}:host([focused]) .placeholder,:host([size="small"]) .placeholder,:host([size="medium"]) .placeholder{visibility:visible}:host([size="small"]) .placeholder{height:var(--core-type-paragraph-20-leading);font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}::slotted(label){cursor:pointer}::slotted([slot="displayed-selection"]){min-height:0;margin:0}::slotted([slot="displayed-selection"])::before,::slotted([slot="displayed-selection"])::after{display:none}::slotted([slot="list"]){display:none}`;
    }
}, [
    257,
    "market-select",
    {
        name: [
            1
        ],
        value: [
            1537
        ],
        size: [
            513
        ],
        placeholder: [
            1
        ],
        readonly: [
            516
        ],
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        invalid: [
            516
        ],
        required: [
            516
        ],
        multiselect: [
            516
        ],
        popoverContainer: [
            1,
            "popover-container"
        ],
        popoverStrategy: [
            1,
            "popover-strategy"
        ],
        listIsActive: [
            32
        ],
        focusedRowIndex: [
            32
        ],
        isKeyboardNavigating: [
            32
        ],
        hasLeadingAccessory: [
            32
        ],
        hasTrailingAccessory: [
            32
        ],
        openList: [
            64
        ],
        closeList: [
            64
        ],
        toggleList: [
            64
        ]
    },
    [
        [
            8,
            "click",
            "windowClick"
        ]
    ],
    {
        value: [
            {
                valueWatcher: 0
            }
        ],
        multiselect: [
            {
                multiselectWatcher: 0
            }
        ],
        focusedRowIndex: [
            {
                focusedRowIndexWatcher: 0
            }
        ]
    }
]), x$2 = y$1;
var w = function(t2) {
    return c$7(s$9(t2, void 0, n$e), t2 + "");
}(function(t2, i2, e2) {
    return function(t3, i3, e3) {
        if ("function" != typeof t3) throw new TypeError("Expected a function");
        return setTimeout(function() {
            t3.apply(void 0, e3);
        }, i3);
    }(t2, c$r(i2) || 0, e2);
});
const y = {
    threshold: 0,
    linearRatio: 1,
    quadraticRatio: 1,
    invert: false
};
function k(t2, i2, e2) {
    return t2 + e2 * (i2 - t2);
}
function x$1(t2, i2) {
    return {
        x: i2.x - t2.x,
        y: i2.y - t2.y
    };
}
const D$1 = H$5 + I$4 + J$2, z$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7), this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7), this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7), this.type = "sheet", this.boundOnDragMove = this.onDragMove.bind(this), this.boundOnDragEnd = this.onDragEnd.bind(this), this.boundOnScrollDrag = this.onScrollDrag.bind(this), this.hidden = false, this.openMode = "partial", this.animationEnterDuration = n$H, this.animationExitDuration = h$h, this.disableFocus = false, this.closeHandleAriaLabel = "Close";
    }
    async activateFocusTrap(t2, i2) {
        this.focusTrap ? (this.focusTrap.activate(i2), this.disableFocus && (this.disableFocus = false)) : this.focusTrap = C$4({
            activateOptions: i2,
            el: this.el,
            options: Object.assign(Object.assign({}, t2), {
                initialFocus: false
            })
        }), this.focusTrapActivateOptions = i2 || {};
    }
    async deactivateFocusTrap(t2) {
        this.focusTrap && (this.focusTrap.deactivate(t2), this.focusTrap = void 0);
    }
    async dismiss(t2) {
        const { defaultPrevented: i2 } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (null == t2 ? void 0 : t2.origin) || this.el
        });
        i2 || (this.hidden = true, await new Promise((t3)=>setTimeout(t3, h$h)), this.marketDialogDidDismiss.emit({
            dialog: this.el,
            type: this.type,
            origin: this.el
        }));
    }
    setState(t2) {
        let i2 = t2;
        "closed" !== i2 && "dynamic" !== this.openMode && (i2 = this.openMode + "-open"), this.el.setAttribute("state", i2), this.resetTopByState();
    }
    resetTopByState() {
        var t2, i2, e2;
        this.calculateTopBoundary(), this.el.style.paddingBottom = "0";
        const o2 = this.el.getAttribute("state"), a2 = this.el.clientHeight;
        "closed" === o2 ? this.el.style.removeProperty("top") : this.el.style.top = a2 + D$1 >= window.innerHeight || "full-open" === o2 ? D$1 + ((null === (t2 = window.visualViewport) || void 0 === t2 ? void 0 : t2.offsetTop) || 0) + "px" : `calc(100% - ${a2}px)`, this.el.style.paddingBottom = (null === (i2 = window.visualViewport) || void 0 === i2 ? void 0 : i2.offsetTop) ? (null === (e2 = window.visualViewport) || void 0 === e2 ? void 0 : e2.offsetTop) + "px" : "0";
    }
    calculateTopBoundary() {
        this.topBoundary = "partial" === this.openMode ? window.innerHeight - this.el.clientHeight : D$1, this.compressionRatio = k(0.55, 0.8, this.topBoundary / window.innerHeight);
    }
    setTop(t2) {
        const i2 = function(t3, i3 = {}) {
            const { quadraticRatio: e2, linearRatio: o2, threshold: a2, invert: s2 } = Object.assign({}, y, i3), n2 = s2 ? -1 : 1;
            if (t3 * n2 < a2 * n2) return t3;
            let r2 = ((t3 - a2) * n2 + 1) ** e2 - 1;
            return r2 *= o2, a2 + r2 * n2;
        }(t2, {
            threshold: this.topBoundary,
            quadraticRatio: this.compressionRatio,
            invert: true
        });
        return this.el.style.top = i2 + "px", i2;
    }
    onDragStart(t2) {
        var i2;
        if (!n$s(t2) && 0 !== t2.button) return;
        if (null === (i2 = window.visualViewport) || void 0 === i2 ? void 0 : i2.offsetTop) {
            if (t2.target === document.activeElement) return;
            return document.activeElement.blur(), void t2.target.click();
        }
        const { top: e2 } = this.el.getBoundingClientRect();
        this.dragStartTop = e2, this.el.setAttribute("dragging", ""), this.calculateTopBoundary();
        const o2 = this.setTop(e2), a2 = o$e(t2);
        this.dragEventStack = [
            [
                t2.timeStamp,
                o2
            ]
        ], this.touchStartCoords = a2, this.dragDelta = {
            x: 0,
            y: 0
        };
        const { boundOnDragMove: s2, boundOnDragEnd: n2 } = this;
        document.addEventListener("mousemove", s2), document.addEventListener("mouseup", n2), document.addEventListener("touchmove", s2), document.addEventListener("touchend", n2);
    }
    onDragMove(t2) {
        const i2 = o$e(t2);
        this.dragDelta = x$1(this.touchStartCoords, i2), !this.el.hasAttribute("tapdisabled") && function(t3) {
            return (t3.x ** 2 + t3.y ** 2) ** 0.5;
        }(this.dragDelta) / window.innerHeight > 0.01 && this.el.setAttribute("tapdisabled", "");
        const e2 = this.setTop(this.dragStartTop + this.dragDelta.y);
        this.dragEventStack.push([
            t2.timeStamp,
            e2
        ]), this.pruneStack(t2.timeStamp);
    }
    onDragEnd(t2) {
        const i2 = o$e(t2);
        this.dragDelta = x$1(this.touchStartCoords, i2);
        const e2 = this.dragStartTop + this.dragDelta.y, o2 = this.setTop(e2), a2 = "full" === this.openMode ? D$1 : window.innerHeight - this.el.clientHeight, s2 = window.innerHeight / 2, n2 = k(window.innerHeight, a2, 0.6), r2 = k(D$1, a2, 0.6), d2 = 0.12 * window.innerHeight;
        this.dragEventStack.push([
            t2.timeStamp,
            o2
        ]);
        const h2 = this.getGestureDelta(t2, d2);
        h2 > d2 ? this.dismiss() : h2 < -d2 ? this.setState("full-open") : e2 > s2 && e2 > n2 ? this.dismiss() : this.setState(e2 < r2 ? "full-open" : "partial-open"), this.cleanupDragging();
    }
    onScrollStart() {
        this.scrollStart = this.mainContent.scrollTop, document.addEventListener("touchmove", this.boundOnScrollDrag, {
            passive: true
        });
    }
    onScrollDrag(t2) {
        const i2 = this.mainContent.scrollHeight - this.mainContent.clientHeight, e2 = o$e(t2), o2 = x$1(this.touchStartCoords, e2), a2 = this.scrollStart - o2.y, { boundOnScrollDrag: s2, mainContent: n2 } = this;
        a2 >= 0 && a2 <= i2 ? (t2.stopImmediatePropagation(), this.cleanupDragging()) : n2.setAttribute("dragging", ""), document.removeEventListener("touchmove", s2);
    }
    pruneStack(t2) {
        for(; this.dragEventStack.length > 0 && this.dragEventStack[0][0] < t2 - 250;)this.dragEventStack.shift();
    }
    getGestureDelta(t2, i2) {
        var e2, o2;
        let a2 = 0, s2 = null === (e2 = this.dragEventStack.pop()) || void 0 === e2 ? void 0 : e2[1];
        for(this.pruneStack(t2.timeStamp); this.dragEventStack.length > 0 && s2;){
            const t3 = null === (o2 = this.dragEventStack.pop()) || void 0 === o2 ? void 0 : o2[1];
            if (a2 += (s2 || 0) - (t3 || 0), s2 = t3, Math.abs(a2) > i2) break;
        }
        return a2;
    }
    cleanupDragging() {
        const { boundOnDragMove: t2, boundOnDragEnd: i2, el: e2, mainContent: o2 } = this;
        e2.removeAttribute("dragging"), o2.removeAttribute("dragging"), e2.removeAttribute("tapdisabled"), document.removeEventListener("mousemove", t2), document.removeEventListener("mouseup", i2), document.removeEventListener("touchmove", t2), document.removeEventListener("touchend", i2);
    }
    onKeyDown(t2) {
        switch(t2.key){
            case "Enter":
                this.dismiss();
                break;
            case " ":
                this.dismiss(t2), t2.preventDefault();
        }
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            }), this.disableFocus || this.activateFocusTrap();
        }, this.hidden ? 0 : n$H);
    }
    hiddenHandler() {
        this.setState(this.hidden ? "closed" : "partial-open");
    }
    componentDidLoad() {
        var t2;
        this.hiddenHandler(), this.heightObserver = new ResizeObserver(d$j(()=>{
            this.resetTopByState();
        }, 16)), this.heightObserver.observe(this.el), this.boundThrottledResetTopByState = d$j(()=>{
            this.resetTopByState();
        }, 16), null === (t2 = window.visualViewport) || void 0 === t2 || t2.addEventListener("resize", this.boundThrottledResetTopByState), this.boundFocusinHandler = (t3)=>{
            this.resetTopByState(), w(()=>{
                var i2, e2, o2, a2;
                if (null === (i2 = window.visualViewport) || void 0 === i2 ? void 0 : i2.offsetTop) {
                    const i3 = null === (e2 = t3.relatedTarget) || void 0 === e2 ? void 0 : e2.offsetTop, s2 = null === (o2 = document.activeElement) || void 0 === o2 ? void 0 : o2.offsetTop;
                    null === (a2 = document.activeElement) || void 0 === a2 || a2.scrollIntoView({
                        behavior: "smooth",
                        block: i3 < s2 ? "start" : "center",
                        inline: "start"
                    });
                }
            }, 250);
        }, this.mainContent.addEventListener("focusin", this.boundFocusinHandler);
    }
    disconnectedCallback() {
        var t2, i2, e2;
        clearTimeout(this.connectedCallbackTimeout), this.deactivateFocusTrap(), null === (t2 = this.heightObserver) || void 0 === t2 || t2.disconnect(), null === (i2 = window.visualViewport) || void 0 === i2 || i2.removeEventListener("resize", this.boundThrottledResetTopByState), null === (e2 = this.mainContent) || void 0 === e2 || e2.removeEventListener("focusin", this.boundFocusinHandler), this.deactivateFocusTrap();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "fb386fe8eaceaea79e4a8e4ead0acdf0f6463a32",
            role: "dialog",
            onMouseDown: (t2)=>this.onDragStart(t2),
            onTouchStart: (t2)=>this.onDragStart(t2)
        }, (0, $696Z8.h)("button", {
            key: "12bbf4e9870b056316c69e5bdd1e3a49fdd80556",
            "aria-label": this.closeHandleAriaLabel,
            class: "handle",
            onClick: this.dismiss.bind(this),
            onKeyDown: this.onKeyDown.bind(this)
        }), (0, $696Z8.h)("slot", {
            key: "ff099349bbc57f66cae42e2b9563a42676181d59",
            name: "header"
        }), (0, $696Z8.h)("div", {
            key: "f5b281db683fc98ccc940e5b0dc820258353e319",
            class: "main",
            ref: (t2)=>this.mainContent = t2,
            onTouchStart: ()=>this.onScrollStart()
        }, (0, $696Z8.h)("slot", {
            key: "b2ba36f094de88356cf63dfb4d22158b27acdadb"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            hidden: [
                {
                    hiddenHandler: 0
                }
            ]
        };
    }
    static get style() {
        return ':root{--animation-infinite-duration:1s;--animation-infinite-iteration-count:infinite;--animation-infinite-timing-function:linear}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-file-upload-loading-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-activity-indicator-rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main),:host ::slotted(.main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{--handle-whitespace:calc(var(--modal-sheet-handle-padding-top-size) + var(--modal-sheet-handle-padding-bottom-size));--handle-area-height:calc(var(--handle-whitespace) + var(--modal-sheet-handle-height));--max-width-padding:var(--modal-sheet-regular-horizontal-size-class-horizontal-padding);--min-width-padding:var(--modal-sheet-compact-horizontal-size-class-horizontal-padding);--padding-width:clamp(var(--min-width-padding), calc(50% - 200px), var(--max-width-padding));--padding-height:var(--modal-sheet-regular-vertical-size-class-vertical-padding);position:fixed;top:calc(100vh + var(--handle-area-height));bottom:auto;left:50%;overflow:visible;box-sizing:border-box;width:100%;max-width:calc(400px + calc(var(--max-width-padding) + var(--max-width-padding)));max-height:calc(100% - var(--handle-area-height));padding-top:var(--padding-height);border-radius:var(--modal-sheet-border-radius) var(--modal-sheet-border-radius) 0 0;background-color:var(--modal-sheet-background-color);opacity:0;-webkit-user-select:none;-moz-user-select:none;user-select:none;transition:top var(--core-animation-enter-transition-moderate-speed-duration),     opacity var(--core-animation-enter-transition-moderate-speed-duration);transform:translate(-50%, 0)}:host([state="closed"]){top:calc(100vh + var(--handle-area-height));opacity:0;transition:top var(--core-animation-exit-transition-moderate-speed-duration),       opacity var(--core-animation-exit-transition-moderate-speed-duration)}:host([state="partial-open"]){opacity:1}:host([state="full-open"]){opacity:1}:host([dragging]){transition:opacity var(--core-animation-enter-transition-moderate-speed-duration)}:host([tapdisabled]){pointer-events:none}:host ::slotted([slot="header"]){padding-right:var(--padding-width);padding-left:var(--padding-width)}:host::after{content:"";position:absolute;top:100%;display:block;width:inherit;max-width:inherit;height:100vh;background-color:inherit}.handle{position:fixed;bottom:calc(100% + var(--modal-sheet-handle-padding-bottom-size));left:50%;display:block;width:var(--modal-sheet-handle-width);height:var(--modal-sheet-handle-height);border:none;border-radius:var(--modal-sheet-border-radius);background-color:var(--modal-sheet-handle-background-color);-webkit-user-select:none;-moz-user-select:none;user-select:none;transform:translate(-50%, 0)}.handle::before{content:"";position:absolute;inset:calc(var(--modal-sheet-handle-padding-bottom-size) * -1)}.handle:focus{outline:var(--button-focus-ring-border-size) solid var(--button-focus-ring-color)}.main{overflow:hidden auto;padding-right:var(--padding-width);padding-bottom:var(--padding-height);padding-left:var(--padding-width);overscroll-behavior:contain}.main[dragging]{overflow-y:hidden}';
    }
}, [
    257,
    "market-sheet",
    {
        hidden: [
            1540
        ],
        dialogID: [
            513,
            "data-dialog-id"
        ],
        openMode: [
            1,
            "open-mode"
        ],
        animationEnterDuration: [
            2,
            "animation-enter-duration"
        ],
        animationExitDuration: [
            2,
            "animation-exit-duration"
        ],
        disableFocus: [
            1028,
            "disable-focus"
        ],
        closeHandleAriaLabel: [
            1,
            "close-handle-aria-label"
        ],
        activateFocusTrap: [
            64
        ],
        deactivateFocusTrap: [
            64
        ],
        dismiss: [
            64
        ]
    },
    void 0,
    {
        hidden: [
            {
                hiddenHandler: 0
            }
        ]
    }
]), T$1 = z$1;
const l$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketStepperValueChange = (0, $696Z8.createEvent)(this, "marketStepperValueChange", 7), this.marketStepperInputFocus = (0, $696Z8.createEvent)(this, "marketStepperInputFocus", 7), this.placeholder = "0", this.step = 1, this.readonly = false, this.disabled = false, this.focused = false, this.invalid = false, this.inputAriaLabel = "Number", this.decrementAriaLabel = "Decrement", this.incrementAriaLabel = "Increment", this.incrementDisabled = false, this.decrementDisabled = false;
    }
    valueChangeHandler() {
        const e2 = this.sanitizeValue(this.value);
        e2 !== this.value && (this.value = e2), this.updateButtonDisabledStates();
    }
    setFocus(e2 = true) {
        return this.readonly || this.disabled || (this.focused = e2, this.focused ? this.inputEl.focus() : this.inputEl.blur()), Promise.resolve();
    }
    onChange() {
        const e2 = this.value;
        let t2 = Number.parseFloat(this.inputEl.value);
        Number.isNaN(t2) ? (t2 = null, this.inputEl.value = "") : (t2 = this.sanitizeValue(t2), this.inputEl.value = "" + t2), t2 !== e2 && (this.value = t2, this.emitChangeEvent(e2));
    }
    onInputFocus() {
        this.emitInputFocusEvent();
    }
    onDecrementClick() {
        this.stepValue(-this.step);
    }
    onIncrementClick() {
        this.stepValue(this.step);
    }
    onKeyDown(e2) {
        "Enter" === e2.key && t(this.el);
    }
    stepValue(e2) {
        const t2 = this.value, o2 = this.sanitizeValue((t2 || 0) + e2);
        o2 !== t2 && (this.value = o2, this.emitChangeEvent(t2));
    }
    sanitizeValue(e2) {
        var t2;
        const o2 = (null === (t2 = ("" + this.step).split(".")[1]) || void 0 === t2 ? void 0 : t2.length) || 0, a2 = null != this.max, r2 = null != this.min;
        let i2 = Math.round(e2 / this.step) * this.step;
        return i2 = Number.parseFloat(i2.toFixed(o2)), i2 = a2 ? Math.min(i2, this.max) : i2, r2 ? Math.max(i2, this.min) : i2;
    }
    updateButtonDisabledStates() {
        const { value: e2, max: t2, min: o2 } = this, a2 = null != e2;
        this.incrementDisabled = !!a2 && e2 === t2, this.decrementDisabled = !!a2 && e2 === o2;
    }
    emitChangeEvent(e2) {
        const { el: t2, value: o2, marketStepperValueChange: a2 } = this;
        a2.emit({
            el: t2,
            value: o2,
            previousValue: e2
        });
    }
    emitInputFocusEvent() {
        const { marketStepperInputFocus: e2 } = this;
        e2.emit();
    }
    componentWillRender() {
        this.updateButtonDisabledStates();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "aecc3ecf2862b393d3ba5e2dd0d74d80cdab475a",
            class: "market-stepper",
            onFocus: ()=>{
                this.focused = true;
            },
            onBlur: ()=>{
                this.focused = false;
            }
        }, (0, $696Z8.h)("button", {
            key: "ae4af5e7bd3ea3c6aab9000a7abf6a3faed22b83",
            tabindex: this.disabled || this.decrementDisabled ? -1 : null,
            disabled: this.disabled || this.decrementDisabled,
            onClick: ()=>this.onDecrementClick(),
            "aria-label": this.decrementAriaLabel
        }, (0, $696Z8.h)("svg", {
            key: "01b36f51b84f37829627e4a5743e757ea3c436cf",
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "75a2ea01b50611df87befff045ab66b53a7ac660",
            d: "M9.66667 0.333328H0.333336V1.66666H9.66667V0.333328Z"
        }))), (0, $696Z8.h)("input", {
            key: "81c115c8ef238d82672abc7e686a7cade5859767",
            ref: (e2)=>this.inputEl = e2,
            type: "number",
            id: this.inputId,
            name: this.name,
            readonly: this.readonly,
            disabled: this.disabled,
            placeholder: this.placeholder,
            step: this.step,
            min: this.min,
            max: this.max,
            value: this.value,
            "aria-label": this.inputAriaLabel,
            onChange: ()=>this.onChange(),
            onFocus: ()=>this.onInputFocus(),
            onKeyDown: (e2)=>this.onKeyDown(e2),
            part: "native-input"
        }), (0, $696Z8.h)("button", {
            key: "f590a33a2b7932e9fabcfadd16df2c88d82be45e",
            tabindex: this.disabled || this.incrementDisabled ? -1 : null,
            disabled: this.disabled || this.incrementDisabled,
            onClick: ()=>this.onIncrementClick(),
            "aria-label": this.incrementAriaLabel
        }, (0, $696Z8.h)("svg", {
            key: "a4fcae3c03a2f3839944c206419549e1e95e6555",
            width: "10",
            height: "10",
            viewBox: "0 0 10 10",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "a3575aa6c126ebf4d36098141a610095f4903adc",
            d: "M5.66665 9.66666V5.66666H9.66665V4.33333H5.66665V0.333328H4.33331V4.33333H0.333313V5.66666H4.33331V9.66666H5.66665Z"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            value: [
                {
                    valueChangeHandler: 0
                }
            ]
        };
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host input,:host ::slotted(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color);}:host::after{content:"";position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)         var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([readonly]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([disabled]) ::slotted(.market-accessory),:host([disabled]) ::slotted(img[slot*="accessory"]),:host([disabled]) ::slotted(svg[slot*="accessory"]),:host([disabled]) ::slotted(div[slot*="accessory"]){--field-disabled-state-accessory-opacity:var(--row-disabled-state-leading-accessory-opacity);opacity:var(--field-disabled-state-accessory-opacity)}:host([value=""]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=""])) ::slotted(label),:host([value=""][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=""]):hover) ::slotted(label),:host([value=""][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=""][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=""])[disabled]) ::slotted(label),:host([value=""][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host input::-webkit-outer-spin-button,:host input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none;appearance:none}:host input[type="number"]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}:host{--focus-ring-color:color-mix(in srgb, var(--core-focus-ring-color) 100%, transparent);display:flex;align-items:center}:host input{--stepper-quantity-input-field-height:calc(         var(--stepper-quantity-input-field-value-text-leading) + var(--stepper-padding-size) * 2       );position:relative;bottom:0;width:100%;height:var(--stepper-quantity-input-field-height);color:var(--stepper-quantity-input-field-value-text-normal-state-color);font-weight:var(--stepper-quantity-input-field-value-text-weight);font-size:var(--stepper-quantity-input-field-value-text-size);font-family:var(--stepper-quantity-input-field-value-text-font-family);line-height:var(--stepper-quantity-input-field-value-text-leading);letter-spacing:var(--stepper-quantity-input-field-value-text-tracking);text-align:center;text-transform:var(--stepper-quantity-input-field-value-text-case);cursor:text;font-feature-settings:"tnum";}:host input[disabled]{color:var(--stepper-quantity-input-field-value-text-disabled-state-color)}:host input::-moz-placeholder{color:var(--stepper-quantity-input-field-value-text-placeholder-color)}:host input::placeholder{color:var(--stepper-quantity-input-field-value-text-placeholder-color)}button{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);--stepper-button-size:var(--stepper-button-minimum-height);position:relative;display:inline-flex;flex-shrink:0;justify-content:center;align-items:center;box-sizing:content-box;width:var(--stepper-button-size);height:var(--stepper-button-size);padding:var(--stepper-padding-size);border:none;border-radius:var(--stepper-border-radius);background:none;cursor:pointer;transition:background-color color var(--transition-duration)}button::before{content:"";position:absolute;inset:0;display:block;margin:var(--stepper-padding-size);border-radius:var(--stepper-button-border-radius);background:var(--stepper-button-normal-state-background-color)}button svg{position:relative;pointer-events:none;fill:var(--stepper-button-normal-state-icon-color)}button:hover::before{background:var(--stepper-button-hover-state-background-color)}button:hover svg{fill:var(--stepper-button-hover-state-icon-color)}button:focus{outline:none}button:focus-visible::before{outline:var(--core-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--core-focus-ring-border-size)}button:active::before{background:var(--stepper-button-pressed-state-background-color)}button:active svg{fill:var(--stepper-button-pressed-state-icon-color)}button[disabled]{cursor:not-allowed}button[disabled]::before{background:var(--stepper-button-disabled-state-background-color)}button[disabled] svg{fill:var(--stepper-button-disabled-state-icon-color)}`;
    }
}, [
    1,
    "market-stepper",
    {
        value: [
            1538
        ],
        inputId: [
            1,
            "input-id"
        ],
        name: [
            1
        ],
        placeholder: [
            1
        ],
        max: [
            2
        ],
        min: [
            2
        ],
        step: [
            2
        ],
        readonly: [
            516
        ],
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        invalid: [
            516
        ],
        inputAriaLabel: [
            513,
            "input-aria-label"
        ],
        decrementAriaLabel: [
            513,
            "decrement-aria-label"
        ],
        incrementAriaLabel: [
            513,
            "increment-aria-label"
        ],
        incrementDisabled: [
            32
        ],
        decrementDisabled: [
            32
        ],
        setFocus: [
            64
        ]
    },
    void 0,
    {
        value: [
            {
                valueChangeHandler: 0
            }
        ]
    }
]), n$9 = l$3;
const s$6 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTabSelectedChanged = (0, $696Z8.createEvent)(this, "marketTabSelectedChanged", 7), this.disabled = false, this.size = "medium", this.selected = false;
    }
    select() {
        if (this.selected || this.disabled) return Promise.resolve();
        const { defaultPrevented: t2 } = this.marketTabSelectedChanged.emit({
            panelId: this.el.getAttribute("aria-controls"),
            prevValue: this.selected,
            tabId: this.el.id,
            value: true
        });
        return t2 || (this.selected = true), Promise.resolve();
    }
    deselect() {
        if (!this.selected) return Promise.resolve();
        const { defaultPrevented: t2 } = this.marketTabSelectedChanged.emit({
            panelId: this.el.getAttribute("aria-controls"),
            prevValue: this.selected,
            tabId: this.el.id,
            value: false
        });
        return t2 || (this.selected = false), Promise.resolve();
    }
    disabledWatcher() {
        this.selected = false;
    }
    handleClick() {
        this.select();
    }
    handleKeydown(t2) {
        "Enter" !== t2.key && " " !== t2.key || (t2.preventDefault(), this.select());
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "94a982f36672134b47427850915d79d4a1eba2aa",
            "aria-disabled": "" + this.disabled,
            "aria-selected": "" + this.selected,
            class: "market-tab",
            onClick: this.handleClick.bind(this),
            onKeydown: this.handleKeydown.bind(this),
            role: "tab",
            tabindex: "0"
        }, (0, $696Z8.h)("button", {
            key: "309b3378622afeaa840ffa89ecc0116d81ab9d37",
            disabled: this.disabled,
            part: "button",
            ref: (t2)=>this.buttonEl = t2,
            tabindex: "-1"
        }, (0, $696Z8.h)("slot", {
            key: "69d62b428d1e5615e6f3362086fa98f25b22496a"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            disabled: [
                {
                    disabledWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ':host([size="large"]){font-weight:var(--core-type-heading-30-weight);font-size:var(--core-type-heading-30-size);font-family:var(--core-type-heading-30-font-family);line-height:var(--core-type-heading-30-leading);letter-spacing:var(--core-type-heading-30-tracking);text-transform:var(--core-type-heading-30-case)}:host(:not([size])),:host([size="medium"]){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}:host([size="small"]){font-weight:var(--core-type-medium-20-weight);font-size:var(--core-type-medium-20-size);font-family:var(--core-type-medium-20-font-family);line-height:var(--core-type-medium-20-leading);letter-spacing:var(--core-type-medium-20-tracking);text-transform:var(--core-type-medium-20-case)}:host{--focus-ring-color:color-mix(in srgb, var(--core-focus-ring-color) 100%, transparent);color:var(--tabs-tab-text-color, var(--core-text-20-color))}:host(:focus-visible){border-radius:var(--core-radius-66);outline:var(--core-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}:host [part="button"]{position:relative;border:0;background:none;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;text-transform:inherit;cursor:pointer;transition:color     var(--core-animation-enter-transition-fast-speed-duration)     var(--core-animation-enter-transition-easing)}:host [part="button"]::after{content:"";position:absolute;bottom:0;left:0;z-index:1;width:100%;height:0;border-radius:var(--tabs-tab-bottom-border-border-radius-top-left, var(--core-metrics-spacing-25))       var(--tabs-tab-bottom-border-border-radius-top-right, var(--core-metrics-spacing-25))       var(--tabs-tab-bottom-border-border-radius-bottom-right, 0)       var(--tabs-tab-bottom-border-border-radius-bottom-left, 0);background:var(--tabs-tab-bottom-border-background-color, var(--core-text-10-color));transition:height       var(--core-animation-enter-transition-fast-speed-duration)       var(--core-animation-enter-transition-easing),       background       var(--core-animation-enter-transition-fast-speed-duration)       var(--core-animation-enter-transition-easing)}:host(:hover),:host(:active){color:var(--tabs-tab-hover-state-text-color, var(--core-emphasis-text-color));transition:color     var(--core-animation-exit-transition-fast-speed-duration)     var(--core-animation-exit-transition-easing)}@media (-webkit-device-pixel-ratio: 1){:host [part="button"]::after{border-radius:0}}:host([size="small"]) [part="button"]{padding:var(--tabs-tab-small-size-top-padding-size, 4px)       0       var(--tabs-tab-small-size-bottom-padding-size, 10px)}:host(:not([size])) [part="button"],:host([size="medium"]) [part="button"]{padding:var(--tabs-tab-medium-size-top-padding-size, 4px)       0       var(--tabs-tab-medium-size-bottom-padding-size, 10px)}:host([size="large"]) [part="button"]{padding:var(--tabs-tab-large-size-top-padding-size, 4px)       0       var(--tabs-tab-large-size-bottom-padding-size, 12px)}:host([selected]){color:var(--tabs-tab-selected-text-color, var(--core-text-10-color))}:host([selected]) [part="button"]::after{height:var(--tabs-tab-selected-bottom-border-height, var(--core-metrics-spacing-25))}:host([selected]):hover{color:var(--tabs-tab-hover-state-selected-text-color, var(--core-text-10-color))}:host([selected]):active{color:var(--tabs-tab-active-state-selected-text-color, var(--core-emphasis-text-color))}:host([selected]):active [part="button"]::after{background:var(--tabs-tab-active-state-bottom-border-background-color, var(--core-emphasis-text-color))}:host([disabled]){color:var(--tabs-tab-disabled-state-text-color, var(--core-text-30-color))}:host([disabled]):hover{color:var(--tabs-tab-disabled-state-text-color, var(--core-text-30-color))}:host([disabled]) [part="button"]{cursor:not-allowed}';
    }
}, [
    257,
    "market-tab",
    {
        disabled: [
            516
        ],
        size: [
            513
        ],
        selected: [
            1540
        ],
        select: [
            64
        ],
        deselect: [
            64
        ]
    },
    void 0,
    {
        disabled: [
            {
                disabledWatcher: 0
            }
        ]
    }
]), n$8 = s$6;
const l$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTabListSelectedTabChanged = (0, $696Z8.createEvent)(this, "marketTabListSelectedTabChanged", 7);
    }
    marketTabSelectedChangedEventHandler(t2) {
        var e2;
        const { tabId: s2, value: a2 } = t2.detail;
        if (a2) {
            if (this.selectedTab !== s2) {
                const { defaultPrevented: t3 } = this.marketTabListSelectedTabChanged.emit({
                    prevValue: this.selectedTab,
                    value: s2
                });
                t3 || (this.selectedTab = s2);
            }
            null === (e2 = this.tabEls) || void 0 === e2 || e2.forEach((t3)=>{
                t3.id === s2 ? t3.tabIndex = 0 : (t3.deselect(), t3.tabIndex = -1);
            });
        }
    }
    tabWatcher(t2) {
        this.selectTab(t2);
    }
    sizeWatcher(t2) {
        this.propagateSizeProp(t2);
    }
    selectTab(t2) {
        var e2, s2;
        const a2 = (null === (e2 = this.tabEls) || void 0 === e2 ? void 0 : e2.find((e3)=>t2 === e3.id && !e3.disabled)) || (null === (s2 = this.tabEls) || void 0 === s2 ? void 0 : s2.find((t3)=>!t3.disabled));
        null == a2 || a2.select();
    }
    propagateSizeProp(t2) {
        this.tabEls.forEach((e2)=>{
            this.size && e2.size !== this.size && (e2.size = t2);
        });
    }
    focusOnTab(t2) {
        null == t2 || t2.focus();
    }
    handleKeyDown(t2) {
        if (this.tabEls && !this.tabEls.every((t3)=>t3.disabled) && ("ArrowLeft" === t2.key || "ArrowRight" === t2.key || "Home" === t2.key || "End" === t2.key)) {
            t2.preventDefault();
            const e2 = this.tabEls.indexOf(t2.target);
            if (e2 < 0) return;
            const s2 = this.tabEls.slice(0, e2), a2 = this.tabEls.slice(e2 + 1);
            switch(t2.key){
                case "ArrowRight":
                    {
                        const t3 = [
                            ...a2,
                            ...s2
                        ].find((t4)=>!t4.disabled);
                        this.focusOnTab(t3);
                        break;
                    }
                case "ArrowLeft":
                    {
                        const t3 = [
                            ...a2,
                            ...s2
                        ].reverse().find((t4)=>!t4.disabled);
                        this.focusOnTab(t3);
                        break;
                    }
                case "Home":
                    {
                        const t3 = this.tabEls.find((t4)=>!t4.disabled);
                        this.focusOnTab(t3);
                        break;
                    }
                case "End":
                    {
                        const t3 = this.tabEls.filter((t4)=>!t4.disabled).at(-1);
                        t3 && this.focusOnTab(t3);
                        break;
                    }
            }
        }
    }
    handleSlotChange() {
        this.tabEls = [
            ...this.el.querySelectorAll(l$s("market-tab"))
        ], this.propagateSizeProp(this.size);
    }
    componentWillLoad() {
        this.handleSlotChange(), this.selectTab(this.selectedTab || this.defaultTab);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "9af4771b6de15d912c269cdc537f871ded11e9c9",
            class: "market-tab-list",
            onKeyDown: this.handleKeyDown.bind(this),
            role: "tablist"
        }, (0, $696Z8.h)("slot", {
            key: "79101a9ad7dbd3109a9c936e09612bbd438da14e",
            onSlotchange: ()=>this.handleSlotChange()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            selectedTab: [
                {
                    tabWatcher: 0
                }
            ],
            size: [
                {
                    sizeWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ':host{position:relative;display:flex}:host::after{content:"";position:absolute;bottom:0;left:0;display:block;width:100%;height:var(--tabs-list-bottom-border-size, 1px);background-color:var(--tabs-list-bottom-border-color, var(--core-divider-20-color))}:host(:not([size])),:host([size="small"]),:host([size="medium"]){gap:var(--tabs-list-medium-size-horizontal-spacing, var(--core-metrics-spacing-200))}:host([size="large"]){gap:var(--tabs-list-large-size-horizontal-spacing, var(--core-metrics-spacing-300))}';
    }
}, [
    257,
    "market-tab-list",
    {
        size: [
            1
        ],
        selectedTab: [
            1537,
            "selected-tab"
        ],
        defaultTab: [
            1,
            "default-tab"
        ]
    },
    [
        [
            0,
            "marketTabSelectedChanged",
            "marketTabSelectedChangedEventHandler"
        ]
    ],
    {
        selectedTab: [
            {
                tabWatcher: 0
            }
        ],
        size: [
            {
                sizeWatcher: 0
            }
        ]
    }
]), n$7 = l$2;
const n$6 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.hidden = false;
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "a6fc5046534853d442e432fee6624097115cce86",
            "aria-hidden": "" + this.hidden,
            class: "market-tab-panel",
            role: "tabpanel",
            tabindex: "0"
        }, (0, $696Z8.h)("slot", {
            key: "d8be32e0fa22489b3132cd9b3077a597e8cb529f"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host{--focus-ring-color:color-mix(in srgb, var(--core-focus-ring-color) 100%, transparent);display:block}:host(:focus-visible){border-radius:var(--core-radius-66);outline:var(--core-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}:host([hidden]){display:none}";
    }
}, [
    257,
    "market-tab-panel",
    {
        hidden: [
            516
        ]
    }
]), a$4 = n$6;
const n$5 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.allColumns = [], this.visibleColumns = [], this.columnsStuckLeft = [], this.columnsStuckRight = [], this.columnsUnstuck = [], this.allRows = [], this.rowsStuckTop = [], this.rowsStuckBottom = [], this.rowsUnstuck = [], this.hasAccordionRows = false, this.observers = {}, this.throttledDetectStyleDeclaration = d$j(this.detectStyleDeclaration.bind(this), 16);
    }
    styleDeclarationObserver(t2, e2) {
        if (t2 !== e2) {
            if (t2.getPropertyValue("grid-template-columns") === t2.getPropertyValue("width")) return void (this.gridColumnTemplate = []);
            const e3 = ((t3)=>{
                const e4 = t3.split(" "), s2 = [
                    "auto-fill",
                    "auto-fit",
                    "minmax",
                    "fit-content"
                ].filter((e5)=>t3.includes(e5)), i2 = `${s2.length > 0 ? "features" : "feature"} ${s2.map((t4)=>`\`${t4}\``).join(", ")}`;
                if (s2.length > 0) return console.warn(`<market-table>'s grid layout is not built to support the use of the CSS ${i2}.
To avoid potential column layout issues, try using explicitly defined \`grid-template-column\` widths using length, percentage, or flex units.`), e4;
                const o2 = [];
                let r2 = 0, a2 = null;
                for(r2 = 0; r2 < e4.length; r2++){
                    const t4 = e4[r2];
                    if (t4.includes("repeat(")) {
                        a2 = Number.parseInt("" + t4.match(/\d+/), 10);
                        const s3 = e4.findIndex((t5, e5)=>e5 > r2 && t5.includes(")")), i3 = e4.slice(r2 + 1, s3 + 1).map((t5)=>t5.replace(/\W/, ""));
                        for(let t5 = 0; t5 < a2; t5++)o2.push("" + i3[t5 % i3.length]);
                        a2 = null, r2 += i3.length;
                    } else a2 || o2.push(t4);
                }
                return o2;
            })(t2.getPropertyValue("grid-template-columns"));
            (function(t3, e4) {
                return V$2(t3, e4);
            })(e3, this.gridColumnTemplate) || (this.gridColumnTemplate = e3);
        }
    }
    gridTemplateObserver(t2, e2) {
        t2 !== e2 && (this.setColumnWidths(t2), this.updateGridLayout());
    }
    allColumnsObserver(t2, e2) {
        !t2 || e2 && t2 === e2 || (this.setColumnWidths(this.gridColumnTemplate), this.forwardColumnPropertiesToCells(this.allColumns), this.updateGridLayout());
    }
    allRowsObserver(t2, e2) {
        t2 !== e2 && t2 && (this.updateGridLayout(), this.forwardColumnPropertiesToCells(this.allColumns), this.updateStickyRows());
    }
    stuckRowsObserver(t2, e2) {
        var s2, i2;
        t2 !== e2 && (this.allRows.map((t3)=>t3.classList.remove("buffer-row")), this.rowsStuckTop.length > 0 && (null === (s2 = this.rowsStuckTop.at(-1)) || void 0 === s2 || s2.classList.add("buffer-row")), this.rowsUnstuck.length > 0 && this.rowsStuckBottom.length > 0 && (null === (i2 = this.rowsUnstuck.at(-1)) || void 0 === i2 || i2.classList.add("buffer-row")));
    }
    marketTableHeaderLoadedEventHandler({ detail: t2 }) {
        this.allColumns = [
            ...t2.columns
        ], this.checkColumnVisibility();
    }
    marketTableRowStickEventHandler({ target: t2, detail: e2 }) {
        switch(e2.position){
            case "top":
                t2.slot = "sticky-header";
                break;
            case "bottom":
                t2.slot = "sticky-footer";
                break;
            default:
                console.warn("could not stick row to an unknown position");
        }
        this.updateStickyRows();
    }
    marketTableRowUnstickEventHandler({ target: t2 }) {
        t2.originalSlot ? t2.slot = t2.originalSlot : t2.removeAttribute("slot"), this.updateStickyRows();
    }
    async marketTableColumnStickEventHandler({ target: t2, detail: e2 }) {
        await Promise.all([
            ...this.allRows
        ].map(async (s2)=>{
            await s2._stickColumn(t2.name, e2.position);
        })), this.updateGridLayout();
    }
    async marketTableColumnUnstickEventHandler({ target: t2 }) {
        await Promise.all([
            ...this.allRows
        ].map(async (e2)=>{
            await e2._unstickColumn(t2.name);
        })), this.updateGridLayout();
    }
    marketTableColumnVisibilityChangeHandler({ detail: t2 }) {
        this.checkColumnVisibility(), this.allRows.forEach((e2)=>e2._syncColumnVisibilityWithCells(t2.columnName, t2.hidden)), this.detectStyleDeclaration();
    }
    checkColumnVisibility() {
        this.visibleColumns = this.allColumns.filter((t2)=>!t2.hidden);
    }
    setColumnWidths(t2) {
        this.allColumns.length > 0 && this.visibleColumns.forEach((e2, s2)=>{
            e2.width = t2[s2];
        });
    }
    forwardColumnPropertiesToCells(t2) {
        this.allRows.forEach((e2)=>e2.tableColumns = t2);
    }
    updateGridLayout() {
        if (this.allColumns.length > 0) {
            this.columnsUnstuck = this.visibleColumns.filter((t3)=>!t3.stickTo), this.columnsStuckLeft = this.visibleColumns.filter((t3)=>"left" === t3.stickTo), this.columnsStuckRight = this.visibleColumns.filter((t3)=>"right" === t3.stickTo);
            const t2 = this.columnsUnstuck.map((t3)=>t3.width), e2 = this.columnsStuckLeft.map((t3)=>t3.width), s2 = this.columnsStuckRight.map((t3)=>t3.width);
            this.allRows.length > 0 && this.allRows.forEach((i2)=>{
                i2.gridTemplateMain = t2, i2.gridTemplateLeft = e2, i2.gridTemplateRight = s2;
            });
        }
    }
    updateStickyRows() {
        this.rowsStuckTop = this.allRows.filter((t2)=>t2.sticky && t2.header || "top" === t2.stickTo), this.rowsStuckBottom = this.allRows.filter((t2)=>t2.sticky && t2.footer || "bottom" === t2.stickTo), this.rowsUnstuck = this.allRows.filter((t2)=>!t2.stickTo && !t2.sticky);
    }
    handleSlotChange() {
        this.allRows = [
            ...this.el.querySelectorAll(l$s("market-table-row"))
        ];
        const t2 = [
            ...this.el.children
        ].some((t3)=>t3.tagName.toLowerCase() === l$s("market-accordion-item")) || this.hasAccordionRows;
        this.allRows.forEach((e2)=>{
            e2.index = Array.prototype.indexOf.call(this.allRows, e2), e2.nested = t2;
        });
    }
    detectStyleDeclaration() {
        this.styleDeclaration = window.getComputedStyle(this.el);
    }
    initResizeObserver() {
        this.observers.resize || (this.observers.resize = new ResizeObserver(()=>{
            window.requestAnimationFrame(()=>{
                this.throttledDetectStyleDeclaration();
            });
        }), this.observers.resize.observe(this.el));
    }
    initInlineStyleObserver() {
        this.observers.inlineStyle || (this.observers.inlineStyle = new MutationObserver(()=>this.detectStyleDeclaration()), this.observers.inlineStyle.observe(this.el, {
            attributes: true,
            attributeFilter: [
                "style"
            ]
        }));
    }
    initContentObserver() {
        this.observers.content || (this.observers.content = new MutationObserver(()=>this.handleSlotChange()), this.observers.content.observe(this.el, {
            childList: true,
            subtree: true,
            characterData: true
        }));
    }
    componentWillLoad() {
        this.detectStyleDeclaration(), this.handleSlotChange();
    }
    componentDidLoad() {
        this.initResizeObserver(), this.initInlineStyleObserver(), this.initContentObserver();
    }
    render() {
        const t2 = l$s("market-table-area");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "cb5a17796e7a73ac8a2e4c9f0176086cb858e3d6",
            class: "market-table",
            role: "table",
            onSlotchange: ()=>this.handleSlotChange()
        }, (0, $696Z8.h)(t2, {
            key: "190e61958402f0d534e4f09794eebd1999e202d0",
            orientation: "horizontal",
            "stick-to": "top",
            active: this.rowsStuckTop.length > 0
        }, (0, $696Z8.h)("slot", {
            key: "e4f8cef18ca0124d8169e1ecf8564589e99d2116",
            name: "sticky-header"
        })), (0, $696Z8.h)(t2, {
            key: "978e180ce9703654737882e5f411edc8dd09d756",
            orientation: "horizontal",
            active: true
        }, (0, $696Z8.h)("slot", {
            key: "70d9bbf16952e9476032894770d1c0462b15f5f8",
            name: "header"
        }), (0, $696Z8.h)("slot", {
            key: "522effff97fd98cc1e874af84d68c574404b7836"
        }), (0, $696Z8.h)("slot", {
            key: "f9dc977db1d5775cd3c9c837834d1e8532acd650",
            name: "footer"
        })), (0, $696Z8.h)(t2, {
            key: "89eba91e0e1c71151858079b80882216a4604e69",
            orientation: "horizontal",
            "stick-to": "bottom",
            active: this.rowsStuckBottom.length > 0
        }, (0, $696Z8.h)("slot", {
            key: "538eb849b4b03dbfcf8f9ef25e0d36bb0c99075b",
            name: "sticky-footer"
        })));
    }
    disconnectedCallback() {
        Object.values(this.observers).forEach((t2)=>{
            null == t2 || t2.disconnect();
        });
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            styleDeclaration: [
                {
                    styleDeclarationObserver: 0
                }
            ],
            gridColumnTemplate: [
                {
                    gridTemplateObserver: 0
                }
            ],
            allColumns: [
                {
                    allColumnsObserver: 0
                }
            ],
            visibleColumns: [
                {
                    allColumnsObserver: 0
                }
            ],
            allRows: [
                {
                    allRowsObserver: 0
                }
            ],
            rowsStuckTop: [
                {
                    stuckRowsObserver: 0
                }
            ],
            rowsStuckBottom: [
                {
                    stuckRowsObserver: 0
                }
            ],
            rowsUnstuck: [
                {
                    stuckRowsObserver: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;display:grid;grid-auto-columns:1fr;grid-auto-flow:row;overflow-x:clip;height:auto}::slotted(.market-table-row:last-of-type:not([slot="header"])),::slotted(.market-table-row.buffer-row){border-bottom:none !important;}';
    }
}, [
    257,
    "market-table",
    {
        styleDeclaration: [
            32
        ],
        gridColumnTemplate: [
            32
        ],
        allColumns: [
            32
        ],
        visibleColumns: [
            32
        ],
        columnsStuckLeft: [
            32
        ],
        columnsStuckRight: [
            32
        ],
        columnsUnstuck: [
            32
        ],
        allRows: [
            32
        ],
        rowsStuckTop: [
            32
        ],
        rowsStuckBottom: [
            32
        ],
        rowsUnstuck: [
            32
        ],
        hasAccordionRows: [
            32
        ]
    },
    [
        [
            0,
            "marketTableHeaderLoaded",
            "marketTableHeaderLoadedEventHandler"
        ],
        [
            0,
            "marketTableRowStick",
            "marketTableRowStickEventHandler"
        ],
        [
            0,
            "marketTableRowUnstick",
            "marketTableRowUnstickEventHandler"
        ],
        [
            0,
            "marketTableColumnStick",
            "marketTableColumnStickEventHandler"
        ],
        [
            0,
            "marketTableColumnUnstick",
            "marketTableColumnUnstickEventHandler"
        ],
        [
            0,
            "marketTableColumnVisibilityChange",
            "marketTableColumnVisibilityChangeHandler"
        ]
    ],
    {
        styleDeclaration: [
            {
                styleDeclarationObserver: 0
            }
        ],
        gridColumnTemplate: [
            {
                gridTemplateObserver: 0
            }
        ],
        allColumns: [
            {
                allColumnsObserver: 0
            }
        ],
        visibleColumns: [
            {
                allColumnsObserver: 0
            }
        ],
        allRows: [
            {
                allRowsObserver: 0
            }
        ],
        rowsStuckTop: [
            {
                stuckRowsObserver: 0
            }
        ],
        rowsStuckBottom: [
            {
                stuckRowsObserver: 0
            }
        ],
        rowsUnstuck: [
            {
                stuckRowsObserver: 0
            }
        ]
    }
]), c$4 = n$5;
const a$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.orientation = "horizontal", this.active = false, this.placement = [
            1,
            -1
        ];
    }
    assignGridTemplate(t2, e2) {
        t2 && t2 !== e2 && (t2.length > 0 || void 0 === e2 ? (this.active = true, this.el.style.gridTemplateColumns = t2.join(" ")) : (this.active = false, this.el.style.gridTemplateColumns = void 0));
    }
    placementObserver(t2, e2) {
        t2 !== e2 && (this.el.style.gridColumn = `${t2[0]} / span ${t2[1]}`);
    }
    componentWillLoad() {
        this.assignGridTemplate(this.gridTemplate);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "1aea5ba210d6229aeef7297d2d68d46e90a6a758",
            class: "market-table-area"
        }, (0, $696Z8.h)("slot", {
            key: "390fcebf799c9e22f333e3a18839f1df959f3c31"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            gridTemplate: [
                {
                    assignGridTemplate: 0
                }
            ],
            placement: [
                {
                    placementObserver: 0
                }
            ]
        };
    }
    static get style() {
        return ':host{position:relative;grid-column:1 / -1;background-color:var(--table-cell-state-normal-background-color, var(--core-surface-10-color))}:host(:not([active])){display:none !important;}:host([orientation="horizontal"]){display:block}:host([orientation="vertical"]){display:grid;grid-auto-columns:1fr;grid-auto-flow:column}:host([orientation="vertical"]) ::slotted(.market-table-row){border-bottom:none}:host([stick-to]){position:sticky;z-index:1}:host([stick-to][orientation="horizontal"]){z-index:2}:host([stick-to="top"]){top:0;border-bottom:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([stick-to="bottom"]){bottom:0}:host([stick-to="bottom"]:not(:empty)){border-top:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([stick-to="left"]){left:0;justify-content:end;border-right:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([stick-to="right"]){right:0;justify-content:start;border-left:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}';
    }
}, [
    257,
    "market-table-area",
    {
        orientation: [
            513
        ],
        stickTo: [
            513,
            "stick-to"
        ],
        gridTemplate: [
            16
        ],
        active: [
            1540
        ],
        placement: [
            16
        ],
        elements: [
            32
        ]
    },
    void 0,
    {
        gridTemplate: [
            {
                assignGridTemplate: 0
            }
        ],
        placement: [
            {
                placementObserver: 0
            }
        ]
    }
]), s$5 = a$3;
const a$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTableCellClicked = (0, $696Z8.createEvent)(this, "marketTableCellClicked", 7), this.align = false, this.leadingIndentation = 0, this.active = false, this.interactive = false, this.disabled = false, this.hidden = false;
    }
    _updateColumnRelatedProperties(t2) {
        return t2 ? (this.column = t2.name, this.align = t2.align, this.hidden = t2.hidden, t2.stickTo && this._stickSelf(t2.stickTo), Promise.resolve()) : Promise.resolve();
    }
    _updateFirstCellProperties(t2) {
        return this.leadingIndentation = t2.leadingIndentation || 0, this.el.style.setProperty("--cell-indent-level", "" + this.leadingIndentation), Promise.resolve();
    }
    _stickSelf(t2) {
        return t2 && (this.el.slot = "sticky-" + t2), Promise.resolve();
    }
    _unstickSelf() {
        return this.originalSlot ? this.el.slot = this.originalSlot : this.el.removeAttribute("slot"), Promise.resolve();
    }
    componentWillLoad() {
        this.originalSlot = this.el.getAttribute("slot");
    }
    handleClick() {
        this.interactive && this.marketTableCellClicked.emit();
    }
    handleKeydown(t2) {
        if (t2.target === this.el) switch(t2.key){
            case "Enter":
                this.handleClick();
                break;
            case " ":
                this.handleClick(), t2.preventDefault();
        }
    }
    render() {
        const { disabled: t2, interactive: e2, align: o2, hidden: l2 } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "0d573cb1fc2fe8cb95ef33820e8495111e8fad60",
            class: "market-table-cell",
            role: "cell",
            align: "right" === o2 && o2,
            hidden: l2,
            tabindex: e2 && !t2 ? "0" : null,
            onClick: ()=>this.handleClick(),
            onKeydown: (t3)=>this.handleKeydown(t3)
        }, (0, $696Z8.h)("slot", {
            key: "e1e6c17011b8bad77d30bca3198df2f5a7945ca0",
            name: "nested-row-indicator"
        }), (0, $696Z8.h)("slot", {
            key: "8918929d14f054dd82b4faa336f112392678e534",
            name: "leading-accessory"
        }), (0, $696Z8.h)("slot", {
            key: "8e2badb4f93106b640c3629aac082e9732f09ef0"
        }), (0, $696Z8.h)("slot", {
            key: "fe082a65291341da38fe8674ffcb2903821045f9",
            name: "trailing-accessory"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;display:flex;justify-content:flex-start;align-items:center;overflow:hidden;padding:var(--table-cell-vertical-padding-size, 12px) var(--table-cell-horizontal-padding-size, 8px);background-color:var(--table-cell-state-normal-background-color, var(--core-surface-10-color));font-weight:var(--table-cell-primary-text-font-weight, var(--core-type-paragraph-20-weight));font-size:var(--table-cell-primary-text-font-size, var(--core-type-paragraph-20-size));line-height:var(--table-cell-primary-text-line-height, var(--core-type-paragraph-20-leading));text-overflow:ellipsis}:host([align="right"]){justify-content:flex-end}:host([align="right"]) .sorting-caret{order:-1;margin-right:var(--table-heading-sort-icon-space-size, 8px);margin-left:0}:host([stickTo="left"]){position:sticky;grid-area:left;border-right:var(--table-fixed-column-border-width, 1px)       solid       var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host([stickTo="right"]){grid-area:right;border-left:var(--table-fixed-column-border-width, 1px)       solid       var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);transition:background-color var(--transition-duration)}@media (hover: hover){:host{}:host([interactive]:not([disabled]):hover){background-color:var(--table-cell-hover-state-background-color)}}:host([interactive]){cursor:pointer}:host([interactive]:focus){outline:none;}:host([interactive]:not([disabled]):focus){background-color:var(--table-cell-focus-state-background-color)}:host([interactive]:not([disabled]):active){background-color:var(--table-cell-pressed-state-background-color)}:host([active]){background-color:var(--table-cell-selected-state-background-color)}:host([interactive][disabled]){pointer-events:none}:host([disabled]){background-color:transparent;color:var(--table-cell-disabled-state-text-color);pointer-events:none}:host([hidden]){display:none}:host(:first-of-type){padding-left:var(--table-cell-padding, 8px)}:host(:first-of-type) ::slotted(button){all:unset;display:flex;justify-content:space-between;align-items:center;padding-right:var(--core-metrics-spacing-100);padding-left:calc(         var(--cell-indent-level) *         var(--table-row-indentation-padding, 40px) +         var(--core-metrics-spacing-100)       );color:var(--table-cell-normal-state-content-color, var(--core-fill-black-color));cursor:pointer}:host(:first-of-type) ::slotted(button):focus-visible{outline:none}:host(:first-of-type) ::slotted(button):focus{color:var(--table-accordion-focus-state-content-color, var(--core-fill-black-color))}:host(:first-of-type) ::slotted(button):hover{color:var(--table-accordion-hover-state-content-color, var(--core-fill-black-color))}:host(:first-of-type) ::slotted(button):active{color:var(--table-accordion-pressed-state-content-color, var(--core-fill-black-color))}:host(:first-of-type) ::slotted([slot="nested-row-indicator"]){height:100%}:host(:first-of-type) ::slotted([slot="nested-row-indicator"]:focus-visible){z-index:1;border-radius:var(--core-radius-66);outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color)}::slotted([slot="leading-accessory"][size="image"]){margin-right:16px;margin-left:12px}::slotted([slot="leading-accessory"][size="icon"]){margin-right:16px;margin-left:16px}::slotted([slot="trailing-accessory"][size="image"]){margin-right:12px;margin-left:16px}::slotted([slot="trailing-accessory"][size="icon"]){margin-right:16px;margin-left:16px}::slotted([slot="nested-row-indicator"]){color:var(--table-cell-normal-state-content-color, var(--core-fill-black-color))}::slotted([slot="nested-row-indicator"]:focus){color:var(--table-accordion-focus-state-content-color, var(--core-fill-black-color))}::slotted([slot="nested-row-indicator"]:hover){color:var(--table-accordion-hover-state-content-color, var(--core-fill-black-color))}::slotted([slot="nested-row-indicator"]:active){color:var(--table-accordion-pressed-state-content-color, var(--core-fill-black-color))}';
    }
}, [
    257,
    "market-table-cell",
    {
        align: [
            1032
        ],
        column: [
            1537
        ],
        leadingIndentation: [
            1026,
            "leading-indentation"
        ],
        active: [
            516
        ],
        interactive: [
            516
        ],
        disabled: [
            516
        ],
        originalSlot: [
            32
        ],
        hidden: [
            32
        ],
        _updateColumnRelatedProperties: [
            64
        ],
        _updateFirstCellProperties: [
            64
        ],
        _stickSelf: [
            64
        ],
        _unstickSelf: [
            64
        ]
    }
]), s$4 = a$2;
const s$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTableColumnStick = (0, $696Z8.createEvent)(this, "marketTableColumnStick", 7), this.marketTableColumnUnstick = (0, $696Z8.createEvent)(this, "marketTableColumnUnstick", 7), this.marketTableColumnSort = (0, $696Z8.createEvent)(this, "marketTableColumnSort", 7), this.marketTableColumnVisibilityChange = (0, $696Z8.createEvent)(this, "marketTableColumnVisibilityChange", 7), this.align = false, this.sortable = false, this.hidden = false, this.index = 0;
    }
    emitVisibilityChangeEvent(t2, e2) {
        t2 !== e2 && this.marketTableColumnVisibilityChange.emit({
            columnName: this.name,
            hidden: t2
        });
    }
    async emitStickyEvents(t2, e2) {
        t2 && t2 !== e2 ? await this.stick(t2) : this.unstick(t2);
    }
    stick(t2) {
        return t2 === this.stickTo ? this.marketTableColumnStick.emit({
            position: t2,
            index: this.index
        }) : this.stickTo = t2, Promise.resolve();
    }
    unstick(t2) {
        return this.marketTableColumnUnstick.emit({
            position: t2,
            index: this.index
        }), Promise.resolve();
    }
    _stickSelf(t2) {
        return t2 && (this.el.slot = "sticky-" + t2), this.stickTo = t2, Promise.resolve();
    }
    _unstickSelf() {
        return this.originalSlot ? this.el.slot = this.originalSlot : this.el.removeAttribute("slot"), this.el.removeAttribute("stick-to"), Promise.resolve();
    }
    clickHandler() {
        this.sortable && this.marketTableColumnSort.emit({
            column: this.name,
            previousSortOrder: this.sortOrder
        });
    }
    componentWillLoad() {
        this.originalSlot = this.el.getAttribute("slot"), this.name || console.warn("Please set a name on <market-table-column>. Tables may not work correctly without this.");
    }
    componentDidLoad() {
        this.stickTo && this.stick(this.stickTo);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "69d5c6e36b03daa0a7be61d1f4bf3fcb4609950e",
            class: "market-table-column",
            align: "right" === this.align && this.align,
            role: "columnheader",
            "aria-sort": this.sortOrder,
            onClick: ()=>this.clickHandler()
        }, (0, $696Z8.h)("slot", {
            key: "2bc6f2ebcc6bdd7dfa2b4d0b787238e7c2211d86",
            name: "leading-accessory"
        }), this.sortable && (0, $696Z8.h)("button", {
            key: "e3da1d70a04bd8c27b7cdd8e68e774d7888f6eec"
        }, (0, $696Z8.h)("slot", {
            key: "4c7171dbc8891ae1c41bdcfd817ca731327feea4"
        }), (0, $696Z8.h)("svg", {
            key: "936ecf8ec68f64464aacb0a216704ab68ec69ccb",
            width: "16",
            height: "15",
            viewBox: "0 0 16 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            class: "sorting-caret",
            "aria-hidden": "true"
        }, (0, $696Z8.h)("path", {
            key: "ae57a43eaeb211d7ecb0bf2e97bda5f8eef7972e",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.70709 14.7071C8.31657 15.0976 7.6834 15.0976 7.29288 14.7071L0.292879 7.7071L1.70709 6.29289L6.99999 11.5858L6.99999 -7.612e-07L8.99999 -5.86354e-07L8.99999 11.5858L14.2929 6.29289L15.7071 7.70711L8.70709 14.7071Z"
        }))), !this.sortable && (0, $696Z8.h)("slot", {
            key: "7e8fc07622bc376a1eac362d1bfb8517287348f1"
        }), (0, $696Z8.h)("slot", {
            key: "a37d866ec81384958211f78152b94d6a954426fd",
            name: "trailing-accessory"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            hidden: [
                {
                    emitVisibilityChangeEvent: 0
                }
            ],
            stickTo: [
                {
                    emitStickyEvents: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;display:flex;justify-content:flex-start;align-items:center;overflow:hidden;padding:var(--table-cell-vertical-padding-size, 12px) var(--table-cell-horizontal-padding-size, 8px);background-color:var(--table-cell-state-normal-background-color, var(--core-surface-10-color));font-weight:var(--table-cell-primary-text-font-weight, var(--core-type-paragraph-20-weight));font-size:var(--table-cell-primary-text-font-size, var(--core-type-paragraph-20-size));line-height:var(--table-cell-primary-text-line-height, var(--core-type-paragraph-20-leading));text-overflow:ellipsis}:host([align="right"]){justify-content:flex-end}:host([align="right"]) .sorting-caret{order:-1;margin-right:var(--table-heading-sort-icon-space-size, 8px);margin-left:0}:host([stickTo="left"]){position:sticky;grid-area:left;border-right:var(--table-fixed-column-border-width, 1px)       solid       var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host([stickTo="right"]){grid-area:right;border-left:var(--table-fixed-column-border-width, 1px)       solid       var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host{font-weight:var(--table-heading-primary-text-font-weight, 500);font-size:var(--table-heading-primary-text-font-size, var(--core-type-semibold-20-size));line-height:var(--table-heading-primary-text-line-height, var(--core-type-semibold-20-leading))}:host([sortable]){cursor:pointer;transition:background-color       var(--core-animation-enter-transition-fast-speed-duration)       var(--core-animation-enter-transition-fast-speed-duration-easing)}:host([sortable]:hover){background-color:var(--table-heading-hover-state-background-color, var(--core-fill-50-color))}:host([sortable]:active){background-color:var(--table-heading-active-state-background-color, var(--core-emphasis-40-color))}:host([sort-order]) .sorting-caret{fill:var(--table-heading-sortable-variant-active-state-caret-color, var(--core-text-10-color))}:host([sort-order="descending"]) .sorting-caret{transform:rotate(0deg)}:host([hidden]){display:none}.sorting-caret{margin-left:var(--table-heading-sort-icon-space-size, 8px);fill:var(--table-heading-sortable-variant-normal-state-caret-color, var(--core-text-30-color));transition:color     var(--core-animation-enter-transition-fast-speed-duration)     var(--core-animation-enter-transition-fast-speed-duration-easing);transform:rotate(180deg)}::slotted([slot="leading-accessory"][size="image"]){margin-right:16px;margin-left:12px}::slotted([slot="leading-accessory"][size="icon"]){margin-right:16px;margin-left:16px}::slotted([slot="trailing-accessory"][size="image"]){margin-right:12px;margin-left:16px}::slotted([slot="trailing-accessory"][size="icon"]){margin-right:16px;margin-left:16px}button{display:flex;align-items:center;padding:0;border:inherit;background-color:transparent;color:unset;font:inherit}';
    }
}, [
    257,
    "market-table-column",
    {
        name: [
            513
        ],
        align: [
            8
        ],
        stickTo: [
            1537,
            "stick-to"
        ],
        sortable: [
            516
        ],
        sortOrder: [
            513,
            "sort-order"
        ],
        hidden: [
            516
        ],
        index: [
            2
        ],
        width: [
            1
        ],
        originalSlot: [
            32
        ],
        stick: [
            64
        ],
        unstick: [
            64
        ],
        _stickSelf: [
            64
        ],
        _unstickSelf: [
            64
        ]
    },
    void 0,
    {
        hidden: [
            {
                emitVisibilityChangeEvent: 0
            }
        ],
        stickTo: [
            {
                emitStickyEvents: 0
            }
        ]
    }
]), n$4 = s$3;
const a$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTableHeaderLoaded = (0, $696Z8.createEvent)(this, "marketTableHeaderLoaded", 7), this.marketTableRowClicked = (0, $696Z8.createEvent)(this, "marketTableRowClicked", 7), this.marketTableRowStick = (0, $696Z8.createEvent)(this, "marketTableRowStick", 7), this.marketTableRowUnstick = (0, $696Z8.createEvent)(this, "marketTableRowUnstick", 7), this.marketAccordionToggled = (0, $696Z8.createEvent)(this, "marketAccordionToggled", 7), this.marketNestedRowToggled = (0, $696Z8.createEvent)(this, "marketNestedRowToggled", 7), this.leadingIndentation = 0, this.stickTo = false, this.active = false, this.interactive = false, this.disabled = false, this.selected = false, this.header = false, this.footer = false, this.index = 0, this.gridTemplateMain = [], this.gridTemplateLeft = [], this.gridTemplateRight = [], this.expanded = false, this.nested = false, this.gridTemplate = [], this.componentLoaded = false;
    }
    formNewGridTemplate() {
        this.gridTemplate = [
            ...this.gridTemplateLeft,
            ...this.gridTemplateMain,
            ...this.gridTemplateRight
        ], this.tableAreaLeft && (this.tableAreaLeft.placement = [
            1,
            this.gridTemplateLeft.length
        ]), this.tableAreaMain && (this.tableAreaMain.placement = [
            this.gridTemplateLeft.length + 1,
            this.gridTemplateMain.length
        ]), this.tableAreaRight && (this.tableAreaRight.placement = [
            this.gridTemplateLeft.length + this.gridTemplateMain.length + 1,
            this.gridTemplateRight.length
        ]);
    }
    gridTemplateObserver(t2, e2) {
        t2 !== e2 && (this.el.style.gridTemplateColumns = t2.join(" "));
    }
    stickyObserver(t2, e2) {
        t2 !== e2 && this.emitStickyEvents();
    }
    columnsObserver(t2) {
        this.setCellColumnProperties(t2);
    }
    updateCellProperties(t2, e2) {
        t2 !== e2 && this.setCellColumnProperties(this.tableColumns);
    }
    updateFirstCellProperties() {
        this._setFirstCellProperties();
    }
    updateNestedRowButton() {
        if (this.nestedRowToggleButton) {
            this.nestedRowToggleButton.ariaExpanded = "" + this.expanded;
            const t2 = this.nestedRowToggleButton.querySelector("svg");
            t2 && (t2.style.transform = this.expanded ? "rotate(-180deg)" : "rotate(0deg)");
        }
    }
    updateSlottedControlCheckedValue() {
        var t2;
        null === (t2 = this.slottedControl) || void 0 === t2 || t2.setSelection(this.selected);
    }
    updateSlottedControlDisabledValue() {
        var t2;
        null === (t2 = this.slottedControl) || void 0 === t2 || t2.setDisabled(this.disabled);
    }
    handleMarketCheckboxValueChange(t2) {
        t2.target === this.slottedControl && (this.selected = t2.detail.current);
    }
    stick(t2) {
        return t2 ? this.stickTo = t2 : (this.header || this.footer) && (this.sticky = true), Promise.resolve();
    }
    unstick() {
        return this.sticky = false, this.stickTo = false, Promise.resolve();
    }
    async _stickColumn(t2, e2) {
        const i2 = this.el.querySelector(`[name="${t2}"], [column="${t2}"]`);
        i2 ? await i2._stickSelf(e2) : console.warn("cannot stick cell to unknown position");
    }
    async _unstickColumn(t2) {
        const e2 = this.el.querySelector(`[name="${t2}"], [column="${t2}"]`);
        e2 ? await e2._unstickSelf() : console.warn("cannot unstick cell from unknown position");
    }
    _syncColumnVisibilityWithCells(t2, e2) {
        const i2 = this.el.querySelector(`[name="${t2}"], [column="${t2}"]`);
        return i2 && (i2.hidden = e2), Promise.resolve();
    }
    _setFirstCellProperties() {
        var t2, e2, i2;
        return (null === (t2 = this.cells) || void 0 === t2 ? void 0 : t2.length) && this.isStylableCell(this.cells[0]) && (null === (i2 = (e2 = this.cells[0])._updateFirstCellProperties) || void 0 === i2 || i2.call(e2, this.el)), Promise.resolve();
    }
    setLeadingIndentation(t2) {
        return this.leadingIndentation = t2, Promise.resolve();
    }
    toggleNestedRow() {
        return this.expanded = !this.expanded, this.marketAccordionToggled.emit({
            expanded: this.expanded
        }), this.marketNestedRowToggled.emit({
            expanded: this.expanded
        }), Promise.resolve();
    }
    isStylableCell(t2) {
        return void 0 !== t2._updateColumnRelatedProperties && void 0 !== t2._updateFirstCellProperties;
    }
    setCellColumnProperties(t2) {
        this.cells && t2 && t2.length > 0 && this.cells.forEach((e2, i2)=>{
            this.isStylableCell(e2) && e2._updateColumnRelatedProperties(t2[i2]);
        });
    }
    emitStickyEvents() {
        let t2;
        this.stickTo ? t2 = this.stickTo : this.header ? t2 = "top" : this.footer && (t2 = "bottom"), this.sticky || this.stickTo ? this.marketTableRowStick.emit({
            position: t2,
            index: this.index
        }) : this.componentLoaded && this.marketTableRowUnstick.emit({
            position: t2,
            index: this.index
        });
    }
    componentWillLoad() {
        this.originalSlot = this.el.slot, this.header = "header" === this.originalSlot, this.footer = "footer" === this.originalSlot, this.cells = this.el.querySelectorAll(l$s("market-table-cell"));
    }
    handleSlotChange() {
        this.cells = this.el.querySelectorAll(`${l$s("market-table-cell")}, ${l$s("market-table-column")}`), this.header && this.marketTableHeaderLoaded.emit({
            columns: this.el.querySelectorAll(l$s("market-table-column"))
        }), this.emitStickyEvents();
    }
    _getMarketRowElement(t2) {
        return t2.querySelector(l$s("market-table-row"));
    }
    _addCaretButtonToFirstCell() {
        this.cells && this.cells[0] && (this.nestedRowToggleButton = document.createElement("button"), Object.assign(this.nestedRowToggleButton, {
            slot: "nested-row-indicator",
            type: "button",
            ariaExpanded: "" + this.expanded,
            onclick: ()=>this.toggleNestedRow()
        }), this.nestedRowToggleButton.innerHTML = '<svg class="caret" width="14" height="8" viewBox="0 0 14 8" fill="none" style="transition-duration:300ms;" xmlns="http://www.w3.org/2000/svg">\n          <path\n            fill-rule="evenodd"\n            clip-rule="evenodd"\n            d="M7.70715 7.70711C7.31663 8.09763 6.68346 8.09763 6.29294 7.70711L0.29294 1.70711L1.70715 0.292892L7.00005 5.58579L12.2929 0.292893L13.7072 1.70711L7.70715 7.70711Z"\n            fill="currentColor"\n          />\n        </svg>', this.cells[0].append(this.nestedRowToggleButton));
    }
    _registerSlottedControl() {
        this.slottedControl = this.el.querySelector([
            '[slot="control"] ' + l$s("market-checkbox"),
            '[slot="control"] ' + l$s("market-toggle")
        ].join(",")), this.slottedControl && (this.slottedControl.setDisabled(this.disabled), this.slottedControl.setSelection(this.selected));
    }
    componentDidRender() {
        var t2, e2;
        const i2 = this.el.closest(l$s("market-accordion-item"));
        if (i2) {
            let o2;
            if ("custom-trigger" === this.el.slot) {
                const e3 = null === (t2 = i2.parentElement) || void 0 === t2 ? void 0 : t2.closest(l$s("market-accordion-item"));
                e3 && (o2 = [
                    ...e3.children
                ].find((t3)=>"custom-trigger" === t3.slot));
            } else o2 = [
                ...i2.children
            ].find((t3)=>"custom-trigger" === t3.slot);
            this.leadingIndentation = o2 ? (null !== (e2 = o2.leadingIndentation) && void 0 !== e2 ? e2 : 0) + 1 : 0;
        }
        this._setFirstCellProperties();
    }
    componentDidLoad() {
        if (this.componentLoaded = true, "custom-trigger" === this.el.slot) {
            this._addCaretButtonToFirstCell();
            const t2 = this.nestedRowToggleButton.querySelector("svg");
            t2 && this.expanded && (t2.style.transform = "rotate(-180deg)");
        }
    }
    handleClick(t2) {
        [
            l$s("market-accessory"),
            l$s("market-button"),
            l$s("market-button-dropdown"),
            l$s("market-checkbox"),
            l$s("market-link"),
            l$s("market-toggle"),
            "button",
            "a"
        ].some((e2)=>t2.target.closest(e2)) || this.interactive && this.marketTableRowClicked.emit();
    }
    handleKeydown(t2) {
        if (t2.target === this.el) switch(t2.key){
            case "Enter":
                this.handleClick(t2);
                break;
            case " ":
                this.handleClick(t2), t2.preventDefault();
        }
    }
    render() {
        const { disabled: t2, footer: e2, gridTemplateLeft: i2, gridTemplateMain: r2, gridTemplateRight: a2, header: n2, interactive: d2, selected: c, slottedControl: h } = this, b = l$s("market-table-area");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ae38de31e95af2782cdd90e6361a3dcba5b8b1b2",
            "aria-selected": h ? "" + !!c : null,
            class: "market-table-row",
            role: "row",
            tabindex: d2 && !t2 ? "0" : null,
            header: n2,
            footer: e2,
            onClick: (t3)=>this.handleClick(t3),
            onKeydown: (t3)=>this.handleKeydown(t3)
        }, (0, $696Z8.h)(b, {
            key: "40140ccfcc46bf5601b8ce1ef039844fe383c969",
            orientation: "vertical",
            "stick-to": "left",
            gridTemplate: i2,
            ref: (t3)=>this.tableAreaLeft = t3
        }, (0, $696Z8.h)("slot", {
            key: "044a9d12306c3fb9e0236fe90bbc8311bbe039b0",
            name: "sticky-left"
        })), (0, $696Z8.h)(b, {
            key: "10fa520c4a4b85e3ea18c372d57fe49af48448b9",
            orientation: "vertical",
            gridTemplate: r2,
            ref: (t3)=>this.tableAreaMain = t3,
            active: true
        }, (0, $696Z8.h)("slot", {
            key: "30cda8268491e099bd2b52ae5a614e9e5bf9ccd3",
            name: "control",
            onSlotchange: ()=>this._registerSlottedControl()
        }), (0, $696Z8.h)("slot", {
            key: "2ed9bdb374abc6870088a7653b050c958981da8c",
            onSlotchange: ()=>this.handleSlotChange()
        })), (0, $696Z8.h)(b, {
            key: "26ebc6a9097a0d06b3b920bbd4280e0d7bcceedc",
            orientation: "vertical",
            "stick-to": "right",
            gridTemplate: a2,
            ref: (t3)=>this.tableAreaRight = t3
        }, (0, $696Z8.h)("slot", {
            key: "a88e62facd38a9fdde3f83d4243498b2fddb9b23",
            name: "sticky-right"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            gridTemplateMain: [
                {
                    formNewGridTemplate: 0
                }
            ],
            gridTemplateLeft: [
                {
                    formNewGridTemplate: 0
                }
            ],
            gridTemplateRight: [
                {
                    formNewGridTemplate: 0
                }
            ],
            gridTemplate: [
                {
                    gridTemplateObserver: 0
                }
            ],
            stickTo: [
                {
                    stickyObserver: 0
                }
            ],
            sticky: [
                {
                    stickyObserver: 0
                }
            ],
            tableColumns: [
                {
                    columnsObserver: 0
                }
            ],
            cells: [
                {
                    updateCellProperties: 0
                }
            ],
            leadingIndentation: [
                {
                    updateFirstCellProperties: 0
                }
            ],
            expanded: [
                {
                    updateNestedRowButton: 0
                }
            ],
            selected: [
                {
                    updateSlottedControlCheckedValue: 0
                }
            ],
            disabled: [
                {
                    updateSlottedControlDisabledValue: 0
                }
            ]
        };
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);position:relative;display:grid;grid-column:1 / -1;grid-auto-columns:1fr;grid-auto-flow:column;border-bottom:var(--table-border-width, 1px) solid var(--table-row-border-color, var(--core-divider-20-color));transition:background-color var(--transition-duration)}@media (hover: hover){:host{}:host([interactive]:not([disabled]):hover) ::slotted(.market-table-cell){background-color:var(--table-cell-hover-state-background-color, var(--core-fill-50-color))}}:host([header]){border-bottom:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([footer]) ::slotted(.market-table-cell){border-bottom:none;font-weight:var(--table-footing-primary-text-font-weight, 500);font-size:var(--table-footing-primary-text-font-size, var(--core-type-semibold-20-size));line-height:var(--table-footing-primary-text-line-height, var(--core-type-semibold-20-leading))}:host([interactive]) ::slotted(.market-table-cell){cursor:pointer}:host([interactive]:focus){outline:none;}:host([interactive]:not([disabled]):focus) ::slotted(.market-table-cell){background-color:var(--table-cell-focus-state-background-color)}:host([interactive]:not([disabled]):active) ::slotted(.market-table-cell){background-color:var(--table-cell-pressed-state-background-color)}:host([active]) ::slotted(.market-table-cell){background-color:var(--table-cell-selected-state-background-color)}:host([active]) ::slotted(.market-table-cell),:host([interactive]:not([disabled]):active) ::slotted(.market-table-cell){background-color:var(--table-cell-pressed-state-background-color, var(--core-emphasis-40-color))}:host([interactive][disabled]){pointer-events:none}:host([disabled]) ::slotted(.market-table-cell){background-color:transparent;color:var(--table-cell-disabled-state-text-color, var(--core-text-30-color));pointer-events:none}:host([nested]) ::slotted(.market-table-cell:first-of-type){padding-left:calc(         (           var(--cell-indent-level) *           var(--table-row-indentation-padding, 40px)         ) +         var(--table-cell-padding, 8px) +         var(--table-accordion-content-width, 30px)       )}:host([slot='custom-trigger']) ::slotted(.market-table-cell:first-of-type),:host([slot='header']) ::slotted(.market-table-cell:first-of-type),:host([slot='footer']) ::slotted(.market-table-cell:first-of-type){padding-left:var(--table-cell-padding, 8px)}:host ::slotted(.market-table-cell:first-of-type){padding-left:calc(       var(--table-cell-padding, 8px) +       (var(--cell-indent-level) * var(--table-row-indentation-padding, 40px))     )}";
    }
}, [
    257,
    "market-table-row",
    {
        leadingIndentation: [
            1538,
            "leading-indentation"
        ],
        stickTo: [
            1544,
            "stick-to"
        ],
        sticky: [
            1540
        ],
        active: [
            516
        ],
        interactive: [
            516
        ],
        disabled: [
            516
        ],
        selected: [
            1540
        ],
        header: [
            1540
        ],
        footer: [
            1540
        ],
        originalSlot: [
            1025,
            "original-slot"
        ],
        index: [
            2
        ],
        tableColumns: [
            16
        ],
        cells: [
            1040
        ],
        gridTemplateMain: [
            16
        ],
        gridTemplateLeft: [
            16
        ],
        gridTemplateRight: [
            16
        ],
        expanded: [
            1028
        ],
        nested: [
            516
        ],
        styleDeclaration: [
            32
        ],
        gridTemplate: [
            32
        ],
        nestedRowToggleButton: [
            32
        ],
        stick: [
            64
        ],
        unstick: [
            64
        ],
        _stickColumn: [
            64
        ],
        _unstickColumn: [
            64
        ],
        _syncColumnVisibilityWithCells: [
            64
        ],
        _setFirstCellProperties: [
            64
        ],
        setLeadingIndentation: [
            64
        ],
        toggleNestedRow: [
            64
        ]
    },
    [
        [
            0,
            "marketCheckboxValueChange",
            "handleMarketCheckboxValueChange"
        ],
        [
            0,
            "marketToggleChange",
            "handleMarketCheckboxValueChange"
        ]
    ],
    {
        gridTemplateMain: [
            {
                formNewGridTemplate: 0
            }
        ],
        gridTemplateLeft: [
            {
                formNewGridTemplate: 0
            }
        ],
        gridTemplateRight: [
            {
                formNewGridTemplate: 0
            }
        ],
        gridTemplate: [
            {
                gridTemplateObserver: 0
            }
        ],
        stickTo: [
            {
                stickyObserver: 0
            }
        ],
        sticky: [
            {
                stickyObserver: 0
            }
        ],
        tableColumns: [
            {
                columnsObserver: 0
            }
        ],
        cells: [
            {
                updateCellProperties: 0
            }
        ],
        leadingIndentation: [
            {
                updateFirstCellProperties: 0
            }
        ],
        expanded: [
            {
                updateNestedRowButton: 0
            }
        ],
        selected: [
            {
                updateSlottedControlCheckedValue: 0
            }
        ],
        disabled: [
            {
                updateSlottedControlDisabledValue: 0
            }
        ]
    }
]), n$3 = a$1;
function x(t2, r2) {
    if (null == t2) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var n2 in r2)Object.prototype.hasOwnProperty.call(r2, n2) && (t2[n2] = r2[n2]);
    return t2;
}
function g$1(t2, r2) {
    (null == r2 || r2 > t2.length) && (r2 = t2.length);
    for(var n2 = 0, e2 = Array(r2); n2 < r2; n2++)e2[n2] = t2[n2];
    return e2;
}
function T(t2, r2) {
    var n2 = "undefined" != typeof Symbol && t2[Symbol.iterator] || t2["@@iterator"];
    if (!n2) {
        if (Array.isArray(t2) || (n2 = function(t3, r3) {
            if (t3) {
                if ("string" == typeof t3) return g$1(t3, r3);
                var n3 = ({}).toString.call(t3).slice(8, -1);
                return "Object" === n3 && t3.constructor && (n3 = t3.constructor.name), "Map" === n3 || "Set" === n3 ? Array.from(t3) : "Arguments" === n3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? g$1(t3, r3) : void 0;
            }
        }(t2)) || r2) {
            n2 && (t2 = n2);
            var e2 = 0, i2 = function() {};
            return {
                s: i2,
                n: function() {
                    return e2 >= t2.length ? {
                        done: true
                    } : {
                        done: false,
                        value: t2[e2++]
                    };
                },
                e: function(t3) {
                    throw t3;
                },
                f: i2
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a2, o2 = true, u2 = false;
    return {
        s: function() {
            n2 = n2.call(t2);
        },
        n: function() {
            var t3 = n2.next();
            return o2 = t3.done, t3;
        },
        e: function(t3) {
            u2 = true, a2 = t3;
        },
        f: function() {
            try {
                o2 || null == n2.return || n2.return();
            } finally{
                if (u2) throw a2;
            }
        }
    };
}
function A(t2) {
    if (void 0 === t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t2;
}
function D(t2, r2) {
    return D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, r3) {
        return t3.__proto__ = r3, t3;
    }, D(t2, r2);
}
function E(t2, r2) {
    if ("function" != typeof r2 && null !== r2) throw new TypeError("Super expression must either be null or a function");
    t2.prototype = Object.create(r2 && r2.prototype, {
        constructor: {
            value: t2,
            writable: true,
            configurable: true
        }
    }), Object.defineProperty(t2, "prototype", {
        writable: false
    }), r2 && D(t2, r2);
}
function M(t2) {
    return M = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
        return t3.__proto__ || Object.getPrototypeOf(t3);
    }, M(t2);
}
function q() {
    try {
        var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t3) {}
    return (q = function() {
        return !!t2;
    })();
}
function R(t2) {
    var n2 = q();
    return function() {
        var e2, i2 = M(t2);
        if (n2) {
            var a2 = M(this).constructor;
            e2 = Reflect.construct(i2, arguments, a2);
        } else e2 = i2.apply(this, arguments);
        return function(t3, n3) {
            if (n3 && ("object" == e$8(n3) || "function" == typeof n3)) return n3;
            if (void 0 !== n3) throw new TypeError("Derived constructors may only return object or undefined");
            return A(t3);
        }(this, e2);
    };
}
function Q(t2, r2) {
    if (!(t2 instanceof r2)) throw new TypeError("Cannot call a class as a function");
}
function I(t2) {
    var n2 = function(t3) {
        if ("object" != e$8(t3) || !t3) return t3;
        var n3 = t3[Symbol.toPrimitive];
        if (void 0 !== n3) {
            var e2 = n3.call(t3, "string");
            if ("object" != e$8(e2)) return e2;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t3);
    }(t2);
    return "symbol" == e$8(n2) ? n2 : n2 + "";
}
function L(t2, r2) {
    return r2 && function(t3, r3) {
        for(var n2 = 0; n2 < r3.length; n2++){
            var e2 = r3[n2];
            e2.enumerable = e2.enumerable || false, e2.configurable = true, "value" in e2 && (e2.writable = true), Object.defineProperty(t3, I(e2.key), e2);
        }
    }(t2.prototype, r2), Object.defineProperty(t2, "prototype", {
        writable: false
    }), t2;
}
function j(t2, r2, n2) {
    return (r2 = I(r2)) in t2 ? Object.defineProperty(t2, r2, {
        value: n2,
        enumerable: true,
        configurable: true,
        writable: true
    }) : t2[r2] = n2, t2;
}
var B = function() {
    function t2() {
        Q(this, t2), j(this, "priority", void 0), j(this, "subPriority", 0);
    }
    return L(t2, [
        {
            key: "validate",
            value: function() {
                return true;
            }
        }
    ]), t2;
}(), Y = function() {
    E(r2, B);
    var t2 = R(r2);
    function r2(n2, e2, i2, a2, o2) {
        var u2;
        return Q(this, r2), (u2 = t2.call(this)).value = n2, u2.validateValue = e2, u2.setValue = i2, u2.priority = a2, o2 && (u2.subPriority = o2), u2;
    }
    return L(r2, [
        {
            key: "validate",
            value: function(t3, r3) {
                return this.validateValue(t3, this.value, r3);
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return this.setValue(t3, r3, this.value, n2);
            }
        }
    ]), r2;
}(), O = function() {
    E(r2, B);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 10), j(A(n2), "subPriority", -1), n2;
    }
    return L(r2, [
        {
            key: "set",
            value: function(t3, r3) {
                if (r3.timestampIsSet) return t3;
                var n2 = /* @__PURE__ */ new Date(0);
                return n2.setFullYear(t3.getUTCFullYear(), t3.getUTCMonth(), t3.getUTCDate()), n2.setHours(t3.getUTCHours(), t3.getUTCMinutes(), t3.getUTCSeconds(), t3.getUTCMilliseconds()), n2;
            }
        }
    ]), r2;
}(), N = function() {
    function t2() {
        Q(this, t2), j(this, "incompatibleTokens", void 0), j(this, "priority", void 0), j(this, "subPriority", void 0);
    }
    return L(t2, [
        {
            key: "run",
            value: function(t3, r2, n2, e2) {
                var i2 = this.parse(t3, r2, n2, e2);
                return i2 ? {
                    setter: new Y(i2.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: i2.rest
                } : null;
            }
        },
        {
            key: "validate",
            value: function() {
                return true;
            }
        }
    ]), t2;
}(), S = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 140), j(A(n2), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "G":
                    case "GG":
                    case "GGG":
                        return n2.era(t3, {
                            width: "abbreviated"
                        }) || n2.era(t3, {
                            width: "narrow"
                        });
                    case "GGGGG":
                        return n2.era(t3, {
                            width: "narrow"
                        });
                    default:
                        return n2.era(t3, {
                            width: "wide"
                        }) || n2.era(t3, {
                            width: "abbreviated"
                        }) || n2.era(t3, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return r3.era = n2, t3.setUTCFullYear(n2, 0, 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), G = /^(1[0-2]|0?\d)/, X = /^(3[0-1]|[0-2]?\d)/, H = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, K = /^(5[0-3]|[0-4]?\d)/, P = /^(2[0-3]|[0-1]?\d)/, Z = /^(2[0-4]|[0-1]?\d)/, C = /^(1[0-1]|0?\d)/, $ = /^(1[0-2]|0?\d)/, W = /^[0-5]?\d/, z = /^[0-5]?\d/, F = /^\d/, U = /^\d{1,2}/, _ = /^\d{1,3}/, J = /^\d{1,4}/, V = /^-?\d+/, tt = /^-?\d/, rt = /^-?\d{1,2}/, nt = /^-?\d{1,3}/, et = /^-?\d{1,4}/, it = /^([+-])(\d{2})(\d{2})?|Z/, at = /^([+-])(\d{2})(\d{2})|Z/, ot = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, ut = /^([+-])(\d{2}):(\d{2})|Z/, ct = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function st(t2, r2) {
    return t2 ? {
        value: r2(t2.value),
        rest: t2.rest
    } : t2;
}
function ft(t2, r2) {
    var n2 = r2.match(t2);
    return n2 ? {
        value: parseInt(n2[0], 10),
        rest: r2.slice(n2[0].length)
    } : null;
}
function vt(t2, r2) {
    var n2 = r2.match(t2);
    if (!n2) return null;
    if ("Z" === n2[0]) return {
        value: 0,
        rest: r2.slice(1)
    };
    var e2 = "+" === n2[1] ? 1 : -1, i2 = n2[2] ? parseInt(n2[2], 10) : 0, a2 = n2[3] ? parseInt(n2[3], 10) : 0, s2 = n2[5] ? parseInt(n2[5], 10) : 0;
    return {
        value: e2 * (i2 * o$c + a2 * i$g + s2 * u$a),
        rest: r2.slice(n2[0].length)
    };
}
function lt(t2) {
    return ft(V, t2);
}
function dt(t2, r2) {
    switch(t2){
        case 1:
            return ft(F, r2);
        case 2:
            return ft(U, r2);
        case 3:
            return ft(_, r2);
        case 4:
            return ft(J, r2);
        default:
            return ft(new RegExp("^\\d{1," + t2 + "}"), r2);
    }
}
function wt(t2, r2) {
    switch(t2){
        case 1:
            return ft(tt, r2);
        case 2:
            return ft(rt, r2);
        case 3:
            return ft(nt, r2);
        case 4:
            return ft(et, r2);
        default:
            return ft(new RegExp("^-?\\d{1," + t2 + "}"), r2);
    }
}
function ht(t2) {
    switch(t2){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        default:
            return 0;
    }
}
function yt(t2, r2) {
    var n2, e2 = r2 > 0, i2 = e2 ? r2 : 1 - r2;
    if (i2 <= 50) n2 = t2 || 100;
    else {
        var a2 = i2 + 50;
        n2 = t2 + 100 * Math.floor(a2 / 100) - (t2 >= a2 % 100 ? 100 : 0);
    }
    return e2 ? n2 : 1 - n2;
}
function mt(t2) {
    return t2 % 400 == 0 || t2 % 4 == 0 && t2 % 100 != 0;
}
var bt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 130), j(A(n2), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                var e2 = function(t4) {
                    return {
                        year: t4,
                        isTwoDigitYear: "yy" === r3
                    };
                };
                switch(r3){
                    case "y":
                        return st(dt(4, t3), e2);
                    case "yo":
                        return st(n2.ordinalNumber(t3, {
                            unit: "year"
                        }), e2);
                    default:
                        return st(dt(r3.length, t3), e2);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3.isTwoDigitYear || r3.year > 0;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                var e2 = t3.getUTCFullYear();
                if (n2.isTwoDigitYear) {
                    var i2 = yt(n2.year, e2);
                    return t3.setUTCFullYear(i2, 0, 1), t3.setUTCHours(0, 0, 0, 0), t3;
                }
                return t3.setUTCFullYear("era" in r3 && 1 !== r3.era ? 1 - n2.year : n2.year, 0, 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), pt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 130), j(A(n2), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                var e2 = function(t4) {
                    return {
                        year: t4,
                        isTwoDigitYear: "YY" === r3
                    };
                };
                switch(r3){
                    case "Y":
                        return st(dt(4, t3), e2);
                    case "Yo":
                        return st(n2.ordinalNumber(t3, {
                            unit: "year"
                        }), e2);
                    default:
                        return st(dt(r3.length, t3), e2);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3.isTwoDigitYear || r3.year > 0;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2, e2) {
                var i2 = f$9(t3, e2);
                if (n2.isTwoDigitYear) {
                    var a2 = yt(n2.year, i2);
                    return t3.setUTCFullYear(a2, 0, e2.firstWeekContainsDate), t3.setUTCHours(0, 0, 0, 0), m$6(t3, e2);
                }
                return t3.setUTCFullYear("era" in r3 && 1 !== r3.era ? 1 - n2.year : n2.year, 0, e2.firstWeekContainsDate), t3.setUTCHours(0, 0, 0, 0), m$6(t3, e2);
            }
        }
    ]), r2;
}(), kt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 130), j(A(n2), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3) {
                return wt("R" === r3 ? 4 : r3.length, t3);
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                var e2 = /* @__PURE__ */ new Date(0);
                return e2.setUTCFullYear(n2, 0, 4), e2.setUTCHours(0, 0, 0, 0), s$k(e2);
            }
        }
    ]), r2;
}(), xt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 130), j(A(n2), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3) {
                return wt("u" === r3 ? 4 : r3.length, t3);
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCFullYear(n2, 0, 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), gt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 120), j(A(n2), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "Q":
                    case "QQ":
                        return dt(r3.length, t3);
                    case "Qo":
                        return n2.ordinalNumber(t3, {
                            unit: "quarter"
                        });
                    case "QQQ":
                        return n2.quarter(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.quarter(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "QQQQQ":
                        return n2.quarter(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.quarter(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.quarter(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.quarter(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 4;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMonth(3 * (n2 - 1), 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Tt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 120), j(A(n2), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "q":
                    case "qq":
                        return dt(r3.length, t3);
                    case "qo":
                        return n2.ordinalNumber(t3, {
                            unit: "quarter"
                        });
                    case "qqq":
                        return n2.quarter(t3, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || n2.quarter(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "qqqqq":
                        return n2.quarter(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    default:
                        return n2.quarter(t3, {
                            width: "wide",
                            context: "standalone"
                        }) || n2.quarter(t3, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || n2.quarter(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 4;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMonth(3 * (n2 - 1), 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), At = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), j(A(n2), "priority", 110), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                var e2 = function(t4) {
                    return t4 - 1;
                };
                switch(r3){
                    case "M":
                        return st(ft(G, t3), e2);
                    case "MM":
                        return st(dt(2, t3), e2);
                    case "Mo":
                        return st(n2.ordinalNumber(t3, {
                            unit: "month"
                        }), e2);
                    case "MMM":
                        return n2.month(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.month(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "MMMMM":
                        return n2.month(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.month(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.month(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.month(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 11;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMonth(n2, 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Dt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 110), j(A(n2), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                var e2 = function(t4) {
                    return t4 - 1;
                };
                switch(r3){
                    case "L":
                        return st(ft(G, t3), e2);
                    case "LL":
                        return st(dt(2, t3), e2);
                    case "Lo":
                        return st(n2.ordinalNumber(t3, {
                            unit: "month"
                        }), e2);
                    case "LLL":
                        return n2.month(t3, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || n2.month(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "LLLLL":
                        return n2.month(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    default:
                        return n2.month(t3, {
                            width: "wide",
                            context: "standalone"
                        }) || n2.month(t3, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || n2.month(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 11;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMonth(n2, 1), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Et = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 100), j(A(n2), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "w":
                        return ft(K, t3);
                    case "wo":
                        return n2.ordinalNumber(t3, {
                            unit: "week"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 53;
            }
        },
        {
            key: "set",
            value: function(t3, r3, a2, o2) {
                return m$6(function(t4, r4, a3) {
                    n$q(2, arguments);
                    var o3 = o$d(t4), u2 = t$3(r4), c2 = c$l(o3, a3) - u2;
                    return o3.setUTCDate(o3.getUTCDate() - 7 * c2), o3;
                }(t3, a2, o2), o2);
            }
        }
    ]), r2;
}(), Mt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 100), j(A(n2), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "I":
                        return ft(K, t3);
                    case "Io":
                        return n2.ordinalNumber(t3, {
                            unit: "week"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 53;
            }
        },
        {
            key: "set",
            value: function(t3, r3, a2) {
                return s$k(function(t4, r4) {
                    n$q(2, arguments);
                    var a3 = o$d(t4), o2 = t$3(r4), u2 = l$i(a3) - o2;
                    return a3.setUTCDate(a3.getUTCDate() - 7 * u2), a3;
                }(t3, a2));
            }
        }
    ]), r2;
}(), qt = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], Rt = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], Qt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 90), j(A(n2), "subPriority", 1), j(A(n2), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "d":
                        return ft(X, t3);
                    case "do":
                        return n2.ordinalNumber(t3, {
                            unit: "date"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                var n2 = mt(t3.getUTCFullYear()), e2 = t3.getUTCMonth();
                return n2 ? r3 >= 1 && r3 <= Rt[e2] : r3 >= 1 && r3 <= qt[e2];
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCDate(n2), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), It = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 90), j(A(n2), "subpriority", 1), j(A(n2), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "D":
                    case "DD":
                        return ft(H, t3);
                    case "Do":
                        return n2.ordinalNumber(t3, {
                            unit: "date"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return mt(t3.getUTCFullYear()) ? r3 >= 1 && r3 <= 366 : r3 >= 1 && r3 <= 365;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMonth(0, n2), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}();
function Lt(t2, r2, o2) {
    var u2, c2, s2, f2, v2, l2, d2, w2;
    n$q(2, arguments);
    var h2 = a$k(), y2 = t$3(null !== (u2 = null !== (c2 = null !== (s2 = null !== (f2 = null == o2 ? void 0 : o2.weekStartsOn) && void 0 !== f2 ? f2 : null == o2 || null === (v2 = o2.locale) || void 0 === v2 || null === (l2 = v2.options) || void 0 === l2 ? void 0 : l2.weekStartsOn) && void 0 !== s2 ? s2 : h2.weekStartsOn) && void 0 !== c2 ? c2 : null === (d2 = h2.locale) || void 0 === d2 || null === (w2 = d2.options) || void 0 === w2 ? void 0 : w2.weekStartsOn) && void 0 !== u2 ? u2 : 0);
    if (!(y2 >= 0 && y2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var m2 = o$d(t2), b2 = t$3(r2), p2 = ((b2 % 7 + 7) % 7 < y2 ? 7 : 0) + b2 - m2.getUTCDay();
    return m2.setUTCDate(m2.getUTCDate() + p2), m2;
}
var jt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 90), j(A(n2), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "E":
                    case "EE":
                    case "EEE":
                        return n2.day(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "EEEEE":
                        return n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "EEEEEE":
                        return n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.day(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 6;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2, e2) {
                return (t3 = Lt(t3, n2, e2)).setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Bt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 90), j(A(n2), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2, e2) {
                var i2 = function(t4) {
                    var r4 = 7 * Math.floor((t4 - 1) / 7);
                    return (t4 + e2.weekStartsOn + 6) % 7 + r4;
                };
                switch(r3){
                    case "e":
                    case "ee":
                        return st(dt(r3.length, t3), i2);
                    case "eo":
                        return st(n2.ordinalNumber(t3, {
                            unit: "day"
                        }), i2);
                    case "eee":
                        return n2.day(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "eeeee":
                        return n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "eeeeee":
                        return n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.day(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 6;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2, e2) {
                return (t3 = Lt(t3, n2, e2)).setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Yt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 90), j(A(n2), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2, e2) {
                var i2 = function(t4) {
                    var r4 = 7 * Math.floor((t4 - 1) / 7);
                    return (t4 + e2.weekStartsOn + 6) % 7 + r4;
                };
                switch(r3){
                    case "c":
                    case "cc":
                        return st(dt(r3.length, t3), i2);
                    case "co":
                        return st(n2.ordinalNumber(t3, {
                            unit: "day"
                        }), i2);
                    case "ccc":
                        return n2.day(t3, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "standalone"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "ccccc":
                        return n2.day(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    case "cccccc":
                        return n2.day(t3, {
                            width: "short",
                            context: "standalone"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                    default:
                        return n2.day(t3, {
                            width: "wide",
                            context: "standalone"
                        }) || n2.day(t3, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "standalone"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 6;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2, e2) {
                return (t3 = Lt(t3, n2, e2)).setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Ot = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 90), j(A(n2), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                var e2 = function(t4) {
                    return 0 === t4 ? 7 : t4;
                };
                switch(r3){
                    case "i":
                    case "ii":
                        return dt(r3.length, t3);
                    case "io":
                        return n2.ordinalNumber(t3, {
                            unit: "day"
                        });
                    case "iii":
                        return st(n2.day(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        }), e2);
                    case "iiiii":
                        return st(n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        }), e2);
                    case "iiiiii":
                        return st(n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        }), e2);
                    default:
                        return st(n2.day(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "short",
                            context: "formatting"
                        }) || n2.day(t3, {
                            width: "narrow",
                            context: "formatting"
                        }), e2);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 7;
            }
        },
        {
            key: "set",
            value: function(t3, r3, a2) {
                return t3 = function(t4, r4) {
                    n$q(2, arguments);
                    var a3 = t$3(r4);
                    a3 % 7 == 0 && (a3 -= 7);
                    var o2 = o$d(t4), u2 = ((a3 % 7 + 7) % 7 < 1 ? 7 : 0) + a3 - o2.getUTCDay();
                    return o2.setUTCDate(o2.getUTCDate() + u2), o2;
                }(t3, a2), t3.setUTCHours(0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Nt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 80), j(A(n2), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "a":
                    case "aa":
                    case "aaa":
                        return n2.dayPeriod(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.dayPeriod(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCHours(ht(n2), 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), St = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 80), j(A(n2), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "b":
                    case "bb":
                    case "bbb":
                        return n2.dayPeriod(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.dayPeriod(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCHours(ht(n2), 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Gt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 80), j(A(n2), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "B":
                    case "BB":
                    case "BBB":
                        return n2.dayPeriod(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                    default:
                        return n2.dayPeriod(t3, {
                            width: "wide",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || n2.dayPeriod(t3, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCHours(ht(n2), 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Xt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 70), j(A(n2), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "h":
                        return ft($, t3);
                    case "ho":
                        return n2.ordinalNumber(t3, {
                            unit: "hour"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 12;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                var e2 = t3.getUTCHours() >= 12;
                return t3.setUTCHours(e2 && n2 < 12 ? n2 + 12 : e2 || 12 !== n2 ? n2 : 0, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Ht = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 70), j(A(n2), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "H":
                        return ft(P, t3);
                    case "Ho":
                        return n2.ordinalNumber(t3, {
                            unit: "hour"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 23;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCHours(n2, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Kt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 70), j(A(n2), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "K":
                        return ft(C, t3);
                    case "Ko":
                        return n2.ordinalNumber(t3, {
                            unit: "hour"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 11;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                var e2 = t3.getUTCHours() >= 12;
                return t3.setUTCHours(e2 && n2 < 12 ? n2 + 12 : n2, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Pt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 70), j(A(n2), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "k":
                        return ft(Z, t3);
                    case "ko":
                        return n2.ordinalNumber(t3, {
                            unit: "hour"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 1 && r3 <= 24;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCHours(n2 <= 24 ? n2 % 24 : n2, 0, 0, 0), t3;
            }
        }
    ]), r2;
}(), Zt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 60), j(A(n2), "incompatibleTokens", [
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "m":
                        return ft(W, t3);
                    case "mo":
                        return n2.ordinalNumber(t3, {
                            unit: "minute"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 59;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMinutes(n2, 0, 0), t3;
            }
        }
    ]), r2;
}(), Ct = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 50), j(A(n2), "incompatibleTokens", [
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3, n2) {
                switch(r3){
                    case "s":
                        return ft(z, t3);
                    case "so":
                        return n2.ordinalNumber(t3, {
                            unit: "second"
                        });
                    default:
                        return dt(r3.length, t3);
                }
            }
        },
        {
            key: "validate",
            value: function(t3, r3) {
                return r3 >= 0 && r3 <= 59;
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCSeconds(n2, 0), t3;
            }
        }
    ]), r2;
}(), $t = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 30), j(A(n2), "incompatibleTokens", [
            "t",
            "T"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3) {
                return st(dt(r3.length, t3), function(t4) {
                    return Math.floor(t4 * Math.pow(10, 3 - r3.length));
                });
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return t3.setUTCMilliseconds(n2), t3;
            }
        }
    ]), r2;
}(), Wt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 10), j(A(n2), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3) {
                switch(r3){
                    case "X":
                        return vt(it, t3);
                    case "XX":
                        return vt(at, t3);
                    case "XXXX":
                        return vt(ot, t3);
                    case "XXXXX":
                        return vt(ct, t3);
                    default:
                        return vt(ut, t3);
                }
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return r3.timestampIsSet ? t3 : new Date(t3.getTime() - n2);
            }
        }
    ]), r2;
}(), zt = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 10), j(A(n2), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3, r3) {
                switch(r3){
                    case "x":
                        return vt(it, t3);
                    case "xx":
                        return vt(at, t3);
                    case "xxxx":
                        return vt(ot, t3);
                    case "xxxxx":
                        return vt(ct, t3);
                    default:
                        return vt(ut, t3);
                }
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return r3.timestampIsSet ? t3 : new Date(t3.getTime() - n2);
            }
        }
    ]), r2;
}(), Ft = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 40), j(A(n2), "incompatibleTokens", "*"), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3) {
                return lt(t3);
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return [
                    new Date(1e3 * n2),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]), r2;
}(), Ut = function() {
    E(r2, N);
    var t2 = R(r2);
    function r2() {
        var n2;
        Q(this, r2);
        for(var e2 = arguments.length, i2 = new Array(e2), a2 = 0; a2 < e2; a2++)i2[a2] = arguments[a2];
        return j(A(n2 = t2.call.apply(t2, [
            this
        ].concat(i2))), "priority", 20), j(A(n2), "incompatibleTokens", "*"), n2;
    }
    return L(r2, [
        {
            key: "parse",
            value: function(t3) {
                return lt(t3);
            }
        },
        {
            key: "set",
            value: function(t3, r3, n2) {
                return [
                    new Date(n2),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]), r2;
}(), _t = {
    G: new S(),
    y: new bt(),
    Y: new pt(),
    R: new kt(),
    u: new xt(),
    Q: new gt(),
    q: new Tt(),
    M: new At(),
    L: new Dt(),
    w: new Et(),
    I: new Mt(),
    d: new Qt(),
    D: new It(),
    E: new jt(),
    e: new Bt(),
    c: new Yt(),
    i: new Ot(),
    a: new Nt(),
    b: new St(),
    B: new Gt(),
    h: new Xt(),
    H: new Ht(),
    K: new Kt(),
    k: new Pt(),
    m: new Zt(),
    s: new Ct(),
    S: new $t(),
    X: new Wt(),
    x: new zt(),
    t: new Ft(),
    T: new Ut()
}, Jt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Vt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, tr = /^'([^]*?)'?$/, rr = /''/g, nr = /\S/, er = /[a-zA-Z]/;
function ir(t2, o2, u2, c2) {
    var s2, f2, v2, l2, d2, g2, A2, D2, E2;
    n$q(3, arguments);
    var M2 = String(t2), q2 = String(o2), R2 = a$k(), Q2 = null !== (s2 = R2.locale) && void 0 !== s2 ? s2 : A$5;
    if (!Q2.match) throw new RangeError("locale must contain match property");
    var I2 = t$3(null !== (f2 = null !== (v2 = R2.firstWeekContainsDate) && void 0 !== v2 ? v2 : null === (l2 = R2.locale) || void 0 === l2 || null === (d2 = l2.options) || void 0 === d2 ? void 0 : d2.firstWeekContainsDate) && void 0 !== f2 ? f2 : 1);
    if (!(I2 >= 1 && I2 <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var L2 = t$3(null !== (g2 = null !== (A2 = R2.weekStartsOn) && void 0 !== A2 ? A2 : null === (D2 = R2.locale) || void 0 === D2 || null === (E2 = D2.options) || void 0 === E2 ? void 0 : E2.weekStartsOn) && void 0 !== g2 ? g2 : 0);
    if (!(L2 >= 0 && L2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if ("" === q2) return "" === M2 ? o$d(u2) : /* @__PURE__ */ new Date(NaN);
    var j2, B2 = {
        firstWeekContainsDate: I2,
        weekStartsOn: L2,
        locale: Q2
    }, Y2 = [
        new O()
    ], N2 = q2.match(Vt).map(function(t3) {
        var r2 = t3[0];
        return r2 in w$6 ? (0, w$6[r2])(t3, Q2.formatLong) : t3;
    }).join("").match(Jt), S2 = [], G2 = T(N2);
    try {
        var X2 = function() {
            var r2 = j2.value;
            M$5(r2) && P$6(r2, q2, t2), p$7(r2) && P$6(r2, q2, t2);
            var n2 = r2[0], e2 = _t[n2];
            if (e2) {
                var i2 = e2.incompatibleTokens;
                if (Array.isArray(i2)) {
                    var a2 = S2.find(function(t3) {
                        return i2.includes(t3.token) || t3.token === n2;
                    });
                    if (a2) throw new RangeError("The format string mustn't contain `".concat(a2.fullToken, "` and `").concat(r2, "` at the same time"));
                } else if ("*" === e2.incompatibleTokens && S2.length > 0) throw new RangeError("The format string mustn't contain `".concat(r2, "` and any other token at the same time"));
                S2.push({
                    token: n2,
                    fullToken: r2
                });
                var o3 = e2.run(M2, r2, Q2.match, B2);
                if (!o3) return {
                    v: /* @__PURE__ */ new Date(NaN)
                };
                Y2.push(o3.setter), M2 = o3.rest;
            } else {
                if (n2.match(er)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + n2 + "`");
                if ("''" === r2 ? r2 = "'" : "'" === n2 && (r2 = r2.match(tr)[1].replace(rr, "'")), 0 !== M2.indexOf(r2)) return {
                    v: /* @__PURE__ */ new Date(NaN)
                };
                M2 = M2.slice(r2.length);
            }
        };
        for(G2.s(); !(j2 = G2.n()).done;){
            var H2 = X2();
            if ("object" === e$8(H2)) return H2.v;
        }
    } catch (t3) {
        G2.e(t3);
    } finally{
        G2.f();
    }
    if (M2.length > 0 && nr.test(M2)) return /* @__PURE__ */ new Date(NaN);
    var K2 = Y2.map(function(t3) {
        return t3.priority;
    }).sort(function(t3, r2) {
        return r2 - t3;
    }).filter(function(t3, r2, n2) {
        return n2.indexOf(t3) === r2;
    }).map(function(t3) {
        return Y2.filter(function(r2) {
            return r2.priority === t3;
        }).sort(function(t4, r2) {
            return r2.subPriority - t4.subPriority;
        });
    }).map(function(t3) {
        return t3[0];
    }), P2 = o$d(u2);
    if (isNaN(P2.getTime())) return /* @__PURE__ */ new Date(NaN);
    var Z2, C2 = d$d(P2, r$a(P2)), $2 = {}, W2 = T(K2);
    try {
        for(W2.s(); !(Z2 = W2.n()).done;){
            var z2 = Z2.value;
            if (!z2.validate(C2, B2)) return /* @__PURE__ */ new Date(NaN);
            var F2 = z2.set(C2, $2, B2);
            Array.isArray(F2) ? (C2 = F2[0], x($2, F2[1])) : C2 = F2;
        }
    } catch (t3) {
        W2.e(t3);
    } finally{
        W2.f();
    }
    return C2;
}
const ar = ({ items: r2, order: n2, column: e2, strategy: i2, format: a2 })=>{
    const o2 = [
        ...r2
    ];
    return o2.sort((r3, o3)=>{
        const u2 = {
            rowA: a$c(r3) ? r3.querySelector('[slot="parent"]') : r3,
            rowB: a$c(o3) ? o3.querySelector('[slot="parent"]') : o3,
            order: n2,
            column: e2
        };
        return "function" == typeof i2 ? i2(u2) : "number" === i2 ? or(u2) : "datetime" === i2 && a2 ? cr(Object.assign(Object.assign({}, u2), {
            format: a2
        })) : ur(u2);
    }), o2;
}, or = ({ rowA: t2, rowB: r2, order: n2, column: e2 })=>{
    var i2, a2, o2, u2, c2, s2;
    const f2 = Number.parseFloat(null !== (o2 = null === (a2 = null === (i2 = null == t2 ? void 0 : t2.children[e2]) || void 0 === i2 ? void 0 : i2.textContent) || void 0 === a2 ? void 0 : a2.trim()) && void 0 !== o2 ? o2 : ""), v2 = Number.parseFloat(null !== (s2 = null === (c2 = null === (u2 = null == r2 ? void 0 : r2.children[e2]) || void 0 === u2 ? void 0 : u2.textContent) || void 0 === c2 ? void 0 : c2.trim()) && void 0 !== s2 ? s2 : "");
    return "ascending" === n2 ? f2 - v2 : v2 - f2;
}, ur = ({ rowA: t2, rowB: r2, order: n2, column: e2 })=>{
    var i2, a2, o2, u2, c2, s2;
    const f2 = (null !== (o2 = null === (a2 = null === (i2 = null == t2 ? void 0 : t2.children[e2]) || void 0 === i2 ? void 0 : i2.textContent) || void 0 === a2 ? void 0 : a2.trim()) && void 0 !== o2 ? o2 : "").toUpperCase(), v2 = (null !== (s2 = null === (c2 = null === (u2 = null == r2 ? void 0 : r2.children[e2]) || void 0 === u2 ? void 0 : u2.textContent) || void 0 === c2 ? void 0 : c2.trim()) && void 0 !== s2 ? s2 : "").toUpperCase();
    return "ascending" === n2 ? f2 < v2 ? -1 : f2 > v2 ? 1 : 0 : f2 < v2 ? 1 : f2 > v2 ? -1 : 0;
}, cr = ({ rowA: t2, rowB: r2, order: n2, column: e2, format: i2 })=>{
    var a2, o2, u2, c2, s2, f2;
    const v2 = null !== (u2 = null === (o2 = null === (a2 = null == t2 ? void 0 : t2.children[e2]) || void 0 === a2 ? void 0 : a2.textContent) || void 0 === o2 ? void 0 : o2.trim()) && void 0 !== u2 ? u2 : "", l2 = null !== (f2 = null === (s2 = null === (c2 = null == r2 ? void 0 : r2.children[e2]) || void 0 === c2 ? void 0 : c2.textContent) || void 0 === s2 ? void 0 : s2.trim()) && void 0 !== f2 ? f2 : "", d2 = ir(v2, i2, /* @__PURE__ */ new Date()), w2 = ir(l2, i2, /* @__PURE__ */ new Date());
    return "ascending" === n2 ? d2 < w2 ? -1 : d2 > w2 ? 1 : 0 : d2 < w2 ? 1 : d2 > w2 ? -1 : 0;
};
const c$3 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketTableV2RowsReordered = (0, $696Z8.createEvent)(this, "marketTableV2RowsReordered", 7), this.collapsible = false, this.layout = "auto", this.reorderMode = "default", this.selected = "false";
    }
    async onMarketTableV2SelectionChange(e2) {
        const { header: t2, footer: r2 } = this, { target: a2, detail: l2 } = e2, o2 = l2.current;
        e2.stopPropagation(), a2 === t2 || a2 === r2 ? await this.setSelected(o2, {
            silent: true
        }) : await this.setSelectedFromChildEvent(e2);
    }
    onMarketTableV2CellSortClicked(e2) {
        const { el: t2, header: r2, children: a2, groups: l2, footer: o2 } = this, i2 = e2.target;
        if (i2.parentElement !== r2) return;
        const { current: s2 } = e2.detail, n2 = [
            ...r2.children
        ], c2 = n2.indexOf(i2), { sortStrategy: h2, sortStrategyFormat: g2 } = i2, b = ar({
            items: a2,
            order: s2,
            column: c2,
            strategy: h2,
            format: g2
        });
        null == l2 || l2.forEach((e3)=>{
            e3.sort({
                order: s2,
                column: c2,
                strategy: h2,
                format: g2
            });
        }), i2.sortOrder = s2, n2.forEach((e3)=>{
            e3.sortOrder = e3 === i2 ? s2 : void 0;
        }), b.forEach((e3)=>{
            t2.append(e3);
        }), o2 && t2.append(o2);
    }
    onDragMove(e2) {
        var t2;
        null === (t2 = this.reorder) || void 0 === t2 || t2.dragMove(e2);
    }
    onDragLeave() {
        var e2;
        null === (e2 = this.reorder) || void 0 === e2 || e2.dragLeave();
    }
    onDragEnd(e2) {
        var t2;
        null === (t2 = this.reorder) || void 0 === t2 || t2.dragEnd(e2);
    }
    onDragDrop(e2) {
        var t2;
        null === (t2 = this.reorder) || void 0 === t2 || t2.dragDrop(e2);
    }
    watchCollapsible() {
        const { rows: e2, groups: t2, collapsible: r2 } = this;
        t2.forEach((e3)=>{
            e3.collapsible = r2, e3.indent = 0;
        }), e2.forEach((e3)=>{
            e3.header || e3.footer || (e3.indent = r2 && t2.length > 0 ? 1 : 0);
        });
    }
    watchReorderable() {
        const { el: e2, reorder: t2, reorderable: r2, reorderMode: a2, marketTableV2RowsReordered: l2 } = this;
        if (null == t2 || t2.destroy(), [
            "internal",
            "external"
        ].includes(r2)) {
            const t3 = l$s("market-table-v2-row"), r3 = l$s("market-table-v2-group");
            this.reorder = new i$9({
                el: e2,
                accepts: [
                    t3 + ':not([header]):not([footer]):not([slot="parent"])',
                    r3
                ],
                event: l2,
                mode: a2
            });
        }
        this.syncDragEnabled();
    }
    async setSelected(e2, { silent: t2 = false } = {}) {
        const { header: r2, footer: a2, children: l2, selected: o2 } = this;
        return o2 === e2 || (this.selected = e2, await (null == r2 ? void 0 : r2.setSelected(e2, {
            silent: t2
        })), await (null == a2 ? void 0 : a2.setSelected(e2, {
            silent: t2
        })), null == l2 || l2.forEach(async (r3)=>{
            await r3.setSelected(e2, {
                silent: t2
            });
        })), Promise.resolve();
    }
    async setSelectedFromChildEvent(e2) {
        const { header: t2, footer: r2, children: a2, selected: l2 } = this, { target: o2, detail: i2 } = e2, { current: s2 } = i2, n2 = a2.map((e3)=>o2 === e3 ? s2 : e3.selected), d2 = n2.every((e3)=>"true" === e3) ? "true" : n2.every((e3)=>"false" === e3) ? "false" : "indeterminate";
        l2 !== d2 && (this.selected = d2, await (null == t2 ? void 0 : t2.setSelected(d2, {
            silent: true
        })), await (null == r2 ? void 0 : r2.setSelected(d2, {
            silent: true
        })));
    }
    getElements() {
        this.rows = [
            ...this.el.children
        ].filter((e2)=>e2.tagName === l$s("market-table-v2-row").toUpperCase()), this.groups = [
            ...this.el.children
        ].filter((e2)=>e2.tagName === l$s("market-table-v2-group").toUpperCase()), this.header = this.rows.find((e2)=>e2.header), this.footer = this.rows.find((e2)=>e2.footer), this.children = [
            ...this.groups,
            ...this.rows.filter((e2)=>!e2.header && !e2.footer)
        ];
    }
    syncDragEnabled() {
        const { header: e2, footer: t2, rows: r2, groups: a2, reorderable: l2, reorderMode: o2 } = this, i2 = [
            "internal",
            "external"
        ].includes(l2);
        e2 && (e2.dragEnabled = i2), t2 && (t2.dragEnabled = i2), null == r2 || r2.forEach((e3)=>{
            l$b(e3) && (e3.dragEnabled = i2);
        }), null == a2 || a2.forEach((e3)=>{
            e3.dragEnabled = i2, e3.reorderable = l2, e3.reorderMode = o2;
        });
    }
    onSlotChange() {
        this.getElements(), this.watchCollapsible(), this.syncDragEnabled();
    }
    connectedCallback() {
        this.getElements(), this.watchCollapsible(), this.syncDragEnabled();
    }
    componentDidRender() {
        this.watchReorderable();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "9439ffd2072776047f83148e99185f0d20313e18",
            class: "market-table-v2"
        }, (0, $696Z8.h)("div", {
            key: "fae9f97a17df6245d39fde47576c910796b12998",
            role: "table",
            part: "table"
        }, (0, $696Z8.h)("slot", {
            key: "f5f2d8d545193678ab2cbb30733f4cb2a0927156",
            onSlotchange: ()=>this.onSlotChange()
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            collapsible: [
                {
                    watchCollapsible: 0
                }
            ],
            reorderable: [
                {
                    watchReorderable: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,*{box-sizing:border-box}:host{--table-cell-state-normal-background-color:var(--core-surface-10-color);position:relative;display:block;overflow:auto;width:100%;background-color:var(--table-cell-state-normal-background-color);font-feature-settings:"tnum"}:host [role="table"]{display:table;vertical-align:middle;width:100%;height:100%;border-spacing:0;border-collapse:separate;table-layout:auto;text-align:left}:host slot{vertical-align:inherit;text-align:inherit}:host([layout="fixed"]) [role="table"]{table-layout:fixed}:host([align="left"]) [role="table"]{text-align:left}:host([align="center"]) [role="table"]{text-align:center}:host([align="right"]) [role="table"]{text-align:right}:host([valign="top"]) [role="table"]{vertical-align:top}:host([valign="middle"]) [role="table"]{vertical-align:middle}:host([valign="bottom"]) [role="table"]{vertical-align:bottom}::slotted(.market-drag-cursor){--drag-cursor-height:4px;position:absolute;right:0;left:0;z-index:3;display:block;height:0;outline:calc(var(--drag-cursor-height) / 2) solid var(--core-emphasis-fill-color);pointer-events:none}';
    }
}, [
    257,
    "market-table-v2",
    {
        align: [
            513
        ],
        collapsible: [
            516
        ],
        layout: [
            513
        ],
        reorderable: [
            513
        ],
        reorderMode: [
            1,
            "reorder-mode"
        ],
        selected: [
            1025
        ],
        valign: [
            513
        ],
        setSelected: [
            64
        ]
    },
    [
        [
            0,
            "marketInternalTableV2RowSelectionChange",
            "onMarketTableV2SelectionChange"
        ],
        [
            0,
            "marketInternalTableV2GroupSelectionChange",
            "onMarketTableV2SelectionChange"
        ],
        [
            0,
            "marketTableV2CellSortClicked",
            "onMarketTableV2CellSortClicked"
        ],
        [
            0,
            "marketDragMove",
            "onDragMove"
        ],
        [
            0,
            "marketDragLeave",
            "onDragLeave"
        ],
        [
            0,
            "marketDragEnd",
            "onDragEnd"
        ],
        [
            0,
            "marketDragDrop",
            "onDragDrop"
        ]
    ],
    {
        collapsible: [
            {
                watchCollapsible: 0
            }
        ],
        reorderable: [
            {
                watchReorderable: 0
            }
        ]
    }
]), h$2 = c$3;
function i$2(e2) {
    var t2;
    const r2 = null === (t2 = null == e2 ? void 0 : e2.tagName) || void 0 === t2 ? void 0 : t2.toLowerCase();
    return !(!e2 || r2 !== l$s("market-checkbox"));
}
const s$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketTableV2CellCaretClicked = (0, $696Z8.createEvent)(this, "marketTableV2CellCaretClicked", 7), this.marketTableV2CellSortClicked = (0, $696Z8.createEvent)(this, "marketTableV2CellSortClicked", 7), this.marketInternalTableV2CellSelectionChange = (0, $696Z8.createEvent)(this, "marketInternalTableV2CellSelectionChange", 7), this.active = false, this.caretAriaLabelExpanded = "Group of rows is expanded: click to collapse", this.caretAriaLabelCollapsed = "Group of rows is collapsed: click to expand", this.disabled = false, this.interactive = false, this.nowrap = false, this.selected = "false", this.sortAriaLabelAscending = "Sorted ascending: click to sort descending", this.sortAriaLabelDescending = "Sorted descending: click to sort ascending", this.sortAriaLabelNone = "Not sorted: click to sort ascending", this.sortOrder = "none", this.onKeydown = (e3)=>{
            const { target: t2, key: r2 } = e3, { el: a2, disabled: o2, interactive: n2 } = this;
            o2 || n2 && t2 === a2 && ("Enter" !== r2 && " " !== r2 || (e3.preventDefault(), a2.click()));
        };
    }
    async onMarketControlSelectionChange(e2) {
        const { control: t2 } = this, { target: r2, detail: a2 } = e2;
        if (r2 !== t2) return;
        const o2 = a2.current ? "true" : "false";
        await this.setSelected(o2);
    }
    async setSelected(e2, { silent: t2 = false } = {}) {
        const { marketInternalTableV2CellSelectionChange: r2, selected: a2 } = this;
        return a2 === e2 || (t2 || r2.emit({
            current: e2,
            previous: a2
        }), this.selected = e2, await this.setControlSelected(e2)), Promise.resolve();
    }
    async setControlSelected(e2) {
        const { control: t2 } = this;
        t2 && (await t2.setSelection("true" === e2, {
            silent: true
        }), i$2(t2) && await t2.setIndeterminate("indeterminate" === e2));
    }
    getTabIndex() {
        const { disabled: e2, interactive: t2 } = this;
        return t2 && !e2 ? "0" : null;
    }
    getStyles() {
        const { indent: e2 } = this;
        return !e2 || e2 < 1 ? {} : {
            "--table-cell-indent-level": "" + e2
        };
    }
    getSortButtonLabel() {
        const { sortOrder: e2, sortAriaLabelAscending: t2, sortAriaLabelDescending: r2, sortAriaLabelNone: a2 } = this;
        switch(e2){
            case "ascending":
                return t2;
            case "descending":
                return r2;
            default:
                return a2;
        }
    }
    onCaretClick(e2) {
        e2.stopPropagation(), this.marketTableV2CellCaretClicked.emit();
    }
    onSortClick() {
        const { sortOrder: e2, marketTableV2CellSortClicked: t2 } = this, r2 = e2 || "none", a2 = "ascending" === r2 ? "descending" : "ascending", { defaultPrevented: o2 } = t2.emit({
            current: a2,
            previous: r2
        });
        o2 || (this.sortOrder = a2);
    }
    async syncControlState() {
        const { el: e2, selected: t2 } = this, r2 = [
            ...e2.children
        ].find((e3)=>"control" === e3.slot);
        (function(e3) {
            return i$2(e3) || function(e4) {
                var t3;
                const r3 = null === (t3 = null == e4 ? void 0 : e4.tagName) || void 0 === t3 ? void 0 : t3.toLowerCase();
                return !(!e4 || r3 !== l$s("market-toggle"));
            }(e3);
        })(r2) && (this.control = r2, t2 && await this.setControlSelected(t2));
    }
    async connectedCallback() {
        await this.syncControlState();
    }
    renderCaretButton() {
        return (0, $696Z8.h)("button", {
            class: "caret-button",
            "aria-label": "down" === this.caret ? this.caretAriaLabelCollapsed : this.caretAriaLabelExpanded,
            onClick: (e2)=>this.onCaretClick(e2)
        }, (0, $696Z8.h)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.70715 11.7071C8.31663 12.0976 7.68346 12.0976 7.29294 11.7071L1.29294 5.70711L2.70715 4.29289L8.00005 9.58579L13.2929 4.29289L14.7072 5.70711L8.70715 11.7071Z"
        })));
    }
    renderSortAscendingSvg() {
        return (0, $696Z8.h)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.52861 2.86177C7.78895 2.60142 8.21107 2.60142 8.47141 2.86177L13.1381 7.52843L12.1953 8.47124L8.66668 4.94265L8.66668 12.6665H7.33334V4.94265L3.80475 8.47124L2.86194 7.52843L7.52861 2.86177Z"
        }));
    }
    renderSortDecendingSvg() {
        return (0, $696Z8.h)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.47129 13.1382C8.21094 13.3986 7.78883 13.3986 7.52848 13.1382L2.86182 8.47157L3.80463 7.52876L7.33322 11.0574L7.33322 3.3335L8.66655 3.3335L8.66655 11.0574L12.1952 7.52876L13.138 8.47157L8.47129 13.1382Z"
        }));
    }
    renderSortNoneSvg() {
        return (0, $696Z8.h)("svg", {
            width: "16",
            height: "17",
            viewBox: "0 0 16 17",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M10.8633 14.31L8.19664 11.6434L9.1433 10.7034L10.67 12.23L10.67 3.17002L12.0033 3.17002L12.0033 12.23L13.53 10.7034L14.47 11.6434L11.8033 14.31C11.5433 14.57 11.1233 14.57 10.8633 14.31ZM2.46997 6.30338L1.52997 5.36338L4.19664 2.69671C4.45664 2.43671 4.87664 2.43671 5.13664 2.69671L7.8033 5.36338L6.8633 6.30338L5.33664 4.77671L5.33664 13.8367L4.0033 13.8367L4.0033 4.77671L2.46997 6.30338Z"
        }));
    }
    renderSortSvg() {
        switch(this.sortOrder){
            case "ascending":
                return this.renderSortAscendingSvg();
            case "descending":
                return this.renderSortDecendingSvg();
            default:
                return this.renderSortNoneSvg();
        }
    }
    render() {
        var e2;
        const { el: t2, caret: r2, sortable: n2, sortOrder: l2, onKeydown: i2 } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "06b112f160821d797abb9ea2f55a2f25996c8224",
            role: null !== (e2 = t2.role) && void 0 !== e2 ? e2 : "cell",
            tabindex: this.getTabIndex(),
            style: this.getStyles(),
            class: "market-table-v2-cell",
            "sort-order": "none" === l2 ? null : l2,
            "aria-sort": "none" === l2 ? null : l2,
            onKeyDown: i2
        }, (0, $696Z8.h)("div", {
            key: "bce1d0ae9e15895120ae22c59954239a9014d291",
            class: "content-outer"
        }, r2 && this.renderCaretButton(), (0, $696Z8.h)("slot", {
            key: "8f578eb85c9490d1379031a5356b1c170529c63e",
            name: "control",
            onSlotchange: ()=>this.syncControlState()
        }), (0, $696Z8.h)("div", {
            key: "0934d7eedb1aedcec55453b226adafa3c830d067",
            class: "content-inner"
        }, (0, $696Z8.h)("slot", {
            key: "b507bb50d2e416c6bbbcfb8e38c84eab4360e361",
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            key: "99dff89866a24dacdb015b6e11eb2e383a65a8de",
            class: "default-slot"
        }, !n2 && (0, $696Z8.h)("slot", {
            key: "9fffe72c7db7939e4d535234155b96eef973fe76"
        }), n2 && (0, $696Z8.h)("button", {
            key: "8da793df1247c44d95c61381b9760875a961b466",
            class: "sort-button",
            "aria-describedby": "sort-button-label",
            onClick: ()=>this.onSortClick()
        }, (0, $696Z8.h)("slot", {
            key: "05d59fe1942161059b7681e446d758887718c1cc"
        }), this.renderSortSvg(), (0, $696Z8.h)("span", {
            key: "dde979cdfd0e2866ead04cb9614158b5ad2681f1",
            id: "sort-button-label",
            hidden: true
        }, this.getSortButtonLabel()))), (0, $696Z8.h)("slot", {
            key: "7f2849f1ed4be107dbbe5fc6c0424df723a363d8",
            name: "trailing-accessory"
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,*{box-sizing:border-box}:host{--table-cell-vertical-padding-size:var(--core-metrics-spacing-150);--table-cell-horizontal-padding-size:var(--core-metrics-spacing-100);--table-cell-horizontal-spacing-size:var(--core-metrics-spacing-150);--table-cell-border-width:1px;--table-cell-heading-border-color:var(--core-divider-10-color);--table-cell-indent-level:0;--table-cell-indent-size:var(--core-metrics-spacing-500);--table-cell-caret-size:var(--core-metrics-spacing-500);--table-cell-text-font-weight:var(--core-type-paragraph-20-weight);--table-cell-text-font-size:var(--core-type-paragraph-20-size);--table-cell-text-line-height:var(--core-type-paragraph-20-leading);--table-cell-focus-ring-color:var(--core-focus-ring-color);display:table-cell;vertical-align:inherit;width:auto;padding:var(--table-cell-vertical-padding-size) var(--table-cell-horizontal-padding-size);border-bottom:var(--table-cell-border-width) solid var(--table-cell-border-color);outline:none;font-weight:var(--table-cell-text-font-weight);font-size:var(--table-cell-text-font-size);line-height:var(--table-cell-text-line-height);text-align:inherit}:host .content-outer{display:flex;gap:var(--table-cell-horizontal-spacing-size);justify-content:space-between;align-items:center;width:100%;transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:gap}:host .content-inner{display:flex;gap:var(--table-cell-horizontal-spacing-size);align-items:center;width:100%}:host .default-slot{width:100%}:host([indent]:not([indent="0"])){padding-left:calc(         var(--table-cell-horizontal-spacing-size) + var(--table-cell-indent-level) * var(--table-cell-indent-size)       )}:host([indent][caret]:not([indent="0"])){padding-left:calc(         var(--table-cell-horizontal-padding-size) + var(--table-cell-indent-level) * var(--table-cell-indent-size)       )}:host([nowrap]) .default-slot{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host([align="left"]){text-align:left}:host([align="center"]){text-align:center}:host([align="right"]){text-align:right}:host([valign="top"]){vertical-align:top}:host([valign="middle"]){vertical-align:middle}:host([valign="bottom"]){vertical-align:bottom}:host([sticky]){position:sticky;z-index:2;background-color:var(--table-cell-state-normal-background-color)}:host([sticky="left"]){left:0;border-right:var(--table-cell-border-width) solid var(--table-cell-heading-border-color)}:host([sticky="right"]){right:0;border-left:var(--table-cell-border-width) solid var(--table-cell-heading-border-color)}:host(.market-drag-clone-first-cell){padding-left:var(--table-cell-horizontal-padding-size) !important}:host(.market-drag-clone-first-cell) .content-outer{gap:0}:host(.market-drag-clone-first-cell) .caret-button,:host(.market-drag-clone-first-cell) ::slotted([slot="control"]){width:0;height:0;opacity:0}::slotted([slot="control"]),::slotted([slot="leading-accessory"]),::slotted([slot="trailing-accessory"]){flex-shrink:0}.caret-button,::slotted([slot="control"]){transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:width, height, opacity}:host([interactive]){cursor:pointer}@media (hover: hover){:host([sortable]:hover),:host([interactive]:hover){background-color:var(--table-cell-hover-state-background-color)}}:host([sortable]:focus),:host([interactive]:focus){background-color:var(--table-cell-focus-state-background-color)}:host([sortable]:active),:host([interactive]:active){background-color:var(--table-cell-pressed-state-background-color)}:host([active]){background-color:var(--table-cell-selected-state-background-color)}:host([disabled]){color:var(--table-cell-disabled-state-text-color);pointer-events:none}.caret-button{display:flex;flex-shrink:0;justify-content:center;align-items:center;width:var(--table-cell-caret-size);height:var(--table-cell-caret-size);margin-top:calc(var(--table-cell-vertical-padding-size) * -1);margin-bottom:calc(var(--table-cell-vertical-padding-size) * -1);margin-left:calc(var(--table-cell-horizontal-padding-size) * -1);padding:0;border:none;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.caret-button svg{display:block;fill:var(--core-fill-20-color);transition:var(--core-animation-enter-transition-moderate-speed-duration) transform ease}:host([caret="up"]) .caret-button svg{transform:rotate(-180deg)}.caret-button:focus-visible{border-radius:var(--core-radius-10);outline:var(--core-focus-ring-border-size) solid var(--table-cell-focus-ring-color);outline-offset:calc(var(--core-focus-ring-border-size) * -1)}.sort-button{display:flex;flex-shrink:0;gap:var(--core-metrics-spacing-50);align-items:center;width:100%;margin:0;padding:var(--table-cell-vertical-padding-size) var(--table-cell-horizontal-padding-size);border:none;background:transparent;color:unset;outline:none;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-align:inherit;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.sort-button svg{display:block;flex-shrink:0;fill:var(--core-text-30-color)}.sort-button:focus-visible{border-radius:var(--core-radius-10);outline:var(--core-focus-ring-border-size) solid var(--table-cell-focus-ring-color);outline-offset:calc(var(--core-focus-ring-border-size) * -1)}:host([align="left"]) .sort-button{justify-content:start}:host([align="center"]) .sort-button{justify-content:center}:host([align="right"]) .sort-button{justify-content:end}:host([sortable]){padding:0}:host([sortable][sort-order="ascending"]) .sort-button svg,:host([sortable][sort-order="descending"]) .sort-button svg{fill:var(--core-text-10-color)}';
    }
}, [
    257,
    "market-table-v2-cell",
    {
        active: [
            516
        ],
        align: [
            513
        ],
        caret: [
            513
        ],
        caretAriaLabelExpanded: [
            1,
            "caret-aria-label-expanded"
        ],
        caretAriaLabelCollapsed: [
            1,
            "caret-aria-label-collapsed"
        ],
        disabled: [
            516
        ],
        indent: [
            514
        ],
        interactive: [
            516
        ],
        nowrap: [
            516
        ],
        selected: [
            1025
        ],
        sticky: [
            513
        ],
        sortable: [
            516
        ],
        sortAriaLabelAscending: [
            1,
            "sort-aria-label-ascending"
        ],
        sortAriaLabelDescending: [
            1,
            "sort-aria-label-descending"
        ],
        sortAriaLabelNone: [
            1,
            "sort-aria-label-none"
        ],
        sortOrder: [
            1025,
            "sort-order"
        ],
        sortStrategy: [
            1,
            "sort-strategy"
        ],
        sortStrategyFormat: [
            1,
            "sort-strategy-format"
        ],
        valign: [
            513
        ],
        setSelected: [
            64
        ]
    },
    [
        [
            0,
            "marketToggleChange",
            "onMarketControlSelectionChange"
        ],
        [
            0,
            "marketCheckboxValueChange",
            "onMarketControlSelectionChange"
        ]
    ]
]), c$2 = s$2;
const h$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketInternalTableV2GroupSelectionChange = (0, $696Z8.createEvent)(this, "marketInternalTableV2GroupSelectionChange", 7), this.marketTableV2RowsReordered = (0, $696Z8.createEvent)(this, "marketTableV2RowsReordered", 7), this.marketTableV2GroupCollapsedChange = (0, $696Z8.createEvent)(this, "marketTableV2GroupCollapsedChange", 7), this.collapsible = false, this.collapsed = false, this.dragEnabled = false, this.indent = 0, this.reorderMode = "default", this.selected = "false";
    }
    onMarketTableV2CellCaretClicked(e2) {
        e2.stopPropagation(), this.setCollapsed(!this.collapsed);
    }
    async onMarketTableV2SelectionChange(e2) {
        const { el: t2, parent: r2 } = this, { target: a2, detail: l2 } = e2, { current: n2 } = l2;
        a2 !== t2 && (e2.stopImmediatePropagation(), a2 === r2 ? await this.setSelected(n2) : await this.setSelectedFromChildEvent(e2));
    }
    async onDragHandleStart(e2) {
        e2.stopImmediatePropagation();
        const { el: t2, parent: r2 } = this, { target: a2, detail: l2 } = e2;
        if (r2 !== a2) return;
        const n2 = new c$e(t2, {
            anchor: "leading" === r2.dragHandlePosition ? "left" : "right"
        });
        this.drag = n2, await n2.start(l2), r2.classList.add("market-drag-placeholder");
    }
    onDragHandleMove(e2) {
        e2.stopImmediatePropagation();
        const { parent: t2, drag: r2 } = this, { target: a2, detail: l2 } = e2;
        t2 === a2 && r2.move(l2);
    }
    async onDragHandleDragEnd(e2) {
        e2.stopImmediatePropagation();
        const { parent: t2, drag: r2 } = this, { target: a2, detail: l2 } = e2;
        t2 === a2 && (await r2.end(l2), t2.classList.remove("market-drag-placeholder"), r2.destroy());
    }
    onDragMove(e2) {
        const { parent: t2, reorder: r2 } = this, { el: a2 } = e2.detail;
        t2 !== a2 && (e2.stopImmediatePropagation(), null == r2 || r2.dragMove(e2));
    }
    onDragLeave(e2) {
        const { parent: t2, reorder: r2 } = this, { el: a2 } = e2.detail;
        t2 !== a2 && (e2.stopImmediatePropagation(), null == r2 || r2.dragLeave());
    }
    onDragEnd(e2) {
        const { parent: t2, reorder: r2 } = this, { el: a2 } = e2.detail;
        t2 !== a2 && (null == r2 || r2.dragEnd(e2));
    }
    onDragDrop(e2) {
        const { parent: t2, reorder: r2 } = this, { el: a2 } = e2.detail;
        t2 !== a2 && (null == r2 || r2.dragDrop(e2));
    }
    propagateNestedState() {
        const { parent: e2, children: t2, groups: r2, rows: a2, indent: l2, collapsible: n2, collapsed: o2 } = this;
        if (r2.forEach((e3)=>{
            e3.collapsible = n2;
        }), n2) {
            const s2 = t2.length > 0;
            e2 && (e2.caret = s2 ? o2 ? "down" : "up" : void 0, e2.indent = s2 ? l2 : l2 + 1), r2.forEach((e3)=>{
                e3.indent = l2 + 1, e3.collapsible = n2;
            }), a2.forEach((e3)=>{
                e3.indent = l2 + 2;
            });
        } else e2 && (e2.caret = void 0, e2.indent = l2), t2.forEach((e3)=>{
            e3.indent = l2 + 1;
        }), r2.forEach((e3)=>{
            e3.collapsible = n2;
        });
    }
    watchDragEnabled() {
        const { parent: e2, children: t2, dragEnabled: r2 } = this;
        e2 && (e2.dragEnabled = r2), null == t2 || t2.forEach((e3)=>{
            e3.dragEnabled = r2;
        });
    }
    watchReorderable() {
        const { el: e2, reorder: t2, reorderable: r2, reorderMode: a2, marketTableV2RowsReordered: l2 } = this;
        if (null == t2 || t2.destroy(), [
            "internal",
            "external"
        ].includes(r2)) {
            const t3 = l$s("market-table-v2-row"), r3 = l$s("market-table-v2-group");
            this.reorder = new i$9({
                el: e2,
                accepts: [
                    t3 + ':not([header]):not([footer]):not([slot="parent"])',
                    r3
                ],
                event: l2,
                mode: a2
            });
        }
        this.syncDragEnabled();
    }
    async setSelected(e2, { silent: t2 = false } = {}) {
        const { parent: r2, children: a2, marketInternalTableV2GroupSelectionChange: l2, selected: n2 } = this;
        return n2 === e2 || (t2 || l2.emit({
            current: e2,
            previous: n2
        }), this.selected = e2, await (null == r2 ? void 0 : r2.setSelected(e2, {
            silent: true
        })), null == a2 || a2.forEach(async (t3)=>{
            await t3.setSelected(e2, {
                silent: true
            });
        })), Promise.resolve();
    }
    async setCollapsed(e2, { silent: t2 = false } = {}) {
        const { collapsed: r2, collapsible: a2, marketTableV2GroupCollapsedChange: l2 } = this;
        if (!a2) return Promise.resolve();
        if (e2 === r2) return Promise.resolve();
        if (this.collapsed = e2, !t2) {
            const { defaultPrevented: t3 } = l2.emit({
                previous: r2,
                current: e2
            });
            t3 && (this.collapsed = r2);
        }
        return Promise.resolve();
    }
    async sort({ order: e2, column: t2, strategy: r2, format: a2 }) {
        const { el: l2, children: n2, groups: o2 } = this, s2 = ar({
            items: n2,
            order: e2,
            column: t2,
            strategy: r2,
            format: a2
        });
        return null == o2 || o2.forEach((l3)=>l3.sort({
                order: e2,
                column: t2,
                strategy: r2,
                format: a2
            })), s2.forEach((e3)=>{
            l2.append(e3);
        }), Promise.resolve();
    }
    async setSelectedFromChildEvent(e2) {
        const { parent: t2, children: r2, marketInternalTableV2GroupSelectionChange: a2, selected: l2 } = this, { target: n2, detail: o2 } = e2, { current: s2 } = o2, i2 = r2.map((e3)=>n2 === e3 ? s2 : e3.selected), d2 = i2.every((e3)=>"true" === e3) ? "true" : i2.every((e3)=>"false" === e3) ? "false" : "indeterminate";
        l2 !== d2 && (a2.emit({
            current: d2,
            previous: l2
        }), this.selected = d2, await t2.setSelected(d2, {
            silent: true
        }));
    }
    getElements() {
        this.parent = [
            ...this.el.children
        ].find((e2)=>e2.tagName === l$s("market-table-v2-row").toUpperCase() && "parent" === e2.slot), this.rows = [
            ...this.el.children
        ].filter((e2)=>e2.tagName === l$s("market-table-v2-row").toUpperCase() && "parent" !== e2.slot), this.groups = [
            ...this.el.children
        ].filter((e2)=>e2.tagName === l$s("market-table-v2-group").toUpperCase() && "parent" !== e2.slot), this.children = [
            ...this.groups,
            ...this.rows
        ];
    }
    getStyles() {
        const { indent: e2 } = this;
        return {
            "--drag-cursor-indent-level": "" + e2
        };
    }
    syncDragEnabled() {
        const { parent: e2, rows: t2, groups: r2, reorderable: a2, reorderMode: l2 } = this, n2 = [
            "internal",
            "external"
        ].includes(a2);
        e2 && (e2.dragEnabled = n2), null == t2 || t2.forEach((e3)=>{
            l$b(e3) && (e3.dragEnabled = n2);
        }), null == r2 || r2.forEach((e3)=>{
            e3.dragEnabled = n2, e3.reorderable = a2, e3.reorderMode = l2;
        });
    }
    onSlotChange() {
        this.getElements(), this.propagateNestedState(), this.syncDragEnabled();
    }
    connectedCallback() {
        this.getElements(), this.propagateNestedState(), this.syncDragEnabled();
    }
    componentDidRender() {
        this.watchReorderable();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "84390ff0fa82e9e171605a446e9313752ae5f2f0",
            class: "market-table-v2-group",
            style: this.getStyles()
        }, (0, $696Z8.h)("slot", {
            key: "3da6cef5e57b83298b4ccb16fd717ff8a3677843",
            name: "parent",
            onSlotchange: ()=>this.onSlotChange()
        }), (0, $696Z8.h)("div", {
            key: "a4571aa4004670ee6ec6efaa1ca1cd9ee480cd32",
            class: "children"
        }, (0, $696Z8.h)("slot", {
            key: "b6349aab9652bd03d81a671867228359e58a2002",
            onSlotchange: ()=>this.onSlotChange()
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            indent: [
                {
                    propagateNestedState: 0
                }
            ],
            collapsed: [
                {
                    propagateNestedState: 0
                }
            ],
            collapsible: [
                {
                    propagateNestedState: 0
                }
            ],
            dragEnabled: [
                {
                    watchDragEnabled: 0
                }
            ],
            reorderable: [
                {
                    watchReorderable: 0
                }
            ]
        };
    }
    static get style() {
        return ':host{--table-cell-horizontal-padding-size:8px;--table-cell-indent-size:40px;--drag-highlight-border-size:2px}:host,slot,.children{vertical-align:inherit;text-align:inherit}:host,.children{display:contents}:host([collapsible][collapsed]) .children{display:none}:host(.market-drag-cursor-parent[collapsible][collapsed]) ::slotted([slot="parent"]){position:relative;border-radius:var(--core-radius-10);background-color:var(--core-emphasis-40-color);outline:var(--drag-highlight-border-size) solid var(--core-emphasis-fill-color);outline-offset:calc(var(--drag-highlight-border-size) * -1)}::slotted(.market-drag-cursor){--drag-cursor-height:4px;position:absolute;right:0;left:calc(       var(--table-cell-horizontal-padding-size) +       (var(--drag-cursor-indent-level) + 1) * var(--table-cell-indent-size)     );display:block;height:0;outline:calc(var(--drag-cursor-height) / 2) solid var(--core-emphasis-fill-color);pointer-events:none}:host(.market-drag-placeholder) ::slotted(:not([slot="parent"])){display:none}';
    }
}, [
    257,
    "market-table-v2-group",
    {
        collapsible: [
            516
        ],
        collapsed: [
            1540
        ],
        dragEnabled: [
            516,
            "drag-enabled"
        ],
        indent: [
            514
        ],
        reorderable: [
            513
        ],
        reorderMode: [
            1,
            "reorder-mode"
        ],
        selected: [
            1025
        ],
        setSelected: [
            64
        ],
        setCollapsed: [
            64
        ],
        sort: [
            64
        ]
    },
    [
        [
            0,
            "marketTableV2CellCaretClicked",
            "onMarketTableV2CellCaretClicked"
        ],
        [
            0,
            "marketInternalTableV2RowSelectionChange",
            "onMarketTableV2SelectionChange"
        ],
        [
            0,
            "marketInternalTableV2GroupSelectionChange",
            "onMarketTableV2SelectionChange"
        ],
        [
            0,
            "marketDragHandleDragStart",
            "onDragHandleStart"
        ],
        [
            0,
            "marketDragHandleDragMove",
            "onDragHandleMove"
        ],
        [
            0,
            "marketDragHandleDragEnd",
            "onDragHandleDragEnd"
        ],
        [
            0,
            "marketDragMove",
            "onDragMove"
        ],
        [
            0,
            "marketDragLeave",
            "onDragLeave"
        ],
        [
            0,
            "marketDragEnd",
            "onDragEnd"
        ],
        [
            0,
            "marketDragDrop",
            "onDragDrop"
        ]
    ],
    {
        indent: [
            {
                propagateNestedState: 0
            }
        ],
        collapsed: [
            {
                propagateNestedState: 0
            }
        ],
        collapsible: [
            {
                propagateNestedState: 0
            }
        ],
        dragEnabled: [
            {
                watchDragEnabled: 0
            }
        ],
        reorderable: [
            {
                watchReorderable: 0
            }
        ]
    }
]), g = h$1;
const s$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketInternalTableV2RowSelectionChange = (0, $696Z8.createEvent)(this, "marketInternalTableV2RowSelectionChange", 7), this.marketTableV2RowSelectionChange = (0, $696Z8.createEvent)(this, "marketTableV2RowSelectionChange", 7), this.active = false, this.disabled = false, this.dragEnabled = false, this.footer = false, this.header = false, this.interactive = false, this.selected = "false", this.onKeydown = (e3)=>{
            const { target: t2, key: a2 } = e3, { el: r2, disabled: o2, interactive: l2 } = this;
            o2 || l2 && t2 === r2 && ("Enter" !== a2 && " " !== a2 || (e3.preventDefault(), r2.click()));
        };
    }
    async onMarketInternalTableV2CellSelectionChange(e2) {
        const { detail: t2, target: a2 } = e2, { current: r2 } = t2, { firstCell: o2 } = this;
        a2 === o2 && (e2.stopPropagation(), await this.setSelected(r2));
    }
    async onDragStart(e2) {
        const { el: t2, dragHandlePosition: a2 } = this;
        if ("parent" === t2.slot) return;
        e2.stopPropagation();
        const r2 = e2.detail, o2 = new c$e(t2, {
            anchor: "leading" === a2 ? "left" : "right"
        });
        this.drag = o2, await o2.start(r2);
    }
    onDragMove(e2) {
        "parent" !== this.el.slot && (e2.stopPropagation(), this.drag.move(e2.detail));
    }
    async onDragEnd(e2) {
        if ("parent" === this.el.slot) return;
        e2.stopPropagation();
        const t2 = e2.detail;
        await this.drag.end(t2), this.drag.destroy();
    }
    watchCaret() {
        const { firstCell: e2, caret: t2 } = this;
        e2 && (e2.caret = t2);
    }
    watchIndent() {
        const { firstCell: e2, indent: t2 } = this;
        e2 && (e2.indent = t2);
    }
    async setSelected(e2, { silent: t2 = false } = {}) {
        const { firstCell: a2, selected: r2, marketTableV2RowSelectionChange: o2, marketInternalTableV2RowSelectionChange: l2 } = this;
        if (r2 === e2) return Promise.resolve();
        const { defaultPrevented: i2 } = o2.emit({
            current: e2,
            previous: r2
        });
        return i2 ? (await (null == a2 ? void 0 : a2.setSelected(r2, {
            silent: true
        })), Promise.resolve()) : (t2 || l2.emit({
            current: e2,
            previous: r2
        }), this.selected = e2, await (null == a2 ? void 0 : a2.setSelected(e2, {
            silent: t2
        })), Promise.resolve());
    }
    getTabIndex() {
        const { disabled: e2, interactive: t2 } = this;
        return t2 && !e2 ? "0" : null;
    }
    async initFirstCell() {
        const { el: e2, selected: t2 } = this, a2 = l$s("market-table-v2-cell"), r2 = e2.querySelector("" + a2);
        r2 && (this.firstCell = r2, t2 && await (null == r2 ? void 0 : r2.setSelected(t2))), this.watchCaret(), this.watchIndent();
    }
    async connectedCallBack() {
        await this.initFirstCell();
    }
    renderDragHandleCell() {
        const e2 = l$s("market-drag-handle"), t2 = l$s("market-table-v2-cell");
        return (0, $696Z8.h)(t2, {
            class: "drag-handle-cell",
            part: "drag-handle-cell"
        }, (0, $696Z8.h)(e2, {
            part: "drag-handle"
        }));
    }
    render() {
        const { dragEnabled: e2, dragHandlePosition: t2, onKeydown: a2 } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "ea08da86422e73be9bd88c2c79d2835cbffcef65",
            role: "row",
            class: "market-table-v2-row",
            tabindex: this.getTabIndex(),
            onKeyDown: a2,
            onMarketDragHandleDragStart: (e3)=>this.onDragStart(e3),
            onMarketDragHandleDragMove: (e3)=>this.onDragMove(e3),
            onMarketDragHandleDragEnd: (e3)=>this.onDragEnd(e3)
        }, e2 && "leading" === t2 && this.renderDragHandleCell(), (0, $696Z8.h)("slot", {
            key: "a4c67bbc5e71b0eae77d65dca4b23fb45c3b9211",
            onSlotchange: ()=>this.initFirstCell()
        }), e2 && "leading" !== t2 && this.renderDragHandleCell());
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            caret: [
                {
                    watchCaret: 0
                }
            ],
            indent: [
                {
                    watchIndent: 0
                }
            ]
        };
    }
    static get style() {
        return ':host,*{box-sizing:border-box}:host{--table-cell-border-width:1px;--table-cell-border-color:var(--core-divider-20-color);--table-cell-horizontal-spacing:var(--core-metrics-spacing-150);--table-cell-heading-border-color:var(--core-divider-10-color);--table-cell-heading-font-weight:var(--core-type-medium-weight);--table-cell-state-normal-background-color:var(--core-surface-10-color);display:table-row;vertical-align:inherit;width:100%;outline:none;text-align:inherit}:host slot{vertical-align:inherit;text-align:inherit}:host([align="left"]){text-align:left}:host([align="center"]){text-align:center}:host([align="right"]){text-align:right}:host([valign="top"]){vertical-align:top}:host([valign="middle"]){vertical-align:middle}:host([valign="bottom"]){vertical-align:bottom}:host([header]) .market-table-v2-cell,:host([header]) ::slotted(.market-table-v2-cell),:host([footer]) .market-table-v2-cell,:host([footer]) ::slotted(.market-table-v2-cell){font-weight:var(--table-cell-heading-font-weight)}:host([header]) .market-drag-handle,:host([footer]) .market-drag-handle{visibility:hidden}:host([header]) .market-table-v2-cell,:host([header]) ::slotted(.market-table-v2-cell),:host([sticky="top"]) .market-table-v2-cell,:host([sticky="top"]) ::slotted(.market-table-v2-cell){border-bottom:var(--table-cell-border-width) solid var(--table-cell-heading-border-color)}:host([footer]) .market-table-v2-cell,:host([footer]) ::slotted(.market-table-v2-cell),:host([sticky="bottom"]) .market-table-v2-cell,:host([sticky="bottom"]) ::slotted(.market-table-v2-cell){border-top:var(--table-cell-border-width) solid var(--table-cell-heading-border-color);border-bottom:none}:host([sticky]){position:sticky;z-index:3;background-color:var(--table-cell-state-normal-background-color)}:host([sticky="top"]){top:0}:host([sticky="bottom"]){bottom:0}:host([interactive]){cursor:pointer}@media (hover: hover){:host([interactive]:hover){background-color:var(--table-cell-hover-state-background-color)}}:host([interactive]:focus){background-color:var(--table-cell-focus-state-background-color)}:host([interactive]:active){background-color:var(--table-cell-pressed-state-background-color)}:host([active]){background-color:var(--table-cell-selected-state-background-color)}:host([disabled]){color:var(--table-cell-disabled-state-text-color);pointer-events:none}.drag-handle-cell{width:var(--core-metrics-spacing-500)}@media (hover: hover){:host([drag-handle-visibility="hover"]) .market-drag-handle{opacity:0}:host([drag-handle-visibility="hover"]:hover) .market-drag-handle{opacity:1}}:host(.market-drag-placeholder),:host(.market-drag-placeholder[interactive]){background-color:var(--core-fill-50-color)}:host(.market-drag-placeholder) *,:host(.market-drag-placeholder) ::slotted(*),:host(.market-drag-placeholder[interactive]) *,:host(.market-drag-placeholder[interactive]) ::slotted(*){opacity:0}:host(.market-drag-placeholder) .market-drag-handle,:host(.market-drag-placeholder[interactive]) .market-drag-handle{pointer-events:none}:host(.market-drag-clone),:host(.market-drag-clone[interactive]){--table-row-dragged-width:240px;display:flex;justify-content:space-between;align-items:center;width:var(--table-row-dragged-width);border-bottom:var(--table-cell-border-width) solid var(--table-cell-border-color);border-radius:var(--core-radius-10);background-color:var(--core-surface-20-color);cursor:grabbing;transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:top, width, height}:host(.market-drag-clone)::after,:host(.market-drag-clone[interactive])::after{content:"";position:absolute;inset:0;display:block;border-radius:var(--core-radius-10);box-shadow:var(--elevation-20-shadow);opacity:var(--market-drag-clone-shadow-opacity, 0);transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:opacity}:host(.market-drag-clone) .market-drag-handle,:host(.market-drag-clone[interactive]) .market-drag-handle{cursor:grabbing}:host(.market-drag-clone) ::slotted(.market-table-v2-cell:first-child),:host(.market-drag-clone[interactive]) ::slotted(.market-table-v2-cell:first-child){overflow:hidden;width:100%;border:none;text-overflow:ellipsis;white-space:nowrap;transition-timing-function:var(--core-animation-move-transition-easing);transition-duration:var(--core-animation-move-transition-moderate-speed-duration);transition-property:padding-left}:host(.market-drag-clone) ::slotted(.market-table-v2-cell:not(:first-child)),:host(.market-drag-clone[interactive]) ::slotted(.market-table-v2-cell:not(:first-child)){display:none}:host(.market-drag-clone) .drag-handle-cell,:host(.market-drag-clone[interactive]) .drag-handle-cell{border:none}:host(.market-drag-clone[drag-handle-position="leading"]){justify-content:flex-start}:host(.market-drag-released){pointer-events:none;transition-property:opacity, width, height, transform, scale}:host(.market-drag-into-collapsed-group){opacity:0;scale:0}';
    }
}, [
    257,
    "market-table-v2-row",
    {
        active: [
            516
        ],
        align: [
            513
        ],
        caret: [
            513
        ],
        disabled: [
            516
        ],
        dragEnabled: [
            516,
            "drag-enabled"
        ],
        dragHandleVisibility: [
            513,
            "drag-handle-visibility"
        ],
        dragHandlePosition: [
            513,
            "drag-handle-position"
        ],
        footer: [
            516
        ],
        header: [
            516
        ],
        indent: [
            514
        ],
        interactive: [
            516
        ],
        selected: [
            1025
        ],
        sticky: [
            513
        ],
        valign: [
            513
        ],
        setSelected: [
            64
        ]
    },
    [
        [
            0,
            "marketInternalTableV2CellSelectionChange",
            "onMarketInternalTableV2CellSelectionChange"
        ]
    ],
    {
        caret: [
            {
                watchCaret: 0
            }
        ],
        indent: [
            {
                watchIndent: 0
            }
        ]
    }
]), c$1 = s$1;
const r$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow();
    }
    marketTabSelectedChangedEventHandler(t2) {
        t2.stopPropagation();
        const { panelId: e2, tabId: a2, value: s2 } = t2.detail;
        s2 && (this.selectedTab !== a2 && (this.selectedTab = a2), this.showPanelWithId(e2));
    }
    tabWatcher(t2) {
        this.setTab(t2);
    }
    setTab(t2) {
        this.tabListEl && (this.tabListEl.selectedTab = t2);
    }
    showPanelWithId(t2) {
        var e2;
        null === (e2 = this.panelEls) || void 0 === e2 || e2.forEach((e3)=>{
            e3.hidden = e3.id !== t2;
        });
    }
    handleSlotChange() {
        this.panelEls = [
            ...this.el.querySelectorAll(l$s("market-tab-panel"))
        ].map((t2)=>(t2.hidden = true, t2)), this.tabListEl = this.el.querySelector(l$s("market-tab-list"));
    }
    componentWillLoad() {
        var t2;
        this.handleSlotChange(), this.setTab(null !== (t2 = this.selectedTab) && void 0 !== t2 ? t2 : this.defaultTab);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "53ff789aed8ca0f7be61b9a25db6626b42205547",
            class: "market-tabs"
        }, (0, $696Z8.h)("slot", {
            key: "1bd8b9a6a81c14e139d9e74bdee8f12669d792e6",
            onSlotchange: ()=>this.handleSlotChange()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            selectedTab: [
                {
                    tabWatcher: 0
                }
            ]
        };
    }
    static get style() {
        return ":host{display:block}";
    }
}, [
    257,
    "market-tabs",
    {
        selectedTab: [
            1537,
            "selected-tab"
        ],
        defaultTab: [
            1,
            "default-tab"
        ]
    },
    [
        [
            0,
            "marketTabSelectedChanged",
            "marketTabSelectedChangedEventHandler"
        ]
    ],
    {
        selectedTab: [
            {
                tabWatcher: 0
            }
        ]
    }
]), i$1 = r$2;
const r$1 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTagDismissed = (0, $696Z8.createEvent)(this, "marketTagDismissed", 7), this.disabled = false, this.focused = false, this.size = "small", this.hasIcon = false;
    }
    onFocus() {
        this.disabled || (this.focused = !this.focused);
    }
    handleDismissTagEvent(t2) {
        this.marketTagDismissed.emit(), t2.stopPropagation(), this.el.remove();
    }
    componentWillLoad() {
        this.hasIcon = !!this.el.querySelector('[slot="icon"]');
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "0d31cfbf3b5afc83ee271323dd8f6f0ece71f16e",
            class: "market-tag " + (this.hasIcon ? "has-icon" : ""),
            onClick: ()=>{
                this.onFocus();
            },
            onFocus: ()=>{
                this.onFocus();
            },
            "aria-disabled": this.disabled
        }, (0, $696Z8.h)("span", {
            key: "ebf3bc3b0a246d66859a7c4de8587c3c357f576f",
            class: "icon"
        }, (0, $696Z8.h)("slot", {
            key: "1e9b689ffa026deafe717d85156b4c24ed1f037a",
            name: "icon"
        })), (0, $696Z8.h)("slot", {
            key: "3605b2c56951765f91742aa5b3a3092a8ffd99a9"
        }), (0, $696Z8.h)("svg", {
            key: "d3a668734a1cb3add8b6048ce160740b0051862f",
            class: "remove-indicator",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: (t2)=>this.handleDismissTagEvent(t2)
        }, (0, $696Z8.h)("path", {
            key: "192b5ed9227d2616625afb58f7b188c026e50686",
            d: "M4.4734 12.4734L8.00007 8.94002L11.5267 12.4734L12.4734 11.5267L8.94007 8.00002L12.4734 4.47335L11.5267 3.52669L8.00007 7.06002L4.4734 3.52669L3.52673 4.47335L7.06007 8.00002L3.52673 11.5267L4.4734 12.4734Z"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--tag-small-size-minimum-height:var(--core-metrics-spacing-400);--tag-small-size-horizontal-spacing:var(--core-metrics-spacing-50);--tag-small-size-text-weight:var(--core-type-paragraph-10-weight);--tag-small-size-text-size:var(--core-type-paragraph-10-size);--tag-small-size-text-leading:var(--core-type-paragraph-10-leading);--tag-small-size-text-tracking:var(--core-type-paragraph-10-tracking);--tag-small-size-text-case:var(--core-type-paragraph-10-case);--tag-small-size-basic-format-top-padding:7px;--tag-small-size-basic-format-right-padding:8px;--tag-small-size-basic-format-bottom-padding:7px;--tag-small-size-basic-format-left-padding:12px;--tag-small-size-with-icon-format-top-padding:7px;--tag-small-size-with-icon-format-right-padding:8px;--tag-small-size-with-icon-format-bottom-padding:7px;--tag-small-size-with-icon-format-left-padding:8px;--tag-medium-size-minimum-height:var(--core-metrics-spacing-500);--tag-medium-size-horizontal-spacing:var(--core-metrics-spacing-50);--tag-medium-size-text-weight:var(--core-type-paragraph-20-weight);--tag-medium-size-text-size:var(--core-type-paragraph-20-size);--tag-medium-size-text-leading:var(--core-type-paragraph-20-leading);--tag-medium-size-text-tracking:var(--core-type-paragraph-20-tracking);--tag-medium-size-text-case:var(--core-type-paragraph-20-case);--tag-medium-size-basic-format-top-padding:9px;--tag-medium-size-basic-format-right-padding:8px;--tag-medium-size-basic-format-bottom-padding:9px;--tag-medium-size-basic-format-left-padding:12px;--tag-medium-size-with-icon-format-top-padding:9px;--tag-medium-size-with-icon-format-right-padding:8px;--tag-medium-size-with-icon-format-bottom-padding:9px;--tag-medium-size-with-icon-format-left-padding:8px;display:inline-flex;align-items:center;background-color:var(--tag-normal-state-background-color);color:var(--tag-normal-state-label-color);cursor:pointer}:host .icon{display:none}:host(.has-icon) .icon{display:inline-block}:host([size="small"]){gap:var(--tag-small-size-horizontal-spacing);min-height:var(--tag-small-size-minimum-height);padding:var(--tag-small-size-basic-format-top-padding)       var(--tag-small-size-basic-format-right-padding)       var(--tag-small-size-basic-format-bottom-padding)       var(--tag-small-size-basic-format-left-padding);border-radius:calc(var(--tag-small-size-minimum-height) / 2);font-weight:var(--tag-small-size-text-weight);font-size:var(--tag-small-size-text-size);line-height:var(--tag-small-size-text-leading);letter-spacing:var(--tag-small-size-text-tracking);text-transform:var(--tag-small-size-text-case)}:host([size="small"],.has-icon){padding:var(--tag-small-size-with-icon-format-top-padding)         var(--tag-small-size-with-icon-format-right-padding)         var(--tag-small-size-with-icon-format-bottom-padding)         var(--tag-small-size-with-icon-format-left-padding)}:host([size="medium"]){gap:var(--tag-medium-size-horizontal-spacing);min-height:var(--tag-medium-size-minimum-height);padding:var(--tag-medium-size-basic-format-top-padding)       var(--tag-medium-size-basic-format-right-padding)       var(--tag-medium-size-basic-format-bottom-padding)       var(--tag-medium-size-basic-format-left-padding);border-radius:calc(var(--tag-medium-size-minimum-height) / 2);font-weight:var(--tag-medium-size-text-weight);font-size:var(--tag-medium-size-text-size);line-height:var(--tag-medium-size-text-leading);letter-spacing:var(--tag-medium-size-text-tracking);text-transform:var(--tag-medium-size-text-case)}:host([size="medium"],.has-icon){padding:var(--tag-medium-size-with-icon-format-top-padding)         var(--tag-medium-size-with-icon-format-right-padding)         var(--tag-medium-size-with-icon-format-bottom-padding)         var(--tag-medium-size-with-icon-format-left-padding)}svg.remove-indicator,::slotted([slot="icon"]){flex-shrink:0}::slotted([slot="icon"]){fill:var(--tag-normal-state-icon-color)}svg.remove-indicator{fill:var(--tag-normal-state-remove-indicator-color)}@media (hover: hover){:host(:hover){background-color:var(--tag-hover-state-background-color);color:var(--tag-hover-state-label-color)}:host(:hover) ::slotted([slot="icon"]){fill:var(--tag-hover-state-icon-color)}:host(:hover) svg.remove-indicator{fill:var(--tag-hover-state-remove-indicator-color)}}:host(:active){background-color:var(--tag-pressed-state-background-color);color:var(--tag-pressed-state-label-color)}:host(:active) ::slotted([slot="icon"]){fill:var(--tag-pressed-state-icon-color)}:host(:active) svg.remove-indicator{fill:var(--tag-pressed-state-remove-indicator-color)}:host(:focus),:host([focused]){background-color:var(--tag-focus-state-background-color);color:var(--tag-focus-state-label-color)}:host(:focus) ::slotted([slot="icon"]),:host([focused]) ::slotted([slot="icon"]){fill:var(--tag-focus-state-icon-color)}:host(:focus) svg.remove-indicator,:host([focused]) svg.remove-indicator{fill:var(--tag-focus-state-remove-indicator-color)}:host([disabled]){background-color:var(--tag-disabled-state-background-color);color:var(--tag-disabled-state-label-color)}:host([disabled]) ::slotted([slot="icon"]){fill:var(--tag-disabled-state-icon-color)}:host([disabled]) svg.remove-indicator{fill:var(--tag-disabled-state-remove-indicator-color)}';
    }
}, [
    257,
    "market-tag",
    {
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        size: [
            513
        ],
        hasIcon: [
            32
        ]
    }
]), l$1 = r$1;
const n$2 = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketTextareaValueChange = (0, $696Z8.createEvent)(this, "marketTextareaValueChange", 7), this.value = "", this.readonly = false, this.disabled = false, this.focused = false, this.invalid = false, this.maxHeight = R$5 + "px", this.autofocus = false, this.sharedProps = {}, this.onMutationObserved = (e3)=>{
            this.ariaAttributes = e3;
        };
    }
    handleMarketDialogLoaded() {
        this.autofocus && this.setFocus();
    }
    registerSlottedTextarea(e2) {
        var t2;
        return this.slottedTextarea = e2 || this.el.querySelector("textarea[slot=textarea]") || (null === (t2 = this.el.getRootNode().host) || void 0 === t2 ? void 0 : t2.querySelector("textarea[slot=textarea]")), this.slottedTextarea && (this.slottedTextarea.addEventListener("input", (e3)=>this.textareaValueDidChange(e3)), this.slottedTextarea.addEventListener("focus", ()=>this.setFocus()), this.slottedTextarea.addEventListener("blur", ()=>this.focused = false)), Promise.resolve();
    }
    syncSharedPropsToSlottedTextarea(e2) {
        this.slottedTextarea && [
            .../* @__PURE__ */ new Set([
                ...Object.keys(e2),
                ...Object.keys(this.sharedProps)
            ])
        ].forEach((e3)=>{
            e3 in this.sharedProps ? this.slottedTextarea.setAttribute(e3, true === this.sharedProps[e3] ? "" : this.sharedProps[e3]) : this.slottedTextarea.removeAttribute(e3);
        });
    }
    updateSharedPropsAndSyncSlottedTextarea() {
        const e2 = Object.assign({}, this.sharedProps);
        this.sharedProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.name && {
            name: this.name
        }), this.placeholder && {
            placeholder: this.placeholder
        }), void 0 !== this.maxlength && Number.parseInt(this.maxlength, 10) >= 0 && {
            maxlength: this.maxlength
        }), void 0 !== this.value && {
            value: this.value
        }), this.readonly && {
            readonly: this.readonly
        }), this.disabled && {
            disabled: this.disabled
        }), this.autofocus && {
            autofocus: this.autofocus
        }), this.inputmode && {
            inputmode: this.inputmode
        }), this.ariaAttributes), {
            "aria-label": n$A(this.el)
        }), this.syncSharedPropsToSlottedTextarea(e2);
    }
    componentWillLoad() {
        this.mutationObserver = a$q(this.el, this.onMutationObserved), this.registerSlottedTextarea(), this.updateSharedPropsAndSyncSlottedTextarea();
    }
    componentDidLoad() {
        this.maxHeight && (this.el.style.maxHeight = this.maxHeight), this.autofocus && !this.focused && this.setFocus();
    }
    componentWillUpdate() {
        this.updateSharedPropsAndSyncSlottedTextarea();
    }
    textareaValueDidChange(e2) {
        this.value = e2.target.value, this.marketTextareaValueChange.emit({
            value: e2.target.value,
            originalEvent: e2
        });
    }
    setFocus(e2 = true) {
        var t2, o2, a2, i2, l2;
        if (this.readonly || this.disabled) return;
        const s2 = e2 && !this.focused;
        this.focused = e2, s2 && (this.slottedTextarea ? this.slottedTextarea.focus() : null === (l2 = null === (i2 = null === (a2 = null === (o2 = null === (t2 = this.el) || void 0 === t2 ? void 0 : t2.shadowRoot) || void 0 === o2 ? void 0 : o2.querySelector) || void 0 === a2 ? void 0 : a2.call(o2, "textarea")) || void 0 === i2 ? void 0 : i2.focus) || void 0 === l2 || l2.call(i2));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "7b9bce8cbbd3c6f38bb8f3b54091aeeb1e5064b7",
            class: "market-textarea",
            onBlur: ()=>{
                this.focused = false;
            },
            onClick: ()=>{
                this.setFocus();
            },
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("div", {
            key: "7eb8aeef472ce9a56162c19d29bc304e4daea1b8",
            class: "label-input-container",
            part: "container"
        }, (0, $696Z8.h)("slot", {
            key: "9d2b616ffdf8e442fcfee0e2464df977e15be5fd"
        }), (0, $696Z8.h)("slot", {
            key: "f767165d3a5603695dc9371c1c3611425555e675",
            name: "textarea",
            onSlotchange: ()=>this.registerSlottedTextarea()
        }, !this.slottedTextarea && (0, $696Z8.h)("textarea", Object.assign({
            key: "04316958e969650062f8a389b81931130d115634"
        }, this.ariaAttributes, {
            id: this.name,
            onInput: (e2)=>this.textareaValueDidChange(e2)
        }, this.sharedProps)))));
    }
    disconnectedCallback() {
        var e2;
        null === (e2 = this.mutationObserver) || void 0 === e2 || e2.disconnect();
    }
    get el() {
        return this;
    }
    static get style() {
        return `:host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host input,:host ::slotted(input){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color);}:host::after{content:"";position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)         var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([readonly]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([disabled]) ::slotted(.market-accessory),:host([disabled]) ::slotted(img[slot*="accessory"]),:host([disabled]) ::slotted(svg[slot*="accessory"]),:host([disabled]) ::slotted(div[slot*="accessory"]){--field-disabled-state-accessory-opacity:var(--row-disabled-state-leading-accessory-opacity);opacity:var(--field-disabled-state-accessory-opacity)}:host([value=""]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=""])) ::slotted(label),:host([value=""][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=""]):hover) ::slotted(label),:host([value=""][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=""][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=""])[disabled]) ::slotted(label),:host([value=""][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{--field-input-animation-speed:var(--core-animation-enter-transition-moderate-speed-duration);--field-input-label-translate:12px;--field-empty-phase-label-text-size-unitless:16;--field-float-phase-label-text-size-unitless:14;--field-size-medium-float-phase-vertical-padding-size:12px;--field-size-medium-float-phase-horizontal-padding-size:16px;--field-size-small-float-phase-vertical-padding-size:9px;--field-size-small-float-phase-horizontal-padding-size:12px;display:flex;align-items:center}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{flex-grow:1;padding:var(--field-float-phase-vertical-padding-size) var(--field-float-phase-horizontal-padding-size)}:host([size='medium']) .label-input-container,:host([size='medium'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-medium-float-phase-vertical-padding-size)       var(--field-size-medium-float-phase-horizontal-padding-size)}:host([size='small']) .label-input-container,:host([size='small'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-small-float-phase-vertical-padding-size)       var(--field-size-small-float-phase-horizontal-padding-size)}:host ::slotted(label){display:block;min-height:var(--field-empty-phase-label-text-leading);font-weight:var(--field-empty-phase-label-text-weight);font-size:var(--field-empty-phase-label-text-size);line-height:var(--field-empty-phase-label-text-leading);letter-spacing:var(--field-empty-phase-label-text-tracking);transition:all var(--field-input-animation-speed);transform:translateY(var(--field-input-label-translate));transform-origin:0 0}:host(:not([value=""])) ::slotted(label),:host([value=""]:not([focused])[autofilled]) ::slotted(label),:host([focused]) ::slotted(label){font-weight:var(--field-float-phase-label-text-weight);transform:scale(         calc(var(--field-float-phase-label-text-size-unitless) / var(--field-empty-phase-label-text-size-unitless))       )}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){opacity:0}:host([focused]) input,:host([focused]) ::slotted(input),:host([focused]) textarea,:host([focused]) ::slotted(textarea),:host(:not([value=''])) input,:host(:not([value=''])) ::slotted(input),:host(:not([value=''])) textarea,:host(:not([value=''])) ::slotted(textarea){opacity:1}:host([size='small']) ::slotted(label),:host([size='medium']) ::slotted(label){position:absolute;overflow:hidden;width:1px;height:1px;white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%)}:host([size='small']) input,:host([size='small']) ::slotted(input),:host([size='small']) textarea,:host([size='small']) ::slotted(textarea),:host([size='medium']) input,:host([size='medium']) ::slotted(input),:host([size='medium']) textarea,:host([size='medium']) ::slotted(textarea){opacity:1}:host{--textarea-height:120px;--textarea-minimum-height:120px;--textarea-label-bottom-padding:16px;flex-direction:column;overflow:hidden;min-height:var(--textarea-minimum-height);max-height:var(--textarea-maximum-height);resize:vertical}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{display:flex;flex-direction:column;width:100%;padding-bottom:var(--textarea-label-bottom-padding);font-weight:var(--textarea-font-weight);font-size:var(--textarea-font-size);line-height:var(--textarea-font-leading);letter-spacing:var(--textarea-font-tracking)}:host([disabled]) textarea,:host([disabled]) ::slotted(textarea){pointer-events:auto !important;}textarea,::slotted(textarea){flex-grow:1;resize:none}`;
    }
}, [
    257,
    "market-textarea",
    {
        placeholder: [
            1
        ],
        name: [
            1
        ],
        value: [
            1537
        ],
        maxlength: [
            1
        ],
        readonly: [
            516
        ],
        disabled: [
            516
        ],
        focused: [
            1540
        ],
        invalid: [
            516
        ],
        maxHeight: [
            1,
            "max-height"
        ],
        autofocus: [
            4
        ],
        inputmode: [
            1
        ],
        ariaAttributes: [
            32
        ],
        registerSlottedTextarea: [
            64
        ]
    },
    [
        [
            8,
            "marketDialogLoaded",
            "handleMarketDialogLoaded"
        ]
    ]
]), h = n$2;
const l = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketTileSelectedChanged = (0, $696Z8.createEvent)(this, "marketTileSelectedChanged", 7), this.marketTileRemoveClicked = (0, $696Z8.createEvent)(this, "marketTileRemoveClicked", 7), this.hasTrailingAccessorySlot = false, this.hasIndicatorTextSlot = false, this.disabled = false, this.interactive = false, this.showActions = false, this.size = "medium", this.selected = false, this.hasSlottedMedia = false;
    }
    onSizeChange() {
        this.adjustSlottedLabels();
    }
    setSelected(e2) {
        if ("boolean" != typeof e2) return Promise.resolve();
        if (this.selected !== e2) {
            const { defaultPrevented: t2 } = this.marketTileSelectedChanged.emit({
                selected: this.selected,
                value: this.value
            });
            t2 || (this.selected = e2);
        }
        return Promise.resolve();
    }
    handleClick(e2) {
        !this.disabled && this.interactive && (this.selected = !this.selected, e2.preventDefault(), this.marketTileSelectedChanged.emit({
            selected: this.selected,
            value: this.value
        }));
    }
    handleRemoveActionKeydown(e2) {
        switch(e2.key){
            case "Enter":
            case " ":
                this.handleRemoveActionClick(e2);
        }
    }
    handleRemoveActionClick(e2) {
        !this.disabled && this.interactive && (e2.stopPropagation(), this.marketTileRemoveClicked.emit());
    }
    renderDefaultRemoveAction() {
        const { disabled: e2, handleRemoveActionClick: t2, handleRemoveActionKeydown: i2 } = this;
        return (0, $696Z8.h)("button", {
            class: "remove-button",
            disabled: e2,
            onClick: t2.bind(this),
            onKeyUp: i2.bind(this)
        }, (0, $696Z8.h)("svg", {
            slot: "icon",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "var(--core-critical-text-color)",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M12.8318 7.3335V7.1685H12.6668H3.3335H3.1685V7.3335V8.66683V8.83183H3.3335H12.6668H12.8318V8.66683V7.3335Z",
            fill: "var(--core-critical-text-color)",
            stroke: "var(--core-critical-text-color)",
            "stroke-width": "0.33"
        })));
    }
    handleKeydown(e2) {
        if (e2.target === this.el) switch(e2.key){
            case "Enter":
            case " ":
                this.handleClick(e2);
        }
    }
    adjustSlottedLabels() {
        const { size: e2, el: t2 } = this, i2 = t2.querySelector('[slot="hint"]'), o2 = t2.querySelector('[slot="label"]'), a2 = t2.querySelector('[slot="subtext"]');
        o2 && t2.style.setProperty("--item-tile-label-line-clamp", "" + (i2 || a2 && "small" === e2 ? 1 : 2));
    }
    checkSlottedMedia() {
        this.hasSlottedMedia = !!this.el.querySelector('[slot="media"]');
    }
    componentWillLoad() {
        this.checkSlottedMedia(), this.hasIndicatorTextSlot = !!this.el.querySelector('[slot="indicator"]');
    }
    render() {
        const { disabled: e2, size: t2, hasSlottedMedia: i2, hasIndicatorTextSlot: r2, interactive: l2, showActions: n2, selected: c2 } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "f3df9954be6adda872de523e351bceaa2692df4b",
            class: "market-tile",
            tabindex: l2 && !e2 ? "0" : null,
            "aria-selected": "" + c2,
            onClick: (e3)=>this.handleClick(e3),
            onKeydown: (e3)=>this.handleKeydown(e3)
        }, (0, $696Z8.h)("div", {
            key: "4aab73a000bc09198dffd4558e9663ba84a865e4",
            class: t$a("background-image", {
                "has-slotted-media": i2
            })
        }, (0, $696Z8.h)("slot", {
            key: "811c470b278d4c213946429e53af2f45afc0d641",
            onSlotchange: ()=>this.checkSlottedMedia(),
            name: "media"
        })), (0, $696Z8.h)("slot", {
            key: "9b04e99c676d557eb24885ebbe0434978bcb7094",
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            key: "134d5766ba43ae9b0254ee646fe24e94f617e6df",
            class: "trailing-accessory-container"
        }, n2 && (0, $696Z8.h)("slot", {
            key: "0f0e8736ae5aa3660094ea34028aecd05161c884",
            name: "actions"
        }, this.renderDefaultRemoveAction()), !n2 && r2 && (0, $696Z8.h)("slot", {
            key: "d17a297a3e1e7b5ea1ef54bef9f4414de42b2940",
            name: "indicator"
        })), (0, $696Z8.h)("div", {
            key: "f8cf34383295e8a57c79754a189f0e4cd390c838",
            class: "content"
        }, "small" !== t2 && (0, $696Z8.h)("slot", {
            key: "d06d600bf217a85552045518c2ca2302d8510d1e",
            onSlotchange: ()=>this.adjustSlottedLabels(),
            name: "hint"
        }), (0, $696Z8.h)("slot", {
            key: "f932b8fe3bdea5500129a6285a056bff745567d1",
            onSlotchange: ()=>this.adjustSlottedLabels(),
            name: "label"
        }), (0, $696Z8.h)("slot", {
            key: "e87f05431c32b21e30837d8033547fdc961b0c0a",
            onSlotchange: ()=>this.adjustSlottedLabels(),
            name: "subtext"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            size: [
                {
                    onSizeChange: 0
                }
            ]
        };
    }
    static get style() {
        return '::slotted([slot="hint"]){font-weight:var(--core-type-display-10-weight);font-size:var(--core-type-display-10-size);font-family:var(--core-type-display-10-font-family);line-height:var(--core-type-display-10-leading);letter-spacing:var(--core-type-display-10-tracking);text-transform:var(--core-type-display-10-case)}::slotted([slot="subtext"]){font-weight:var(--core-type-paragraph-10-weight);font-size:var(--core-type-paragraph-10-size);font-family:var(--core-type-paragraph-10-font-family);line-height:var(--core-type-paragraph-10-leading);letter-spacing:var(--core-type-paragraph-10-tracking);text-transform:var(--core-type-paragraph-10-case)}::slotted([slot="subtext"]) b,::slotted([slot="subtext"]) strong{font-weight:var(--core-type-semibold-10-weight)}::slotted([slot="label"]){font-weight:var(--core-type-medium-30-weight);font-size:var(--core-type-medium-30-size);font-family:var(--core-type-medium-30-font-family);line-height:var(--core-type-medium-30-leading);letter-spacing:var(--core-type-medium-30-tracking);text-transform:var(--core-type-medium-30-case)}::slotted([slot="indicator"]){font-weight:var(--core-type-semibold-10-weight);font-size:var(--core-type-semibold-10-size);font-family:var(--core-type-semibold-10-font-family);line-height:var(--core-type-semibold-10-leading);letter-spacing:var(--core-type-semibold-10-tracking);text-transform:var(--core-type-semibold-10-case)}:host{--item-tile-text-color:black;--focus-ring-color:color-mix(       in srgb,       var(--item-tile-focus-ring-color, var(--core-focus-ring-color)) 100%,       transparent     );position:relative;z-index:1;display:grid;grid-template-areas:"leading-accessory _ trailing-accessory"     "content content content";grid-template-columns:minmax(0, max-content) 1fr auto;box-sizing:border-box;width:var(--item-tile-width, 200px);height:var(--item-tile-medium-height, 124px);padding:var(--item-tile-medium-padding, var(--core-metrics-spacing-150));border-radius:var(--item-tile-border-radius, 6px);background:var(--item-tile-fill-color, var(--core-fill-40-color));-webkit-user-select:none;-moz-user-select:none;user-select:none}:host([interactive]){cursor:pointer}:host([size="small"]){grid-template-areas:"leading-accessory content trailing-accessory";grid-template-columns:max-content 1fr minmax(0, max-content);-moz-column-gap:var(--core-metrics-spacing-100);column-gap:var(--core-metrics-spacing-100);height:var(--item-tile-small-height, 56px);padding:var(--item-tile-small-padding-vertical, var(--core-metrics-spacing-50))       var(--item-tile-small-padding-horizontal, var(--core-metrics-spacing-150))}:host([size="small"]) ::slotted([slot="leading-accessory"]),:host([size="small"]) .trailing-accessory-container{align-items:center}:host([size="small"]) .content{justify-content:center;align-items:start}:host([size="small"]) .remove-button{position:relative}:host([aria-disabled]){opacity:0.2;cursor:not-allowed}:host([aria-disabled]) .remove-button{cursor:not-allowed}:host([aria-disabled]) .remove-button:hover{background:var(--item-tile-remove-button-fill, #fff)}:host([aria-selected="true"]) ::before{content:"";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:var(--item-tile-border-radius, 6px);box-shadow:inset 0 0 0 var(--item-tile-selected-value-border-width, 2px)         var(--item-tile-selected-value-border-color, var(--core-emphasis-fill-color))}:host(:focus-visible){outline:var(--item-tile-focus-ring-border-size, var(--core-focus-ring-border-size)) solid var(--focus-ring-color);outline-offset:var(--item-tile-focus-ring-buffer-size, var(--core-focus-ring-buffer-size))}.background-image{display:none}.background-image.has-slotted-media,.background-image ::slotted([slot="media"]){--item-tile-text-color:white;position:absolute;top:0;left:0;z-index:-1;display:block;-o-object-fit:cover;object-fit:cover;width:100%;height:100%;border-radius:var(--item-tile-border-radius, 6px)}.background-image.has-slotted-media::before,.background-image ::slotted([slot="media"])::before{content:"";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:var(--item-tile-border-radius, 6px);background-image:var(         --item-tile-background-image-gradient,         linear-gradient(180.98deg, rgb(0 0 0 / 4%) 0.84%, rgb(0 0 0 / 40%) 99.16%)       )}::slotted([slot="leading-accessory"]){z-index:2;display:flex;grid-area:leading-accessory;align-items:flex-start}.trailing-accessory-container{z-index:3;display:flex;grid-area:trailing-accessory;justify-content:flex-end}.trailing-accessory-container .remove-button{position:absolute;width:var(--item-tile-remove-button-width, 24px);height:var(--item-tile-remove-button-height, 24px);border:none;border-radius:100px;background:var(--item-tile-remove-button-fill, var(--core-surface-30-color));box-shadow:var(--elevation-10-shadow);cursor:pointer}.trailing-accessory-container .remove-button:hover{background:var(--item-tile-remove-button-hover-state-background-color, #ffe5ea)}.trailing-accessory-container .remove-button:active{background:var(--item-time-remove-button-active-state-background-color, #ffccd5)}.trailing-accessory-container .remove-button svg{position:absolute;top:0;left:0;padding:var(--core-metrics-spacing-50)}.trailing-accessory-container ::slotted([slot="indicator"]){height:var(--core-metrics-spacing-200);padding:0 var(--core-metrics-spacing-100);border-radius:100px;background:var(--core-fill-10-dark-mode-color);color:black;box-shadow:var(--elevation-10-shadow)}.content{z-index:2;display:flex;flex-direction:column;grid-area:content;justify-content:flex-end;min-width:0}::slotted([slot="label"]){display:-webkit-box;overflow-y:hidden;min-width:0;-webkit-line-clamp:var(--item-tile-label-line-clamp, 1);-webkit-box-orient:vertical}::slotted([slot="subtext"]){display:-webkit-box;overflow-y:hidden;min-width:0;-webkit-line-clamp:1;-webkit-box-orient:vertical}';
    }
}, [
    257,
    "market-tile",
    {
        disabled: [
            516,
            "aria-disabled"
        ],
        interactive: [
            4
        ],
        showActions: [
            4,
            "show-actions"
        ],
        size: [
            513
        ],
        value: [
            513
        ],
        selected: [
            1540
        ],
        hasSlottedMedia: [
            32
        ],
        setSelected: [
            64
        ]
    },
    void 0,
    {
        size: [
            {
                onSizeChange: 0
            }
        ]
    }
]), n$1 = l;
const e = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketToastAutoDismissed = (0, $696Z8.createEvent)(this, "marketToastAutoDismissed", 7), this.marketToastManuallyDismissed = (0, $696Z8.createEvent)(this, "marketToastManuallyDismissed", 7), this.variant = "info", this.persistent = false, this.dismissButtonAriaLabel = "Dismiss", this.progress = -1, this.durationTilAutoDismiss = 5e3, this.showActionsNav = false;
    }
    startAutoDismissTimer() {
        return this.persistent || (this.autoDismissTimeout = setTimeout(()=>{
            this.marketToastAutoDismissed.emit();
        }, this.durationTilAutoDismiss)), Promise.resolve();
    }
    handleManualDismiss() {
        this.marketToastManuallyDismissed.emit();
    }
    disconnectedCallback() {
        clearTimeout(this.autoDismissTimeout);
    }
    componentWillLoad() {
        this.checkIfActionsArePresent();
    }
    checkIfActionsArePresent() {
        const t2 = this.el.querySelector('[slot="action"]');
        this.showActionsNav = !!t2;
    }
    getVariantIcon() {
        switch(this.variant){
            case "success":
                return "success";
            case "info":
                return "info";
            case "warning":
                return "attention";
            case "insight":
                return "recommendation";
            default:
                return "warning";
        }
    }
    render() {
        const t2 = l$s("market-icon"), a2 = Math.min(this.progress, 100), o2 = {
            width: a2 + "%"
        };
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "bd15d9665d0b2cae2643b953c47798e243a2c927",
            class: "market-toast",
            role: "alert"
        }, (0, $696Z8.h)("div", {
            key: "a4a12fcb767dcc1b034fae1d079b1e3943f0b1ed",
            class: "content"
        }, (0, $696Z8.h)("span", {
            key: "931442bff31c3b892a00b24ca75dabe9a4c563e8",
            class: "icon-container"
        }, (0, $696Z8.h)(t2, {
            key: "5a4a602134da6d7db8ccbb82b296b67fae75f7dd",
            name: this.getVariantIcon()
        })), (0, $696Z8.h)("div", {
            key: "2a65f074ce4b7a0a68b48158a0d7767aa1fbb117",
            class: "main"
        }, (0, $696Z8.h)("section", {
            key: "d46053b38475135ecfc63344ecde3acc1b99a116"
        }, (0, $696Z8.h)("slot", {
            key: "4d2707a1dd4d1a986bdcc1410481202a3418308c"
        })), (0, $696Z8.h)("nav", {
            key: "8e6b88eda4bf8f7fbf060cd19d4f81496bfbd2a0",
            "aria-label": "toast-actions",
            class: this.showActionsNav ? "" : "hidden"
        }, (0, $696Z8.h)("slot", {
            key: "de61545f58715dc02ec8ebb29aab518c161bb2aa",
            name: "action",
            onSlotchange: ()=>this.checkIfActionsArePresent()
        }))), (0, $696Z8.h)("nav", {
            key: "302fe3dbb9a9b4eb7a95b340c055acd366c0d0ea",
            "aria-label": "dismiss-container",
            class: "dismiss-container"
        }, (0, $696Z8.h)("button", {
            key: "a605b5efffeec089d99995f80b4f74f5ab8649fe",
            type: "button",
            "aria-label": this.dismissButtonAriaLabel,
            onClick: ()=>this.handleManualDismiss()
        }, (0, $696Z8.h)(t2, {
            key: "f1f79b226ea1f92cdd78cc8cbca73897eb76bd27",
            name: "close"
        })))), this.progress >= 0 && (0, $696Z8.h)("progress-bar", {
            key: "baade336b508e01352e2ad1ca37be6eddcd3e506",
            role: "progressbar",
            "aria-valuenow": a2,
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            style: o2
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:flex;flex-direction:column;align-items:flex-start;overflow:hidden;width:100%;max-width:var(--toast-maximum-width);border-radius:var(--toast-radius);box-shadow:var(--elevation-30-shadow);font-weight:var(--toast-text-weight);font-size:var(--toast-text-size);line-height:var(--toast-text-leading);letter-spacing:var(--toast-text-tracking);text-transform:var(--toast-text-case)}.icon-container,.dismiss-container{display:flex;flex-shrink:0;align-items:center}.dismiss-container button{display:flex;justify-content:center;align-items:center;margin:0;padding:0;border:none;background-color:transparent;color:inherit;cursor:pointer;transition:opacity var(--core-animation-enter-transition-moderate-speed-duration);-webkit-appearance:none;-moz-appearance:none;appearance:none}.content{display:flex;-moz-column-gap:var(--toast-icon-spacing);column-gap:var(--toast-icon-spacing);align-items:flex-start;width:100%;padding:var(--toast-vertical-padding-size) var(--toast-horizontal-padding-size)}.main{display:flex;flex-grow:1;flex-wrap:wrap;gap:var(--toast-text-multiline-spacing) var(--toast-content-spacing)}section{flex-grow:1}nav{display:flex;flex-wrap:wrap;justify-content:flex-end}nav.hidden{display:none}::slotted(button),::slotted(a){margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:var(--toast-button-text-weight);font-size:var(--toast-button-text-size);font-family:inherit;line-height:var(--toast-button-text-leading);letter-spacing:var(--toast-button-text-tracking);text-decoration:underline;text-transform:var(--toast-button-text-case);cursor:pointer;transition:opacity var(--core-animation-enter-transition-moderate-speed-duration);text-underline-offset:2px;text-decoration-thickness:1px}::slotted(button:hover),::slotted(a:hover){opacity:var(--text-link-hover-state-opacity)}::slotted(button:active),::slotted(a:active){opacity:var(--text-link-pressed-state-opacity)}::slotted([slot="action"]){display:flex;justify-content:center;align-items:center}::slotted([slot="action"]:not(:last-child)){margin-right:calc(var(--toast-button-spacing) * 2 + var(--toast-separator-width))}::slotted([slot="action"]:not(:last-child))::after{content:"";display:inline-block;width:var(--toast-separator-width);height:var(--toast-separator-height);margin-right:calc(-1 * var(--toast-button-spacing) - var(--toast-separator-width));margin-left:var(--toast-button-spacing);opacity:var(--toast-separator-opacity);pointer-events:none}progress-bar{height:var(--toast-progress-bar-height)}:host([variant="info"]){background-color:var(--toast-info-variant-background-color);color:var(--toast-info-variant-text-color)}:host([variant="info"]) .icon-container{color:var(--toast-info-variant-icon-color)}:host([variant="info"]) .dismiss-container{color:var(--toast-info-variant-dismiss-button-color)}:host([variant="info"]) progress-bar{background-color:var(--toast-info-variant-progress-bar-color)}:host([variant="info"]) ::slotted(a){color:var(--toast-info-variant-text-link-text-color)}:host([variant="info"]) ::slotted(button){color:var(--toast-info-variant-button-text-color)}:host([variant="info"]) ::slotted([slot="action"]:not(:last-child))::after{background-color:var(--toast-info-variant-separator-color)}:host([variant="success"]){background-color:var(--toast-success-variant-background-color);color:var(--toast-success-variant-text-color)}:host([variant="success"]) .icon-container{color:var(--toast-success-variant-icon-color)}:host([variant="success"]) .dismiss-container{color:var(--toast-success-variant-dismiss-button-color)}:host([variant="success"]) progress-bar{background-color:var(--toast-success-variant-progress-bar-color)}:host([variant="success"]) ::slotted(a){color:var(--toast-success-variant-text-link-text-color)}:host([variant="success"]) ::slotted(button){color:var(--toast-success-variant-button-text-color)}:host([variant="success"]) ::slotted([slot="action"]:not(:last-child))::after{background-color:var(--toast-success-variant-separator-color)}:host([variant="warning"]){background-color:var(--toast-warning-variant-background-color);color:var(--toast-warning-variant-text-color)}:host([variant="warning"]) .icon-container{color:var(--toast-warning-variant-icon-color)}:host([variant="warning"]) .dismiss-container{color:var(--toast-warning-variant-dismiss-button-color)}:host([variant="warning"]) progress-bar{background-color:var(--toast-warning-variant-progress-bar-color)}:host([variant="warning"]) ::slotted(a){color:var(--toast-warning-variant-text-link-text-color)}:host([variant="warning"]) ::slotted(button){color:var(--toast-warning-variant-button-text-color)}:host([variant="warning"]) ::slotted([slot="action"]:not(:last-child))::after{background-color:var(--toast-warning-variant-separator-color)}:host([variant="critical"]){background-color:var(--toast-critical-variant-background-color);color:var(--toast-critical-variant-text-color)}:host([variant="critical"]) .icon-container{color:var(--toast-critical-variant-icon-color)}:host([variant="critical"]) .dismiss-container{color:var(--toast-critical-variant-dismiss-button-color)}:host([variant="critical"]) progress-bar{background-color:var(--toast-critical-variant-progress-bar-color)}:host([variant="critical"]) ::slotted(a){color:var(--toast-critical-variant-text-link-text-color)}:host([variant="critical"]) ::slotted(button){color:var(--toast-critical-variant-button-text-color)}:host([variant="critical"]) ::slotted([slot="action"]:not(:last-child))::after{background-color:var(--toast-critical-variant-separator-color)}:host([variant="insight"]){background-color:var(--toast-insight-variant-background-color);color:var(--toast-insight-variant-text-color)}:host([variant="insight"]) .icon-container{color:var(--toast-insight-variant-icon-color)}:host([variant="insight"]) .dismiss-container{color:var(--toast-insight-variant-dismiss-button-color)}:host([variant="insight"]) progress-bar{background-color:var(--toast-insight-variant-progress-bar-color)}:host([variant="insight"]) ::slotted(a){color:var(--toast-insight-variant-text-link-text-color)}:host([variant="insight"]) ::slotted(button){color:var(--toast-insight-variant-button-text-color)}:host([variant="insight"]) ::slotted([slot="action"]:not(:last-child))::after{background-color:var(--toast-insight-variant-separator-color)}:host-context([data-market-theme="monochrome"]) ::slotted(button:focus-visible),:host-context([data-market-theme="monochrome"]) ::slotted(a:focus-visible),:host-context([data-market-theme="monochrome"]) .dismiss-container *:focus-visible{outline-color:currentcolor}';
    }
}, [
    257,
    "market-toast",
    {
        variant: [
            513
        ],
        persistent: [
            4
        ],
        dismissButtonAriaLabel: [
            513,
            "dismiss-button-aria-label"
        ],
        progress: [
            514
        ],
        durationTilAutoDismiss: [
            32
        ],
        showActionsNav: [
            32
        ],
        startAutoDismissTimer: [
            64
        ]
    }
]), c = e;
const r = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.toasts = [];
    }
    async show(t2) {
        this.toasts.unshift(t2), t2.classList.add("use-transitions"), this.el.appendChild(t2), window.requestAnimationFrame(this.positionToasts.bind(this)), await new Promise((t3)=>setTimeout(t3, 200)), t2.startAutoDismissTimer();
    }
    positionToasts() {
        let t2 = 24;
        this.toasts.forEach((e2)=>{
            e2.style.transform = `translate(-50%, calc(-100% - ${t2}px))`, t2 += e2.offsetHeight + 16;
        });
    }
    async hide(t2) {
        const e2 = this.toasts.indexOf(t2);
        this.toasts.splice(e2, 1), window.requestAnimationFrame(()=>{
            t2.style.transform = "", this.positionToasts();
        }), await new Promise((t3)=>setTimeout(t3, 200)), t2.remove();
    }
    removeAll() {
        const t2 = [
            ...this.toasts
        ];
        return Promise.all(t2.map((t3)=>this.hide(t3)));
    }
    toastAutoDismissedEventHandler({ target: t2 }) {
        this.hide(t2);
    }
    toastManuallyDismissedEventHandler({ target: t2 }) {
        this.hide(t2);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "1e7cd1efe786c2e413bc777b5c3f7de137c6f100",
            class: "market-toaster"
        }, (0, $696Z8.h)("slot", {
            key: "0e77820fe26f481aa541124a1f399e12b0602e28"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{position:fixed;right:0;bottom:0;left:0;z-index:1010;padding:0 0 var(--toast-bottom-margin, 24px);pointer-events:none}:host ::slotted(.market-toast){width:calc(100% - var(--toast-horizontal-margin, 16px) * 2);margin:var(--toast-vertical-spacing, 16px) auto 0;pointer-events:auto}:host ::slotted(.use-transitions){position:absolute;top:100%;left:50%;margin:0;transition:transform       var(         --toast-animation-transition-duration,         var(--core-animation-enter-transition-moderate-speed-duration)       )       ease-in-out;transform:translate(-50%, 0)}";
    }
}, [
    257,
    "market-toaster",
    {
        show: [
            64
        ],
        hide: [
            64
        ],
        removeAll: [
            64
        ]
    },
    [
        [
            0,
            "marketToastAutoDismissed",
            "toastAutoDismissedEventHandler"
        ],
        [
            0,
            "marketToastManuallyDismissed",
            "toastManuallyDismissedEventHandler"
        ]
    ]
]), a = r;
const i = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(e2){
        super(), false !== e2 && this.__registerHost(), this.__attachShadow(), this.marketToggleChange = (0, $696Z8.createEvent)(this, "marketToggleChange", 7), this.checked = false, this.disabled = false, this.focused = false, this.hovered = false, this.active = false, this.ariaAttributesHash = 0;
    }
    setSelection(e2, { silent: t2 = false } = {}) {
        const { marketToggleChange: o2, checked: r2, innerInput: s2 } = this;
        if ("boolean" != typeof e2) return Promise.resolve();
        if (r2 === e2) return Promise.resolve();
        if (!t2) {
            const { defaultPrevented: t3 } = o2.emit({
                current: e2,
                previous: r2
            });
            if (t3) return Promise.resolve();
        }
        return this.checked = e2, s2 && (s2.checked = e2), Promise.resolve();
    }
    setValue(e2) {
        return console.warn("market-toggle's setValue() method has been deprecated. Use setSelection() instead.", this.el), this.setSelection(e2), Promise.resolve();
    }
    setActive(e2) {
        return this.active = e2, Promise.resolve();
    }
    setHover(e2) {
        return this.hovered = e2, Promise.resolve();
    }
    setDisabled(e2) {
        return this.disabled = e2, Promise.resolve();
    }
    setFocus(e2 = true) {
        return this.disabled && e2 || (this.focused = e2), Promise.resolve();
    }
    handleClick(e2) {
        e2.preventDefault(), this.disabled || (this.setFocus(), this.setSelection(!this.checked));
    }
    componentWillLoad() {
        "undefined" != typeof MutationObserver && (this.mutationObserver = a$q(this.el, ()=>{
            (this.el.hasAttribute("aria-label") || this.el.hasAttribute("aria-labelledby")) && this.ariaAttributesHash++;
        }));
    }
    disconnectedCallback() {
        var e2;
        null === (e2 = this.mutationObserver) || void 0 === e2 || e2.disconnect();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "d4815a201038d173d42ee35c2c2c6c67b96a7618",
            class: "market-toggle",
            onBlur: ()=>{
                this.setFocus(false);
            },
            onClick: this.handleClick,
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("input", {
            key: "7530f40597920fe850f742bc18c19f6ff92c147e",
            ref: (e2)=>this.innerInput = e2,
            type: "checkbox",
            role: "switch",
            "aria-label": e$d(this.el),
            checked: this.checked,
            disabled: this.disabled
        }), (0, $696Z8.h)("svg", {
            key: "558d8fb8e915c6f515cfbc4786f3354eee099f54",
            width: "40",
            height: "24",
            viewBox: "0 0 40 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
        }, (0, $696Z8.h)("rect", {
            key: "c34c9bdbb92971fceeadcf64cf512c7cfc87494a",
            x: "1",
            y: "1",
            width: "38",
            height: "22",
            rx: "11",
            "stroke-width": "2"
        }), (0, $696Z8.h)("circle", {
            key: "d88c09fa6d17d5d686fc89682241ccf57a06f1ec",
            cx: "12",
            cy: "12",
            r: "7"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{--focus-ring-color:color-mix(in srgb, var(--toggle-focus-ring-color) 100%, transparent);position:relative;display:inline-block;height:var(--toggle-height)}input{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;border-radius:var(--toggle-border-radius);background:transparent;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}input:focus-visible{outline:var(--toggle-focus-ring-border-size) solid var(--focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size);}circle,rect{transition:var(--row-slotted-control-transition, var(--core-animation-enter-transition-moderate-speed-duration))}circle{fill:var(--toggle-normal-state-unselected-value-thumb-color)}rect{fill:var(--toggle-normal-state-unselected-value-track-color);stroke:var(--toggle-normal-state-unselected-value-border-color)}:host([checked]){}:host([checked]) circle{fill:var(--toggle-normal-state-selected-value-thumb-color);cx:28px}:host([checked]) rect{fill:var(--toggle-normal-state-selected-value-track-color);stroke:var(--toggle-normal-state-selected-value-border-color)}:host(:hover) circle,:host([hovered]) circle{fill:var(--toggle-hover-state-unselected-value-thumb-color)}:host(:hover) rect,:host([hovered]) rect{fill:var(--toggle-hover-state-unselected-value-track-color);stroke:var(--toggle-hover-state-unselected-value-border-color)}:host([checked]:hover) circle,:host([checked][hovered]) circle{fill:var(--toggle-hover-state-selected-value-thumb-color)}:host([checked]:hover) rect,:host([checked][hovered]) rect{fill:var(--toggle-hover-state-selected-value-track-color);stroke:var(--toggle-hover-state-selected-value-border-color)}:host([focused]) circle{fill:var(--toggle-focus-state-unselected-value-thumb-color)}:host([focused]) rect{fill:var(--toggle-focus-state-unselected-value-track-color);stroke:var(--toggle-focus-state-unselected-value-border-color)}:host([checked][focused]) circle{fill:var(--toggle-focus-state-selected-value-thumb-color)}:host([checked][focused]) rect{fill:var(--toggle-focus-state-selected-value-track-color);stroke:var(--toggle-focus-state-selected-value-border-color)}:host(:active) circle,:host([active]) circle{fill:var(--toggle-pressed-state-unselected-value-thumb-color)}:host(:active) rect,:host([active]) rect{fill:var(--toggle-pressed-state-unselected-value-track-color);stroke:var(--toggle-pressed-state-unselected-value-border-color)}:host([checked]:active) circle,:host([checked][active]) circle{fill:var(--toggle-pressed-state-selected-value-thumb-color)}:host([checked]:active) rect,:host([checked][active]) rect{fill:var(--toggle-pressed-state-selected-value-track-color);stroke:var(--toggle-pressed-state-selected-value-border-color)}:host([disabled]) input{cursor:not-allowed}:host([disabled]) circle{fill:var(--toggle-disabled-state-unselected-value-thumb-color)}:host([disabled]) rect{fill:var(--toggle-disabled-state-unselected-value-track-color);stroke:var(--toggle-disabled-state-unselected-value-border-color)}:host([disabled][checked]) circle{fill:var(--toggle-disabled-state-selected-value-thumb-color)}:host([disabled][checked]) rect{fill:var(--toggle-disabled-state-selected-value-track-color);stroke:var(--toggle-disabled-state-selected-value-border-color)}";
    }
}, [
    1,
    "market-toggle",
    {
        checked: [
            1540
        ],
        disabled: [
            1540
        ],
        focused: [
            1540
        ],
        hovered: [
            1540
        ],
        active: [
            1540
        ],
        ariaAttributesHash: [
            32
        ],
        setSelection: [
            64
        ],
        setValue: [
            64
        ],
        setActive: [
            64
        ],
        setHover: [
            64
        ],
        setDisabled: [
            64
        ],
        setFocus: [
            64
        ]
    }
]), d = i;
const n = (0, $696Z8.proxyCustomElement)(class extends (0, $696Z8.HTMLElement) {
    constructor(t2){
        super(), false !== t2 && this.__registerHost(), this.__attachShadow(), this.marketTooltipOpened = (0, $696Z8.createEvent)(this, "marketTooltipOpened", 7), this.marketTooltipClosed = (0, $696Z8.createEvent)(this, "marketTooltipClosed", 7), this.interaction = "hover", this.disabled = false, this.popoverPlacement = "bottom", this.popoverStrategy = "absolute", this.popoverDistance = 0, this.expanded = false;
    }
    dropdownOpenedEventHandler(t2) {
        t2.target === this.el && (t2.stopPropagation(), this.expanded = true, this.marketTooltipOpened.emit());
    }
    dropdownClosedEventHandler(t2) {
        t2.target === this.el && (t2.stopPropagation(), this.expanded = false, this.marketTooltipClosed.emit());
    }
    openTooltip() {
        return this.innerDropdown.openDropdown();
    }
    closeTooltip() {
        return this.innerDropdown.closeDropdown();
    }
    styleLinks() {
        const t2 = [
            ...this.el.children
        ].find((t3)=>"content" === t3.slot), o2 = null == t2 ? void 0 : t2.querySelectorAll("a"), e2 = null == t2 ? void 0 : t2.querySelectorAll("" + l$s("market-link"));
        null == o2 || o2.forEach((t3)=>{
            t3.style.color = "var(--tooltip-link-color)", t3.style.fontSize = "var(--tooltip-link-size)", t3.style.fontWeight = "var(--tooltip-link-weight)", t3.style.lineHeight = "var(--tooltip-link-leading)", t3.style.letterSpacing = "var(--tooltip-link-tracking)", t3.style.textTransform = "var(--tooltip-link-case)", t3.style.textDecoration = "underline", t3.style.textUnderlineOffset = "2px", t3.style.outline = "none";
        }), null == e2 || e2.forEach((t3)=>{
            t3.style.setProperty("--link-internal-underline-size", "1px");
        });
    }
    componentWillRender() {
        this.styleLinks();
    }
    render() {
        const t2 = l$s("market-dropdown");
        return (0, $696Z8.h)((0, $696Z8.Host), {
            key: "404c93fa59881b44104c38f5cae7c971d67c396b",
            "aria-expanded": this.expanded,
            class: "market-tooltip"
        }, (0, $696Z8.h)(t2, {
            key: "6b95a2a392bba233092542b48950f8a6bc83d364",
            interaction: this.interaction,
            "popover-placement": this.popoverPlacement,
            "popover-strategy": this.popoverStrategy,
            "popover-distance": this.popoverDistance,
            "popover-skidding": this.popoverSkidding,
            "popover-constrain-width": true,
            disabled: this.disabled,
            expanded: this.expanded,
            "aria-expanded": this.expanded,
            part: "dropdown",
            ref: (t3)=>this.innerDropdown = t3,
            tabIndex: 0
        }, (0, $696Z8.h)("div", {
            key: "bbf2aef32c31dc4d1526f80bb87e0fad36269bc3",
            slot: "trigger",
            part: "trigger",
            class: "trigger-tap-target"
        }, (0, $696Z8.h)("slot", {
            key: "632360db0a6eb45bf16359a5ed141d3d8a9eeeff",
            name: "trigger"
        }, (0, $696Z8.h)("svg", {
            key: "8a77c484edcad261a6b0f470f903bd1fb58f2ab4",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            key: "64927235de90f8623d419ee867e314c5286359a9",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M9 0C4.04 0 0 4.04 0 9C0 13.96 4.04 18 9 18C13.96 18 18 13.96 18 9C18 4.04 13.96 0 9 0ZM9 16C5.14 16 2 12.86 2 9C2 5.14 5.14 2 9 2C12.86 2 16 5.14 16 9C16 12.86 12.86 16 9 16ZM8 7.5V14H10V7.5H8ZM10.25 5.25C10.25 5.94036 9.69036 6.5 9 6.5C8.30964 6.5 7.75 5.94036 7.75 5.25C7.75 4.55964 8.30964 4 9 4C9.69036 4 10.25 4.55964 10.25 5.25Z"
        })))), (0, $696Z8.h)("div", {
            key: "6f74622c3d77fc73e3eec0a9e8f06ca621db677b",
            class: "popover",
            slot: "popover",
            part: "popover",
            role: "tooltip"
        }, (0, $696Z8.h)("slot", {
            key: "b40cd0407136aa4f9368413449ae4014bb40898a",
            name: "content",
            onSlotchange: ()=>this.styleLinks()
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return ':host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host *{outline-color:var(--core-focus-ring-color)}:host(:focus-visible),::slotted(*:focus-visible){outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color);outline-offset:var(--core-focus-ring-buffer-size)}::slotted(a),::slotted(button){border-radius:1px}:host{display:inline-block;}:host .market-dropdown{padding-bottom:0;border-radius:var(--core-radius-66)}:host .market-dropdown .trigger-tap-target{display:flex;justify-content:center;align-items:center;min-width:var(--tooltip-minimum-width);min-height:var(--tooltip-minimum-height)}:host svg,:host ::slotted(svg[slot="trigger"]){fill:var(--tooltip-trigger-icon-normal-state-color);transition:fill       var(--tooltip-animation-move-transition-duration)       ease-out}:host ::slotted([slot="trigger"]:not(svg)){color:var(--tooltip-trigger-text-normal-state-color);transition:color       border-bottom       var(--tooltip-trigger-animation-fade-transition-duration)       ease-out;text-decoration-line:underline;text-decoration-style:dashed;text-decoration-color:var(--tooltip-trigger-text-normal-state-color);text-decoration-thickness:var(--tooltip-trigger-text-underline-size);text-underline-position:under;text-underline-offset:2px;}:host([aria-expanded]) svg,:host([aria-expanded]) ::slotted(svg[slot="trigger"]){fill:var(--tooltip-trigger-icon-active-state-color)}:host([aria-expanded]) ::slotted([slot="trigger"]:not(svg)){color:var(--tooltip-trigger-text-active-state-color);text-decoration-color:var(--tooltip-trigger-text-active-state-color)}:host([disabled]) svg,:host([disabled]) ::slotted(svg[slot="trigger"]){fill:var(--tooltip-trigger-icon-disabled-state-color)}:host([disabled]) ::slotted([slot="trigger"]:not(svg)){color:var(--tooltip-trigger-text-disabled-state-color);text-decoration-color:var(--tooltip-trigger-text-disabled-state-color)}:host .popover{--text-link-normal-variant-color:var(--tooltip-link-color);--text-link-normal-variant-hover-state-color:var(--tooltip-link-color);--text-link-normal-variant-pressed-state-color:var(--tooltip-link-color);--text-link-normal-variant-disabled-state-color:var(--tooltip-link-color);--text-link-destructive-variant-color:var(--tooltip-link-color);--text-link-destructive-variant-hover-state-color:var(--tooltip-link-color);--text-link-destructive-variant-pressed-state-color:var(--tooltip-link-color);--text-link-destructive-variant-disabled-state-color:var(--tooltip-link-color);width:-moz-max-content;width:max-content;max-width:var(--tooltip-maximum-width);padding:var(--tooltip-padding-vertical-size) var(--tooltip-padding-horizontal-size);border-radius:var(--tooltip-radius);background-color:var(--tooltip-background-color);color:var(--tooltip-text-color);box-shadow:var(--elevation-30-shadow);font-weight:var(--tooltip-text-weight);font-size:var(--tooltip-text-size);line-height:var(--tooltip-text-leading);letter-spacing:var(--tooltip-text-tracking);text-transform:var(--tooltip-text-case)}';
    }
}, [
    257,
    "market-tooltip",
    {
        interaction: [
            1
        ],
        disabled: [
            516
        ],
        popoverPlacement: [
            1,
            "popover-placement"
        ],
        popoverStrategy: [
            1,
            "popover-strategy"
        ],
        popoverSkidding: [
            2,
            "popover-skidding"
        ],
        popoverDistance: [
            2,
            "popover-distance"
        ],
        expanded: [
            516
        ],
        openTooltip: [
            64
        ],
        closeTooltip: [
            64
        ]
    },
    [
        [
            0,
            "marketDropdownOpened",
            "dropdownOpenedEventHandler"
        ],
        [
            0,
            "marketDropdownClosed",
            "dropdownClosedEventHandler"
        ]
    ]
]), s = n;
function Mr(r2) {
    var t2;
    const m2 = r2;
    return (null === (t2 = null == m2 ? void 0 : m2.tagName) || void 0 === t2 ? void 0 : t2.includes("MARKET-")) && "function" == typeof m2.componentOnReady;
}
const Or = async (r2)=>{
    var t2, m2, o2;
    if (!r2) return;
    Mr(r2) && await new Promise((t3)=>{
        var m3;
        null === (m3 = r2.componentOnReady) || void 0 === m3 || m3.call(r2).then((r3)=>{
            t3(r3);
        }), setTimeout(()=>{
            t3(null);
        }, 200);
    });
    const e2 = [
        ...null !== (t2 = r2.children) && void 0 !== t2 ? t2 : [],
        ...null !== (o2 = null === (m2 = r2.shadowRoot) || void 0 === m2 ? void 0 : m2.children) && void 0 !== o2 ? o2 : []
    ].filter((r3)=>![
            "svg",
            void 0
        ].includes(r3.tagName));
    await Promise.all(e2.map((r3)=>Or(r3)));
}, Rr = (s2)=>{
    "undefined" != typeof customElements && [
        c$x,
        g$c,
        l$q,
        n$E,
        s$u,
        d$l,
        u$h,
        l$o,
        c$t,
        h$e,
        n$x,
        n$w,
        n$v,
        a$m,
        c$p,
        b$9,
        s$o,
        s$n,
        x$9,
        c$n,
        u$c,
        d$f,
        O$6,
        s$l,
        K$2,
        n$p,
        h$b,
        n$o,
        c$j,
        y$6,
        i$e,
        n$m,
        n$l,
        c$h,
        a$g,
        c$g,
        p$5,
        n$j,
        c$f,
        s$h,
        i$b,
        o$7,
        l$d,
        d$7,
        p$4,
        l$c,
        W$2,
        f$3,
        f$2,
        r$4,
        l$6,
        c$8,
        n$d,
        d$3,
        I$1,
        p,
        b,
        c$5,
        j$1,
        i$3,
        d$1,
        x$2,
        T$1,
        n$9,
        n$8,
        n$7,
        a$4,
        c$4,
        s$5,
        s$4,
        n$4,
        n$3,
        h$2,
        c$2,
        g,
        c$1,
        i$1,
        l$1,
        h,
        n$1,
        c,
        a,
        d,
        s
    ].forEach((t2)=>{
        customElements.get((0, $696Z8.transformTag)(t2.is)) || customElements.define((0, $696Z8.transformTag)(t2.is), t2, s2);
    });
};

});
parcelRegister("696Z8", function(module, exports) {

$parcel$export(module.exports, "h", () => $47990066fdbc3144$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "transformTag", () => $47990066fdbc3144$export$e6778302ec5425de);
$parcel$export(module.exports, "Host", () => $47990066fdbc3144$export$5d2c872882e2b878);
$parcel$export(module.exports, "createEvent", () => $47990066fdbc3144$export$c30017717ce2168e);
$parcel$export(module.exports, "proxyCustomElement", () => $47990066fdbc3144$export$370caf1876b7c579);
$parcel$export(module.exports, "Fragment", () => $47990066fdbc3144$export$ffb0004e005737fa);
$parcel$export(module.exports, "HTMLElement", () => $47990066fdbc3144$export$7f8ddf7c7c20b3cd);
/*
 Stencil Client Platform v4.43.4 | MIT Licensed | https://stenciljs.com
 */ // src/client/client-build.ts

var $kxuSp = parcelRequire("kxuSp");

var $5C7R7 = parcelRequire("5C7R7");
var $47990066fdbc3144$export$77b5f1d340d6466b = {
    isDev: (0, $kxuSp.BUILD).isDev ? true : false,
    isBrowser: true,
    isServer: false,
    isTesting: (0, $kxuSp.BUILD).isTesting ? true : false
};
// src/utils/constants.ts
var $47990066fdbc3144$var$SVG_NS = "http://www.w3.org/2000/svg";
var $47990066fdbc3144$var$HTML_NS = "http://www.w3.org/1999/xhtml";
var $47990066fdbc3144$var$PrimitiveType = /* @__PURE__ */ ((PrimitiveType2)=>{
    PrimitiveType2["Undefined"] = "undefined";
    PrimitiveType2["Null"] = "null";
    PrimitiveType2["String"] = "string";
    PrimitiveType2["Number"] = "number";
    PrimitiveType2["SpecialNumber"] = "number";
    PrimitiveType2["Boolean"] = "boolean";
    PrimitiveType2["BigInt"] = "bigint";
    return PrimitiveType2;
})($47990066fdbc3144$var$PrimitiveType || {});
var $47990066fdbc3144$var$NonPrimitiveType = /* @__PURE__ */ ((NonPrimitiveType2)=>{
    NonPrimitiveType2["Array"] = "array";
    NonPrimitiveType2["Date"] = "date";
    NonPrimitiveType2["Map"] = "map";
    NonPrimitiveType2["Object"] = "object";
    NonPrimitiveType2["RegularExpression"] = "regexp";
    NonPrimitiveType2["Set"] = "set";
    NonPrimitiveType2["Channel"] = "channel";
    NonPrimitiveType2["Symbol"] = "symbol";
    return NonPrimitiveType2;
})($47990066fdbc3144$var$NonPrimitiveType || {});
var $47990066fdbc3144$var$TYPE_CONSTANT = "type";
var $47990066fdbc3144$var$VALUE_CONSTANT = "value";
var $47990066fdbc3144$var$SERIALIZED_PREFIX = "serialized:";
// src/utils/get-prop-descriptor.ts
function $47990066fdbc3144$var$getPropertyDescriptor(obj, memberName, getOnly) {
    const stopAt = typeof HTMLElement !== "undefined" ? HTMLElement.prototype : null;
    while(obj && obj !== stopAt){
        const desc = Object.getOwnPropertyDescriptor(obj, memberName);
        if (desc && (!getOnly || desc.get)) return desc;
        obj = Object.getPrototypeOf(obj);
    }
    return void 0;
}
// src/utils/es2022-rewire-class-members.ts
var $47990066fdbc3144$var$reWireGetterSetter = (instance, hostRef)=>{
    var _a;
    const cmpMeta = hostRef.$cmpMeta$;
    const members = Object.entries((_a = cmpMeta.$members$) != null ? _a : {});
    members.map(([memberName, [memberFlags]])=>{
        if (((0, $kxuSp.BUILD).state || (0, $kxuSp.BUILD).prop) && (memberFlags & 31 /* Prop */  || memberFlags & 32 /* State */ )) {
            const ogValue = instance[memberName];
            const ogDescriptor = $47990066fdbc3144$var$getPropertyDescriptor(Object.getPrototypeOf(instance), memberName, true) || Object.getOwnPropertyDescriptor(instance, memberName);
            if (ogDescriptor) Object.defineProperty(instance, memberName, {
                get () {
                    return ogDescriptor.get.call(this);
                },
                set (newValue) {
                    ogDescriptor.set.call(this, newValue);
                },
                configurable: true,
                enumerable: true
            });
            if (hostRef.$instanceValues$.has(memberName)) instance[memberName] = hostRef.$instanceValues$.get(memberName);
            else if (ogValue !== void 0) instance[memberName] = ogValue;
        }
    });
};
// src/client/client-host-ref.ts
var $47990066fdbc3144$export$3f84770eccf215d2 = (ref)=>{
    if (ref.__stencil__getHostRef) return ref.__stencil__getHostRef();
    return void 0;
};
var $47990066fdbc3144$export$ea4bcaef8454fd24 = (lazyInstance, hostRef)=>{
    if (!hostRef) return;
    lazyInstance.__stencil__getHostRef = ()=>hostRef;
    hostRef.$lazyInstance$ = lazyInstance;
    if (hostRef.$cmpMeta$.$flags$ & 512 /* hasModernPropertyDecls */  && ((0, $kxuSp.BUILD).state || (0, $kxuSp.BUILD).prop)) $47990066fdbc3144$var$reWireGetterSetter(lazyInstance, hostRef);
};
var $47990066fdbc3144$export$c20b986001efcf6c = (hostElement, cmpMeta)=>{
    const hostRef = {
        $flags$: 0,
        $hostElement$: hostElement,
        $cmpMeta$: cmpMeta,
        $instanceValues$: /* @__PURE__ */ new Map(),
        $serializerValues$: /* @__PURE__ */ new Map()
    };
    if ((0, $kxuSp.BUILD).isDev) hostRef.$renderCount$ = 0;
    if ((0, $kxuSp.BUILD).method && (0, $kxuSp.BUILD).lazyLoad) hostRef.$onInstancePromise$ = new Promise((r)=>hostRef.$onInstanceResolve$ = r);
    if ((0, $kxuSp.BUILD).asyncLoading) {
        hostRef.$onReadyPromise$ = new Promise((r)=>hostRef.$onReadyResolve$ = r);
        hostElement["s-p"] = [];
        hostElement["s-rc"] = [];
    }
    if ((0, $kxuSp.BUILD).lazyLoad) hostRef.$fetchedCbList$ = [];
    const ref = hostRef;
    hostElement.__stencil__getHostRef = ()=>ref;
    if (!(0, $kxuSp.BUILD).lazyLoad && cmpMeta.$flags$ & 512 /* hasModernPropertyDecls */  && ((0, $kxuSp.BUILD).state || (0, $kxuSp.BUILD).prop)) $47990066fdbc3144$var$reWireGetterSetter(hostElement, hostRef);
    return ref;
};
var $47990066fdbc3144$export$304efeaa4c96d4e9 = (elm, memberName)=>memberName in elm;
var $47990066fdbc3144$var$customError;
var $47990066fdbc3144$export$bf36f23bad3e1069 = (e, el)=>($47990066fdbc3144$var$customError || console.error)(e, el);
var $47990066fdbc3144$export$262a85bf225b2794 = (0, $kxuSp.BUILD).isTesting ? [
    "STENCIL:"
] : [
    "%cstencil",
    "color: white;background:#4c47ff;font-weight: bold; font-size:10px; padding:2px 6px; border-radius: 5px"
];
var $47990066fdbc3144$export$47b52a6e53fbbc24 = (...m)=>console.error(...$47990066fdbc3144$export$262a85bf225b2794, ...m);
var $47990066fdbc3144$export$5d385f3b3df7e1b9 = (...m)=>console.warn(...$47990066fdbc3144$export$262a85bf225b2794, ...m);
var $47990066fdbc3144$export$f71f4f192932e35e = (...m)=>console.info(...$47990066fdbc3144$export$262a85bf225b2794, ...m);
var $47990066fdbc3144$export$56c340fcfa13d1a2 = (handler)=>$47990066fdbc3144$var$customError = handler;
// src/client/client-load-module.ts
var $47990066fdbc3144$export$a8b3e6b062e6642a = /* @__PURE__ */ new Map();
var $47990066fdbc3144$var$MODULE_IMPORT_PREFIX = "./";
var $47990066fdbc3144$export$ebb47fdc8f2dbc6f = (cmpMeta, hostRef, hmrVersionId)=>{
    const exportName = cmpMeta.$tagName$.replace(/-/g, "_");
    const bundleId = cmpMeta.$lazyBundleId$;
    if ((0, $kxuSp.BUILD).isDev && typeof bundleId !== "string") {
        $47990066fdbc3144$export$47b52a6e53fbbc24(`Trying to lazily load component <${cmpMeta.$tagName$}> with style mode "${hostRef.$modeName$}", but it does not exist.`);
        return void 0;
    } else if (!bundleId) return void 0;
    const module = !(0, $kxuSp.BUILD).hotModuleReplacement ? $47990066fdbc3144$export$a8b3e6b062e6642a.get(bundleId) : false;
    if (module) return module[exportName];
    /*!__STENCIL_STATIC_IMPORT_SWITCH__*/ return import(/* @vite-ignore */ /* webpackInclude: /\.entry\.js$/ */ /* webpackExclude: /\.system\.entry\.js$/ */ /* webpackMode: "lazy" */ `./${bundleId}.entry.js${(0, $kxuSp.BUILD).hotModuleReplacement && hmrVersionId ? "?s-hmr=" + hmrVersionId : ""}`).then((importedModule)=>{
        if (!(0, $kxuSp.BUILD).hotModuleReplacement) $47990066fdbc3144$export$a8b3e6b062e6642a.set(bundleId, importedModule);
        return importedModule[exportName];
    }, (e)=>{
        $47990066fdbc3144$export$bf36f23bad3e1069(e, hostRef.$hostElement$);
    });
};
// src/client/client-style.ts
var $47990066fdbc3144$export$9dd6ff9ea0189349 = /* @__PURE__ */ new Map();
var $47990066fdbc3144$export$31c64a1f6cd0f6 = [];
var $47990066fdbc3144$export$9c2eaf71209e2d97 = (_opts)=>{};
var $47990066fdbc3144$export$8145590be035627c = ()=>false;
// src/runtime/runtime-constants.ts
var $47990066fdbc3144$var$CONTENT_REF_ID = "r";
var $47990066fdbc3144$var$ORG_LOCATION_ID = "o";
var $47990066fdbc3144$var$SLOT_NODE_ID = "s";
var $47990066fdbc3144$var$TEXT_NODE_ID = "t";
var $47990066fdbc3144$var$COMMENT_NODE_ID = "c";
var $47990066fdbc3144$var$HYDRATE_ID = "s-id";
var $47990066fdbc3144$export$2859fc9056ffe6fa = "sty-id";
var $47990066fdbc3144$var$HYDRATE_CHILD_ID = "c-id";
var $47990066fdbc3144$var$HYDRATED_CSS = "{visibility:hidden}.hydrated{visibility:inherit}";
var $47990066fdbc3144$var$STENCIL_DOC_DATA = "_stencilDocData";
var $47990066fdbc3144$var$DEFAULT_DOC_DATA = {
    hostIds: 0,
    rootLevelIds: 0,
    staticComponents: /* @__PURE__ */ new Set()
};
var $47990066fdbc3144$var$SLOT_FB_CSS = "slot-fb{display:contents}slot-fb[hidden]{display:none}";
var $47990066fdbc3144$var$XLINK_NS = "http://www.w3.org/1999/xlink";
var $47990066fdbc3144$var$FORM_ASSOCIATED_CUSTOM_ELEMENT_CALLBACKS = [
    "formAssociatedCallback",
    "formResetCallback",
    "formDisabledCallback",
    "formStateRestoreCallback"
];
var $47990066fdbc3144$export$10a0f131c0eea21b = typeof window !== "undefined" ? window : {};
var $47990066fdbc3144$export$7f8ddf7c7c20b3cd = $47990066fdbc3144$export$10a0f131c0eea21b.HTMLElement || class {
};
var $47990066fdbc3144$export$2e40610e9d23bca6 = {
    $flags$: 0,
    $resourcesUrl$: "",
    jmp: (h2)=>h2(),
    raf: (h2)=>requestAnimationFrame(h2),
    ael: (el, eventName, listener, opts)=>el.addEventListener(eventName, listener, opts),
    rel: (el, eventName, listener, opts)=>el.removeEventListener(eventName, listener, opts),
    ce: (eventName, opts)=>new CustomEvent(eventName, opts)
};
var $47990066fdbc3144$export$a8ba718ef458346 = (helpers)=>{
    Object.assign($47990066fdbc3144$export$2e40610e9d23bca6, helpers);
};
var $47990066fdbc3144$export$b4e7e6d61dbcd813 = (0, $kxuSp.BUILD).shadowDom;
var $47990066fdbc3144$export$b4b667f9f62821eb = /* @__PURE__ */ (()=>{
    var _a;
    let supportsListenerOptions2 = false;
    try {
        (_a = $47990066fdbc3144$export$10a0f131c0eea21b.document) == null || _a.addEventListener("e", null, Object.defineProperty({}, "passive", {
            get () {
                supportsListenerOptions2 = true;
            }
        }));
    } catch (e) {}
    return supportsListenerOptions2;
})();
var $47990066fdbc3144$export$2578fbb2d34e3823 = (v)=>Promise.resolve(v);
var $47990066fdbc3144$export$27b311cd1cb97100 = (0, $kxuSp.BUILD).constructableCSS ? /* @__PURE__ */ (()=>{
    try {
        if (!$47990066fdbc3144$export$10a0f131c0eea21b.document.adoptedStyleSheets) return false;
        new CSSStyleSheet();
        return typeof new CSSStyleSheet().replaceSync === "function";
    } catch (e) {}
    return false;
})() : false;
var $47990066fdbc3144$export$c204a0a7017166bb = $47990066fdbc3144$export$27b311cd1cb97100 ? /* @__PURE__ */ (()=>!!$47990066fdbc3144$export$10a0f131c0eea21b.document && Object.getOwnPropertyDescriptor($47990066fdbc3144$export$10a0f131c0eea21b.document.adoptedStyleSheets, "length").writable)() : false;
// src/client/client-task-queue.ts
var $47990066fdbc3144$var$queueCongestion = 0;
var $47990066fdbc3144$var$queuePending = false;
var $47990066fdbc3144$var$queueDomReads = [];
var $47990066fdbc3144$var$queueDomWrites = [];
var $47990066fdbc3144$var$queueDomWritesLow = [];
var $47990066fdbc3144$var$queueTask = (queue, write)=>(cb)=>{
        queue.push(cb);
        if (!$47990066fdbc3144$var$queuePending) {
            $47990066fdbc3144$var$queuePending = true;
            if (write && $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 4 /* queueSync */ ) $47990066fdbc3144$export$bdd553fddd433dcb($47990066fdbc3144$var$flush);
            else $47990066fdbc3144$export$2e40610e9d23bca6.raf($47990066fdbc3144$var$flush);
        }
    };
var $47990066fdbc3144$var$consume = (queue)=>{
    for(let i2 = 0; i2 < queue.length; i2++)try {
        queue[i2](performance.now());
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e);
    }
    queue.length = 0;
};
var $47990066fdbc3144$var$consumeTimeout = (queue, timeout)=>{
    let i2 = 0;
    let ts = 0;
    while(i2 < queue.length && (ts = performance.now()) < timeout)try {
        queue[i2++](ts);
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e);
    }
    if (i2 === queue.length) queue.length = 0;
    else if (i2 !== 0) queue.splice(0, i2);
};
var $47990066fdbc3144$var$flush = ()=>{
    if ((0, $kxuSp.BUILD).asyncQueue) $47990066fdbc3144$var$queueCongestion++;
    $47990066fdbc3144$var$consume($47990066fdbc3144$var$queueDomReads);
    if ((0, $kxuSp.BUILD).asyncQueue) {
        const timeout = ($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 6 /* queueMask */ ) === 2 /* appLoaded */  ? performance.now() + 14 * Math.ceil($47990066fdbc3144$var$queueCongestion * 0.1) : Infinity;
        $47990066fdbc3144$var$consumeTimeout($47990066fdbc3144$var$queueDomWrites, timeout);
        $47990066fdbc3144$var$consumeTimeout($47990066fdbc3144$var$queueDomWritesLow, timeout);
        if ($47990066fdbc3144$var$queueDomWrites.length > 0) {
            $47990066fdbc3144$var$queueDomWritesLow.push(...$47990066fdbc3144$var$queueDomWrites);
            $47990066fdbc3144$var$queueDomWrites.length = 0;
        }
        if ($47990066fdbc3144$var$queuePending = $47990066fdbc3144$var$queueDomReads.length + $47990066fdbc3144$var$queueDomWrites.length + $47990066fdbc3144$var$queueDomWritesLow.length > 0) $47990066fdbc3144$export$2e40610e9d23bca6.raf($47990066fdbc3144$var$flush);
        else $47990066fdbc3144$var$queueCongestion = 0;
    } else {
        $47990066fdbc3144$var$consume($47990066fdbc3144$var$queueDomWrites);
        if ($47990066fdbc3144$var$queuePending = $47990066fdbc3144$var$queueDomReads.length > 0) $47990066fdbc3144$export$2e40610e9d23bca6.raf($47990066fdbc3144$var$flush);
    }
};
var $47990066fdbc3144$export$bdd553fddd433dcb = (cb)=>$47990066fdbc3144$export$2578fbb2d34e3823().then(cb);
var $47990066fdbc3144$export$de6bea324e6d63f6 = /* @__PURE__ */ $47990066fdbc3144$var$queueTask($47990066fdbc3144$var$queueDomReads, false);
var $47990066fdbc3144$export$bbfc1321f142f72c = /* @__PURE__ */ $47990066fdbc3144$var$queueTask($47990066fdbc3144$var$queueDomWrites, true);
// src/runtime/asset-path.ts
var $47990066fdbc3144$export$7c3997b47f2311d9 = (path)=>{
    const assetUrl = new URL(path, $47990066fdbc3144$export$2e40610e9d23bca6.$resourcesUrl$);
    return assetUrl.origin !== $47990066fdbc3144$export$10a0f131c0eea21b.location.origin ? assetUrl.href : assetUrl.pathname;
};
var $47990066fdbc3144$export$4d21c79ffe6155ac = (path)=>$47990066fdbc3144$export$2e40610e9d23bca6.$resourcesUrl$ = path;
// src/utils/style.ts
function $47990066fdbc3144$var$createStyleSheetIfNeededAndSupported(styles2) {
    if (!styles2 || !$47990066fdbc3144$export$27b311cd1cb97100) return void 0;
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles2);
    return sheet;
}
// src/utils/shadow-root.ts
var $47990066fdbc3144$var$globalStyleSheet;
var $47990066fdbc3144$var$GLOBAL_STYLE_ID = "sc-global";
function $47990066fdbc3144$var$createShadowRoot(cmpMeta) {
    var _a;
    const opts = {
        mode: "open"
    };
    if ((0, $kxuSp.BUILD).shadowDelegatesFocus) opts.delegatesFocus = !!(cmpMeta.$flags$ & 16 /* shadowDelegatesFocus */ );
    if ((0, $kxuSp.BUILD).shadowSlotAssignmentManual) {
        const isManual = !!(cmpMeta.$flags$ & 1024 /* shadowSlotAssignmentManual */ );
        if (isManual) opts.slotAssignment = "manual";
    }
    const shadowRoot = this.attachShadow(opts);
    if ($47990066fdbc3144$var$globalStyleSheet === void 0) $47990066fdbc3144$var$globalStyleSheet = (_a = $47990066fdbc3144$var$createStyleSheetIfNeededAndSupported((0, $5C7R7.globalStyles))) != null ? _a : null;
    if ($47990066fdbc3144$var$globalStyleSheet) {
        if ($47990066fdbc3144$export$c204a0a7017166bb) shadowRoot.adoptedStyleSheets.push($47990066fdbc3144$var$globalStyleSheet);
        else shadowRoot.adoptedStyleSheets = [
            ...shadowRoot.adoptedStyleSheets,
            $47990066fdbc3144$var$globalStyleSheet
        ];
    } else if ((0, $5C7R7.globalStyles) && !$47990066fdbc3144$export$27b311cd1cb97100) {
        const styleElm = document.createElement("style");
        styleElm.innerHTML = (0, $5C7R7.globalStyles);
        if ((0, $kxuSp.BUILD).hotModuleReplacement) styleElm.setAttribute($47990066fdbc3144$export$2859fc9056ffe6fa, $47990066fdbc3144$var$GLOBAL_STYLE_ID);
        shadowRoot.prepend(styleElm);
    }
}
var $47990066fdbc3144$var$updateFallbackSlotVisibility = (elm)=>{
    const childNodes = $47990066fdbc3144$var$internalCall(elm, "childNodes");
    if (elm.tagName && elm.tagName.includes("-") && elm["s-cr"] && elm.tagName !== "SLOT-FB") $47990066fdbc3144$var$getHostSlotNodes(childNodes, elm.tagName).forEach((slotNode)=>{
        if (slotNode.nodeType === 1 /* ElementNode */  && slotNode.tagName === "SLOT-FB") {
            if ($47990066fdbc3144$var$getSlotChildSiblings(slotNode, $47990066fdbc3144$var$getSlotName(slotNode), false).length) slotNode.hidden = true;
            else slotNode.hidden = false;
        }
    });
    let i2 = 0;
    for(i2 = 0; i2 < childNodes.length; i2++){
        const childNode = childNodes[i2];
        if (childNode.nodeType === 1 /* ElementNode */  && $47990066fdbc3144$var$internalCall(childNode, "childNodes").length) $47990066fdbc3144$var$updateFallbackSlotVisibility(childNode);
    }
};
var $47990066fdbc3144$var$getSlottedChildNodes = (childNodes)=>{
    const result = [];
    for(let i2 = 0; i2 < childNodes.length; i2++){
        const slottedNode = childNodes[i2]["s-nr"] || void 0;
        if (slottedNode && slottedNode.isConnected) result.push(slottedNode);
    }
    return result;
};
function $47990066fdbc3144$var$getHostSlotNodes(childNodes, hostName, slotName) {
    let i2 = 0;
    let slottedNodes = [];
    let childNode;
    for(; i2 < childNodes.length; i2++){
        childNode = childNodes[i2];
        if (childNode["s-sr"] && (!hostName || childNode["s-hn"] === hostName) && (slotName === void 0 || $47990066fdbc3144$var$getSlotName(childNode) === slotName)) {
            slottedNodes.push(childNode);
            if (typeof slotName !== "undefined") return slottedNodes;
        }
        slottedNodes = [
            ...slottedNodes,
            ...$47990066fdbc3144$var$getHostSlotNodes(childNode.childNodes, hostName, slotName)
        ];
    }
    return slottedNodes;
}
var $47990066fdbc3144$var$getSlotChildSiblings = (slot, slotName, includeSlot = true)=>{
    const childNodes = [];
    if (includeSlot && slot["s-sr"] || !slot["s-sr"]) childNodes.push(slot);
    let node = slot;
    while(node = node.nextSibling)if ($47990066fdbc3144$var$getSlotName(node) === slotName && (includeSlot || !node["s-sr"])) childNodes.push(node);
    return childNodes;
};
var $47990066fdbc3144$var$isNodeLocatedInSlot = (nodeToRelocate, slotName)=>{
    if (nodeToRelocate.nodeType === 1 /* ElementNode */ ) {
        if (nodeToRelocate.getAttribute("slot") === null && slotName === "") return true;
        if (nodeToRelocate.getAttribute("slot") === slotName) return true;
        return false;
    }
    if (nodeToRelocate["s-sn"] === slotName) return true;
    return slotName === "";
};
var $47990066fdbc3144$var$addSlotRelocateNode = (newChild, slotNode, prepend, position)=>{
    if (newChild["s-ol"] && newChild["s-ol"].isConnected) return;
    const slottedNodeLocation = document.createTextNode("");
    slottedNodeLocation["s-nr"] = newChild;
    if (!slotNode["s-cr"] || !slotNode["s-cr"].parentNode) return;
    const parent = slotNode["s-cr"].parentNode;
    const appendMethod = prepend ? $47990066fdbc3144$var$internalCall(parent, "prepend") : $47990066fdbc3144$var$internalCall(parent, "appendChild");
    if ((0, $kxuSp.BUILD).hydrateClientSide && typeof position !== "undefined") {
        slottedNodeLocation["s-oo"] = position;
        const childNodes = $47990066fdbc3144$var$internalCall(parent, "childNodes");
        const slotRelocateNodes = [
            slottedNodeLocation
        ];
        childNodes.forEach((n)=>{
            if (n["s-nr"]) slotRelocateNodes.push(n);
        });
        slotRelocateNodes.sort((a, b)=>{
            if (!a["s-oo"] || a["s-oo"] < (b["s-oo"] || 0)) return -1;
            else if (!b["s-oo"] || b["s-oo"] < a["s-oo"]) return 1;
            return 0;
        });
        slotRelocateNodes.forEach((n)=>appendMethod.call(parent, n));
    } else appendMethod.call(parent, slottedNodeLocation);
    newChild["s-ol"] = slottedNodeLocation;
    newChild["s-sh"] = slotNode["s-hn"];
};
var $47990066fdbc3144$var$getSlotName = (node)=>typeof node["s-sn"] === "string" ? node["s-sn"] : node.nodeType === 1 && node.getAttribute("slot") || void 0;
function $47990066fdbc3144$var$patchSlotNode(node) {
    if (node.assignedElements || node.assignedNodes || !node["s-sr"]) return;
    const assignedFactory = (elementsOnly)=>(function(opts) {
            const toReturn = [];
            const slotName = this["s-sn"];
            if (opts == null ? void 0 : opts.flatten) console.error(`
          Flattening is not supported for Stencil non-shadow slots.
          You can use \`.childNodes\` to nested slot fallback content.
          If you have a particular use case, please open an issue on the Stencil repo.
        `);
            const parent = this["s-cr"].parentElement;
            const slottedNodes = parent.__childNodes ? parent.childNodes : $47990066fdbc3144$var$getSlottedChildNodes(parent.childNodes);
            slottedNodes.forEach((n)=>{
                if (slotName === $47990066fdbc3144$var$getSlotName(n)) toReturn.push(n);
            });
            if (elementsOnly) return toReturn.filter((n)=>n.nodeType === 1 /* ElementNode */ );
            return toReturn;
        }).bind(node);
    node.assignedElements = assignedFactory(true);
    node.assignedNodes = assignedFactory(false);
}
function $47990066fdbc3144$var$dispatchSlotChangeEvent(elm) {
    elm.dispatchEvent(new CustomEvent("slotchange", {
        bubbles: false,
        cancelable: false,
        composed: false
    }));
}
function $47990066fdbc3144$var$findSlotFromSlottedNode(slottedNode, parentHost) {
    var _a;
    parentHost = parentHost || ((_a = slottedNode["s-ol"]) == null ? void 0 : _a.parentElement);
    if (!parentHost) return {
        slotNode: null,
        slotName: ""
    };
    const slotName = slottedNode["s-sn"] = $47990066fdbc3144$var$getSlotName(slottedNode) || "";
    const childNodes = $47990066fdbc3144$var$internalCall(parentHost, "childNodes");
    const slotNode = $47990066fdbc3144$var$getHostSlotNodes(childNodes, parentHost.tagName, slotName)[0];
    return {
        slotNode: slotNode,
        slotName: slotName
    };
}
// src/runtime/dom-extras.ts
var $47990066fdbc3144$var$patchPseudoShadowDom = (hostElementPrototype)=>{
    $47990066fdbc3144$var$patchCloneNode(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotAppendChild(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotAppend(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotPrepend(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotInsertAdjacentElement(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotInsertAdjacentHTML(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotInsertAdjacentText(hostElementPrototype);
    $47990066fdbc3144$var$patchInsertBefore(hostElementPrototype);
    $47990066fdbc3144$var$patchTextContent(hostElementPrototype);
    $47990066fdbc3144$var$patchChildSlotNodes(hostElementPrototype);
    $47990066fdbc3144$var$patchSlotRemoveChild(hostElementPrototype);
};
var $47990066fdbc3144$var$patchCloneNode = (HostElementPrototype)=>{
    if (HostElementPrototype.__cloneNode) return;
    const orgCloneNode = HostElementPrototype.__cloneNode = HostElementPrototype.cloneNode;
    HostElementPrototype.cloneNode = function(deep) {
        const srcNode = this;
        const isShadowDom = (0, $kxuSp.BUILD).shadowDom ? srcNode.shadowRoot && $47990066fdbc3144$export$b4e7e6d61dbcd813 : false;
        const clonedNode = orgCloneNode.call(srcNode, isShadowDom ? deep : false);
        if ((0, $kxuSp.BUILD).slot && !isShadowDom && deep) {
            let i2 = 0;
            let slotted, nonStencilNode;
            const stencilPrivates = [
                "s-id",
                "s-cr",
                "s-lr",
                "s-rc",
                "s-sc",
                "s-p",
                "s-cn",
                "s-sr",
                "s-sn",
                "s-hn",
                "s-ol",
                "s-nr",
                "s-si",
                "s-rf",
                "s-scs"
            ];
            const childNodes = this.__childNodes || this.childNodes;
            for(; i2 < childNodes.length; i2++){
                slotted = childNodes[i2]["s-nr"];
                nonStencilNode = stencilPrivates.every((privateField)=>!childNodes[i2][privateField]);
                if (slotted) {
                    if ((0, $kxuSp.BUILD).appendChildSlotFix && clonedNode.__appendChild) clonedNode.__appendChild(slotted.cloneNode(true));
                    else clonedNode.appendChild(slotted.cloneNode(true));
                }
                if (nonStencilNode) clonedNode.appendChild(childNodes[i2].cloneNode(true));
            }
        }
        return clonedNode;
    };
};
var $47990066fdbc3144$var$patchSlotAppendChild = (HostElementPrototype)=>{
    if (HostElementPrototype.__appendChild) return;
    HostElementPrototype.__appendChild = HostElementPrototype.appendChild;
    HostElementPrototype.appendChild = function(newChild) {
        const { slotName: slotName, slotNode: slotNode } = $47990066fdbc3144$var$findSlotFromSlottedNode(newChild, this);
        if (slotNode) {
            $47990066fdbc3144$var$addSlotRelocateNode(newChild, slotNode);
            const slotChildNodes = $47990066fdbc3144$var$getSlotChildSiblings(slotNode, slotName);
            const appendAfter = slotChildNodes[slotChildNodes.length - 1];
            const parent = $47990066fdbc3144$var$internalCall(appendAfter, "parentNode");
            const insertedNode = $47990066fdbc3144$var$internalCall(parent, "insertBefore")(newChild, appendAfter.nextSibling);
            $47990066fdbc3144$var$dispatchSlotChangeEvent(slotNode);
            $47990066fdbc3144$var$updateFallbackSlotVisibility(this);
            return insertedNode;
        }
        return this.__appendChild(newChild);
    };
};
var $47990066fdbc3144$var$patchSlotRemoveChild = (ElementPrototype)=>{
    if (ElementPrototype.__removeChild) return;
    ElementPrototype.__removeChild = ElementPrototype.removeChild;
    ElementPrototype.removeChild = function(toRemove) {
        if (toRemove && typeof toRemove["s-sn"] !== "undefined") {
            const childNodes = this.__childNodes || this.childNodes;
            const slotNode = $47990066fdbc3144$var$getHostSlotNodes(childNodes, this.tagName, toRemove["s-sn"]);
            if (slotNode && toRemove.isConnected) {
                toRemove.remove();
                $47990066fdbc3144$var$updateFallbackSlotVisibility(this);
                return;
            }
        }
        return this.__removeChild(toRemove);
    };
};
var $47990066fdbc3144$var$patchSlotPrepend = (HostElementPrototype)=>{
    if (HostElementPrototype.__prepend) return;
    HostElementPrototype.__prepend = HostElementPrototype.prepend;
    HostElementPrototype.prepend = function(...newChildren) {
        newChildren.forEach((newChild)=>{
            if (typeof newChild === "string") newChild = this.ownerDocument.createTextNode(newChild);
            const slotName = (newChild["s-sn"] = $47990066fdbc3144$var$getSlotName(newChild)) || "";
            const childNodes = $47990066fdbc3144$var$internalCall(this, "childNodes");
            const slotNode = $47990066fdbc3144$var$getHostSlotNodes(childNodes, this.tagName, slotName)[0];
            if (slotNode) {
                $47990066fdbc3144$var$addSlotRelocateNode(newChild, slotNode, true);
                const slotChildNodes = $47990066fdbc3144$var$getSlotChildSiblings(slotNode, slotName);
                const appendAfter = slotChildNodes[0];
                const parent = $47990066fdbc3144$var$internalCall(appendAfter, "parentNode");
                const toReturn = $47990066fdbc3144$var$internalCall(parent, "insertBefore")(newChild, $47990066fdbc3144$var$internalCall(appendAfter, "nextSibling"));
                $47990066fdbc3144$var$dispatchSlotChangeEvent(slotNode);
                return toReturn;
            }
            if (newChild.nodeType === 1 && !!newChild.getAttribute("slot")) newChild.hidden = true;
            return HostElementPrototype.__prepend(newChild);
        });
    };
};
var $47990066fdbc3144$var$patchSlotAppend = (HostElementPrototype)=>{
    if (HostElementPrototype.__append) return;
    HostElementPrototype.__append = HostElementPrototype.append;
    HostElementPrototype.append = function(...newChildren) {
        newChildren.forEach((newChild)=>{
            if (typeof newChild === "string") newChild = this.ownerDocument.createTextNode(newChild);
            this.appendChild(newChild);
        });
    };
};
var $47990066fdbc3144$var$patchSlotInsertAdjacentHTML = (HostElementPrototype)=>{
    if (HostElementPrototype.__insertAdjacentHTML) return;
    const originalInsertAdjacentHtml = HostElementPrototype.insertAdjacentHTML;
    HostElementPrototype.insertAdjacentHTML = function(position, text) {
        if (position !== "afterbegin" && position !== "beforeend") return originalInsertAdjacentHtml.call(this, position, text);
        const container = this.ownerDocument.createElement("_");
        let node;
        container.innerHTML = text;
        if (position === "afterbegin") while(node = container.firstChild)this.prepend(node);
        else if (position === "beforeend") while(node = container.firstChild)this.append(node);
    };
};
var $47990066fdbc3144$var$patchSlotInsertAdjacentText = (HostElementPrototype)=>{
    HostElementPrototype.insertAdjacentText = function(position, text) {
        this.insertAdjacentHTML(position, text);
    };
};
var $47990066fdbc3144$var$patchInsertBefore = (HostElementPrototype)=>{
    if (HostElementPrototype.__insertBefore) return;
    const eleProto = HostElementPrototype;
    if (eleProto.__insertBefore) return;
    eleProto.__insertBefore = HostElementPrototype.insertBefore;
    HostElementPrototype.insertBefore = function(newChild, currentChild) {
        const { slotName: slotName, slotNode: slotNode } = $47990066fdbc3144$var$findSlotFromSlottedNode(newChild, this);
        const slottedNodes = this.__childNodes ? this.childNodes : $47990066fdbc3144$var$getSlottedChildNodes(this.childNodes);
        if (slotNode) {
            let found = false;
            slottedNodes.forEach((childNode)=>{
                if (childNode === currentChild || currentChild === null) {
                    found = true;
                    if (currentChild === null || slotName !== currentChild["s-sn"]) {
                        this.appendChild(newChild);
                        return;
                    }
                    if (slotName === currentChild["s-sn"]) {
                        $47990066fdbc3144$var$addSlotRelocateNode(newChild, slotNode);
                        const parent = $47990066fdbc3144$var$internalCall(currentChild, "parentNode");
                        $47990066fdbc3144$var$internalCall(parent, "insertBefore")(newChild, currentChild);
                        $47990066fdbc3144$var$dispatchSlotChangeEvent(slotNode);
                    }
                    return;
                }
            });
            if (found) return newChild;
        }
        const parentNode = currentChild == null ? void 0 : currentChild.__parentNode;
        if (parentNode && !this.isSameNode(parentNode)) return this.appendChild(newChild);
        return this.__insertBefore(newChild, currentChild);
    };
};
var $47990066fdbc3144$var$patchSlotInsertAdjacentElement = (HostElementPrototype)=>{
    if (HostElementPrototype.__insertAdjacentElement) return;
    const originalInsertAdjacentElement = HostElementPrototype.insertAdjacentElement;
    HostElementPrototype.insertAdjacentElement = function(position, element) {
        if (position !== "afterbegin" && position !== "beforeend") return originalInsertAdjacentElement.call(this, position, element);
        if (position === "afterbegin") {
            this.prepend(element);
            return element;
        } else if (position === "beforeend") {
            this.append(element);
            return element;
        }
        return element;
    };
};
var $47990066fdbc3144$var$patchTextContent = (hostElementPrototype)=>{
    $47990066fdbc3144$var$patchHostOriginalAccessor("textContent", hostElementPrototype);
    Object.defineProperty(hostElementPrototype, "textContent", {
        get: function() {
            let text = "";
            const childNodes = this.__childNodes ? this.childNodes : $47990066fdbc3144$var$getSlottedChildNodes(this.childNodes);
            childNodes.forEach((node)=>text += node.textContent || "");
            return text;
        },
        set: function(value) {
            const childNodes = this.__childNodes ? this.childNodes : $47990066fdbc3144$var$getSlottedChildNodes(this.childNodes);
            childNodes.forEach((node)=>{
                if (node["s-ol"]) node["s-ol"].remove();
                node.remove();
            });
            this.insertAdjacentHTML("beforeend", value);
        }
    });
};
var $47990066fdbc3144$var$patchChildSlotNodes = (elm)=>{
    class FakeNodeList extends Array {
        item(n) {
            return this[n];
        }
    }
    $47990066fdbc3144$var$patchHostOriginalAccessor("children", elm);
    Object.defineProperty(elm, "children", {
        get () {
            return this.childNodes.filter((n)=>n.nodeType === 1);
        }
    });
    Object.defineProperty(elm, "childElementCount", {
        get () {
            return this.children.length;
        }
    });
    $47990066fdbc3144$var$patchHostOriginalAccessor("firstChild", elm);
    Object.defineProperty(elm, "firstChild", {
        get () {
            return this.childNodes[0];
        }
    });
    $47990066fdbc3144$var$patchHostOriginalAccessor("lastChild", elm);
    Object.defineProperty(elm, "lastChild", {
        get () {
            return this.childNodes[this.childNodes.length - 1];
        }
    });
    $47990066fdbc3144$var$patchHostOriginalAccessor("childNodes", elm);
    Object.defineProperty(elm, "childNodes", {
        get () {
            const result = new FakeNodeList();
            result.push(...$47990066fdbc3144$var$getSlottedChildNodes(this.__childNodes));
            return result;
        }
    });
};
var $47990066fdbc3144$var$patchSlottedNode = (node)=>{
    if (!node || node.__nextSibling !== void 0 || !globalThis.Node) return;
    $47990066fdbc3144$var$patchNextSibling(node);
    $47990066fdbc3144$var$patchPreviousSibling(node);
    $47990066fdbc3144$var$patchParentNode(node);
    if (node.nodeType === Node.ELEMENT_NODE) {
        $47990066fdbc3144$var$patchNextElementSibling(node);
        $47990066fdbc3144$var$patchPreviousElementSibling(node);
    }
};
var $47990066fdbc3144$var$patchNextSibling = (node)=>{
    if (!node || node.__nextSibling) return;
    $47990066fdbc3144$var$patchHostOriginalAccessor("nextSibling", node);
    Object.defineProperty(node, "nextSibling", {
        get: function() {
            var _a;
            const parentNodes = (_a = this["s-ol"]) == null ? void 0 : _a.parentNode.childNodes;
            const index = parentNodes == null ? void 0 : parentNodes.indexOf(this);
            if (parentNodes && index > -1) return parentNodes[index + 1];
            return this.__nextSibling;
        }
    });
};
var $47990066fdbc3144$var$patchNextElementSibling = (element)=>{
    if (!element || element.__nextElementSibling) return;
    $47990066fdbc3144$var$patchHostOriginalAccessor("nextElementSibling", element);
    Object.defineProperty(element, "nextElementSibling", {
        get: function() {
            var _a;
            const parentEles = (_a = this["s-ol"]) == null ? void 0 : _a.parentNode.children;
            const index = parentEles == null ? void 0 : parentEles.indexOf(this);
            if (parentEles && index > -1) return parentEles[index + 1];
            return this.__nextElementSibling;
        }
    });
};
var $47990066fdbc3144$var$patchPreviousSibling = (node)=>{
    if (!node || node.__previousSibling) return;
    $47990066fdbc3144$var$patchHostOriginalAccessor("previousSibling", node);
    Object.defineProperty(node, "previousSibling", {
        get: function() {
            var _a;
            const parentNodes = (_a = this["s-ol"]) == null ? void 0 : _a.parentNode.childNodes;
            const index = parentNodes == null ? void 0 : parentNodes.indexOf(this);
            if (parentNodes && index > -1) return parentNodes[index - 1];
            return this.__previousSibling;
        }
    });
};
var $47990066fdbc3144$var$patchPreviousElementSibling = (element)=>{
    if (!element || element.__previousElementSibling) return;
    $47990066fdbc3144$var$patchHostOriginalAccessor("previousElementSibling", element);
    Object.defineProperty(element, "previousElementSibling", {
        get: function() {
            var _a;
            const parentNodes = (_a = this["s-ol"]) == null ? void 0 : _a.parentNode.children;
            const index = parentNodes == null ? void 0 : parentNodes.indexOf(this);
            if (parentNodes && index > -1) return parentNodes[index - 1];
            return this.__previousElementSibling;
        }
    });
};
var $47990066fdbc3144$var$patchParentNode = (node)=>{
    if (!node || node.__parentNode) return;
    $47990066fdbc3144$var$patchHostOriginalAccessor("parentNode", node);
    Object.defineProperty(node, "parentNode", {
        get: function() {
            var _a;
            return ((_a = this["s-ol"]) == null ? void 0 : _a.parentNode) || this.__parentNode;
        },
        set: function(value) {
            this.__parentNode = value;
        }
    });
};
var $47990066fdbc3144$var$validElementPatches = [
    "children",
    "nextElementSibling",
    "previousElementSibling"
];
var $47990066fdbc3144$var$validNodesPatches = [
    "childNodes",
    "firstChild",
    "lastChild",
    "nextSibling",
    "previousSibling",
    "textContent",
    "parentNode"
];
function $47990066fdbc3144$var$patchHostOriginalAccessor(accessorName, node) {
    if (!globalThis.Node || !globalThis.Element) return;
    let accessor;
    if ($47990066fdbc3144$var$validElementPatches.includes(accessorName)) accessor = Object.getOwnPropertyDescriptor(Element.prototype, accessorName);
    else if ($47990066fdbc3144$var$validNodesPatches.includes(accessorName)) accessor = Object.getOwnPropertyDescriptor(Node.prototype, accessorName);
    if (!accessor) accessor = Object.getOwnPropertyDescriptor(node, accessorName);
    if (accessor) Object.defineProperty(node, "__" + accessorName, accessor);
}
function $47990066fdbc3144$var$internalCall(node, method) {
    if ("__" + method in node) {
        const toReturn = node["__" + method];
        if (typeof toReturn !== "function") return toReturn;
        return toReturn.bind(node);
    } else {
        if (typeof node[method] !== "function") return node[method];
        return node[method].bind(node);
    }
}
var $47990066fdbc3144$var$i = 0;
var $47990066fdbc3144$var$createTime = (fnName, tagName = "")=>{
    if ((0, $kxuSp.BUILD).profile && performance.mark) {
        const key = `st:${fnName}:${tagName}:${$47990066fdbc3144$var$i++}`;
        performance.mark(key);
        return ()=>performance.measure(`[Stencil] ${fnName}() <${tagName}>`, key);
    } else return ()=>{
        return;
    };
};
var $47990066fdbc3144$var$uniqueTime = (key, measureText)=>{
    if ((0, $kxuSp.BUILD).profile && performance.mark) {
        if (performance.getEntriesByName(key, "mark").length === 0) performance.mark(key);
        return ()=>{
            if (performance.getEntriesByName(measureText, "measure").length === 0) performance.measure(measureText, key);
        };
    } else return ()=>{
        return;
    };
};
var $47990066fdbc3144$var$inspect = (ref)=>{
    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(ref);
    if (!hostRef) return void 0;
    const flags = hostRef.$flags$;
    const hostElement = hostRef.$hostElement$;
    return {
        renderCount: hostRef.$renderCount$,
        flags: {
            hasRendered: !!(flags & 2 /* hasRendered */ ),
            hasConnected: !!(flags & 1 /* hasConnected */ ),
            isWaitingForChildren: !!(flags & 4 /* isWaitingForChildren */ ),
            isConstructingInstance: !!(flags & 8 /* isConstructingInstance */ ),
            isQueuedForUpdate: !!(flags & 16 /* isQueuedForUpdate */ ),
            hasInitializedComponent: !!(flags & 32 /* hasInitializedComponent */ ),
            hasLoadedComponent: !!(flags & 64 /* hasLoadedComponent */ ),
            isWatchReady: !!(flags & 128 /* isWatchReady */ ),
            isListenReady: !!(flags & 256 /* isListenReady */ ),
            needsRerender: !!(flags & 512 /* needsRerender */ )
        },
        instanceValues: hostRef.$instanceValues$,
        serializerValues: hostRef.$serializerValues$,
        ancestorComponent: hostRef.$ancestorComponent$,
        hostElement: hostElement,
        lazyInstance: hostRef.$lazyInstance$,
        vnode: hostRef.$vnode$,
        modeName: hostRef.$modeName$,
        fetchedCbList: hostRef.$fetchedCbList$,
        onReadyPromise: hostRef.$onReadyPromise$,
        onReadyResolve: hostRef.$onReadyResolve$,
        onInstancePromise: hostRef.$onInstancePromise$,
        onInstanceResolve: hostRef.$onInstanceResolve$,
        onRenderResolve: hostRef.$onRenderResolve$,
        queuedListeners: hostRef.$queuedListeners$,
        rmListeners: hostRef.$rmListeners$,
        ["s-id"]: hostElement["s-id"],
        ["s-cr"]: hostElement["s-cr"],
        ["s-lr"]: hostElement["s-lr"],
        ["s-p"]: hostElement["s-p"],
        ["s-rc"]: hostElement["s-rc"],
        ["s-sc"]: hostElement["s-sc"]
    };
};
var $47990066fdbc3144$var$installDevTools = ()=>{
    if ((0, $kxuSp.BUILD).devTools) {
        const stencil = $47990066fdbc3144$export$10a0f131c0eea21b.stencil = $47990066fdbc3144$export$10a0f131c0eea21b.stencil || {};
        const originalInspect = stencil.inspect;
        stencil.inspect = (ref)=>{
            let result = $47990066fdbc3144$var$inspect(ref);
            if (!result && typeof originalInspect === "function") result = originalInspect(ref);
            return result;
        };
    }
};
// src/utils/query-nonce-meta-tag-content.ts
function $47990066fdbc3144$var$queryNonceMetaTagContent(doc) {
    var _a, _b, _c;
    return (_c = (_b = (_a = doc.head) == null ? void 0 : _a.querySelector('meta[name="csp-nonce"]')) == null ? void 0 : _b.getAttribute("content")) != null ? _c : void 0;
}
// src/runtime/styles.ts
var $47990066fdbc3144$var$rootAppliedStyles = /* @__PURE__ */ new WeakMap();
var $47990066fdbc3144$var$registerStyle = (scopeId2, cssText, allowCS)=>{
    let style = $47990066fdbc3144$export$9dd6ff9ea0189349.get(scopeId2);
    if ($47990066fdbc3144$export$27b311cd1cb97100 && allowCS) {
        style = style || new CSSStyleSheet();
        if (typeof style === "string") style = cssText;
        else style.replaceSync(cssText);
    } else style = cssText;
    $47990066fdbc3144$export$9dd6ff9ea0189349.set(scopeId2, style);
};
var $47990066fdbc3144$var$addStyle = (styleContainerNode, cmpMeta, mode)=>{
    var _a, _b, _c;
    const scopeId2 = $47990066fdbc3144$var$getScopeId(cmpMeta, mode);
    const style = $47990066fdbc3144$export$9dd6ff9ea0189349.get(scopeId2);
    if (!(0, $kxuSp.BUILD).attachStyles || !$47990066fdbc3144$export$10a0f131c0eea21b.document) return scopeId2;
    styleContainerNode = styleContainerNode.nodeType === 11 /* DocumentFragment */  ? styleContainerNode : $47990066fdbc3144$export$10a0f131c0eea21b.document;
    if (style) {
        if (typeof style === "string") {
            styleContainerNode = styleContainerNode.head || styleContainerNode;
            let appliedStyles = $47990066fdbc3144$var$rootAppliedStyles.get(styleContainerNode);
            let styleElm;
            if (!appliedStyles) $47990066fdbc3144$var$rootAppliedStyles.set(styleContainerNode, appliedStyles = /* @__PURE__ */ new Set());
            const existingStyleElm = ((0, $kxuSp.BUILD).hydrateClientSide || (0, $kxuSp.BUILD).hotModuleReplacement) && styleContainerNode.querySelector(`[${$47990066fdbc3144$export$2859fc9056ffe6fa}="${scopeId2}"]`);
            if (existingStyleElm) existingStyleElm.textContent = style;
            else if (!appliedStyles.has(scopeId2)) {
                styleElm = $47990066fdbc3144$export$10a0f131c0eea21b.document.createElement("style");
                styleElm.textContent = style;
                const nonce = (_a = $47990066fdbc3144$export$2e40610e9d23bca6.$nonce$) != null ? _a : $47990066fdbc3144$var$queryNonceMetaTagContent($47990066fdbc3144$export$10a0f131c0eea21b.document);
                if (nonce != null) styleElm.setAttribute("nonce", nonce);
                if (((0, $kxuSp.BUILD).hydrateServerSide || (0, $kxuSp.BUILD).hotModuleReplacement) && (cmpMeta.$flags$ & 2 /* scopedCssEncapsulation */  || cmpMeta.$flags$ & 128 /* shadowNeedsScopedCss */  || cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ )) styleElm.setAttribute($47990066fdbc3144$export$2859fc9056ffe6fa, scopeId2);
                if (!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ )) {
                    if (styleContainerNode.nodeName === "HEAD") {
                        const preconnectLinks = styleContainerNode.querySelectorAll("link[rel=preconnect]");
                        const referenceNode2 = preconnectLinks.length > 0 ? preconnectLinks[preconnectLinks.length - 1].nextSibling : styleContainerNode.querySelector("style");
                        styleContainerNode.insertBefore(styleElm, (referenceNode2 == null ? void 0 : referenceNode2.parentNode) === styleContainerNode ? referenceNode2 : null);
                    } else if ("host" in styleContainerNode) {
                        if ($47990066fdbc3144$export$27b311cd1cb97100) {
                            const currentWindow = (_b = styleContainerNode.defaultView) != null ? _b : styleContainerNode.ownerDocument.defaultView;
                            const stylesheet = new currentWindow.CSSStyleSheet();
                            stylesheet.replaceSync(style);
                            if ($47990066fdbc3144$export$c204a0a7017166bb) styleContainerNode.adoptedStyleSheets.unshift(stylesheet);
                            else styleContainerNode.adoptedStyleSheets = [
                                stylesheet,
                                ...styleContainerNode.adoptedStyleSheets
                            ];
                        } else {
                            const existingStyleContainer = styleContainerNode.querySelector("style");
                            if (existingStyleContainer && !(0, $kxuSp.BUILD).hotModuleReplacement) existingStyleContainer.textContent = style + existingStyleContainer.textContent;
                            else styleContainerNode.prepend(styleElm);
                        }
                    } else styleContainerNode.append(styleElm);
                }
                if (cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) styleContainerNode.insertBefore(styleElm, null);
                if (cmpMeta.$flags$ & 4 /* hasSlotRelocation */ ) styleElm.textContent += $47990066fdbc3144$var$SLOT_FB_CSS;
                if (appliedStyles) appliedStyles.add(scopeId2);
            }
        } else if ((0, $kxuSp.BUILD).constructableCSS) {
            let appliedStyles = $47990066fdbc3144$var$rootAppliedStyles.get(styleContainerNode);
            if (!appliedStyles) $47990066fdbc3144$var$rootAppliedStyles.set(styleContainerNode, appliedStyles = /* @__PURE__ */ new Set());
            if (!appliedStyles.has(scopeId2)) {
                const currentWindow = (_c = styleContainerNode.defaultView) != null ? _c : styleContainerNode.ownerDocument.defaultView;
                let stylesheet;
                if (style.constructor === currentWindow.CSSStyleSheet) stylesheet = style;
                else {
                    stylesheet = new currentWindow.CSSStyleSheet();
                    for(let i2 = 0; i2 < style.cssRules.length; i2++)stylesheet.insertRule(style.cssRules[i2].cssText, i2);
                }
                if ($47990066fdbc3144$export$c204a0a7017166bb) styleContainerNode.adoptedStyleSheets.push(stylesheet);
                else styleContainerNode.adoptedStyleSheets = [
                    ...styleContainerNode.adoptedStyleSheets,
                    stylesheet
                ];
                appliedStyles.add(scopeId2);
                if ((0, $kxuSp.BUILD).hydrateClientSide && "host" in styleContainerNode) {
                    const ssrStyleElm = styleContainerNode.querySelector(`[${$47990066fdbc3144$export$2859fc9056ffe6fa}="${scopeId2}"]`);
                    if (ssrStyleElm) $47990066fdbc3144$export$bbfc1321f142f72c(()=>ssrStyleElm.remove());
                }
            }
        }
    }
    return scopeId2;
};
var $47990066fdbc3144$var$attachStyles = (hostRef)=>{
    const cmpMeta = hostRef.$cmpMeta$;
    const elm = hostRef.$hostElement$;
    const flags = cmpMeta.$flags$;
    const endAttachStyles = $47990066fdbc3144$var$createTime("attachStyles", cmpMeta.$tagName$);
    const scopeId2 = $47990066fdbc3144$var$addStyle((0, $kxuSp.BUILD).shadowDom && $47990066fdbc3144$export$b4e7e6d61dbcd813 && elm.shadowRoot ? elm.shadowRoot : elm.getRootNode(), cmpMeta, hostRef.$modeName$);
    if (((0, $kxuSp.BUILD).shadowDom || (0, $kxuSp.BUILD).scoped) && (0, $kxuSp.BUILD).cssAnnotations && flags & 10 /* needsScopedEncapsulation */ ) {
        elm["s-sc"] = scopeId2;
        elm.classList.add(scopeId2 + "-h");
    }
    endAttachStyles();
};
var $47990066fdbc3144$var$getScopeId = (cmp, mode)=>"sc-" + ((0, $kxuSp.BUILD).mode && mode && cmp.$flags$ & 32 /* hasMode */  ? cmp.$tagName$ + "-" + mode : cmp.$tagName$);
var $47990066fdbc3144$var$convertScopedToShadow = (css)=>css.replace(/\/\*!@([^\/]+)\*\/[^\{]+\{/g, "$1{");
var $47990066fdbc3144$var$hydrateScopedToShadow = ()=>{
    if (!$47990066fdbc3144$export$10a0f131c0eea21b.document) return;
    const styles2 = $47990066fdbc3144$export$10a0f131c0eea21b.document.querySelectorAll(`[${$47990066fdbc3144$export$2859fc9056ffe6fa}]`);
    let i2 = 0;
    for(; i2 < styles2.length; i2++)$47990066fdbc3144$var$registerStyle(styles2[i2].getAttribute($47990066fdbc3144$export$2859fc9056ffe6fa), $47990066fdbc3144$var$convertScopedToShadow(styles2[i2].innerHTML), true);
};
// src/utils/helpers.ts
var $47990066fdbc3144$var$isDef = (v)=>v != null && v !== void 0;
var $47990066fdbc3144$var$isComplexType = (o)=>{
    o = typeof o;
    return o === "object" || o === "function";
};
// src/runtime/vdom/h.ts
var $47990066fdbc3144$export$dda1d9f60106f0e9 = (nodeName, vnodeData, ...children)=>{
    if (typeof nodeName === "string") nodeName = $47990066fdbc3144$export$e6778302ec5425de(nodeName);
    let child = null;
    let key = null;
    let slotName = null;
    let simple = false;
    let lastSimple = false;
    const vNodeChildren = [];
    const walk = (c)=>{
        for(let i2 = 0; i2 < c.length; i2++){
            child = c[i2];
            if (Array.isArray(child)) walk(child);
            else if (child != null && typeof child !== "boolean") {
                if (simple = typeof nodeName !== "function" && !$47990066fdbc3144$var$isComplexType(child)) child = String(child);
                else if ((0, $kxuSp.BUILD).isDev && typeof nodeName !== "function" && child.$flags$ === void 0) $47990066fdbc3144$export$47b52a6e53fbbc24(`vNode passed as children has unexpected type.
Make sure it's using the correct h() function.
Empty objects can also be the cause, look for JSX comments that became objects.`);
                if (simple && lastSimple) vNodeChildren[vNodeChildren.length - 1].$text$ += child;
                else vNodeChildren.push(simple ? $47990066fdbc3144$var$newVNode(null, child) : child);
                lastSimple = simple;
            }
        }
    };
    walk(children);
    if (vnodeData) {
        if ((0, $kxuSp.BUILD).isDev && nodeName === "input") $47990066fdbc3144$var$validateInputProperties(vnodeData);
        if ((0, $kxuSp.BUILD).vdomKey && vnodeData.key) key = vnodeData.key;
        if ((0, $kxuSp.BUILD).slotRelocation && vnodeData.name) slotName = vnodeData.name;
        if ((0, $kxuSp.BUILD).vdomClass) {
            const classData = vnodeData.className || vnodeData.class;
            if (classData) vnodeData.class = typeof classData !== "object" ? classData : Object.keys(classData).filter((k)=>classData[k]).join(" ");
        }
    }
    if ((0, $kxuSp.BUILD).isDev && vNodeChildren.some($47990066fdbc3144$var$isHost)) $47990066fdbc3144$export$47b52a6e53fbbc24(`The <Host> must be the single root component. Make sure:
- You are NOT using hostData() and <Host> in the same component.
- <Host> is used once, and it's the single root component of the render() function.`);
    if ((0, $kxuSp.BUILD).vdomFunctional && typeof nodeName === "function") return nodeName(vnodeData === null ? {} : vnodeData, vNodeChildren, $47990066fdbc3144$var$vdomFnUtils);
    const vnode = $47990066fdbc3144$var$newVNode(nodeName, null);
    vnode.$attrs$ = vnodeData;
    if (vNodeChildren.length > 0) vnode.$children$ = vNodeChildren;
    if ((0, $kxuSp.BUILD).vdomKey) vnode.$key$ = key;
    if ((0, $kxuSp.BUILD).slotRelocation) vnode.$name$ = slotName;
    return vnode;
};
var $47990066fdbc3144$var$newVNode = (tag, text)=>{
    const vnode = {
        $flags$: 0,
        $tag$: tag,
        // Normalize undefined to null to prevent rendering "undefined" as text
        $text$: text != null ? text : null,
        $elm$: null,
        $children$: null
    };
    if ((0, $kxuSp.BUILD).vdomAttribute) vnode.$attrs$ = null;
    if ((0, $kxuSp.BUILD).vdomKey) vnode.$key$ = null;
    if ((0, $kxuSp.BUILD).slotRelocation) vnode.$name$ = null;
    return vnode;
};
var $47990066fdbc3144$export$5d2c872882e2b878 = {};
var $47990066fdbc3144$var$isHost = (node)=>node && node.$tag$ === $47990066fdbc3144$export$5d2c872882e2b878;
var $47990066fdbc3144$var$vdomFnUtils = {
    forEach: (children, cb)=>children.map($47990066fdbc3144$var$convertToPublic).forEach(cb),
    map: (children, cb)=>children.map($47990066fdbc3144$var$convertToPublic).map(cb).map($47990066fdbc3144$var$convertToPrivate)
};
var $47990066fdbc3144$var$convertToPublic = (node)=>({
        vattrs: node.$attrs$,
        vchildren: node.$children$,
        vkey: node.$key$,
        vname: node.$name$,
        vtag: node.$tag$,
        vtext: node.$text$
    });
var $47990066fdbc3144$var$convertToPrivate = (node)=>{
    if (typeof node.vtag === "function") {
        const vnodeData = {
            ...node.vattrs
        };
        if (node.vkey) vnodeData.key = node.vkey;
        if (node.vname) vnodeData.name = node.vname;
        return $47990066fdbc3144$export$dda1d9f60106f0e9(node.vtag, vnodeData, ...node.vchildren || []);
    }
    const vnode = $47990066fdbc3144$var$newVNode(node.vtag, node.vtext);
    vnode.$attrs$ = node.vattrs;
    vnode.$children$ = node.vchildren;
    vnode.$key$ = node.vkey;
    vnode.$name$ = node.vname;
    return vnode;
};
var $47990066fdbc3144$var$validateInputProperties = (inputElm)=>{
    const props = Object.keys(inputElm);
    const value = props.indexOf("value");
    if (value === -1) return;
    const typeIndex = props.indexOf("type");
    const minIndex = props.indexOf("min");
    const maxIndex = props.indexOf("max");
    const stepIndex = props.indexOf("step");
    if (value < typeIndex || value < minIndex || value < maxIndex || value < stepIndex) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The "value" prop of <input> should be set after "min", "max", "type" and "step"`);
};
// src/runtime/client-hydrate.ts
var $47990066fdbc3144$var$initializeClientHydrate = (hostElm, tagName, hostId, hostRef)=>{
    var _a, _b, _c, _d;
    const endHydrate = $47990066fdbc3144$var$createTime("hydrateClient", tagName);
    const shadowRoot = hostElm.shadowRoot;
    const childRenderNodes = [];
    const slotNodes = [];
    const slottedNodes = [];
    const shadowRootNodes = (0, $kxuSp.BUILD).shadowDom && shadowRoot ? [] : null;
    const vnode = $47990066fdbc3144$var$newVNode(tagName, null);
    vnode.$elm$ = hostElm;
    let scopeId2;
    if ((0, $kxuSp.BUILD).scoped) {
        const cmpMeta = hostRef.$cmpMeta$;
        if (cmpMeta && cmpMeta.$flags$ & 10 /* needsScopedEncapsulation */  && hostElm["s-sc"]) {
            scopeId2 = hostElm["s-sc"];
            hostElm.classList.add(scopeId2 + "-h");
        } else if (hostElm["s-sc"]) delete hostElm["s-sc"];
    }
    if ($47990066fdbc3144$export$10a0f131c0eea21b.document && (!$47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$ || !$47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.size)) $47990066fdbc3144$var$initializeDocumentHydrate($47990066fdbc3144$export$10a0f131c0eea21b.document.body, $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$ = /* @__PURE__ */ new Map());
    hostElm[$47990066fdbc3144$var$HYDRATE_ID] = hostId;
    hostElm.removeAttribute($47990066fdbc3144$var$HYDRATE_ID);
    hostRef.$vnode$ = $47990066fdbc3144$var$clientHydrate(vnode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, hostElm, hostId, slottedNodes);
    let crIndex = 0;
    const crLength = childRenderNodes.length;
    let childRenderNode;
    for(crIndex; crIndex < crLength; crIndex++){
        childRenderNode = childRenderNodes[crIndex];
        const orgLocationId = childRenderNode.$hostId$ + "." + childRenderNode.$nodeId$;
        const orgLocationNode = $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.get(orgLocationId);
        const node = childRenderNode.$elm$;
        if (!shadowRoot) {
            node["s-hn"] = $47990066fdbc3144$export$e6778302ec5425de(tagName).toUpperCase();
            if (childRenderNode.$tag$ === "slot") node["s-cr"] = hostElm["s-cr"];
        } else if (((_a = childRenderNode.$tag$) == null ? void 0 : _a.toString().includes("-")) && childRenderNode.$tag$ !== "slot-fb" && !childRenderNode.$elm$.shadowRoot) {
            const cmpMeta = $47990066fdbc3144$export$3f84770eccf215d2(childRenderNode.$elm$);
            if (cmpMeta) {
                const scopeId3 = $47990066fdbc3144$var$getScopeId(cmpMeta.$cmpMeta$, (0, $kxuSp.BUILD).mode ? childRenderNode.$elm$.getAttribute("s-mode") : void 0);
                const styleSheet = $47990066fdbc3144$export$10a0f131c0eea21b.document.querySelector(`style[sty-id="${scopeId3}"]`);
                if (styleSheet) shadowRootNodes.unshift(styleSheet.cloneNode(true));
            }
        }
        if (childRenderNode.$tag$ === "slot") {
            childRenderNode.$name$ = childRenderNode.$elm$["s-sn"] || childRenderNode.$elm$["name"] || null;
            if (childRenderNode.$children$) {
                childRenderNode.$flags$ |= 2 /* isSlotFallback */ ;
                if (!childRenderNode.$elm$.childNodes.length) childRenderNode.$children$.forEach((c)=>{
                    childRenderNode.$elm$.appendChild(c.$elm$);
                });
            } else childRenderNode.$flags$ |= 1 /* isSlotReference */ ;
        }
        if (orgLocationNode && orgLocationNode.isConnected) {
            if (orgLocationNode.parentElement.shadowRoot && orgLocationNode["s-en"] === "") orgLocationNode.parentNode.insertBefore(node, orgLocationNode.nextSibling);
            orgLocationNode.parentNode.removeChild(orgLocationNode);
            if (!shadowRoot) node["s-oo"] = parseInt(childRenderNode.$nodeId$);
        }
        if (orgLocationNode && !orgLocationNode["s-id"]) $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.delete(orgLocationId);
    }
    const hosts = [];
    const snLen = slottedNodes.length;
    let snIndex = 0;
    let slotGroup;
    let snGroupIdx;
    let snGroupLen;
    let slottedItem;
    let currentPos = 0;
    for(snIndex; snIndex < snLen; snIndex++){
        slotGroup = slottedNodes[snIndex];
        if (!slotGroup || !slotGroup.length) continue;
        snGroupLen = slotGroup.length;
        snGroupIdx = 0;
        for(snGroupIdx; snGroupIdx < snGroupLen; snGroupIdx++){
            slottedItem = slotGroup[snGroupIdx];
            if (!hosts[slottedItem.hostId]) hosts[slottedItem.hostId] = $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.get(slottedItem.hostId);
            if (!hosts[slottedItem.hostId]) continue;
            const hostEle = hosts[slottedItem.hostId];
            if (hostEle.shadowRoot && slottedItem.node.parentElement !== hostEle) hostEle.insertBefore(slottedItem.node, (_c = (_b = slotGroup[snGroupIdx - 1]) == null ? void 0 : _b.node) == null ? void 0 : _c.nextSibling);
            if (!hostEle.shadowRoot || !shadowRoot) {
                if (!slottedItem.slot["s-cr"]) {
                    slottedItem.slot["s-cr"] = hostEle["s-cr"];
                    if (!slottedItem.slot["s-cr"] && hostEle.shadowRoot) slottedItem.slot["s-cr"] = hostEle;
                    else slottedItem.slot["s-cr"] = (hostEle.__childNodes || hostEle.childNodes)[0];
                }
                $47990066fdbc3144$var$addSlotRelocateNode(slottedItem.node, slottedItem.slot, false, slottedItem.node["s-oo"] || currentPos);
                if (((_d = slottedItem.node.parentElement) == null ? void 0 : _d.shadowRoot) && slottedItem.node["getAttribute"] && slottedItem.node.getAttribute("slot")) slottedItem.node.removeAttribute("slot");
                if ((0, $kxuSp.BUILD).experimentalSlotFixes) $47990066fdbc3144$var$patchSlottedNode(slottedItem.node);
            }
            currentPos = (slottedItem.node["s-oo"] || currentPos) + 1;
        }
    }
    if ((0, $kxuSp.BUILD).scoped && scopeId2 && slotNodes.length) slotNodes.forEach((slot)=>{
        slot.$elm$.parentElement.classList.add(scopeId2 + "-s");
    });
    if ((0, $kxuSp.BUILD).shadowDom && shadowRoot && !shadowRoot.childNodes.length) {
        let rnIdex = 0;
        const rnLen = shadowRootNodes.length;
        if (rnLen) {
            for(rnIdex; rnIdex < rnLen; rnIdex++){
                const node = shadowRootNodes[rnIdex];
                if (node) shadowRoot.appendChild(node);
            }
            Array.from(hostElm.childNodes).forEach((node)=>{
                if (typeof node["s-en"] !== "string" && typeof node["s-sn"] !== "string") {
                    if (node.nodeType === 1 /* ElementNode */  && node.slot && node.hidden) node.removeAttribute("hidden");
                    else if (node.nodeType === 8 /* CommentNode */  && !node.nodeValue) node.parentNode.removeChild(node);
                }
            });
        }
    }
    hostRef.$hostElement$ = hostElm;
    endHydrate();
};
var $47990066fdbc3144$var$clientHydrate = (parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node, hostId, slottedNodes = [])=>{
    let childNodeType;
    let childIdSplt;
    let childVNode;
    let i2;
    const scopeId2 = hostElm["s-sc"];
    if (node.nodeType === 1 /* ElementNode */ ) {
        childNodeType = node.getAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID);
        if (childNodeType) {
            childIdSplt = childNodeType.split(".");
            if (childIdSplt[0] === hostId || childIdSplt[0] === "0") {
                childVNode = $47990066fdbc3144$var$createSimpleVNode({
                    $flags$: 0,
                    $hostId$: childIdSplt[0],
                    $nodeId$: childIdSplt[1],
                    $depth$: childIdSplt[2],
                    $index$: childIdSplt[3],
                    $tag$: node.tagName.toLowerCase(),
                    $elm$: node,
                    // If we don't add the initial classes to the VNode, the first `vdom-render.ts` patch
                    // won't try to reconcile them. Classes set on the node will be blown away.
                    $attrs$: {
                        class: node.className || ""
                    }
                });
                childRenderNodes.push(childVNode);
                node.removeAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID);
                if (!parentVNode.$children$) parentVNode.$children$ = [];
                if ((0, $kxuSp.BUILD).scoped && scopeId2 && childIdSplt[0] === hostId) {
                    node["s-si"] = scopeId2;
                    childVNode.$attrs$.class += " " + scopeId2;
                }
                const slotName = childVNode.$elm$.getAttribute("s-sn");
                if (typeof slotName === "string") {
                    if (childVNode.$tag$ === "slot-fb") {
                        $47990066fdbc3144$var$addSlot(slotName, childIdSplt[2], childVNode, node, parentVNode, childRenderNodes, slotNodes, shadowRootNodes, slottedNodes);
                        if ((0, $kxuSp.BUILD).scoped && scopeId2) node.classList.add(scopeId2);
                    }
                    childVNode.$elm$["s-sn"] = slotName;
                    childVNode.$elm$.removeAttribute("s-sn");
                }
                if (childVNode.$index$ !== void 0) parentVNode.$children$[childVNode.$index$] = childVNode;
                parentVNode = childVNode;
                if (shadowRootNodes && childVNode.$depth$ === "0") shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
            }
        }
        if (node.shadowRoot) for(i2 = node.shadowRoot.childNodes.length - 1; i2 >= 0; i2--)$47990066fdbc3144$var$clientHydrate(parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node.shadowRoot.childNodes[i2], hostId, slottedNodes);
        const nonShadowNodes = node.__childNodes || node.childNodes;
        for(i2 = nonShadowNodes.length - 1; i2 >= 0; i2--)$47990066fdbc3144$var$clientHydrate(parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, nonShadowNodes[i2], hostId, slottedNodes);
    } else if (node.nodeType === 8 /* CommentNode */ ) {
        childIdSplt = node.nodeValue.split(".");
        if (childIdSplt[1] === hostId || childIdSplt[1] === "0") {
            childNodeType = childIdSplt[0];
            childVNode = $47990066fdbc3144$var$createSimpleVNode({
                $hostId$: childIdSplt[1],
                $nodeId$: childIdSplt[2],
                $depth$: childIdSplt[3],
                $index$: childIdSplt[4] || "0",
                $elm$: node,
                $attrs$: null,
                $children$: null,
                $key$: null,
                $name$: null,
                $tag$: null,
                $text$: null
            });
            if (childNodeType === $47990066fdbc3144$var$TEXT_NODE_ID) {
                childVNode.$elm$ = $47990066fdbc3144$var$findCorrespondingNode(node, 3 /* TextNode */ );
                if (childVNode.$elm$ && childVNode.$elm$.nodeType === 3 /* TextNode */ ) {
                    childVNode.$text$ = childVNode.$elm$.textContent;
                    childRenderNodes.push(childVNode);
                    node.remove();
                    if (hostId === childVNode.$hostId$) {
                        if (!parentVNode.$children$) parentVNode.$children$ = [];
                        parentVNode.$children$[childVNode.$index$] = childVNode;
                    }
                    if (shadowRootNodes && childVNode.$depth$ === "0") shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
                }
            } else if (childNodeType === $47990066fdbc3144$var$COMMENT_NODE_ID) {
                childVNode.$elm$ = $47990066fdbc3144$var$findCorrespondingNode(node, 8 /* CommentNode */ );
                if (childVNode.$elm$ && childVNode.$elm$.nodeType === 8 /* CommentNode */ ) {
                    childRenderNodes.push(childVNode);
                    node.remove();
                }
            } else if (childVNode.$hostId$ === hostId) {
                if (childNodeType === $47990066fdbc3144$var$SLOT_NODE_ID) {
                    const slotName = node["s-sn"] = childIdSplt[5] || "";
                    $47990066fdbc3144$var$addSlot(slotName, childIdSplt[2], childVNode, node, parentVNode, childRenderNodes, slotNodes, shadowRootNodes, slottedNodes);
                } else if (childNodeType === $47990066fdbc3144$var$CONTENT_REF_ID) {
                    if ((0, $kxuSp.BUILD).shadowDom && shadowRootNodes) node.remove();
                    else if ((0, $kxuSp.BUILD).slotRelocation) {
                        hostElm["s-cr"] = node;
                        node["s-cn"] = true;
                    }
                }
            }
        }
    } else if (parentVNode && parentVNode.$tag$ === "style") {
        const vnode = $47990066fdbc3144$var$newVNode(null, node.textContent);
        vnode.$elm$ = node;
        vnode.$index$ = "0";
        parentVNode.$children$ = [
            vnode
        ];
    }
    return parentVNode;
};
var $47990066fdbc3144$var$initializeDocumentHydrate = (node, orgLocNodes)=>{
    if (node.nodeType === 1 /* ElementNode */ ) {
        const componentId = node[$47990066fdbc3144$var$HYDRATE_ID] || node.getAttribute($47990066fdbc3144$var$HYDRATE_ID);
        if (componentId) orgLocNodes.set(componentId, node);
        let i2 = 0;
        if (node.shadowRoot) for(; i2 < node.shadowRoot.childNodes.length; i2++)$47990066fdbc3144$var$initializeDocumentHydrate(node.shadowRoot.childNodes[i2], orgLocNodes);
        const nonShadowNodes = node.__childNodes || node.childNodes;
        for(i2 = 0; i2 < nonShadowNodes.length; i2++)$47990066fdbc3144$var$initializeDocumentHydrate(nonShadowNodes[i2], orgLocNodes);
    } else if (node.nodeType === 8 /* CommentNode */ ) {
        const childIdSplt = node.nodeValue.split(".");
        if (childIdSplt[0] === $47990066fdbc3144$var$ORG_LOCATION_ID) {
            orgLocNodes.set(childIdSplt[1] + "." + childIdSplt[2], node);
            node.nodeValue = "";
            node["s-en"] = childIdSplt[3];
        }
    }
};
var $47990066fdbc3144$var$createSimpleVNode = (vnode)=>{
    const defaultVNode = {
        $flags$: 0,
        $hostId$: null,
        $nodeId$: null,
        $depth$: null,
        $index$: "0",
        $elm$: null,
        $attrs$: null,
        $children$: null,
        $key$: null,
        $name$: null,
        $tag$: null,
        $text$: null
    };
    return {
        ...defaultVNode,
        ...vnode
    };
};
function $47990066fdbc3144$var$addSlot(slotName, slotId, childVNode, node, parentVNode, childRenderNodes, slotNodes, shadowRootNodes, slottedNodes) {
    node["s-sr"] = true;
    childVNode.$name$ = slotName || null;
    childVNode.$tag$ = "slot";
    const parentNodeId = (parentVNode == null ? void 0 : parentVNode.$elm$) ? parentVNode.$elm$["s-id"] || parentVNode.$elm$.getAttribute("s-id") : "";
    if ((0, $kxuSp.BUILD).shadowDom && shadowRootNodes && $47990066fdbc3144$export$10a0f131c0eea21b.document) {
        const slot = childVNode.$elm$ = $47990066fdbc3144$export$10a0f131c0eea21b.document.createElement(childVNode.$tag$);
        if (childVNode.$name$) childVNode.$elm$.setAttribute("name", slotName);
        if (parentVNode.$elm$.shadowRoot && parentNodeId && parentNodeId !== childVNode.$hostId$) $47990066fdbc3144$var$internalCall(parentVNode.$elm$, "insertBefore")(slot, $47990066fdbc3144$var$internalCall(parentVNode.$elm$, "children")[0]);
        else $47990066fdbc3144$var$internalCall($47990066fdbc3144$var$internalCall(node, "parentNode"), "insertBefore")(slot, node);
        $47990066fdbc3144$var$addSlottedNodes(slottedNodes, slotId, slotName, node, childVNode.$hostId$);
        node.remove();
        if (childVNode.$depth$ === "0") shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
    } else {
        const slot = childVNode.$elm$;
        const shouldMove = parentNodeId && parentNodeId !== childVNode.$hostId$ && parentVNode.$elm$.shadowRoot;
        $47990066fdbc3144$var$addSlottedNodes(slottedNodes, slotId, slotName, node, shouldMove ? parentNodeId : childVNode.$hostId$);
        $47990066fdbc3144$var$patchSlotNode(node);
        if (shouldMove) parentVNode.$elm$.insertBefore(slot, parentVNode.$elm$.children[0]);
    }
    childRenderNodes.push(childVNode);
    slotNodes.push(childVNode);
    if (!parentVNode.$children$) parentVNode.$children$ = [];
    parentVNode.$children$[childVNode.$index$] = childVNode;
}
var $47990066fdbc3144$var$addSlottedNodes = (slottedNodes, slotNodeId, slotName, slotNode, hostId)=>{
    var _a, _b;
    let slottedNode = slotNode.nextSibling;
    slottedNodes[slotNodeId] = slottedNodes[slotNodeId] || [];
    if (!slottedNode || ((_a = slottedNode.nodeValue) == null ? void 0 : _a.startsWith($47990066fdbc3144$var$SLOT_NODE_ID + "."))) return;
    do {
        if (slottedNode && ((slottedNode["getAttribute"] && slottedNode.getAttribute("slot") || slottedNode["s-sn"]) === slotName || slotName === "" && !slottedNode["s-sn"] && (!slottedNode["getAttribute"] || !slottedNode.getAttribute("slot")) && (slottedNode.nodeType === 8 /* CommentNode */  || slottedNode.nodeType === 3 /* TextNode */ ))) {
            slottedNode["s-sn"] = slotName;
            slottedNodes[slotNodeId].push({
                slot: slotNode,
                node: slottedNode,
                hostId: hostId
            });
        }
        slottedNode = slottedNode == null ? void 0 : slottedNode.nextSibling;
    }while (slottedNode && !((_b = slottedNode.nodeValue) == null ? void 0 : _b.startsWith($47990066fdbc3144$var$SLOT_NODE_ID + ".")));
};
var $47990066fdbc3144$var$findCorrespondingNode = (node, type)=>{
    let sibling = node;
    do sibling = sibling.nextSibling;
    while (sibling && (sibling.nodeType !== type || !sibling.nodeValue));
    return sibling;
};
// src/utils/regular-expression.ts
var $47990066fdbc3144$var$escapeRegExpSpecialCharacters = (text)=>{
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
// src/utils/shadow-css.ts
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 *
 * This file is a port of shadowCSS from `webcomponents.js` to TypeScript.
 * https://github.com/webcomponents/webcomponentsjs/blob/4efecd7e0e/src/ShadowCSS/ShadowCSS.js
 * https://github.com/angular/angular/blob/master/packages/compiler/src/shadow_css.ts
 */ var $47990066fdbc3144$var$safeSelector = (selector)=>{
    const placeholders = [];
    let index = 0;
    selector = selector.replace(/(\[\s*part~=\s*("[^"]*"|'[^']*')\s*\])/g, (_, keep)=>{
        const replaceBy = `__part-${index}__`;
        placeholders.push(keep);
        index++;
        return replaceBy;
    });
    selector = selector.replace(/(\[[^\]]*\])/g, (_, keep)=>{
        const replaceBy = `__ph-${index}__`;
        placeholders.push(keep);
        index++;
        return replaceBy;
    });
    const content = selector.replace(/(:nth-[-\w]+)(\([^)]+\))/g, (_, pseudo, exp)=>{
        const replaceBy = `__ph-${index}__`;
        placeholders.push(exp);
        index++;
        return pseudo + replaceBy;
    });
    const ss = {
        content: content,
        placeholders: placeholders
    };
    return ss;
};
var $47990066fdbc3144$var$restoreSafeSelector = (placeholders, content)=>{
    content = content.replace(/__part-(\d+)__/g, (_, index)=>placeholders[+index]);
    return content.replace(/__ph-(\d+)__/g, (_, index)=>placeholders[+index]);
};
var $47990066fdbc3144$var$_polyfillHost = "-shadowcsshost";
var $47990066fdbc3144$var$_polyfillSlotted = "-shadowcssslotted";
var $47990066fdbc3144$var$_polyfillHostContext = "-shadowcsscontext";
var $47990066fdbc3144$var$_parenSuffix = ")(?:\\(((?:\\([^)(]*\\)|[^)(]*)+?)\\))?([^,{]*)";
var $47990066fdbc3144$var$_cssColonHostRe = new RegExp("(" + $47990066fdbc3144$var$_polyfillHost + $47990066fdbc3144$var$_parenSuffix, "gim");
var $47990066fdbc3144$var$_cssColonHostContextRe = new RegExp("(" + $47990066fdbc3144$var$_polyfillHostContext + $47990066fdbc3144$var$_parenSuffix, "gim");
var $47990066fdbc3144$var$_cssColonSlottedRe = new RegExp("(" + $47990066fdbc3144$var$_polyfillSlotted + $47990066fdbc3144$var$_parenSuffix, "gim");
var $47990066fdbc3144$var$_polyfillHostNoCombinator = $47990066fdbc3144$var$_polyfillHost + "-no-combinator";
var $47990066fdbc3144$var$_polyfillHostNoCombinatorRe = /-shadowcsshost-no-combinator([^\s]*)/;
var $47990066fdbc3144$var$_shadowDOMSelectorsRe = [
    /::shadow/g,
    /::content/g
];
var $47990066fdbc3144$var$_safePartRe = /__part-(\d+)__/g;
var $47990066fdbc3144$var$_selectorReSuffix = "([>\\s~+[.,{:][\\s\\S]*)?$";
var $47990066fdbc3144$var$_polyfillHostRe = /-shadowcsshost/gim;
var $47990066fdbc3144$var$createSupportsRuleRe = (selector)=>{
    const safeSelector2 = $47990066fdbc3144$var$escapeRegExpSpecialCharacters(selector);
    return new RegExp(// First capture group: match any context before the selector that's not inside @supports selector()
    // Using negative lookahead to avoid matching inside @supports selector(...) condition
    `(^|[^@]|@(?!supports\\s+selector\\s*\\([^{]*?${safeSelector2}))(${safeSelector2}\\b)`, "g");
};
var $47990066fdbc3144$var$_commentRe = /\/\*\s*[\s\S]*?\*\//g;
var $47990066fdbc3144$var$stripComments = (input)=>{
    return input.replace($47990066fdbc3144$var$_commentRe, "");
};
var $47990066fdbc3144$var$_commentWithHashRe = /\/\*\s*#\s*source(Mapping)?URL=[\s\S]+?\*\//g;
var $47990066fdbc3144$var$extractCommentsWithHash = (input)=>{
    return input.match($47990066fdbc3144$var$_commentWithHashRe) || [];
};
var $47990066fdbc3144$var$_ruleRe = /(\s*)([^;\{\}]+?)(\s*)((?:{%BLOCK%}?\s*;?)|(?:\s*;))/g;
var $47990066fdbc3144$var$_curlyRe = /([{}])/g;
var $47990066fdbc3144$var$_selectorPartsRe = /(^.*?[^\\])??((:+)(.*)|$)/;
var $47990066fdbc3144$var$OPEN_CURLY = "{";
var $47990066fdbc3144$var$CLOSE_CURLY = "}";
var $47990066fdbc3144$var$BLOCK_PLACEHOLDER = "%BLOCK%";
var $47990066fdbc3144$var$processRules = (input, ruleCallback)=>{
    const inputWithEscapedBlocks = $47990066fdbc3144$var$escapeBlocks(input);
    let nextBlockIndex = 0;
    return inputWithEscapedBlocks.escapedString.replace($47990066fdbc3144$var$_ruleRe, (...m)=>{
        const selector = m[2];
        let content = "";
        let suffix = m[4];
        let contentPrefix = "";
        if (suffix && suffix.startsWith("{" + $47990066fdbc3144$var$BLOCK_PLACEHOLDER)) {
            content = inputWithEscapedBlocks.blocks[nextBlockIndex++];
            suffix = suffix.substring($47990066fdbc3144$var$BLOCK_PLACEHOLDER.length + 1);
            contentPrefix = "{";
        }
        const cssRule = {
            selector: selector,
            content: content
        };
        const rule = ruleCallback(cssRule);
        return `${m[1]}${rule.selector}${m[3]}${contentPrefix}${rule.content}${suffix}`;
    });
};
var $47990066fdbc3144$var$escapeBlocks = (input)=>{
    const inputParts = input.split($47990066fdbc3144$var$_curlyRe);
    const resultParts = [];
    const escapedBlocks = [];
    let bracketCount = 0;
    let currentBlockParts = [];
    for(let partIndex = 0; partIndex < inputParts.length; partIndex++){
        const part = inputParts[partIndex];
        if (part === $47990066fdbc3144$var$CLOSE_CURLY) bracketCount--;
        if (bracketCount > 0) currentBlockParts.push(part);
        else {
            if (currentBlockParts.length > 0) {
                escapedBlocks.push(currentBlockParts.join(""));
                resultParts.push($47990066fdbc3144$var$BLOCK_PLACEHOLDER);
                currentBlockParts = [];
            }
            resultParts.push(part);
        }
        if (part === $47990066fdbc3144$var$OPEN_CURLY) bracketCount++;
    }
    if (currentBlockParts.length > 0) {
        escapedBlocks.push(currentBlockParts.join(""));
        resultParts.push($47990066fdbc3144$var$BLOCK_PLACEHOLDER);
    }
    const strEscapedBlocks = {
        escapedString: resultParts.join(""),
        blocks: escapedBlocks
    };
    return strEscapedBlocks;
};
var $47990066fdbc3144$var$insertPolyfillHostInCssText = (cssText)=>{
    const supportsBlocks = [];
    cssText = cssText.replace(/@supports\s+selector\s*\(\s*([^)]*)\s*\)/g, (_, selectorContent)=>{
        const placeholder = `__supports_${supportsBlocks.length}__`;
        supportsBlocks.push(selectorContent);
        return `@supports selector(${placeholder})`;
    });
    const _colonSlottedRe = $47990066fdbc3144$var$createSupportsRuleRe("::slotted");
    const _colonHostRe = $47990066fdbc3144$var$createSupportsRuleRe(":host");
    const _colonHostContextRe = $47990066fdbc3144$var$createSupportsRuleRe(":host-context");
    cssText = cssText.replace(_colonHostContextRe, `$1${$47990066fdbc3144$var$_polyfillHostContext}`).replace(_colonHostRe, `$1${$47990066fdbc3144$var$_polyfillHost}`).replace(_colonSlottedRe, `$1${$47990066fdbc3144$var$_polyfillSlotted}`);
    supportsBlocks.forEach((originalSelector, index)=>{
        cssText = cssText.replace(`__supports_${index}__`, originalSelector);
    });
    return cssText;
};
var $47990066fdbc3144$var$convertColonRule = (cssText, regExp, partReplacer)=>{
    return cssText.replace(regExp, (...m)=>{
        if (m[2]) {
            const parts = m[2].split(",");
            const r = [];
            for(let i2 = 0; i2 < parts.length; i2++){
                const p = parts[i2].trim();
                if (!p) break;
                r.push(partReplacer($47990066fdbc3144$var$_polyfillHostNoCombinator, p, m[3]));
            }
            return r.join(",");
        } else return $47990066fdbc3144$var$_polyfillHostNoCombinator + m[3];
    });
};
var $47990066fdbc3144$var$colonHostPartReplacer = (host, part, suffix)=>{
    return host + part.replace($47990066fdbc3144$var$_polyfillHost, "") + suffix;
};
var $47990066fdbc3144$var$convertColonHost = (cssText)=>{
    return $47990066fdbc3144$var$convertColonRule(cssText, $47990066fdbc3144$var$_cssColonHostRe, $47990066fdbc3144$var$colonHostPartReplacer);
};
var $47990066fdbc3144$var$colonHostContextPartReplacer = (host, part, suffix)=>{
    if (part.indexOf($47990066fdbc3144$var$_polyfillHost) > -1) return $47990066fdbc3144$var$colonHostPartReplacer(host, part, suffix);
    else return host + part + suffix + ", " + part + " " + host + suffix;
};
var $47990066fdbc3144$var$convertColonSlotted = (cssText, slotScopeId)=>{
    const slotClass = "." + slotScopeId + " > ";
    const selectors = [];
    cssText = cssText.replace($47990066fdbc3144$var$_cssColonSlottedRe, (...m)=>{
        if (m[2]) {
            const compound = m[2].trim();
            const suffix = m[3];
            const slottedSelector = slotClass + compound + suffix;
            let prefixSelector = "";
            for(let i2 = m[4] - 1; i2 >= 0; i2--){
                const char = m[5][i2];
                if (char === "}" || char === ",") break;
                prefixSelector = char + prefixSelector;
            }
            const orgSelector = (prefixSelector + slottedSelector).trim();
            const addedSelector = `${prefixSelector.trimEnd()}${slottedSelector.trim()}`.trim();
            if (orgSelector !== addedSelector) {
                const updatedSelector = `${addedSelector}, ${orgSelector}`;
                selectors.push({
                    orgSelector: orgSelector,
                    updatedSelector: updatedSelector
                });
            }
            return slottedSelector;
        } else return $47990066fdbc3144$var$_polyfillHostNoCombinator + m[3];
    });
    return {
        selectors: selectors,
        cssText: cssText
    };
};
var $47990066fdbc3144$var$convertColonHostContext = (cssText)=>{
    return $47990066fdbc3144$var$convertColonRule(cssText, $47990066fdbc3144$var$_cssColonHostContextRe, $47990066fdbc3144$var$colonHostContextPartReplacer);
};
var $47990066fdbc3144$var$convertShadowDOMSelectors = (cssText)=>{
    return $47990066fdbc3144$var$_shadowDOMSelectorsRe.reduce((result, pattern)=>result.replace(pattern, " "), cssText);
};
var $47990066fdbc3144$var$makeScopeMatcher = (scopeSelector2)=>{
    const lre = /\[/g;
    const rre = /\]/g;
    scopeSelector2 = scopeSelector2.replace(lre, "\\[").replace(rre, "\\]");
    return new RegExp("^(" + scopeSelector2 + ")" + $47990066fdbc3144$var$_selectorReSuffix, "m");
};
var $47990066fdbc3144$var$selectorNeedsScoping = (selector, scopeSelector2)=>{
    const re = $47990066fdbc3144$var$makeScopeMatcher(scopeSelector2);
    return !re.test(selector);
};
var $47990066fdbc3144$var$injectScopingSelector = (selector, scopingSelector)=>{
    return selector.replace($47990066fdbc3144$var$_selectorPartsRe, (_, before = "", _colonGroup, colon = "", after = "")=>{
        return before + scopingSelector + colon + after;
    });
};
var $47990066fdbc3144$var$applySimpleSelectorScope = (selector, scopeSelector2, hostSelector)=>{
    $47990066fdbc3144$var$_polyfillHostRe.lastIndex = 0;
    if ($47990066fdbc3144$var$_polyfillHostRe.test(selector)) {
        const replaceBy = `.${hostSelector}`;
        return selector.replace($47990066fdbc3144$var$_polyfillHostNoCombinatorRe, (_, selector2)=>$47990066fdbc3144$var$injectScopingSelector(selector2, replaceBy)).replace($47990066fdbc3144$var$_polyfillHostRe, replaceBy + " ");
    }
    return scopeSelector2 + " " + selector;
};
var $47990066fdbc3144$var$applyStrictSelectorScope = (selector, scopeSelector2, hostSelector)=>{
    const isRe = /\[is=([^\]]*)\]/g;
    scopeSelector2 = scopeSelector2.replace(isRe, (_, ...parts)=>parts[0]);
    const className = "." + scopeSelector2;
    const _scopeSelectorPart = (p)=>{
        let scopedP = p.trim();
        if (!scopedP) return "";
        if (p.indexOf($47990066fdbc3144$var$_polyfillHostNoCombinator) > -1) scopedP = $47990066fdbc3144$var$applySimpleSelectorScope(p, scopeSelector2, hostSelector);
        else {
            const t = p.replace($47990066fdbc3144$var$_polyfillHostRe, "");
            if (t.length > 0) scopedP = $47990066fdbc3144$var$injectScopingSelector(t, className);
        }
        return scopedP;
    };
    const safeContent = $47990066fdbc3144$var$safeSelector(selector);
    selector = safeContent.content;
    let scopedSelector = "";
    let startIndex = 0;
    let res;
    const sep = /( |>|\+|~(?!=))(?=(?:[^()]*\([^()]*\))*[^()]*$)\s*/g;
    const hasHost = selector.indexOf($47990066fdbc3144$var$_polyfillHostNoCombinator) > -1;
    let shouldScope = !hasHost;
    while((res = sep.exec(selector)) !== null){
        const separator = res[1];
        const part2 = selector.slice(startIndex, res.index).trim();
        shouldScope = shouldScope || part2.indexOf($47990066fdbc3144$var$_polyfillHostNoCombinator) > -1;
        const scopedPart = shouldScope ? _scopeSelectorPart(part2) : part2;
        scopedSelector += `${scopedPart} ${separator} `;
        startIndex = sep.lastIndex;
    }
    const part = selector.substring(startIndex);
    shouldScope = !part.match($47990066fdbc3144$var$_safePartRe) && (shouldScope || part.indexOf($47990066fdbc3144$var$_polyfillHostNoCombinator) > -1);
    scopedSelector += shouldScope ? _scopeSelectorPart(part) : part;
    return $47990066fdbc3144$var$restoreSafeSelector(safeContent.placeholders, scopedSelector);
};
var $47990066fdbc3144$var$scopeSelector = (selector, scopeSelectorText, hostSelector, slotSelector)=>{
    return selector.split(",").map((shallowPart)=>{
        if (slotSelector && shallowPart.indexOf("." + slotSelector) > -1) return shallowPart.trim();
        if ($47990066fdbc3144$var$selectorNeedsScoping(shallowPart, scopeSelectorText)) return $47990066fdbc3144$var$applyStrictSelectorScope(shallowPart, scopeSelectorText, hostSelector).trim();
        else return shallowPart.trim();
    }).join(", ");
};
var $47990066fdbc3144$var$scopeSelectors = (cssText, scopeSelectorText, hostSelector, slotSelector, commentOriginalSelector)=>{
    return $47990066fdbc3144$var$processRules(cssText, (rule)=>{
        let selector = rule.selector;
        let content = rule.content;
        if (rule.selector[0] !== "@") selector = $47990066fdbc3144$var$scopeSelector(rule.selector, scopeSelectorText, hostSelector, slotSelector);
        else if (rule.selector.startsWith("@media") || rule.selector.startsWith("@supports") || rule.selector.startsWith("@page") || rule.selector.startsWith("@document")) content = $47990066fdbc3144$var$scopeSelectors(rule.content, scopeSelectorText, hostSelector, slotSelector, commentOriginalSelector);
        const cssRule = {
            selector: selector.replace(/\s{2,}/g, " ").trim(),
            content: content
        };
        return cssRule;
    });
};
var $47990066fdbc3144$var$scopeCssText = (cssText, scopeId2, hostScopeId, slotScopeId, commentOriginalSelector)=>{
    cssText = $47990066fdbc3144$var$insertPolyfillHostInCssText(cssText);
    cssText = $47990066fdbc3144$var$convertColonHost(cssText);
    cssText = $47990066fdbc3144$var$convertColonHostContext(cssText);
    const slotted = $47990066fdbc3144$var$convertColonSlotted(cssText, slotScopeId);
    cssText = slotted.cssText;
    cssText = $47990066fdbc3144$var$convertShadowDOMSelectors(cssText);
    if (scopeId2) cssText = $47990066fdbc3144$var$scopeSelectors(cssText, scopeId2, hostScopeId, slotScopeId, commentOriginalSelector);
    cssText = $47990066fdbc3144$var$replaceShadowCssHost(cssText, hostScopeId);
    cssText = cssText.replace(/>\s*\*\s+([^{, ]+)/gm, " $1 ");
    return {
        cssText: cssText.trim(),
        // We need to replace the shadow CSS host string in each of these selectors since we created
        // them prior to the replacement happening in the components CSS text.
        slottedSelectors: slotted.selectors.map((ref)=>({
                orgSelector: $47990066fdbc3144$var$replaceShadowCssHost(ref.orgSelector, hostScopeId),
                updatedSelector: $47990066fdbc3144$var$replaceShadowCssHost(ref.updatedSelector, hostScopeId)
            }))
    };
};
var $47990066fdbc3144$var$replaceShadowCssHost = (cssText, hostScopeId)=>{
    return cssText.replace(/-shadowcsshost-no-combinator/g, `.${hostScopeId}`);
};
var $47990066fdbc3144$var$expandPartSelectors = (cssText)=>{
    const partSelectorRe = /([^\s,{][^,{]*?)::part\(\s*([^)]+?)\s*\)((?:[:.][^,{]*)*)/g;
    return $47990066fdbc3144$var$processRules(cssText, (rule)=>{
        if (rule.selector[0] === "@") return rule;
        const selectors = rule.selector.split(",").map((sel)=>{
            const out = [
                sel.trim()
            ];
            let m;
            while((m = partSelectorRe.exec(sel)) !== null){
                const before = m[1].trimEnd();
                const partNames = m[2].trim().split(/\s+/);
                const after = m[3] || "";
                const partAttr = partNames.flatMap((p)=>{
                    if (!rule.selector.includes(`[part~="${p}"]`)) return [
                        `[part~="${p}"]`
                    ];
                    return [];
                }).join("");
                const expanded = `${before} ${partAttr}${after}`;
                if (!!partAttr && expanded !== sel.trim()) out.push(expanded);
            }
            return out.join(", ");
        });
        rule.selector = selectors.join(", ");
        return rule;
    });
};
var $47990066fdbc3144$var$scopeCss = (cssText, scopeId2, commentOriginalSelector)=>{
    const hostScopeId = scopeId2 + "-h";
    const slotScopeId = scopeId2 + "-s";
    const commentsWithHash = $47990066fdbc3144$var$extractCommentsWithHash(cssText);
    cssText = $47990066fdbc3144$var$stripComments(cssText);
    const orgSelectors = [];
    if (commentOriginalSelector) {
        const processCommentedSelector = (rule)=>{
            const placeholder = `/*!@___${orgSelectors.length}___*/`;
            const comment = `/*!@${rule.selector}*/`;
            orgSelectors.push({
                placeholder: placeholder,
                comment: comment
            });
            rule.selector = placeholder + rule.selector;
            return rule;
        };
        cssText = $47990066fdbc3144$var$processRules(cssText, (rule)=>{
            if (rule.selector[0] !== "@") return processCommentedSelector(rule);
            else if (rule.selector.startsWith("@media") || rule.selector.startsWith("@supports") || rule.selector.startsWith("@page") || rule.selector.startsWith("@document")) {
                rule.content = $47990066fdbc3144$var$processRules(rule.content, processCommentedSelector);
                return rule;
            }
            return rule;
        });
    }
    const scoped = $47990066fdbc3144$var$scopeCssText(cssText, scopeId2, hostScopeId, slotScopeId, commentOriginalSelector);
    cssText = [
        scoped.cssText,
        ...commentsWithHash
    ].join("\n");
    if (commentOriginalSelector) orgSelectors.forEach(({ placeholder: placeholder, comment: comment })=>{
        cssText = cssText.replace(placeholder, comment);
    });
    scoped.slottedSelectors.forEach((slottedSelector)=>{
        const regex = new RegExp($47990066fdbc3144$var$escapeRegExpSpecialCharacters(slottedSelector.orgSelector) + "(?=\\s*[,{]|$)", "g");
        cssText = cssText.replace(regex, slottedSelector.updatedSelector);
    });
    cssText = $47990066fdbc3144$var$expandPartSelectors(cssText);
    return cssText;
};
// src/runtime/mode.ts
var $47990066fdbc3144$var$computeMode = (elm)=>$47990066fdbc3144$export$31c64a1f6cd0f6.map((h2)=>h2(elm)).find((m)=>!!m);
var $47990066fdbc3144$export$d4f039427a1beff1 = (handler)=>$47990066fdbc3144$export$31c64a1f6cd0f6.push(handler);
var $47990066fdbc3144$export$1fc0f6205829e19c = (ref)=>{
    var _a;
    return (_a = $47990066fdbc3144$export$3f84770eccf215d2(ref)) == null ? void 0 : _a.$modeName$;
};
// src/runtime/normalize-watchers.ts
var $47990066fdbc3144$export$9bd12ad9059cd2fb = (raw)=>{
    if (!raw) return void 0;
    const keys = Object.keys(raw);
    if (keys.length === 0) return void 0;
    let hasLegacy = false;
    for (const propName of keys){
        if (hasLegacy) break;
        for (const h2 of raw[propName])if (typeof h2 === "string") {
            hasLegacy = true;
            break;
        }
    }
    if (!hasLegacy) return raw;
    const out = {};
    for (const propName of keys)out[propName] = raw[propName].map((h2)=>typeof h2 === "string" ? {
            [h2]: 0
        } : h2);
    return out;
};
// src/utils/remote-value.ts
var $47990066fdbc3144$var$RemoteValue = class _RemoteValue {
    /**
   * Deserializes a LocalValue serialized object back to its original JavaScript representation
   *
   * @param serialized The serialized LocalValue object
   * @returns The original JavaScript value/object
   */ static fromLocalValue(serialized) {
        const type = serialized[$47990066fdbc3144$var$TYPE_CONSTANT];
        const value = $47990066fdbc3144$var$VALUE_CONSTANT in serialized ? serialized[$47990066fdbc3144$var$VALUE_CONSTANT] : void 0;
        switch(type){
            case "string" /* String */ :
                return value;
            case "boolean" /* Boolean */ :
                return value;
            case "bigint" /* BigInt */ :
                return BigInt(value);
            case "undefined" /* Undefined */ :
                return void 0;
            case "null" /* Null */ :
                return null;
            case "number" /* Number */ :
                if (value === "NaN") return NaN;
                if (value === "-0") return -0;
                if (value === "Infinity") return Infinity;
                if (value === "-Infinity") return -Infinity;
                return value;
            case "array" /* Array */ :
                return value.map((item)=>_RemoteValue.fromLocalValue(item));
            case "date" /* Date */ :
                return new Date(value);
            case "map" /* Map */ :
                const map = /* @__PURE__ */ new Map();
                for (const [key, val] of value){
                    const deserializedKey = typeof key === "object" && key !== null ? _RemoteValue.fromLocalValue(key) : key;
                    const deserializedValue = _RemoteValue.fromLocalValue(val);
                    map.set(deserializedKey, deserializedValue);
                }
                return map;
            case "object" /* Object */ :
                const obj = {};
                for (const [key, val] of value)obj[key] = _RemoteValue.fromLocalValue(val);
                return obj;
            case "regexp" /* RegularExpression */ :
                const { pattern: pattern, flags: flags } = value;
                return new RegExp(pattern, flags);
            case "set" /* Set */ :
                const set = /* @__PURE__ */ new Set();
                for (const item of value)set.add(_RemoteValue.fromLocalValue(item));
                return set;
            case "symbol" /* Symbol */ :
                return Symbol(value);
            default:
                throw new Error(`Unsupported type: ${type}`);
        }
    }
    /**
   * Utility method to deserialize multiple LocalValues at once
   *
   * @param serializedValues Array of serialized LocalValue objects
   * @returns Array of deserialized JavaScript values
   */ static fromLocalValueArray(serializedValues) {
        return serializedValues.map((value)=>_RemoteValue.fromLocalValue(value));
    }
    /**
   * Verifies if the given object matches the structure of a serialized LocalValue
   *
   * @param obj Object to verify
   * @returns boolean indicating if the object has LocalValue structure
   */ static isLocalValueObject(obj) {
        if (typeof obj !== "object" || obj === null) return false;
        if (!obj.hasOwnProperty($47990066fdbc3144$var$TYPE_CONSTANT)) return false;
        const type = obj[$47990066fdbc3144$var$TYPE_CONSTANT];
        const hasTypeProperty = Object.values({
            ...$47990066fdbc3144$var$PrimitiveType,
            ...$47990066fdbc3144$var$NonPrimitiveType
        }).includes(type);
        if (!hasTypeProperty) return false;
        if (type !== "null" /* Null */  && type !== "undefined" /* Undefined */ ) return obj.hasOwnProperty($47990066fdbc3144$var$VALUE_CONSTANT);
        return true;
    }
};
// src/utils/serialize.ts
function $47990066fdbc3144$var$decodeBase64Unicode(base64) {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for(let i2 = 0; i2 < binary.length; i2++)bytes[i2] = binary.charCodeAt(i2);
    return new TextDecoder().decode(bytes);
}
function $47990066fdbc3144$var$deserializeProperty(value) {
    if (typeof value !== "string" || !value.startsWith($47990066fdbc3144$var$SERIALIZED_PREFIX)) return value;
    return $47990066fdbc3144$var$RemoteValue.fromLocalValue(JSON.parse($47990066fdbc3144$var$decodeBase64Unicode(value.slice($47990066fdbc3144$var$SERIALIZED_PREFIX.length))));
}
// src/runtime/parse-property-value.ts
var $47990066fdbc3144$export$480b8c8d1e35b434 = (propValue, propType, isFormAssociated)=>{
    if (((0, $kxuSp.BUILD).hydrateClientSide || (0, $kxuSp.BUILD).hydrateServerSide) && typeof propValue === "string" && propValue.startsWith($47990066fdbc3144$var$SERIALIZED_PREFIX)) {
        propValue = $47990066fdbc3144$var$deserializeProperty(propValue);
        return propValue;
    }
    if (propValue != null && !$47990066fdbc3144$var$isComplexType(propValue)) {
        if ((0, $kxuSp.BUILD).propBoolean && propType & 4 /* Boolean */ ) {
            if ((0, $kxuSp.BUILD).formAssociated && isFormAssociated && typeof propValue === "string") return propValue === "" || !!propValue;
            else return propValue === "false" ? false : propValue === "" || !!propValue;
        }
        if ((0, $kxuSp.BUILD).propNumber && propType & 2 /* Number */ ) return typeof propValue === "string" ? parseFloat(propValue) : typeof propValue === "number" ? propValue : NaN;
        if ((0, $kxuSp.BUILD).propString && propType & 1 /* String */ ) return String(propValue);
        return propValue;
    }
    return propValue;
};
var $47990066fdbc3144$export$d16800b7e59a8051 = (ref)=>{
    var _a;
    return (0, $kxuSp.BUILD).lazyLoad ? (_a = $47990066fdbc3144$export$3f84770eccf215d2(ref)) == null ? void 0 : _a.$hostElement$ : ref;
};
// src/runtime/event-emitter.ts
var $47990066fdbc3144$export$c30017717ce2168e = (ref, name, flags)=>{
    const elm = $47990066fdbc3144$export$d16800b7e59a8051(ref);
    return {
        emit: (detail)=>{
            if ((0, $kxuSp.BUILD).isDev && !elm.isConnected) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The "${name}" event was emitted, but the dispatcher node is no longer connected to the dom.`);
            return $47990066fdbc3144$var$emitEvent(elm, name, {
                bubbles: !!(flags & 4 /* Bubbles */ ),
                composed: !!(flags & 2 /* Composed */ ),
                cancelable: !!(flags & 1 /* Cancellable */ ),
                detail: detail
            });
        }
    };
};
var $47990066fdbc3144$var$emitEvent = (elm, name, opts)=>{
    const ev = $47990066fdbc3144$export$2e40610e9d23bca6.ce(name, opts);
    elm.dispatchEvent(ev);
    return ev;
};
var $47990066fdbc3144$var$setAccessor = (elm, memberName, oldValue, newValue, isSvg, flags, initialRender)=>{
    if (oldValue === newValue) return;
    let isProp = $47990066fdbc3144$export$304efeaa4c96d4e9(elm, memberName);
    let ln = memberName.toLowerCase();
    if ((0, $kxuSp.BUILD).vdomClass && memberName === "class") {
        const classList = elm.classList;
        const oldClasses = $47990066fdbc3144$var$parseClassList(oldValue);
        let newClasses = $47990066fdbc3144$var$parseClassList(newValue);
        if ((0, $kxuSp.BUILD).hydrateClientSide && (elm["s-si"] || elm["s-sc"]) && initialRender) {
            const scopeId2 = elm["s-sc"] || elm["s-si"];
            newClasses.push(scopeId2);
            oldClasses.forEach((c)=>{
                if (c.startsWith(scopeId2)) newClasses.push(c);
            });
            newClasses = [
                ...new Set(newClasses)
            ].filter((c)=>c);
            classList.add(...newClasses);
        } else {
            classList.remove(...oldClasses.filter((c)=>c && !newClasses.includes(c)));
            classList.add(...newClasses.filter((c)=>c && !oldClasses.includes(c)));
        }
    } else if ((0, $kxuSp.BUILD).vdomStyle && memberName === "style") {
        if ((0, $kxuSp.BUILD).updatable) {
            for(const prop in oldValue)if (!newValue || newValue[prop] == null) {
                if (!(0, $kxuSp.BUILD).hydrateServerSide && prop.includes("-")) elm.style.removeProperty(prop);
                else elm.style[prop] = "";
            }
        }
        for(const prop in newValue)if (!oldValue || newValue[prop] !== oldValue[prop]) {
            if (!(0, $kxuSp.BUILD).hydrateServerSide && prop.includes("-")) elm.style.setProperty(prop, newValue[prop]);
            else elm.style[prop] = newValue[prop];
        }
    } else if ((0, $kxuSp.BUILD).vdomKey && memberName === "key") ;
    else if ((0, $kxuSp.BUILD).vdomRef && memberName === "ref") {
        if (newValue) $47990066fdbc3144$var$queueRefAttachment(newValue, elm);
    } else if ((0, $kxuSp.BUILD).vdomListener && ((0, $kxuSp.BUILD).lazyLoad ? !isProp : !elm.__lookupSetter__(memberName)) && memberName[0] === "o" && memberName[1] === "n") {
        if (memberName[2] === "-") memberName = memberName.slice(3);
        else if ($47990066fdbc3144$export$304efeaa4c96d4e9($47990066fdbc3144$export$10a0f131c0eea21b, ln)) memberName = ln.slice(2);
        else memberName = ln[2] + memberName.slice(3);
        if (oldValue || newValue) {
            const capture = memberName.endsWith($47990066fdbc3144$var$CAPTURE_EVENT_SUFFIX);
            memberName = memberName.replace($47990066fdbc3144$var$CAPTURE_EVENT_REGEX, "");
            if (oldValue) $47990066fdbc3144$export$2e40610e9d23bca6.rel(elm, memberName, oldValue, capture);
            if (newValue) $47990066fdbc3144$export$2e40610e9d23bca6.ael(elm, memberName, newValue, capture);
        }
    } else if ((0, $kxuSp.BUILD).vdomPropOrAttr && memberName[0] === "a" && memberName.startsWith("attr:")) {
        const propName = memberName.slice(5);
        let attrName;
        if ((0, $kxuSp.BUILD).member) {
            const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
            if (hostRef && hostRef.$cmpMeta$ && hostRef.$cmpMeta$.$members$) {
                const memberMeta = hostRef.$cmpMeta$.$members$[propName];
                if (memberMeta && memberMeta[1]) attrName = memberMeta[1];
            }
        }
        if (!attrName) attrName = propName.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        if (newValue == null || newValue === false) {
            if (newValue !== false || elm.getAttribute(attrName) === "") elm.removeAttribute(attrName);
        } else elm.setAttribute(attrName, newValue === true ? "" : newValue);
        return;
    } else if ((0, $kxuSp.BUILD).vdomPropOrAttr && memberName[0] === "p" && memberName.startsWith("prop:")) {
        const propName = memberName.slice(5);
        try {
            elm[propName] = newValue;
        } catch (e) {}
        return;
    } else if ((0, $kxuSp.BUILD).vdomPropOrAttr) {
        const isComplex = $47990066fdbc3144$var$isComplexType(newValue);
        if ((isProp || isComplex && newValue !== null) && !isSvg) try {
            if (!elm.tagName.includes("-")) {
                const n = newValue == null ? "" : newValue;
                if (memberName === "list") isProp = false;
                else if (oldValue == null || elm[memberName] !== n) {
                    if (typeof elm.__lookupSetter__(memberName) === "function") elm[memberName] = n;
                    else elm.setAttribute(memberName, n);
                }
            } else if (elm[memberName] !== newValue) elm[memberName] = newValue;
        } catch (e) {}
        let xlink = false;
        if ((0, $kxuSp.BUILD).vdomXlink) {
            if (ln !== (ln = ln.replace(/^xlink\:?/, ""))) {
                memberName = ln;
                xlink = true;
            }
        }
        if (newValue == null || newValue === false) {
            if (newValue !== false || elm.getAttribute(memberName) === "") {
                if ((0, $kxuSp.BUILD).vdomXlink && xlink) elm.removeAttributeNS($47990066fdbc3144$var$XLINK_NS, memberName);
                else elm.removeAttribute(memberName);
            }
        } else if ((!isProp || flags & 4 /* isHost */  || isSvg) && !isComplex && elm.nodeType === 1 /* ElementNode */ ) {
            newValue = newValue === true ? "" : newValue;
            if ((0, $kxuSp.BUILD).vdomXlink && xlink) elm.setAttributeNS($47990066fdbc3144$var$XLINK_NS, memberName, newValue);
            else elm.setAttribute(memberName, newValue);
        }
    }
};
var $47990066fdbc3144$var$parseClassListRegex = /\s/;
var $47990066fdbc3144$var$parseClassList = (value)=>{
    if (typeof value === "object" && value && "baseVal" in value) value = value.baseVal;
    if (!value || typeof value !== "string") return [];
    return value.split($47990066fdbc3144$var$parseClassListRegex);
};
var $47990066fdbc3144$var$CAPTURE_EVENT_SUFFIX = "Capture";
var $47990066fdbc3144$var$CAPTURE_EVENT_REGEX = new RegExp($47990066fdbc3144$var$CAPTURE_EVENT_SUFFIX + "$");
// src/runtime/vdom/update-element.ts
var $47990066fdbc3144$var$updateElement = (oldVnode, newVnode, isSvgMode2, isInitialRender)=>{
    const elm = newVnode.$elm$.nodeType === 11 /* DocumentFragment */  && newVnode.$elm$.host ? newVnode.$elm$.host : newVnode.$elm$;
    const oldVnodeAttrs = oldVnode && oldVnode.$attrs$ || {};
    const newVnodeAttrs = newVnode.$attrs$ || {};
    if ((0, $kxuSp.BUILD).updatable) {
        for (const memberName of $47990066fdbc3144$var$sortedAttrNames(Object.keys(oldVnodeAttrs)))if (!(memberName in newVnodeAttrs)) $47990066fdbc3144$var$setAccessor(elm, memberName, oldVnodeAttrs[memberName], void 0, isSvgMode2, newVnode.$flags$, isInitialRender);
    }
    for (const memberName of $47990066fdbc3144$var$sortedAttrNames(Object.keys(newVnodeAttrs)))$47990066fdbc3144$var$setAccessor(elm, memberName, oldVnodeAttrs[memberName], newVnodeAttrs[memberName], isSvgMode2, newVnode.$flags$, isInitialRender);
};
function $47990066fdbc3144$var$sortedAttrNames(attrNames) {
    return attrNames.includes("ref") ? // we need to sort these to ensure that `'ref'` is the last attr
    [
        ...attrNames.filter((attr)=>attr !== "ref"),
        "ref"
    ] : // no need to sort, return the original array
    attrNames;
}
// src/runtime/vdom/vdom-render.ts
var $47990066fdbc3144$var$scopeId;
var $47990066fdbc3144$var$contentRef;
var $47990066fdbc3144$var$hostTagName;
var $47990066fdbc3144$var$useNativeShadowDom = false;
var $47990066fdbc3144$var$checkSlotFallbackVisibility = false;
var $47990066fdbc3144$var$checkSlotRelocate = false;
var $47990066fdbc3144$var$isSvgMode = false;
var $47990066fdbc3144$var$refCallbacksToRemove = [];
var $47990066fdbc3144$var$refCallbacksToAttach = [];
var $47990066fdbc3144$var$createElm = (oldParentVNode, newParentVNode, childIndex)=>{
    var _a;
    const newVNode2 = newParentVNode.$children$[childIndex];
    let i2 = 0;
    let elm;
    let childNode;
    let oldVNode;
    if ((0, $kxuSp.BUILD).slotRelocation && !$47990066fdbc3144$var$useNativeShadowDom) {
        $47990066fdbc3144$var$checkSlotRelocate = true;
        if (newVNode2.$tag$ === "slot") newVNode2.$flags$ |= newVNode2.$children$ ? // slot element has fallback content
        // still create an element that "mocks" the slot element
        2 /* isSlotFallback */  : // slot element does not have fallback content
        // create an html comment we'll use to always reference
        // where actual slot content should sit next to
        1 /* isSlotReference */ ;
    }
    if ((0, $kxuSp.BUILD).isDev && newVNode2.$elm$) $47990066fdbc3144$export$47b52a6e53fbbc24(`The JSX ${newVNode2.$text$ !== null ? `"${newVNode2.$text$}" text` : `"${newVNode2.$tag$}" element`} node should not be shared within the same renderer. The renderer caches element lookups in order to improve performance. However, a side effect from this is that the exact same JSX node should not be reused. For more information please see https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes`);
    if ((0, $kxuSp.BUILD).vdomText && newVNode2.$text$ != null) elm = newVNode2.$elm$ = $47990066fdbc3144$export$10a0f131c0eea21b.document.createTextNode(newVNode2.$text$);
    else if ((0, $kxuSp.BUILD).slotRelocation && newVNode2.$flags$ & 1 /* isSlotReference */ ) {
        elm = newVNode2.$elm$ = (0, $kxuSp.BUILD).isDebug || (0, $kxuSp.BUILD).hydrateServerSide ? $47990066fdbc3144$var$slotReferenceDebugNode(newVNode2) : $47990066fdbc3144$export$10a0f131c0eea21b.document.createTextNode("");
        if ((0, $kxuSp.BUILD).vdomAttribute) $47990066fdbc3144$var$updateElement(null, newVNode2, $47990066fdbc3144$var$isSvgMode);
    } else {
        if ((0, $kxuSp.BUILD).svg && !$47990066fdbc3144$var$isSvgMode) $47990066fdbc3144$var$isSvgMode = newVNode2.$tag$ === "svg";
        if (!$47990066fdbc3144$export$10a0f131c0eea21b.document) throw new Error("You are trying to render a Stencil component in an environment that doesn't support the DOM.");
        elm = newVNode2.$elm$ = (0, $kxuSp.BUILD).svg ? $47990066fdbc3144$export$10a0f131c0eea21b.document.createElementNS($47990066fdbc3144$var$isSvgMode ? $47990066fdbc3144$var$SVG_NS : $47990066fdbc3144$var$HTML_NS, !$47990066fdbc3144$var$useNativeShadowDom && (0, $kxuSp.BUILD).slotRelocation && newVNode2.$flags$ & 2 /* isSlotFallback */  ? "slot-fb" : newVNode2.$tag$) : $47990066fdbc3144$export$10a0f131c0eea21b.document.createElement(!$47990066fdbc3144$var$useNativeShadowDom && (0, $kxuSp.BUILD).slotRelocation && newVNode2.$flags$ & 2 /* isSlotFallback */  ? "slot-fb" : newVNode2.$tag$);
        if ((0, $kxuSp.BUILD).svg && $47990066fdbc3144$var$isSvgMode && newVNode2.$tag$ === "foreignObject") $47990066fdbc3144$var$isSvgMode = false;
        if ((0, $kxuSp.BUILD).vdomAttribute) $47990066fdbc3144$var$updateElement(null, newVNode2, $47990066fdbc3144$var$isSvgMode);
        if (((0, $kxuSp.BUILD).scoped || (0, $kxuSp.BUILD).hydrateServerSide && 128 /* shadowNeedsScopedCss */ ) && $47990066fdbc3144$var$isDef($47990066fdbc3144$var$scopeId) && elm["s-si"] !== $47990066fdbc3144$var$scopeId) elm.classList.add(elm["s-si"] = $47990066fdbc3144$var$scopeId);
        if (newVNode2.$children$) {
            const appendTarget = newVNode2.$tag$ === "template" ? elm.content : elm;
            for(i2 = 0; i2 < newVNode2.$children$.length; ++i2){
                childNode = $47990066fdbc3144$var$createElm(oldParentVNode, newVNode2, i2);
                if (childNode) appendTarget.appendChild(childNode);
            }
        }
        if ((0, $kxuSp.BUILD).svg) {
            if (newVNode2.$tag$ === "svg") $47990066fdbc3144$var$isSvgMode = false;
            else if (elm.tagName === "foreignObject") $47990066fdbc3144$var$isSvgMode = true;
        }
    }
    elm["s-hn"] = $47990066fdbc3144$var$hostTagName;
    if ((0, $kxuSp.BUILD).slotRelocation) {
        if (newVNode2.$flags$ & 3 /* isSlotReference */ ) {
            elm["s-sr"] = true;
            elm["s-cr"] = $47990066fdbc3144$var$contentRef;
            elm["s-sn"] = newVNode2.$name$ || "";
            elm["s-rf"] = (_a = newVNode2.$attrs$) == null ? void 0 : _a.ref;
            $47990066fdbc3144$var$patchSlotNode(elm);
            oldVNode = oldParentVNode && oldParentVNode.$children$ && oldParentVNode.$children$[childIndex];
            if (oldVNode && oldVNode.$tag$ === newVNode2.$tag$ && oldParentVNode.$elm$) $47990066fdbc3144$var$relocateToHostRoot(oldParentVNode.$elm$);
            if ((0, $kxuSp.BUILD).scoped || (0, $kxuSp.BUILD).hydrateServerSide && 128 /* shadowNeedsScopedCss */ ) $47990066fdbc3144$var$addRemoveSlotScopedClass($47990066fdbc3144$var$contentRef, elm, newParentVNode.$elm$, oldParentVNode == null ? void 0 : oldParentVNode.$elm$);
        }
    }
    return elm;
};
var $47990066fdbc3144$var$relocateToHostRoot = (parentElm)=>{
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 1 /* isTmpDisconnected */ ;
    const host = parentElm.closest($47990066fdbc3144$var$hostTagName.toLowerCase());
    if (host != null) {
        const contentRefNode = Array.from(host.__childNodes || host.childNodes).find((ref)=>ref["s-cr"]);
        const childNodeArray = Array.from(parentElm.__childNodes || parentElm.childNodes);
        for (const childNode of contentRefNode ? childNodeArray.reverse() : childNodeArray)if (childNode["s-sh"] != null) {
            $47990066fdbc3144$var$insertBefore(host, childNode, contentRefNode != null ? contentRefNode : null);
            childNode["s-sh"] = void 0;
            $47990066fdbc3144$var$checkSlotRelocate = true;
        }
    }
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ &= -2 /* isTmpDisconnected */ ;
};
var $47990066fdbc3144$var$putBackInOriginalLocation = (parentElm, recursive)=>{
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 1 /* isTmpDisconnected */ ;
    const oldSlotChildNodes = Array.from(parentElm.__childNodes || parentElm.childNodes);
    if (parentElm["s-sr"]) {
        let node = parentElm;
        while(node = node.nextSibling)if (node && node["s-sn"] === parentElm["s-sn"] && node["s-sh"] === $47990066fdbc3144$var$hostTagName) oldSlotChildNodes.push(node);
    }
    for(let i2 = oldSlotChildNodes.length - 1; i2 >= 0; i2--){
        const childNode = oldSlotChildNodes[i2];
        if (childNode["s-hn"] !== $47990066fdbc3144$var$hostTagName && childNode["s-ol"]) {
            $47990066fdbc3144$var$insertBefore($47990066fdbc3144$var$referenceNode(childNode).parentNode, childNode, $47990066fdbc3144$var$referenceNode(childNode));
            childNode["s-ol"].remove();
            childNode["s-ol"] = void 0;
            childNode["s-sh"] = void 0;
            $47990066fdbc3144$var$checkSlotRelocate = true;
        }
        if (recursive) $47990066fdbc3144$var$putBackInOriginalLocation(childNode, recursive);
    }
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ &= -2 /* isTmpDisconnected */ ;
};
var $47990066fdbc3144$var$addVnodes = (parentElm, before, parentVNode, vnodes, startIdx, endIdx)=>{
    let containerElm = (0, $kxuSp.BUILD).slotRelocation && parentElm["s-cr"] && parentElm["s-cr"].parentNode || parentElm;
    let childNode;
    if ((0, $kxuSp.BUILD).shadowDom && containerElm.shadowRoot && containerElm.tagName === $47990066fdbc3144$var$hostTagName) containerElm = containerElm.shadowRoot;
    if (parentVNode.$tag$ === "template") containerElm = containerElm.content;
    for(; startIdx <= endIdx; ++startIdx)if (vnodes[startIdx]) {
        childNode = $47990066fdbc3144$var$createElm(null, parentVNode, startIdx);
        if (childNode) {
            vnodes[startIdx].$elm$ = childNode;
            $47990066fdbc3144$var$insertBefore(containerElm, childNode, (0, $kxuSp.BUILD).slotRelocation ? $47990066fdbc3144$var$referenceNode(before) : before);
        }
    }
};
var $47990066fdbc3144$var$removeVnodes = (vnodes, startIdx, endIdx)=>{
    for(let index = startIdx; index <= endIdx; ++index){
        const vnode = vnodes[index];
        if (vnode) {
            const elm = vnode.$elm$;
            $47990066fdbc3144$var$nullifyVNodeRefs(vnode);
            if (elm) {
                if ((0, $kxuSp.BUILD).slotRelocation) {
                    $47990066fdbc3144$var$checkSlotFallbackVisibility = true;
                    if (elm["s-ol"]) elm["s-ol"].remove();
                    else $47990066fdbc3144$var$putBackInOriginalLocation(elm, true);
                }
                elm.remove();
            }
        }
    }
};
var $47990066fdbc3144$var$updateChildren = (parentElm, oldCh, newVNode2, newCh, isInitialRender = false)=>{
    let oldStartIdx = 0;
    let newStartIdx = 0;
    let idxInOld = 0;
    let i2 = 0;
    let oldEndIdx = oldCh.length - 1;
    let oldStartVnode = oldCh[0];
    let oldEndVnode = oldCh[oldEndIdx];
    let newEndIdx = newCh.length - 1;
    let newStartVnode = newCh[0];
    let newEndVnode = newCh[newEndIdx];
    let node;
    let elmToMove;
    const containerElm = newVNode2.$tag$ === "template" ? parentElm.content : parentElm;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($47990066fdbc3144$var$isSameVnode(oldStartVnode, newStartVnode, isInitialRender)) {
            $47990066fdbc3144$var$patch(oldStartVnode, newStartVnode, isInitialRender);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($47990066fdbc3144$var$isSameVnode(oldEndVnode, newEndVnode, isInitialRender)) {
            $47990066fdbc3144$var$patch(oldEndVnode, newEndVnode, isInitialRender);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($47990066fdbc3144$var$isSameVnode(oldStartVnode, newEndVnode, isInitialRender)) {
            if ((0, $kxuSp.BUILD).slotRelocation && (oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot")) $47990066fdbc3144$var$putBackInOriginalLocation(oldStartVnode.$elm$.parentNode, false);
            $47990066fdbc3144$var$patch(oldStartVnode, newEndVnode, isInitialRender);
            $47990066fdbc3144$var$insertBefore(containerElm, oldStartVnode.$elm$, oldEndVnode.$elm$.nextSibling);
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($47990066fdbc3144$var$isSameVnode(oldEndVnode, newStartVnode, isInitialRender)) {
            if ((0, $kxuSp.BUILD).slotRelocation && (oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot")) $47990066fdbc3144$var$putBackInOriginalLocation(oldEndVnode.$elm$.parentNode, false);
            $47990066fdbc3144$var$patch(oldEndVnode, newStartVnode, isInitialRender);
            $47990066fdbc3144$var$insertBefore(containerElm, oldEndVnode.$elm$, oldStartVnode.$elm$);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            idxInOld = -1;
            if ((0, $kxuSp.BUILD).vdomKey) {
                for(i2 = oldStartIdx; i2 <= oldEndIdx; ++i2)if (oldCh[i2] && oldCh[i2].$key$ !== null && oldCh[i2].$key$ === newStartVnode.$key$) {
                    idxInOld = i2;
                    break;
                }
            }
            if ((0, $kxuSp.BUILD).vdomKey && idxInOld >= 0) {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.$tag$ !== newStartVnode.$tag$) node = $47990066fdbc3144$var$createElm(oldCh && oldCh[newStartIdx], newVNode2, idxInOld);
                else {
                    $47990066fdbc3144$var$patch(elmToMove, newStartVnode, isInitialRender);
                    oldCh[idxInOld] = void 0;
                    node = elmToMove.$elm$;
                }
                newStartVnode = newCh[++newStartIdx];
            } else {
                node = $47990066fdbc3144$var$createElm(oldCh && oldCh[newStartIdx], newVNode2, newStartIdx);
                newStartVnode = newCh[++newStartIdx];
            }
            if (node) {
                if ((0, $kxuSp.BUILD).slotRelocation) $47990066fdbc3144$var$insertBefore($47990066fdbc3144$var$referenceNode(oldStartVnode.$elm$).parentNode, node, $47990066fdbc3144$var$referenceNode(oldStartVnode.$elm$));
                else $47990066fdbc3144$var$insertBefore(oldStartVnode.$elm$.parentNode, node, oldStartVnode.$elm$);
            }
        }
    }
    if (oldStartIdx > oldEndIdx) $47990066fdbc3144$var$addVnodes(parentElm, newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].$elm$, newVNode2, newCh, newStartIdx, newEndIdx);
    else if ((0, $kxuSp.BUILD).updatable && newStartIdx > newEndIdx) $47990066fdbc3144$var$removeVnodes(oldCh, oldStartIdx, oldEndIdx);
};
var $47990066fdbc3144$var$isSameVnode = (leftVNode, rightVNode, isInitialRender = false)=>{
    if (leftVNode.$tag$ === rightVNode.$tag$) {
        if ((0, $kxuSp.BUILD).slotRelocation && leftVNode.$tag$ === "slot") return leftVNode.$name$ === rightVNode.$name$;
        if ((0, $kxuSp.BUILD).vdomKey && !isInitialRender) return leftVNode.$key$ === rightVNode.$key$;
        if (isInitialRender && !leftVNode.$key$ && rightVNode.$key$) leftVNode.$key$ = rightVNode.$key$;
        return true;
    }
    return false;
};
var $47990066fdbc3144$var$referenceNode = (node)=>node && node["s-ol"] || node;
var $47990066fdbc3144$var$patch = (oldVNode, newVNode2, isInitialRender = false)=>{
    const elm = newVNode2.$elm$ = oldVNode.$elm$;
    const oldChildren = oldVNode.$children$;
    const newChildren = newVNode2.$children$;
    const tag = newVNode2.$tag$;
    const text = newVNode2.$text$;
    let defaultHolder;
    if (!(0, $kxuSp.BUILD).vdomText || text == null) {
        if ((0, $kxuSp.BUILD).svg) $47990066fdbc3144$var$isSvgMode = tag === "svg" ? true : tag === "foreignObject" ? false : $47990066fdbc3144$var$isSvgMode;
        if ((0, $kxuSp.BUILD).vdomAttribute || (0, $kxuSp.BUILD).reflect) {
            if ((0, $kxuSp.BUILD).slot && tag === "slot" && !$47990066fdbc3144$var$useNativeShadowDom) {
                if (oldVNode.$name$ !== newVNode2.$name$) {
                    newVNode2.$elm$["s-sn"] = newVNode2.$name$ || "";
                    $47990066fdbc3144$var$relocateToHostRoot(newVNode2.$elm$.parentElement);
                }
            }
            $47990066fdbc3144$var$updateElement(oldVNode, newVNode2, $47990066fdbc3144$var$isSvgMode, isInitialRender);
        }
        if ((0, $kxuSp.BUILD).updatable && oldChildren !== null && newChildren !== null) $47990066fdbc3144$var$updateChildren(elm, oldChildren, newVNode2, newChildren, isInitialRender);
        else if (newChildren !== null) {
            if ((0, $kxuSp.BUILD).updatable && (0, $kxuSp.BUILD).vdomText && oldVNode.$text$ !== null) elm.textContent = "";
            $47990066fdbc3144$var$addVnodes(elm, null, newVNode2, newChildren, 0, newChildren.length - 1);
        } else if (// don't do this on initial render as it can cause non-hydrated content to be removed
        !isInitialRender && (0, $kxuSp.BUILD).updatable && oldChildren !== null) $47990066fdbc3144$var$removeVnodes(oldChildren, 0, oldChildren.length - 1);
        else if ((0, $kxuSp.BUILD).hydrateClientSide && isInitialRender && (0, $kxuSp.BUILD).updatable && oldChildren !== null && newChildren === null) newVNode2.$children$ = oldChildren;
        if ((0, $kxuSp.BUILD).svg && $47990066fdbc3144$var$isSvgMode && tag === "svg") $47990066fdbc3144$var$isSvgMode = false;
    } else if ((0, $kxuSp.BUILD).vdomText && (0, $kxuSp.BUILD).slotRelocation && (defaultHolder = elm["s-cr"])) defaultHolder.parentNode.textContent = text;
    else if ((0, $kxuSp.BUILD).vdomText && oldVNode.$text$ !== text) elm.data = text;
};
var $47990066fdbc3144$var$relocateNodes = [];
var $47990066fdbc3144$var$markSlotContentForRelocation = (elm)=>{
    let node;
    let hostContentNodes;
    let j;
    const children = elm.__childNodes || elm.childNodes;
    for (const childNode of children){
        if (childNode["s-sr"] && (node = childNode["s-cr"]) && node.parentNode) {
            hostContentNodes = node.parentNode.__childNodes || node.parentNode.childNodes;
            const slotName = childNode["s-sn"];
            for(j = hostContentNodes.length - 1; j >= 0; j--){
                node = hostContentNodes[j];
                if (!node["s-cn"] && !node["s-nr"] && node["s-hn"] !== childNode["s-hn"] && (!node["s-sh"] || node["s-sh"] !== childNode["s-hn"])) {
                    if ($47990066fdbc3144$var$isNodeLocatedInSlot(node, slotName)) {
                        let relocateNodeData = $47990066fdbc3144$var$relocateNodes.find((r)=>r.$nodeToRelocate$ === node);
                        $47990066fdbc3144$var$checkSlotFallbackVisibility = true;
                        node["s-sn"] = node["s-sn"] || slotName;
                        if (relocateNodeData) {
                            relocateNodeData.$nodeToRelocate$["s-sh"] = childNode["s-hn"];
                            relocateNodeData.$slotRefNode$ = childNode;
                        } else {
                            node["s-sh"] = childNode["s-hn"];
                            $47990066fdbc3144$var$relocateNodes.push({
                                $slotRefNode$: childNode,
                                $nodeToRelocate$: node
                            });
                        }
                        if (node["s-sr"]) $47990066fdbc3144$var$relocateNodes.map((relocateNode)=>{
                            if ($47990066fdbc3144$var$isNodeLocatedInSlot(relocateNode.$nodeToRelocate$, node["s-sn"])) {
                                relocateNodeData = $47990066fdbc3144$var$relocateNodes.find((r)=>r.$nodeToRelocate$ === node);
                                if (relocateNodeData && !relocateNode.$slotRefNode$) relocateNode.$slotRefNode$ = relocateNodeData.$slotRefNode$;
                            }
                        });
                    } else if (!$47990066fdbc3144$var$relocateNodes.some((r)=>r.$nodeToRelocate$ === node)) $47990066fdbc3144$var$relocateNodes.push({
                        $nodeToRelocate$: node
                    });
                }
            }
        }
        if (childNode.nodeType === 1 /* ElementNode */ ) $47990066fdbc3144$var$markSlotContentForRelocation(childNode);
    }
};
var $47990066fdbc3144$var$nullifyVNodeRefs = (vNode)=>{
    if ((0, $kxuSp.BUILD).vdomRef) {
        if (vNode.$attrs$ && vNode.$attrs$.ref) $47990066fdbc3144$var$refCallbacksToRemove.push(()=>vNode.$attrs$.ref(null));
        vNode.$children$ && vNode.$children$.map($47990066fdbc3144$var$nullifyVNodeRefs);
    }
};
var $47990066fdbc3144$var$queueRefAttachment = (refCallback, elm)=>{
    if ((0, $kxuSp.BUILD).vdomRef) $47990066fdbc3144$var$refCallbacksToAttach.push(()=>refCallback(elm));
};
var $47990066fdbc3144$var$flushQueuedRefCallbacks = ()=>{
    if ((0, $kxuSp.BUILD).vdomRef) {
        $47990066fdbc3144$var$refCallbacksToRemove.forEach((cb)=>cb());
        $47990066fdbc3144$var$refCallbacksToRemove.length = 0;
        $47990066fdbc3144$var$refCallbacksToAttach.forEach((cb)=>cb());
        $47990066fdbc3144$var$refCallbacksToAttach.length = 0;
    }
};
var $47990066fdbc3144$var$insertBefore = (parent, newNode, reference, isInitialLoad)=>{
    if ((0, $kxuSp.BUILD).slotRelocation) {
        if ((0, $kxuSp.BUILD).scoped && typeof newNode["s-sn"] === "string" && !!newNode["s-sr"] && !!newNode["s-cr"]) $47990066fdbc3144$var$addRemoveSlotScopedClass(newNode["s-cr"], newNode, parent, newNode.parentElement);
        else if (typeof newNode["s-sn"] === "string") {
            if ((0, $kxuSp.BUILD).experimentalSlotFixes && parent.getRootNode().nodeType !== 11 /* DOCUMENT_FRAGMENT_NODE */ ) $47990066fdbc3144$var$patchParentNode(newNode);
            parent.insertBefore(newNode, reference);
            const { slotNode: slotNode } = $47990066fdbc3144$var$findSlotFromSlottedNode(newNode);
            if (slotNode && !isInitialLoad) $47990066fdbc3144$var$dispatchSlotChangeEvent(slotNode);
            return newNode;
        }
    }
    if (parent.__insertBefore) return parent.__insertBefore(newNode, reference);
    else return parent == null ? void 0 : parent.insertBefore(newNode, reference);
};
function $47990066fdbc3144$var$addRemoveSlotScopedClass(reference, slotNode, newParent, oldParent) {
    var _a, _b;
    let scopeId2;
    if (reference && typeof slotNode["s-sn"] === "string" && !!slotNode["s-sr"] && reference.parentNode && reference.parentNode["s-sc"] && (scopeId2 = slotNode["s-si"] || reference.parentNode["s-sc"])) {
        const scopeName = slotNode["s-sn"];
        const hostName = slotNode["s-hn"];
        (_a = newParent.classList) == null || _a.add(scopeId2 + "-s");
        if (oldParent && ((_b = oldParent.classList) == null ? void 0 : _b.contains(scopeId2 + "-s"))) {
            let child = (oldParent.__childNodes || oldParent.childNodes)[0];
            let found = false;
            while(child){
                if (child["s-sn"] !== scopeName && child["s-hn"] === hostName && !!child["s-sr"]) {
                    found = true;
                    break;
                }
                child = child.nextSibling;
            }
            if (!found) oldParent.classList.remove(scopeId2 + "-s");
        }
    }
}
var $47990066fdbc3144$export$52f8e388858754a = (hostRef, renderFnResults, isInitialLoad = false)=>{
    var _a, _b, _c, _d, _e;
    const hostElm = hostRef.$hostElement$;
    const cmpMeta = hostRef.$cmpMeta$;
    const oldVNode = hostRef.$vnode$ || $47990066fdbc3144$var$newVNode(null, null);
    const isHostElement = $47990066fdbc3144$var$isHost(renderFnResults);
    const rootVnode = isHostElement ? renderFnResults : $47990066fdbc3144$export$dda1d9f60106f0e9(null, null, renderFnResults);
    $47990066fdbc3144$var$hostTagName = hostElm.tagName;
    if ((0, $kxuSp.BUILD).isDev && Array.isArray(renderFnResults) && renderFnResults.some($47990066fdbc3144$var$isHost)) throw new Error(`The <Host> must be the single root component.
Looks like the render() function of "${$47990066fdbc3144$var$hostTagName.toLowerCase()}" is returning an array that contains the <Host>.

The render() function should look like this instead:

render() {
  // Do not return an array
  return (
    <Host>{content}</Host>
  );
}
  `);
    if ((0, $kxuSp.BUILD).reflect && cmpMeta.$attrsToReflect$) {
        rootVnode.$attrs$ = rootVnode.$attrs$ || {};
        cmpMeta.$attrsToReflect$.forEach(([propName, attribute])=>{
            if ((0, $kxuSp.BUILD).serializer && hostRef.$serializerValues$.has(propName)) rootVnode.$attrs$[attribute] = hostRef.$serializerValues$.get(propName);
            else rootVnode.$attrs$[attribute] = hostElm[propName];
        });
    }
    if (isInitialLoad && rootVnode.$attrs$) {
        for (const key of Object.keys(rootVnode.$attrs$))if (hostElm.hasAttribute(key) && ![
            "key",
            "ref",
            "style",
            "class"
        ].includes(key)) rootVnode.$attrs$[key] = hostElm[key];
    }
    rootVnode.$tag$ = null;
    rootVnode.$flags$ |= 4 /* isHost */ ;
    hostRef.$vnode$ = rootVnode;
    rootVnode.$elm$ = oldVNode.$elm$ = (0, $kxuSp.BUILD).shadowDom ? hostElm.shadowRoot || hostElm : hostElm;
    if ((0, $kxuSp.BUILD).scoped || (0, $kxuSp.BUILD).shadowDom) $47990066fdbc3144$var$scopeId = hostElm["s-sc"];
    $47990066fdbc3144$var$useNativeShadowDom = $47990066fdbc3144$export$b4e7e6d61dbcd813 && !!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) && !(cmpMeta.$flags$ & 128 /* shadowNeedsScopedCss */ );
    if ((0, $kxuSp.BUILD).slotRelocation) {
        $47990066fdbc3144$var$contentRef = hostElm["s-cr"];
        $47990066fdbc3144$var$checkSlotFallbackVisibility = false;
    }
    $47990066fdbc3144$var$patch(oldVNode, rootVnode, isInitialLoad);
    if ((0, $kxuSp.BUILD).slotRelocation) {
        $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 1 /* isTmpDisconnected */ ;
        if ($47990066fdbc3144$var$checkSlotRelocate) {
            $47990066fdbc3144$var$markSlotContentForRelocation(rootVnode.$elm$);
            for (const relocateData of $47990066fdbc3144$var$relocateNodes){
                const nodeToRelocate = relocateData.$nodeToRelocate$;
                if (!nodeToRelocate["s-ol"] && $47990066fdbc3144$export$10a0f131c0eea21b.document) {
                    const orgLocationNode = (0, $kxuSp.BUILD).isDebug || (0, $kxuSp.BUILD).hydrateServerSide ? $47990066fdbc3144$var$originalLocationDebugNode(nodeToRelocate) : $47990066fdbc3144$export$10a0f131c0eea21b.document.createTextNode("");
                    orgLocationNode["s-nr"] = nodeToRelocate;
                    $47990066fdbc3144$var$insertBefore(nodeToRelocate.parentNode, nodeToRelocate["s-ol"] = orgLocationNode, nodeToRelocate, isInitialLoad);
                }
            }
            for (const relocateData of $47990066fdbc3144$var$relocateNodes){
                const nodeToRelocate = relocateData.$nodeToRelocate$;
                const slotRefNode = relocateData.$slotRefNode$;
                if (nodeToRelocate.nodeType === 1 /* ElementNode */  && isInitialLoad) nodeToRelocate["s-ih"] = (_a = nodeToRelocate.hidden) != null ? _a : false;
                if (slotRefNode) {
                    const parentNodeRef = slotRefNode.parentNode;
                    let insertBeforeNode = slotRefNode.nextSibling;
                    if (!(0, $kxuSp.BUILD).hydrateServerSide && insertBeforeNode && insertBeforeNode.nodeType === 1 /* ElementNode */ ) {
                        let orgLocationNode = (_b = nodeToRelocate["s-ol"]) == null ? void 0 : _b.previousSibling;
                        while(orgLocationNode){
                            let refNode = (_c = orgLocationNode["s-nr"]) != null ? _c : null;
                            if (refNode && refNode["s-sn"] === nodeToRelocate["s-sn"] && parentNodeRef === (refNode.__parentNode || refNode.parentNode)) {
                                refNode = refNode.nextSibling;
                                while(refNode === nodeToRelocate || (refNode == null ? void 0 : refNode["s-sr"]))refNode = refNode == null ? void 0 : refNode.nextSibling;
                                if (!refNode || !refNode["s-nr"]) {
                                    insertBeforeNode = refNode;
                                    break;
                                }
                            }
                            orgLocationNode = orgLocationNode.previousSibling;
                        }
                    }
                    const parent = nodeToRelocate.__parentNode || nodeToRelocate.parentNode;
                    const nextSibling = nodeToRelocate.__nextSibling || nodeToRelocate.nextSibling;
                    if (!insertBeforeNode && parentNodeRef !== parent || nextSibling !== insertBeforeNode) {
                        if (nodeToRelocate !== insertBeforeNode) {
                            $47990066fdbc3144$var$insertBefore(parentNodeRef, nodeToRelocate, insertBeforeNode, isInitialLoad);
                            if (nodeToRelocate.nodeType === 8 /* CommentNode */  && nodeToRelocate.nodeValue.startsWith("s-nt-")) {
                                const textNode = $47990066fdbc3144$export$10a0f131c0eea21b.document.createTextNode(nodeToRelocate.nodeValue.replace(/^s-nt-/, ""));
                                textNode["s-hn"] = nodeToRelocate["s-hn"];
                                textNode["s-sn"] = nodeToRelocate["s-sn"];
                                textNode["s-sh"] = nodeToRelocate["s-sh"];
                                textNode["s-sr"] = nodeToRelocate["s-sr"];
                                textNode["s-ol"] = nodeToRelocate["s-ol"];
                                textNode["s-ol"]["s-nr"] = textNode;
                                $47990066fdbc3144$var$insertBefore(nodeToRelocate.parentNode, textNode, nodeToRelocate, isInitialLoad);
                                nodeToRelocate.parentNode.removeChild(nodeToRelocate);
                            }
                            if (nodeToRelocate.nodeType === 1 /* ElementNode */  && nodeToRelocate.tagName !== "SLOT-FB") nodeToRelocate.hidden = (_d = nodeToRelocate["s-ih"]) != null ? _d : false;
                        }
                    }
                    nodeToRelocate && typeof slotRefNode["s-rf"] === "function" && slotRefNode["s-rf"](slotRefNode);
                } else if (nodeToRelocate.nodeType === 1 /* ElementNode */ ) nodeToRelocate.hidden = true;
            }
        }
        if ($47990066fdbc3144$var$checkSlotFallbackVisibility) $47990066fdbc3144$var$updateFallbackSlotVisibility(rootVnode.$elm$);
        $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ &= -2 /* isTmpDisconnected */ ;
        $47990066fdbc3144$var$relocateNodes.length = 0;
    }
    if ((0, $kxuSp.BUILD).slotRelocation && !$47990066fdbc3144$var$useNativeShadowDom && !(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) && hostElm["s-cr"]) {
        const children = rootVnode.$elm$.__childNodes || rootVnode.$elm$.childNodes;
        for (const childNode of children)if (childNode["s-hn"] !== $47990066fdbc3144$var$hostTagName && !childNode["s-sh"]) {
            if (isInitialLoad && childNode["s-ih"] == null) childNode["s-ih"] = (_e = childNode.hidden) != null ? _e : false;
            if (childNode.nodeType === 1 /* ElementNode */ ) childNode.hidden = true;
            else if (childNode.nodeType === 3 /* TextNode */  && !!childNode.nodeValue.trim()) {
                const textCommentNode = $47990066fdbc3144$export$10a0f131c0eea21b.document.createComment("s-nt-" + childNode.nodeValue);
                textCommentNode["s-sn"] = childNode["s-sn"];
                $47990066fdbc3144$var$insertBefore(childNode.parentNode, textCommentNode, childNode, isInitialLoad);
                childNode.parentNode.removeChild(childNode);
            }
        }
    }
    $47990066fdbc3144$var$contentRef = void 0;
    $47990066fdbc3144$var$flushQueuedRefCallbacks();
};
var $47990066fdbc3144$var$slotReferenceDebugNode = (slotVNode)=>{
    var _a;
    return (_a = $47990066fdbc3144$export$10a0f131c0eea21b.document) == null ? void 0 : _a.createComment(`<slot${slotVNode.$name$ ? ' name="' + slotVNode.$name$ + '"' : ""}> (host=${$47990066fdbc3144$var$hostTagName.toLowerCase()})`);
};
var $47990066fdbc3144$var$originalLocationDebugNode = (nodeToRelocate)=>{
    var _a;
    return (_a = $47990066fdbc3144$export$10a0f131c0eea21b.document) == null ? void 0 : _a.createComment(`org-location for ` + (nodeToRelocate.localName ? `<${nodeToRelocate.localName}> (host=${nodeToRelocate["s-hn"]})` : `[${nodeToRelocate.textContent}]`));
};
// src/runtime/update-component.ts
var $47990066fdbc3144$var$attachToAncestor = (hostRef, ancestorComponent)=>{
    if ((0, $kxuSp.BUILD).asyncLoading && ancestorComponent && !hostRef.$onRenderResolve$ && ancestorComponent["s-p"]) {
        const index = ancestorComponent["s-p"].push(new Promise((r)=>hostRef.$onRenderResolve$ = ()=>{
                ancestorComponent["s-p"].splice(index - 1, 1);
                r();
            }));
    }
};
var $47990066fdbc3144$var$scheduleUpdate = (hostRef, isInitialLoad)=>{
    if ((0, $kxuSp.BUILD).taskQueue && (0, $kxuSp.BUILD).updatable) hostRef.$flags$ |= 16 /* isQueuedForUpdate */ ;
    if ((0, $kxuSp.BUILD).asyncLoading && hostRef.$flags$ & 4 /* isWaitingForChildren */ ) {
        hostRef.$flags$ |= 512 /* needsRerender */ ;
        return;
    }
    $47990066fdbc3144$var$attachToAncestor(hostRef, hostRef.$ancestorComponent$);
    const dispatch = ()=>$47990066fdbc3144$var$dispatchHooks(hostRef, isInitialLoad);
    if (isInitialLoad) {
        queueMicrotask(()=>{
            dispatch();
        });
        return;
    }
    return (0, $kxuSp.BUILD).taskQueue ? $47990066fdbc3144$export$bbfc1321f142f72c(dispatch) : dispatch();
};
var $47990066fdbc3144$var$dispatchHooks = (hostRef, isInitialLoad)=>{
    const elm = hostRef.$hostElement$;
    const endSchedule = $47990066fdbc3144$var$createTime("scheduleUpdate", hostRef.$cmpMeta$.$tagName$);
    const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
    if (!instance) throw new Error(`Can't render component <${elm.tagName.toLowerCase()} /> with invalid Stencil runtime! Make sure this imported component is compiled with a \`externalRuntime: true\` flag. For more information, please refer to https://stenciljs.com/docs/custom-elements#externalruntime`);
    let maybePromise;
    if (isInitialLoad) {
        if ((0, $kxuSp.BUILD).lazyLoad) {
            if ((0, $kxuSp.BUILD).slotRelocation && hostRef.$deferredConnectedCallback$) {
                hostRef.$deferredConnectedCallback$ = false;
                $47990066fdbc3144$var$safeCall(instance, "connectedCallback", void 0, elm);
            }
            if ((0, $kxuSp.BUILD).hostListener) {
                hostRef.$flags$ |= 256 /* isListenReady */ ;
                if (hostRef.$queuedListeners$) {
                    hostRef.$queuedListeners$.map(([methodName, event])=>$47990066fdbc3144$var$safeCall(instance, methodName, event, elm));
                    hostRef.$queuedListeners$ = void 0;
                }
            }
            if (hostRef.$fetchedCbList$.length) hostRef.$fetchedCbList$.forEach((cb)=>cb(elm));
        }
        $47990066fdbc3144$var$emitLifecycleEvent(elm, "componentWillLoad");
        maybePromise = $47990066fdbc3144$var$safeCall(instance, "componentWillLoad", void 0, elm);
    } else {
        $47990066fdbc3144$var$emitLifecycleEvent(elm, "componentWillUpdate");
        maybePromise = $47990066fdbc3144$var$safeCall(instance, "componentWillUpdate", void 0, elm);
    }
    $47990066fdbc3144$var$emitLifecycleEvent(elm, "componentWillRender");
    maybePromise = $47990066fdbc3144$var$enqueue(maybePromise, ()=>$47990066fdbc3144$var$safeCall(instance, "componentWillRender", void 0, elm));
    endSchedule();
    return $47990066fdbc3144$var$enqueue(maybePromise, ()=>$47990066fdbc3144$var$updateComponent(hostRef, instance, isInitialLoad));
};
var $47990066fdbc3144$var$enqueue = (maybePromise, fn)=>$47990066fdbc3144$var$isPromisey(maybePromise) ? maybePromise.then(fn).catch((err)=>{
        console.error(err);
        fn();
    }) : fn();
var $47990066fdbc3144$var$isPromisey = (maybePromise)=>maybePromise instanceof Promise || maybePromise && maybePromise.then && typeof maybePromise.then === "function";
var $47990066fdbc3144$var$updateComponent = async (hostRef, instance, isInitialLoad)=>{
    var _a;
    const elm = hostRef.$hostElement$;
    const endUpdate = $47990066fdbc3144$var$createTime("update", hostRef.$cmpMeta$.$tagName$);
    const rc = elm["s-rc"];
    if ((0, $kxuSp.BUILD).style && isInitialLoad) $47990066fdbc3144$var$attachStyles(hostRef);
    const endRender = $47990066fdbc3144$var$createTime("render", hostRef.$cmpMeta$.$tagName$);
    if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 1024 /* devOnRender */ ;
    if ((0, $kxuSp.BUILD).hydrateServerSide) await $47990066fdbc3144$var$callRender(hostRef, instance, elm, isInitialLoad);
    else $47990066fdbc3144$var$callRender(hostRef, instance, elm, isInitialLoad);
    if ((0, $kxuSp.BUILD).isDev) {
        hostRef.$renderCount$ = hostRef.$renderCount$ === void 0 ? 1 : hostRef.$renderCount$ + 1;
        hostRef.$flags$ &= -1025 /* devOnRender */ ;
    }
    if ((0, $kxuSp.BUILD).hydrateServerSide) try {
        $47990066fdbc3144$var$serverSideConnected(elm);
        if (isInitialLoad) {
            if (hostRef.$cmpMeta$.$flags$ & 1 /* shadowDomEncapsulation */ ) elm["s-en"] = "";
            else if (hostRef.$cmpMeta$.$flags$ & 2 /* scopedCssEncapsulation */ ) elm["s-en"] = "c";
        }
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
    }
    if ((0, $kxuSp.BUILD).asyncLoading && rc) {
        rc.map((cb)=>cb());
        elm["s-rc"] = void 0;
    }
    endRender();
    endUpdate();
    if ((0, $kxuSp.BUILD).asyncLoading) {
        const childrenPromises = (_a = elm["s-p"]) != null ? _a : [];
        const postUpdate = ()=>$47990066fdbc3144$export$a2fffedced549758(hostRef);
        if (childrenPromises.length === 0) postUpdate();
        else {
            Promise.all(childrenPromises).then(postUpdate).catch(postUpdate);
            hostRef.$flags$ |= 4 /* isWaitingForChildren */ ;
            childrenPromises.length = 0;
        }
    } else $47990066fdbc3144$export$a2fffedced549758(hostRef);
};
var $47990066fdbc3144$var$renderingRef = null;
var $47990066fdbc3144$var$callRender = (hostRef, instance, elm, isInitialLoad)=>{
    const allRenderFn = (0, $kxuSp.BUILD).allRenderFn ? true : false;
    const lazyLoad = (0, $kxuSp.BUILD).lazyLoad ? true : false;
    const taskQueue = (0, $kxuSp.BUILD).taskQueue ? true : false;
    const updatable = (0, $kxuSp.BUILD).updatable ? true : false;
    try {
        $47990066fdbc3144$var$renderingRef = instance;
        instance = allRenderFn ? instance.render() : instance.render && instance.render();
        if (updatable && taskQueue) hostRef.$flags$ &= -17 /* isQueuedForUpdate */ ;
        if (updatable || lazyLoad) hostRef.$flags$ |= 2 /* hasRendered */ ;
        if ((0, $kxuSp.BUILD).hasRenderFn || (0, $kxuSp.BUILD).reflect) {
            if ((0, $kxuSp.BUILD).vdomRender || (0, $kxuSp.BUILD).reflect) {
                if ((0, $kxuSp.BUILD).hydrateServerSide) return Promise.resolve(instance).then((value)=>$47990066fdbc3144$export$52f8e388858754a(hostRef, value, isInitialLoad));
                else $47990066fdbc3144$export$52f8e388858754a(hostRef, instance, isInitialLoad);
            } else {
                const shadowRoot = elm.shadowRoot;
                if (hostRef.$cmpMeta$.$flags$ & 1 /* shadowDomEncapsulation */ ) shadowRoot.textContent = instance;
                else elm.textContent = instance;
            }
        }
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e, hostRef.$hostElement$);
    }
    $47990066fdbc3144$var$renderingRef = null;
    return null;
};
var $47990066fdbc3144$export$40c3cc0861cb4611 = ()=>$47990066fdbc3144$var$renderingRef;
var $47990066fdbc3144$export$a2fffedced549758 = (hostRef)=>{
    const tagName = hostRef.$cmpMeta$.$tagName$;
    const elm = hostRef.$hostElement$;
    const endPostUpdate = $47990066fdbc3144$var$createTime("postUpdate", tagName);
    const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
    const ancestorComponent = hostRef.$ancestorComponent$;
    if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 1024 /* devOnRender */ ;
    $47990066fdbc3144$var$safeCall(instance, "componentDidRender", void 0, elm);
    if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ &= -1025 /* devOnRender */ ;
    $47990066fdbc3144$var$emitLifecycleEvent(elm, "componentDidRender");
    if (!(hostRef.$flags$ & 64 /* hasLoadedComponent */ )) {
        hostRef.$flags$ |= 64 /* hasLoadedComponent */ ;
        if ((0, $kxuSp.BUILD).asyncLoading && (0, $kxuSp.BUILD).cssAnnotations) $47990066fdbc3144$var$addHydratedFlag(elm);
        if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 2048 /* devOnDidLoad */ ;
        $47990066fdbc3144$var$safeCall(instance, "componentDidLoad", void 0, elm);
        if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ &= -2049 /* devOnDidLoad */ ;
        $47990066fdbc3144$var$emitLifecycleEvent(elm, "componentDidLoad");
        endPostUpdate();
        if ((0, $kxuSp.BUILD).asyncLoading) {
            hostRef.$onReadyResolve$(elm);
            if (!ancestorComponent) $47990066fdbc3144$var$appDidLoad(tagName);
        }
    } else {
        if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 1024 /* devOnRender */ ;
        $47990066fdbc3144$var$safeCall(instance, "componentDidUpdate", void 0, elm);
        if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ &= -1025 /* devOnRender */ ;
        $47990066fdbc3144$var$emitLifecycleEvent(elm, "componentDidUpdate");
        endPostUpdate();
    }
    if ((0, $kxuSp.BUILD).method && (0, $kxuSp.BUILD).lazyLoad) hostRef.$onInstanceResolve$(elm);
    if ((0, $kxuSp.BUILD).asyncLoading) {
        if (hostRef.$onRenderResolve$) {
            hostRef.$onRenderResolve$();
            hostRef.$onRenderResolve$ = void 0;
        }
        if (hostRef.$flags$ & 512 /* needsRerender */ ) $47990066fdbc3144$export$bdd553fddd433dcb(()=>$47990066fdbc3144$var$scheduleUpdate(hostRef, false));
        hostRef.$flags$ &= -517;
    }
};
var $47990066fdbc3144$export$98c7f8edae68c30f = (ref)=>{
    var _a;
    if ((0, $kxuSp.BUILD).updatable && ($47990066fdbc3144$export$77b5f1d340d6466b.isBrowser || $47990066fdbc3144$export$77b5f1d340d6466b.isTesting)) {
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(ref);
        const isConnected = (_a = hostRef == null ? void 0 : hostRef.$hostElement$) == null ? void 0 : _a.isConnected;
        if (isConnected && (hostRef.$flags$ & 18 /* isQueuedForUpdate */ ) === 2 /* hasRendered */ ) $47990066fdbc3144$var$scheduleUpdate(hostRef, false);
        return isConnected;
    }
    return false;
};
var $47990066fdbc3144$var$appDidLoad = (who)=>{
    var _a;
    if ((0, $kxuSp.BUILD).asyncQueue) $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 2 /* appLoaded */ ;
    $47990066fdbc3144$export$bdd553fddd433dcb(()=>$47990066fdbc3144$var$emitEvent($47990066fdbc3144$export$10a0f131c0eea21b, "appload", {
            detail: {
                namespace: (0, $kxuSp.NAMESPACE)
            }
        }));
    if ((0, $kxuSp.BUILD).hydrateClientSide) {
        if ((_a = $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$) == null ? void 0 : _a.size) $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.clear();
    }
    if ((0, $kxuSp.BUILD).profile && performance.measure) performance.measure(`[Stencil] ${(0, $kxuSp.NAMESPACE)} initial load (by ${who})`, "st:app:start");
};
var $47990066fdbc3144$var$safeCall = (instance, method, arg, elm)=>{
    if (instance && instance[method]) try {
        return instance[method](arg);
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
    }
    return void 0;
};
var $47990066fdbc3144$var$emitLifecycleEvent = (elm, lifecycleName)=>{
    if ((0, $kxuSp.BUILD).lifecycleDOMEvents) $47990066fdbc3144$var$emitEvent(elm, "stencil_" + lifecycleName, {
        bubbles: true,
        composed: true,
        detail: {
            namespace: (0, $kxuSp.NAMESPACE)
        }
    });
};
var $47990066fdbc3144$var$addHydratedFlag = (elm)=>{
    var _a, _b;
    return (0, $kxuSp.BUILD).hydratedClass ? elm.classList.add((_a = (0, $kxuSp.BUILD).hydratedSelectorName) != null ? _a : "hydrated") : (0, $kxuSp.BUILD).hydratedAttribute ? elm.setAttribute((_b = (0, $kxuSp.BUILD).hydratedSelectorName) != null ? _b : "hydrated", "") : void 0;
};
var $47990066fdbc3144$var$serverSideConnected = (elm)=>{
    const children = elm.children;
    if (children != null) for(let i2 = 0, ii = children.length; i2 < ii; i2++){
        const childElm = children[i2];
        if (typeof childElm.connectedCallback === "function") childElm.connectedCallback();
        $47990066fdbc3144$var$serverSideConnected(childElm);
    }
};
// src/runtime/set-value.ts
var $47990066fdbc3144$export$bf7199a9ebcb84a9 = (ref, propName)=>$47990066fdbc3144$export$3f84770eccf215d2(ref).$instanceValues$.get(propName);
var $47990066fdbc3144$export$80746c6bc6142fc8 = (ref, propName, newVal, cmpMeta)=>{
    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(ref);
    if (!hostRef) return;
    if ((0, $kxuSp.BUILD).lazyLoad && !hostRef) throw new Error(`Couldn't find host element for "${cmpMeta.$tagName$}" as it is unknown to this Stencil runtime. This usually happens when integrating a 3rd party Stencil component with another Stencil component or application. Please reach out to the maintainers of the 3rd party Stencil component or report this on the Stencil Discord server (https://chat.stenciljs.com) or comment on this similar [GitHub issue](https://github.com/stenciljs/core/issues/5457).`);
    if ((0, $kxuSp.BUILD).serializer && hostRef.$serializerValues$.has(propName) && hostRef.$serializerValues$.get(propName) === newVal) return;
    const elm = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$hostElement$ : ref;
    const oldVal = hostRef.$instanceValues$.get(propName);
    const flags = hostRef.$flags$;
    const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
    newVal = $47990066fdbc3144$export$480b8c8d1e35b434(newVal, cmpMeta.$members$[propName][0], (0, $kxuSp.BUILD).formAssociated && !!(cmpMeta.$flags$ & 64 /* formAssociated */ ));
    const areBothNaN = Number.isNaN(oldVal) && Number.isNaN(newVal);
    const didValueChange = newVal !== oldVal && !areBothNaN;
    if ((!(0, $kxuSp.BUILD).lazyLoad || !(flags & 8 /* isConstructingInstance */ ) || oldVal === void 0) && didValueChange) {
        hostRef.$instanceValues$.set(propName, newVal);
        if ((0, $kxuSp.BUILD).serializer && (0, $kxuSp.BUILD).reflect && cmpMeta.$attrsToReflect$) {
            if (cmpMeta.$serializers$ && cmpMeta.$serializers$[propName]) {
                const runSerializer = (inst)=>{
                    let attrVal = newVal;
                    for (const serializer of cmpMeta.$serializers$[propName]){
                        const [[methodName]] = Object.entries(serializer);
                        attrVal = inst[methodName](attrVal, propName);
                    }
                    hostRef.$serializerValues$.set(propName, attrVal);
                };
                if (instance) runSerializer(instance);
                else hostRef.$fetchedCbList$.push(()=>{
                    runSerializer(hostRef.$lazyInstance$);
                });
            }
        }
        if ((0, $kxuSp.BUILD).isDev) {
            if (hostRef.$flags$ & 1024 /* devOnRender */ ) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The state/prop "${propName}" changed during rendering. This can potentially lead to infinite-loops and other bugs.`, "\nElement", elm, "\nNew value", newVal, "\nOld value", oldVal);
            else if (hostRef.$flags$ & 2048 /* devOnDidLoad */ ) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The state/prop "${propName}" changed during "componentDidLoad()", this triggers extra re-renders, try to setup on "componentWillLoad()"`, "\nElement", elm, "\nNew value", newVal, "\nOld value", oldVal);
        }
        if ((0, $kxuSp.BUILD).propChangeCallback && cmpMeta.$watchers$) {
            const watchMethods = cmpMeta.$watchers$[propName];
            if (watchMethods) watchMethods.map((watcher)=>{
                try {
                    const [[watchMethodName, watcherFlags]] = Object.entries(watcher);
                    if (flags & 128 /* isWatchReady */  || watcherFlags & 1 /* Immediate */ ) {
                        if (!instance) hostRef.$fetchedCbList$.push(()=>{
                            hostRef.$lazyInstance$[watchMethodName](newVal, oldVal, propName);
                        });
                        else instance[watchMethodName](newVal, oldVal, propName);
                    }
                } catch (e) {
                    $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
                }
            });
        }
        if ((0, $kxuSp.BUILD).updatable && flags & 2 /* hasRendered */ ) {
            if (instance.componentShouldUpdate) {
                const shouldUpdate = instance.componentShouldUpdate(newVal, oldVal, propName);
                if (shouldUpdate === false && !(flags & 16 /* isQueuedForUpdate */ )) return;
            }
            if (!(flags & 16 /* isQueuedForUpdate */ )) $47990066fdbc3144$var$scheduleUpdate(hostRef, false);
        }
    }
};
// src/runtime/proxy-component.ts
var $47990066fdbc3144$export$982064ca8d9ad69 = (Cstr, cmpMeta, flags)=>{
    var _a, _b;
    const prototype = Cstr.prototype;
    if ((0, $kxuSp.BUILD).isTesting) {
        if (prototype.__stencilAugmented) return;
        prototype.__stencilAugmented = true;
    }
    if ((0, $kxuSp.BUILD).formAssociated && cmpMeta.$flags$ & 64 /* formAssociated */  && flags & 1 /* isElementConstructor */ ) $47990066fdbc3144$var$FORM_ASSOCIATED_CUSTOM_ELEMENT_CALLBACKS.forEach((cbName)=>{
        const originalFormAssociatedCallback = prototype[cbName];
        Object.defineProperty(prototype, cbName, {
            value (...args) {
                var _a2;
                const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(this);
                const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef == null ? void 0 : hostRef.$lazyInstance$ : this;
                if (!instance) (_a2 = hostRef == null ? void 0 : hostRef.$onReadyPromise$) == null || _a2.then((asyncInstance)=>{
                    const cb = asyncInstance[cbName];
                    typeof cb === "function" && cb.call(asyncInstance, ...args);
                });
                else {
                    const cb = (0, $kxuSp.BUILD).lazyLoad ? instance[cbName] : originalFormAssociatedCallback;
                    typeof cb === "function" && cb.call(instance, ...args);
                }
            }
        });
    });
    if ((0, $kxuSp.BUILD).member && cmpMeta.$members$ || (0, $kxuSp.BUILD).propChangeCallback) {
        if ((0, $kxuSp.BUILD).propChangeCallback) {
            if (Cstr.watchers && !cmpMeta.$watchers$) cmpMeta.$watchers$ = $47990066fdbc3144$export$9bd12ad9059cd2fb(Cstr.watchers);
            if (Cstr.deserializers && !cmpMeta.$deserializers$) cmpMeta.$deserializers$ = Cstr.deserializers;
            if (Cstr.serializers && !cmpMeta.$serializers$) cmpMeta.$serializers$ = Cstr.serializers;
        }
        const members = Object.entries((_a = cmpMeta.$members$) != null ? _a : {});
        members.map(([memberName, [memberFlags]])=>{
            if (((0, $kxuSp.BUILD).prop || (0, $kxuSp.BUILD).state) && (memberFlags & 31 /* Prop */  || (!(0, $kxuSp.BUILD).lazyLoad || flags & 2 /* proxyState */ ) && memberFlags & 32 /* State */ )) {
                const { get: origGetter, set: origSetter } = $47990066fdbc3144$var$getPropertyDescriptor(prototype, memberName) || {};
                if (origGetter) cmpMeta.$members$[memberName][0] |= 2048 /* Getter */ ;
                if (origSetter) cmpMeta.$members$[memberName][0] |= 4096 /* Setter */ ;
                if (flags & 1 /* isElementConstructor */  || !origGetter) Object.defineProperty(prototype, memberName, {
                    get () {
                        if ((0, $kxuSp.BUILD).lazyLoad) {
                            if ((cmpMeta.$members$[memberName][0] & 2048 /* Getter */ ) === 0) return $47990066fdbc3144$export$bf7199a9ebcb84a9(this, memberName);
                            const ref = $47990066fdbc3144$export$3f84770eccf215d2(this);
                            const instance = ref ? ref.$lazyInstance$ : prototype;
                            if (!instance) return;
                            return instance[memberName];
                        }
                        if (!(0, $kxuSp.BUILD).lazyLoad) return origGetter ? origGetter.apply(this) : $47990066fdbc3144$export$bf7199a9ebcb84a9(this, memberName);
                    },
                    configurable: true,
                    enumerable: true
                });
                Object.defineProperty(prototype, memberName, {
                    set (newValue) {
                        const ref = $47990066fdbc3144$export$3f84770eccf215d2(this);
                        if (!ref) return;
                        if ((0, $kxuSp.BUILD).isDev) {
                            if (// we are proxying the instance (not element)
                            (flags & 1 /* isElementConstructor */ ) === 0 && // if the class has a setter, then the Element can update instance values, so ignore
                            (cmpMeta.$members$[memberName][0] & 4096 /* Setter */ ) === 0 && // the element is not constructing
                            (ref && ref.$flags$ & 8 /* isConstructingInstance */ ) === 0 && // the member is a prop
                            (memberFlags & 31 /* Prop */ ) !== 0 && // the member is not mutable
                            (memberFlags & 1024 /* Mutable */ ) === 0) $47990066fdbc3144$export$5d385f3b3df7e1b9(`@Prop() "${memberName}" on <${cmpMeta.$tagName$}> is immutable but was modified from within the component.
More information: https://stenciljs.com/docs/properties#prop-mutability`);
                        }
                        if (origSetter) {
                            const currentValue = memberFlags & 32 /* State */  ? this[memberName] : ref.$hostElement$[memberName];
                            if (typeof currentValue === "undefined" && ref.$instanceValues$.get(memberName)) newValue = ref.$instanceValues$.get(memberName);
                            origSetter.apply(this, [
                                $47990066fdbc3144$export$480b8c8d1e35b434(newValue, memberFlags, (0, $kxuSp.BUILD).formAssociated && !!(cmpMeta.$flags$ & 64 /* formAssociated */ ))
                            ]);
                            newValue = memberFlags & 32 /* State */  ? this[memberName] : ref.$hostElement$[memberName];
                            $47990066fdbc3144$export$80746c6bc6142fc8(this, memberName, newValue, cmpMeta);
                            return;
                        }
                        if (!(0, $kxuSp.BUILD).lazyLoad) {
                            $47990066fdbc3144$export$80746c6bc6142fc8(this, memberName, newValue, cmpMeta);
                            return;
                        }
                        if ((0, $kxuSp.BUILD).lazyLoad) {
                            if ((flags & 1 /* isElementConstructor */ ) === 0 || (cmpMeta.$members$[memberName][0] & 4096 /* Setter */ ) === 0) {
                                $47990066fdbc3144$export$80746c6bc6142fc8(this, memberName, newValue, cmpMeta);
                                if (flags & 1 /* isElementConstructor */  && !ref.$lazyInstance$) ref.$fetchedCbList$.push(()=>{
                                    if (cmpMeta.$members$[memberName][0] & 4096 /* Setter */  && ref.$lazyInstance$[memberName] !== ref.$instanceValues$.get(memberName)) ref.$lazyInstance$[memberName] = newValue;
                                });
                                return;
                            }
                            const setterSetVal = ()=>{
                                const currentValue = ref.$lazyInstance$[memberName];
                                if (!ref.$instanceValues$.get(memberName) && currentValue) ref.$instanceValues$.set(memberName, currentValue);
                                ref.$lazyInstance$[memberName] = $47990066fdbc3144$export$480b8c8d1e35b434(newValue, memberFlags, (0, $kxuSp.BUILD).formAssociated && !!(cmpMeta.$flags$ & 64 /* formAssociated */ ));
                                $47990066fdbc3144$export$80746c6bc6142fc8(this, memberName, ref.$lazyInstance$[memberName], cmpMeta);
                            };
                            if (ref.$lazyInstance$) setterSetVal();
                            else ref.$fetchedCbList$.push(()=>{
                                setterSetVal();
                            });
                        }
                    }
                });
            } else if ((0, $kxuSp.BUILD).lazyLoad && (0, $kxuSp.BUILD).method && flags & 1 /* isElementConstructor */  && memberFlags & 64 /* Method */ ) Object.defineProperty(prototype, memberName, {
                value (...args) {
                    var _a2;
                    const ref = $47990066fdbc3144$export$3f84770eccf215d2(this);
                    return (_a2 = ref == null ? void 0 : ref.$onInstancePromise$) == null ? void 0 : _a2.then(()=>{
                        var _a3;
                        return (_a3 = ref.$lazyInstance$) == null ? void 0 : _a3[memberName](...args);
                    });
                }
            });
        });
        if ((0, $kxuSp.BUILD).observeAttribute && (!(0, $kxuSp.BUILD).lazyLoad || flags & 1 /* isElementConstructor */ )) {
            const attrNameToPropName = /* @__PURE__ */ new Map();
            prototype.attributeChangedCallback = function(attrName, oldValue, newValue) {
                $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>{
                    var _a2;
                    const propName = attrNameToPropName.get(attrName);
                    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(this);
                    if ((0, $kxuSp.BUILD).serializer && hostRef.$serializerValues$.has(propName) && hostRef.$serializerValues$.get(propName) === newValue) return;
                    if (this.hasOwnProperty(propName) && (0, $kxuSp.BUILD).lazyLoad) {
                        newValue = this[propName];
                        delete this[propName];
                    }
                    if ((0, $kxuSp.BUILD).deserializer && cmpMeta.$deserializers$ && cmpMeta.$deserializers$[propName]) {
                        const setVal = (methodName, instance)=>{
                            const deserializeVal = instance == null ? void 0 : instance[methodName](newValue, propName);
                            if (deserializeVal !== this[propName]) this[propName] = deserializeVal;
                        };
                        for (const deserializer of cmpMeta.$deserializers$[propName]){
                            const [[methodName]] = Object.entries(deserializer);
                            if ((0, $kxuSp.BUILD).lazyLoad) {
                                if (hostRef.$lazyInstance$) setVal(methodName, hostRef.$lazyInstance$);
                                else hostRef.$fetchedCbList$.push(()=>{
                                    setVal(methodName, hostRef.$lazyInstance$);
                                });
                            } else setVal(methodName, this);
                        }
                        return;
                    } else if (prototype.hasOwnProperty(propName) && typeof this[propName] === "number" && // cast type to number to avoid TS compiler issues
                    this[propName] == newValue) return;
                    else if (propName == null) {
                        const flags2 = hostRef == null ? void 0 : hostRef.$flags$;
                        if (hostRef && flags2 && !(flags2 & 8 /* isConstructingInstance */ ) && newValue !== oldValue) {
                            const elm = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$hostElement$ : this;
                            const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
                            const entry = (_a2 = cmpMeta.$watchers$) == null ? void 0 : _a2[attrName];
                            entry == null || entry.forEach((watcher)=>{
                                const [[watchMethodName, watcherFlags]] = Object.entries(watcher);
                                if (instance[watchMethodName] != null && (flags2 & 128 /* isWatchReady */  || watcherFlags & 1 /* Immediate */ )) instance[watchMethodName].call(instance, newValue, oldValue, attrName);
                            });
                        }
                        return;
                    }
                    const propFlags = members.find(([m])=>m === propName);
                    const isBooleanTarget = propFlags && propFlags[1][0] & 4 /* Boolean */ ;
                    const isSpuriousBooleanRemoval = isBooleanTarget && newValue === null && this[propName] === void 0;
                    if (isBooleanTarget) newValue = newValue === null || newValue === "false" ? false : true;
                    const propDesc = Object.getOwnPropertyDescriptor(prototype, propName);
                    if (!isSpuriousBooleanRemoval && newValue != this[propName] && (!propDesc.get || !!propDesc.set)) this[propName] = newValue;
                });
            };
            Cstr.observedAttributes = Array.from(/* @__PURE__ */ new Set([
                ...Object.keys((_b = cmpMeta.$watchers$) != null ? _b : {}),
                ...members.filter(([_, m])=>m[0] & 31 /* HasAttribute */ ).map(([propName, m])=>{
                    var _a2;
                    const attrName = m[1] || propName;
                    attrNameToPropName.set(attrName, propName);
                    if ((0, $kxuSp.BUILD).reflect && m[0] & 512 /* ReflectAttr */ ) (_a2 = cmpMeta.$attrsToReflect$) == null || _a2.push([
                        propName,
                        attrName
                    ]);
                    return attrName;
                })
            ]));
        }
    }
    return Cstr;
};
// src/runtime/initialize-component.ts
var $47990066fdbc3144$var$initializeComponent = async (elm, hostRef, cmpMeta, hmrVersionId)=>{
    let Cstr;
    try {
        if ((hostRef.$flags$ & 32 /* hasInitializedComponent */ ) === 0) {
            hostRef.$flags$ |= 32 /* hasInitializedComponent */ ;
            const bundleId = cmpMeta.$lazyBundleId$;
            if ((0, $kxuSp.BUILD).lazyLoad && bundleId) {
                const CstrImport = $47990066fdbc3144$export$ebb47fdc8f2dbc6f(cmpMeta, hostRef, hmrVersionId);
                if (CstrImport && "then" in CstrImport) {
                    const endLoad = $47990066fdbc3144$var$uniqueTime(`st:load:${cmpMeta.$tagName$}:${hostRef.$modeName$}`, `[Stencil] Load module for <${cmpMeta.$tagName$}>`);
                    Cstr = await CstrImport;
                    endLoad();
                } else Cstr = CstrImport;
                if (!Cstr) throw new Error(`Constructor for "${cmpMeta.$tagName$}#${hostRef.$modeName$}" was not found`);
                if ((0, $kxuSp.BUILD).member && !Cstr.isProxied) {
                    if ((0, $kxuSp.BUILD).propChangeCallback) {
                        cmpMeta.$watchers$ = $47990066fdbc3144$export$9bd12ad9059cd2fb(Cstr.watchers);
                        cmpMeta.$serializers$ = Cstr.serializers;
                        cmpMeta.$deserializers$ = Cstr.deserializers;
                    }
                    $47990066fdbc3144$export$982064ca8d9ad69(Cstr, cmpMeta, 2 /* proxyState */ );
                    Cstr.isProxied = true;
                }
                const endNewInstance = $47990066fdbc3144$var$createTime("createInstance", cmpMeta.$tagName$);
                if ((0, $kxuSp.BUILD).member) hostRef.$flags$ |= 8 /* isConstructingInstance */ ;
                try {
                    new Cstr(hostRef);
                } catch (e) {
                    $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
                }
                if ((0, $kxuSp.BUILD).member) hostRef.$flags$ &= -9 /* isConstructingInstance */ ;
                if ((0, $kxuSp.BUILD).propChangeCallback) hostRef.$flags$ |= 128 /* isWatchReady */ ;
                endNewInstance();
                const needsDeferredCallback = (0, $kxuSp.BUILD).slotRelocation && cmpMeta.$flags$ & 4 /* hasSlotRelocation */ ;
                if (!needsDeferredCallback) $47990066fdbc3144$var$fireConnectedCallback(hostRef.$lazyInstance$, elm);
                else hostRef.$deferredConnectedCallback$ = true;
            } else {
                Cstr = elm.constructor;
                const cmpTag = elm.localName;
                customElements.whenDefined(cmpTag).then(()=>hostRef.$flags$ |= 128 /* isWatchReady */ );
            }
            if ((0, $kxuSp.BUILD).style && Cstr && Cstr.style) {
                let style;
                if (typeof Cstr.style === "string") style = Cstr.style;
                else if ((0, $kxuSp.BUILD).mode && typeof Cstr.style !== "string") {
                    hostRef.$modeName$ = $47990066fdbc3144$var$computeMode(elm);
                    if (hostRef.$modeName$) style = Cstr.style[hostRef.$modeName$];
                    if ((0, $kxuSp.BUILD).hydrateServerSide && hostRef.$modeName$) elm.setAttribute("s-mode", hostRef.$modeName$);
                }
                const scopeId2 = $47990066fdbc3144$var$getScopeId(cmpMeta, hostRef.$modeName$);
                if (!$47990066fdbc3144$export$9dd6ff9ea0189349.has(scopeId2) || (0, $kxuSp.BUILD).hotModuleReplacement && hmrVersionId) {
                    const endRegisterStyles = $47990066fdbc3144$var$createTime("registerStyles", cmpMeta.$tagName$);
                    if ((0, $kxuSp.BUILD).hydrateServerSide && (0, $kxuSp.BUILD).shadowDom) {
                        if (cmpMeta.$flags$ & 128 /* shadowNeedsScopedCss */ ) style = $47990066fdbc3144$var$scopeCss(style, scopeId2, true);
                        else if ($47990066fdbc3144$export$8145590be035627c()) style = $47990066fdbc3144$var$expandPartSelectors(style);
                    }
                    $47990066fdbc3144$var$registerStyle(scopeId2, style, !!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ));
                    endRegisterStyles();
                }
            }
        }
        const ancestorComponent = hostRef.$ancestorComponent$;
        const schedule = ()=>$47990066fdbc3144$var$scheduleUpdate(hostRef, true);
        if ((0, $kxuSp.BUILD).asyncLoading && ancestorComponent && ancestorComponent["s-rc"]) ancestorComponent["s-rc"].push(schedule);
        else schedule();
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
        if ((0, $kxuSp.BUILD).asyncLoading && hostRef.$onRenderResolve$) {
            hostRef.$onRenderResolve$();
            hostRef.$onRenderResolve$ = void 0;
        }
        if ((0, $kxuSp.BUILD).asyncLoading && hostRef.$onReadyResolve$) hostRef.$onReadyResolve$(elm);
    }
};
var $47990066fdbc3144$var$fireConnectedCallback = (instance, elm)=>{
    if ((0, $kxuSp.BUILD).lazyLoad) $47990066fdbc3144$var$safeCall(instance, "connectedCallback", void 0, elm);
};
// src/runtime/connected-callback.ts
var $47990066fdbc3144$export$de367db4d6dadc9f = (elm)=>{
    if (($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 1 /* isTmpDisconnected */ ) === 0) {
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
        if (!hostRef) return;
        const cmpMeta = hostRef.$cmpMeta$;
        const endConnected = $47990066fdbc3144$var$createTime("connectedCallback", cmpMeta.$tagName$);
        if ((0, $kxuSp.BUILD).hostListenerTargetParent) $47990066fdbc3144$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, true);
        if (!(hostRef.$flags$ & 1 /* hasConnected */ )) {
            hostRef.$flags$ |= 1 /* hasConnected */ ;
            let hostId;
            if ((0, $kxuSp.BUILD).hydrateClientSide) {
                hostId = elm.getAttribute($47990066fdbc3144$var$HYDRATE_ID);
                if (hostId) {
                    if ((0, $kxuSp.BUILD).shadowDom && $47990066fdbc3144$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) {
                        const scopeId2 = (0, $kxuSp.BUILD).mode ? $47990066fdbc3144$var$addStyle(elm.shadowRoot, cmpMeta, elm.getAttribute("s-mode")) : $47990066fdbc3144$var$addStyle(elm.shadowRoot, cmpMeta);
                        elm.classList.remove(scopeId2 + "-h", scopeId2 + "-s");
                    } else if ((0, $kxuSp.BUILD).scoped && cmpMeta.$flags$ & 2 /* scopedCssEncapsulation */ ) {
                        const scopeId2 = $47990066fdbc3144$var$getScopeId(cmpMeta, (0, $kxuSp.BUILD).mode ? elm.getAttribute("s-mode") : void 0);
                        elm["s-sc"] = scopeId2;
                    }
                    $47990066fdbc3144$var$initializeClientHydrate(elm, cmpMeta.$tagName$, hostId, hostRef);
                }
            }
            if ((0, $kxuSp.BUILD).slotRelocation && !hostId) {
                if ((0, $kxuSp.BUILD).hydrateServerSide || ((0, $kxuSp.BUILD).slot || (0, $kxuSp.BUILD).shadowDom) && // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
                cmpMeta.$flags$ & 12 /* needsShadowDomShim */ ) $47990066fdbc3144$var$setContentReference(elm);
            }
            if ((0, $kxuSp.BUILD).asyncLoading) {
                let ancestorComponent = elm;
                while(ancestorComponent = ancestorComponent.parentNode || ancestorComponent.host)if ((0, $kxuSp.BUILD).hydrateClientSide && ancestorComponent.nodeType === 1 /* ElementNode */  && ancestorComponent.hasAttribute("s-id") && ancestorComponent["s-p"] || ancestorComponent["s-p"]) {
                    $47990066fdbc3144$var$attachToAncestor(hostRef, hostRef.$ancestorComponent$ = ancestorComponent);
                    break;
                }
            }
            if ((0, $kxuSp.BUILD).prop && !(0, $kxuSp.BUILD).hydrateServerSide && cmpMeta.$members$) Object.entries(cmpMeta.$members$).map(([memberName, [memberFlags]])=>{
                if (memberFlags & 31 /* Prop */  && Object.prototype.hasOwnProperty.call(elm, memberName)) {
                    const value = elm[memberName];
                    delete elm[memberName];
                    elm[memberName] = value;
                }
            });
            if ((0, $kxuSp.BUILD).initializeNextTick) $47990066fdbc3144$export$bdd553fddd433dcb(()=>$47990066fdbc3144$var$initializeComponent(elm, hostRef, cmpMeta));
            else $47990066fdbc3144$var$initializeComponent(elm, hostRef, cmpMeta);
        } else {
            $47990066fdbc3144$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, false);
            if (hostRef == null ? void 0 : hostRef.$lazyInstance$) $47990066fdbc3144$var$fireConnectedCallback(hostRef.$lazyInstance$, elm);
            else if (hostRef == null ? void 0 : hostRef.$onReadyPromise$) hostRef.$onReadyPromise$.then(()=>$47990066fdbc3144$var$fireConnectedCallback(hostRef.$lazyInstance$, elm));
        }
        endConnected();
    }
};
var $47990066fdbc3144$var$setContentReference = (elm)=>{
    if (!$47990066fdbc3144$export$10a0f131c0eea21b.document) return;
    const contentRefElm = elm["s-cr"] = $47990066fdbc3144$export$10a0f131c0eea21b.document.createComment((0, $kxuSp.BUILD).isDebug ? `content-ref (host=${elm.localName})` : "");
    contentRefElm["s-cn"] = true;
    $47990066fdbc3144$var$insertBefore(elm, contentRefElm, elm.firstChild);
};
var $47990066fdbc3144$var$disconnectInstance = (instance, elm)=>{
    if ((0, $kxuSp.BUILD).lazyLoad) $47990066fdbc3144$var$safeCall(instance, "disconnectedCallback", void 0, elm || instance);
};
var $47990066fdbc3144$export$6cf1a3dd300e0a4f = async (elm)=>{
    if (($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 1 /* isTmpDisconnected */ ) === 0) {
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
        if ((0, $kxuSp.BUILD).hostListener) {
            if (hostRef == null ? void 0 : hostRef.$rmListeners$) {
                hostRef.$rmListeners$.map((rmListener)=>rmListener());
                hostRef.$rmListeners$ = void 0;
            }
        }
        if (!(0, $kxuSp.BUILD).lazyLoad) $47990066fdbc3144$var$disconnectInstance(elm);
        else if (hostRef == null ? void 0 : hostRef.$lazyInstance$) $47990066fdbc3144$var$disconnectInstance(hostRef.$lazyInstance$, elm);
        else if (hostRef == null ? void 0 : hostRef.$onReadyPromise$) hostRef.$onReadyPromise$.then(()=>$47990066fdbc3144$var$disconnectInstance(hostRef.$lazyInstance$, elm));
    }
    if ($47990066fdbc3144$var$rootAppliedStyles.has(elm)) $47990066fdbc3144$var$rootAppliedStyles.delete(elm);
    if (elm.shadowRoot && $47990066fdbc3144$var$rootAppliedStyles.has(elm.shadowRoot)) $47990066fdbc3144$var$rootAppliedStyles.delete(elm.shadowRoot);
};
// src/runtime/bootstrap-custom-element.ts
var $47990066fdbc3144$export$a00e2346eabbdbef = (Cstr, compactMeta)=>{
    customElements.define($47990066fdbc3144$export$e6778302ec5425de(compactMeta[1]), $47990066fdbc3144$export$370caf1876b7c579(Cstr, compactMeta));
};
var $47990066fdbc3144$export$370caf1876b7c579 = (Cstr, compactMeta)=>{
    const cmpMeta = {
        $flags$: compactMeta[0],
        $tagName$: compactMeta[1]
    };
    try {
        if ((0, $kxuSp.BUILD).member) cmpMeta.$members$ = compactMeta[2];
        if ((0, $kxuSp.BUILD).hostListener) cmpMeta.$listeners$ = compactMeta[3];
        if ((0, $kxuSp.BUILD).propChangeCallback) {
            cmpMeta.$watchers$ = $47990066fdbc3144$export$9bd12ad9059cd2fb(Cstr.$watchers$);
            cmpMeta.$deserializers$ = Cstr.$deserializers$;
            cmpMeta.$serializers$ = Cstr.$serializers$;
        }
        if ((0, $kxuSp.BUILD).reflect) cmpMeta.$attrsToReflect$ = [];
        if ((0, $kxuSp.BUILD).shadowDom && !$47990066fdbc3144$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) cmpMeta.$flags$ |= 8 /* needsShadowDomShim */ ;
        if (!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) && cmpMeta.$flags$ & 256 /* hasSlot */ ) {
            if ((0, $kxuSp.BUILD).experimentalSlotFixes) $47990066fdbc3144$var$patchPseudoShadowDom(Cstr.prototype);
            else {
                if ((0, $kxuSp.BUILD).slotChildNodesFix) $47990066fdbc3144$var$patchChildSlotNodes(Cstr.prototype);
                if ((0, $kxuSp.BUILD).cloneNodeFix) $47990066fdbc3144$var$patchCloneNode(Cstr.prototype);
                if ((0, $kxuSp.BUILD).appendChildSlotFix) $47990066fdbc3144$var$patchSlotAppendChild(Cstr.prototype);
                if ((0, $kxuSp.BUILD).scopedSlotTextContentFix && cmpMeta.$flags$ & 2 /* scopedCssEncapsulation */ ) $47990066fdbc3144$var$patchTextContent(Cstr.prototype);
            }
        } else if ((0, $kxuSp.BUILD).cloneNodeFix) $47990066fdbc3144$var$patchCloneNode(Cstr.prototype);
        if ((0, $kxuSp.BUILD).hydrateClientSide && (0, $kxuSp.BUILD).shadowDom) $47990066fdbc3144$var$hydrateScopedToShadow();
        const originalConnectedCallback = Cstr.prototype.connectedCallback;
        const originalDisconnectedCallback = Cstr.prototype.disconnectedCallback;
        Object.assign(Cstr.prototype, {
            __hasHostListenerAttached: false,
            __registerHost () {
                $47990066fdbc3144$export$c20b986001efcf6c(this, cmpMeta);
            },
            connectedCallback () {
                if (!this.__hasHostListenerAttached) {
                    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(this);
                    if (!hostRef) return;
                    $47990066fdbc3144$export$62df7fa1a32c483(this, hostRef, cmpMeta.$listeners$, false);
                    this.__hasHostListenerAttached = true;
                }
                $47990066fdbc3144$export$de367db4d6dadc9f(this);
                if (originalConnectedCallback) originalConnectedCallback.call(this);
            },
            disconnectedCallback () {
                $47990066fdbc3144$export$6cf1a3dd300e0a4f(this);
                if (originalDisconnectedCallback) originalDisconnectedCallback.call(this);
            },
            __attachShadow () {
                if ($47990066fdbc3144$export$b4e7e6d61dbcd813) {
                    if (!this.shadowRoot) $47990066fdbc3144$var$createShadowRoot.call(this, cmpMeta);
                    else {
                        if (this.shadowRoot.mode !== "open") throw new Error(`Unable to re-use existing shadow root for ${cmpMeta.$tagName$}! Mode is set to ${this.shadowRoot.mode} but Stencil only supports open shadow roots.`);
                    }
                } else this.shadowRoot = this;
            }
        });
        Object.defineProperty(Cstr, "is", {
            value: cmpMeta.$tagName$,
            configurable: true
        });
        return $47990066fdbc3144$export$982064ca8d9ad69(Cstr, cmpMeta, 3 /* proxyState */ );
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e);
        return Cstr;
    }
};
var $47990066fdbc3144$export$d156c3c6ac0fffa3 = (elm)=>{
    if ((0, $kxuSp.BUILD).style && (0, $kxuSp.BUILD).mode && !(0, $kxuSp.BUILD).lazyLoad) {
        const mode = $47990066fdbc3144$var$computeMode(elm);
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
        if (hostRef && hostRef.$modeName$ !== mode) {
            const cmpMeta = hostRef.$cmpMeta$;
            const oldScopeId = elm["s-sc"];
            const scopeId2 = $47990066fdbc3144$var$getScopeId(cmpMeta, mode);
            const style = elm.constructor.style[mode];
            const flags = cmpMeta.$flags$;
            if (style) {
                if (!$47990066fdbc3144$export$9dd6ff9ea0189349.has(scopeId2)) $47990066fdbc3144$var$registerStyle(scopeId2, style, !!(flags & 1 /* shadowDomEncapsulation */ ));
                hostRef.$modeName$ = mode;
                elm.classList.remove(oldScopeId + "-h", oldScopeId + "-s");
                $47990066fdbc3144$var$attachStyles(hostRef);
                $47990066fdbc3144$export$98c7f8edae68c30f(elm);
            }
        }
    }
};
// src/runtime/hmr-component.ts
var $47990066fdbc3144$var$hmrStart = (hostElement, cmpMeta, hmrVersionId)=>{
    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(hostElement);
    if (!hostRef) return;
    hostRef.$flags$ = 1 /* hasConnected */ ;
    $47990066fdbc3144$var$initializeComponent(hostElement, hostRef, cmpMeta, hmrVersionId);
};
// src/runtime/bootstrap-lazy.ts
var $47990066fdbc3144$export$12ca34fb6e539801 = (lazyBundles, options = {})=>{
    var _a;
    if ((0, $kxuSp.BUILD).profile && performance.mark) performance.mark("st:app:start");
    $47990066fdbc3144$var$installDevTools();
    if (!$47990066fdbc3144$export$10a0f131c0eea21b.document) {
        console.warn("Stencil: No document found. Skipping bootstrapping lazy components.");
        return;
    }
    const endBootstrap = $47990066fdbc3144$var$createTime("bootstrapLazy");
    const cmpTags = [];
    const exclude = options.exclude || [];
    const customElements2 = $47990066fdbc3144$export$10a0f131c0eea21b.customElements;
    const head = $47990066fdbc3144$export$10a0f131c0eea21b.document.head;
    const metaCharset = /* @__PURE__ */ head.querySelector("meta[charset]");
    const dataStyles = /* @__PURE__ */ $47990066fdbc3144$export$10a0f131c0eea21b.document.createElement("style");
    const deferredConnectedCallbacks = [];
    let appLoadFallback;
    let isBootstrapping = true;
    Object.assign($47990066fdbc3144$export$2e40610e9d23bca6, options);
    $47990066fdbc3144$export$2e40610e9d23bca6.$resourcesUrl$ = new URL(options.resourcesUrl || "./", $47990066fdbc3144$export$10a0f131c0eea21b.document.baseURI).href;
    if ((0, $kxuSp.BUILD).asyncQueue) {
        if (options.syncQueue) $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 4 /* queueSync */ ;
    }
    if ((0, $kxuSp.BUILD).hydrateClientSide) $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 2 /* appLoaded */ ;
    if ((0, $kxuSp.BUILD).hydrateClientSide && (0, $kxuSp.BUILD).shadowDom) $47990066fdbc3144$var$hydrateScopedToShadow();
    let hasSlotRelocation = false;
    lazyBundles.map((lazyBundle)=>{
        lazyBundle[1].map((compactMeta)=>{
            var _a2, _b;
            const cmpMeta = {
                $flags$: compactMeta[0],
                $tagName$: compactMeta[1],
                $members$: compactMeta[2],
                $listeners$: compactMeta[3]
            };
            if (cmpMeta.$flags$ & 4 /* hasSlotRelocation */ ) hasSlotRelocation = true;
            if ((0, $kxuSp.BUILD).member) cmpMeta.$members$ = compactMeta[2];
            if ((0, $kxuSp.BUILD).hostListener) cmpMeta.$listeners$ = compactMeta[3];
            if ((0, $kxuSp.BUILD).reflect) cmpMeta.$attrsToReflect$ = [];
            if ((0, $kxuSp.BUILD).propChangeCallback) {
                cmpMeta.$watchers$ = $47990066fdbc3144$export$9bd12ad9059cd2fb(compactMeta[4]);
                cmpMeta.$serializers$ = (_a2 = compactMeta[5]) != null ? _a2 : {};
                cmpMeta.$deserializers$ = (_b = compactMeta[6]) != null ? _b : {};
            }
            if ((0, $kxuSp.BUILD).shadowDom && !$47990066fdbc3144$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) cmpMeta.$flags$ |= 8 /* needsShadowDomShim */ ;
            const tagName = (0, $kxuSp.BUILD).transformTagName && options.transformTagName ? options.transformTagName(cmpMeta.$tagName$) : $47990066fdbc3144$export$e6778302ec5425de(cmpMeta.$tagName$);
            const HostElement = class extends HTMLElement {
                ["s-p"];
                ["s-rc"];
                hasRegisteredEventListeners = false;
                // StencilLazyHost
                constructor(self){
                    super(self);
                    self = this;
                    $47990066fdbc3144$export$c20b986001efcf6c(self, cmpMeta);
                    if ((0, $kxuSp.BUILD).shadowDom && cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) {
                        if ($47990066fdbc3144$export$b4e7e6d61dbcd813) {
                            if (!self.shadowRoot) $47990066fdbc3144$var$createShadowRoot.call(self, cmpMeta);
                            else {
                                if (self.shadowRoot.mode !== "open") throw new Error(`Unable to re-use existing shadow root for ${cmpMeta.$tagName$}! Mode is set to ${self.shadowRoot.mode} but Stencil only supports open shadow roots.`);
                            }
                        } else if (!(0, $kxuSp.BUILD).hydrateServerSide && !("shadowRoot" in self)) self.shadowRoot = self;
                    }
                }
                connectedCallback() {
                    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(this);
                    if (!hostRef) return;
                    if (!this.hasRegisteredEventListeners) {
                        this.hasRegisteredEventListeners = true;
                        $47990066fdbc3144$export$62df7fa1a32c483(this, hostRef, cmpMeta.$listeners$, false);
                    }
                    if (appLoadFallback) {
                        clearTimeout(appLoadFallback);
                        appLoadFallback = null;
                    }
                    if (isBootstrapping) deferredConnectedCallbacks.push(this);
                    else $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>$47990066fdbc3144$export$de367db4d6dadc9f(this));
                }
                disconnectedCallback() {
                    $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>$47990066fdbc3144$export$6cf1a3dd300e0a4f(this));
                    $47990066fdbc3144$export$2e40610e9d23bca6.raf(()=>{
                        var _a3;
                        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(this);
                        if (!hostRef) return;
                        const i2 = deferredConnectedCallbacks.findIndex((host)=>host === this);
                        if (i2 > -1) deferredConnectedCallbacks.splice(i2, 1);
                        if (((_a3 = hostRef == null ? void 0 : hostRef.$vnode$) == null ? void 0 : _a3.$elm$) instanceof Node && !hostRef.$vnode$.$elm$.isConnected) delete hostRef.$vnode$.$elm$;
                    });
                }
                componentOnReady() {
                    var _a3;
                    return (_a3 = $47990066fdbc3144$export$3f84770eccf215d2(this)) == null ? void 0 : _a3.$onReadyPromise$;
                }
            };
            if (!(cmpMeta.$flags$ & 1 /* shadowDomEncapsulation */ ) && cmpMeta.$flags$ & 256 /* hasSlot */ ) {
                if ((0, $kxuSp.BUILD).experimentalSlotFixes) $47990066fdbc3144$var$patchPseudoShadowDom(HostElement.prototype);
                else {
                    if ((0, $kxuSp.BUILD).slotChildNodesFix) $47990066fdbc3144$var$patchChildSlotNodes(HostElement.prototype);
                    if ((0, $kxuSp.BUILD).cloneNodeFix) $47990066fdbc3144$var$patchCloneNode(HostElement.prototype);
                    if ((0, $kxuSp.BUILD).appendChildSlotFix) $47990066fdbc3144$var$patchSlotAppendChild(HostElement.prototype);
                    if ((0, $kxuSp.BUILD).scopedSlotTextContentFix && cmpMeta.$flags$ & 2 /* scopedCssEncapsulation */ ) $47990066fdbc3144$var$patchTextContent(HostElement.prototype);
                }
            } else if ((0, $kxuSp.BUILD).cloneNodeFix) $47990066fdbc3144$var$patchCloneNode(HostElement.prototype);
            if ((0, $kxuSp.BUILD).formAssociated && cmpMeta.$flags$ & 64 /* formAssociated */ ) HostElement.formAssociated = true;
            if ((0, $kxuSp.BUILD).hotModuleReplacement) HostElement.prototype["s-hmr"] = function(hmrVersionId) {
                $47990066fdbc3144$var$hmrStart(this, cmpMeta, hmrVersionId);
            };
            cmpMeta.$lazyBundleId$ = lazyBundle[0];
            if (!exclude.includes(tagName) && !customElements2.get(tagName)) {
                cmpTags.push(tagName);
                customElements2.define(tagName, $47990066fdbc3144$export$982064ca8d9ad69(HostElement, cmpMeta, 1 /* isElementConstructor */ ));
            }
        });
    });
    if (cmpTags.length > 0) {
        if ((0, $kxuSp.BUILD).slotRelocation && hasSlotRelocation) dataStyles.textContent += $47990066fdbc3144$var$SLOT_FB_CSS;
        if ((0, $kxuSp.BUILD).invisiblePrehydration && ((0, $kxuSp.BUILD).hydratedClass || (0, $kxuSp.BUILD).hydratedAttribute)) dataStyles.textContent += cmpTags.sort() + $47990066fdbc3144$var$HYDRATED_CSS;
        if (dataStyles.innerHTML.length) {
            dataStyles.setAttribute("data-styles", "");
            const nonce = (_a = $47990066fdbc3144$export$2e40610e9d23bca6.$nonce$) != null ? _a : $47990066fdbc3144$var$queryNonceMetaTagContent($47990066fdbc3144$export$10a0f131c0eea21b.document);
            if (nonce != null) dataStyles.setAttribute("nonce", nonce);
            head.insertBefore(dataStyles, metaCharset ? metaCharset.nextSibling : head.firstChild);
        }
    }
    isBootstrapping = false;
    if (deferredConnectedCallbacks.length) deferredConnectedCallbacks.map((host)=>host.connectedCallback());
    else if ((0, $kxuSp.BUILD).profile) $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>appLoadFallback = setTimeout($47990066fdbc3144$var$appDidLoad, 30, "timeout"));
    else $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>appLoadFallback = setTimeout($47990066fdbc3144$var$appDidLoad, 30));
    endBootstrap();
};
// src/runtime/fragment.ts
var $47990066fdbc3144$export$ffb0004e005737fa = (_, children)=>children;
var $47990066fdbc3144$export$62df7fa1a32c483 = (elm, hostRef, listeners, attachParentListeners)=>{
    if ((0, $kxuSp.BUILD).hostListener && listeners && $47990066fdbc3144$export$10a0f131c0eea21b.document) {
        if ((0, $kxuSp.BUILD).hostListenerTargetParent) {
            if (attachParentListeners) listeners = listeners.filter(([flags])=>flags & 32 /* TargetParent */ );
            else listeners = listeners.filter(([flags])=>!(flags & 32 /* TargetParent */ ));
        }
        listeners.map(([flags, name, method])=>{
            const target = (0, $kxuSp.BUILD).hostListenerTarget ? $47990066fdbc3144$var$getHostListenerTarget($47990066fdbc3144$export$10a0f131c0eea21b.document, elm, flags) : elm;
            const handler = $47990066fdbc3144$var$hostListenerProxy(hostRef, method);
            const opts = $47990066fdbc3144$var$hostListenerOpts(flags);
            $47990066fdbc3144$export$2e40610e9d23bca6.ael(target, name, handler, opts);
            (hostRef.$rmListeners$ = hostRef.$rmListeners$ || []).push(()=>$47990066fdbc3144$export$2e40610e9d23bca6.rel(target, name, handler, opts));
        });
    }
};
var $47990066fdbc3144$var$hostListenerProxy = (hostRef, methodName)=>(ev)=>{
        var _a;
        try {
            if ((0, $kxuSp.BUILD).lazyLoad) {
                if (hostRef.$flags$ & 256 /* isListenReady */ ) (_a = hostRef.$lazyInstance$) == null || _a[methodName](ev);
                else (hostRef.$queuedListeners$ = hostRef.$queuedListeners$ || []).push([
                    methodName,
                    ev
                ]);
            } else hostRef.$hostElement$[methodName](ev);
        } catch (e) {
            $47990066fdbc3144$export$bf36f23bad3e1069(e, hostRef.$hostElement$);
        }
    };
var $47990066fdbc3144$var$getHostListenerTarget = (doc, elm, flags)=>{
    if ((0, $kxuSp.BUILD).hostListenerTargetDocument && flags & 4 /* TargetDocument */ ) return doc;
    if ((0, $kxuSp.BUILD).hostListenerTargetWindow && flags & 8 /* TargetWindow */ ) return $47990066fdbc3144$export$10a0f131c0eea21b;
    if ((0, $kxuSp.BUILD).hostListenerTargetBody && flags & 16 /* TargetBody */ ) return doc.body;
    if ((0, $kxuSp.BUILD).hostListenerTargetParent && flags & 32 /* TargetParent */  && elm.parentElement) return elm.parentElement;
    return elm;
};
var $47990066fdbc3144$var$hostListenerOpts = (flags)=>$47990066fdbc3144$export$b4b667f9f62821eb ? {
        passive: (flags & 1 /* Passive */ ) !== 0,
        capture: (flags & 2 /* Capture */ ) !== 0
    } : (flags & 2 /* Capture */ ) !== 0;
var $47990066fdbc3144$var$baseClass = (0, $kxuSp.BUILD).lazyLoad ? class {
} : globalThis.HTMLElement || class {
};
function $47990066fdbc3144$export$c8d63b7d67105f7(...mixins) {
    return mixins.reduceRight((acc, mixin)=>mixin(acc), $47990066fdbc3144$var$baseClass);
}
// src/runtime/nonce.ts
var $47990066fdbc3144$export$c5f670b24c0ae95a = (nonce)=>$47990066fdbc3144$export$2e40610e9d23bca6.$nonce$ = nonce;
// src/runtime/platform-options.ts
var $47990066fdbc3144$export$ac8bf6eebf15d3df = (opts)=>Object.assign($47990066fdbc3144$export$2e40610e9d23bca6, opts);
// src/runtime/render.ts
var $47990066fdbc3144$var$hostRefCache = /* @__PURE__ */ new WeakMap();
function $47990066fdbc3144$export$b3890eb0ae9dca99(vnode, container) {
    let ref = $47990066fdbc3144$var$hostRefCache.get(container);
    if (!ref) {
        const cmpMeta = {
            $flags$: 0,
            $tagName$: container.tagName
        };
        ref = {
            $flags$: 0,
            $cmpMeta$: cmpMeta,
            $hostElement$: container
        };
        $47990066fdbc3144$var$hostRefCache.set(container, ref);
    }
    $47990066fdbc3144$export$52f8e388858754a(ref, vnode);
}
// src/runtime/tag-transform.ts
var $47990066fdbc3144$var$tagTransformer = void 0;
function $47990066fdbc3144$export$e6778302ec5425de(tag) {
    if (!$47990066fdbc3144$var$tagTransformer) return tag;
    return $47990066fdbc3144$var$tagTransformer(tag);
}
function $47990066fdbc3144$export$123d633594af360d(transformer) {
    if ($47990066fdbc3144$var$tagTransformer) console.warn(`
      A tagTransformer has already been set. 
      Overwriting it may lead to error and unexpected results if your components have already been defined.
    `);
    $47990066fdbc3144$var$tagTransformer = transformer;
}
// src/runtime/vdom/jsx-dev-runtime.ts
function $47990066fdbc3144$export$b03b108e02387893(type, props, key, _isStaticChildren, _source, _self) {
    const propsObj = props || {};
    const { children: children, ...rest } = propsObj;
    let vnodeData = rest;
    if (key !== void 0 && !("key" in rest)) vnodeData = {
        ...rest,
        key: key
    };
    if (vnodeData && Object.keys(vnodeData).length === 0) vnodeData = null;
    if (children !== void 0) {
        if (Array.isArray(children)) return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData, ...children);
        if (typeof children === "object" && children !== null && "$flags$" in children) return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData, children);
        return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData, children);
    }
    return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData);
}
// src/runtime/vdom/jsx-runtime.ts
function $47990066fdbc3144$export$34b9dba7ce09269b(type, props, key) {
    const propsObj = props || {};
    const { children: children, ...rest } = propsObj;
    let vnodeData = rest;
    if (key !== void 0 && !("key" in rest)) vnodeData = {
        ...rest,
        key: key
    };
    if (vnodeData && Object.keys(vnodeData).length === 0) vnodeData = null;
    if (children !== void 0) {
        if (Array.isArray(children)) return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData, ...children);
        if (typeof children === "object" && children !== null && "$flags$" in children) return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData, children);
        return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData, children);
    }
    return $47990066fdbc3144$export$dda1d9f60106f0e9(type, vnodeData);
}
function $47990066fdbc3144$export$25062201e9e25d76(type, props, key) {
    return $47990066fdbc3144$export$34b9dba7ce09269b(type, props, key);
}
// src/runtime/vdom/vdom-annotations.ts
var $47990066fdbc3144$export$fd226bebc5efbbed = (doc, staticComponents)=>{
    if (doc != null) {
        const docData = $47990066fdbc3144$var$STENCIL_DOC_DATA in doc ? doc[$47990066fdbc3144$var$STENCIL_DOC_DATA] : {
            ...$47990066fdbc3144$var$DEFAULT_DOC_DATA
        };
        docData.staticComponents = new Set(staticComponents);
        const orgLocationNodes = [];
        $47990066fdbc3144$var$parseVNodeAnnotations(doc, doc.body, docData, orgLocationNodes);
        orgLocationNodes.forEach((orgLocationNode)=>{
            var _a;
            if (orgLocationNode != null && orgLocationNode["s-nr"]) {
                const nodeRef = orgLocationNode["s-nr"];
                let hostId = nodeRef["s-host-id"];
                let nodeId = nodeRef["s-node-id"];
                let childId = `${hostId}.${nodeId}`;
                if (hostId == null) {
                    hostId = 0;
                    docData.rootLevelIds++;
                    nodeId = docData.rootLevelIds;
                    childId = `${hostId}.${nodeId}`;
                    if (nodeRef.nodeType === 1 /* ElementNode */ ) {
                        nodeRef.setAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID, childId);
                        if (typeof nodeRef["s-sn"] === "string" && !nodeRef.getAttribute("slot")) nodeRef.setAttribute("s-sn", nodeRef["s-sn"]);
                    } else if (nodeRef.nodeType === 3 /* TextNode */ ) {
                        if (hostId === 0) {
                            const textContent = (_a = nodeRef.nodeValue) == null ? void 0 : _a.trim();
                            if (textContent === "") {
                                orgLocationNode.remove();
                                return;
                            }
                        }
                        const commentBeforeTextNode = doc.createComment(childId);
                        commentBeforeTextNode.nodeValue = `${$47990066fdbc3144$var$TEXT_NODE_ID}.${childId}`;
                        $47990066fdbc3144$var$insertBefore(nodeRef.parentNode, commentBeforeTextNode, nodeRef);
                    } else if (nodeRef.nodeType === 8 /* CommentNode */ ) {
                        const commentBeforeTextNode = doc.createComment(childId);
                        commentBeforeTextNode.nodeValue = `${$47990066fdbc3144$var$COMMENT_NODE_ID}.${childId}`;
                        nodeRef.parentNode.insertBefore(commentBeforeTextNode, nodeRef);
                    }
                }
                let orgLocationNodeId = `${$47990066fdbc3144$var$ORG_LOCATION_ID}.${childId}`;
                const orgLocationParentNode = orgLocationNode.parentElement;
                if (orgLocationParentNode) {
                    if (orgLocationParentNode["s-en"] === "") orgLocationNodeId += `.`;
                    else if (orgLocationParentNode["s-en"] === "c") orgLocationNodeId += `.c`;
                }
                orgLocationNode.nodeValue = orgLocationNodeId;
            }
        });
    }
};
var $47990066fdbc3144$var$parseVNodeAnnotations = (doc, node, docData, orgLocationNodes)=>{
    var _a;
    if (node == null) return;
    if (node["s-nr"] != null) orgLocationNodes.push(node);
    if (node.nodeType === 1 /* ElementNode */ ) {
        const childNodes = [
            ...Array.from(node.childNodes),
            ...Array.from(((_a = node.shadowRoot) == null ? void 0 : _a.childNodes) || [])
        ];
        childNodes.forEach((childNode)=>{
            const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(childNode);
            if (hostRef != null && !docData.staticComponents.has(childNode.nodeName.toLowerCase())) {
                const cmpData = {
                    nodeIds: 0
                };
                $47990066fdbc3144$var$insertVNodeAnnotations(doc, childNode, hostRef.$vnode$, docData, cmpData);
            }
            $47990066fdbc3144$var$parseVNodeAnnotations(doc, childNode, docData, orgLocationNodes);
        });
    }
};
var $47990066fdbc3144$var$insertVNodeAnnotations = (doc, hostElm, vnode, docData, cmpData)=>{
    if (vnode != null) {
        const hostId = ++docData.hostIds;
        hostElm.setAttribute($47990066fdbc3144$var$HYDRATE_ID, hostId);
        if (hostElm["s-cr"] != null) hostElm["s-cr"].nodeValue = `${$47990066fdbc3144$var$CONTENT_REF_ID}.${hostId}`;
        if (vnode.$children$ != null) {
            const depth = 0;
            vnode.$children$.forEach((vnodeChild, index)=>{
                $47990066fdbc3144$var$insertChildVNodeAnnotations(doc, vnodeChild, cmpData, hostId, depth, index);
            });
        }
        if (hostElm && vnode && vnode.$elm$ && !hostElm.hasAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID)) {
            const parent = hostElm.parentElement;
            if (parent && parent.childNodes) {
                const parentChildNodes = Array.from(parent.childNodes);
                const comment = parentChildNodes.find((node)=>node.nodeType === 8 /* CommentNode */  && node["s-sr"]);
                if (comment) {
                    const index = parentChildNodes.indexOf(hostElm) - 1;
                    vnode.$elm$.setAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID, `${comment["s-host-id"]}.${comment["s-node-id"]}.0.${index}`);
                }
            }
        }
    }
};
var $47990066fdbc3144$var$insertChildVNodeAnnotations = (doc, vnodeChild, cmpData, hostId, depth, index)=>{
    const childElm = vnodeChild.$elm$;
    if (childElm == null) return;
    const nodeId = cmpData.nodeIds++;
    const childId = `${hostId}.${nodeId}.${depth}.${index}`;
    childElm["s-host-id"] = hostId;
    childElm["s-node-id"] = nodeId;
    if (childElm.nodeType === 1 /* ElementNode */ ) {
        childElm.setAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID, childId);
        if (typeof childElm["s-sn"] === "string" && !childElm.getAttribute("slot")) childElm.setAttribute("s-sn", childElm["s-sn"]);
    } else if (childElm.nodeType === 3 /* TextNode */ ) {
        const parentNode = childElm.parentNode;
        const nodeName = parentNode == null ? void 0 : parentNode.nodeName;
        if (nodeName !== "STYLE" && nodeName !== "SCRIPT") {
            const textNodeId = `${$47990066fdbc3144$var$TEXT_NODE_ID}.${childId}`;
            const commentBeforeTextNode = doc.createComment(textNodeId);
            $47990066fdbc3144$var$insertBefore(parentNode, commentBeforeTextNode, childElm);
        }
    } else if (childElm.nodeType === 8 /* CommentNode */ ) {
        if (childElm["s-sr"]) {
            const slotName = childElm["s-sn"] || "";
            const slotNodeId = `${$47990066fdbc3144$var$SLOT_NODE_ID}.${childId}.${slotName}`;
            childElm.nodeValue = slotNodeId;
        }
    }
    if (vnodeChild.$children$ != null) {
        const childDepth = depth + 1;
        vnodeChild.$children$.forEach((vnode, index2)=>{
            $47990066fdbc3144$var$insertChildVNodeAnnotations(doc, vnode, cmpData, hostId, childDepth, index2);
        });
    }
};

});
parcelRegister("kxuSp", function(module, exports) {

$parcel$export(module.exports, "BUILD", () => $ef3ed721cea257a1$export$455dbfd86f20b704);
$parcel$export(module.exports, "NAMESPACE", () => $ef3ed721cea257a1$export$6aad947bda0f3f46);
// src/app-data/index.ts
var $ef3ed721cea257a1$export$455dbfd86f20b704 = {
    allRenderFn: false,
    element: true,
    event: true,
    hasRenderFn: true,
    hostListener: true,
    hostListenerTargetWindow: true,
    hostListenerTargetDocument: true,
    hostListenerTargetBody: true,
    hostListenerTargetParent: false,
    hostListenerTarget: true,
    member: true,
    method: true,
    mode: true,
    observeAttribute: true,
    prop: true,
    propMutable: true,
    reflect: true,
    scoped: true,
    shadowDom: true,
    slot: true,
    cssAnnotations: true,
    state: true,
    style: true,
    formAssociated: false,
    svg: true,
    updatable: true,
    vdomAttribute: true,
    vdomXlink: true,
    vdomClass: true,
    vdomFunctional: true,
    vdomKey: true,
    vdomListener: true,
    vdomRef: true,
    vdomPropOrAttr: true,
    vdomRender: true,
    vdomStyle: true,
    vdomText: true,
    propChangeCallback: true,
    taskQueue: true,
    hotModuleReplacement: false,
    isDebug: false,
    isDev: false,
    isTesting: false,
    hydrateServerSide: false,
    hydrateClientSide: false,
    lifecycleDOMEvents: false,
    lazyLoad: false,
    profile: false,
    slotRelocation: true,
    // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
    appendChildSlotFix: false,
    // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
    cloneNodeFix: false,
    hydratedAttribute: false,
    hydratedClass: true,
    // TODO(STENCIL-1305): remove this option
    scriptDataOpts: false,
    // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
    scopedSlotTextContentFix: false,
    // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
    shadowDomShim: false,
    // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
    slotChildNodesFix: false,
    invisiblePrehydration: true,
    propBoolean: true,
    propNumber: true,
    propString: true,
    constructableCSS: true,
    devTools: false,
    shadowDelegatesFocus: true,
    shadowSlotAssignmentManual: false,
    initializeNextTick: false,
    asyncLoading: true,
    asyncQueue: false,
    // TODO: deprecated in favour of `setTagTransformer` and `transformTag`. Remove in 5.0
    transformTagName: false,
    attachStyles: true,
    // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
    experimentalSlotFixes: false
};
var $ef3ed721cea257a1$export$6c0517834721cef7 = {};
var $ef3ed721cea257a1$export$6aad947bda0f3f46 = /* default */ "app";

});

parcelRegister("5C7R7", function(module, exports) {

$parcel$export(module.exports, "globalStyles", () => $41669855d6f1c6dd$export$aa0e86c7c0d2f400);
// src/app-globals/index.ts
var $41669855d6f1c6dd$export$7be014228b4d4c4a = /* default */ ()=>{};
var $41669855d6f1c6dd$export$aa0e86c7c0d2f400 = /* default */ "";

});



parcelRegister("lLiTM", function(module, exports) {
"use strict";

var $fd7ca5a843f03722$var$protobuf = module.exports = (parcelRequire("8MpkV"));
$fd7ca5a843f03722$var$protobuf.build = "light";
/**
 * A node-style callback as used by {@link load} and {@link Root#load}.
 * @typedef LoadCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Root} [root] Root, if there hasn't been an error
 * @returns {undefined}
 */ /**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and calls the callback.
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} root Root namespace, defaults to create a new one if omitted.
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @see {@link Root#load}
 */ function $fd7ca5a843f03722$var$load(filename, root, callback) {
    if (typeof root === "function") {
        callback = root;
        root = new $fd7ca5a843f03722$var$protobuf.Root();
    } else if (!root) root = new $fd7ca5a843f03722$var$protobuf.Root();
    return root.load(filename, callback);
}
/**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and calls the callback.
 * @name load
 * @function
 * @param {string|string[]} filename One or multiple files to load
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @see {@link Root#load}
 * @variation 2
 */ // function load(filename:string, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and returns a promise.
 * @name load
 * @function
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted.
 * @returns {Promise<Root>} Promise
 * @see {@link Root#load}
 * @variation 3
 */ // function load(filename:string, [root:Root]):Promise<Root>
$fd7ca5a843f03722$var$protobuf.load = $fd7ca5a843f03722$var$load;
/**
 * Synchronously loads one or multiple .proto or preprocessed .json files into a common root namespace (node only).
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted.
 * @returns {Root} Root namespace
 * @throws {Error} If synchronous fetching is not supported (i.e. in browsers) or if a file's syntax is invalid
 * @see {@link Root#loadSync}
 */ function $fd7ca5a843f03722$var$loadSync(filename, root) {
    if (!root) root = new $fd7ca5a843f03722$var$protobuf.Root();
    return root.loadSync(filename);
}
$fd7ca5a843f03722$var$protobuf.loadSync = $fd7ca5a843f03722$var$loadSync;

// Serialization
$fd7ca5a843f03722$var$protobuf.encoder = (parcelRequire("ekUKG"));

$fd7ca5a843f03722$var$protobuf.decoder = (parcelRequire("8D1oN"));

$fd7ca5a843f03722$var$protobuf.verifier = (parcelRequire("kfNH8"));

$fd7ca5a843f03722$var$protobuf.converter = (parcelRequire("iaLh4"));

// Reflection
$fd7ca5a843f03722$var$protobuf.ReflectionObject = (parcelRequire("eqXqI"));

$fd7ca5a843f03722$var$protobuf.Namespace = (parcelRequire("3keUm"));

$fd7ca5a843f03722$var$protobuf.Root = (parcelRequire("hjrO2"));

$fd7ca5a843f03722$var$protobuf.Enum = (parcelRequire("teZIn"));

$fd7ca5a843f03722$var$protobuf.Type = (parcelRequire("kPRSk"));

$fd7ca5a843f03722$var$protobuf.Field = (parcelRequire("fMEB1"));

$fd7ca5a843f03722$var$protobuf.OneOf = (parcelRequire("8DQkR"));

$fd7ca5a843f03722$var$protobuf.MapField = (parcelRequire("80tkS"));

$fd7ca5a843f03722$var$protobuf.Service = (parcelRequire("hqJin"));

$fd7ca5a843f03722$var$protobuf.Method = (parcelRequire("3lwwS"));

// Runtime
$fd7ca5a843f03722$var$protobuf.Message = (parcelRequire("gLmvK"));

$fd7ca5a843f03722$var$protobuf.wrappers = (parcelRequire("9C7Ox"));

// Utility
$fd7ca5a843f03722$var$protobuf.types = (parcelRequire("keBMp"));

$fd7ca5a843f03722$var$protobuf.util = (parcelRequire("jshGU"));
// Set up possibly cyclic reflection dependencies
$fd7ca5a843f03722$var$protobuf.ReflectionObject._configure($fd7ca5a843f03722$var$protobuf.Root);
$fd7ca5a843f03722$var$protobuf.Namespace._configure($fd7ca5a843f03722$var$protobuf.Type, $fd7ca5a843f03722$var$protobuf.Service, $fd7ca5a843f03722$var$protobuf.Enum);
$fd7ca5a843f03722$var$protobuf.Root._configure($fd7ca5a843f03722$var$protobuf.Type);
$fd7ca5a843f03722$var$protobuf.Field._configure($fd7ca5a843f03722$var$protobuf.Type);

});
parcelRegister("8MpkV", function(module, exports) {
"use strict";
var $664675b82ee8df1a$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $664675b82ee8df1a$var$protobuf.build = "minimal";

// Serialization
$664675b82ee8df1a$var$protobuf.Writer = (parcelRequire("3KUVy"));

$664675b82ee8df1a$var$protobuf.BufferWriter = (parcelRequire("axYUT"));

$664675b82ee8df1a$var$protobuf.Reader = (parcelRequire("hP5zC"));

$664675b82ee8df1a$var$protobuf.BufferReader = (parcelRequire("hVbTm"));

// Utility
$664675b82ee8df1a$var$protobuf.util = (parcelRequire("hf2LF"));

$664675b82ee8df1a$var$protobuf.rpc = (parcelRequire("kPAIY"));

$664675b82ee8df1a$var$protobuf.roots = (parcelRequire("38hgC"));
$664675b82ee8df1a$var$protobuf.configure = $664675b82ee8df1a$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $664675b82ee8df1a$var$configure() {
    $664675b82ee8df1a$var$protobuf.util._configure();
    $664675b82ee8df1a$var$protobuf.Writer._configure($664675b82ee8df1a$var$protobuf.BufferWriter);
    $664675b82ee8df1a$var$protobuf.Reader._configure($664675b82ee8df1a$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$664675b82ee8df1a$var$configure();

});
parcelRegister("3KUVy", function(module, exports) {
"use strict";
module.exports = $2bc1d392757dc2c2$var$Writer;

var $hf2LF = parcelRequire("hf2LF");
var $2bc1d392757dc2c2$var$BufferWriter; // cyclic
var $2bc1d392757dc2c2$var$LongBits = $hf2LF.LongBits, $2bc1d392757dc2c2$var$base64 = $hf2LF.base64, $2bc1d392757dc2c2$var$utf8 = $hf2LF.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $2bc1d392757dc2c2$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $2bc1d392757dc2c2$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $2bc1d392757dc2c2$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $2bc1d392757dc2c2$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $2bc1d392757dc2c2$var$create = function create() {
    return $hf2LF.Buffer ? function create_buffer_setup() {
        return ($2bc1d392757dc2c2$var$Writer.create = function create_buffer() {
            return new $2bc1d392757dc2c2$var$BufferWriter();
        })();
    } : function create_array() {
        return new $2bc1d392757dc2c2$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $2bc1d392757dc2c2$var$Writer.create = $2bc1d392757dc2c2$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $2bc1d392757dc2c2$var$Writer.alloc = function alloc(size) {
    return new $hf2LF.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($hf2LF.Array !== Array) $2bc1d392757dc2c2$var$Writer.alloc = $hf2LF.pool($2bc1d392757dc2c2$var$Writer.alloc, $hf2LF.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $2bc1d392757dc2c2$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $2bc1d392757dc2c2$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $2bc1d392757dc2c2$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $2bc1d392757dc2c2$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $2bc1d392757dc2c2$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$2bc1d392757dc2c2$var$VarintOp.prototype = Object.create($2bc1d392757dc2c2$var$Op.prototype);
$2bc1d392757dc2c2$var$VarintOp.prototype.fn = $2bc1d392757dc2c2$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $2bc1d392757dc2c2$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.int32 = function write_int32(value) {
    return (value |= 0) < 0 ? this._push($2bc1d392757dc2c2$var$writeVarint64, 10, $2bc1d392757dc2c2$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $2bc1d392757dc2c2$var$writeVarint64(val, buf, pos) {
    var lo = val.lo, hi = val.hi;
    while(hi){
        buf[pos++] = lo & 127 | 128;
        lo = (lo >>> 7 | hi << 25) >>> 0;
        hi >>>= 7;
    }
    while(lo > 127){
        buf[pos++] = lo & 127 | 128;
        lo = lo >>> 7;
    }
    buf[pos++] = lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value);
    return this._push($2bc1d392757dc2c2$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.int64 = $2bc1d392757dc2c2$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value).zzEncode();
    return this._push($2bc1d392757dc2c2$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($2bc1d392757dc2c2$var$writeByte, 1, value ? 1 : 0);
};
function $2bc1d392757dc2c2$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($2bc1d392757dc2c2$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.sfixed32 = $2bc1d392757dc2c2$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value);
    return this._push($2bc1d392757dc2c2$var$writeFixed32, 4, bits.lo)._push($2bc1d392757dc2c2$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.sfixed64 = $2bc1d392757dc2c2$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.float = function write_float(value) {
    return this._push($hf2LF.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.double = function write_double(value) {
    return this._push($hf2LF.float.writeDoubleLE, 8, value);
};
var $2bc1d392757dc2c2$var$writeBytes = $hf2LF.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($2bc1d392757dc2c2$var$writeByte, 1, 0);
    if ($hf2LF.isString(value)) {
        var buf = $2bc1d392757dc2c2$var$Writer.alloc(len = $2bc1d392757dc2c2$var$base64.length(value));
        $2bc1d392757dc2c2$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($2bc1d392757dc2c2$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.string = function write_string(value) {
    var len = $2bc1d392757dc2c2$var$utf8.length(value);
    return len ? this.uint32(len)._push($2bc1d392757dc2c2$var$utf8.write, len, value) : this._push($2bc1d392757dc2c2$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.fork = function fork() {
    this.states = new $2bc1d392757dc2c2$var$State(this);
    this.head = this.tail = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $2bc1d392757dc2c2$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$2bc1d392757dc2c2$var$Writer._configure = function(BufferWriter_) {
    $2bc1d392757dc2c2$var$BufferWriter = BufferWriter_;
    $2bc1d392757dc2c2$var$Writer.create = $2bc1d392757dc2c2$var$create();
    $2bc1d392757dc2c2$var$BufferWriter._configure();
};

});
parcelRegister("hf2LF", function(module, exports) {
"use strict";
var $c8d5fc00154f529a$var$util = module.exports;

// used to return a Promise where callback is omitted
$c8d5fc00154f529a$var$util.asPromise = (parcelRequire("6TUyK"));

// converts to / from base64 encoded strings
$c8d5fc00154f529a$var$util.base64 = (parcelRequire("ljrw7"));

// base class of rpc.Service
$c8d5fc00154f529a$var$util.EventEmitter = (parcelRequire("cTpsI"));

// float handling accross browsers
$c8d5fc00154f529a$var$util.float = (parcelRequire("b8LQB"));

// converts to / from utf8 encoded strings
$c8d5fc00154f529a$var$util.utf8 = (parcelRequire("1x6UU"));

// provides a node-like buffer pool in the browser
$c8d5fc00154f529a$var$util.pool = (parcelRequire("hU2wx"));

// utility to work with the low and high bits of a 64 bit value
$c8d5fc00154f529a$var$util.LongBits = (parcelRequire("5S9hy"));
/**
 * Tests if the specified key can affect object prototypes.
 * @memberof util
 * @param {string} key Key to test
 * @returns {boolean} `true` if the key is unsafe
 */ function $c8d5fc00154f529a$var$isUnsafeProperty(key) {
    return key === "__proto__" || key === "prototype" || key === "constructor";
}
$c8d5fc00154f529a$var$util.isUnsafeProperty = $c8d5fc00154f529a$var$isUnsafeProperty;
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $c8d5fc00154f529a$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $c8d5fc00154f529a$var$util.global = $c8d5fc00154f529a$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $c8d5fc00154f529a$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $c8d5fc00154f529a$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $c8d5fc00154f529a$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $c8d5fc00154f529a$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $c8d5fc00154f529a$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $c8d5fc00154f529a$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $c8d5fc00154f529a$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && Object.hasOwnProperty.call(obj, prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $c8d5fc00154f529a$var$util.Buffer = function() {
    try {
        var Buffer = $c8d5fc00154f529a$var$util.global.Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$c8d5fc00154f529a$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$c8d5fc00154f529a$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $c8d5fc00154f529a$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $c8d5fc00154f529a$var$util.Buffer ? $c8d5fc00154f529a$var$util._Buffer_allocUnsafe(sizeOrArray) : new $c8d5fc00154f529a$var$util.Array(sizeOrArray) : $c8d5fc00154f529a$var$util.Buffer ? $c8d5fc00154f529a$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $c8d5fc00154f529a$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;

/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $c8d5fc00154f529a$var$util.Long = /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.dcodeIO && /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.Long || function() {
    try {
        var Long = (parcelRequire("lkntF"));
        return Long && Long.isLong ? Long : null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $c8d5fc00154f529a$var$util.longToHash = function longToHash(value) {
    return value ? $c8d5fc00154f529a$var$util.LongBits.from(value).toHash() : $c8d5fc00154f529a$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $c8d5fc00154f529a$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $c8d5fc00154f529a$var$util.LongBits.fromHash(hash);
    if ($c8d5fc00154f529a$var$util.Long) return $c8d5fc00154f529a$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {...(Object.<string,*>|boolean)} src Source objects, optionally followed by an `ifNotSet` flag
 * @returns {Object.<string,*>} Destination object
 */ function $c8d5fc00154f529a$var$merge(dst) {
    var ifNotSet = typeof arguments[arguments.length - 1] === "boolean", limit = ifNotSet ? arguments.length - 1 : arguments.length;
    ifNotSet = ifNotSet && arguments[arguments.length - 1];
    for(var a = 1; a < limit; ++a){
        var src = arguments[a];
        if (!src) continue;
        for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (!$c8d5fc00154f529a$var$isUnsafeProperty(keys[i]) && (dst[keys[i]] === undefined || !ifNotSet)) dst[keys[i]] = src[keys[i]];
    }
    return dst;
}
$c8d5fc00154f529a$var$util.merge = $c8d5fc00154f529a$var$merge;
/**
 * Schema declaration nesting limit.
 * @memberof util
 * @type {number}
 */ $c8d5fc00154f529a$var$util.nestingLimit = 32; // protoc: MaxMessageDeclarationNestingDepth
/**
 * Recursion limit.
 * @memberof util
 * @type {number}
 */ $c8d5fc00154f529a$var$util.recursionLimit = 100; // protoc: CodedInputStream::default_recursion_limit_
/**
 * Makes a property safe for assignment as an own property.
 * @memberof util
 * @param {Object.<string,*>} obj Object
 * @param {string} key Property key
 * @returns {undefined}
 */ $c8d5fc00154f529a$var$util.makeProp = function makeProp(obj, key) {
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true
    });
};
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $c8d5fc00154f529a$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $c8d5fc00154f529a$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $c8d5fc00154f529a$var$merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError,
            writable: true,
            enumerable: false,
            configurable: true
        },
        name: {
            get: function get() {
                return name;
            },
            set: undefined,
            enumerable: false,
            // configurable: false would accurately preserve the behavior of
            // the original, but I'm guessing that was not intentional.
            // For an actual error subclass, this property would
            // be configurable.
            configurable: true
        },
        toString: {
            value: function value() {
                return this.name + ": " + this.message;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    return CustomError;
}
$c8d5fc00154f529a$var$util.newError = $c8d5fc00154f529a$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $c8d5fc00154f529a$var$util.ProtocolError = $c8d5fc00154f529a$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $c8d5fc00154f529a$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $c8d5fc00154f529a$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $c8d5fc00154f529a$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$c8d5fc00154f529a$var$util._configure = function() {
    var Buffer = $c8d5fc00154f529a$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $c8d5fc00154f529a$var$util._Buffer_from = $c8d5fc00154f529a$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $c8d5fc00154f529a$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $c8d5fc00154f529a$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("6TUyK", function(module, exports) {
"use strict";
module.exports = $5063c0aab3220c21$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $5063c0aab3220c21$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("ljrw7", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $f840b7a2526f15a0$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $f840b7a2526f15a0$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $f840b7a2526f15a0$var$b64 = new Array(64);
// Base64 decoding table
var $f840b7a2526f15a0$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $f840b7a2526f15a0$var$i = 0; $f840b7a2526f15a0$var$i < 64;)$f840b7a2526f15a0$var$s64[$f840b7a2526f15a0$var$b64[$f840b7a2526f15a0$var$i] = $f840b7a2526f15a0$var$i < 26 ? $f840b7a2526f15a0$var$i + 65 : $f840b7a2526f15a0$var$i < 52 ? $f840b7a2526f15a0$var$i + 71 : $f840b7a2526f15a0$var$i < 62 ? $f840b7a2526f15a0$var$i - 4 : $f840b7a2526f15a0$var$i - 59 | 43] = $f840b7a2526f15a0$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $f840b7a2526f15a0$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $f840b7a2526f15a0$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $f840b7a2526f15a0$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $f840b7a2526f15a0$var$b64[t | b >> 6];
                chunk[i++] = $f840b7a2526f15a0$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $f840b7a2526f15a0$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $f840b7a2526f15a0$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $f840b7a2526f15a0$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $f840b7a2526f15a0$var$s64[c]) === undefined) throw Error($f840b7a2526f15a0$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($f840b7a2526f15a0$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $f840b7a2526f15a0$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("cTpsI", function(module, exports) {
"use strict";
module.exports = $962e5f58319de5e6$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $962e5f58319de5e6$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = Object.create(null);
}
/**
 * Event listener as used by {@link util.EventEmitter}.
 * @typedef EventEmitterListener
 * @type {function}
 * @param {...*} args Arguments
 * @returns {undefined}
 */ /**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {EventEmitterListener} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {EventEmitterListener} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = Object.create(null);
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        if (!listeners) return this;
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("b8LQB", function(module, exports) {
"use strict";
module.exports = $81c58e96688a18b7$var$factory($81c58e96688a18b7$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $81c58e96688a18b7$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $81c58e96688a18b7$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $81c58e96688a18b7$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $81c58e96688a18b7$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $81c58e96688a18b7$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $81c58e96688a18b7$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $81c58e96688a18b7$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $81c58e96688a18b7$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $81c58e96688a18b7$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $81c58e96688a18b7$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $81c58e96688a18b7$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $81c58e96688a18b7$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $81c58e96688a18b7$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("1x6UU", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $11de3d165fc704f0$var$utf8 = module.exports, $11de3d165fc704f0$var$replacementCharCode = 0xFFFD; // U+FFFD REPLACEMENT CHARACTER
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $11de3d165fc704f0$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $11de3d165fc704f0$var$utf8.read = function utf8_read(buffer, start, end) {
    if (end - start < 1) return "";
    // Batch code units and flush via String.fromCharCode.apply in 8192-unit
    // chunks to avoid the per-character ConsString buildup of `str += ...`.
    var parts = null, chunk = [], i = 0, t, t2, c2, c3;
    while(start < end){
        t = buffer[start++];
        if (t <= 0x7F) chunk[i++] = t;
        else if (t >= 0xC0 && t < 0xE0) {
            c2 = (t & 0x1F) << 6 | buffer[start++] & 0x3F;
            chunk[i++] = c2 >= 0x80 ? c2 : $11de3d165fc704f0$var$replacementCharCode;
        } else if (t >= 0xE0 && t < 0xF0) {
            c3 = (t & 0xF) << 12 | (buffer[start++] & 0x3F) << 6 | buffer[start++] & 0x3F;
            chunk[i++] = c3 >= 0x800 ? c3 : $11de3d165fc704f0$var$replacementCharCode;
        } else if (t >= 0xF0) {
            t2 = (t & 7) << 18 | (buffer[start++] & 0x3F) << 12 | (buffer[start++] & 0x3F) << 6 | buffer[start++] & 0x3F;
            if (t2 < 0x10000 || t2 > 0x10FFFF) chunk[i++] = $11de3d165fc704f0$var$replacementCharCode;
            else {
                t2 -= 0x10000;
                chunk[i++] = 0xD800 + (t2 >> 10);
                chunk[i++] = 0xDC00 + (t2 & 0x3FF);
            }
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk.slice(0, i)));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $11de3d165fc704f0$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("hU2wx", function(module, exports) {
"use strict";
module.exports = $d0899fc8295f4c1e$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $d0899fc8295f4c1e$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("5S9hy", function(module, exports) {
"use strict";
module.exports = $44693224ff456c0c$var$LongBits;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $44693224ff456c0c$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $44693224ff456c0c$var$zero = $44693224ff456c0c$var$LongBits.zero = new $44693224ff456c0c$var$LongBits(0, 0);
$44693224ff456c0c$var$zero.toNumber = function() {
    return 0;
};
$44693224ff456c0c$var$zero.zzEncode = $44693224ff456c0c$var$zero.zzDecode = function() {
    return this;
};
$44693224ff456c0c$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $44693224ff456c0c$var$zeroHash = $44693224ff456c0c$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $44693224ff456c0c$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $44693224ff456c0c$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $44693224ff456c0c$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $44693224ff456c0c$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $44693224ff456c0c$var$LongBits.fromNumber(value);
    if ($hf2LF.isString(value)) {
        /* istanbul ignore else */ if ($hf2LF.Long) value = $hf2LF.Long.fromString(value);
        else return $44693224ff456c0c$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $44693224ff456c0c$var$LongBits(value.low >>> 0, value.high >>> 0) : $44693224ff456c0c$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $44693224ff456c0c$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $44693224ff456c0c$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $hf2LF.Long ? new $hf2LF.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $44693224ff456c0c$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $44693224ff456c0c$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $44693224ff456c0c$var$zeroHash) return $44693224ff456c0c$var$zero;
    return new $44693224ff456c0c$var$LongBits(($44693224ff456c0c$var$charCodeAt.call(hash, 0) | $44693224ff456c0c$var$charCodeAt.call(hash, 1) << 8 | $44693224ff456c0c$var$charCodeAt.call(hash, 2) << 16 | $44693224ff456c0c$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($44693224ff456c0c$var$charCodeAt.call(hash, 4) | $44693224ff456c0c$var$charCodeAt.call(hash, 5) << 8 | $44693224ff456c0c$var$charCodeAt.call(hash, 6) << 16 | $44693224ff456c0c$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $44693224ff456c0c$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $44693224ff456c0c$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $44693224ff456c0c$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $44693224ff456c0c$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});

parcelRegister("lkntF", function(module, exports) {
// GENERATED FILE. DO NOT EDIT.
(function(global, factory) {
    function preferDefault(exports1) {
        return exports1.default || exports1;
    }
    if (typeof define === "function" && define.amd) define([], function() {
        var exports1 = {};
        factory(exports1);
        return preferDefault(exports1);
    });
    else {
        factory(module.exports);
        module.exports = preferDefault(module.exports);
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : module.exports, function(_exports) {
    "use strict";
    Object.defineProperty(_exports, "__esModule", {
        value: true
    });
    _exports.default = void 0;
    /**
     * @license
     * Copyright 2009 The Closure Library Authors
     * Copyright 2020 Daniel Wirtz / The long.js Authors.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *     http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * SPDX-License-Identifier: Apache-2.0
     */ // WebAssembly optimizations to do native i64 multiplication and divide
    var wasm = null;
    try {
        wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
            // \0asm
            0,
            97,
            115,
            109,
            // version 1
            1,
            0,
            0,
            0,
            // section "type"
            1,
            13,
            2,
            // 0, () => i32
            96,
            0,
            1,
            127,
            // 1, (i32, i32, i32, i32) => i32
            96,
            4,
            127,
            127,
            127,
            127,
            1,
            127,
            // section "function"
            3,
            7,
            6,
            // 0, type 0
            0,
            // 1, type 1
            1,
            // 2, type 1
            1,
            // 3, type 1
            1,
            // 4, type 1
            1,
            // 5, type 1
            1,
            // section "global"
            6,
            6,
            1,
            // 0, "high", mutable i32
            127,
            1,
            65,
            0,
            11,
            // section "export"
            7,
            50,
            6,
            // 0, "mul"
            3,
            109,
            117,
            108,
            0,
            1,
            // 1, "div_s"
            5,
            100,
            105,
            118,
            95,
            115,
            0,
            2,
            // 2, "div_u"
            5,
            100,
            105,
            118,
            95,
            117,
            0,
            3,
            // 3, "rem_s"
            5,
            114,
            101,
            109,
            95,
            115,
            0,
            4,
            // 4, "rem_u"
            5,
            114,
            101,
            109,
            95,
            117,
            0,
            5,
            // 5, "get_high"
            8,
            103,
            101,
            116,
            95,
            104,
            105,
            103,
            104,
            0,
            0,
            // section "code"
            10,
            191,
            1,
            6,
            // 0, "get_high"
            4,
            0,
            35,
            0,
            11,
            // 1, "mul"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            126,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 2, "div_s"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            127,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 3, "div_u"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            128,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 4, "rem_s"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            129,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 5, "rem_u"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            130,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11
        ])), {}).exports;
    } catch  {
    // no wasm support :(
    }
    /**
     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
     *  See the from* functions below for more convenient ways of constructing Longs.
     * @exports Long
     * @class A Long class for representing a 64 bit two's-complement integer value.
     * @param {number} low The low (signed) 32 bits of the long
     * @param {number} high The high (signed) 32 bits of the long
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @constructor
     */ function Long(low, high, unsigned) {
        /**
       * The low 32 bits as a signed value.
       * @type {number}
       */ this.low = low | 0;
        /**
       * The high 32 bits as a signed value.
       * @type {number}
       */ this.high = high | 0;
        /**
       * Whether unsigned or not.
       * @type {boolean}
       */ this.unsigned = !!unsigned;
    }
    // The internal representation of a long is the two given signed, 32-bit values.
    // We use 32-bit pieces because these are the size of integers on which
    // Javascript performs bit-operations.  For operations like addition and
    // multiplication, we split each number into 16 bit pieces, which can easily be
    // multiplied within Javascript's floating-point representation without overflow
    // or change in sign.
    //
    // In the algorithms below, we frequently reduce the negative case to the
    // positive case by negating the input(s) and then post-processing the result.
    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    // a positive number, it overflows back into a negative).  Not handling this
    // case would often result in infinite recursion.
    //
    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    // methods on which they depend.
    /**
     * An indicator used to reliably determine if an object is a Long or not.
     * @type {boolean}
     * @const
     * @private
     */ Long.prototype.__isLong__;
    Object.defineProperty(Long.prototype, "__isLong__", {
        value: true
    });
    /**
     * @function
     * @param {*} obj Object
     * @returns {boolean}
     * @inner
     */ function isLong(obj) {
        return (obj && obj["__isLong__"]) === true;
    }
    /**
     * @function
     * @param {*} value number
     * @returns {number}
     * @inner
     */ function ctz32(value) {
        var c = Math.clz32(value & -value);
        return value ? 31 - c : c;
    }
    /**
     * Tests if the specified object is a Long.
     * @function
     * @param {*} obj Object
     * @returns {boolean}
     */ Long.isLong = isLong;
    /**
     * A cache of the Long representations of small integer values.
     * @type {!Object}
     * @inner
     */ var INT_CACHE = {};
    /**
     * A cache of the Long representations of small unsigned integer values.
     * @type {!Object}
     * @inner
     */ var UINT_CACHE = {};
    /**
     * @param {number} value
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromInt(value, unsigned) {
        var obj, cachedObj, cache;
        if (unsigned) {
            value >>>= 0;
            if (cache = 0 <= value && value < 256) {
                cachedObj = UINT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, 0, true);
            if (cache) UINT_CACHE[value] = obj;
            return obj;
        } else {
            value |= 0;
            if (cache = -128 <= value && value < 128) {
                cachedObj = INT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, value < 0 ? -1 : 0, false);
            if (cache) INT_CACHE[value] = obj;
            return obj;
        }
    }
    /**
     * Returns a Long representing the given 32 bit integer value.
     * @function
     * @param {number} value The 32 bit integer in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromInt = fromInt;
    /**
     * @param {number} value
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromNumber(value, unsigned) {
        if (isNaN(value)) return unsigned ? UZERO : ZERO;
        if (unsigned) {
            if (value < 0) return UZERO;
            if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
        } else {
            if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
            if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
        }
        if (value < 0) return fromNumber(-value, unsigned).neg();
        return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
    }
    /**
     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
     * @function
     * @param {number} value The number in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromNumber = fromNumber;
    /**
     * @param {number} lowBits
     * @param {number} highBits
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromBits(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    }
    /**
     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
     *  assumed to use 32 bits.
     * @function
     * @param {number} lowBits The low 32 bits
     * @param {number} highBits The high 32 bits
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromBits = fromBits;
    /**
     * @function
     * @param {number} base
     * @param {number} exponent
     * @returns {number}
     * @inner
     */ var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
    /**
     * @param {string} str
     * @param {(boolean|number)=} unsigned
     * @param {number=} radix
     * @returns {!Long}
     * @inner
     */ function fromString(str, unsigned, radix) {
        if (str.length === 0) throw Error("empty string");
        if (typeof unsigned === "number") {
            // For goog.math.long compatibility
            radix = unsigned;
            unsigned = false;
        } else unsigned = !!unsigned;
        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return unsigned ? UZERO : ZERO;
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        var p;
        if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
        else if (p === 0) return fromString(str.substring(1), unsigned, radix).neg();
        // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 8));
        var result = ZERO;
        for(var i = 0; i < str.length; i += 8){
            var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = fromNumber(pow_dbl(radix, size));
                result = result.mul(power).add(fromNumber(value));
            } else {
                result = result.mul(radixToPower);
                result = result.add(fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    }
    /**
     * Returns a Long representation of the given string, written using the specified radix.
     * @function
     * @param {string} str The textual representation of the Long
     * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
     * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
     * @returns {!Long} The corresponding Long value
     */ Long.fromString = fromString;
    /**
     * @function
     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromValue(val, unsigned) {
        if (typeof val === "number") return fromNumber(val, unsigned);
        if (typeof val === "string") return fromString(val, unsigned);
        // Throws for non-objects, converts non-instanceof Long:
        return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
    }
    /**
     * Converts the specified value to a Long using the appropriate from* function for its type.
     * @function
     * @param {!Long|number|bigint|string|!{low: number, high: number, unsigned: boolean}} val Value
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long}
     */ Long.fromValue = fromValue;
    // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    // no runtime penalty for these.
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_16_DBL = 65536;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_24_DBL = 16777216;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
    /**
     * @type {!Long}
     * @const
     * @inner
     */ var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
    /**
     * @type {!Long}
     * @inner
     */ var ZERO = fromInt(0);
    /**
     * Signed zero.
     * @type {!Long}
     */ Long.ZERO = ZERO;
    /**
     * @type {!Long}
     * @inner
     */ var UZERO = fromInt(0, true);
    /**
     * Unsigned zero.
     * @type {!Long}
     */ Long.UZERO = UZERO;
    /**
     * @type {!Long}
     * @inner
     */ var ONE = fromInt(1);
    /**
     * Signed one.
     * @type {!Long}
     */ Long.ONE = ONE;
    /**
     * @type {!Long}
     * @inner
     */ var UONE = fromInt(1, true);
    /**
     * Unsigned one.
     * @type {!Long}
     */ Long.UONE = UONE;
    /**
     * @type {!Long}
     * @inner
     */ var NEG_ONE = fromInt(-1);
    /**
     * Signed negative one.
     * @type {!Long}
     */ Long.NEG_ONE = NEG_ONE;
    /**
     * @type {!Long}
     * @inner
     */ var MAX_VALUE = fromBits(-1, 2147483647, false);
    /**
     * Maximum signed value.
     * @type {!Long}
     */ Long.MAX_VALUE = MAX_VALUE;
    /**
     * @type {!Long}
     * @inner
     */ var MAX_UNSIGNED_VALUE = fromBits(-1, -1, true);
    /**
     * Maximum unsigned value.
     * @type {!Long}
     */ Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
    /**
     * @type {!Long}
     * @inner
     */ var MIN_VALUE = fromBits(0, -2147483648, false);
    /**
     * Minimum signed value.
     * @type {!Long}
     */ Long.MIN_VALUE = MIN_VALUE;
    /**
     * @alias Long.prototype
     * @inner
     */ var LongPrototype = Long.prototype;
    /**
     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.toInt = function toInt() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };
    /**
     * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.toNumber = function toNumber() {
        if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    };
    /**
     * Converts the Long to a string written in the specified radix.
     * @this {!Long}
     * @param {number=} radix Radix (2-36), defaults to 10
     * @returns {string}
     * @override
     * @throws {RangeError} If `radix` is out of range
     */ LongPrototype.toString = function toString(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        if (this.isZero()) return "0";
        if (this.isNegative()) {
            // Unsigned Longs are never negative
            if (this.eq(MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
                return div.toString(radix) + rem1.toInt().toString(radix);
            } else return "-" + this.neg().toString(radix);
        }
        // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
        var result = "";
        while(true){
            var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero()) return digits + result;
            else {
                while(digits.length < 6)digits = "0" + digits;
                result = "" + digits + result;
            }
        }
    };
    /**
     * Gets the high 32 bits as a signed integer.
     * @this {!Long}
     * @returns {number} Signed high bits
     */ LongPrototype.getHighBits = function getHighBits() {
        return this.high;
    };
    /**
     * Gets the high 32 bits as an unsigned integer.
     * @this {!Long}
     * @returns {number} Unsigned high bits
     */ LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
        return this.high >>> 0;
    };
    /**
     * Gets the low 32 bits as a signed integer.
     * @this {!Long}
     * @returns {number} Signed low bits
     */ LongPrototype.getLowBits = function getLowBits() {
        return this.low;
    };
    /**
     * Gets the low 32 bits as an unsigned integer.
     * @this {!Long}
     * @returns {number} Unsigned low bits
     */ LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
        return this.low >>> 0;
    };
    /**
     * Gets the number of bits needed to represent the absolute value of this Long.
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
        if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
        var val = this.high != 0 ? this.high : this.low;
        for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
        return this.high != 0 ? bit + 33 : bit + 1;
    };
    /**
     * Tests if this Long can be safely represented as a JavaScript number.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isSafeInteger = function isSafeInteger() {
        // 2^53-1 is the maximum safe value
        var top11Bits = this.high >> 21;
        // [0, 2^53-1]
        if (!top11Bits) return true;
        // > 2^53-1
        if (this.unsigned) return false;
        // [-2^53, -1] except -2^53
        return top11Bits === -1 && !(this.low === 0 && this.high === -2097152);
    };
    /**
     * Tests if this Long's value equals zero.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isZero = function isZero() {
        return this.high === 0 && this.low === 0;
    };
    /**
     * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
     * @returns {boolean}
     */ LongPrototype.eqz = LongPrototype.isZero;
    /**
     * Tests if this Long's value is negative.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isNegative = function isNegative() {
        return !this.unsigned && this.high < 0;
    };
    /**
     * Tests if this Long's value is positive or zero.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isPositive = function isPositive() {
        return this.unsigned || this.high >= 0;
    };
    /**
     * Tests if this Long's value is odd.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isOdd = function isOdd() {
        return (this.low & 1) === 1;
    };
    /**
     * Tests if this Long's value is even.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isEven = function isEven() {
        return (this.low & 1) === 0;
    };
    /**
     * Tests if this Long's value equals the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.equals = function equals(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
        return this.high === other.high && this.low === other.low;
    };
    /**
     * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.eq = LongPrototype.equals;
    /**
     * Tests if this Long's value differs from the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.notEquals = function notEquals(other) {
        return !this.eq(/* validates */ other);
    };
    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.neq = LongPrototype.notEquals;
    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.ne = LongPrototype.notEquals;
    /**
     * Tests if this Long's value is less than the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lessThan = function lessThan(other) {
        return this.comp(/* validates */ other) < 0;
    };
    /**
     * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lt = LongPrototype.lessThan;
    /**
     * Tests if this Long's value is less than or equal the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
        return this.comp(/* validates */ other) <= 0;
    };
    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lte = LongPrototype.lessThanOrEqual;
    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.le = LongPrototype.lessThanOrEqual;
    /**
     * Tests if this Long's value is greater than the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.greaterThan = function greaterThan(other) {
        return this.comp(/* validates */ other) > 0;
    };
    /**
     * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.gt = LongPrototype.greaterThan;
    /**
     * Tests if this Long's value is greater than or equal the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
        return this.comp(/* validates */ other) >= 0;
    };
    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.gte = LongPrototype.greaterThanOrEqual;
    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.ge = LongPrototype.greaterThanOrEqual;
    /**
     * Compares this Long's value with the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     */ LongPrototype.compare = function compare(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.eq(other)) return 0;
        var thisNeg = this.isNegative(), otherNeg = other.isNegative();
        if (thisNeg && !otherNeg) return -1;
        if (!thisNeg && otherNeg) return 1;
        // At this point the sign bits are the same
        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
        // Both are positive if at least one is unsigned
        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
    };
    /**
     * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     */ LongPrototype.comp = LongPrototype.compare;
    /**
     * Negates this Long's value.
     * @this {!Long}
     * @returns {!Long} Negated Long
     */ LongPrototype.negate = function negate() {
        if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
        return this.not().add(ONE);
    };
    /**
     * Negates this Long's value. This is an alias of {@link Long#negate}.
     * @function
     * @returns {!Long} Negated Long
     */ LongPrototype.neg = LongPrototype.negate;
    /**
     * Returns the sum of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} addend Addend
     * @returns {!Long} Sum
     */ LongPrototype.add = function add(addend) {
        if (!isLong(addend)) addend = fromValue(addend);
        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xffff;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 + b48;
        c48 &= 0xffff;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the difference of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     */ LongPrototype.subtract = function subtract(subtrahend) {
        if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
        return this.add(subtrahend.neg());
    };
    /**
     * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
     * @function
     * @param {!Long|number|bigint|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     */ LongPrototype.sub = LongPrototype.subtract;
    /**
     * Returns the product of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} multiplier Multiplier
     * @returns {!Long} Product
     */ LongPrototype.multiply = function multiply(multiplier) {
        if (this.isZero()) return this;
        if (!isLong(multiplier)) multiplier = fromValue(multiplier);
        // use wasm support if present
        if (wasm) {
            var low = wasm["mul"](this.low, this.high, multiplier.low, multiplier.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (multiplier.isZero()) return this.unsigned ? UZERO : ZERO;
        if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
        if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
        if (this.isNegative()) {
            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
            else return this.neg().mul(multiplier).neg();
        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
        // If both longs are small, use float multiplication
        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xffff;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xffff;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
     * @function
     * @param {!Long|number|bigint|string} multiplier Multiplier
     * @returns {!Long} Product
     */ LongPrototype.mul = LongPrototype.multiply;
    /**
     * Returns this Long divided by the specified. The result is signed if this Long is signed or
     *  unsigned if this Long is unsigned.
     * @this {!Long}
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Quotient
     */ LongPrototype.divide = function divide(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        if (divisor.isZero()) throw Error("division by zero");
        // use wasm support if present
        if (wasm) {
            // guard against signed division overflow: the largest
            // negative number / -1 would be 1 larger than the largest
            // positive number, due to two's complement.
            if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
            return this;
            var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (this.isZero()) return this.unsigned ? UZERO : ZERO;
        var approx, rem, res;
        if (!this.unsigned) {
            // This section is only relevant for signed longs and is derived from the
            // closure library as a whole.
            if (this.eq(MIN_VALUE)) {
                if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                else if (divisor.eq(MIN_VALUE)) return ONE;
                else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shr(1);
                    approx = halfThis.div(divisor).shl(1);
                    if (approx.eq(ZERO)) return divisor.isNegative() ? ONE : NEG_ONE;
                    else {
                        rem = this.sub(divisor.mul(approx));
                        res = approx.add(rem.div(divisor));
                        return res;
                    }
                }
            } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
            if (this.isNegative()) {
                if (divisor.isNegative()) return this.neg().div(divisor.neg());
                return this.neg().div(divisor).neg();
            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
            res = ZERO;
        } else {
            // The algorithm below has not been made for unsigned longs. It's therefore
            // required to take special care of the MSB prior to running it.
            if (!divisor.unsigned) divisor = divisor.toUnsigned();
            if (divisor.gt(this)) return UZERO;
            if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
            res = UZERO;
        }
        // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        rem = this;
        while(rem.gte(divisor)){
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
            // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
            while(approxRem.isNegative() || approxRem.gt(rem)){
                approx -= delta;
                approxRes = fromNumber(approx, this.unsigned);
                approxRem = approxRes.mul(divisor);
            }
            // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero()) approxRes = ONE;
            res = res.add(approxRes);
            rem = rem.sub(approxRem);
        }
        return res;
    };
    /**
     * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Quotient
     */ LongPrototype.div = LongPrototype.divide;
    /**
     * Returns this Long modulo the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.modulo = function modulo(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        // use wasm support if present
        if (wasm) {
            var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        return this.sub(this.div(divisor).mul(divisor));
    };
    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.mod = LongPrototype.modulo;
    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.rem = LongPrototype.modulo;
    /**
     * Returns the bitwise NOT of this Long.
     * @this {!Long}
     * @returns {!Long}
     */ LongPrototype.not = function not() {
        return fromBits(~this.low, ~this.high, this.unsigned);
    };
    /**
     * Returns count leading zeros of this Long.
     * @this {!Long}
     * @returns {!number}
     */ LongPrototype.countLeadingZeros = function countLeadingZeros() {
        return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
    };
    /**
     * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
     * @function
     * @param {!Long}
     * @returns {!number}
     */ LongPrototype.clz = LongPrototype.countLeadingZeros;
    /**
     * Returns count trailing zeros of this Long.
     * @this {!Long}
     * @returns {!number}
     */ LongPrototype.countTrailingZeros = function countTrailingZeros() {
        return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
    };
    /**
     * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
     * @function
     * @param {!Long}
     * @returns {!number}
     */ LongPrototype.ctz = LongPrototype.countTrailingZeros;
    /**
     * Returns the bitwise AND of this Long and the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.and = function and(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };
    /**
     * Returns the bitwise OR of this Long and the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.or = function or(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };
    /**
     * Returns the bitwise XOR of this Long and the given one.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.xor = function xor(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftLeft = function shiftLeft(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
        else return fromBits(0, this.low << numBits - 32, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shl = LongPrototype.shiftLeft;
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftRight = function shiftRight(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
        else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    };
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shr = LongPrototype.shiftRight;
    /**
     * Returns this Long with bits logically shifted to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
        if (numBits === 32) return fromBits(this.high, 0, this.unsigned);
        return fromBits(this.high >>> numBits - 32, 0, this.unsigned);
    };
    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shru = LongPrototype.shiftRightUnsigned;
    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
    /**
     * Returns this Long with bits rotated to the left by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotateLeft = function rotateLeft(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.low << numBits | this.high >>> b, this.high << numBits | this.low >>> b, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.high << numBits | this.low >>> b, this.low << numBits | this.high >>> b, this.unsigned);
    };
    /**
     * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotl = LongPrototype.rotateLeft;
    /**
     * Returns this Long with bits rotated to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotateRight = function rotateRight(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.high << b | this.low >>> numBits, this.low << b | this.high >>> numBits, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.low << b | this.high >>> numBits, this.high << b | this.low >>> numBits, this.unsigned);
    };
    /**
     * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotr = LongPrototype.rotateRight;
    /**
     * Converts this Long to signed.
     * @this {!Long}
     * @returns {!Long} Signed long
     */ LongPrototype.toSigned = function toSigned() {
        if (!this.unsigned) return this;
        return fromBits(this.low, this.high, false);
    };
    /**
     * Converts this Long to unsigned.
     * @this {!Long}
     * @returns {!Long} Unsigned long
     */ LongPrototype.toUnsigned = function toUnsigned() {
        if (this.unsigned) return this;
        return fromBits(this.low, this.high, true);
    };
    /**
     * Converts this Long to its byte representation.
     * @param {boolean=} le Whether little or big endian, defaults to big endian
     * @this {!Long}
     * @returns {!Array.<number>} Byte representation
     */ LongPrototype.toBytes = function toBytes(le) {
        return le ? this.toBytesLE() : this.toBytesBE();
    };
    /**
     * Converts this Long to its little endian byte representation.
     * @this {!Long}
     * @returns {!Array.<number>} Little endian byte representation
     */ LongPrototype.toBytesLE = function toBytesLE() {
        var hi = this.high, lo = this.low;
        return [
            lo & 0xff,
            lo >>> 8 & 0xff,
            lo >>> 16 & 0xff,
            lo >>> 24,
            hi & 0xff,
            hi >>> 8 & 0xff,
            hi >>> 16 & 0xff,
            hi >>> 24
        ];
    };
    /**
     * Converts this Long to its big endian byte representation.
     * @this {!Long}
     * @returns {!Array.<number>} Big endian byte representation
     */ LongPrototype.toBytesBE = function toBytesBE() {
        var hi = this.high, lo = this.low;
        return [
            hi >>> 24,
            hi >>> 16 & 0xff,
            hi >>> 8 & 0xff,
            hi & 0xff,
            lo >>> 24,
            lo >>> 16 & 0xff,
            lo >>> 8 & 0xff,
            lo & 0xff
        ];
    };
    /**
     * Creates a Long from its byte representation.
     * @param {!Array.<number>} bytes Byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @param {boolean=} le Whether little or big endian, defaults to big endian
     * @returns {Long} The corresponding Long value
     */ Long.fromBytes = function fromBytes(bytes, unsigned, le) {
        return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    };
    /**
     * Creates a Long from its little endian byte representation.
     * @param {!Array.<number>} bytes Little endian byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {Long} The corresponding Long value
     */ Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
        return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
    };
    /**
     * Creates a Long from its big endian byte representation.
     * @param {!Array.<number>} bytes Big endian byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {Long} The corresponding Long value
     */ Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
        return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
    };
    // Support conversion to/from BigInt where available
    if (typeof BigInt === "function") {
        /**
       * Returns a Long representing the given big integer.
       * @function
       * @param {number} value The big integer value
       * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
       * @returns {!Long} The corresponding Long value
       */ Long.fromBigInt = function fromBigInt(value, unsigned) {
            var lowBits = Number(BigInt.asIntN(32, value));
            var highBits = Number(BigInt.asIntN(32, value >> BigInt(32)));
            return fromBits(lowBits, highBits, unsigned);
        };
        // Override
        Long.fromValue = function fromValueWithBigInt(value, unsigned) {
            if (typeof value === "bigint") return Long.fromBigInt(value, unsigned);
            return fromValue(value, unsigned);
        };
        /**
       * Converts the Long to its big integer representation.
       * @this {!Long}
       * @returns {bigint}
       */ LongPrototype.toBigInt = function toBigInt() {
            var lowBigInt = BigInt(this.low >>> 0);
            var highBigInt = BigInt(this.unsigned ? this.high >>> 0 : this.high);
            return highBigInt << BigInt(32) | lowBigInt;
        };
    }
    var _default = _exports.default = Long;
});

});



parcelRegister("axYUT", function(module, exports) {
"use strict";
module.exports = $7adc3d3bb0285adb$var$BufferWriter;

var $3KUVy = parcelRequire("3KUVy");
($7adc3d3bb0285adb$var$BufferWriter.prototype = Object.create($3KUVy.prototype)).constructor = $7adc3d3bb0285adb$var$BufferWriter;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $7adc3d3bb0285adb$var$BufferWriter() {
    $3KUVy.call(this);
}
$7adc3d3bb0285adb$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $7adc3d3bb0285adb$var$BufferWriter.alloc = $hf2LF._Buffer_allocUnsafe;
    $7adc3d3bb0285adb$var$BufferWriter.writeBytesBuffer = $hf2LF.Buffer && $hf2LF.Buffer.prototype instanceof Uint8Array && $hf2LF.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $7adc3d3bb0285adb$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($hf2LF.isString(value)) value = $hf2LF._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($7adc3d3bb0285adb$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $7adc3d3bb0285adb$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $hf2LF.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $7adc3d3bb0285adb$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $hf2LF.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($7adc3d3bb0285adb$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $7adc3d3bb0285adb$var$BufferWriter._configure();

});

parcelRegister("hP5zC", function(module, exports) {
"use strict";
module.exports = $cf9b85d8c65bf523$var$Reader;

var $hf2LF = parcelRequire("hf2LF");
var $cf9b85d8c65bf523$var$BufferReader; // cyclic
var $cf9b85d8c65bf523$var$LongBits = $hf2LF.LongBits, $cf9b85d8c65bf523$var$utf8 = $hf2LF.utf8;
/* istanbul ignore next */ function $cf9b85d8c65bf523$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $cf9b85d8c65bf523$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $cf9b85d8c65bf523$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $cf9b85d8c65bf523$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $cf9b85d8c65bf523$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $cf9b85d8c65bf523$var$create = function create() {
    return $hf2LF.Buffer ? function create_buffer_setup(buffer) {
        return ($cf9b85d8c65bf523$var$Reader.create = function create_buffer(buffer) {
            return $hf2LF.Buffer.isBuffer(buffer) ? new $cf9b85d8c65bf523$var$BufferReader(buffer) : $cf9b85d8c65bf523$var$create_array(buffer);
        })(buffer);
    } : $cf9b85d8c65bf523$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $cf9b85d8c65bf523$var$Reader.create = $cf9b85d8c65bf523$var$create();
$cf9b85d8c65bf523$var$Reader.prototype._slice = $hf2LF.Array.prototype.subarray || /* istanbul ignore next */ $hf2LF.Array.prototype.slice;
function $cf9b85d8c65bf523$var$readVarint32NearEnd(reader) {
    // Safely read up to four bytes of a varint32 near the reader limit
    var value = 0;
    for(var i = 0; i < 4; ++i){
        if (reader.pos >= reader.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(reader);
        var b = reader.buf[reader.pos++];
        value = (value | (b & 127) << i * 7) >>> 0;
        if (b < 128) return value;
    }
    throw $cf9b85d8c65bf523$var$indexOutOfRange(reader);
}
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        if (this.len - this.pos < 5) {
            if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
            if (this.buf[this.pos] >= 128) return $cf9b85d8c65bf523$var$readVarint32NearEnd(this);
        }
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $cf9b85d8c65bf523$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $cf9b85d8c65bf523$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $cf9b85d8c65bf523$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    return $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    return $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $cf9b85d8c65bf523$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 8);
    return new $cf9b85d8c65bf523$var$LongBits($cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4), $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    var value = $hf2LF.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    var value = $hf2LF.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    if (start === end) {
        var nativeBuffer = $hf2LF.Buffer;
        return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $cf9b85d8c65bf523$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $cf9b85d8c65bf523$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Recursion limit.
 * @type {number}
 */ $cf9b85d8c65bf523$var$Reader.recursionLimit = $hf2LF.recursionLimit;
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @param {number} [depth] Depth of recursion to control nested calls; 0 if omitted
 * @returns {Reader} `this`
 */ $cf9b85d8c65bf523$var$Reader.prototype.skipType = function(wireType, depth) {
    if (depth === undefined) depth = 0;
    if (depth > $cf9b85d8c65bf523$var$Reader.recursionLimit) throw Error("maximum nesting depth exceeded");
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType, depth + 1);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$cf9b85d8c65bf523$var$Reader._configure = function(BufferReader_) {
    $cf9b85d8c65bf523$var$BufferReader = BufferReader_;
    $cf9b85d8c65bf523$var$Reader.create = $cf9b85d8c65bf523$var$create();
    $cf9b85d8c65bf523$var$BufferReader._configure();
    var fn = $hf2LF.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $hf2LF.merge($cf9b85d8c65bf523$var$Reader.prototype, {
        int64: function read_int64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $cf9b85d8c65bf523$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $cf9b85d8c65bf523$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("hVbTm", function(module, exports) {
"use strict";
module.exports = $d0c0fc09890ced56$var$BufferReader;

var $hP5zC = parcelRequire("hP5zC");
($d0c0fc09890ced56$var$BufferReader.prototype = Object.create($hP5zC.prototype)).constructor = $d0c0fc09890ced56$var$BufferReader;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $d0c0fc09890ced56$var$BufferReader(buffer) {
    $hP5zC.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$d0c0fc09890ced56$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($hf2LF.Buffer) $d0c0fc09890ced56$var$BufferReader.prototype._slice = $hf2LF.Buffer.prototype.slice;
};
/**
 * @override
 */ $d0c0fc09890ced56$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $d0c0fc09890ced56$var$BufferReader._configure();

});

parcelRegister("kPAIY", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $f2a50ebf117c2427$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $f2a50ebf117c2427$var$rpc.Service = (parcelRequire("9qfRI"));

});
parcelRegister("9qfRI", function(module, exports) {
"use strict";
module.exports = $6dc2d94c097e90b5$var$Service;

var $hf2LF = parcelRequire("hf2LF");
// Extends EventEmitter
($6dc2d94c097e90b5$var$Service.prototype = Object.create($hf2LF.EventEmitter.prototype)).constructor = $6dc2d94c097e90b5$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $6dc2d94c097e90b5$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $hf2LF.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $6dc2d94c097e90b5$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $hf2LF.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $6dc2d94c097e90b5$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("38hgC", function(module, exports) {
"use strict";
module.exports = Object.create(null); /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available across modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});


parcelRegister("ekUKG", function(module, exports) {
"use strict";
module.exports = $a6fef4afa6d495a9$var$encoder;

var $teZIn = parcelRequire("teZIn");

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
/**
 * Generates a partial message type encoder.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $a6fef4afa6d495a9$var$genTypePartial(gen, field, fieldIndex, ref) {
    return field.delimited ? gen("types[%i].encode(%s,w.uint32(%i),q+1).uint32(%i)", fieldIndex, ref, (field.id << 3 | 3) >>> 0, (field.id << 3 | 4) >>> 0) : gen("types[%i].encode(%s,w.uint32(%i).fork(),q+1).ldelim()", fieldIndex, ref, (field.id << 3 | 2) >>> 0);
}
/**
 * Generates an encoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $a6fef4afa6d495a9$var$encoder(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var gen = $jshGU.codegen([
        "m",
        "w",
        "q"
    ], mtype.name + "$encode")("if(!w)")("w=Writer.create()")("if(q===undefined)q=0")("if(q>util.recursionLimit)")("throw Error(\"max depth exceeded\")");
    var i, ref;
    // "when a message is serialized its known fields should be written sequentially by field number"
    var fields = /* initializes */ mtype.fieldsArray.slice().sort($jshGU.compareFieldsById);
    for(var i = 0; i < fields.length; ++i){
        var field = fields[i].resolve(), index = mtype._fieldsArray.indexOf(field), type = field.resolvedType instanceof $teZIn ? "int32" : field.type, wireType = $keBMp.basic[type];
        ref = "m" + $jshGU.safeProp(field.name);
        // Map fields
        if (field.map) {
            gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", ref, field.name) // !== undefined && !== null
            ("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", ref)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (field.id << 3 | 2) >>> 0, 8 | $keBMp.mapKey[field.keyType], field.keyType);
            if (wireType === undefined) gen("types[%i].encode(%s[ks[i]],w.uint32(18).fork(),q+1).ldelim().ldelim()", index, ref); // can't be groups
            else gen(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | wireType, type, ref);
            gen("}")("}");
        // Repeated fields
        } else if (field.repeated) {
            gen("if(%s!=null&&%s.length){", ref, ref); // !== undefined && !== null
            // Packed repeated
            if (field.packed && $keBMp.packed[type] !== undefined) gen("w.uint32(%i).fork()", (field.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", ref)("w.%s(%s[i])", type, ref)("w.ldelim()");
            else {
                gen("for(var i=0;i<%s.length;++i)", ref);
                if (wireType === undefined) $a6fef4afa6d495a9$var$genTypePartial(gen, field, index, ref + "[i]");
                else gen("w.uint32(%i).%s(%s[i])", (field.id << 3 | wireType) >>> 0, type, ref);
            }
            gen("}");
        // Non-repeated
        } else {
            if (field.optional) gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", ref, field.name); // !== undefined && !== null
            if (wireType === undefined) $a6fef4afa6d495a9$var$genTypePartial(gen, field, index, ref);
            else gen("w.uint32(%i).%s(%s)", (field.id << 3 | wireType) >>> 0, type, ref);
        }
    }
    return gen("return w");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }

});
parcelRegister("teZIn", function(module, exports) {
"use strict";
module.exports = $057e571fb61d2aca$var$Enum;

var $eqXqI = parcelRequire("eqXqI");
(($057e571fb61d2aca$var$Enum.prototype = Object.create($eqXqI.prototype)).constructor = $057e571fb61d2aca$var$Enum).className = "Enum";

var $3keUm = parcelRequire("3keUm");

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new enum instance.
 * @classdesc Reflected enum.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {Object.<string,number>} [values] Enum values as an object, by name
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] The comment for this enum
 * @param {Object.<string,string>} [comments] The value comments for this enum
 * @param {Object.<string,Object<string,*>>|undefined} [valuesOptions] The value options for this enum
 */ function $057e571fb61d2aca$var$Enum(name, values, options, comment, comments, valuesOptions) {
    $eqXqI.call(this, name, options);
    if (values && typeof values !== "object") throw TypeError("values must be an object");
    /**
     * Enum values by id.
     * @type {Object.<number,string>}
     */ this.valuesById = {};
    /**
     * Enum values by name.
     * @type {Object.<string,number>}
     */ this.values = Object.create(this.valuesById); // toJSON, marker
    /**
     * Enum comment text.
     * @type {string|null}
     */ this.comment = comment;
    /**
     * Value comment texts, if any.
     * @type {Object.<string,string>}
     */ this.comments = comments || {};
    /**
     * Values options, if any
     * @type {Object<string, Object<string, *>>|undefined}
     */ this.valuesOptions = valuesOptions;
    /**
     * Resolved values features, if any
     * @type {Object<string, Object<string, *>>|undefined}
     */ this._valuesFeatures = {};
    /**
     * Reserved ranges, if any.
     * @type {Array.<number[]|string>}
     */ this.reserved = undefined; // toJSON
    // Note that values inherit valuesById on their prototype which makes them a TypeScript-
    // compatible enum. This is used by pbts to write actual enum definitions that work for
    // static and reflection code alike instead of emitting generic object definitions.
    if (values) {
        for(var keys = Object.keys(values), i = 0; i < keys.length; ++i)if (keys[i] !== "__proto__" && typeof values[keys[i]] === "number") this.valuesById[this.values[keys[i]] = values[keys[i]]] = keys[i];
    }
}
/**
 * @override
 */ $057e571fb61d2aca$var$Enum.prototype._resolveFeatures = function _resolveFeatures(edition) {
    edition = this._edition || edition;
    $eqXqI.prototype._resolveFeatures.call(this, edition);
    Object.keys(this.values).forEach((key)=>{
        var parentFeaturesCopy = $jshGU.merge({}, this._features);
        this._valuesFeatures[key] = $jshGU.merge(parentFeaturesCopy, this.valuesOptions && this.valuesOptions[key] && this.valuesOptions[key].features || {});
    });
    return this;
};
/**
 * Enum descriptor.
 * @interface IEnum
 * @property {Object.<string,number>} values Enum values
 * @property {Object.<string,*>} [options] Enum options
 */ /**
 * Constructs an enum from an enum descriptor.
 * @param {string} name Enum name
 * @param {IEnum} json Enum descriptor
 * @returns {Enum} Created enum
 * @throws {TypeError} If arguments are invalid
 */ $057e571fb61d2aca$var$Enum.fromJSON = function fromJSON(name, json) {
    var enm = new $057e571fb61d2aca$var$Enum(name, json.values, json.options, json.comment, json.comments);
    enm.reserved = json.reserved;
    if (json.edition) enm._edition = json.edition;
    enm._defaultEdition = "proto3"; // For backwards-compatibility.
    return enm;
};
/**
 * Converts this enum to an enum descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IEnum} Enum descriptor
 */ $057e571fb61d2aca$var$Enum.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "options",
        this.options,
        "valuesOptions",
        this.valuesOptions,
        "values",
        this.values,
        "reserved",
        this.reserved && this.reserved.length ? this.reserved : undefined,
        "comment",
        keepComments ? this.comment : undefined,
        "comments",
        keepComments ? this.comments : undefined
    ]);
};
/**
 * Adds a value to this enum.
 * @param {string} name Value name
 * @param {number} id Value id
 * @param {string} [comment] Comment, if any
 * @param {Object.<string, *>|undefined} [options] Options, if any
 * @returns {Enum} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a value with this name or id
 */ $057e571fb61d2aca$var$Enum.prototype.add = function add(name, id, comment, options) {
    // utilized by the parser but not by .fromJSON
    if (!$jshGU.isString(name)) throw TypeError("name must be a string");
    if (!$jshGU.isInteger(id)) throw TypeError("id must be an integer");
    if (name === "__proto__") return this;
    if (this.values[name] !== undefined) throw Error("duplicate name '" + name + "' in " + this);
    if (this.isReservedId(id)) throw Error("id " + id + " is reserved in " + this);
    if (this.isReservedName(name)) throw Error("name '" + name + "' is reserved in " + this);
    if (this.valuesById[id] !== undefined) {
        if (!(this.options && this.options.allow_alias)) throw Error("duplicate id " + id + " in " + this);
        this.values[name] = id;
    } else this.valuesById[this.values[name] = id] = name;
    if (options) {
        if (this.valuesOptions === undefined) this.valuesOptions = {};
        this.valuesOptions[name] = options || null;
    }
    this.comments[name] = comment || null;
    return this;
};
/**
 * Removes a value from this enum
 * @param {string} name Value name
 * @returns {Enum} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `name` is not a name of this enum
 */ $057e571fb61d2aca$var$Enum.prototype.remove = function remove(name) {
    if (!$jshGU.isString(name)) throw TypeError("name must be a string");
    var val = this.values[name];
    if (val == null) throw Error("name '" + name + "' does not exist in " + this);
    delete this.valuesById[val];
    delete this.values[name];
    delete this.comments[name];
    if (this.valuesOptions) delete this.valuesOptions[name];
    return this;
};
/**
 * Tests if the specified id is reserved.
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $057e571fb61d2aca$var$Enum.prototype.isReservedId = function isReservedId(id) {
    return $3keUm.isReservedId(this.reserved, id);
};
/**
 * Tests if the specified name is reserved.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $057e571fb61d2aca$var$Enum.prototype.isReservedName = function isReservedName(name) {
    return $3keUm.isReservedName(this.reserved, name);
};

});
parcelRegister("eqXqI", function(module, exports) {
"use strict";
module.exports = $a82197f06aba8e75$var$ReflectionObject;
$a82197f06aba8e75$var$ReflectionObject.className = "ReflectionObject";

var $8DQkR = parcelRequire("8DQkR");

var $jshGU = parcelRequire("jshGU");
var $a82197f06aba8e75$var$Root; // cyclic
/* eslint-disable no-warning-comments */ // TODO: Replace with embedded proto.
var $a82197f06aba8e75$var$editions2023Defaults = {
    enum_type: "OPEN",
    field_presence: "EXPLICIT",
    json_format: "ALLOW",
    message_encoding: "LENGTH_PREFIXED",
    repeated_field_encoding: "PACKED",
    utf8_validation: "VERIFY"
};
var $a82197f06aba8e75$var$proto2Defaults = {
    enum_type: "CLOSED",
    field_presence: "EXPLICIT",
    json_format: "LEGACY_BEST_EFFORT",
    message_encoding: "LENGTH_PREFIXED",
    repeated_field_encoding: "EXPANDED",
    utf8_validation: "NONE"
};
var $a82197f06aba8e75$var$proto3Defaults = {
    enum_type: "OPEN",
    field_presence: "IMPLICIT",
    json_format: "ALLOW",
    message_encoding: "LENGTH_PREFIXED",
    repeated_field_encoding: "PACKED",
    utf8_validation: "VERIFY"
};
/**
 * Constructs a new reflection object instance.
 * @classdesc Base class of all reflection objects.
 * @constructor
 * @param {string} name Object name
 * @param {Object.<string,*>} [options] Declared options
 * @abstract
 */ function $a82197f06aba8e75$var$ReflectionObject(name, options) {
    if (!$jshGU.isString(name)) throw TypeError("name must be a string");
    if (options && !$jshGU.isObject(options)) throw TypeError("options must be an object");
    /**
     * Options.
     * @type {Object.<string,*>|undefined}
     */ this.options = options; // toJSON
    /**
     * Parsed Options.
     * @type {Array.<Object.<string,*>>|undefined}
     */ this.parsedOptions = null;
    /**
     * Unique name within its namespace.
     * @type {string}
     */ this.name = name;
    /**
     * The edition specified for this object.  Only relevant for top-level objects.
     * @type {string}
     * @private
     */ this._edition = null;
    /**
     * The default edition to use for this object if none is specified.  For legacy reasons,
     * this is proto2 except in the JSON parsing case where it was proto3.
     * @type {string}
     * @private
     */ this._defaultEdition = "proto2";
    /**
     * Resolved Features.
     * @type {object}
     * @private
     */ this._features = {};
    /**
     * Whether or not features have been resolved.
     * @type {boolean}
     * @private
     */ this._featuresResolved = false;
    /**
     * Parent namespace.
     * @type {Namespace|null}
     */ this.parent = null;
    /**
     * Whether already resolved or not.
     * @type {boolean}
     */ this.resolved = false;
    /**
     * Comment text, if any.
     * @type {string|null}
     */ this.comment = null;
    /**
     * Defining file name.
     * @type {string|null}
     */ this.filename = null;
}
Object.defineProperties($a82197f06aba8e75$var$ReflectionObject.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */ root: {
        get: function() {
            var ptr = this;
            while(ptr.parent !== null)ptr = ptr.parent;
            return ptr;
        }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */ fullName: {
        get: function() {
            var path = [
                this.name
            ], ptr = this.parent;
            while(ptr){
                path.unshift(ptr.name);
                ptr = ptr.parent;
            }
            return path.join(".");
        }
    }
});
/**
 * Converts this reflection object to its descriptor representation.
 * @returns {Object.<string,*>} Descriptor
 * @abstract
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.toJSON = /* istanbul ignore next */ function toJSON() {
    throw Error(); // not implemented, shouldn't happen
};
/**
 * Called when this object is added to a parent.
 * @param {ReflectionObject} parent Parent added to
 * @returns {undefined}
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.onAdd = function onAdd(parent) {
    if (this.parent && this.parent !== parent) this.parent.remove(this);
    this.parent = parent;
    this.resolved = false;
    var root = parent.root;
    if (root instanceof $a82197f06aba8e75$var$Root) root._handleAdd(this);
};
/**
 * Called when this object is removed from a parent.
 * @param {ReflectionObject} parent Parent removed from
 * @returns {undefined}
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.onRemove = function onRemove(parent) {
    var root = parent.root;
    if (root instanceof $a82197f06aba8e75$var$Root) root._handleRemove(this);
    this.parent = null;
    this.resolved = false;
};
/**
 * Resolves this objects type references.
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    if (this.root instanceof $a82197f06aba8e75$var$Root) this.resolved = true; // only if part of a root
    return this;
};
/**
 * Resolves this objects editions features.
 * @param {string} edition The edition we're currently resolving for.
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    return this._resolveFeatures(this._edition || edition);
};
/**
 * Resolves child features from parent features
 * @param {string} edition The edition we're currently resolving for.
 * @returns {undefined}
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._resolveFeatures = function _resolveFeatures(edition) {
    if (this._featuresResolved) return;
    var defaults = {};
    /* istanbul ignore if */ if (!edition) throw new Error("Unknown edition for " + this.fullName);
    var protoFeatures = $jshGU.merge({}, this.options && this.options.features, this._inferLegacyProtoFeatures(edition));
    if (this._edition) {
        // For a namespace marked with a specific edition, reset defaults.
        /* istanbul ignore else */ if (edition === "proto2") defaults = Object.assign({}, $a82197f06aba8e75$var$proto2Defaults);
        else if (edition === "proto3") defaults = Object.assign({}, $a82197f06aba8e75$var$proto3Defaults);
        else if (edition === "2023") defaults = Object.assign({}, $a82197f06aba8e75$var$editions2023Defaults);
        else throw new Error("Unknown edition: " + edition);
        this._features = $jshGU.merge(defaults, protoFeatures);
        this._featuresResolved = true;
        return;
    }
    // fields in Oneofs aren't actually children of them, so we have to
    // special-case it
    /* istanbul ignore else */ if (this.partOf instanceof $8DQkR) {
        var lexicalParentFeaturesCopy = $jshGU.merge({}, this.partOf._features);
        this._features = $jshGU.merge(lexicalParentFeaturesCopy, protoFeatures);
    } else if (this.declaringField) ;
    else if (this.parent) {
        var parentFeaturesCopy = $jshGU.merge({}, this.parent._features);
        this._features = $jshGU.merge(parentFeaturesCopy, protoFeatures);
    } else throw new Error("Unable to find a parent for " + this.fullName);
    if (this.extensionField) // Sister fields should have the same features as their extensions.
    this.extensionField._features = this._features;
    this._featuresResolved = true;
};
/**
 * Infers features from legacy syntax that may have been specified differently.
 * in older editions.
 * @param {string|undefined} edition The edition this proto is on, or undefined if pre-editions
 * @returns {object} The feature values to override
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._inferLegacyProtoFeatures = function _inferLegacyProtoFeatures() {
    return {};
};
/**
 * Gets an option value.
 * @param {string} name Option name
 * @returns {*} Option value or `undefined` if not set
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.getOption = function getOption(name) {
    if (this.options) return this.options[name];
    return undefined;
};
/**
 * Sets an option.
 * @param {string} name Option name
 * @param {*} value Option value
 * @param {boolean|undefined} [ifNotSet] Sets the option only if it isn't currently set
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.setOption = function setOption(name, value, ifNotSet) {
    if (name === "__proto__") return this;
    if (!this.options) this.options = {};
    if (/^features\./.test(name)) $jshGU.setProperty(this.options, name, value, ifNotSet);
    else if (!ifNotSet || this.options[name] === undefined) {
        if (this.getOption(name) !== value) this.resolved = false;
        this.options[name] = value;
    }
    return this;
};
/**
 * Sets a parsed option.
 * @param {string} name parsed Option name
 * @param {*} value Option value
 * @param {string} propName dot '.' delimited full path of property within the option to set. if undefined\empty, will add a new option with that value
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.setParsedOption = function setParsedOption(name, value, propName) {
    if (name === "__proto__") return this;
    if (!this.parsedOptions) this.parsedOptions = [];
    var parsedOptions = this.parsedOptions;
    if (propName) {
        // If setting a sub property of an option then try to merge it
        // with an existing option
        var opt = parsedOptions.find(function(opt) {
            return Object.prototype.hasOwnProperty.call(opt, name);
        });
        if (opt) {
            // If we found an existing option - just merge the property value
            // (If it's a feature, will just write over)
            var newValue = opt[name];
            $jshGU.setProperty(newValue, propName, value);
        } else {
            // otherwise, create a new option, set its property and add it to the list
            opt = {};
            opt[name] = $jshGU.setProperty({}, propName, value);
            parsedOptions.push(opt);
        }
    } else {
        // Always create a new option when setting the value of the option itself
        var newOpt = {};
        newOpt[name] = value;
        parsedOptions.push(newOpt);
    }
    return this;
};
/**
 * Sets multiple options.
 * @param {Object.<string,*>} options Options to set
 * @param {boolean} [ifNotSet] Sets an option only if it isn't currently set
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.setOptions = function setOptions(options, ifNotSet) {
    if (options) for(var keys = Object.keys(options), i = 0; i < keys.length; ++i)this.setOption(keys[i], options[keys[i]], ifNotSet);
    return this;
};
/**
 * Converts this instance to its string representation.
 * @returns {string} Class name[, space, full name]
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.toString = function toString() {
    var className = this.constructor.className, fullName = this.fullName;
    if (fullName.length) return className + " " + fullName;
    return className;
};
/**
 * Converts the edition this object is pinned to for JSON format.
 * @returns {string|undefined} The edition string for JSON representation
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._editionToJSON = function _editionToJSON() {
    if (!this._edition || this._edition === "proto3") // Avoid emitting proto3 since we need to default to it for backwards
    // compatibility anyway.
    return undefined;
    return this._edition;
};
// Sets up cyclic dependencies (called in index-light)
$a82197f06aba8e75$var$ReflectionObject._configure = function(Root_) {
    $a82197f06aba8e75$var$Root = Root_;
};

});
parcelRegister("8DQkR", function(module, exports) {
"use strict";
module.exports = $64aa8ffec14d52ef$var$OneOf;

var $eqXqI = parcelRequire("eqXqI");
(($64aa8ffec14d52ef$var$OneOf.prototype = Object.create($eqXqI.prototype)).constructor = $64aa8ffec14d52ef$var$OneOf).className = "OneOf";

var $fMEB1 = parcelRequire("fMEB1");

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new oneof instance.
 * @classdesc Reflected oneof.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Oneof name
 * @param {string[]|Object.<string,*>} [fieldNames] Field names
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $64aa8ffec14d52ef$var$OneOf(name, fieldNames, options, comment) {
    if (!Array.isArray(fieldNames)) {
        options = fieldNames;
        fieldNames = undefined;
    }
    $eqXqI.call(this, name, options);
    /* istanbul ignore if */ if (!(fieldNames === undefined || Array.isArray(fieldNames))) throw TypeError("fieldNames must be an Array");
    /**
     * Field names that belong to this oneof.
     * @type {string[]}
     */ this.oneof = fieldNames || []; // toJSON, marker
    /**
     * Fields that belong to this oneof as an array for iteration.
     * @type {Field[]}
     * @readonly
     */ this.fieldsArray = []; // declared readonly for conformance, possibly not yet added to parent
    /**
     * Comment for this field.
     * @type {string|null}
     */ this.comment = comment;
}
/**
 * Oneof descriptor.
 * @interface IOneOf
 * @property {Array.<string>} oneof Oneof field names
 * @property {Object.<string,*>} [options] Oneof options
 */ /**
 * Constructs a oneof from a oneof descriptor.
 * @param {string} name Oneof name
 * @param {IOneOf} json Oneof descriptor
 * @returns {OneOf} Created oneof
 * @throws {TypeError} If arguments are invalid
 */ $64aa8ffec14d52ef$var$OneOf.fromJSON = function fromJSON(name, json) {
    return new $64aa8ffec14d52ef$var$OneOf(name, json.oneof, json.options, json.comment);
};
/**
 * Converts this oneof to a oneof descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IOneOf} Oneof descriptor
 */ $64aa8ffec14d52ef$var$OneOf.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "options",
        this.options,
        "oneof",
        this.oneof,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Adds the fields of the specified oneof to the parent if not already done so.
 * @param {OneOf} oneof The oneof
 * @returns {undefined}
 * @inner
 * @ignore
 */ function $64aa8ffec14d52ef$var$addFieldsToParent(oneof) {
    if (oneof.parent) {
        for(var i = 0; i < oneof.fieldsArray.length; ++i)if (!oneof.fieldsArray[i].parent) oneof.parent.add(oneof.fieldsArray[i]);
    }
}
/**
 * Adds a field to this oneof and removes it from its current parent, if any.
 * @param {Field} field Field to add
 * @returns {OneOf} `this`
 */ $64aa8ffec14d52ef$var$OneOf.prototype.add = function add(field) {
    /* istanbul ignore if */ if (!(field instanceof $fMEB1)) throw TypeError("field must be a Field");
    if (field.parent && field.parent !== this.parent) field.parent.remove(field);
    this.oneof.push(field.name);
    this.fieldsArray.push(field);
    field.partOf = this; // field.parent remains null
    $64aa8ffec14d52ef$var$addFieldsToParent(this);
    return this;
};
/**
 * Removes a field from this oneof and puts it back to the oneof's parent.
 * @param {Field} field Field to remove
 * @returns {OneOf} `this`
 */ $64aa8ffec14d52ef$var$OneOf.prototype.remove = function remove(field) {
    /* istanbul ignore if */ if (!(field instanceof $fMEB1)) throw TypeError("field must be a Field");
    var index = this.fieldsArray.indexOf(field);
    /* istanbul ignore if */ if (index < 0) throw Error(field + " is not a member of " + this);
    this.fieldsArray.splice(index, 1);
    index = this.oneof.indexOf(field.name);
    /* istanbul ignore else */ if (index > -1) this.oneof.splice(index, 1);
    field.partOf = null;
    return this;
};
/**
 * @override
 */ $64aa8ffec14d52ef$var$OneOf.prototype.onAdd = function onAdd(parent) {
    $eqXqI.prototype.onAdd.call(this, parent);
    var self = this;
    // Collect present fields
    for(var i = 0; i < this.oneof.length; ++i){
        var field = parent.get(this.oneof[i]);
        if (field && !field.partOf) {
            field.partOf = self;
            self.fieldsArray.push(field);
        }
    }
    // Add not yet present fields
    $64aa8ffec14d52ef$var$addFieldsToParent(this);
};
/**
 * @override
 */ $64aa8ffec14d52ef$var$OneOf.prototype.onRemove = function onRemove(parent) {
    for(var i = 0, field; i < this.fieldsArray.length; ++i)if ((field = this.fieldsArray[i]).parent) field.parent.remove(field);
    $eqXqI.prototype.onRemove.call(this, parent);
};
/**
 * Determines whether this field corresponds to a synthetic oneof created for
 * a proto3 optional field.  No behavioral logic should depend on this, but it
 * can be relevant for reflection.
 * @name OneOf#isProto3Optional
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($64aa8ffec14d52ef$var$OneOf.prototype, "isProto3Optional", {
    get: function() {
        if (this.fieldsArray == null || this.fieldsArray.length !== 1) return false;
        var field = this.fieldsArray[0];
        return field.options != null && field.options["proto3_optional"] === true;
    }
});
/**
 * Decorator function as returned by {@link OneOf.d} (TypeScript).
 * @typedef OneOfDecorator
 * @type {function}
 * @param {Object} prototype Target prototype
 * @param {string} oneofName OneOf name
 * @returns {undefined}
 */ /**
 * OneOf decorator (TypeScript).
 * @function
 * @param {...string} fieldNames Field names
 * @returns {OneOfDecorator} Decorator function
 * @template T extends string
 */ $64aa8ffec14d52ef$var$OneOf.d = function decorateOneOf() {
    var fieldNames = new Array(arguments.length), index = 0;
    while(index < arguments.length)fieldNames[index] = arguments[index++];
    return function oneOfDecorator(prototype, oneofName) {
        $jshGU.decorateType(prototype.constructor).add(new $64aa8ffec14d52ef$var$OneOf(oneofName, fieldNames));
        Object.defineProperty(prototype, oneofName, {
            get: $jshGU.oneOfGetter(fieldNames),
            set: $jshGU.oneOfSetter(fieldNames)
        });
    };
};

});
parcelRegister("fMEB1", function(module, exports) {
"use strict";
module.exports = $b7dad4439ac362ad$var$Field;

var $eqXqI = parcelRequire("eqXqI");
(($b7dad4439ac362ad$var$Field.prototype = Object.create($eqXqI.prototype)).constructor = $b7dad4439ac362ad$var$Field).className = "Field";

var $teZIn = parcelRequire("teZIn");

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
var $b7dad4439ac362ad$var$Type; // cyclic
var $b7dad4439ac362ad$var$ruleRe = /^required|optional|repeated$/;
/**
 * Constructs a new message field instance. Note that {@link MapField|map fields} have their own class.
 * @name Field
 * @classdesc Reflected message field.
 * @extends FieldBase
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} type Value type
 * @param {string|Object.<string,*>} [rule="optional"] Field rule
 * @param {string|Object.<string,*>} [extend] Extended type if different from parent
 * @param {Object.<string,*>} [options] Declared options
 */ /**
 * Constructs a field from a field descriptor.
 * @param {string} name Field name
 * @param {IField} json Field descriptor
 * @returns {Field} Created field
 * @throws {TypeError} If arguments are invalid
 */ $b7dad4439ac362ad$var$Field.fromJSON = function fromJSON(name, json) {
    var field = new $b7dad4439ac362ad$var$Field(name, json.id, json.type, json.rule, json.extend, json.options, json.comment);
    if (json.edition) field._edition = json.edition;
    field._defaultEdition = "proto3"; // For backwards-compatibility.
    return field;
};
/**
 * Not an actual constructor. Use {@link Field} instead.
 * @classdesc Base class of all reflected message fields. This is not an actual class but here for the sake of having consistent type definitions.
 * @exports FieldBase
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} type Value type
 * @param {string|Object.<string,*>} [rule="optional"] Field rule
 * @param {string|Object.<string,*>} [extend] Extended type if different from parent
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $b7dad4439ac362ad$var$Field(name, id, type, rule, extend, options, comment) {
    if ($jshGU.isObject(rule)) {
        comment = extend;
        options = rule;
        rule = extend = undefined;
    } else if ($jshGU.isObject(extend)) {
        comment = options;
        options = extend;
        extend = undefined;
    }
    $eqXqI.call(this, name, options);
    if (!$jshGU.isInteger(id) || id < 0) throw TypeError("id must be a non-negative integer");
    if (!$jshGU.isString(type)) throw TypeError("type must be a string");
    if (rule !== undefined && !$b7dad4439ac362ad$var$ruleRe.test(rule = rule.toString().toLowerCase())) throw TypeError("rule must be a string rule");
    if (extend !== undefined && !$jshGU.isString(extend)) throw TypeError("extend must be a string");
    /**
     * Field rule, if any.
     * @type {string|undefined}
     */ if (rule === "proto3_optional") rule = "optional";
    this.rule = rule && rule !== "optional" ? rule : undefined; // toJSON
    /**
     * Field type.
     * @type {string}
     */ this.type = type; // toJSON
    /**
     * Unique field id.
     * @type {number}
     */ this.id = id; // toJSON, marker
    /**
     * Extended type if different from parent.
     * @type {string|undefined}
     */ this.extend = extend || undefined; // toJSON
    /**
     * Whether this field is repeated.
     * @type {boolean}
     */ this.repeated = rule === "repeated";
    /**
     * Whether this field is a map or not.
     * @type {boolean}
     */ this.map = false;
    /**
     * Message this field belongs to.
     * @type {Type|null}
     */ this.message = null;
    /**
     * OneOf this field belongs to, if any,
     * @type {OneOf|null}
     */ this.partOf = null;
    /**
     * The field type's default value.
     * @type {*}
     */ this.typeDefault = null;
    /**
     * The field's default value on prototypes.
     * @type {*}
     */ this.defaultValue = null;
    /**
     * Whether this field's value should be treated as a long.
     * @type {boolean}
     */ this.long = $jshGU.Long ? $keBMp.long[type] !== undefined : /* istanbul ignore next */ false;
    /**
     * Whether this field's value is a buffer.
     * @type {boolean}
     */ this.bytes = type === "bytes";
    /**
     * Resolved type if not a basic type.
     * @type {Type|Enum|null}
     */ this.resolvedType = null;
    /**
     * Sister-field within the extended type if a declaring extension field.
     * @type {Field|null}
     */ this.extensionField = null;
    /**
     * Sister-field within the declaring namespace if an extended field.
     * @type {Field|null}
     */ this.declaringField = null;
    /**
     * Comment for this field.
     * @type {string|null}
     */ this.comment = comment;
}
/**
 * Determines whether this field is required.
 * @name Field#required
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "required", {
    get: function() {
        return this._features.field_presence === "LEGACY_REQUIRED";
    }
});
/**
 * Determines whether this field is not required.
 * @name Field#optional
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "optional", {
    get: function() {
        return !this.required;
    }
});
/**
 * Determines whether this field uses tag-delimited encoding.  In proto2 this
 * corresponded to group syntax.
 * @name Field#delimited
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "delimited", {
    get: function() {
        return this.resolvedType instanceof $b7dad4439ac362ad$var$Type && this._features.message_encoding === "DELIMITED";
    }
});
/**
 * Determines whether this field is packed. Only relevant when repeated.
 * @name Field#packed
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "packed", {
    get: function() {
        return this._features.repeated_field_encoding === "PACKED";
    }
});
/**
 * Determines whether this field tracks presence.
 * @name Field#hasPresence
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "hasPresence", {
    get: function() {
        if (this.repeated || this.map) return false;
        return this.partOf || // oneofs
        this.declaringField || this.extensionField || // extensions
        this._features.field_presence !== "IMPLICIT";
    }
});
/**
 * @override
 */ $b7dad4439ac362ad$var$Field.prototype.setOption = function setOption(name, value, ifNotSet) {
    return $eqXqI.prototype.setOption.call(this, name, value, ifNotSet);
};
/**
 * Field descriptor.
 * @interface IField
 * @property {string} [rule="optional"] Field rule
 * @property {string} type Field type
 * @property {number} id Field id
 * @property {Object.<string,*>} [options] Field options
 */ /**
 * Extension field descriptor.
 * @interface IExtensionField
 * @extends IField
 * @property {string} extend Extended type
 */ /**
 * Converts this field to a field descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IField} Field descriptor
 */ $b7dad4439ac362ad$var$Field.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "rule",
        this.rule !== "optional" && this.rule || undefined,
        "type",
        this.type,
        "id",
        this.id,
        "extend",
        this.extend,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Resolves this field's type references.
 * @returns {Field} `this`
 * @throws {Error} If any reference cannot be resolved
 */ $b7dad4439ac362ad$var$Field.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    if ((this.typeDefault = $keBMp.defaults[this.type]) === undefined) {
        this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type);
        if (this.resolvedType instanceof $b7dad4439ac362ad$var$Type) this.typeDefault = null;
        else this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]; // first defined
    } else if (this.options && this.options.proto3_optional) // proto3 scalar value marked optional; should default to null
    this.typeDefault = null;
    // use explicitly set default value if present
    if (this.options && this.options["default"] != null) {
        this.typeDefault = this.options["default"];
        if (this.resolvedType instanceof $teZIn && typeof this.typeDefault === "string") this.typeDefault = this.resolvedType.values[this.typeDefault];
    }
    // remove unnecessary options
    if (this.options) {
        if (this.options.packed !== undefined && this.resolvedType && !(this.resolvedType instanceof $teZIn)) delete this.options.packed;
        if (!Object.keys(this.options).length) this.options = undefined;
    }
    // convert to internal data type if necesssary
    if (this.long) {
        this.typeDefault = $jshGU.Long.fromNumber(this.typeDefault, this.type === "uint64" || this.type === "fixed64");
        /* istanbul ignore else */ if (Object.freeze) Object.freeze(this.typeDefault); // long instances are meant to be immutable anyway (i.e. use small int cache that even requires it)
    } else if (this.bytes && typeof this.typeDefault === "string") {
        var buf;
        if ($jshGU.base64.test(this.typeDefault)) $jshGU.base64.decode(this.typeDefault, buf = $jshGU.newBuffer($jshGU.base64.length(this.typeDefault)), 0);
        else $jshGU.utf8.write(this.typeDefault, buf = $jshGU.newBuffer($jshGU.utf8.length(this.typeDefault)), 0);
        this.typeDefault = buf;
    }
    // take special care of maps and repeated fields
    if (this.map) this.defaultValue = $jshGU.emptyObject;
    else if (this.repeated) this.defaultValue = $jshGU.emptyArray;
    else this.defaultValue = this.typeDefault;
    // ensure proper value on prototype
    if (this.parent instanceof $b7dad4439ac362ad$var$Type) this.parent.ctor.prototype[this.name] = this.defaultValue;
    return $eqXqI.prototype.resolve.call(this);
};
/**
 * Infers field features from legacy syntax that may have been specified differently.
 * in older editions.
 * @param {string|undefined} edition The edition this proto is on, or undefined if pre-editions
 * @returns {object} The feature values to override
 */ $b7dad4439ac362ad$var$Field.prototype._inferLegacyProtoFeatures = function _inferLegacyProtoFeatures(edition) {
    if (edition !== "proto2" && edition !== "proto3") return {};
    var features = {};
    if (this.rule === "required") features.field_presence = "LEGACY_REQUIRED";
    if (this.parent && $keBMp.defaults[this.type] === undefined) {
        // We can't use resolvedType because types may not have been resolved yet.  However,
        // legacy groups are always in the same scope as the field so we don't have to do a
        // full scan of the tree.
        var type = this.parent.get(this.type.split(".").pop());
        if (type && type instanceof $b7dad4439ac362ad$var$Type && type.group) features.message_encoding = "DELIMITED";
    }
    if (this.getOption("packed") === true) features.repeated_field_encoding = "PACKED";
    else if (this.getOption("packed") === false) features.repeated_field_encoding = "EXPANDED";
    return features;
};
/**
 * @override
 */ $b7dad4439ac362ad$var$Field.prototype._resolveFeatures = function _resolveFeatures(edition) {
    return $eqXqI.prototype._resolveFeatures.call(this, this._edition || edition);
};
/**
 * Decorator function as returned by {@link Field.d} and {@link MapField.d} (TypeScript).
 * @typedef FieldDecorator
 * @type {function}
 * @param {Object} prototype Target prototype
 * @param {string} fieldName Field name
 * @returns {undefined}
 */ /**
 * Field decorator (TypeScript).
 * @name Field.d
 * @function
 * @param {number} fieldId Field id
 * @param {"double"|"float"|"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"string"|"bool"|"bytes"|Object} fieldType Field type
 * @param {"optional"|"required"|"repeated"} [fieldRule="optional"] Field rule
 * @param {T} [defaultValue] Default value
 * @returns {FieldDecorator} Decorator function
 * @template T extends number | number[] | Long | Long[] | string | string[] | boolean | boolean[] | Uint8Array | Uint8Array[] | Buffer | Buffer[]
 */ $b7dad4439ac362ad$var$Field.d = function decorateField(fieldId, fieldType, fieldRule, defaultValue) {
    // submessage: decorate the submessage and use its name as the type
    if (typeof fieldType === "function") fieldType = $jshGU.decorateType(fieldType).name;
    else if (fieldType && typeof fieldType === "object") fieldType = $jshGU.decorateEnum(fieldType).name;
    return function fieldDecorator(prototype, fieldName) {
        $jshGU.decorateType(prototype.constructor).add(new $b7dad4439ac362ad$var$Field(fieldName, fieldId, fieldType, fieldRule, {
            "default": defaultValue
        }));
    };
};
/**
 * Field decorator (TypeScript).
 * @name Field.d
 * @function
 * @param {number} fieldId Field id
 * @param {Constructor<T>|string} fieldType Field type
 * @param {"optional"|"required"|"repeated"} [fieldRule="optional"] Field rule
 * @returns {FieldDecorator} Decorator function
 * @template T extends Message<T>
 * @variation 2
 */ // like Field.d but without a default value
// Sets up cyclic dependencies (called in index-light)
$b7dad4439ac362ad$var$Field._configure = function configure(Type_) {
    $b7dad4439ac362ad$var$Type = Type_;
};

});
parcelRegister("keBMp", function(module, exports) {
"use strict";
/**
 * Common type constants.
 * @namespace
 */ var $ebb26bbd31aa20d5$var$types = module.exports;

var $jshGU = parcelRequire("jshGU");
var $ebb26bbd31aa20d5$var$s = [
    "double",
    "float",
    "int32",
    "uint32",
    "sint32",
    "fixed32",
    "sfixed32",
    "int64",
    "uint64",
    "sint64",
    "fixed64",
    "sfixed64",
    "bool",
    "string",
    "bytes" // 14
];
function $ebb26bbd31aa20d5$var$bake(values, offset) {
    var i = 0, o = Object.create(null);
    offset |= 0;
    while(i < values.length)o[$ebb26bbd31aa20d5$var$s[i + offset]] = values[i++];
    return o;
}
/**
 * Basic type wire types.
 * @type {Object.<string,number>}
 * @const
 * @property {number} double=1 Fixed64 wire type
 * @property {number} float=5 Fixed32 wire type
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 * @property {number} string=2 Ldelim wire type
 * @property {number} bytes=2 Ldelim wire type
 */ $ebb26bbd31aa20d5$var$types.basic = $ebb26bbd31aa20d5$var$bake([
    /* double   */ 1,
    /* float    */ 5,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0,
    /* string   */ 2,
    /* bytes    */ 2
]);
/**
 * Basic type defaults.
 * @type {Object.<string,*>}
 * @const
 * @property {number} double=0 Double default
 * @property {number} float=0 Float default
 * @property {number} int32=0 Int32 default
 * @property {number} uint32=0 Uint32 default
 * @property {number} sint32=0 Sint32 default
 * @property {number} fixed32=0 Fixed32 default
 * @property {number} sfixed32=0 Sfixed32 default
 * @property {number} int64=0 Int64 default
 * @property {number} uint64=0 Uint64 default
 * @property {number} sint64=0 Sint32 default
 * @property {number} fixed64=0 Fixed64 default
 * @property {number} sfixed64=0 Sfixed64 default
 * @property {boolean} bool=false Bool default
 * @property {string} string="" String default
 * @property {Array.<number>} bytes=Array(0) Bytes default
 * @property {null} message=null Message default
 */ $ebb26bbd31aa20d5$var$types.defaults = $ebb26bbd31aa20d5$var$bake([
    /* double   */ 0,
    /* float    */ 0,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 0,
    /* sfixed32 */ 0,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 0,
    /* sfixed64 */ 0,
    /* bool     */ false,
    /* string   */ "",
    /* bytes    */ $jshGU.emptyArray,
    /* message  */ null
]);
/**
 * Basic long type wire types.
 * @type {Object.<string,number>}
 * @const
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 */ $ebb26bbd31aa20d5$var$types.long = $ebb26bbd31aa20d5$var$bake([
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1
], 7);
/**
 * Allowed types for map keys with their associated wire type.
 * @type {Object.<string,number>}
 * @const
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 * @property {number} string=2 Ldelim wire type
 */ $ebb26bbd31aa20d5$var$types.mapKey = $ebb26bbd31aa20d5$var$bake([
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0,
    /* string   */ 2
], 2);
/**
 * Allowed types for packed repeated fields with their associated wire type.
 * @type {Object.<string,number>}
 * @const
 * @property {number} double=1 Fixed64 wire type
 * @property {number} float=5 Fixed32 wire type
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 */ $ebb26bbd31aa20d5$var$types.packed = $ebb26bbd31aa20d5$var$bake([
    /* double   */ 1,
    /* float    */ 5,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0
]);

});
parcelRegister("jshGU", function(module, exports) {
"use strict";

/**
 * Various utility functions.
 * @namespace
 */ var $e29e5af3c073127d$var$util = module.exports = (parcelRequire("hf2LF"));

var $38hgC = parcelRequire("38hgC");
var $e29e5af3c073127d$var$Type, $e29e5af3c073127d$var$Enum;

$e29e5af3c073127d$var$util.codegen = (parcelRequire("jvP0G"));

$e29e5af3c073127d$var$util.fetch = (parcelRequire("87at5"));

$e29e5af3c073127d$var$util.path = (parcelRequire("hcPZH"));

$e29e5af3c073127d$var$util.patterns = (parcelRequire("4SAE1"));
var $e29e5af3c073127d$var$reservedRe = $e29e5af3c073127d$var$util.patterns.reservedRe;

/**
 * Node's fs module if available.
 * @type {Object.<string,*>}
 */ $e29e5af3c073127d$var$util.fs = (parcelRequire("i2mO6"));
/**
 * Checks a recursion depth.
 * @param {number|undefined} depth Depth of recursion
 * @returns {number} Depth of recursion
 * @throws {Error} If depth exceeds util.recursionLimit
 */ $e29e5af3c073127d$var$util.checkDepth = function checkDepth(depth) {
    if (depth === undefined) depth = 0;
    if (depth > $e29e5af3c073127d$var$util.recursionLimit) throw Error("max depth exceeded");
    return depth;
};
/**
 * Converts an object's values to an array.
 * @param {Object.<string,*>} object Object to convert
 * @returns {Array.<*>} Converted array
 */ $e29e5af3c073127d$var$util.toArray = function toArray(object) {
    if (object) {
        var keys = Object.keys(object), array = new Array(keys.length), index = 0;
        while(index < keys.length)array[index] = object[keys[index++]];
        return array;
    }
    return [];
};
/**
 * Converts an array of keys immediately followed by their respective value to an object, omitting undefined values.
 * @param {Array.<*>} array Array to convert
 * @returns {Object.<string,*>} Converted object
 */ $e29e5af3c073127d$var$util.toObject = function toObject(array) {
    var object = {}, index = 0;
    while(index < array.length){
        var key = array[index++], val = array[index++];
        if (val !== undefined) object[key] = val;
    }
    return object;
};
/**
 * Tests whether the specified name is a reserved word in JS.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $e29e5af3c073127d$var$util.isReserved = function isReserved(name) {
    return $e29e5af3c073127d$var$reservedRe.test(name);
};
/**
 * Returns a safe property accessor for the specified property name.
 * @param {string} prop Property name
 * @returns {string} Safe accessor
 */ $e29e5af3c073127d$var$util.safeProp = function safeProp(prop) {
    if (!/^[$\w_]+$/.test(prop) || $e29e5af3c073127d$var$reservedRe.test(prop)) return "[" + JSON.stringify(prop) + "]";
    return "." + prop;
};
/**
 * Converts the first character of a string to upper case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $e29e5af3c073127d$var$util.ucFirst = function ucFirst(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $e29e5af3c073127d$var$camelCaseRe = /_([a-z])/g;
/**
 * Converts a string to camel case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $e29e5af3c073127d$var$util.camelCase = function camelCase(str) {
    return str.substring(0, 1) + str.substring(1).replace($e29e5af3c073127d$var$camelCaseRe, function($0, $1) {
        return $1.toUpperCase();
    });
};
/**
 * Compares reflected fields by id.
 * @param {Field} a First field
 * @param {Field} b Second field
 * @returns {number} Comparison value
 */ $e29e5af3c073127d$var$util.compareFieldsById = function compareFieldsById(a, b) {
    return a.id - b.id;
};

/**
 * Decorator helper for types (TypeScript).
 * @param {Constructor<T>} ctor Constructor function
 * @param {string} [typeName] Type name, defaults to the constructor's name
 * @returns {Type} Reflected type
 * @template T extends Message<T>
 * @property {Root} root Decorators root
 */ $e29e5af3c073127d$var$util.decorateType = function decorateType(ctor, typeName) {
    /* istanbul ignore if */ if (ctor.$type) {
        if (typeName && ctor.$type.name !== typeName) {
            $e29e5af3c073127d$var$util.decorateRoot.remove(ctor.$type);
            ctor.$type.name = typeName;
            $e29e5af3c073127d$var$util.decorateRoot.add(ctor.$type);
        }
        return ctor.$type;
    }
    /* istanbul ignore next */ if (!$e29e5af3c073127d$var$Type) $e29e5af3c073127d$var$Type = (parcelRequire("kPRSk"));
    var type = new $e29e5af3c073127d$var$Type(typeName || ctor.name);
    $e29e5af3c073127d$var$util.decorateRoot.add(type);
    type.ctor = ctor; // sets up .encode, .decode etc.
    Object.defineProperty(ctor, "$type", {
        value: type,
        enumerable: false
    });
    Object.defineProperty(ctor.prototype, "$type", {
        value: type,
        enumerable: false
    });
    return type;
};
var $e29e5af3c073127d$var$decorateEnumIndex = 0;

/**
 * Decorator helper for enums (TypeScript).
 * @param {Object} object Enum object
 * @returns {Enum} Reflected enum
 */ $e29e5af3c073127d$var$util.decorateEnum = function decorateEnum(object) {
    /* istanbul ignore if */ if (object.$type) return object.$type;
    /* istanbul ignore next */ if (!$e29e5af3c073127d$var$Enum) $e29e5af3c073127d$var$Enum = (parcelRequire("teZIn"));
    var enm = new $e29e5af3c073127d$var$Enum("Enum" + $e29e5af3c073127d$var$decorateEnumIndex++, object);
    $e29e5af3c073127d$var$util.decorateRoot.add(enm);
    Object.defineProperty(object, "$type", {
        value: enm,
        enumerable: false
    });
    return enm;
};
/**
 * Sets the value of a property by property path. If a value already exists, it is turned to an array
 * @param {Object.<string,*>} dst Destination object
 * @param {string} path dot '.' delimited path of the property to set
 * @param {Object} value the value to set
 * @param {boolean|undefined} [ifNotSet] Sets the option only if it isn't currently set
 * @returns {Object.<string,*>} Destination object
 */ $e29e5af3c073127d$var$util.setProperty = function setProperty(dst, path, value, ifNotSet) {
    function setProp(dst, path, value) {
        var part = path.shift();
        if ($e29e5af3c073127d$var$util.isUnsafeProperty(part)) return dst;
        if (path.length > 0) dst[part] = setProp(dst[part] || {}, path, value);
        else {
            var prevValue = dst[part];
            if (prevValue && ifNotSet) return dst;
            if (prevValue) value = [].concat(prevValue).concat(value);
            dst[part] = value;
        }
        return dst;
    }
    if (typeof dst !== "object") throw TypeError("dst must be an object");
    if (!path) throw TypeError("path must be specified");
    path = path.split(".");
    if (path.length > $e29e5af3c073127d$var$util.recursionLimit) throw Error("max depth exceeded");
    return setProp(dst, path, value);
};

/**
 * Decorator root (TypeScript).
 * @name util.decorateRoot
 * @type {Root}
 * @readonly
 */ Object.defineProperty($e29e5af3c073127d$var$util, "decorateRoot", {
    get: function() {
        return $38hgC.decorated || ($38hgC["decorated"] = new (parcelRequire("hjrO2"))());
    }
});

});
parcelRegister("jvP0G", function(module, exports) {
"use strict";
module.exports = $e3487b1c341f7a9d$var$codegen;
var $e3487b1c341f7a9d$var$reservedRe = /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/;
/**
 * Begins generating a function.
 * @memberof util
 * @param {string[]} functionParams Function parameter names
 * @param {string} [functionName] Function name if not anonymous
 * @returns {Codegen} Appender that appends code to the function's body
 */ function $e3487b1c341f7a9d$var$codegen(functionParams, functionName) {
    /* istanbul ignore if */ if (typeof functionParams === "string") {
        functionName = functionParams;
        functionParams = undefined;
    }
    var body = [];
    /**
     * Appends code to the function's body or finishes generation.
     * @typedef Codegen
     * @type {function}
     * @param {string|Object.<string,*>} [formatStringOrScope] Format string or, to finish the function, an object of additional scope variables, if any
     * @param {...*} [formatParams] Format parameters
     * @returns {Codegen|Function} Itself or the generated function if finished
     * @throws {Error} If format parameter counts do not match
     */ function Codegen(formatStringOrScope) {
        // note that explicit array handling below makes this ~50% faster
        // finish the function
        if (typeof formatStringOrScope !== "string") {
            var source = toString();
            if ($e3487b1c341f7a9d$var$codegen.verbose) console.log("codegen: " + source); // eslint-disable-line no-console
            source = "return " + source;
            if (formatStringOrScope) {
                var scopeKeys = Object.keys(formatStringOrScope), scopeParams = new Array(scopeKeys.length + 1), scopeValues = new Array(scopeKeys.length), scopeOffset = 0;
                while(scopeOffset < scopeKeys.length){
                    scopeParams[scopeOffset] = scopeKeys[scopeOffset];
                    scopeValues[scopeOffset] = formatStringOrScope[scopeKeys[scopeOffset++]];
                }
                scopeParams[scopeOffset] = source;
                return Function.apply(null, scopeParams).apply(null, scopeValues); // eslint-disable-line no-new-func
            }
            return Function(source)(); // eslint-disable-line no-new-func
        }
        // otherwise append to body
        var formatParams = new Array(arguments.length - 1), formatOffset = 0;
        while(formatOffset < formatParams.length)formatParams[formatOffset] = arguments[++formatOffset];
        formatOffset = 0;
        formatStringOrScope = formatStringOrScope.replace(/%([%dfijs])/g, function replace($0, $1) {
            var value = formatParams[formatOffset++];
            switch($1){
                case "d":
                case "f":
                    return String(Number(value));
                case "i":
                    return String(Math.floor(value));
                case "j":
                    return JSON.stringify(value);
                case "s":
                    return String(value);
            }
            return "%";
        });
        if (formatOffset !== formatParams.length) throw Error("parameter count mismatch");
        body.push(formatStringOrScope);
        return Codegen;
    }
    function toString(functionNameOverride) {
        return "function " + $e3487b1c341f7a9d$var$safeFunctionName(functionNameOverride || functionName) + "(" + (functionParams && functionParams.join(",") || "") + "){\n  " + body.join("\n  ") + "\n}";
    }
    Codegen.toString = toString;
    return Codegen;
}
/**
 * Begins generating a function.
 * @memberof util
 * @function codegen
 * @param {string} [functionName] Function name if not anonymous
 * @returns {Codegen} Appender that appends code to the function's body
 * @variation 2
 */ /**
 * When set to `true`, codegen will log generated code to console. Useful for debugging.
 * @name util.codegen.verbose
 * @type {boolean}
 */ $e3487b1c341f7a9d$var$codegen.verbose = false;
function $e3487b1c341f7a9d$var$safeFunctionName(name) {
    if (!name) return "";
    name = String(name).replace(/[^\w$]/g, "");
    if (!name) return "";
    if (/^\d/.test(name)) name = "_" + name;
    return $e3487b1c341f7a9d$var$reservedRe.test(name) ? name + "_" : name;
}

});

parcelRegister("87at5", function(module, exports) {
"use strict";
module.exports = $5e8718e80f9d930c$var$fetch;

var $6TUyK = parcelRequire("6TUyK");

var $4wVtr = parcelRequire("4wVtr");
/**
 * Node-style callback as used by {@link util.fetch}.
 * @typedef FetchCallback
 * @type {function}
 * @param {?Error} error Error, if any, otherwise `null`
 * @param {string} [contents] File contents, if there hasn't been an error
 * @returns {undefined}
 */ /**
 * Options as used by {@link util.fetch}.
 * @interface IFetchOptions
 * @property {boolean} [binary=false] Whether expecting a binary response
 * @property {boolean} [xhr=false] If `true`, forces the use of XMLHttpRequest
 */ /**
 * Fetches the contents of a file.
 * @memberof util
 * @param {string} filename File path or url
 * @param {IFetchOptions} options Fetch options
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 */ function $5e8718e80f9d930c$var$fetch(filename, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    } else if (!options) options = {};
    if (!callback) return $6TUyK($5e8718e80f9d930c$var$fetch, this, filename, options); // eslint-disable-line no-invalid-this
    // if a node-like filesystem is present, try it first but fall back to XHR if nothing is found.
    if (!options.xhr && $4wVtr && $4wVtr.readFile) return $4wVtr.readFile(filename, function fetchReadFileCallback(err, contents) {
        return err && typeof XMLHttpRequest !== "undefined" ? $5e8718e80f9d930c$var$fetch.xhr(filename, options, callback) : err ? callback(err) : callback(null, options.binary ? contents : contents.toString("utf8"));
    });
    // use the XHR version otherwise.
    return $5e8718e80f9d930c$var$fetch.xhr(filename, options, callback);
}
/**
 * Fetches the contents of a file.
 * @name util.fetch
 * @function
 * @param {string} path File path or url
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 * @variation 2
 */ /**
 * Fetches the contents of a file.
 * @name util.fetch
 * @function
 * @param {string} path File path or url
 * @param {IFetchOptions} [options] Fetch options
 * @returns {Promise<string|Uint8Array>} Promise
 * @variation 3
 */ /**/ $5e8718e80f9d930c$var$fetch.xhr = function fetch_xhr(filename, options, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function fetchOnReadyStateChange() {
        if (xhr.readyState !== 4) return undefined;
        // local cors security errors return status 0 / empty string, too. afaik this cannot be
        // reliably distinguished from an actually empty file for security reasons. feel free
        // to send a pull request if you are aware of a solution.
        if (xhr.status !== 0 && xhr.status !== 200) return callback(Error("status " + xhr.status));
        // if binary data is expected, make sure that some sort of array is returned, even if
        // ArrayBuffers are not supported. the binary string fallback, however, is unsafe.
        if (options.binary) {
            var buffer = xhr.response;
            if (!buffer) {
                buffer = [];
                for(var i = 0; i < xhr.responseText.length; ++i)buffer.push(xhr.responseText.charCodeAt(i) & 255);
            }
            return callback(null, typeof Uint8Array !== "undefined" ? new Uint8Array(buffer) : buffer);
        }
        return callback(null, xhr.responseText);
    };
    if (options.binary) {
        // ref: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Sending_and_Receiving_Binary_Data#Receiving_binary_data_in_older_browsers
        if ("overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        xhr.responseType = "arraybuffer";
    }
    xhr.open("GET", filename);
    xhr.send();
};

});
parcelRegister("4wVtr", function(module, exports) {
"use strict";
var $34c6bbb4acbadca3$var$fs = null;

try {
    $34c6bbb4acbadca3$var$fs = (parcelRequire("jMNYH"));
    if (!$34c6bbb4acbadca3$var$fs || !$34c6bbb4acbadca3$var$fs.readFile || !$34c6bbb4acbadca3$var$fs.readFileSync) $34c6bbb4acbadca3$var$fs = null;
} catch (e) {
// `fs` is unavailable in browsers and browser-like bundles.
}
module.exports = $34c6bbb4acbadca3$var$fs;

});
parcelRegister("jMNYH", function(module, exports) {
"use strict";

});



parcelRegister("hcPZH", function(module, exports) {
"use strict";
/**
 * A minimal path module to resolve Unix, Windows and URL paths alike.
 * @memberof util
 * @namespace
 */ var $c86be39b61cc2191$var$path = module.exports;
var $c86be39b61cc2191$var$isAbsolute = /**
 * Tests if the specified path is absolute.
 * @param {string} path Path to test
 * @returns {boolean} `true` if path is absolute
 */ $c86be39b61cc2191$var$path.isAbsolute = function isAbsolute(path) {
    return /^(?:\/|\w+:)/.test(path);
};
var $c86be39b61cc2191$var$normalize = /**
 * Normalizes the specified path.
 * @param {string} path Path to normalize
 * @returns {string} Normalized path
 */ $c86be39b61cc2191$var$path.normalize = function normalize(path) {
    path = path.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
    var parts = path.split("/"), absolute = $c86be39b61cc2191$var$isAbsolute(path), prefix = "";
    if (absolute) prefix = parts.shift() + "/";
    for(var i = 0; i < parts.length;){
        if (parts[i] === "..") {
            if (i > 0 && parts[i - 1] !== "..") parts.splice(--i, 2);
            else if (absolute) parts.splice(i, 1);
            else ++i;
        } else if (parts[i] === ".") parts.splice(i, 1);
        else ++i;
    }
    return prefix + parts.join("/");
};
/**
 * Resolves the specified include path against the specified origin path.
 * @param {string} originPath Path to the origin file
 * @param {string} includePath Include path relative to origin path
 * @param {boolean} [alreadyNormalized=false] `true` if both paths are already known to be normalized
 * @returns {string} Path to the include file
 */ $c86be39b61cc2191$var$path.resolve = function resolve(originPath, includePath, alreadyNormalized) {
    if (!alreadyNormalized) includePath = $c86be39b61cc2191$var$normalize(includePath);
    if ($c86be39b61cc2191$var$isAbsolute(includePath)) return includePath;
    if (!alreadyNormalized) originPath = $c86be39b61cc2191$var$normalize(originPath);
    return (originPath = originPath.replace(/(?:\/|^)[^/]+$/, "")).length ? $c86be39b61cc2191$var$normalize(originPath + "/" + includePath) : includePath;
};

});

parcelRegister("4SAE1", function(module, exports) {
"use strict";
var $38d8a168bfcc6412$var$patterns = module.exports;
$38d8a168bfcc6412$var$patterns.numberRe = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/;
$38d8a168bfcc6412$var$patterns.typeRefRe = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/;
$38d8a168bfcc6412$var$patterns.reservedRe = /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/;

});

parcelRegister("i2mO6", function(module, exports) {
"use strict";
var $d21a1aefaf9422fd$var$fs = null;

try {
    $d21a1aefaf9422fd$var$fs = (parcelRequire("jMNYH"));
    if (!$d21a1aefaf9422fd$var$fs || !$d21a1aefaf9422fd$var$fs.readFile || !$d21a1aefaf9422fd$var$fs.readFileSync) $d21a1aefaf9422fd$var$fs = null;
} catch (e) {
// `fs` is unavailable in browsers and browser-like bundles.
}
module.exports = $d21a1aefaf9422fd$var$fs;

});

parcelRegister("kPRSk", function(module, exports) {
"use strict";
module.exports = $f2b25c8c7de96169$var$Type;

var $3keUm = parcelRequire("3keUm");
(($f2b25c8c7de96169$var$Type.prototype = Object.create($3keUm.prototype)).constructor = $f2b25c8c7de96169$var$Type).className = "Type";

var $teZIn = parcelRequire("teZIn");

var $8DQkR = parcelRequire("8DQkR");

var $fMEB1 = parcelRequire("fMEB1");

var $80tkS = parcelRequire("80tkS");

var $hqJin = parcelRequire("hqJin");

var $gLmvK = parcelRequire("gLmvK");

var $hP5zC = parcelRequire("hP5zC");

var $3KUVy = parcelRequire("3KUVy");

var $jshGU = parcelRequire("jshGU");

var $ekUKG = parcelRequire("ekUKG");

var $8D1oN = parcelRequire("8D1oN");

var $kfNH8 = parcelRequire("kfNH8");

var $iaLh4 = parcelRequire("iaLh4");

var $9C7Ox = parcelRequire("9C7Ox");
/**
 * Constructs a new reflected message type instance.
 * @classdesc Reflected message type.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Message name
 * @param {Object.<string,*>} [options] Declared options
 */ function $f2b25c8c7de96169$var$Type(name, options) {
    name = name.replace(/\W/g, "");
    $3keUm.call(this, name, options);
    /**
     * Message fields.
     * @type {Object.<string,Field>}
     */ this.fields = {}; // toJSON, marker
    /**
     * Oneofs declared within this namespace, if any.
     * @type {Object.<string,OneOf>}
     */ this.oneofs = undefined; // toJSON
    /**
     * Extension ranges, if any.
     * @type {number[][]}
     */ this.extensions = undefined; // toJSON
    /**
     * Reserved ranges, if any.
     * @type {Array.<number[]|string>}
     */ this.reserved = undefined; // toJSON
    /*?
     * Whether this type is a legacy group.
     * @type {boolean|undefined}
     */ this.group = undefined; // toJSON
    /**
     * Cached fields by id.
     * @type {Object.<number,Field>|null}
     * @private
     */ this._fieldsById = null;
    /**
     * Cached fields as an array.
     * @type {Field[]|null}
     * @private
     */ this._fieldsArray = null;
    /**
     * Cached oneofs as an array.
     * @type {OneOf[]|null}
     * @private
     */ this._oneofsArray = null;
    /**
     * Cached constructor.
     * @type {Constructor<{}>}
     * @private
     */ this._ctor = null;
}
Object.defineProperties($f2b25c8c7de96169$var$Type.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */ fieldsById: {
        get: function() {
            /* istanbul ignore if */ if (this._fieldsById) return this._fieldsById;
            this._fieldsById = {};
            for(var names = Object.keys(this.fields), i = 0; i < names.length; ++i){
                var field = this.fields[names[i]], id = field.id;
                /* istanbul ignore if */ if (this._fieldsById[id]) throw Error("duplicate id " + id + " in " + this);
                this._fieldsById[id] = field;
            }
            return this._fieldsById;
        }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */ fieldsArray: {
        get: function() {
            return this._fieldsArray || (this._fieldsArray = $jshGU.toArray(this.fields));
        }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */ oneofsArray: {
        get: function() {
            return this._oneofsArray || (this._oneofsArray = $jshGU.toArray(this.oneofs));
        }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */ ctor: {
        get: function() {
            return this._ctor || (this.ctor = $f2b25c8c7de96169$var$Type.generateConstructor(this)());
        },
        set: function(ctor) {
            // Ensure proper prototype
            var prototype = ctor.prototype;
            if (!(prototype instanceof $gLmvK)) {
                (ctor.prototype = new $gLmvK()).constructor = ctor;
                $jshGU.merge(ctor.prototype, prototype);
            }
            // Classes and messages reference their reflected type
            ctor.$type = ctor.prototype.$type = this;
            // Mix in static methods
            $jshGU.merge(ctor, $gLmvK, true);
            this._ctor = ctor;
            // Messages have non-enumerable default values on their prototype
            var i = 0;
            for(; i < /* initializes */ this.fieldsArray.length; ++i)this._fieldsArray[i].resolve(); // ensures a proper value
            // Messages have non-enumerable getters and setters for each virtual oneof field
            var ctorProperties = {};
            for(i = 0; i < /* initializes */ this.oneofsArray.length; ++i)ctorProperties[this._oneofsArray[i].resolve().name] = {
                get: $jshGU.oneOfGetter(this._oneofsArray[i].oneof),
                set: $jshGU.oneOfSetter(this._oneofsArray[i].oneof)
            };
            if (i) Object.defineProperties(ctor.prototype, ctorProperties);
        }
    }
});
/**
 * Generates a constructor function for the specified type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $f2b25c8c7de96169$var$Type.generateConstructor = function generateConstructor(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $jshGU.codegen([
        "p"
    ], mtype.name);
    // explicitly initialize mutable object/array fields so that these aren't just inherited from the prototype
    for(var i = 0, field; i < mtype.fieldsArray.length; ++i)if ((field = mtype._fieldsArray[i]).map) gen("this%s={}", $jshGU.safeProp(field.name));
    else if (field.repeated) gen("this%s=[]", $jshGU.safeProp(field.name));
    return gen("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null&&ks[i]!==\"__proto__\")") // omit undefined or null
    ("this[ks[i]]=p[ks[i]]");
/* eslint-enable no-unexpected-multiline */ };
function $f2b25c8c7de96169$var$clearCache(type) {
    type._fieldsById = type._fieldsArray = type._oneofsArray = null;
    delete type.encode;
    delete type.decode;
    delete type.verify;
    return type;
}
/**
 * Message type descriptor.
 * @interface IType
 * @extends INamespace
 * @property {Object.<string,IOneOf>} [oneofs] Oneof descriptors
 * @property {Object.<string,IField>} fields Field descriptors
 * @property {number[][]} [extensions] Extension ranges
 * @property {Array.<number[]|string>} [reserved] Reserved ranges
 * @property {boolean} [group=false] Whether a legacy group or not
 */ /**
 * Creates a message type from a message type descriptor.
 * @param {string} name Message name
 * @param {IType} json Message type descriptor
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Type} Created message type
 */ $f2b25c8c7de96169$var$Type.fromJSON = function fromJSON(name, json, depth) {
    if (depth === undefined) depth = 0;
    if (depth > $jshGU.nestingLimit) throw Error("max depth exceeded");
    var type = new $f2b25c8c7de96169$var$Type(name, json.options);
    type.extensions = json.extensions;
    type.reserved = json.reserved;
    var names = Object.keys(json.fields), i = 0;
    for(; i < names.length; ++i)type.add((typeof json.fields[names[i]].keyType !== "undefined" ? $80tkS.fromJSON : $fMEB1.fromJSON)(names[i], json.fields[names[i]]));
    if (json.oneofs) for(names = Object.keys(json.oneofs), i = 0; i < names.length; ++i)type.add($8DQkR.fromJSON(names[i], json.oneofs[names[i]]));
    if (json.nested) for(names = Object.keys(json.nested), i = 0; i < names.length; ++i){
        var nested = json.nested[names[i]];
        type.add((nested.id !== undefined ? $fMEB1.fromJSON : nested.fields !== undefined ? $f2b25c8c7de96169$var$Type.fromJSON : nested.values !== undefined ? $teZIn.fromJSON : nested.methods !== undefined ? $hqJin.fromJSON : $3keUm.fromJSON)(names[i], nested, depth + 1));
    }
    if (json.extensions && json.extensions.length) type.extensions = json.extensions;
    if (json.reserved && json.reserved.length) type.reserved = json.reserved;
    if (json.group) type.group = true;
    if (json.comment) type.comment = json.comment;
    if (json.edition) type._edition = json.edition;
    type._defaultEdition = "proto3"; // For backwards-compatibility.
    return type;
};
/**
 * Converts this message type to a message type descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IType} Message type descriptor
 */ $f2b25c8c7de96169$var$Type.prototype.toJSON = function toJSON(toJSONOptions) {
    var inherited = $3keUm.prototype.toJSON.call(this, toJSONOptions);
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "options",
        inherited && inherited.options || undefined,
        "oneofs",
        $3keUm.arrayToJSON(this.oneofsArray, toJSONOptions),
        "fields",
        $3keUm.arrayToJSON(this.fieldsArray.filter(function(obj) {
            return !obj.declaringField;
        }), toJSONOptions) || {},
        "extensions",
        this.extensions && this.extensions.length ? this.extensions : undefined,
        "reserved",
        this.reserved && this.reserved.length ? this.reserved : undefined,
        "group",
        this.group || undefined,
        "nested",
        inherited && inherited.nested || undefined,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * @override
 */ $f2b25c8c7de96169$var$Type.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    $3keUm.prototype.resolveAll.call(this);
    var oneofs = this.oneofsArray;
    i = 0;
    while(i < oneofs.length)oneofs[i++].resolve();
    var fields = this.fieldsArray, i = 0;
    while(i < fields.length)fields[i++].resolve();
    return this;
};
/**
 * @override
 */ $f2b25c8c7de96169$var$Type.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    if (!this._needsRecursiveFeatureResolution) return this;
    edition = this._edition || edition;
    $3keUm.prototype._resolveFeaturesRecursive.call(this, edition);
    this.oneofsArray.forEach((oneof)=>{
        oneof._resolveFeatures(edition);
    });
    this.fieldsArray.forEach((field)=>{
        field._resolveFeatures(edition);
    });
    return this;
};
/**
 * @override
 */ $f2b25c8c7de96169$var$Type.prototype.get = function get(name) {
    if (Object.prototype.hasOwnProperty.call(this.fields, name)) return this.fields[name];
    if (this.oneofs && Object.prototype.hasOwnProperty.call(this.oneofs, name)) return this.oneofs[name];
    if (this.nested && Object.prototype.hasOwnProperty.call(this.nested, name)) return this.nested[name];
    return null;
};
/**
 * Adds a nested object to this type.
 * @param {ReflectionObject} object Nested object to add
 * @returns {Type} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a nested object with this name or, if a field, when there is already a field with this id
 */ $f2b25c8c7de96169$var$Type.prototype.add = function add(object) {
    if (this.get(object.name)) throw Error("duplicate name '" + object.name + "' in " + this);
    if (object instanceof $fMEB1 && object.extend === undefined) {
        // NOTE: Extension fields aren't actual fields on the declaring type, but nested objects.
        // The root object takes care of adding distinct sister-fields to the respective extended
        // type instead.
        // avoids calling the getter if not absolutely necessary because it's called quite frequently
        if (this._fieldsById ? /* istanbul ignore next */ this._fieldsById[object.id] : this.fieldsById[object.id]) throw Error("duplicate id " + object.id + " in " + this);
        if (this.isReservedId(object.id)) throw Error("id " + object.id + " is reserved in " + this);
        if (this.isReservedName(object.name) || object.name.charAt(0) === "$") throw Error("name '" + object.name + "' is reserved in " + this);
        if (object.name === "__proto__") return this;
        if (object.parent) object.parent.remove(object);
        this.fields[object.name] = object;
        object.message = this;
        object.onAdd(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    if (object instanceof $8DQkR) {
        if (object.name.charAt(0) === "$") throw Error("name '" + object.name + "' is reserved in " + this);
        if (object.name === "__proto__") return this;
        if (!this.oneofs) this.oneofs = {};
        this.oneofs[object.name] = object;
        object.onAdd(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    return $3keUm.prototype.add.call(this, object);
};
/**
 * Removes a nested object from this type.
 * @param {ReflectionObject} object Nested object to remove
 * @returns {Type} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `object` is not a member of this type
 */ $f2b25c8c7de96169$var$Type.prototype.remove = function remove(object) {
    if (object instanceof $fMEB1 && object.extend === undefined) {
        // See Type#add for the reason why extension fields are excluded here.
        /* istanbul ignore if */ if (!this.fields || this.fields[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.fields[object.name];
        object.parent = null;
        object.onRemove(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    if (object instanceof $8DQkR) {
        /* istanbul ignore if */ if (!this.oneofs || this.oneofs[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.oneofs[object.name];
        object.parent = null;
        object.onRemove(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    return $3keUm.prototype.remove.call(this, object);
};
/**
 * Tests if the specified id is reserved.
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $f2b25c8c7de96169$var$Type.prototype.isReservedId = function isReservedId(id) {
    return $3keUm.isReservedId(this.reserved, id);
};
/**
 * Tests if the specified name is reserved.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $f2b25c8c7de96169$var$Type.prototype.isReservedName = function isReservedName(name) {
    return $3keUm.isReservedName(this.reserved, name);
};
/**
 * Creates a new message of this type using the specified properties.
 * @param {Object.<string,*>} [properties] Properties to set
 * @returns {Message<{}>} Message instance
 */ $f2b25c8c7de96169$var$Type.prototype.create = function create(properties) {
    return new this.ctor(properties);
};
/**
 * Sets up {@link Type#encode|encode}, {@link Type#decode|decode} and {@link Type#verify|verify}.
 * @returns {Type} `this`
 */ $f2b25c8c7de96169$var$Type.prototype.setup = function setup() {
    // Sets up everything at once so that the prototype chain does not have to be re-evaluated
    // multiple times (V8, soft-deopt prototype-check).
    var fullName = this.fullName, types = [];
    for(var i = 0; i < /* initializes */ this.fieldsArray.length; ++i)types.push(this._fieldsArray[i].resolve().resolvedType);
    // Replace setup methods with type-specific generated functions
    this.encode = $ekUKG(this)({
        Writer: $3KUVy,
        types: types,
        util: $jshGU
    });
    this.decode = $8D1oN(this)({
        Reader: $hP5zC,
        types: types,
        util: $jshGU
    });
    this.verify = $kfNH8(this)({
        types: types,
        util: $jshGU
    });
    this.fromObject = $iaLh4.fromObject(this)({
        types: types,
        util: $jshGU
    });
    this.toObject = $iaLh4.toObject(this)({
        types: types,
        util: $jshGU
    });
    // Inject custom wrappers for common types
    var wrapper = $9C7Ox[fullName];
    if (wrapper) {
        var originalThis = Object.create(this);
        // if (wrapper.fromObject) {
        originalThis.fromObject = this.fromObject;
        this.fromObject = wrapper.fromObject.bind(originalThis);
        // }
        // if (wrapper.toObject) {
        originalThis.toObject = this.toObject;
        this.toObject = wrapper.toObject.bind(originalThis);
    // }
    }
    return this;
};
/**
 * Encodes a message of this type. Does not implicitly {@link Type#verify|verify} messages.
 * @param {Message<{}>|Object.<string,*>} message Message instance or plain object
 * @param {Writer} [writer] Writer to encode to
 * @returns {Writer} writer
 */ $f2b25c8c7de96169$var$Type.prototype.encode = function encode_setup(message, writer) {
    return this.setup().encode.apply(this, arguments); // overrides this method
};
/**
 * Encodes a message of this type preceeded by its byte length as a varint. Does not implicitly {@link Type#verify|verify} messages.
 * @param {Message<{}>|Object.<string,*>} message Message instance or plain object
 * @param {Writer} [writer] Writer to encode to
 * @returns {Writer} writer
 */ $f2b25c8c7de96169$var$Type.prototype.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
};
/**
 * Decodes a message of this type.
 * @param {Reader|Uint8Array} reader Reader or buffer to decode from
 * @param {number} [length] Length of the message, if known beforehand
 * @param {number} [end] Expected group end tag, if decoding a group
 * @param {number} [depth] Current nesting depth
 * @returns {Message<{}>} Decoded message
 * @throws {Error} If the payload is not a reader or valid buffer
 * @throws {util.ProtocolError<{}>} If required fields are missing
 */ $f2b25c8c7de96169$var$Type.prototype.decode = function decode_setup(reader, length, end, depth) {
    return this.setup().decode(reader, length, end, depth); // overrides this method
};
/**
 * Decodes a message of this type preceeded by its byte length as a varint.
 * @param {Reader|Uint8Array} reader Reader or buffer to decode from
 * @returns {Message<{}>} Decoded message
 * @throws {Error} If the payload is not a reader or valid buffer
 * @throws {util.ProtocolError} If required fields are missing
 */ $f2b25c8c7de96169$var$Type.prototype.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $hP5zC)) reader = $hP5zC.create(reader);
    return this.decode(reader, reader.uint32());
};
/**
 * Verifies that field values are valid and that required fields are present.
 * @param {Object.<string,*>} message Plain object to verify
 * @param {number} [depth] Current nesting depth
 * @returns {null|string} `null` if valid, otherwise the reason why it is not
 */ $f2b25c8c7de96169$var$Type.prototype.verify = function verify_setup(message, depth) {
    return this.setup().verify(message, depth); // overrides this method
};
/**
 * Creates a new message of this type from a plain object. Also converts values to their respective internal types.
 * @param {Object.<string,*>} object Plain object to convert
 * @param {number} [depth] Current nesting depth
 * @returns {Message<{}>} Message instance
 */ $f2b25c8c7de96169$var$Type.prototype.fromObject = function fromObject(object, depth) {
    return this.setup().fromObject(object, depth);
};
/**
 * Conversion options as used by {@link Type#toObject} and {@link Message.toObject}.
 * @interface IConversionOptions
 * @property {Function} [longs] Long conversion type.
 * Valid values are `BigInt`, `String` and `Number` (the global types).
 * Defaults to copy the present value, which is a possibly unsafe number without and a {@link Long} with a long library.
 * @property {Function} [enums] Enum value conversion type.
 * Only valid value is `String` (the global type).
 * Defaults to copy the present value, which is the numeric id.
 * @property {Function} [bytes] Bytes value conversion type.
 * Valid values are `Array` and (a base64 encoded) `String` (the global types).
 * Defaults to copy the present value, which usually is a Buffer under node and an Uint8Array in the browser.
 * @property {boolean} [defaults=false] Also sets default values on the resulting object
 * @property {boolean} [arrays=false] Sets empty arrays for missing repeated fields even if `defaults=false`
 * @property {boolean} [objects=false] Sets empty objects for missing map fields even if `defaults=false`
 * @property {boolean} [oneofs=false] Includes virtual oneof properties set to the present field's name, if any
 * @property {boolean} [json=false] Performs additional JSON compatibility conversions, i.e. NaN and Infinity to strings
 */ /**
 * Creates a plain object from a message of this type. Also converts values to other types if specified.
 * @param {Message<{}>} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 */ $f2b25c8c7de96169$var$Type.prototype.toObject = function toObject(message, options) {
    return this.setup().toObject.apply(this, arguments);
};
/**
 * Decorator function as returned by {@link Type.d} (TypeScript).
 * @typedef TypeDecorator
 * @type {function}
 * @param {Constructor<T>} target Target constructor
 * @returns {undefined}
 * @template T extends Message<T>
 */ /**
 * Type decorator (TypeScript).
 * @param {string} [typeName] Type name, defaults to the constructor's name
 * @returns {TypeDecorator<T>} Decorator function
 * @template T extends Message<T>
 */ $f2b25c8c7de96169$var$Type.d = function decorateType(typeName) {
    return function typeDecorator(target) {
        $jshGU.decorateType(target, typeName);
    };
};

});
parcelRegister("3keUm", function(module, exports) {
"use strict";
module.exports = $26becdcd6379c642$var$Namespace;

var $eqXqI = parcelRequire("eqXqI");
(($26becdcd6379c642$var$Namespace.prototype = Object.create($eqXqI.prototype)).constructor = $26becdcd6379c642$var$Namespace).className = "Namespace";

var $fMEB1 = parcelRequire("fMEB1");

var $jshGU = parcelRequire("jshGU");

var $8DQkR = parcelRequire("8DQkR");
var $26becdcd6379c642$var$Type, $26becdcd6379c642$var$Service, $26becdcd6379c642$var$Enum;
/**
 * Constructs a new namespace instance.
 * @name Namespace
 * @classdesc Reflected namespace.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Namespace name
 * @param {Object.<string,*>} [options] Declared options
 */ /**
 * Constructs a namespace from JSON.
 * @memberof Namespace
 * @function
 * @param {string} name Namespace name
 * @param {Object.<string,*>} json JSON object
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Namespace} Created namespace
 * @throws {TypeError} If arguments are invalid
 */ $26becdcd6379c642$var$Namespace.fromJSON = function fromJSON(name, json, depth) {
    depth = $jshGU.checkDepth(depth);
    return new $26becdcd6379c642$var$Namespace(name, json.options).addJSON(json.nested, depth);
};
/**
 * Converts an array of reflection objects to JSON.
 * @memberof Namespace
 * @param {ReflectionObject[]} array Object array
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {Object.<string,*>|undefined} JSON object or `undefined` when array is empty
 */ function $26becdcd6379c642$var$arrayToJSON(array, toJSONOptions) {
    if (!(array && array.length)) return undefined;
    var obj = {};
    for(var i = 0; i < array.length; ++i)obj[array[i].name] = array[i].toJSON(toJSONOptions);
    return obj;
}
$26becdcd6379c642$var$Namespace.arrayToJSON = $26becdcd6379c642$var$arrayToJSON;
/**
 * Tests if the specified id is reserved.
 * @param {Array.<number[]|string>|undefined} reserved Array of reserved ranges and names
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $26becdcd6379c642$var$Namespace.isReservedId = function isReservedId(reserved, id) {
    if (reserved) {
        for(var i = 0; i < reserved.length; ++i)if (typeof reserved[i] !== "string" && reserved[i][0] <= id && reserved[i][1] > id) return true;
    }
    return false;
};
/**
 * Tests if the specified name is reserved.
 * @param {Array.<number[]|string>|undefined} reserved Array of reserved ranges and names
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $26becdcd6379c642$var$Namespace.isReservedName = function isReservedName(reserved, name) {
    if (reserved) {
        for(var i = 0; i < reserved.length; ++i)if (reserved[i] === name) return true;
    }
    return false;
};
/**
 * Not an actual constructor. Use {@link Namespace} instead.
 * @classdesc Base class of all reflection objects containing nested objects. This is not an actual class but here for the sake of having consistent type definitions.
 * @exports NamespaceBase
 * @extends ReflectionObject
 * @abstract
 * @constructor
 * @param {string} name Namespace name
 * @param {Object.<string,*>} [options] Declared options
 * @see {@link Namespace}
 */ function $26becdcd6379c642$var$Namespace(name, options) {
    $eqXqI.call(this, name, options);
    /**
     * Nested objects by name.
     * @type {Object.<string,ReflectionObject>|undefined}
     */ this.nested = undefined; // toJSON
    /**
     * Cached nested objects as an array.
     * @type {ReflectionObject[]|null}
     * @private
     */ this._nestedArray = null;
    /**
     * Cache lookup calls for any objects contains anywhere under this namespace.
     * This drastically speeds up resolve for large cross-linked protos where the same
     * types are looked up repeatedly.
     * @type {Object.<string,ReflectionObject|null>}
     * @private
     */ this._lookupCache = Object.create(null);
    /**
     * Whether or not objects contained in this namespace need feature resolution.
     * @type {boolean}
     * @protected
     */ this._needsRecursiveFeatureResolution = true;
    /**
     * Whether or not objects contained in this namespace need a resolve.
     * @type {boolean}
     * @protected
     */ this._needsRecursiveResolve = true;
}
function $26becdcd6379c642$var$clearCache(namespace) {
    namespace._nestedArray = null;
    namespace._lookupCache = Object.create(null);
    // Also clear parent caches, since they include nested lookups.
    var parent = namespace;
    while(parent = parent.parent)parent._lookupCache = Object.create(null);
    return namespace;
}
/**
 * Nested objects of this namespace as an array for iteration.
 * @name NamespaceBase#nestedArray
 * @type {ReflectionObject[]}
 * @readonly
 */ Object.defineProperty($26becdcd6379c642$var$Namespace.prototype, "nestedArray", {
    get: function() {
        return this._nestedArray || (this._nestedArray = $jshGU.toArray(this.nested));
    }
});
/**
 * Namespace descriptor.
 * @interface INamespace
 * @property {Object.<string,*>} [options] Namespace options
 * @property {Object.<string,AnyNestedObject>} [nested] Nested object descriptors
 */ /**
 * Any extension field descriptor.
 * @typedef AnyExtensionField
 * @type {IExtensionField|IExtensionMapField}
 */ /**
 * Any nested object descriptor.
 * @typedef AnyNestedObject
 * @type {IEnum|IType|IService|AnyExtensionField|INamespace|IOneOf}
 */ /**
 * Converts this namespace to a namespace descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {INamespace} Namespace descriptor
 */ $26becdcd6379c642$var$Namespace.prototype.toJSON = function toJSON(toJSONOptions) {
    return $jshGU.toObject([
        "options",
        this.options,
        "nested",
        $26becdcd6379c642$var$arrayToJSON(this.nestedArray, toJSONOptions)
    ]);
};
/**
 * Adds nested objects to this namespace from nested object descriptors.
 * @param {Object.<string,AnyNestedObject>} nestedJson Any nested object descriptors
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Namespace} `this`
 */ $26becdcd6379c642$var$Namespace.prototype.addJSON = function addJSON(nestedJson, depth) {
    depth = $jshGU.checkDepth(depth);
    var ns = this;
    /* istanbul ignore else */ if (nestedJson) for(var names = Object.keys(nestedJson), i = 0, nested; i < names.length; ++i){
        nested = nestedJson[names[i]];
        ns.add((nested.fields !== undefined ? $26becdcd6379c642$var$Type.fromJSON : nested.values !== undefined ? $26becdcd6379c642$var$Enum.fromJSON : nested.methods !== undefined ? $26becdcd6379c642$var$Service.fromJSON : nested.id !== undefined ? $fMEB1.fromJSON : $26becdcd6379c642$var$Namespace.fromJSON)(names[i], nested, depth + 1));
    }
    return this;
};
/**
 * Gets the nested object of the specified name.
 * @param {string} name Nested object name
 * @returns {ReflectionObject|null} The reflection object or `null` if it doesn't exist
 */ $26becdcd6379c642$var$Namespace.prototype.get = function get(name) {
    return this.nested && Object.prototype.hasOwnProperty.call(this.nested, name) ? this.nested[name] : null;
};
/**
 * Gets the values of the nested {@link Enum|enum} of the specified name.
 * This methods differs from {@link Namespace#get|get} in that it returns an enum's values directly and throws instead of returning `null`.
 * @param {string} name Nested enum name
 * @returns {Object.<string,number>} Enum values
 * @throws {Error} If there is no such enum
 */ $26becdcd6379c642$var$Namespace.prototype.getEnum = function getEnum(name) {
    if (this.nested && Object.prototype.hasOwnProperty.call(this.nested, name) && this.nested[name] instanceof $26becdcd6379c642$var$Enum) return this.nested[name].values;
    throw Error("no such enum: " + name);
};
/**
 * Adds a nested object to this namespace.
 * @param {ReflectionObject} object Nested object to add
 * @returns {Namespace} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a nested object with this name
 */ $26becdcd6379c642$var$Namespace.prototype.add = function add(object) {
    if (!(object instanceof $fMEB1 && object.extend !== undefined || object instanceof $26becdcd6379c642$var$Type || object instanceof $8DQkR || object instanceof $26becdcd6379c642$var$Enum || object instanceof $26becdcd6379c642$var$Service || object instanceof $26becdcd6379c642$var$Namespace)) throw TypeError("object must be a valid nested object");
    if (object.name === "__proto__") return this;
    if (!this.nested) this.nested = {};
    else {
        var prev = this.get(object.name);
        if (prev) {
            if (prev instanceof $26becdcd6379c642$var$Namespace && object instanceof $26becdcd6379c642$var$Namespace && !(prev instanceof $26becdcd6379c642$var$Type || prev instanceof $26becdcd6379c642$var$Service)) {
                // replace plain namespace but keep existing nested elements and options
                var nested = prev.nestedArray;
                for(var i = 0; i < nested.length; ++i)object.add(nested[i]);
                this.remove(prev);
                if (!this.nested) this.nested = {};
                object.setOptions(prev.options, true);
            } else throw Error("duplicate name '" + object.name + "' in " + this);
        }
    }
    this.nested[object.name] = object;
    if (!(this instanceof $26becdcd6379c642$var$Type || this instanceof $26becdcd6379c642$var$Service || this instanceof $26becdcd6379c642$var$Enum || this instanceof $fMEB1)) // This is a package or a root namespace.
    {
        if (!object._edition) // Make sure that some edition is set if it hasn't already been specified.
        object._edition = object._defaultEdition;
    }
    this._needsRecursiveFeatureResolution = true;
    this._needsRecursiveResolve = true;
    // Also clear parent caches, since they need to recurse down.
    var parent = this;
    while(parent = parent.parent){
        parent._needsRecursiveFeatureResolution = true;
        parent._needsRecursiveResolve = true;
    }
    object.onAdd(this);
    return $26becdcd6379c642$var$clearCache(this);
};
/**
 * Removes a nested object from this namespace.
 * @param {ReflectionObject} object Nested object to remove
 * @returns {Namespace} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `object` is not a member of this namespace
 */ $26becdcd6379c642$var$Namespace.prototype.remove = function remove(object) {
    if (!(object instanceof $eqXqI)) throw TypeError("object must be a ReflectionObject");
    if (object.parent !== this) throw Error(object + " is not a member of " + this);
    delete this.nested[object.name];
    if (!Object.keys(this.nested).length) this.nested = undefined;
    object.onRemove(this);
    return $26becdcd6379c642$var$clearCache(this);
};
/**
 * Defines additial namespaces within this one if not yet existing.
 * @param {string|string[]} path Path to create
 * @param {*} [json] Nested types to create from JSON
 * @returns {Namespace} Pointer to the last namespace created or `this` if path is empty
 */ $26becdcd6379c642$var$Namespace.prototype.define = function define(path, json) {
    if ($jshGU.isString(path)) path = path.split(".");
    else if (!Array.isArray(path)) throw TypeError("illegal path");
    if (path && path.length && path[0] === "") throw Error("path must be relative");
    if (path.length > $jshGU.recursionLimit) throw Error("max depth exceeded");
    var ptr = this;
    while(path.length > 0){
        var part = path.shift();
        if (ptr.nested && ptr.nested[part]) {
            ptr = ptr.nested[part];
            if (!(ptr instanceof $26becdcd6379c642$var$Namespace)) throw Error("path conflicts with non-namespace objects");
        } else ptr.add(ptr = new $26becdcd6379c642$var$Namespace(part));
    }
    if (json) ptr.addJSON(json);
    return ptr;
};
/**
 * Resolves this namespace's and all its nested objects' type references. Useful to validate a reflection tree, but comes at a cost.
 * @returns {Namespace} `this`
 */ $26becdcd6379c642$var$Namespace.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    this._resolveFeaturesRecursive(this._edition);
    var nested = this.nestedArray, i = 0;
    this.resolve();
    while(i < nested.length)if (nested[i] instanceof $26becdcd6379c642$var$Namespace) nested[i++].resolveAll();
    else nested[i++].resolve();
    this._needsRecursiveResolve = false;
    return this;
};
/**
 * @override
 */ $26becdcd6379c642$var$Namespace.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    if (!this._needsRecursiveFeatureResolution) return this;
    this._needsRecursiveFeatureResolution = false;
    edition = this._edition || edition;
    $eqXqI.prototype._resolveFeaturesRecursive.call(this, edition);
    this.nestedArray.forEach((nested)=>{
        nested._resolveFeaturesRecursive(edition);
    });
    return this;
};
/**
 * Recursively looks up the reflection object matching the specified path in the scope of this namespace.
 * @param {string|string[]} path Path to look up
 * @param {*|Array.<*>} filterTypes Filter types, any combination of the constructors of `protobuf.Type`, `protobuf.Enum`, `protobuf.Service` etc.
 * @param {boolean} [parentAlreadyChecked=false] If known, whether the parent has already been checked
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 */ $26becdcd6379c642$var$Namespace.prototype.lookup = function lookup(path, filterTypes, parentAlreadyChecked) {
    /* istanbul ignore next */ if (typeof filterTypes === "boolean") {
        parentAlreadyChecked = filterTypes;
        filterTypes = undefined;
    } else if (filterTypes && !Array.isArray(filterTypes)) filterTypes = [
        filterTypes
    ];
    if ($jshGU.isString(path) && path.length) {
        if (path === ".") return this.root;
        path = path.split(".");
    } else if (!path.length) return this;
    var flatPath = path.join(".");
    // Start at root if path is absolute
    if (path[0] === "") return this.root.lookup(path.slice(1), filterTypes);
    // Early bailout for objects with matching absolute paths
    var found = this.root._fullyQualifiedObjects && this.root._fullyQualifiedObjects["." + flatPath];
    if (found && (!filterTypes || filterTypes.indexOf(found.constructor) > -1)) return found;
    // Do a regular lookup at this namespace and below
    found = this._lookupImpl(path, flatPath);
    if (found && (!filterTypes || filterTypes.indexOf(found.constructor) > -1)) return found;
    if (parentAlreadyChecked) return null;
    // If there hasn't been a match, walk up the tree and look more broadly
    var current = this;
    while(current.parent){
        found = current.parent._lookupImpl(path, flatPath);
        if (found && (!filterTypes || filterTypes.indexOf(found.constructor) > -1)) return found;
        current = current.parent;
    }
    return null;
};
/**
 * Internal helper for lookup that handles searching just at this namespace and below along with caching.
 * @param {string[]} path Path to look up
 * @param {string} flatPath Flattened version of the path to use as a cache key
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 * @private
 */ $26becdcd6379c642$var$Namespace.prototype._lookupImpl = function lookup(path, flatPath) {
    if (Object.prototype.hasOwnProperty.call(this._lookupCache, flatPath)) return this._lookupCache[flatPath];
    // Test if the first part matches any nested object, and if so, traverse if path contains more
    var found = this.get(path[0]);
    var exact = null;
    if (found) {
        if (path.length === 1) exact = found;
        else if (found instanceof $26becdcd6379c642$var$Namespace) {
            path = path.slice(1);
            exact = found._lookupImpl(path, path.join("."));
        }
    // Otherwise try each nested namespace
    } else {
        for(var i = 0; i < this.nestedArray.length; ++i)if (this._nestedArray[i] instanceof $26becdcd6379c642$var$Namespace && (found = this._nestedArray[i]._lookupImpl(path, flatPath))) {
            exact = found;
            break;
        }
    }
    // Set this even when null, so that when we walk up the tree we can quickly bail on repeated checks back down.
    this._lookupCache[flatPath] = exact;
    return exact;
};
/**
 * Looks up the reflection object at the specified path, relative to this namespace.
 * @name NamespaceBase#lookup
 * @function
 * @param {string|string[]} path Path to look up
 * @param {boolean} [parentAlreadyChecked=false] Whether the parent has already been checked
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 * @variation 2
 */ // lookup(path: string, [parentAlreadyChecked: boolean])
/**
 * Looks up the {@link Type|type} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Type} Looked up type
 * @throws {Error} If `path` does not point to a type
 */ $26becdcd6379c642$var$Namespace.prototype.lookupType = function lookupType(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Type
    ]);
    if (!found) throw Error("no such type: " + path);
    return found;
};
/**
 * Looks up the values of the {@link Enum|enum} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Enum} Looked up enum
 * @throws {Error} If `path` does not point to an enum
 */ $26becdcd6379c642$var$Namespace.prototype.lookupEnum = function lookupEnum(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Enum
    ]);
    if (!found) throw Error("no such Enum '" + path + "' in " + this);
    return found;
};
/**
 * Looks up the {@link Type|type} or {@link Enum|enum} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Type} Looked up type or enum
 * @throws {Error} If `path` does not point to a type or enum
 */ $26becdcd6379c642$var$Namespace.prototype.lookupTypeOrEnum = function lookupTypeOrEnum(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Type,
        $26becdcd6379c642$var$Enum
    ]);
    if (!found) throw Error("no such Type or Enum '" + path + "' in " + this);
    return found;
};
/**
 * Looks up the {@link Service|service} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Service} Looked up service
 * @throws {Error} If `path` does not point to a service
 */ $26becdcd6379c642$var$Namespace.prototype.lookupService = function lookupService(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Service
    ]);
    if (!found) throw Error("no such Service '" + path + "' in " + this);
    return found;
};
// Sets up cyclic dependencies (called in index-light)
$26becdcd6379c642$var$Namespace._configure = function(Type_, Service_, Enum_) {
    $26becdcd6379c642$var$Type = Type_;
    $26becdcd6379c642$var$Service = Service_;
    $26becdcd6379c642$var$Enum = Enum_;
};

});

parcelRegister("80tkS", function(module, exports) {
"use strict";
module.exports = $5d45144450ee0279$var$MapField;

var $fMEB1 = parcelRequire("fMEB1");
(($5d45144450ee0279$var$MapField.prototype = Object.create($fMEB1.prototype)).constructor = $5d45144450ee0279$var$MapField).className = "MapField";

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new map field instance.
 * @classdesc Reflected map field.
 * @extends FieldBase
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} keyType Key type
 * @param {string} type Value type
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $5d45144450ee0279$var$MapField(name, id, keyType, type, options, comment) {
    $fMEB1.call(this, name, id, type, undefined, undefined, options, comment);
    /* istanbul ignore if */ if (!$jshGU.isString(keyType)) throw TypeError("keyType must be a string");
    /**
     * Key type.
     * @type {string}
     */ this.keyType = keyType; // toJSON, marker
    /**
     * Resolved key type if not a basic type.
     * @type {ReflectionObject|null}
     */ this.resolvedKeyType = null;
    // Overrides Field#map
    this.map = true;
}
/**
 * Map field descriptor.
 * @interface IMapField
 * @extends {IField}
 * @property {string} keyType Key type
 */ /**
 * Extension map field descriptor.
 * @interface IExtensionMapField
 * @extends IMapField
 * @property {string} extend Extended type
 */ /**
 * Constructs a map field from a map field descriptor.
 * @param {string} name Field name
 * @param {IMapField} json Map field descriptor
 * @returns {MapField} Created map field
 * @throws {TypeError} If arguments are invalid
 */ $5d45144450ee0279$var$MapField.fromJSON = function fromJSON(name, json) {
    return new $5d45144450ee0279$var$MapField(name, json.id, json.keyType, json.type, json.options, json.comment);
};
/**
 * Converts this map field to a map field descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IMapField} Map field descriptor
 */ $5d45144450ee0279$var$MapField.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "keyType",
        this.keyType,
        "type",
        this.type,
        "id",
        this.id,
        "extend",
        this.extend,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * @override
 */ $5d45144450ee0279$var$MapField.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    // Besides a value type, map fields have a key type that may be "any scalar type except for floating point types and bytes"
    if ($keBMp.mapKey[this.keyType] === undefined) throw Error("invalid key type: " + this.keyType);
    return $fMEB1.prototype.resolve.call(this);
};
/**
 * Map field decorator (TypeScript).
 * @name MapField.d
 * @function
 * @param {number} fieldId Field id
 * @param {"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"bool"|"string"} fieldKeyType Field key type
 * @param {"double"|"float"|"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"bool"|"string"|"bytes"|Object|Constructor<{}>} fieldValueType Field value type
 * @returns {FieldDecorator} Decorator function
 * @template T extends { [key: string]: number | Long | string | boolean | Uint8Array | Buffer | number[] | Message<{}> }
 */ $5d45144450ee0279$var$MapField.d = function decorateMapField(fieldId, fieldKeyType, fieldValueType) {
    // submessage value: decorate the submessage and use its name as the type
    if (typeof fieldValueType === "function") fieldValueType = $jshGU.decorateType(fieldValueType).name;
    else if (fieldValueType && typeof fieldValueType === "object") fieldValueType = $jshGU.decorateEnum(fieldValueType).name;
    return function mapFieldDecorator(prototype, fieldName) {
        $jshGU.decorateType(prototype.constructor).add(new $5d45144450ee0279$var$MapField(fieldName, fieldId, fieldKeyType, fieldValueType));
    };
};

});

parcelRegister("hqJin", function(module, exports) {
"use strict";
module.exports = $cb080016f4e98073$var$Service;

var $3keUm = parcelRequire("3keUm");
(($cb080016f4e98073$var$Service.prototype = Object.create($3keUm.prototype)).constructor = $cb080016f4e98073$var$Service).className = "Service";

var $3lwwS = parcelRequire("3lwwS");

var $jshGU = parcelRequire("jshGU");

var $kPAIY = parcelRequire("kPAIY");
/**
 * Constructs a new service instance.
 * @classdesc Reflected service.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Service name
 * @param {Object.<string,*>} [options] Service options
 * @throws {TypeError} If arguments are invalid
 */ function $cb080016f4e98073$var$Service(name, options) {
    $3keUm.call(this, name, options);
    /**
     * Service methods.
     * @type {Object.<string,Method>}
     */ this.methods = {}; // toJSON, marker
    /**
     * Cached methods as an array.
     * @type {Method[]|null}
     * @private
     */ this._methodsArray = null;
}
/**
 * Service descriptor.
 * @interface IService
 * @extends INamespace
 * @property {Object.<string,IMethod>} methods Method descriptors
 */ /**
 * Constructs a service from a service descriptor.
 * @param {string} name Service name
 * @param {IService} json Service descriptor
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Service} Created service
 * @throws {TypeError} If arguments are invalid
 */ $cb080016f4e98073$var$Service.fromJSON = function fromJSON(name, json, depth) {
    depth = $jshGU.checkDepth(depth);
    var service = new $cb080016f4e98073$var$Service(name, json.options);
    /* istanbul ignore else */ if (json.methods) for(var names = Object.keys(json.methods), i = 0; i < names.length; ++i)service.add($3lwwS.fromJSON(names[i], json.methods[names[i]]));
    if (json.nested) service.addJSON(json.nested, depth);
    if (json.edition) service._edition = json.edition;
    service.comment = json.comment;
    service._defaultEdition = "proto3"; // For backwards-compatibility.
    return service;
};
/**
 * Converts this service to a service descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IService} Service descriptor
 */ $cb080016f4e98073$var$Service.prototype.toJSON = function toJSON(toJSONOptions) {
    var inherited = $3keUm.prototype.toJSON.call(this, toJSONOptions);
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "options",
        inherited && inherited.options || undefined,
        "methods",
        $3keUm.arrayToJSON(this.methodsArray, toJSONOptions) || /* istanbul ignore next */ {},
        "nested",
        inherited && inherited.nested || undefined,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Methods of this service as an array for iteration.
 * @name Service#methodsArray
 * @type {Method[]}
 * @readonly
 */ Object.defineProperty($cb080016f4e98073$var$Service.prototype, "methodsArray", {
    get: function() {
        return this._methodsArray || (this._methodsArray = $jshGU.toArray(this.methods));
    }
});
function $cb080016f4e98073$var$clearCache(service) {
    service._methodsArray = null;
    return service;
}
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.get = function get(name) {
    return Object.prototype.hasOwnProperty.call(this.methods, name) ? this.methods[name] : $3keUm.prototype.get.call(this, name);
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    $3keUm.prototype.resolve.call(this);
    var methods = this.methodsArray;
    for(var i = 0; i < methods.length; ++i)methods[i].resolve();
    return this;
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    if (!this._needsRecursiveFeatureResolution) return this;
    edition = this._edition || edition;
    $3keUm.prototype._resolveFeaturesRecursive.call(this, edition);
    this.methodsArray.forEach((method)=>{
        method._resolveFeaturesRecursive(edition);
    });
    return this;
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.add = function add(object) {
    /* istanbul ignore if */ if (this.get(object.name)) throw Error("duplicate name '" + object.name + "' in " + this);
    if (object instanceof $3lwwS) {
        if (object.name === "__proto__") return this;
        this.methods[object.name] = object;
        object.parent = this;
        return $cb080016f4e98073$var$clearCache(this);
    }
    return $3keUm.prototype.add.call(this, object);
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.remove = function remove(object) {
    if (object instanceof $3lwwS) {
        /* istanbul ignore if */ if (this.methods[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.methods[object.name];
        object.parent = null;
        return $cb080016f4e98073$var$clearCache(this);
    }
    return $3keUm.prototype.remove.call(this, object);
};
/**
 * Creates a runtime service using the specified rpc implementation.
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 * @returns {rpc.Service} RPC service. Useful where requests and/or responses are streamed.
 */ $cb080016f4e98073$var$Service.prototype.create = function create(rpcImpl, requestDelimited, responseDelimited) {
    var rpcService = new $kPAIY.Service(rpcImpl, requestDelimited, responseDelimited);
    for(var i = 0, method; i < /* initializes */ this.methodsArray.length; ++i){
        var methodName = $jshGU.lcFirst((method = this._methodsArray[i]).resolve().name).replace(/[^$\w_]/g, "");
        rpcService[methodName] = function(method, requestType, responseType) {
            return function rpcMethod(request, callback) {
                return $kPAIY.Service.prototype.rpcCall.call(this, method, requestType, responseType, request, callback);
            };
        }(method, method.resolvedRequestType.ctor, method.resolvedResponseType.ctor);
    }
    return rpcService;
};

});
parcelRegister("3lwwS", function(module, exports) {
"use strict";
module.exports = $26fc90ea21b9b882$var$Method;

var $eqXqI = parcelRequire("eqXqI");
(($26fc90ea21b9b882$var$Method.prototype = Object.create($eqXqI.prototype)).constructor = $26fc90ea21b9b882$var$Method).className = "Method";

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new service method instance.
 * @classdesc Reflected service method.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Method name
 * @param {string|undefined} type Method type, usually `"rpc"`
 * @param {string} requestType Request message type
 * @param {string} responseType Response message type
 * @param {boolean|Object.<string,*>} [requestStream] Whether the request is streamed
 * @param {boolean|Object.<string,*>} [responseStream] Whether the response is streamed
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] The comment for this method
 * @param {Object.<string,*>} [parsedOptions] Declared options, properly parsed into an object
 */ function $26fc90ea21b9b882$var$Method(name, type, requestType, responseType, requestStream, responseStream, options, comment, parsedOptions) {
    /* istanbul ignore next */ if ($jshGU.isObject(requestStream)) {
        options = requestStream;
        requestStream = responseStream = undefined;
    } else if ($jshGU.isObject(responseStream)) {
        options = responseStream;
        responseStream = undefined;
    }
    /* istanbul ignore if */ if (!(type === undefined || $jshGU.isString(type))) throw TypeError("type must be a string");
    /* istanbul ignore if */ if (!$jshGU.isString(requestType)) throw TypeError("requestType must be a string");
    /* istanbul ignore if */ if (!$jshGU.isString(responseType)) throw TypeError("responseType must be a string");
    $eqXqI.call(this, name, options);
    /**
     * Method type.
     * @type {string}
     */ this.type = type || "rpc"; // toJSON
    /**
     * Request type.
     * @type {string}
     */ this.requestType = requestType; // toJSON, marker
    /**
     * Whether requests are streamed or not.
     * @type {boolean|undefined}
     */ this.requestStream = requestStream ? true : undefined; // toJSON
    /**
     * Response type.
     * @type {string}
     */ this.responseType = responseType; // toJSON
    /**
     * Whether responses are streamed or not.
     * @type {boolean|undefined}
     */ this.responseStream = responseStream ? true : undefined; // toJSON
    /**
     * Resolved request type.
     * @type {Type|null}
     */ this.resolvedRequestType = null;
    /**
     * Resolved response type.
     * @type {Type|null}
     */ this.resolvedResponseType = null;
    /**
     * Comment for this method
     * @type {string|null}
     */ this.comment = comment;
    /**
     * Options properly parsed into an object
     */ this.parsedOptions = parsedOptions;
}
/**
 * Method descriptor.
 * @interface IMethod
 * @property {string} [type="rpc"] Method type
 * @property {string} requestType Request type
 * @property {string} responseType Response type
 * @property {boolean} [requestStream=false] Whether requests are streamed
 * @property {boolean} [responseStream=false] Whether responses are streamed
 * @property {Object.<string,*>} [options] Method options
 * @property {string} comment Method comments
 * @property {Object.<string,*>} [parsedOptions] Method options properly parsed into an object
 */ /**
 * Constructs a method from a method descriptor.
 * @param {string} name Method name
 * @param {IMethod} json Method descriptor
 * @returns {Method} Created method
 * @throws {TypeError} If arguments are invalid
 */ $26fc90ea21b9b882$var$Method.fromJSON = function fromJSON(name, json) {
    return new $26fc90ea21b9b882$var$Method(name, json.type, json.requestType, json.responseType, json.requestStream, json.responseStream, json.options, json.comment, json.parsedOptions);
};
/**
 * Converts this method to a method descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IMethod} Method descriptor
 */ $26fc90ea21b9b882$var$Method.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "type",
        this.type !== "rpc" && /* istanbul ignore next */ this.type || undefined,
        "requestType",
        this.requestType,
        "requestStream",
        this.requestStream,
        "responseType",
        this.responseType,
        "responseStream",
        this.responseStream,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined,
        "parsedOptions",
        this.parsedOptions
    ]);
};
/**
 * @override
 */ $26fc90ea21b9b882$var$Method.prototype.resolve = function resolve() {
    /* istanbul ignore if */ if (this.resolved) return this;
    this.resolvedRequestType = this.parent.lookupType(this.requestType);
    this.resolvedResponseType = this.parent.lookupType(this.responseType);
    return $eqXqI.prototype.resolve.call(this);
};

});


parcelRegister("gLmvK", function(module, exports) {
"use strict";
module.exports = $c3427f5ddb23f4c4$var$Message;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new message instance.
 * @classdesc Abstract runtime message.
 * @constructor
 * @param {Properties<T>} [properties] Properties to set
 * @template T extends object = object
 */ function $c3427f5ddb23f4c4$var$Message(properties) {
    // not used internally
    if (properties) for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i){
        var key = keys[i];
        if (key === "__proto__") continue;
        this[key] = properties[key];
    }
}
/**
 * Reference to the reflected type.
 * @name Message.$type
 * @type {Type}
 * @readonly
 */ /**
 * Reference to the reflected type.
 * @name Message#$type
 * @type {Type}
 * @readonly
 */ /*eslint-disable valid-jsdoc*/ /**
 * Creates a new message of this type using the specified properties.
 * @param {Object.<string,*>} [properties] Properties to set
 * @returns {Message<T>} Message instance
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.create = function create(properties) {
    return this.$type.create(properties);
};
/**
 * Encodes a message of this type.
 * @param {T|Object.<string,*>} message Message to encode
 * @param {Writer} [writer] Writer to use
 * @returns {Writer} Writer
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.encode = function encode(message, writer) {
    return this.$type.encode(message, writer);
};
/**
 * Encodes a message of this type preceeded by its length as a varint.
 * @param {T|Object.<string,*>} message Message to encode
 * @param {Writer} [writer] Writer to use
 * @returns {Writer} Writer
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.encodeDelimited = function encodeDelimited(message, writer) {
    return this.$type.encodeDelimited(message, writer);
};
/**
 * Decodes a message of this type.
 * @name Message.decode
 * @function
 * @param {Reader|Uint8Array} reader Reader or buffer to decode
 * @returns {T} Decoded message
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.decode = function decode(reader) {
    return this.$type.decode(reader);
};
/**
 * Decodes a message of this type preceeded by its length as a varint.
 * @name Message.decodeDelimited
 * @function
 * @param {Reader|Uint8Array} reader Reader or buffer to decode
 * @returns {T} Decoded message
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.decodeDelimited = function decodeDelimited(reader) {
    return this.$type.decodeDelimited(reader);
};
/**
 * Verifies a message of this type.
 * @name Message.verify
 * @function
 * @param {Object.<string,*>} message Plain object to verify
 * @returns {string|null} `null` if valid, otherwise the reason why it is not
 */ $c3427f5ddb23f4c4$var$Message.verify = function verify(message) {
    return this.$type.verify(message);
};
/**
 * Creates a new message of this type from a plain object. Also converts values to their respective internal types.
 * @param {Object.<string,*>} object Plain object
 * @returns {T} Message instance
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.fromObject = function fromObject(object) {
    return this.$type.fromObject(object);
};
/**
 * Creates a plain object from a message of this type. Also converts values to other types if specified.
 * @param {T} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.toObject = function toObject(message, options) {
    return this.$type.toObject(message, options);
};
/**
 * Converts this message to JSON.
 * @returns {Object.<string,*>} JSON object
 */ $c3427f5ddb23f4c4$var$Message.prototype.toJSON = function toJSON() {
    return this.$type.toObject(this, $hf2LF.toJSONOptions);
}; /*eslint-enable valid-jsdoc*/ 

});

parcelRegister("8D1oN", function(module, exports) {
"use strict";
module.exports = $64830d0f853fe0da$var$decoder;

var $teZIn = parcelRequire("teZIn");

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
function $64830d0f853fe0da$var$missing(field) {
    return "missing required '" + field.name + "'";
}
/**
 * Generates a decoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $64830d0f853fe0da$var$decoder(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $jshGU.codegen([
        "r",
        "l",
        "e",
        "n"
    ], mtype.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("if(n===undefined)n=0")("if(n>Reader.recursionLimit)")("throw Error(\"maximum nesting depth exceeded\")")("var c,m" + (mtype.fieldsArray.filter(function(field) {
        return field.map;
    }).length ? ",k,value" : ""))("if(l===undefined)")("c=r.len")("else{")("c=r.pos+l")("if(c>r.len)")("throw RangeError(\"index out of range\")")("l=r.len")("r.len=c")("}")("m=new this.ctor")("while(r.pos<c){")("var t=r.uint32()")("if(t===e)")("break")("switch(t>>>3){");
    var i = 0;
    for(; i < /* initializes */ mtype.fieldsArray.length; ++i){
        var field = mtype._fieldsArray[i].resolve(), type = field.resolvedType instanceof $teZIn ? "int32" : field.type, ref = "m" + $jshGU.safeProp(field.name);
        gen("case %i: {", field.id);
        // Map fields
        if (field.map) {
            gen("if(%s===util.emptyObject)", ref)("%s={}", ref)("var c2=r.uint32()+r.pos")("if(c2>r.len)")("throw RangeError(\"index out of range\")")("r.len=c2");
            if ($keBMp.defaults[field.keyType] !== undefined) gen("k=%j", $keBMp.defaults[field.keyType]);
            else gen("k=null");
            if ($keBMp.defaults[type] !== undefined) gen("value=%j", $keBMp.defaults[type]);
            else gen("value=null");
            gen("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", field.keyType)("case 2:");
            if ($keBMp.basic[type] === undefined) gen("value=types[%i].decode(r,r.uint32(),undefined,n+1)", i); // can't be groups
            else gen("value=r.%s()", type);
            gen("break")("default:")("r.skipType(tag2&7,n)")("break")("}")("}")("if(r.pos!==c2)")("throw RangeError(\"index out of range\")")("r.len=c");
            if ($keBMp.long[field.keyType] !== undefined) gen("%s[typeof k===\"object\"?util.longToHash(k):k]=value", ref);
            else {
                if (field.keyType === "string") gen("if(k===\"__proto__\")")("util.makeProp(%s,k)", ref);
                gen("%s[k]=value", ref);
            }
        // Repeated fields
        } else if (field.repeated) {
            gen("if(!(%s&&%s.length))", ref, ref)("%s=[]", ref);
            // Packable (always check for forward and backward compatiblity)
            if ($keBMp.packed[type] !== undefined) gen("if((t&7)===2){")("var c2=r.uint32()+r.pos")("if(c2>r.len)")("throw RangeError(\"index out of range\")")("r.len=c2")("while(r.pos<c2)")("%s.push(r.%s())", ref, type)("if(r.pos!==c2)")("throw RangeError(\"index out of range\")")("r.len=c")("}else");
            // Non-packed
            if ($keBMp.basic[type] === undefined) gen(field.delimited ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4),n+1))" : "%s.push(types[%i].decode(r,r.uint32(),undefined,n+1))", ref, i);
            else gen("%s.push(r.%s())", ref, type);
        // Non-repeated
        } else if ($keBMp.basic[type] === undefined) gen(field.delimited ? "%s=types[%i].decode(r,undefined,((t&~7)|4),n+1)" : "%s=types[%i].decode(r,r.uint32(),undefined,n+1)", ref, i);
        else gen("%s=r.%s()", ref, type);
        gen("break")("}");
    // Unknown fields
    }
    gen("default:")("r.skipType(t&7,n)")("break")("}")("}");
    gen("if(l!==undefined){")("if(r.pos!==c)")("throw RangeError(\"index out of range\")")("r.len=l")("}");
    // Field presence
    for(i = 0; i < mtype._fieldsArray.length; ++i){
        var rfield = mtype._fieldsArray[i];
        if (rfield.required) gen("if(!Object.hasOwnProperty.call(m,%j))", rfield.name)("throw util.ProtocolError(%j,{instance:m})", $64830d0f853fe0da$var$missing(rfield));
    }
    return gen("return m");
/* eslint-enable no-unexpected-multiline */ }

});

parcelRegister("kfNH8", function(module, exports) {
"use strict";
module.exports = $ebebc1b0dc90e532$var$verifier;

var $teZIn = parcelRequire("teZIn");

var $jshGU = parcelRequire("jshGU");
function $ebebc1b0dc90e532$var$invalid(field, expected) {
    return field.name + ": " + expected + (field.repeated && expected !== "array" ? "[]" : field.map && expected !== "object" ? "{k:" + field.keyType + "}" : "") + " expected";
}
/**
 * Generates a partial value verifier.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $ebebc1b0dc90e532$var$genVerifyValue(gen, field, fieldIndex, ref) {
    /* eslint-disable no-unexpected-multiline */ if (field.resolvedType) {
        if (field.resolvedType instanceof $teZIn) {
            gen("switch(%s){", ref)("default:")("return%j", $ebebc1b0dc90e532$var$invalid(field, "enum value"));
            for(var keys = Object.keys(field.resolvedType.values), j = 0; j < keys.length; ++j)gen("case %i:", field.resolvedType.values[keys[j]]);
            gen("break")("}");
        } else gen("{")("var e=types[%i].verify(%s,n+1);", fieldIndex, ref)("if(e)")("return%j+e", field.name + ".")("}");
    } else switch(field.type){
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
            gen("if(!util.isInteger(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer"));
            break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
            gen("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", ref, ref, ref, ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer|Long"));
            break;
        case "float":
        case "double":
            gen("if(typeof %s!==\"number\")", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "number"));
            break;
        case "bool":
            gen("if(typeof %s!==\"boolean\")", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "boolean"));
            break;
        case "string":
            gen("if(!util.isString(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "string"));
            break;
        case "bytes":
            gen("if(!(%s&&typeof %s.length===\"number\"||util.isString(%s)))", ref, ref, ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "buffer"));
            break;
    }
    return gen;
/* eslint-enable no-unexpected-multiline */ }
/**
 * Generates a partial key verifier.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $ebebc1b0dc90e532$var$genVerifyKey(gen, field, ref) {
    /* eslint-disable no-unexpected-multiline */ switch(field.keyType){
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
            gen("if(!util.key32Re.test(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer key"));
            break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
            gen("if(!util.key64Re.test(%s))", ref) // see comment above: x is ok, d is not
            ("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer|Long key"));
            break;
        case "bool":
            gen("if(!util.key2Re.test(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "boolean key"));
            break;
    }
    return gen;
/* eslint-enable no-unexpected-multiline */ }
/**
 * Generates a verifier specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $ebebc1b0dc90e532$var$verifier(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $jshGU.codegen([
        "m",
        "n"
    ], mtype.name + "$verify")("if(typeof m!==\"object\"||m===null)")("return%j", "object expected")("if(n===undefined)n=0")("if(n>util.recursionLimit)")("return%j", "maximum nesting depth exceeded");
    var oneofs = mtype.oneofsArray, seenFirstField = {};
    if (oneofs.length) gen("var p={}");
    for(var i = 0; i < /* initializes */ mtype.fieldsArray.length; ++i){
        var field = mtype._fieldsArray[i].resolve(), ref = "m" + $jshGU.safeProp(field.name);
        if (field.optional) gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", ref, field.name); // !== undefined && !== null
        // map fields
        if (field.map) {
            gen("if(!util.isObject(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "object"))("var k=Object.keys(%s)", ref)("for(var i=0;i<k.length;++i){");
            $ebebc1b0dc90e532$var$genVerifyKey(gen, field, "k[i]");
            $ebebc1b0dc90e532$var$genVerifyValue(gen, field, i, ref + "[k[i]]")("}");
        // repeated fields
        } else if (field.repeated) {
            gen("if(!Array.isArray(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "array"))("for(var i=0;i<%s.length;++i){", ref);
            $ebebc1b0dc90e532$var$genVerifyValue(gen, field, i, ref + "[i]")("}");
        // required or present fields
        } else {
            if (field.partOf) {
                var oneofProp = $jshGU.safeProp(field.partOf.name);
                if (seenFirstField[field.partOf.name] === 1) gen("if(p%s===1)", oneofProp)("return%j", field.partOf.name + ": multiple values");
                seenFirstField[field.partOf.name] = 1;
                gen("p%s=1", oneofProp);
            }
            $ebebc1b0dc90e532$var$genVerifyValue(gen, field, i, ref);
        }
        if (field.optional) gen("}");
    }
    return gen("return null");
/* eslint-enable no-unexpected-multiline */ }

});

parcelRegister("iaLh4", function(module, exports) {
"use strict";
/**
 * Runtime message from/to plain object converters.
 * @namespace
 */ var $d3add4dfd9202b09$var$converter = module.exports;

var $teZIn = parcelRequire("teZIn");

var $jshGU = parcelRequire("jshGU");
/**
 * Generates a partial value fromObject conveter.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} prop Property reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, fieldIndex, prop) {
    var defaultAlreadyEmitted = false;
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ if (field.resolvedType) {
        if (field.resolvedType instanceof $teZIn) {
            gen("switch(d%s){", prop);
            for(var values = field.resolvedType.values, keys = Object.keys(values), i = 0; i < keys.length; ++i){
                // enum unknown values passthrough
                if (values[keys[i]] === field.typeDefault && !defaultAlreadyEmitted) {
                    gen("default:")("if(typeof(d%s)===\"number\"){m%s=d%s;break}", prop, prop, prop);
                    if (!field.repeated) gen // fallback to default value only for
                    ("break"); // for non-repeated fields, just ignore
                    defaultAlreadyEmitted = true;
                }
                gen("case%j:", keys[i])("case %i:", values[keys[i]])("m%s=%j", prop, values[keys[i]])("break");
            }
            gen("}");
        } else gen("if(!util.isObject(d%s))", prop)("throw TypeError(%j)", field.fullName + ": object expected")("m%s=types[%i].fromObject(d%s,n+1)", prop, fieldIndex, prop);
    } else {
        var isUnsigned = false;
        switch(field.type){
            case "double":
            case "float":
                gen("m%s=Number(d%s)", prop, prop); // also catches "NaN", "Infinity"
                break;
            case "uint32":
            case "fixed32":
                gen("m%s=d%s>>>0", prop, prop);
                break;
            case "int32":
            case "sint32":
            case "sfixed32":
                gen("m%s=d%s|0", prop, prop);
                break;
            case "uint64":
            case "fixed64":
                isUnsigned = true;
            // eslint-disable-next-line no-fallthrough
            case "int64":
            case "sint64":
            case "sfixed64":
                gen("if(util.Long)")("m%s=util.Long.fromValue(d%s,%j)", prop, prop, isUnsigned)("else if(typeof d%s===\"string\")", prop)("m%s=parseInt(d%s,10)", prop, prop)("else if(typeof d%s===\"number\")", prop)("m%s=d%s", prop, prop)("else if(typeof d%s===\"object\")", prop)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", prop, prop, prop, isUnsigned ? "true" : "");
                break;
            case "bytes":
                gen("if(typeof d%s===\"string\")", prop)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", prop, prop, prop)("else if(d%s.length >= 0)", prop)("m%s=d%s", prop, prop);
                break;
            case "string":
                gen("m%s=String(d%s)", prop, prop);
                break;
            case "bool":
                gen("m%s=Boolean(d%s)", prop, prop);
                break;
        }
    }
    return gen;
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }
/**
 * Generates a plain object to runtime message converter specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $d3add4dfd9202b09$var$converter.fromObject = function fromObject(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var fields = mtype.fieldsArray;
    var gen = $jshGU.codegen([
        "d",
        "n"
    ], mtype.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
    if (!fields.length) return gen("return new this.ctor");
    gen("if(!util.isObject(d))")("throw TypeError(%j)", mtype.fullName + ": object expected")("if(n===undefined)n=0")("if(n>util.recursionLimit)")("throw Error(\"maximum nesting depth exceeded\")");
    gen("var m=new this.ctor");
    for(var i = 0; i < fields.length; ++i){
        var field = fields[i].resolve(), prop = $jshGU.safeProp(field.name);
        // Map fields
        if (field.map) {
            gen("if(d%s){", prop)("if(!util.isObject(d%s))", prop)("throw TypeError(%j)", field.fullName + ": object expected")("m%s={}", prop)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", prop);
            gen("if(ks[i]===\"__proto__\")")("util.makeProp(m%s,ks[i])", prop);
            $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop + "[ks[i]]")("}")("}");
        // Repeated fields
        } else if (field.repeated) {
            gen("if(d%s){", prop)("if(!Array.isArray(d%s))", prop)("throw TypeError(%j)", field.fullName + ": array expected")("m%s=[]", prop)("for(var i=0;i<d%s.length;++i){", prop);
            $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop + "[i]")("}")("}");
        // Non-repeated fields
        } else {
            if (!(field.resolvedType instanceof $teZIn)) gen // no need to test for null/undefined if an enum (uses switch)
            ("if(d%s!=null){", prop); // !== undefined && !== null
            $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop);
            if (!(field.resolvedType instanceof $teZIn)) gen("}");
        }
    }
    return gen("return m");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ };
/**
 * Generates a partial value toObject converter.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} prop Property reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, fieldIndex, prop) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ if (field.resolvedType) {
        if (field.resolvedType instanceof $teZIn) gen("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", prop, fieldIndex, prop, prop, fieldIndex, prop, prop);
        else gen("d%s=types[%i].toObject(m%s,o,q+1)", prop, fieldIndex, prop);
    } else {
        var isUnsigned = false;
        switch(field.type){
            case "double":
            case "float":
                gen("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", prop, prop, prop, prop);
                break;
            case "uint64":
            case "fixed64":
                isUnsigned = true;
            // eslint-disable-next-line no-fallthrough
            case "int64":
            case "sint64":
            case "sfixed64":
                gen("if(typeof BigInt!==\"undefined\"&&o.longs===BigInt)")("d%s=typeof m%s===\"number\"?BigInt(m%s):util.Long.fromBits(m%s.low>>>0,m%s.high>>>0,%j).toBigInt()", prop, prop, prop, prop, prop, isUnsigned)("else if(typeof m%s===\"number\")", prop)("d%s=o.longs===String?String(m%s):m%s", prop, prop, prop)("else") // Long-like
                ("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", prop, prop, prop, prop, isUnsigned ? "true" : "", prop);
                break;
            case "bytes":
                gen("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", prop, prop, prop, prop, prop);
                break;
            default:
                gen("d%s=m%s", prop, prop);
                break;
        }
    }
    return gen;
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }
/**
 * Generates a runtime message to plain object converter specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $d3add4dfd9202b09$var$converter.toObject = function toObject(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var fields = mtype.fieldsArray.slice().sort($jshGU.compareFieldsById);
    if (!fields.length) return $jshGU.codegen()("return {}");
    var gen = $jshGU.codegen([
        "m",
        "o",
        "q"
    ], mtype.name + "$toObject")("if(!o)")("o={}")("if(q===undefined)q=0")("if(q>util.recursionLimit)")("throw Error(\"max depth exceeded\")")("var d={}");
    var repeatedFields = [], mapFields = [], normalFields = [], i = 0;
    for(; i < fields.length; ++i)if (!fields[i].partOf) (fields[i].resolve().repeated ? repeatedFields : fields[i].map ? mapFields : normalFields).push(fields[i]);
    if (repeatedFields.length) {
        gen("if(o.arrays||o.defaults){");
        for(i = 0; i < repeatedFields.length; ++i)gen("d%s=[]", $jshGU.safeProp(repeatedFields[i].name));
        gen("}");
    }
    if (mapFields.length) {
        gen("if(o.objects||o.defaults){");
        for(i = 0; i < mapFields.length; ++i)gen("d%s={}", $jshGU.safeProp(mapFields[i].name));
        gen("}");
    }
    if (normalFields.length) {
        gen("if(o.defaults){");
        for(i = 0; i < normalFields.length; ++i){
            var field = normalFields[i], prop = $jshGU.safeProp(field.name);
            if (field.resolvedType instanceof $teZIn) gen("d%s=o.enums===String?%j:%j", prop, field.resolvedType.valuesById[field.typeDefault], field.typeDefault);
            else if (field.long) gen("if(util.Long){")("var n=new util.Long(%i,%i,%j)", field.typeDefault.low, field.typeDefault.high, field.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():typeof BigInt!==\"undefined\"&&o.longs===BigInt?n.toBigInt():n", prop)("}else")("d%s=o.longs===String?%j:typeof BigInt!==\"undefined\"&&o.longs===BigInt?BigInt(%j):%i", prop, field.typeDefault.toString(), field.typeDefault.toString(), field.typeDefault.toNumber());
            else if (field.bytes) {
                var arrayDefault = Array.prototype.slice.call(field.typeDefault);
                gen("if(o.bytes===String)d%s=%j", prop, String.fromCharCode.apply(String, field.typeDefault))("else{")("d%s=%j", prop, arrayDefault)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", prop, prop)("}");
            } else gen("d%s=%j", prop, field.typeDefault); // also messages (=null)
        }
        gen("}");
    }
    var hasKs2 = false;
    for(i = 0; i < fields.length; ++i){
        var field = fields[i], index = mtype._fieldsArray.indexOf(field), prop = $jshGU.safeProp(field.name);
        if (field.map) {
            if (!hasKs2) {
                hasKs2 = true;
                gen("var ks2");
            }
            gen("if(m%s&&(ks2=Object.keys(m%s)).length){", prop, prop)("d%s={}", prop)("for(var j=0;j<ks2.length;++j){");
            gen("if(ks2[j]===\"__proto__\")")("util.makeProp(d%s,ks2[j])", prop);
            $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop + "[ks2[j]]")("}");
        } else if (field.repeated) {
            gen("if(m%s&&m%s.length){", prop, prop)("d%s=[]", prop)("for(var j=0;j<m%s.length;++j){", prop);
            $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop + "[j]")("}");
        } else {
            gen("if(m%s!=null&&Object.hasOwnProperty.call(m,%j)){", prop, field.name); // !== undefined && !== null
            $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop);
            if (field.partOf) gen("if(o.oneofs)")("d%s=%j", $jshGU.safeProp(field.partOf.name), field.name);
        }
        gen("}");
    }
    return gen("return d");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ };

});

parcelRegister("9C7Ox", function(module, exports) {
"use strict";
/**
 * Wrappers for common types.
 * @type {Object.<string,IWrapper>}
 * @const
 */ var $6ffdb967c9213627$var$wrappers = module.exports;

var $gLmvK = parcelRequire("gLmvK");

var $hf2LF = parcelRequire("hf2LF");
/**
 * From object converter part of an {@link IWrapper}.
 * @typedef WrapperFromObjectConverter
 * @type {function}
 * @param {Object.<string,*>} object Plain object
 * @returns {Message<{}>} Message instance
 * @this Type
 */ /**
 * To object converter part of an {@link IWrapper}.
 * @typedef WrapperToObjectConverter
 * @type {function}
 * @param {Message<{}>} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 * @this Type
 */ /**
 * Common type wrapper part of {@link wrappers}.
 * @interface IWrapper
 * @property {WrapperFromObjectConverter} [fromObject] From object converter
 * @property {WrapperToObjectConverter} [toObject] To object converter
 */ // Custom wrapper for Any
$6ffdb967c9213627$var$wrappers[".google.protobuf.Any"] = {
    fromObject: function(object, depth) {
        if (depth === undefined) depth = 0;
        if (depth > $hf2LF.recursionLimit) throw Error("max depth exceeded");
        // unwrap value type if mapped
        if (object && object["@type"]) {
            // Only use fully qualified type name after the last '/'
            var name = object["@type"].substring(object["@type"].lastIndexOf("/") + 1);
            var type = this.lookup(name);
            /* istanbul ignore else */ if (type) {
                // type_url does not accept leading "."
                var type_url = object["@type"].charAt(0) === "." ? object["@type"].slice(1) : object["@type"];
                // type_url prefix is optional, but path seperator is required
                if (type_url.indexOf("/") === -1) type_url = "/" + type_url;
                return this.create({
                    type_url: type_url,
                    value: type.encode(type.fromObject(object, depth + 1)).finish()
                });
            }
        }
        return this.fromObject(object, depth);
    },
    toObject: function(message, options, depth) {
        if (depth === undefined) depth = 0;
        if (depth > $hf2LF.recursionLimit) throw Error("max depth exceeded");
        // Default prefix
        var googleApi = "type.googleapis.com/";
        var prefix = "";
        var name = "";
        // decode value if requested and unmapped
        if (options && options.json && message.type_url && message.value) {
            // Only use fully qualified type name after the last '/'
            name = message.type_url.substring(message.type_url.lastIndexOf("/") + 1);
            // Separate the prefix used
            prefix = message.type_url.substring(0, message.type_url.lastIndexOf("/") + 1);
            var type = this.lookup(name);
            /* istanbul ignore else */ if (type) message = type.decode(message.value, undefined, undefined, depth + 1);
        }
        // wrap value if unmapped
        if (!(message instanceof this.ctor) && message instanceof $gLmvK) {
            var object = message.$type.toObject(message, options, depth + 1);
            var messageName = message.$type.fullName[0] === "." ? message.$type.fullName.slice(1) : message.$type.fullName;
            // Default to type.googleapis.com prefix if no prefix is used
            if (prefix === "") prefix = googleApi;
            name = prefix + messageName;
            object["@type"] = name;
            return object;
        }
        return this.toObject(message, options, depth);
    }
};

});


parcelRegister("hjrO2", function(module, exports) {
"use strict";
module.exports = $c9a9c7b8ab27cfd9$var$Root;

var $3keUm = parcelRequire("3keUm");
(($c9a9c7b8ab27cfd9$var$Root.prototype = Object.create($3keUm.prototype)).constructor = $c9a9c7b8ab27cfd9$var$Root).className = "Root";

var $fMEB1 = parcelRequire("fMEB1");

var $teZIn = parcelRequire("teZIn");

var $8DQkR = parcelRequire("8DQkR");

var $jshGU = parcelRequire("jshGU");
var $c9a9c7b8ab27cfd9$var$Type, $c9a9c7b8ab27cfd9$var$parse, $c9a9c7b8ab27cfd9$var$common; // "
/**
 * Constructs a new root namespace instance.
 * @classdesc Root namespace wrapping all types, enums, services, sub-namespaces etc. that belong together.
 * @extends NamespaceBase
 * @constructor
 * @param {Object.<string,*>} [options] Top level options
 */ function $c9a9c7b8ab27cfd9$var$Root(options) {
    $3keUm.call(this, "", options);
    /**
     * Deferred extension fields.
     * @type {Field[]}
     */ this.deferred = [];
    /**
     * Resolved file names of loaded files.
     * @type {string[]}
     */ this.files = [];
    /**
     * Edition, defaults to proto2 if unspecified.
     * @type {string}
     * @private
     */ this._edition = "proto2";
    /**
     * Global lookup cache of fully qualified names.
     * @type {Object.<string,ReflectionObject>}
     * @private
     */ this._fullyQualifiedObjects = {};
}
/**
 * Loads a namespace descriptor into a root namespace.
 * @param {INamespace} json Namespace descriptor
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Root} Root namespace
 */ $c9a9c7b8ab27cfd9$var$Root.fromJSON = function fromJSON(json, root, depth) {
    depth = $jshGU.checkDepth(depth);
    if (!root) root = new $c9a9c7b8ab27cfd9$var$Root();
    if (json.options) root.setOptions(json.options);
    return root.addJSON(json.nested, depth).resolveAll();
};
/**
 * Resolves the path of an imported file, relative to the importing origin.
 * This method exists so you can override it with your own logic in case your imports are scattered over multiple directories.
 * @function
 * @param {string} origin The file name of the importing file
 * @param {string} target The file name being imported
 * @returns {string|null} Resolved path to `target` or `null` to skip the file
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.resolvePath = $jshGU.path.resolve;
/**
 * Fetch content from file path or url
 * This method exists so you can override it with your own logic.
 * @function
 * @param {string} path File path or url
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.fetch = $jshGU.fetch;
// A symbol-like function to safely signal synchronous loading
/* istanbul ignore next */ function $c9a9c7b8ab27cfd9$var$SYNC() {} // eslint-disable-line no-empty-function
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and calls the callback.
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} options Parse options
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.load = function load(filename, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = undefined;
    }
    var self = this;
    if (!callback) return $jshGU.asPromise(load, self, filename, options);
    var sync = callback === $c9a9c7b8ab27cfd9$var$SYNC; // undocumented
    // Finishes loading by calling the callback (exactly once)
    function finish(err, root) {
        /* istanbul ignore if */ if (!callback) return;
        if (sync) throw err;
        if (root) root.resolveAll();
        var cb = callback;
        callback = null;
        cb(err, root);
    }
    // Bundled definition existence checking
    function getBundledFileName(filename) {
        var idx = filename.lastIndexOf("google/protobuf/");
        if (idx > -1) {
            var altname = filename.substring(idx);
            if (altname in $c9a9c7b8ab27cfd9$var$common) return altname;
        }
        return null;
    }
    // Processes a single file
    function process(filename, source, depth) {
        if (depth === undefined) depth = 0;
        try {
            if (depth > $jshGU.recursionLimit) throw Error("max depth exceeded");
            if ($jshGU.isString(source) && source.charAt(0) === "{") source = JSON.parse(source);
            if (!$jshGU.isString(source)) self.setOptions(source.options).addJSON(source.nested);
            else {
                $c9a9c7b8ab27cfd9$var$parse.filename = filename;
                var parsed = $c9a9c7b8ab27cfd9$var$parse(source, self, options), resolved, i = 0;
                if (parsed.imports) {
                    for(; i < parsed.imports.length; ++i)if (resolved = getBundledFileName(parsed.imports[i]) || self.resolvePath(filename, parsed.imports[i])) fetch(resolved, false, depth + 1);
                }
                if (parsed.weakImports) {
                    for(i = 0; i < parsed.weakImports.length; ++i)if (resolved = getBundledFileName(parsed.weakImports[i]) || self.resolvePath(filename, parsed.weakImports[i])) fetch(resolved, true, depth + 1);
                }
            }
        } catch (err) {
            finish(err);
        }
        if (!sync && !queued) finish(null, self); // only once anyway
    }
    // Fetches a single file
    function fetch(filename, weak, depth) {
        if (depth === undefined) depth = 0;
        filename = getBundledFileName(filename) || filename;
        // Skip if already loaded / attempted
        if (self.files.indexOf(filename) > -1) return;
        self.files.push(filename);
        // Shortcut bundled definitions
        if (filename in $c9a9c7b8ab27cfd9$var$common) {
            if (sync) process(filename, $c9a9c7b8ab27cfd9$var$common[filename], depth);
            else {
                ++queued;
                setTimeout(function() {
                    --queued;
                    process(filename, $c9a9c7b8ab27cfd9$var$common[filename], depth);
                });
            }
            return;
        }
        // Otherwise fetch from disk or network
        if (sync) {
            var source;
            try {
                source = $jshGU.fs.readFileSync(filename).toString("utf8");
            } catch (err) {
                if (!weak) finish(err);
                return;
            }
            process(filename, source, depth);
        } else {
            ++queued;
            self.fetch(filename, function(err, source) {
                --queued;
                /* istanbul ignore if */ if (!callback) return; // terminated meanwhile
                if (err) {
                    /* istanbul ignore else */ if (!weak) finish(err);
                    else if (!queued) finish(null, self);
                    return;
                }
                process(filename, source, depth);
            });
        }
    }
    var queued = 0;
    // Assembling the root namespace doesn't require working type
    // references anymore, so we can load everything in parallel
    if ($jshGU.isString(filename)) filename = [
        filename
    ];
    for(var i = 0, resolved; i < filename.length; ++i)if (resolved = self.resolvePath("", filename[i])) fetch(resolved);
    if (sync) {
        self.resolveAll();
        return self;
    }
    if (!queued) finish(null, self);
    return self;
};
// function load(filename:string, options:IParseOptions, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and calls the callback.
 * @function Root#load
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @variation 2
 */ // function load(filename:string, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and returns a promise.
 * @function Root#load
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {Promise<Root>} Promise
 * @variation 3
 */ // function load(filename:string, [options:IParseOptions]):Promise<Root>
/**
 * Synchronously loads one or multiple .proto or preprocessed .json files into this root namespace (node only).
 * @function Root#loadSync
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {Root} Root namespace
 * @throws {Error} If synchronous fetching is not supported (i.e. in browsers) or if a file's syntax is invalid
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.loadSync = function loadSync(filename, options) {
    if (!$jshGU.isNode) throw Error("not supported");
    return this.load(filename, options, $c9a9c7b8ab27cfd9$var$SYNC);
};
/**
 * @override
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    if (this.deferred.length) throw Error("unresolvable extensions: " + this.deferred.map(function(field) {
        return "'extend " + field.extend + "' in " + field.parent.fullName;
    }).join(", "));
    return $3keUm.prototype.resolveAll.call(this);
};
// only uppercased (and thus conflict-free) children are exposed, see below
var $c9a9c7b8ab27cfd9$var$exposeRe = /^[A-Z]/;
/**
 * Handles a deferred declaring extension field by creating a sister field to represent it within its extended type.
 * @param {Root} root Root instance
 * @param {Field} field Declaring extension field witin the declaring type
 * @returns {boolean} `true` if successfully added to the extended type, `false` otherwise
 * @inner
 * @ignore
 */ function $c9a9c7b8ab27cfd9$var$tryHandleExtension(root, field) {
    var extendedType = field.parent.lookup(field.extend);
    if (extendedType) {
        var sisterField = new $fMEB1(field.fullName, field.id, field.type, field.rule, undefined, field.options);
        //do not allow to extend same field twice to prevent the error
        if (extendedType.get(sisterField.name)) return true;
        sisterField.declaringField = field;
        field.extensionField = sisterField;
        extendedType.add(sisterField);
        return true;
    }
    return false;
}
/**
 * Called when any object is added to this root or its sub-namespaces.
 * @param {ReflectionObject} object Object added
 * @returns {undefined}
 * @private
 */ $c9a9c7b8ab27cfd9$var$Root.prototype._handleAdd = function _handleAdd(object) {
    if (object instanceof $fMEB1) {
        if (/* an extension field (implies not part of a oneof) */ object.extend !== undefined && /* not already handled */ !object.extensionField) {
            if (!$c9a9c7b8ab27cfd9$var$tryHandleExtension(this, object)) this.deferred.push(object);
        }
    } else if (object instanceof $teZIn) {
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) object.parent[object.name] = object.values; // expose enum values as property of its parent
    } else if (!(object instanceof $8DQkR)) /* everything else is a namespace */ {
        if (object instanceof $c9a9c7b8ab27cfd9$var$Type) for(var i = 0; i < this.deferred.length;)if ($c9a9c7b8ab27cfd9$var$tryHandleExtension(this, this.deferred[i])) this.deferred.splice(i, 1);
        else ++i;
        for(var j = 0; j < /* initializes */ object.nestedArray.length; ++j)this._handleAdd(object._nestedArray[j]);
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) object.parent[object.name] = object; // expose namespace as property of its parent
    }
    if (object instanceof $c9a9c7b8ab27cfd9$var$Type || object instanceof $teZIn || object instanceof $fMEB1) // Only store types and enums for quick lookup during resolve.
    this._fullyQualifiedObjects[object.fullName] = object;
// The above also adds uppercased (and thus conflict-free) nested types, services and enums as
// properties of namespaces just like static code does. This allows using a .d.ts generated for
// a static module with reflection-based solutions where the condition is met.
};
/**
 * Called when any object is removed from this root or its sub-namespaces.
 * @param {ReflectionObject} object Object removed
 * @returns {undefined}
 * @private
 */ $c9a9c7b8ab27cfd9$var$Root.prototype._handleRemove = function _handleRemove(object) {
    if (object instanceof $fMEB1) {
        if (/* an extension field */ object.extend !== undefined) {
            if (/* already handled */ object.extensionField) {
                object.extensionField.parent.remove(object.extensionField);
                object.extensionField = null;
            } else {
                var index = this.deferred.indexOf(object);
                /* istanbul ignore else */ if (index > -1) this.deferred.splice(index, 1);
            }
        }
    } else if (object instanceof $teZIn) {
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) delete object.parent[object.name]; // unexpose enum values
    } else if (object instanceof $3keUm) {
        for(var i = 0; i < /* initializes */ object.nestedArray.length; ++i)this._handleRemove(object._nestedArray[i]);
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) delete object.parent[object.name]; // unexpose namespaces
    }
    delete this._fullyQualifiedObjects[object.fullName];
};
// Sets up cyclic dependencies (called in index-light)
$c9a9c7b8ab27cfd9$var$Root._configure = function(Type_, parse_, common_) {
    $c9a9c7b8ab27cfd9$var$Type = Type_;
    $c9a9c7b8ab27cfd9$var$parse = parse_;
    $c9a9c7b8ab27cfd9$var$common = common_;
};

});









parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("jMNYH"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});


parcelRegister("WS9F7", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("86Wyx", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                /\b(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        'OnePlus': [
                            '304',
                            '403',
                            '203'
                        ],
                        '*': OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    'Nokia'
                ]
            ],
            [
                // Google
                /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Archos
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i // Infinix XPad
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i // Nvidia Shield TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                // SmartTV from Unidentified Vendors
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i // Nvidia Portable
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i // OnePlus Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i // Motorola 360
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i // Sony SmartWatch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i // LG G Watch R
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i // Apple HomePod
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i // LibWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    'LibWeb'
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Touch'
                ],
                VERSION
            ],
            [
                // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("hNQFu", function(module, exports) {

$parcel$export(module.exports, "makeContextSubject", () => makeContextSubject);
$parcel$export(module.exports, "entityMatch", () => entityMatch);
$parcel$export(module.exports, "getProp", () => getProp);

var $l73hA = parcelRequire("l73hA");

var $4ya6m = parcelRequire("4ya6m");
function makeContextSubject() {
    return {
        userToken: this.user.entityId,
        // cookie based token value
        anonymousToken: (0, $l73hA.getAndSetAvtSafe)(),
        // entity based token values check for matching entityType
        // before falling back user traits or message props
        employmentToken: this.entityMatch((0, $4ya6m.EntityTypes).employee) ? this.user.entityId : this.getProp('employmentToken'),
        merchantToken: this.entityMatch((0, $4ya6m.EntityTypes).merchant) ? this.user.entityId : this.getProp('merchantToken'),
        personToken: this.entityMatch((0, $4ya6m.EntityTypes).person) ? this.user.entityId : this.getProp('personToken'),
        unitToken: this.entityMatch((0, $4ya6m.EntityTypes).unit) ? this.user.entityId : this.getProp('unitToken'),
        /*
        these fields are only pulled from user traits or message props
        long term, it is best for these to be gotten via enrichment
        See discussion: https://docs.google.com/document/d/1OqpYJGFqU30leYRBjXtau4xV-03m5hZ-OonNrXvQqDA/edit?disco=AAAAkvBE_VY
    
        Note that we don't persist these values to localStorage in the
        the case that different users may share the same device.
        e.g. an employee with employmentCanAccessMobileRegister permission
        will log in and out of a device at the workplace. Then a different
        employee may log in and not have that permission
        */ legalEntityToken: this.getProp('legalEntityToken'),
        credentialToken: this.getProp('credentialToken'),
        deviceCredentialToken: this.getProp('deviceCredentialToken'),
        employmentCanAccessMobileRegister: this.getProp('employmentCanAccessMobileRegister'),
        employmentCanAccessSharedRegister: this.getProp('employmentCanAccessSharedRegister'),
        employmentIsOwner: this.getProp('employmentIsOwner'),
        accountCountryCode: this.getProp('accountCountryCode'),
        registeredCountryCode: this.getProp('registeredCountryCode')
    };
}
function entityMatch(entityTypeKey) {
    return this.user.entityType === entityTypeKey;
}
function getProp(propName) {
    return this.user.entityTraits[propName] || this.properties[propName] || null;
// TODO when we add group, user.traits and context.traits
// will not be the same so we need to check in both places
}

});
parcelRegister("l73hA", function(module, exports) {

$parcel$export(module.exports, "getAndSetAvtSafe", () => $03f76ea64b3c058d$export$bfecc853928377a4);
$parcel$export(module.exports, "entityIdAndTypeMatch", () => $03f76ea64b3c058d$export$84ad3bea9365c50b);

var $5sKyw = parcelRequire("5sKyw");
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");
var $i34zz = parcelRequire("i34zz");
var $fvmH2 = parcelRequire("fvmH2");

var $4ya6m = parcelRequire("4ya6m");
function $03f76ea64b3c058d$export$bfecc853928377a4(passedId) {
    if ((0, $i34zz.isUUID)(passedId)) {
        // AVT can and should be overwritten by application logic
        $03f76ea64b3c058d$export$8583a1aa579ace2b(passedId);
        return passedId;
    } else {
        // if AVT is valid in cookies, return
        const avt = $03f76ea64b3c058d$export$4ad563027b36efdf();
        if (avt) return avt;
    }
    // create and set AVT if it doesn't exist
    const uuid = (0, $5sKyw.default)();
    $03f76ea64b3c058d$export$8583a1aa579ace2b(uuid);
    return uuid;
}
function $03f76ea64b3c058d$export$4ad563027b36efdf() {
    const avt = (0, $7tMaX.cookies).get((0, $4ya6m.CookieNames).avt);
    return (0, $i34zz.isUUID)(avt) ? avt : null;
}
function $03f76ea64b3c058d$export$8583a1aa579ace2b(id) {
    (0, $7tMaX.cookies).set((0, $4ya6m.CookieNames).avt, id);
    (0, $7tMaX.cookies).set((0, $4ya6m.LegacyStoreNames).anonId, id);
}
function $03f76ea64b3c058d$export$84ad3bea9365c50b(id, type) {
    if (!(0, $i34zz.isEntity)(type)) {
        (0, $fvmH2.warn)(`The second argument is not a valid entity type. Instead received "${type}". The identity will default to "${(0, $4ya6m.EntityTypes).anonVisitor}". Refer to https://go/cdpentities for a list of entity types.`);
        return false;
    }
    if (type === (0, $4ya6m.EntityTypes).merchant) {
        if ((0, $i34zz.isMerchantToken)(id)) return true;
        (0, $fvmH2.warn)(`The second argument entity type was specified as "${type}". The first argument should be a ${type} token. Instead received "${id}". The identity will default to "${(0, $4ya6m.EntityTypes).anonVisitor}".`);
        return false;
    }
    if (type === (0, $4ya6m.EntityTypes).anonVisitor) {
        if ((0, $i34zz.isUUID)(id)) return true;
        (0, $fvmH2.warn)(`The second argument entity type was specified as "${type}". The first argument should be a anonymous visitor token. Instead received "${id}". The user will be identified as an "${type}" but the entity id will be set to the AVT: "${$03f76ea64b3c058d$export$bfecc853928377a4()}".`);
        return false;
    }
    return true;
}

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $7qKRb.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $64ZUg.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("5o0ob", function(module, exports) {
$parcel$export(module.exports, "ls", () => (parcelRequire("lll06")).ls);
$parcel$export(module.exports, "isArray", () => (parcelRequire("i34zz")).isArray);
$parcel$export(module.exports, "isEntity", () => (parcelRequire("i34zz")).isEntity);
$parcel$export(module.exports, "isEntityId", () => (parcelRequire("i34zz")).isEntityId);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("i34zz")).isFunction);
$parcel$export(module.exports, "isGroupWithSchema", () => (parcelRequire("i34zz")).isGroupWithSchema);
$parcel$export(module.exports, "isIdentify", () => (parcelRequire("i34zz")).isIdentify);
$parcel$export(module.exports, "isIdentifyWithSchema", () => (parcelRequire("i34zz")).isIdentifyWithSchema);
$parcel$export(module.exports, "isMerchantToken", () => (parcelRequire("i34zz")).isMerchantToken);
$parcel$export(module.exports, "isObject", () => (parcelRequire("i34zz")).isObject);
$parcel$export(module.exports, "isPage", () => (parcelRequire("i34zz")).isPage);
$parcel$export(module.exports, "isRecord", () => (parcelRequire("i34zz")).isRecord);
$parcel$export(module.exports, "isSchemaMessage", () => (parcelRequire("i34zz")).isSchemaMessage);
$parcel$export(module.exports, "isString", () => (parcelRequire("i34zz")).isString);
$parcel$export(module.exports, "isTrack", () => (parcelRequire("i34zz")).isTrack);
$parcel$export(module.exports, "isTrackWithSchema", () => (parcelRequire("i34zz")).isTrackWithSchema);
$parcel$export(module.exports, "isTraits", () => (parcelRequire("i34zz")).isTraits);
$parcel$export(module.exports, "isUUID", () => (parcelRequire("i34zz")).isUUID);
$parcel$export(module.exports, "cookies", () => (parcelRequire("7tMaX")).cookies);
$parcel$export(module.exports, "error", () => (parcelRequire("fvmH2")).error);
$parcel$export(module.exports, "logEvent", () => (parcelRequire("fvmH2")).logEvent);
$parcel$export(module.exports, "logRejectedMessages", () => (parcelRequire("fvmH2")).logRejectedMessages);
$parcel$export(module.exports, "shouldLogEventsToConsole", () => (parcelRequire("fvmH2")).shouldLogEventsToConsole);
$parcel$export(module.exports, "throwError", () => (parcelRequire("fvmH2")).throwError);
$parcel$export(module.exports, "warn", () => (parcelRequire("fvmH2")).warn);
$parcel$export(module.exports, "warnAboutExcessiveColumns", () => (parcelRequire("3EKNW")).warnAboutExcessiveColumns);
$parcel$export(module.exports, "assignReadOnly", () => (parcelRequire("4BZ7p")).assignReadOnly);
$parcel$export(module.exports, "timeout", () => (parcelRequire("hLZet")).timeout);
$parcel$export(module.exports, "unwrapSchemaObject", () => (parcelRequire("f6qDi")).unwrapSchemaObject);
parcelRequire("lll06");
parcelRequire("i34zz");
parcelRequire("7tMaX");
parcelRequire("fvmH2");
parcelRequire("3EKNW");
parcelRequire("4BZ7p");
parcelRequire("hLZet");
parcelRequire("f6qDi");

});
parcelRegister("lll06", function(module, exports) {

$parcel$export(module.exports, "ls", () => $f89bd96943f8d4ba$export$e0412d591d45e9b);

var $i34zz = parcelRequire("i34zz");
class $f89bd96943f8d4ba$export$24c55f0c9a7498db {
    set(key, value) {
        try {
            if ((0, $i34zz.isString)(value)) window.localStorage.setItem(key, value);
            else window.localStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
            if (err instanceof Error && err.name === 'QuotaExceededError') throw new Error('Browser localStorage is full or disabled.');
        }
    }
    get(key) {
        let result = null;
        try {
            result = window.localStorage.getItem(key);
            if (result) return JSON.parse(result);
            return result;
        } catch (_a) {
            return result;
        }
    }
    remove(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (_a) {
        // do nothing
        }
    }
}
const $f89bd96943f8d4ba$export$e0412d591d45e9b = new $f89bd96943f8d4ba$export$24c55f0c9a7498db();

});
parcelRegister("i34zz", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $d23c0dddc54d17ad$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNull", () => $d23c0dddc54d17ad$export$630801d484da15df);
$parcel$export(module.exports, "isUndefined", () => $d23c0dddc54d17ad$export$fce6876652108ab);
$parcel$export(module.exports, "isObject", () => $d23c0dddc54d17ad$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isRecord", () => $d23c0dddc54d17ad$export$6ba840931da50680);
$parcel$export(module.exports, "isString", () => $d23c0dddc54d17ad$export$844ec244b1367d54);
$parcel$export(module.exports, "isFunction", () => $d23c0dddc54d17ad$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isEntity", () => $d23c0dddc54d17ad$export$b98f384b6711260c);
$parcel$export(module.exports, "isEntityId", () => $d23c0dddc54d17ad$export$d2e4f6b7ea45a200);
$parcel$export(module.exports, "isTraits", () => $d23c0dddc54d17ad$export$f91c32fb7ae270e8);
$parcel$export(module.exports, "isUUID", () => $d23c0dddc54d17ad$export$a1a1baf9c6597488);
$parcel$export(module.exports, "isMerchantToken", () => $d23c0dddc54d17ad$export$f4474880c6605184);
$parcel$export(module.exports, "isTrack", () => $d23c0dddc54d17ad$export$b36e5aedccf8be81);
$parcel$export(module.exports, "isTrackWithSchema", () => $d23c0dddc54d17ad$export$dd34ff7bf876a5b6);
$parcel$export(module.exports, "isIdentifyWithSchema", () => $d23c0dddc54d17ad$export$63c46f009e087edf);
$parcel$export(module.exports, "isGroupWithSchema", () => $d23c0dddc54d17ad$export$2f9a91909791990f);
$parcel$export(module.exports, "isSchemaMessage", () => $d23c0dddc54d17ad$export$3e87e7d99c52700c);
$parcel$export(module.exports, "isPage", () => $d23c0dddc54d17ad$export$61d82a1ff85c609a);
$parcel$export(module.exports, "isIdentify", () => $d23c0dddc54d17ad$export$e5e98f9e52813f92);

var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
function $d23c0dddc54d17ad$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $d23c0dddc54d17ad$export$630801d484da15df(arg) {
    return arg === null;
}
function $d23c0dddc54d17ad$export$fce6876652108ab(arg) {
    return arg === undefined;
}
function $d23c0dddc54d17ad$export$4967676db1b89293(arg) {
    return arg === null || arg === undefined;
}
function $d23c0dddc54d17ad$export$9a2e0569f350e442(arg) {
    return !$d23c0dddc54d17ad$export$4967676db1b89293(arg);
}
function $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg) {
    if (typeof arg === 'object' && arg !== null) {
        const prototype = Object.getPrototypeOf(arg);
        return prototype === Object.prototype || prototype === null;
    }
    return false;
}
function $d23c0dddc54d17ad$export$6ba840931da50680(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function $d23c0dddc54d17ad$export$c66718ac105b3610(arg) {
    return $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg) || $d23c0dddc54d17ad$export$43bee75e5e14138e(arg);
}
function $d23c0dddc54d17ad$export$844ec244b1367d54(arg) {
    return typeof arg === 'string';
}
function $d23c0dddc54d17ad$export$f6e2535fb5126e54(arg) {
    return typeof arg === 'function';
}
function $d23c0dddc54d17ad$export$b98f384b6711260c(entity) {
    if (!$d23c0dddc54d17ad$export$844ec244b1367d54(entity)) return false;
    return (0, $jPIgV.entities).includes(entity);
}
function $d23c0dddc54d17ad$export$d2e4f6b7ea45a200(entity) {
    return $d23c0dddc54d17ad$export$844ec244b1367d54(entity);
}
function $d23c0dddc54d17ad$export$f91c32fb7ae270e8(obj) {
    return $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(obj);
}
function $d23c0dddc54d17ad$export$a1a1baf9c6597488(id) {
    if (!$d23c0dddc54d17ad$export$844ec244b1367d54(id)) return false;
    return (0, $4ya6m.Regex).uuid.test(id);
}
function $d23c0dddc54d17ad$export$f4474880c6605184(id) {
    if (!$d23c0dddc54d17ad$export$844ec244b1367d54(id)) return false;
    return (0, $4ya6m.Regex).merchantToken.test(id);
}
function $d23c0dddc54d17ad$export$b36e5aedccf8be81(msg) {
    return msg.apiMethod === 'track';
}
function $d23c0dddc54d17ad$export$dd34ff7bf876a5b6(msg) {
    return msg.apiMethod === 'trackWithSchema';
}
function $d23c0dddc54d17ad$export$63c46f009e087edf(msg) {
    return msg.apiMethod === 'identifyWithSchema';
}
function $d23c0dddc54d17ad$export$2f9a91909791990f(msg) {
    return msg.apiMethod === 'groupWithSchema';
}
function $d23c0dddc54d17ad$export$3e87e7d99c52700c(msg) {
    return $d23c0dddc54d17ad$export$dd34ff7bf876a5b6(msg) || $d23c0dddc54d17ad$export$63c46f009e087edf(msg) || $d23c0dddc54d17ad$export$2f9a91909791990f(msg);
}
function $d23c0dddc54d17ad$export$61d82a1ff85c609a(msg) {
    return msg.apiMethod === 'page';
}
function $d23c0dddc54d17ad$export$e5e98f9e52813f92(msg) {
    return msg.apiMethod === 'identify';
}
function $d23c0dddc54d17ad$export$dae3322343de7d27(arg) {
    if (!$d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg)) return false;
    return 'integrations' in arg || 'page' in arg;
}

});
parcelRegister("jPIgV", function(module, exports) {

$parcel$export(module.exports, "LIBRARY_NAME", () => $e7051f36c76cee3d$export$450823d27eb9a43);
$parcel$export(module.exports, "LIBRARY_VERSION", () => $e7051f36c76cee3d$export$bb0adf1d8db61383);
$parcel$export(module.exports, "entities", () => $e7051f36c76cee3d$export$5345fd892b40e1f6);
$parcel$export(module.exports, "cookiePrefixMap", () => $e7051f36c76cee3d$export$94986e774361b474);
$parcel$export(module.exports, "gclidKeySet", () => $e7051f36c76cee3d$export$cedea2ee74d54d56);
/**
 * Library version is updated automatically during the
 * release process, do not update this manually.
 */ const $e7051f36c76cee3d$export$450823d27eb9a43 = '@squareup/cdp';
const $e7051f36c76cee3d$export$bb0adf1d8db61383 = '1.7.0';
const $e7051f36c76cee3d$export$5345fd892b40e1f6 = [
    'merchant',
    'employee',
    'anonymous_visitor',
    'capital_customer',
    'developer',
    'person',
    'unit',
    'weebly_user',
    'square_employee',
    'buyer',
    'test'
];
const $e7051f36c76cee3d$export$10300b62880611fe = [
    '',
    null,
    undefined
];
const $e7051f36c76cee3d$export$94986e774361b474 = {
    aud: [
        'audience'
    ],
    c: [
        'campaignChannel'
    ],
    cmtp: [
        'campaigntype'
    ],
    cn: [
        'campaignname'
    ],
    crcopy: [
        'creativecopy'
    ],
    crcta: [
        'creativecta'
    ],
    crim: [
        'creativeimage'
    ],
    crtype: [
        'creativetype'
    ],
    d: [
        'detailChannel',
        'channel'
    ],
    dt: [
        'deviceChannel',
        'devicetype'
    ],
    exp: [
        'experiment'
    ],
    f: [
        'forecastChannel'
    ],
    l: [
        'locationChannel',
        'locationcountry'
    ],
    lang: [
        'language'
    ],
    meta1: [
        'meta1'
    ],
    meta2: [
        'meta2'
    ],
    o: [
        'offerChannel',
        'offer'
    ],
    p: [
        'partnerChannel',
        'partner'
    ],
    pr: [
        'productChannel',
        'initiative'
    ],
    route: [
        'destinationurl'
    ],
    sq: [
        'marinTag'
    ],
    subch: [
        'subchannel'
    ],
    subcmtp: [
        'subcampaigntype'
    ],
    subp: [
        'subpartner'
    ],
    tar: [
        'targetingtype'
    ],
    tarpr: [
        'targetproduct'
    ],
    u: [
        'urlChannel'
    ]
};
const $e7051f36c76cee3d$export$cedea2ee74d54d56 = new Set([
    'gclid',
    'pub',
    'kw',
    'kwid',
    'matchtype',
    'device'
]);

});

parcelRegister("4ya6m", function(module, exports) {

$parcel$export(module.exports, "EntityTypes", () => $35022c629f82799d$export$ede76e7dc512924d);
$parcel$export(module.exports, "StoreNames", () => $35022c629f82799d$export$bfe89b7256f355e8);
$parcel$export(module.exports, "CookieNames", () => $35022c629f82799d$export$ac4b353634732ef6);
$parcel$export(module.exports, "LSNames", () => $35022c629f82799d$export$8e09aad693641a41);
$parcel$export(module.exports, "LegacyStoreNames", () => $35022c629f82799d$export$75518b681ea4cbf5);
$parcel$export(module.exports, "LegacyLSNames", () => $35022c629f82799d$export$a56e4ff3628a33f0);
$parcel$export(module.exports, "LsKeysV1", () => $35022c629f82799d$export$9e20319ccc45b52a);
$parcel$export(module.exports, "Environments", () => $35022c629f82799d$export$56edef3a554a6277);
$parcel$export(module.exports, "LogEventsToConsole", () => $35022c629f82799d$export$bdbdfeafa5315b49);
$parcel$export(module.exports, "Regex", () => $35022c629f82799d$export$280b9474c61b36c7);
$parcel$export(module.exports, "EmittedEvents", () => $35022c629f82799d$export$12ca4b5fb01229d8);
$parcel$export(module.exports, "CdpVersion", () => $35022c629f82799d$export$4cbe077957a26cc0);
var $35022c629f82799d$export$ede76e7dc512924d;
(function(EntityTypes) {
    EntityTypes["merchant"] = "merchant";
    EntityTypes["employee"] = "employee";
    EntityTypes["anonVisitor"] = "anonymous_visitor";
    EntityTypes["capitalCustomer"] = "capital_customer";
    EntityTypes["developer"] = "developer";
    EntityTypes["person"] = "person";
    EntityTypes["unit"] = "unit";
    EntityTypes["weeblyUser"] = "weebly_user";
    EntityTypes["squareEmployee"] = "square_employee";
    EntityTypes["buyer"] = "buyer";
})($35022c629f82799d$export$ede76e7dc512924d || ($35022c629f82799d$export$ede76e7dc512924d = {}));
var $35022c629f82799d$export$bfe89b7256f355e8;
(function(StoreNames) {
    StoreNames["userEntityType"] = "cdpUserEntityType";
    StoreNames["userEntityId"] = "cdpUserEntityId";
})($35022c629f82799d$export$bfe89b7256f355e8 || ($35022c629f82799d$export$bfe89b7256f355e8 = {}));
var $35022c629f82799d$export$ac4b353634732ef6;
(function(CookieNames) {
    CookieNames["avt"] = "_savt";
    CookieNames["enabled"] = "cdpCookiesEnabled";
    CookieNames["trackCookie"] = "track_cookie";
})($35022c629f82799d$export$ac4b353634732ef6 || ($35022c629f82799d$export$ac4b353634732ef6 = {}));
var $35022c629f82799d$export$8e09aad693641a41;
(function(LSNames) {
    LSNames["userEntityTraits"] = "cdpUserEntityTraits";
    LSNames["groupProps"] = "cdpGroupProps";
/*
    user traits and group props are potentially
    massive amounts of data, even after encoding.
    We may hit the size limit of the cookie (4kb)
    */ })($35022c629f82799d$export$8e09aad693641a41 || ($35022c629f82799d$export$8e09aad693641a41 = {}));
var $35022c629f82799d$export$75518b681ea4cbf5;
(function(LegacyStoreNames) {
    LegacyStoreNames["userEntityId"] = "dajs_user_id";
    LegacyStoreNames["userEntityType"] = "da_js_user_type";
    LegacyStoreNames["anonId"] = "dajs_anonymous_id";
    LegacyStoreNames["groupId"] = "dajs_group_id";
})($35022c629f82799d$export$75518b681ea4cbf5 || ($35022c629f82799d$export$75518b681ea4cbf5 = {}));
var $35022c629f82799d$export$a56e4ff3628a33f0;
(function(LegacyLSNames) {
    LegacyLSNames["groupProps"] = "dajs_group_properties";
    LegacyLSNames["userEntityTraits"] = "dajs_user_traits";
})($35022c629f82799d$export$a56e4ff3628a33f0 || ($35022c629f82799d$export$a56e4ff3628a33f0 = {}));
var $35022c629f82799d$export$9e20319ccc45b52a;
(function(LsKeysV1) {
    LsKeysV1["items"] = "persisted-queue:v1:items";
    LsKeysV1["seen"] = "persisted-queue:v1:seen";
    LsKeysV1["lockKey"] = "persisted-queue:v1:lock";
})($35022c629f82799d$export$9e20319ccc45b52a || ($35022c629f82799d$export$9e20319ccc45b52a = {}));
var $35022c629f82799d$export$56edef3a554a6277;
(function(Environments) {
    Environments["production"] = "production";
    Environments["stage"] = "staging";
    Environments["development"] = "development";
    Environments["localDev"] = "localDev";
})($35022c629f82799d$export$56edef3a554a6277 || ($35022c629f82799d$export$56edef3a554a6277 = {}));
var $35022c629f82799d$export$bdbdfeafa5315b49;
(function(LogEventsToConsole) {
    LogEventsToConsole["on"] = "on";
    LogEventsToConsole["off"] = "off";
    LogEventsToConsole["default"] = "default";
})($35022c629f82799d$export$bdbdfeafa5315b49 || ($35022c629f82799d$export$bdbdfeafa5315b49 = {}));
class $35022c629f82799d$export$280b9474c61b36c7 {
}
$35022c629f82799d$export$280b9474c61b36c7.uuid = /^[\dA-Fa-f]{8}(?:\b-[\dA-Fa-f]{4}){3}\b-[\dA-Fa-f]{12}$/;
/* Seller Profile tokens: https://java-docs.square.com/roster/tokens
 * We have no guarantee these token formats will stay the same in the future, see link below
 * https://square.slack.com/archives/C03EH7224/p1670872738450729?thread_ts=1670861733.529879&cid=C03EH7224
 */ $35022c629f82799d$export$280b9474c61b36c7.merchantToken = /^(merchant:)?[\dA-Z]{13,14}$/;
$35022c629f82799d$export$280b9474c61b36c7.unitToken = /^(unit:)?[\dA-Z]{13,14}$/;
// setting min length of 5 as that seems good enough
$35022c629f82799d$export$280b9474c61b36c7.employmentToken = /^(employment:)?[\w-]{5,20}$/;
var $35022c629f82799d$export$12ca4b5fb01229d8;
(function(EmittedEvents) {
    EmittedEvents["BatchCompleted"] = "cdp-batch-completed";
    EmittedEvents["BatchFailed"] = "cdp-batch-failed";
    EmittedEvents["BatchSent"] = "cdp-batch-sent";
    EmittedEvents["DeliveryFailure"] = "cdp-delivery-failure";
    EmittedEvents["DeliverySuccess"] = "cdp-delivery-success";
    EmittedEvents["DoNotRetry"] = "cdp-do-not-retry";
    EmittedEvents["ExcessiveColumns"] = "cdp-excessive-columns";
    EmittedEvents["Invoke"] = "cdp-invoke";
})($35022c629f82799d$export$12ca4b5fb01229d8 || ($35022c629f82799d$export$12ca4b5fb01229d8 = {}));
var $35022c629f82799d$export$4cbe077957a26cc0;
(function(CdpVersion) {
    CdpVersion["V1"] = "v1";
    CdpVersion["V2"] = "v2";
    CdpVersion["Proxy"] = "proxy";
})($35022c629f82799d$export$4cbe077957a26cc0 || ($35022c629f82799d$export$4cbe077957a26cc0 = {}));

});



parcelRegister("7tMaX", function(module, exports) {

$parcel$export(module.exports, "cookies", () => $57209c843bc4ff85$export$97131b3b5327c27f);

var $hta8F = parcelRequire("hta8F");

var $4ya6m = parcelRequire("4ya6m");
function $57209c843bc4ff85$export$294ead44cbc289a5(host) {
    // https://github.com/squareup/public-web-styles/blob/master/app/assets/javascripts/public-web-styles/modules/tracking.js.es6#L97-L108
    const domain_match = /[^.]*\.([^.]*|..\...|...\...)$/.exec(host);
    const ip_match = /^[\d.]+$/.exec(host);
    if (!ip_match && domain_match) return `.${domain_match[0]}`;
    else return undefined;
}
const $57209c843bc4ff85$var$cookieOptions = {
    expires: 1095,
    path: '/'
};
function $57209c843bc4ff85$var$get(name) {
    if (name === undefined) return (0, $hta8F.default).get();
    let store = (0, $hta8F.default).get(name);
    if (Object.values((0, $4ya6m.LegacyStoreNames)).includes(name) && store) store = store.slice(1, -1);
    return store;
}
function $57209c843bc4ff85$var$set(name, value) {
    let store = value;
    if (Object.values((0, $4ya6m.LegacyStoreNames)).includes(name)) store = window.JSON.stringify(store);
    if (!$57209c843bc4ff85$var$cookieOptions.domain) $57209c843bc4ff85$var$cookieOptions.domain = $57209c843bc4ff85$export$294ead44cbc289a5(window.location.hostname);
    return (0, $hta8F.default).set(name, store, $57209c843bc4ff85$var$cookieOptions);
}
const $57209c843bc4ff85$export$97131b3b5327c27f = {
    remove: (0, $hta8F.default).remove,
    set: $57209c843bc4ff85$var$set,
    get: $57209c843bc4ff85$var$get
};

});
parcelRegister("hta8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2bda4b905adee7$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $fb2bda4b905adee7$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $fb2bda4b905adee7$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $fb2bda4b905adee7$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $fb2bda4b905adee7$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $fb2bda4b905adee7$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $fb2bda4b905adee7$var$init(this.converter, $fb2bda4b905adee7$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $fb2bda4b905adee7$var$init($fb2bda4b905adee7$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $fb2bda4b905adee7$export$2e2bcd8739ae039 = $fb2bda4b905adee7$var$init($fb2bda4b905adee7$var$defaultConverter, {
    path: '/'
});

});


parcelRegister("fvmH2", function(module, exports) {

$parcel$export(module.exports, "warn", () => $b49b5aab683e55af$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $b49b5aab683e55af$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "throwError", () => $b49b5aab683e55af$export$8bf7aba4a9e09055);
$parcel$export(module.exports, "shouldLogEventsToConsole", () => $b49b5aab683e55af$export$20de18a7a1a3a089);
$parcel$export(module.exports, "logRejectedMessages", () => $b49b5aab683e55af$export$3382a8173bbc436a);
$parcel$export(module.exports, "logEvent", () => $b49b5aab683e55af$export$5e9eec8001665ac5);

var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");

var $lfTBe = parcelRequire("lfTBe");

var $i34zz = parcelRequire("i34zz");
function $b49b5aab683e55af$export$c106dd0671a0fc2d(message) {
    console.warn(`${(0, $jPIgV.LIBRARY_NAME)}: ${message}`);
}
function $b49b5aab683e55af$export$a3bc9b8ed74fc(message) {
    console.error(`${(0, $jPIgV.LIBRARY_NAME)}: ${message}`);
}
function $b49b5aab683e55af$export$8bf7aba4a9e09055(message) {
    throw new Error(`${(0, $jPIgV.LIBRARY_NAME)}: ${message}`);
}
function $b49b5aab683e55af$export$20de18a7a1a3a089(value, environment) {
    switch(value){
        case 'on':
            return true;
        case 'off':
            return false;
        default:
            return environment !== (0, $4ya6m.Environments).production;
    }
}
const $b49b5aab683e55af$export$abaa3d2e8b1241a9 = new Map([
    [
        'identify',
        '#FF5722'
    ],
    [
        'identifyWithSchema',
        '#FF7043'
    ],
    [
        'page',
        '#4CAF50'
    ],
    [
        'track',
        '#2196F3'
    ],
    [
        'trackWithSchema',
        '#009688'
    ],
    [
        'group',
        '#009688'
    ],
    [
        'groupWithSchema',
        '#26A69A'
    ]
]);
function $b49b5aab683e55af$export$3382a8173bbc436a(errors) {
    if (errors.length === 0) return;
    console.group(`${(0, $jPIgV.LIBRARY_NAME)}: error - The following messages were rejected by the server:`);
    errors.forEach(({ message_id: message_id, type: type, reason: reason })=>console.error(`${message_id} - ${type} - ${reason}`));
    console.groupEnd();
}
function $b49b5aab683e55af$export$a13decb7c9026980(event) {
    // Page name
    if ('name' in event) return event.name;
    // Track event name
    if ('eventName' in event) return event.eventName;
    // Schematized event name
    if ('event' in event) {
        const eventName = event.event.name;
        return eventName.charAt(0).toUpperCase() + eventName.slice(1).replaceAll(/_([a-z])/g, ([_, match])=>match.toUpperCase());
    }
    return undefined;
}
function $b49b5aab683e55af$export$28195c1f3490f3f1(event) {
    // Track/page event properties
    if ('properties' in event && event.properties) return {
        properties: event.properties
    };
    // Schematized event properties
    if ('event' in event && event.event.parameters) return {
        properties: event.event.parameters
    };
    return {};
}
function $b49b5aab683e55af$export$26aaafc23e53ff08(event) {
    if ('traits' in event && event.traits) return {
        traits: event.traits
    };
    return {};
}
function $b49b5aab683e55af$export$31553aaa555c1514(event, schemaContext) {
    if ((0, $i34zz.isSchemaMessage)(event)) return {
        context: (0, $lfTBe.default)(schemaContext)
    };
    return {
        context: event.context
    };
}
function $b49b5aab683e55af$export$5e9eec8001665ac5(event, schemaContext) {
    var _a, _b;
    const eventName = $b49b5aab683e55af$export$a13decb7c9026980(event);
    let apiKey = '';
    const appRegistryName = ((_b = (_a = event.context) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.name) || '';
    if (!(0, $i34zz.isSchemaMessage)(event)) apiKey = event.apiKey;
    const { apiMethod: apiMethod, entityId: entityId, entityType: entityType, messageId: messageId, originalTimestamp: originalTimestamp, sentAt: sentAt, timestamp: timestamp } = event;
    const { groupCollapsed: groupCollapsed, log: log, groupEnd: groupEnd } = console;
    groupCollapsed(`%c${(0, $jPIgV.LIBRARY_NAME)}: ${messageId} \u{2192} ${apiMethod} ${eventName ? ` - "${eventName}"` : ''}`, `color:${$b49b5aab683e55af$export$abaa3d2e8b1241a9.get(apiMethod)}`);
    log(Object.assign(Object.assign(Object.assign({
        apiKey: apiKey,
        appRegistryName: appRegistryName,
        messageId: messageId,
        entityId: entityId,
        entityType: entityType,
        sentAt: sentAt,
        originalTimestamp: originalTimestamp,
        timestamp: timestamp
    }, $b49b5aab683e55af$export$28195c1f3490f3f1(event)), $b49b5aab683e55af$export$26aaafc23e53ff08(event)), $b49b5aab683e55af$export$31553aaa555c1514(event, schemaContext)));
    groupEnd();
}

});
parcelRegister("lfTBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f796209a1a234b00$export$2e2bcd8739ae039);

var $i34zz = parcelRequire("i34zz");
function $f796209a1a234b00$var$isEmpty(arg) {
    // An empty array is a meaningful value, not "empty": it must reach the warehouse
    // as `[]` (parity with the native SDKs), so it is intentionally not stripped here.
    return (0, $i34zz.isUndefined)(arg) || (0, $i34zz.isNull)(arg) || (0, $i34zz.isString)(arg) && arg.length === 0 || (0, $i34zz.isObject)(arg) && Object.keys(arg).length === 0;
}
function $f796209a1a234b00$var$getKeys(o) {
    return Object.keys(o);
}
function $f796209a1a234b00$var$recursiveClean(obj) {
    // If 'obj' is an array, check its elements for objects to clean up.
    if ((0, $i34zz.isArray)(obj)) {
        obj.forEach($f796209a1a234b00$var$recursiveClean);
        // Remove empty objects from the array
        for(let i = 0; i < obj.length; i++)if ($f796209a1a234b00$var$isEmpty(obj[i])) obj.splice(i, 1);
    } else if ((0, $i34zz.isObject)(obj)) $f796209a1a234b00$var$getKeys(obj).forEach((key)=>{
        if ($f796209a1a234b00$var$isEmpty(obj[key])) // eslint-disable-next-line no-param-reassign
        delete obj[key];
        else {
            $f796209a1a234b00$var$recursiveClean(obj[key]);
            // eslint-disable-next-line no-param-reassign
            if ($f796209a1a234b00$var$isEmpty(obj[key])) delete obj[key];
        }
    });
}
function $f796209a1a234b00$export$2e2bcd8739ae039(obj) {
    const mutatedObj = JSON.parse(JSON.stringify(obj));
    $f796209a1a234b00$var$recursiveClean(mutatedObj);
    return mutatedObj;
}

});


parcelRegister("3EKNW", function(module, exports) {

$parcel$export(module.exports, "warnAboutExcessiveColumns", () => $2a9969f152be2058$export$736ab14d476c5318);

var $fvmH2 = parcelRequire("fvmH2");

var $i34zz = parcelRequire("i34zz");

var $4ya6m = parcelRequire("4ya6m");
const $2a9969f152be2058$export$482753196d6d7002 = 30;
function $2a9969f152be2058$export$733129a7d66ee0ba(eventProps) {
    let columns = 1;
    if ((0, $i34zz.isObject)(eventProps)) for (const value of Object.values(eventProps))columns += $2a9969f152be2058$export$733129a7d66ee0ba(value);
    return columns;
}
function $2a9969f152be2058$export$736ab14d476c5318(message) {
    const columns = $2a9969f152be2058$export$733129a7d66ee0ba(message.properties) - 1;
    if (columns > $2a9969f152be2058$export$482753196d6d7002) {
        (0, $fvmH2.warn)(`event "${message.eventName}" will create ${columns} columns in some upstream database tables`);
        window.dispatchEvent(new CustomEvent((0, $4ya6m.EmittedEvents).ExcessiveColumns, {
            detail: {
                message: message,
                columns: columns,
                cdpVersion: (0, $4ya6m.CdpVersion).V1
            }
        }));
    }
}

});

parcelRegister("4BZ7p", function(module, exports) {

$parcel$export(module.exports, "assignReadOnly", () => $35ba06fbc6c09960$export$a3a0906114eec376);
function $35ba06fbc6c09960$export$a3a0906114eec376(context, field, value) {
    Object.defineProperty(context, field, {
        value: value,
        writable: false,
        configurable: true
    });
}

});

parcelRegister("hLZet", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $cf0652f57315af7b$export$83e74882c5df8fe1);

var $i34zz = parcelRequire("i34zz");
function $cf0652f57315af7b$export$83e74882c5df8fe1(fn) {
    if ((0, $i34zz.isFunction)(fn)) // 300 is default value in data-api.js
    setTimeout(fn, 300);
}

});

parcelRegister("f6qDi", function(module, exports) {

$parcel$export(module.exports, "unwrapSchemaObject", () => $afec134b92fc1f0e$export$9d96a17b7f26d01a);
function $afec134b92fc1f0e$export$9d96a17b7f26d01a(value) {
    if (typeof value === 'object' && value !== null && 'toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
    return value;
}

});




parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));




var $27bb0e5b34358db8$export$32180ef41b15b513;
$27bb0e5b34358db8$export$32180ef41b15b513 = `myMTMW_index_body`;


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $3Tvfn = parcelRequire("3Tvfn");
const $078609d239e2b7c3$export$640106f6dc7d2706 = window.location.hostname.split(".").slice(-2).join(".");
var $078609d239e2b7c3$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "ENVIRONMENT_DEVELOPMENT";
    Environment["Staging"] = "ENVIRONMENT_STAGING";
    Environment["Production"] = "ENVIRONMENT_PRODUCTION";
    return Environment;
}({});
const $078609d239e2b7c3$export$57570b1603cf6adb = ()=>{
    if ($078609d239e2b7c3$export$640106f6dc7d2706 === "squareupstaging.com") return "ENVIRONMENT_STAGING";
    if ($078609d239e2b7c3$export$640106f6dc7d2706 === "squareup.com") return "ENVIRONMENT_PRODUCTION";
    throw new Error("Cannot determine environment");
};
const $078609d239e2b7c3$export$987dd53eec1f61cf = ()=>$078609d239e2b7c3$export$57570b1603cf6adb() === "ENVIRONMENT_DEVELOPMENT";
const $078609d239e2b7c3$export$b3e1bb4c27c63f89 = ()=>$078609d239e2b7c3$export$57570b1603cf6adb() === "ENVIRONMENT_STAGING";
const $078609d239e2b7c3$export$9c0c5d1f8a7fb19a = ()=>$078609d239e2b7c3$export$57570b1603cf6adb() === "ENVIRONMENT_PRODUCTION";


function $e510731c6d5d7eb1$export$3988ae62b71be9a3(name) {
    if (document == null) return undefined;
    const cookies = document.cookie == null ? [] : document.cookie.split("; ");
    for(let i = 0; i < cookies.length; i++){
        const cookie = cookies[i];
        const parts = cookie.split("=");
        if (parts[0] === name) {
            const value = parts.slice(1).join("=");
            value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
            return value;
        }
    }
}


// "https://foo.bar.squareupstaging.com/baz" => "https://squareupstaging.com"
const $6a4edd14a7aeb8ed$var$BASE_URL = new URL(`${window.location.protocol}//${window.location.hostname.split(".").slice(-2).join(".")}`);
var $6a4edd14a7aeb8ed$export$2e2bcd8739ae039 = $6a4edd14a7aeb8ed$var$BASE_URL;


var // TODO(steckel): Use api subdomain and standardized path GRPC
// https://github.com/protobufjs/protobuf.js/#using-services
/* eslint-disable @typescript-eslint/ban-types */ $a8dda4170dc4b740$export$2e2bcd8739ae039 = (fetch)=>(method, requestData, callback)=>{
        /* eslint-enable @typescript-eslint/ban-types */ if (typeof method === "function") return method;
        const headers = new Headers();
        headers.append("Accept", "application/x-protobuf");
        headers.append("Content-Type", "application/x-protobuf");
        const csrfValue = (0, $e510731c6d5d7eb1$export$3988ae62b71be9a3)("_js_csrf");
        if (csrfValue != null) headers.append("X-CSRF-Token", csrfValue);
        const path = `/services/${$a8dda4170dc4b740$var$fullyQualifiedMethodName(method)}`;
        const grpcMethodUrl = new URL(path, (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039));
        const request = new Request(grpcMethodUrl.toString(), {
            body: requestData,
            credentials: "include",
            headers: headers,
            method: "POST",
            mode: "cors"
        });
        fetch(request).then($a8dda4170dc4b740$var$fetchHandler(callback)).then((buffer)=>new Uint8Array(buffer)).then((message)=>callback(null, message)).catch((error)=>callback(error, null));
    };
const $a8dda4170dc4b740$var$fetchHandler = (callback)=>(response)=>{
        if (!response.ok) callback(new Error(`HTTP Response ${response.status}`), null);
        return response.arrayBuffer();
    };
// TODO(steckel): assert on parent being non-null
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $a8dda4170dc4b740$var$fullyQualifiedMethodName = (method)=>`${method.parent.fullName.slice(1)}/${method.name}`; /* eslint-enable @typescript-eslint/no-non-null-assertion */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ var $10433685c0be4487$exports = {};
// light library entry point.
"use strict";

$10433685c0be4487$exports = (parcelRequire("lLiTM"));



const $5fc7bb4dcf6d49e8$export$3f8fe6489e95757d = Symbol('build');
const $5fc7bb4dcf6d49e8$export$5baac73b42fdd539 = Symbol('validateAndBuild');
const $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9 = Symbol('validate');
const $5fc7bb4dcf6d49e8$export$423e32095c917e40 = Symbol('validated');


function $5b4e7aff5e6ce4a3$var$addInstanceof(Type) {
    // This lets `message instanceof Type` work
    Type[Symbol.hasInstance] = (instance)=>instance instanceof Type.ctor;
}
function $5b4e7aff5e6ce4a3$var$getChildren(field, value) {
    if (field.repeated) return value;
    else if (field.map) return [
        ...Object.values(value)
    ];
    else return [
        value
    ];
}
// Fixes create to make sure the Message has the correct types.
// It accepts the interfaces for the objects (regular objects potentially missing fields),
// but we then expect it to have the correct child Message objects.
function $5b4e7aff5e6ce4a3$var$fixCreate(Type) {
    const originalCreate = Type.create.bind(Type);
    Type.create = (...args)=>{
        const created = originalCreate(...args);
        for (const field of Object.values(Type.fields)){
            // This is not the type of field we need to convert
            if (!created[field.name] || !field.resolvedType || field.resolvedType instanceof (0, $10433685c0be4487$exports.Enum)) continue;
            if (field.repeated) created[field.name] = created[field.name].map((value)=>{
                if (value instanceof field.resolvedType) return value;
                else return field.resolvedType.create(value);
            });
            else if (field.map) created[field.name] = Object.fromEntries(Object.entries(created[field.name]).map(([key, value])=>{
                if (value instanceof field.resolvedType) return [
                    key,
                    value
                ];
                else return [
                    key,
                    field.resolvedType.create(value)
                ];
            }));
            else // This is already an instance of the type, so no need to convert it.
            if (!(created[field.name] instanceof field.resolvedType)) // We have a plain object (or the wrong type) but we want a Message.
            created[field.name] = field.resolvedType.create(created[field.name]);
        }
        return created;
    };
}
function $5b4e7aff5e6ce4a3$var$addValidations(Type, validationOptions = {}) {
    const existingDescriptor = Object.getOwnPropertyDescriptor(Type.__proto__, 'ctor');
    // no need to add validations if they have already been added
    // this function fires twice on fast refresh on frameworks such as NextJS
    if (Type.validateAndCreate) return;
    // This way the validation methods get added to any ctor added to this type, including
    // the default one that needs to be lazily created later.
    Object.defineProperty(Type, 'ctor', {
        ...existingDescriptor,
        get: function() {
            return existingDescriptor.get.call(Type);
        },
        set: function(ctor) {
            existingDescriptor.set.call(Type, ctor);
            ctor.prototype[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9] = function() {
                for (const [propertyName, options] of Object.entries(validationOptions)){
                    for (const [validationType, validationValue] of Object.entries(options))switch(validationType){
                        case 'required':
                            if (!Object.prototype.hasOwnProperty.call(this, propertyName)) throw new TypeError(`Invalid ${propertyName}`);
                            break;
                        case 'notEmpty':
                            const value = this[propertyName];
                            const field = Type.fields[propertyName];
                            if (!$5b4e7aff5e6ce4a3$var$getChildren(field, value).every((v)=>v && v.length > 0)) throw new TypeError(`Invalid ${propertyName}`);
                            break;
                    }
                    for (const [propertyName, field] of Object.entries(Type.fields)){
                        const value = this[propertyName];
                        for (const childValue of $5b4e7aff5e6ce4a3$var$getChildren(field, value))childValue?.[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9]?.();
                    }
                }
            };
            ctor.prototype[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40] = function() {
                this[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9]();
                return this;
            };
            if (!ctor.prototype.validate) ctor.prototype.validate = ctor.prototype[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9];
            if (!ctor.prototype.validated) ctor.prototype.validated = ctor.prototype[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40];
        }
    });
    Type.validateAndCreate = (...args)=>{
        return Type.create(...args)[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40]();
    };
}
function $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb(Type, validationOptions) {
    $5b4e7aff5e6ce4a3$var$addInstanceof(Type);
    $5b4e7aff5e6ce4a3$var$fixCreate(Type);
    $5b4e7aff5e6ce4a3$var$addValidations(Type, validationOptions);
}



class $ae9a6665233e0895$export$2e2bcd8739ae039 {
    static createAndAttachToType(Type) {
        class MessageBuilder extends $ae9a6665233e0895$export$2e2bcd8739ae039 {
            static from(instance) {
                if (!(instance instanceof Type.ctor)) throw new Error(`cannot create ${Type.name}.Builder from object; types do not match`);
                const builder = new MessageBuilder();
                for(const key in Type.fields)if (Object.prototype.hasOwnProperty.call(instance, key)) {
                    const field = Type.fields[key];
                    builder[field.name](instance[field.name]);
                }
                return builder;
            }
        }
        for(const key in Type.fields){
            const field = Type.fields[key];
            MessageBuilder.prototype[field.name] = function(value) {
                this[`_${field.name}`] = value;
                return this;
            };
        }
        MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$3f8fe6489e95757d] = function() {
            const values = {};
            for(const key in Type.fields){
                const field = Type.fields[key];
                values[field.name] = this[`_${field.name}`];
            }
            return Type.create(values);
        };
        MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$5baac73b42fdd539] = function() {
            return this.build()[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40]();
        };
        if (!MessageBuilder.prototype.build) MessageBuilder.prototype.build = MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$3f8fe6489e95757d];
        if (!MessageBuilder.prototype.validateAndBuild) MessageBuilder.prototype.validateAndBuild = MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$5baac73b42fdd539];
        Type.Builder = MessageBuilder; // eslint-disable-line no-param-reassign
        return MessageBuilder;
    }
}


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $63d33be972ac5a3a$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $63d33be972ac5a3a$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "time": {
                        "nested": {
                            "DateTime": {
                                "fields": {
                                    "instantUsec": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "timezoneOffsetMin": {
                                        "type": "sint32",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "posixTz": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "tzName": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "repeated"
                                    },
                                    "ordinal": {
                                        "type": "int64",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DateTimeInterval": {
                                "fields": {
                                    "inclusiveStart": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "exclusiveEnd": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "YearMonth": {
                                "fields": {
                                    "year": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "monthOfYear": {
                                        "type": "int32",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "YearMonthDay": {
                                "fields": {
                                    "year": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "monthOfYear": {
                                        "type": "int32",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "dayOfMonth": {
                                        "type": "int32",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.DateTime && !$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.DateTimeInterval && !$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.YearMonth && !$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.YearMonthDay) $63d33be972ac5a3a$var$$root.addJSON($63d33be972ac5a3a$var$jsonData);
const $63d33be972ac5a3a$export$82f9ebd9adeba146 = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.DateTime');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$82f9ebd9adeba146);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$82f9ebd9adeba146);
const $63d33be972ac5a3a$export$7ed523682b793870 = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.DateTimeInterval');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$7ed523682b793870, {
    inclusiveStart: {
        required: true
    },
    exclusiveEnd: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$7ed523682b793870);
const $63d33be972ac5a3a$export$b707805e12671f51 = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.YearMonth');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$b707805e12671f51);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$b707805e12671f51);
const $63d33be972ac5a3a$export$eedd050964d63dd = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.YearMonthDay');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$eedd050964d63dd);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$eedd050964d63dd);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $a8741251394c554f$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $a8741251394c554f$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "countries": {
                        "nested": {
                            "Country": {
                                "values": {
                                    "US": 840,
                                    "AD": 20,
                                    "AE": 784,
                                    "AF": 4,
                                    "AG": 28,
                                    "AI": 660,
                                    "AL": 8,
                                    "AM": 51,
                                    "AO": 24,
                                    "AQ": 10,
                                    "AR": 32,
                                    "AS": 16,
                                    "AT": 40,
                                    "AU": 36,
                                    "AW": 533,
                                    "AX": 248,
                                    "AZ": 31,
                                    "BA": 70,
                                    "BB": 52,
                                    "BD": 50,
                                    "BE": 56,
                                    "BF": 854,
                                    "BG": 100,
                                    "BH": 48,
                                    "BI": 108,
                                    "BJ": 204,
                                    "BL": 652,
                                    "BM": 60,
                                    "BN": 96,
                                    "BO": 68,
                                    "BQ": 535,
                                    "BR": 76,
                                    "BS": 44,
                                    "BT": 64,
                                    "BV": 74,
                                    "BW": 72,
                                    "BY": 112,
                                    "BZ": 84,
                                    "CA": 124,
                                    "CC": 166,
                                    "CD": 180,
                                    "CF": 140,
                                    "CG": 178,
                                    "CH": 756,
                                    "CI": 384,
                                    "CK": 184,
                                    "CL": 152,
                                    "CM": 120,
                                    "CN": 156,
                                    "CO": 170,
                                    "CR": 188,
                                    "CU": 192,
                                    "CV": 132,
                                    "CW": 531,
                                    "CX": 162,
                                    "CY": 196,
                                    "CZ": 203,
                                    "DE": 276,
                                    "DJ": 262,
                                    "DK": 208,
                                    "DM": 212,
                                    "DO": 214,
                                    "DZ": 12,
                                    "EC": 218,
                                    "EE": 233,
                                    "EG": 818,
                                    "EH": 732,
                                    "ER": 232,
                                    "ES": 724,
                                    "ET": 231,
                                    "FI": 246,
                                    "FJ": 242,
                                    "FK": 238,
                                    "FM": 583,
                                    "FO": 234,
                                    "FR": 250,
                                    "GA": 266,
                                    "GB": 826,
                                    "GD": 308,
                                    "GE": 268,
                                    "GF": 254,
                                    "GG": 831,
                                    "GH": 288,
                                    "GI": 292,
                                    "GL": 304,
                                    "GM": 270,
                                    "GN": 324,
                                    "GP": 312,
                                    "GQ": 226,
                                    "GR": 300,
                                    "GS": 239,
                                    "GT": 320,
                                    "GU": 316,
                                    "GW": 624,
                                    "GY": 328,
                                    "HK": 344,
                                    "HM": 334,
                                    "HN": 340,
                                    "HR": 191,
                                    "HT": 332,
                                    "HU": 348,
                                    "ID": 360,
                                    "IE": 372,
                                    "IL": 376,
                                    "IM": 833,
                                    "IN": 356,
                                    "IO": 86,
                                    "IQ": 368,
                                    "IR": 364,
                                    "IS": 352,
                                    "IT": 380,
                                    "JE": 832,
                                    "JM": 388,
                                    "JO": 400,
                                    "JP": 392,
                                    "KE": 404,
                                    "KG": 417,
                                    "KH": 116,
                                    "KI": 296,
                                    "KM": 174,
                                    "KN": 659,
                                    "KP": 408,
                                    "KR": 410,
                                    "KW": 414,
                                    "KY": 136,
                                    "KZ": 398,
                                    "LA": 418,
                                    "LB": 422,
                                    "LC": 662,
                                    "LI": 438,
                                    "LK": 144,
                                    "LR": 430,
                                    "LS": 426,
                                    "LT": 440,
                                    "LU": 442,
                                    "LV": 428,
                                    "LY": 434,
                                    "MA": 504,
                                    "MC": 492,
                                    "MD": 498,
                                    "ME": 499,
                                    "MF": 663,
                                    "MG": 450,
                                    "MH": 584,
                                    "MK": 807,
                                    "ML": 466,
                                    "MM": 104,
                                    "MN": 496,
                                    "MO": 446,
                                    "MP": 580,
                                    "MQ": 474,
                                    "MR": 478,
                                    "MS": 500,
                                    "MT": 470,
                                    "MU": 480,
                                    "MV": 462,
                                    "MW": 454,
                                    "MX": 484,
                                    "MY": 458,
                                    "MZ": 508,
                                    "NA": 516,
                                    "NC": 540,
                                    "NE": 562,
                                    "NF": 574,
                                    "NG": 566,
                                    "NI": 558,
                                    "NL": 528,
                                    "NO": 578,
                                    "NP": 524,
                                    "NR": 520,
                                    "NU": 570,
                                    "NZ": 554,
                                    "OM": 512,
                                    "PA": 591,
                                    "PE": 604,
                                    "PF": 258,
                                    "PG": 598,
                                    "PH": 608,
                                    "PK": 586,
                                    "PL": 616,
                                    "PM": 666,
                                    "PN": 612,
                                    "PR": 630,
                                    "PS": 275,
                                    "PT": 620,
                                    "PW": 585,
                                    "PY": 600,
                                    "QA": 634,
                                    "RE": 638,
                                    "RO": 642,
                                    "RS": 688,
                                    "RU": 643,
                                    "RW": 646,
                                    "SA": 682,
                                    "SB": 90,
                                    "SC": 690,
                                    "SD": 729,
                                    "SE": 752,
                                    "SG": 702,
                                    "SH": 654,
                                    "SI": 705,
                                    "SJ": 744,
                                    "SK": 703,
                                    "SL": 694,
                                    "SM": 674,
                                    "SN": 686,
                                    "SO": 706,
                                    "SR": 740,
                                    "SS": 728,
                                    "ST": 678,
                                    "SV": 222,
                                    "SX": 534,
                                    "SY": 760,
                                    "SZ": 748,
                                    "TC": 796,
                                    "TD": 148,
                                    "TF": 260,
                                    "TG": 768,
                                    "TH": 764,
                                    "TJ": 762,
                                    "TK": 772,
                                    "TL": 626,
                                    "TM": 795,
                                    "TN": 788,
                                    "TO": 776,
                                    "TR": 792,
                                    "TT": 780,
                                    "TV": 798,
                                    "TW": 158,
                                    "TZ": 834,
                                    "UA": 804,
                                    "UG": 800,
                                    "UM": 581,
                                    "UY": 858,
                                    "UZ": 860,
                                    "VA": 336,
                                    "VC": 670,
                                    "VE": 862,
                                    "VG": 92,
                                    "VI": 850,
                                    "VN": 704,
                                    "VU": 548,
                                    "WF": 876,
                                    "WS": 882,
                                    "XT": 963,
                                    "YE": 887,
                                    "YT": 175,
                                    "ZA": 710,
                                    "ZM": 894,
                                    "ZW": 716,
                                    "ZZ": 999
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$a8741251394c554f$var$$root.nested?.squareup?.nested?.common?.nested?.countries?.nested?.Country) $a8741251394c554f$var$$root.addJSON($a8741251394c554f$var$jsonData);
const $a8741251394c554f$export$5552a8f08b2b9f9e = $a8741251394c554f$var$$root.lookupEnum('squareup.common.countries.Country').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $fed2a7c6f34400dc$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $fed2a7c6f34400dc$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "script": {
                        "nested": {
                            "Script": {
                                "values": {
                                    "Zyyy": 998,
                                    "Hani": 500,
                                    "Hira": 410,
                                    "Jpan": 413,
                                    "Kana": 411,
                                    "Latn": 215
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$fed2a7c6f34400dc$var$$root.nested?.squareup?.nested?.common?.nested?.script?.nested?.Script) $fed2a7c6f34400dc$var$$root.addJSON($fed2a7c6f34400dc$var$jsonData);
const $fed2a7c6f34400dc$export$2f8b47a141e57afc = $fed2a7c6f34400dc$var$$root.lookupEnum('squareup.common.script.Script').values;


const $04e03da92c8def10$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $04e03da92c8def10$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "location": {
                        "nested": {
                            "Coordinates": {
                                "fields": {
                                    "latitude": {
                                        "type": "double",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "longitude": {
                                        "type": "double",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "altitude": {
                                        "type": "double",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "geographicAccuracy": {
                                        "type": "double",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "altitudinalAccuracy": {
                                        "type": "double",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "heading": {
                                        "type": "double",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "speed": {
                                        "type": "double",
                                        "id": 7,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GlobalAddress": {
                                "fields": {
                                    "addressLine1": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "addressLine2": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "addressLine3": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "locality": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "sublocality": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "administrativeDistrictLevel1": {
                                        "type": "string",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "postalCode": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "countryCode": {
                                        "type": ".squareup.common.countries.Country",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "script": {
                                        "type": ".squareup.common.script.Script",
                                        "id": 20,
                                        "rule": "optional"
                                    },
                                    "alternateFormats": {
                                        "type": ".squareup.common.location.GlobalAddress.AlternateFormats",
                                        "id": 21,
                                        "rule": "optional"
                                    },
                                    "addressLine4": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "addressLine5": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "sublocality1": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "sublocality2": {
                                        "type": "string",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "sublocality3": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "sublocality4": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "sublocality5": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "administrativeDistrictLevel2": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "administrativeDistrictLevel3": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "addressCoordinates": {
                                        "type": ".squareup.common.location.Coordinates",
                                        "id": 18,
                                        "rule": "optional"
                                    },
                                    "neighborhood": {
                                        "type": "string",
                                        "id": 19,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "AlternateFormats": {
                                        "fields": {
                                            "countrySubdivisionCode": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$04e03da92c8def10$var$$root.nested?.squareup?.nested?.common?.nested?.location?.nested?.Coordinates && !$04e03da92c8def10$var$$root.nested?.squareup?.nested?.common?.nested?.location?.nested?.GlobalAddress && !$04e03da92c8def10$var$$root.nested?.squareup?.nested?.common?.nested?.location?.nested?.GlobalAddress?.nested?.AlternateFormats) $04e03da92c8def10$var$$root.addJSON($04e03da92c8def10$var$jsonData);
const $04e03da92c8def10$export$d6e0f5996cc55599 = $04e03da92c8def10$var$$root.lookupType('squareup.common.location.Coordinates');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($04e03da92c8def10$export$d6e0f5996cc55599, {
    latitude: {
        required: true
    },
    longitude: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($04e03da92c8def10$export$d6e0f5996cc55599);
const $04e03da92c8def10$export$1d6b20d87bad724b = $04e03da92c8def10$var$$root.lookupType('squareup.common.location.GlobalAddress');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($04e03da92c8def10$export$1d6b20d87bad724b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($04e03da92c8def10$export$1d6b20d87bad724b);
/**
 * SOURCE AlternateFormats @ squareup/common/location.proto at 121:3
 */ $04e03da92c8def10$export$1d6b20d87bad724b.AlternateFormats = $04e03da92c8def10$var$$root.lookupType('squareup.common.location.GlobalAddress.AlternateFormats');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($04e03da92c8def10$export$1d6b20d87bad724b.AlternateFormats);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($04e03da92c8def10$export$1d6b20d87bad724b.AlternateFormats);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 




const $716cdaea1b5a62df$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $716cdaea1b5a62df$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "CardType": {
                                        "values": {
                                            "CARD_TYPE_DO_NOT_USE": 0,
                                            "PHYSICAL": 1,
                                            "VIRTUAL": 2,
                                            "PAIR": 3
                                        }
                                    },
                                    "CardStatus": {
                                        "values": {
                                            "CARD_STATUS_DO_NOT_USE": 0,
                                            "ORDERED": 1,
                                            "ISSUED": 2,
                                            "ISSUED_ACTIVATABLE": 3,
                                            "ACTIVE": 4,
                                            "DISABLED": 5,
                                            "SUSPENDED": 6,
                                            "TERMINATED": 7
                                        }
                                    },
                                    "CardFulfillment": {
                                        "fields": {
                                            "shipping": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "customization": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Shipping": {
                                                "fields": {
                                                    "address": {
                                                        "type": ".squareup.common.location.GlobalAddress",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "status": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping.ShippingStatus",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "ShippingStatus": {
                                                        "values": {
                                                            "SHIPPING_STATUS_DO_NOT_USE": 0,
                                                            "PROCESSING": 1,
                                                            "SHIPPED": 2,
                                                            "DELIVERED": 3,
                                                            "FAILURE": 4,
                                                            "CANCELED": 5
                                                        }
                                                    }
                                                }
                                            },
                                            "Customization": {
                                                "fields": {
                                                    "signature": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.Signature",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "cardText": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText",
                                                        "id": 2,
                                                        "rule": "repeated"
                                                    }
                                                },
                                                "nested": {
                                                    "CardText": {
                                                        "fields": {
                                                            "text": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "type": {
                                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText.Type",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            }
                                                        },
                                                        "nested": {
                                                            "Type": {
                                                                "values": {
                                                                    "CARD_TEXT_DO_NOT_USE": 0,
                                                                    "BUSINESS_NAME": 1,
                                                                    "CARD_HOLDER": 2
                                                                }
                                                            }
                                                        }
                                                    },
                                                    "Signature": {
                                                        "fields": {
                                                            "imageBytes": {
                                                                "type": "bytes",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "mimeType": {
                                                                "type": "string",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "Card": {
                                        "fields": {
                                            "id": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "status": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardStatus",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "type": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardType",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "fulfillment": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cardPairId": {
                                                "type": "string",
                                                "id": 6,
                                                "rule": "optional"
                                            },
                                            "panSuffix": {
                                                "type": "string",
                                                "id": 7,
                                                "rule": "optional"
                                            },
                                            "fullPan": {
                                                "type": "string",
                                                "id": 8,
                                                "rule": "optional"
                                            },
                                            "securityCode": {
                                                "type": "string",
                                                "id": 9,
                                                "rule": "optional"
                                            },
                                            "expiration": {
                                                "type": ".squareup.common.time.YearMonth",
                                                "id": 10,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardType && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardStatus && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Shipping && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Shipping?.nested?.ShippingStatus && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization?.nested?.CardText && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization?.nested?.CardText?.nested?.Type && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization?.nested?.Signature && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Card) $716cdaea1b5a62df$var$$root.addJSON($716cdaea1b5a62df$var$jsonData);
const $716cdaea1b5a62df$export$f1a79bffad3377cd = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardType').values;
const $716cdaea1b5a62df$export$490c7ce941281ba8 = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardStatus').values;
const $716cdaea1b5a62df$export$b2a48b6a70d75edb = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb);
/**
 * SOURCE Shipping @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 62:3
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping);
/**
 * SOURCE ShippingStatus @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 63:5
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping.ShippingStatus = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping.ShippingStatus').values;
/**
 * SOURCE Customization @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 75:3
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization);
/**
 * SOURCE CardText @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 79:5
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText);
/**
 * SOURCE Type @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 83:7
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText.Type = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText.Type').values;
/**
 * SOURCE Signature @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 90:5
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.Signature = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.Signature');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.Signature);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.Signature);
const $716cdaea1b5a62df$export$60332b2344f7fe41 = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.Card');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$60332b2344f7fe41);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$60332b2344f7fe41);


const $bc006730c79954a6$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $bc006730c79954a6$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "ActivateCardRequest": {
                                        "fields": {
                                            "cardToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "activation": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.ActivateCardRequest.ExpirationAndCVC",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ExpirationAndCVC": {
                                                "fields": {
                                                    "expiration": {
                                                        "type": ".squareup.common.time.YearMonth",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "cvc": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "ActivateCardResponse": {
                                        "fields": {
                                            "error": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.ActivateCardResponse.ActivateCardError",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        },
                                        "nested": {
                                            "ActivateCardError": {
                                                "values": {
                                                    "ACTIVATE_CARD_ERROR_UNKNOWN": 0,
                                                    "ACTIVATE_CARD_ERROR_INVALID_EXPIRATION_CVC": 1,
                                                    "ACTIVATE_CARD_ERROR_UNAUTHORIZED": 2
                                                }
                                            }
                                        }
                                    },
                                    "CreateCardRequest": {
                                        "fields": {
                                            "idempotencyKey": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "cardCustomizationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "shippingAddress": {
                                                "type": ".squareup.common.location.GlobalAddress",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreateCardResponse": {
                                        "fields": {
                                            "cardToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "error": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CreateCardResponse.IssueCardError",
                                                "id": 2,
                                                "rule": "repeated"
                                            }
                                        },
                                        "nested": {
                                            "IssueCardError": {
                                                "values": {
                                                    "ISSUE_CARD_ERROR_UNKNOWN": 0,
                                                    "ISSUE_CARD_ERROR_UNAUTHORIZED": 1,
                                                    "ISSUE_CARD_ERROR_OBLIGATION_REQUIRES_COMPLIANCE_VERIFICATION": 2
                                                }
                                            }
                                        }
                                    },
                                    "CreateCardCustomizationRequest": {
                                        "fields": {
                                            "idempotencyKey": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "imageBytes": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "mimeType": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreateCardCustomizationResponse": {
                                        "fields": {
                                            "cardCustomizationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "ListCardsRequest": {
                                        "fields": {}
                                    },
                                    "ListCardsResponse": {
                                        "fields": {
                                            "cards": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Card",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    },
                                    "RetrieveCardRequest": {
                                        "fields": {
                                            "cardId": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "RetrieveCardResponse": {
                                        "fields": {
                                            "card": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Card",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "BankingWebCardService": {
                                        "methods": {
                                            "ActivateCard": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.ActivateCardRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.ActivateCardResponse"
                                            },
                                            "CreateCard": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.CreateCardRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.CreateCardResponse"
                                            },
                                            "CreateCardCustomization": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationResponse"
                                            },
                                            "ListCards": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.ListCardsRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.ListCardsResponse"
                                            },
                                            "RetrieveCard": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.RetrieveCardRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.RetrieveCardResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardRequest?.nested?.ExpirationAndCVC && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardResponse?.nested?.ActivateCardError && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardResponse?.nested?.IssueCardError && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardCustomizationRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardCustomizationResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListCardsRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListCardsResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.RetrieveCardRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.RetrieveCardResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.BankingWebCardService) $bc006730c79954a6$var$$root.addJSON($bc006730c79954a6$var$jsonData);
const $bc006730c79954a6$export$7e4385b3b341704b = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ActivateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$7e4385b3b341704b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$7e4385b3b341704b);
/**
 * SOURCE ExpirationAndCVC @ squareup/bbfrontend/bankingweb/v1/card_service.proto at 47:3
 */ $bc006730c79954a6$export$7e4385b3b341704b.ExpirationAndCVC = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ActivateCardRequest.ExpirationAndCVC');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$7e4385b3b341704b.ExpirationAndCVC);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$7e4385b3b341704b.ExpirationAndCVC);
const $bc006730c79954a6$export$7dde42e884f2d048 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ActivateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$7dde42e884f2d048);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$7dde42e884f2d048);
/**
 * SOURCE ActivateCardError @ squareup/bbfrontend/bankingweb/v1/card_service.proto at 56:3
 */ $bc006730c79954a6$export$7dde42e884f2d048.ActivateCardError = $bc006730c79954a6$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.ActivateCardResponse.ActivateCardError').values;
const $bc006730c79954a6$export$531aee450bc3dbd4 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$531aee450bc3dbd4, {
    idempotencyKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$531aee450bc3dbd4);
const $bc006730c79954a6$export$77c2e9a08149a1ad = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$77c2e9a08149a1ad);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$77c2e9a08149a1ad);
/**
 * SOURCE IssueCardError @ squareup/bbfrontend/bankingweb/v1/card_service.proto at 77:3
 */ $bc006730c79954a6$export$77c2e9a08149a1ad.IssueCardError = $bc006730c79954a6$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CreateCardResponse.IssueCardError').values;
const $bc006730c79954a6$export$aed3bec368de6e1f = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$aed3bec368de6e1f, {
    idempotencyKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$aed3bec368de6e1f);
const $bc006730c79954a6$export$ed2908e9380ce647 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$ed2908e9380ce647);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$ed2908e9380ce647);
const $bc006730c79954a6$export$1f9ff0d796a08011 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListCardsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$1f9ff0d796a08011);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$1f9ff0d796a08011);
const $bc006730c79954a6$export$8a92910321c6ac49 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListCardsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$8a92910321c6ac49);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$8a92910321c6ac49);
const $bc006730c79954a6$export$8f1da4e33ad24fb3 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.RetrieveCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$8f1da4e33ad24fb3, {
    cardId: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$8f1da4e33ad24fb3);
const $bc006730c79954a6$export$763e5b98f5f24d5f = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.RetrieveCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$763e5b98f5f24d5f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$763e5b98f5f24d5f);
const $bc006730c79954a6$export$3fcca2f60820bf28 = $bc006730c79954a6$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.BankingWebCardService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $e12f7d4943895009$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e12f7d4943895009$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "OpenCardInvitation": {
                                        "fields": {
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "balanceId": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e12f7d4943895009$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.OpenCardInvitation) $e12f7d4943895009$var$$root.addJSON($e12f7d4943895009$var$jsonData);
const $e12f7d4943895009$export$fab0e103913ff3a8 = $e12f7d4943895009$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.OpenCardInvitation');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e12f7d4943895009$export$fab0e103913ff3a8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e12f7d4943895009$export$fab0e103913ff3a8);


const $2a6a68ea1459b895$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $2a6a68ea1459b895$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "ListOpenCardInvitationsRequest": {
                                        "fields": {}
                                    },
                                    "ListOpenCardInvitationsResponse": {
                                        "fields": {
                                            "openCardInvitations": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.OpenCardInvitation",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "error": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse.ListOpenCardInvitationsError",
                                                "id": 2,
                                                "rule": "repeated"
                                            }
                                        },
                                        "nested": {
                                            "ListOpenCardInvitationsError": {
                                                "values": {
                                                    "LIST_OPEN_CARD_INVITATIONS_ERROR_UNKNOWN": 0,
                                                    "LIST_OPEN_CARD_INVITATIONS_ERROR_UNAUTHORIZED": 1
                                                }
                                            }
                                        }
                                    },
                                    "BankingWebService": {
                                        "methods": {
                                            "ListOpenCardInvitations": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListOpenCardInvitationsRequest && !$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListOpenCardInvitationsResponse && !$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListOpenCardInvitationsResponse?.nested?.ListOpenCardInvitationsError && !$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.BankingWebService) $2a6a68ea1459b895$var$$root.addJSON($2a6a68ea1459b895$var$jsonData);
const $2a6a68ea1459b895$export$498c8f0ad968f111 = $2a6a68ea1459b895$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($2a6a68ea1459b895$export$498c8f0ad968f111);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($2a6a68ea1459b895$export$498c8f0ad968f111);
const $2a6a68ea1459b895$export$9ba45d39ce6d3f6e = $2a6a68ea1459b895$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($2a6a68ea1459b895$export$9ba45d39ce6d3f6e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($2a6a68ea1459b895$export$9ba45d39ce6d3f6e);
/**
 * SOURCE ListOpenCardInvitationsError @ squareup/bbfrontend/bankingweb/v1/service.proto at 26:3
 */ $2a6a68ea1459b895$export$9ba45d39ce6d3f6e.ListOpenCardInvitationsError = $2a6a68ea1459b895$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse.ListOpenCardInvitationsError').values;
const $2a6a68ea1459b895$export$65bc5f5b6b3789b3 = $2a6a68ea1459b895$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.BankingWebService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $3f95b099726a1553$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3f95b099726a1553$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "Profile": {
                                        "fields": {
                                            "personToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile.Name",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Name": {
                                                "fields": {
                                                    "firstName": {
                                                        "type": "string",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "lastName": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "GetPersonProfileRequest": {
                                        "fields": {}
                                    },
                                    "GetPersonProfileResponse": {
                                        "fields": {
                                            "personToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "profile": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "UpdatePersonProfileRequest": {
                                        "fields": {
                                            "idempotenceKey": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "profile": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "UpdatePersonProfileResponse": {
                                        "fields": {
                                            "profile": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "PersonProfileService": {
                                        "methods": {
                                            "GetPersonProfile": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.GetPersonProfileRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.GetPersonProfileResponse"
                                            },
                                            "UpdatePersonProfile": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Profile && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Profile?.nested?.Name && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetPersonProfileRequest && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetPersonProfileResponse && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.UpdatePersonProfileRequest && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.UpdatePersonProfileResponse && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.PersonProfileService) $3f95b099726a1553$var$$root.addJSON($3f95b099726a1553$var$jsonData);
const $3f95b099726a1553$export$5120f2d0b8d4cab8 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.Profile');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$5120f2d0b8d4cab8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$5120f2d0b8d4cab8);
/**
 * SOURCE Name @ squareup/bbfrontend/bankingweb/v1/person_profile_service.proto at 16:3
 */ $3f95b099726a1553$export$5120f2d0b8d4cab8.Name = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.Profile.Name');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$5120f2d0b8d4cab8.Name);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$5120f2d0b8d4cab8.Name);
const $3f95b099726a1553$export$2ad677b174787c25 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetPersonProfileRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$2ad677b174787c25);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$2ad677b174787c25);
const $3f95b099726a1553$export$9ee66f3a232e9cb2 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetPersonProfileResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$9ee66f3a232e9cb2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$9ee66f3a232e9cb2);
const $3f95b099726a1553$export$2d30a2bab0b6db0 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$2d30a2bab0b6db0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$2d30a2bab0b6db0);
const $3f95b099726a1553$export$3b61cfb87cf1bb3b = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$3b61cfb87cf1bb3b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$3b61cfb87cf1bb3b);
const $3f95b099726a1553$export$f0d0e3d2fc028c = $3f95b099726a1553$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.PersonProfileService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 




/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $e77187f11e04d37d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e77187f11e04d37d$var$jsonData = {
    "squareup": {
        "nested": {
            "address": {
                "nested": {
                    "country_data": {
                        "nested": {
                            "CountryAddressData": {
                                "fields": {
                                    "name": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "format": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "requiredFields": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "upperCaseFields": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "createMethod": {
                                        "type": ".squareup.address.country_data.CountryAddressData.InputMethod",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "editMethod": {
                                        "type": ".squareup.address.country_data.CountryAddressData.InputMethod",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "admin1Label": {
                                        "type": ".squareup.address.country_data.CountryAddressData.Admin1Scope.Admin1Label",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "localityLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.LocalityScope.LocalityLabel",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "sublocalityLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.SublocalityScope.SublocalityLabel",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "postalCodeLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.PostalCodeScope.PostalCodeLabel",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "defaultLinecount": {
                                        "type": "int32",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "examplePostalCodes": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "repeated"
                                    },
                                    "admin1Values": {
                                        "type": ".squareup.address.country_data.CountryAddressData.NameNode",
                                        "id": 13,
                                        "rule": "repeated"
                                    },
                                    "sortingCodeLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.SortingCodeScope.SortingCodeLabel",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "countryCode": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "locale": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "NameNode": {
                                        "fields": {
                                            "code": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "value": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "InputMethod": {
                                        "values": {
                                            "FORM": 0,
                                            "INVERTED_DROPDOWNS": 1,
                                            "CORRECT_AS_YOU_TYPE": 2
                                        }
                                    },
                                    "Admin1Scope": {
                                        "nested": {
                                            "Admin1Label": {
                                                "values": {
                                                    "PROVINCE": 0,
                                                    "AREA": 1,
                                                    "DEPARTMENT": 2,
                                                    "DISTRICT": 3,
                                                    "DO_SI": 4,
                                                    "EMIRATE": 5,
                                                    "ISLAND": 6,
                                                    "OBLAST": 7,
                                                    "PARISH": 8,
                                                    "PREFECTURE": 9,
                                                    "STATE": 10,
                                                    "COUNTY": 11
                                                }
                                            }
                                        }
                                    },
                                    "LocalityScope": {
                                        "nested": {
                                            "LocalityLabel": {
                                                "values": {
                                                    "CITY": 0,
                                                    "DISTRICT": 1,
                                                    "POST_TOWN": 2,
                                                    "SUBURB": 3,
                                                    "TOWN_CITY": 4
                                                }
                                            }
                                        }
                                    },
                                    "SublocalityScope": {
                                        "nested": {
                                            "SublocalityLabel": {
                                                "values": {
                                                    "SUBURB": 0,
                                                    "DISTRICT": 1,
                                                    "NEIGHBORHOOD": 2,
                                                    "TOWNLAND": 3,
                                                    "VILLAGE_TOWNSHIP": 4,
                                                    "TOWN": 5
                                                }
                                            }
                                        }
                                    },
                                    "PostalCodeScope": {
                                        "nested": {
                                            "PostalCodeLabel": {
                                                "values": {
                                                    "POSTAL": 0,
                                                    "EIRCODE": 1,
                                                    "PIN": 2,
                                                    "ZIP": 3
                                                }
                                            }
                                        }
                                    },
                                    "SortingCodeScope": {
                                        "nested": {
                                            "SortingCodeLabel": {
                                                "values": {
                                                    "CEDEX": 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.NameNode && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.InputMethod && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.Admin1Scope?.nested?.Admin1Label && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.LocalityScope?.nested?.LocalityLabel && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.SublocalityScope?.nested?.SublocalityLabel && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.PostalCodeScope?.nested?.PostalCodeLabel && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.SortingCodeScope?.nested?.SortingCodeLabel) $e77187f11e04d37d$var$$root.addJSON($e77187f11e04d37d$var$jsonData);
const $e77187f11e04d37d$export$a4125e32180777a7 = $e77187f11e04d37d$var$$root.lookupType('squareup.address.country_data.CountryAddressData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e77187f11e04d37d$export$a4125e32180777a7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e77187f11e04d37d$export$a4125e32180777a7);
/**
 * SOURCE NameNode @ squareup/address/country_data.proto at 81:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.NameNode = $e77187f11e04d37d$var$$root.lookupType('squareup.address.country_data.CountryAddressData.NameNode');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e77187f11e04d37d$export$a4125e32180777a7.NameNode);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e77187f11e04d37d$export$a4125e32180777a7.NameNode);
/**
 * SOURCE InputMethod @ squareup/address/country_data.proto at 92:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.InputMethod = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.InputMethod').values;
/**
 * SOURCE Admin1Scope @ squareup/address/country_data.proto at 103:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.Admin1Scope = {};
/**
 * SOURCE Admin1Label @ squareup/address/country_data.proto at 104:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.Admin1Scope.Admin1Label = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.Admin1Scope.Admin1Label').values;
/**
 * SOURCE LocalityScope @ squareup/address/country_data.proto at 122:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.LocalityScope = {};
/**
 * SOURCE LocalityLabel @ squareup/address/country_data.proto at 123:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.LocalityScope.LocalityLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.LocalityScope.LocalityLabel').values;
/**
 * SOURCE SublocalityScope @ squareup/address/country_data.proto at 132:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.SublocalityScope = {};
/**
 * SOURCE SublocalityLabel @ squareup/address/country_data.proto at 133:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.SublocalityScope.SublocalityLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.SublocalityScope.SublocalityLabel').values;
/**
 * SOURCE PostalCodeScope @ squareup/address/country_data.proto at 145:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.PostalCodeScope = {};
/**
 * SOURCE PostalCodeLabel @ squareup/address/country_data.proto at 146:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.PostalCodeScope.PostalCodeLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.PostalCodeScope.PostalCodeLabel').values;
/**
 * SOURCE SortingCodeScope @ squareup/address/country_data.proto at 156:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.SortingCodeScope = {};
/**
 * SOURCE SortingCodeLabel @ squareup/address/country_data.proto at 157:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.SortingCodeScope.SortingCodeLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.SortingCodeScope.SortingCodeLabel').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $12e327d46afe7e5e$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $12e327d46afe7e5e$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "service": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "GetBillPayDataRequest": {
                                        "fields": {
                                            "authorizationCode": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "unitToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GetBillPayDataResponse": {
                                        "fields": {
                                            "value": {
                                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData",
                                                "id": 1
                                            },
                                            "error": {
                                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.Error",
                                                "id": 2
                                            }
                                        },
                                        "nested": {
                                            "BillPayData": {
                                                "fields": {
                                                    "card": {
                                                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateCardData",
                                                        "id": 1,
                                                        "rule": "repeated"
                                                    },
                                                    "directDepositAccount": {
                                                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData",
                                                        "id": 2,
                                                        "rule": "repeated"
                                                    }
                                                },
                                                "nested": {
                                                    "PrivateCardData": {
                                                        "fields": {
                                                            "fullPan": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "cvc": {
                                                                "type": "string",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "expiration": {
                                                                "type": ".squareup.common.time.YearMonth",
                                                                "id": 3,
                                                                "rule": "optional"
                                                            },
                                                            "nameOnCard": {
                                                                "type": "string",
                                                                "id": 4,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    },
                                                    "PrivateDirectDepositAccountData": {
                                                        "fields": {
                                                            "routingNumber": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "accountNumber": {
                                                                "type": "string",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "Error": {
                                                "values": {
                                                    "UNKNOWN": 0,
                                                    "UNAUTHORIZED": 1,
                                                    "AUTHORIZATION_FAILURE": 2
                                                }
                                            },
                                            "result": {
                                                "oneof": [
                                                    "value",
                                                    "error"
                                                ]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataRequest && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData?.nested?.PrivateCardData && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData?.nested?.PrivateDirectDepositAccountData && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.Error) $12e327d46afe7e5e$var$$root.addJSON($12e327d46afe7e5e$var$jsonData);
const $12e327d46afe7e5e$export$65e14e19649f8e85 = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$65e14e19649f8e85, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$65e14e19649f8e85);
const $12e327d46afe7e5e$export$3be84277be75e6b7 = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7);
/**
 * SOURCE BillPayData @ squareup/bbfrontend/v1/bill_pay.proto at 31:3
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData);
/**
 * duplicated from squareup.bizbank.card_management.PrivateCardData
 *
 * SOURCE PrivateCardData @ squareup/bbfrontend/v1/bill_pay.proto at 36:5
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateCardData = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateCardData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateCardData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateCardData);
/**
 * SOURCE PrivateDirectDepositAccountData @ squareup/bbfrontend/v1/bill_pay.proto at 43:5
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateDirectDepositAccountData = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateDirectDepositAccountData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateDirectDepositAccountData);
/**
 * SOURCE Error @ squareup/bbfrontend/v1/bill_pay.proto at 49:3
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.Error = $12e327d46afe7e5e$var$$root.lookupEnum('squareup.bbfrontend.service.v1.GetBillPayDataResponse.Error').values;


const $fce501362cc81cfc$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $fce501362cc81cfc$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "service": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "BootstrapRequest": {
                                        "fields": {}
                                    },
                                    "BootstrapResponse": {
                                        "fields": {
                                            "authenticated": {
                                                "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated",
                                                "id": 1
                                            },
                                            "unauthenticated": {
                                                "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Unauthenticated",
                                                "id": 2
                                            }
                                        },
                                        "nested": {
                                            "Authenticated": {
                                                "fields": {
                                                    "personProfile": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "status": {
                                                        "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Status",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "authorized": {
                                                        "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Authorized",
                                                        "id": 3
                                                    },
                                                    "unauthorized": {
                                                        "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Unauthorized",
                                                        "id": 4
                                                    }
                                                },
                                                "nested": {
                                                    "Status": {
                                                        "values": {
                                                            "NEW_USER": 1,
                                                            "EXISTING_USER": 2
                                                        }
                                                    },
                                                    "Authorized": {
                                                        "fields": {}
                                                    },
                                                    "Unauthorized": {
                                                        "fields": {}
                                                    },
                                                    "authorization": {
                                                        "oneof": [
                                                            "authorized",
                                                            "unauthorized"
                                                        ]
                                                    }
                                                }
                                            },
                                            "Unauthenticated": {
                                                "fields": {}
                                            },
                                            "bootstrap": {
                                                "oneof": [
                                                    "authenticated",
                                                    "unauthenticated"
                                                ]
                                            }
                                        }
                                    },
                                    "GetCountryAddressDataRequest": {
                                        "fields": {
                                            "countryCode": {
                                                "type": ".squareup.common.countries.Country",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GetCountryAddressDataResponse": {
                                        "fields": {
                                            "countryAddressData": {
                                                "type": ".squareup.address.country_data.CountryAddressData",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "WebService": {
                                        "methods": {
                                            "GetBillPayData": {
                                                "requestType": ".squareup.bbfrontend.service.v1.GetBillPayDataRequest",
                                                "responseType": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse"
                                            },
                                            "GetBootstrap": {
                                                "requestType": ".squareup.bbfrontend.service.v1.BootstrapRequest",
                                                "responseType": ".squareup.bbfrontend.service.v1.BootstrapResponse"
                                            },
                                            "GetCountryAddressData": {
                                                "requestType": ".squareup.bbfrontend.service.v1.GetCountryAddressDataRequest",
                                                "responseType": ".squareup.bbfrontend.service.v1.GetCountryAddressDataResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapRequest && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated?.nested?.Status && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated?.nested?.Authorized && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated?.nested?.Unauthorized && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Unauthenticated && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCountryAddressDataRequest && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCountryAddressDataResponse && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.WebService) $fce501362cc81cfc$var$$root.addJSON($fce501362cc81cfc$var$jsonData);
const $fce501362cc81cfc$export$fed1fc70f4110737 = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$fed1fc70f4110737);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$fed1fc70f4110737);
const $fce501362cc81cfc$export$21aaaaa317a5d23f = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f);
/**
 * SOURCE Authenticated @ squareup/bbfrontend/v1/web_service.proto at 27:3
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated);
/**
 * SOURCE Status @ squareup/bbfrontend/v1/web_service.proto at 38:5
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Status = $fce501362cc81cfc$var$$root.lookupEnum('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Status').values;
/**
 * Denotes person is logged in/authenticated and authorized to use banking web
 *
 * SOURCE Authorized @ squareup/bbfrontend/v1/web_service.proto at 44:5
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Authorized = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Authorized');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Authorized);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Authorized);
/**
 * Denotes person is not authorized to use banking web even though they are logged in
 * For example, a seller who has a square account but does not have any card invitations.
 *
 * SOURCE Unauthorized @ squareup/bbfrontend/v1/web_service.proto at 49:5
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Unauthorized = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Unauthorized');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Unauthorized);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Unauthorized);
/**
 * SOURCE Unauthenticated @ squareup/bbfrontend/v1/web_service.proto at 52:3
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Unauthenticated = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Unauthenticated');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Unauthenticated);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Unauthenticated);
const $fce501362cc81cfc$export$be0c7e46b391ca72 = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.GetCountryAddressDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$be0c7e46b391ca72);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$be0c7e46b391ca72);
const $fce501362cc81cfc$export$cce565f709f0ad22 = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.GetCountryAddressDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$cce565f709f0ad22);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$cce565f709f0ad22);
const $fce501362cc81cfc$export$b944e8af96427ee6 = $fce501362cc81cfc$var$$root.lookupService('squareup.bbfrontend.service.v1.WebService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $81287a0f87730909$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $81287a0f87730909$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "GetOrCreateComplianceVerificationRequest": {
                                        "fields": {
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "globalAddress": {
                                                "type": ".squareup.common.location.GlobalAddress",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GetOrCreateComplianceVerificationResponse": {
                                        "fields": {
                                            "result": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse.ComplianceResult",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ComplianceResult": {
                                                "values": {
                                                    "COMPLIANCE_RESULT_UNKNOWN": 0,
                                                    "COMPLIANCE_RESULT_PASSED": 1,
                                                    "COMPLIANCE_RESULT_FAILED": 2
                                                }
                                            }
                                        }
                                    },
                                    "BankingWebComplianceService": {
                                        "methods": {
                                            "GetOrCreateComplianceVerification": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetOrCreateComplianceVerificationRequest && !$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetOrCreateComplianceVerificationResponse && !$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetOrCreateComplianceVerificationResponse?.nested?.ComplianceResult && !$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.BankingWebComplianceService) $81287a0f87730909$var$$root.addJSON($81287a0f87730909$var$jsonData);
const $81287a0f87730909$export$32eac23879e45813 = $81287a0f87730909$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($81287a0f87730909$export$32eac23879e45813);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($81287a0f87730909$export$32eac23879e45813);
const $81287a0f87730909$export$5a81323f8347f22 = $81287a0f87730909$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($81287a0f87730909$export$5a81323f8347f22);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($81287a0f87730909$export$5a81323f8347f22);
/**
 * SOURCE ComplianceResult @ squareup/bbfrontend/bankingweb/v1/compliance_service.proto at 27:3
 */ $81287a0f87730909$export$5a81323f8347f22.ComplianceResult = $81287a0f87730909$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse.ComplianceResult').values;
const $81287a0f87730909$export$58773615f38984aa = $81287a0f87730909$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.BankingWebComplianceService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $32d23a4e2afcf5bf$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $32d23a4e2afcf5bf$var$jsonData = {
    "google": {
        "nested": {
            "protobuf": {
                "nested": {
                    "FieldMask": {
                        "fields": {
                            "paths": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$32d23a4e2afcf5bf$var$$root.nested?.google?.nested?.protobuf?.nested?.FieldMask) $32d23a4e2afcf5bf$var$$root.addJSON($32d23a4e2afcf5bf$var$jsonData);
const $32d23a4e2afcf5bf$export$90f2e2c209b42f72 = $32d23a4e2afcf5bf$var$$root.lookupType('google.protobuf.FieldMask');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($32d23a4e2afcf5bf$export$90f2e2c209b42f72);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($32d23a4e2afcf5bf$export$90f2e2c209b42f72);



const $d272bac0a1712861$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $d272bac0a1712861$var$jsonData = {
    "squareup": {
        "nested": {
            "bbdebit": {
                "nested": {
                    "cardmanagement": {
                        "nested": {
                            "Error": {
                                "fields": {
                                    "category": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error.Category",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "code": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error.Code",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "detail": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "field": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Category": {
                                        "values": {
                                            "ERROR_CATEGORY_DO_NOT_USE": 0,
                                            "ERROR_CATEGORY_API_ERROR": 1,
                                            "ERROR_CATEGORY_AUTHENTICATION_ERROR": 2,
                                            "ERROR_CATEGORY_AUTHORIZATION_ERROR": 3,
                                            "ERROR_CATEGORY_INVALID_REQUEST_ERROR": 4
                                        }
                                    },
                                    "Code": {
                                        "values": {
                                            "ERROR_CODE_DO_NOT_USE": 0,
                                            "ERROR_CODE_INTERNAL_SERVER_ERROR": 1,
                                            "ERROR_CODE_UNAUTHENTICATED": 2,
                                            "ERROR_CODE_UNAUTHORIZED": 3,
                                            "ERROR_CODE_MISSING_REQUIRED_PARAMETER": 4,
                                            "ERROR_CODE_NOT_FOUND": 5
                                        }
                                    }
                                }
                            },
                            "Challenge": {
                                "fields": {}
                            },
                            "ActivateCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "expiration": {
                                        "type": ".squareup.common.time.YearMonth",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cvv": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ActivateCardResponse": {
                                "fields": {
                                    "error": {
                                        "type": ".squareup.bbdebit.cardmanagement.ActivateCardResponse.ActivateCardError",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ActivateCardError": {
                                        "values": {
                                            "ACTIVATE_CARD_ERROR_DO_NOT_USE": 0,
                                            "ACTIVATE_CARD_ERROR_INVALID_CVV_OR_EXPIRATION": 1
                                        }
                                    }
                                }
                            },
                            "Card": {
                                "fields": {
                                    "id": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardStatus",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardBrand": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardBrand",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "fulfillment": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardFulfillment",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "lastFour": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "fullPan": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "securityCode": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "expiration": {
                                        "type": ".squareup.common.time.YearMonth",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "canDigitalSpend": {
                                        "type": "bool",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "relationship": {
                                        "type": ".squareup.bbdebit.cardmanagement.Relationship",
                                        "id": 11,
                                        "rule": "repeated"
                                    },
                                    "expirationData": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card.Expiration",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "previousCardId": {
                                        "type": "string",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "digitalWalletData": {
                                        "type": ".squareup.bbdebit.cardmanagement.DigitalWalletData",
                                        "id": 14,
                                        "rule": "repeated"
                                    },
                                    "pinIsSet": {
                                        "type": "bool",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "isEligibleForPhysicalCardPair": {
                                        "type": "bool",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Expiration": {
                                        "fields": {
                                            "expiration": {
                                                "type": ".squareup.common.time.YearMonth",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "status": {
                                                "type": ".squareup.bbdebit.cardmanagement.Card.Expiration.ExpirationStatus",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "replacementCard": {
                                                "type": ".squareup.bbdebit.cardmanagement.Card.Expiration.ReplacementCard",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ReplacementCard": {
                                                "fields": {
                                                    "id": {
                                                        "type": "string",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "scheduledIssueDate": {
                                                        "type": ".squareup.common.time.YearMonthDay",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                }
                                            },
                                            "ExpirationStatus": {
                                                "values": {
                                                    "EXPIRATION_STATUS_DO_NOT_USE": 0,
                                                    "EXPIRATION_STATUS_NOT_EXPIRED": 1,
                                                    "EXPIRATION_STATUS_EXPIRING": 2,
                                                    "EXPIRATION_STATUS_EXPIRED": 3
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "CardBrand": {
                                "values": {
                                    "CARD_BRAND_DO_NOT_USE": 0,
                                    "CARD_BRAND_MASTERCARD": 1
                                }
                            },
                            "CardStatus": {
                                "values": {
                                    "CARD_STATUS_DO_NOT_USE": 0,
                                    "CARD_STATUS_ORDERED": 1,
                                    "CARD_STATUS_ISSUED": 2,
                                    "CARD_STATUS_ACTIVATABLE": 3,
                                    "CARD_STATUS_ACTIVE": 4,
                                    "CARD_STATUS_LOCKED": 5,
                                    "CARD_STATUS_SUSPENDED": 6,
                                    "CARD_STATUS_TERMINATED": 7
                                }
                            },
                            "CardFulfillment": {
                                "fields": {
                                    "status": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardFulfillment.FulfillmentStatus",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "customization": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization",
                                        "id": 2,
                                        "rule": "repeated"
                                    },
                                    "address": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "cardCustomization": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "deliveryDate": {
                                        "type": ".squareup.common.time.YearMonthDay",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "FulfillmentStatus": {
                                        "values": {
                                            "FULFILLMENT_STATUS_DO_NOT_USE": 0,
                                            "FULFILLMENT_STATUS_PROCESSING": 1,
                                            "FULFILLMENT_STATUS_SHIPPED": 2,
                                            "FULFILLMENT_STATUS_DELIVERED": 3,
                                            "FULFILLMENT_STATUS_FAILURE": 4,
                                            "FULFILLMENT_STATUS_CANCELED": 5,
                                            "FULFILLMENT_STATUS_REJECTED": 6
                                        }
                                    }
                                }
                            },
                            "Customization": {
                                "fields": {
                                    "id": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardTexts": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization.CardText",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "CardText": {
                                        "fields": {
                                            "type": {
                                                "type": ".squareup.bbdebit.cardmanagement.Customization.CardText.Type",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "text": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Type": {
                                                "values": {
                                                    "CARD_TEXT_TYPE_BUSINESS_NAME": 1,
                                                    "CARD_TEXT_TYPE_CARDHOLDER_NAME": 2
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "DigitalWalletData": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "panReferenceId": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardRequest": {
                                "fields": {
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardCustomization": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "cardFulfillment": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardFulfillment",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "cardIssuingType": {
                                        "type": ".squareup.bbdebit.cardmanagement.CreateCardRequest.CardIssuingType",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "existingCardIdInPair": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "CardIssuingType": {
                                        "values": {
                                            "CARD_ISSUING_TYPE_DO_NOT_USE": 0,
                                            "CARD_ISSUING_TYPE_VIRTUAL": 1,
                                            "CARD_ISSUING_TYPE_PHYSICAL": 2,
                                            "CARD_ISSUING_TYPE_VIRTUAL_AND_PHYSICAL": 3
                                        }
                                    },
                                    "account_identifier": {
                                        "oneof": [
                                            "unitToken",
                                            "balanceId"
                                        ]
                                    }
                                }
                            },
                            "CreateCardResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.CreateCardResponse.CreateCardError",
                                        "id": 2,
                                        "rule": "repeated"
                                    },
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1
                                    },
                                    "challenge": {
                                        "type": ".squareup.bbdebit.cardmanagement.Challenge",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "CreateCardError": {
                                        "values": {
                                            "CREATE_CARD_ERROR_DO_NOT_USE": 0,
                                            "CREATE_CARD_ERROR_AUTHORIZATION_CHALLENGED": 1
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "card",
                                            "challenge"
                                        ]
                                    }
                                }
                            },
                            "ListCardsRequest": {
                                "fields": {
                                    "sortOrder": {
                                        "type": ".squareup.bbdebit.cardmanagement.ListCardsRequest.SortOrder",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                            "default": "DESC"
                                        }
                                    },
                                    "cursor": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "limit": {
                                        "type": "int32",
                                        "id": 3,
                                        "rule": "optional",
                                        "options": {
                                            "default": 10
                                        }
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "relationship": {
                                        "type": ".squareup.bbdebit.cardmanagement.Relationship",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "personToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "includeTerminated": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "SortOrder": {
                                        "values": {
                                            "DESC": 0,
                                            "ASC": 1
                                        }
                                    }
                                }
                            },
                            "ListCardsResponse": {
                                "fields": {
                                    "cards": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "cursor": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LockCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LockCardResponse": {
                                "fields": {
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "RetrieveCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RetrieveCardResponse": {
                                "fields": {
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.RetrieveCardResponse.RetrieveCardError",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "RetrieveCardError": {
                                        "values": {
                                            "RETRIEVE_CARD_ERROR_DO_NOT_USE": 0,
                                            "RETRIEVE_CARD_ERROR_INVALID_CARD_TOKEN": 1
                                        }
                                    }
                                }
                            },
                            "RetrieveCardRelationshipsRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RetrieveCardRelationshipsResponse": {
                                "fields": {
                                    "relationships": {
                                        "type": ".squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse.Relationship",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Relationship": {
                                        "values": {
                                            "RELATIONSHIP_DO_NOT_USE": 0,
                                            "RELATIONSHIP_ACCOUNT_HOLDER": 1,
                                            "RELATIONSHIP_CARD_HOLDER": 2
                                        }
                                    }
                                }
                            },
                            "Relationship": {
                                "values": {
                                    "RELATIONSHIP_DO_NOT_USE": 0,
                                    "RELATIONSHIP_CARDHOLDER": 1,
                                    "RELATIONSHIP_ACCOUNT_HOLDER": 2
                                }
                            },
                            "SetPinRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "pin": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetPinResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.SetPinResponse.SetPinError",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "error": {
                                        "type": ".squareup.bbdebit.cardmanagement.SetPinResponse.SetPinError",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "SetPinError": {
                                        "values": {
                                            "SET_PIN_ERROR_DO_NOT_USE": 0,
                                            "SET_PIN_ERROR_INVALID_CARD_TOKEN": 1,
                                            "SET_PIN_ERROR_UNAUTHORIZED": 2,
                                            "SET_PIN_ERROR_WEAK_PIN": 3
                                        }
                                    }
                                }
                            },
                            "TerminateCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "reason": {
                                        "type": ".squareup.bbdebit.cardmanagement.TerminateCardRequest.TerminateCardReason",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "TerminateCardReason": {
                                        "values": {
                                            "TERMINATE_CARD_REASON_DO_NOT_USE": 0,
                                            "TERMINATE_CARD_REASON_LOST_OR_STOLEN": 1,
                                            "TERMINATE_CARD_REASON_DAMAGED": 2,
                                            "TERMINATE_CARD_REASON_CARD_NOT_RECEIVED": 3,
                                            "TERMINATE_CARD_REASON_CANCEL": 4,
                                            "TERMINATE_CARD_REASON_ACCOUNT_CLOSED": 5,
                                            "TERMINATE_CARD_REASON_FRAUD": 6,
                                            "TERMINATE_CARD_REASON_EXPIRED": 7,
                                            "TERMINATE_CARD_REASON_REISSUED": 8,
                                            "TERMINATE_CARD_REASON_OTHER": 9
                                        }
                                    }
                                }
                            },
                            "TerminateCardResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.TerminateCardResponse.TerminateCardError",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "TerminateCardError": {
                                        "values": {
                                            "TERMINATE_CARD_ERROR_DO_NOT_USE": 0,
                                            "TERMINATE_CARD_ERROR_INVALID_CARD_TOKEN": 1,
                                            "TERMINATE_CARD_ERROR_CARD_ALREADY_TERMINATED": 2
                                        }
                                    }
                                }
                            },
                            "UnlockCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UnlockCardResponse": {
                                "fields": {
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "CardManagementService": {
                                "methods": {
                                    "ActivateCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.ActivateCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.ActivateCardResponse"
                                    },
                                    "CreateCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.CreateCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.CreateCardResponse"
                                    },
                                    "ListCards": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.ListCardsRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.ListCardsResponse"
                                    },
                                    "LockCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.LockCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.LockCardResponse"
                                    },
                                    "RetrieveCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.RetrieveCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.RetrieveCardResponse"
                                    },
                                    "RetrieveCardRelationships": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse"
                                    },
                                    "SetPin": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.SetPinRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.SetPinResponse"
                                    },
                                    "TerminateCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.TerminateCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.TerminateCardResponse"
                                    },
                                    "UnlockCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.UnlockCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.UnlockCardResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Error && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Error?.nested?.Category && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Error?.nested?.Code && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Challenge && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ActivateCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ActivateCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ActivateCardResponse?.nested?.ActivateCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card?.nested?.Expiration && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card?.nested?.Expiration?.nested?.ReplacementCard && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card?.nested?.Expiration?.nested?.ExpirationStatus && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardBrand && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardStatus && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardFulfillment && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardFulfillment?.nested?.FulfillmentStatus && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Customization && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Customization?.nested?.CardText && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Customization?.nested?.CardText?.nested?.Type && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.DigitalWalletData && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardRequest?.nested?.CardIssuingType && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardResponse?.nested?.CreateCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ListCardsRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ListCardsRequest?.nested?.SortOrder && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ListCardsResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.LockCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.LockCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardResponse?.nested?.RetrieveCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRelationshipsRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRelationshipsResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRelationshipsResponse?.nested?.Relationship && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Relationship && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.SetPinRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.SetPinResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.SetPinResponse?.nested?.SetPinError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardRequest?.nested?.TerminateCardReason && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardResponse?.nested?.TerminateCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.UnlockCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.UnlockCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardManagementService) $d272bac0a1712861$var$$root.addJSON($d272bac0a1712861$var$jsonData);
const $d272bac0a1712861$export$edf27be85e5f6da0 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Error');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$edf27be85e5f6da0, {
    category: {
        required: true
    },
    code: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$edf27be85e5f6da0);
/**
 * SOURCE Category @ squareup/bbdebit/cardmanagement.proto at 18:3
 */ $d272bac0a1712861$export$edf27be85e5f6da0.Category = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Error.Category').values;
/**
 * SOURCE Code @ squareup/bbdebit/cardmanagement.proto at 40:3
 */ $d272bac0a1712861$export$edf27be85e5f6da0.Code = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Error.Code').values;
const $d272bac0a1712861$export$a50dcf13e7b62e9d = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Challenge');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$a50dcf13e7b62e9d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$a50dcf13e7b62e9d);
const $d272bac0a1712861$export$7e4385b3b341704b = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ActivateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$7e4385b3b341704b, {
    cardToken: {
        notEmpty: true
    },
    expiration: {
        required: true
    },
    cvv: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$7e4385b3b341704b);
const $d272bac0a1712861$export$7dde42e884f2d048 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ActivateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$7dde42e884f2d048);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$7dde42e884f2d048);
/**
 * SOURCE ActivateCardError @ squareup/bbdebit/cardmanagement.proto at 107:3
 */ $d272bac0a1712861$export$7dde42e884f2d048.ActivateCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.ActivateCardResponse.ActivateCardError').values;
const $d272bac0a1712861$export$60332b2344f7fe41 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Card');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$60332b2344f7fe41, {
    id: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$60332b2344f7fe41);
/**
 * SOURCE Expiration @ squareup/bbdebit/cardmanagement.proto at 165:3
 */ $d272bac0a1712861$export$60332b2344f7fe41.Expiration = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Card.Expiration');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$60332b2344f7fe41.Expiration);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$60332b2344f7fe41.Expiration);
/**
 * SOURCE ReplacementCard @ squareup/bbdebit/cardmanagement.proto at 170:5
 */ $d272bac0a1712861$export$60332b2344f7fe41.Expiration.ReplacementCard = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Card.Expiration.ReplacementCard');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$60332b2344f7fe41.Expiration.ReplacementCard);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$60332b2344f7fe41.Expiration.ReplacementCard);
/**
 * Expiration status of the current card. The expiring status will start being populated two
 * months prior to card expiration
 *
 * SOURCE ExpirationStatus @ squareup/bbdebit/cardmanagement.proto at 187:5
 */ $d272bac0a1712861$export$60332b2344f7fe41.Expiration.ExpirationStatus = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Card.Expiration.ExpirationStatus').values;
const $d272bac0a1712861$export$1e5507a06cab5709 = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CardBrand').values;
const $d272bac0a1712861$export$490c7ce941281ba8 = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CardStatus').values;
const $d272bac0a1712861$export$b2a48b6a70d75edb = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.CardFulfillment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$b2a48b6a70d75edb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$b2a48b6a70d75edb);
/**
 * SOURCE FulfillmentStatus @ squareup/bbdebit/cardmanagement.proto at 228:3
 */ $d272bac0a1712861$export$b2a48b6a70d75edb.FulfillmentStatus = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CardFulfillment.FulfillmentStatus').values;
const $d272bac0a1712861$export$f27319a4138ec79f = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Customization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$f27319a4138ec79f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$f27319a4138ec79f);
/**
 * SOURCE CardText @ squareup/bbdebit/cardmanagement.proto at 249:3
 */ $d272bac0a1712861$export$f27319a4138ec79f.CardText = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Customization.CardText');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$f27319a4138ec79f.CardText, {
    type: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$f27319a4138ec79f.CardText);
/**
 * SOURCE Type @ squareup/bbdebit/cardmanagement.proto at 259:5
 */ $d272bac0a1712861$export$f27319a4138ec79f.CardText.Type = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Customization.CardText.Type').values;
const $d272bac0a1712861$export$59597d2c7b41f3be = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.DigitalWalletData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$59597d2c7b41f3be);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$59597d2c7b41f3be);
const $d272bac0a1712861$export$531aee450bc3dbd4 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.CreateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$531aee450bc3dbd4, {
    idempotenceKey: {
        notEmpty: true
    },
    cardCustomization: {
        required: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$531aee450bc3dbd4);
/**
 * CardIssuingType specifies the type of card issuing strategy
 *
 * SOURCE CardIssuingType @ squareup/bbdebit/cardmanagement.proto at 329:3
 */ $d272bac0a1712861$export$531aee450bc3dbd4.CardIssuingType = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CreateCardRequest.CardIssuingType').values;
const $d272bac0a1712861$export$77c2e9a08149a1ad = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.CreateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$77c2e9a08149a1ad);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$77c2e9a08149a1ad);
/**
 * CreateCardError will be deprecated once clients switch over to using the Challenge object instead
 *
 * SOURCE CreateCardError @ squareup/bbdebit/cardmanagement.proto at 364:3
 */ $d272bac0a1712861$export$77c2e9a08149a1ad.CreateCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CreateCardResponse.CreateCardError').values;
const $d272bac0a1712861$export$1f9ff0d796a08011 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ListCardsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$1f9ff0d796a08011);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$1f9ff0d796a08011);
/**
 * SOURCE SortOrder @ squareup/bbdebit/cardmanagement.proto at 371:3
 */ $d272bac0a1712861$export$1f9ff0d796a08011.SortOrder = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.ListCardsRequest.SortOrder').values;
const $d272bac0a1712861$export$8a92910321c6ac49 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ListCardsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$8a92910321c6ac49);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$8a92910321c6ac49);
const $d272bac0a1712861$export$ea294dc182de2c2c = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.LockCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$ea294dc182de2c2c, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$ea294dc182de2c2c);
const $d272bac0a1712861$export$35137ddc8e41e17f = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.LockCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$35137ddc8e41e17f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$35137ddc8e41e17f);
const $d272bac0a1712861$export$8f1da4e33ad24fb3 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$8f1da4e33ad24fb3, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$8f1da4e33ad24fb3);
const $d272bac0a1712861$export$763e5b98f5f24d5f = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$763e5b98f5f24d5f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$763e5b98f5f24d5f);
/**
 * SOURCE RetrieveCardError @ squareup/bbdebit/cardmanagement.proto at 471:3
 */ $d272bac0a1712861$export$763e5b98f5f24d5f.RetrieveCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.RetrieveCardResponse.RetrieveCardError').values;
const $d272bac0a1712861$export$94bbb7cf8da173b5 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$94bbb7cf8da173b5, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$94bbb7cf8da173b5);
const $d272bac0a1712861$export$a7a3cd26cb3a7a31 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$a7a3cd26cb3a7a31);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$a7a3cd26cb3a7a31);
/**
 * SOURCE Relationship @ squareup/bbdebit/cardmanagement.proto at 491:3
 */ $d272bac0a1712861$export$a7a3cd26cb3a7a31.Relationship = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse.Relationship').values;
const $d272bac0a1712861$export$69a0e7946cf616df = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Relationship').values;
const $d272bac0a1712861$export$6129867d2a9d1edf = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.SetPinRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$6129867d2a9d1edf, {
    cardToken: {
        required: true
    },
    pin: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$6129867d2a9d1edf);
const $d272bac0a1712861$export$7aecf5bab678a854 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.SetPinResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$7aecf5bab678a854);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$7aecf5bab678a854);
/**
 * SOURCE SetPinError @ squareup/bbdebit/cardmanagement.proto at 519:3
 */ $d272bac0a1712861$export$7aecf5bab678a854.SetPinError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.SetPinResponse.SetPinError').values;
const $d272bac0a1712861$export$6f80cf9974e4741 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.TerminateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$6f80cf9974e4741, {
    cardToken: {
        notEmpty: true
    },
    reason: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$6f80cf9974e4741);
/**
 * SOURCE TerminateCardReason @ squareup/bbdebit/cardmanagement.proto at 548:3
 */ $d272bac0a1712861$export$6f80cf9974e4741.TerminateCardReason = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.TerminateCardRequest.TerminateCardReason').values;
const $d272bac0a1712861$export$607876000fb9e10a = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.TerminateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$607876000fb9e10a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$607876000fb9e10a);
/**
 * SOURCE TerminateCardError @ squareup/bbdebit/cardmanagement.proto at 597:3
 */ $d272bac0a1712861$export$607876000fb9e10a.TerminateCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.TerminateCardResponse.TerminateCardError').values;
const $d272bac0a1712861$export$708d55e385ca855d = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.UnlockCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$708d55e385ca855d, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$708d55e385ca855d);
const $d272bac0a1712861$export$9f3bbac088b762d6 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.UnlockCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$9f3bbac088b762d6);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$9f3bbac088b762d6);
const $d272bac0a1712861$export$f40f1fb9063205d8 = $d272bac0a1712861$var$$root.lookupService('squareup.bbdebit.cardmanagement.CardManagementService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $239527144304fba6$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $239527144304fba6$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "Denominations": {
                        "fields": {
                            "banknoteCents": {
                                "type": "int32",
                                "id": 1,
                                "rule": "repeated"
                            },
                            "coinCents": {
                                "type": "int32",
                                "id": 2,
                                "rule": "repeated"
                            }
                        }
                    },
                    "CurrencyCode": {
                        "values": {
                            "AED": 784,
                            "AFN": 971,
                            "ALL": 8,
                            "AMD": 51,
                            "ANG": 532,
                            "AOA": 973,
                            "ARS": 32,
                            "AUD": 36,
                            "AWG": 533,
                            "AZN": 944,
                            "BAM": 977,
                            "BBD": 52,
                            "BDT": 50,
                            "BGN": 975,
                            "BHD": 48,
                            "BIF": 108,
                            "BMD": 60,
                            "BND": 96,
                            "BOB": 68,
                            "BOV": 984,
                            "BRL": 986,
                            "BSD": 44,
                            "BTN": 64,
                            "BWP": 72,
                            "BYR": 974,
                            "BZD": 84,
                            "CAD": 124,
                            "CDF": 976,
                            "CHE": 947,
                            "CHF": 756,
                            "CHW": 948,
                            "CLF": 990,
                            "CLP": 152,
                            "CNY": 156,
                            "COP": 170,
                            "COU": 970,
                            "CRC": 188,
                            "CUC": 931,
                            "CUP": 192,
                            "CVE": 132,
                            "CZK": 203,
                            "DJF": 262,
                            "DKK": 208,
                            "DOP": 214,
                            "DZD": 12,
                            "EGP": 818,
                            "ERN": 232,
                            "ETB": 230,
                            "EUR": 978,
                            "FJD": 242,
                            "FKP": 238,
                            "GBP": 826,
                            "GEL": 981,
                            "GHS": 936,
                            "GIP": 292,
                            "GMD": 270,
                            "GNF": 324,
                            "GTQ": 320,
                            "GYD": 328,
                            "HKD": 344,
                            "HNL": 340,
                            "HRK": 191,
                            "HTG": 332,
                            "HUF": 348,
                            "IDR": 360,
                            "ILS": 376,
                            "INR": 356,
                            "IQD": 368,
                            "IRR": 364,
                            "ISK": 352,
                            "JMD": 388,
                            "JOD": 400,
                            "JPY": 392,
                            "KES": 404,
                            "KGS": 417,
                            "KHR": 116,
                            "KMF": 174,
                            "KPW": 408,
                            "KRW": 410,
                            "KWD": 414,
                            "KYD": 136,
                            "KZT": 398,
                            "LAK": 418,
                            "LBP": 422,
                            "LKR": 144,
                            "LRD": 430,
                            "LSL": 426,
                            "LTL": 440,
                            "LVL": 428,
                            "LYD": 434,
                            "MAD": 504,
                            "MDL": 498,
                            "MGA": 969,
                            "MKD": 807,
                            "MMK": 104,
                            "MNT": 496,
                            "MOP": 446,
                            "MRO": 478,
                            "MUR": 480,
                            "MVR": 462,
                            "MWK": 454,
                            "MXN": 484,
                            "MXV": 979,
                            "MYR": 458,
                            "MZN": 943,
                            "NAD": 516,
                            "NGN": 566,
                            "NIO": 558,
                            "NOK": 578,
                            "NPR": 524,
                            "NZD": 554,
                            "OMR": 512,
                            "PAB": 590,
                            "PEN": 604,
                            "PGK": 598,
                            "PHP": 608,
                            "PKR": 586,
                            "PLN": 985,
                            "PYG": 600,
                            "QAR": 634,
                            "RON": 946,
                            "RSD": 941,
                            "RUB": 643,
                            "RWF": 646,
                            "SAR": 682,
                            "SBD": 90,
                            "SCR": 690,
                            "SDG": 938,
                            "SEK": 752,
                            "SGD": 702,
                            "SHP": 654,
                            "SLL": 694,
                            "SOS": 706,
                            "SRD": 968,
                            "SSP": 728,
                            "STD": 678,
                            "SVC": 222,
                            "SYP": 760,
                            "SZL": 748,
                            "THB": 764,
                            "TJS": 972,
                            "TMT": 934,
                            "TND": 788,
                            "TOP": 776,
                            "TRY": 949,
                            "TTD": 780,
                            "TWD": 901,
                            "TZS": 834,
                            "UAH": 980,
                            "UGX": 800,
                            "USD": 840,
                            "USN": 997,
                            "USS": 998,
                            "UYI": 940,
                            "UYU": 858,
                            "UZS": 860,
                            "VEF": 937,
                            "VND": 704,
                            "VUV": 548,
                            "WST": 882,
                            "XAF": 950,
                            "XAG": 961,
                            "XAU": 959,
                            "XBA": 955,
                            "XBB": 956,
                            "XBC": 957,
                            "XBD": 958,
                            "XCD": 951,
                            "XDR": 960,
                            "XOF": 952,
                            "XPD": 964,
                            "XPF": 953,
                            "XPT": 962,
                            "XTS": 963,
                            "XXX": 999,
                            "YER": 886,
                            "ZAR": 710,
                            "ZMK": 894,
                            "ZMW": 967,
                            "BTC": 1001,
                            "XUS": 1002,
                            "SLE": 925
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$239527144304fba6$var$$root.nested?.squareup?.nested?.common?.nested?.Denominations && !$239527144304fba6$var$$root.nested?.squareup?.nested?.common?.nested?.CurrencyCode) $239527144304fba6$var$$root.addJSON($239527144304fba6$var$jsonData);
const $239527144304fba6$export$c4145ae48aba6c75 = $239527144304fba6$var$$root.lookupType('squareup.common.Denominations');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($239527144304fba6$export$c4145ae48aba6c75);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($239527144304fba6$export$c4145ae48aba6c75);
const $239527144304fba6$export$6e3fca9a737174b = $239527144304fba6$var$$root.lookupEnum('squareup.common.CurrencyCode').values;


const $5404581afd6e3c7f$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $5404581afd6e3c7f$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "Money": {
                        "fields": {
                            "amount": {
                                "type": "int64",
                                "id": 2,
                                "rule": "optional"
                            },
                            "currencyCode": {
                                "type": ".squareup.common.CurrencyCode",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                    "default": "USD"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$5404581afd6e3c7f$var$$root.nested?.squareup?.nested?.common?.nested?.Money) $5404581afd6e3c7f$var$$root.addJSON($5404581afd6e3c7f$var$jsonData);
const $5404581afd6e3c7f$export$d26bcf891bc220f6 = $5404581afd6e3c7f$var$$root.lookupType('squareup.common.Money');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($5404581afd6e3c7f$export$d26bcf891bc220f6);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($5404581afd6e3c7f$export$d26bcf891bc220f6);



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $2b37713ec131f59e$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $2b37713ec131f59e$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "model": {
                        "nested": {
                            "BatchRequest": {
                                "fields": {
                                    "batchSize": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                            "default": 20
                                        }
                                    },
                                    "paginationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$2b37713ec131f59e$var$$root.nested?.squareup?.nested?.bizbank?.nested?.model?.nested?.BatchRequest) $2b37713ec131f59e$var$$root.addJSON($2b37713ec131f59e$var$jsonData);
const $2b37713ec131f59e$export$fc03689ccf0157bb = $2b37713ec131f59e$var$$root.lookupType('squareup.bizbank.model.BatchRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($2b37713ec131f59e$export$fc03689ccf0157bb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($2b37713ec131f59e$export$fc03689ccf0157bb);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $17122ce9dd6f9602$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $17122ce9dd6f9602$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "external": {
                        "nested": {
                            "ExternalSystem": {
                                "values": {
                                    "SQUARE_CASH_PAYMENT": 1,
                                    "SQUARE_CASH_TRANSFER": 2,
                                    "BANKSY_TRANSFER": 3,
                                    "DASH_CARD": 4,
                                    "CORE_PRO_ACH": 5,
                                    "SHAZAM_CARD": 6,
                                    "MARQETA_CARD": 7,
                                    "SQUARE_CASH_CLAWBACK": 8,
                                    "GREEN_DOT_ACH": 9,
                                    "CARD_FULFILLMENT": 10,
                                    "CARD_MAILING": 11,
                                    "PITNEY_BOWES_CARD_MAILING": 12,
                                    "BITCOIN_BLOCKCHAIN": 13,
                                    "TRADEBLOCK": 14,
                                    "SQUARE_CASH_TRADING": 15,
                                    "THIRD_PARTY_TRADE": 16,
                                    "MARQETA_BUSINESS_CARD": 17,
                                    "DRIVEWEALTH": 18,
                                    "INVEST_CORE": 19,
                                    "MARQETA_ACH": 20,
                                    "LEDGER_INTERNAL": 21,
                                    "LOANSTAR": 22,
                                    "SQUARE_CASH_REFUND": 23,
                                    "SQUARE_CASH_ADMIN": 24,
                                    "MOBILE_CHECK_DEPOSIT": 25,
                                    "MITEK_CHECK_DEPOSIT": 26,
                                    "BTC_NETWORK": 27,
                                    "RISKARBITER_ACH": 28,
                                    "INVEST_CRYPTO": 29,
                                    "VDBS": 30,
                                    "PAY_WITH_CASH": 31,
                                    "INSTANT_PAY": 32,
                                    "MODERN_TREASURY_WIRE": 33,
                                    "VISA_CARD": 34,
                                    "RISKARBITER_WIRE": 35,
                                    "CRYPTO_SPARKY": 36,
                                    "VISA_DPS_CARD": 37,
                                    "NETWORK_OF_NETWORKS_GLOBAL_X": 38,
                                    "DISPUTRON": 39,
                                    "CASH_LIMITS": 40,
                                    "CASH_ME_OUTSIDE": 41,
                                    "CASH_BARB": 42,
                                    "ENSENTA_CHECK_DEPOSIT": 43,
                                    "SQUARE_BANKING_OPS": 44,
                                    "OVERDRAFT": 45,
                                    "CASH_DDA_ACH": 46,
                                    "WELLS_FARGO_WIRE": 47,
                                    "CASH_FOR_BUSINESS": 48,
                                    "PIGGYBANK": 49,
                                    "BILL_PAY_PAYMENTUS": 50,
                                    "CIVIL_PROCESSOR": 51,
                                    "ISTL": 52,
                                    "ORDERLY_AFTERPAY": 53,
                                    "BLOCK_STABLE": 54,
                                    "SALVAGER": 55,
                                    "TIMECARDS": 56
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$17122ce9dd6f9602$var$$root.nested?.squareup?.nested?.banklin?.nested?.external?.nested?.ExternalSystem) $17122ce9dd6f9602$var$$root.addJSON($17122ce9dd6f9602$var$jsonData);
const $17122ce9dd6f9602$export$be167ca5b681b6fa = $17122ce9dd6f9602$var$$root.lookupEnum('squareup.banklin.external.ExternalSystem').values;



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $74ad1a5cc9e66690$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $74ad1a5cc9e66690$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "octopus": {
                        "nested": {
                            "OctopusResult": {
                                "values": {
                                    "SUCCESS": 1,
                                    "GENERIC_FAILURE": 2,
                                    "TRANSPORT_ERROR": 3,
                                    "UNSUPPORTED_INSTRUMENT": 4,
                                    "INSUFFICIENT_FUNDS": 5,
                                    "INVALID_INSTRUMENT": 6,
                                    "INSTRUMENT_EXPIRED": 7,
                                    "CARD_LOST_OR_STOLEN": 8,
                                    "INVALID_CVV": 9,
                                    "DECLINED": 10,
                                    "FAILED_TO_REACH_ISSUER": 11,
                                    "LEASE_EXPIRED": 12,
                                    "INVALID_ROUTING_NUMBER": 13,
                                    "CONTACT_ACQUIRER": 14,
                                    "PICK_UP_CARD": 15,
                                    "SUSPECTED_FRAUD": 16,
                                    "DO_NOT_HONOR": 17,
                                    "REENTER_TRANSACTION": 18,
                                    "ACCOUNT_FROZEN": 19,
                                    "FAILED_BANKBOOK_VALIDATION": 23,
                                    "INVALID_BANKBOOK_ACCOUNT": 34,
                                    "BANKBOOK_CREDENTIALS_EXPIRED": 33,
                                    "POTENTIALLY_INSUFFICIENT_FUNDS": 20,
                                    "INSTRUMENT_DISABLED": 21,
                                    "UNSUPPORTED_CURRENCY": 22,
                                    "INVALID_AVS": 24,
                                    "UNACTIVATED_INSTRUMENT": 25,
                                    "INVALID_PIN": 26,
                                    "OVER_LIMIT": 27,
                                    "TOO_MANY_ACTIVATION_ATTEMPTS": 28,
                                    "MANUAL_REVIEW": 29,
                                    "UNSUPPORTED_COUNTRY": 30,
                                    "CHIP_ERROR": 31,
                                    "INVALID_AMOUNT": 32,
                                    "BLOCKED_BY_FRISKY": 35,
                                    "RESTRICTED_CARD": 36,
                                    "TRANSACTION_NOT_PERMITTED": 37,
                                    "AUTHENTICATION_REQUIRED": 38,
                                    "INVALID_MERCHANT": 40,
                                    "INVALID_EXPIRATION": 41,
                                    "SUSPECTED_STOLEN": 42,
                                    "DECLINED_CARD_LOCKED": 43,
                                    "UNSUPPORTED_MCC": 44,
                                    "ACCOUNT_DENYLISTED": 45,
                                    "ACCOUNT_EXTERNAL_SUSPENDED": 46,
                                    "CARD_TERMINATED": 47,
                                    "UNSUPPORTED_REASON_CODE": 48,
                                    "MOBILE_WALLET_ERROR": 49,
                                    "STOP_PAYMENT": 50,
                                    "REVOCATION_OF_AUTH": 51,
                                    "MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER": 52,
                                    "MERCHANT_BLOCKED_BY_CUSTOMER": 53,
                                    "PIN_TRY_LIMIT_EXCEEDED": 54,
                                    "AUTO_REVERSAL": 55,
                                    "AUTO_REVERSAL_WITH_MANUAL_REVIEW": 56,
                                    "IN_APP_AUTHENTICATION_REQUIRED": 57,
                                    "DUPLICATE_TRANSACTION": 58,
                                    "AUTHENTICATION_FAILED": 59,
                                    "LINKED_ACCOUNT_LIMIT_EXCEEDED": 61,
                                    "STORED_VALUE_REQUIRED": 62,
                                    "DIDV_REQUIRED": 63,
                                    "BNF_NAME_REQUIRED": 64,
                                    "CREDIT_LIMIT_EXCEEDED": 65,
                                    "INVALID_USE_OF_CASH_CARD": 66,
                                    "INSTRUMENT_INCURS_ADDITIONAL_FEES": 67
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$74ad1a5cc9e66690$var$$root.nested?.squareup?.nested?.banklin?.nested?.octopus?.nested?.OctopusResult) $74ad1a5cc9e66690$var$$root.addJSON($74ad1a5cc9e66690$var$jsonData);
const $74ad1a5cc9e66690$export$90a1be0f1aee044f = $74ad1a5cc9e66690$var$$root.lookupEnum('squareup.banklin.octopus.OctopusResult').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $59b0e09277c0251d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $59b0e09277c0251d$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "StoredValueBalance": {
                        "nested": {
                            "Type": {
                                "values": {
                                    "CURRENCY": 1,
                                    "EQUITY": 2,
                                    "SAVINGS": 3,
                                    "LOAN": 4,
                                    "INVEST_PAYMENT": 5,
                                    "GIFT_CARD": 6,
                                    "CCY_CLEARING": 7,
                                    "EXT_INSTRUMENT": 8,
                                    "OVERDRAFT": 9,
                                    "P2P": 10,
                                    "EXCHANGE": 11,
                                    "FUNDING_PROMISE": 12,
                                    "AFTERPAY_LOAN": 13,
                                    "MONEY_POOL": 14
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$59b0e09277c0251d$var$$root.nested?.squareup?.nested?.banklin?.nested?.StoredValueBalance?.nested?.Type) $59b0e09277c0251d$var$$root.addJSON($59b0e09277c0251d$var$jsonData);
const $59b0e09277c0251d$export$2b863153179ec9fa = {};
/**
 * SOURCE Type @ squareup/banklin/stored_value_balance.proto at 34:3
 */ $59b0e09277c0251d$export$2b863153179ec9fa.Type = $59b0e09277c0251d$var$$root.lookupEnum('squareup.banklin.StoredValueBalance.Type').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $792408278ae1508d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $792408278ae1508d$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "rewards": {
                        "nested": {
                            "Reward": {
                                "fields": {
                                    "token": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "rewardProgramToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "flatReward": {
                                        "type": ".squareup.banklin.rewards.Reward.FlatRewardTerms",
                                        "id": 1
                                    },
                                    "percentageReward": {
                                        "type": ".squareup.banklin.rewards.Reward.PercentageRewardTerms",
                                        "id": 4
                                    }
                                },
                                "nested": {
                                    "FlatRewardTerms": {
                                        "fields": {
                                            "rewardAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "minimumSpendAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "PercentageRewardTerms": {
                                        "fields": {
                                            "rewardBasisPoints": {
                                                "type": "int64",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "terms": {
                                        "oneof": [
                                            "flatReward",
                                            "percentageReward"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$792408278ae1508d$var$$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward && !$792408278ae1508d$var$$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward?.nested?.FlatRewardTerms && !$792408278ae1508d$var$$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward?.nested?.PercentageRewardTerms) $792408278ae1508d$var$$root.addJSON($792408278ae1508d$var$jsonData);
const $792408278ae1508d$export$c6b5fd5be4b5d9d8 = $792408278ae1508d$var$$root.lookupType('squareup.banklin.rewards.Reward');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($792408278ae1508d$export$c6b5fd5be4b5d9d8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($792408278ae1508d$export$c6b5fd5be4b5d9d8);
/**
 * SOURCE FlatRewardTerms @ squareup/banklin/rewards.proto at 13:3
 */ $792408278ae1508d$export$c6b5fd5be4b5d9d8.FlatRewardTerms = $792408278ae1508d$var$$root.lookupType('squareup.banklin.rewards.Reward.FlatRewardTerms');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($792408278ae1508d$export$c6b5fd5be4b5d9d8.FlatRewardTerms);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($792408278ae1508d$export$c6b5fd5be4b5d9d8.FlatRewardTerms);
/**
 * SOURCE PercentageRewardTerms @ squareup/banklin/rewards.proto at 18:3
 */ $792408278ae1508d$export$c6b5fd5be4b5d9d8.PercentageRewardTerms = $792408278ae1508d$var$$root.lookupType('squareup.banklin.rewards.Reward.PercentageRewardTerms');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($792408278ae1508d$export$c6b5fd5be4b5d9d8.PercentageRewardTerms);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($792408278ae1508d$export$c6b5fd5be4b5d9d8.PercentageRewardTerms);



const $175b90705c9182e7$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $175b90705c9182e7$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "TransactionState": {
                        "values": {
                            "PENDING": 1,
                            "SETTLED": 2,
                            "VOIDED": 3,
                            "DECLINED": 4,
                            "REFUNDED": 5,
                            "REVERSED": 6,
                            "DISPUTED": 7,
                            "DISPUTE_REVERSED": 8,
                            "DISPUTE_WON": 9,
                            "IN_REVIEW": 10,
                            "IN_REVERSAL": 11,
                            "WAITING_ON_EXTERNAL": 12,
                            "SETTLED_EXTERNALLY": 13,
                            "REVERSED_EXTERNALLY": 14,
                            "IN_REVERSAL_EXTERNALLY": 15,
                            "DISPUTE_WRITTEN_OFF": 16
                        }
                    },
                    "TransactionReasonCode": {
                        "values": {
                            "ATM_WITHDRAWAL": 1,
                            "ATM_CHECK_DEPOSIT": 2,
                            "ATM_FEE": 3,
                            "CARD_PRESENT_PURCHASE": 4,
                            "CARD_NOT_PRESENT_PURCHASE": 5,
                            "ACCOUNT_MAINTENANCE_FEE": 6,
                            "BALANCE_ADJUSTMENT": 7,
                            "SQUARE_CASH_SELF": 8,
                            "SQUARE_CASH_P2P": 9,
                            "SQUARE_CASH_BUSINESS": 10,
                            "PINDEBIT": 11,
                            "PINCREDIT": 12,
                            "ACH": 13,
                            "UNLINKED_CREDIT": 14,
                            "GREENDOT_FEE": 15,
                            "NETWORK_FEE": 16,
                            "SQUARE_CASH_FEE": 17,
                            "CARD_MERCHANT_REFUND": 18,
                            "OVERDRAFT_FEE": 19,
                            "CARD_PRE_AUTHORIZATION": 20,
                            "MOBILE_CHECK_DEPOSIT": 21,
                            "CHECK_PAYMENT": 22,
                            "CARD_VALIDATION": 23,
                            "ONLINE_PURCHASE": 24,
                            "ATM_BALANCE_CHECK": 25,
                            "SQUARE_REGISTER_INSTANT_DEPOSIT": 26,
                            "SQUARE_CASH_REFERRAL": 27,
                            "APPLE_PAY_PURCHASE": 28,
                            "APPLE_PAY_ACTIVATION": 29,
                            "INTERNAL_CURRENCY_EXCHANGE": 30,
                            "BITCOIN_TRANSFER": 31,
                            "ANDROID_PAY_PURCHASE": 32,
                            "ANDROID_PAY_ACTIVATION": 33,
                            "PINDEBIT_CASHBACK": 34,
                            "PINDEBIT_QUASI_CASH": 35,
                            "CARD_ACTIVATION": 36,
                            "FUNDS_TRANSFER": 37,
                            "BILL_PAYMENT": 38,
                            "ATM_UNVERIFIED_DEPOSIT": 39,
                            "ATM_CASH_DEPOSIT": 40,
                            "SAMSUNG_PAY_PURCHASE": 41,
                            "SAMSUNG_PAY_ACTIVATION": 42,
                            "MICROSOFT_PAY_PURCHASE": 43,
                            "MICROSOFT_PAY_ACTIVATION": 44,
                            "VISA_CHECKOUT_PURCHASE": 45,
                            "VISA_CHECKOUT_ACTIVATION": 46,
                            "FACEBOOK_TOKEN_PURCHASE": 47,
                            "FACEBOOK_TOKEN_ACTIVATION": 48,
                            "NETFLIX_TOKEN_PURCHASE": 49,
                            "NETFLIX_TOKEN_ACTIVATION": 50,
                            "ATM_TRANSFER": 51,
                            "BITCOIN_TRADE_SETTLEMENT": 52,
                            "CAVIAR_SETTLEMENT": 53,
                            "DIGITAL_WALLET_PURCHASE": 54,
                            "SECURITIES_TRADE": 55,
                            "SECURITIES_DIVIDEND_PAYMENT": 56,
                            "SECURITIES_CORPORATE_ACTION": 57,
                            "ACCOUNT_FUNDING_TRANSACTION": 58,
                            "ORIGINAL_CREDIT_TRANSACTION": 59,
                            "CUSTOMER_MERGE": 60,
                            "LENDING_CASH_ADVANCE": 61,
                            "SECURITIES_TRADE_ERROR_CORRECTION": 62,
                            "ADMIN_BALANCE_ADJUSTMENT": 63,
                            "APPLE_PAY_NOT_PRESENT_PURCHASE": 64,
                            "ANDROID_PAY_NOT_PRESENT_PURCHASE": 65,
                            "BITCOIN_P2P": 66,
                            "MONEY_ORDER": 67,
                            "PAPER_MONEY_DEPOSIT": 68,
                            "PWC_PURCHASE": 69,
                            "INSTANT_PAY_ADVANCE": 70,
                            "INSTANT_PAY_PAYBACK": 71,
                            "SPONSORED_CARD_ACTIVATION": 72,
                            "WIRE": 73,
                            "LIGHTNING_TRANSFER": 74,
                            "LENDING_DRAWDOWN": 75,
                            "LENDING_PAYMENT": 76,
                            "LENDING_REFUND": 77,
                            "LENDING_LATE_FEE": 78,
                            "LENDING_INTEREST": 79,
                            "LENDING_ADJUSTMENT": 80,
                            "CRYPTO_PAYROLL_CONVERSION": 81,
                            "CRYPTO_CASH_CARD_ROUND_UP": 82,
                            "REMITTANCE_P2P_PAYMENT": 83,
                            "SAVINGS_TRANSFER": 84,
                            "OVERDRAFT_LIMIT_UPDATE": 85,
                            "OVERDRAFT_REPAYMENT": 86,
                            "OVERDRAFT_NON_REPAYMENT_UPDATE": 87,
                            "SQUARE_TAP_TO_PAY": 88,
                            "OVERDRAFT_RECOUP_REPAYMENT": 89,
                            "OVERDRAFT_MANUAL_REPAYMENT": 90,
                            "SAVINGS_INTEREST": 91,
                            "BITCOIN_WITHDRAWAL": 92,
                            "ONE_TIME_HOLD_TAX_LEVY": 93,
                            "CONTINUOUS_HOLD_TAX_LEVY": 94,
                            "CRYPTO_PURCHASE": 95,
                            "EQUITY_PURCHASE": 96,
                            "REMITTANCE": 97,
                            "RECEIVERSHIP": 98,
                            "INFORMATION_SUBPOENA": 99,
                            "USDC_BUY": 100,
                            "USDC_SELL": 101,
                            "MONEY_POOL_PAYMENT": 102,
                            "MONEY_POOL_TRANSFER": 103,
                            "SQUARE_TIP_PAYMENT": 104
                        }
                    },
                    "TransactionDeclineReason": {
                        "values": {
                            "UNKNOWN": 1,
                            "INSUFFICIENT_BALANCE": 2,
                            "POTENTIALLY_INSUFFICIENT_BALANCE": 3,
                            "BLOCKED_BY_RISK": 4,
                            "CARD_DISABLED": 5,
                            "INVALID_CURRENCY": 6,
                            "RISK_SYSTEMS_UNAVAILABLE": 7
                        }
                    },
                    "TransactionEvent": {
                        "fields": {
                            "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                            },
                            "transactionToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                            },
                            "type": {
                                "type": ".squareup.banklin.TransactionState",
                                "id": 3,
                                "rule": "optional"
                            },
                            "externalSystem": {
                                "type": ".squareup.banklin.external.ExternalSystem",
                                "id": 4,
                                "rule": "optional"
                            },
                            "externalSystemId": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                            },
                            "balanceToken": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                            },
                            "instrumentToken": {
                                "type": "string",
                                "id": 7,
                                "rule": "optional"
                            },
                            "occurredAt": {
                                "type": "int64",
                                "id": 8,
                                "rule": "optional"
                            },
                            "eventOrder": {
                                "type": "int64",
                                "id": 16,
                                "rule": "optional"
                            },
                            "amount": {
                                "type": ".squareup.common.Money",
                                "id": 9,
                                "rule": "optional"
                            },
                            "balanceSnapshotAmount": {
                                "type": ".squareup.common.Money",
                                "id": 10,
                                "rule": "optional"
                            },
                            "description": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                            },
                            "reference": {
                                "type": "string",
                                "id": 12,
                                "rule": "optional"
                            },
                            "declineReason": {
                                "type": ".squareup.banklin.TransactionDeclineReason",
                                "id": 13,
                                "rule": "optional"
                            },
                            "balanceSnapshotVersion": {
                                "type": "int64",
                                "id": 14,
                                "rule": "optional"
                            },
                            "octopusResult": {
                                "type": ".squareup.banklin.octopus.OctopusResult",
                                "id": 15,
                                "rule": "optional"
                            },
                            "reasonCode": {
                                "type": ".squareup.banklin.TransactionReasonCode",
                                "id": 18,
                                "rule": "optional"
                            },
                            "kind": {
                                "type": ".squareup.banklin.EventKind",
                                "id": 19,
                                "rule": "optional"
                            },
                            "amountType": {
                                "type": ".squareup.banklin.AmountType",
                                "id": 31,
                                "rule": "optional"
                            },
                            "merchantToken": {
                                "type": "string",
                                "id": 20,
                                "rule": "optional"
                            },
                            "expiresAt": {
                                "type": "int64",
                                "id": 21,
                                "rule": "optional"
                            },
                            "customerToken": {
                                "type": "string",
                                "id": 23,
                                "rule": "optional"
                            },
                            "precedingRelatedExternalSystemId": {
                                "type": "string",
                                "id": 25,
                                "rule": "optional"
                            },
                            "disputeFundsAvailability": {
                                "type": ".squareup.banklin.DisputeFundsAvailability",
                                "id": 26,
                                "rule": "optional"
                            },
                            "customerFeeSatoshis": {
                                "type": "uint64",
                                "id": 27,
                                "rule": "optional"
                            },
                            "targetWalletAddress": {
                                "type": "string",
                                "id": 28,
                                "rule": "optional"
                            },
                            "balanceType": {
                                "type": ".squareup.banklin.StoredValueBalance.Type",
                                "id": 29,
                                "rule": "optional"
                            },
                            "internationalFee": {
                                "type": ".squareup.common.Money",
                                "id": 30,
                                "rule": "optional"
                            },
                            "discount": {
                                "type": ".squareup.banklin.TransactionEvent.Discount",
                                "id": 22
                            }
                        },
                        "nested": {
                            "Discount": {
                                "fields": {
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "discountAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "rewardDiscount": {
                                        "type": ".squareup.banklin.RewardDiscount",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "reward": {
                                        "type": ".squareup.banklin.rewards.Reward",
                                        "id": 1
                                    }
                                },
                                "nested": {
                                    "source": {
                                        "oneof": [
                                            "reward"
                                        ]
                                    }
                                }
                            },
                            "kind_specific_details": {
                                "oneof": [
                                    "discount"
                                ]
                            }
                        }
                    },
                    "DisputeFundsAvailability": {
                        "values": {
                            "RELEASE_TO_CUSTOMER": 1,
                            "WITHHOLD": 2,
                            "ISSUED": 3,
                            "NOT_ISSUED": 4
                        }
                    },
                    "AmountType": {
                        "values": {
                            "AMOUNT_TYPE_UNSPECIFIED": 0,
                            "AMOUNT_TYPE_PRINCIPAL": 1,
                            "AMOUNT_TYPE_ACQUIRER_FEE": 2,
                            "AMOUNT_TYPE_DISCOUNT": 3,
                            "AMOUNT_TYPE_CASH_APP_FEE": 4,
                            "AMOUNT_TYPE_CASH_BACK": 5,
                            "AMOUNT_TYPE_ACQUIRER_FEE_REIMBURSEMENT": 6,
                            "AMOUNT_TYPE_CASH_APP_FEE_REIMBURSEMENT": 7,
                            "AMOUNT_TYPE_GOVERNMENT_FEE": 8,
                            "AMOUNT_TYPE_TAX_WITHHOLDING": 9,
                            "AMOUNT_TYPE_LOAN_PRINCIPAL": 10,
                            "AMOUNT_TYPE_LOAN_INTEREST": 11,
                            "AMOUNT_TYPE_LOAN_SETUP_FEE": 12,
                            "AMOUNT_TYPE_LOAN_LATE_FEE": 13,
                            "AMOUNT_TYPE_CREDIT_CARD_FEE": 14,
                            "AMOUNT_TYPE_BUSINESS_FEE": 15,
                            "AMOUNT_TYPE_INSTANT_DEPOSIT_FEE": 16,
                            "AMOUNT_TYPE_INTERNATIONAL_FEE": 17,
                            "AMOUNT_TYPE_INTERNATIONAL_FEE_REIMBURSEMENT": 18,
                            "AMOUNT_TYPE_OUT_OF_NETWORK_FEE": 19
                        }
                    },
                    "EventKind": {
                        "values": {
                            "NO_AUTHORIZATION": 1,
                            "AUTHORIZATION": 2,
                            "PREAUTHORIZATION": 3,
                            "AFD_PREAUTHORIZATION": 4,
                            "AUTH_ADJUSTMENT": 5,
                            "ACQUIRER_FEE": 6,
                            "DISCOUNT": 7,
                            "SUBMITTED_TO_BITBANK": 8,
                            "SENT_TO_BLOCKCHAIN": 9,
                            "AUTH_OVERRIDE": 10,
                            "AUTH_INCREMENTAL": 11,
                            "MERCHANT_REVERSAL": 12,
                            "ISSUER_REVERSAL": 13,
                            "BOOKKEEPING": 14,
                            "CASH_APP_FEE": 15,
                            "PARTIAL_CAPTURE": 16,
                            "CASH_BACK": 17,
                            "RECEIVED_FROM_BLOCKCHAIN": 18,
                            "CASH_APP_FEE_REIMBURSEMENT": 19,
                            "ACQUIRER_FEE_REIMBURSEMENT": 20,
                            "SETTLED_INTERNALLY": 21,
                            "EARLY_DIRECT_DEPOSIT": 22,
                            "PROVISIONAL_CREDIT_ISSUED": 23,
                            "PROVISIONAL_CREDIT_WITHHELD": 24,
                            "PARTIAL_AUTH": 25,
                            "PAPER_CASH_DEPOSIT": 26,
                            "GOVERNMENT_FEE": 27,
                            "TAX_WITHHOLDING": 28,
                            "LOAN_PRINCIPAL": 29,
                            "LOAN_INTEREST": 30,
                            "LOAN_SETUP_FEE": 31,
                            "LOAN_LATE_FEE": 32,
                            "INTERNAL_REVERSAL": 33,
                            "RULE_BASED_AUTO_INTERNAL_REVERSAL": 34,
                            "AGENT_INTERNAL_REVERSAL": 35,
                            "INTERNATIONAL_FEE": 36,
                            "INTERNATIONAL_FEE_REIMBURSEMENT": 37,
                            "CREDIT_CARD_FEE": 38,
                            "INSTANT_DEPOSIT_FEE": 39,
                            "BUSINESS_FEE": 40,
                            "OUT_OF_NETWORK_FEE": 41
                        }
                    },
                    "RewardDiscount": {
                        "fields": {
                            "discountToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                            },
                            "missingRewardReportToken": {
                                "type": "string",
                                "id": 7,
                                "rule": "optional"
                            },
                            "missingRewardReportData": {
                                "type": ".squareup.banklin.RewardDiscount.MissingRewardReportData",
                                "id": 8,
                                "rule": "optional"
                            },
                            "crossCurrencyReward": {
                                "type": ".squareup.common.Money",
                                "id": 9,
                                "rule": "optional"
                            },
                            "crossCurrencyRewardExchangeRate": {
                                "type": ".squareup.common.Money",
                                "id": 10,
                                "rule": "optional"
                            },
                            "cardTransactionToken": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                            },
                            "rewardTransactionToken": {
                                "type": "string",
                                "id": 12,
                                "rule": "optional"
                            },
                            "crossCurrencyRewardInfo": {
                                "type": ".squareup.banklin.RewardDiscount.CrossCurrencyRewardInfo",
                                "id": 13,
                                "rule": "optional"
                            },
                            "rewardAmount": {
                                "type": ".squareup.common.Money",
                                "id": 5
                            },
                            "rewardBasisPoints": {
                                "type": "int64",
                                "id": 6
                            }
                        },
                        "nested": {
                            "MissingRewardReportData": {
                                "fields": {
                                    "missingRewardReportToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "approvedOnce": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "approvalReason": {
                                        "type": ".squareup.banklin.RewardDiscount.MissingRewardReportData.ApprovalReason",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ApprovalReason": {
                                        "values": {
                                            "MERCHANT_DATA_UPDATED": 1,
                                            "ONE_TIME_APPROVAL_SILENT": 2,
                                            "ONE_TIME_APPROVAL": 3
                                        }
                                    }
                                }
                            },
                            "CrossCurrencyRewardInfo": {
                                "fields": {
                                    "rewardAmount": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "rewardCurrency": {
                                        "type": ".squareup.common.CurrencyCode",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "rewardValueSnapshot": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "rewardExchangeRate": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "rewardTransactionToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "cardTransactionToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "discount": {
                                "oneof": [
                                    "rewardAmount",
                                    "rewardBasisPoints"
                                ]
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionState && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionReasonCode && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionDeclineReason && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionEvent && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionEvent?.nested?.Discount && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.DisputeFundsAvailability && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.AmountType && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.EventKind && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.MissingRewardReportData && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.MissingRewardReportData?.nested?.ApprovalReason && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.CrossCurrencyRewardInfo) $175b90705c9182e7$var$$root.addJSON($175b90705c9182e7$var$jsonData);
const $175b90705c9182e7$export$52a28250c602ca8a = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.TransactionState').values;
const $175b90705c9182e7$export$7154d4c57f05541c = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.TransactionReasonCode').values;
const $175b90705c9182e7$export$af7292a86c4af22c = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.TransactionDeclineReason').values;
const $175b90705c9182e7$export$71730754b67b3035 = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.TransactionEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$71730754b67b3035);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$71730754b67b3035);
/**
 * SOURCE Discount @ squareup/banklin/transaction.proto at 631:3
 */ $175b90705c9182e7$export$71730754b67b3035.Discount = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.TransactionEvent.Discount');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$71730754b67b3035.Discount);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$71730754b67b3035.Discount);
const $175b90705c9182e7$export$d56a4336bd979175 = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.DisputeFundsAvailability').values;
const $175b90705c9182e7$export$4ced26ff9a1ce1ae = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.AmountType').values;
const $175b90705c9182e7$export$50508d7849040d51 = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.EventKind').values;
const $175b90705c9182e7$export$e33da8b6e7e2c746 = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.RewardDiscount');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$e33da8b6e7e2c746);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$e33da8b6e7e2c746);
/**
 * SOURCE MissingRewardReportData @ squareup/banklin/transaction.proto at 969:3
 */ $175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.RewardDiscount.MissingRewardReportData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData);
/**
 * SOURCE ApprovalReason @ squareup/banklin/transaction.proto at 972:5
 */ $175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData.ApprovalReason = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.RewardDiscount.MissingRewardReportData.ApprovalReason').values;
/**
 * Populated only if this payment is a boost where the reward is a different currency than the
 * card transaction.  Gives us context related to the reward transaction for display on the card
 * transaction.
 *
 * SOURCE CrossCurrencyRewardInfo @ squareup/banklin/transaction.proto at 996:3
 */ $175b90705c9182e7$export$e33da8b6e7e2c746.CrossCurrencyRewardInfo = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.RewardDiscount.CrossCurrencyRewardInfo');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$e33da8b6e7e2c746.CrossCurrencyRewardInfo);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$e33da8b6e7e2c746.CrossCurrencyRewardInfo);



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $82064d661c002629$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $82064d661c002629$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "DigitalWalletState": {
                        "values": {
                            "REQUESTED": 1,
                            "VERIFICATION_REQUESTED": 2,
                            "REJECTED": 3,
                            "SUSPENDED": 4,
                            "ACTIVE": 5,
                            "REJECTED_INTERNALLY": 6,
                            "FAILED": 7,
                            "TERMINATED": 8,
                            "REQUEST_DECLINED": 9
                        }
                    },
                    "DigitalWalletIssuer": {
                        "values": {
                            "APPLE_PAY": 1,
                            "ANDROID_PAY": 2,
                            "SAMSUNG_PAY": 3,
                            "MICROSOFT_PAY": 4,
                            "VISA_CHECKOUT": 5,
                            "FACEBOOK": 6,
                            "NETFLIX": 7,
                            "UNKNOWN_WALLET_ISSUER": 8,
                            "FITBIT_PAY": 9,
                            "GARMIN_PAY": 10,
                            "SPOTIFY": 11,
                            "ALIPAY": 12,
                            "STRIPE": 13,
                            "VIACOM_INTERNATIONAL": 14,
                            "AMAZON": 15,
                            "UBER": 16,
                            "SCENTBIRD": 17,
                            "SONY_PLAYSTATION": 18,
                            "ONE_PAY": 19,
                            "DOORDASH": 20,
                            "SHOPIFY": 21,
                            "MICROSOFT_NETWORK": 22,
                            "PAYPAL": 23,
                            "AUTOZONE": 24,
                            "WORLDPAY": 25,
                            "STARBUCKS": 26,
                            "TIDAL": 27,
                            "CLASSDOJO": 28,
                            "ANGIES_LIST": 29,
                            "ADOBE": 30,
                            "EBAY": 31
                        }
                    },
                    "DeviceType": {
                        "values": {
                            "MOBILE_PHONE": 1,
                            "WATCH": 2,
                            "TABLET": 3,
                            "LAPTOP": 4,
                            "PERSONAL_COMPUTER": 5,
                            "WEARABLE": 6,
                            "UNKNOWN_DEVICE_TYPE": 10
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$82064d661c002629$var$$root.nested?.squareup?.nested?.banklin?.nested?.DigitalWalletState && !$82064d661c002629$var$$root.nested?.squareup?.nested?.banklin?.nested?.DigitalWalletIssuer && !$82064d661c002629$var$$root.nested?.squareup?.nested?.banklin?.nested?.DeviceType) $82064d661c002629$var$$root.addJSON($82064d661c002629$var$jsonData);
const $82064d661c002629$export$a44a1ae835a585c3 = $82064d661c002629$var$$root.lookupEnum('squareup.banklin.DigitalWalletState').values;
const $82064d661c002629$export$fa3a1177a934b3f1 = $82064d661c002629$var$$root.lookupEnum('squareup.banklin.DigitalWalletIssuer').values;
const $82064d661c002629$export$ec1e04e4e5ef8233 = $82064d661c002629$var$$root.lookupEnum('squareup.banklin.DeviceType').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $caa20d27bc7281a1$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $caa20d27bc7281a1$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "invitations": {
                        "nested": {
                            "CardInvitationState": {
                                "values": {
                                    "CARD_INVITATION_STATE_DO_NOT_USE": 0,
                                    "OPEN": 1,
                                    "CLAIMED": 2,
                                    "CLOSED": 3
                                }
                            },
                            "CardInvitationClosedReason": {
                                "values": {
                                    "CLOSED_REASON_DO_NOT_USE": 0,
                                    "EXPIRED": 1,
                                    "REVOKED": 2
                                }
                            },
                            "CardInvitation": {
                                "fields": {
                                    "token": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "inviterPersonToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "inviteePersonToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "state": {
                                        "type": ".squareup.bizbank.invitations.CardInvitationState",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "closedReason": {
                                        "type": ".squareup.bizbank.invitations.CardInvitationClosedReason",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "expiresAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "createdAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "updatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$caa20d27bc7281a1$var$$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitationState && !$caa20d27bc7281a1$var$$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitationClosedReason && !$caa20d27bc7281a1$var$$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitation) $caa20d27bc7281a1$var$$root.addJSON($caa20d27bc7281a1$var$jsonData);
const $caa20d27bc7281a1$export$ba2c43813aefeb59 = $caa20d27bc7281a1$var$$root.lookupEnum('squareup.bizbank.invitations.CardInvitationState').values;
const $caa20d27bc7281a1$export$bcc8c651ffea7e86 = $caa20d27bc7281a1$var$$root.lookupEnum('squareup.bizbank.invitations.CardInvitationClosedReason').values;
const $caa20d27bc7281a1$export$285d7a47fed7dbbc = $caa20d27bc7281a1$var$$root.lookupType('squareup.bizbank.invitations.CardInvitation');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($caa20d27bc7281a1$export$285d7a47fed7dbbc);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($caa20d27bc7281a1$export$285d7a47fed7dbbc);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $3a95a6cf182aa66b$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3a95a6cf182aa66b$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "IssuedCard": {
                        "nested": {
                            "CardState": {
                                "values": {
                                    "ACTIVE": 1,
                                    "DISABLED": 2,
                                    "TERMINATED": 3,
                                    "SUSPENDED": 4,
                                    "VERIFIED": 5,
                                    "ISSUED": 6,
                                    "UNDELIVERABLE": 7,
                                    "MONITORED": 12,
                                    "SHIPPED": 8,
                                    "CANCELLED": 9,
                                    "REJECTED": 10,
                                    "DESTROYED": 11
                                }
                            }
                        }
                    },
                    "CardEvent": {
                        "fields": {
                            "issuedCardToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                            },
                            "storedValueToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                            },
                            "issuer": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                            },
                            "type": {
                                "type": ".squareup.banklin.CardEvent.Type",
                                "id": 4,
                                "rule": "optional"
                            },
                            "result": {
                                "type": ".squareup.banklin.CardEvent.Result",
                                "id": 5,
                                "rule": "optional"
                            },
                            "message": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                            },
                            "occurredAt": {
                                "type": "int64",
                                "id": 7,
                                "rule": "optional"
                            },
                            "createdAt": {
                                "type": "int64",
                                "id": 8,
                                "rule": "optional"
                            },
                            "fideliusToken": {
                                "type": "string",
                                "id": 9,
                                "rule": "optional"
                            },
                            "cardState": {
                                "type": ".squareup.banklin.IssuedCard.CardState",
                                "id": 10,
                                "rule": "optional"
                            },
                            "cardType": {
                                "type": ".squareup.banklin.CardType",
                                "id": 11,
                                "rule": "optional"
                            },
                            "customerToken": {
                                "type": "string",
                                "id": 12,
                                "rule": "optional"
                            }
                        },
                        "nested": {
                            "Result": {
                                "values": {
                                    "SUCCESS": 1,
                                    "FAILED": 2,
                                    "ISSUER_EXCEPTION": 3,
                                    "SUSPECTED_FRAUD": 4
                                }
                            },
                            "Type": {
                                "values": {
                                    "ACTIVATED": 1,
                                    "DISABLED": 2,
                                    "ENABLED": 3,
                                    "SUSPENDED": 4,
                                    "REINSTATED": 5,
                                    "ISSUED": 6,
                                    "TERMINATED": 7,
                                    "VERIFIED": 8,
                                    "SHIPPED": 9,
                                    "CANCELLED": 10,
                                    "REJECTED": 11,
                                    "DESTROYED": 12,
                                    "SET_PIN": 13,
                                    "UNDELIVERABLE": 14,
                                    "REISSUED_LOST_OR_STOLEN": 15,
                                    "REISSUED_DAMAGED": 16,
                                    "UPDATED_IDV": 17,
                                    "UPDATED_ADDRESS": 18,
                                    "UPDATED_EMAIL": 19,
                                    "COURIER_FIRST_SCANNED": 20,
                                    "COURIER_IN_HOME_FORECAST": 21,
                                    "COURIER_UNDELIVERABLE": 22,
                                    "UPDATED_USER": 23,
                                    "DEACTIVATED_USER": 24,
                                    "ENABLED_ENHANCED_MONITORING": 25,
                                    "ACTIVATED_USER": 26,
                                    "SET_PRIMARY": 27,
                                    "UNSET_PRIMARY": 28,
                                    "UPDATED_BUSINESS": 29,
                                    "DISABLED_ENHANCED_MONITORING": 30,
                                    "ORDERED": 31,
                                    "ACTIVATION_ATTEMPT": 32,
                                    "ACTIVATION_RISK_EVALUATED": 33
                                }
                            }
                        }
                    },
                    "CardType": {
                        "values": {
                            "VIRTUAL": 1,
                            "PHYSICAL": 2
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.IssuedCard?.nested?.CardState && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent?.nested?.Result && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent?.nested?.Type && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardType) $3a95a6cf182aa66b$var$$root.addJSON($3a95a6cf182aa66b$var$jsonData);
const $3a95a6cf182aa66b$export$e4a7553722ed8603 = {};
/**
 * SOURCE CardState @ squareup/banklin/issued_card.proto at 80:3
 */ $3a95a6cf182aa66b$export$e4a7553722ed8603.CardState = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.IssuedCard.CardState').values;
const $3a95a6cf182aa66b$export$fd2b87ee9b86c6df = $3a95a6cf182aa66b$var$$root.lookupType('squareup.banklin.CardEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3a95a6cf182aa66b$export$fd2b87ee9b86c6df);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3a95a6cf182aa66b$export$fd2b87ee9b86c6df);
/**
 * SOURCE Result @ squareup/banklin/issued_card.proto at 187:3
 */ $3a95a6cf182aa66b$export$fd2b87ee9b86c6df.Result = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.CardEvent.Result').values;
/**
 * SOURCE Type @ squareup/banklin/issued_card.proto at 194:3
 */ $3a95a6cf182aa66b$export$fd2b87ee9b86c6df.Type = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.CardEvent.Type').values;
const $3a95a6cf182aa66b$export$f1a79bffad3377cd = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.CardType').values;



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $65c896b44f717dd1$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $65c896b44f717dd1$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "instrument": {
                        "nested": {
                            "InstrumentType": {
                                "values": {
                                    "UNKNOWN": 1,
                                    "VISA": 2,
                                    "MASTER_CARD": 3,
                                    "AMERICAN_EXPRESS": 4,
                                    "DISCOVER": 5,
                                    "DISCOVER_DINERS": 6,
                                    "JCB": 7,
                                    "BALANCE": 8,
                                    "UNION_PAY": 9,
                                    "SQUARE_GIFT_CARD_V2": 10,
                                    "INTERAC": 11,
                                    "SQUARE_CAPITAL_CARD": 12,
                                    "EFTPOS": 13,
                                    "FELICA": 14,
                                    "ALIPAY": 15,
                                    "CASH_APP": 16,
                                    "EBT": 17,
                                    "PAYPAY": 18,
                                    "AFTERPAY": 19,
                                    "SQUARE_ACCOUNT_BALANCE": 20,
                                    "AU_PAY": 21,
                                    "MERPAY": 22,
                                    "RAKUTEN_PAY": 23,
                                    "D_BARAI": 24,
                                    "WECHAT_PAY": 25
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$65c896b44f717dd1$var$$root.nested?.squareup?.nested?.common?.nested?.instrument?.nested?.InstrumentType) $65c896b44f717dd1$var$$root.addJSON($65c896b44f717dd1$var$jsonData);
const $65c896b44f717dd1$export$8facc574da228694 = $65c896b44f717dd1$var$$root.lookupEnum('squareup.common.instrument.InstrumentType').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $41eeb8c0a39de798$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $41eeb8c0a39de798$var$jsonData = {
    "squareup": {
        "nested": {
            "solidshop": {
                "nested": {
                    "VerifyShippingAddressResponse": {
                        "nested": {
                            "CorrectedField": {
                                "values": {
                                    "UNKNOWN_FIELD": 0,
                                    "POSTAL_CODE": 1,
                                    "LOCALITY": 2,
                                    "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                                    "ADDRESS_LINE_1": 4,
                                    "ADDRESS_LINE_2": 5
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$41eeb8c0a39de798$var$$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressResponse?.nested?.CorrectedField) $41eeb8c0a39de798$var$$root.addJSON($41eeb8c0a39de798$var$jsonData);
const $41eeb8c0a39de798$export$d8fc9e0b7f205a8c = {};
/**
 * Which fields were corrected in the corrected address
 *
 * SOURCE CorrectedField @ squareup/solidshop/addressVerification/service.proto at 67:3
 */ $41eeb8c0a39de798$export$d8fc9e0b7f205a8c.CorrectedField = $41eeb8c0a39de798$var$$root.lookupEnum('squareup.solidshop.VerifyShippingAddressResponse.CorrectedField').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 






const $e57ed9311822f585$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e57ed9311822f585$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "unified_activity": {
                        "nested": {
                            "UnifiedActivity": {
                                "fields": {
                                    "activityToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "latestEventAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "activityType": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "activityState": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "description": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "merchantImage": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "declineReason": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "cardLastFour": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "transactionReasonCode": {
                                        "type": ".squareup.banklin.TransactionReasonCode",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "merchantCanonicalCategory": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantCanonicalCategory",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "banklinCardToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "balanceToken": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ActivityType": {
                                        "values": {
                                            "UNKNOWN": 0,
                                            "CARD_PAYMENT": 1,
                                            "ATM_WITHDRAWAL": 2,
                                            "DEBIT_CARD_TRANSFER_IN": 3,
                                            "STANDARD_TRANSFER_OUT": 4,
                                            "INSTANT_TRANSFER_OUT": 5,
                                            "CARD_PROCESSING_SALES": 6,
                                            "CARD_PROCESSING_ADJUSTMENTS": 7,
                                            "PROMOTIONAL_REWARD": 8,
                                            "PAYROLL": 9,
                                            "PAYROLL_CANCELLATION": 10,
                                            "DIRECT_DEPOSIT_IN": 11,
                                            "DIRECT_DEPOSIT_OUT": 12,
                                            "CAPITAL_LOAN": 13,
                                            "CAPITAL_LOAN_CANCELLATION": 14,
                                            "CHECK_TRANSFER_IN": 15,
                                            "BALANCE_TRANSFER_SFS_AND_BANKLIN": 16,
                                            "BALANCE_TRANSFER_OTHER": 17,
                                            "BALANCE_TRANSFER_IN_SFS_TO_BANKLIN": 18,
                                            "BALANCE_TRANSFER_OUT_BANKLIN_TO_SFS": 19,
                                            "DEBIT_CARD_PAY_IN_CHARGEBACK": 20,
                                            "DIRECT_DEPOSIT_IN_CHARGEBACK": 21,
                                            "CHECK_TRANSFER_IN_CHARGEBACK": 22,
                                            "BILL_PAYMENT": 23
                                        }
                                    },
                                    "ActivityState": {
                                        "values": {
                                            "PENDING": 1,
                                            "SETTLED": 2,
                                            "VOIDED": 3,
                                            "DECLINED": 4,
                                            "REFUNDED": 5,
                                            "REVERSED": 6,
                                            "DISPUTED": 7,
                                            "DISPUTE_REVERSED": 8,
                                            "DISPUTE_WON": 9,
                                            "IN_REVIEW": 10,
                                            "IN_REVERSAL": 11,
                                            "WAITING_ON_EXTERNAL": 12,
                                            "INITIATED": 13
                                        }
                                    },
                                    "MerchantImage": {
                                        "fields": {
                                            "merchantImageUrl": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "colorCode": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "backgroundColorCode": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "isPrerendered": {
                                                "type": "bool",
                                                "id": 4,
                                                "rule": "optional",
                                                "options": {
                                                    "default": false
                                                }
                                            }
                                        }
                                    },
                                    "MerchantCanonicalCategory": {
                                        "fields": {
                                            "name": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "UnifiedActivityEvent": {
                                "fields": {
                                    "activityToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "occurredAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "activityType": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "activityState": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "description": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "merchantImage": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "eventToken": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "declineReason": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "cardLastFour": {
                                        "type": "string",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "modifierType": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "bizbankCardToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "sourceApp": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetUnifiedActivitiesRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "activityStateCategory": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.ActivityStateCategory",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "currentTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ActivityStateCategory": {
                                        "values": {
                                            "PENDING": 1,
                                            "COMPLETED": 2
                                        }
                                    },
                                    "Filters": {
                                        "fields": {
                                            "includeActivityTypes": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "minLatestEventAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "maxLatestEventAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxRetroactiveBalanceVersion": {
                                                "type": "int64",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "onlyIncludeBalanceActivities": {
                                                "type": "bool",
                                                "id": 5,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetUnifiedActivitiesResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivities": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "paginationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "hasHiddenBalanceActivityTransactions": {
                                                "type": "bool",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "UnifiedActivityDetails": {
                                "fields": {
                                    "description": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "modifiers": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier",
                                        "id": 3,
                                        "rule": "repeated"
                                    },
                                    "grossAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "netAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "externalLink": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.ExternalLink",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "attachments": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Attachment",
                                        "id": 7,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Modifier": {
                                        "fields": {
                                            "modifierType": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "modifierAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "modifierAmountDescription": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ModifierType": {
                                                "values": {
                                                    "DO_NOT_USE": 0,
                                                    "COMMUNITY_REWARD": 1,
                                                    "ATM_WITHDRAWAL_FEE": 2,
                                                    "INSTANT_TRANSFER_FEE": 3,
                                                    "CASHBACK": 4,
                                                    "CARD_PAYMENT_FEE": 5,
                                                    "GENERIC_REWARD": 6
                                                }
                                            }
                                        }
                                    },
                                    "ExternalLink": {
                                        "fields": {
                                            "title": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "url": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Attachment": {
                                        "fields": {
                                            "localizedLabel": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "imageData": {
                                                "type": "bytes",
                                                "id": 2
                                            }
                                        },
                                        "nested": {
                                            "content": {
                                                "oneof": [
                                                    "imageData"
                                                ]
                                            }
                                        }
                                    }
                                }
                            },
                            "GetUnifiedActivityDetailsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "activityToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "currentTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetUnifiedActivityDetailsResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivity": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "unifiedActivityDetails": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityEventsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest.Filters",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Filters": {
                                        "fields": {
                                            "minOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "maxOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "activityToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "transactionToken": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetUnifiedActivityEventsResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivityEvents": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityEvent",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "paginationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "unitToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityEventDetailsRequest": {
                                "fields": {
                                    "eventToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetUnifiedActivityEventDetailsResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivityEvent": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityEvent",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "LineItem": {
                                "fields": {
                                    "type": {
                                        "type": ".squareup.bizbank.unified_activity.LineItem.LineItemType",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "total": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "LineItemType": {
                                        "values": {
                                            "UNKNOWN": 0,
                                            "PROCESSING_CARD_PAYMENTS": 1,
                                            "PROCESSING_CARD_REFUNDS": 2,
                                            "PROCESSING_CARD_TOTAL_COLLECTED": 3,
                                            "PROCESSING_CARD_FEES": 4,
                                            "PROCESSING_FREE_PROCESSING_CREDIT": 5,
                                            "PROCESSING_SQUARE_CAPITAL_REPAYMENT": 6,
                                            "PROCESSING_DISPUTES": 7,
                                            "PROCESSING_RESERVES_HELD": 8,
                                            "PROCESSING_RESERVES_RELEASED": 9,
                                            "PROCESSING_OTHER_ADJUSTMENTS": 10,
                                            "TRANSFERS_OUT": 11,
                                            "TRANSFERS_INSTANT_FEES": 12,
                                            "TRANSFERS_IN": 13,
                                            "TRANSFERS_BANK_ACCOUNT_DEBITS": 14,
                                            "PROCESSING_SAVINGS_TRANSFER": 15,
                                            "CARD_PAYMENT": 16,
                                            "ATM_WITHDRAWAL": 17,
                                            "PROMOTIONAL_REWARD": 18
                                        }
                                    }
                                }
                            },
                            "TopLevelLineItem": {
                                "fields": {
                                    "type": {
                                        "type": ".squareup.bizbank.unified_activity.TopLevelLineItem.TopLevelLineItemType",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "total": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "subLineItems": {
                                        "type": ".squareup.bizbank.unified_activity.LineItem",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "TopLevelLineItemType": {
                                        "values": {
                                            "UNKNOWN": 0,
                                            "PAYMENT_PROCESSING": 1,
                                            "SQUARE_CARD_SPEND": 2,
                                            "TRANSFERS": 3,
                                            "PAYROLL": 4,
                                            "LOANS": 5
                                        }
                                    }
                                }
                            },
                            "BalanceOverview": {
                                "fields": {
                                    "startingBalance": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "endingBalance": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "lineItems": {
                                        "type": ".squareup.bizbank.unified_activity.TopLevelLineItem",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetBalanceOverviewRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "startTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "endTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "maxRetroactiveBalanceVersion": {
                                        "type": "int64",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetBalanceOverviewResponse": {
                                "fields": {
                                    "balanceOverview": {
                                        "type": ".squareup.bizbank.unified_activity.BalanceOverview",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "result": {
                                        "oneof": [
                                            "balanceOverview",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "PaymentProcessingDetails": {
                                "fields": {
                                    "lineItems": {
                                        "type": ".squareup.bizbank.unified_activity.LineItem",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetPaymentProcessingDetailsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "startTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "endTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPaymentProcessingDetailsResponse": {
                                "fields": {
                                    "paymentProcessingDetails": {
                                        "type": ".squareup.bizbank.unified_activity.PaymentProcessingDetails",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "result": {
                                        "oneof": [
                                            "paymentProcessingDetails",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityTransitionDataRequest": {
                                "fields": {
                                    "pendingActivitiesPaginationToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "recentEventsPaginationTokens": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest.RecentEventsPaginationTokens",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "balanceToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "RecentEventsPaginationTokens": {
                                        "fields": {
                                            "bankcPaginationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "nonBankcPaginationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "token": {
                                        "oneof": [
                                            "unitToken",
                                            "balanceToken"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityTransitionDataResponse": {
                                "fields": {
                                    "transitionData": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData",
                                        "id": 1
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionDataError",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "AccountTokens": {
                                        "fields": {
                                            "unitToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "balanceToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "TransitionData": {
                                        "fields": {
                                            "accountsTokens": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.AccountTokens",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "latestHistoricalBalance": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "latestRetroactiveBalance": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "pendingActivitiesAndEvents": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "recentEvents": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents",
                                                "id": 5,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "RecordTokens": {
                                                "fields": {
                                                    "eventToken": {
                                                        "type": "string",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "activityToken": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "transactionToken": {
                                                        "type": "string",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    }
                                                }
                                            },
                                            "LatestRecord": {
                                                "fields": {
                                                    "latestRecordTokens": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "balanceAmount": {
                                                        "type": ".squareup.common.Money",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "balanceVersion": {
                                                        "type": "int64",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    },
                                                    "paginationToken": {
                                                        "type": "string",
                                                        "id": 4,
                                                        "rule": "optional"
                                                    },
                                                    "latestRecordTimestamp": {
                                                        "type": ".squareup.common.time.DateTime",
                                                        "id": 5,
                                                        "rule": "optional"
                                                    },
                                                    "subsequentSweepActivity": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord.SubsequentSweepActivity",
                                                        "id": 6,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "SubsequentSweepActivity": {
                                                        "fields": {
                                                            "transactionToken": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "amount": {
                                                                "type": ".squareup.common.Money",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "balanceAmount": {
                                                                "type": ".squareup.common.Money",
                                                                "id": 3,
                                                                "rule": "optional"
                                                            },
                                                            "balanceVersion": {
                                                                "type": "int64",
                                                                "id": 4,
                                                                "rule": "optional"
                                                            },
                                                            "updatedAt": {
                                                                "type": ".squareup.common.time.DateTime",
                                                                "id": 5,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "PendingActivitiesAndEvents": {
                                                "fields": {
                                                    "pendingActivitiesAndEvents": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents",
                                                        "id": 1,
                                                        "rule": "repeated"
                                                    },
                                                    "pendingActivitiesPaginationToken": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "PendingActivityAndEvents": {
                                                        "fields": {
                                                            "tokens": {
                                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "activity": {
                                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "events": {
                                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityEvent",
                                                                "id": 3,
                                                                "rule": "repeated"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "RecentEvents": {
                                                "fields": {
                                                    "recentBankcEvents": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent",
                                                        "id": 1,
                                                        "rule": "repeated"
                                                    },
                                                    "recentOtherEvents": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent",
                                                        "id": 2,
                                                        "rule": "repeated"
                                                    },
                                                    "recentEventsPaginationTokenBankc": {
                                                        "type": "string",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    },
                                                    "recentEventsPaginationTokenOther": {
                                                        "type": "string",
                                                        "id": 4,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "RecentEvent": {
                                                        "fields": {
                                                            "tokens": {
                                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "occurredAt": {
                                                                "type": ".squareup.common.time.DateTime",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "type": {
                                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent.Type",
                                                                "id": 3,
                                                                "rule": "optional"
                                                            },
                                                            "state": {
                                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                                                                "id": 4,
                                                                "rule": "optional"
                                                            }
                                                        },
                                                        "nested": {
                                                            "Type": {
                                                                "values": {
                                                                    "UNKNOWN": 0,
                                                                    "BANKC": 1,
                                                                    "OTHER": 2
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "TransitionDataError": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "NOT_BIZBANK_USER": 1
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "transitionData",
                                            "error"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.ActivityType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.ActivityState && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.MerchantImage && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.MerchantCanonicalCategory && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityEvent && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest?.nested?.ActivityStateCategory && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest?.nested?.Filters && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Modifier && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Modifier?.nested?.ModifierType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.ExternalLink && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Attachment && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsRequest?.nested?.Filters && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventDetailsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventDetailsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventDetailsResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.LineItem && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.LineItem?.nested?.LineItemType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.TopLevelLineItem && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.TopLevelLineItem?.nested?.TopLevelLineItemType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.BalanceOverview && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetBalanceOverviewRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetBalanceOverviewResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.PaymentProcessingDetails && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetPaymentProcessingDetailsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetPaymentProcessingDetailsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataRequest?.nested?.RecentEventsPaginationTokens && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.AccountTokens && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecordTokens && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.LatestRecord && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.LatestRecord?.nested?.SubsequentSweepActivity && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.PendingActivitiesAndEvents && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.PendingActivitiesAndEvents?.nested?.PendingActivityAndEvents && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecentEvents && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecentEvents?.nested?.RecentEvent && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecentEvents?.nested?.RecentEvent?.nested?.Type && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionDataError) $e57ed9311822f585$var$$root.addJSON($e57ed9311822f585$var$jsonData);
const $e57ed9311822f585$export$29bdc794142e11e = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$29bdc794142e11e, {
    activityToken: {
        required: true
    },
    latestEventAt: {
        required: true
    },
    activityType: {
        required: true
    },
    activityState: {
        required: true
    },
    description: {
        required: true
    },
    amount: {
        required: true
    },
    balanceToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$29bdc794142e11e);
/**
 * SOURCE ActivityType @ squareup/bizbank/unified_activity.proto at 22:3
 */ $e57ed9311822f585$export$29bdc794142e11e.ActivityType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivity.ActivityType').values;
/**
 * Currently maps to com.squareup.protos.banklin.data.TransactionState
 *
 * SOURCE ActivityState @ squareup/bizbank/unified_activity.proto at 73:3
 */ $e57ed9311822f585$export$29bdc794142e11e.ActivityState = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivity.ActivityState').values;
/**
 * SOURCE MerchantImage @ squareup/bizbank/unified_activity.proto at 130:3
 */ $e57ed9311822f585$export$29bdc794142e11e.MerchantImage = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$29bdc794142e11e.MerchantImage, {
    merchantImageUrl: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$29bdc794142e11e.MerchantImage);
/**
 * SOURCE MerchantCanonicalCategory @ squareup/bizbank/unified_activity.proto at 140:3
 */ $e57ed9311822f585$export$29bdc794142e11e.MerchantCanonicalCategory = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity.MerchantCanonicalCategory');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$29bdc794142e11e.MerchantCanonicalCategory, {
    name: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$29bdc794142e11e.MerchantCanonicalCategory);
const $e57ed9311822f585$export$f2c402645c2e7e61 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$f2c402645c2e7e61);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$f2c402645c2e7e61);
const $e57ed9311822f585$export$84c227598c17818e = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$84c227598c17818e, {
    activityStateCategory: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$84c227598c17818e);
/**
 * Category of UnifiedActivity.ActivityStates
 *
 * SOURCE ActivityStateCategory @ squareup/bizbank/unified_activity.proto at 221:3
 */ $e57ed9311822f585$export$84c227598c17818e.ActivityStateCategory = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.ActivityStateCategory').values;
/**
 * SOURCE Filters @ squareup/bizbank/unified_activity.proto at 227:3
 */ $e57ed9311822f585$export$84c227598c17818e.Filters = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$84c227598c17818e.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$84c227598c17818e.Filters);
const $e57ed9311822f585$export$244bc1d47f660674 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$244bc1d47f660674);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$244bc1d47f660674);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 255:3
 */ $e57ed9311822f585$export$244bc1d47f660674.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$244bc1d47f660674.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$244bc1d47f660674.Response);
const $e57ed9311822f585$export$d2f2207f59721d5f = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f, {
    description: {
        required: true
    },
    grossAmount: {
        required: true
    },
    netAmount: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f);
/**
 * SOURCE Modifier @ squareup/bizbank/unified_activity.proto at 274:3
 */ $e57ed9311822f585$export$d2f2207f59721d5f.Modifier = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f.Modifier, {
    modifierType: {
        required: true
    },
    modifierAmount: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f.Modifier);
/**
 * SOURCE ModifierType @ squareup/bizbank/unified_activity.proto at 275:5
 */ $e57ed9311822f585$export$d2f2207f59721d5f.Modifier.ModifierType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType').values;
/**
 * Associated URL for an activity
 *
 * SOURCE ExternalLink @ squareup/bizbank/unified_activity.proto at 292:3
 */ $e57ed9311822f585$export$d2f2207f59721d5f.ExternalLink = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.ExternalLink');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f.ExternalLink);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f.ExternalLink);
/**
 * SOURCE Attachment @ squareup/bizbank/unified_activity.proto at 298:3
 */ $e57ed9311822f585$export$d2f2207f59721d5f.Attachment = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.Attachment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f.Attachment);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f.Attachment);
const $e57ed9311822f585$export$24a11b384ef009b = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$24a11b384ef009b, {
    activityToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$24a11b384ef009b);
const $e57ed9311822f585$export$f5278f172d976bbe = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$f5278f172d976bbe);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$f5278f172d976bbe);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 333:3
 */ $e57ed9311822f585$export$f5278f172d976bbe.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$f5278f172d976bbe.Response, {
    unifiedActivity: {
        required: true
    },
    unifiedActivityDetails: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$f5278f172d976bbe.Response);
const $e57ed9311822f585$export$c4965485f2174055 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$c4965485f2174055);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$c4965485f2174055);
/**
 * SOURCE Filters @ squareup/bizbank/unified_activity.proto at 346:3
 */ $e57ed9311822f585$export$c4965485f2174055.Filters = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$c4965485f2174055.Filters, {
    activityToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$c4965485f2174055.Filters);
const $e57ed9311822f585$export$1b77dab9a79ca1b0 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$1b77dab9a79ca1b0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$1b77dab9a79ca1b0);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 367:3
 */ $e57ed9311822f585$export$1b77dab9a79ca1b0.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$1b77dab9a79ca1b0.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$1b77dab9a79ca1b0.Response);
const $e57ed9311822f585$export$b959b00040c6f8ed = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$b959b00040c6f8ed);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$b959b00040c6f8ed);
const $e57ed9311822f585$export$85edbf2779642eb8 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$85edbf2779642eb8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$85edbf2779642eb8);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 387:3
 */ $e57ed9311822f585$export$85edbf2779642eb8.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$85edbf2779642eb8.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$85edbf2779642eb8.Response);
const $e57ed9311822f585$export$63e502d15ed2c7b5 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.LineItem');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$63e502d15ed2c7b5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$63e502d15ed2c7b5);
/**
 * SOURCE LineItemType @ squareup/bizbank/unified_activity.proto at 399:3
 */ $e57ed9311822f585$export$63e502d15ed2c7b5.LineItemType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.LineItem.LineItemType').values;
const $e57ed9311822f585$export$d986f8c0e4fe0e52 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.TopLevelLineItem');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d986f8c0e4fe0e52);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d986f8c0e4fe0e52);
/**
 * SOURCE TopLevelLineItemType @ squareup/bizbank/unified_activity.proto at 445:3
 */ $e57ed9311822f585$export$d986f8c0e4fe0e52.TopLevelLineItemType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.TopLevelLineItem.TopLevelLineItemType').values;
const $e57ed9311822f585$export$da41595dfa198660 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.BalanceOverview');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$da41595dfa198660);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$da41595dfa198660);
const $e57ed9311822f585$export$819cb40db0e653a6 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetBalanceOverviewRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$819cb40db0e653a6);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$819cb40db0e653a6);
const $e57ed9311822f585$export$79d14a84d6dd5cfe = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetBalanceOverviewResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$79d14a84d6dd5cfe);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$79d14a84d6dd5cfe);
const $e57ed9311822f585$export$28b8d7b4c3a0c8ad = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.PaymentProcessingDetails');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$28b8d7b4c3a0c8ad);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$28b8d7b4c3a0c8ad);
const $e57ed9311822f585$export$40a561b19f4fb80b = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$40a561b19f4fb80b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$40a561b19f4fb80b);
const $e57ed9311822f585$export$b4bdcdf688c908f8 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$b4bdcdf688c908f8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$b4bdcdf688c908f8);
const $e57ed9311822f585$export$5dd38045b9f855b4 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$5dd38045b9f855b4);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$5dd38045b9f855b4);
/**
 * SOURCE RecentEventsPaginationTokens @ squareup/bizbank/unified_activity.proto at 507:3
 */ $e57ed9311822f585$export$5dd38045b9f855b4.RecentEventsPaginationTokens = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest.RecentEventsPaginationTokens');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$5dd38045b9f855b4.RecentEventsPaginationTokens);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$5dd38045b9f855b4.RecentEventsPaginationTokens);
const $e57ed9311822f585$export$73f6915383d5e6b2 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2);
/**
 * SOURCE AccountTokens @ squareup/bizbank/unified_activity.proto at 516:3
 */ $e57ed9311822f585$export$73f6915383d5e6b2.AccountTokens = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.AccountTokens');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.AccountTokens);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.AccountTokens);
/**
 * SOURCE TransitionData @ squareup/bizbank/unified_activity.proto at 521:3
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData);
/**
 * SOURCE RecordTokens @ squareup/bizbank/unified_activity.proto at 522:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecordTokens = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecordTokens);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecordTokens);
/**
 * If subsequent_sweep_activity is populated, then the fields on `LatestRecord` refer to
 * the info on the activity prior to the sweep activity. If there's no prior activity,
 * the other fields will also refer to the same sweep activity.
 *
 * SOURCE LatestRecord @ squareup/bizbank/unified_activity.proto at 533:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord);
/**
 * SOURCE SubsequentSweepActivity @ squareup/bizbank/unified_activity.proto at 534:7
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord.SubsequentSweepActivity = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord.SubsequentSweepActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord.SubsequentSweepActivity);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord.SubsequentSweepActivity);
/**
 * SOURCE PendingActivitiesAndEvents @ squareup/bizbank/unified_activity.proto at 554:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents);
/**
 * SOURCE PendingActivityAndEvents @ squareup/bizbank/unified_activity.proto at 555:7
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents);
/**
 * SOURCE RecentEvents @ squareup/bizbank/unified_activity.proto at 565:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents);
/**
 * SOURCE RecentEvent @ squareup/bizbank/unified_activity.proto at 566:7
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent);
/**
 * SOURCE Type @ squareup/bizbank/unified_activity.proto at 567:9
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent.Type = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent.Type').values;
/**
 * SOURCE TransitionDataError @ squareup/bizbank/unified_activity.proto at 590:3
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionDataError = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionDataError').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 





const $e521b340cb47b525$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e521b340cb47b525$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "transaction_dispute": {
                        "nested": {
                            "TransactionDispute": {
                                "fields": {
                                    "id": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "statusLastUpdatedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "marqetaCaseToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "transactionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "disputeForm": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "sellerDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "squareDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditIssuedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditDebitedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "finalResolution": {
                                        "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "resolutionReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                                        "id": 18,
                                        "rule": "optional"
                                    },
                                    "finalResolutionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 19,
                                        "rule": "optional"
                                    },
                                    "finalFollowUpDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 20,
                                        "rule": "optional"
                                    },
                                    "createdAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 21,
                                        "rule": "optional"
                                    },
                                    "updatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 22,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeFiledByLdap": {
                                        "type": "string",
                                        "id": 23,
                                        "rule": "optional"
                                    },
                                    "marqetaChargebackToken": {
                                        "type": "string",
                                        "id": 24,
                                        "rule": "optional"
                                    },
                                    "publicStatus": {
                                        "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                                        "id": 25,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ReasonCode": {
                                "values": {
                                    "UNKNOWN_REASON_CODE": 0,
                                    "FRAUD_OR_UNAUTHORIZED": 1,
                                    "NOT_RECEIVED": 2,
                                    "NOT_DESCRIBED": 3,
                                    "DUPLICATE_PROCESSING": 4,
                                    "TRANSACTION_AMOUNT_INCORRECT": 5,
                                    "CANCELED_OR_CREDIT_NOT_PROCESSED": 6
                                }
                            },
                            "DisputeStatus": {
                                "values": {
                                    "UNKNOWN_DISPUTE_STATUS": 0,
                                    "NEW": 1,
                                    "WAITING_ON_CARD_HOLDER": 2,
                                    "FILED": 3,
                                    "INITIATED": 4,
                                    "REPRESENTMENT": 5,
                                    "PREARBITRATION": 6,
                                    "ARBITRATION": 7,
                                    "NETWORK_REJECTED": 8,
                                    "WON": 9,
                                    "LOST": 10,
                                    "CLOSED": 11,
                                    "PENDING_AUTOMATED_REVIEW": 12,
                                    "PREARBITRATION_RESPONDED": 13
                                }
                            },
                            "PublicStatus": {
                                "values": {
                                    "UNKNOWN_PUBLIC_STATUS": 0,
                                    "PENDING_REVIEW": 1,
                                    "INFORMATION_NEEDED": 2,
                                    "IN_PROGRESS": 3,
                                    "SELLER_WON": 4,
                                    "SELLER_LOST": 5,
                                    "RESOLVED": 6
                                }
                            },
                            "FinalResolution": {
                                "values": {
                                    "UNKNOWN_FINAL_RESOLUTION": 0,
                                    "APPROVED": 1,
                                    "DENIED": 2,
                                    "CREDITED_FROM_SQUARE": 3,
                                    "VOIDED": 4,
                                    "REJECTED_BY_SQUARE": 5,
                                    "REFUNDED": 6,
                                    "REJECTED_BY_MARQETA": 7,
                                    "DENIED_WARNING": 8
                                }
                            },
                            "ResolutionReason": {
                                "values": {
                                    "UNKNOWN_RESOLUTION_REASON": 0,
                                    "ATO": 1,
                                    "BUSINESS_DECISION": 2,
                                    "CARDHOLDER_CANCELED_CLAIM": 3,
                                    "DISPUTE_LOST": 4,
                                    "DISPUTE_WON": 5,
                                    "DENIAL_GUIDELINES": 6,
                                    "LESS_THAN_25_DOLLARS": 7,
                                    "NO_REPLY": 8,
                                    "PAYMENT_WITH_CHIP_AND_PIN": 9,
                                    "REFUND": 10,
                                    "TRANSACTION_VOID": 11,
                                    "MULTIPLE_TRANSACTIONS": 12,
                                    "RESOLUTION_OVERTURNED": 13,
                                    "INACCURATE_OR_INCOMPLETE": 14,
                                    "AUTO_CHIP_OR_CONTACTLESS_WITH_CARD_IN_POSSESSION": 19,
                                    "AUTO_CARD_PIN_USED": 20,
                                    "AUTO_MOBILE_PAYMENT": 21,
                                    "AUTO_CONSENT_PROVIDED": 22
                                }
                            },
                            "DisputeForm": {
                                "fields": {
                                    "merchantName": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "transactionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": "int64",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "usedWithMerchantBefore": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "provideCardOrInformation": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "cardInPossession": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "firstDateCardMissing": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "lastTransaction": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "sharedPinWithAnyone": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "receivedExpectedProducts": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "didNotReceiveProductsDetails": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "receivedProductsOnAgreedDate": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "receivedExpectedProductsDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "productsReceivedWereAsDescribed": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "productsReceivedWereNotAsDescribedDetails": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "chargedMultipleTimes": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "chargedMultipleTimesCorrectTransaction": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "amountIsCorrect": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 18,
                                        "rule": "optional"
                                    },
                                    "correctChargeAmount": {
                                        "type": "int64",
                                        "id": 27,
                                        "rule": "optional"
                                    },
                                    "purchaseWasCanceled": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 19,
                                        "rule": "optional"
                                    },
                                    "purchasedCanceledDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 20,
                                        "rule": "optional"
                                    },
                                    "merchandiseIsReturned": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 21,
                                        "rule": "optional"
                                    },
                                    "returnedMerchandise": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise",
                                        "id": 22,
                                        "rule": "optional"
                                    },
                                    "merchantAgreedToIssueCredit": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 23,
                                        "rule": "optional"
                                    },
                                    "merchantAgreedToIssueCreditDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 24,
                                        "rule": "optional"
                                    },
                                    "anythingElse": {
                                        "type": "string",
                                        "id": 25,
                                        "rule": "optional"
                                    },
                                    "pinWasWrittenDown": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 26,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "DisputeFormAnswer": {
                                        "values": {
                                            "UNKNOWN_ANSWER": 0,
                                            "NO": 1,
                                            "YES": 2
                                        }
                                    },
                                    "LastTransaction": {
                                        "fields": {
                                            "lastTransactionDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "lastTransactionMerchant": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "SharedPinWithAnyone": {
                                        "fields": {
                                            "hasSharedPinWithAnyone": {
                                                "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "sharedPinPerson": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "ChargedMultipleTimes": {
                                        "fields": {
                                            "correctChargeDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "correctChargeAmount": {
                                                "type": "int64",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "ReturnedMerchandise": {
                                        "fields": {
                                            "returnedMerchandiseDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "returnedMerchandiseProof": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetTransactionDisputeRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeResponse": {
                                "fields": {
                                    "transactionDispute": {
                                        "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeByTransactionTokenRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeByTransactionTokenResponse": {
                                "fields": {
                                    "transactionDispute": {
                                        "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeActivityRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeActivityResponse": {
                                "fields": {
                                    "events": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "Event": {
                                "fields": {
                                    "eventAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "statusChangeEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.StatusChangeEvent",
                                        "id": 2
                                    },
                                    "futureStatusChangeEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent",
                                        "id": 3
                                    },
                                    "creditIssuedEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent",
                                        "id": 4
                                    },
                                    "creditDebitedEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent",
                                        "id": 5
                                    }
                                },
                                "nested": {
                                    "StatusChangeEvent": {
                                        "fields": {
                                            "publicStatus": {
                                                "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "FutureStatusChangeEvent": {
                                        "fields": {
                                            "publicStatus": {
                                                "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreditIssuedEvent": {
                                        "fields": {
                                            "amount": {
                                                "type": ".squareup.common.Money",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreditDebitedEvent": {
                                        "fields": {
                                            "amount": {
                                                "type": ".squareup.common.Money",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "event": {
                                        "oneof": [
                                            "statusChangeEvent",
                                            "futureStatusChangeEvent",
                                            "creditIssuedEvent",
                                            "creditDebitedEvent"
                                        ]
                                    }
                                }
                            },
                            "ListTransactionDisputesRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "beginTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "endTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "includeStatuses": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 4,
                                        "rule": "repeated"
                                    },
                                    "inProgressOnly": {
                                        "type": "bool",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "resolvedOnly": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListTransactionDisputesResponse": {
                                "fields": {
                                    "transactionDisputes": {
                                        "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "paginationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListTransactionDisputeStatusUpdatesRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListTransactionDisputeStatusUpdatesResponse": {
                                "fields": {
                                    "statusUpdates": {
                                        "type": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse.StatusUpdate",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "StatusUpdate": {
                                        "fields": {
                                            "transactionDisputesHistoryId": {
                                                "type": "int64",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "status": {
                                                "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "statusUpdatedDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "CreateTransactionDisputeRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "disputeForm": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sellerDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateTransactionDisputeResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateTransactionDisputeRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "statusUpdatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "squareDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditIssuedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditDebitedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "finalResolution": {
                                        "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "resolutionReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "finalResolutionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "finalFollowUpDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeFiledByLdap": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "marqetaChargebackToken": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "marqetaCaseToken": {
                                        "type": "string",
                                        "id": 18,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateTransactionDisputeByTransactionTokenRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "statusUpdatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "squareDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditIssuedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditDebitedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "finalResolution": {
                                        "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "resolutionReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "finalResolutionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "finalFollowUpDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeFiledByLdap": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "marqetaChargebackToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "marqetaCaseToken": {
                                        "type": "string",
                                        "id": 17,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateTransactionDisputeResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "HandleDisputeStatusUpdateEventRequest": {
                                "fields": {
                                    "updateEventJson": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "HandleDisputeStatusUpdateEventResponse": {
                                "fields": {}
                            },
                            "MarqetaDisputeReason": {
                                "values": {
                                    "UNKNOWN_MQ_DISPUTE_REASON": 0,
                                    "WARNING_BULLETIN_FILE": 1,
                                    "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM": 2,
                                    "ACCOUNT_NUMBER_NOT_ON_FILE": 3,
                                    "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER": 4,
                                    "POINT_OF_INTERACTION_ERRORS": 5,
                                    "NOT_AUTHORIZED_CARD_PRESENT": 6,
                                    "NOT_AUTHORIZED_CARD_ABSENT": 7,
                                    "FRAUD_TRANSACTION": 8,
                                    "CANCELLED_RECURRING_TRANSACTION": 9,
                                    "LATE_PRESENTMENT": 10,
                                    "INCORRECT_CURRENCY": 11,
                                    "INCORRECT_TRANSACTION_CODE": 12,
                                    "INCORRECT_CURRENCY_OR_TRANSACTION_CODE": 13,
                                    "QUESTIONABLE_MERCHANT_ACTIVITY": 14,
                                    "INSTALLMENT_BILLING_DISPUTE": 15,
                                    "CARDHOLDER_DISPUTE_US_ONLY": 16,
                                    "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED": 17,
                                    "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE": 18,
                                    "CREDIT_NOT_PROCESSED": 19,
                                    "TRANSACTION_NOT_RECOGNIZED": 20,
                                    "CHIP_LIABILITY_SHIFT": 21,
                                    "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN": 22,
                                    "CHIP_READ_POS_LATE_PRESENTMENT": 23,
                                    "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE": 24,
                                    "CARDHOLDER_DISPUTE": 25
                                }
                            },
                            "MarqetaDisputeDocumentCategory": {
                                "values": {
                                    "UNKNOWN_MQ_DISPUTE_DOCUMENT_CATEGORY": 0,
                                    "RECEIPT": 1,
                                    "CUSTOMER_SIGNATURE": 2,
                                    "CUSTOMER_DL": 3,
                                    "CUSTOMER_SSN": 4,
                                    "CUSTOMER_PASSPORT": 5,
                                    "UTILITY_BILL": 6,
                                    "CUSTOMER_COMMUNICATION": 7,
                                    "DISPUTE_FORM": 8,
                                    "BANK_STATEMENT": 9,
                                    "TAX_DOCUMENTS": 10,
                                    "INCORPORATION_CERTIFICATE": 11,
                                    "LEASE_AGREEMENT": 12,
                                    "OTHERS": 13
                                }
                            },
                            "CreateMarqetaDisputeRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.MarqetaDisputeReason",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "submittedBy": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "memo": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "document": {
                                        "type": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest.Document",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Document": {
                                        "fields": {
                                            "fileBytes": {
                                                "type": "bytes",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "contentType": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "fileName": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "category": {
                                                "type": ".squareup.bizbank.transaction_dispute.MarqetaDisputeDocumentCategory",
                                                "id": 4,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "CreateMarqetaDisputeResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LedgerDisputeLostRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LedgerDisputeLostResponse": {
                                "fields": {}
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.TransactionDispute && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ReasonCode && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeStatus && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.PublicStatus && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.FinalResolution && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ResolutionReason && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.DisputeFormAnswer && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.LastTransaction && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.SharedPinWithAnyone && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ChargedMultipleTimes && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ReturnedMerchandise && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeByTransactionTokenRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeByTransactionTokenResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.StatusChangeEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.FutureStatusChangeEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditIssuedEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditDebitedEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesResponse?.nested?.StatusUpdate && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateTransactionDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateTransactionDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeByTransactionTokenRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.HandleDisputeStatusUpdateEventRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.HandleDisputeStatusUpdateEventResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.MarqetaDisputeReason && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.MarqetaDisputeDocumentCategory && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeRequest?.nested?.Document && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.LedgerDisputeLostRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.LedgerDisputeLostResponse) $e521b340cb47b525$var$$root.addJSON($e521b340cb47b525$var$jsonData);
const $e521b340cb47b525$export$201f7a2811c12e8f = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.TransactionDispute');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$201f7a2811c12e8f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$201f7a2811c12e8f);
const $e521b340cb47b525$export$73bd2caeeaeda77b = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.ReasonCode').values;
const $e521b340cb47b525$export$ca69f21448a28201 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeStatus').values;
const $e521b340cb47b525$export$4c81e80b8c38fc62 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.PublicStatus').values;
const $e521b340cb47b525$export$6154cee52a5a8aa8 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.FinalResolution').values;
const $e521b340cb47b525$export$385de46e976190af = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.ResolutionReason').values;
const $e521b340cb47b525$export$f9dbf923c40c0402 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402);
/**
 * SOURCE DisputeFormAnswer @ squareup/bizbank/transaction_dispute.proto at 177:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.DisputeFormAnswer = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer').values;
/**
 * What was the last transaction you made with your Square Card?
 *
 * SOURCE LastTransaction @ squareup/bizbank/transaction_dispute.proto at 205:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.LastTransaction = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.LastTransaction);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.LastTransaction);
/**
 * SOURCE SharedPinWithAnyone @ squareup/bizbank/transaction_dispute.proto at 212:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.SharedPinWithAnyone = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.SharedPinWithAnyone);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.SharedPinWithAnyone);
/**
 * If you were charged multiple times for this payment, what was the date and amount of the correct transaction?
 *
 * SOURCE ChargedMultipleTimes @ squareup/bizbank/transaction_dispute.proto at 243:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.ChargedMultipleTimes = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.ChargedMultipleTimes);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.ChargedMultipleTimes);
/**
 * If you’ve returned the merchandise, please provide the return date and provide proof of return authorization (i.e tracking number, delivery confirmation, or return merchandise authorization)
 *
 * SOURCE ReturnedMerchandise @ squareup/bizbank/transaction_dispute.proto at 265:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.ReturnedMerchandise = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.ReturnedMerchandise);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.ReturnedMerchandise);
const $e521b340cb47b525$export$6ffc02cb2556bcd4 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$6ffc02cb2556bcd4, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$6ffc02cb2556bcd4);
const $e521b340cb47b525$export$875e74715c8af887 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$875e74715c8af887);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$875e74715c8af887);
const $e521b340cb47b525$export$58d6f643d9797046 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$58d6f643d9797046, {
    transactionToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$58d6f643d9797046);
const $e521b340cb47b525$export$5e20b7bac2c8538d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$5e20b7bac2c8538d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$5e20b7bac2c8538d);
const $e521b340cb47b525$export$b358a6910d4d2055 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$b358a6910d4d2055, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$b358a6910d4d2055);
const $e521b340cb47b525$export$269f6f0781e5c7a9 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$269f6f0781e5c7a9);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$269f6f0781e5c7a9);
const $e521b340cb47b525$export$d61e24a684f9e51 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51);
/**
 * SOURCE StatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 319:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.StatusChangeEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.StatusChangeEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.StatusChangeEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.StatusChangeEvent);
/**
 * SOURCE FutureStatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 323:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.FutureStatusChangeEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.FutureStatusChangeEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.FutureStatusChangeEvent);
/**
 * SOURCE CreditIssuedEvent @ squareup/bizbank/transaction_dispute.proto at 327:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.CreditIssuedEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.CreditIssuedEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.CreditIssuedEvent);
/**
 * SOURCE CreditDebitedEvent @ squareup/bizbank/transaction_dispute.proto at 331:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.CreditDebitedEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.CreditDebitedEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.CreditDebitedEvent);
const $e521b340cb47b525$export$f72a9e2991d87a1d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f72a9e2991d87a1d, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f72a9e2991d87a1d);
const $e521b340cb47b525$export$5ff93e9cf3e843d4 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$5ff93e9cf3e843d4);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$5ff93e9cf3e843d4);
const $e521b340cb47b525$export$4cfed3e3362beeda = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$4cfed3e3362beeda, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$4cfed3e3362beeda);
const $e521b340cb47b525$export$8abc09afcd3b2abc = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$8abc09afcd3b2abc);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$8abc09afcd3b2abc);
/**
 * SOURCE StatusUpdate @ squareup/bizbank/transaction_dispute.proto at 359:3
 */ $e521b340cb47b525$export$8abc09afcd3b2abc.StatusUpdate = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse.StatusUpdate');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$8abc09afcd3b2abc.StatusUpdate);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$8abc09afcd3b2abc.StatusUpdate);
const $e521b340cb47b525$export$245c333457639690 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateTransactionDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$245c333457639690, {
    unitToken: {
        notEmpty: true
    },
    disputeAmount: {
        required: true
    },
    reasonCode: {
        required: true
    },
    sellerDisputedDate: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$245c333457639690);
const $e521b340cb47b525$export$721540c0352c4f0d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateTransactionDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$721540c0352c4f0d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$721540c0352c4f0d);
const $e521b340cb47b525$export$8b1cd1b6bf235738 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$8b1cd1b6bf235738, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$8b1cd1b6bf235738);
const $e521b340cb47b525$export$ec46f8e3efdec47d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeByTransactionTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$ec46f8e3efdec47d, {
    transactionToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$ec46f8e3efdec47d);
const $e521b340cb47b525$export$679cc044a25585b0 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$679cc044a25585b0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$679cc044a25585b0);
const $e521b340cb47b525$export$fe944c5289c65dda = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$fe944c5289c65dda, {
    updateEventJson: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$fe944c5289c65dda);
const $e521b340cb47b525$export$9b65f99468247c8e = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$9b65f99468247c8e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$9b65f99468247c8e);
const $e521b340cb47b525$export$df53fbf07eee81b6 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.MarqetaDisputeReason').values;
const $e521b340cb47b525$export$1af9daa1f66a14cf = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.MarqetaDisputeDocumentCategory').values;
const $e521b340cb47b525$export$a2e166388e805d4 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$a2e166388e805d4, {
    unitToken: {
        notEmpty: true
    },
    disputeAmount: {
        required: true
    },
    transactionToken: {
        notEmpty: true
    },
    marqetaDisputeReason: {
        required: true
    },
    submittedBy: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$a2e166388e805d4);
/**
 * SOURCE Document @ squareup/bizbank/transaction_dispute.proto at 488:3
 */ $e521b340cb47b525$export$a2e166388e805d4.Document = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest.Document');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$a2e166388e805d4.Document, {
    contentType: {
        notEmpty: true
    },
    fileName: {
        notEmpty: true
    },
    category: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$a2e166388e805d4.Document);
const $e521b340cb47b525$export$f59816ef0ad5d634 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f59816ef0ad5d634, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f59816ef0ad5d634);
const $e521b340cb47b525$export$7483d2465c90ff13 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.LedgerDisputeLostRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$7483d2465c90ff13, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$7483d2465c90ff13);
const $e521b340cb47b525$export$b1ef9545d73f06f8 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.LedgerDisputeLostResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$b1ef9545d73f06f8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$b1ef9545d73f06f8);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $69670b9fb8fe807f$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $69670b9fb8fe807f$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "card_management": {
                        "nested": {
                            "CreateUserAuthorizationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "authenticationToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateUserAuthorizationResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "SUCCESS": 1,
                                            "ERROR": 2,
                                            "INVALID_TOKEN": 3,
                                            "EXPIRED_TOKEN": 4
                                        }
                                    }
                                }
                            },
                            "GetPrivateCardDataRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "loggableSessionToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "PrivateCardData": {
                                "fields": {
                                    "fullPan": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cvc": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "expiration": {
                                        "type": ".squareup.common.time.YearMonth",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPrivateCardDataResponse": {
                                "fields": {
                                    "privateCardInfo": {
                                        "type": ".squareup.bizbank.card_management.PrivateCardData",
                                        "id": 1
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.card_management.GetPrivateCardDataResponse.Error",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Error": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "ERROR": 1,
                                            "UNAUTHORIZED": 2
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "privateCardInfo",
                                            "error"
                                        ]
                                    }
                                }
                            },
                            "ExpireAllUserAuthorizationsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "bizbankCardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ExpireAllUserAuthorizationsResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "result": {
                                        "oneof": [
                                            "success",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationRequest && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationResponse && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationResponse?.nested?.Result && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataRequest && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.PrivateCardData && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataResponse && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataResponse?.nested?.Error && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.ExpireAllUserAuthorizationsRequest && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.ExpireAllUserAuthorizationsResponse) $69670b9fb8fe807f$var$$root.addJSON($69670b9fb8fe807f$var$jsonData);
const $69670b9fb8fe807f$export$c1fff74db1cb380e = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.CreateUserAuthorizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$c1fff74db1cb380e, {
    authenticationToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$c1fff74db1cb380e);
const $69670b9fb8fe807f$export$83ccf668fe6813a2 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.CreateUserAuthorizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$83ccf668fe6813a2, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$83ccf668fe6813a2);
/**
 * Invalid token will be returned if two factor authentication code is invalid or expired
 *
 * SOURCE Result @ squareup/bizbank/card_management.proto at 24:3
 */ $69670b9fb8fe807f$export$83ccf668fe6813a2.Result = $69670b9fb8fe807f$var$$root.lookupEnum('squareup.bizbank.card_management.CreateUserAuthorizationResponse.Result').values;
const $69670b9fb8fe807f$export$acc45b72a9895637 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.GetPrivateCardDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$acc45b72a9895637, {
    cardToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$acc45b72a9895637);
const $69670b9fb8fe807f$export$76ea8ebac544371a = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.PrivateCardData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$76ea8ebac544371a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$76ea8ebac544371a);
const $69670b9fb8fe807f$export$27437b8b654e9873 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.GetPrivateCardDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$27437b8b654e9873);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$27437b8b654e9873);
/**
 * SOURCE Error @ squareup/bizbank/card_management.proto at 59:3
 */ $69670b9fb8fe807f$export$27437b8b654e9873.Error = $69670b9fb8fe807f$var$$root.lookupEnum('squareup.bizbank.card_management.GetPrivateCardDataResponse.Error').values;
const $69670b9fb8fe807f$export$e591fc412cabb5a2 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.ExpireAllUserAuthorizationsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$e591fc412cabb5a2, {
    unitToken: {
        required: true
    },
    bizbankCardToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$e591fc412cabb5a2);
const $69670b9fb8fe807f$export$aba26c5151bca4a5 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.ExpireAllUserAuthorizationsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$aba26c5151bca4a5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$aba26c5151bca4a5);


const $3f73c216104868a6$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3f73c216104868a6$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "service": {
                        "nested": {
                            "AddMobileNumberForSmsNotificationsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "mobileNumber": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "locale": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "AddMobileNumberForSmsNotificationsResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "localizedErrorTitle": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "localizedErrorDescription": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CheckIdentityVerificationStatusRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "pollToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CheckIdentityVerificationStatusResponse": {
                                "fields": {
                                    "pending": {
                                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending",
                                        "id": 1
                                    },
                                    "response": {
                                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response",
                                        "id": 2
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "idvState": {
                                                "type": ".squareup.bizbank.service.IdvState",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "idvNeedsSsn": {
                                                "type": "bool",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "canRetryIdv": {
                                                "type": "bool",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "idvError": {
                                                "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "idvRetriesRemaining": {
                                                "type": "int32",
                                                "id": 5,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Pending": {
                                        "fields": {
                                            "pollToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "IdvError": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "TOO_MANY_ATTEMPTS": 3,
                                            "UNDER_AGE_OF_MAJORITY": 4,
                                            "DOES_NOT_MATCH": 5
                                        }
                                    },
                                    "Error": {
                                        "fields": {
                                            "reason": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "pending",
                                            "response",
                                            "error"
                                        ]
                                    }
                                }
                            },
                            "ConfirmIssueCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardIssueToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "customizationToken": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "shouldPauseDeposits": {
                                        "type": "bool",
                                        "id": 6,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ConfirmIssueCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "canImmediatelyAddToWallet": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "cardData": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "IssueCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardholderPersonToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "createPhysicalCard": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "createVirtualCard": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "physicalCardDetails": {
                                        "type": ".squareup.bizbank.service.IssueCardRequest.PhysicalCardDetails",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "PhysicalCardDetails": {
                                        "fields": {
                                            "firstName": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "lastName": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "shippingAddress": {
                                                "type": ".squareup.common.location.GlobalAddress",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "customizationToken": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "IssueCardResponse": {
                                "fields": {
                                    "physicalCardData": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardCustomizationRequest": {
                                "fields": {
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "imageBytes": {
                                        "type": "bytes",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "mimeType": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "existingTrunkToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardCustomizationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cutomizationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DeactivateCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "deactivationReason": {
                                        "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "DeactivationReason": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "LOST": 1,
                                            "STOLEN": 2,
                                            "CARD_NOT_RECEIVED": 3,
                                            "CANCEL": 4,
                                            "FRAUD": 5,
                                            "TRANSFER_OF_ACCOUNT": 6,
                                            "RISK_ACCOUNT_DEACTIVATION": 7,
                                            "LOST_OR_STOLEN": 8,
                                            "DAMAGED": 9
                                        }
                                    }
                                }
                            },
                            "DeactivateCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "bizbankEnabled": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateDeactivationReasonRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "reason": {
                                        "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateDeactivationReasonResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bizbank.service.UpdateDeactivationReasonResponse.UpdateDeactivationReasonError",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "UpdateDeactivationReasonError": {
                                        "values": {
                                            "UPDATE_DEACTIVATION_REASON_ERROR_DO_NOT_USE": 0,
                                            "UPDATE_DEACTIVATION_REASON_ERROR_INVALID_CARD_TOKEN": 1
                                        }
                                    }
                                }
                            },
                            "FinishCardActivationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "activationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cvv": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "expirationMmyy": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "fideliusToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "FinishCardActivationResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.FinishCardActivationResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "pinIsSet": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "SUCCESS": 1,
                                            "FAILED": 2,
                                            "ACTIVATION_TOKEN_INVALID": 3,
                                            "ACTIVATION_TOKEN_EXPIRED": 4,
                                            "INCORRECT_CVV": 5,
                                            "INCORRECT_EXPIRATION": 6,
                                            "INCORRECT_CARD_INFO": 7
                                        }
                                    }
                                }
                            },
                            "EnqueueSweepRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "EnqueueSweepResponse": {
                                "fields": {}
                            },
                            "GetBalanceRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetBalanceResponse": {
                                "fields": {
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "maxInstantDepositAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "pendingBalance": {
                                        "type": ".squareup.common.Money",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetBizbankAccountRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "includeIdvData": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    }
                                }
                            },
                            "GetBizbankAccountResponse": {
                                "fields": {
                                    "bizbankAccount": {
                                        "type": ".squareup.bizbank.service.GetBizbankAccountResponse.BizbankAccount",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "BizbankAccount": {
                                        "fields": {
                                            "unitToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "isBizbankEnabled": {
                                                "type": "bool",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "balance": {
                                                "type": ".squareup.common.Money",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxInstantDepositAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cards": {
                                                "type": ".squareup.bizbank.service.CardData",
                                                "id": 5,
                                                "rule": "repeated"
                                            },
                                            "cardActivity": {
                                                "type": ".squareup.bizbank.service.CardActivity",
                                                "id": 6,
                                                "rule": "repeated"
                                            },
                                            "pendingBalance": {
                                                "type": ".squareup.common.Money",
                                                "id": 7,
                                                "rule": "optional"
                                            },
                                            "idvState": {
                                                "type": ".squareup.bizbank.service.IdvState",
                                                "id": 8,
                                                "rule": "optional"
                                            },
                                            "idvAttemptsRemaining": {
                                                "type": "int32",
                                                "id": 9,
                                                "rule": "optional"
                                            },
                                            "canToggleEnabled": {
                                                "type": "bool",
                                                "id": 10,
                                                "rule": "optional"
                                            },
                                            "canOrderCard": {
                                                "type": "bool",
                                                "id": 11,
                                                "rule": "optional"
                                            },
                                            "eligibilityReason": {
                                                "type": ".squareup.bizbank.service.UnitIneligibilityReason",
                                                "id": 12,
                                                "rule": "optional"
                                            },
                                            "storedValueToken": {
                                                "type": "string",
                                                "id": 13,
                                                "rule": "optional"
                                            },
                                            "countryCode": {
                                                "type": ".squareup.common.countries.Country",
                                                "id": 14,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "UnitIneligibilityReason": {
                                "values": {
                                    "UNKNOWN": 0,
                                    "SUSPENDED_BY_MARQETA": 1,
                                    "DEACTIVATED_BY_MARQETA": 2,
                                    "TOO_MANY_CLAIMS": 3,
                                    "NOT_ACTIVATED": 4,
                                    "NOT_FOUND": 5,
                                    "MCC_INELIGIBLE": 6,
                                    "DEACTIVATED_BY_RISK": 7,
                                    "INVALID_BUSINESS_NAME": 8,
                                    "EXHAUSTED_IDV_RETRIES": 9,
                                    "SUSPECTED_ATO": 10,
                                    "FAKE_ACCOUNT": 11,
                                    "SELLS_CANNABIS": 13,
                                    "PRODUCT_LEVEL_HARDBLOCKED_BY_COMPLIANCE": 14,
                                    "DECLINED_BY_RISK": 15
                                }
                            },
                            "GetCardOrderingEligibilityRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "skipRiskproxyEvaluation": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                            "default": true
                                        }
                                    }
                                }
                            },
                            "GetCardOrderingEligibilityResponse": {
                                "fields": {
                                    "canOrderCard": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "idvState": {
                                        "type": ".squareup.bizbank.service.IdvState",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "idvAttemptsRemaining": {
                                        "type": "int32",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "ineligibilityReasons": {
                                        "type": ".squareup.bizbank.service.UnitIneligibilityReason",
                                        "id": 6,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetCardActivityRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.service.GetCardActivityRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Filters": {
                                        "fields": {
                                            "includeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "excludeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 2,
                                                "rule": "repeated"
                                            },
                                            "minOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "excludeActivityTypes": {
                                                "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                                                "id": 5,
                                                "rule": "repeated"
                                            },
                                            "includeActivityTypes": {
                                                "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                                                "id": 6,
                                                "rule": "repeated"
                                            },
                                            "dateSource": {
                                                "type": ".squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource",
                                                "id": 7,
                                                "rule": "optional",
                                                "options": {
                                                    "default": "OCCURRED_AT"
                                                }
                                            }
                                        },
                                        "nested": {
                                            "DateSource": {
                                                "values": {
                                                    "OCCURRED_AT": 1,
                                                    "UPDATED_AT": 2
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "GetCardActivityResponse": {
                                "fields": {
                                    "transactionEvents": {
                                        "type": ".squareup.banklin.TransactionEvent",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "cardActivity": {
                                        "type": ".squareup.bizbank.service.CardActivity",
                                        "id": 6,
                                        "rule": "repeated"
                                    },
                                    "batchResponse": {
                                        "type": ".squareup.bizbank.service.GetCardActivityResponse.BatchResponse",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "fetchedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "maxInstantDepositAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "BatchResponse": {
                                        "fields": {
                                            "nextPaginationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetCardCustomizationRequest": {
                                "fields": {
                                    "returnFullImage": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "customizationToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "token": {
                                        "oneof": [
                                            "unitToken",
                                            "customizationToken"
                                        ]
                                    }
                                }
                            },
                            "CardCustomization": {
                                "fields": {
                                    "imageBytes": {
                                        "type": "bytes",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "mimeType": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCardCustomizationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "businessName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardCustomization": {
                                        "type": ".squareup.bizbank.service.CardCustomization",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "merchantToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledResponse": {
                                "fields": {
                                    "isEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "enabledAttributes": {
                                        "type": ".squareup.bizbank.service.GetEnabledResponse.EnabledAttribute",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "EnabledAttribute": {
                                        "fields": {
                                            "unitToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "isEnabled": {
                                                "type": "bool",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetEnabledHistoryRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledHistoryResponse": {
                                "fields": {
                                    "enabledIntervals": {
                                        "type": ".squareup.common.time.DateTimeInterval",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "enabledIntervalsByBanklinToken": {
                                        "type": ".squareup.bizbank.service.GetEnabledHistoryResponse.DateTimeIntervals",
                                        "id": 2,
                                        "keyType": "string"
                                    }
                                },
                                "nested": {
                                    "DateTimeIntervals": {
                                        "fields": {
                                            "intervals": {
                                                "type": ".squareup.common.time.DateTimeInterval",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetCardBillingAddressRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCardBillingAddressResponse": {
                                "fields": {
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DigitalWalletToken": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "issuerCardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "digitalWalletIssuer": {
                                        "type": ".squareup.banklin.DigitalWalletIssuer",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "digitalWalletState": {
                                        "type": ".squareup.banklin.DigitalWalletState",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "devicePhoneNumberLastFour": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "deviceType": {
                                        "type": ".squareup.banklin.DeviceType",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "bizbankCardToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "panReferenceId": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokenRequest": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokenResponse": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": ".squareup.bizbank.service.DigitalWalletToken",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokensForUnitRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokensForUnitResponse": {
                                "fields": {
                                    "digitalWalletTokens": {
                                        "type": ".squareup.bizbank.service.DigitalWalletToken",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetRolledUpActivityRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sortOrder": {
                                        "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.SortOrder",
                                        "id": 4,
                                        "rule": "optional",
                                        "options": {
                                            "default": "DESC"
                                        }
                                    }
                                },
                                "nested": {
                                    "SortOrder": {
                                        "values": {
                                            "ASC": 1,
                                            "DESC": 2
                                        }
                                    },
                                    "RolledUpActivityType": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "CARD_PAYMENT": 1,
                                            "DEPOSIT": 2,
                                            "INSTANT_DEPOSIT": 3,
                                            "ATM_WITHDRAWAL": 4
                                        }
                                    },
                                    "Filters": {
                                        "fields": {
                                            "includeTypes": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "excludeTypes": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType",
                                                "id": 2,
                                                "rule": "repeated"
                                            },
                                            "minOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "transactionToken": {
                                                "type": "string",
                                                "id": 5,
                                                "rule": "repeated"
                                            },
                                            "includeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 6,
                                                "rule": "repeated"
                                            },
                                            "excludeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 7,
                                                "rule": "repeated"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetRolledUpActivityResponse": {
                                "fields": {
                                    "cardActivity": {
                                        "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.RolledUpCardActivity",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Fee": {
                                        "fields": {
                                            "amount": {
                                                "type": ".squareup.common.Money",
                                                "id": 100,
                                                "rule": "optional"
                                            },
                                            "feeType": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.Fee.FeeType",
                                                "id": 101,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "FeeType": {
                                                "values": {
                                                    "ATM": 1,
                                                    "INSTANT_DEPOSIT": 2
                                                }
                                            }
                                        }
                                    },
                                    "RolledUpCardActivity": {
                                        "fields": {
                                            "activity": {
                                                "type": ".squareup.bizbank.service.CardActivity",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "fee": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.Fee",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "unitToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetSpendingLimitsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetSpendingLimitsResponse": {
                                "fields": {
                                    "spendSummaries": {
                                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "SpendSummary": {
                                        "fields": {
                                            "spendType": {
                                                "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendType",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "spendLimits": {
                                                "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit",
                                                "id": 2,
                                                "rule": "repeated"
                                            },
                                            "includesPurchases": {
                                                "type": "bool",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "includesWithdrawals": {
                                                "type": "bool",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "includesTransfers": {
                                                "type": "bool",
                                                "id": 5,
                                                "rule": "optional"
                                            },
                                            "includesCashback": {
                                                "type": "bool",
                                                "id": 6,
                                                "rule": "optional"
                                            },
                                            "includesCredits": {
                                                "type": "bool",
                                                "id": 7,
                                                "rule": "optional"
                                            },
                                            "includesP2p": {
                                                "type": "bool",
                                                "id": 9,
                                                "rule": "optional"
                                            },
                                            "controlName": {
                                                "type": "string",
                                                "id": 8,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "SpendType": {
                                                "values": {
                                                    "DO_NOT_USE": 0,
                                                    "MAX_SPEND": 1,
                                                    "CASH_ACCESS": 2,
                                                    "MAX_ATM": 3,
                                                    "MCC_CASH_DISBURSE": 4,
                                                    "CASHBACK": 5,
                                                    "CASHBACK_RESTRICTION": 6,
                                                    "CASHAPP_SEND": 7,
                                                    "P2P_CASHAPP": 8
                                                }
                                            },
                                            "SpendLimit": {
                                                "fields": {
                                                    "cadence": {
                                                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "amountAvailableToSpend": {
                                                        "type": ".squareup.common.Money",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "limitAmount": {
                                                        "type": ".squareup.common.Money",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    },
                                                    "daysLeftInCycle": {
                                                        "type": "int32",
                                                        "id": 4,
                                                        "rule": "optional"
                                                    },
                                                    "cardType": {
                                                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType",
                                                        "id": 5,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "Cadence": {
                                                        "values": {
                                                            "DAILY": 1,
                                                            "WEEKLY": 2,
                                                            "MONTHLY": 3,
                                                            "SINGLE_TRANSACTION": 4
                                                        }
                                                    },
                                                    "CardType": {
                                                        "values": {
                                                            "PHYSICAL_CARD": 0,
                                                            "VIRTUAL_CARD": 1,
                                                            "PHYSICAL_AND_VIRTUAL_CARD": 2
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "GetAtmLimitsRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetAtmLimitsResponse": {
                                "fields": {
                                    "limits": {
                                        "type": ".squareup.bizbank.service.GetAtmLimitsResponse.Limit",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Limit": {
                                        "fields": {
                                            "cadence": {
                                                "type": ".squareup.bizbank.service.GetAtmLimitsResponse.Limit.Cadence",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "availableToSpendAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "limitAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Cadence": {
                                                "values": {
                                                    "DAILY": 1,
                                                    "WEEKLY": 2,
                                                    "MONTHLY": 3,
                                                    "PER_TRANSACTION": 4
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "CreateCardInvitationRequest": {
                                "fields": {
                                    "firstName": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "lastName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "email": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardInvitationResponse": {
                                "fields": {
                                    "cardInvitation": {
                                        "type": ".squareup.bizbank.invitations.CardInvitation",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SendNotificationRequest": {
                                "fields": {
                                    "idempotencyKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardInvitationEmail": {
                                        "type": ".squareup.bizbank.service.SendNotificationRequest.CardInvitationEmailPayload",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "CardInvitationEmailPayload": {
                                        "fields": {
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "notification_payload": {
                                        "oneof": [
                                            "cardInvitationEmail"
                                        ]
                                    }
                                }
                            },
                            "SendNotificationResponse": {
                                "fields": {}
                            },
                            "CardAssignment": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "personToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardInvitationToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SearchCardAssignmentsRequest": {
                                "fields": {
                                    "query": {
                                        "type": ".squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsQuery",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "CardAssignmentsFilter": {
                                        "fields": {
                                            "cardTokens": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    },
                                    "CardAssignmentsQuery": {
                                        "fields": {
                                            "filter": {
                                                "type": ".squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsFilter",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "SearchCardAssignmentsResponse": {
                                "fields": {
                                    "assignments": {
                                        "type": ".squareup.bizbank.service.CardAssignment",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "ListCardsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "includeAdditionalDetails": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.service.ListCardsRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sortOrder": {
                                        "type": ".squareup.bizbank.service.ListCardsRequest.SortOrder",
                                        "id": 4,
                                        "rule": "optional",
                                        "options": {
                                            "default": "ASC"
                                        }
                                    }
                                },
                                "nested": {
                                    "SortOrder": {
                                        "values": {
                                            "ASC": 1,
                                            "DESC": 2
                                        }
                                    },
                                    "Filters": {
                                        "fields": {
                                            "includedCardTypes": {
                                                "type": ".squareup.bizbank.service.CardData.CardType",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    }
                                }
                            },
                            "ListCardsResponse": {
                                "fields": {
                                    "cards": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "CardBrand": {
                                "values": {
                                    "VISA": 1,
                                    "MASTERCARD": 2
                                }
                            },
                            "CardData": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "banklinCardToken": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "cardState": {
                                        "type": ".squareup.bizbank.service.CardData.CardState",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardBrand": {
                                        "type": ".squareup.bizbank.service.CardBrand",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "panLastFour": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "nameOnCard": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "active2faTokenTypes": {
                                        "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                                        "id": 6,
                                        "rule": "repeated"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "createdAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "cardType": {
                                        "type": ".squareup.bizbank.service.CardData.CardType",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "deactivationReason": {
                                        "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "cardEvents": {
                                        "type": ".squareup.banklin.CardEvent",
                                        "id": 12,
                                        "rule": "repeated"
                                    },
                                    "isActivatable": {
                                        "type": "bool",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "customizationToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "CardState": {
                                        "values": {
                                            "ACTIVE": 1,
                                            "DISABLED": 2,
                                            "TERMINATED": 3,
                                            "SUSPENDED": 4,
                                            "VERIFIED": 5,
                                            "ISSUED": 6,
                                            "UNDELIVERABLE": 7,
                                            "SHIPPED": 8,
                                            "CANCELLED": 9,
                                            "REJECTED": 10,
                                            "DESTROYED": 11,
                                            "ACTIVE_PENDING_2FA": 12,
                                            "REVIEW_PENDING": 13,
                                            "CUSTOMIZATION_APPROVED": 14,
                                            "CUSTOMIZATION_DENIED": 15
                                        }
                                    },
                                    "CardType": {
                                        "values": {
                                            "PHYSICAL": 1,
                                            "VIRTUAL": 2
                                        }
                                    }
                                }
                            },
                            "CardActivity": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "description": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "activityType": {
                                        "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "transactionState": {
                                        "type": ".squareup.banklin.TransactionState",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "occurredAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "activityDisplayString": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "paginationToken": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "declineReason": {
                                        "type": ".squareup.banklin.octopus.OctopusResult",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "updatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "moneyTransferServerToken": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "cardInfo": {
                                        "type": ".squareup.bizbank.service.CardActivity.DepositCardInfo",
                                        "id": 9
                                    },
                                    "bankInfo": {
                                        "type": ".squareup.bizbank.service.CardActivity.DepositBankInfo",
                                        "id": 10
                                    }
                                },
                                "nested": {
                                    "ActivityType": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "CARD_PAYMENT": 1,
                                            "DEPOSIT": 2,
                                            "INSTANT_DEPOSIT": 3,
                                            "INSTANT_DEPOSIT_FEE": 4,
                                            "ATM_WITHDRAWAL": 5,
                                            "ATM_WITHDRAWAL_FEE": 6,
                                            "CARD_PAYMENT_REWARD": 7
                                        }
                                    },
                                    "DepositCardInfo": {
                                        "fields": {
                                            "cardBrand": {
                                                "type": ".squareup.common.instrument.InstrumentType",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "panSuffix": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "cardToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "DepositBankInfo": {
                                        "fields": {
                                            "bankName": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "bankAccountSuffix": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "bankAccountToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "deposit_info": {
                                        "oneof": [
                                            "cardInfo",
                                            "bankInfo"
                                        ]
                                    }
                                }
                            },
                            "ProvideFeedbackRequest": {
                                "fields": {
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "feedbackText": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "feedbackSource": {
                                        "type": ".squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "FeedbackSource": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "CARD_DEACTIVATION": 1,
                                            "BALANCE_DEACTIVATION": 2,
                                            "ACCOUNT_DEACTIVATION_REGULATOR": 3,
                                            "TRANSFER_OF_ACCOUNT": 4,
                                            "ADMIN_CONSOLE": 5,
                                            "ACCOUNT_DEACTIVATION_BANK_PARTNER": 6,
                                            "ACCOUNT_DEACTIVATION_RISK_TEAM": 7
                                        }
                                    }
                                }
                            },
                            "ProvisionDigitalWalletTokenRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "provisioningAppVersion": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "deviceType": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.DeviceType",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "applePayRequest": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.ApplePayRequest",
                                        "id": 5
                                    },
                                    "googlePayRequest": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.GooglePayRequest",
                                        "id": 6
                                    }
                                },
                                "nested": {
                                    "DeviceType": {
                                        "values": {
                                            "UNKNOWN": 1,
                                            "MOBILE_PHONE": 2,
                                            "WATCH": 3
                                        }
                                    },
                                    "ApplePayRequest": {
                                        "fields": {
                                            "certificates": {
                                                "type": "bytes",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "nonce": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "nonceSignature": {
                                                "type": "bytes",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GooglePayRequest": {
                                        "fields": {
                                            "walletAccountId": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "deviceId": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Request": {
                                        "oneof": [
                                            "applePayRequest",
                                            "googlePayRequest"
                                        ]
                                    }
                                }
                            },
                            "ProvisionDigitalWalletTokenResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "applePayResponse": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.ApplePayResponse",
                                        "id": 2
                                    },
                                    "googlePayResponse": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.GooglePayResponse",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "ApplePayResponse": {
                                        "fields": {
                                            "encryptedPassData": {
                                                "type": "bytes",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "activationData": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "ephemeralPublicKey": {
                                                "type": "bytes",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GooglePayResponse": {
                                        "fields": {
                                            "opaquePaymentCard": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Response": {
                                        "oneof": [
                                            "applePayResponse",
                                            "googlePayResponse"
                                        ]
                                    }
                                }
                            },
                            "ProvideFeedbackResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetCardBillingAddressRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetCardBillingAddressResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "failureReason": {
                                        "type": ".squareup.bizbank.service.SetCardBillingAddressResponse.FailureReason",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "FailureReason": {
                                        "values": {
                                            "NO_FAILURE": 0,
                                            "NO_BIZBANK_USER_FOUND": 1,
                                            "ADDRESS_IS_PO_BOX": 2,
                                            "ADDRESS_IS_INVALID": 3,
                                            "MARQETA_VERIFICATION_ERROR": 4
                                        }
                                    }
                                }
                            },
                            "SetEnabledRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "enabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetEnabledResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetPasscodeRequest": {
                                "fields": {
                                    "passcode": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "authenticationToken": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetPasscodeResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.SetPasscodeResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "SUCCESS": 1,
                                            "FAILED": 2,
                                            "INVALID_CARD_TOKEN": 3,
                                            "FAILED_WEAK_PASSCODE": 4,
                                            "AUTHENTICATION_TOKEN_INVALID": 5,
                                            "AUTHENTICATION_TOKEN_EXPIRED": 6
                                        }
                                    }
                                }
                            },
                            "StartCardActivationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartCardActivationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIdentityVerificationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "ownerAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "ownerBirthDate": {
                                        "type": ".squareup.common.time.YearMonthDay",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "ownerSocialSecurityNumber": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIdentityVerificationResponse": {
                                "fields": {
                                    "pollToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIssueCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIssueCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardIssueToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "normalizedAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "addressNormalizationResult": {
                                        "type": ".squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "correctedField": {
                                        "type": ".squareup.solidshop.VerifyShippingAddressResponse.CorrectedField",
                                        "id": 6,
                                        "rule": "repeated"
                                    },
                                    "challengeRequested": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    }
                                },
                                "nested": {
                                    "AddressNormalizationResult": {
                                        "values": {
                                            "SUCCESS": 1,
                                            "VERIFICATION_NOT_AVAILABLE": 2,
                                            "VERIFICATION_FAILED": 3,
                                            "UNKNOWN_ERROR": 4
                                        }
                                    }
                                }
                            },
                            "TwoFactorAuthenticationRequestType": {
                                "values": {
                                    "DO_NOT_USE": 0,
                                    "CARD_ACTIVATION": 1,
                                    "RESET_PASSCODE": 2,
                                    "SHOW_PRIVATE_CARD_DATA": 3,
                                    "SHOW_DIRECT_DEPOSIT_ACCOUNT": 4
                                }
                            },
                            "StartTwoFactorAuthenticationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "requestType": {
                                        "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartTwoFactorAuthenticationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ToggleCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "enableCard": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ToggleCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "card": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VerifyCardActivationTokenRequest": {
                                "fields": {
                                    "activationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VerifyCardActivationTokenResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.VerifyCardActivationTokenResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "VERIFIED": 1,
                                            "INVALID_TOKEN": 2,
                                            "EXPIRED_TOKEN": 3,
                                            "USED": 4,
                                            "FAILED": 5
                                        }
                                    }
                                }
                            },
                            "VerifyTwoFactorAuthenticationTokenRequest": {
                                "fields": {
                                    "authenticationToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "requestType": {
                                        "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VerifyTwoFactorAuthenticationTokenResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "VERIFIED": 1,
                                            "INVALID_TOKEN": 2,
                                            "EXPIRED_TOKEN": 3
                                        }
                                    }
                                }
                            },
                            "VoidAuthorizationRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VoidAuthorizationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "IdvState": {
                                "values": {
                                    "IDV_DO_NOT_USE": 0,
                                    "APPROVED": 1,
                                    "INCOMPLETE": 2
                                }
                            },
                            "GetFundsHoldingAccountRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "balanceToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "customer_token": {
                                        "oneof": [
                                            "unitToken",
                                            "balanceToken"
                                        ]
                                    }
                                }
                            },
                            "GetFundsHoldingAccountResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "countryCode": {
                                        "type": ".squareup.common.countries.Country",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetIsUserAuthorizedRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "loggableSessionToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetIsUserAuthorizedResponse": {
                                "fields": {
                                    "isAuthorized": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPromotionalRewardDescriptionRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPromotionalRewardDescriptionResponse": {
                                "fields": {
                                    "description": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.service.GetPromotionalRewardDescriptionResponse.Error",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Error": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "TRANSACTION_NOT_FOUND": 1,
                                            "INVALID_TRANSACTION_TOKEN": 2
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "description",
                                            "error"
                                        ]
                                    }
                                }
                            },
                            "LookupUnitRequest": {
                                "fields": {
                                    "panFideliusToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LookupUnitResponse": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListDisputedTransactionTokensRequest": {
                                "fields": {
                                    "transactionTokens": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "ListDisputedTransactionTokensResponse": {
                                "fields": {
                                    "disputedTransactionTokens": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "ValidateAddressRequest": {
                                "fields": {
                                    "address": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ValidateAddressResponse": {
                                "fields": {
                                    "normalizedAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "addressNormalizationResult": {
                                        "type": ".squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "correctedFields": {
                                        "type": ".squareup.bizbank.service.ValidateAddressResponse.CorrectedField",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "CorrectedField": {
                                        "values": {
                                            "DO_NOT_USE_FIELD": 0,
                                            "ADDRESS_LINE_1": 1,
                                            "ADDRESS_LINE_2": 2,
                                            "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                                            "LOCALITY": 4,
                                            "POSTAL_CODE": 5
                                        }
                                    },
                                    "AddressNormalizationResult": {
                                        "values": {
                                            "DO_NOT_USE_RESULT": 0,
                                            "SUCCESS": 1,
                                            "VERIFICATION_NOT_AVAILABLE": 2,
                                            "VERIFICATION_FAILED": 3,
                                            "UNKNOWN_ERROR": 4
                                        }
                                    }
                                }
                            },
                            "UpdateCustomerDataRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "banklinToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "customer_token": {
                                        "oneof": [
                                            "unitToken",
                                            "banklinToken"
                                        ]
                                    }
                                }
                            },
                            "UpdateCustomerDataResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCustomizationSettingsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "userAgent": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCustomizationSettingsResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "ownerName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "businessName": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "minInkCoverage": {
                                        "type": "float",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "maxInkCoverage": {
                                        "type": "float",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "idvState": {
                                        "type": ".squareup.bizbank.service.IdvState",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "canRetryIdv": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "ownerAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "ownerBirthDate": {
                                        "type": ".squareup.common.time.YearMonthDay",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "idvNeedsSsn": {
                                        "type": "bool",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "idvRetriesRemaining": {
                                        "type": "int32",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "ineligibilityReason": {
                                        "type": ".squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "existingCustomization": {
                                        "type": ".squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization",
                                        "id": 13,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "IneligibilityReason": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "NOT_ELIGIBLE": 1,
                                            "EXHAUSTED_IDV_RETRIES": 2,
                                            "NOT_ACTIVATED": 3
                                        }
                                    },
                                    "ExistingCustomization": {
                                        "fields": {
                                            "trunkToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "imageBytes": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "mimeType": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetAllStampsRequest": {
                                "fields": {}
                            },
                            "GetAllStampsResponse": {
                                "fields": {
                                    "stamps": {
                                        "type": ".squareup.bizbank.service.Stamp",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "Stamp": {
                                "fields": {
                                    "name": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "accessibilityText": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "svg": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "minScale": {
                                        "type": "int32",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetFontsRequest": {
                                "fields": {}
                            },
                            "GetFontsResponse": {
                                "fields": {
                                    "fonts": {
                                        "type": ".squareup.bizbank.service.GetFontsResponse.Font",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Font": {
                                        "fields": {
                                            "fontFamily": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "fontUrl": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "DeactivateAccountRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "deactivationReason": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "source": {
                                        "type": ".squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DeactivateAccountResponse": {
                                "fields": {}
                            },
                            "MerchantBlockState": {
                                "values": {
                                    "UNKNOWN_MERCHANT_BLOCK_STATE": 0,
                                    "BLOCKED": 1,
                                    "UNBLOCKED": 2
                                }
                            },
                            "UpdateMerchantBlockRequest": {
                                "fields": {
                                    "merchanteinMerchantToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "merchantBlockState": {
                                        "type": ".squareup.bizbank.service.MerchantBlockState",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateMerchantBlockResponse": {
                                "fields": {
                                    "merchantBlockState": {
                                        "type": ".squareup.bizbank.service.MerchantBlockState",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetMerchantBlockRequest": {
                                "fields": {
                                    "merchanteinMerchantToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetMerchantBlockResponse": {
                                "fields": {
                                    "merchantBlockState": {
                                        "type": ".squareup.bizbank.service.MerchantBlockState",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListMerchantBlocksRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListMerchantBlocksResponse": {
                                "fields": {
                                    "blockedMerchanteinMerchants": {
                                        "type": ".squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "MerchanteinMerchant": {
                                        "fields": {
                                            "token": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "merchantImage": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "BizbankService": {
                                "methods": {
                                    "AddMobileNumberForSmsNotifications": {
                                        "requestType": ".squareup.bizbank.service.AddMobileNumberForSmsNotificationsRequest",
                                        "responseType": ".squareup.bizbank.service.AddMobileNumberForSmsNotificationsResponse"
                                    },
                                    "ConfirmIssueCard": {
                                        "requestType": ".squareup.bizbank.service.ConfirmIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.ConfirmIssueCardResponse"
                                    },
                                    "CheckIdentityVerificationStatus": {
                                        "requestType": ".squareup.bizbank.service.CheckIdentityVerificationStatusRequest",
                                        "responseType": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse"
                                    },
                                    "LedgerDisputeLost": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.LedgerDisputeLostRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.LedgerDisputeLostResponse"
                                    },
                                    "CreateCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.CreateCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.CreateCardCustomizationResponse"
                                    },
                                    "CreateMarqetaDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeResponse"
                                    },
                                    "CreateTransactionDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.CreateTransactionDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.CreateTransactionDisputeResponse"
                                    },
                                    "CreateUserAuthorization": {
                                        "requestType": ".squareup.bizbank.card_management.CreateUserAuthorizationRequest",
                                        "responseType": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse"
                                    },
                                    "DeactivateAccount": {
                                        "requestType": ".squareup.bizbank.service.DeactivateAccountRequest",
                                        "responseType": ".squareup.bizbank.service.DeactivateAccountResponse"
                                    },
                                    "DeactivateCard": {
                                        "requestType": ".squareup.bizbank.service.DeactivateCardRequest",
                                        "responseType": ".squareup.bizbank.service.DeactivateCardResponse"
                                    },
                                    "ExpireAllUserAuthorizations": {
                                        "requestType": ".squareup.bizbank.card_management.ExpireAllUserAuthorizationsRequest",
                                        "responseType": ".squareup.bizbank.card_management.ExpireAllUserAuthorizationsResponse"
                                    },
                                    "FinishCardActivation": {
                                        "requestType": ".squareup.bizbank.service.FinishCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.FinishCardActivationResponse"
                                    },
                                    "EnqueueSweep": {
                                        "requestType": ".squareup.bizbank.service.EnqueueSweepRequest",
                                        "responseType": ".squareup.bizbank.service.EnqueueSweepResponse"
                                    },
                                    "GetAtmLimits": {
                                        "requestType": ".squareup.bizbank.service.GetAtmLimitsRequest",
                                        "responseType": ".squareup.bizbank.service.GetAtmLimitsResponse"
                                    },
                                    "GetBalance": {
                                        "requestType": ".squareup.bizbank.service.GetBalanceRequest",
                                        "responseType": ".squareup.bizbank.service.GetBalanceResponse"
                                    },
                                    "GetBalanceOverview": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetBalanceOverviewRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetBalanceOverviewResponse"
                                    },
                                    "GetPaymentProcessingDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse"
                                    },
                                    "GetBizbankAccount": {
                                        "requestType": ".squareup.bizbank.service.GetBizbankAccountRequest",
                                        "responseType": ".squareup.bizbank.service.GetBizbankAccountResponse"
                                    },
                                    "GetCardActivity": {
                                        "requestType": ".squareup.bizbank.service.GetCardActivityRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardActivityResponse"
                                    },
                                    "GetCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.GetCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardCustomizationResponse"
                                    },
                                    "GetCardOrderingEligibility": {
                                        "requestType": ".squareup.bizbank.service.GetCardOrderingEligibilityRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardOrderingEligibilityResponse"
                                    },
                                    "GetDigitalWalletToken": {
                                        "requestType": ".squareup.bizbank.service.GetDigitalWalletTokenRequest",
                                        "responseType": ".squareup.bizbank.service.GetDigitalWalletTokenResponse"
                                    },
                                    "GetDigitalWalletTokensForUnit": {
                                        "requestType": ".squareup.bizbank.service.GetDigitalWalletTokensForUnitRequest",
                                        "responseType": ".squareup.bizbank.service.GetDigitalWalletTokensForUnitResponse"
                                    },
                                    "GetFundsHoldingAccount": {
                                        "requestType": ".squareup.bizbank.service.GetFundsHoldingAccountRequest",
                                        "responseType": ".squareup.bizbank.service.GetFundsHoldingAccountResponse"
                                    },
                                    "GetPrivateCardData": {
                                        "requestType": ".squareup.bizbank.card_management.GetPrivateCardDataRequest",
                                        "responseType": ".squareup.bizbank.card_management.GetPrivateCardDataResponse"
                                    },
                                    "GetEnabled": {
                                        "requestType": ".squareup.bizbank.service.GetEnabledRequest",
                                        "responseType": ".squareup.bizbank.service.GetEnabledResponse"
                                    },
                                    "GetEnabledHistory": {
                                        "requestType": ".squareup.bizbank.service.GetEnabledHistoryRequest",
                                        "responseType": ".squareup.bizbank.service.GetEnabledHistoryResponse"
                                    },
                                    "GetFonts": {
                                        "requestType": ".squareup.bizbank.service.GetFontsRequest",
                                        "responseType": ".squareup.bizbank.service.GetFontsResponse"
                                    },
                                    "GetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.GetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardBillingAddressResponse"
                                    },
                                    "GetRolledUpActivity": {
                                        "requestType": ".squareup.bizbank.service.GetRolledUpActivityRequest",
                                        "responseType": ".squareup.bizbank.service.GetRolledUpActivityResponse"
                                    },
                                    "GetSpendingLimits": {
                                        "requestType": ".squareup.bizbank.service.GetSpendingLimitsRequest",
                                        "responseType": ".squareup.bizbank.service.GetSpendingLimitsResponse"
                                    },
                                    "GetUnifiedActivities": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse"
                                    },
                                    "GetUnifiedActivityDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse"
                                    },
                                    "GetUnifiedActivityEvents": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse"
                                    },
                                    "GetUnifiedActivityEventDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse"
                                    },
                                    "GetUnifiedActivityTransitionData": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse"
                                    },
                                    "GetIsUserAuthorized": {
                                        "requestType": ".squareup.bizbank.service.GetIsUserAuthorizedRequest",
                                        "responseType": ".squareup.bizbank.service.GetIsUserAuthorizedResponse"
                                    },
                                    "HandleDisputeStatusUpdateEvent": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventResponse"
                                    },
                                    "ListCards": {
                                        "requestType": ".squareup.bizbank.service.ListCardsRequest",
                                        "responseType": ".squareup.bizbank.service.ListCardsResponse"
                                    },
                                    "GetTransactionDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeResponse"
                                    },
                                    "GetTransactionDisputeByTransactionToken": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenResponse"
                                    },
                                    "GetTransactionDisputeActivity": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse"
                                    },
                                    "IssueCard": {
                                        "requestType": ".squareup.bizbank.service.IssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.IssueCardResponse"
                                    },
                                    "CreateCardInvitation": {
                                        "requestType": ".squareup.bizbank.service.CreateCardInvitationRequest",
                                        "responseType": ".squareup.bizbank.service.CreateCardInvitationResponse"
                                    },
                                    "SendNotification": {
                                        "requestType": ".squareup.bizbank.service.SendNotificationRequest",
                                        "responseType": ".squareup.bizbank.service.SendNotificationResponse"
                                    },
                                    "SearchCardAssignments": {
                                        "requestType": ".squareup.bizbank.service.SearchCardAssignmentsRequest",
                                        "responseType": ".squareup.bizbank.service.SearchCardAssignmentsResponse"
                                    },
                                    "ListTransactionDisputes": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse"
                                    },
                                    "ListDisputedTransactionTokens": {
                                        "requestType": ".squareup.bizbank.service.ListDisputedTransactionTokensRequest",
                                        "responseType": ".squareup.bizbank.service.ListDisputedTransactionTokensResponse"
                                    },
                                    "ListTransactionDisputeStatusUpdates": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse"
                                    },
                                    "LookupUnit": {
                                        "requestType": ".squareup.bizbank.service.LookupUnitRequest",
                                        "responseType": ".squareup.bizbank.service.LookupUnitResponse"
                                    },
                                    "ProvideFeedback": {
                                        "requestType": ".squareup.bizbank.service.ProvideFeedbackRequest",
                                        "responseType": ".squareup.bizbank.service.ProvideFeedbackResponse"
                                    },
                                    "ProvisionDigitalWalletToken": {
                                        "requestType": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest",
                                        "responseType": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse"
                                    },
                                    "SetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.SetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.SetCardBillingAddressResponse"
                                    },
                                    "SetEnabled": {
                                        "requestType": ".squareup.bizbank.service.SetEnabledRequest",
                                        "responseType": ".squareup.bizbank.service.SetEnabledResponse"
                                    },
                                    "SetPasscode": {
                                        "requestType": ".squareup.bizbank.service.SetPasscodeRequest",
                                        "responseType": ".squareup.bizbank.service.SetPasscodeResponse"
                                    },
                                    "StartCardActivation": {
                                        "requestType": ".squareup.bizbank.service.StartCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.StartCardActivationResponse"
                                    },
                                    "StartIdentityVerification": {
                                        "requestType": ".squareup.bizbank.service.StartIdentityVerificationRequest",
                                        "responseType": ".squareup.bizbank.service.StartIdentityVerificationResponse"
                                    },
                                    "StartIssueCard": {
                                        "requestType": ".squareup.bizbank.service.StartIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.StartIssueCardResponse"
                                    },
                                    "StartTwoFactorAuthentication": {
                                        "requestType": ".squareup.bizbank.service.StartTwoFactorAuthenticationRequest",
                                        "responseType": ".squareup.bizbank.service.StartTwoFactorAuthenticationResponse"
                                    },
                                    "ToggleCard": {
                                        "requestType": ".squareup.bizbank.service.ToggleCardRequest",
                                        "responseType": ".squareup.bizbank.service.ToggleCardResponse"
                                    },
                                    "UpdateCustomerData": {
                                        "requestType": ".squareup.bizbank.service.UpdateCustomerDataRequest",
                                        "responseType": ".squareup.bizbank.service.UpdateCustomerDataResponse"
                                    },
                                    "UpdateTransactionDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse"
                                    },
                                    "UpdateTransactionDisputeByTransactionToken": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeByTransactionTokenRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse"
                                    },
                                    "UpdateDeactivationReason": {
                                        "requestType": ".squareup.bizbank.service.UpdateDeactivationReasonRequest",
                                        "responseType": ".squareup.bizbank.service.UpdateDeactivationReasonResponse"
                                    },
                                    "ValidateAddress": {
                                        "requestType": ".squareup.bizbank.service.ValidateAddressRequest",
                                        "responseType": ".squareup.bizbank.service.ValidateAddressResponse"
                                    },
                                    "VerifyCardActivationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyCardActivationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyCardActivationTokenResponse"
                                    },
                                    "VerifyTwoFactorAuthenticationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse"
                                    },
                                    "VoidAuthorization": {
                                        "requestType": ".squareup.bizbank.service.VoidAuthorizationRequest",
                                        "responseType": ".squareup.bizbank.service.VoidAuthorizationResponse"
                                    },
                                    "GetPromotionalRewardDescription": {
                                        "requestType": ".squareup.bizbank.service.GetPromotionalRewardDescriptionRequest",
                                        "responseType": ".squareup.bizbank.service.GetPromotionalRewardDescriptionResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.AddMobileNumberForSmsNotificationsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.AddMobileNumberForSmsNotificationsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Response && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Pending && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.IdvError && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Error && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardRequest?.nested?.PhysicalCardDetails && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest?.nested?.DeactivationReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonResponse?.nested?.UpdateDeactivationReasonError && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.EnqueueSweepRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.EnqueueSweepResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountResponse?.nested?.BizbankAccount && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UnitIneligibilityReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardOrderingEligibilityRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardOrderingEligibilityResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters?.nested?.DateSource && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse?.nested?.BatchResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardCustomization && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledResponse?.nested?.EnabledAttribute && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryResponse?.nested?.DateTimeIntervals && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DigitalWalletToken && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokensForUnitRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokensForUnitResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.SortOrder && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.RolledUpActivityType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.Filters && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.Fee && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.Fee?.nested?.FeeType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.RolledUpCardActivity && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit?.nested?.Cadence && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit?.nested?.CardType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse?.nested?.Limit && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse?.nested?.Limit?.nested?.Cadence && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardInvitationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardInvitationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationRequest?.nested?.CardInvitationEmailPayload && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardAssignment && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest?.nested?.CardAssignmentsFilter && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest?.nested?.CardAssignmentsQuery && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.SortOrder && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.Filters && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardBrand && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardState && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.ActivityType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositCardInfo && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositBankInfo && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest?.nested?.FeedbackSource && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.DeviceType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.ApplePayRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.GooglePayRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse?.nested?.ApplePayResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse?.nested?.GooglePayResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse?.nested?.FailureReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse?.nested?.AddressNormalizationResult && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.TwoFactorAuthenticationRequestType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VoidAuthorizationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VoidAuthorizationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IdvState && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFundsHoldingAccountRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFundsHoldingAccountResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetIsUserAuthorizedRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetIsUserAuthorizedResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionResponse?.nested?.Error && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.LookupUnitRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.LookupUnitResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListDisputedTransactionTokensRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListDisputedTransactionTokensResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.CorrectedField && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.AddressNormalizationResult && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateCustomerDataRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateCustomerDataResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.IneligibilityReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.ExistingCustomization && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.Stamp && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsResponse?.nested?.Font && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateAccountRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateAccountResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.MerchantBlockState && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse?.nested?.MerchanteinMerchant && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.BizbankService) $3f73c216104868a6$var$$root.addJSON($3f73c216104868a6$var$jsonData);
const $3f73c216104868a6$export$253585ba1cdf0b3a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.AddMobileNumberForSmsNotificationsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$253585ba1cdf0b3a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$253585ba1cdf0b3a);
const $3f73c216104868a6$export$c158937f79cc6528 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.AddMobileNumberForSmsNotificationsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c158937f79cc6528);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c158937f79cc6528);
const $3f73c216104868a6$export$bde473bfd1f5e612 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$bde473bfd1f5e612, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$bde473bfd1f5e612);
const $3f73c216104868a6$export$23505a1850980175 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175);
/**
 * SOURCE Response @ squareup/bizbank/service.proto at 71:3
 */ $3f73c216104868a6$export$23505a1850980175.Response = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175.Response);
/**
 * SOURCE Pending @ squareup/bizbank/service.proto at 82:3
 */ $3f73c216104868a6$export$23505a1850980175.Pending = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175.Pending);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175.Pending);
/**
 * SOURCE IdvError @ squareup/bizbank/service.proto at 86:3
 */ $3f73c216104868a6$export$23505a1850980175.IdvError = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError').values;
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 94:3
 */ $3f73c216104868a6$export$23505a1850980175.Error = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175.Error);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175.Error);
const $3f73c216104868a6$export$323ab8e57069a144 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ConfirmIssueCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$323ab8e57069a144, {
    unitToken: {
        notEmpty: true
    },
    cardIssueToken: {
        notEmpty: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$323ab8e57069a144);
const $3f73c216104868a6$export$881590e4b6fda91d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ConfirmIssueCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$881590e4b6fda91d, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$881590e4b6fda91d);
const $3f73c216104868a6$export$9f6faf5543ebcce8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.IssueCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9f6faf5543ebcce8, {
    unitToken: {
        notEmpty: true
    },
    createPhysicalCard: {
        required: true
    },
    createVirtualCard: {
        required: true
    },
    idempotenceKey: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9f6faf5543ebcce8);
/**
 * SOURCE PhysicalCardDetails @ squareup/bizbank/service.proto at 129:3
 */ $3f73c216104868a6$export$9f6faf5543ebcce8.PhysicalCardDetails = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.IssueCardRequest.PhysicalCardDetails');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9f6faf5543ebcce8.PhysicalCardDetails, {
    firstName: {
        notEmpty: true
    },
    lastName: {
        notEmpty: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9f6faf5543ebcce8.PhysicalCardDetails);
const $3f73c216104868a6$export$94d83c06da546ba7 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.IssueCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$94d83c06da546ba7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$94d83c06da546ba7);
const $3f73c216104868a6$export$aed3bec368de6e1f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardCustomizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$aed3bec368de6e1f, {
    idempotenceKey: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$aed3bec368de6e1f);
const $3f73c216104868a6$export$ed2908e9380ce647 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardCustomizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ed2908e9380ce647, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ed2908e9380ce647);
const $3f73c216104868a6$export$384405cd0a72593f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$384405cd0a72593f, {
    unitToken: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$384405cd0a72593f);
/**
 * SOURCE DeactivationReason @ squareup/bizbank/service.proto at 171:3
 */ $3f73c216104868a6$export$384405cd0a72593f.DeactivationReason = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.DeactivateCardRequest.DeactivationReason').values;
const $3f73c216104868a6$export$9fa1b18da678fcb4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9fa1b18da678fcb4, {
    success: {
        required: true
    },
    bizbankEnabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9fa1b18da678fcb4);
const $3f73c216104868a6$export$738d8d6ff2491de0 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateDeactivationReasonRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$738d8d6ff2491de0, {
    cardToken: {
        notEmpty: true
    },
    reason: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$738d8d6ff2491de0);
const $3f73c216104868a6$export$8027559510942413 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateDeactivationReasonResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8027559510942413);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8027559510942413);
/**
 * SOURCE UpdateDeactivationReasonError @ squareup/bizbank/service.proto at 204:3
 */ $3f73c216104868a6$export$8027559510942413.UpdateDeactivationReasonError = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.UpdateDeactivationReasonResponse.UpdateDeactivationReasonError').values;
const $3f73c216104868a6$export$fd7459a734464a1d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.FinishCardActivationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$fd7459a734464a1d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$fd7459a734464a1d);
const $3f73c216104868a6$export$39d716a763ccfd83 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.FinishCardActivationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$39d716a763ccfd83, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$39d716a763ccfd83);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 227:3
 */ $3f73c216104868a6$export$39d716a763ccfd83.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.FinishCardActivationResponse.Result').values;
const $3f73c216104868a6$export$351538caa34ab18f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.EnqueueSweepRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$351538caa34ab18f, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$351538caa34ab18f);
const $3f73c216104868a6$export$c293b32f4f7c2c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.EnqueueSweepResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c293b32f4f7c2c);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c293b32f4f7c2c);
const $3f73c216104868a6$export$818864c64bfcb2bc = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBalanceRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$818864c64bfcb2bc, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$818864c64bfcb2bc);
const $3f73c216104868a6$export$b98a487d2e723b1a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBalanceResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b98a487d2e723b1a, {
    balance: {
        required: true
    },
    maxInstantDepositAmount: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b98a487d2e723b1a);
const $3f73c216104868a6$export$d338e911948e15fd = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBizbankAccountRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d338e911948e15fd, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d338e911948e15fd);
const $3f73c216104868a6$export$7134c1000889519b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBizbankAccountResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7134c1000889519b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7134c1000889519b);
/**
 * SOURCE BizbankAccount @ squareup/bizbank/service.proto at 260:3
 */ $3f73c216104868a6$export$7134c1000889519b.BizbankAccount = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBizbankAccountResponse.BizbankAccount');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7134c1000889519b.BizbankAccount);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7134c1000889519b.BizbankAccount);
const $3f73c216104868a6$export$9754410f606dac06 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.UnitIneligibilityReason').values;
const $3f73c216104868a6$export$77b589e9c6b7128d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardOrderingEligibilityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$77b589e9c6b7128d, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$77b589e9c6b7128d);
const $3f73c216104868a6$export$58dd883c48dff825 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardOrderingEligibilityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$58dd883c48dff825);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$58dd883c48dff825);
const $3f73c216104868a6$export$74efe1ca0c13869 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$74efe1ca0c13869, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$74efe1ca0c13869);
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 325:3
 */ $3f73c216104868a6$export$74efe1ca0c13869.Filters = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$74efe1ca0c13869.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$74efe1ca0c13869.Filters);
/**
 * SOURCE DateSource @ squareup/bizbank/service.proto at 326:5
 */ $3f73c216104868a6$export$74efe1ca0c13869.Filters.DateSource = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource').values;
const $3f73c216104868a6$export$c40f4b8f45081c9a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c40f4b8f45081c9a, {
    batchResponse: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c40f4b8f45081c9a);
/**
 * SOURCE BatchResponse @ squareup/bizbank/service.proto at 357:3
 */ $3f73c216104868a6$export$c40f4b8f45081c9a.BatchResponse = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityResponse.BatchResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c40f4b8f45081c9a.BatchResponse);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c40f4b8f45081c9a.BatchResponse);
const $3f73c216104868a6$export$1a963d2655841b69 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardCustomizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$1a963d2655841b69);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$1a963d2655841b69);
const $3f73c216104868a6$export$4eecc657670f7f54 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardCustomization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$4eecc657670f7f54);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$4eecc657670f7f54);
const $3f73c216104868a6$export$18f331a0de47a7a4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardCustomizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$18f331a0de47a7a4, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$18f331a0de47a7a4);
const $3f73c216104868a6$export$31465efa99f2f023 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$31465efa99f2f023);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$31465efa99f2f023);
const $3f73c216104868a6$export$d0fbfd319946e0e2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0fbfd319946e0e2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0fbfd319946e0e2);
/**
 * SOURCE EnabledAttribute @ squareup/bizbank/service.proto at 421:3
 */ $3f73c216104868a6$export$d0fbfd319946e0e2.EnabledAttribute = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledResponse.EnabledAttribute');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0fbfd319946e0e2.EnabledAttribute, {
    unitToken: {
        notEmpty: true
    },
    isEnabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0fbfd319946e0e2.EnabledAttribute);
const $3f73c216104868a6$export$e23273883df96fe1 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledHistoryRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e23273883df96fe1, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e23273883df96fe1);
const $3f73c216104868a6$export$e26f0f5b45a54589 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledHistoryResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e26f0f5b45a54589);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e26f0f5b45a54589);
/**
 * SOURCE DateTimeIntervals @ squareup/bizbank/service.proto at 437:3
 */ $3f73c216104868a6$export$e26f0f5b45a54589.DateTimeIntervals = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledHistoryResponse.DateTimeIntervals');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e26f0f5b45a54589.DateTimeIntervals);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e26f0f5b45a54589.DateTimeIntervals);
const $3f73c216104868a6$export$f87764fc5894590 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardBillingAddressRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f87764fc5894590, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f87764fc5894590);
const $3f73c216104868a6$export$f27b951ce73f58f3 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardBillingAddressResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f27b951ce73f58f3);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f27b951ce73f58f3);
const $3f73c216104868a6$export$f0a8476e47a67d1f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DigitalWalletToken');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f0a8476e47a67d1f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f0a8476e47a67d1f);
const $3f73c216104868a6$export$4514144d4614cd7e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$4514144d4614cd7e, {
    digitalWalletToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$4514144d4614cd7e);
const $3f73c216104868a6$export$64fb0537c121896a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$64fb0537c121896a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$64fb0537c121896a);
const $3f73c216104868a6$export$82d1991fb076a01e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokensForUnitRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$82d1991fb076a01e, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$82d1991fb076a01e);
const $3f73c216104868a6$export$573329aa8c61c8c5 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokensForUnitResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$573329aa8c61c8c5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$573329aa8c61c8c5);
const $3f73c216104868a6$export$8507afe130f824e2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8507afe130f824e2, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8507afe130f824e2);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 490:3
 */ $3f73c216104868a6$export$8507afe130f824e2.SortOrder = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityRequest.SortOrder').values;
/**
 * SOURCE RolledUpActivityType @ squareup/bizbank/service.proto at 494:3
 */ $3f73c216104868a6$export$8507afe130f824e2.RolledUpActivityType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 501:3
 */ $3f73c216104868a6$export$8507afe130f824e2.Filters = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8507afe130f824e2.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8507afe130f824e2.Filters);
const $3f73c216104868a6$export$5218d6d1b5b50253 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5218d6d1b5b50253);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5218d6d1b5b50253);
/**
 * SOURCE Fee @ squareup/bizbank/service.proto at 531:3
 */ $3f73c216104868a6$export$5218d6d1b5b50253.Fee = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse.Fee');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5218d6d1b5b50253.Fee);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5218d6d1b5b50253.Fee);
/**
 * SOURCE FeeType @ squareup/bizbank/service.proto at 532:5
 */ $3f73c216104868a6$export$5218d6d1b5b50253.Fee.FeeType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityResponse.Fee.FeeType').values;
/**
 * SOURCE RolledUpCardActivity @ squareup/bizbank/service.proto at 540:3
 */ $3f73c216104868a6$export$5218d6d1b5b50253.RolledUpCardActivity = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse.RolledUpCardActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5218d6d1b5b50253.RolledUpCardActivity);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5218d6d1b5b50253.RolledUpCardActivity);
const $3f73c216104868a6$export$8f898512f958f471 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8f898512f958f471, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8f898512f958f471);
const $3f73c216104868a6$export$204078808a8732ba = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$204078808a8732ba);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$204078808a8732ba);
/**
 * SOURCE SpendSummary @ squareup/bizbank/service.proto at 556:3
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$204078808a8732ba.SpendSummary);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$204078808a8732ba.SpendSummary);
/**
 * SOURCE SpendType @ squareup/bizbank/service.proto at 557:5
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendType').values;
/**
 * SOURCE SpendLimit @ squareup/bizbank/service.proto at 569:5
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit);
/**
 * SOURCE Cadence @ squareup/bizbank/service.proto at 570:7
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit.Cadence = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 577:7
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit.CardType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType').values;
const $3f73c216104868a6$export$b2bcae3e90f0c84 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAtmLimitsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b2bcae3e90f0c84, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b2bcae3e90f0c84);
const $3f73c216104868a6$export$75d013afa1aa418d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAtmLimitsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$75d013afa1aa418d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$75d013afa1aa418d);
/**
 * SOURCE Limit @ squareup/bizbank/service.proto at 613:3
 */ $3f73c216104868a6$export$75d013afa1aa418d.Limit = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAtmLimitsResponse.Limit');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$75d013afa1aa418d.Limit);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$75d013afa1aa418d.Limit);
/**
 * SOURCE Cadence @ squareup/bizbank/service.proto at 614:5
 */ $3f73c216104868a6$export$75d013afa1aa418d.Limit.Cadence = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetAtmLimitsResponse.Limit.Cadence').values;
const $3f73c216104868a6$export$ec11df8f80d70e0e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ec11df8f80d70e0e, {
    firstName: {
        notEmpty: true
    },
    lastName: {
        notEmpty: true
    },
    email: {
        notEmpty: true
    },
    balanceId: {
        notEmpty: true
    },
    idempotenceKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ec11df8f80d70e0e);
const $3f73c216104868a6$export$e83735994418891e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e83735994418891e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e83735994418891e);
const $3f73c216104868a6$export$a2aa99ded42c8f67 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SendNotificationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a2aa99ded42c8f67, {
    idempotencyKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a2aa99ded42c8f67);
/**
 * SOURCE CardInvitationEmailPayload @ squareup/bizbank/service.proto at 670:3
 */ $3f73c216104868a6$export$a2aa99ded42c8f67.CardInvitationEmailPayload = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SendNotificationRequest.CardInvitationEmailPayload');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a2aa99ded42c8f67.CardInvitationEmailPayload, {
    cardInvitationToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a2aa99ded42c8f67.CardInvitationEmailPayload);
const $3f73c216104868a6$export$8cd5b864f9576eb = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SendNotificationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8cd5b864f9576eb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8cd5b864f9576eb);
const $3f73c216104868a6$export$87f8ad33a2eb9c44 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardAssignment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$87f8ad33a2eb9c44);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$87f8ad33a2eb9c44);
const $3f73c216104868a6$export$ca7406e507311134 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ca7406e507311134);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ca7406e507311134);
/**
 * SOURCE CardAssignmentsFilter @ squareup/bizbank/service.proto at 697:3
 */ $3f73c216104868a6$export$ca7406e507311134.CardAssignmentsFilter = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsFilter');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsFilter);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsFilter);
/**
 * SOURCE CardAssignmentsQuery @ squareup/bizbank/service.proto at 700:3
 */ $3f73c216104868a6$export$ca7406e507311134.CardAssignmentsQuery = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsQuery');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsQuery);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsQuery);
const $3f73c216104868a6$export$9e9599d7ce2899b2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9e9599d7ce2899b2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9e9599d7ce2899b2);
const $3f73c216104868a6$export$1f9ff0d796a08011 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListCardsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$1f9ff0d796a08011, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$1f9ff0d796a08011);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 711:3
 */ $3f73c216104868a6$export$1f9ff0d796a08011.SortOrder = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ListCardsRequest.SortOrder').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 718:3
 */ $3f73c216104868a6$export$1f9ff0d796a08011.Filters = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListCardsRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$1f9ff0d796a08011.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$1f9ff0d796a08011.Filters);
const $3f73c216104868a6$export$8a92910321c6ac49 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListCardsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8a92910321c6ac49);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8a92910321c6ac49);
const $3f73c216104868a6$export$1e5507a06cab5709 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardBrand').values;
const $3f73c216104868a6$export$578a96ad364ed08b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$578a96ad364ed08b, {
    cardState: {
        required: true
    },
    cardBrand: {
        required: true
    },
    cardType: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$578a96ad364ed08b);
/**
 * SOURCE CardState @ squareup/bizbank/service.proto at 772:3
 */ $3f73c216104868a6$export$578a96ad364ed08b.CardState = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardData.CardState').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 792:3
 */ $3f73c216104868a6$export$578a96ad364ed08b.CardType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardData.CardType').values;
const $3f73c216104868a6$export$d0506934027d387d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0506934027d387d, {
    transactionToken: {
        required: true
    },
    amount: {
        required: true
    },
    description: {
        required: true
    },
    activityType: {
        required: true
    },
    transactionState: {
        required: true
    },
    occurredAt: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0506934027d387d);
/**
 * SOURCE ActivityType @ squareup/bizbank/service.proto at 819:3
 */ $3f73c216104868a6$export$d0506934027d387d.ActivityType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardActivity.ActivityType').values;
/**
 * SOURCE DepositCardInfo @ squareup/bizbank/service.proto at 840:3
 */ $3f73c216104868a6$export$d0506934027d387d.DepositCardInfo = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardActivity.DepositCardInfo');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0506934027d387d.DepositCardInfo);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0506934027d387d.DepositCardInfo);
/**
 * SOURCE DepositBankInfo @ squareup/bizbank/service.proto at 847:3
 */ $3f73c216104868a6$export$d0506934027d387d.DepositBankInfo = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardActivity.DepositBankInfo');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0506934027d387d.DepositBankInfo);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0506934027d387d.DepositBankInfo);
const $3f73c216104868a6$export$c3ed00e569d17746 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvideFeedbackRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c3ed00e569d17746, {
    idempotenceKey: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    },
    feedbackText: {
        notEmpty: true
    },
    feedbackSource: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c3ed00e569d17746);
/**
 * SOURCE FeedbackSource @ squareup/bizbank/service.proto at 877:3
 */ $3f73c216104868a6$export$c3ed00e569d17746.FeedbackSource = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource').values;
const $3f73c216104868a6$export$7eeb177f30c2be7a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7eeb177f30c2be7a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7eeb177f30c2be7a);
/**
 * Maps to squareup.banklin.service.DeviceType
 *
 * SOURCE DeviceType @ squareup/bizbank/service.proto at 918:3
 */ $3f73c216104868a6$export$7eeb177f30c2be7a.DeviceType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.DeviceType').values;
/**
 * SOURCE ApplePayRequest @ squareup/bizbank/service.proto at 924:3
 */ $3f73c216104868a6$export$7eeb177f30c2be7a.ApplePayRequest = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.ApplePayRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7eeb177f30c2be7a.ApplePayRequest);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7eeb177f30c2be7a.ApplePayRequest);
/**
 * SOURCE GooglePayRequest @ squareup/bizbank/service.proto at 939:3
 */ $3f73c216104868a6$export$7eeb177f30c2be7a.GooglePayRequest = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.GooglePayRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7eeb177f30c2be7a.GooglePayRequest);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7eeb177f30c2be7a.GooglePayRequest);
const $3f73c216104868a6$export$c94200d6ab793599 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c94200d6ab793599);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c94200d6ab793599);
/**
 * SOURCE ApplePayResponse @ squareup/bizbank/service.proto at 959:3
 */ $3f73c216104868a6$export$c94200d6ab793599.ApplePayResponse = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.ApplePayResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c94200d6ab793599.ApplePayResponse);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c94200d6ab793599.ApplePayResponse);
/**
 * SOURCE GooglePayResponse @ squareup/bizbank/service.proto at 974:3
 */ $3f73c216104868a6$export$c94200d6ab793599.GooglePayResponse = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.GooglePayResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c94200d6ab793599.GooglePayResponse);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c94200d6ab793599.GooglePayResponse);
const $3f73c216104868a6$export$9c8808f25c0c2a7a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvideFeedbackResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9c8808f25c0c2a7a, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9c8808f25c0c2a7a);
const $3f73c216104868a6$export$5cad5c80d2995506 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetCardBillingAddressRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5cad5c80d2995506, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5cad5c80d2995506);
const $3f73c216104868a6$export$ab3effbfa8b072ee = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetCardBillingAddressResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ab3effbfa8b072ee);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ab3effbfa8b072ee);
/**
 * SOURCE FailureReason @ squareup/bizbank/service.proto at 996:3
 */ $3f73c216104868a6$export$ab3effbfa8b072ee.FailureReason = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.SetCardBillingAddressResponse.FailureReason').values;
const $3f73c216104868a6$export$190c7bbba8b2dd5b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetEnabledRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$190c7bbba8b2dd5b, {
    unitToken: {
        notEmpty: true
    },
    enabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$190c7bbba8b2dd5b);
const $3f73c216104868a6$export$383b035df2f74cbc = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetEnabledResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$383b035df2f74cbc, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$383b035df2f74cbc);
const $3f73c216104868a6$export$11663ee714acba9c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetPasscodeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$11663ee714acba9c, {
    passcode: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$11663ee714acba9c);
const $3f73c216104868a6$export$640c45aee55c5a05 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetPasscodeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$640c45aee55c5a05, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$640c45aee55c5a05);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1026:3
 */ $3f73c216104868a6$export$640c45aee55c5a05.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.SetPasscodeResponse.Result').values;
const $3f73c216104868a6$export$b04f9b9772683560 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartCardActivationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b04f9b9772683560, {
    unitToken: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b04f9b9772683560);
const $3f73c216104868a6$export$6b5a516299533ce2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartCardActivationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$6b5a516299533ce2, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$6b5a516299533ce2);
const $3f73c216104868a6$export$3876c45275011242 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIdentityVerificationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$3876c45275011242, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$3876c45275011242);
const $3f73c216104868a6$export$e5ba8a9283a704a1 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIdentityVerificationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e5ba8a9283a704a1);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e5ba8a9283a704a1);
const $3f73c216104868a6$export$c1df98fe62718065 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIssueCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c1df98fe62718065, {
    unitToken: {
        notEmpty: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c1df98fe62718065);
const $3f73c216104868a6$export$5f2c1b223d9ce345 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIssueCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5f2c1b223d9ce345, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5f2c1b223d9ce345);
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1076:3
 */ $3f73c216104868a6$export$5f2c1b223d9ce345.AddressNormalizationResult = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult').values;
const $3f73c216104868a6$export$9366cce3f193cb83 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.TwoFactorAuthenticationRequestType').values;
const $3f73c216104868a6$export$f1ed199d6959b70c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f1ed199d6959b70c, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f1ed199d6959b70c);
const $3f73c216104868a6$export$a00902a84afe5fed = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a00902a84afe5fed, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a00902a84afe5fed);
const $3f73c216104868a6$export$874456b1e6c7ddf = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ToggleCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$874456b1e6c7ddf, {
    unitToken: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$874456b1e6c7ddf);
const $3f73c216104868a6$export$ea5572bcc3fede05 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ToggleCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ea5572bcc3fede05);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ea5572bcc3fede05);
const $3f73c216104868a6$export$6aabdc425eb3c113 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$6aabdc425eb3c113, {
    activationToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$6aabdc425eb3c113);
const $3f73c216104868a6$export$adfc1e489f8313d5 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$adfc1e489f8313d5, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$adfc1e489f8313d5);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1131:3
 */ $3f73c216104868a6$export$adfc1e489f8313d5.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.VerifyCardActivationTokenResponse.Result').values;
const $3f73c216104868a6$export$cba70e0b29b94c67 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$cba70e0b29b94c67, {
    authenticationToken: {
        notEmpty: true
    },
    requestType: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$cba70e0b29b94c67);
const $3f73c216104868a6$export$87c54b251e79ee15 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$87c54b251e79ee15, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$87c54b251e79ee15);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1152:3
 */ $3f73c216104868a6$export$87c54b251e79ee15.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result').values;
const $3f73c216104868a6$export$256769e9e0c8eaed = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VoidAuthorizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$256769e9e0c8eaed, {
    transactionToken: {
        required: true,
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$256769e9e0c8eaed);
const $3f73c216104868a6$export$82eabcdd4ffe7dca = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VoidAuthorizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$82eabcdd4ffe7dca);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$82eabcdd4ffe7dca);
const $3f73c216104868a6$export$e5cc96c060ae9851 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.IdvState').values;
const $3f73c216104868a6$export$a9e165e810257348 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFundsHoldingAccountRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a9e165e810257348);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a9e165e810257348);
const $3f73c216104868a6$export$f9cdbd229c36b373 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFundsHoldingAccountResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f9cdbd229c36b373, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f9cdbd229c36b373);
const $3f73c216104868a6$export$273c5bcd8be2b812 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetIsUserAuthorizedRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$273c5bcd8be2b812, {
    unitToken: {
        notEmpty: true
    },
    loggableSessionToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$273c5bcd8be2b812);
const $3f73c216104868a6$export$f91f986de3bf155b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetIsUserAuthorizedResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f91f986de3bf155b, {
    isAuthorized: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f91f986de3bf155b);
const $3f73c216104868a6$export$107f9a454ad5572c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetPromotionalRewardDescriptionRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$107f9a454ad5572c, {
    transactionToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$107f9a454ad5572c);
const $3f73c216104868a6$export$9d5f43d3a6defc29 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetPromotionalRewardDescriptionResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9d5f43d3a6defc29);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9d5f43d3a6defc29);
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 1243:3
 */ $3f73c216104868a6$export$9d5f43d3a6defc29.Error = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetPromotionalRewardDescriptionResponse.Error').values;
const $3f73c216104868a6$export$fb7e21f12e0f3909 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.LookupUnitRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$fb7e21f12e0f3909);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$fb7e21f12e0f3909);
const $3f73c216104868a6$export$14f6123428c42788 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.LookupUnitResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$14f6123428c42788, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$14f6123428c42788);
const $3f73c216104868a6$export$bb07015d694d04a8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListDisputedTransactionTokensRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$bb07015d694d04a8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$bb07015d694d04a8);
const $3f73c216104868a6$export$ab0fbb702c2ed0ea = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListDisputedTransactionTokensResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ab0fbb702c2ed0ea);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ab0fbb702c2ed0ea);
const $3f73c216104868a6$export$b53f3420139a64e8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ValidateAddressRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b53f3420139a64e8, {
    address: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b53f3420139a64e8);
const $3f73c216104868a6$export$fe9fdc7d6de9364e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ValidateAddressResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$fe9fdc7d6de9364e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$fe9fdc7d6de9364e);
/**
 * SOURCE CorrectedField @ squareup/bizbank/service.proto at 1293:3
 */ $3f73c216104868a6$export$fe9fdc7d6de9364e.CorrectedField = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.CorrectedField').values;
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1302:3
 */ $3f73c216104868a6$export$fe9fdc7d6de9364e.AddressNormalizationResult = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult').values;
const $3f73c216104868a6$export$106fc4beac01f7c8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateCustomerDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$106fc4beac01f7c8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$106fc4beac01f7c8);
const $3f73c216104868a6$export$58cc93ed2bdcabda = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateCustomerDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$58cc93ed2bdcabda, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$58cc93ed2bdcabda);
const $3f73c216104868a6$export$54bba2a1b23a3693 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCustomizationSettingsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$54bba2a1b23a3693, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$54bba2a1b23a3693);
const $3f73c216104868a6$export$99b3bcac9f2c8f3 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$99b3bcac9f2c8f3, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$99b3bcac9f2c8f3);
/**
 * SOURCE IneligibilityReason @ squareup/bizbank/service.proto at 2074:3
 */ $3f73c216104868a6$export$99b3bcac9f2c8f3.IneligibilityReason = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason').values;
/**
 * SOURCE ExistingCustomization @ squareup/bizbank/service.proto at 2083:3
 */ $3f73c216104868a6$export$99b3bcac9f2c8f3.ExistingCustomization = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$99b3bcac9f2c8f3.ExistingCustomization);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$99b3bcac9f2c8f3.ExistingCustomization);
const $3f73c216104868a6$export$c715bd10825208e5 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAllStampsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c715bd10825208e5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c715bd10825208e5);
const $3f73c216104868a6$export$8df4dee2d5069ed = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAllStampsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8df4dee2d5069ed);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8df4dee2d5069ed);
const $3f73c216104868a6$export$8897676213252052 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.Stamp');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8897676213252052);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8897676213252052);
const $3f73c216104868a6$export$4b3247d5b313d0db = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFontsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$4b3247d5b313d0db);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$4b3247d5b313d0db);
const $3f73c216104868a6$export$30a59e598847ea22 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFontsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$30a59e598847ea22);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$30a59e598847ea22);
/**
 * SOURCE Font @ squareup/bizbank/service.proto at 2114:3
 */ $3f73c216104868a6$export$30a59e598847ea22.Font = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFontsResponse.Font');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$30a59e598847ea22.Font, {
    fontFamily: {
        notEmpty: true
    },
    fontUrl: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$30a59e598847ea22.Font);
const $3f73c216104868a6$export$e8bb92aaff106560 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateAccountRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e8bb92aaff106560, {
    unitToken: {
        required: true
    },
    deactivationReason: {
        required: true
    },
    source: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e8bb92aaff106560);
const $3f73c216104868a6$export$a9f0b0a3b546c5c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateAccountResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a9f0b0a3b546c5c);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a9f0b0a3b546c5c);
const $3f73c216104868a6$export$6e24e2f587b728e1 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.MerchantBlockState').values;
const $3f73c216104868a6$export$ae98eb5b52fe16cb = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateMerchantBlockRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ae98eb5b52fe16cb, {
    merchanteinMerchantToken: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    },
    merchantBlockState: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ae98eb5b52fe16cb);
const $3f73c216104868a6$export$408740df96fac795 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateMerchantBlockResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$408740df96fac795, {
    merchantBlockState: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$408740df96fac795);
const $3f73c216104868a6$export$ace449f314897593 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetMerchantBlockRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ace449f314897593, {
    merchanteinMerchantToken: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ace449f314897593);
const $3f73c216104868a6$export$64f6977fb3775bfe = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetMerchantBlockResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$64f6977fb3775bfe, {
    merchantBlockState: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$64f6977fb3775bfe);
const $3f73c216104868a6$export$528ae0b88a2792f4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListMerchantBlocksRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$528ae0b88a2792f4, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$528ae0b88a2792f4);
const $3f73c216104868a6$export$737f5af1ddd15df4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$737f5af1ddd15df4);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$737f5af1ddd15df4);
/**
 * SOURCE MerchanteinMerchant @ squareup/bizbank/service.proto at 2325:3
 */ $3f73c216104868a6$export$737f5af1ddd15df4.MerchanteinMerchant = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$737f5af1ddd15df4.MerchanteinMerchant, {
    token: {
        notEmpty: true
    },
    name: {
        notEmpty: true
    },
    merchantImage: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$737f5af1ddd15df4.MerchanteinMerchant);
const $3f73c216104868a6$export$f0012387d4e9c920 = $3f73c216104868a6$var$$root.lookupService('squareup.bizbank.service.BizbankService');





const $3abdcd0949da282d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3abdcd0949da282d$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "externalservice": {
                        "nested": {
                            "GetEnabledRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledResponse": {
                                "fields": {
                                    "isEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ExternalBizbankService": {
                                "methods": {
                                    "CheckIdentityVerificationStatus": {
                                        "requestType": ".squareup.bizbank.service.CheckIdentityVerificationStatusRequest",
                                        "responseType": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse"
                                    },
                                    "ConfirmIssueCard": {
                                        "requestType": ".squareup.bizbank.service.ConfirmIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.ConfirmIssueCardResponse"
                                    },
                                    "CreateCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.CreateCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.CreateCardCustomizationResponse"
                                    },
                                    "CreateUserAuthorization": {
                                        "requestType": ".squareup.bizbank.card_management.CreateUserAuthorizationRequest",
                                        "responseType": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse"
                                    },
                                    "DeactivateCard": {
                                        "requestType": ".squareup.bizbank.service.DeactivateCardRequest",
                                        "responseType": ".squareup.bizbank.service.DeactivateCardResponse"
                                    },
                                    "FinishCardActivation": {
                                        "requestType": ".squareup.bizbank.service.FinishCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.FinishCardActivationResponse"
                                    },
                                    "GetBalance": {
                                        "requestType": ".squareup.bizbank.service.GetBalanceRequest",
                                        "responseType": ".squareup.bizbank.service.GetBalanceResponse"
                                    },
                                    "GetBalanceOverview": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetBalanceOverviewRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetBalanceOverviewResponse"
                                    },
                                    "GetPaymentProcessingDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse"
                                    },
                                    "GetUnifiedActivities": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse"
                                    },
                                    "GetUnifiedActivityDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse"
                                    },
                                    "GetCardActivity": {
                                        "requestType": ".squareup.bizbank.service.GetCardActivityRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardActivityResponse"
                                    },
                                    "GetCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.GetCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardCustomizationResponse"
                                    },
                                    "GetCustomizationSettings": {
                                        "requestType": ".squareup.bizbank.service.GetCustomizationSettingsRequest",
                                        "responseType": ".squareup.bizbank.service.GetCustomizationSettingsResponse"
                                    },
                                    "GetAllStamps": {
                                        "requestType": ".squareup.bizbank.service.GetAllStampsRequest",
                                        "responseType": ".squareup.bizbank.service.GetAllStampsResponse"
                                    },
                                    "GetEnabled": {
                                        "requestType": ".squareup.bizbank.externalservice.GetEnabledRequest",
                                        "responseType": ".squareup.bizbank.externalservice.GetEnabledResponse"
                                    },
                                    "GetPrivateCardData": {
                                        "requestType": ".squareup.bizbank.card_management.GetPrivateCardDataRequest",
                                        "responseType": ".squareup.bizbank.card_management.GetPrivateCardDataResponse"
                                    },
                                    "GetTransactionDisputeActivity": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse"
                                    },
                                    "ListCards": {
                                        "requestType": ".squareup.bizbank.service.ListCardsRequest",
                                        "responseType": ".squareup.bizbank.service.ListCardsResponse"
                                    },
                                    "ListTransactionDisputes": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse"
                                    },
                                    "ProvideFeedback": {
                                        "requestType": ".squareup.bizbank.service.ProvideFeedbackRequest",
                                        "responseType": ".squareup.bizbank.service.ProvideFeedbackResponse"
                                    },
                                    "SetEnabled": {
                                        "requestType": ".squareup.bizbank.service.SetEnabledRequest",
                                        "responseType": ".squareup.bizbank.service.SetEnabledResponse"
                                    },
                                    "SetPasscode": {
                                        "requestType": ".squareup.bizbank.service.SetPasscodeRequest",
                                        "responseType": ".squareup.bizbank.service.SetPasscodeResponse"
                                    },
                                    "StartCardActivation": {
                                        "requestType": ".squareup.bizbank.service.StartCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.StartCardActivationResponse"
                                    },
                                    "StartIdentityVerification": {
                                        "requestType": ".squareup.bizbank.service.StartIdentityVerificationRequest",
                                        "responseType": ".squareup.bizbank.service.StartIdentityVerificationResponse"
                                    },
                                    "StartIssueCard": {
                                        "requestType": ".squareup.bizbank.service.StartIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.StartIssueCardResponse"
                                    },
                                    "StartTwoFactorAuthentication": {
                                        "requestType": ".squareup.bizbank.service.StartTwoFactorAuthenticationRequest",
                                        "responseType": ".squareup.bizbank.service.StartTwoFactorAuthenticationResponse"
                                    },
                                    "ToggleCard": {
                                        "requestType": ".squareup.bizbank.service.ToggleCardRequest",
                                        "responseType": ".squareup.bizbank.service.ToggleCardResponse"
                                    },
                                    "ValidateAddress": {
                                        "requestType": ".squareup.bizbank.service.ValidateAddressRequest",
                                        "responseType": ".squareup.bizbank.service.ValidateAddressResponse"
                                    },
                                    "VerifyCardActivationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyCardActivationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyCardActivationTokenResponse"
                                    },
                                    "VerifyTwoFactorAuthenticationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse"
                                    },
                                    "GetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.GetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardBillingAddressResponse"
                                    },
                                    "SetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.SetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.SetCardBillingAddressResponse"
                                    },
                                    "UpdateMerchantBlock": {
                                        "requestType": ".squareup.bizbank.service.UpdateMerchantBlockRequest",
                                        "responseType": ".squareup.bizbank.service.UpdateMerchantBlockResponse"
                                    },
                                    "GetMerchantBlock": {
                                        "requestType": ".squareup.bizbank.service.GetMerchantBlockRequest",
                                        "responseType": ".squareup.bizbank.service.GetMerchantBlockResponse"
                                    },
                                    "ListMerchantBlocks": {
                                        "requestType": ".squareup.bizbank.service.ListMerchantBlocksRequest",
                                        "responseType": ".squareup.bizbank.service.ListMerchantBlocksResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3abdcd0949da282d$var$$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.GetEnabledRequest && !$3abdcd0949da282d$var$$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.GetEnabledResponse && !$3abdcd0949da282d$var$$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.ExternalBizbankService) $3abdcd0949da282d$var$$root.addJSON($3abdcd0949da282d$var$jsonData);
const $3abdcd0949da282d$export$31465efa99f2f023 = $3abdcd0949da282d$var$$root.lookupType('squareup.bizbank.externalservice.GetEnabledRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3abdcd0949da282d$export$31465efa99f2f023, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3abdcd0949da282d$export$31465efa99f2f023);
const $3abdcd0949da282d$export$d0fbfd319946e0e2 = $3abdcd0949da282d$var$$root.lookupType('squareup.bizbank.externalservice.GetEnabledResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3abdcd0949da282d$export$d0fbfd319946e0e2, {
    isEnabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3abdcd0949da282d$export$d0fbfd319946e0e2);
const $3abdcd0949da282d$export$97e6853b0e6eaa06 = $3abdcd0949da282d$var$$root.lookupService('squareup.bizbank.externalservice.ExternalBizbankService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 




const $bbc3574921766dd2$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $bbc3574921766dd2$var$jsonData = {
    "squareup": {
        "nested": {
            "banking": {
                "nested": {
                    "card_invitation": {
                        "nested": {
                            "Name": {
                                "fields": {
                                    "full": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "first": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "middle": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "last": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "nickname": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CardInvitation": {
                                "fields": {
                                    "id": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "inviter": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation.Inviter",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "invitee": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation.Invitee",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "state": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation.State",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "expiresAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "State": {
                                        "values": {
                                            "STATE_NONE": 0,
                                            "STATE_OPEN": 1,
                                            "STATE_CLAIMED": 2,
                                            "STATE_EXPIRED": 3,
                                            "STATE_REVOKED": 4,
                                            "STATE_ARCHIVED": 5
                                        }
                                    },
                                    "Inviter": {
                                        "fields": {
                                            "name": {
                                                "type": ".squareup.banking.card_invitation.Name",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "businessName": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Invitee": {
                                        "fields": {
                                            "name": {
                                                "type": ".squareup.banking.card_invitation.Name",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "emailAddress": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "OpenCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "OpenCardInvitationResponse": {
                                "fields": {}
                            },
                            "RetrieveCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RetrieveCardInvitationResponse": {
                                "fields": {
                                    "cardInvitation": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RevokeCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RevokeCardInvitationResponse": {
                                "fields": {}
                            },
                            "SendCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "idempotenceToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SendCardInvitationResponse": {
                                "fields": {}
                            },
                            "ClaimCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ClaimCardInvitationResponse": {
                                "fields": {}
                            },
                            "UserCardInvitationService": {
                                "methods": {
                                    "OpenCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.OpenCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.OpenCardInvitationResponse"
                                    },
                                    "RetrieveCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.RetrieveCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.RetrieveCardInvitationResponse"
                                    },
                                    "RevokeCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.RevokeCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.RevokeCardInvitationResponse"
                                    },
                                    "SendCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.SendCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.SendCardInvitationResponse"
                                    },
                                    "ClaimCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.ClaimCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.ClaimCardInvitationResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.Name && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.State && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.Inviter && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.Invitee && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.OpenCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.OpenCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RetrieveCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RetrieveCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RevokeCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RevokeCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.SendCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.SendCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.ClaimCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.ClaimCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.UserCardInvitationService) $bbc3574921766dd2$var$$root.addJSON($bbc3574921766dd2$var$jsonData);
const $bbc3574921766dd2$export$c7bd411105e2dec3 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.Name');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$c7bd411105e2dec3);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$c7bd411105e2dec3);
const $bbc3574921766dd2$export$285d7a47fed7dbbc = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.CardInvitation');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$285d7a47fed7dbbc);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$285d7a47fed7dbbc);
/**
 * SOURCE State @ squareup/banking/card_invitation.proto at 48:5
 */ $bbc3574921766dd2$export$285d7a47fed7dbbc.State = $bbc3574921766dd2$var$$root.lookupEnum('squareup.banking.card_invitation.CardInvitation.State').values;
/**
 * SOURCE Inviter @ squareup/banking/card_invitation.proto at 57:5
 */ $bbc3574921766dd2$export$285d7a47fed7dbbc.Inviter = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.CardInvitation.Inviter');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$285d7a47fed7dbbc.Inviter);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$285d7a47fed7dbbc.Inviter);
/**
 * SOURCE Invitee @ squareup/banking/card_invitation.proto at 66:5
 */ $bbc3574921766dd2$export$285d7a47fed7dbbc.Invitee = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.CardInvitation.Invitee');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$285d7a47fed7dbbc.Invitee);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$285d7a47fed7dbbc.Invitee);
const $bbc3574921766dd2$export$38e23c7fdcbf972d = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.OpenCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$38e23c7fdcbf972d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$38e23c7fdcbf972d);
const $bbc3574921766dd2$export$ed2cae7159a68007 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.OpenCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$ed2cae7159a68007);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$ed2cae7159a68007);
const $bbc3574921766dd2$export$f3079ad0d113f9b7 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RetrieveCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$f3079ad0d113f9b7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$f3079ad0d113f9b7);
const $bbc3574921766dd2$export$73ffa9c14793433a = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RetrieveCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$73ffa9c14793433a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$73ffa9c14793433a);
const $bbc3574921766dd2$export$291ceb4f3c6dd653 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RevokeCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$291ceb4f3c6dd653);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$291ceb4f3c6dd653);
const $bbc3574921766dd2$export$605b601da2e03762 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RevokeCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$605b601da2e03762);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$605b601da2e03762);
const $bbc3574921766dd2$export$8774604bbf7dff83 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.SendCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$8774604bbf7dff83);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$8774604bbf7dff83);
const $bbc3574921766dd2$export$2de656cc4882b4f5 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.SendCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$2de656cc4882b4f5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$2de656cc4882b4f5);
const $bbc3574921766dd2$export$818c5a2d30ed1bb0 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.ClaimCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$818c5a2d30ed1bb0, {
    cardInvitationId: {
        required: true
    },
    cardToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$818c5a2d30ed1bb0);
const $bbc3574921766dd2$export$671ce799e042e3c0 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.ClaimCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$671ce799e042e3c0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$671ce799e042e3c0);
const $bbc3574921766dd2$export$dede9ff322f0030a = $bbc3574921766dd2$var$$root.lookupService('squareup.banking.card_invitation.UserCardInvitationService');


var $701d006d22a68e04$export$9faacf97a1a86e9d = /*#__PURE__*/ function(APP_DEP) {
    APP_DEP["BANKING_WEB_CARD_SERVICE"] = "BANKING_WEB_CARD_SERVICE";
    APP_DEP["BANKING_WEB_COMPLIANCE_SERVICE"] = "BANKING_WEB_COMPLIANCE_SERVICE";
    APP_DEP["BANKING_WEB_SERVICE"] = "BANKING_WEB_SERVICE";
    APP_DEP["CARD_MANAGEMENT_SERVICE"] = "CARD_MANAGEMENT_SERVICE";
    APP_DEP["EXTERNAL_BIZBANK_SERVICE"] = "EXTERNAL_BIZBANK_SERVICE";
    APP_DEP["PERSON_PROFILE_SERVICE"] = "PERSON_PROFILE_SERVICE";
    APP_DEP["USER_CARD_INVITATION_SERVICE"] = "USER_CARD_INVITATION_SERVICE";
    APP_DEP["WEB_SERVICE"] = "WEB_SERVICE";
    return APP_DEP;
}({});
const $701d006d22a68e04$var$configureServices = async ()=>{
    const rpcImpl = (0, $a8dda4170dc4b740$export$2e2bcd8739ae039)(window.fetch);
    const bankingWebCardService = (0, $bc006730c79954a6$export$3fcca2f60820bf28).create(// eslint-disable-next-line
    rpcImpl);
    const bankingWebComplianceService = (0, $81287a0f87730909$export$58773615f38984aa).create(// eslint-disable-next-line
    rpcImpl);
    const bankingWebService = (0, $2a6a68ea1459b895$export$65bc5f5b6b3789b3).create(// eslint-disable-next-line
    rpcImpl);
    const cardManagementService = (0, $d272bac0a1712861$export$f40f1fb9063205d8).create(// eslint-disable-next-line
    rpcImpl);
    const externalBizbankService = (0, $3abdcd0949da282d$export$97e6853b0e6eaa06).create(// eslint-disable-next-line
    rpcImpl);
    const personProfileService = (0, $3f95b099726a1553$export$f0d0e3d2fc028c).create(// eslint-disable-next-line
    rpcImpl);
    const webService = (0, $fce501362cc81cfc$export$b944e8af96427ee6).create(// eslint-disable-next-line
    rpcImpl);
    const userCardInvitationService = (0, $bbc3574921766dd2$export$dede9ff322f0030a).create(// eslint-disable-next-line
    rpcImpl);
    return {
        ["BANKING_WEB_CARD_SERVICE"]: bankingWebCardService,
        ["BANKING_WEB_COMPLIANCE_SERVICE"]: bankingWebComplianceService,
        ["BANKING_WEB_SERVICE"]: bankingWebService,
        ["CARD_MANAGEMENT_SERVICE"]: cardManagementService,
        ["EXTERNAL_BIZBANK_SERVICE"]: externalBizbankService,
        ["PERSON_PROFILE_SERVICE"]: personProfileService,
        ["USER_CARD_INVITATION_SERVICE"]: userCardInvitationService,
        ["WEB_SERVICE"]: webService
    };
};
const $701d006d22a68e04$export$e9bcd07a423f60d8 = async ()=>{
    const servicesDependencies = await $701d006d22a68e04$var$configureServices();
    return {
        ...servicesDependencies
    };
};


const $3592a0510b526070$export$849dbeeeda01ae98 = 'production';


// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "8.40.0";



/** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $1a40e26460b4422e$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $1a40e26460b4422e$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return 0, $1a40e26460b4422e$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $b0bfa51115099518$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
}





// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



const $cccaafc2216668b2$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cccaafc2216668b2$export$c660c1f3ab49225c(selector) {
    if ($cccaafc2216668b2$var$WINDOW.document && $cccaafc2216668b2$var$WINDOW.document.querySelector) return $cccaafc2216668b2$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = 'Sentry Logger ';
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $18144a665bc8acf7$export$16a28057038b10ef) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $1a40e26460b4422e$export$7e223ec222791509)('logger', $c9674f9e04798056$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) return false;
    if ((0, $9a62450b4f3c2c3b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $f4dd084fe83374eb$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d)(target) ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $cee8faa76567523a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $cee8faa76567523a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $4f6ba265374890ec$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $4f6ba265374890ec$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $4f6ba265374890ec$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $4f6ba265374890ec$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $4f6ba265374890ec$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $4f6ba265374890ec$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496() {
    const gbl = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $cee8faa76567523a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $4f55103f4332a5b0$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns a new minimal propagation context
 */ function $dc99b4184ec29e47$export$37f0f2f9cf343e5e() {
    return {
        traceId: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        spanId: (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $33c387bb26fe522d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = (0, $dc99b4184ec29e47$export$37f0f2f9cf343e5e)();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $33c387bb26fe522d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this._propagationContext = (0, $dc99b4184ec29e47$export$37f0f2f9cf343e5e)();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $33c387bb26fe522d$export$775b6bb06e53a214 = $33c387bb26fe522d$var$ScopeClass;



/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}










/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $1a40e26460b4422e$export$7e223ec222791509)('globalScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;














/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init2.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init3.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




const $107941ce73c7a34f$var$debugIdStackParserCache = new WeakMap();
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $107941ce73c7a34f$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $107941ce73c7a34f$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id.
    return Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $25eec345af6c49d3$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $25eec345af6c49d3$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $f4dd084fe83374eb$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9a62450b4f3c2c3b$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = 'sentry.profile_id';
const $068c396dceb690a1$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $068c396dceb690a1$export$b016f89ac1066ec = 'cache.hit';
const $068c396dceb690a1$export$3110e4c3f4386399 = 'cache.key';
const $068c396dceb690a1$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = 'http.request.method';
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = 'url.full';





const $bcdb7fb6cf7e08bf$export$9ca9946bd449ac06 = 'baggage';
const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = 'sentry-';
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e426c875bd1d2890$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $deb2e427fa07e3b2$var$METRICS_SPAN_FIELD = '_sentryMetrics';
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $deb2e427fa07e3b2$export$2e7205e45c58797d(span) {
    const storage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $f4dd084fe83374eb$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $deb2e427fa07e3b2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}



const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}






// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        spanId: (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16),
        spanId: (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)(), spanId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
                status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
                op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
                origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
                _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $36b15c0d755e29f6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $36b15c0d755e29f6$export$1be426a8e585c83e();
    if (span) (0, $deb2e427fa07e3b2$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}


/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed((0, $36b15c0d755e29f6$export$92d8c23565496537)(span).trace_id || '', client);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const jsonSpan = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
}










/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'extra', extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'tags', tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'user', user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $f4dd084fe83374eb$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$var$applyClientOptions(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $cee8faa76567523a$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $cee8faa76567523a$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $cee8faa76567523a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $107941ce73c7a34f$export$e069fee9c632ed00)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $baba650ac852ba0c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}




const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $fbb22756c9507e85$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}





const $b99d5bb3db344fdd$var$INTEGRATION_NAME = 'Dedupe';
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = 'FunctionToString';
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $18144a665bc8acf7$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}



const $0e303f054920e2b1$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $f4dd084fe83374eb$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler"
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = 'InboundFilters';
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $67b350191b117f2b$var$_getPossibleEventMessages(event).some((message)=>(0, $cee8faa76567523a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $67b350191b117f2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}




const $020e060e3b422828$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return 'ReportingObserver' in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}





// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $210880305d43071a$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $210880305d43071a$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $210880305d43071a$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $210880305d43071a$var$WINDOW && !!$210880305d43071a$var$WINDOW.history.pushState && !!$210880305d43071a$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);


let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    if (!(0, $210880305d43071a$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate;
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
            })),
        version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}










/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    return (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    return (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5eb42146e0d2c9ef$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $f5682b06913d5b03$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(span)) : (span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f5682b06913d5b03$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $71e03e2f84576ceb$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}









/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}



const $4f30d529f2099042$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4f30d529f2099042$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $f5682b06913d5b03$export$d650323442802f6f)(env, (0, $f5682b06913d5b03$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $f4dd084fe83374eb$export$d25f2688db1bb433)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $c9674f9e04798056$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4f30d529f2099042$var$isTransactionEvent(event);
        const isError = $4f30d529f2099042$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4f30d529f2099042$var$processBeforeSend(this, options, prepared, hint);
            return $4f30d529f2099042$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $bbe8beff1aee2812$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9171e4713e443b9b$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4f30d529f2099042$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4f30d529f2099042$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($4f30d529f2099042$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($4f30d529f2099042$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else client.recordDroppedEvent('before_send', 'span');
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $4f30d529f2099042$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4f30d529f2099042$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $5eb42146e0d2c9ef$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(exception) || (0, $9a62450b4f3c2c3b$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(exception) || (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $f4dd084fe83374eb$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            before && typeof before;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $f4dd084fe83374eb$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $4f30d529f2099042$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1d72e3a9e632bed3$export$8ad33f488b1ab046)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
}






const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f079126c500c7ea2$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[target] && (0, $955496f5d3029976$export$56d8a8a25bd48b81)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(target, '_sentryId', (0, $4f55103f4332a5b0$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const startTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg
                    };
                    (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(header) && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return;
    (0, $c9674f9e04798056$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console)) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $c9674f9e04798056$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $c9674f9e04798056$export$77c4ce905194557b)[level];
                log && log.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $020e060e3b422828$export$c82d238e23c40b21)()) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // We capture the stack right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualStackTrace = new Error().stack;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualStackTrace;
                    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($da5e32477400e3c6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $2bf5ed435a4428b5$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/core` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/core` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $197a1d16f7c0faf5$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $197a1d16f7c0faf5$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $16d762171e064dbd$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $da5e32477400e3c6$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4f55103f4332a5b0$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(status_code);
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http',
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(data.status_code);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http',
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setTimeout', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setInterval', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'requestAnimationFrame', $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4e018dbe28beb052$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}




let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror;
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('error', handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler && !$4d76cdf59d4d2156$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler && !$7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $3920039f2d643754$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$truncateAggregateExceptions($71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $71a9151fcd5ea774$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $cee8faa76567523a$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = 'cause';
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = 'LinkedErrors';
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $71a9151fcd5ea774$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $4010ef0d9b3761f9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $020e060e3b422828$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('setTimeout')(...rest);
}








/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9ad49a0639c06d33$export$78e43115b553f358)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f3cbf180d3404fe0$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f5682b06913d5b03$export$b11169581eeaf237)(type);
            if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $f5682b06913d5b03$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f5682b06913d5b03$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $edfbff9038a67171$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $67b350191b117f2b$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)()
    ];
}
function $928f566aa50bb77a$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
        if (!(0, $020e060e3b422828$export$edf3cb81fd7d2a3e)()) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $4010ef0d9b3761f9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    const client = (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $928f566aa50bb77a$var$startSessionTracking();
    return client;
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $928f566aa50bb77a$var$startSessionTracking() {
    if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $928f566aa50bb77a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'react');
    (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)('react', {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}


const $d457a61013135fd1$export$1f7656c617418e15 = (environment)=>{
    (0, $07b303fd558e140e$export$2cd8252107eb640b)({
        dsn: "https://e9cc13fb4bcd4bd9b55f06a7898f7159@o160250.ingest.sentry.io/6707190",
        attachStacktrace: true,
        environment: environment
    });
};


const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$673ff3dfc4a496de$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $673ff3dfc4a496de$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $673ff3dfc4a496de$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$673ff3dfc4a496de$var$PATH_KEY]: path } = selector($673ff3dfc4a496de$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $673ff3dfc4a496de$var$shouldHandleAsObject = (res)=>!$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
        const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $673ff3dfc4a496de$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$673ff3dfc4a496de$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($673ff3dfc4a496de$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = {
            ...data,
            count: options.count
        };
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
        this.resolveHierarchyCache = {};
    }
    clearCache() {
        this.resolveHierarchyCache = {};
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackLng = this.options.fallbackLng;
        const fallbackLngKey = Array.isArray(fallbackLng) ? fallbackLng.join('|') : fallbackLng;
        if (fallbackLngKey !== this._cachedFallbackLng) {
            this.resolveHierarchyCache = {};
            this._cachedFallbackLng = fallbackLngKey;
        }
        const hasCacheableFallback = fallbackCode === undefined || fallbackCode === false || $673ff3dfc4a496de$var$isString(fallbackCode);
        const usesUncacheableOptionsFallback = fallbackCode === undefined && typeof this.options.fallbackLng === 'function';
        const cacheable = $673ff3dfc4a496de$var$isString(code) && hasCacheableFallback && !usesUncacheableOptionsFallback;
        let cacheKey = null;
        if (cacheable) {
            let fallbackCacheKey;
            if (fallbackCode === undefined) fallbackCacheKey = 'undefined';
            else if (fallbackCode === false) fallbackCacheKey = 'boolean:false';
            else fallbackCacheKey = `string:${fallbackCode}`;
            cacheKey = `${code.length}:${code}|${fallbackCacheKey}`;
        }
        if (cacheKey !== null) {
            const cached = this.resolveHierarchyCache[cacheKey];
            if (cached !== undefined) return cached.slice();
        }
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (!codes.includes(fc)) addCode(this.formatLanguageCode(fc));
        });
        if (cacheKey !== null) {
            this.resolveHierarchyCache[cacheKey] = codes;
            return codes.slice();
        }
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $673ff3dfc4a496de$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $673ff3dfc4a496de$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>val
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? this.escape(val) : val
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], $673ff3dfc4a496de$var$regexSafe(safeValue));
                if (skipOnVariables) {
                    todo.regex.lastIndex += safeValue.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$673ff3dfc4a496de$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/s.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], $673ff3dfc4a496de$var$regexSafe($673ff3dfc4a496de$var$makeString(value)));
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($673ff3dfc4a496de$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $673ff3dfc4a496de$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($673ff3dfc4a496de$var$getCleanedCode(l), o)(v);
class $673ff3dfc4a496de$var$Formatter {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $673ff3dfc4a496de$var$createCachedFormatter : $673ff3dfc4a496de$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $673ff3dfc4a496de$var$noop) {
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $673ff3dfc4a496de$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($673ff3dfc4a496de$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $673ff3dfc4a496de$var$I18n(options, callback);
        instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $673ff3dfc4a496de$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $673ff3dfc4a496de$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $673ff3dfc4a496de$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

// inlined from the former `void-elements` dependency, so the package has
// zero runtime dependencies. `!doctype`/`!DOCTYPE` are treated as void so a
// doctype parses as a childless node instead of swallowing the document.
const $e481e183a1d88720$var$voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    '!doctype': true,
    '!DOCTYPE': true
};
const $e481e183a1d88720$var$attrRE = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $e481e183a1d88720$var$parseTag(tag) {
    const res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };
    const tagMatch = tag.match(/<\/?([^\s]+?)[/\s>]/);
    if (tagMatch) {
        res.name = tagMatch[1];
        // void-element lookup stays case sensitive on purpose: react-i18next
        // relies on `<Br>` NOT being treated as a void `<br>` (see 1df0f9d)
        if ($e481e183a1d88720$var$voidElements[tagMatch[1]] || tag.charAt(tag.length - 2) === '/') res.voidElement = true;
        // handle comment tag
        if (res.name.startsWith('!--')) {
            const endIndex = tag.indexOf('-->');
            return {
                type: 'comment',
                comment: endIndex !== -1 ? tag.slice(4, endIndex) : ''
            };
        }
    }
    const reg = new RegExp($e481e183a1d88720$var$attrRE);
    let result = null;
    for(;;){
        result = reg.exec(tag);
        if (result === null) break;
        if (!result[0].trim()) continue;
        if (result[1]) {
            const attr = result[1].trim();
            // boolean attributes carry `null` so stringify can render them bare
            // (`<input disabled/>` instead of `<input disabled=""/>`)
            let arr = [
                attr,
                null
            ];
            const eq = attr.indexOf('=');
            if (eq > -1) // split at the first `=` only, so `data-x=a=b` keeps its full value
            arr = [
                attr.slice(0, eq),
                attr.slice(eq + 1)
            ];
            res.attrs[arr[0]] = arr[1];
            reg.lastIndex--;
        } else if (result[2]) res.attrs[result[2]] = result[3].trim().substring(1, result[3].length - 1);
    }
    return res;
}
// comments are matched as a whole (so `>` inside them is fine), everything
// else tag-shaped is matched by the second alternative
const $e481e183a1d88720$var$tagRE = /<!--[\s\S]*?-->|<[a-zA-Z0-9\-!/](?:"[^"]*"|'[^']*'|[^'">])*>/g;
const $e481e183a1d88720$var$tagNameRE = /<\/?([^\s]+?)[/\s>]/;
const $e481e183a1d88720$var$whitespaceRE = /^\s*$/;
// tags whose content is raw text: nothing inside them is markup
const $e481e183a1d88720$var$rawTextRE = /^(script|style)$/i;
// placeholder for `<` of tags rejected by options.allowedTags; restored to a
// literal `<` in text/attr/comment content after parsing (U+0000 cannot appear
// in sane input, and a collision would merely render as an extra `<`)
const $e481e183a1d88720$var$sentinel = '\u0000';
// re-used obj for quick lookups of components
const $e481e183a1d88720$var$empty = Object.create(null);
function $e481e183a1d88720$var$restoreSentinels(nodes) {
    nodes.forEach(function(node) {
        if (node.type === 'text') {
            node.content = node.content.split($e481e183a1d88720$var$sentinel).join('<');
            return;
        }
        if (node.type === 'comment') {
            node.comment = node.comment.split($e481e183a1d88720$var$sentinel).join('<');
            return;
        }
        for(const key in node.attrs){
            const value = node.attrs[key];
            if (typeof value === 'string' && value.indexOf($e481e183a1d88720$var$sentinel) > -1) node.attrs[key] = value.split($e481e183a1d88720$var$sentinel).join('<');
        }
        if (node.children.length) $e481e183a1d88720$var$restoreSentinels(node.children);
    });
}
function $e481e183a1d88720$export$98e6a39c04603d36(html, options) {
    const components = options && options.components || $e481e183a1d88720$var$empty;
    const allowedTags = options && options.allowedTags;
    let restoreNeeded = false;
    if (allowedTags) {
        const isAllowed = typeof allowedTags === 'function' ? allowedTags : function(name) {
            return allowedTags.indexOf(name) > -1;
        };
        // neutralize tags whose name is not allowed, so they parse as text.
        // on a disallowed match only the leading `<` is escaped and scanning
        // resumes right after it, so a valid tag glued into the same match
        // (e.g. `<bold>` inside `<10, <20, and <bold>`) still gets recognized
        let out = '';
        let pos = 0;
        $e481e183a1d88720$var$tagRE.lastIndex = 0;
        let am;
        while(am = $e481e183a1d88720$var$tagRE.exec(html)){
            const tag = am[0];
            out += html.slice(pos, am.index);
            const nameMatch = tag.match($e481e183a1d88720$var$tagNameRE);
            if (tag.startsWith('<!--') || nameMatch && isAllowed(nameMatch[1])) {
                out += tag;
                pos = am.index + tag.length;
            } else {
                restoreNeeded = true;
                out += $e481e183a1d88720$var$sentinel;
                pos = am.index + 1;
                $e481e183a1d88720$var$tagRE.lastIndex = pos;
            }
        }
        html = out + html.slice(pos);
    }
    const result = [];
    const arr = [];
    let current;
    let level = -1;
    let inComponent = false;
    // while parsing raw-text content (script/style), tag-looking matches
    // before this index belong to the content and must be skipped
    let rawUntil = 0;
    // lazily created lowercase copy for case-insensitive raw-text close-tag search
    let htmlLower;
    // handle text at top level
    if (html.indexOf('<') !== 0) {
        const end = html.indexOf('<');
        result.push({
            type: 'text',
            content: end === -1 ? html : html.substring(0, end)
        });
    }
    // collect matches with an exec loop instead of matchAll to keep ES5 API compat
    const matches = [];
    let m;
    while(m = $e481e183a1d88720$var$tagRE.exec(html))matches.push(m);
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        // comments match as a whole; their content must not trigger the
        // mismatched-bracket split below
        if (tag.startsWith('<!--')) return;
        // count brackets outside quoted attribute values, so `<` inside an
        // attribute (e.g. title="1 < 2") can't trigger a bogus split
        let lts = 0;
        let gts = 0;
        let secondLt = -1;
        let quote = null;
        for(let j = 0; j < tag.length; j++){
            const c = tag.charAt(j);
            if (quote) {
                if (c === quote) quote = null;
            } else if (c === '"' || c === "'") quote = c;
            else if (c === '<') {
                lts++;
                if (lts === 2) secondLt = j;
            } else if (c === '>') gts++;
        }
        // only split when the remainder is itself a valid tag start; otherwise
        // a fragment like `< <!-->` desyncs the string-level isComment check
        // from parseTag's name-based comment detection and crashes the walker
        const validSplit = secondLt > -1 && /[a-zA-Z0-9\-!/]/.test(tag.charAt(secondLt + 1));
        if (lts > gts && validSplit) {
            const firstPart = tag.substring(0, secondLt);
            const secondPart = tag.substring(firstPart.length);
            matches[i][0] = secondPart;
            matches[i].index += firstPart.length;
        }
    });
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        const index = match.index;
        if (index < rawUntil) return;
        if (inComponent) {
            if (tag !== '</' + current.name + '>') return;
            else inComponent = false;
        }
        const isOpen = tag.charAt(1) !== '/';
        const isComment = tag.startsWith('<!--');
        const start = index + tag.length;
        const nextChar = html.charAt(start);
        const nextMatch = matches[i + 1];
        let isText;
        if (nextChar === '<' && nextMatch) {
            const nextTag = html.substring(start, nextMatch.index);
            isText = nextTag.split('<').length > nextTag.split('>').length;
        }
        let parent;
        if (isComment) {
            const comment = $e481e183a1d88720$var$parseTag(tag);
            // if we're at root, push new base node
            if (level < 0) {
                result.push(comment);
                return result;
            }
            parent = arr[level];
            parent.children.push(comment);
            const text = html.slice(start, nextMatch ? nextMatch.index : undefined);
            if (text.length > 0) parent.children.push({
                type: 'text',
                content: text
            });
            return result;
        }
        if (isOpen) {
            level++;
            current = $e481e183a1d88720$var$parseTag(tag);
            if (current.type === 'tag' && components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }
            let isRawText = false;
            if (!inComponent && !current.voidElement && $e481e183a1d88720$var$rawTextRE.test(current.name)) {
                // raw-text element: everything up to the matching close tag is one
                // text child, regardless of what it looks like
                isRawText = true;
                htmlLower || (htmlLower = html.toLowerCase());
                const closeIndex = htmlLower.indexOf('</' + current.name.toLowerCase() + '>', start);
                const contentEnd = closeIndex === -1 ? html.length : closeIndex;
                const content = html.slice(start, contentEnd);
                if (content) current.children.push({
                    type: 'text',
                    content: content
                });
                rawUntil = contentEnd;
            }
            if (!current.voidElement && !inComponent && !isRawText && nextChar && nextChar !== '<') // text content runs to the next actual tag match; stray `<`
            // characters in between are part of the text
            current.children.push({
                type: 'text',
                content: html.slice(start, nextMatch ? nextMatch.index : undefined)
            });
            // if we're at root, push new base node
            if (level === 0) result.push(current);
            parent = arr[level - 1];
            if (parent) parent.children.push(current);
            arr[level] = current;
        }
        if (!isOpen || current.voidElement) {
            if (level > -1 && (current.voidElement || current.name === tag.slice(2, -1))) {
                level--;
                // move current up a level to match the end tag
                current = level === -1 ? result : arr[level];
            }
            if (!inComponent && (nextChar !== '<' || isText) && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                // the text node runs to the next actual tag match; -1 means
                // there's no tag after it (trailing text)
                const end = nextMatch ? nextMatch.index : -1;
                let content = html.slice(start, end === -1 ? undefined : end);
                // if a node is nothing but whitespace, collapse it as the spec states:
                // https://www.w3.org/TR/html4/struct/text.html#h-9.1
                if ($e481e183a1d88720$var$whitespaceRE.test(content)) content = ' ';
                // don't add whitespace-only text nodes if they would be trailing text nodes
                // or if they would be leading whitespace-only text nodes:
                //  * end > -1 indicates this is not a trailing text node
                //  * leading node is when level is -1 and parent has length 0
                if (end > -1 && level + parent.length >= 0 || content !== ' ') parent.push({
                    type: 'text',
                    content: content
                });
            }
        }
    });
    if (restoreNeeded) $e481e183a1d88720$var$restoreSentinels(result);
    return result;
}
function $e481e183a1d88720$var$attrString(attrs) {
    const buff = [];
    for(const key in attrs)if (attrs[key] === null) // boolean attribute, render bare
    buff.push(key);
    else // escape double quotes so values parsed from single-quoted or
    // multiline attributes can't break out of the generated markup
    buff.push(key + '="' + String(attrs[key]).replace(/"/g, '&quot;') + '"');
    if (!buff.length) return '';
    return ' ' + buff.join(' ');
}
function $e481e183a1d88720$var$stringifyNode(buff, doc) {
    switch(doc.type){
        case 'text':
            return buff + doc.content;
        case 'tag':
            {
                // a doctype is void but must not self-close: `<!DOCTYPE html>` not `<!DOCTYPE html/>`
                const tagEnd = doc.voidElement && doc.name.toLowerCase() !== '!doctype' ? '/>' : '>';
                buff += '<' + doc.name + (doc.attrs ? $e481e183a1d88720$var$attrString(doc.attrs) : '') + tagEnd;
                if (doc.voidElement) return buff;
                return buff + doc.children.reduce($e481e183a1d88720$var$stringifyNode, '') + '</' + doc.name + '>';
            }
        case 'comment':
            buff += '<!--' + doc.comment + '-->';
            return buff;
    }
}
function $e481e183a1d88720$export$fac44ee5b035f737(doc) {
    return doc.reduce(function(token, rootEl) {
        return token + $e481e183a1d88720$var$stringifyNode('', rootEl);
    }, '');
}
var $e481e183a1d88720$export$2e2bcd8739ae039 = {
    parse: $e481e183a1d88720$export$98e6a39c04603d36,
    stringify: $e481e183a1d88720$export$fac44ee5b035f737
};


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg) && $cfb6e0167e0b350d$var$alreadyWarned[msg]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg)) $cfb6e0167e0b350d$var$alreadyWarned[msg] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;



const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>$acffcb171536f8e9$var$getAsArray(children).every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $acffcb171536f8e9$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                const cnt = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren) ? childChildren : $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += `<${type}>${cnt}</${type}>`;
                return;
            }
            const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $acffcb171536f8e9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const knownNames = Object.keys(data);
    const allowedTags = (name)=>/^\d+$/.test(name) || keepArray.indexOf(name) > -1 || knownNames.indexOf(name) > -1;
    const ast = (0, $e481e183a1d88720$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`, {
        allowedTags: allowedTags
    });
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            if (c.type === (0, $acw62.Fragment) || c.props?.i18nIsDynamicList !== undefined) {
                const freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach((k)=>{
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $acw62.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            const override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $acw62.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        const keepTagOccurrence = {};
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(val)) props[p] = (0, $d7f2d92b0368699f$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            let matched;
                            let seen = 0;
                            for(let r = 0; r < reactNodes.length; r += 1){
                                const rn = reactNodes[r];
                                if ((0, $acw62.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            const innerScope = matched ? $acffcb171536f8e9$var$getAsArray($acffcb171536f8e9$var$getChildren(matched)) : reactNodes;
                            const inner = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
const $acffcb171536f8e9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $acw62.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
    }
    return (0, $acw62.createElement)(Componentized, {
        key: componentKey
    });
};
const $acffcb171536f8e9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$acffcb171536f8e9$var$fixComponentProps(c, index, translation));
const $acffcb171536f8e9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $acffcb171536f8e9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $acffcb171536f8e9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $acffcb171536f8e9$var$generateArrayComponents(components, translation);
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(components)) return $acffcb171536f8e9$var$generateObjectComponents(components, translation);
    (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $acffcb171536f8e9$var$isComponentsMap = (object)=>{
    if (!(0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $673ff3dfc4a496de$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $acffcb171536f8e9$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $acffcb171536f8e9$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($acffcb171536f8e9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $acffcb171536f8e9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


class $e0c19337b294ccec$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e0c19337b294ccec$export$aa9e222d9ffc5d1b);
    }
}


const $1ddf6027fecc0115$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $1ddf6027fecc0115$var$entityPattern = new RegExp(Object.keys($1ddf6027fecc0115$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $1ddf6027fecc0115$export$5cfeaa4af6841c8f = (text)=>text.replace($1ddf6027fecc0115$var$entityPattern, (match)=>$1ddf6027fecc0115$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $5f107391742a83a7$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $acw62 = parcelRequire("acw62");



const $54962d9d09845ed9$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, ...children);
};
const $54962d9d09845ed9$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5f107391742a83a7$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $1ddf6027fecc0115$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $54962d9d09845ed9$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $e917e4d32765654d$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey || defaultTranslation, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $54962d9d09845ed9$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, translation);
    }
}
$e917e4d32765654d$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $60cfc2270f17f8cc$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $e917e4d32765654d$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$60cfc2270f17f8cc$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));




const $3765cebd031b52c0$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $3765cebd031b52c0$var$notReadySnapshot = {
    t: $3765cebd031b52c0$var$notReadyT,
    ready: false
};
const $3765cebd031b52c0$var$dummySubscribe = ()=>()=>{};
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    const i18nOptions = (0, $acw62.useMemo)(()=>({
            ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $acw62.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $acw62.useRef)(0);
    const subscribe = (0, $acw62.useCallback)((callback)=>{
        if (!i18n) return $3765cebd031b52c0$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $acw62.useRef)();
    const getSnapshot = (0, $acw62.useCallback)(()=>{
        if (!i18n) return $3765cebd031b52c0$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $acw62.useState)(0);
    const { t: t, ready: ready } = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $acw62.useRef)(null);
    const wrapperLangRef = (0, $acw62.useRef)();
    const languageKey = (inst)=>`${inst.language}|${inst.resolvedLanguage}|${inst.languages?.join(',')}`;
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $acw62.useMemo)(()=>{
        const original = finalI18n;
        const lang = original && languageKey(original);
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        let inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw new Promise((resolve)=>{
            const onLoaded = ()=>resolve();
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        });
    }
    return ret;
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';


//#region lib/utils.js
const $3faa45b77b2a48ba$var$arr = [];
$3faa45b77b2a48ba$var$arr.forEach;
$3faa45b77b2a48ba$var$arr.slice;
const $3faa45b77b2a48ba$var$UNSAFE_KEYS$1 = [
    "__proto__",
    "constructor",
    "prototype"
];
function $3faa45b77b2a48ba$var$isSafeUrlSegmentBase(v) {
    if (typeof v !== "string") return false;
    if (v.length === 0 || v.length > 128) return false;
    if ($3faa45b77b2a48ba$var$UNSAFE_KEYS$1.indexOf(v) > -1) return false;
    if (v.indexOf("..") > -1) return false;
    if (v.indexOf("\\") > -1) return false;
    if (/[?#%:\s]/.test(v)) return false;
    if (/[\x00-\x1F\x7F]/.test(v)) return false;
    return true;
}
function $3faa45b77b2a48ba$var$isSafeLangUrlSegment(v) {
    if (!$3faa45b77b2a48ba$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf("/") > -1 || v.indexOf("@") > -1) return false;
    return true;
}
function $3faa45b77b2a48ba$var$isSafeNsUrlSegment(v) {
    if (!$3faa45b77b2a48ba$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf("//") > -1) return false;
    return true;
}
const $3faa45b77b2a48ba$var$SAFETY_CHECK_BY_KEY = {
    lng: $3faa45b77b2a48ba$var$isSafeLangUrlSegment,
    ns: $3faa45b77b2a48ba$var$isSafeNsUrlSegment
};
function $3faa45b77b2a48ba$var$sanitizeLogValue(v) {
    if (typeof v !== "string") return v;
    return v.replace(/[\r\n\x00-\x1F\x7F]/g, " ");
}
function $3faa45b77b2a48ba$var$redactUrlCredentials(u) {
    if (typeof u !== "string" || u.length === 0) return u;
    try {
        const parsed = new URL(u);
        if (parsed.username || parsed.password) {
            parsed.username = "";
            parsed.password = "";
            return parsed.toString();
        }
        return u;
    } catch (e) {
        return u.replace(/(\/\/)[^/@\s]+@/g, "$1");
    }
}
function $3faa45b77b2a48ba$var$hasXMLHttpRequest() {
    return typeof XMLHttpRequest === "function" || typeof XMLHttpRequest === "object";
}
/**
* Determine whether the given `maybePromise` is a Promise.
*
* @param {*} maybePromise
*
* @returns {Boolean}
*/ function $3faa45b77b2a48ba$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
/**
* Convert any value to a Promise than will resolve to this value.
*
* @param {*} maybePromise
*
* @returns {Promise}
*/ function $3faa45b77b2a48ba$var$makePromise(maybePromise) {
    if ($3faa45b77b2a48ba$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}
const $3faa45b77b2a48ba$var$interpolationRegexp = /\{\{(.+?)\}\}/g;
function $3faa45b77b2a48ba$var$interpolateUrl(str, data) {
    let unsafe = false;
    const result = str.replace($3faa45b77b2a48ba$var$interpolationRegexp, (match, key)=>{
        const k = key.trim();
        if ($3faa45b77b2a48ba$var$UNSAFE_KEYS$1.indexOf(k) > -1) return match;
        const value = data[k];
        if (value == null) return match;
        const check = $3faa45b77b2a48ba$var$SAFETY_CHECK_BY_KEY[k] || $3faa45b77b2a48ba$var$isSafeLangUrlSegment;
        const segments = String(value).split("+");
        for (const seg of segments)if (!check(seg)) {
            unsafe = true;
            return match;
        }
        return segments.join("+");
    });
    return unsafe ? null : result;
}
//#endregion
//#region lib/request.js
const $3faa45b77b2a48ba$var$g = typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : void 0;
let $3faa45b77b2a48ba$var$fetchApi;
if (typeof fetch === "function") $3faa45b77b2a48ba$var$fetchApi = fetch;
else if ($3faa45b77b2a48ba$var$g && typeof $3faa45b77b2a48ba$var$g.fetch === "function") $3faa45b77b2a48ba$var$fetchApi = $3faa45b77b2a48ba$var$g.fetch;
const $3faa45b77b2a48ba$var$XmlHttpRequestApi = $3faa45b77b2a48ba$var$hasXMLHttpRequest() && $3faa45b77b2a48ba$var$g ? $3faa45b77b2a48ba$var$g.XMLHttpRequest : void 0;
const $3faa45b77b2a48ba$var$ActiveXObjectApi = typeof ActiveXObject === "function" && $3faa45b77b2a48ba$var$g ? $3faa45b77b2a48ba$var$g.ActiveXObject : void 0;
const $3faa45b77b2a48ba$var$UNSAFE_KEYS = [
    "__proto__",
    "constructor",
    "prototype"
];
const $3faa45b77b2a48ba$var$addQueryString = (url, params)=>{
    if (params && typeof params === "object") {
        let queryString = "";
        for (const paramName of Object.keys(params)){
            if ($3faa45b77b2a48ba$var$UNSAFE_KEYS.indexOf(paramName) > -1) continue;
            queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        }
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
const $3faa45b77b2a48ba$var$fetchIt = (url, fetchOptions, callback, altFetch)=>{
    const resolver = (response)=>{
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then((data)=>{
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        const altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === "function") fetch(url, fetchOptions).then(resolver).catch(callback);
    else $3faa45b77b2a48ba$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
const $3faa45b77b2a48ba$var$requestWithFetch = (options, url, payload, callback)=>{
    if (options.queryStringParams) url = $3faa45b77b2a48ba$var$addQueryString(url, options.queryStringParams);
    const headers = {
        ...typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders
    };
    if (typeof window === "undefined" && typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && $parcel$global.process.versions && $parcel$global.process.versions.node) headers["User-Agent"] = `i18next-http-backend (node/${$parcel$global.process.version}; ${$parcel$global.process.platform} ${$parcel$global.process.arch})`;
    if (payload) headers["Content-Type"] = "application/json";
    const reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    const fetchOptions = {
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : void 0,
        headers: headers,
        ...options._omitFetchOptions ? {} : reqOptions
    };
    const altFetch = typeof options.alternateFetch === "function" && options.alternateFetch.length >= 1 ? options.alternateFetch : void 0;
    try {
        $3faa45b77b2a48ba$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach((opt)=>{
                delete fetchOptions[opt];
            });
            $3faa45b77b2a48ba$var$fetchIt(url, fetchOptions, callback, altFetch);
            options._omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
const $3faa45b77b2a48ba$var$requestWithXmlHttpRequest = (options, url, payload, callback)=>{
    if (payload && typeof payload === "object") payload = $3faa45b77b2a48ba$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $3faa45b77b2a48ba$var$addQueryString(url, options.queryStringParams);
    try {
        const x = $3faa45b77b2a48ba$var$XmlHttpRequestApi ? new $3faa45b77b2a48ba$var$XmlHttpRequestApi() : new $3faa45b77b2a48ba$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        let h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for (const i of Object.keys(h)){
            if ($3faa45b77b2a48ba$var$UNSAFE_KEYS.indexOf(i) > -1) continue;
            x.setRequestHeader(i, h[i]);
        }
        x.onreadystatechange = ()=>{
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
const $3faa45b77b2a48ba$var$request = (options, url, payload, callback)=>{
    if (typeof payload === "function") {
        callback = payload;
        payload = void 0;
    }
    callback = callback || (()=>{});
    if ($3faa45b77b2a48ba$var$fetchApi && url.indexOf("file:") !== 0) return $3faa45b77b2a48ba$var$requestWithFetch(options, url, payload, callback);
    if ($3faa45b77b2a48ba$var$hasXMLHttpRequest() || typeof ActiveXObject === "function") return $3faa45b77b2a48ba$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(/* @__PURE__ */ new Error("No fetch and no xhr implementation found!"));
};
//#endregion
//#region lib/index.js
const $3faa45b77b2a48ba$var$getDefaults = ()=>{
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        parse: (data)=>JSON.parse(data),
        stringify: JSON.stringify,
        parsePayload: (namespace, key, fallbackValue)=>({
                [key]: fallbackValue || ""
            }),
        parseLoadPayload: (languages, namespaces)=>void 0,
        request: $3faa45b77b2a48ba$var$request,
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $3faa45b77b2a48ba$export$2e2bcd8739ae039 = class {
    constructor(services, options = {}, allOptions = {}){
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    init(services, options = {}, allOptions = {}) {
        this.services = services;
        this.options = {
            ...$3faa45b77b2a48ba$var$getDefaults(),
            ...this.options || {},
            ...options
        };
        this.allOptions = allOptions;
        if (this.services && this.options.reloadInterval) {
            const timer = setInterval(()=>this.reload(), this.options.reloadInterval);
            if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
        }
    }
    readMulti(languages, namespaces, callback) {
        this._readAny(languages, languages, namespaces, namespaces, callback);
    }
    read(language, namespace, callback) {
        this._readAny([
            language
        ], language, [
            namespace
        ], namespace, callback);
    }
    _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
        let loadPath = this.options.loadPath;
        if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
        loadPath = $3faa45b77b2a48ba$var$makePromise(loadPath);
        loadPath.then((resolvedLoadPath)=>{
            if (!resolvedLoadPath) return callback(null, {});
            const url = $3faa45b77b2a48ba$var$interpolateUrl(resolvedLoadPath, {
                lng: languages.join("+"),
                ns: namespaces.join("+")
            });
            if (url == null) {
                const safeLngs = languages.map($3faa45b77b2a48ba$var$sanitizeLogValue).join(", ");
                const safeNss = namespaces.map($3faa45b77b2a48ba$var$sanitizeLogValue).join(", ");
                return callback(/* @__PURE__ */ new Error("i18next-http-backend: unsafe lng/ns value \u2014 refusing to build request URL for languages=[" + safeLngs + "] namespaces=[" + safeNss + "]"), false);
            }
            this.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
        });
    }
    loadUrl(url, callback, languages, namespaces) {
        const lng = typeof languages === "string" ? [
            languages
        ] : languages;
        const ns = typeof namespaces === "string" ? [
            namespaces
        ] : namespaces;
        const payload = this.options.parseLoadPayload(lng, ns);
        const safeUrl = $3faa45b77b2a48ba$var$sanitizeLogValue($3faa45b77b2a48ba$var$redactUrlCredentials(url));
        this.options.request(this.options, url, payload, (err, res)=>{
            if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + safeUrl + "; status code: " + res.status, true);
            if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + safeUrl + "; status code: " + res.status, false);
            if (!res && err && err.message) {
                const errorMessage = err.message.toLowerCase();
                if ([
                    "failed",
                    "fetch",
                    "network",
                    "load"
                ].find((term)=>errorMessage.indexOf(term) > -1)) return callback("failed loading " + safeUrl + ": " + $3faa45b77b2a48ba$var$sanitizeLogValue(err.message), true);
            }
            if (err) return callback(err, false);
            let ret, parseErr;
            try {
                if (typeof res.data === "string") ret = this.options.parse(res.data, languages, namespaces);
                else ret = res.data;
            } catch (e) {
                parseErr = "failed parsing " + safeUrl + " to json";
            }
            if (parseErr) return callback(parseErr, false);
            callback(null, ret);
        });
    }
    create(languages, namespace, key, fallbackValue, callback) {
        if (!this.options.addPath) return;
        if (typeof languages === "string") languages = [
            languages
        ];
        const payload = this.options.parsePayload(namespace, key, fallbackValue);
        let finished = 0;
        const dataArray = [];
        const resArray = [];
        languages.forEach((lng)=>{
            let addPath = this.options.addPath;
            if (typeof this.options.addPath === "function") addPath = this.options.addPath(lng, namespace);
            const url = $3faa45b77b2a48ba$var$interpolateUrl(addPath, {
                lng: lng,
                ns: namespace
            });
            if (url == null) {
                finished += 1;
                if (callback && finished === languages.length) callback(dataArray, resArray);
                return;
            }
            this.options.request(this.options, url, payload, (data, res)=>{
                finished += 1;
                dataArray.push(data);
                resArray.push(res);
                if (finished === languages.length) {
                    if (typeof callback === "function") callback(dataArray, resArray);
                }
            });
        });
    }
    reload() {
        const { backendConnector: backendConnector, languageUtils: languageUtils, logger: logger } = this.services;
        const currentLanguage = backendConnector.language;
        if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
        const toLoad = [];
        const append = (lng)=>{
            languageUtils.toResolveHierarchy(lng).forEach((l)=>{
                if (toLoad.indexOf(l) < 0) toLoad.push(l);
            });
        };
        append(currentLanguage);
        if (this.allOptions.preload) this.allOptions.preload.forEach((l)=>append(l));
        toLoad.forEach((lng)=>{
            this.allOptions.ns.forEach((ns)=>{
                backendConnector.read(lng, ns, "read", null, null, (err, data)=>{
                    if (err) logger.warn(`loading namespace ${ns} for language ${lng} failed`, err);
                    if (!err && data) logger.log(`loaded namespace ${ns} for language ${lng}`, data);
                    backendConnector.loaded(`${lng}|${ns}`, err, data);
                });
            });
        });
    }
};
$3faa45b77b2a48ba$export$2e2bcd8739ae039.type = "backend";


const { slice: $60196a4650e96cb1$var$slice, forEach: $60196a4650e96cb1$var$forEach } = [];
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$forEach.call($60196a4650e96cb1$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $60196a4650e96cb1$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $60196a4650e96cb1$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $60196a4650e96cb1$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $60196a4650e96cb1$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $60196a4650e96cb1$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $60196a4650e96cb1$var$hasLocalStorageSupport = null;
const $60196a4650e96cb1$var$localStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$60196a4650e96cb1$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $60196a4650e96cb1$var$hasSessionStorageSupport = null;
const $60196a4650e96cb1$var$sessionStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$60196a4650e96cb1$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $60196a4650e96cb1$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $60196a4650e96cb1$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $60196a4650e96cb1$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$60196a4650e96cb1$var$canCookies) $60196a4650e96cb1$var$order.splice(1, 1);
const $60196a4650e96cb1$var$getDefaults = ()=>({
        order: $60196a4650e96cb1$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $60196a4650e96cb1$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($60196a4650e96cb1$var$cookie$1);
        this.addDetector($60196a4650e96cb1$var$querystring);
        this.addDetector($60196a4650e96cb1$var$localStorage);
        this.addDetector($60196a4650e96cb1$var$sessionStorage);
        this.addDetector($60196a4650e96cb1$var$navigator$1);
        this.addDetector($60196a4650e96cb1$var$htmlTag);
        this.addDetector($60196a4650e96cb1$var$path);
        this.addDetector($60196a4650e96cb1$var$subdomain);
        this.addDetector($60196a4650e96cb1$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$60196a4650e96cb1$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$60196a4650e96cb1$export$2e2bcd8739ae039.type = 'languageDetector';


(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
/**
   * Needed to dynamically load bundled translation instead of manually
   * importing the translation files. This is not really a backend.
   */ .use((0, $3faa45b77b2a48ba$export$2e2bcd8739ae039)).init({
    backend: {
        loadPath: "/translations/{{lng}}/{{ns}}.json"
    },
    fallbackLng: "en-US",
    interpolation: {
        escapeValue: false
    },
    load: "currentOnly",
    react: {
        useSuspense: true
    }
});
var $dae7aefd84fd0ab6$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
let $31600a1e7102c3e5$var$localTransformTagName;
function $31600a1e7102c3e5$export$39b482c5e57630a8(tagName) {
    return new Proxy((tag)=>tag, {
        apply (target, thisArg, args) {
            return Reflect.apply($31600a1e7102c3e5$var$localTransformTagName !== null && $31600a1e7102c3e5$var$localTransformTagName !== void 0 ? $31600a1e7102c3e5$var$localTransformTagName : target, thisArg, args);
        }
    })(tagName);
}
const $31600a1e7102c3e5$export$2408f22a0fab9ae5 = (transform)=>{
    $31600a1e7102c3e5$var$localTransformTagName = transform;
};
function $31600a1e7102c3e5$export$23f2a1d2818174ef(el, tagName) {
    var _a, _b;
    return ((_b = (_a = el === null || el === void 0 ? void 0 : el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a)) === $31600a1e7102c3e5$export$39b482c5e57630a8(tagName);
}


function $74038f4f6c996b1d$export$f04b97654be23409(node) {
    var _a;
    const node_ = node;
    return ((_a = node_ === null || node_ === void 0 ? void 0 : node_.tagName) === null || _a === void 0 ? void 0 : _a.includes("MARKET-")) && typeof node_.componentOnReady === "function";
}
const $74038f4f6c996b1d$export$e6be160dea4e140c = async (elm)=>{
    var _a, _b, _c;
    if (!elm) return;
    if ($74038f4f6c996b1d$export$f04b97654be23409(elm)) await new Promise((resolve)=>{
        var _a2;
        (_a2 = elm.componentOnReady) === null || _a2 === void 0 || _a2.call(elm).then((value)=>{
            resolve(value);
        });
        setTimeout(()=>{
            resolve(null);
        }, 200);
    });
    const children = [
        ...(_a = elm.children) !== null && _a !== void 0 ? _a : []
    ];
    const shadowRootChildren = [
        ...(_c = (_b = elm.shadowRoot) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []
    ];
    const childElements = [
        ...children,
        ...shadowRootChildren
    ].filter((el)=>![
            // Market doesn't render inside of SVGs
            "svg",
            // Text nodes have an undefined tagName.
            void 0
        ].includes(el.tagName));
    await Promise.all(childElements.map((el)=>$74038f4f6c996b1d$export$e6be160dea4e140c(el)));
};


const $61293f7622d5ba04$var$dashToPascalCase = (str)=>str.toLowerCase().split("-").map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $61293f7622d5ba04$var$camelToDashCase = (str)=>str.replace(/([A-Z])/g, (m)=>`-${m[0].toLowerCase()}`);
const $61293f7622d5ba04$var$attachProps = (node, newProps, oldProps = {})=>{
    if (node instanceof Element) {
        const className = $61293f7622d5ba04$var$getClassName(node.classList, newProps, oldProps);
        if (className !== "") node.className = className;
        Object.keys(newProps).forEach((name)=>{
            if (name === "children" || name === "style" || name === "ref" || name === "class" || name === "className" || name === "forwardedRef") return;
            if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
                const eventName = name.substring(2);
                const eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);
                if (!$61293f7622d5ba04$var$isCoveredByReact(eventNameLc)) $61293f7622d5ba04$var$syncEvent(node, eventNameLc, newProps[name]);
            } else {
                node[name] = newProps[name];
                const propType = typeof newProps[name];
                if (propType === "boolean") {
                    if (newProps[name] === true) node.setAttribute($61293f7622d5ba04$var$camelToDashCase(name), "");
                    else node.removeAttribute($61293f7622d5ba04$var$camelToDashCase(name));
                } else if (propType === "string") node.setAttribute($61293f7622d5ba04$var$camelToDashCase(name), newProps[name]);
            }
        });
    }
};
const $61293f7622d5ba04$var$getClassName = (classList, newProps, oldProps)=>{
    const newClassProp = newProps.className || newProps.class;
    const oldClassProp = oldProps.className || oldProps.class;
    const currentClasses = $61293f7622d5ba04$var$arrayToMap(classList);
    const incomingPropClasses = $61293f7622d5ba04$var$arrayToMap(newClassProp ? newClassProp.split(" ") : []);
    const oldPropClasses = $61293f7622d5ba04$var$arrayToMap(oldClassProp ? oldClassProp.split(" ") : []);
    const finalClassNames = [];
    currentClasses.forEach((currentClass)=>{
        if (incomingPropClasses.has(currentClass)) {
            finalClassNames.push(currentClass);
            incomingPropClasses.delete(currentClass);
        } else if (!oldPropClasses.has(currentClass)) finalClassNames.push(currentClass);
    });
    incomingPropClasses.forEach((s)=>finalClassNames.push(s));
    return finalClassNames.join(" ");
};
const $61293f7622d5ba04$var$transformReactEventName = (eventNameSuffix)=>{
    switch(eventNameSuffix){
        case "doubleclick":
            return "dblclick";
    }
    return eventNameSuffix;
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ const $61293f7622d5ba04$var$isCoveredByReact = (eventNameSuffix)=>{
    if (typeof document === "undefined") return true;
    else {
        const eventName = "on" + $61293f7622d5ba04$var$transformReactEventName(eventNameSuffix);
        let isSupported = eventName in document;
        if (!isSupported) {
            const element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
};
const $61293f7622d5ba04$var$syncEvent = (node, eventName, newEventHandler)=>{
    const eventStore = node.__events || (node.__events = {});
    const oldEventHandler = eventStore[eventName];
    if (oldEventHandler) node.removeEventListener(eventName, oldEventHandler);
    node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
        if (newEventHandler) newEventHandler.call(this, e);
    });
};
const $61293f7622d5ba04$var$arrayToMap = (arr)=>{
    const map = /* @__PURE__ */ new Map();
    arr.forEach((s)=>map.set(s, s));
    return map;
};
var $61293f7622d5ba04$var$__defProp$2 = Object.defineProperty;
var $61293f7622d5ba04$var$__defProps$2 = Object.defineProperties;
var $61293f7622d5ba04$var$__getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var $61293f7622d5ba04$var$__getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var $61293f7622d5ba04$var$__hasOwnProp$2 = Object.prototype.hasOwnProperty;
var $61293f7622d5ba04$var$__propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var $61293f7622d5ba04$var$__defNormalProp$2 = (obj, key, value)=>key in obj ? $61293f7622d5ba04$var$__defProp$2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $61293f7622d5ba04$var$__spreadValues$2 = (a, b)=>{
    for(var prop in b || (b = {}))if ($61293f7622d5ba04$var$__hasOwnProp$2.call(b, prop)) $61293f7622d5ba04$var$__defNormalProp$2(a, prop, b[prop]);
    if ($61293f7622d5ba04$var$__getOwnPropSymbols$2) {
        for (var prop of $61293f7622d5ba04$var$__getOwnPropSymbols$2(b))if ($61293f7622d5ba04$var$__propIsEnum$2.call(b, prop)) $61293f7622d5ba04$var$__defNormalProp$2(a, prop, b[prop]);
    }
    return a;
};
var $61293f7622d5ba04$var$__spreadProps$2 = (a, b)=>$61293f7622d5ba04$var$__defProps$2(a, $61293f7622d5ba04$var$__getOwnPropDescs$2(b));
const $61293f7622d5ba04$var$setRef = (ref, value)=>{
    if (typeof ref === "function") ref(value);
    else if (ref != null) ref.current = value;
};
const $61293f7622d5ba04$var$mergeRefs = (...refs)=>{
    return (value)=>{
        refs.forEach((ref)=>{
            $61293f7622d5ba04$var$setRef(ref, value);
        });
    };
};
const $61293f7622d5ba04$var$createForwardRef = (ReactComponent, displayName)=>{
    const forwardRef = (props, ref)=>{
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ReactComponent, $61293f7622d5ba04$var$__spreadProps$2($61293f7622d5ba04$var$__spreadValues$2({}, props), {
            forwardedRef: ref
        }));
    };
    forwardRef.displayName = displayName;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(forwardRef);
};
var $61293f7622d5ba04$var$__defProp$1 = Object.defineProperty;
var $61293f7622d5ba04$var$__defProps$1 = Object.defineProperties;
var $61293f7622d5ba04$var$__getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var $61293f7622d5ba04$var$__getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var $61293f7622d5ba04$var$__hasOwnProp$1 = Object.prototype.hasOwnProperty;
var $61293f7622d5ba04$var$__propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var $61293f7622d5ba04$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $61293f7622d5ba04$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $61293f7622d5ba04$var$__spreadValues$1 = (a, b)=>{
    for(var prop in b || (b = {}))if ($61293f7622d5ba04$var$__hasOwnProp$1.call(b, prop)) $61293f7622d5ba04$var$__defNormalProp$1(a, prop, b[prop]);
    if ($61293f7622d5ba04$var$__getOwnPropSymbols$1) {
        for (var prop of $61293f7622d5ba04$var$__getOwnPropSymbols$1(b))if ($61293f7622d5ba04$var$__propIsEnum$1.call(b, prop)) $61293f7622d5ba04$var$__defNormalProp$1(a, prop, b[prop]);
    }
    return a;
};
var $61293f7622d5ba04$var$__spreadProps$1 = (a, b)=>$61293f7622d5ba04$var$__defProps$1(a, $61293f7622d5ba04$var$__getOwnPropDescs$1(b));
var $61293f7622d5ba04$var$__objRest$1 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($61293f7622d5ba04$var$__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $61293f7622d5ba04$var$__getOwnPropSymbols$1) {
        for (var prop of $61293f7622d5ba04$var$__getOwnPropSymbols$1(source))if (exclude.indexOf(prop) < 0 && $61293f7622d5ba04$var$__propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $61293f7622d5ba04$export$927875efa13d9ac5 = (tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement)=>{
    if (defineCustomElement !== void 0) defineCustomElement();
    const displayName = $61293f7622d5ba04$var$dashToPascalCase(tagName);
    const ReactComponent = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
        constructor(props){
            super(props);
            this.setComponentElRef = (element)=>{
                this.componentEl = element;
            };
        }
        componentDidMount() {
            this.componentDidUpdate(this.props);
        }
        componentDidUpdate(prevProps) {
            $61293f7622d5ba04$var$attachProps(this.componentEl, this.props, prevProps);
        }
        render() {
            const _a = this.props, { children: children, forwardedRef: forwardedRef, style: style, className: className, ref: ref } = _a, cProps = $61293f7622d5ba04$var$__objRest$1(_a, [
                "children",
                "forwardedRef",
                "style",
                "className",
                "ref"
            ]);
            let propsToPass = Object.keys(cProps).reduce((acc, name)=>{
                const value = cProps[name];
                if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
                    const eventName = name.substring(2).toLowerCase();
                    if (typeof document !== "undefined" && $61293f7622d5ba04$var$isCoveredByReact(eventName)) acc[name] = value;
                } else {
                    const type = typeof value;
                    if (type === "string" || type === "boolean" || type === "number") acc[$61293f7622d5ba04$var$camelToDashCase(name)] = value;
                }
                return acc;
            }, {});
            if (manipulatePropsFunction) propsToPass = manipulatePropsFunction(this.props, propsToPass);
            const newProps = $61293f7622d5ba04$var$__spreadProps$1($61293f7622d5ba04$var$__spreadValues$1({}, propsToPass), {
                ref: $61293f7622d5ba04$var$mergeRefs(forwardedRef, this.setComponentElRef),
                style: style
            });
            return (0, $acw62.createElement)(tagName, newProps, children);
        }
        static get displayName() {
            return displayName;
        }
    };
    if (ReactComponentContext) ReactComponent.contextType = ReactComponentContext;
    return $61293f7622d5ba04$var$createForwardRef(ReactComponent, displayName);
};
var $61293f7622d5ba04$var$__defProp = Object.defineProperty;
var $61293f7622d5ba04$var$__defProps = Object.defineProperties;
var $61293f7622d5ba04$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $61293f7622d5ba04$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $61293f7622d5ba04$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $61293f7622d5ba04$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $61293f7622d5ba04$var$__defNormalProp = (obj, key, value)=>key in obj ? $61293f7622d5ba04$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $61293f7622d5ba04$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($61293f7622d5ba04$var$__hasOwnProp.call(b, prop)) $61293f7622d5ba04$var$__defNormalProp(a, prop, b[prop]);
    if ($61293f7622d5ba04$var$__getOwnPropSymbols) {
        for (var prop of $61293f7622d5ba04$var$__getOwnPropSymbols(b))if ($61293f7622d5ba04$var$__propIsEnum.call(b, prop)) $61293f7622d5ba04$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $61293f7622d5ba04$var$__spreadProps = (a, b)=>$61293f7622d5ba04$var$__defProps(a, $61293f7622d5ba04$var$__getOwnPropDescs(b));
var $61293f7622d5ba04$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($61293f7622d5ba04$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $61293f7622d5ba04$var$__getOwnPropSymbols) {
        for (var prop of $61293f7622d5ba04$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $61293f7622d5ba04$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $61293f7622d5ba04$var$MARKET_TAGNAME_REGEX = /(market-)(.*)/;
const $61293f7622d5ba04$export$8f95d9dcc176da71 = (tagName, defineCustomElement)=>{
    if (defineCustomElement !== void 0) defineCustomElement();
    const displayName = $61293f7622d5ba04$var$dashToPascalCase(tagName);
    const contextManagerTagName = tagName.replace($61293f7622d5ba04$var$MARKET_TAGNAME_REGEX, "$1context-manager");
    const contextTagName = tagName.replace($61293f7622d5ba04$var$MARKET_TAGNAME_REGEX, "$1context");
    const MarketContext = $61293f7622d5ba04$export$927875efa13d9ac5(contextTagName);
    const ModalElement = $61293f7622d5ba04$export$927875efa13d9ac5(tagName);
    const createOrReturnContextManager = ()=>{
        const contextManager = document.querySelector(contextManagerTagName);
        if (!contextManager) {
            const contextManager2 = document.createElement(contextManagerTagName);
            document.body.appendChild(contextManager2);
            return contextManager2;
        }
        return contextManager;
    };
    const ReactComponent = (_a)=>{
        var _b = _a, { children: children, forwardedRef: forwardedRef, style: style, className: className, ref: ref } = _b, cProps = $61293f7622d5ba04$var$__objRest(_b, [
            "children",
            "forwardedRef",
            "style",
            "className",
            "ref"
        ]);
        const containerRef = (0, $acw62.useRef)(null);
        const contextManagerElement = createOrReturnContextManager();
        const [isDismissing, setIsDismissing] = (0, $acw62.useState)(false);
        const propsToPass = Object.keys(cProps).reduce((acc, name)=>{
            const value = cProps[name];
            if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) acc[name] = value;
            else {
                const type = typeof value;
                if (type === "string" || type === "boolean" || type === "number") acc[$61293f7622d5ba04$var$camelToDashCase(name)] = value;
            }
            return acc;
        }, {});
        const newProps = $61293f7622d5ba04$var$__spreadProps($61293f7622d5ba04$var$__spreadValues({}, propsToPass), {
            ref: forwardedRef,
            style: style,
            className: className
        });
        (0, $acw62.useEffect)(()=>{
            let dialogElement = null;
            const handleDismiss = (event)=>{
                queueMicrotask(()=>{
                    if (!event.defaultPrevented) setIsDismissing(true);
                });
            };
            const setupModal = async ()=>{
                var _a2, _b2;
                await (0, $74038f4f6c996b1d$export$e6be160dea4e140c)(containerRef.current);
                await ((_a2 = containerRef.current) == null ? void 0 : _a2.open(containerRef.current.firstElementChild));
                await contextManagerElement.activate();
                dialogElement = (_b2 = containerRef.current) == null ? void 0 : _b2.firstElementChild;
                dialogElement == null || dialogElement.addEventListener("marketDialogDismissed", handleDismiss);
            };
            setupModal().catch(()=>null);
            return ()=>{
                dialogElement == null || dialogElement.removeEventListener("marketDialogDismissed", handleDismiss);
                if (contextManagerElement.childElementCount === 0) contextManagerElement.deactivate();
            };
        }, []);
        if (contextManagerElement === null) return null;
        if (isDismissing) return null;
        return (0, $1u0KT.createPortal)(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MarketContext, {
            ref: containerRef
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalElement, $61293f7622d5ba04$var$__spreadValues({}, newProps), children)), contextManagerElement);
    };
    ReactComponent.displayName = displayName;
    return $61293f7622d5ba04$var$createForwardRef(ReactComponent, displayName);
};
const $61293f7622d5ba04$export$6f0866326599ed67 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-accessory");
const $61293f7622d5ba04$export$6145a59a4e4eac8b = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-accordion-item");
const $61293f7622d5ba04$export$cac360922d5e9af6 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-action-card");
const $61293f7622d5ba04$export$28c2b904b2ab5c88 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-activity-indicator");
const $61293f7622d5ba04$export$809cbe1e0a7d9f9 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-activity-indicator-bar");
const $61293f7622d5ba04$export$5c6fd3bcc87b049b = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-banner");
const $61293f7622d5ba04$export$edd5eb07a68f878 = /* @__PURE__ */ $61293f7622d5ba04$export$8f95d9dcc176da71("market-blade");
const $61293f7622d5ba04$export$862a33790ffda48f = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-button");
const $61293f7622d5ba04$export$19f8dfeebad6b5c4 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-button-dropdown");
const $61293f7622d5ba04$export$98f7e185520106d0 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-button-group");
const $61293f7622d5ba04$export$1df005bf392232de = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-checkbox");
const $61293f7622d5ba04$export$2e8eb11a7d8d825 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-choice-button");
const $61293f7622d5ba04$export$6ce1c5a1197c7e0f = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-code-display");
const $61293f7622d5ba04$export$f1fcfd478d0fa17d = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-code-input");
const $61293f7622d5ba04$export$32a0d8ef77c99c93 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-color-picker");
const $61293f7622d5ba04$export$71167bce880f3124 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-color-picker-gradient");
const $61293f7622d5ba04$export$5c730a9503a514d3 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-color-picker-input");
const $61293f7622d5ba04$export$7da6088ee238975d = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-color-swatch");
const $61293f7622d5ba04$export$9dfd05d09a8b7e2e = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-color-swatch-list");
const $61293f7622d5ba04$export$e11c4ee477acc652 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-content-card");
const $61293f7622d5ba04$export$5c6dae3c700da9bd = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-context");
const $61293f7622d5ba04$export$671557a13be7cc96 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-context-manager");
const $61293f7622d5ba04$export$507e2a5199469119 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-date-picker");
const $61293f7622d5ba04$export$759993c595fab914 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-date-picker-date");
const $61293f7622d5ba04$export$5916b05805a96ee3 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-date-picker-input-date");
const $61293f7622d5ba04$export$efbd9f2ed7780a30 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-date-picker-menu");
const $61293f7622d5ba04$export$ae31bb92daaacf7b = /* @__PURE__ */ $61293f7622d5ba04$export$8f95d9dcc176da71("market-dialog");
const $61293f7622d5ba04$export$2bf53bba4802f0ae = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-divider");
const $61293f7622d5ba04$export$45b2ab2714d81604 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-drag-handle");
const $61293f7622d5ba04$export$55e40bf6ba98f173 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-dropdown");
const $61293f7622d5ba04$export$53fe4b71065a03ce = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-empty-state");
const $61293f7622d5ba04$export$bf9d3c0d17a2f99e = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-field");
const $61293f7622d5ba04$export$3bb74e73144a7a1c = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-file-upload");
const $61293f7622d5ba04$export$ac4de2402813dce3 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-filter");
const $61293f7622d5ba04$export$e5dbc5e04048d721 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-filter-button");
const $61293f7622d5ba04$export$2a6919f5f2d41050 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-filter-dropdown-menu");
const $61293f7622d5ba04$export$78870e85af0e5c95 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-filter-group");
const $61293f7622d5ba04$export$a2053447cfda9df3 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-footer");
const $61293f7622d5ba04$export$95abf1952846aff4 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-header");
const $61293f7622d5ba04$export$66ab025a5c72bc37 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-inline-section-header");
const $61293f7622d5ba04$export$7bbcd26000435b17 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-inline-status");
const $61293f7622d5ba04$export$bd6be06d24180fe5 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-input-password");
const $61293f7622d5ba04$export$2ede3c8d67d0b9d0 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-input-search");
const $61293f7622d5ba04$export$f8929a49510d767f = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-input-text");
const $61293f7622d5ba04$export$49443b5f5d98af6e = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-link");
const $61293f7622d5ba04$export$5f38cc4b3e71c577 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-list");
const $61293f7622d5ba04$export$9be6f02cefaea425 = /* @__PURE__ */ $61293f7622d5ba04$export$8f95d9dcc176da71("market-modal-full");
const $61293f7622d5ba04$export$4fa994bc91bf3e1 = /* @__PURE__ */ $61293f7622d5ba04$export$8f95d9dcc176da71("market-modal-partial");
const $61293f7622d5ba04$export$2d83be035d558064 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-pagination");
const $61293f7622d5ba04$export$ffeb71fc62d8c571 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-pagination-nav");
const $61293f7622d5ba04$export$924e17977e3d512f = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-pagination-page-size");
const $61293f7622d5ba04$export$2deb0c47cc93ce63 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-pill");
const $61293f7622d5ba04$export$a00ed319fc43be46 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-popover");
const $61293f7622d5ba04$export$561cbb7b502ca6ee = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-progress-tracker");
const $61293f7622d5ba04$export$e4682f92f3256842 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-progress-tracker-step");
const $61293f7622d5ba04$export$98adee31ea2d2621 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-qrcode");
const $61293f7622d5ba04$export$3f5cc96cec366be4 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-radio");
const $61293f7622d5ba04$export$14eeaa98ef1abeb2 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-row");
const $61293f7622d5ba04$export$d9270f60b07d09a = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-segment");
const $61293f7622d5ba04$export$42ee0af031e2823c = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-segmented-control");
const $61293f7622d5ba04$export$29823418345456dd = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-select");
const $61293f7622d5ba04$export$94847df857c7a21e = /* @__PURE__ */ $61293f7622d5ba04$export$8f95d9dcc176da71("market-sheet");
const $61293f7622d5ba04$export$47ef55df1edd51ec = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-stepper");
const $61293f7622d5ba04$export$a351e59f4d54d834 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tab");
const $61293f7622d5ba04$export$b4a4c53ca46e095f = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tab-list");
const $61293f7622d5ba04$export$e8b65da8829cd4fc = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tab-panel");
const $61293f7622d5ba04$export$8c7c5327e9abf9e9 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table");
const $61293f7622d5ba04$export$f2c35307246bb502 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-area");
const $61293f7622d5ba04$export$47cffd043943b519 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-cell");
const $61293f7622d5ba04$export$98d982f91501addb = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-column");
const $61293f7622d5ba04$export$4791d97b1f79ac1a = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-row");
const $61293f7622d5ba04$export$dcc0675722e11d9a = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-v2");
const $61293f7622d5ba04$export$ad11139b8552df77 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-v2-cell");
const $61293f7622d5ba04$export$2f24e5b62bcd95a0 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-v2-group");
const $61293f7622d5ba04$export$c0dd1175b8b645f4 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-table-v2-row");
const $61293f7622d5ba04$export$d2c429788534e7b2 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tabs");
const $61293f7622d5ba04$export$2157929c12620208 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tag");
const $61293f7622d5ba04$export$f6983f729ebeb4cd = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-textarea");
const $61293f7622d5ba04$export$91a0ef8451160b3b = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tile");
const $61293f7622d5ba04$export$7976a0b446a572f = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-toast");
const $61293f7622d5ba04$export$6185df1bc788a671 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-toaster");
const $61293f7622d5ba04$export$b2dd8e9aed9c0935 = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-toggle");
const $61293f7622d5ba04$export$8f7631573f08e68b = /* @__PURE__ */ $61293f7622d5ba04$export$927875efa13d9ac5("market-tooltip");




// DO NOT EDIT! This is copy and pasted from dashboard
// TODO(cvu): eventually import this from dashboard via bazel
// frontend/@banking/ui/addon/utils/assert.ts
// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/utils/predicates.ts
// TODO(cvu): eventually import this from dashboard via bazel
const $e414140c55630b60$export$ec3bcb3c4c9d7237 = (value)=>typeof value === "boolean";
const $e414140c55630b60$export$26128561c93f5847 = (value)=>value != null;


function $5cdd7c46b89c41cf$export$2e2bcd8739ae039(condition, msg) {
    if (!condition) throw new Error(msg ?? "assertion failure");
}
function $5cdd7c46b89c41cf$export$a5d83b356248b8b4(val, ctor) {
    // eslint-disable-next-line
    function assert(val, ctor) {
        if (!(val instanceof ctor)) throw new TypeError(`Expected value to be an instance of ${ctor.name}.`);
    }
    assert(val, ctor);
    return val;
}
function $5cdd7c46b89c41cf$export$860d92d158d1ae0e(val) {
    $5cdd7c46b89c41cf$export$2e2bcd8739ae039((0, $e414140c55630b60$export$ec3bcb3c4c9d7237)(val), "value must be boolean");
    return val;
}
function $5cdd7c46b89c41cf$export$31407c2dd876dbd1(val) {
    $5cdd7c46b89c41cf$export$2e2bcd8739ae039((0, $e414140c55630b60$export$26128561c93f5847)(val), "value cannot be nullable");
    return val;
}


const $f52070b5f7ea08cf$export$f0f3a5c436134bc0 = (personProfile)=>{
    if (personProfile == null) throw new Error("Missing personProfile from bootstrap");
    if (personProfile.personToken === "") throw new Error("PersonProfile person token is empty from bootstrap");
    return {
        personToken: personProfile.personToken,
        name: {
            first: personProfile.name?.firstName ?? "",
            last: personProfile.name?.lastName ?? ""
        }
    };
};
const $f52070b5f7ea08cf$export$155800cbebf9d04f = (user)=>{
    const firstName = user.name.first;
    const lastName = user.name.last;
    return $f52070b5f7ea08cf$export$525011322c57ec0f(firstName, lastName);
};
const $f52070b5f7ea08cf$export$525011322c57ec0f = (firstName, lastName)=>{
    return `${firstName} ${lastName}`.trim();
};


const $214b3af3bfc0d570$export$8f5519c5909517b3 = (bootstrap)=>({
        user: (0, $f52070b5f7ea08cf$export$f0f3a5c436134bc0)(bootstrap.personProfile)
    });




var $acw62 = parcelRequire("acw62");

/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $ee8fa670c1d03165$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $ee8fa670c1d03165$export$825a82322d91916e = /^[\\/]{2}/;
function $ee8fa670c1d03165$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $2ce80a7c58bedbaf$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $2ce80a7c58bedbaf$var$PopStateEventType = "popstate";
function $2ce80a7c58bedbaf$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $2ce80a7c58bedbaf$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $2ce80a7c58bedbaf$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $2ce80a7c58bedbaf$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $2ce80a7c58bedbaf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $2ce80a7c58bedbaf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $2ce80a7c58bedbaf$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $2ce80a7c58bedbaf$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    }
    return $2ce80a7c58bedbaf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $2ce80a7c58bedbaf$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $2ce80a7c58bedbaf$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $2ce80a7c58bedbaf$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $2ce80a7c58bedbaf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $2ce80a7c58bedbaf$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $2ce80a7c58bedbaf$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $2ce80a7c58bedbaf$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $2ce80a7c58bedbaf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $2ce80a7c58bedbaf$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $2ce80a7c58bedbaf$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $2ce80a7c58bedbaf$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $2ce80a7c58bedbaf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $2ce80a7c58bedbaf$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $2ce80a7c58bedbaf$var$isLocation(to) ? to : $2ce80a7c58bedbaf$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $2ce80a7c58bedbaf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $2ce80a7c58bedbaf$var$isLocation(to) ? to : $2ce80a7c58bedbaf$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $2ce80a7c58bedbaf$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $2ce80a7c58bedbaf$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($2ce80a7c58bedbaf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($2ce80a7c58bedbaf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $2ce80a7c58bedbaf$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $2ce80a7c58bedbaf$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $2ce80a7c58bedbaf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $ee8fa670c1d03165$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $edf931d6dcac43ec$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $edf931d6dcac43ec$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
const $edf931d6dcac43ec$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children",
    "unstable_validateParams"
]);
function $edf931d6dcac43ec$export$3e22299e33adeed1(key) {
    return $edf931d6dcac43ec$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $edf931d6dcac43ec$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children",
    "unstable_validateParams"
]);
function $edf931d6dcac43ec$export$a89d811eaa209e85(key) {
    return $edf931d6dcac43ec$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $edf931d6dcac43ec$var$isIndexRoute(route) {
    return route.index === true;
}
function $edf931d6dcac43ec$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $acw62.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $edf931d6dcac43ec$export$87cb1a9238dc3fba(routes, mapRouteProperties = $edf931d6dcac43ec$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($edf931d6dcac43ec$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $edf931d6dcac43ec$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $edf931d6dcac43ec$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $edf931d6dcac43ec$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $edf931d6dcac43ec$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $edf931d6dcac43ec$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $edf931d6dcac43ec$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $edf931d6dcac43ec$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $edf931d6dcac43ec$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $edf931d6dcac43ec$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $edf931d6dcac43ec$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $edf931d6dcac43ec$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $edf931d6dcac43ec$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $edf931d6dcac43ec$export$e486c0390e42ccf6(routes) {
    let branches = $edf931d6dcac43ec$var$flattenRoutes(routes);
    $edf931d6dcac43ec$var$rankRouteBranches(branches);
    return branches;
}
function $edf931d6dcac43ec$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $edf931d6dcac43ec$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $edf931d6dcac43ec$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $edf931d6dcac43ec$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $edf931d6dcac43ec$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $edf931d6dcac43ec$export$82472424e06ad5c9(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $edf931d6dcac43ec$export$82472424e06ad5c9(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $edf931d6dcac43ec$export$82472424e06ad5c9(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $edf931d6dcac43ec$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $edf931d6dcac43ec$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $edf931d6dcac43ec$var$paramRe = /^:[\w-]+$/;
const $edf931d6dcac43ec$var$partialParamRe = /^:[\w-]+/;
const $edf931d6dcac43ec$var$partialDynamicSegmentValue = 3.5;
const $edf931d6dcac43ec$var$dynamicSegmentValue = 3;
const $edf931d6dcac43ec$var$indexRouteValue = 2;
const $edf931d6dcac43ec$var$emptySegmentValue = 1;
const $edf931d6dcac43ec$var$staticSegmentValue = 10;
const $edf931d6dcac43ec$var$splatPenalty = -2;
const $edf931d6dcac43ec$var$isSplat = (s)=>s === "*";
function $edf931d6dcac43ec$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($edf931d6dcac43ec$var$isSplat)) initialScore += $edf931d6dcac43ec$var$splatPenalty;
    if (index) initialScore += $edf931d6dcac43ec$var$indexRouteValue;
    return segments.filter((s)=>!$edf931d6dcac43ec$var$isSplat(s)).reduce((score, segment)=>score + ($edf931d6dcac43ec$var$paramRe.test(segment) ? $edf931d6dcac43ec$var$dynamicSegmentValue : $edf931d6dcac43ec$var$partialParamRe.test(segment) ? $edf931d6dcac43ec$var$partialDynamicSegmentValue : segment === "" ? $edf931d6dcac43ec$var$emptySegmentValue : $edf931d6dcac43ec$var$staticSegmentValue), initialScore);
}
function $edf931d6dcac43ec$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $edf931d6dcac43ec$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $edf931d6dcac43ec$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $edf931d6dcac43ec$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $edf931d6dcac43ec$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $edf931d6dcac43ec$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $edf931d6dcac43ec$export$a5c6d149b50c1d86($edf931d6dcac43ec$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $edf931d6dcac43ec$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $edf931d6dcac43ec$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $edf931d6dcac43ec$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$edf931d6dcac43ec$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $edf931d6dcac43ec$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $edf931d6dcac43ec$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $edf931d6dcac43ec$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $edf931d6dcac43ec$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $edf931d6dcac43ec$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $edf931d6dcac43ec$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $edf931d6dcac43ec$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $edf931d6dcac43ec$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $edf931d6dcac43ec$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $edf931d6dcac43ec$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $edf931d6dcac43ec$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $edf931d6dcac43ec$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $edf931d6dcac43ec$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $edf931d6dcac43ec$export$a1cbf2de32a9fd1 = (url)=>(0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $edf931d6dcac43ec$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $edf931d6dcac43ec$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $edf931d6dcac43ec$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $edf931d6dcac43ec$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $edf931d6dcac43ec$var$normalizeSearch(search),
        hash: $edf931d6dcac43ec$var$normalizeHash(hash)
    };
}
function $edf931d6dcac43ec$var$resolvePathname(relativePath, fromPathname) {
    let segments = $edf931d6dcac43ec$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $edf931d6dcac43ec$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $edf931d6dcac43ec$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $edf931d6dcac43ec$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $edf931d6dcac43ec$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $edf931d6dcac43ec$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $edf931d6dcac43ec$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $edf931d6dcac43ec$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $edf931d6dcac43ec$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $edf931d6dcac43ec$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $edf931d6dcac43ec$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $edf931d6dcac43ec$export$86d9a7913e44197e = (paths)=>$edf931d6dcac43ec$export$f857a07c5bd323b8(paths.join("/"));
function $edf931d6dcac43ec$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $edf931d6dcac43ec$export$a5c6d149b50c1d86 = (pathname)=>$edf931d6dcac43ec$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $edf931d6dcac43ec$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $edf931d6dcac43ec$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $edf931d6dcac43ec$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $edf931d6dcac43ec$export$4051a07651545597(data, init) {
    return new $edf931d6dcac43ec$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $edf931d6dcac43ec$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $edf931d6dcac43ec$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $edf931d6dcac43ec$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $edf931d6dcac43ec$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $edf931d6dcac43ec$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $edf931d6dcac43ec$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $edf931d6dcac43ec$export$d738435097971c09(matches) {
    return $edf931d6dcac43ec$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $edf931d6dcac43ec$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $edf931d6dcac43ec$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $edf931d6dcac43ec$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($edf931d6dcac43ec$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $ee8fa670c1d03165$export$825a82322d91916e).test(to) ? new URL((0, $ee8fa670c1d03165$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $edf931d6dcac43ec$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $7ab28948be9dda45$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $7ab28948be9dda45$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $7ab28948be9dda45$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $7ab28948be9dda45$var$DEFAULT_NAVIGATION_URL;
    }
}
function $7ab28948be9dda45$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $7ab28948be9dda45$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $7ab28948be9dda45$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$7ab28948be9dda45$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$7ab28948be9dda45$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$7ab28948be9dda45$var$isExplicitUrl(original, originalUrl) || !$7ab28948be9dda45$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region lib/router/instrumentation.ts
const $bb1de4858130979b$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $bb1de4858130979b$export$b1aab28b8e9d7d25 = (0, $edf931d6dcac43ec$export$fd42f52fd3ae1109)();
let $bb1de4858130979b$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $bb1de4858130979b$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.loader, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.action, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $bb1de4858130979b$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.middleware, $bb1de4858130979b$var$getHandlerInfo(args[0]), ()=>original(...args), $bb1de4858130979b$var$getInstrumentationInnerResult));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $bb1de4858130979b$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $bb1de4858130979b$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to) : ".",
                ...$bb1de4858130979b$var$getRouterInfo(router, opts ?? {})
            };
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $bb1de4858130979b$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$bb1de4858130979b$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $bb1de4858130979b$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $bb1de4858130979b$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        return $bb1de4858130979b$var$throwOrReturnResult(await $bb1de4858130979b$var$recurseRight(aggregated.request, {
            request: $bb1de4858130979b$var$getReadonlyRequest(request),
            context: $bb1de4858130979b$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($bb1de4858130979b$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$bb1de4858130979b$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $bb1de4858130979b$var$getUninstrumentedHandler(handler) {
    return handler[$bb1de4858130979b$var$UninstrumentedSymbol] ?? handler;
}
function $bb1de4858130979b$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$bb1de4858130979b$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $bb1de4858130979b$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($bb1de4858130979b$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $bb1de4858130979b$export$5579798e35f5560e(router) {
    let receiver = $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.get(router);
    $bb1de4858130979b$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $bb1de4858130979b$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $bb1de4858130979b$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $bb1de4858130979b$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $bb1de4858130979b$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $bb1de4858130979b$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $bb1de4858130979b$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $bb1de4858130979b$var$getReadonlyContext(context)
    };
}
function $bb1de4858130979b$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $bb1de4858130979b$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $bb1de4858130979b$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/matcher.ts
var $6069f2a71d2ba88b$export$92541312f2982378 = class {
    #routes = [];
    #branches = [];
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        this.#routes = routes;
        this.#branches = (0, $edf931d6dcac43ec$export$e486c0390e42ccf6)(routes);
    }
    match(locationArg, allowPartial = false) {
        return (0, $edf931d6dcac43ec$export$5c7b09132f833c25)(this.#routes, locationArg, this.#basename, allowPartial, this.#branches);
    }
};


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * Split a route pattern into protocol, hostname, port, pathname, and search
 * spans delimited as `protocol://hostname:port/pathname?search`.
 *
 * Delimiters are not included in the spans with the exception of the leading `/` for pathname.
 * Spans are [begin (inclusive), end (exclusive)].
 *
 * @param source the route pattern string to split
 * @returns an object containing spans for each URL component
 */ function $344366481ada1aed$export$65980d18b75784e2(source) {
    let result = {
        protocol: null,
        hostname: null,
        port: null,
        pathname: null,
        search: null
    };
    let questionMarkIndex = source.indexOf('?');
    if (questionMarkIndex !== -1) {
        result.search = $344366481ada1aed$var$span(questionMarkIndex + 1, source.length);
        source = source.slice(0, questionMarkIndex);
    }
    let solidusIndex = source.indexOf('://');
    if (solidusIndex === -1) {
        result.pathname = $344366481ada1aed$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    let slashIndex = source.indexOf('/');
    if (slashIndex === solidusIndex + 1) slashIndex = source.indexOf('/', solidusIndex + 3);
    if (slashIndex === -1) {
        result.protocol = $344366481ada1aed$var$span(0, solidusIndex);
        let host = $344366481ada1aed$var$span(solidusIndex + 3, source.length);
        if (host) {
            let { hostname: hostname, port: port } = $344366481ada1aed$var$hostSpans(source, host);
            result.hostname = hostname;
            result.port = port;
        }
        return result;
    }
    if (slashIndex < solidusIndex) {
        result.pathname = $344366481ada1aed$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    result.protocol = $344366481ada1aed$var$span(0, solidusIndex);
    let host = $344366481ada1aed$var$span(solidusIndex + 3, slashIndex);
    if (host) {
        let { hostname: hostname, port: port } = $344366481ada1aed$var$hostSpans(source, host);
        result.hostname = hostname;
        result.port = port;
    }
    result.pathname = $344366481ada1aed$var$pathnameSpan(source, slashIndex, source.length);
    return result;
}
function $344366481ada1aed$var$span(start, end) {
    if (start === end) return null;
    return [
        start,
        end
    ];
}
function $344366481ada1aed$var$hostSpans(source, host) {
    let lastColonIndex = source.slice(0, host[1]).lastIndexOf(':');
    if (lastColonIndex === -1 || lastColonIndex < host[0]) return {
        hostname: host,
        port: null
    };
    if (source.slice(lastColonIndex + 1, host[1]).match(/^\d+$/)) return {
        hostname: $344366481ada1aed$var$span(host[0], lastColonIndex),
        port: $344366481ada1aed$var$span(lastColonIndex + 1, host[1])
    };
    return {
        hostname: host,
        port: null
    };
}
function $344366481ada1aed$var$pathnameSpan(source, begin, end) {
    if (source[begin] === '/') begin += 1;
    return $344366481ada1aed$var$span(begin, end);
}



const $460a28c920c4dfda$var$IDENTIFIER_RE = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
function $460a28c920c4dfda$export$e26190e3669abbfe(source) {
    let spans = (0, $344366481ada1aed$export$65980d18b75784e2)(source);
    return new (0, $0d4f95eb196de161$export$2917961db0dd6e8b)({
        protocol: $460a28c920c4dfda$var$parseProtocol(source, spans.protocol),
        hostname: $460a28c920c4dfda$var$parseHostname(source, spans.hostname),
        port: spans.port ? source.slice(...spans.port) : null,
        pathname: spans.pathname ? $460a28c920c4dfda$export$6681bda78b6b4cbd(source, {
            span: spans.pathname,
            type: 'pathname'
        }) : $460a28c920c4dfda$export$6681bda78b6b4cbd('', {
            span: [
                0,
                0
            ],
            type: 'pathname'
        }),
        search: spans.search ? $460a28c920c4dfda$var$parseSearch(source.slice(...spans.search)) : new Map()
    });
}
function $460a28c920c4dfda$export$6681bda78b6b4cbd(source, options) {
    let span = options.span ?? [
        0,
        source.length
    ];
    let separator = options.type === 'hostname' ? '.' : '/';
    let tokens = [];
    let optionals = new Map();
    let appendText = (text)=>{
        let currentToken = tokens.at(-1);
        if (currentToken?.type === 'text') currentToken.text += text;
        else tokens.push({
            type: 'text',
            text: text
        });
    };
    let i = span[0];
    let optionalStack = [];
    while(i < span[1]){
        let char = source[i];
        if (char === '(') {
            optionalStack.push(tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ')') {
            let begin = optionalStack.pop();
            if (begin === undefined) throw new $460a28c920c4dfda$export$f9c837a54db411d('unmatched )', source, i);
            optionals.set(begin, tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ':') {
            i += 1;
            let name = $460a28c920c4dfda$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            if (!name) throw new $460a28c920c4dfda$export$f9c837a54db411d('missing variable name', source, i - 1);
            tokens.push({
                type: ':',
                name: name
            });
            i += name.length;
            continue;
        }
        if (char === '*') {
            i += 1;
            let name = $460a28c920c4dfda$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            tokens.push({
                type: '*',
                name: name ?? '*'
            });
            i += name?.length ?? 0;
            continue;
        }
        if (char === separator) {
            tokens.push({
                type: 'separator'
            });
            i += 1;
            continue;
        }
        if (char === '\\') {
            if (i + 1 === span[1]) throw new $460a28c920c4dfda$export$f9c837a54db411d('dangling escape', source, i);
            let text = source.slice(i + 1, i + 2);
            appendText(text);
            i += 2;
            continue;
        }
        appendText(char);
        i += 1;
    }
    if (optionalStack.length > 0) throw new $460a28c920c4dfda$export$f9c837a54db411d('unmatched (', source, optionalStack.at(-1));
    return {
        tokens: tokens,
        optionals: optionals,
        type: options.type
    };
}
function $460a28c920c4dfda$var$parseProtocol(source, span) {
    if (!span) return null;
    let protocol = source.slice(...span);
    if (protocol === '' || protocol === 'http' || protocol === 'https' || protocol === 'http(s)') return protocol === '' ? null : protocol;
    throw new $460a28c920c4dfda$export$f9c837a54db411d('invalid protocol', source, span[0]);
}
function $460a28c920c4dfda$var$parseHostname(source, span) {
    if (!span) return null;
    let part = $460a28c920c4dfda$export$6681bda78b6b4cbd(source, {
        span: span,
        type: 'hostname'
    });
    if ($460a28c920c4dfda$var$isNamelessWildcard(part)) return null;
    return part;
}
function $460a28c920c4dfda$var$isNamelessWildcard(part) {
    if (part.tokens.length !== 1) return false;
    let token = part.tokens[0];
    if (token.type !== '*') return false;
    return token.name === '*';
}
function $460a28c920c4dfda$var$parseSearch(source) {
    let constraints = new Map();
    let searchParams = new URLSearchParams(source);
    for (let [key, value] of searchParams){
        let requiredValues = constraints.get(key);
        if (!requiredValues) {
            requiredValues = new Set();
            constraints.set(key, requiredValues);
        }
        if (value === '') continue;
        requiredValues.add(value);
    }
    return constraints;
}
class $460a28c920c4dfda$export$f9c837a54db411d extends Error {
    /** The parse failure category. */ type;
    /** Original pattern source being parsed. */ source;
    /** Character index where parsing failed. */ index;
    constructor(type, source, index){
        let underline = ' '.repeat(index) + '^';
        let message = `${type}\n\n${source}\n${underline}`;
        super(message);
        this.name = 'ParseError';
        this.type = type;
        this.source = source;
        this.index = index;
    }
}


/**
 * An internal error that should never happen.
 *
 * @param value Typed as `never` to ensure exhaustiveness for discriminated unions.
 */ function $153a5362d6eec09c$export$565e9d9bd6b6e0d4(value) {
    let message = value === undefined ? 'Unreachable' : `Unreachable: ${value}`;
    throw new Error(message);
}


function $5d9d1b69d16348c5$export$f54f830b0caf58b(pattern) {
    let protocol = $5d9d1b69d16348c5$export$f5782abab8870711(pattern);
    let hostname = $5d9d1b69d16348c5$export$191bef10f978d68f(pattern);
    let port = $5d9d1b69d16348c5$export$776a5d5828862b2f(pattern);
    let pathname = $5d9d1b69d16348c5$export$a2dfe5fa28b7cbe3(pattern);
    let search = $5d9d1b69d16348c5$export$3ba2b473bde2deb8(pattern);
    let result = '';
    if (protocol || hostname || port) result += `${protocol}://${hostname}${port === '' ? '' : `:${port}`}`;
    result += '/' + pathname;
    if (search) result += `?${search}`;
    return result;
}
function $5d9d1b69d16348c5$export$161f896add7aeb90(pattern) {
    return {
        protocol: $5d9d1b69d16348c5$export$f5782abab8870711(pattern),
        hostname: $5d9d1b69d16348c5$export$191bef10f978d68f(pattern),
        port: $5d9d1b69d16348c5$export$776a5d5828862b2f(pattern),
        pathname: $5d9d1b69d16348c5$export$a2dfe5fa28b7cbe3(pattern),
        search: $5d9d1b69d16348c5$export$3ba2b473bde2deb8(pattern)
    };
}
function $5d9d1b69d16348c5$export$f5782abab8870711(pattern) {
    return pattern.protocol ?? '';
}
function $5d9d1b69d16348c5$export$191bef10f978d68f(pattern) {
    return pattern.hostname ? $5d9d1b69d16348c5$export$4d98ccdba8645223(pattern.hostname) : '';
}
function $5d9d1b69d16348c5$export$776a5d5828862b2f(pattern) {
    return pattern.port ?? '';
}
function $5d9d1b69d16348c5$export$a2dfe5fa28b7cbe3(pattern) {
    return $5d9d1b69d16348c5$export$4d98ccdba8645223(pattern.pathname);
}
function $5d9d1b69d16348c5$export$3ba2b473bde2deb8(pattern) {
    if (pattern.search.size === 0) return '';
    let searchParams = new URLSearchParams();
    for (let [key, constraint] of pattern.search){
        if (constraint.size === 0) searchParams.append(key, '');
        else for (let value of constraint)searchParams.append(key, value);
    }
    return searchParams.toString();
}
function $5d9d1b69d16348c5$var$escapeText(text) {
    return text.replaceAll(/[:*()\\]/g, '\\$&');
}
function $5d9d1b69d16348c5$export$4d98ccdba8645223(part) {
    let separator = part.type === 'hostname' ? '.' : '/';
    let result = '';
    for (let token of part.tokens){
        if (token.type === '(' || token.type === ')') {
            result += token.type;
            continue;
        }
        if (token.type === 'text') {
            result += $5d9d1b69d16348c5$var$escapeText(token.text);
            continue;
        }
        if (token.type === ':' || token.type === '*') {
            let name = token.name === '*' ? '' : token.name;
            result += `${token.type}${name}`;
            continue;
        }
        if (token.type === 'separator') {
            result += separator;
            continue;
        }
        (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}


class $0d4f95eb196de161$export$2917961db0dd6e8b {
    protocol;
    hostname;
    port;
    pathname;
    search;
    /**
     * Create a new `RoutePattern` by parsing a source string.
     *
     * @param source The route pattern source string.
     * @returns The parsed route pattern.
     */ static parse(source) {
        return (0, $460a28c920c4dfda$export$e26190e3669abbfe)(source);
    }
    /**
     * Create a new `RoutePattern` from parsed parts of a route pattern.
     *
     * Useful for efficiently deriving new patterns from already parsed patterns.
     * Unless you know what you are doing, you probably want `RoutePattern.parse`.
     *
     * @param parsed Parsed route pattern parts.
     */ constructor(parsed){
        this.protocol = parsed.protocol;
        this.hostname = parsed.hostname;
        this.port = parsed.port;
        this.pathname = parsed.pathname;
        this.search = parsed.search;
    }
    /** Normalized string representation of this pattern */ get source() {
        return (0, $5d9d1b69d16348c5$export$f54f830b0caf58b)(this);
    }
    /**
     * Returns a string representing this route pattern.
     *
     * @returns The same normalized pattern string as `RoutePattern.source`.
     */ toString() {
        return this.source;
    }
    /**
     * Returns a JSON-serializable object containing each serialized part of this route pattern.
     *
     * @returns The serialized protocol, hostname, port, pathname, and search.
     */ toJSON() {
        return (0, $5d9d1b69d16348c5$export$161f896add7aeb90)(this);
    }
}



// Adapted from https://github.com/mathiasbynens/punycode.js/blob/9e1b2cda98d215d3a73fcbfe93c62e021f4ba768/punycode.js
/** Highest positive signed 32-bit float value */ const $99cf089510b52c01$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $99cf089510b52c01$var$base = 36;
const $99cf089510b52c01$var$tMin = 1;
const $99cf089510b52c01$var$tMax = 26;
const $99cf089510b52c01$var$skew = 38;
const $99cf089510b52c01$var$damp = 700;
const $99cf089510b52c01$var$initialBias = 72;
const $99cf089510b52c01$var$initialN = 128; // 0x80
const $99cf089510b52c01$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $99cf089510b52c01$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $99cf089510b52c01$var$errors = {
    overflow: 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
const $99cf089510b52c01$var$baseMinusTMin = $99cf089510b52c01$var$base - $99cf089510b52c01$var$tMin;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @param type The error type.
 */ function $99cf089510b52c01$var$error(type) {
    throw new RangeError($99cf089510b52c01$var$errors[type]);
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @param domain The domain name or email address.
 * @param callback The function that gets called for every character.
 * @returns A new string of characters returned by the callback function.
 */ function $99cf089510b52c01$var$mapDomain(domain, callback) {
    let parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    domain = domain.replace($99cf089510b52c01$var$regexSeparators, '.');
    let labels = domain.split('.');
    let encoded = labels.map(callback).join('.');
    return result + encoded;
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @param codePoint The basic numeric code point value.
 * @returns The numeric value of a basic code point in the range `0` to
 * `base - 1`, or `base` if the code point does not represent a value.
 */ function $99cf089510b52c01$var$basicToDigit(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3a) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5b) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7b) return codePoint - 0x61;
    return $99cf089510b52c01$var$base;
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @param delta The current delta.
 * @param numPoints The number of code points handled.
 * @param firstTime Whether this is the first adaptation.
 * @returns The adapted bias.
 */ function $99cf089510b52c01$var$adapt(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? Math.floor(delta / $99cf089510b52c01$var$damp) : delta >> 1;
    delta += Math.floor(delta / numPoints);
    for(; delta > $99cf089510b52c01$var$baseMinusTMin * $99cf089510b52c01$var$tMax >> 1; k += $99cf089510b52c01$var$base)delta = Math.floor(delta / $99cf089510b52c01$var$baseMinusTMin);
    return Math.floor(k + ($99cf089510b52c01$var$baseMinusTMin + 1) * delta / (delta + $99cf089510b52c01$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @param input The Punycode string of ASCII-only symbols.
 * @returns The resulting string of Unicode symbols.
 */ function $99cf089510b52c01$var$decode(input) {
    // Don't use UCS-2.
    let output = [];
    let inputLength = input.length;
    let i = 0;
    let n = $99cf089510b52c01$var$initialN;
    let bias = $99cf089510b52c01$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($99cf089510b52c01$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $99cf089510b52c01$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength /* no final expression */ ;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $99cf089510b52c01$var$base /* no condition */ ;; k += $99cf089510b52c01$var$base){
            if (index >= inputLength) $99cf089510b52c01$var$error('invalid-input');
            let digit = $99cf089510b52c01$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $99cf089510b52c01$var$base) $99cf089510b52c01$var$error('invalid-input');
            if (digit > Math.floor(($99cf089510b52c01$var$maxInt - i) / w)) $99cf089510b52c01$var$error('overflow');
            i += digit * w;
            let t = k <= bias ? $99cf089510b52c01$var$tMin : k >= bias + $99cf089510b52c01$var$tMax ? $99cf089510b52c01$var$tMax : k - bias;
            if (digit < t) break;
            let baseMinusT = $99cf089510b52c01$var$base - t;
            if (w > Math.floor($99cf089510b52c01$var$maxInt / baseMinusT)) $99cf089510b52c01$var$error('overflow');
            w *= baseMinusT;
        }
        let out = output.length + 1;
        bias = $99cf089510b52c01$var$adapt(i - oldi, out, oldi === 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (Math.floor(i / out) > $99cf089510b52c01$var$maxInt - n) $99cf089510b52c01$var$error('overflow');
        n += Math.floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
}
const $99cf089510b52c01$export$110c810e8727e62b = function(input) {
    // Optimization: skip if no punycode markers found
    if (!input.includes('xn--')) return input;
    return $99cf089510b52c01$var$mapDomain(input, function(string) {
        return string.startsWith('xn--') ? $99cf089510b52c01$var$decode(string.slice(4).toLowerCase()) : string;
    });
};





function $141bb69856e07f84$export$4e7f196112fea3c5(text) {
    return text.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}
function $141bb69856e07f84$export$238374f1b270e387(tokens, options) {
    let result = '';
    for (let token of tokens){
        if (token.type === 'text') {
            result += $141bb69856e07f84$export$4e7f196112fea3c5(token.text);
            continue;
        }
        if (token.type === ':') {
            result += `([^${options.separator}]+?)`;
            continue;
        }
        if (token.type === '*') {
            result += `(.*)`;
            continue;
        }
        if (token.type === '(') {
            result += '(?:';
            continue;
        }
        if (token.type === ')') {
            result += ')?';
            continue;
        }
        if (token.type === 'separator') {
            result += $141bb69856e07f84$export$4e7f196112fea3c5(options.separator);
            continue;
        }
        (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
    }
    let flags = 'd';
    if (options.ignoreCase) flags += 'i';
    return new RegExp(`^${result}$`, flags);
}



function $36c37f2dc102fab2$export$9ac16898ad61bc17(pattern) {
    let result = [];
    for (let protocol of $36c37f2dc102fab2$var$generateProtocolVariants(pattern.protocol)){
        let port = $36c37f2dc102fab2$var$normalizePort(protocol, pattern.port);
        for (let hostname of $36c37f2dc102fab2$var$generateHostnameVariants(pattern.hostname))for (let pathname of $36c37f2dc102fab2$var$generatePathnameVariants(pattern.pathname))result.push({
            protocol: protocol,
            hostname: hostname,
            port: port,
            pathname: pathname
        });
    }
    return result;
}
function $36c37f2dc102fab2$var$generateProtocolVariants(protocol) {
    if (protocol === null || protocol === 'http(s)') return [
        'http',
        'https'
    ];
    return [
        protocol
    ];
}
function $36c37f2dc102fab2$var$normalizePort(protocol, port) {
    if (port === null) return '';
    if (protocol === 'http' && port === '80') return '';
    if (protocol === 'https' && port === '443') return '';
    return port;
}
function $36c37f2dc102fab2$var$toParams(tokens) {
    let params = [];
    for (let token of tokens)if (token.type === ':' || token.type === '*') params.push(token);
    return params;
}
function $36c37f2dc102fab2$var$generateHostnameVariants(hostname) {
    let result = [];
    if (hostname === null) return [
        {
            type: 'any'
        }
    ];
    for (let variant of $36c37f2dc102fab2$export$57a1d23d0b7a46c(hostname)){
        let params = $36c37f2dc102fab2$var$toParams(variant);
        if (params.length > 0) result.push({
            type: 'dynamic',
            params: params,
            regexp: (0, $141bb69856e07f84$export$238374f1b270e387)(variant, {
                separator: '.',
                ignoreCase: false
            })
        });
        else result.push({
            type: 'static',
            value: $36c37f2dc102fab2$var$stringifyStatic(variant, '.')
        });
    }
    return result;
}
function $36c37f2dc102fab2$var$stringifyStatic(variant, separator) {
    let result = '';
    for (let token of variant){
        if (token.type === 'text') result += token.text;
        else if (token.type === 'separator') result += separator;
        else throw new Error(`expected static part variant, got token type '${token.type}'`);
    }
    return result;
}
function $36c37f2dc102fab2$var$generatePathnameVariants(pathname, options) {
    let result = [];
    let ignoreCase = options?.ignoreCase ?? false;
    for (let tokens of $36c37f2dc102fab2$export$57a1d23d0b7a46c(pathname)){
        let variant = [];
        let key = '';
        let reSource = '';
        let reFlags = ignoreCase ? 'di' : 'd';
        let type = 'static';
        let params = [];
        for (let token of tokens){
            if (token.type === 'separator') {
                if (type === 'static') {
                    variant.push({
                        type: 'static',
                        key: ignoreCase ? key.toLowerCase() : key
                    });
                    key = '';
                    reSource = '';
                    continue;
                }
                if (type === 'variable') {
                    variant.push({
                        type: 'variable',
                        key: key,
                        regexp: new RegExp(`^${reSource}$`, reFlags),
                        params: params
                    });
                    key = '';
                    reSource = '';
                    params = [];
                    type = 'static';
                    continue;
                }
                if (type === 'wildcard') {
                    key += '/';
                    reSource += (0, $141bb69856e07f84$export$4e7f196112fea3c5)('/');
                    continue;
                }
                (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(type);
            }
            if (token.type === 'text') {
                // Encode to comply with URL pathname normalization in trie matcher
                let text = encodeURIComponent(token.text);
                key += text;
                reSource += (0, $141bb69856e07f84$export$4e7f196112fea3c5)(text);
                continue;
            }
            if (token.type === ':') {
                key += '{:}';
                reSource += `([^/]+)`;
                params.push(token);
                if (type === 'static') type = 'variable';
                continue;
            }
            if (token.type === '*') {
                key += '{*}';
                reSource += `(.*)`;
                params.push(token);
                type = 'wildcard';
                continue;
            }
            (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
        }
        if (type === 'static') variant.push({
            type: 'static',
            key: ignoreCase ? key.toLowerCase() : key
        });
        if (type === 'variable' || type === 'wildcard') variant.push({
            type: type,
            key: key,
            regexp: new RegExp(`^${reSource}$`, reFlags),
            params: params
        });
        result.push(variant);
    }
    return result;
}
function $36c37f2dc102fab2$export$57a1d23d0b7a46c(part) {
    let result = [];
    let stack = [
        {
            index: 0,
            tokens: []
        }
    ];
    while(stack.length > 0){
        let { index: index, tokens: tokens } = stack.pop();
        if (index === part.tokens.length) {
            result.push(tokens);
            continue;
        }
        let token = part.tokens[index];
        if (token.type === '(') {
            stack.push({
                index: index + 1,
                tokens: tokens
            }, {
                index: part.optionals.get(index) + 1,
                tokens: tokens.slice()
            });
            continue;
        }
        if (token.type === ')') {
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        if (token.type === ':' || token.type === '*' || token.type === 'text' || token.type === 'separator') {
            tokens.push(token);
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}



class $60ae74f014ccd001$export$73571c50d0f2507e {
    ignoreCase;
    #root;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#root = {
            http: $60ae74f014ccd001$var$createHostnameNode(),
            https: $60ae74f014ccd001$var$createHostnameNode()
        };
    }
    insert(pattern, data) {
        for (let variant of (0, $36c37f2dc102fab2$export$9ac16898ad61bc17)(pattern)){
            let hostnameNode = this.#root[variant.protocol];
            let portNode;
            if (variant.hostname.type === 'any') portNode = hostnameNode.any;
            else if (variant.hostname.type === 'static') {
                let key = variant.hostname.value.toLowerCase();
                let existing = hostnameNode.static.get(key);
                if (existing === undefined) {
                    existing = new Map();
                    hostnameNode.static.set(key, existing);
                }
                portNode = existing;
            } else {
                portNode = new Map();
                hostnameNode.dynamic.push({
                    regexp: variant.hostname.regexp,
                    params: variant.hostname.params,
                    portNode: portNode
                });
            }
            let pathnameRoot = portNode.get(variant.port);
            if (pathnameRoot === undefined) {
                pathnameRoot = $60ae74f014ccd001$var$createPathnameNode();
                portNode.set(variant.port, pathnameRoot);
            }
            let pathnameNode = pathnameRoot;
            for (let segment of variant.pathname){
                if (segment.type === 'static') {
                    let key = this.ignoreCase ? segment.key.toLowerCase() : segment.key;
                    let next = pathnameNode.static.get(key);
                    if (next === undefined) {
                        next = $60ae74f014ccd001$var$createPathnameNode();
                        pathnameNode.static.set(key, next);
                    }
                    pathnameNode = next;
                    continue;
                }
                if (segment.type === 'variable') {
                    let next = pathnameNode.variable.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $60ae74f014ccd001$var$createPathnameNode()
                        };
                        pathnameNode.variable.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                if (segment.type === 'wildcard') {
                    let next = pathnameNode.wildcard.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $60ae74f014ccd001$var$createPathnameNode()
                        };
                        pathnameNode.wildcard.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)(segment);
            }
            let requiredParams = [];
            for (let segment of variant.pathname){
                if (segment.type === 'variable' || segment.type === 'wildcard') for (let param of segment.params)requiredParams.push(param);
            }
            let undefinedParams = [];
            for (let param of pattern.pathname.tokens){
                if (param.type !== ':' && param.type !== '*') continue;
                if (requiredParams.some((p)=>p.name === param.name)) continue;
                if (undefinedParams.some((p)=>p.name === param.name)) continue;
                undefinedParams.push(param);
            }
            pathnameNode.values.push({
                pattern: pattern,
                data: data,
                requiredParams: requiredParams,
                undefinedParams: undefinedParams
            });
        }
    }
    search(url) {
        let protocol = url.protocol.slice(0, -1);
        if (protocol !== 'http' && protocol !== 'https') return [];
        let hostnameNode = this.#root[protocol];
        let decodedHostname = (0, $99cf089510b52c01$export$110c810e8727e62b)(url.hostname);
        let origins = [];
        // any hostname (no port allowed -- empty-port key)
        let anyPathname = hostnameNode.any.get('');
        if (anyPathname) origins.push({
            hostnameMatch: [
                {
                    type: '*',
                    name: '*',
                    value: decodedHostname,
                    begin: 0,
                    end: decodedHostname.length
                }
            ],
            pathnameNode: anyPathname
        });
        // static hostname
        let staticPort = hostnameNode.static.get(decodedHostname.toLowerCase());
        if (staticPort) {
            let next = staticPort.get(url.port);
            if (next) origins.push({
                hostnameMatch: [],
                pathnameNode: next
            });
        }
        // dynamic hostnames
        for (let entry of hostnameNode.dynamic){
            let m = entry.regexp.exec(decodedHostname);
            if (!m) continue;
            let next = entry.portNode.get(url.port);
            if (!next) continue;
            let hostnameMatch = [];
            for(let i = 0; i < entry.params.length; i++){
                let param = entry.params[i];
                let span = m.indices?.[i + 1];
                if (span === undefined) continue;
                hostnameMatch.push({
                    type: param.type,
                    name: param.name,
                    value: m[i + 1],
                    begin: span[0],
                    end: span[1]
                });
            }
            origins.push({
                hostnameMatch: hostnameMatch,
                pathnameNode: next
            });
        }
        let results = [];
        let urlSegments = $60ae74f014ccd001$var$normalizePathname(url.pathname);
        if (urlSegments === null) return results;
        for (let origin of origins){
            let stack = [
                {
                    segmentIndex: 0,
                    pathnameNode: origin.pathnameNode,
                    charOffset: 0,
                    captures: []
                }
            ];
            while(stack.length > 0){
                let current = stack.pop();
                if (current.segmentIndex === urlSegments.length) {
                    for (let value of current.pathnameNode.values){
                        if (!$60ae74f014ccd001$var$matchSearch(url.searchParams, value.pattern.search)) continue;
                        let pathnameMatch = [];
                        for(let i = 0; i < value.requiredParams.length; i++){
                            let param = value.requiredParams[i];
                            let cap = current.captures[i];
                            pathnameMatch.push({
                                type: param.type,
                                name: param.name,
                                value: $60ae74f014ccd001$var$fastDecodeURIComponent(cap.value),
                                begin: cap.begin,
                                end: cap.end
                            });
                        }
                        let params = {};
                        for (let token of value.pattern.hostname?.tokens ?? [])if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let token of value.pattern.pathname.tokens)if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let p of origin.hostnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        for (let p of pathnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        results.push({
                            url: url,
                            pattern: value.pattern,
                            data: value.data,
                            params: params,
                            paramsMeta: {
                                hostname: origin.hostnameMatch,
                                pathname: pathnameMatch
                            }
                        });
                    }
                    continue;
                }
                let urlSegment = urlSegments[current.segmentIndex];
                let staticKey = this.ignoreCase ? urlSegment.toLowerCase() : urlSegment;
                let nextStatic = current.pathnameNode.static.get(staticKey);
                if (nextStatic) stack.push({
                    segmentIndex: current.segmentIndex + 1,
                    pathnameNode: nextStatic,
                    charOffset: current.charOffset + urlSegment.length + 1,
                    captures: current.captures
                });
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.variable.values()){
                    let m = regexp.exec(urlSegment);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) (0, $153a5362d6eec09c$export$565e9d9bd6b6e0d4)();
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: current.segmentIndex + 1,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + m.index + m[0].length + 1,
                        captures: captures
                    });
                }
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.wildcard.values()){
                    let remaining = urlSegments.slice(current.segmentIndex).join('/');
                    let m = regexp.exec(remaining);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) continue;
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: urlSegments.length,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + remaining.length,
                        captures: captures
                    });
                }
            }
        }
        return results;
    }
}
// Pathname codec ----------------------------------------------------------------------------------
// Pathname matching uses canonical percent-encoded text. URL pathnames are split on structural
// "/" before normalization so encoded slashes like "%2F" remain data within a segment instead of
// becoming separators. Pattern static text is encoded the same way when variants are generated.
function $60ae74f014ccd001$var$normalizePathname(pathname) {
    let segments = [];
    for (let segment of pathname.slice(1).split('/')){
        let normalized = $60ae74f014ccd001$var$normalizePathnameText(segment);
        if (normalized === null) return null;
        segments.push(normalized);
    }
    return segments;
}
function $60ae74f014ccd001$var$normalizePathnameText(text) {
    let decoded = $60ae74f014ccd001$var$safeDecodeURIComponent(text);
    return decoded === null ? null : encodeURIComponent(decoded);
}
function $60ae74f014ccd001$var$fastDecodeURIComponent(text) {
    return text.includes('%') ? decodeURIComponent(text) : text;
}
function $60ae74f014ccd001$var$safeDecodeURIComponent(text) {
    try {
        return $60ae74f014ccd001$var$fastDecodeURIComponent(text);
    } catch (error) {
        if (error instanceof URIError) return null;
        throw error;
    }
}
// Search ------------------------------------------------------------------------------------------
function $60ae74f014ccd001$var$matchSearch(params, constraints) {
    for (let [name, requiredValues] of constraints){
        if (requiredValues.size === 0) {
            if (!params.has(name)) return false;
            continue;
        }
        let values = params.getAll(name);
        for (let requiredValue of requiredValues){
            if (!values.includes(requiredValue)) return false;
        }
    }
    return true;
}
function $60ae74f014ccd001$var$createHostnameNode() {
    return {
        static: new Map(),
        dynamic: [],
        any: new Map()
    };
}
function $60ae74f014ccd001$var$createPathnameNode() {
    return {
        static: new Map(),
        variable: new Map(),
        wildcard: new Map(),
        values: []
    };
}



function $9fb36bacaef2a008$export$9b050841a3a1b328(a, b) {
    return $9fb36bacaef2a008$export$398604a469f7de9a(a, b) === -1;
}
function $9fb36bacaef2a008$export$f517ea36c68d4644(a, b) {
    return $9fb36bacaef2a008$export$398604a469f7de9a(a, b) === 1;
}
function $9fb36bacaef2a008$export$411ce8e5a71e3069(a, b) {
    return $9fb36bacaef2a008$export$398604a469f7de9a(a, b) === 0;
}
const $9fb36bacaef2a008$export$fcb633242ef15540 = (a, b)=>$9fb36bacaef2a008$export$398604a469f7de9a(a, b);
const $9fb36bacaef2a008$export$4fa3190a997c3d8f = (a, b)=>$9fb36bacaef2a008$export$398604a469f7de9a(a, b) * -1;
function $9fb36bacaef2a008$export$398604a469f7de9a(a, b) {
    if (a.url.href !== b.url.href) throw new Error(`Cannot compare matches for different URLs: ${a.url.href} vs ${b.url.href}`);
    let hostname = (0, $99cf089510b52c01$export$110c810e8727e62b)(a.url.hostname);
    let hostnameResult = $9fb36bacaef2a008$var$compareHostname(hostname, a.paramsMeta.hostname, b.paramsMeta.hostname);
    if (hostnameResult !== 0) return hostnameResult;
    let pathnameResult = $9fb36bacaef2a008$var$comparePathname(a.paramsMeta.pathname, b.paramsMeta.pathname);
    if (pathnameResult !== 0) return pathnameResult;
    let searchResult = $9fb36bacaef2a008$var$compareSearch(a.pattern.search, b.pattern.search);
    if (searchResult !== 0) return searchResult;
    return 0;
}
function $9fb36bacaef2a008$var$compareHostname(hostname, a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    // Encoding of hostname chars: 0 = static, 1 = variable (:), 2 = wildcard (*)
    // Note: `Int8Array` defaults to 0 for all indices not explicitly set.
    let aEncoding = new Int8Array(hostname.length);
    for (let range of a)aEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    let bEncoding = new Int8Array(hostname.length);
    for (let range of b)bEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    // Build segments right-to-left: desc order by begin
    let segments = [];
    let end = hostname.length;
    for(let i = hostname.length - 1; i >= 0; i--)if (hostname[i] === '.') {
        segments.push({
            begin: i + 1,
            end: end
        });
        end = i;
    }
    segments.push({
        begin: 0,
        end: end
    }); // leftmost segment
    for (let segment of segments)for(let j = segment.begin; j < segment.end; j++){
        if (aEncoding[j] < bEncoding[j]) return 1; // a is more specific
        if (aEncoding[j] > bEncoding[j]) return -1; // b is more specific
    }
    return 0;
}
function $9fb36bacaef2a008$var$comparePathname(a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    let i = 0;
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < a.length || bIndex < b.length){
        let aRange = a[aIndex];
        let bRange = b[bIndex];
        if (aRange === undefined) return 1; // a is fully static from here
        if (bRange === undefined) return -1; // b is fully static from here
        // Skip to the minimum begin of the two current ranges
        i = Math.min(aRange.begin, bRange.begin);
        if (i < aRange.begin) return 1; // a has static content at i
        if (i < bRange.begin) return -1; // b has static content at i
        if (aRange.type === ':' && bRange.type === '*') return 1; // a is more specific
        if (aRange.type === '*' && bRange.type === ':') return -1; // b is more specific
        let minEnd = Math.min(aRange.end, bRange.end);
        i = minEnd;
        // Advance range indices if we've reached their ends
        if (i >= aRange.end) aIndex += 1;
        if (i >= bRange.end) bIndex += 1;
    }
    return 0;
}
function $9fb36bacaef2a008$var$compareSearch(a, b) {
    let aSpecificity = $9fb36bacaef2a008$var$searchSpecificity(a);
    let bSpecificity = $9fb36bacaef2a008$var$searchSpecificity(b);
    if (aSpecificity.keyValue > bSpecificity.keyValue) return 1;
    if (aSpecificity.keyValue < bSpecificity.keyValue) return -1;
    if (aSpecificity.key > bSpecificity.key) return 1;
    if (aSpecificity.key < bSpecificity.key) return -1;
    return 0;
}
function $9fb36bacaef2a008$var$searchSpecificity(constraints) {
    let specificity = {
        key: 0,
        keyValue: 0
    };
    for (let constraint of constraints.values()){
        if (constraint.size === 0) {
            specificity.key += 1;
            continue;
        }
        specificity.keyValue += constraint.size;
    }
    return specificity;
}


function $5eb3501f92234bfb$export$1d94974cf1366deb(pattern, options) {
    pattern = typeof pattern === 'string' ? (0, $0d4f95eb196de161$export$2917961db0dd6e8b).parse(pattern) : pattern;
    let matcher = $5eb3501f92234bfb$export$cf760d085d57ec27(options);
    matcher.add(pattern, undefined);
    return {
        match (url) {
            return matcher.match(url);
        }
    };
}
function $5eb3501f92234bfb$export$cf760d085d57ec27(options) {
    return new $5eb3501f92234bfb$var$TrieMatcher(options);
}
class $5eb3501f92234bfb$var$TrieMatcher {
    ignoreCase;
    #trie;
    constructor(options){
        this.ignoreCase = options?.ignoreCase ?? false;
        this.#trie = new (0, $60ae74f014ccd001$export$73571c50d0f2507e)({
            ignoreCase: this.ignoreCase
        });
    }
    add(pattern, data) {
        pattern = typeof pattern === 'string' ? (0, $460a28c920c4dfda$export$e26190e3669abbfe)(pattern) : pattern;
        this.#trie.insert(pattern, data);
    }
    match(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let best = null;
        for (let match of this.#trie.search(parsedUrl))if (best === null || $9fb36bacaef2a008$export$f517ea36c68d4644(match, best)) best = match;
        return best;
    }
    matchAll(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let matches = [];
        for (let match of this.#trie.search(parsedUrl))matches.push(match);
        return matches.sort($9fb36bacaef2a008$export$4fa3190a997c3d8f);
    }
}







//#region lib/router/matcher-route-pattern.ts
var $6c7b288f30438a50$export$9f42f7e9b7c469cc = class {
    #state;
    #basename;
    constructor(basename){
        this.#basename = basename;
    }
    update(routes) {
        let branches = $6c7b288f30438a50$var$flattenRoutes(routes);
        let matcher = (0, $5eb3501f92234bfb$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        let partialMatcher = (0, $5eb3501f92234bfb$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        for (let branch of branches){
            let routePattern = $6c7b288f30438a50$var$convertReactRouterPathToRoutePattern(branch.path);
            $6c7b288f30438a50$var$validateRoutePatternSplat(branch.path, routePattern);
            routePattern = $6c7b288f30438a50$var$addOptionalTrailingSlash(routePattern);
            matcher.add(routePattern, branch);
            if (!branch.routesMeta[branch.routesMeta.length - 1].route.index) partialMatcher.add(routePattern === "/" ? `/*__rr_partial` : `${routePattern}(/*__rr_partial)`, branch);
        }
        this.#state = {
            branches: branches,
            matcher: matcher,
            partialMatcher: partialMatcher
        };
        return branches;
    }
    match(locationArg, allowPartial = false) {
        let pathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)((typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", this.#basename);
        if (pathname == null) return null;
        let decoded = (0, $edf931d6dcac43ec$export$cd27bea214d030c2)(pathname);
        let url = new URL("http://reactrouter.local");
        url.pathname = pathname.endsWith("/") ? pathname : `${pathname}/`;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(this.#state, "Route pattern routes must be initialized before matching.");
        let matches = this.#state.matcher.matchAll(url);
        if (allowPartial) matches.push(...this.#state.partialMatcher.matchAll(url));
        for (let match of $6c7b288f30438a50$var$prioritizeValidatedMatches(matches)){
            let routeMatches = $6c7b288f30438a50$var$convertRoutePatternMatchToRouteMatches(match, decoded, allowPartial);
            if (routeMatches && $6c7b288f30438a50$var$validateRouteMatchParams(routeMatches)) return routeMatches;
        }
        return null;
    }
};
function $6c7b288f30438a50$var$validateRoutePatternSplat(routePath, routePattern) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($6c7b288f30438a50$var$getRoutePatternSplatIndexes(routePattern).length <= 1 && $6c7b288f30438a50$var$isTerminalRoutePatternSplat(routePattern), `Route path "${routePath}" is not supported with \`future.unstable_routePatternMatching\` because React Router only supports a single splat at the end of a route path.`);
}
function $6c7b288f30438a50$var$getRoutePatternSplatIndexes(routePattern) {
    let splatIndexes = [];
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char === "*") splatIndexes.push(i);
    }
    return splatIndexes;
}
function $6c7b288f30438a50$var$isTerminalRoutePatternSplat(routePattern) {
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char !== "*") continue;
        let suffix = routePattern.slice(i + 1);
        return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(suffix) || suffix === "";
    }
    return true;
}
function $6c7b288f30438a50$var$addOptionalTrailingSlash(routePattern) {
    return routePattern === "/" ? routePattern : `${routePattern.replace(/\/+$/, "")}(/)`;
}
function $6c7b288f30438a50$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    routes.forEach((route, index)=>{
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.caseSensitive !== true, "`caseSensitive` routes are not supported with `future.unstable_routePatternMatching`.");
        let meta = {
            relativePath: route.path || "",
            caseSensitive: false,
            childrenIndex: index,
            route: route
        };
        let absolutePath;
        if (meta.relativePath.startsWith("/")) {
            absolutePath = meta.relativePath;
            let parentPathMatch = (0, $edf931d6dcac43ec$export$82472424e06ad5c9)(parentPath).find((path)=>meta.relativePath.startsWith(path));
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(parentPathMatch != null, `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPathMatch.length);
        }
        let routesMeta = parentsMeta.concat(meta);
        let path = absolutePath ?? (meta.relativePath ? (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            parentPath,
            meta.relativePath
        ]) : parentPath);
        if (route.children && route.children.length > 0) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $6c7b288f30438a50$var$flattenRoutes(route.children, branches, routesMeta, path);
            if (route.children?.some((child)=>child.index)) return;
        }
        if (route.path != null || route.index) branches.push({
            path: path,
            score: 0,
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $6c7b288f30438a50$var$convertReactRouterPathToRoutePattern(path) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) path = path.replace(/\*$/, "/*");
    path = path.replace(/^\/*/, "/");
    if (path === "") return "/";
    let segments = path.split("/");
    let pattern = segments.shift() || "";
    for(let i = 0; i < segments.length;){
        let optionalRun = [];
        while(i < segments.length && $6c7b288f30438a50$var$isOptionalRouteSegment(segments[i])){
            optionalRun.push($6c7b288f30438a50$var$convertRouteSegment(segments[i].slice(0, -1)));
            i++;
        }
        if (optionalRun.length > 0) {
            let nested = optionalRun.reduceRight((child, segment)=>`/${segment}${child ? `(${child})` : ""}`, "");
            pattern += `(${nested})`;
            continue;
        }
        pattern += `/${$6c7b288f30438a50$var$convertRouteSegment(segments[i])}`;
        i++;
    }
    return pattern || "/";
}
function $6c7b288f30438a50$var$isOptionalRouteSegment(segment) {
    return segment.endsWith("?");
}
function $6c7b288f30438a50$var$convertRouteSegment(segment) {
    if (segment === "*") return "*__rr_splat";
    let paramMatch = segment.match(/^:([\w-]+)(\?)?(.*)$/);
    if (paramMatch) {
        let [, paramName, optional, suffix] = paramMatch;
        let converted = `:${paramName}${$6c7b288f30438a50$var$escapeRoutePatternLiteral(suffix)}`;
        return optional ? `(:${paramName})${$6c7b288f30438a50$var$escapeRoutePatternLiteral(suffix)}` : converted;
    }
    return $6c7b288f30438a50$var$escapeRoutePatternLiteral(segment);
}
function $6c7b288f30438a50$var$escapeRoutePatternLiteral(value) {
    return value.replace(/[\\():*]/g, "\\$&");
}
function $6c7b288f30438a50$var$validateRouteMatchParams(matches) {
    return matches.every(({ route: route, params: params })=>route.unstable_validateParams == null || Object.keys(route.unstable_validateParams).length === 0 || Object.entries(route.unstable_validateParams).every(([param, re])=>params[param] != null ? new RegExp(re.source, re.flags).test(params[param]) : true));
}
function $6c7b288f30438a50$var$prioritizeValidatedMatches(matches) {
    return matches.sort((a, b)=>{
        let specificity = (0, $9fb36bacaef2a008$export$4fa3190a997c3d8f)(a, b);
        if (specificity !== 0) return specificity;
        return Number($6c7b288f30438a50$var$hasParamValidators(b)) - Number($6c7b288f30438a50$var$hasParamValidators(a));
    });
}
function $6c7b288f30438a50$var$hasParamValidators(match) {
    return match.data.routesMeta.some((meta)=>meta.route.unstable_validateParams != null && Object.keys(meta.route.unstable_validateParams).length > 0);
}
function $6c7b288f30438a50$var$convertRoutePatternMatchToRouteMatches(match, pathname, allowPartial) {
    let result = $6c7b288f30438a50$var$matchRoutePatternBranch(match.data, pathname, allowPartial, 0, "/", {});
    if (result == null) return null;
    for (let routeMatch of result.matches)routeMatch.params = result.params;
    return result.matches;
}
function $6c7b288f30438a50$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex, matchedPathname, matchedParams) {
    let meta = branch.routesMeta[metaIndex];
    let end = metaIndex === branch.routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    for (let relativePath of (0, $edf931d6dcac43ec$export$82472424e06ad5c9)(meta.relativePath)){
        let pattern = {
            path: relativePath,
            caseSensitive: false,
            end: end
        };
        let pathMatch = (0, $edf931d6dcac43ec$export$81336c211d5ff295)(pattern, remainingPathname);
        if (!pathMatch && end && allowPartial && !meta.route.index) pathMatch = (0, $edf931d6dcac43ec$export$81336c211d5ff295)({
            ...pattern,
            end: false
        }, remainingPathname);
        if (!pathMatch) continue;
        let params = {
            ...matchedParams,
            ...pathMatch.params
        };
        let routeMatch = {
            params: params,
            pathname: (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathname
            ]),
            pathnameBase: (0, $edf931d6dcac43ec$export$a5c6d149b50c1d86)((0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathnameBase
            ])),
            route: meta.route
        };
        let nextMatchedPathname = pathMatch.pathnameBase === "/" ? matchedPathname : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            matchedPathname,
            pathMatch.pathnameBase
        ]);
        if (end) return {
            matches: [
                routeMatch
            ],
            params: params
        };
        let childResult = $6c7b288f30438a50$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex + 1, nextMatchedPathname, params);
        if (childResult) return {
            matches: [
                routeMatch,
                ...childResult.matches
            ],
            params: childResult.params
        };
    }
    return null;
}


//#region lib/router/matcher-route-pattern.preload.ts
let $bb354d9dd1aa514b$var$RoutePatternMatcher;
function $bb354d9dd1aa514b$export$45cda2a841115322() {
    return $bb354d9dd1aa514b$var$RoutePatternMatcher;
}
/**
* Initialize the route-pattern matcher before creating a Data Router or static
* handler with `future.unstable_routePatternMatching` enabled. Import from
* `react-router/route-pattern` and call this once during application startup.
* Server and browser applications must each preload their own matcher.
*
* The matcher is statically imported by this module. Tree-shaking bundlers can
* remove it from applications that do not use this function. Initialization is
* synchronous, and repeated calls are safe.
*
* @public
* @category Data Routers
* @mode data
* @returns {void}
*/ function $bb354d9dd1aa514b$export$c6cb8c636109e21b() {
    $bb354d9dd1aa514b$var$RoutePatternMatcher = (0, $6c7b288f30438a50$export$9f42f7e9b7c469cc);
}



//#region lib/router/router.ts
const $27ddc9c887d48115$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $27ddc9c887d48115$var$validMutationMethods = new Set($27ddc9c887d48115$var$validMutationMethodsArr);
const $27ddc9c887d48115$var$validRequestMethodsArr = [
    "GET",
    ...$27ddc9c887d48115$var$validMutationMethodsArr
];
const $27ddc9c887d48115$var$validRequestMethods = new Set($27ddc9c887d48115$var$validRequestMethodsArr);
const $27ddc9c887d48115$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $27ddc9c887d48115$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $27ddc9c887d48115$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $27ddc9c887d48115$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $27ddc9c887d48115$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $27ddc9c887d48115$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $27ddc9c887d48115$export$5e64b3b9d7e2ec36(future, basename) {
    if (future.unstable_routePatternMatching) {
        let RoutePatternMatcher = (0, $bb354d9dd1aa514b$export$45cda2a841115322)();
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(RoutePatternMatcher, "You must call unstable_preloadRoutePattern() from \"react-router/route-pattern\" before enabling future.unstable_routePatternMatching.");
        return new RoutePatternMatcher(basename);
    }
    return new (0, $6069f2a71d2ba88b$export$92541312f2982378)(basename);
}
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $27ddc9c887d48115$var$DataRoutes = class {
    #routes;
    #hmrRoutes;
    #matcher;
    constructor(routes, matcher){
        this.#routes = routes;
        this.#matcher = matcher;
        this.#matcher.update(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        if (!this.#hmrRoutes) this.#matcher.update(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#matcher.update(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#hmrRoutes = void 0;
            this.#matcher.update(this.#routes);
        }
    }
};
/**
* Create a router and listen to history POP navigations
*/ function $27ddc9c887d48115$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $bb1de4858130979b$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let future = {
        ...init.future
    };
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataRouteMatcher = $27ddc9c887d48115$export$5e64b3b9d7e2ec36(future, basename);
    let manifest = {};
    let dataRoutes = new $27ddc9c887d48115$var$DataRoutes((0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest), dataRouteMatcher);
    let dataStrategyImpl = init.dataStrategy || $27ddc9c887d48115$var$defaultDataStrategyWithMiddleware;
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = dataRouteMatcher.match(init.history.location);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $27ddc9c887d48115$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $27ddc9c887d48115$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $27ddc9c887d48115$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$27ddc9c887d48115$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $27ddc9c887d48115$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $27ddc9c887d48115$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $27ddc9c887d48115$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $27ddc9c887d48115$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $27ddc9c887d48115$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $27ddc9c887d48115$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $bb1de4858130979b$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $27ddc9c887d48115$var$normalizeNavigateOptions(false, $27ddc9c887d48115$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $ee8fa670c1d03165$export$825a82322d91916e).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(typeof opts.mask === "string" ? opts.mask : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(opts.mask), (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $27ddc9c887d48115$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $27ddc9c887d48115$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : dataRouteMatcher.match(location);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $27ddc9c887d48115$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $27ddc9c887d48115$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $27ddc9c887d48115$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $27ddc9c887d48115$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $27ddc9c887d48115$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $27ddc9c887d48115$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($27ddc9c887d48115$var$isErrorResult(result) && (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $27ddc9c887d48115$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $27ddc9c887d48115$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $27ddc9c887d48115$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $27ddc9c887d48115$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $27ddc9c887d48115$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $27ddc9c887d48115$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $27ddc9c887d48115$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $27ddc9c887d48115$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $27ddc9c887d48115$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $27ddc9c887d48115$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$27ddc9c887d48115$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $27ddc9c887d48115$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $bb1de4858130979b$export$5579798e35f5560e)(router);
        let normalizedPath = $27ddc9c887d48115$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = dataRouteMatcher.match(normalizedPath);
        let fogOfWar = checkFogOfWar(matches, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($27ddc9c887d48115$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $27ddc9c887d48115$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        let loadMatch = {
            routeId: routeId,
            path: path,
            isDiscovering: fogOfWar.active
        };
        fetchLoadMatches.set(key, loadMatch);
        await handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $27ddc9c887d48115$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($27ddc9c887d48115$var$isRedirectResult(actionResult) || $27ddc9c887d48115$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($27ddc9c887d48115$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $27ddc9c887d48115$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($27ddc9c887d48115$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? dataRouteMatcher.match(state.navigation.location) : state.matches;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $27ddc9c887d48115$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $27ddc9c887d48115$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $27ddc9c887d48115$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $27ddc9c887d48115$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $27ddc9c887d48115$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $27ddc9c887d48115$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $27ddc9c887d48115$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission) {
        let { routeId: routeId, path: path } = loadMatch;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $27ddc9c887d48115$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(init.history, path, abortController.signal);
        if (loadMatch.isDiscovering) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $27ddc9c887d48115$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                loadMatch.isDiscovering = false;
            }
        }
        let match = $27ddc9c887d48115$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
            return;
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $27ddc9c887d48115$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $2ce80a7c58bedbaf$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $27ddc9c887d48115$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($27ddc9c887d48115$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $27ddc9c887d48115$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $27ddc9c887d48115$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$27ddc9c887d48115$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($27ddc9c887d48115$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $27ddc9c887d48115$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $27ddc9c887d48115$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $27ddc9c887d48115$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $27ddc9c887d48115$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $27ddc9c887d48115$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $27ddc9c887d48115$export$386d57f03f0b2883;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $27ddc9c887d48115$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $edf931d6dcac43ec$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = dataRouteMatcher.match(pathname);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = dataRouteMatcher.match(pathname, true);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = dataRouteMatcher.match(pathname, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        match (locationArg) {
            return dataRouteMatcher.match(locationArg);
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $bb1de4858130979b$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $27ddc9c887d48115$export$3336b097a6fbc59a(routes, opts) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    let dataRouteMatcher = $27ddc9c887d48115$export$5e64b3b9d7e2ec36({
        ...opts?.future
    }, basename);
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $bb1de4858130979b$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    dataRouteMatcher.update(dataRoutes);
    let match = (locationArg)=>dataRouteMatcher.match(locationArg);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $27ddc9c887d48115$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        if (!$27ddc9c887d48115$var$isValidMethod(method) && method !== "HEAD") {
            let error = $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $27ddc9c887d48115$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(requestContext instanceof (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $27ddc9c887d48115$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result,
                            _match: match
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($27ddc9c887d48115$export$6e80290866a84dd4(error)) return error;
                    if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(error.status, error.statusText, await $27ddc9c887d48115$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(error)) error = $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $27ddc9c887d48115$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $27ddc9c887d48115$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $27ddc9c887d48115$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {},
                            _match: match
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($27ddc9c887d48115$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result,
            _match: match
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $27ddc9c887d48115$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $2ce80a7c58bedbaf$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04)();
        if (!$27ddc9c887d48115$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $27ddc9c887d48115$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $27ddc9c887d48115$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $27ddc9c887d48115$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $27ddc9c887d48115$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(requestContext instanceof (0, $edf931d6dcac43ec$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $27ddc9c887d48115$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($27ddc9c887d48115$var$dataWithResponseInitToResponse(error));
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($27ddc9c887d48115$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $27ddc9c887d48115$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($27ddc9c887d48115$var$isDataStrategyResult(e) && $27ddc9c887d48115$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($27ddc9c887d48115$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $27ddc9c887d48115$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($27ddc9c887d48115$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($27ddc9c887d48115$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($27ddc9c887d48115$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($27ddc9c887d48115$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $27ddc9c887d48115$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $27ddc9c887d48115$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $edf931d6dcac43ec$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategy || $27ddc9c887d48115$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($27ddc9c887d48115$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result.result)) throw $27ddc9c887d48115$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        match: match,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $27ddc9c887d48115$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $27ddc9c887d48115$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $27ddc9c887d48115$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $27ddc9c887d48115$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $27ddc9c887d48115$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to ? to : ".", (0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(contextualMatches), (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $27ddc9c887d48115$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $edf931d6dcac43ec$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
}
function $27ddc9c887d48115$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$27ddc9c887d48115$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$27ddc9c887d48115$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $27ddc9c887d48115$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $27ddc9c887d48115$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $27ddc9c887d48115$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$27ddc9c887d48115$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$27ddc9c887d48115$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $27ddc9c887d48115$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $27ddc9c887d48115$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $27ddc9c887d48115$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $27ddc9c887d48115$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $edf931d6dcac43ec$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $27ddc9c887d48115$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($27ddc9c887d48115$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($27ddc9c887d48115$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $27ddc9c887d48115$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key) || f.isDiscovering) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = dataRouteMatcher.match(f.path);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $27ddc9c887d48115$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $27ddc9c887d48115$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($27ddc9c887d48115$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $27ddc9c887d48115$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$27ddc9c887d48115$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $27ddc9c887d48115$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $27ddc9c887d48115$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $27ddc9c887d48115$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $27ddc9c887d48115$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$27ddc9c887d48115$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $edf931d6dcac43ec$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $27ddc9c887d48115$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$27ddc9c887d48115$var$isSameRoute(aChild, bChild))) ?? false;
}
const $27ddc9c887d48115$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $27ddc9c887d48115$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $27ddc9c887d48115$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $27ddc9c887d48115$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $edf931d6dcac43ec$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $27ddc9c887d48115$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $27ddc9c887d48115$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $27ddc9c887d48115$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $edf931d6dcac43ec$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $27ddc9c887d48115$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $27ddc9c887d48115$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $27ddc9c887d48115$var$isNonNullable(value) {
    return value !== void 0;
}
function $27ddc9c887d48115$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $27ddc9c887d48115$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($27ddc9c887d48115$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $27ddc9c887d48115$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $27ddc9c887d48115$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $27ddc9c887d48115$var$defaultDataStrategy(args);
    return $27ddc9c887d48115$var$runClientMiddlewarePipeline(args, ()=>$27ddc9c887d48115$var$defaultDataStrategy(args));
}
function $27ddc9c887d48115$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, processResult, $27ddc9c887d48115$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $27ddc9c887d48115$export$e0163cfdf7bc9cfa(result) ? $27ddc9c887d48115$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $27ddc9c887d48115$var$runClientMiddlewarePipeline(args, handler) {
    return $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($27ddc9c887d48115$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $27ddc9c887d48115$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$27ddc9c887d48115$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $27ddc9c887d48115$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $27ddc9c887d48115$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $27ddc9c887d48115$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $27ddc9c887d48115$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $27ddc9c887d48115$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $27ddc9c887d48115$var$loadLazyRoute(match.route, $27ddc9c887d48115$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $27ddc9c887d48115$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $27ddc9c887d48115$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $27ddc9c887d48115$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$27ddc9c887d48115$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($27ddc9c887d48115$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $27ddc9c887d48115$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $27ddc9c887d48115$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $27ddc9c887d48115$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $27ddc9c887d48115$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $edf931d6dcac43ec$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $27ddc9c887d48115$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $27ddc9c887d48115$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $27ddc9c887d48115$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $27ddc9c887d48115$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $27ddc9c887d48115$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $27ddc9c887d48115$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $27ddc9c887d48115$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $27ddc9c887d48115$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($27ddc9c887d48115$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $27ddc9c887d48115$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $edf931d6dcac43ec$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($27ddc9c887d48115$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $27ddc9c887d48115$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $27ddc9c887d48115$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $27ddc9c887d48115$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $27ddc9c887d48115$export$961a3ef7a4da3a39(location) {
    try {
        return $27ddc9c887d48115$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $27ddc9c887d48115$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $edf931d6dcac43ec$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $ee8fa670c1d03165$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $ee8fa670c1d03165$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($27ddc9c887d48115$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $edf931d6dcac43ec$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($27ddc9c887d48115$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $27ddc9c887d48115$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($27ddc9c887d48115$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $27ddc9c887d48115$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $27ddc9c887d48115$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $27ddc9c887d48115$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $27ddc9c887d48115$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!$27ddc9c887d48115$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $27ddc9c887d48115$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $27ddc9c887d48115$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $27ddc9c887d48115$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($27ddc9c887d48115$var$isErrorResult(result)) {
            let boundaryMatch = $27ddc9c887d48115$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($27ddc9c887d48115$var$isRedirectResult(result)) (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $27ddc9c887d48115$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $27ddc9c887d48115$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $27ddc9c887d48115$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    let preservedCount = 0;
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) {
            mergedLoaderData[id] = loaderData[id];
            preservedCount++;
        }
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return Object.keys(newLoaderData).length === 0 && preservedCount === Object.keys(loaderData).length ? loaderData : mergedLoaderData;
}
function $27ddc9c887d48115$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $27ddc9c887d48115$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $27ddc9c887d48115$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $27ddc9c887d48115$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $27ddc9c887d48115$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $27ddc9c887d48115$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($27ddc9c887d48115$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $27ddc9c887d48115$var$stripHashFromPath(path) {
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $27ddc9c887d48115$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $27ddc9c887d48115$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $27ddc9c887d48115$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $27ddc9c887d48115$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $27ddc9c887d48115$var$isDataStrategyResult(value));
}
function $27ddc9c887d48115$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $27ddc9c887d48115$var$isRedirectDataStrategyResult(result) {
    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result.result) && $27ddc9c887d48115$var$redirectStatusCodes.has(result.result.status);
}
function $27ddc9c887d48115$var$isErrorResult(result) {
    return result.type === "error";
}
function $27ddc9c887d48115$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $27ddc9c887d48115$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $27ddc9c887d48115$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $27ddc9c887d48115$export$794b2760043cf8cd(statusCode) {
    return $27ddc9c887d48115$var$redirectStatusCodes.has(statusCode);
}
function $27ddc9c887d48115$export$6e80290866a84dd4(result) {
    return $27ddc9c887d48115$export$3f1eb41d9a6a6a27(result) && $27ddc9c887d48115$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $27ddc9c887d48115$var$isValidMethod(method) {
    return $27ddc9c887d48115$var$validRequestMethods.has(method.toUpperCase());
}
function $27ddc9c887d48115$export$cbae47800eb95bc3(method) {
    return $27ddc9c887d48115$var$validMutationMethods.has(method.toUpperCase());
}
function $27ddc9c887d48115$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $27ddc9c887d48115$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $27ddc9c887d48115$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $edf931d6dcac43ec$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $27ddc9c887d48115$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $edf931d6dcac43ec$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $edf931d6dcac43ec$export$d738435097971c09)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $27ddc9c887d48115$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $27ddc9c887d48115$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $27ddc9c887d48115$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $27ddc9c887d48115$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $27ddc9c887d48115$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $27ddc9c887d48115$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $27ddc9c887d48115$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $27ddc9c887d48115$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($27ddc9c887d48115$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $27ddc9c887d48115$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
//#region lib/context.ts
const $52882ad28a21bc0a$export$2eeee58951ff3c1c = $acw62.createContext(null);
$52882ad28a21bc0a$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $52882ad28a21bc0a$export$315e3ffb01f217 = $acw62.createContext(null);
$52882ad28a21bc0a$export$315e3ffb01f217.displayName = "DataRouterState";
const $52882ad28a21bc0a$export$19d7395466bdeac8 = $acw62.createContext(null);
$52882ad28a21bc0a$export$19d7395466bdeac8.displayName = "DataRouterData";
const $52882ad28a21bc0a$export$2473c5952c6a10d1 = $acw62.createContext(null);
$52882ad28a21bc0a$export$2473c5952c6a10d1.displayName = "DataRouterNavigation";
const $52882ad28a21bc0a$export$717f757c655223f1 = $acw62.createContext(false);
function $52882ad28a21bc0a$export$6e1eeb090b3ec35b() {
    return $acw62.useContext($52882ad28a21bc0a$export$717f757c655223f1);
}
const $52882ad28a21bc0a$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$52882ad28a21bc0a$export$3681f408decb40d1.displayName = "ViewTransition";
const $52882ad28a21bc0a$export$cb3f1df1bef00a39 = $acw62.createContext(null);
$52882ad28a21bc0a$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $52882ad28a21bc0a$export$804c460aade54ac8 = $acw62.createContext(null);
$52882ad28a21bc0a$export$804c460aade54ac8.displayName = "Await";
const $52882ad28a21bc0a$export$2666c20e15407622 = (props)=>$acw62.createElement($52882ad28a21bc0a$export$804c460aade54ac8.Provider, props);
const $52882ad28a21bc0a$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$52882ad28a21bc0a$export$3044ab7fdabeaee6.displayName = "Navigation";
const $52882ad28a21bc0a$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$52882ad28a21bc0a$export$e6a44b110a0c44d3.displayName = "Location";
const $52882ad28a21bc0a$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$52882ad28a21bc0a$export$aac280ed165a4397.displayName = "Route";
const $52882ad28a21bc0a$export$efd71bfc7ccfba1 = $acw62.createContext(false);
$52882ad28a21bc0a$export$efd71bfc7ccfba1.displayName = "IsDataRoute";
const $52882ad28a21bc0a$export$92d0be8f6ef5c7bf = $acw62.createContext(void 0);
$52882ad28a21bc0a$export$92d0be8f6ef5c7bf.displayName = "RouteId";
const $52882ad28a21bc0a$export$af8bd2647fea9c11 = $acw62.createContext(null);
$52882ad28a21bc0a$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $b9584a574d863128$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $b9584a574d863128$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $b9584a574d863128$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $b9584a574d863128$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$b9584a574d863128$var$ERROR_DIGEST_BASE}:${$b9584a574d863128$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $b9584a574d863128$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$b9584a574d863128$var$ERROR_DIGEST_BASE}:${$b9584a574d863128$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $acw62 = parcelRequire("acw62");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $baf2581b6f4e4c0a$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $baf2581b6f4e4c0a$export$9c954a9d03d32f4a() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $baf2581b6f4e4c0a$export$45d76561a5302f2b() {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $baf2581b6f4e4c0a$export$1b3f31771c5d07c() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $baf2581b6f4e4c0a$export$6c330e8992e8a295(pattern) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$81336c211d5ff295)(pattern, (0, $edf931d6dcac43ec$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $baf2581b6f4e4c0a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $baf2581b6f4e4c0a$export$9770f232ac06a008() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$efd71bfc7ccfba1)) ? $baf2581b6f4e4c0a$var$useNavigateStable() : $baf2581b6f4e4c0a$var$useNavigateUnstable();
}
function $baf2581b6f4e4c0a$var$useNavigateUnstable() {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $acw62.useRef(false);
    $acw62.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $acw62.useCallback((to, options = {})=>{
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(activeRef.current, $baf2581b6f4e4c0a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $7ab28948be9dda45$export$1da545bc000055cf)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $baf2581b6f4e4c0a$var$OutletContext = $acw62.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $baf2581b6f4e4c0a$export$4138103a3ae699cc() {
    return $acw62.useContext($baf2581b6f4e4c0a$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $baf2581b6f4e4c0a$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397)).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches));
    return $acw62.useMemo(()=>(0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $baf2581b6f4e4c0a$export$5d3fca4a98652595(routes, locationArg) {
    return $baf2581b6f4e4c0a$export$f7ce0646a48561fb(routes, locationArg);
}
function $baf2581b6f4e4c0a$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)($baf2581b6f4e4c0a$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $baf2581b6f4e4c0a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches;
    if (dataRouterOpts) {
        if (dataRouterOpts.state.matches.length) matches = dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
                route: dataRouterOpts.manifest[m.route.id] || m.route
            }));
        else matches = dataRouterOpts.router.match(dataRouterOpts.state.location);
    } else matches = (0, $edf931d6dcac43ec$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $baf2581b6f4e4c0a$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $baf2581b6f4e4c0a$var$DefaultErrorComponent() {
    let error = $baf2581b6f4e4c0a$export$ed527bf60f6e05f2();
    let message = (0, $edf931d6dcac43ec$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $baf2581b6f4e4c0a$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$DefaultErrorComponent, null);
var $baf2581b6f4e4c0a$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $52882ad28a21bc0a$export$717f757c655223f1);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $b9584a574d863128$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$efd71bfc7ccfba1).Provider, {
            value: this.props.routeContext.isDataRoute
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$92d0be8f6ef5c7bf).Provider, {
            value: this.props.routeContext.matches[this.props.routeContext.matches.length - 1]?.route.id
        }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })))) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $baf2581b6f4e4c0a$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $baf2581b6f4e4c0a$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $b9584a574d863128$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $baf2581b6f4e4c0a$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $edf931d6dcac43ec$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(redirect.location, target, (0, $7ab28948be9dda45$export$1da545bc000055cf)(navigator), "allow-explicit");
            if ((0, $27ddc9c887d48115$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $edf931d6dcac43ec$export$4e09c449d6c407f7) && !$baf2581b6f4e4c0a$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $baf2581b6f4e4c0a$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $baf2581b6f4e4c0a$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$efd71bfc7ccfba1).Provider, {
        value: routeContext.isDataRoute
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$92d0be8f6ef5c7bf).Provider, {
        value: match.route.id
    }, children)));
}
function $baf2581b6f4e4c0a$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $baf2581b6f4e4c0a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $baf2581b6f4e4c0a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($baf2581b6f4e4c0a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $baf2581b6f4e4c0a$export$ae09415e57d46628(hookName) {
    let ctx = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(ctx, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $baf2581b6f4e4c0a$export$f93124018767f269(hookName) {
    let state = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(state, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return state;
}
function $baf2581b6f4e4c0a$export$c6e4e4d7047d4ffe(hookName) {
    let fetchers = $acw62.useContext((0, $52882ad28a21bc0a$export$cb3f1df1bef00a39));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(fetchers, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return fetchers;
}
function $baf2581b6f4e4c0a$export$798168c290ba5b3d(hookName) {
    let data = $acw62.useContext((0, $52882ad28a21bc0a$export$19d7395466bdeac8));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(data, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return data;
}
function $baf2581b6f4e4c0a$var$useDataRouterNavigation(hookName) {
    let navigation = $acw62.useContext((0, $52882ad28a21bc0a$export$2473c5952c6a10d1));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(navigation, $baf2581b6f4e4c0a$var$getDataRouterConsoleError(hookName));
    return navigation;
}
function $baf2581b6f4e4c0a$export$501a3f562d56eac6(hookName) {
    let routeId = $acw62.useContext((0, $52882ad28a21bc0a$export$92d0be8f6ef5c7bf));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeId, `${hookName} can only be used on routes that contain a unique "id"`);
    return routeId;
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $baf2581b6f4e4c0a$export$d0fd4b7106de2769() {
    let { navigation: navigation } = $baf2581b6f4e4c0a$var$useDataRouterNavigation("useNavigation");
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = navigation;
        return rest;
    }, [
        navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $baf2581b6f4e4c0a$export$600dc272ed516c15() {
    let dataRouterContext = $baf2581b6f4e4c0a$export$ae09415e57d46628("useRevalidator");
    let { revalidation: revalidation } = $baf2581b6f4e4c0a$var$useDataRouterNavigation("useRevalidator");
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: revalidation
        }), [
        revalidate,
        revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $baf2581b6f4e4c0a$export$2378eb7f5ff86053() {
    let { matches: matches } = $baf2581b6f4e4c0a$export$f93124018767f269("useMatches");
    let { loaderData: loaderData } = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useMatches");
    return $acw62.useMemo(()=>matches.map((m)=>(0, $edf931d6dcac43ec$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $baf2581b6f4e4c0a$export$1448a5050d252c4d() {
    let data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useLoaderData");
    let routeId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useLoaderData");
    return data.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $baf2581b6f4e4c0a$export$fd5d37484eab868d(routeId) {
    return $baf2581b6f4e4c0a$export$798168c290ba5b3d("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $baf2581b6f4e4c0a$export$fdc00f3f26066d5e() {
    let data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useActionData");
    let routeId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useActionData");
    return data.actionData ? data.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $baf2581b6f4e4c0a$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext((0, $52882ad28a21bc0a$export$af8bd2647fea9c11));
    let data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useRouteError");
    let routeId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useRouteError");
    if (error !== void 0) return error;
    return data.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $baf2581b6f4e4c0a$export$78a72ddb39bdd145() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$804c460aade54ac8))?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $baf2581b6f4e4c0a$export$17f53340677d5831() {
    return $acw62.useContext((0, $52882ad28a21bc0a$export$804c460aade54ac8))?._error;
}
let $baf2581b6f4e4c0a$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $baf2581b6f4e4c0a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $baf2581b6f4e4c0a$export$ae09415e57d46628("useBlocker");
    let state = $baf2581b6f4e4c0a$export$f93124018767f269("useBlocker");
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$baf2581b6f4e4c0a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $27ddc9c887d48115$export$386d57f03f0b2883);
}
function $baf2581b6f4e4c0a$var$useNavigateStable() {
    let { router: router } = $baf2581b6f4e4c0a$export$ae09415e57d46628("useNavigate");
    let id = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useNavigate");
    let activeRef = $acw62.useRef(false);
    $acw62.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $acw62.useCallback(async (to, options = {})=>{
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(activeRef.current, $baf2581b6f4e4c0a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $baf2581b6f4e4c0a$var$alreadyWarned = {};
function $baf2581b6f4e4c0a$var$warningOnce(key, cond, message) {
    if (!cond && !$baf2581b6f4e4c0a$var$alreadyWarned[key]) {
        $baf2581b6f4e4c0a$var$alreadyWarned[key] = true;
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, message);
    }
}
function $baf2581b6f4e4c0a$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $baf2581b6f4e4c0a$export$501a3f562d56eac6("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $baf2581b6f4e4c0a$export$f93124018767f269("useRoute");
    const data = $baf2581b6f4e4c0a$export$798168c290ba5b3d("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: data.loaderData[id],
        actionData: data.actionData?.[id]
    };
}
function $baf2581b6f4e4c0a$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $baf2581b6f4e4c0a$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches } = $baf2581b6f4e4c0a$export$f93124018767f269("unstable_useRouterState");
    let { navigation: navigation } = $baf2581b6f4e4c0a$var$useDataRouterNavigation("unstable_useRouterState");
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$baf2581b6f4e4c0a$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$baf2581b6f4e4c0a$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $9cdee517b2ac63e9$var$alreadyWarned = {};
function $9cdee517b2ac63e9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$9cdee517b2ac63e9$var$alreadyWarned[message]) {
        $9cdee517b2ac63e9$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $acw62 = parcelRequire("acw62");
//#region lib/components.tsx
const $1b6caee6a6f10651$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $1b6caee6a6f10651$export$f30f7e456d254e83(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $1b6caee6a6f10651$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $1b6caee6a6f10651$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = (0, $acw62.useOptimistic)(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$1b6caee6a6f10651$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1b6caee6a6f10651$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$1b6caee6a6f10651$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    let dataRouterState = $acw62.useMemo(()=>({
            historyAction: state.historyAction,
            location: state.location,
            matches: state.matches,
            initialized: state.initialized,
            renderFallback: state.renderFallback,
            restoreScrollPosition: state.restoreScrollPosition,
            preventScrollReset: state.preventScrollReset,
            blockers: state.blockers
        }), [
        state.historyAction,
        state.location,
        state.matches,
        state.initialized,
        state.renderFallback,
        state.restoreScrollPosition,
        state.preventScrollReset,
        state.blockers
    ]);
    let dataRouterNavigation = $acw62.useMemo(()=>({
            navigation: state.navigation,
            revalidation: state.revalidation
        }), [
        state.navigation,
        state.revalidation
    ]);
    let dataRouterData = $acw62.useMemo(()=>({
            loaderData: state.loaderData,
            actionData: state.actionData,
            errors: state.errors
        }), [
        state.loaderData,
        state.actionData,
        state.errors
    ]);
    let fetchersContext = $acw62.useMemo(()=>({
            fetchers: state.fetchers,
            fetcherData: fetcherData.current
        }), [
        state.fetchers
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$315e3ffb01f217).Provider, {
        value: dataRouterState
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$2473c5952c6a10d1).Provider, {
        value: dataRouterNavigation
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$19d7395466bdeac8).Provider, {
        value: dataRouterData
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$cb3f1df1bef00a39).Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        state: state,
        isStatic: false,
        onError: onError
    })))))))), null);
}
function $1b6caee6a6f10651$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $1b6caee6a6f10651$var$MemoizedDataRoutes = $acw62.memo($1b6caee6a6f10651$export$699f06c8afb533c9);
function $1b6caee6a6f10651$export$699f06c8afb533c9({ routes: routes, manifest: manifest, state: state, isStatic: isStatic, onError: onError }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(dataRouterContext, "You must render this element inside a <DataRouterContext.Provider> element");
    return (0, $baf2581b6f4e4c0a$export$f7ce0646a48561fb)(routes, void 0, {
        router: dataRouterContext.router,
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $1b6caee6a6f10651$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $1b6caee6a6f10651$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)((0, $baf2581b6f4e4c0a$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    let path = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(to, (0, $edf931d6dcac43ec$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    (0, $7ab28948be9dda45$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $7ab28948be9dda45$export$1da545bc000055cf)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $1b6caee6a6f10651$export$910ae8079b2c2852(props) {
    return (0, $baf2581b6f4e4c0a$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $1b6caee6a6f10651$export$e7b0ac011bb776c6(props) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $1b6caee6a6f10651$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!(0, $baf2581b6f4e4c0a$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2ce80a7c58bedbaf$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $1b6caee6a6f10651$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $baf2581b6f4e4c0a$export$5d3fca4a98652595)($1b6caee6a6f10651$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $1b6caee6a6f10651$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext((0, $52882ad28a21bc0a$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $acw62.useContext((0, $52882ad28a21bc0a$export$315e3ffb01f217));
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $edf931d6dcac43ec$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($1b6caee6a6f10651$var$ResolveAwait, null, children));
}
var $1b6caee6a6f10651$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $acw62.createElement((0, $52882ad28a21bc0a$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $1b6caee6a6f10651$var$ResolveAwait({ children: children }) {
    let data = (0, $baf2581b6f4e4c0a$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $1b6caee6a6f10651$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $1b6caee6a6f10651$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(element.type === $1b6caee6a6f10651$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $1b6caee6a6f10651$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $1b6caee6a6f10651$export$9b5b6d122dea0c88 = $1b6caee6a6f10651$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $1b6caee6a6f10651$export$daf73786167a7f72(matches) {
    return (0, $baf2581b6f4e4c0a$export$569816e95a012c39)(matches);
}
function $1b6caee6a6f10651$var$useRouteComponentProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)(),
        matches: (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)()
    };
}
function $1b6caee6a6f10651$export$6c4f3826290c37af({ children: children }) {
    const props = $1b6caee6a6f10651$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $1b6caee6a6f10651$var$useRouteComponentProps();
        return $acw62.createElement(Component, props);
    };
}
function $1b6caee6a6f10651$var$useHydrateFallbackProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)()
    };
}
function $1b6caee6a6f10651$export$f8cff34f39c1932a({ children: children }) {
    const props = $1b6caee6a6f10651$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $1b6caee6a6f10651$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $1b6caee6a6f10651$var$useErrorBoundaryProps() {
    return {
        params: (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $baf2581b6f4e4c0a$export$1448a5050d252c4d)(),
        actionData: (0, $baf2581b6f4e4c0a$export$fdc00f3f26066d5e)(),
        error: (0, $baf2581b6f4e4c0a$export$ed527bf60f6e05f2)()
    };
}
function $1b6caee6a6f10651$export$e5afde5c4b6d747b({ children: children }) {
    const props = $1b6caee6a6f10651$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $1b6caee6a6f10651$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $1b6caee6a6f10651$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}


//#region lib/dom-export/dom-router-provider.tsx
function $1faf284ef8693bcb$export$323e4fc2fa4753fb(props) {
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$323e4fc2fa4753fb), {
        flushSync: $1u0KT.flushSync,
        ...props
    });
}



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 






/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $89bbb3f5cea75f10$var$defaultEncType = "application/x-www-form-urlencoded";
function $89bbb3f5cea75f10$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $89bbb3f5cea75f10$var$isButtonElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $89bbb3f5cea75f10$var$isFormElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $89bbb3f5cea75f10$var$isInputElement(object) {
    return $89bbb3f5cea75f10$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $89bbb3f5cea75f10$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $89bbb3f5cea75f10$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$89bbb3f5cea75f10$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $89bbb3f5cea75f10$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = null;
function $89bbb3f5cea75f10$var$isFormDataSubmitterSupported() {
    if ($89bbb3f5cea75f10$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = false;
    } catch  {
        $89bbb3f5cea75f10$var$_formDataSupportsSubmitter = true;
    }
    return $89bbb3f5cea75f10$var$_formDataSupportsSubmitter;
}
const $89bbb3f5cea75f10$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $89bbb3f5cea75f10$var$getFormEncType(encType) {
    if (encType != null && !$89bbb3f5cea75f10$var$supportedFormEncTypes.has(encType)) {
        (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$89bbb3f5cea75f10$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $89bbb3f5cea75f10$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($89bbb3f5cea75f10$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $89bbb3f5cea75f10$var$getFormEncType(target.getAttribute("enctype")) || $89bbb3f5cea75f10$var$defaultEncType;
        formData = new FormData(target);
    } else if ($89bbb3f5cea75f10$var$isButtonElement(target) || $89bbb3f5cea75f10$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $89bbb3f5cea75f10$var$getFormEncType(target.getAttribute("formenctype")) || $89bbb3f5cea75f10$var$getFormEncType(form.getAttribute("enctype")) || $89bbb3f5cea75f10$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$89bbb3f5cea75f10$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($89bbb3f5cea75f10$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $89bbb3f5cea75f10$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $c6f8fc82db0f6244$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $c6f8fc82db0f6244$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $c6f8fc82db0f6244$export$4cf11838cdc2a8a8(html) {
    return html.replace($c6f8fc82db0f6244$var$ESCAPE_REGEX, (match)=>$c6f8fc82db0f6244$var$ESCAPE_LOOKUP[match]);
}
function $c6f8fc82db0f6244$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $f6e8c7ac4ab8992c$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $b7db53197255e154$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $b7db53197255e154$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $b7db53197255e154$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $bb47af95f14cb967$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $bb47af95f14cb967$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $bb47af95f14cb967$export$442b9e023f41af00(matches, manifest));
}
function $bb47af95f14cb967$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $bb47af95f14cb967$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $bb47af95f14cb967$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($bb47af95f14cb967$var$prefetchStyleLink));
}
async function $bb47af95f14cb967$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$bb47af95f14cb967$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$bb47af95f14cb967$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$bb47af95f14cb967$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($bb47af95f14cb967$var$prefetchStyleLink));
}
async function $bb47af95f14cb967$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $bb47af95f14cb967$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $bb47af95f14cb967$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $bb47af95f14cb967$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $bb47af95f14cb967$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $b7db53197255e154$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($bb47af95f14cb967$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $bb47af95f14cb967$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $bb47af95f14cb967$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $bb47af95f14cb967$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $bb47af95f14cb967$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $bb47af95f14cb967$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $bb47af95f14cb967$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$bb47af95f14cb967$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($bb47af95f14cb967$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $bb47af95f14cb967$var$_isPreloadSupported;
function $bb47af95f14cb967$var$isPreloadSupported() {
    if ($bb47af95f14cb967$var$_isPreloadSupported !== void 0) return $bb47af95f14cb967$var$_isPreloadSupported;
    let el = document.createElement("link");
    $bb47af95f14cb967$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $bb47af95f14cb967$var$_isPreloadSupported;
}



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $bb1d86855daf76fc$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $bb1d86855daf76fc$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $fe0f2fac6e7ce220$var$TIME_LIMIT_MS = 1;
const $fe0f2fac6e7ce220$var$getNow = ()=>Date.now();
const $fe0f2fac6e7ce220$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $fe0f2fac6e7ce220$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $fe0f2fac6e7ce220$var$stringify.call(this, stack);
    return index;
}
async function $fe0f2fac6e7ce220$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $fe0f2fac6e7ce220$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $fe0f2fac6e7ce220$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $fe0f2fac6e7ce220$var$TIME_LIMIT_MS) {
            await $fe0f2fac6e7ce220$var$yieldToMain();
            lastYieldTime = $fe0f2fac6e7ce220$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($fe0f2fac6e7ce220$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $fe0f2fac6e7ce220$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fe0f2fac6e7ce220$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fe0f2fac6e7ce220$var$objectProtoNames;
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $f0a2a611d7bf4aef$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $f0a2a611d7bf4aef$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $f0a2a611d7bf4aef$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $f0a2a611d7bf4aef$var$hydrate.call(this, startIndex);
}
function $f0a2a611d7bf4aef$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $bb1d86855daf76fc$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $f0a2a611d7bf4aef$var$globalObj && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(errorType) && errorType in $f0a2a611d7bf4aef$var$globalObj && typeof $f0a2a611d7bf4aef$var$globalObj[errorType] === "function" ? new $f0a2a611d7bf4aef$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $7dbb8f88df69b2a1$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $bb1d86855daf76fc$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $bb1d86855daf76fc$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $7dbb8f88df69b2a1$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $7dbb8f88df69b2a1$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $7dbb8f88df69b2a1$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, line)
    };
}
async function $7dbb8f88df69b2a1$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $f0a2a611d7bf4aef$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $7dbb8f88df69b2a1$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $fe0f2fac6e7ce220$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $0f7c5b1be99998e3$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/single-fetch.tsx
const $45db1c6124c1e415$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $45db1c6124c1e415$var$SingleFetchNoResultError = class extends Error {
};
const $45db1c6124c1e415$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $45db1c6124c1e415$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($45db1c6124c1e415$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $45db1c6124c1e415$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $45db1c6124c1e415$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $45db1c6124c1e415$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $45db1c6124c1e415$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $45db1c6124c1e415$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $45db1c6124c1e415$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $45db1c6124c1e415$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $45db1c6124c1e415$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $45db1c6124c1e415$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $27ddc9c887d48115$export$3f1eb41d9a6a6a27)(result.result) || (0, $edf931d6dcac43ec$export$972111febbeef05b)(result.result) || (0, $27ddc9c887d48115$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $edf931d6dcac43ec$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $45db1c6124c1e415$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map(async (m)=>{
        let routeId = m.route.id;
        results[routeId] = await m.resolve(async (handler)=>{
            let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return hasClientLoader ? handler(async ()=>{
                let { data: data } = await fetchAndDecode(args, [
                    routeId
                ]);
                return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
            }) : handler();
        });
    }));
    return results;
}
async function $45db1c6124c1e415$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$45db1c6124c1e415$var$createDeferred());
    let singleFetchDfd = $45db1c6124c1e415$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $45db1c6124c1e415$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $45db1c6124c1e415$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $45db1c6124c1e415$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $45db1c6124c1e415$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $45db1c6124c1e415$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $45db1c6124c1e415$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $45db1c6124c1e415$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $45db1c6124c1e415$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $45db1c6124c1e415$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $45db1c6124c1e415$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $45db1c6124c1e415$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $0f7c5b1be99998e3$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($45db1c6124c1e415$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $45db1c6124c1e415$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($45db1c6124c1e415$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$45db1c6124c1e415$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch (cause) {
        throw new Error("Unable to decode turbo-stream response", {
            cause: cause
        });
    }
}
function $45db1c6124c1e415$export$4023ad4ecd4126a2(body, global) {
    return (0, $7dbb8f88df69b2a1$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$45db1c6124c1e415$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $45db1c6124c1e415$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $edf931d6dcac43ec$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $45db1c6124c1e415$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $45db1c6124c1e415$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/errorBoundaries.tsx
var $75aa75cf49dc6413$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $75aa75cf49dc6413$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $edf931d6dcac43ec$export$972111febbeef05b)(error)) return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($75aa75cf49dc6413$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $75aa75cf49dc6413$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement((0, $baf242efa2d54ba7$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/fallback.tsx
function $a7f36f18f4887f62$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $baf242efa2d54ba7$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $acw62.createElement((0, $75aa75cf49dc6413$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/routes.tsx
function $aa520e004fa2ab60$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $a7f36f18f4887f62$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement((0, $75aa75cf49dc6413$export$20b33acd14692c9), {
            error: (0, $baf2581b6f4e4c0a$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $aa520e004fa2ab60$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $aa520e004fa2ab60$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $aa520e004fa2ab60$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $aa520e004fa2ab60$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $aa520e004fa2ab60$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $aa520e004fa2ab60$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $bb47af95f14cb967$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$aa520e004fa2ab60$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $aa520e004fa2ab60$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $aa520e004fa2ab60$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $aa520e004fa2ab60$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $aa520e004fa2ab60$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $aa520e004fa2ab60$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $aa520e004fa2ab60$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $aa520e004fa2ab60$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $aa520e004fa2ab60$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $aa520e004fa2ab60$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $edf931d6dcac43ec$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $aa520e004fa2ab60$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $aa520e004fa2ab60$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $b7db53197255e154$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $bb47af95f14cb967$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $bb47af95f14cb967$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $aa520e004fa2ab60$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $aa520e004fa2ab60$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/fog-of-war.ts
const $a41fcd44fe4543d6$var$nextPaths = /* @__PURE__ */ new Set();
const $a41fcd44fe4543d6$var$discoveredPathsMaxSize = 1e3;
const $a41fcd44fe4543d6$var$discoveredPaths = /* @__PURE__ */ new Set();
const $a41fcd44fe4543d6$export$b5915cf27fa06b9f = 7680;
function $a41fcd44fe4543d6$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $a41fcd44fe4543d6$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = router.match(path);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $a41fcd44fe4543d6$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($a41fcd44fe4543d6$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $a41fcd44fe4543d6$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$a41fcd44fe4543d6$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$a41fcd44fe4543d6$var$discoveredPaths.has(pathname)) $a41fcd44fe4543d6$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($a41fcd44fe4543d6$var$nextPaths.keys()).filter((path)=>{
                if ($a41fcd44fe4543d6$var$discoveredPaths.has(path)) {
                    $a41fcd44fe4543d6$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $a41fcd44fe4543d6$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $a41fcd44fe4543d6$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
const $a41fcd44fe4543d6$var$MANIFEST_RELOAD_TIMEOUT = 5e3;
let $a41fcd44fe4543d6$var$pendingManifestReload;
async function $a41fcd44fe4543d6$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if ($a41fcd44fe4543d6$var$pendingManifestReload) return $a41fcd44fe4543d6$var$pendingManifestReload;
    if (!needsReload) {
        try {
            sessionStorage.removeItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    let alreadyReloaded = false;
    try {
        alreadyReloaded = sessionStorage.getItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY) === version;
        if (!alreadyReloaded) sessionStorage.setItem($a41fcd44fe4543d6$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    if (alreadyReloaded) throw new Error("Unable to discover routes due to manifest version mismatch.");
    let rejectReload;
    let reloadPromise = new Promise((_, reject)=>{
        rejectReload = reject;
    });
    $a41fcd44fe4543d6$var$pendingManifestReload = reloadPromise;
    let failReload = ()=>{
        clearTimeout(timeout);
        window.removeEventListener("pageshow", onPageShow);
        $a41fcd44fe4543d6$var$pendingManifestReload = void 0;
        rejectReload(/* @__PURE__ */ new Error("Unable to discover routes due to manifest version mismatch."));
    };
    let timeout = setTimeout(failReload, $a41fcd44fe4543d6$var$MANIFEST_RELOAD_TIMEOUT);
    let onPageShow = (event)=>{
        if (event.persisted) failReload();
    };
    window.addEventListener("pageshow", onPageShow);
    try {
        window.location.href = errorReloadPath;
        console.warn("Detected manifest version mismatch, reloading...");
    } catch  {
        failReload();
    }
    return reloadPromise;
}
async function $a41fcd44fe4543d6$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $a41fcd44fe4543d6$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($a41fcd44fe4543d6$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $a41fcd44fe4543d6$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $a41fcd44fe4543d6$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$a41fcd44fe4543d6$var$addToFifoQueue(p, $a41fcd44fe4543d6$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $aa520e004fa2ab60$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $a41fcd44fe4543d6$var$addToFifoQueue(path, queue) {
    if (queue.size >= $a41fcd44fe4543d6$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $a41fcd44fe4543d6$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/ssr/components.tsx
const $baf242efa2d54ba7$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$baf242efa2d54ba7$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $baf242efa2d54ba7$export$17134ff624fc6bc2() {
    let context = $acw62.useContext($baf242efa2d54ba7$export$208d6a3bc3aa62bd);
    (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $baf242efa2d54ba7$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($baf242efa2d54ba7$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $baf242efa2d54ba7$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $baf242efa2d54ba7$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $baf242efa2d54ba7$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $baf242efa2d54ba7$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $baf242efa2d54ba7$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $baf242efa2d54ba7$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $baf242efa2d54ba7$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$baf242efa2d54ba7$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $baf242efa2d54ba7$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $baf242efa2d54ba7$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("Links");
    let { errors: errors } = (0, $baf2581b6f4e4c0a$export$798168c290ba5b3d)("Links");
    let matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$baf242efa2d54ba7$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$baf242efa2d54ba7$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $bb47af95f14cb967$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $baf242efa2d54ba7$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("PrefetchPageLinks");
    let matches = $acw62.useMemo(()=>router.match(page), [
        router,
        router.routes,
        page
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($baf242efa2d54ba7$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $baf242efa2d54ba7$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        (0, $bb47af95f14cb967$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $baf242efa2d54ba7$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $45db1c6124c1e415$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $baf242efa2d54ba7$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { matches: matches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("PrefetchPageLinks");
    let { loaderData: loaderData } = (0, $baf2581b6f4e4c0a$export$798168c290ba5b3d)("PrefetchPageLinks");
    let newMatchesForData = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $45db1c6124c1e415$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>(0, $bb47af95f14cb967$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $baf242efa2d54ba7$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $baf242efa2d54ba7$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("Meta");
    let { errors: errors, loaderData: loaderData } = (0, $baf2581b6f4e4c0a$export$798168c290ba5b3d)("Meta");
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let _matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$baf242efa2d54ba7$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $baf242efa2d54ba7$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $baf242efa2d54ba7$var$isHydrated = false;
function $baf242efa2d54ba7$export$3be068dde909e563() {
    $baf242efa2d54ba7$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $baf242efa2d54ba7$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $baf242efa2d54ba7$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("Scripts");
    let { matches: routerMatches } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("Scripts");
    let isRSCRouterContext = (0, $52882ad28a21bc0a$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $a41fcd44fe4543d6$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $baf242efa2d54ba7$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $baf242efa2d54ba7$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $f6e8c7ac4ab8992c$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $a41fcd44fe4543d6$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $baf242efa2d54ba7$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $bb47af95f14cb967$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $9cdee517b2ac63e9$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $baf242efa2d54ba7$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $baf242efa2d54ba7$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $acw62 = parcelRequire("acw62");
//#region lib/dom/lib.tsx
const $5cec2af50e95548c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5cec2af50e95548c$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5cec2af50e95548c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5cec2af50e95548c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5cec2af50e95548c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $27ddc9c887d48115$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $2ce80a7c58bedbaf$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5cec2af50e95548c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $edf931d6dcac43ec$export$6bc17138063be773),
        hydrationRouteProperties: $1b6caee6a6f10651$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5cec2af50e95548c$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5cec2af50e95548c$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5cec2af50e95548c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $edf931d6dcac43ec$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $edf931d6dcac43ec$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $5cec2af50e95548c$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $5cec2af50e95548c$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $acw62.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $2ce80a7c58bedbaf$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $5cec2af50e95548c$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $1b6caee6a6f10651$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$5cec2af50e95548c$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $5cec2af50e95548c$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $edf931d6dcac43ec$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $baf2581b6f4e4c0a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $edf931d6dcac43ec$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $baf242efa2d54ba7$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $5cec2af50e95548c$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $baf242efa2d54ba7$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement((0, $baf242efa2d54ba7$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$5cec2af50e95548c$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $5cec2af50e95548c$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let routerNavigation = $acw62.useContext((0, $52882ad28a21bc0a$export$2473c5952c6a10d1));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let isTransitioning = routerNavigation != null && $5cec2af50e95548c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerNavigation?.navigation.location ? routerNavigation.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($5cec2af50e95548c$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5cec2af50e95548c$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $5cec2af50e95548c$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let submit = $5cec2af50e95548c$export$47c85c6e3a081d3();
    let formAction = $5cec2af50e95548c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $ee8fa670c1d03165$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5cec2af50e95548c$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $5cec2af50e95548c$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext((0, $baf242efa2d54ba7$export$208d6a3bc3aa62bd));
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let matches = (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)();
    $5cec2af50e95548c$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $c6f8fc82db0f6244$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$5cec2af50e95548c$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $5cec2af50e95548c$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ((0, $89bbb3f5cea75f10$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(location) === (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $5cec2af50e95548c$export$f1a78c17382fe22a(defaultInit) {
    (0, $2ce80a7c58bedbaf$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $acw62.useRef((0, $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>(0, $89bbb3f5cea75f10$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    return [
        searchParams,
        $acw62.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $89bbb3f5cea75f10$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $5cec2af50e95548c$var$fetcherId = 0;
let $5cec2af50e95548c$var$getUniqueFetcherId = ()=>`__${String(++$5cec2af50e95548c$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $5cec2af50e95548c$export$47c85c6e3a081d3() {
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useSubmit");
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $baf2581b6f4e4c0a$export$501a3f562d56eac6)("useSubmit");
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $89bbb3f5cea75f10$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $5cec2af50e95548c$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $5cec2af50e95548c$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let routeContext = $acw62.useContext((0, $52882ad28a21bc0a$export$aac280ed165a4397));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $edf931d6dcac43ec$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $2ce80a7c58bedbaf$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $5cec2af50e95548c$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useFetcher");
    let fetchersContext = (0, $baf2581b6f4e4c0a$export$c6e4e4d7047d4ffe)("useFetcher");
    let routeId = (0, $baf2581b6f4e4c0a$export$501a3f562d56eac6)("useFetcher");
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5cec2af50e95548c$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($5cec2af50e95548c$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = fetchersContext.fetchers.get(fetcherKey) || (0, $27ddc9c887d48115$export$52eace9c284d3585);
    let data = fetchersContext.fetcherData.get(fetcherKey);
    return $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $5cec2af50e95548c$export$fa996778a3a31087() {
    let { fetchers: fetchers } = (0, $baf2581b6f4e4c0a$export$c6e4e4d7047d4ffe)("useFetchers");
    return $acw62.useMemo(()=>Array.from(fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        fetchers
    ]);
}
const $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $5cec2af50e95548c$var$savedScrollPositions = {};
function $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $5cec2af50e95548c$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = (0, $baf2581b6f4e4c0a$export$f93124018767f269)("useScrollRestoration");
    let { basename: basename } = $acw62.useContext((0, $52882ad28a21bc0a$export$3044ab7fdabeaee6));
    let location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    let matches = (0, $baf2581b6f4e4c0a$export$2378eb7f5ff86053)();
    let navigation = (0, $baf2581b6f4e4c0a$export$d0fd4b7106de2769)();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5cec2af50e95548c$var$usePageShow($acw62.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $5cec2af50e95548c$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5cec2af50e95548c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5cec2af50e95548c$var$savedScrollPositions));
        } catch (error) {
            (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5cec2af50e95548c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5cec2af50e95548c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5cec2af50e95548c$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$5cec2af50e95548c$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $2ce80a7c58bedbaf$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $5cec2af50e95548c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5cec2af50e95548c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5cec2af50e95548c$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $5cec2af50e95548c$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $baf2581b6f4e4c0a$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $5cec2af50e95548c$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext((0, $52882ad28a21bc0a$export$3681f408decb40d1));
    (0, $2ce80a7c58bedbaf$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = (0, $baf2581b6f4e4c0a$export$ae09415e57d46628)("useViewTransitionState");
    let path = (0, $baf2581b6f4e4c0a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $edf931d6dcac43ec$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $edf931d6dcac43ec$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $edf931d6dcac43ec$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $5e79fd8d87f78889$export$129aff4b527bc0eb = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $5e79fd8d87f78889$export$4dda1981a34a6aa4({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5e79fd8d87f78889$export$129aff4b527bc0eb.Provider, {
        value: value,
        children: children
    });
}


const $7c5a3dd94b85a123$export$72f8d6ff1467b5f4 = (Component, diConfig)=>// eslint-disable-next-line react/display-name
    (props)=>{
        const diContainer = (0, $acw62.useContext)((0, $5e79fd8d87f78889$export$129aff4b527bc0eb));
        if (diContainer == null) throw new Error("DIContainerContext not provided");
        const dependencyInjectionProps = Object.entries(diConfig).reduce((acc, [propName, dependencyName])=>{
            const dependency = diContainer[dependencyName];
            return {
                ...acc,
                [propName]: dependency
            };
        }, {});
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ...dependencyInjectionProps
        });
    };




var $5sKyw = parcelRequire("5sKyw");

var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");


function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}


function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $702e4d306615a028$var$extendStatics = function(d, b) {
    $702e4d306615a028$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $702e4d306615a028$var$extendStatics(d, b);
};
function $702e4d306615a028$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $702e4d306615a028$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $702e4d306615a028$export$18ce0697a983be9b = function() {
    $702e4d306615a028$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702e4d306615a028$export$18ce0697a983be9b.apply(this, arguments);
};
function $702e4d306615a028$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $702e4d306615a028$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $702e4d306615a028$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $702e4d306615a028$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $702e4d306615a028$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $702e4d306615a028$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $702e4d306615a028$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $702e4d306615a028$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $702e4d306615a028$export$45d3717a4c69092e(o, m, p);
}
function $702e4d306615a028$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $702e4d306615a028$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $702e4d306615a028$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($702e4d306615a028$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $702e4d306615a028$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $702e4d306615a028$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $702e4d306615a028$export$10c90e4f7922046c(v) {
    return this instanceof $702e4d306615a028$export$10c90e4f7922046c ? (this.v = v, this) : new $702e4d306615a028$export$10c90e4f7922046c(v);
}
function $702e4d306615a028$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $702e4d306615a028$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $702e4d306615a028$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $702e4d306615a028$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $702e4d306615a028$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $702e4d306615a028$export$19a8beecd37a4c45 === "function" ? $702e4d306615a028$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $702e4d306615a028$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $702e4d306615a028$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $702e4d306615a028$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $702e4d306615a028$export$45d3717a4c69092e(result, mod, k);
    }
    $702e4d306615a028$var$__setModuleDefault(result, mod);
    return result;
}
function $702e4d306615a028$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $702e4d306615a028$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $702e4d306615a028$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $702e4d306615a028$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}






function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $702e4d306615a028$export$1216008129fb82ed)((0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(errors)), (0, $702e4d306615a028$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};


function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}





var $acw62 = parcelRequire("acw62");
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}




function $6fb8b1c12553edae$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $6fb8b1c12553edae$var$defaultCompare;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $6fb8b1c12553edae$var$defaultCompare(a, b) {
    return a === b;
}


const $52d6aae768cd1bf0$export$7bc289ae93a0a81d = (context, initialState, createWorkflow)=>{
    const [_workflow] = (0, $acw62.useState)(createWorkflow(initialState, context));
    const [_state, setState] = (0, $acw62.useState)(initialState);
    const dispatch = (action)=>_workflow.emit(action);
    (0, $acw62.useEffect)(()=>{
        const subscription = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscription.add(_workflow.states.pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)((previous, current)=>JSON.stringify(previous) === JSON.stringify(current))).subscribe(setState));
        var next;
        return ()=>{
            subscription.unsubscribe();
        };
    }, []);
    return [
        _state,
        dispatch,
        _workflow
    ];
};



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}




var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();



function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $702e4d306615a028$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $702e4d306615a028$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $702e4d306615a028$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $702e4d306615a028$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $702e4d306615a028$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}



function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}



function $195e3b3043565ec4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, scheduler);
}


/* eslint @typescript-eslint/no-explicit-any: "off" */ /**
 * NOTE(cvu): COPIED FROM @banking DASHBOARD. DO NOT EDIT
 */ 
var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

function $854df3a4a165b4ff$export$6003a5f097c73977(pred, thisArg) {
    return function(value, index) {
        return !pred.call(thisArg, value, index);
    };
}




function $98681b222841709d$export$b29f828819edca8d(source, predicate, thisArg) {
    return [
        (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(predicate, thisArg)((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source)),
        (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((0, $854df3a4a165b4ff$export$6003a5f097c73977)(predicate, thisArg))((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source))
    ];
}





var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);





function $b910c27483c6e6a0$export$3dede90624df3ba9(selector) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(selector(err, $b910c27483c6e6a0$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});






function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $8c2c9c105ebfd25b$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8c2c9c105ebfd25b$var$defaultErrorFactory;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $8c2c9c105ebfd25b$var$defaultErrorFactory() {
    return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
}



function $b9a90ca4d933af63$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655), (0, $e53e80f9042754be$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8c2c9c105ebfd25b$export$c8ea5e9f84346833)(function() {
            return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
        }));
    };
}



function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}


var $95de7a7c38006759$export$5b8affa63fc6df16 = (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9);



function $949f1fd33ffd44b7$export$8f9d79d42bff1aac() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}






function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}


function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $4707859e785b3da6$export$18aef43295bbe906)(1);
}




function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $3a4e37c3b56570cb$export$b314777ae20abca9)()((0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, (0, $3b29c258456d9a89$export$29534b2f653ae592)(args)));
}




function $b52129d9072c7912$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(values);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}








function $ada720f14bd5f844$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(inputs);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(inputs[i]).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $7569c528cdd9d182$export$f0954fd7d5368655))) && (hasValue = null);
                }
            }, (0, $528e75db69787807$export$8793edee2d425525)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (ready) {
                var values = (0, $702e4d306615a028$export$1216008129fb82ed)([
                    value
                ], (0, $702e4d306615a028$export$8d051b38c9118094)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(values))) : values);
            }
        }));
    });
}


var $f244369e42336676$export$cc7e12c76513e857 = /*#__PURE__*/ function(Command) {
    Command["Done"] = "SECRET_KEY__DO_NOT__USE__OR_WE_WILL_ADD_MORE_UNDERSCORES/DONE";
    return Command;
}({});
const $f244369e42336676$export$26128561c93f5847 = (value)=>value != null;
const $f244369e42336676$var$isCommand = (value)=>value === "SECRET_KEY__DO_NOT__USE__OR_WE_WILL_ADD_MORE_UNDERSCORES/DONE";
// NOTE(steckel): We previously utilized `instance of Promise` for this
// use-case but that does not work well where Promise-polyfill libraries must
// seamlessly integrate.
const $f244369e42336676$var$isPromiseLike = (value)=>typeof value?.then === "function";
const $f244369e42336676$export$a7a096f65990e390 = (nextAction)=>{
    const observableAction = (()=>{
        if (nextAction instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return nextAction;
        else if ($f244369e42336676$var$isPromiseLike(nextAction)) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(nextAction);
        else if (nextAction !== null) return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(nextAction);
        else return (0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)();
    })();
    return observableAction.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)($f244369e42336676$export$26128561c93f5847));
};
const $f244369e42336676$var$update = (updater, seed)=>(source)=>new (0, $4f562137a990678a$export$77cea355fa80b5f4)((subscriber)=>{
            let state = seed;
            const next = (action)=>{
                try {
                    const update = updater(state, action);
                    state = update[0];
                    subscriber.next(update);
                } catch (err) {
                    subscriber.error(err);
                }
            };
            const error = (err)=>{
                subscriber.error(err);
            };
            const subscription = source.subscribe({
                next: next,
                error: error
            });
            return ()=>subscription.unsubscribe();
        });
const $f244369e42336676$var$workflow = (updater, seed)=>{
    // Public states subject. This will be exposed publically as a hot
    // observable for workflow state.
    const publicStates = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    // Public side-effect subject. This will be exposed publically as a hot
    // observable for workflow side-effects.
    const publicUpdates = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    const internalActions = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    const [commands, actions] = (0, $98681b222841709d$export$b29f828819edca8d)(internalActions, (val)=>$f244369e42336676$var$isCommand(val));
    // Handle Command.DONE
    commands.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)((command)=>command === "SECRET_KEY__DO_NOT__USE__OR_WE_WILL_ADD_MORE_UNDERSCORES/DONE"), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)())).subscribe(()=>publicStates.complete());
    // This observable receives actions and invokes the updater function
    const actionHandler = actions.pipe($f244369e42336676$var$update(updater, seed), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([state, nextActionFactory])=>[
            state,
            $f244369e42336676$export$a7a096f65990e390(nextActionFactory?.() ?? null)
        ]), // We need this observable to be hot so that the update function does not
    // receive duplicate invocations for a particular action
    (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
    // This observable powers our public states observable
    const states = actionHandler.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(([state, _])=>state), // immediately send the initial state into the observable
    // (aids with updates initial value)
    (0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(seed));
    // This observable powers our public updates/side-effect observable
    const updates = states.pipe(// select previous and next state
    (0, $949f1fd33ffd44b7$export$8f9d79d42bff1aac)(), (0, $ada720f14bd5f844$export$d449030e5c10edf7)(actions), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([states, action])=>[
            states,
            action
        ]), // swallow errors from upstream and end the observable gracefully
    (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)()));
    // Subscribe to our internal observables to push values into our public
    // subjects
    updates.subscribe({
        next: (value)=>publicUpdates.next(value)
    });
    states.subscribe({
        next: (value)=>publicStates.next(value),
        error: (err)=>publicStates.error(err)
    });
    // This observable extracts any next actions from the result of calling the
    // updater function
    actionHandler.pipe(// swallow errors from upstream and end the observable gracefully;
    // do not continue with more actions
    (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)()), // flat map the next actions observable upward for subscription
    (0, $95de7a7c38006759$export$5b8affa63fc6df16)(([_, actions])=>actions)).subscribe({
        // forward actions to original actions subject for processing
        next: (action)=>internalActions.next(action),
        // forward errors to original actions subject to publish error within
        // the public states observable
        error: (err)=>internalActions.error(err)
    });
    // TODO(steckel): Consider transforming states with `.pipe(distinctUntilChanged)`
    return {
        emit: (action)=>internalActions.next(action),
        states: publicStates.asObservable().pipe((0, $0cd9b6b86141760f$export$ed80d9de1d9df928)()),
        updates: publicUpdates.asObservable().pipe((0, $0cd9b6b86141760f$export$ed80d9de1d9df928)())
    };
};
var $f244369e42336676$export$2e2bcd8739ae039 = $f244369e42336676$var$workflow;









// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/models/checking/onboarding/card-customization.ts
// TODO(cvu): eventually import this from dashboard via bazel
var $8ac095e22cd80964$export$c1bd96fb305c59e8 = /*#__PURE__*/ function(SignatureFont) {
    SignatureFont["AlexBrush"] = "Alex Brush";
    SignatureFont["Allura"] = "Allura";
    SignatureFont["AmaticSC"] = "Amatic SC";
    SignatureFont["AnnieUseYourTelescope"] = "Annie Use Your Telescope";
    SignatureFont["DancingScript"] = "Dancing Script";
    SignatureFont["GreatVibes"] = "Great Vibes";
    SignatureFont["IndieFlower"] = "Indie Flower";
    SignatureFont["Kristi"] = "Kristi";
    SignatureFont["LaBelleAurore"] = "La Belle Aurore";
    SignatureFont["MeieScript"] = "Meie Script";
    SignatureFont["MrsSaintDelafield"] = "Mrs Saint Delafield";
    SignatureFont["NanumPenScript"] = "Nanum Pen Script";
    SignatureFont["OvertheRainbow"] = "Over the Rainbow";
    SignatureFont["Qwigley"] = "Qwigley";
    SignatureFont["ReenieBeanie"] = "Reenie Beanie";
    SignatureFont["SueEllenFrancisco"] = "Sue Ellen Francisco";
    return SignatureFont;
}({});
const $8ac095e22cd80964$export$970f1491a494c331 = Object.values($8ac095e22cd80964$export$c1bd96fb305c59e8);


// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/utils/string.ts
// TODO(cvu): eventually import this from dashboard via bazel
// Regular expression initially extracted from lodash. Treat with skepticism.
const $488d76279e935265$var$EMOJI_PATTERN = // eslint-disable-next-line no-misleading-character-class
/[\u2700-\u27BF]|(?:\uD83C[\uDDE6-\uDDFF]){2}|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u0023-\u0039]\uFE0F?\u20E3|\u3299|\u3297|\u303D|\u3030|\u24C2|\uD83C[\uDD70\uDD71]|\uD83C[\uDD7E\uDD7F]|\uD83C\uDD8E|\uD83C[\uDD91-\uDD9A]|\uD83C[\uDDE6-\uDDFF]|[\uD83C\uDE01\uDE02]|\uD83C\uDE1A|\uD83C\uDE2F|[\uD83C\uDE32-\uDE3A]|[\uD83C\uDE50\uDE51]|\u203C|\u2049|[\u25AA\u25AB]|\u25B6|\u25C0|[\u25FB-\u25FE]|\u00A9|\u00AE|\u2122|\u2139|\uD83C\uDC04|[\u2600-\u26FF]|\u2B05|\u2B06|\u2B07|\u2B1B|\u2B1C|\u2B50|\u2B55|\u231A|\u231B|\u2328|\u23CF|[\u23E9-\u23F3]|[\u23F8-\u23FA]|\uD83C\uDCCF|\u2934|\u2935|[\u2190-\u21FF]|\uFE0F|\u200D/g;
function $488d76279e935265$export$9efee81811214072(input) {
    return `${input}`.replace($488d76279e935265$var$EMOJI_PATTERN, "");
}
function $488d76279e935265$export$537947b51dead775(input) {
    return input.match($488d76279e935265$var$EMOJI_PATTERN) !== null;
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/utils/text-renderer.ts
// TODO(cvu): eventually import this from dashboard via bazel

const $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_WIDTH = 1062;
const $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_HEIGHT = 354;
const $74c7b72a71b76868$var$SIGNATURE_PADDING = 4;
const $74c7b72a71b76868$export$9a1b8f2a422bb03a = {
    width: $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_WIDTH,
    height: $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_HEIGHT
};
function $74c7b72a71b76868$export$cb8806e8acc557d7(fontSize, fontFamily) {
    return `${fontSize}px ${fontFamily}`;
}
function $74c7b72a71b76868$export$2344b14b097df817(a, b) {
    return a.height >= b.height && a.width >= b.width;
}
function $74c7b72a71b76868$export$ec1a41cc27ddd097(context, font, text) {
    context.textAlign = "right";
    context.textBaseline = "middle";
    context.font = font;
    const { actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight } = context.measureText(text);
    if (actualBoundingBoxAscent == null || actualBoundingBoxDescent == null || actualBoundingBoxLeft == null || actualBoundingBoxRight == null) throw new Error("TextMetrics does not support required actualBoundingBox properties");
    const height = Math.ceil(actualBoundingBoxAscent + actualBoundingBoxDescent) + $74c7b72a71b76868$var$SIGNATURE_PADDING;
    const width = Math.ceil(actualBoundingBoxLeft + actualBoundingBoxRight) + $74c7b72a71b76868$var$SIGNATURE_PADDING;
    const x = context.canvas.width - Math.ceil(actualBoundingBoxRight) - $74c7b72a71b76868$var$SIGNATURE_PADDING / 2;
    const y = (context.canvas.height - height) / 2 + Math.ceil(actualBoundingBoxAscent) + $74c7b72a71b76868$var$SIGNATURE_PADDING / 2;
    return {
        coordinates: {
            x: x,
            y: y
        },
        rect: {
            width: width,
            height: height
        }
    };
}
function $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize, measureTextFn, text) {
    if (fontSize <= 0 || fontSize > Number.MAX_VALUE) throw new RangeError("Calculated font size fell outside bounds before reaching a solution.");
    if (!/\S/.test(text)) return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        coordinates: {
            x: 0,
            y: 0
        }
    };
    const font = $74c7b72a71b76868$export$cb8806e8acc557d7(fontSize, fontFamily);
    const targetSize = {
        width: context.canvas.width,
        height: context.canvas.height
    };
    const actualSize = measureTextFn(context, font, text);
    const fits = $74c7b72a71b76868$export$2344b14b097df817(targetSize, actualSize.rect);
    if (fits) {
        const increasedFontSize = fontSize + 1;
        const increasedFont = $74c7b72a71b76868$export$cb8806e8acc557d7(increasedFontSize, fontFamily);
        const increasedActualSize = measureTextFn(context, increasedFont, text);
        const increasedFits = $74c7b72a71b76868$export$2344b14b097df817(targetSize, increasedActualSize.rect);
        if (increasedFits) return $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize + 2, measureTextFn, text);
        // if this size fits, but n + 1 doesn't, we found our match
        return {
            fontFamily: fontFamily,
            fontSize: fontSize,
            coordinates: actualSize.coordinates
        };
    }
    const decreasedFontSize = fontSize - 1;
    const decreasedFont = $74c7b72a71b76868$export$cb8806e8acc557d7(decreasedFontSize, fontFamily);
    const decreasedActualSize = measureTextFn(context, decreasedFont, text);
    const decreasedFits = $74c7b72a71b76868$export$2344b14b097df817(targetSize, decreasedActualSize.rect);
    if (decreasedFits) // if this size doesn't fit, but n - 1 does, we found our match
    return {
        fontFamily: fontFamily,
        fontSize: decreasedFontSize,
        coordinates: decreasedActualSize.coordinates
    };
    return $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize - 2, measureTextFn, text);
}
const $74c7b72a71b76868$export$5aa9cd1ba259435e = {
    calculateTextRenderingParams (context, fontSize, fontFamily, text) {
        return $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize, $74c7b72a71b76868$export$ec1a41cc27ddd097, text);
    },
    createCanvas () {
        return document.createElement("canvas");
    }
};
class $74c7b72a71b76868$export$2e2bcd8739ae039 {
    #canvas;
    #context;
    #textRenderingParams;
    #strategy;
    #text;
    constructor(estimatedfontSize, fontFamily, text, boundingBox, strategy){
        this.#canvas = strategy.createCanvas();
        this.#canvas.height = boundingBox.height;
        this.#canvas.width = boundingBox.width;
        this.#context = (0, $5cdd7c46b89c41cf$export$31407c2dd876dbd1)(this.#canvas.getContext("2d"));
        this.#strategy = strategy;
        this.#text = text;
        this.#textRenderingParams = this.#strategy.calculateTextRenderingParams(this.#context, estimatedfontSize, fontFamily, text);
    }
    get fontFamily() {
        return this.#textRenderingParams.fontFamily;
    }
    set fontFamily(newFontFamily) {
        if (this.#textRenderingParams.fontFamily !== newFontFamily) {
            const { fontSize: fontSize } = this.#textRenderingParams;
            this.#textRenderingParams = this.#strategy.calculateTextRenderingParams(this.#context, fontSize, newFontFamily, this.#text);
        }
    }
    get text() {
        return this.#text;
    }
    set text(newText) {
        if (this.#text !== newText) {
            this.#text = newText;
            const { fontFamily: fontFamily, fontSize: fontSize } = this.#textRenderingParams;
            this.#textRenderingParams = this.#strategy.calculateTextRenderingParams(this.#context, fontSize, fontFamily, this.#text);
        }
    }
    toDataURL() {
        this.render();
        return this.#canvas.toDataURL();
    }
    toBytes() {
        this.render();
        return new Promise((resolve, reject)=>{
            try {
                this.#canvas.toBlob((blob)=>resolve(blob), "image/png");
            } catch (e) {
                reject(e);
            }
        }).then((blob)=>blob ?? new Blob()).then((blob)=>blob.arrayBuffer()).then((buffer)=>new Uint8Array(buffer));
    }
    render() {
        const context = (0, $5cdd7c46b89c41cf$export$31407c2dd876dbd1)(this.#canvas.getContext("2d"));
        context.clearRect(0, 0, this.#canvas.width, this.#canvas.height);
        if (/\S/.test(this.#text)) {
            const { fontFamily: fontFamily, fontSize: fontSize, coordinates: coordinates } = this.#textRenderingParams;
            context.font = $74c7b72a71b76868$export$cb8806e8acc557d7(fontSize, fontFamily);
            context.fillText(this.#text, coordinates.x, coordinates.y);
        }
    }
}


const $d50f52fc18ffa921$export$6bcdc49eab1cd857 = 21;
const $d50f52fc18ffa921$var$MIME_TYPE = "image/png";
var $d50f52fc18ffa921$export$b58c4be94c1619ca = /*#__PURE__*/ function(CardCustomizationSignatureError) {
    CardCustomizationSignatureError["ContainsEmoji"] = "CARD_CUSTOMIZATION_SIGNATURE_ERROR_CONTAINS_EMOJI";
    CardCustomizationSignatureError["Empty"] = "CARD_CUSTOMIZATION_SIGNATURE_ERROR_EMPTY";
    CardCustomizationSignatureError["ExceededMaxLength"] = "CARD_CUSTOMIZATION_SIGNATURE_ERROR_EXCEEDED_MAX_LENGTH";
    return CardCustomizationSignatureError;
}({});
const $d50f52fc18ffa921$export$36d128238e6b60f5 = {
    cardInvitationToken: "",
    cardCustomizationToken: "",
    customSignatureInputError: [],
    done: false,
    loading: false,
    signatureFont: (0, $8ac095e22cd80964$export$c1bd96fb305c59e8).AlexBrush,
    signatureInputText: "",
    signatureText: "",
    toggleCustomSignature: false
};
const $d50f52fc18ffa921$export$e6a0daad8304de = (overrides = {})=>({
        ...$d50f52fc18ffa921$export$36d128238e6b60f5,
        ...overrides
    });
const $d50f52fc18ffa921$var$renderCardCustomization = (TextRenderer)=>(state)=>state.toggleCustomSignature ? new TextRenderer(// Note(cvu): This value was copied from dashboard so the image generated
        // in banking-web will be the same as the one generated in dashboard.
        // https://github.com/squareup/dashboard/blob/4642381a3237dd628fbe821ef1a1d4bdfbba298e/frontend/%40banking/applet-engine/addon/workflows/banking/checking/onboarding/index.ts#L866
        100, state.signatureFont, state.signatureText, (0, $74c7b72a71b76868$export$9a1b8f2a422bb03a), (0, $74c7b72a71b76868$export$5aa9cd1ba259435e)).toBytes() : Promise.resolve(undefined);
var $d50f52fc18ffa921$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["CreateCardCustomizationReceived"] = "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_RECEIVED";
    ActionType["CreateCardCustomizationRejected"] = "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_REJECTED";
    ActionType["Done"] = "CARD_CUSTOMIZATION_DONE";
    ActionType["Initialize"] = "CARD_CUSTOMIZATION_INITIALIZE";
    ActionType["UserChangeSignatureFont"] = "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_FONT";
    ActionType["UserChangeSignatureText"] = "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_TEXT";
    ActionType["UserToggleCustomizeSignature"] = "CARD_CUSTOMIZATION_USER_TOGGLE_CUSTOMIZE_SIGNATURE";
    ActionType["UserClickNextAction"] = "CARD_CUSTOMIZATION_USER_CLICK_NEXT";
    return ActionType;
}({});
const $d50f52fc18ffa921$export$2d705c8ebe551367 = (response)=>({
        type: "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_RECEIVED",
        response: response
    });
const $d50f52fc18ffa921$export$f96823155fd35b20 = (// eslint-disable-next-line
error)=>({
        type: "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_REJECTED",
        error: error
    });
const $d50f52fc18ffa921$export$8789045e6aca717c = ()=>({
        type: "CARD_CUSTOMIZATION_DONE"
    });
const $d50f52fc18ffa921$export$c81c36414a1e3192 = (cardInvitationToken, signatureText)=>({
        type: "CARD_CUSTOMIZATION_INITIALIZE",
        cardInvitationToken: cardInvitationToken,
        signatureText: signatureText
    });
const $d50f52fc18ffa921$export$817cb1cc86775b9b = (signatureFont)=>({
        type: "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_FONT",
        signatureFont: signatureFont
    });
const $d50f52fc18ffa921$export$22e3bdf54f208610 = (signatureInputText)=>({
        type: "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_TEXT",
        signatureInputText: signatureInputText
    });
const $d50f52fc18ffa921$export$69864c1ae20800a8 = ()=>({
        type: "CARD_CUSTOMIZATION_USER_CLICK_NEXT"
    });
const $d50f52fc18ffa921$export$74d52cff822ce1fe = (value)=>({
        type: "CARD_CUSTOMIZATION_USER_TOGGLE_CUSTOMIZE_SIGNATURE",
        value: value
    });
function $d50f52fc18ffa921$var$handleCreateCardCustomizationReceived(state, action) {
    const { cardCustomizationToken: cardCustomizationToken } = action.response;
    return [
        {
            ...state,
            cardCustomizationToken: cardCustomizationToken,
            loading: false
        },
        $d50f52fc18ffa921$export$8789045e6aca717c
    ];
}
function $d50f52fc18ffa921$var$handleInitialize(state, action) {
    const { cardInvitationToken: cardInvitationToken, signatureText: signatureText } = action;
    return [
        $d50f52fc18ffa921$export$e6a0daad8304de({
            cardInvitationToken: cardInvitationToken,
            signatureText: signatureText,
            signatureInputText: signatureText
        }),
        null
    ];
}
function $d50f52fc18ffa921$var$handleUserChangeSignatureText(state, action) {
    const { signatureInputText: signatureInputText } = action;
    const customSignatureInputError = [];
    if ((0, $488d76279e935265$export$537947b51dead775)(signatureInputText)) customSignatureInputError.push("CARD_CUSTOMIZATION_SIGNATURE_ERROR_CONTAINS_EMOJI");
    if (signatureInputText.length === 0) customSignatureInputError.push("CARD_CUSTOMIZATION_SIGNATURE_ERROR_EMPTY");
    if (signatureInputText.length > $d50f52fc18ffa921$export$6bcdc49eab1cd857) customSignatureInputError.push("CARD_CUSTOMIZATION_SIGNATURE_ERROR_EXCEEDED_MAX_LENGTH");
    const signatureText = (0, $488d76279e935265$export$9efee81811214072)(signatureInputText).trim().substring(0, $d50f52fc18ffa921$export$6bcdc49eab1cd857);
    return [
        {
            ...state,
            signatureText: signatureText,
            signatureInputText: signatureInputText,
            customSignatureInputError: customSignatureInputError
        },
        null
    ];
}
function $d50f52fc18ffa921$var$handleUserClickNext(context, state) {
    const { bankingWebCardService: bankingWebCardService } = context;
    const { cardInvitationToken: cardInvitationToken, customSignatureInputError: customSignatureInputError } = state;
    if (customSignatureInputError.length) return [
        state,
        null
    ];
    const work = ()=>{
        const response = $d50f52fc18ffa921$var$renderCardCustomization(context.textRenderer)(state).then((imageBytes)=>{
            const request = (0, $bc006730c79954a6$export$aed3bec368de6e1f).create({
                cardInvitationToken: cardInvitationToken,
                idempotencyKey: context.uuid(),
                imageBytes: imageBytes,
                mimeType: $d50f52fc18ffa921$var$MIME_TYPE
            });
            return bankingWebCardService.createCardCustomization(request).then($d50f52fc18ffa921$export$2d705c8ebe551367, $d50f52fc18ffa921$export$f96823155fd35b20);
        });
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
    };
    return [
        {
            ...state,
            loading: true
        },
        work
    ];
}
function $d50f52fc18ffa921$var$handleUserToggleCustomizeSignature(state, action) {
    const { value: value } = action;
    // TODO(cvu): person name here
    return [
        {
            ...state,
            toggleCustomSignature: value
        },
        null
    ];
}
const $d50f52fc18ffa921$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_RECEIVED":
                return $d50f52fc18ffa921$var$handleCreateCardCustomizationReceived(state, action);
            case "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_REJECTED":
                return [
                    {
                        ...state,
                        loading: false
                    },
                    null
                ];
            case "CARD_CUSTOMIZATION_DONE":
                return [
                    {
                        ...state,
                        done: true
                    },
                    null
                ];
            case "CARD_CUSTOMIZATION_INITIALIZE":
                return $d50f52fc18ffa921$var$handleInitialize(state, action);
            case "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_FONT":
                return [
                    {
                        ...state,
                        signatureFont: action.signatureFont
                    },
                    null
                ];
            case "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_TEXT":
                return $d50f52fc18ffa921$var$handleUserChangeSignatureText(state, action);
            case "CARD_CUSTOMIZATION_USER_CLICK_NEXT":
                return $d50f52fc18ffa921$var$handleUserClickNext(context, state);
            case "CARD_CUSTOMIZATION_USER_TOGGLE_CUSTOMIZE_SIGNATURE":
                return $d50f52fc18ffa921$var$handleUserToggleCustomizeSignature(state, action);
        }
    };







/**
 * For multiple cards GA, we will be handling address validation in the client. This should ideally be
 * handled in the backend with some validate address endpoint. We are currently in a in-between state
 * with our high-level RPCs.
 *
 * We also want to be able to launch GA first and fix this later.
 *
 * TODO(cvu): Remove this file when we properly validate addresses
 */ const $074c0fa941456ba7$var$ZIP5_TO_STATE = {
    "06390": "NY",
    "83414": "WY",
    "96799": "AS",
    "96940": "PW",
    "96941": "FM",
    "96942": "FM",
    "96943": "FM",
    "96944": "FM",
    "96950": "MP",
    "96951": "MP",
    "96952": "MP",
    "96960": "MH",
    "96970": "MH"
};
const $074c0fa941456ba7$var$ZIP3_TO_STATE = {
    "005": "NY",
    "006": "PR",
    "007": "PR",
    "008": "VI",
    "009": "PR",
    "010": "MA",
    "011": "MA",
    "012": "MA",
    "013": "MA",
    "014": "MA",
    "015": "MA",
    "016": "MA",
    "017": "MA",
    "018": "MA",
    "019": "MA",
    "020": "MA",
    "021": "MA",
    "022": "MA",
    "023": "MA",
    "024": "MA",
    "025": "MA",
    "026": "MA",
    "027": "MA",
    "028": "RI",
    "029": "RI",
    "030": "NH",
    "031": "NH",
    "032": "NH",
    "033": "NH",
    "034": "NH",
    "035": "NH",
    "036": "NH",
    "037": "NH",
    "038": "NH",
    "039": "ME",
    "040": "ME",
    "041": "ME",
    "042": "ME",
    "043": "ME",
    "044": "ME",
    "045": "ME",
    "046": "ME",
    "047": "ME",
    "048": "ME",
    "049": "ME",
    "050": "VT",
    "051": "VT",
    "052": "VT",
    "053": "VT",
    "054": "VT",
    "055": "MA",
    "056": "VT",
    "057": "VT",
    "058": "VT",
    "059": "VT",
    "060": "CT",
    "061": "CT",
    "062": "CT",
    "063": "CT",
    "064": "CT",
    "065": "CT",
    "066": "CT",
    "067": "CT",
    "068": "CT",
    "069": "CT",
    "070": "NJ",
    "071": "NJ",
    "072": "NJ",
    "073": "NJ",
    "074": "NJ",
    "075": "NJ",
    "076": "NJ",
    "077": "NJ",
    "078": "NJ",
    "079": "NJ",
    "080": "NJ",
    "081": "NJ",
    "082": "NJ",
    "083": "NJ",
    "084": "NJ",
    "085": "NJ",
    "086": "NJ",
    "087": "NJ",
    "088": "NJ",
    "089": "NJ",
    "090": "AE",
    "091": "AE",
    "092": "AE",
    "093": "AE",
    "094": "AE",
    "095": "AE",
    "096": "AE",
    "097": "AE",
    "098": "AE",
    "100": "NY",
    "101": "NY",
    "102": "NY",
    "103": "NY",
    "104": "NY",
    "105": "NY",
    "106": "NY",
    "107": "NY",
    "108": "NY",
    "109": "NY",
    "110": "NY",
    "111": "NY",
    "112": "NY",
    "113": "NY",
    "114": "NY",
    "115": "NY",
    "116": "NY",
    "117": "NY",
    "118": "NY",
    "119": "NY",
    "120": "NY",
    "121": "NY",
    "122": "NY",
    "123": "NY",
    "124": "NY",
    "125": "NY",
    "126": "NY",
    "127": "NY",
    "128": "NY",
    "129": "NY",
    "130": "NY",
    "131": "NY",
    "132": "NY",
    "133": "NY",
    "134": "NY",
    "135": "NY",
    "136": "NY",
    "137": "NY",
    "138": "NY",
    "139": "NY",
    "140": "NY",
    "141": "NY",
    "142": "NY",
    "143": "NY",
    "144": "NY",
    "145": "NY",
    "146": "NY",
    "147": "NY",
    "148": "NY",
    "149": "NY",
    "150": "PA",
    "151": "PA",
    "152": "PA",
    "153": "PA",
    "154": "PA",
    "155": "PA",
    "156": "PA",
    "157": "PA",
    "158": "PA",
    "159": "PA",
    "160": "PA",
    "161": "PA",
    "162": "PA",
    "163": "PA",
    "164": "PA",
    "165": "PA",
    "166": "PA",
    "167": "PA",
    "168": "PA",
    "169": "PA",
    "170": "PA",
    "171": "PA",
    "172": "PA",
    "173": "PA",
    "174": "PA",
    "175": "PA",
    "176": "PA",
    "177": "PA",
    "178": "PA",
    "179": "PA",
    "180": "PA",
    "181": "PA",
    "182": "PA",
    "183": "PA",
    "184": "PA",
    "185": "PA",
    "186": "PA",
    "187": "PA",
    "188": "PA",
    "189": "PA",
    "190": "PA",
    "191": "PA",
    "192": "PA",
    "193": "PA",
    "194": "PA",
    "195": "PA",
    "196": "PA",
    "197": "DE",
    "198": "DE",
    "199": "DE",
    "200": "DC",
    "201": "VA",
    "202": "DC",
    "203": "DC",
    "204": "DC",
    "205": "DC",
    "206": "MD",
    "207": "MD",
    "208": "MD",
    "209": "MD",
    "210": "MD",
    "211": "MD",
    "212": "MD",
    "214": "MD",
    "215": "MD",
    "216": "MD",
    "217": "MD",
    "218": "MD",
    "219": "MD",
    "220": "VA",
    "221": "VA",
    "222": "VA",
    "223": "VA",
    "224": "VA",
    "225": "VA",
    "226": "VA",
    "227": "VA",
    "228": "VA",
    "229": "VA",
    "230": "VA",
    "231": "VA",
    "232": "VA",
    "233": "VA",
    "234": "VA",
    "235": "VA",
    "236": "VA",
    "237": "VA",
    "238": "VA",
    "239": "VA",
    "240": "VA",
    "241": "VA",
    "242": "VA",
    "243": "VA",
    "244": "VA",
    "245": "VA",
    "246": "VA",
    "247": "WV",
    "248": "WV",
    "249": "WV",
    "250": "WV",
    "251": "WV",
    "252": "WV",
    "253": "WV",
    "254": "WV",
    "255": "WV",
    "256": "WV",
    "257": "WV",
    "258": "WV",
    "259": "WV",
    "260": "WV",
    "261": "WV",
    "262": "WV",
    "263": "WV",
    "264": "WV",
    "265": "WV",
    "266": "WV",
    "267": "WV",
    "268": "WV",
    "270": "NC",
    "271": "NC",
    "272": "NC",
    "273": "NC",
    "274": "NC",
    "275": "NC",
    "276": "NC",
    "277": "NC",
    "278": "NC",
    "279": "NC",
    "280": "NC",
    "281": "NC",
    "282": "NC",
    "283": "NC",
    "284": "NC",
    "285": "NC",
    "286": "NC",
    "287": "NC",
    "288": "NC",
    "289": "NC",
    "290": "SC",
    "291": "SC",
    "292": "SC",
    "293": "SC",
    "294": "SC",
    "295": "SC",
    "296": "SC",
    "297": "SC",
    "298": "SC",
    "299": "SC",
    "300": "GA",
    "301": "GA",
    "302": "GA",
    "303": "GA",
    "304": "GA",
    "305": "GA",
    "306": "GA",
    "307": "GA",
    "308": "GA",
    "309": "GA",
    "310": "GA",
    "311": "GA",
    "312": "GA",
    "313": "GA",
    "314": "GA",
    "315": "GA",
    "316": "GA",
    "317": "GA",
    "318": "GA",
    "319": "GA",
    "320": "FL",
    "321": "FL",
    "322": "FL",
    "323": "FL",
    "324": "FL",
    "325": "FL",
    "326": "FL",
    "327": "FL",
    "328": "FL",
    "329": "FL",
    "330": "FL",
    "331": "FL",
    "332": "FL",
    "333": "FL",
    "334": "FL",
    "335": "FL",
    "336": "FL",
    "337": "FL",
    "338": "FL",
    "339": "FL",
    "340": "AA",
    "341": "FL",
    "342": "FL",
    "344": "FL",
    "346": "FL",
    "347": "FL",
    "349": "FL",
    "350": "AL",
    "351": "AL",
    "352": "AL",
    "354": "AL",
    "355": "AL",
    "356": "AL",
    "357": "AL",
    "358": "AL",
    "359": "AL",
    "360": "AL",
    "361": "AL",
    "362": "AL",
    "363": "AL",
    "364": "AL",
    "365": "AL",
    "366": "AL",
    "367": "AL",
    "368": "AL",
    "369": "AL",
    "370": "TN",
    "371": "TN",
    "372": "TN",
    "373": "TN",
    "374": "TN",
    "375": "TN",
    "376": "TN",
    "377": "TN",
    "378": "TN",
    "379": "TN",
    "380": "TN",
    "381": "TN",
    "382": "TN",
    "383": "TN",
    "384": "TN",
    "385": "TN",
    "386": "MS",
    "387": "MS",
    "388": "MS",
    "389": "MS",
    "390": "MS",
    "391": "MS",
    "392": "MS",
    "393": "MS",
    "394": "MS",
    "395": "MS",
    "396": "MS",
    "397": "MS",
    "398": "GA",
    "399": "GA",
    "400": "KY",
    "401": "KY",
    "402": "KY",
    "403": "KY",
    "404": "KY",
    "405": "KY",
    "406": "KY",
    "407": "KY",
    "408": "KY",
    "409": "KY",
    "410": "KY",
    "411": "KY",
    "412": "KY",
    "413": "KY",
    "414": "KY",
    "415": "KY",
    "416": "KY",
    "417": "KY",
    "418": "KY",
    "420": "KY",
    "421": "KY",
    "422": "KY",
    "423": "KY",
    "424": "KY",
    "425": "KY",
    "426": "KY",
    "427": "KY",
    "430": "OH",
    "431": "OH",
    "432": "OH",
    "433": "OH",
    "434": "OH",
    "435": "OH",
    "436": "OH",
    "437": "OH",
    "438": "OH",
    "439": "OH",
    "440": "OH",
    "441": "OH",
    "442": "OH",
    "443": "OH",
    "444": "OH",
    "445": "OH",
    "446": "OH",
    "447": "OH",
    "448": "OH",
    "449": "OH",
    "450": "OH",
    "451": "OH",
    "452": "OH",
    "453": "OH",
    "454": "OH",
    "455": "OH",
    "456": "OH",
    "457": "OH",
    "458": "OH",
    "459": "OH",
    "460": "IN",
    "461": "IN",
    "462": "IN",
    "463": "IN",
    "464": "IN",
    "465": "IN",
    "466": "IN",
    "467": "IN",
    "468": "IN",
    "469": "IN",
    "470": "IN",
    "471": "IN",
    "472": "IN",
    "473": "IN",
    "474": "IN",
    "475": "IN",
    "476": "IN",
    "477": "IN",
    "478": "IN",
    "479": "IN",
    "480": "MI",
    "481": "MI",
    "482": "MI",
    "483": "MI",
    "484": "MI",
    "485": "MI",
    "486": "MI",
    "487": "MI",
    "488": "MI",
    "489": "MI",
    "490": "MI",
    "491": "MI",
    "492": "MI",
    "493": "MI",
    "494": "MI",
    "495": "MI",
    "496": "MI",
    "497": "MI",
    "498": "MI",
    "499": "MI",
    "500": "IA",
    "501": "IA",
    "502": "IA",
    "503": "IA",
    "504": "IA",
    "505": "IA",
    "506": "IA",
    "507": "IA",
    "508": "IA",
    "509": "IA",
    "510": "IA",
    "511": "IA",
    "512": "IA",
    "513": "IA",
    "514": "IA",
    "515": "IA",
    "516": "IA",
    "520": "IA",
    "521": "IA",
    "522": "IA",
    "523": "IA",
    "524": "IA",
    "525": "IA",
    "526": "IA",
    "527": "IA",
    "528": "IA",
    "530": "WI",
    "531": "WI",
    "532": "WI",
    "534": "WI",
    "535": "WI",
    "537": "WI",
    "538": "WI",
    "539": "WI",
    "540": "WI",
    "541": "WI",
    "542": "WI",
    "543": "WI",
    "544": "WI",
    "545": "WI",
    "546": "WI",
    "547": "WI",
    "548": "WI",
    "549": "WI",
    "550": "MN",
    "551": "MN",
    "553": "MN",
    "554": "MN",
    "555": "MN",
    "556": "MN",
    "557": "MN",
    "558": "MN",
    "559": "MN",
    "560": "MN",
    "561": "MN",
    "562": "MN",
    "563": "MN",
    "564": "MN",
    "565": "MN",
    "566": "MN",
    "567": "MN",
    "569": "DC",
    "570": "SD",
    "571": "SD",
    "572": "SD",
    "573": "SD",
    "574": "SD",
    "575": "SD",
    "576": "SD",
    "577": "SD",
    "580": "ND",
    "581": "ND",
    "582": "ND",
    "583": "ND",
    "584": "ND",
    "585": "ND",
    "586": "ND",
    "587": "ND",
    "588": "ND",
    "590": "MT",
    "591": "MT",
    "592": "MT",
    "593": "MT",
    "594": "MT",
    "595": "MT",
    "596": "MT",
    "597": "MT",
    "598": "MT",
    "599": "MT",
    "600": "IL",
    "601": "IL",
    "602": "IL",
    "603": "IL",
    "604": "IL",
    "605": "IL",
    "606": "IL",
    "607": "IL",
    "608": "IL",
    "609": "IL",
    "610": "IL",
    "611": "IL",
    "612": "IL",
    "613": "IL",
    "614": "IL",
    "615": "IL",
    "616": "IL",
    "617": "IL",
    "618": "IL",
    "619": "IL",
    "620": "IL",
    "622": "IL",
    "623": "IL",
    "624": "IL",
    "625": "IL",
    "626": "IL",
    "627": "IL",
    "628": "IL",
    "629": "IL",
    "630": "MO",
    "631": "MO",
    "633": "MO",
    "634": "MO",
    "635": "MO",
    "636": "MO",
    "637": "MO",
    "638": "MO",
    "639": "MO",
    "640": "MO",
    "641": "MO",
    "644": "MO",
    "645": "MO",
    "646": "MO",
    "647": "MO",
    "648": "MO",
    "649": "MO",
    "650": "MO",
    "651": "MO",
    "652": "MO",
    "653": "MO",
    "654": "MO",
    "655": "MO",
    "656": "MO",
    "657": "MO",
    "658": "MO",
    "660": "KS",
    "661": "KS",
    "662": "KS",
    "664": "KS",
    "665": "KS",
    "666": "KS",
    "667": "KS",
    "668": "KS",
    "669": "KS",
    "670": "KS",
    "671": "KS",
    "672": "KS",
    "673": "KS",
    "674": "KS",
    "675": "KS",
    "676": "KS",
    "677": "KS",
    "678": "KS",
    "679": "KS",
    "680": "NE",
    "681": "NE",
    "683": "NE",
    "684": "NE",
    "685": "NE",
    "686": "NE",
    "687": "NE",
    "688": "NE",
    "689": "NE",
    "690": "NE",
    "691": "NE",
    "692": "NE",
    "693": "NE",
    "700": "LA",
    "701": "LA",
    "703": "LA",
    "704": "LA",
    "705": "LA",
    "706": "LA",
    "707": "LA",
    "708": "LA",
    "710": "LA",
    "711": "LA",
    "712": "LA",
    "713": "LA",
    "714": "LA",
    "716": "AR",
    "717": "AR",
    "718": "AR",
    "719": "AR",
    "720": "AR",
    "721": "AR",
    "722": "AR",
    "723": "AR",
    "724": "AR",
    "725": "AR",
    "726": "AR",
    "727": "AR",
    "728": "AR",
    "729": "AR",
    "730": "OK",
    "731": "OK",
    "733": "TX",
    "734": "OK",
    "735": "OK",
    "736": "OK",
    "737": "OK",
    "738": "OK",
    "739": "OK",
    "740": "OK",
    "741": "OK",
    "743": "OK",
    "744": "OK",
    "745": "OK",
    "746": "OK",
    "747": "OK",
    "748": "OK",
    "749": "OK",
    "750": "TX",
    "751": "TX",
    "752": "TX",
    "753": "TX",
    "754": "TX",
    "755": "TX",
    "756": "TX",
    "757": "TX",
    "758": "TX",
    "759": "TX",
    "760": "TX",
    "761": "TX",
    "762": "TX",
    "763": "TX",
    "764": "TX",
    "765": "TX",
    "766": "TX",
    "767": "TX",
    "768": "TX",
    "769": "TX",
    "770": "TX",
    "772": "TX",
    "773": "TX",
    "774": "TX",
    "775": "TX",
    "776": "TX",
    "777": "TX",
    "778": "TX",
    "779": "TX",
    "780": "TX",
    "781": "TX",
    "782": "TX",
    "783": "TX",
    "784": "TX",
    "785": "TX",
    "786": "TX",
    "787": "TX",
    "788": "TX",
    "789": "TX",
    "790": "TX",
    "791": "TX",
    "792": "TX",
    "793": "TX",
    "794": "TX",
    "795": "TX",
    "796": "TX",
    "797": "TX",
    "798": "TX",
    "799": "TX",
    "800": "CO",
    "801": "CO",
    "802": "CO",
    "803": "CO",
    "804": "CO",
    "805": "CO",
    "806": "CO",
    "807": "CO",
    "808": "CO",
    "809": "CO",
    "810": "CO",
    "811": "CO",
    "812": "CO",
    "813": "CO",
    "814": "CO",
    "815": "CO",
    "816": "CO",
    "820": "WY",
    "821": "WY",
    "822": "WY",
    "823": "WY",
    "824": "WY",
    "825": "WY",
    "826": "WY",
    "827": "WY",
    "828": "WY",
    "829": "WY",
    "830": "WY",
    "831": "WY",
    "832": "ID",
    "833": "ID",
    "834": "ID",
    "835": "ID",
    "836": "ID",
    "837": "ID",
    "838": "ID",
    "840": "UT",
    "841": "UT",
    "842": "UT",
    "843": "UT",
    "844": "UT",
    "845": "UT",
    "846": "UT",
    "847": "UT",
    "850": "AZ",
    "851": "AZ",
    "852": "AZ",
    "853": "AZ",
    "855": "AZ",
    "856": "AZ",
    "857": "AZ",
    "859": "AZ",
    "860": "AZ",
    "863": "AZ",
    "864": "AZ",
    "865": "AZ",
    "870": "NM",
    "871": "NM",
    "872": "NM",
    "873": "NM",
    "874": "NM",
    "875": "NM",
    "877": "NM",
    "878": "NM",
    "879": "NM",
    "880": "NM",
    "881": "NM",
    "882": "NM",
    "883": "NM",
    "884": "NM",
    "885": "TX",
    "889": "NV",
    "890": "NV",
    "891": "NV",
    "893": "NV",
    "894": "NV",
    "895": "NV",
    "897": "NV",
    "898": "NV",
    "900": "CA",
    "901": "CA",
    "902": "CA",
    "903": "CA",
    "904": "CA",
    "905": "CA",
    "906": "CA",
    "907": "CA",
    "908": "CA",
    "910": "CA",
    "911": "CA",
    "912": "CA",
    "913": "CA",
    "914": "CA",
    "915": "CA",
    "916": "CA",
    "917": "CA",
    "918": "CA",
    "919": "CA",
    "920": "CA",
    "921": "CA",
    "922": "CA",
    "923": "CA",
    "924": "CA",
    "925": "CA",
    "926": "CA",
    "927": "CA",
    "928": "CA",
    "930": "CA",
    "931": "CA",
    "932": "CA",
    "933": "CA",
    "934": "CA",
    "935": "CA",
    "936": "CA",
    "937": "CA",
    "938": "CA",
    "939": "CA",
    "940": "CA",
    "941": "CA",
    "942": "CA",
    "943": "CA",
    "944": "CA",
    "945": "CA",
    "946": "CA",
    "947": "CA",
    "948": "CA",
    "949": "CA",
    "950": "CA",
    "951": "CA",
    "952": "CA",
    "953": "CA",
    "954": "CA",
    "955": "CA",
    "956": "CA",
    "957": "CA",
    "958": "CA",
    "959": "CA",
    "960": "CA",
    "961": "CA",
    "962": "AP",
    "963": "AP",
    "964": "AP",
    "965": "AP",
    "966": "AP",
    "967": "HI",
    "968": "HI",
    "969": "GU",
    "970": "OR",
    "971": "OR",
    "972": "OR",
    "973": "OR",
    "974": "OR",
    "975": "OR",
    "976": "OR",
    "977": "OR",
    "978": "OR",
    "979": "OR",
    "980": "WA",
    "981": "WA",
    "982": "WA",
    "983": "WA",
    "984": "WA",
    "985": "WA",
    "986": "WA",
    "988": "WA",
    "989": "WA",
    "990": "WA",
    "991": "WA",
    "992": "WA",
    "993": "WA",
    "994": "WA",
    "995": "AK",
    "996": "AK",
    "997": "AK",
    "998": "AK",
    "999": "AK"
};
const $074c0fa941456ba7$export$c58b7bec74e6ca50 = (zip)=>{
    const cleanedZip = zip.trim();
    // 5 digit zip / 9 digit zip with hyphen / 9 digit zip without hyphen
    const regex = new RegExp("(^\\d{5}(-\\d{4})?$)|(^\\d{9}$)");
    return regex.test(cleanedZip) && (Boolean($074c0fa941456ba7$var$ZIP5_TO_STATE[cleanedZip.substring(0, 5)]) || Boolean($074c0fa941456ba7$var$ZIP3_TO_STATE[cleanedZip.substring(0, 3)]));
};


var $a9356ac90e965f5c$export$804a92ba667853be = /*#__PURE__*/ function(AddressError) {
    AddressError["Empty"] = "ADDRESS_ERROR_EMPTY";
    return AddressError;
}({});
var $a9356ac90e965f5c$export$74e717fd56f132db = /*#__PURE__*/ function(PostalCodeError) {
    PostalCodeError["Invalid"] = "POSTAL_CODE_ERROR_INVALID";
    return PostalCodeError;
}({});
var $a9356ac90e965f5c$export$4b2f75d0e5275120 = /*#__PURE__*/ function(AddressField) {
    AddressField["AddressLine1"] = "addressLine1";
    AddressField["AddressLine2"] = "addressLine2";
    AddressField["AdministrativeDistrictLevel1"] = "administrativeDistrictLevel1";
    AddressField["Locality"] = "locality";
    AddressField["PostalCode"] = "postalCode";
    AddressField["CountryCode"] = "countryCode";
    return AddressField;
}({});
const $a9356ac90e965f5c$export$e82aa99a68ee705d = [
    (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US
];
const $a9356ac90e965f5c$export$c8bac1d5c31c83a1 = (address)=>{
    const addressLine1 = address["addressLine1"];
    const administrativeDistrictLevelOne = address["administrativeDistrictLevel1"];
    const locality = address["locality"];
    const postalCode = address["postalCode"];
    const countryCode = address["countryCode"];
    if (!$a9356ac90e965f5c$export$e82aa99a68ee705d.includes(countryCode)) throw new Error(`Country is not supported: [country=${countryCode}]`);
    const addressLine1Errors = [];
    const administrativeDistrictLevelOneErrors = [];
    const localityErrors = [];
    const postalCodeErrors = $a9356ac90e965f5c$export$815da5de8966867b(postalCode, countryCode);
    if (addressLine1 === "") addressLine1Errors.push("ADDRESS_ERROR_EMPTY");
    if (administrativeDistrictLevelOne === "") administrativeDistrictLevelOneErrors.push("ADDRESS_ERROR_EMPTY");
    if (locality === "") localityErrors.push("ADDRESS_ERROR_EMPTY");
    const valid = addressLine1Errors.length === 0 && administrativeDistrictLevelOneErrors.length === 0 && localityErrors.length === 0 && postalCodeErrors.length === 0;
    return {
        errors: {
            ["addressLine1"]: addressLine1Errors,
            ["administrativeDistrictLevel1"]: administrativeDistrictLevelOneErrors,
            ["locality"]: localityErrors,
            ["postalCode"]: $a9356ac90e965f5c$export$815da5de8966867b(postalCode, countryCode)
        },
        valid: valid
    };
};
const $a9356ac90e965f5c$export$815da5de8966867b = (postalCode, countryCode)=>{
    const postalCodeErrors = [];
    if (postalCode === "") postalCodeErrors.push("ADDRESS_ERROR_EMPTY");
    // TODO(cvu): support Canada maybe. this code will probably be obsolete when we support Canada
    switch(countryCode){
        case (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US:
            if (!(0, $074c0fa941456ba7$export$c58b7bec74e6ca50)(postalCode)) postalCodeErrors.push("POSTAL_CODE_ERROR_INVALID");
            break;
        default:
            throw new Error(`Country is not supported: [country=${countryCode}]`);
    }
    return postalCodeErrors;
};


var $a4c47930ee9facdd$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["EnterAddress"] = 0] = "EnterAddress";
    Screen[Screen["ConfirmAddress"] = 1] = "ConfirmAddress";
    return Screen;
}({});
var $a4c47930ee9facdd$export$625913c7ca4f03a9 = /*#__PURE__*/ function(ChosenAddress) {
    ChosenAddress[ChosenAddress["SystemNormalized"] = 0] = "SystemNormalized";
    ChosenAddress[ChosenAddress["UserInput"] = 1] = "UserInput";
    return ChosenAddress;
}({});
var $a4c47930ee9facdd$export$804a92ba667853be = /*#__PURE__*/ function(AddressError) {
    AddressError["Empty"] = "ADDRESS_ERROR_EMPTY";
    return AddressError;
}({});
var $a4c47930ee9facdd$export$4b2f75d0e5275120 = /*#__PURE__*/ function(AddressField) {
    AddressField["AddressLine1"] = "addressLine1";
    AddressField["AddressLine2"] = "addressLine2";
    AddressField["AdministrativeDistrictLevel1"] = "administrativeDistrictLevel1";
    AddressField["Locality"] = "locality";
    AddressField["PostalCode"] = "postalCode";
    return AddressField;
}({});
const $a4c47930ee9facdd$export$36d128238e6b60f5 = {
    address: (0, $04e03da92c8def10$export$1d6b20d87bad724b).create({
        // TODO(cvu): Support other countries in the future
        // https://jira.sqprod.co/browse/SQCARD-2656
        countryCode: (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US
    }),
    loading: false,
    // TODO(cvu): use when normalizing address is supported and set to SystemNormalized
    chosenAddress: 1,
    countryAddressData: null,
    normalizedAddress: null,
    screen: 0,
    validation: {
        errors: {
            ["addressLine1"]: [],
            ["administrativeDistrictLevel1"]: [],
            ["locality"]: [],
            ["postalCode"]: []
        },
        valid: true
    }
};
const $a4c47930ee9facdd$export$e6a0daad8304de = (overrides = {})=>({
        ...$a4c47930ee9facdd$export$36d128238e6b60f5,
        ...overrides
    });
const $a4c47930ee9facdd$export$7b943f50522d3fc4 = (countryAddressData)=>countryAddressData.admin1Values.map((admin1Value)=>admin1Value.value);
var $a4c47930ee9facdd$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Done"] = "CARD_SHIPPING_DONE";
    ActionType["Error"] = "CARD_SHIPPING_ERROR";
    ActionType["Initialize"] = "CARD_SHIPPING_INITIALIZE";
    ActionType["GetCountryAddressDataReceived"] = "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_RECEIVED";
    ActionType["GetCountryAddressDataRejected"] = "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_REJECTED";
    ActionType["NavigateToScreen"] = "CARD_SHIPPING_NAVIGATE_TO_SCREEN";
    ActionType["UserChangeAddress"] = "CARD_SHIPPING_USER_CHANGE_ADDRESS";
    ActionType["UserChangeChosenAddress"] = "CARD_SHIPPING_USER_CHANGE_CHOSEN_ADDRESS";
    ActionType["UserClickNextButton"] = "CARD_SHIPPING_USER_CLICK_NEXT_BUTTON";
    ActionType["ValidateAddressReceived"] = "CARD_SHIPPING_VALIDATE_ADDRESS_RECEIVED";
    ActionType["ValidateAddressRejected"] = "CARD_SHIPPING_VALIDATE_ADDRESS_REJECTED";
    return ActionType;
}({});
const $a4c47930ee9facdd$export$8789045e6aca717c = ()=>({
        type: "CARD_SHIPPING_DONE"
    });
const $a4c47930ee9facdd$export$2be98aef2d1db8da = ()=>({
        type: "CARD_SHIPPING_ERROR"
    });
const $a4c47930ee9facdd$export$c81c36414a1e3192 = ()=>({
        type: "CARD_SHIPPING_INITIALIZE"
    });
const $a4c47930ee9facdd$export$4551d583fda7b1a7 = (response)=>({
        type: "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_RECEIVED",
        response: response
    });
const $a4c47930ee9facdd$export$d5e8efdb3deefa9c = ()=>({
        type: "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_REJECTED"
    });
const $a4c47930ee9facdd$export$a7b94443be12fd7b = (screen)=>({
        type: "CARD_SHIPPING_NAVIGATE_TO_SCREEN",
        screen: screen
    });
const $a4c47930ee9facdd$export$24e513df93afa94e = (chosenAddress)=>({
        type: "CARD_SHIPPING_USER_CHANGE_CHOSEN_ADDRESS",
        chosenAddress: chosenAddress
    });
const $a4c47930ee9facdd$export$426fffe680412262 = (field, value)=>({
        type: "CARD_SHIPPING_USER_CHANGE_ADDRESS",
        field: field,
        value: value
    });
const $a4c47930ee9facdd$export$848ce7d6602fe3bd = ()=>({
        type: "CARD_SHIPPING_USER_CLICK_NEXT_BUTTON"
    });
function $a4c47930ee9facdd$var$handleInitialize(context, state) {
    const { countryAddressData: countryAddressData } = state;
    if (countryAddressData == null) {
        const work = ()=>{
            const response = context.webService.getCountryAddressData((0, $fce501362cc81cfc$export$be0c7e46b391ca72).create({
                // TODO(cvu): Support other countries in the future
                // https://jira.sqprod.co/browse/SQCARD-2656
                countryCode: (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US
            })).then($a4c47930ee9facdd$export$4551d583fda7b1a7, $a4c47930ee9facdd$export$d5e8efdb3deefa9c);
            return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
        };
        return [
            state,
            work
        ];
    }
    return [
        state,
        null
    ];
}
function $a4c47930ee9facdd$var$handleGetCountryAddressDataReceived(state, action) {
    const countryAddressData = action.response.countryAddressData || null;
    return [
        {
            ...state,
            countryAddressData: countryAddressData
        },
        null
    ];
}
function $a4c47930ee9facdd$var$handleUserChangeAddress(state, action) {
    const { address: address } = state;
    const addressRecord = address.toJSON();
    switch(action.field){
        case "addressLine1":
            addressRecord.addressLine1 = action.value;
            break;
        case "addressLine2":
            addressRecord.addressLine2 = action.value;
            break;
        case "postalCode":
            addressRecord.postalCode = action.value;
            break;
        case "administrativeDistrictLevel1":
            addressRecord.administrativeDistrictLevel1 = action.value;
            break;
        case "locality":
            addressRecord.locality = action.value;
            break;
    }
    return [
        {
            ...state,
            address: (0, $04e03da92c8def10$export$1d6b20d87bad724b).fromObject(addressRecord)
        },
        null
    ];
}
function $a4c47930ee9facdd$var$handleUserClickNextButton(context, state) {
    const { address: address, screen: screen } = state;
    if (screen === 0) {
        const validation = (0, $a9356ac90e965f5c$export$c8bac1d5c31c83a1)(address);
        const work = ()=>{
            if (!validation.valid) return null;
            return $a4c47930ee9facdd$export$8789045e6aca717c();
        };
        return [
            {
                ...state,
                loading: validation.valid,
                validation: validation
            },
            work
        ];
    }
    return [
        state,
        $a4c47930ee9facdd$export$8789045e6aca717c
    ];
}
const $a4c47930ee9facdd$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "CARD_SHIPPING_DONE":
            case "CARD_SHIPPING_ERROR":
                return [
                    state,
                    null
                ];
            case "CARD_SHIPPING_INITIALIZE":
                return $a4c47930ee9facdd$var$handleInitialize(context, state);
            case "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_RECEIVED":
                return $a4c47930ee9facdd$var$handleGetCountryAddressDataReceived(state, action);
            case "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_REJECTED":
                return [
                    state,
                    null
                ];
            case "CARD_SHIPPING_NAVIGATE_TO_SCREEN":
                {
                    const { screen: screen } = action;
                    return [
                        {
                            ...state,
                            screen: screen
                        },
                        null
                    ];
                }
            case "CARD_SHIPPING_USER_CHANGE_ADDRESS":
                return $a4c47930ee9facdd$var$handleUserChangeAddress(state, action);
            case "CARD_SHIPPING_USER_CHANGE_CHOSEN_ADDRESS":
                return [
                    {
                        ...state,
                        chosenAddress: action.chosenAddress
                    },
                    null
                ];
            case "CARD_SHIPPING_USER_CLICK_NEXT_BUTTON":
                return $a4c47930ee9facdd$var$handleUserClickNextButton(context, state);
        }
    };



var $c27a3102df5220b7$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOT_DONE"] = 0] = "NOT_DONE";
    DoneState[DoneState["DONE"] = 1] = "DONE";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});
var $c27a3102df5220b7$export$a455218a85c89869 = /*#__PURE__*/ function(Field) {
    Field["FirstName"] = "firstName";
    Field["LastName"] = "lastName";
    return Field;
}({});
var $c27a3102df5220b7$export$e4493d7100331504 = /*#__PURE__*/ function(VerifyNameError) {
    VerifyNameError[VerifyNameError["VERIFY_NAME_ERROR_EMPTY"] = 0] = "VERIFY_NAME_ERROR_EMPTY";
    return VerifyNameError;
}({});
const $c27a3102df5220b7$export$36d128238e6b60f5 = {
    done: 0,
    ["firstName"]: "",
    ["lastName"]: "",
    loading: false,
    validation: {
        errors: {
            firstName: [],
            lastName: []
        },
        valid: true
    }
};
const $c27a3102df5220b7$export$e6a0daad8304de = (overrides = {})=>({
        ...$c27a3102df5220b7$export$36d128238e6b60f5,
        ...overrides
    });
const $c27a3102df5220b7$export$cd31394628980743 = (field, state)=>{
    const { validation: validation } = state;
    return {
        ...validation,
        errors: {
            ...validation.errors,
            [field]: []
        }
    };
};
const $c27a3102df5220b7$export$c8bac1d5c31c83a1 = (state)=>{
    const firstName = state["firstName"];
    const lastName = state["lastName"];
    const firstNameErrors = [];
    const lastNameErrors = [];
    if (firstName === "") firstNameErrors.push(0);
    if (lastName === "") lastNameErrors.push(0);
    const valid = firstNameErrors.length === 0 && lastNameErrors.length === 0;
    return {
        errors: {
            ["firstName"]: firstNameErrors,
            ["lastName"]: lastNameErrors
        },
        valid: valid
    };
};
var $c27a3102df5220b7$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Done"] = "VERIFY_NAME_DONE";
    ActionType["Initialize"] = "VERIFY_NAME_INITIALIZE";
    ActionType["UpdatePersonProfileReceived"] = "VERIFY_NAME_UPDATE_PERSON_PROFILE_RECEIVED";
    ActionType["UpdatePersonProfileRejected"] = "VERIFY_NAME_UPDATE_PERSON_PROFILE_REJECTED";
    ActionType["UserChangeInputFieldValue"] = "VERIFY_NAME_USER_CHANGE_INPUT_FIELD_VALUE";
    ActionType["UserClickNext"] = "VERIFY_NAME_USER_CLICK_NEXT";
    return ActionType;
}({});
const $c27a3102df5220b7$export$8789045e6aca717c = (doneState)=>({
        type: "VERIFY_NAME_DONE",
        doneState: doneState
    });
const $c27a3102df5220b7$export$c81c36414a1e3192 = (user)=>({
        type: "VERIFY_NAME_INITIALIZE",
        user: user
    });
const $c27a3102df5220b7$export$db85caff4653ef45 = (response)=>({
        type: "VERIFY_NAME_UPDATE_PERSON_PROFILE_RECEIVED",
        response: response
    });
const $c27a3102df5220b7$export$c68fed2e072f5d53 = (error)=>({
        type: "VERIFY_NAME_UPDATE_PERSON_PROFILE_REJECTED",
        error: error
    });
const $c27a3102df5220b7$export$49d8151683dabb69 = (field, value)=>({
        type: "VERIFY_NAME_USER_CHANGE_INPUT_FIELD_VALUE",
        field: field,
        value: value
    });
const $c27a3102df5220b7$export$69864c1ae20800a8 = ()=>({
        type: "VERIFY_NAME_USER_CLICK_NEXT"
    });
function $c27a3102df5220b7$var$handleDone(state, { doneState: doneState }) {
    return [
        {
            ...state,
            done: doneState
        },
        null
    ];
}
function $c27a3102df5220b7$var$handleInitialize(context, { user: user }) {
    const { first: first = "", last: last = "" } = user.name;
    return [
        {
            ...$c27a3102df5220b7$export$36d128238e6b60f5,
            ["firstName"]: first,
            ["lastName"]: last
        },
        null
    ];
}
function $c27a3102df5220b7$var$handleUpdatePersonProfileReceived(context, state, { response: response }) {
    const profile = response.profile;
    if (profile == null) {
        context.sentry.captureException("Card issuing - Person profile missing from update response");
        return [
            {
                ...state,
                loading: false
            },
            ()=>$c27a3102df5220b7$export$8789045e6aca717c(2)
        ];
    }
    if (profile.name == null) {
        context.sentry.captureException("Card issuing - Person profile missing name");
        return [
            {
                ...state,
                loading: false
            },
            ()=>$c27a3102df5220b7$export$8789045e6aca717c(2)
        ];
    }
    const { firstName: firstName, lastName: lastName } = profile.name;
    return [
        {
            ...state,
            ["firstName"]: firstName,
            ["lastName"]: lastName,
            loading: false
        },
        ()=>$c27a3102df5220b7$export$8789045e6aca717c(1)
    ];
}
function $c27a3102df5220b7$var$handleUpdatePersonProfileRejected(context, state, { error: error }) {
    context.sentry.captureException(error);
    return [
        {
            ...state,
            loading: false
        },
        ()=>$c27a3102df5220b7$export$8789045e6aca717c(2)
    ];
}
function $c27a3102df5220b7$var$handleUserChangeInputFieldValue(state, action) {
    const { field: field, value: value } = action;
    const nextState = {
        ...state,
        [field]: value
    };
    // revalidate to remove any error highlighting
    const validation = $c27a3102df5220b7$export$cd31394628980743(field, state);
    return [
        {
            ...nextState,
            validation: validation
        },
        null
    ];
}
function $c27a3102df5220b7$var$handleUserClickNext(context, state) {
    const validation = $c27a3102df5220b7$export$c8bac1d5c31c83a1(state);
    const work = ()=>{
        if (!validation.valid) return null;
        const { firstName: firstName, lastName: lastName } = state;
        return context.personProfileService.updatePersonProfile((0, $3f95b099726a1553$export$2d30a2bab0b6db0).create({
            idempotenceKey: context.uuid(),
            profile: (0, $3f95b099726a1553$export$5120f2d0b8d4cab8).create({
                name: (0, $3f95b099726a1553$export$5120f2d0b8d4cab8).Name.create({
                    firstName: firstName,
                    lastName: lastName
                })
            })
        })).then($c27a3102df5220b7$export$db85caff4653ef45, $c27a3102df5220b7$export$c68fed2e072f5d53);
    };
    // Do not trigger loading state if validation failure.
    return [
        {
            ...state,
            loading: validation.valid,
            validation: validation
        },
        work
    ];
}
const $c27a3102df5220b7$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "VERIFY_NAME_DONE":
                return $c27a3102df5220b7$var$handleDone(state, action);
            case "VERIFY_NAME_INITIALIZE":
                return $c27a3102df5220b7$var$handleInitialize(context, action);
            case "VERIFY_NAME_UPDATE_PERSON_PROFILE_RECEIVED":
                return $c27a3102df5220b7$var$handleUpdatePersonProfileReceived(context, state, action);
            case "VERIFY_NAME_UPDATE_PERSON_PROFILE_REJECTED":
                return $c27a3102df5220b7$var$handleUpdatePersonProfileRejected(context, state, action);
            case "VERIFY_NAME_USER_CHANGE_INPUT_FIELD_VALUE":
                return $c27a3102df5220b7$var$handleUserChangeInputFieldValue(state, action);
            case "VERIFY_NAME_USER_CLICK_NEXT":
                return $c27a3102df5220b7$var$handleUserClickNext(context, state);
        }
    };


var $b2490fa107d6478d$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["None"] = 0] = "None";
    Screen[Screen["VerifyName"] = 1] = "VerifyName";
    Screen[Screen["Customization"] = 2] = "Customization";
    Screen[Screen["ShippingAddress"] = 3] = "ShippingAddress";
    Screen[Screen["SetPin"] = 4] = "SetPin";
    Screen[Screen["ConfirmPin"] = 5] = "ConfirmPin";
    Screen[Screen["OrderConfirmation"] = 6] = "OrderConfirmation";
    Screen[Screen["AddToDigitalWallet"] = 7] = "AddToDigitalWallet";
    Screen[Screen["Error"] = 8] = "Error";
    return Screen;
}({});
const $b2490fa107d6478d$export$49d8745ae22a51ab = [
    2,
    3,
    6
];
const $b2490fa107d6478d$export$3ef250ace880f95b = [
    8
];
const $b2490fa107d6478d$var$PIN_LENGTH = 4;
var $b2490fa107d6478d$export$99337e8421d6e839 = /*#__PURE__*/ function(CardIssuingError) {
    CardIssuingError[CardIssuingError["None"] = 0] = "None";
    CardIssuingError[CardIssuingError["Generic"] = 1] = "Generic";
    CardIssuingError[CardIssuingError["Ineligible"] = 2] = "Ineligible";
    return CardIssuingError;
}({});
const $b2490fa107d6478d$var$INITIAL_STATE = {
    balanceId: "",
    businessName: "",
    cardCustomizationState: $d50f52fc18ffa921$export$e6a0daad8304de(),
    cardInvitationToken: "",
    cardShippingState: $a4c47930ee9facdd$export$e6a0daad8304de(),
    cardToken: "",
    confirmPin: "",
    done: false,
    error: 0,
    loading: false,
    modalOpen: false,
    navigation: {
        current: 0,
        flow: []
    },
    pin: "",
    verifyNameState: $c27a3102df5220b7$export$e6a0daad8304de()
};
const $b2490fa107d6478d$export$e6a0daad8304de = (overrides = {})=>({
        ...$b2490fa107d6478d$var$INITIAL_STATE,
        ...overrides
    });
const $b2490fa107d6478d$export$477b3fce3049067a = (state)=>{
    const { current: current, flow: flow } = state.navigation;
    const currentIndex = flow.indexOf(current);
    return currentIndex === 0 || currentIndex === flow.length - 1;
};
const $b2490fa107d6478d$export$f3db0dc3a05c157d = (state)=>{
    const { current: current, flow: flow } = state.navigation;
    const currentIndex = flow.indexOf(current);
    return currentIndex !== flow.length - 1;
};
var $b2490fa107d6478d$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["ClaimCardInvitationReceived"] = "CLAIM_CARD_INVITATION_RECEIVED";
    ActionType["ClaimCardInvitationRejected"] = "CLAIM_CARD_INVITATION_REJECTED";
    ActionType["CreateCardResponseReceived"] = "CREATE_CARD_RESPONSE_RECEIVED";
    ActionType["CreateCardResponseRejected"] = "CREATE_CARD_RESPONSE_REJECTED";
    ActionType["Done"] = "DONE";
    ActionType["GetOrCreateComplianceVerificationReceived"] = "GET_OR_CREATE_COMPLIANCE_VERIFICATION_RECEIVED";
    ActionType["GetOrCreateComplianceVerificationRejected"] = "GET_OR_CREATE_COMPLIANCE_VERIFICATION_REJECTED";
    ActionType["Initialize"] = "INITIALIZE";
    ActionType["NavigateBack"] = "NAVIGATE_BACK";
    ActionType["NavigateNext"] = "NAVIGATE_NEXT";
    ActionType["NavigateToScreen"] = "NAVIGATE_TO_SCREEN";
    ActionType["OnCardShippingDone"] = "ON_CARD_SHIPPING_DONE";
    ActionType["OnVerifyNameDone"] = "ON_VERIFY_NAME_DONE";
    ActionType["SetError"] = "SET_ERROR";
    ActionType["ToggleModal"] = "TOGGLE_MODAL";
    ActionType["UserChangeConfirmPin"] = "USER_CHANGE_CONFIRM_PIN";
    ActionType["UserChangeSetPin"] = "USER_CHANGE_SET_PIN";
    ActionType["UserClickAddToDigitalWallet"] = "USER_CLICK_ADD_TO_DIGITAL_WALLET";
    ActionType["UserClickBackButton"] = "USER_CLICK_BACK_BUTTON";
    ActionType["UserClickCloseButton"] = "USER_CLICK_CLOSE_BUTTON";
    ActionType["UserClickNextButton"] = "USER_CLICK_NEXT_BUTTON";
    ActionType["UserClickSkipAddToDigitalWallet"] = "USER_CLICK_SKIP_ADD_TO_DIGITAL_WALLET";
    return ActionType;
}({});
const $b2490fa107d6478d$export$48f9bc309d916c4e = (response)=>({
        type: "CLAIM_CARD_INVITATION_RECEIVED",
        response: response
    });
const $b2490fa107d6478d$export$21eb82a138d815c3 = (error)=>({
        type: "CLAIM_CARD_INVITATION_REJECTED",
        error: error
    });
const $b2490fa107d6478d$export$57a2388bf0bd5829 = (response)=>({
        type: "CREATE_CARD_RESPONSE_RECEIVED",
        response: response
    });
const $b2490fa107d6478d$export$9d65633e27e46a5a = (error)=>({
        type: "CREATE_CARD_RESPONSE_REJECTED",
        error: error
    });
const $b2490fa107d6478d$export$d3d98dcc45b4508e = (response)=>({
        type: "GET_OR_CREATE_COMPLIANCE_VERIFICATION_RECEIVED",
        response: response
    });
const $b2490fa107d6478d$export$7ae8da9fc164fe4a = (error)=>({
        type: "GET_OR_CREATE_COMPLIANCE_VERIFICATION_REJECTED",
        error: error
    });
const $b2490fa107d6478d$export$8789045e6aca717c = ()=>({
        type: "DONE"
    });
const $b2490fa107d6478d$export$c81c36414a1e3192 = (balanceId, businessName, cardInvitationToken, user, requiresVerification)=>({
        type: "INITIALIZE",
        balanceId: balanceId,
        businessName: businessName,
        cardInvitationToken: cardInvitationToken,
        user: user,
        requiresVerification: requiresVerification
    });
const $b2490fa107d6478d$export$5305586e9456f3b2 = ()=>({
        type: "NAVIGATE_BACK"
    });
const $b2490fa107d6478d$export$48b2ba392cc5989f = ()=>({
        type: "NAVIGATE_NEXT"
    });
const $b2490fa107d6478d$export$a7b94443be12fd7b = (screen)=>({
        type: "NAVIGATE_TO_SCREEN",
        screen: screen
    });
const $b2490fa107d6478d$export$8e55300aef6a3a48 = ()=>({
        type: "ON_CARD_SHIPPING_DONE"
    });
const $b2490fa107d6478d$export$d2125e9041c4ce = ()=>({
        type: "ON_VERIFY_NAME_DONE"
    });
const $b2490fa107d6478d$export$8f12bad0f165bfad = (error)=>({
        type: "SET_ERROR",
        error: error
    });
const $b2490fa107d6478d$export$2085928ad4455e61 = (value)=>({
        type: "TOGGLE_MODAL",
        value: value
    });
const $b2490fa107d6478d$export$7fccafb1bae4775a = (confirmPin)=>({
        type: "USER_CHANGE_CONFIRM_PIN",
        confirmPin: confirmPin
    });
const $b2490fa107d6478d$export$5ad45d9849095e2d = (pin)=>({
        type: "USER_CHANGE_SET_PIN",
        pin: pin
    });
const $b2490fa107d6478d$export$ecbea34edac74891 = ()=>({
        type: "USER_CLICK_BACK_BUTTON"
    });
const $b2490fa107d6478d$export$34ed016b7ffc8a51 = ()=>({
        type: "USER_CLICK_CLOSE_BUTTON"
    });
const $b2490fa107d6478d$export$848ce7d6602fe3bd = ()=>({
        type: "USER_CLICK_NEXT_BUTTON"
    });
function $b2490fa107d6478d$var$handleCreateCardResponseReceived(context, state, action) {
    const { card: card, errors: errors } = action.response;
    if (errors.length) {
        const hasAuthChallengeError = errors.includes((0, $d272bac0a1712861$export$77c2e9a08149a1ad).CreateCardError.CREATE_CARD_ERROR_AUTHORIZATION_CHALLENGED);
        const errorType = hasAuthChallengeError ? 2 : 1;
        return [
            state,
            ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(errorType)
        ];
    }
    if (!card?.id) return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
    const work = ()=>{
        const { userCardInvitationService: userCardInvitationService } = context;
        const request = (0, $bbc3574921766dd2$export$818c5a2d30ed1bb0).create({
            cardInvitationId: state.cardInvitationToken,
            cardToken: card.id
        });
        const response = userCardInvitationService.claimCardInvitation(request).then($b2490fa107d6478d$export$48f9bc309d916c4e, $b2490fa107d6478d$export$21eb82a138d815c3);
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
    };
    return [
        {
            ...state,
            cardToken: card.id
        },
        work
    ];
}
function $b2490fa107d6478d$var$handleClaimCardInvitationReceived(state) {
    return [
        {
            ...state,
            loading: false
        },
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
}
function $b2490fa107d6478d$var$handleClaimCardInvitationRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleCreateCardResponseRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleDone(state) {
    return [
        {
            ...state,
            done: true
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationReceived(context, state, action) {
    const { result: result } = action.response;
    switch(result){
        case (0, $81287a0f87730909$export$5a81323f8347f22).ComplianceResult.COMPLIANCE_RESULT_UNKNOWN:
            return [
                state,
                ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
            ];
        case (0, $81287a0f87730909$export$5a81323f8347f22).ComplianceResult.COMPLIANCE_RESULT_FAILED:
            return [
                state,
                ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(2)
            ];
        case (0, $81287a0f87730909$export$5a81323f8347f22).ComplianceResult.COMPLIANCE_RESULT_PASSED:
            {
                const { cardCustomizationState: cardCustomizationState, cardInvitationToken: cardInvitationToken, balanceId: balanceId, cardShippingState: cardShippingState } = state;
                const shippingAddress = cardShippingState.address;
                try {
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(cardCustomizationState.cardCustomizationToken.length > 0, "Card issuing - card customization token is empty");
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(cardInvitationToken.length > 0, "Card issuing - card invitation token is empty");
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(shippingAddress, "Card issuing - chosen address is null");
                } catch (e) {
                    context.sentry.captureException(e);
                    return [
                        {
                            ...state,
                            loading: false
                        },
                        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
                    ];
                }
                const work = ()=>{
                    const { cardManagementService: cardManagementService } = context;
                    const { businessName: businessName, verifyNameState: verifyNameState } = state;
                    const cardHolderName = (0, $f52070b5f7ea08cf$export$525011322c57ec0f)(verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.FirstName], verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.LastName]);
                    const request = (0, $d272bac0a1712861$export$531aee450bc3dbd4).create({
                        balanceId: balanceId,
                        cardCustomization: (0, $d272bac0a1712861$export$f27319a4138ec79f).create({
                            id: cardCustomizationState.cardCustomizationToken,
                            cardTexts: [
                                {
                                    text: businessName,
                                    type: (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME
                                },
                                {
                                    text: cardHolderName,
                                    type: (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME
                                }
                            ]
                        }),
                        idempotenceKey: context.uuid(),
                        shippingAddress: // TODO(cvu): replace when shipping is implemented
                        shippingAddress
                    });
                    const response = cardManagementService.createCard(request).then($b2490fa107d6478d$export$57a2388bf0bd5829, $b2490fa107d6478d$export$9d65633e27e46a5a);
                    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
                };
                return [
                    {
                        ...state,
                        loading: true
                    },
                    work
                ];
            }
    }
}
function $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleInitialize(context, state, action) {
    const { balanceId: balanceId, businessName: businessName, cardInvitationToken: cardInvitationToken, requiresVerification: requiresVerification, user: user } = action;
    const flow = requiresVerification ? [
        1,
        ...$b2490fa107d6478d$export$49d8745ae22a51ab
    ] : [
        ...$b2490fa107d6478d$export$49d8745ae22a51ab
    ];
    const newState = $b2490fa107d6478d$export$e6a0daad8304de();
    const work = ()=>{
        return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(// Always initialize name state with user data, even when skipping name verification screen
        // This ensures that the card holder name can be set correctly when creating the card
        // whether the name verification screen is skipped or not.
        $c27a3102df5220b7$export$c81c36414a1e3192(user), $d50f52fc18ffa921$export$c81c36414a1e3192(cardInvitationToken, (0, $f52070b5f7ea08cf$export$155800cbebf9d04f)(user)), $a4c47930ee9facdd$export$c81c36414a1e3192(), $b2490fa107d6478d$export$a7b94443be12fd7b(flow[0]));
    };
    // Initialize will reset state
    return [
        {
            ...newState,
            businessName: businessName,
            cardInvitationToken: cardInvitationToken,
            balanceId: balanceId,
            navigation: {
                ...newState.navigation,
                flow: flow
            }
        },
        work
    ];
}
function $b2490fa107d6478d$var$handleNavigateBack(context, state) {
    const { navigation: navigation } = state;
    const { current: current, flow: flow } = navigation;
    const currentIndex = flow.indexOf(current);
    const prevIndex = currentIndex - 1;
    if (prevIndex > -1) {
        if (current === 3) {
            if (state.cardShippingState.screen === $a4c47930ee9facdd$export$a98515d67472a41f.ConfirmAddress) return [
                state,
                ()=>$a4c47930ee9facdd$export$a7b94443be12fd7b($a4c47930ee9facdd$export$a98515d67472a41f.EnterAddress)
            ];
        }
        return [
            state,
            ()=>$b2490fa107d6478d$export$a7b94443be12fd7b(flow[prevIndex])
        ];
    }
    context.sentry.captureException(`Tried to navigate back to screen index out of bounds`);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleNavigateNext(context, state) {
    const { navigation: navigation } = state;
    const { current: current, flow: flow } = navigation;
    const currentIndex = flow.indexOf(current);
    const nextIndex = currentIndex + 1;
    if (nextIndex < flow.length) return [
        state,
        ()=>$b2490fa107d6478d$export$a7b94443be12fd7b(flow[nextIndex])
    ];
    else return [
        state,
        $b2490fa107d6478d$export$8789045e6aca717c
    ];
}
function $b2490fa107d6478d$var$handleNavigateToScreen(context, state, action) {
    const { screen: screen } = action;
    const { navigation: navigation } = state;
    if (!navigation.flow.includes(screen)) {
        context.sentry.captureException(`Tried to navigate to screen, ${screen}, not in flow [${navigation.flow.toString()}]`);
        return [
            state,
            ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
        ];
    }
    return [
        {
            ...state,
            navigation: {
                ...navigation,
                current: screen
            }
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleOnCardShippingDone(context, state) {
    const { cardInvitationToken: cardInvitationToken, cardShippingState: cardShippingState } = state;
    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(cardInvitationToken.length > 0);
    const work = ()=>{
        const { bankingWebComplianceService: bankingWebComplianceService } = context;
        const request = (0, $81287a0f87730909$export$32eac23879e45813).create({
            cardInvitationToken: cardInvitationToken,
            globalAddress: cardShippingState.address
        });
        const response = bankingWebComplianceService.getOrCreateComplianceVerification(request).then($b2490fa107d6478d$export$d3d98dcc45b4508e, $b2490fa107d6478d$export$7ae8da9fc164fe4a);
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
    };
    return [
        {
            ...state,
            loading: true
        },
        work
    ];
}
function $b2490fa107d6478d$var$handleOnVerifyNameDone(context, state) {
    const { verifyNameState: verifyNameState } = state;
    if (verifyNameState.done === $c27a3102df5220b7$export$f93c40fda808dd0c.ERROR) return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
    const firstName = verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.FirstName];
    const lastName = verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.LastName];
    return [
        {
            ...state,
            cardCustomizationState: $d50f52fc18ffa921$export$e6a0daad8304de({
                ...state.cardCustomizationState,
                signatureText: (0, $f52070b5f7ea08cf$export$525011322c57ec0f)(firstName, lastName)
            }),
            verifyNameState: verifyNameState
        },
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
}
function $b2490fa107d6478d$var$handleSetError(state, action) {
    const { error: error } = action;
    const navigation = {
        current: $b2490fa107d6478d$export$3ef250ace880f95b[0],
        flow: $b2490fa107d6478d$export$3ef250ace880f95b
    };
    return [
        {
            ...state,
            navigation: navigation,
            error: error
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleToggleModal(state, { value: value }) {
    return [
        {
            ...state,
            modalOpen: value ?? !state.modalOpen
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleUserChangeConfirmPin(state, action) {
    const { pin: pin } = state;
    const { confirmPin: confirmPin } = action;
    if (pin === confirmPin) return [
        {
            ...state,
            confirmPin: confirmPin
        },
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
    else if (confirmPin.length < $b2490fa107d6478d$var$PIN_LENGTH) return [
        {
            ...state,
            confirmPin: confirmPin
        },
        null
    ];
    // TODO(cvu): add pin does not match validation
    return [
        {
            ...state,
            confirmPin: confirmPin
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleUserChangeSetPin(state, action) {
    const { pin: pin } = action;
    // TODO(cvu): add complex pin validation
    const maybeNextAction = pin.length === $b2490fa107d6478d$var$PIN_LENGTH ? $b2490fa107d6478d$export$48b2ba392cc5989f : null;
    return [
        {
            ...state,
            pin: pin
        },
        maybeNextAction
    ];
}
function $b2490fa107d6478d$var$handleUserClickCloseButton(state) {
    const { current: current, flow: flow } = state.navigation;
    if (current === flow[flow.length - 1]) return [
        state,
        ()=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)($b2490fa107d6478d$export$2085928ad4455e61(false), $b2490fa107d6478d$export$8789045e6aca717c())
    ];
    return [
        state,
        ()=>$b2490fa107d6478d$export$2085928ad4455e61(false)
    ];
}
function $b2490fa107d6478d$var$handleUserClickNextButton(context, state) {
    return [
        state,
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
}
const $b2490fa107d6478d$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "CLAIM_CARD_INVITATION_RECEIVED":
                return $b2490fa107d6478d$var$handleClaimCardInvitationReceived(state);
            case "CLAIM_CARD_INVITATION_REJECTED":
                return $b2490fa107d6478d$var$handleClaimCardInvitationRejected(context, state, action);
            case "CREATE_CARD_RESPONSE_RECEIVED":
                return $b2490fa107d6478d$var$handleCreateCardResponseReceived(context, state, action);
            case "CREATE_CARD_RESPONSE_REJECTED":
                return $b2490fa107d6478d$var$handleCreateCardResponseRejected(context, state, action);
            case "DONE":
                return $b2490fa107d6478d$var$handleDone(state);
            case "GET_OR_CREATE_COMPLIANCE_VERIFICATION_RECEIVED":
                return $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationReceived(context, state, action);
            case "GET_OR_CREATE_COMPLIANCE_VERIFICATION_REJECTED":
                return $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationRejected(context, state, action);
            case "INITIALIZE":
                return $b2490fa107d6478d$var$handleInitialize(context, state, action);
            case "NAVIGATE_BACK":
                return $b2490fa107d6478d$var$handleNavigateBack(context, state);
            case "NAVIGATE_NEXT":
                return $b2490fa107d6478d$var$handleNavigateNext(context, state);
            case "NAVIGATE_TO_SCREEN":
                return $b2490fa107d6478d$var$handleNavigateToScreen(context, state, action);
            case "ON_CARD_SHIPPING_DONE":
                return $b2490fa107d6478d$var$handleOnCardShippingDone(context, state);
            case "ON_VERIFY_NAME_DONE":
                return $b2490fa107d6478d$var$handleOnVerifyNameDone(context, state);
            case "SET_ERROR":
                return $b2490fa107d6478d$var$handleSetError(state, action);
            case "TOGGLE_MODAL":
                return $b2490fa107d6478d$var$handleToggleModal(state, action);
            case "USER_CHANGE_CONFIRM_PIN":
                return $b2490fa107d6478d$var$handleUserChangeConfirmPin(state, action);
            case "USER_CHANGE_SET_PIN":
                return $b2490fa107d6478d$var$handleUserChangeSetPin(state, action);
            case "USER_CLICK_ADD_TO_DIGITAL_WALLET":
                // TODO(cvu): Add functionally for this action
                return [
                    state,
                    null
                ];
            case "USER_CLICK_BACK_BUTTON":
                return [
                    state,
                    $b2490fa107d6478d$export$5305586e9456f3b2
                ];
            case "USER_CLICK_CLOSE_BUTTON":
                return $b2490fa107d6478d$var$handleUserClickCloseButton(state);
            case "USER_CLICK_NEXT_BUTTON":
                return $b2490fa107d6478d$var$handleUserClickNextButton(context, state);
            case "USER_CLICK_SKIP_ADD_TO_DIGITAL_WALLET":
                // TODO(cvu): Add functionally for this action
                return [
                    state,
                    null
                ];
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.CreateCardCustomizationRejected:
                {
                    const [cardCustomizationState] = $d50f52fc18ffa921$export$722fbec263ad908a({
                        bankingWebCardService: context.bankingWebCardService,
                        textRenderer: context.textRenderer,
                        uuid: context.uuid
                    })(state.cardCustomizationState, action);
                    context.sentry.captureException(action.error);
                    return [
                        {
                            ...state,
                            cardCustomizationState: cardCustomizationState
                        },
                        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
                    ];
                }
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.CreateCardCustomizationReceived:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.Initialize:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserChangeSignatureFont:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserChangeSignatureText:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserClickNextAction:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserToggleCustomizeSignature:
                {
                    const [cardCustomizationState, nextAction] = $d50f52fc18ffa921$export$722fbec263ad908a({
                        bankingWebCardService: context.bankingWebCardService,
                        textRenderer: context.textRenderer,
                        uuid: context.uuid
                    })(state.cardCustomizationState, action);
                    return [
                        {
                            ...state,
                            cardCustomizationState: cardCustomizationState
                        },
                        nextAction
                    ];
                }
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.Done:
                {
                    const [cardCustomizationState] = $d50f52fc18ffa921$export$722fbec263ad908a({
                        bankingWebCardService: context.bankingWebCardService,
                        textRenderer: context.textRenderer,
                        uuid: context.uuid
                    })(state.cardCustomizationState, action);
                    return [
                        {
                            ...state,
                            cardCustomizationState: cardCustomizationState
                        },
                        $b2490fa107d6478d$export$48b2ba392cc5989f
                    ];
                }
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.Error:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.Done:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.Initialize:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.GetCountryAddressDataReceived:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.GetCountryAddressDataRejected:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.NavigateToScreen:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.UserChangeChosenAddress:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.UserChangeAddress:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.UserClickNextButton:
                {
                    const [cardShippingState, nextAction] = $a4c47930ee9facdd$export$722fbec263ad908a({
                        sentry: context.sentry,
                        webService: context.webService
                    })(state.cardShippingState, action);
                    if (action.type === $a4c47930ee9facdd$export$e4a712fff93fb00f.Done) return [
                        {
                            ...state,
                            cardShippingState: cardShippingState,
                            loading: true
                        },
                        $b2490fa107d6478d$export$8e55300aef6a3a48
                    ];
                    if (action.type === $a4c47930ee9facdd$export$e4a712fff93fb00f.Error) return [
                        {
                            ...state,
                            cardShippingState: cardShippingState
                        },
                        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
                    ];
                    return [
                        {
                            ...state,
                            cardShippingState: cardShippingState
                        },
                        nextAction
                    ];
                }
            case $c27a3102df5220b7$export$e4a712fff93fb00f.Done:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.Initialize:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UpdatePersonProfileReceived:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UpdatePersonProfileRejected:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UserChangeInputFieldValue:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UserClickNext:
                {
                    const [verifyNameState, nextAction] = $c27a3102df5220b7$export$722fbec263ad908a({
                        personProfileService: context.personProfileService,
                        sentry: context.sentry,
                        uuid: context.uuid
                    })(state.verifyNameState, action);
                    const work = action.type === $c27a3102df5220b7$export$e4a712fff93fb00f.Done ? $b2490fa107d6478d$export$d2125e9041c4ce : nextAction;
                    return [
                        {
                            ...state,
                            verifyNameState: verifyNameState
                        },
                        work
                    ];
                }
        }
    };
const $b2490fa107d6478d$var$cardIssuing = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($b2490fa107d6478d$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $b2490fa107d6478d$export$2e2bcd8739ae039 = $b2490fa107d6478d$var$cardIssuing;




const $01f0b782f211d659$var$foldOperators = (pipes)=>(source)=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(...pipes.map((pipe)=>source.pipe(pipe)));
// Combine multiple analytics signals into one.
const $01f0b782f211d659$var$analytics = (pipes)=>(source)=>source.pipe($01f0b782f211d659$var$foldOperators(pipes), (0, $4707859e785b3da6$export$18aef43295bbe906)());
var $01f0b782f211d659$export$2e2bcd8739ae039 = $01f0b782f211d659$var$analytics;








const $86e4772b0444d7da$var$enterLegalNamePageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>!before.modalOpen && after.modalOpen && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).VerifyName), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.EnterLegalName,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$enterLegalNameNextButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).VerifyName && action.type === (0, $c27a3102df5220b7$export$e4a712fff93fb00f).UserClickNext), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.EnterLegalName,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$personalizeCardPageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>before.navigation.current !== (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.PersonalizeCard,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$personalizeCardNextButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization && action.type === (0, $d50f52fc18ffa921$export$e4a712fff93fb00f).UserClickNextAction), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.PersonalizeCard,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$shippingDetailsPageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>before.navigation.current !== (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.ShippingDetails,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$shippingDetailsNextButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress && action.type === (0, $a4c47930ee9facdd$export$e4a712fff93fb00f).UserClickNextButton), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.ShippingDetails,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$orderConfirmationPageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>before.navigation.current !== (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.OrderConfirmation,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$orderConfirmationDoneButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation && action.type === (0, $b2490fa107d6478d$export$e4a712fff93fb00f).Done), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.OrderConfirmation,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
var $86e4772b0444d7da$export$2e2bcd8739ae039 = [
    $86e4772b0444d7da$var$enterLegalNamePageView,
    $86e4772b0444d7da$var$enterLegalNameNextButtonClick,
    $86e4772b0444d7da$var$personalizeCardPageView,
    $86e4772b0444d7da$var$personalizeCardNextButtonClick,
    $86e4772b0444d7da$var$shippingDetailsPageView,
    $86e4772b0444d7da$var$shippingDetailsNextButtonClick,
    $86e4772b0444d7da$var$orderConfirmationPageView,
    $86e4772b0444d7da$var$orderConfirmationDoneButtonClick
];


(function(EventLogging) {
    (function(Action) {
        Action["Click"] = "Click";
        Action["View"] = "View";
    })(EventLogging.Action || (EventLogging.Action = {}));
    (function(Page) {
        Page["EnterLegalName"] = "Enter Legal Name";
        Page["PersonalizeCard"] = "Personalize Card";
        Page["ShippingDetails"] = "Shipping Details";
        Page["OrderConfirmation"] = "Order Confirmation";
    })(EventLogging.Page || (EventLogging.Page = {}));
    (function(Target) {
        Target["Next"] = "Next";
        Target["Done"] = "Done";
    })(EventLogging.Target || (EventLogging.Target = {}));
    (function(Feature) {
        Feature["CardOrdering"] = "Card Ordering";
    })(EventLogging.Feature || (EventLogging.Feature = {}));
    (function(CDP) {
        const eventName = (action, feature)=>`${action} ${feature}`;
        CDP.event = (args)=>{
            const feature = "Card Ordering";
            return {
                eventName: eventName(args.action, feature),
                eventProps: {
                    ...args,
                    applet: "Home",
                    feature: feature
                }
            };
        };
    })(EventLogging.CDP || (EventLogging.CDP = {}));
})($4bc04b71b868732d$export$b8bcf109fec61099 || ($4bc04b71b868732d$export$b8bcf109fec61099 = {}));
var $4bc04b71b868732d$export$2e2bcd8739ae039 = (0, $01f0b782f211d659$export$2e2bcd8739ae039)([
    ...(0, $86e4772b0444d7da$export$2e2bcd8739ae039)
]);
var $4bc04b71b868732d$export$b8bcf109fec61099;





var $df4c13d691d01291$exports = {};
var $a3b0f2fdf3961f6f$exports = {};


$df4c13d691d01291$exports["content"] = `IMiyZG_Page_content`;
$df4c13d691d01291$exports["header"] = `IMiyZG_Page_header`;
$df4c13d691d01291$exports["page"] = `IMiyZG_Page_page`;
for(let key in $a3b0f2fdf3961f6f$exports)if (key in $df4c13d691d01291$exports) $df4c13d691d01291$exports[key] += ' ' + $a3b0f2fdf3961f6f$exports[key];
else $df4c13d691d01291$exports[key] = $a3b0f2fdf3961f6f$exports[key];


function $10b264b7e14b606b$export$6955bcca4cd3539f({ header: header, loading: loading = false, className: className, children: children }) {
    const loadingIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$28c2b904b2ab5c88), {});
    return loading ? loadingIndicator : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($df4c13d691d01291$exports.page, className),
        children: [
            header && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $df4c13d691d01291$exports.header,
                children: header
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $df4c13d691d01291$exports.content,
                children: children
            })
        ]
    });
}












var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


function $01b628065e650f1c$export$20c0b5ff3d7d9924({ businessName: businessName, className: className, signatureDataUri: signatureDataUri }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "335",
        height: "208",
        viewBox: "0 0 335 208",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "335",
                height: "208",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M277.5 16C273.91 16 271 18.9102 271 22.5V57.5C271 61.0899 273.91 64 277.5 64H312.5C316.09 64 319 61.0899 319 57.5V22.5C319 18.9101 316.09 16 312.5 16H277.5ZM282 25C280.895 25 280 25.8954 280 27V53C280 54.1046 280.895 55 282 55H308C309.105 55 310 54.1046 310 53V27C310 25.8954 309.105 25 308 25H282ZM289.5 33C288.672 33 288 33.6716 288 34.5V45.5C288 46.3284 288.672 47 289.5 47H300.5C301.328 47 302 46.3284 302 45.5V34.5C302 33.6716 301.328 33 300.5 33H289.5Z",
                fill: "#F1F3F5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M277.5 16C273.91 16 271 18.9102 271 22.5V57.5C271 61.0899 273.91 64 277.5 64H312.5C316.09 64 319 61.0899 319 57.5V22.5C319 18.9101 316.09 16 312.5 16H277.5ZM282 25C280.895 25 280 25.8954 280 27V53C280 54.1046 280.895 55 282 55H308C309.105 55 310 54.1046 310 53V27C310 25.8954 309.105 25 308 25H282ZM289.5 33C288.672 33 288 33.6716 288 34.5V45.5C288 46.3284 288.672 47 289.5 47H300.5C301.328 47 302 46.3284 302 45.5V34.5C302 33.6716 301.328 33 300.5 33H289.5Z",
                fill: "url(#paint0_radial_555_74899)",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                opacity: "0.8",
                x: "34",
                y: "70",
                width: "40",
                height: "30.9489",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                x: "119",
                y: "109",
                width: "200",
                xlinkHref: signatureDataUri
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "paragraph-30",
                textAnchor: "end",
                x: "319",
                y: "192",
                fill: "#101314",
                children: businessName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                            xlinkHref: "#image0_555_74899",
                            transform: "scale(0.00729927 0.00943396)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                        id: "paint0_radial_555_74899",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(271 16) rotate(45) scale(67.8823)",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                        id: "image0_555_74899",
                        width: "137",
                        height: "106",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
}


function $25a3c353e703cc79$export$35617c7a4abfbad0(props) {
    const [signatureDataUri, setSignatureDataUri] = (0, $acw62.useState)("");
    const [textRenderer, setTextRenderer] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const txtRenderer = new (0, $74c7b72a71b76868$export$2e2bcd8739ae039)(props.estimatedFontSize, props.fontFamily, props.nameOnCard, props.boundingBox, (0, $74c7b72a71b76868$export$5aa9cd1ba259435e));
        setTextRenderer(txtRenderer);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (textRenderer) {
            textRenderer.fontFamily = props.fontFamily;
            textRenderer.text = props.nameOnCard;
            setSignatureDataUri(textRenderer.toDataURL());
        }
    }, [
        textRenderer,
        props.nameOnCard,
        props.fontFamily
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
        ...props,
        signatureDataUri: signatureDataUri
    });
}







var $58cb02b9641cce25$exports = {};
(function(f) {
    var g;
    $58cb02b9641cce25$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(process) {
                    (function(global, factory) {
                        if (typeof define === 'function' && define.amd) define('InputSim', [
                            'exports'
                        ], factory);
                        else if (typeof exports !== 'undefined') factory(exports);
                        else {
                            var mod = {
                                exports: {}
                            };
                            factory(mod.exports);
                            global.InputSim = mod.exports;
                        }
                    })(this, function(exports) {
                        /*! jshint esnext:true, undef:true, unused:true */ /** @private */ 'use strict';
                        Object.defineProperty(exports, '__esModule', {
                            value: true
                        });
                        var _createClass = function() {
                            function defineProperties(target, props) {
                                for(var i = 0; i < props.length; i++){
                                    var descriptor = props[i];
                                    descriptor.enumerable = descriptor.enumerable || false;
                                    descriptor.configurable = true;
                                    if ('value' in descriptor) descriptor.writable = true;
                                    Object.defineProperty(target, descriptor.key, descriptor);
                                }
                            }
                            return function(Constructor, protoProps, staticProps) {
                                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                                if (staticProps) defineProperties(Constructor, staticProps);
                                return Constructor;
                            };
                        }();
                        function _classCallCheck(instance, Constructor) {
                            if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                        }
                        var A = 65;
                        /** @private */ var Y = 89;
                        /** @private */ var Z = 90;
                        /** @private */ var ZERO = 48;
                        /** @private */ var NINE = 57;
                        /** @private */ var LEFT = 37;
                        /** @private */ var RIGHT = 39;
                        /** @private */ var UP = 38;
                        /** @private */ var DOWN = 40;
                        /** @private */ var BACKSPACE = 8;
                        /** @private */ var DELETE = 46;
                        /** @private */ var TAB = 9;
                        /** @private */ var ENTER = 13;
                        /**
   * @namespace KEYS
   */ var KEYS = {
                            A: A,
                            Y: Y,
                            Z: Z,
                            ZERO: ZERO,
                            NINE: NINE,
                            LEFT: LEFT,
                            RIGHT: RIGHT,
                            UP: UP,
                            DOWN: DOWN,
                            BACKSPACE: BACKSPACE,
                            DELETE: DELETE,
                            TAB: TAB,
                            ENTER: ENTER,
                            /**
     * @param {number} keyCode
     * @returns {boolean}
     */ isDigit: function isDigit(keyCode) {
                                return ZERO <= keyCode && keyCode <= NINE;
                            },
                            /**
     * Is an arrow keyCode.
     *
     * @param {number} keyCode
     * @returns {boolean}
     */ isDirectional: function isDirectional(keyCode) {
                                return keyCode === LEFT || keyCode === RIGHT || keyCode === UP || keyCode === DOWN;
                            }
                        };
                        var CTRL = 1;
                        var META = 2;
                        var ALT = 4;
                        var SHIFT = 8;
                        var cache = {};
                        /**
   * Builds a BindingSet based on the current platform.
   *
   * @param {string} platform A string name of a platform (e.g. "OSX").
   * @returns {BindingSet} keybindings appropriate for the given platform.
   */ function keyBindingsForPlatform(platform) {
                            var osx = platform === 'OSX';
                            var ctrl = osx ? META : CTRL;
                            if (!cache[platform]) cache[platform] = build(function(bind) {
                                bind(A, ctrl, 'selectAll');
                                bind(LEFT, null, 'moveLeft');
                                bind(LEFT, ALT, 'moveWordLeft');
                                bind(LEFT, SHIFT, 'moveLeftAndModifySelection');
                                bind(LEFT, ALT | SHIFT, 'moveWordLeftAndModifySelection');
                                bind(RIGHT, null, 'moveRight');
                                bind(RIGHT, ALT, 'moveWordRight');
                                bind(RIGHT, SHIFT, 'moveRightAndModifySelection');
                                bind(RIGHT, ALT | SHIFT, 'moveWordRightAndModifySelection');
                                bind(UP, null, 'moveUp');
                                bind(UP, ALT, 'moveToBeginningOfParagraph');
                                bind(UP, SHIFT, 'moveUpAndModifySelection');
                                bind(UP, ALT | SHIFT, 'moveParagraphBackwardAndModifySelection');
                                bind(DOWN, null, 'moveDown');
                                bind(DOWN, ALT, 'moveToEndOfParagraph');
                                bind(DOWN, SHIFT, 'moveDownAndModifySelection');
                                bind(DOWN, ALT | SHIFT, 'moveParagraphForwardAndModifySelection');
                                bind(BACKSPACE, null, 'deleteBackward');
                                bind(BACKSPACE, SHIFT, 'deleteBackward');
                                bind(BACKSPACE, ALT, 'deleteWordBackward');
                                bind(BACKSPACE, ALT | SHIFT, 'deleteWordBackward');
                                bind(BACKSPACE, ctrl, 'deleteBackwardToBeginningOfLine');
                                bind(BACKSPACE, ctrl | SHIFT, 'deleteBackwardToBeginningOfLine');
                                bind(DELETE, null, 'deleteForward');
                                bind(DELETE, ALT, 'deleteWordForward');
                                bind(TAB, null, 'insertTab');
                                bind(TAB, SHIFT, 'insertBackTab');
                                bind(ENTER, null, 'insertNewline');
                                bind(Z, ctrl, 'undo');
                                if (osx) {
                                    bind(LEFT, META, 'moveToBeginningOfLine');
                                    bind(LEFT, META | SHIFT, 'moveToBeginningOfLineAndModifySelection');
                                    bind(RIGHT, META, 'moveToEndOfLine');
                                    bind(RIGHT, META | SHIFT, 'moveToEndOfLineAndModifySelection');
                                    bind(UP, META, 'moveToBeginningOfDocument');
                                    bind(UP, META | SHIFT, 'moveToBeginningOfDocumentAndModifySelection');
                                    bind(DOWN, META, 'moveToEndOfDocument');
                                    bind(DOWN, META | SHIFT, 'moveToEndOfDocumentAndModifySelection');
                                    bind(BACKSPACE, CTRL, 'deleteBackwardByDecomposingPreviousCharacter');
                                    bind(BACKSPACE, CTRL | SHIFT, 'deleteBackwardByDecomposingPreviousCharacter');
                                    bind(Z, META | SHIFT, 'redo');
                                } else bind(Y, CTRL, 'redo');
                            });
                            return cache[platform];
                        }
                        function build(callback) {
                            var result = new BindingSet();
                            callback(function() {
                                return result.bind.apply(result, arguments);
                            });
                            return result;
                        }
                        /**
   * @private
   */ var BindingSet = function() {
                            function BindingSet() {
                                _classCallCheck(this, BindingSet);
                                this.bindings = {};
                            }
                            /**
     * Enum for text direction affinity.
     *
     * @const
     * @enum {number}
     * @private
     */ /**
     * @param {number} keyCode
     * @param {number} modifiers
     * @param {string} action
     */ _createClass(BindingSet, [
                                {
                                    key: 'bind',
                                    value: function bind(keyCode, modifiers, action) {
                                        if (!this.bindings[keyCode]) this.bindings[keyCode] = {};
                                        this.bindings[keyCode][modifiers || 0] = action;
                                    }
                                },
                                {
                                    key: 'actionForEvent',
                                    value: function actionForEvent(event) {
                                        var bindingsForKeyCode = this.bindings[event.keyCode];
                                        if (bindingsForKeyCode) {
                                            var modifiers = 0;
                                            if (event.altKey) modifiers |= ALT;
                                            if (event.ctrlKey) modifiers |= CTRL;
                                            if (event.metaKey) modifiers |= META;
                                            if (event.shiftKey) modifiers |= SHIFT;
                                            return bindingsForKeyCode[modifiers];
                                        }
                                    }
                                }
                            ]);
                            return BindingSet;
                        }();
                        var Affinity = {
                            UPSTREAM: 0,
                            DOWNSTREAM: 1,
                            NONE: null
                        };
                        /**
   * Tests is string passed in is a single word.
   *
   * @param {string} chr
   * @returns {boolean}
   * @private
   */ function isWordChar(chr) {
                            return chr && /^\w$/.test(chr);
                        }
                        /**
   * Checks if char to the left of {index} in {string}
   * is a break (non-char).
   *
   * @param {string} text
   * @param {number} index
   * @returns {boolean}
   * @private
   */ function hasLeftWordBreakAtIndex(text, index) {
                            if (index === 0) return true;
                            else return !isWordChar(text[index - 1]) && isWordChar(text[index]);
                        }
                        /**
   * Checks if char to the right of {index} in {string}
   * is a break (non-char).
   *
   * @param {string} text
   * @param {number} index
   * @returns {boolean}
   * @private
   */ function hasRightWordBreakAtIndex(text, index) {
                            if (index === text.length - 1) return true;
                            else return isWordChar(text[index]) && !isWordChar(text[index + 1]);
                        }
                        var Input = function() {
                            /**
      * Sets up the initial properties of the TextField and
      * sets  up the event listeners
      *
      * @param {string} value
      * @param {Object} range ({start: 0, length: 0})
      */ function Input(value, range) {
                                _classCallCheck(this, Input);
                                this._value = '';
                                this._selectedRange = {
                                    start: 0,
                                    length: 0
                                };
                                this.shouldCancelEvents = true;
                                this.selectionAffinity = Affinity.NONE;
                                if (value) this.setText(value);
                                if (range) this.setSelectedRange(range);
                                this._buildKeybindings();
                            }
                            /**
     * Clears all characters in the existing selection.
     *
     * @example
     *     // 12|34567|8
     *     clearSelection();
     *     // 12|8
     *
     */ _createClass(Input, [
                                {
                                    key: 'clearSelection',
                                    value: function clearSelection() {
                                        this.replaceSelection('');
                                    }
                                },
                                {
                                    key: 'deleteBackward',
                                    value: function deleteBackward(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length === 0) {
                                            range.start--;
                                            range.length++;
                                            this.setSelectedRange(range);
                                        }
                                        this.clearSelection();
                                    }
                                },
                                {
                                    key: 'deleteWordBackward',
                                    value: function deleteWordBackward(event) {
                                        if (this.hasSelection()) this.deleteBackward(event);
                                        else {
                                            this._handleEvent(event);
                                            var range = this.selectedRange();
                                            var start = this._lastWordBreakBeforeIndex(range.start);
                                            range.length += range.start - start;
                                            range.start = start;
                                            this.setSelectedRange(range);
                                            this.clearSelection();
                                        }
                                    }
                                },
                                {
                                    key: 'deleteBackwardByDecomposingPreviousCharacter',
                                    value: function deleteBackwardByDecomposingPreviousCharacter(event) {
                                        this.deleteBackward(event);
                                    }
                                },
                                {
                                    key: 'deleteBackwardToBeginningOfLine',
                                    value: function deleteBackwardToBeginningOfLine(event) {
                                        if (this.hasSelection()) this.deleteBackward(event);
                                        else {
                                            this._handleEvent(event);
                                            var range = this.selectedRange();
                                            range.length = range.start;
                                            range.start = 0;
                                            this.setSelectedRange(range);
                                            this.clearSelection();
                                        }
                                    }
                                },
                                {
                                    key: 'deleteForward',
                                    value: function deleteForward(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length === 0) {
                                            range.length++;
                                            this.setSelectedRange(range);
                                        }
                                        this.clearSelection();
                                    }
                                },
                                {
                                    key: 'deleteWordForward',
                                    value: function deleteWordForward(event) {
                                        if (this.hasSelection()) return this.deleteForward(event);
                                        else {
                                            this._handleEvent(event);
                                            var range = this.selectedRange();
                                            var end = this._nextWordBreakAfterIndex(range.start + range.length);
                                            this.setSelectedRange({
                                                start: range.start,
                                                length: end - range.start
                                            });
                                            this.clearSelection();
                                        }
                                    }
                                },
                                {
                                    key: 'handleEvent',
                                    value: function handleEvent(event) {
                                        if (typeof event === 'undefined') throw new Error('cannot handle and event that isn\'t passed');
                                        var action = this._bindings.actionForEvent(event);
                                        if (action) this[action](event);
                                        return action;
                                    }
                                },
                                {
                                    key: 'hasSelection',
                                    value: function hasSelection() {
                                        return this.selectedRange().length !== 0;
                                    }
                                },
                                {
                                    key: 'insertBackTab',
                                    value: function insertBackTab() {}
                                },
                                {
                                    key: 'insertNewline',
                                    value: function insertNewline() {}
                                },
                                {
                                    key: 'insertTab',
                                    value: function insertTab() {}
                                },
                                {
                                    key: 'insertText',
                                    value: function insertText(text) {
                                        var range;
                                        if (this.hasSelection()) this.clearSelection();
                                        this.replaceSelection(text);
                                        range = this.selectedRange();
                                        range.start += range.length;
                                        range.length = 0;
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveUp',
                                    value: function moveUp(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRange({
                                            start: 0,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfParagraph',
                                    value: function moveToBeginningOfParagraph(event) {
                                        this.moveUp(event);
                                    }
                                },
                                {
                                    key: 'moveUpAndModifySelection',
                                    value: function moveUpAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                // 12<34 56|78  =>  <1234 56|78
                                                range.length += range.start;
                                                range.start = 0;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                // 12|34 56>78   =>   <12|34 5678
                                                range.length = range.start;
                                                range.start = 0;
                                                break;
                                        }
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveParagraphBackwardAndModifySelection',
                                    value: function moveParagraphBackwardAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                // 12<34 56|78  =>  <1234 56|78
                                                range.length += range.start;
                                                range.start = 0;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                // 12|34 56>78  =>  12|34 5678
                                                range.length = 0;
                                                break;
                                        }
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfDocument',
                                    value: function moveToBeginningOfDocument(event) {
                                        // Since we only support a single line this is just an alias.
                                        this.moveToBeginningOfLine(event);
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfDocumentAndModifySelection',
                                    value: function moveToBeginningOfDocumentAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length += range.start;
                                        range.start = 0;
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveDown',
                                    value: function moveDown(event) {
                                        this._handleEvent(event);
                                        // 12|34 56|78  =>  1234 5678|
                                        var range = {
                                            start: this.text().length,
                                            length: 0
                                        };
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'moveToEndOfParagraph',
                                    value: function moveToEndOfParagraph(event) {
                                        this.moveDown(event);
                                    }
                                },
                                {
                                    key: 'moveDownAndModifySelection',
                                    value: function moveDownAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        var end = this.text().length;
                                        if (this.selectionAffinity === Affinity.UPSTREAM) range.start += range.length;
                                        range.length = end - range.start;
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'moveParagraphForwardAndModifySelection',
                                    value: function moveParagraphForwardAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.DOWNSTREAM:
                                            case Affinity.NONE:
                                                // 12|34 56>78  =>  12|34 5678>
                                                range.length = this.text().length - range.start;
                                                break;
                                            case Affinity.UPSTREAM:
                                                // 12<34 56|78  =>  12|34 5678
                                                range.start += range.length;
                                                range.length = 0;
                                                break;
                                        }
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'moveToEndOfDocument',
                                    value: function moveToEndOfDocument(event) {
                                        // Since we only support a single line this is just an alias.
                                        this.moveToEndOfLine(event);
                                    }
                                },
                                {
                                    key: 'moveToEndOfDocumentAndModifySelection',
                                    value: function moveToEndOfDocumentAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length = this.text().length - range.start;
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'moveLeft',
                                    value: function moveLeft(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length !== 0) range.length = 0;
                                        else range.start--;
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'moveLeftAndModifySelection',
                                    value: function moveLeftAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.UPSTREAM;
                                                range.start--;
                                                range.length++;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                range.length--;
                                                break;
                                        }
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveWordLeft',
                                    value: function moveWordLeft(event) {
                                        this._handleEvent(event);
                                        var index = this._lastWordBreakBeforeIndex(this.selectedRange().start - 1);
                                        this.setSelectedRange({
                                            start: index,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveWordLeftAndModifySelection',
                                    value: function moveWordLeftAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.UPSTREAM;
                                                var start = this._lastWordBreakBeforeIndex(range.start - 1);
                                                range.length += range.start - start;
                                                range.start = start;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                var end = this._lastWordBreakBeforeIndex(range.start + range.length);
                                                if (end < range.start) end = range.start;
                                                range.length -= range.start + range.length - end;
                                                break;
                                        }
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfLine',
                                    value: function moveToBeginningOfLine(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRange({
                                            start: 0,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfLineAndModifySelection',
                                    value: function moveToBeginningOfLineAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length += range.start;
                                        range.start = 0;
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveRight',
                                    value: function moveRight(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length !== 0) {
                                            range.start += range.length;
                                            range.length = 0;
                                        } else range.start++;
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'moveRightAndModifySelection',
                                    value: function moveRightAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                                range.start++;
                                                range.length--;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.DOWNSTREAM;
                                                range.length++;
                                                break;
                                        }
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveWordRight',
                                    value: function moveWordRight(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        var index = this._nextWordBreakAfterIndex(range.start + range.length);
                                        this.setSelectedRange({
                                            start: index,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveWordRightAndModifySelection',
                                    value: function moveWordRightAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        var start = range.start;
                                        var end = range.start + range.length;
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                                start = Math.min(this._nextWordBreakAfterIndex(start), end);
                                                break;
                                            case Affinity.DOWNSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.DOWNSTREAM;
                                                end = this._nextWordBreakAfterIndex(range.start + range.length);
                                                break;
                                        }
                                        this.setSelectedRange({
                                            start: start,
                                            length: end - start
                                        });
                                    }
                                },
                                {
                                    key: 'moveToEndOfLine',
                                    value: function moveToEndOfLine(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRange({
                                            start: this.text().length,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveToEndOfLineAndModifySelection',
                                    value: function moveToEndOfLineAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length = this.text().length - range.start;
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'replaceSelection',
                                    value: function replaceSelection(replacement) {
                                        var range = this.selectedRange();
                                        var end = range.start + range.length;
                                        var text = this.text();
                                        text = text.substring(0, range.start) + replacement + text.substring(end);
                                        range.length = replacement.length;
                                        this.setText(text);
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'rightWordBreakIndexes',
                                    value: function rightWordBreakIndexes() {
                                        var result = [];
                                        var text = this.text();
                                        for(var i = 0, l = text.length; i < l; i++)if (hasRightWordBreakAtIndex(text, i)) result.push(i + 1);
                                        return result;
                                    }
                                },
                                {
                                    key: 'selectAll',
                                    value: function selectAll(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRangeWithAffinity({
                                            start: 0,
                                            length: this.text().length
                                        }, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'text',
                                    value: function text() {
                                        return this._value;
                                    }
                                },
                                {
                                    key: 'setText',
                                    value: function setText(value) {
                                        this._value = '' + value;
                                        this.setSelectedRange({
                                            start: this._value.length,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'selectedRange',
                                    value: function selectedRange() {
                                        return this._selectedRange;
                                    }
                                },
                                {
                                    key: 'setSelectedRange',
                                    value: function setSelectedRange(range) {
                                        this.setSelectedRangeWithAffinity(range, this.selectionAffinity);
                                    }
                                },
                                {
                                    key: 'setSelectedRangeWithAffinity',
                                    value: function setSelectedRangeWithAffinity(range, affinity) {
                                        var min = 0;
                                        var max = this.text().length;
                                        var caret = {
                                            start: Math.max(min, Math.min(max, range.start)),
                                            end: Math.max(min, Math.min(max, range.start + range.length))
                                        };
                                        this._selectedRange = {
                                            start: caret.start,
                                            length: caret.end - caret.start
                                        };
                                        this.selectionAffinity = range.length === 0 ? Affinity.NONE : affinity;
                                        return this._selectedRange;
                                    }
                                },
                                {
                                    key: 'selectionAnchor',
                                    value: function selectionAnchor() {
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                                return range.start + range.length;
                                            case Affinity.DOWNSTREAM:
                                                return range.start;
                                            default:
                                                return Affinity.NONE;
                                        }
                                    }
                                },
                                {
                                    key: '_buildKeybindings',
                                    value: function _buildKeybindings() {
                                        var osx;
                                        if (typeof navigator !== 'undefined') osx = /^Mozilla\/[\d\.]+ \(Macintosh/.test(navigator.userAgent);
                                        else if (typeof process !== 'undefined') osx = /darwin/.test(process.platform);
                                        this._bindings = keyBindingsForPlatform(osx ? 'OSX' : 'Default');
                                    }
                                },
                                {
                                    key: '_handleEvent',
                                    value: function _handleEvent(event) {
                                        if (event && this.shouldCancelEvents) event.preventDefault();
                                    }
                                },
                                {
                                    key: '_lastWordBreakBeforeIndex',
                                    value: function _lastWordBreakBeforeIndex(index) {
                                        var indexes = this._leftWordBreakIndexes();
                                        var result = indexes[0];
                                        for(var i = 0, l = indexes.length; i < l; i++){
                                            var wordBreakIndex = indexes[i];
                                            if (index > wordBreakIndex) result = wordBreakIndex;
                                            else break;
                                        }
                                        return result;
                                    }
                                },
                                {
                                    key: '_leftWordBreakIndexes',
                                    value: function _leftWordBreakIndexes() {
                                        var result = [];
                                        var text = this.text();
                                        for(var i = 0, l = text.length; i < l; i++)if (hasLeftWordBreakAtIndex(text, i)) result.push(i);
                                        return result;
                                    }
                                },
                                {
                                    key: '_nextWordBreakAfterIndex',
                                    value: function _nextWordBreakAfterIndex(index) {
                                        var indexes = this.rightWordBreakIndexes().reverse();
                                        var result = indexes[0];
                                        for(var i = 0, l = indexes.length; i < l; i++){
                                            var wordBreakIndex = indexes[i];
                                            if (index < wordBreakIndex) result = wordBreakIndex;
                                            else break;
                                        }
                                        return result;
                                    }
                                }
                            ]);
                            return Input;
                        }();
                        exports.Input = Input;
                        exports.KEYS = KEYS;
                        exports.keyBindingsForPlatform = keyBindingsForPlatform;
                    });
                }).call(this, _dereq_('_process'));
            },
            {
                "_process": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error('setTimeout has not been defined');
                }
                function defaultClearTimeout() {
                    throw new Error('clearTimeout has not been defined');
                }
                (function() {
                    try {
                        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = 'browser';
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ''; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error('process.binding is not supported');
                };
                process.cwd = function() {
                    return '/';
                };
                process.chdir = function(dir) {
                    throw new Error('process.chdir is not supported');
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global, factory) {
                    if (typeof define === 'function' && define.amd) define('stround', [
                        'exports'
                    ], factory);
                    else if (typeof exports !== 'undefined') factory(exports);
                    else {
                        var mod = {
                            exports: {}
                        };
                        factory(mod.exports);
                        global.stround = mod.exports;
                    }
                })(this, function(exports) {
                    /* jshint sub:true, esnext:true, undef:true, unused:true */ /**
   * Enum for the available rounding modes.
   *
   * @enum {number}
   */ 'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    var _slicedToArray = function() {
                        function sliceIterator(arr, i) {
                            var _arr = [];
                            var _n = true;
                            var _d = false;
                            var _e = undefined;
                            try {
                                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                    _arr.push(_s.value);
                                    if (i && _arr.length === i) break;
                                }
                            } catch (err) {
                                _d = true;
                                _e = err;
                            } finally{
                                try {
                                    if (!_n && _i['return']) _i['return']();
                                } finally{
                                    if (_d) throw _e;
                                }
                            }
                            return _arr;
                        }
                        return function(arr, i) {
                            if (Array.isArray(arr)) return arr;
                            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                            else throw new TypeError('Invalid attempt to destructure non-iterable instance');
                        };
                    }();
                    exports.parse = parse;
                    exports.format = format;
                    exports.shiftParts = shiftParts;
                    exports.shift = shift;
                    exports.round = round;
                    var modes = {
                        CEILING: 0,
                        FLOOR: 1,
                        DOWN: 2,
                        UP: 3,
                        HALF_EVEN: 4,
                        HALF_DOWN: 5,
                        HALF_UP: 6
                    };
                    exports.modes = modes;
                    /**
   * @const
   * @private
   */ var NEG = '-';
                    /**
   * @const
   * @private
   */ var SEP = '.';
                    /**
   * @const
   * @private
   */ var NEG_PATTERN = '-';
                    /**
   * @const
   * @private
   */ var SEP_PATTERN = '\\.';
                    /**
   * @const
   * @private
   */ var NUMBER_PATTERN = new RegExp('^(' + NEG_PATTERN + ')?(\\d*)(?:' + SEP_PATTERN + '(\\d*))?$');
                    /**
   * Increments the given integer represented by a string by one.
   *
   * @example
   *
   *   increment('1');  // '2'
   *   increment('99'); // '100'
   *   increment('');   // '1'
   *
   * @param {string} strint
   * @return {string}
   * @private
   */ function increment(strint) {
                        var length = strint.length;
                        if (length === 0) return '1';
                        var last = parseInt(strint[length - 1], 10);
                        if (last === 9) return increment(strint.slice(0, length - 1)) + '0';
                        else return strint.slice(0, length - 1) + (last + 1);
                    }
                    /**
   * Parses the given decimal string into its component parts.
   *
   * @example
   *
   *   stround.parse('3.14');  // [false, '3', '14']
   *   stround.parse('-3.45'); // [true, '3', '45']
   *
   * @param {string} strnum
   * @return {?Array}
   */ function parse(strnum) {
                        switch(strnum){
                            case 'NaN':
                            case 'Infinity':
                            case '-Infinity':
                                return null;
                        }
                        var match = strnum.match(NUMBER_PATTERN);
                        if (!match) throw new Error('cannot round malformed number: ' + strnum);
                        return [
                            match[1] !== undefined,
                            match[2],
                            match[3] || ''
                        ];
                    }
                    /**
   * Format the given number configuration as a number string.
   *
   * @example
   *
   *   stround.format([false, '12', '34']); // '12.34'
   *   stround.format([true, '8', '']);     // '-8'
   *   stround.format([true, '', '7']);     // '-0.7'
   *
   * @param {Array} parts
   * @return {string}
   */ function format(_ref) {
                        var _ref2 = _slicedToArray(_ref, 3);
                        var negative = _ref2[0];
                        var intPart = _ref2[1];
                        var fracPart = _ref2[2];
                        if (intPart.length === 0) intPart = '0';
                        else {
                            var firstNonZeroIndex = undefined;
                            for(firstNonZeroIndex = 0; firstNonZeroIndex < intPart.length; firstNonZeroIndex++){
                                if (intPart[firstNonZeroIndex] !== '0') break;
                            }
                            if (firstNonZeroIndex !== intPart.length) intPart = intPart.slice(firstNonZeroIndex);
                        }
                        return (negative ? NEG + intPart : intPart) + (fracPart.length ? SEP + fracPart : '');
                    }
                    /**
   * Shift the exponent of the given number (in parts) by the given amount.
   *
   * @example
   *
   *   stround.shiftParts([false, '12', ''], 2);  // [false, '1200', '']
   *   stround.shiftParts([false, '12', ''], -2); // [false, '', '12']
   *
   * @param {Array} parts
   * @param {number} exponent
   * @return {Array}
   */ function shiftParts(_ref3, exponent) {
                        var _ref32 = _slicedToArray(_ref3, 3);
                        var negative = _ref32[0];
                        var intPart = _ref32[1];
                        var fracPart = _ref32[2];
                        var partToMove = undefined;
                        if (exponent > 0) {
                            partToMove = fracPart.slice(0, exponent);
                            while(partToMove.length < exponent)partToMove += '0';
                            intPart += partToMove;
                            fracPart = fracPart.slice(exponent);
                        } else if (exponent < 0) {
                            while(intPart.length < -exponent)intPart = '0' + intPart;
                            partToMove = intPart.slice(intPart.length + exponent);
                            fracPart = partToMove + fracPart;
                            intPart = intPart.slice(0, intPart.length - partToMove.length);
                        }
                        return [
                            negative,
                            intPart,
                            fracPart
                        ];
                    }
                    /**
   * Shift the exponent of the given number (as a string) by the given amount.
   *
   *   shift('12', 2);  // '1200'
   *   shift('12', -2); // '0.12'
   *
   * @param {string|number} strnum
   * @param {number} exponent
   * @return {string}
   */ function shift(strnum, exponent) {
                        if (typeof strnum === 'number') strnum = '' + strnum;
                        var parsed = parse(strnum);
                        if (parsed === null) return strnum;
                        else return format(shiftParts(parsed, exponent));
                    }
                    /**
   * Round the given number represented by a string according to the given
   * precision and mode.
   *
   * @param {string|number} strnum
   * @param {number|null|undefined=} precision
   * @param {modes=} mode
   * @return {string}
   */ function round(strnum, precision, mode) {
                        if (typeof strnum === 'number') strnum = '' + strnum;
                        if (typeof strnum !== 'string') throw new Error('expected a string or number, got: ' + strnum);
                        if (strnum.length === 0) return strnum;
                        if (precision === null || precision === undefined) precision = 0;
                        if (mode === undefined) mode = modes.HALF_EVEN;
                        var parsed = parse(strnum);
                        if (parsed === null) return strnum;
                        if (precision > 0) parsed = shiftParts(parsed, precision);
                        var _parsed = parsed;
                        var _parsed2 = _slicedToArray(_parsed, 3);
                        var negative = _parsed2[0];
                        var intPart = _parsed2[1];
                        var fracPart = _parsed2[2];
                        switch(mode){
                            case modes.CEILING:
                            case modes.FLOOR:
                            case modes.UP:
                                var foundNonZeroDigit = false;
                                for(var i = 0, _length = fracPart.length; i < _length; i++)if (fracPart[i] !== '0') {
                                    foundNonZeroDigit = true;
                                    break;
                                }
                                if (foundNonZeroDigit) {
                                    if (mode === modes.UP || negative !== (mode === modes.CEILING)) intPart = increment(intPart);
                                }
                                break;
                            case modes.HALF_EVEN:
                            case modes.HALF_DOWN:
                            case modes.HALF_UP:
                                var shouldRoundUp = false;
                                var firstFracPartDigit = parseInt(fracPart[0], 10);
                                if (firstFracPartDigit > 5) shouldRoundUp = true;
                                else if (firstFracPartDigit === 5) {
                                    if (mode === modes.HALF_UP) shouldRoundUp = true;
                                    if (!shouldRoundUp) {
                                        for(var i = 1, _length2 = fracPart.length; i < _length2; i++)if (fracPart[i] !== '0') {
                                            shouldRoundUp = true;
                                            break;
                                        }
                                    }
                                    if (!shouldRoundUp && mode === modes.HALF_EVEN) {
                                        var lastIntPartDigit = parseInt(intPart[intPart.length - 1], 10);
                                        shouldRoundUp = lastIntPartDigit % 2 !== 0;
                                    }
                                }
                                if (shouldRoundUp) intPart = increment(intPart);
                                break;
                        }
                        return format(shiftParts([
                            negative,
                            intPart,
                            ''
                        ], -precision));
                    }
                });
            },
            {}
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var _amex_card_formatter = _dereq_('./amex_card_formatter');
                var _amex_card_formatter2 = _interopRequireDefault(_amex_card_formatter);
                var _default_card_formatter = _dereq_('./default_card_formatter');
                var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
                var _card_utils = _dereq_('./card_utils');
                /**
 * AdaptiveCardFormatter will decide if it needs to use
 * {@link AmexCardFormatter} or {@link DefaultCardFormatter}.
 */ var AdaptiveCardFormatter = function() {
                    function AdaptiveCardFormatter() {
                        _classCallCheck(this, AdaptiveCardFormatter);
                        /** @private */ this.amexCardFormatter = new _amex_card_formatter2['default']();
                        /** @private */ this.defaultCardFormatter = new _default_card_formatter2['default']();
                        /** @private */ this.formatter = this.defaultCardFormatter;
                    }
                    /**
   * Will pick the right formatter based on the `pan` and will return the
   * formatted string.
   *
   * @param {string} pan
   * @returns {string} formatted string
   */ _createClass(AdaptiveCardFormatter, [
                        {
                            key: 'format',
                            value: function format(pan) {
                                return this._formatterForPan(pan).format(pan);
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                return this.formatter.parse(text, error);
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                this.formatter = this._formatterForPan(change.proposed.text);
                                return this.formatter.isChangeValid(change, error);
                            }
                        },
                        {
                            key: '_formatterForPan',
                            value: function _formatterForPan(pan) {
                                if ((0, _card_utils.determineCardType)(pan.replace(/[^\d]+/g, '')) === _card_utils.AMEX) return this.amexCardFormatter;
                                else return this.defaultCardFormatter;
                            }
                        }
                    ]);
                    return AdaptiveCardFormatter;
                }();
                exports['default'] = AdaptiveCardFormatter;
                module1.exports = exports['default'];
            },
            {
                "./amex_card_formatter": 5,
                "./card_utils": 7,
                "./default_card_formatter": 9
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _default_card_formatter = _dereq_('./default_card_formatter');
                var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
                /**
 * Amex credit card formatter.
 *
 * @extends DefaultCardFormatter
 */ var AmexCardFormatter = function(_DefaultCardFormatter) {
                    _inherits(AmexCardFormatter, _DefaultCardFormatter);
                    function AmexCardFormatter() {
                        _classCallCheck(this, AmexCardFormatter);
                        _get(Object.getPrototypeOf(AmexCardFormatter.prototype), 'constructor', this).apply(this, arguments);
                    }
                    _createClass(AmexCardFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            /**
     * @override
     */ value: function hasDelimiterAtIndex(index) {
                                return index === 4 || index === 11;
                            }
                        },
                        {
                            key: 'maximumLength',
                            get: function get() {
                                return 17;
                            }
                        }
                    ]);
                    return AmexCardFormatter;
                }(_default_card_formatter2['default']);
                exports['default'] = AmexCardFormatter;
                module1.exports = exports['default'];
            },
            {
                "./default_card_formatter": 9
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _text_field = _dereq_('./text_field');
                var _text_field2 = _interopRequireDefault(_text_field);
                var _adaptive_card_formatter = _dereq_('./adaptive_card_formatter');
                var _adaptive_card_formatter2 = _interopRequireDefault(_adaptive_card_formatter);
                var _card_utils = _dereq_('./card_utils');
                /**
 * Enum for card mask strategies.
 *
 * @readonly
 * @enum {number}
 * @private
 */ var CardMaskStrategy = {
                    None: 'None',
                    DoneEditing: 'DoneEditing'
                };
                /**
 * CardTextField add some functionality for credit card inputs
 *
 * @extends TextField
 */ var CardTextField = function(_TextField) {
                    _inherits(CardTextField, _TextField);
                    /**
   * @param {HTMLElement} element
   */ function CardTextField(element) {
                        _classCallCheck(this, CardTextField);
                        _get(Object.getPrototypeOf(CardTextField.prototype), 'constructor', this).call(this, element, new _adaptive_card_formatter2['default']());
                        this.setCardMaskStrategy(CardMaskStrategy.None);
                        /**
     * Whether we are currently masking the displayed text.
     *
     * @private
     */ this._masked = false;
                        /**
     * Whether we are currently editing.
     *
     * @private
     */ this._editing = false;
                    }
                    /**
   * Gets the card type for the current value.
   *
   * @returns {string} Returns one of 'visa', 'mastercard', 'amex' and 'discover'.
   */ _createClass(CardTextField, [
                        {
                            key: 'cardType',
                            value: function cardType() {
                                return (0, _card_utils.determineCardType)(this.value());
                            }
                        },
                        {
                            key: 'cardMaskStrategy',
                            value: function cardMaskStrategy() {
                                return this._cardMaskStrategy;
                            }
                        },
                        {
                            key: 'setCardMaskStrategy',
                            value: function setCardMaskStrategy(cardMaskStrategy) {
                                if (cardMaskStrategy !== this._cardMaskStrategy) {
                                    this._cardMaskStrategy = cardMaskStrategy;
                                    this._syncMask();
                                }
                            }
                        },
                        {
                            key: 'cardMask',
                            value: function cardMask() {
                                var text = this.text();
                                var last4 = text.slice(-4);
                                var toMask = text.slice(0, -4);
                                return toMask.replace(/\d/g, "\u2022") + last4;
                            }
                        },
                        {
                            key: 'text',
                            value: function text() {
                                if (this._masked) return this._unmaskedText;
                                else return _get(Object.getPrototypeOf(CardTextField.prototype), 'text', this).call(this);
                            }
                        },
                        {
                            key: 'setText',
                            value: function setText(text) {
                                if (this._masked) {
                                    this._unmaskedText = text;
                                    text = this.cardMask();
                                }
                                _get(Object.getPrototypeOf(CardTextField.prototype), 'setText', this).call(this, text);
                            }
                        },
                        {
                            key: 'textFieldDidEndEditing',
                            value: function textFieldDidEndEditing() {
                                this._editing = false;
                                this._syncMask();
                            }
                        },
                        {
                            key: 'textFieldDidBeginEditing',
                            value: function textFieldDidBeginEditing() {
                                this._editing = true;
                                this._syncMask();
                            }
                        },
                        {
                            key: '_enableMasking',
                            value: function _enableMasking() {
                                if (!this._masked) {
                                    this._unmaskedText = this.text();
                                    this._masked = true;
                                    this.setText(this._unmaskedText);
                                }
                            }
                        },
                        {
                            key: '_disableMasking',
                            value: function _disableMasking() {
                                if (this._masked) {
                                    this._masked = false;
                                    this.setText(this._unmaskedText);
                                    this._unmaskedText = null;
                                }
                            }
                        },
                        {
                            key: '_syncMask',
                            value: function _syncMask() {
                                if (this.cardMaskStrategy() === CardMaskStrategy.DoneEditing) {
                                    if (this._editing) this._disableMasking();
                                    else this._enableMasking();
                                }
                            }
                        }
                    ], [
                        {
                            key: 'CardMaskStrategy',
                            get: function get() {
                                return CardMaskStrategy;
                            }
                        }
                    ]);
                    return CardTextField;
                }(_text_field2['default']);
                exports['default'] = CardTextField;
                module1.exports = exports['default'];
            },
            {
                "./adaptive_card_formatter": 4,
                "./card_utils": 7,
                "./text_field": 20
            }
        ],
        7: [
            function(_dereq_, module1, exports) {
                /**
 * @TODO Make this an enum
 */ 'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                exports.determineCardType = determineCardType;
                exports.luhnCheck = luhnCheck;
                exports.validCardLength = validCardLength;
                var AMEX = 'amex';
                exports.AMEX = AMEX;
                var DISCOVER = 'discover';
                exports.DISCOVER = DISCOVER;
                var JCB = 'jcb';
                exports.JCB = JCB;
                var MASTERCARD = 'mastercard';
                exports.MASTERCARD = MASTERCARD;
                var VISA = 'visa';
                exports.VISA = VISA;
                /**
 * Pass in a credit card number and it'll return the
 * type of card it is.
 *
 * @param {string} pan
 * @returns {?string} returns the type of card based in the digits
 */ function determineCardType(pan) {
                    if (pan === null || pan === undefined) return null;
                    pan = pan.toString();
                    var firsttwo = parseInt(pan.slice(0, 2), 10);
                    var iin = parseInt(pan.slice(0, 6), 10);
                    var halfiin = parseInt(pan.slice(0, 3), 10);
                    if (pan[0] === '4') return VISA;
                    else if (pan.slice(0, 4) === '6011' || firsttwo === 65 || halfiin >= 664 && halfiin <= 649 || iin >= 622126 && iin <= 622925) return DISCOVER;
                    else if (pan.slice(0, 4) === '2131' || pan.slice(0, 4) === '1800' || firsttwo === 35) return JCB;
                    else if (firsttwo >= 51 && firsttwo <= 55) return MASTERCARD;
                    else if (firsttwo === 34 || firsttwo === 37) return AMEX;
                }
                /**
 * Pass in a credit card number and it'll return if it
 * passes the [luhn algorithm](http://en.wikipedia.org/wiki/Luhn_algorithm)
 *
 * @param {string} pan
 * @returns {boolean}
 */ function luhnCheck(pan) {
                    var sum = 0;
                    var flip = true;
                    for(var i = pan.length - 1; i >= 0; i--){
                        var digit = parseInt(pan.charAt(i), 10);
                        sum += (flip = !flip) ? Math.floor(digit * 2 / 10) + Math.floor(digit * 2 % 10) : digit;
                    }
                    return sum % 10 === 0;
                }
                /**
 * Pass in a credit card number and it'll return if it
 * is a valid length for that type. If it doesn't know the
 * type it'll return false
 *
 * @param {string} pan
 * @returns {boolean}
 */ function validCardLength(pan) {
                    switch(determineCardType(pan)){
                        case VISA:
                            return pan.length === 13 || pan.length === 16;
                        case DISCOVER:
                        case MASTERCARD:
                            return pan.length === 16;
                        case JCB:
                            return pan.length === 15 || pan.length === 16;
                        case AMEX:
                            return pan.length === 15;
                        default:
                            return false;
                    }
                }
            },
            {}
        ],
        8: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                exports['default'] = installCaret;
                function installCaret() {
                    var _document = arguments.length <= 0 || arguments[0] === undefined ? document : arguments[0];
                    var getCaret = undefined;
                    var setCaret = undefined;
                    if (!_document) throw new Error('Caret does not have access to document');
                    else if ('selectionStart' in _document.createElement('input')) {
                        getCaret = function(element) {
                            return {
                                start: element.selectionStart,
                                end: element.selectionEnd
                            };
                        };
                        setCaret = function(element, start, end) {
                            element.selectionStart = start;
                            element.selectionEnd = end;
                        };
                    } else if (_document.selection) {
                        getCaret = function(element) {
                            var selection = _document.selection;
                            var value = element.value;
                            var range = selection.createRange().duplicate();
                            range.moveEnd('character', value.length);
                            var start = range.text === '' ? value.length : value.lastIndexOf(range.text);
                            range = selection.createRange().duplicate();
                            range.moveStart('character', -value.length);
                            var end = range.text.length;
                            return {
                                start: start,
                                end: end
                            };
                        };
                        setCaret = function(element, start, end) {
                            var range = element.createTextRange();
                            range.collapse(true);
                            range.moveStart('character', start);
                            range.moveEnd('character', end - start);
                            range.select();
                        };
                    } else throw new Error('Caret unknown input selection capabilities');
                    return {
                        getCaret: getCaret,
                        setCaret: setCaret
                    };
                }
                module1.exports = exports['default'];
            },
            {}
        ],
        9: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                var _card_utils = _dereq_('./card_utils');
                /**
 * A generic credit card formatter.
 *
 * @extends DelimitedTextFormatter
 */ var DefaultCardFormatter = function(_DelimitedTextFormatter) {
                    _inherits(DefaultCardFormatter, _DelimitedTextFormatter);
                    function DefaultCardFormatter() {
                        _classCallCheck(this, DefaultCardFormatter);
                        _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), 'constructor', this).call(this, ' ');
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(DefaultCardFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 4 || index === 9 || index === 14;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                var value = this._valueFromText(text);
                                if (typeof error === 'function') {
                                    if (!(0, _card_utils.validCardLength)(value)) error('card-formatter.number-too-short');
                                    if (!(0, _card_utils.luhnCheck)(value)) error('card-formatter.invalid-number');
                                }
                                return _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), 'parse', this).call(this, text, error);
                            }
                        },
                        {
                            key: '_valueFromText',
                            value: function _valueFromText(text) {
                                return _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), '_valueFromText', this).call(this, (text || '').replace(/[^\d]/g, ''));
                            }
                        },
                        {
                            key: 'maximumLength',
                            get: function get() {
                                return 19;
                            }
                        }
                    ]);
                    return DefaultCardFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = DefaultCardFormatter;
                module1.exports = exports['default'];
            },
            {
                "./card_utils": 7,
                "./delimited_text_formatter": 10
            }
        ],
        10: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x2, _x3, _x4) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x2, property = _x3, receiver = _x4;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x2 = parent;
                                _x3 = property;
                                _x4 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                /**
 * A generic delimited formatter.
 *
 * @extends Formatter
 */ var DelimitedTextFormatter = function(_Formatter) {
                    _inherits(DelimitedTextFormatter, _Formatter);
                    /**
   * @param {string=} delimiter
   * @param {boolean=} isLazy
   * @throws {Error} delimiter must have just one character
   */ function DelimitedTextFormatter(delimiter) {
                        var isLazy = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
                        _classCallCheck(this, DelimitedTextFormatter);
                        _get(Object.getPrototypeOf(DelimitedTextFormatter.prototype), 'constructor', this).call(this);
                        if (arguments.length === 0) return;
                        if (delimiter === null || delimiter === undefined || delimiter.length !== 1) throw new Error('delimiter must have just one character');
                        this.delimiter = delimiter;
                        // If the formatter is lazy, delimiter will not be added until input has gone
                        // past the delimiter index. Useful for 'optional' extension, like zip codes.
                        // 94103  ->  type '1'  ->  94103-1
                        this.isLazy = isLazy;
                    }
                    /**
   * Determines the delimiter character at the given index.
   *
   * @param {number} index
   * @returns {?string}
   */ _createClass(DelimitedTextFormatter, [
                        {
                            key: 'delimiterAt',
                            value: function delimiterAt(index) {
                                if (!this.hasDelimiterAtIndex(index)) return null;
                                return this.delimiter;
                            }
                        },
                        {
                            key: 'isDelimiter',
                            value: function isDelimiter(chr) {
                                return chr === this.delimiter;
                            }
                        },
                        {
                            key: 'format',
                            value: function format(value) {
                                return this._textFromValue(value);
                            }
                        },
                        {
                            key: '_textFromValue',
                            value: function _textFromValue(value) {
                                if (!value) return '';
                                var result = '';
                                var delimiter = undefined;
                                var maximumLength = this.maximumLength;
                                for(var i = 0, l = value.length; i < l; i++){
                                    while(delimiter = this.delimiterAt(result.length))result += delimiter;
                                    result += value[i];
                                    if (!this.isLazy) while(delimiter = this.delimiterAt(result.length))result += delimiter;
                                }
                                if (maximumLength !== undefined && maximumLength !== null) return result.slice(0, maximumLength);
                                else return result;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text) {
                                return this._valueFromText(text);
                            }
                        },
                        {
                            key: '_valueFromText',
                            value: function _valueFromText(text) {
                                if (!text) return '';
                                var result = '';
                                for(var i = 0, l = text.length; i < l; i++)if (!this.isDelimiter(text[i])) result += text[i];
                                return result;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (!_get(Object.getPrototypeOf(DelimitedTextFormatter.prototype), 'isChangeValid', this).call(this, change, error)) return false;
                                var newText = change.proposed.text;
                                var range = change.proposed.selectedRange;
                                var hasSelection = range.length !== 0;
                                var startMovedLeft = range.start < change.current.selectedRange.start;
                                var startMovedRight = range.start > change.current.selectedRange.start;
                                var endMovedLeft = range.start + range.length < change.current.selectedRange.start + change.current.selectedRange.length;
                                var endMovedRight = range.start + range.length > change.current.selectedRange.start + change.current.selectedRange.length;
                                var startMovedOverADelimiter = startMovedLeft && this.hasDelimiterAtIndex(range.start) || startMovedRight && this.hasDelimiterAtIndex(range.start - 1);
                                var endMovedOverADelimiter = endMovedLeft && this.hasDelimiterAtIndex(range.start + range.length) || endMovedRight && this.hasDelimiterAtIndex(range.start + range.length - 1);
                                if (this.isDelimiter(change.deleted.text)) {
                                    var newCursorPosition = change.deleted.start - 1;
                                    // delete any immediately preceding delimiters
                                    while(this.isDelimiter(newText.charAt(newCursorPosition))){
                                        newText = newText.substring(0, newCursorPosition) + newText.substring(newCursorPosition + 1);
                                        newCursorPosition--;
                                    }
                                    // finally delete the real character that was intended
                                    newText = newText.substring(0, newCursorPosition) + newText.substring(newCursorPosition + 1);
                                }
                                // adjust the cursor / selection
                                if (startMovedLeft && startMovedOverADelimiter) {
                                    // move left over any immediately preceding delimiters
                                    while(this.delimiterAt(range.start - 1)){
                                        range.start--;
                                        range.length++;
                                    }
                                    // finally move left over the real intended character
                                    range.start--;
                                    range.length++;
                                }
                                if (startMovedRight) {
                                    // move right over any delimiters found on the way, including any leading delimiters
                                    for(var i = change.current.selectedRange.start; i < range.start + range.length; i++)if (this.delimiterAt(i)) {
                                        range.start++;
                                        if (range.length > 0) range.length--;
                                    }
                                    while(this.delimiterAt(range.start)){
                                        range.start++;
                                        range.length--;
                                    }
                                }
                                if (hasSelection) {
                                    // Otherwise, the logic for the range start takes care of everything.
                                    if (endMovedOverADelimiter) {
                                        if (endMovedLeft) {
                                            // move left over any immediately preceding delimiters
                                            while(this.delimiterAt(range.start + range.length - 1))range.length--;
                                            // finally move left over the real intended character
                                            range.length--;
                                        }
                                        if (endMovedRight) {
                                            // move right over any immediately following delimiters
                                            while(this.delimiterAt(range.start + range.length))range.length++;
                                            // finally move right over the real intended character
                                            range.length++;
                                        }
                                    }
                                    // trailing delimiters in the selection
                                    while(this.hasDelimiterAtIndex(range.start + range.length - 1))if (startMovedLeft || endMovedLeft) range.length--;
                                    else range.length++;
                                    while(this.hasDelimiterAtIndex(range.start))if (startMovedRight || endMovedRight) {
                                        range.start++;
                                        range.length--;
                                    } else {
                                        range.start--;
                                        range.length++;
                                    }
                                } else range.length = 0;
                                var result = true;
                                var value = this._valueFromText(newText, function() {
                                    result = false;
                                    error.apply(undefined, arguments);
                                });
                                if (result) change.proposed.text = this._textFromValue(value);
                                return result;
                            }
                        }
                    ]);
                    return DelimitedTextFormatter;
                }(_formatter2['default']);
                exports['default'] = DelimitedTextFormatter;
                module1.exports = exports['default'];
            },
            {
                "./formatter": 14
            }
        ],
        11: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                /**
 * @const
 * @private
 */ var DIGITS_PATTERN = /^\d*$/;
                /**
 * @extends DelimitedTextFormatter
 */ var EmployerIdentificationNumberFormatter = function(_DelimitedTextFormatter) {
                    _inherits(EmployerIdentificationNumberFormatter, _DelimitedTextFormatter);
                    function EmployerIdentificationNumberFormatter() {
                        _classCallCheck(this, EmployerIdentificationNumberFormatter);
                        _get(Object.getPrototypeOf(EmployerIdentificationNumberFormatter.prototype), 'constructor', this).call(this, '-');
                        this.maximumLength = 10;
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(EmployerIdentificationNumberFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 2;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (DIGITS_PATTERN.test(change.inserted.text)) return _get(Object.getPrototypeOf(EmployerIdentificationNumberFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                else return false;
                            }
                        }
                    ]);
                    return EmployerIdentificationNumberFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = EmployerIdentificationNumberFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10
            }
        ],
        12: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _text_field = _dereq_('./text_field');
                var _text_field2 = _interopRequireDefault(_text_field);
                var _expiry_date_formatter = _dereq_('./expiry_date_formatter');
                var _expiry_date_formatter2 = _interopRequireDefault(_expiry_date_formatter);
                /**
 * Adds a default formatter for expiration dates.
 *
 * @extends TextField
 */ var ExpiryDateField = function(_TextField) {
                    _inherits(ExpiryDateField, _TextField);
                    /**
   * @param {HTMLElement} element
   */ function ExpiryDateField(element) {
                        _classCallCheck(this, ExpiryDateField);
                        _get(Object.getPrototypeOf(ExpiryDateField.prototype), 'constructor', this).call(this, element, new _expiry_date_formatter2['default']());
                    }
                    /**
   * Called by our superclass, used to post-process the text.
   *
   * @private
   */ _createClass(ExpiryDateField, [
                        {
                            key: 'textFieldDidEndEditing',
                            value: function textFieldDidEndEditing() {
                                var value = this.value();
                                if (value) this.setText(this.formatter().format(value));
                            }
                        }
                    ]);
                    return ExpiryDateField;
                }(_text_field2['default']);
                exports['default'] = ExpiryDateField;
                module1.exports = exports['default'];
            },
            {
                "./expiry_date_formatter": 13,
                "./text_field": 20
            }
        ],
        13: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                var _utils = _dereq_('./utils');
                /**
 * Give this function a 2 digit year it'll return with 4.
 *
 * @example
 *     interpretTwoDigitYear(15);
 *     // => 2015
 *     interpretTwoDigitYear(97);
 *     // => 1997
 * @param {number} year
 * @returns {number}
 * @private
 */ function interpretTwoDigitYear(year) {
                    var thisYear = new Date().getFullYear();
                    var thisCentury = thisYear - thisYear % 100;
                    var centuries = [
                        thisCentury,
                        thisCentury - 100,
                        thisCentury + 100
                    ].sort(function(a, b) {
                        return Math.abs(thisYear - (year + a)) - Math.abs(thisYear - (year + b));
                    });
                    return year + centuries[0];
                }
                /**
 * @extends DelimitedTextFormatter
 */ var ExpiryDateFormatter = function(_DelimitedTextFormatter) {
                    _inherits(ExpiryDateFormatter, _DelimitedTextFormatter);
                    function ExpiryDateFormatter() {
                        _classCallCheck(this, ExpiryDateFormatter);
                        _get(Object.getPrototypeOf(ExpiryDateFormatter.prototype), 'constructor', this).call(this, '/');
                        this.maximumLength = 5;
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(ExpiryDateFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 2;
                            }
                        },
                        {
                            key: 'format',
                            value: function format(value) {
                                if (!value) return '';
                                var month = value.month;
                                var year = value.year;
                                year = year % 100;
                                return _get(Object.getPrototypeOf(ExpiryDateFormatter.prototype), 'format', this).call(this, (0, _utils.zpad2)(month) + (0, _utils.zpad2)(year));
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                var monthAndYear = text.split(this.delimiter);
                                var month = monthAndYear[0];
                                var year = monthAndYear[1];
                                if (month && month.match(/^(0?[1-9]|1\d)$/) && year && year.match(/^\d\d?$/)) {
                                    month = Number(month);
                                    year = interpretTwoDigitYear(Number(year));
                                    return {
                                        month: month,
                                        year: year
                                    };
                                } else {
                                    if (typeof error === 'function') error('expiry-date-formatter.invalid-date');
                                    return null;
                                }
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (!error) error = function() {};
                                var isBackspace = change.proposed.text.length < change.current.text.length;
                                var newText = change.proposed.text;
                                if (change.inserted.text === this.delimiter && change.current.text === '1') newText = '01' + this.delimiter;
                                else if (change.inserted.text.length > 0 && !/^\d$/.test(change.inserted.text)) {
                                    error('expiry-date-formatter.only-digits-allowed');
                                    return false;
                                } else {
                                    if (isBackspace) {
                                        if (change.deleted.text === this.delimiter) newText = newText[0];
                                        if (newText === '0') newText = '';
                                        if (change.inserted.text.length > 0 && !/^\d$/.test(change.inserted.text)) {
                                            error('expiry-date-formatter.only-digits-allowed');
                                            return false;
                                        }
                                    }
                                    // 4| -> 04|
                                    if (/^[2-9]$/.test(newText)) newText = '0' + newText;
                                    // 1|1|/5 -> 11|/5
                                    if (/^1[3-9].+$/.test(newText)) {
                                        error('expiry-date-formatter.invalid-month');
                                        return false;
                                    }
                                    // 15| -> 01/5|
                                    if (/^1[3-9]$/.test(newText)) newText = '01' + this.delimiter + newText.slice(-1);
                                    // Don't allow 00
                                    if (newText === '00') {
                                        error('expiry-date-formatter.invalid-month');
                                        return false;
                                    }
                                    // 11| -> 11/
                                    if (/^(0[1-9]|1[0-2])$/.test(newText)) newText += this.delimiter;
                                    var match = newText.match(/^(\d\d)(.)(\d\d?).*$/);
                                    if (match && match[2] === this.delimiter) newText = match[1] + this.delimiter + match[3];
                                }
                                change.proposed.text = newText;
                                change.proposed.selectedRange = {
                                    start: newText.length,
                                    length: 0
                                };
                                return true;
                            }
                        }
                    ]);
                    return ExpiryDateFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = ExpiryDateFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10,
                "./utils": 22
            }
        ],
        14: [
            function(_dereq_, module1, exports) {
                /**
 * Base class providing basic formatting, parsing, and change validation to be
 * customized in subclasses.
 */ 'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var Formatter = function() {
                    function Formatter() {
                        _classCallCheck(this, Formatter);
                    }
                    _createClass(Formatter, [
                        {
                            key: 'format',
                            /**
     * @param {string} text
     * @returns {string}
     */ value: function format(text) {
                                if (text === undefined || text === null) text = '';
                                if (this.maximumLength !== undefined && this.maximumLength !== null) text = text.substring(0, this.maximumLength);
                                return text;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text) {
                                if (text === undefined || text === null) text = '';
                                if (this.maximumLength !== undefined && this.maximumLength !== null) text = text.substring(0, this.maximumLength);
                                return text;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change) {
                                var selectedRange = change.proposed.selectedRange;
                                var text = change.proposed.text;
                                if (this.maximumLength !== undefined && this.maximumLength !== null && text.length > this.maximumLength) {
                                    var available = this.maximumLength - (text.length - change.inserted.text.length);
                                    var newText = change.current.text.substring(0, change.current.selectedRange.start);
                                    if (available > 0) newText += change.inserted.text.substring(0, available);
                                    newText += change.current.text.substring(change.current.selectedRange.start + change.current.selectedRange.length);
                                    var truncatedLength = text.length - newText.length;
                                    change.proposed.text = newText;
                                    selectedRange.start -= truncatedLength;
                                }
                                return true;
                            }
                        }
                    ]);
                    return Formatter;
                }();
                exports['default'] = Formatter;
                module1.exports = exports['default'];
            },
            {}
        ],
        15: [
            function(_dereq_, module1, exports) {
                'use strict';
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                var _adaptive_card_formatter = _dereq_('./adaptive_card_formatter');
                var _adaptive_card_formatter2 = _interopRequireDefault(_adaptive_card_formatter);
                var _amex_card_formatter = _dereq_('./amex_card_formatter');
                var _amex_card_formatter2 = _interopRequireDefault(_amex_card_formatter);
                var _card_text_field = _dereq_('./card_text_field');
                var _card_text_field2 = _interopRequireDefault(_card_text_field);
                var _card_utils = _dereq_('./card_utils');
                var _default_card_formatter = _dereq_('./default_card_formatter');
                var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                var _employer_identification_number_formatter = _dereq_('./employer_identification_number_formatter');
                var _employer_identification_number_formatter2 = _interopRequireDefault(_employer_identification_number_formatter);
                var _expiry_date_field = _dereq_('./expiry_date_field');
                var _expiry_date_field2 = _interopRequireDefault(_expiry_date_field);
                var _expiry_date_formatter = _dereq_('./expiry_date_formatter');
                var _expiry_date_formatter2 = _interopRequireDefault(_expiry_date_formatter);
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var _number_formatter = _dereq_('./number_formatter');
                var _number_formatter2 = _interopRequireDefault(_number_formatter);
                var _number_formatter_settings_formatter = _dereq_('./number_formatter_settings_formatter');
                var _number_formatter_settings_formatter2 = _interopRequireDefault(_number_formatter_settings_formatter);
                var _phone_formatter = _dereq_('./phone_formatter');
                var _phone_formatter2 = _interopRequireDefault(_phone_formatter);
                var _social_security_number_formatter = _dereq_('./social_security_number_formatter');
                var _social_security_number_formatter2 = _interopRequireDefault(_social_security_number_formatter);
                var _text_field = _dereq_('./text_field');
                var _text_field2 = _interopRequireDefault(_text_field);
                var _undo_manager = _dereq_('./undo_manager');
                var _undo_manager2 = _interopRequireDefault(_undo_manager);
                /**
 * @namespace FieldKit
 * @readonly
 */ module1.exports = {
                    AdaptiveCardFormatter: _adaptive_card_formatter2['default'],
                    AmexCardFormatter: _amex_card_formatter2['default'],
                    CardTextField: _card_text_field2['default'],
                    CardUtils: {
                        AMEX: _card_utils.AMEX,
                        DISCOVER: _card_utils.DISCOVER,
                        VISA: _card_utils.VISA,
                        MASTERCARD: _card_utils.MASTERCARD,
                        determineCardType: _card_utils.determineCardType,
                        luhnCheck: _card_utils.luhnCheck,
                        validCardLength: _card_utils.validCardLength
                    },
                    DefaultCardFormatter: _default_card_formatter2['default'],
                    DelimitedTextFormatter: _delimited_text_formatter2['default'],
                    EmployerIdentificationNumberFormatter: _employer_identification_number_formatter2['default'],
                    ExpiryDateField: _expiry_date_field2['default'],
                    ExpiryDateFormatter: _expiry_date_formatter2['default'],
                    Formatter: _formatter2['default'],
                    NumberFormatter: _number_formatter2['default'],
                    NumberFormatterSettingsFormatter: _number_formatter_settings_formatter2['default'],
                    PhoneFormatter: _phone_formatter2['default'],
                    SocialSecurityNumberFormatter: _social_security_number_formatter2['default'],
                    TextField: _text_field2['default'],
                    UndoManager: _undo_manager2['default']
                };
            },
            {
                "./adaptive_card_formatter": 4,
                "./amex_card_formatter": 5,
                "./card_text_field": 6,
                "./card_utils": 7,
                "./default_card_formatter": 9,
                "./delimited_text_formatter": 10,
                "./employer_identification_number_formatter": 11,
                "./expiry_date_field": 12,
                "./expiry_date_formatter": 13,
                "./formatter": 14,
                "./number_formatter": 16,
                "./number_formatter_settings_formatter": 17,
                "./phone_formatter": 18,
                "./social_security_number_formatter": 19,
                "./text_field": 20,
                "./undo_manager": 21
            }
        ],
        16: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var _number_formatter_settings_formatter = _dereq_('./number_formatter_settings_formatter');
                var _number_formatter_settings_formatter2 = _interopRequireDefault(_number_formatter_settings_formatter);
                var _utils = _dereq_('./utils');
                var _stround = _dereq_('stround');
                // Style
                var NONE = 0;
                var CURRENCY = 1;
                var PERCENT = 2;
                var DEFAULT_LOCALE = 'en-US';
                var DEFAULT_COUNTRY = 'US';
                /**
 * @param {string} locale
 * @returns {Object} {lang: lang, country: country}
 * @private
 */ function splitLocaleComponents(locale) {
                    var match = locale.match(/^([a-z][a-z])(?:[-_]([a-z][a-z]))?$/i);
                    if (match) {
                        var lang = match[1] && match[1].toLowerCase();
                        var country = match[2] && match[2].toLowerCase();
                        return {
                            lang: lang,
                            country: country
                        };
                    }
                }
                /**
 * This simple property getter assumes that properties will never be functions
 * and so attempts to run those functions using the given args.
 *
 * @private
 */ function get(object, key) {
                    if (object) {
                        var value = object[key];
                        if (typeof value === 'function') {
                            for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                            return value.apply(undefined, args);
                        } else return value;
                    }
                }
                /**
 * @param {string} string
 * @param {string} currencySymbol
 * @return {string}
 * @private
 */ function replaceCurrencySymbol(string, currencySymbol) {
                    return string.replace(/¤/g, currencySymbol);
                }
                /**
 * @param {string} string
 * @param {string} plusSign
 * @returns {string}
 * @private
 */ function replacePlusSign(string, plusSign) {
                    return string.replace(/\+/g, plusSign);
                }
                /**
 * @param {string} string
 * @param {string} minusSign
 * @returns {string}
 * @private
 */ function replaceMinusSign(string, minusSign) {
                    return string.replace(/-/g, minusSign);
                }
                /**
 * Formats and parses numbers. There are many configuration options for how to
 * format numbers as strings, but for many users simply adjusting the
 * {@link NumberFormatter#numberStyle}, {@link NumberFormatter#locale},
 * {@link NumberFormatter#currencyCode}, and {@link NumberFormatter#countryCode}
 * values will be sufficient. NumberFormatter natively understands how to
 * format numbers, currencies, and percentages for a variety of locales.
 *
 * @example
 *
 *   // Configure a NumberFormatter to display currencies.
 *   var f = new FieldKit.NumberFormatter();
 *   f.setNumberStyle(FieldKit.NumberFormatter.Style.CURRENCY);
 *
 *   // Configure the current locale info.
 *   f.setLocale('en-US');
 *   f.setCountryCode('US');
 *   f.setCurrencyCode('USD');
 *
 *   // Showing USD in US uses abbreviated currency.
 *   f.format(6.17);  // '$6.17'
 *
 *   // Showing CAD in US uses fully-qualified currency.
 *   f.setCurrencyCode('CAD');
 *   f.format(6.17);  // 'CA$6.17'
 *
 *   // Showing CAD in CA again uses abbreviated currency.
 *   f.setLocale('en-CA');
 *   f.setCountryCode('CA');
 *   f.format(6.17);  // '$6.17'
 *
 *   // Showing CAD in CA to a French speaker uses correct formatting.
 *   f.setLocale('fr-CA');
 *   f.format(6.17);  // '6,17 $'
 *
 *   // You may customize the behavior of NumberFormatter to achieve whatever
 *   // number formatting you need using the setter methods for the various
 *   // settings, or you can use the {@link NumberFormatter#positiveFormat} and
 *   // {@link NumberFormatter#negativeFormat} shorthand templates.
 *
 *   var f = new FieldKit.NumberFormatter();
 *
 *   // Using this template string…
 *   f.setPositiveFormat('¤#0.00');
 *
 *   // …is equivalent to this:
 *   f.setPositivePrefix('¤');
 *   f.setPositiveSuffix('');
 *   f.setMinimumIntegerDigits(1);
 *   f.setMinimumFractionDigits(2);
 *   f.setMaximumFractionDigits(2);
 *
 *   // And you can determine what the template string is for however you've
 *   // configured the NumberFormatter:
 *   f.setUsesGroupingSeparator(true);
 *   f.setGroupingSize(2);
 *   f.positiveFormat(); // '¤#,#0.00'
 *
 * @extends Formatter
 */ var NumberFormatter = function(_Formatter) {
                    _inherits(NumberFormatter, _Formatter);
                    function NumberFormatter() {
                        _classCallCheck(this, NumberFormatter);
                        _get(Object.getPrototypeOf(NumberFormatter.prototype), 'constructor', this).call(this);
                        this.setNumberStyle(NONE);
                    }
                    /**
   * Defaults
   */ /** @private */ /**
   * Gets whether this formatter will parse float number values. This value does
   * not apply to formatting. To prevent formatting floats, set
   * maximumFractionDigits to 0.
   *
   * @returns {boolean}
   */ _createClass(NumberFormatter, [
                        {
                            key: 'allowsFloats',
                            value: function allowsFloats() {
                                return this._get('allowsFloats');
                            }
                        },
                        {
                            key: 'setAllowsFloats',
                            value: function setAllowsFloats(allowsFloats) {
                                this._allowsFloats = allowsFloats;
                                return this;
                            }
                        },
                        {
                            key: 'alwaysShowsDecimalSeparator',
                            value: function alwaysShowsDecimalSeparator() {
                                return this._get('alwaysShowsDecimalSeparator');
                            }
                        },
                        {
                            key: 'setAlwaysShowsDecimalSeparator',
                            value: function setAlwaysShowsDecimalSeparator(alwaysShowsDecimalSeparator) {
                                this._alwaysShowsDecimalSeparator = alwaysShowsDecimalSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'countryCode',
                            value: function countryCode() {
                                return this._countryCode || DEFAULT_COUNTRY;
                            }
                        },
                        {
                            key: 'setCountryCode',
                            value: function setCountryCode(countryCode) {
                                this._countryCode = countryCode;
                                return this;
                            }
                        },
                        {
                            key: 'currencyCode',
                            value: function currencyCode() {
                                return this._get('currencyCode');
                            }
                        },
                        {
                            key: 'setCurrencyCode',
                            value: function setCurrencyCode(currencyCode) {
                                this._currencyCode = currencyCode;
                                return this;
                            }
                        },
                        {
                            key: 'currencySymbol',
                            value: function currencySymbol() {
                                if (this._shouldShowNativeCurrencySymbol()) return this._get('currencySymbol');
                                else return this._get('internationalCurrencySymbol');
                            }
                        },
                        {
                            key: 'setCurrencySymbol',
                            value: function setCurrencySymbol(currencySymbol) {
                                this._currencySymbol = currencySymbol;
                                return this;
                            }
                        },
                        {
                            key: '_shouldShowNativeCurrencySymbol',
                            value: function _shouldShowNativeCurrencySymbol() {
                                var regionDefaultCurrencyCode = this._regionDefaults().currencyCode;
                                if (typeof regionDefaultCurrencyCode === 'function') regionDefaultCurrencyCode = regionDefaultCurrencyCode();
                                return this.currencyCode() === regionDefaultCurrencyCode;
                            }
                        },
                        {
                            key: 'decimalSeparator',
                            value: function decimalSeparator() {
                                return this._get('decimalSeparator');
                            }
                        },
                        {
                            key: 'setDecimalSeparator',
                            value: function setDecimalSeparator(decimalSeparator) {
                                this._decimalSeparator = decimalSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'exponent',
                            value: function exponent() {
                                return this._get('exponent');
                            }
                        },
                        {
                            key: 'setExponent',
                            value: function setExponent(exponent) {
                                this._exponent = exponent;
                                return this;
                            }
                        },
                        {
                            key: 'groupingSeparator',
                            value: function groupingSeparator() {
                                return this._get('groupingSeparator');
                            }
                        },
                        {
                            key: 'setGroupingSeparator',
                            value: function setGroupingSeparator(groupingSeparator) {
                                this._groupingSeparator = groupingSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'groupingSize',
                            value: function groupingSize() {
                                return this._get('groupingSize');
                            }
                        },
                        {
                            key: 'setGroupingSize',
                            value: function setGroupingSize(groupingSize) {
                                this._groupingSize = groupingSize;
                                return this;
                            }
                        },
                        {
                            key: 'internationalCurrencySymbol',
                            value: function internationalCurrencySymbol() {
                                return this._get('internationalCurrencySymbol');
                            }
                        },
                        {
                            key: 'setInternationalCurrencySymbol',
                            value: function setInternationalCurrencySymbol(internationalCurrencySymbol) {
                                this._internationalCurrencySymbol = internationalCurrencySymbol;
                                return this;
                            }
                        },
                        {
                            key: 'isLenient',
                            value: function isLenient() {
                                return this._lenient;
                            }
                        },
                        {
                            key: 'setLenient',
                            value: function setLenient(lenient) {
                                this._lenient = lenient;
                                return this;
                            }
                        },
                        {
                            key: 'locale',
                            value: function locale() {
                                return this._locale || DEFAULT_LOCALE;
                            }
                        },
                        {
                            key: 'setLocale',
                            value: function setLocale(locale) {
                                this._locale = locale;
                                return this;
                            }
                        },
                        {
                            key: 'maximum',
                            value: function maximum() {
                                return this._maximum;
                            }
                        },
                        {
                            key: 'setMaximum',
                            value: function setMaximum(max) {
                                this._maximum = max;
                                return this;
                            }
                        },
                        {
                            key: 'minimum',
                            value: function minimum() {
                                return this._minimum;
                            }
                        },
                        {
                            key: 'setMinimum',
                            value: function setMinimum(min) {
                                this._minimum = min;
                                return this;
                            }
                        },
                        {
                            key: 'maximumFractionDigits',
                            value: function maximumFractionDigits() {
                                var result = this._get('maximumFractionDigits');
                                var minimumFractionDigits = this._minimumFractionDigits;
                                if (result !== null && result !== undefined && minimumFractionDigits !== null && minimumFractionDigits !== undefined && minimumFractionDigits > result) result = minimumFractionDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMaximumFractionDigits',
                            value: function setMaximumFractionDigits(maximumFractionDigits) {
                                this._maximumFractionDigits = maximumFractionDigits;
                                return this;
                            }
                        },
                        {
                            key: 'minimumFractionDigits',
                            value: function minimumFractionDigits() {
                                var result = this._get('minimumFractionDigits');
                                var maximumFractionDigits = this._maximumFractionDigits;
                                if (result !== null && result !== undefined && maximumFractionDigits !== null && maximumFractionDigits !== undefined && maximumFractionDigits < result) result = maximumFractionDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMinimumFractionDigits',
                            value: function setMinimumFractionDigits(minimumFractionDigits) {
                                this._minimumFractionDigits = minimumFractionDigits;
                                return this;
                            }
                        },
                        {
                            key: 'maximumIntegerDigits',
                            value: function maximumIntegerDigits() {
                                var result = this._get('maximumIntegerDigits');
                                var minimumIntegerDigits = this._minimumIntegerDigits;
                                if (result !== null && result !== undefined && minimumIntegerDigits !== null && minimumIntegerDigits !== undefined && minimumIntegerDigits > result) result = minimumIntegerDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMaximumIntegerDigits',
                            value: function setMaximumIntegerDigits(maximumIntegerDigits) {
                                this._maximumIntegerDigits = maximumIntegerDigits;
                                return this;
                            }
                        },
                        {
                            key: 'minimumIntegerDigits',
                            value: function minimumIntegerDigits() {
                                var result = this._get('minimumIntegerDigits');
                                var maximumIntegerDigits = this._maximumIntegerDigits;
                                if (result !== null && result !== undefined && maximumIntegerDigits !== null && maximumIntegerDigits !== undefined && maximumIntegerDigits < result) result = maximumIntegerDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMinimumIntegerDigits',
                            value: function setMinimumIntegerDigits(minimumIntegerDigits) {
                                this._minimumIntegerDigits = minimumIntegerDigits;
                                return this;
                            }
                        },
                        {
                            key: 'minusSign',
                            value: function minusSign() {
                                return this._get('minusSign');
                            }
                        },
                        {
                            key: 'setMinusSign',
                            value: function setMinusSign(minusSign) {
                                this._minusSign = minusSign;
                                return this;
                            }
                        },
                        {
                            key: 'negativeFormat',
                            value: function negativeFormat() {
                                return this.numberFormatFormatter().format({
                                    alwaysShowsDecimalSeparator: this.alwaysShowsDecimalSeparator(),
                                    groupingSize: this.groupingSize(),
                                    maximumFractionDigits: this.maximumFractionDigits(),
                                    minimumFractionDigits: this.minimumFractionDigits(),
                                    minimumIntegerDigits: this.minimumIntegerDigits(),
                                    prefix: this._get('negativePrefix'),
                                    suffix: this._get('negativeSuffix'),
                                    usesGroupingSeparator: this.usesGroupingSeparator()
                                });
                            }
                        },
                        {
                            key: 'setNegativeFormat',
                            value: function setNegativeFormat(negativeFormat) {
                                var settings = this.numberFormatFormatter().parse(negativeFormat);
                                this.setNegativePrefix(settings.prefix);
                                this.setNegativeSuffix(settings.suffix);
                                this.setGroupingSize(settings.groupingSize);
                                this.setMaximumFractionDigits(settings.maximumFractionDigits);
                                this.setMinimumFractionDigits(settings.minimumFractionDigits);
                                this.setMinimumIntegerDigits(settings.minimumIntegerDigits);
                                this.setUsesGroupingSeparator(settings.usesGroupingSeparator);
                            }
                        },
                        {
                            key: 'negativeInfinitySymbol',
                            value: function negativeInfinitySymbol() {
                                return this._get('negativeInfinitySymbol');
                            }
                        },
                        {
                            key: 'setNegativeInfinitySymbol',
                            value: function setNegativeInfinitySymbol(negativeInfinitySymbol) {
                                this._negativeInfinitySymbol = negativeInfinitySymbol;
                                return this;
                            }
                        },
                        {
                            key: 'negativePrefix',
                            value: function negativePrefix() {
                                return replaceCurrencySymbol(replaceMinusSign(this._get('negativePrefix'), this._get('minusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setNegativePrefix',
                            value: function setNegativePrefix(prefix) {
                                this._negativePrefix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'negativeSuffix',
                            value: function negativeSuffix() {
                                return replaceCurrencySymbol(replaceMinusSign(this._get('negativeSuffix'), this._get('minusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setNegativeSuffix',
                            value: function setNegativeSuffix(prefix) {
                                this._negativeSuffix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'notANumberSymbol',
                            value: function notANumberSymbol() {
                                return this._get('notANumberSymbol');
                            }
                        },
                        {
                            key: 'setNotANumberSymbol',
                            value: function setNotANumberSymbol(notANumberSymbol) {
                                this._notANumberSymbol = notANumberSymbol;
                                return this;
                            }
                        },
                        {
                            key: 'nullSymbol',
                            value: function nullSymbol() {
                                return this._get('nullSymbol');
                            }
                        },
                        {
                            key: 'setNullSymbol',
                            value: function setNullSymbol(nullSymbol) {
                                this._nullSymbol = nullSymbol;
                                return this;
                            }
                        },
                        {
                            key: 'numberFormatFormatter',
                            value: function numberFormatFormatter() {
                                if (!this._numberFormatFormatter) this._numberFormatFormatter = new _number_formatter_settings_formatter2['default']();
                                return this._numberFormatFormatter;
                            }
                        },
                        {
                            key: 'numberStyle',
                            value: function numberStyle() {
                                return this._numberStyle;
                            }
                        },
                        {
                            key: 'setNumberStyle',
                            value: function setNumberStyle(numberStyle) {
                                this._numberStyle = numberStyle;
                                switch(this._numberStyle){
                                    case NONE:
                                        this._styleDefaults = StyleDefaults.NONE;
                                        break;
                                    case PERCENT:
                                        this._styleDefaults = StyleDefaults.PERCENT;
                                        break;
                                    case CURRENCY:
                                        this._styleDefaults = StyleDefaults.CURRENCY;
                                        break;
                                    default:
                                        this._styleDefaults = null;
                                }
                                return this;
                            }
                        },
                        {
                            key: 'percentSymbol',
                            value: function percentSymbol() {
                                return this._get('percentSymbol');
                            }
                        },
                        {
                            key: 'setPercentSymbol',
                            value: function setPercentSymbol(percentSymbol) {
                                this._percentSymbol = percentSymbol;
                                return this;
                            }
                        },
                        {
                            key: 'plusSign',
                            value: function plusSign() {
                                return this._get('plusSign');
                            }
                        },
                        {
                            key: 'setPlusSign',
                            value: function setPlusSign(plusSign) {
                                this._plusSign = plusSign;
                                return this;
                            }
                        },
                        {
                            key: 'positiveFormat',
                            value: function positiveFormat() {
                                return this.numberFormatFormatter().format({
                                    alwaysShowsDecimalSeparator: this.alwaysShowsDecimalSeparator(),
                                    groupingSize: this.groupingSize(),
                                    maximumFractionDigits: this.maximumFractionDigits(),
                                    minimumFractionDigits: this.minimumFractionDigits(),
                                    minimumIntegerDigits: this.minimumIntegerDigits(),
                                    prefix: this._get('positivePrefix'),
                                    suffix: this._get('positiveSuffix'),
                                    usesGroupingSeparator: this.usesGroupingSeparator()
                                });
                            }
                        },
                        {
                            key: 'setPositiveFormat',
                            value: function setPositiveFormat(positiveFormat) {
                                var settings = this.numberFormatFormatter().parse(positiveFormat);
                                this.setPositivePrefix(settings.prefix);
                                this.setPositiveSuffix(settings.suffix);
                                this.setGroupingSize(settings.groupingSize);
                                this.setMaximumFractionDigits(settings.maximumFractionDigits);
                                this.setMinimumFractionDigits(settings.minimumFractionDigits);
                                this.setMinimumIntegerDigits(settings.minimumIntegerDigits);
                                this.setUsesGroupingSeparator(settings.usesGroupingSeparator);
                            }
                        },
                        {
                            key: 'positiveInfinitySymbol',
                            value: function positiveInfinitySymbol() {
                                return this._get('positiveInfinitySymbol');
                            }
                        },
                        {
                            key: 'setPositiveInfinitySymbol',
                            value: function setPositiveInfinitySymbol(positiveInfinitySymbol) {
                                this._positiveInfinitySymbol = positiveInfinitySymbol;
                                return this;
                            }
                        },
                        {
                            key: 'positivePrefix',
                            value: function positivePrefix() {
                                return replaceCurrencySymbol(replacePlusSign(this._get('positivePrefix'), this._get('plusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setPositivePrefix',
                            value: function setPositivePrefix(prefix) {
                                this._positivePrefix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'positiveSuffix',
                            value: function positiveSuffix() {
                                return replaceCurrencySymbol(replacePlusSign(this._get('positiveSuffix'), this._get('plusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setPositiveSuffix',
                            value: function setPositiveSuffix(prefix) {
                                this._positiveSuffix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'roundingMode',
                            value: function roundingMode() {
                                return this._get('roundingMode');
                            }
                        },
                        {
                            key: 'setRoundingMode',
                            value: function setRoundingMode(roundingMode) {
                                this._roundingMode = roundingMode;
                                return this;
                            }
                        },
                        {
                            key: 'usesGroupingSeparator',
                            value: function usesGroupingSeparator() {
                                return this._get('usesGroupingSeparator');
                            }
                        },
                        {
                            key: 'setUsesGroupingSeparator',
                            value: function setUsesGroupingSeparator(usesGroupingSeparator) {
                                this._usesGroupingSeparator = usesGroupingSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'zeroSymbol',
                            value: function zeroSymbol() {
                                return this._get('zeroSymbol');
                            }
                        },
                        {
                            key: 'setZeroSymbol',
                            value: function setZeroSymbol(zeroSymbol) {
                                this._zeroSymbol = zeroSymbol;
                                return this;
                            }
                        },
                        {
                            key: '_get',
                            value: function _get(attr) {
                                var value = this['_' + attr];
                                if (value !== null && value !== undefined) return value;
                                var styleDefaults = this._styleDefaults;
                                var localeDefaults = this._localeDefaults();
                                var regionDefaults = this._regionDefaults();
                                value = get(styleDefaults, attr, this, localeDefaults);
                                if (value !== null && value !== undefined) return value;
                                value = get(localeDefaults, attr, this, styleDefaults);
                                if (value !== null && value !== undefined) return value;
                                value = get(regionDefaults, attr, this, styleDefaults);
                                if (value !== null && value !== undefined) return value;
                                value = get(this._currencyDefaults(), attr, this, localeDefaults);
                                if (value !== null && value !== undefined) return value;
                                return null;
                            }
                        },
                        {
                            key: 'format',
                            value: function format(number) {
                                if (number === '') return '';
                                var zeroSymbol = this.zeroSymbol();
                                if (zeroSymbol !== undefined && zeroSymbol !== null && number === 0) return zeroSymbol;
                                var nullSymbol = this.nullSymbol();
                                if (nullSymbol !== undefined && nullSymbol !== null && number === null) return nullSymbol;
                                var notANumberSymbol = this.notANumberSymbol();
                                if (notANumberSymbol !== undefined && notANumberSymbol !== null && isNaN(number)) return notANumberSymbol;
                                var positiveInfinitySymbol = this.positiveInfinitySymbol();
                                if (positiveInfinitySymbol !== undefined && positiveInfinitySymbol !== null && number === Infinity) return positiveInfinitySymbol;
                                var negativeInfinitySymbol = this.negativeInfinitySymbol();
                                if (negativeInfinitySymbol !== undefined && negativeInfinitySymbol !== null && number === -Infinity) return negativeInfinitySymbol;
                                var negative = number < 0;
                                var parts = ('' + Math.abs(number)).split('.');
                                var integerPart = parts[0];
                                var fractionPart = parts[1] || '';
                                var exponent = this.exponent();
                                if (exponent !== undefined && exponent !== null) {
                                    var shifted = (0, _stround.shiftParts)([
                                        negative,
                                        integerPart,
                                        fractionPart
                                    ], exponent);
                                    negative = shifted[0];
                                    integerPart = shifted[1];
                                    fractionPart = shifted[2];
                                    while(integerPart[0] === '0')integerPart = integerPart.slice(1);
                                }
                                // round fraction part to the maximum length
                                var maximumFractionDigits = this.maximumFractionDigits();
                                if (fractionPart.length > maximumFractionDigits) {
                                    var unrounded = integerPart + '.' + fractionPart;
                                    var rounded = this._round(negative ? '-' + unrounded : unrounded);
                                    if (rounded[0] === '-') rounded = rounded.slice(1);
                                    parts = rounded.split('.');
                                    integerPart = parts[0];
                                    fractionPart = parts[1] || '';
                                }
                                // right-pad fraction zeros up to the minimum length
                                var minimumFractionDigits = this.minimumFractionDigits();
                                while(fractionPart.length < minimumFractionDigits)fractionPart += '0';
                                // left-pad integer zeros up to the minimum length
                                var minimumIntegerDigits = this.minimumIntegerDigits();
                                while(integerPart.length < minimumIntegerDigits)integerPart = '0' + integerPart;
                                // eat any unneeded trailing zeros
                                while(fractionPart.length > minimumFractionDigits && fractionPart.slice(-1) === '0')fractionPart = fractionPart.slice(0, -1);
                                // left-truncate any integer digits over the maximum length
                                var maximumIntegerDigits = this.maximumIntegerDigits();
                                if (maximumIntegerDigits !== undefined && maximumIntegerDigits !== null && integerPart.length > maximumIntegerDigits) integerPart = integerPart.slice(-maximumIntegerDigits);
                                // add the decimal separator
                                if (fractionPart.length > 0 || this.alwaysShowsDecimalSeparator()) fractionPart = this.decimalSeparator() + fractionPart;
                                if (this.usesGroupingSeparator()) {
                                    var integerPartWithGroupingSeparators = '';
                                    var copiedCharacterCount = 0;
                                    for(var i = integerPart.length - 1; i >= 0; i--){
                                        if (copiedCharacterCount > 0 && copiedCharacterCount % this.groupingSize() === 0) integerPartWithGroupingSeparators = this.groupingSeparator() + integerPartWithGroupingSeparators;
                                        integerPartWithGroupingSeparators = integerPart[i] + integerPartWithGroupingSeparators;
                                        copiedCharacterCount++;
                                    }
                                    integerPart = integerPartWithGroupingSeparators;
                                }
                                var result = integerPart + fractionPart;
                                // surround with the appropriate prefix and suffix
                                if (negative) result = this.negativePrefix() + result + this.negativeSuffix();
                                else result = this.positivePrefix() + result + this.positiveSuffix();
                                return result;
                            }
                        },
                        {
                            key: '_round',
                            value: function _round(number) {
                                return (0, _stround.round)(number, this.maximumFractionDigits(), this.roundingMode());
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(string, error) {
                                var result = undefined;
                                var positivePrefix = this.positivePrefix();
                                var negativePrefix = this.negativePrefix();
                                var positiveSuffix = this.positiveSuffix();
                                var negativeSuffix = this.negativeSuffix();
                                if (this.isLenient()) {
                                    string = string.replace(/\s/g, '');
                                    positivePrefix = (0, _utils.trim)(positivePrefix);
                                    negativePrefix = (0, _utils.trim)(negativePrefix);
                                    positiveSuffix = (0, _utils.trim)(positiveSuffix);
                                    negativeSuffix = (0, _utils.trim)(negativeSuffix);
                                }
                                var zeroSymbol = undefined;
                                var nullSymbol = undefined;
                                var notANumberSymbol = undefined;
                                var positiveInfinitySymbol = undefined;
                                var negativeInfinitySymbol = undefined;
                                var innerString = undefined;
                                if ((zeroSymbol = this.zeroSymbol()) !== undefined && zeroSymbol !== null && string === zeroSymbol) result = 0;
                                else if ((nullSymbol = this.nullSymbol()) !== undefined && nullSymbol !== null && string === nullSymbol) result = null;
                                else if ((notANumberSymbol = this.notANumberSymbol()) !== undefined && notANumberSymbol !== null && string === notANumberSymbol) result = NaN;
                                else if ((positiveInfinitySymbol = this.positiveInfinitySymbol()) !== undefined && positiveInfinitySymbol !== null && string === positiveInfinitySymbol) result = Infinity;
                                else if ((negativeInfinitySymbol = this.negativeInfinitySymbol()) !== undefined && negativeInfinitySymbol !== null && string === negativeInfinitySymbol) result = -Infinity;
                                else {
                                    var hasNegativePrefix = (0, _utils.startsWith)(negativePrefix, string);
                                    var hasNegativeSuffix = (0, _utils.endsWith)(negativeSuffix, string);
                                    if (hasNegativePrefix && (this.isLenient() || hasNegativeSuffix)) {
                                        innerString = string.slice(negativePrefix.length);
                                        if (hasNegativeSuffix) innerString = innerString.slice(0, innerString.length - negativeSuffix.length);
                                        result = this._parseAbsoluteValue(innerString, error);
                                        if (result !== undefined && result !== null) result *= -1;
                                    } else {
                                        var hasPositivePrefix = (0, _utils.startsWith)(positivePrefix, string);
                                        var hasPositiveSuffix = (0, _utils.endsWith)(positiveSuffix, string);
                                        if (this.isLenient() || hasPositivePrefix && hasPositiveSuffix) {
                                            innerString = string;
                                            if (hasPositivePrefix) innerString = innerString.slice(positivePrefix.length);
                                            if (hasPositiveSuffix) innerString = innerString.slice(0, innerString.length - positiveSuffix.length);
                                            result = this._parseAbsoluteValue(innerString, error);
                                        } else {
                                            if (typeof error === 'function') error('number-formatter.invalid-format');
                                            return null;
                                        }
                                    }
                                }
                                if (result !== undefined && result !== null) {
                                    var minimum = this.minimum();
                                    if (minimum !== undefined && minimum !== null && result < minimum) {
                                        if (typeof error === 'function') error('number-formatter.out-of-bounds.below-minimum');
                                        return null;
                                    }
                                    var maximum = this.maximum();
                                    if (maximum !== undefined && maximum !== null && result > maximum) {
                                        if (typeof error === 'function') error('number-formatter.out-of-bounds.above-maximum');
                                        return null;
                                    }
                                }
                                return result;
                            }
                        },
                        {
                            key: '_parseAbsoluteValue',
                            value: function _parseAbsoluteValue(string, error) {
                                var number = undefined;
                                if (string.length === 0) {
                                    if (typeof error === 'function') error('number-formatter.invalid-format');
                                    return null;
                                }
                                var parts = string.split(this.decimalSeparator());
                                if (parts.length > 2) {
                                    if (typeof error === 'function') error('number-formatter.invalid-format');
                                    return null;
                                }
                                var integerPart = parts[0];
                                var fractionPart = parts[1] || '';
                                if (this.usesGroupingSeparator()) {
                                    var groupingSize = this.groupingSize();
                                    var groupParts = integerPart.split(this.groupingSeparator());
                                    if (!this.isLenient()) {
                                        if (groupParts.length > 1) {
                                            // disallow 1000,000
                                            if (groupParts[0].length > groupingSize) {
                                                if (typeof error === 'function') error('number-formatter.invalid-format.grouping-size');
                                                return null;
                                            }
                                            // disallow 1,00
                                            var groupPartsTail = groupParts.slice(1);
                                            for(var i = 0, l = groupPartsTail.length; i < l; i++)if (groupPartsTail[i].length !== groupingSize) {
                                                if (typeof error === 'function') error('number-formatter.invalid-format.grouping-size');
                                                return null;
                                            }
                                        }
                                    }
                                    // remove grouping separators
                                    integerPart = groupParts.join('');
                                }
                                if (!(0, _utils.isDigits)(integerPart) || !(0, _utils.isDigits)(fractionPart)) {
                                    if (typeof error === 'function') error('number-formatter.invalid-format');
                                    return null;
                                }
                                var exponent = this.exponent();
                                if (exponent !== undefined && exponent !== null) {
                                    var shifted = (0, _stround.shiftParts)([
                                        false,
                                        integerPart,
                                        fractionPart
                                    ], -exponent);
                                    integerPart = shifted[1];
                                    fractionPart = shifted[2];
                                }
                                number = Number(integerPart) + Number('.' + (fractionPart || '0'));
                                if (!this.allowsFloats() && number !== ~~number) {
                                    if (typeof error === 'function') error('number-formatter.floats-not-allowed');
                                    return null;
                                }
                                return number;
                            }
                        },
                        {
                            key: '_currencyDefaults',
                            value: function _currencyDefaults() {
                                var result = {};
                                (0, _utils.forEach)(CurrencyDefaults['default'], function(value, key) {
                                    result[key] = value;
                                });
                                (0, _utils.forEach)(CurrencyDefaults[this.currencyCode()], function(value, key) {
                                    result[key] = value;
                                });
                                return result;
                            }
                        },
                        {
                            key: '_regionDefaults',
                            value: function _regionDefaults() {
                                var result = {};
                                (0, _utils.forEach)(RegionDefaults['default'], function(value, key) {
                                    result[key] = value;
                                });
                                (0, _utils.forEach)(RegionDefaults[this.countryCode()], function(value, key) {
                                    result[key] = value;
                                });
                                return result;
                            }
                        },
                        {
                            key: '_localeDefaults',
                            value: function _localeDefaults() {
                                var locale = this.locale();
                                var countryCode = this.countryCode();
                                var lang = splitLocaleComponents(locale).lang;
                                var result = {};
                                var defaultFallbacks = [
                                    RegionDefaults['default'],
                                    LocaleDefaults['default'],
                                    RegionDefaults[countryCode],
                                    LocaleDefaults[lang],
                                    LocaleDefaults[locale] // fr-CA
                                ];
                                (0, _utils.forEach)(defaultFallbacks, function(defaults) {
                                    (0, _utils.forEach)(defaults, function(value, key) {
                                        result[key] = value;
                                    });
                                });
                                return result;
                            }
                        }
                    ]);
                    return NumberFormatter;
                }(_formatter2['default']);
                NumberFormatter.prototype._allowsFloats = null;
                /** @private */ NumberFormatter.prototype._alwaysShowsDecimalSeparator = null;
                /** @private */ NumberFormatter.prototype._countryCode = null;
                /** @private */ NumberFormatter.prototype._currencyCode = null;
                /** @private */ NumberFormatter.prototype._exponent = null;
                /** @private */ NumberFormatter.prototype._groupingSeparator = null;
                /** @private */ NumberFormatter.prototype._groupingSize = null;
                /** @private */ NumberFormatter.prototype._lenient = false;
                /** @private */ NumberFormatter.prototype._locale = null;
                /** @private */ NumberFormatter.prototype._internationalCurrencySymbol = null;
                /** @private */ NumberFormatter.prototype._maximumFractionDigits = null;
                /** @private */ NumberFormatter.prototype._minimumFractionDigits = null;
                /** @private */ NumberFormatter.prototype._maximumIntegerDigits = null;
                /** @private */ NumberFormatter.prototype._minimumIntegerDigits = null;
                /** @private */ NumberFormatter.prototype._maximum = null;
                /** @private */ NumberFormatter.prototype._minimum = null;
                /** @private */ NumberFormatter.prototype._notANumberSymbol = null;
                /** @private */ NumberFormatter.prototype._nullSymbol = null;
                /** @private */ NumberFormatter.prototype._numberStyle = null;
                /** @private */ NumberFormatter.prototype._roundingMode = null;
                /** @private */ NumberFormatter.prototype._usesGroupingSeparator = null;
                /** @private */ NumberFormatter.prototype._zeroSymbol = null;
                /**
 * Aliases
 */ NumberFormatter.prototype.stringFromNumber = NumberFormatter.prototype.format;
                NumberFormatter.prototype.numberFromString = NumberFormatter.prototype.parse;
                NumberFormatter.Rounding = _stround.modes;
                /**
 * @enum {number}
 * @readonly
 */ NumberFormatter.Style = {
                    NONE: NONE,
                    CURRENCY: CURRENCY,
                    PERCENT: PERCENT
                };
                /**
 * @namespace StyleDefaults
 */ var StyleDefaults = {
                    NONE: {
                        usesGroupingSeparator: false,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        minimumIntegerDigits: 0
                    },
                    PERCENT: {
                        usesGroupingSeparator: false,
                        exponent: 2,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        minimumIntegerDigits: 1,
                        positiveSuffix: function positiveSuffix(formatter) {
                            return formatter.percentSymbol();
                        },
                        negativeSuffix: function negativeSuffix(formatter) {
                            return formatter.percentSymbol();
                        }
                    },
                    CURRENCY: {
                        positivePrefix: function positivePrefix(formatter, locale) {
                            return get(locale, 'positiveCurrencyPrefix', formatter, this);
                        },
                        positiveSuffix: function positiveSuffix(formatter, locale) {
                            return get(locale, 'positiveCurrencySuffix', formatter, this);
                        },
                        negativePrefix: function negativePrefix(formatter, locale) {
                            return get(locale, 'negativeCurrencyPrefix', formatter, this);
                        },
                        negativeSuffix: function negativeSuffix(formatter, locale) {
                            return get(locale, 'negativeCurrencySuffix', formatter, this);
                        }
                    }
                };
                /**
 * Contains the default values for various number formatter settings, including
 * per-locale overrides. Some of these characters will not be used as-is and
 * instead serve as placeholders:
 *
 *   "¤"  placeholder for `currencySymbol()`.
 *   "-"  placeholder for `minusSign()`.
 *   "+"  placeholder for `plusSign()`.
 *
 * @namespace LocaleDefaults
 */ var LocaleDefaults = {
                    'default': {
                        allowsFloats: true,
                        alwaysShowsDecimalSeparator: false,
                        decimalSeparator: '.',
                        groupingSeparator: ',',
                        groupingSize: 3,
                        minusSign: '-',
                        negativeInfinitySymbol: "-\u221E",
                        negativePrefix: '-',
                        negativeSuffix: '',
                        notANumberSymbol: 'NaN',
                        nullSymbol: '',
                        percentSymbol: '%',
                        positiveInfinitySymbol: "+\u221E",
                        positivePrefix: '',
                        positiveSuffix: '',
                        plusSign: '+',
                        roundingMode: NumberFormatter.Rounding.HALF_EVEN,
                        positiveCurrencyPrefix: "\xa4",
                        positiveCurrencySuffix: '',
                        negativeCurrencyPrefix: "(\xa4",
                        negativeCurrencySuffix: ')'
                    },
                    fr: {
                        decimalSeparator: ',',
                        groupingSeparator: ' ',
                        percentSymbol: ' %',
                        positiveCurrencyPrefix: '',
                        positiveCurrencySuffix: " \xa4",
                        negativeCurrencyPrefix: '(',
                        negativeCurrencySuffix: " \xa4)"
                    },
                    ja: {
                        negativeCurrencyPrefix: "-\xa4",
                        negativeCurrencySuffix: ''
                    },
                    'en-GB': {
                        negativeCurrencyPrefix: "-\xa4",
                        negativeCurrencySuffix: ''
                    },
                    'es-ES': {
                        decimalSeparator: ',',
                        groupingSeparator: ' ',
                        percentSymbol: ' %',
                        positiveCurrencyPrefix: '',
                        positiveCurrencySuffix: " \xa4",
                        negativeCurrencyPrefix: '(',
                        negativeCurrencySuffix: " \xa4)"
                    }
                };
                /**
 * @namespace RegionDefaults
 */ var RegionDefaults = {
                    AE: {
                        currencyCode: 'AED'
                    },
                    AG: {
                        currencyCode: 'XCD'
                    },
                    AI: {
                        currencyCode: 'XCD'
                    },
                    AL: {
                        currencyCode: 'ALL'
                    },
                    AM: {
                        currencyCode: 'AMD'
                    },
                    AO: {
                        currencyCode: 'AOA'
                    },
                    AR: {
                        currencyCode: 'ARS'
                    },
                    AT: {
                        currencyCode: 'EUR'
                    },
                    AU: {
                        currencyCode: 'AUD'
                    },
                    AW: {
                        currencyCode: 'AWG'
                    },
                    AZ: {
                        currencyCode: 'AZN'
                    },
                    BA: {
                        currencyCode: 'BAM'
                    },
                    BB: {
                        currencyCode: 'BBD'
                    },
                    BD: {
                        currencyCode: 'BDT'
                    },
                    BE: {
                        currencyCode: 'EUR'
                    },
                    BF: {
                        currencyCode: 'XOF'
                    },
                    BG: {
                        currencyCode: 'BGN'
                    },
                    BH: {
                        currencyCode: 'BHD'
                    },
                    BJ: {
                        currencyCode: 'XOF'
                    },
                    BM: {
                        currencyCode: 'BMD'
                    },
                    BN: {
                        currencyCode: 'BND'
                    },
                    BO: {
                        currencyCode: 'BOB'
                    },
                    BR: {
                        currencyCode: 'BRL'
                    },
                    BS: {
                        currencyCode: 'BSD'
                    },
                    BT: {
                        currencyCode: 'BTN'
                    },
                    BW: {
                        currencyCode: 'BWP'
                    },
                    BY: {
                        currencyCode: 'BYR'
                    },
                    BZ: {
                        currencyCode: 'BZD'
                    },
                    CA: {
                        currencyCode: 'CAD'
                    },
                    CG: {
                        currencyCode: 'CDF'
                    },
                    CH: {
                        currencyCode: 'CHF'
                    },
                    CI: {
                        currencyCode: 'XOF'
                    },
                    CL: {
                        currencyCode: 'CLP'
                    },
                    CM: {
                        currencyCode: 'XAF'
                    },
                    CN: {
                        currencyCode: 'CNY'
                    },
                    CO: {
                        currencyCode: 'COP'
                    },
                    CR: {
                        currencyCode: 'CRC'
                    },
                    CV: {
                        currencyCode: 'CVE'
                    },
                    CY: {
                        currencyCode: 'EUR'
                    },
                    CZ: {
                        currencyCode: 'CZK'
                    },
                    DE: {
                        currencyCode: 'EUR'
                    },
                    DK: {
                        currencyCode: 'DKK'
                    },
                    DM: {
                        currencyCode: 'XCD'
                    },
                    DO: {
                        currencyCode: 'DOP'
                    },
                    DZ: {
                        currencyCode: 'DZD'
                    },
                    EC: {
                        currencyCode: 'USD'
                    },
                    EE: {
                        currencyCode: 'EUR'
                    },
                    EG: {
                        currencyCode: 'EGP'
                    },
                    ES: {
                        currencyCode: 'EUR'
                    },
                    ET: {
                        currencyCode: 'ETB'
                    },
                    FI: {
                        currencyCode: 'EUR'
                    },
                    FJ: {
                        currencyCode: 'FJD'
                    },
                    FM: {
                        currencyCode: 'USD'
                    },
                    FR: {
                        currencyCode: 'EUR'
                    },
                    GA: {
                        currencyCode: 'XAF'
                    },
                    GB: {
                        currencyCode: 'GBP'
                    },
                    GD: {
                        currencyCode: 'XCD'
                    },
                    GE: {
                        currencyCode: 'GEL'
                    },
                    GH: {
                        currencyCode: 'GHS'
                    },
                    GI: {
                        currencyCode: 'GIP'
                    },
                    GM: {
                        currencyCode: 'GMD'
                    },
                    GR: {
                        currencyCode: 'EUR'
                    },
                    GT: {
                        currencyCode: 'GTQ'
                    },
                    GU: {
                        currencyCode: 'USD'
                    },
                    GW: {
                        currencyCode: 'XOF'
                    },
                    GY: {
                        currencyCode: 'GYD'
                    },
                    HK: {
                        currencyCode: 'HKD'
                    },
                    HN: {
                        currencyCode: 'HNL'
                    },
                    HR: {
                        currencyCode: 'HRK'
                    },
                    HT: {
                        currencyCode: 'HTG'
                    },
                    HU: {
                        currencyCode: 'HUF'
                    },
                    ID: {
                        currencyCode: 'IDR'
                    },
                    IE: {
                        currencyCode: 'EUR'
                    },
                    IL: {
                        currencyCode: 'ILS'
                    },
                    IN: {
                        currencyCode: 'INR'
                    },
                    IS: {
                        currencyCode: 'ISK'
                    },
                    IT: {
                        currencyCode: 'EUR'
                    },
                    JM: {
                        currencyCode: 'JMD'
                    },
                    JO: {
                        currencyCode: 'JOD'
                    },
                    JP: {
                        currencyCode: 'JPY'
                    },
                    KE: {
                        currencyCode: 'KES'
                    },
                    KG: {
                        currencyCode: 'KGS'
                    },
                    KH: {
                        currencyCode: 'KHR'
                    },
                    KN: {
                        currencyCode: 'XCD'
                    },
                    KR: {
                        currencyCode: 'KRW'
                    },
                    KW: {
                        currencyCode: 'KWD'
                    },
                    KY: {
                        currencyCode: 'KYD'
                    },
                    KZ: {
                        currencyCode: 'KZT'
                    },
                    LA: {
                        currencyCode: 'LAK'
                    },
                    LB: {
                        currencyCode: 'LBP'
                    },
                    LC: {
                        currencyCode: 'XCD'
                    },
                    LI: {
                        currencyCode: 'CHF'
                    },
                    LK: {
                        currencyCode: 'LKR'
                    },
                    LR: {
                        currencyCode: 'LRD'
                    },
                    LT: {
                        currencyCode: 'LTL'
                    },
                    LU: {
                        currencyCode: 'EUR'
                    },
                    LV: {
                        currencyCode: 'EUR'
                    },
                    MA: {
                        currencyCode: 'MAD'
                    },
                    MD: {
                        currencyCode: 'MDL'
                    },
                    MG: {
                        currencyCode: 'MGA'
                    },
                    MK: {
                        currencyCode: 'MKD'
                    },
                    ML: {
                        currencyCode: 'XOF'
                    },
                    MM: {
                        currencyCode: 'MMK'
                    },
                    MN: {
                        currencyCode: 'MNT'
                    },
                    MO: {
                        currencyCode: 'MOP'
                    },
                    MP: {
                        currencyCode: 'USD'
                    },
                    MR: {
                        currencyCode: 'MRO'
                    },
                    MS: {
                        currencyCode: 'XCD'
                    },
                    MT: {
                        currencyCode: 'EUR'
                    },
                    MU: {
                        currencyCode: 'MUR'
                    },
                    MW: {
                        currencyCode: 'MWK'
                    },
                    MX: {
                        currencyCode: 'MXN'
                    },
                    MY: {
                        currencyCode: 'MYR'
                    },
                    MZ: {
                        currencyCode: 'MZN'
                    },
                    NA: {
                        currencyCode: 'NAD'
                    },
                    NE: {
                        currencyCode: 'XOF'
                    },
                    NG: {
                        currencyCode: 'NGN'
                    },
                    NI: {
                        currencyCode: 'NIO'
                    },
                    NL: {
                        currencyCode: 'EUR'
                    },
                    NO: {
                        currencyCode: 'NOK'
                    },
                    NP: {
                        currencyCode: 'NPR'
                    },
                    NZ: {
                        currencyCode: 'NZD'
                    },
                    OM: {
                        currencyCode: 'OMR'
                    },
                    PA: {
                        currencyCode: 'PAB'
                    },
                    PE: {
                        currencyCode: 'PEN'
                    },
                    PG: {
                        currencyCode: 'PGK'
                    },
                    PH: {
                        currencyCode: 'PHP'
                    },
                    PK: {
                        currencyCode: 'PKR'
                    },
                    PL: {
                        currencyCode: 'PLN'
                    },
                    PR: {
                        currencyCode: 'USD'
                    },
                    PT: {
                        currencyCode: 'EUR'
                    },
                    PW: {
                        currencyCode: 'USD'
                    },
                    PY: {
                        currencyCode: 'PYG'
                    },
                    QA: {
                        currencyCode: 'QAR'
                    },
                    RO: {
                        currencyCode: 'RON'
                    },
                    RS: {
                        currencyCode: 'RSD'
                    },
                    RU: {
                        currencyCode: 'RUB'
                    },
                    RW: {
                        currencyCode: 'RWF'
                    },
                    SA: {
                        currencyCode: 'SAR'
                    },
                    SB: {
                        currencyCode: 'SBD'
                    },
                    SC: {
                        currencyCode: 'SCR'
                    },
                    SE: {
                        currencyCode: 'SEK'
                    },
                    SG: {
                        currencyCode: 'SGD'
                    },
                    SI: {
                        currencyCode: 'EUR'
                    },
                    SK: {
                        currencyCode: 'EUR'
                    },
                    SL: {
                        currencyCode: 'SLL'
                    },
                    SN: {
                        currencyCode: 'XOF'
                    },
                    SR: {
                        currencyCode: 'SRD'
                    },
                    ST: {
                        currencyCode: 'STD'
                    },
                    SV: {
                        currencyCode: 'SVC'
                    },
                    SZ: {
                        currencyCode: 'SZL'
                    },
                    TC: {
                        currencyCode: 'USD'
                    },
                    TD: {
                        currencyCode: 'XAF'
                    },
                    TG: {
                        currencyCode: 'XOF'
                    },
                    TH: {
                        currencyCode: 'THB'
                    },
                    TJ: {
                        currencyCode: 'TJS'
                    },
                    TM: {
                        currencyCode: 'TMT'
                    },
                    TN: {
                        currencyCode: 'TND'
                    },
                    TR: {
                        currencyCode: 'TRY'
                    },
                    TT: {
                        currencyCode: 'TTD'
                    },
                    TW: {
                        currencyCode: 'TWD'
                    },
                    TZ: {
                        currencyCode: 'TZS'
                    },
                    UA: {
                        currencyCode: 'UAH'
                    },
                    UG: {
                        currencyCode: 'UGX'
                    },
                    US: {
                        currencyCode: 'USD'
                    },
                    UY: {
                        currencyCode: 'UYU'
                    },
                    UZ: {
                        currencyCode: 'UZS'
                    },
                    VC: {
                        currencyCode: 'XCD'
                    },
                    VE: {
                        currencyCode: 'VEF'
                    },
                    VG: {
                        currencyCode: 'USD'
                    },
                    VI: {
                        currencyCode: 'USD'
                    },
                    VN: {
                        currencyCode: 'VND'
                    },
                    YE: {
                        currencyCode: 'YER'
                    },
                    ZA: {
                        currencyCode: 'ZAR'
                    },
                    ZM: {
                        currencyCode: 'ZMW'
                    },
                    ZW: {
                        currencyCode: 'USD'
                    }
                };
                /**
 * @namespace CurrencyDefaults
 */ var CurrencyDefaults = {
                    'default': {
                        currencySymbol: function currencySymbol(formatter) {
                            return formatter.currencyCode();
                        },
                        internationalCurrencySymbol: function internationalCurrencySymbol(formatter) {
                            return formatter.currencyCode();
                        },
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        minimumIntegerDigits: 1,
                        usesGroupingSeparator: true
                    },
                    AED: {
                        currencySymbol: "\u062F.\u0625",
                        internationalCurrencySymbol: "\u062F.\u0625"
                    },
                    ALL: {
                        currencySymbol: 'L',
                        internationalCurrencySymbol: 'L'
                    },
                    AMD: {
                        currencySymbol: "\u0564\u0580.",
                        internationalCurrencySymbol: "\u0564\u0580."
                    },
                    AOA: {
                        currencySymbol: 'Kz',
                        internationalCurrencySymbol: 'Kz'
                    },
                    ARS: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    AUD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    AWG: {
                        currencySymbol: "\u0192",
                        internationalCurrencySymbol: "\u0192"
                    },
                    AZN: {
                        currencySymbol: "\u20BC",
                        internationalCurrencySymbol: "\u20BC"
                    },
                    BAM: {
                        currencySymbol: "\u041A\u041C",
                        internationalCurrencySymbol: "\u041A\u041C"
                    },
                    BBD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BDT: {
                        currencySymbol: "\u09F3",
                        internationalCurrencySymbol: "\u09F3"
                    },
                    BGN: {
                        currencySymbol: "\u043B\u0432",
                        internationalCurrencySymbol: "\u043B\u0432"
                    },
                    BHD: {
                        currencySymbol: "\u0628.\u062F",
                        internationalCurrencySymbol: "\u0628.\u062F",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    BMD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BND: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BOB: {
                        currencySymbol: 'Bs.',
                        internationalCurrencySymbol: 'Bs.'
                    },
                    BRL: {
                        currencySymbol: 'R$',
                        internationalCurrencySymbol: 'R$'
                    },
                    BSD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BTN: {
                        currencySymbol: 'Nu.',
                        internationalCurrencySymbol: 'Nu.'
                    },
                    BWP: {
                        currencySymbol: 'P',
                        internationalCurrencySymbol: 'P'
                    },
                    BYR: {
                        currencySymbol: 'Br',
                        internationalCurrencySymbol: 'Br'
                    },
                    BZD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CAD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CDF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    CHF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    CLP: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    CNY: {
                        currencySymbol: "\xa5",
                        internationalCurrencySymbol: "\xa5"
                    },
                    COP: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CRC: {
                        currencySymbol: "\u20A1",
                        internationalCurrencySymbol: "\u20A1"
                    },
                    CVE: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CZK: {
                        currencySymbol: "K\u010D",
                        internationalCurrencySymbol: "K\u010D"
                    },
                    DKK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    DOP: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    DZD: {
                        currencySymbol: "\u062F.\u062C",
                        internationalCurrencySymbol: "\u062F.\u062C"
                    },
                    EGP: {
                        currencySymbol: "E\xa3",
                        internationalCurrencySymbol: "E\xa3"
                    },
                    ETB: {
                        currencySymbol: "\u1265\u122D",
                        internationalCurrencySymbol: "\u1265\u122D"
                    },
                    EUR: {
                        currencySymbol: "\u20AC",
                        internationalCurrencySymbol: "\u20AC"
                    },
                    FJD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    GBP: {
                        currencySymbol: "\xa3",
                        internationalCurrencySymbol: "\xa3"
                    },
                    GEL: {
                        currencySymbol: "\u10DA,",
                        internationalCurrencySymbol: "\u10DA,"
                    },
                    GHS: {
                        currencySymbol: "\u20B5",
                        internationalCurrencySymbol: "\u20B5"
                    },
                    GIP: {
                        currencySymbol: "\xa3",
                        internationalCurrencySymbol: "\xa3"
                    },
                    GMD: {
                        currencySymbol: 'D',
                        internationalCurrencySymbol: 'D'
                    },
                    GTQ: {
                        currencySymbol: 'Q',
                        internationalCurrencySymbol: 'Q'
                    },
                    GYD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    HKD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    HNL: {
                        currencySymbol: 'L',
                        internationalCurrencySymbol: 'L'
                    },
                    HRK: {
                        currencySymbol: 'kn',
                        internationalCurrencySymbol: 'kn'
                    },
                    HTG: {
                        currencySymbol: 'G',
                        internationalCurrencySymbol: 'G'
                    },
                    HUF: {
                        currencySymbol: 'Ft',
                        internationalCurrencySymbol: 'Ft'
                    },
                    IDR: {
                        currencySymbol: 'Rp',
                        internationalCurrencySymbol: 'Rp'
                    },
                    ILS: {
                        currencySymbol: "\u20AA",
                        internationalCurrencySymbol: "\u20AA"
                    },
                    INR: {
                        currencySymbol: "\u20B9",
                        internationalCurrencySymbol: "\u20B9"
                    },
                    ISK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    JMD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    JOD: {
                        currencySymbol: "\u062F.\u0627",
                        internationalCurrencySymbol: "\u062F.\u0627",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    JPY: {
                        currencySymbol: "\xa5",
                        internationalCurrencySymbol: "\xa5",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    KES: {
                        currencySymbol: 'KSh',
                        internationalCurrencySymbol: 'KSh'
                    },
                    KGS: {
                        currencySymbol: 'som',
                        internationalCurrencySymbol: 'som'
                    },
                    KHR: {
                        currencySymbol: "\u17DB",
                        internationalCurrencySymbol: "\u17DB"
                    },
                    KRW: {
                        currencySymbol: "\u20A9",
                        internationalCurrencySymbol: "\u20A9",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    KWD: {
                        currencySymbol: "\u062F.\u0643",
                        internationalCurrencySymbol: "\u062F.\u0643",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    KYD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    KZT: {
                        currencySymbol: "\u3012",
                        internationalCurrencySymbol: "\u3012"
                    },
                    LAK: {
                        currencySymbol: "\u20AD",
                        internationalCurrencySymbol: "\u20AD"
                    },
                    LBP: {
                        currencySymbol: "\u0644.\u0644",
                        internationalCurrencySymbol: "\u0644.\u0644"
                    },
                    LKR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    LRD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    LTL: {
                        currencySymbol: 'Lt',
                        internationalCurrencySymbol: 'Lt'
                    },
                    MAD: {
                        currencySymbol: "\u062F.\u0645.",
                        internationalCurrencySymbol: "\u062F.\u0645."
                    },
                    MDL: {
                        currencySymbol: 'L',
                        internationalCurrencySymbol: 'L'
                    },
                    MGA: {
                        currencySymbol: 'Ar',
                        internationalCurrencySymbol: 'Ar',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    MKD: {
                        currencySymbol: "\u0434\u0435\u043D",
                        internationalCurrencySymbol: "\u0434\u0435\u043D"
                    },
                    MMK: {
                        currencySymbol: 'K',
                        internationalCurrencySymbol: 'K'
                    },
                    MNT: {
                        currencySymbol: "\u20AE",
                        internationalCurrencySymbol: "\u20AE"
                    },
                    MOP: {
                        currencySymbol: 'P',
                        internationalCurrencySymbol: 'P'
                    },
                    MRO: {
                        currencySymbol: 'UM',
                        internationalCurrencySymbol: 'UM',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    MUR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    MWK: {
                        currencySymbol: 'MK',
                        internationalCurrencySymbol: 'MK'
                    },
                    MXN: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    MYR: {
                        currencySymbol: 'RM',
                        internationalCurrencySymbol: 'RM'
                    },
                    MZN: {
                        currencySymbol: 'MTn',
                        internationalCurrencySymbol: 'MTn'
                    },
                    NAD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    NGN: {
                        currencySymbol: "\u20A6",
                        internationalCurrencySymbol: "\u20A6"
                    },
                    NIO: {
                        currencySymbol: 'C$',
                        internationalCurrencySymbol: 'C$'
                    },
                    NOK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    NPR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    NZD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    OMR: {
                        currencySymbol: "\u0631.\u0639.",
                        internationalCurrencySymbol: "\u0631.\u0639.",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    PAB: {
                        currencySymbol: 'B/.',
                        internationalCurrencySymbol: 'B/.'
                    },
                    PEN: {
                        currencySymbol: 'S/.',
                        internationalCurrencySymbol: 'S/.'
                    },
                    PGK: {
                        currencySymbol: 'K',
                        internationalCurrencySymbol: 'K'
                    },
                    PHP: {
                        currencySymbol: "\u20B1",
                        internationalCurrencySymbol: "\u20B1"
                    },
                    PKR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    PLN: {
                        currencySymbol: "z\u0142",
                        internationalCurrencySymbol: "z\u0142"
                    },
                    PYG: {
                        currencySymbol: "\u20B2",
                        internationalCurrencySymbol: "\u20B2"
                    },
                    QAR: {
                        currencySymbol: "\u0631.\u0642",
                        internationalCurrencySymbol: "\u0631.\u0642"
                    },
                    RON: {
                        currencySymbol: 'Lei',
                        internationalCurrencySymbol: 'Lei'
                    },
                    RSD: {
                        currencySymbol: "\u0420\u0421\u0414",
                        internationalCurrencySymbol: "\u0420\u0421\u0414"
                    },
                    RUB: {
                        currencySymbol: "\u20BD",
                        internationalCurrencySymbol: "\u20BD"
                    },
                    RWF: {
                        currencySymbol: 'FRw',
                        internationalCurrencySymbol: 'FRw'
                    },
                    SAR: {
                        currencySymbol: "\u0631.\u0633",
                        internationalCurrencySymbol: "\u0631.\u0633"
                    },
                    SBD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    SCR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    SEK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    SGD: {
                        currencySymbol: 'S$',
                        internationalCurrencySymbol: 'S$'
                    },
                    SLL: {
                        currencySymbol: 'Le',
                        internationalCurrencySymbol: 'Le'
                    },
                    SRD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    STD: {
                        currencySymbol: 'Db',
                        internationalCurrencySymbol: 'Db'
                    },
                    SVC: {
                        currencySymbol: "\u20A1",
                        internationalCurrencySymbol: "\u20A1"
                    },
                    SZL: {
                        currencySymbol: 'E',
                        internationalCurrencySymbol: 'E'
                    },
                    THB: {
                        currencySymbol: "\u0E3F",
                        internationalCurrencySymbol: "\u0E3F"
                    },
                    TJS: {
                        currencySymbol: "\u0405\u041C",
                        internationalCurrencySymbol: "\u0405\u041C"
                    },
                    TMT: {
                        currencySymbol: 'm',
                        internationalCurrencySymbol: 'm'
                    },
                    TND: {
                        currencySymbol: "\u062F.\u062A",
                        internationalCurrencySymbol: "\u062F.\u062A",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    TRY: {
                        currencySymbol: "\u20BA",
                        internationalCurrencySymbol: "\u20BA"
                    },
                    TTD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    TWD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    TZS: {
                        currencySymbol: 'Sh',
                        internationalCurrencySymbol: 'Sh'
                    },
                    UAH: {
                        currencySymbol: "\u20B4",
                        internationalCurrencySymbol: "\u20B4"
                    },
                    UGX: {
                        currencySymbol: 'USh',
                        internationalCurrencySymbol: 'USh'
                    },
                    USD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: 'US$'
                    },
                    UYU: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    UZS: {
                        currencySymbol: "\u043B\u0432",
                        internationalCurrencySymbol: "\u043B\u0432"
                    },
                    VEF: {
                        currencySymbol: 'Bs F',
                        internationalCurrencySymbol: 'Bs F'
                    },
                    VND: {
                        currencySymbol: "\u20AB",
                        internationalCurrencySymbol: "\u20AB",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    XAF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    XCD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    XOF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    YER: {
                        currencySymbol: "\uFDFC",
                        internationalCurrencySymbol: "\uFDFC"
                    },
                    ZAR: {
                        currencySymbol: 'R',
                        internationalCurrencySymbol: 'R'
                    },
                    ZMW: {
                        currencySymbol: 'ZMK',
                        internationalCurrencySymbol: 'ZMK'
                    }
                };
                exports['default'] = NumberFormatter;
                module1.exports = exports['default'];
            },
            {
                "./formatter": 14,
                "./number_formatter_settings_formatter": 17,
                "./utils": 22,
                "stround": 3
            }
        ],
        17: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var NumberFormatterSettings = function NumberFormatterSettings() {
                    _classCallCheck(this, NumberFormatterSettings);
                    /** @type boolean */ this.alwaysShowsDecimalSeparator = false;
                    /** @type number */ this.groupingSize = 0;
                    /** @type number */ this.maximumFractionDigits = 0;
                    /** @type number */ this.minimumFractionDigits = 0;
                    /** @type number */ this.minimumIntegerDigits = 0;
                    /** @type string */ this.prefix = '';
                    /** @type string */ this.suffix = '';
                    /** @type boolean */ this.usesGroupingSeparator = false;
                } /**
 * Returns a string composed of the given character repeated `length` times.
 *
 * @param {string} character
 * @param {number} length
 * @returns {string}
 * @private
 */ ;
                function chars(character, length) {
                    return new Array(length + 1).join(character);
                }
                /**
 * @const
 * @private
 */ var DIGIT = '#';
                /**
 * @const
 * @private
 */ var PADDING = '0';
                /**
 * @const
 * @private
 */ var DECIMAL_SEPARATOR = '.';
                /**
 * @const
 * @private
 */ var GROUPING_SEPARATOR = ',';
                var NumberFormatterSettingsFormatter = function(_Formatter) {
                    _inherits(NumberFormatterSettingsFormatter, _Formatter);
                    function NumberFormatterSettingsFormatter() {
                        _classCallCheck(this, NumberFormatterSettingsFormatter);
                        _get(Object.getPrototypeOf(NumberFormatterSettingsFormatter.prototype), 'constructor', this).apply(this, arguments);
                    }
                    _createClass(NumberFormatterSettingsFormatter, [
                        {
                            key: 'format',
                            /**
     * @param {NumberFormatterSettings} settings
     * @returns {string}
     */ value: function format(settings) {
                                var result = '';
                                var minimumIntegerDigits = settings.minimumIntegerDigits;
                                if (minimumIntegerDigits !== 0) result += chars(PADDING, minimumIntegerDigits);
                                result = DIGIT + result;
                                if (settings.usesGroupingSeparator) {
                                    while(result.length <= settings.groupingSize)result = DIGIT + result;
                                    result = result.slice(0, -settings.groupingSize) + GROUPING_SEPARATOR + result.slice(-settings.groupingSize);
                                }
                                var minimumFractionDigits = settings.minimumFractionDigits;
                                var maximumFractionDigits = settings.maximumFractionDigits;
                                var hasFractionalPart = settings.alwaysShowsDecimalSeparator || minimumFractionDigits > 0 || maximumFractionDigits > 0;
                                if (hasFractionalPart) {
                                    result += DECIMAL_SEPARATOR;
                                    for(var i = 0, _length = maximumFractionDigits; i < _length; i++)result += i < minimumFractionDigits ? PADDING : DIGIT;
                                }
                                return settings.prefix + result + settings.suffix;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(string) {
                                var result = new NumberFormatterSettings();
                                var hasPassedPrefix = false;
                                var hasStartedSuffix = false;
                                var decimalSeparatorIndex = null;
                                var groupingSeparatorIndex = null;
                                var lastIntegerDigitIndex = null;
                                for(var i = 0, length = string.length; i < length; i++){
                                    var c = string[i];
                                    switch(c){
                                        case DIGIT:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            if (decimalSeparatorIndex !== null) result.maximumFractionDigits++;
                                            break;
                                        case PADDING:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            if (decimalSeparatorIndex === null) result.minimumIntegerDigits++;
                                            else {
                                                result.minimumFractionDigits++;
                                                result.maximumFractionDigits++;
                                            }
                                            break;
                                        case DECIMAL_SEPARATOR:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            decimalSeparatorIndex = i;
                                            lastIntegerDigitIndex = i - 1;
                                            break;
                                        case GROUPING_SEPARATOR:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            groupingSeparatorIndex = i;
                                            break;
                                        default:
                                            if (hasPassedPrefix) {
                                                hasStartedSuffix = true;
                                                result.suffix += c;
                                            } else result.prefix += c;
                                    }
                                }
                                if (decimalSeparatorIndex === null) lastIntegerDigitIndex = length - 1;
                                if (decimalSeparatorIndex === length - 1) result.alwaysShowsDecimalSeparator = true;
                                if (groupingSeparatorIndex !== null) {
                                    result.groupingSize = lastIntegerDigitIndex - groupingSeparatorIndex;
                                    result.usesGroupingSeparator = true;
                                }
                                return result;
                            }
                        }
                    ]);
                    return NumberFormatterSettingsFormatter;
                }(_formatter2['default']);
                exports['default'] = NumberFormatterSettingsFormatter;
                module1.exports = exports['default'];
            },
            {
                "./formatter": 14
            }
        ],
        18: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                /**
 * @const
 * @private
 */ var NANPPhoneDelimiters = {
                    name: 'NANPPhoneDelimiters',
                    0: '(',
                    4: ')',
                    5: ' ',
                    9: '-'
                };
                /**
 * @const
 * @private
 */ var NANPPhoneDelimitersWithOne = {
                    name: 'NANPPhoneDelimitersWithOne',
                    1: ' ',
                    2: '(',
                    6: ')',
                    7: ' ',
                    11: '-'
                };
                /**
 * @const
 * @private
 */ var E164PhoneDelimitersWithOneDigit = {
                    name: 'E164PhoneDelimitersWithOneDigit',
                    2: ' ',
                    3: '(',
                    7: ')',
                    8: ' ',
                    12: '-'
                };
                /**
 * @const
 * @private
 */ var E164PhoneDelimitersWithTwoDigit = {
                    name: 'E164PhoneDelimitersWithTwoDigit',
                    3: ' ',
                    4: '(',
                    8: ')',
                    9: ' ',
                    13: '-'
                };
                /**
 * @const
 * @private
 */ var E164PhoneDelimitersWithThreeDigit = {
                    name: 'E164PhoneDelimitersWithThreeDigit',
                    4: ' ',
                    5: '(',
                    9: ')',
                    10: ' ',
                    14: '-'
                };
                /**
 * This should match any characters in the maps above.
 *
 * @const
 * @private
 */ var DELIMITER_PATTERN = /[-\(\) ]/g;
                /**
 * @const
 * @private
 */ var DEFAULT_COUNTRY_CODE = {
                    "E164": "1",
                    "country": [
                        "American Samoa",
                        "Anguilla",
                        "Antigua and Barbuda",
                        "Bahamas",
                        "Barbados",
                        "Bermuda",
                        "British Virgin Islands",
                        "Canada",
                        "Cayman Islands",
                        "Dominica",
                        "Dominican Republic",
                        "Grenada",
                        "Guam",
                        "Jamaica",
                        "Montserrat",
                        "Northern Mariana Islands",
                        "Puerto Rico",
                        "Saint Kitts and Nevis",
                        "Saint Lucia",
                        "Saint Martin",
                        "Saint Vincent and the Grenadines",
                        "Sint Maarten",
                        "Trinidad and Tobago",
                        "Turks and Caicos Islands",
                        "U.S. Virgin Islands",
                        "United States"
                    ]
                };
                /**
 * This is an internal store for the current country
 *
 * @private
 */ var currentCountryCode = DEFAULT_COUNTRY_CODE;
                /**
 * @extends DelimitedTextFormatter
 */ var PhoneFormatter = function(_DelimitedTextFormatter) {
                    _inherits(PhoneFormatter, _DelimitedTextFormatter);
                    /**
   * @throws {Error} if anything is passed in
   * @param {Array} args
   */ function PhoneFormatter() {
                        _classCallCheck(this, PhoneFormatter);
                        _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'constructor', this).call(this);
                        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (args.length !== 0) throw new Error('were you trying to set a delimiter (' + args[0] + ')?');
                    }
                    /**
   * @param {string} chr
   * @returns {boolean}
   */ _createClass(PhoneFormatter, [
                        {
                            key: 'isDelimiter',
                            value: function isDelimiter(chr) {
                                var map = this.delimiterMap;
                                for(var index in map)if (map.hasOwnProperty(index)) {
                                    if (map[index] === chr) return true;
                                }
                                return false;
                            }
                        },
                        {
                            key: 'delimiterAt',
                            value: function delimiterAt(index) {
                                return this.delimiterMap[index];
                            }
                        },
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                var delimiter = this.delimiterAt(index);
                                return delimiter !== undefined && delimiter !== null;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                if (!error) error = function() {};
                                var digits = this.digitsWithoutCountryCode(text);
                                // Source: http://en.wikipedia.org/wiki/North_American_Numbering_Plan
                                //
                                // Area Code
                                if (text.length < 10) error('phone-formatter.number-too-short');
                                if (digits[0] === '0') error('phone-formatter.area-code-zero');
                                if (digits[0] === '1') error('phone-formatter.area-code-one');
                                if (digits[1] === '9') error('phone-formatter.area-code-n9n');
                                // Central Office Code
                                if (digits[3] === '1') error('phone-formatter.central-office-one');
                                if (digits.slice(4, 6) === '11') error('phone-formatter.central-office-n11');
                                return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'parse', this).call(this, text, error);
                            }
                        },
                        {
                            key: 'format',
                            value: function format(value) {
                                this.guessFormatFromText(value);
                                return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'format', this).call(this, this.removeDelimiterMapChars(value));
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                this.guessFormatFromText(change.proposed.text);
                                if (change.inserted.text.length > 1) {
                                    // handle pastes
                                    var text = change.current.text;
                                    var selectedRange = change.current.selectedRange;
                                    var toInsert = change.inserted.text;
                                    // Replace the selection with the new text, remove non-digits, then format.
                                    var formatted = this.format((text.slice(0, selectedRange.start) + toInsert + text.slice(selectedRange.start + selectedRange.length)).replace(/[^\d]/g, ''));
                                    change.proposed = {
                                        text: formatted,
                                        selectedRange: {
                                            start: formatted.length - (text.length - (selectedRange.start + selectedRange.length)),
                                            length: 0
                                        }
                                    };
                                    return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                }
                                if (/^\d*$/.test(change.inserted.text) || change.proposed.text.indexOf('+') === 0) {
                                    var formatName = this.delimiterMap.name;
                                    // First guess at the localized format
                                    if (currentCountryCode.localizedFormat) {
                                        this.delimiterMap = currentCountryCode.localizedFormat;
                                        this.maximumLength = currentCountryCode.localizedFormat.maximumLength;
                                        formatName = 'localized-' + currentCountryCode.E164;
                                    }
                                    // We need to store the change and current format guess so that if the isChangeValid
                                    // call to super changes the proposed text such that the format we thought is no longer
                                    // valid. If that does happen we actually just rerun it through with the correct format
                                    var originalProposed = change.proposed.text;
                                    var _isChangeValid = _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                    this.guessFormatFromText(change.proposed.text);
                                    // Make sure if the localizedFormat changed, respect that
                                    if (currentCountryCode.localizedFormat) {
                                        this.delimiterMap = currentCountryCode.localizedFormat;
                                        this.maximumLength = currentCountryCode.localizedFormat.maximumLength;
                                        this.delimiterMap.name = 'localized-' + currentCountryCode.E164;
                                    }
                                    if (formatName === this.delimiterMap.name) return _isChangeValid;
                                    else {
                                        var originalChange = change;
                                        originalChange.proposed.text = originalProposed;
                                        return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, originalChange, error);
                                    }
                                } else return false;
                            }
                        },
                        {
                            key: 'guessFormatFromText',
                            value: function guessFormatFromText(text) {
                                currentCountryCode = DEFAULT_COUNTRY_CODE;
                                if (text && text[0] === '+') {
                                    if (text.length > 1) {
                                        var isValidCountryCode = function isValidCountryCode(countryCode) {
                                            var matchingCodes = COUNTRY_CODES.filter(function(country) {
                                                return country.E164 === countryCode;
                                            });
                                            return matchingCodes.length > 0;
                                        };
                                        var rawText = this.removeDelimiterMapChars(text);
                                        if (currentCountryCode = isValidCountryCode(rawText[1])) {
                                            this.delimiterMap = E164PhoneDelimitersWithOneDigit;
                                            this.maximumLength = 17;
                                        } else if (text.length > 2 && (currentCountryCode = isValidCountryCode(rawText.slice(1, 3)))) {
                                            this.delimiterMap = E164PhoneDelimitersWithTwoDigit;
                                            this.maximumLength = 18;
                                        } else {
                                            currentCountryCode = isValidCountryCode(rawText.slice(1, 4)) || DEFAULT_COUNTRY_CODE;
                                            this.delimiterMap = E164PhoneDelimitersWithThreeDigit;
                                            this.maximumLength = 19;
                                        }
                                    } else {
                                        this.delimiterMap = E164PhoneDelimitersWithThreeDigit;
                                        this.maximumLength = 19;
                                    }
                                } else if (text && text[0] === '1') {
                                    this.delimiterMap = NANPPhoneDelimitersWithOne;
                                    this.maximumLength = 16;
                                } else if (text && text[0] === ' ') {
                                    this.delimiterMap = NANPPhoneDelimiters;
                                    this.maximumLength = 15;
                                } else {
                                    this.delimiterMap = NANPPhoneDelimiters;
                                    this.maximumLength = 14;
                                }
                            }
                        },
                        {
                            key: 'digitsWithoutCountryCode',
                            value: function digitsWithoutCountryCode(text) {
                                var digits = (text || '').replace(/[^\d]/g, '');
                                var extraDigits = digits.length - 10;
                                if (extraDigits > 0) digits = digits.substr(extraDigits);
                                return digits;
                            }
                        },
                        {
                            key: 'removeDelimiterMapChars',
                            value: function removeDelimiterMapChars(text) {
                                return (text || '').replace(DELIMITER_PATTERN, '');
                            }
                        }
                    ]);
                    return PhoneFormatter;
                }(_delimited_text_formatter2['default']);
                var COUNTRY_CODES = [
                    {
                        "E164": "93",
                        "country": "Afghanistan"
                    },
                    {
                        "E164": "355",
                        "country": "Albania"
                    },
                    {
                        "E164": "213",
                        "country": "Algeria"
                    },
                    {
                        "E164": "1",
                        "country": [
                            "American Samoa",
                            "Anguilla",
                            "Antigua and Barbuda",
                            "Bahamas",
                            "Barbados",
                            "Bermuda",
                            "British Virgin Islands",
                            "Canada",
                            "Cayman Islands",
                            "Dominica",
                            "Dominican Republic",
                            "Grenada",
                            "Guam",
                            "Jamaica",
                            "Montserrat",
                            "Northern Mariana Islands",
                            "Puerto Rico",
                            "Saint Kitts and Nevis",
                            "Saint Lucia",
                            "Saint Martin",
                            "Saint Vincent and the Grenadines",
                            "Sint Maarten",
                            "Trinidad and Tobago",
                            "Turks and Caicos Islands",
                            "U.S. Virgin Islands",
                            "United States"
                        ]
                    },
                    {
                        "E164": "376",
                        "country": "Andorra"
                    },
                    {
                        "E164": "244",
                        "country": "Angola"
                    },
                    {
                        "E164": "672",
                        "country": "Antarctica"
                    },
                    {
                        "E164": "54",
                        "country": "Argentina"
                    },
                    {
                        "E164": "374",
                        "country": "Armenia"
                    },
                    {
                        "E164": "297",
                        "country": "Aruba"
                    },
                    {
                        "E164": "43",
                        "country": "Austria"
                    },
                    {
                        "E164": "994",
                        "country": "Azerbaijan"
                    },
                    {
                        "E164": "973",
                        "country": "Bahrain"
                    },
                    {
                        "E164": "880",
                        "country": "Bangladesh"
                    },
                    {
                        "E164": "375",
                        "country": "Belarus"
                    },
                    {
                        "E164": "32",
                        "country": "Belgium"
                    },
                    {
                        "E164": "501",
                        "country": "Belize"
                    },
                    {
                        "E164": "229",
                        "country": "Benin"
                    },
                    {
                        "E164": "975",
                        "country": "Bhutan"
                    },
                    {
                        "E164": "591",
                        "country": "Bolivia"
                    },
                    {
                        "E164": "387",
                        "country": "Bosnia and Herzegovina"
                    },
                    {
                        "E164": "267",
                        "country": "Botswana"
                    },
                    {
                        "E164": "55",
                        "country": "Brazil"
                    },
                    {
                        "E164": "246",
                        "country": "British Indian Ocean Territory"
                    },
                    {
                        "E164": "673",
                        "country": "Brunei"
                    },
                    {
                        "E164": "359",
                        "country": "Bulgaria"
                    },
                    {
                        "E164": "226",
                        "country": "Burkina Faso"
                    },
                    {
                        "E164": "257",
                        "country": "Burundi"
                    },
                    {
                        "E164": "855",
                        "country": "Cambodia"
                    },
                    {
                        "E164": "237",
                        "country": "Cameroon"
                    },
                    {
                        "E164": "238",
                        "country": "Cape Verde"
                    },
                    {
                        "E164": "236",
                        "country": "Central African Republic"
                    },
                    {
                        "E164": "235",
                        "country": "Chad"
                    },
                    {
                        "E164": "56",
                        "country": "Chile"
                    },
                    {
                        "E164": "86",
                        "country": "China"
                    },
                    {
                        "E164": "61",
                        "country": [
                            "Australia",
                            "Christmas Island",
                            "Cocos Islands"
                        ]
                    },
                    {
                        "E164": "57",
                        "country": "Colombia"
                    },
                    {
                        "E164": "269",
                        "country": "Comoros"
                    },
                    {
                        "E164": "682",
                        "country": "Cook Islands"
                    },
                    {
                        "E164": "506",
                        "country": "Costa Rica"
                    },
                    {
                        "E164": "385",
                        "country": "Croatia"
                    },
                    {
                        "E164": "53",
                        "country": "Cuba"
                    },
                    {
                        "E164": "599",
                        "country": [
                            "Curacao",
                            "Netherlands Antilles"
                        ]
                    },
                    {
                        "E164": "357",
                        "country": "Cyprus"
                    },
                    {
                        "E164": "420",
                        "country": "Czech Republic"
                    },
                    {
                        "E164": "243",
                        "country": "Democratic Republic of the Congo"
                    },
                    {
                        "E164": "45",
                        "country": "Denmark"
                    },
                    {
                        "E164": "253",
                        "country": "Djibouti"
                    },
                    {
                        "E164": "670",
                        "country": "East Timor"
                    },
                    {
                        "E164": "593",
                        "country": "Ecuador"
                    },
                    {
                        "E164": "20",
                        "country": "Egypt"
                    },
                    {
                        "E164": "503",
                        "country": "El Salvador"
                    },
                    {
                        "E164": "240",
                        "country": "Equatorial Guinea"
                    },
                    {
                        "E164": "291",
                        "country": "Eritrea"
                    },
                    {
                        "E164": "372",
                        "country": "Estonia"
                    },
                    {
                        "E164": "251",
                        "country": "Ethiopia"
                    },
                    {
                        "E164": "500",
                        "country": "Falkland Islands"
                    },
                    {
                        "E164": "298",
                        "country": "Faroe Islands"
                    },
                    {
                        "E164": "679",
                        "country": "Fiji"
                    },
                    {
                        "E164": "358",
                        "country": "Finland"
                    },
                    {
                        "E164": "33",
                        "country": "France"
                    },
                    {
                        "E164": "689",
                        "country": "French Polynesia"
                    },
                    {
                        "E164": "241",
                        "country": "Gabon"
                    },
                    {
                        "E164": "220",
                        "country": "Gambia"
                    },
                    {
                        "E164": "995",
                        "country": "Georgia"
                    },
                    {
                        "E164": "49",
                        "country": "Germany"
                    },
                    {
                        "E164": "233",
                        "country": "Ghana"
                    },
                    {
                        "E164": "350",
                        "country": "Gibraltar"
                    },
                    {
                        "E164": "30",
                        "country": "Greece"
                    },
                    {
                        "E164": "299",
                        "country": "Greenland"
                    },
                    {
                        "E164": "502",
                        "country": "Guatemala"
                    },
                    {
                        "E164": "44",
                        "country": [
                            "Guernsey",
                            "Isle of Man",
                            "Jersey",
                            "United Kingdom"
                        ]
                    },
                    {
                        "E164": "224",
                        "country": "Guinea"
                    },
                    {
                        "E164": "245",
                        "country": "Guinea-Bissau"
                    },
                    {
                        "E164": "592",
                        "country": "Guyana"
                    },
                    {
                        "E164": "509",
                        "country": "Haiti"
                    },
                    {
                        "E164": "504",
                        "country": "Honduras"
                    },
                    {
                        "E164": "852",
                        "country": "Hong Kong"
                    },
                    {
                        "E164": "36",
                        "country": "Hungary"
                    },
                    {
                        "E164": "354",
                        "country": "Iceland"
                    },
                    {
                        "E164": "91",
                        "country": "India"
                    },
                    {
                        "E164": "62",
                        "country": "Indonesia"
                    },
                    {
                        "E164": "98",
                        "country": "Iran"
                    },
                    {
                        "E164": "964",
                        "country": "Iraq"
                    },
                    {
                        "E164": "353",
                        "country": "Ireland"
                    },
                    {
                        "E164": "972",
                        "country": "Israel"
                    },
                    {
                        "E164": "39",
                        "country": [
                            "Italy",
                            "Vatican"
                        ]
                    },
                    {
                        "E164": "225",
                        "country": "Ivory Coast"
                    },
                    {
                        "E164": "81",
                        "country": "Japan"
                    },
                    {
                        "E164": "962",
                        "country": "Jordan"
                    },
                    {
                        "E164": "7",
                        "country": [
                            "Kazakhstan",
                            "Russia"
                        ],
                        "localizedFormat": {
                            "maximumLength": 18,
                            2: ' ',
                            3: '(',
                            7: ')',
                            8: ' ',
                            12: '-',
                            15: '-'
                        }
                    },
                    {
                        "E164": "254",
                        "country": "Kenya"
                    },
                    {
                        "E164": "686",
                        "country": "Kiribati"
                    },
                    {
                        "E164": "383",
                        "country": "Kosovo"
                    },
                    {
                        "E164": "965",
                        "country": "Kuwait"
                    },
                    {
                        "E164": "996",
                        "country": "Kyrgyzstan"
                    },
                    {
                        "E164": "856",
                        "country": "Laos"
                    },
                    {
                        "E164": "371",
                        "country": "Latvia"
                    },
                    {
                        "E164": "961",
                        "country": "Lebanon"
                    },
                    {
                        "E164": "266",
                        "country": "Lesotho"
                    },
                    {
                        "E164": "231",
                        "country": "Liberia"
                    },
                    {
                        "E164": "218",
                        "country": "Libya"
                    },
                    {
                        "E164": "423",
                        "country": "Liechtenstein"
                    },
                    {
                        "E164": "370",
                        "country": "Lithuania"
                    },
                    {
                        "E164": "352",
                        "country": "Luxembourg"
                    },
                    {
                        "E164": "853",
                        "country": "Macao"
                    },
                    {
                        "E164": "389",
                        "country": "Macedonia"
                    },
                    {
                        "E164": "261",
                        "country": "Madagascar"
                    },
                    {
                        "E164": "265",
                        "country": "Malawi"
                    },
                    {
                        "E164": "60",
                        "country": "Malaysia"
                    },
                    {
                        "E164": "960",
                        "country": "Maldives"
                    },
                    {
                        "E164": "223",
                        "country": "Mali"
                    },
                    {
                        "E164": "356",
                        "country": "Malta"
                    },
                    {
                        "E164": "692",
                        "country": "Marshall Islands"
                    },
                    {
                        "E164": "222",
                        "country": "Mauritania"
                    },
                    {
                        "E164": "230",
                        "country": "Mauritius"
                    },
                    {
                        "E164": "262",
                        "country": [
                            "Mayotte",
                            "Reunion"
                        ]
                    },
                    {
                        "E164": "52",
                        "country": "Mexico"
                    },
                    {
                        "E164": "691",
                        "country": "Micronesia"
                    },
                    {
                        "E164": "373",
                        "country": "Moldova"
                    },
                    {
                        "E164": "377",
                        "country": "Monaco"
                    },
                    {
                        "E164": "976",
                        "country": "Mongolia"
                    },
                    {
                        "E164": "382",
                        "country": "Montenegro"
                    },
                    {
                        "E164": "212",
                        "country": [
                            "Morocco",
                            "Western Sahara"
                        ]
                    },
                    {
                        "E164": "258",
                        "country": "Mozambique"
                    },
                    {
                        "E164": "95",
                        "country": "Myanmar"
                    },
                    {
                        "E164": "264",
                        "country": "Namibia"
                    },
                    {
                        "E164": "674",
                        "country": "Nauru"
                    },
                    {
                        "E164": "977",
                        "country": "Nepal"
                    },
                    {
                        "E164": "31",
                        "country": "Netherlands"
                    },
                    {
                        "E164": "687",
                        "country": "New Caledonia"
                    },
                    {
                        "E164": "64",
                        "country": "New Zealand"
                    },
                    {
                        "E164": "64",
                        "country": "Pitcairn"
                    },
                    {
                        "E164": "505",
                        "country": "Nicaragua"
                    },
                    {
                        "E164": "227",
                        "country": "Niger"
                    },
                    {
                        "E164": "234",
                        "country": "Nigeria"
                    },
                    {
                        "E164": "683",
                        "country": "Niue"
                    },
                    {
                        "E164": "850",
                        "country": "North Korea"
                    },
                    {
                        "E164": "47",
                        "country": [
                            "Norway",
                            "Svalbard and Jan Mayen"
                        ]
                    },
                    {
                        "E164": "968",
                        "country": "Oman"
                    },
                    {
                        "E164": "92",
                        "country": "Pakistan"
                    },
                    {
                        "E164": "680",
                        "country": "Palau"
                    },
                    {
                        "E164": "970",
                        "country": "Palestine"
                    },
                    {
                        "E164": "507",
                        "country": "Panama"
                    },
                    {
                        "E164": "675",
                        "country": "Papua New Guinea"
                    },
                    {
                        "E164": "595",
                        "country": "Paraguay"
                    },
                    {
                        "E164": "51",
                        "country": "Peru"
                    },
                    {
                        "E164": "63",
                        "country": "Philippines"
                    },
                    {
                        "E164": "48",
                        "country": "Poland"
                    },
                    {
                        "E164": "351",
                        "country": "Portugal"
                    },
                    {
                        "E164": "974",
                        "country": "Qatar"
                    },
                    {
                        "E164": "242",
                        "country": "Republic of the Congo"
                    },
                    {
                        "E164": "40",
                        "country": "Romania"
                    },
                    {
                        "E164": "250",
                        "country": "Rwanda"
                    },
                    {
                        "E164": "590",
                        "country": "Saint Barthelemy"
                    },
                    {
                        "E164": "290",
                        "country": "Saint Helena"
                    },
                    {
                        "E164": "508",
                        "country": "Saint Pierre and Miquelon"
                    },
                    {
                        "E164": "685",
                        "country": "Samoa"
                    },
                    {
                        "E164": "378",
                        "country": "San Marino"
                    },
                    {
                        "E164": "239",
                        "country": "Sao Tome and Principe"
                    },
                    {
                        "E164": "966",
                        "country": "Saudi Arabia"
                    },
                    {
                        "E164": "221",
                        "country": "Senegal"
                    },
                    {
                        "E164": "381",
                        "country": "Serbia"
                    },
                    {
                        "E164": "248",
                        "country": "Seychelles"
                    },
                    {
                        "E164": "232",
                        "country": "Sierra Leone"
                    },
                    {
                        "E164": "65",
                        "country": "Singapore"
                    },
                    {
                        "E164": "421",
                        "country": "Slovakia"
                    },
                    {
                        "E164": "386",
                        "country": "Slovenia"
                    },
                    {
                        "E164": "677",
                        "country": "Solomon Islands"
                    },
                    {
                        "E164": "252",
                        "country": "Somalia"
                    },
                    {
                        "E164": "27",
                        "country": "South Africa"
                    },
                    {
                        "E164": "82",
                        "country": "South Korea"
                    },
                    {
                        "E164": "211",
                        "country": "South Sudan"
                    },
                    {
                        "E164": "34",
                        "country": "Spain"
                    },
                    {
                        "E164": "94",
                        "country": "Sri Lanka"
                    },
                    {
                        "E164": "249",
                        "country": "Sudan"
                    },
                    {
                        "E164": "597",
                        "country": "Suriname"
                    },
                    {
                        "E164": "268",
                        "country": "Swaziland"
                    },
                    {
                        "E164": "46",
                        "country": "Sweden"
                    },
                    {
                        "E164": "41",
                        "country": "Switzerland"
                    },
                    {
                        "E164": "963",
                        "country": "Syria"
                    },
                    {
                        "E164": "886",
                        "country": "Taiwan"
                    },
                    {
                        "E164": "992",
                        "country": "Tajikistan"
                    },
                    {
                        "E164": "255",
                        "country": "Tanzania"
                    },
                    {
                        "E164": "66",
                        "country": "Thailand"
                    },
                    {
                        "E164": "228",
                        "country": "Togo"
                    },
                    {
                        "E164": "690",
                        "country": "Tokelau"
                    },
                    {
                        "E164": "676",
                        "country": "Tonga"
                    },
                    {
                        "E164": "216",
                        "country": "Tunisia"
                    },
                    {
                        "E164": "90",
                        "country": "Turkey"
                    },
                    {
                        "E164": "993",
                        "country": "Turkmenistan"
                    },
                    {
                        "E164": "688",
                        "country": "Tuvalu"
                    },
                    {
                        "E164": "256",
                        "country": "Uganda"
                    },
                    {
                        "E164": "380",
                        "country": "Ukraine"
                    },
                    {
                        "E164": "971",
                        "country": "United Arab Emirates"
                    },
                    {
                        "E164": "598",
                        "country": "Uruguay"
                    },
                    {
                        "E164": "998",
                        "country": "Uzbekistan"
                    },
                    {
                        "E164": "678",
                        "country": "Vanuatu"
                    },
                    {
                        "E164": "58",
                        "country": "Venezuela"
                    },
                    {
                        "E164": "84",
                        "country": "Vietnam"
                    },
                    {
                        "E164": "681",
                        "country": "Wallis and Futuna"
                    },
                    {
                        "E164": "967",
                        "country": "Yemen"
                    },
                    {
                        "E164": "260",
                        "country": "Zambia"
                    },
                    {
                        "E164": "263",
                        "country": "Zimbabwe"
                    }
                ];
                exports['default'] = PhoneFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10
            }
        ],
        19: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                /**
 * @const
 * @private
 */ var DIGITS_PATTERN = /^\d*$/;
                /**
 * @extends DelimitedTextFormatter
 */ var SocialSecurityNumberFormatter = function(_DelimitedTextFormatter) {
                    _inherits(SocialSecurityNumberFormatter, _DelimitedTextFormatter);
                    function SocialSecurityNumberFormatter() {
                        _classCallCheck(this, SocialSecurityNumberFormatter);
                        _get(Object.getPrototypeOf(SocialSecurityNumberFormatter.prototype), 'constructor', this).call(this, '-');
                        this.maximumLength = 11;
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(SocialSecurityNumberFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 3 || index === 6;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (DIGITS_PATTERN.test(change.inserted.text)) return _get(Object.getPrototypeOf(SocialSecurityNumberFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                else return false;
                            }
                        }
                    ]);
                    return SocialSecurityNumberFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = SocialSecurityNumberFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10
            }
        ],
        20: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var _undo_manager = _dereq_('./undo_manager');
                var _undo_manager2 = _interopRequireDefault(_undo_manager);
                var _utils = _dereq_('./utils');
                var _caret = _dereq_('./caret');
                var _caret2 = _interopRequireDefault(_caret);
                /**
 * Simulates input behavior.
 *
 * @external InputSim
 * @see https://github.com/iamJoeTaylor/input-sim
 */ var _inputSim = _dereq_('input-sim');
                /**
 * TextField is the simplest input and the base for more complex
 * types to inherit.
 *
 * @extends external:InputSim.Input
 */ var _installCaret = (0, _caret2['default'])();
                var getCaret = _installCaret.getCaret;
                var setCaret = _installCaret.setCaret;
                var TextField = function(_Input) {
                    _inherits(TextField, _Input);
                    /**
   * Sets up the initial properties of the TextField and
   * sets  up the event listeners
   *
   * @param {HTMLElement} element
   * @param {Formatter} formatter
   */ function TextField(element, formatter) {
                        _classCallCheck(this, TextField);
                        _get(Object.getPrototypeOf(TextField.prototype), 'constructor', this).call(this);
                        var caret = getCaret(element);
                        if (typeof element.get === 'function') {
                            console.warn("DEPRECATION: FieldKit.TextField instances should no longer be created with a jQuery-wrapped element.");
                            element = element.get(0);
                        }
                        this.element = element;
                        this._formatter = formatter;
                        this._enabled = true;
                        this._manualCaret = {
                            start: 0,
                            end: 0
                        };
                        this._placeholder = null;
                        this._disabledPlaceholder = null;
                        this._focusedPlaceholder = null;
                        this._unfocusedPlaceholder = null;
                        this._isDirty = false;
                        this._valueOnFocus = '';
                        this._currentValue = '';
                        // Make sure textDidChange fires while the value is correct
                        this._needsKeyUpTextDidChangeTrigger = false;
                        this._blur = (0, _utils.bind)(this._blur, this);
                        this._focus = (0, _utils.bind)(this._focus, this);
                        this._click = (0, _utils.bind)(this._click, this);
                        this._paste = (0, _utils.bind)(this._paste, this);
                        this._keyUp = (0, _utils.bind)(this._keyUp, this);
                        this._keyPress = (0, _utils.bind)(this._keyPress, this);
                        this._keyDown = (0, _utils.bind)(this._keyDown, this);
                        if (element['field-kit-text-field']) throw new Error('already attached a TextField to this element');
                        else element['field-kit-text-field'] = this;
                        element.addEventListener('keydown', this._keyDown);
                        element.addEventListener('keypress', this._keyPress);
                        element.addEventListener('keyup', this._keyUp);
                        element.addEventListener('click', this._click);
                        element.addEventListener('paste', this._paste);
                        element.addEventListener('focus', this._focus);
                        element.addEventListener('blur', this._blur);
                        if (!element.getAttribute('autocapitalize')) element.setAttribute('autocapitalize', 'off');
                        var window = element.ownerDocument.defaultView;
                        /**
     * Fixes caret bug (Android) that caused the input
     * to place inserted characters in the wrong place
     * Expected: 1234 5678|  =>  1234 5678 9|
     * Bug: 1234 5678|  =>  1234 5679| 8
     *
     * @private
     */ this._needsManualCaret = window.navigator.userAgent.toLowerCase().indexOf('android') > -1;
                        this.setText(element.value);
                        this.setSelectedRange({
                            start: caret.start,
                            length: caret.end - caret.start
                        });
                    }
                    /**
   * Helps calculate the changes after an event on a FieldKit.TextField.
   *
   * @private
   */ /**
   * **** Public Events ****
   */ /**
   * Called when the user has changed the text of the field. Can be used in
   * subclasses to perform actions suitable for this event.
   *
   * @private
   */ _createClass(TextField, [
                        {
                            key: 'textDidChange',
                            value: function textDidChange() {}
                        },
                        {
                            key: 'textFieldDidEndEditing',
                            value: function textFieldDidEndEditing() {}
                        },
                        {
                            key: 'textFieldDidBeginEditing',
                            value: function textFieldDidBeginEditing() {}
                        },
                        {
                            key: '_textDidChange',
                            value: function _textDidChange() {
                                var delegate = this._delegate;
                                this.textDidChange();
                                if (delegate && typeof delegate.textDidChange === 'function') delegate.textDidChange(this);
                                // manually fire the HTML5 input event
                                this._fireEvent('input');
                            }
                        },
                        {
                            key: '_textFieldDidEndEditing',
                            value: function _textFieldDidEndEditing() {
                                var delegate = this._delegate;
                                this.textFieldDidEndEditing();
                                if (delegate && typeof delegate.textFieldDidEndEditing === 'function') delegate.textFieldDidEndEditing(this);
                                // manually fire the HTML5 change event, only when a change has been made since focus
                                if (this._isDirty && this._valueOnFocus !== this.element.value) this._fireEvent('change');
                                // reset the dirty property
                                this._isDirty = false;
                                this._valueOnFocus = '';
                            }
                        },
                        {
                            key: '_textFieldDidBeginEditing',
                            value: function _textFieldDidBeginEditing() {
                                var delegate = this._delegate;
                                this.textFieldDidBeginEditing();
                                if (delegate && typeof delegate.textFieldDidBeginEditing === 'function') delegate.textFieldDidBeginEditing(this);
                            }
                        },
                        {
                            key: 'delegate',
                            value: function delegate() {
                                return this._delegate;
                            }
                        },
                        {
                            key: 'setDelegate',
                            value: function setDelegate(delegate) {
                                this._delegate = delegate;
                            }
                        },
                        {
                            key: 'destroy',
                            value: function destroy() {
                                var element = this.element;
                                element.removeEventListener('keydown', this._keyDown);
                                element.removeEventListener('keypress', this._keyPress);
                                element.removeEventListener('keyup', this._keyUp);
                                element.removeEventListener('click', this._click);
                                element.removeEventListener('paste', this._paste);
                                element.removeEventListener('focus', this._focus);
                                element.removeEventListener('blur', this._blur);
                                delete element['field-kit-text-field'];
                            }
                        },
                        {
                            key: 'formatter',
                            value: function formatter() {
                                if (!this._formatter) {
                                    this._formatter = new _formatter2['default']();
                                    var maximumLengthString = this.element.getAttribute('maxlength');
                                    if (maximumLengthString !== undefined && maximumLengthString !== null) this._formatter.maximumLength = parseInt(maximumLengthString, 10);
                                }
                                return this._formatter;
                            }
                        },
                        {
                            key: 'setFormatter',
                            value: function setFormatter(formatter) {
                                var value = this.value();
                                this._formatter = formatter;
                                this.setValue(value);
                            }
                        },
                        {
                            key: 'hasChangesAndIsValid',
                            value: function hasChangesAndIsValid(current, proposed) {
                                var _this = this;
                                var change = new TextFieldStateChange(this);
                                var error = function error(errorType) {
                                    var delegate = _this.delegate();
                                    if (delegate) {
                                        if (typeof delegate.textFieldDidFailToValidateChange === 'function') delegate.textFieldDidFailToValidateChange(_this, change, errorType);
                                    }
                                };
                                change.current = {
                                    text: current.text,
                                    selectedRange: current.selectedRange
                                };
                                change.proposed = {
                                    text: proposed.text,
                                    selectedRange: proposed.selectedRange
                                };
                                if (change.hasChanges() && this.formatter().isChangeValid(change, error)) return change;
                                return null;
                            }
                        },
                        {
                            key: 'insertNewline',
                            value: function insertNewline() {
                                this._textFieldDidEndEditing();
                                this._didEndEditingButKeptFocus = true;
                            }
                        },
                        {
                            key: 'inspect',
                            value: function inspect() {
                                return '#<TextField text="' + this.text() + '">';
                            }
                        },
                        {
                            key: 'readSelectionFromPasteboard',
                            value: function readSelectionFromPasteboard(pasteboard) {
                                var range = undefined, text = undefined;
                                text = pasteboard.getData('Text');
                                this.replaceSelection(text);
                                range = this.selectedRange();
                                range.start += range.length;
                                range.length = 0;
                                this.setSelectedRange(range);
                            }
                        },
                        {
                            key: 'rollbackInvalidChanges',
                            value: function rollbackInvalidChanges(callback) {
                                var result = null;
                                var errorType = null;
                                var change = TextFieldStateChange.build(this, function() {
                                    return result = callback();
                                });
                                var error = function error(type) {
                                    errorType = type;
                                };
                                if (change.hasChanges()) {
                                    var formatter = this.formatter();
                                    if (formatter && typeof formatter.isChangeValid === 'function') {
                                        if (!this._isDirty) {
                                            this._valueOnFocus = change.current.text || '';
                                            this._isDirty = true;
                                        }
                                        if (formatter.isChangeValid(change, error)) {
                                            change.recomputeDiff();
                                            this.setText(change.proposed.text);
                                            this.setSelectedRange(change.proposed.selectedRange);
                                        } else {
                                            var delegate = this.delegate();
                                            if (delegate) {
                                                if (typeof delegate.textFieldDidFailToValidateChange === 'function') delegate.textFieldDidFailToValidateChange(this, change, errorType);
                                            }
                                            this.setText(change.current.text);
                                            this.setSelectedRange(change.current.selectedRange);
                                            return result;
                                        }
                                    }
                                    if (change.inserted.text.length || change.deleted.text.length) {
                                        this.undoManager().proxyFor(this)._applyChangeFromUndoManager(change);
                                        this._textDidChange();
                                    }
                                }
                                return result;
                            }
                        },
                        {
                            key: 'value',
                            value: function value() {
                                var _this2 = this;
                                var text = this.text();
                                var delegate = this.delegate();
                                var formatter = this.formatter();
                                if (!formatter) return text;
                                return formatter.parse(text, function(errorType) {
                                    if (delegate) {
                                        if (typeof delegate.textFieldDidFailToParseString === 'function') delegate.textFieldDidFailToParseString(_this2, text, errorType);
                                    }
                                });
                            }
                        },
                        {
                            key: 'setValue',
                            value: function setValue(value) {
                                if (this._formatter) value = this._formatter.format(value);
                                this.setText('' + value);
                            }
                        },
                        {
                            key: 'text',
                            value: function text() {
                                return this.element.value;
                            }
                        },
                        {
                            key: 'setText',
                            value: function setText(text) {
                                this.element.value = text;
                                this._currentValue = text;
                            }
                        },
                        {
                            key: 'selectedRange',
                            value: function selectedRange() {
                                var caret = this._needsManualCaret ? this._manualCaret : getCaret(this.element);
                                return {
                                    start: caret.start,
                                    length: caret.end - caret.start
                                };
                            }
                        },
                        {
                            key: 'setSelectedRangeWithAffinity',
                            value: function setSelectedRangeWithAffinity(range, affinity) {
                                var newRange = _get(Object.getPrototypeOf(TextField.prototype), 'setSelectedRangeWithAffinity', this).call(this, range, affinity);
                                var caret = {
                                    start: newRange.start,
                                    end: newRange.start + newRange.length
                                };
                                this._manualCaret = caret;
                                setCaret(this.element, caret.start, caret.end);
                                this.selectionAffinity = range.length === 0 ? null : affinity;
                            }
                        },
                        {
                            key: 'allowsUndo',
                            value: function allowsUndo() {
                                return this._allowsUndo;
                            }
                        },
                        {
                            key: 'setAllowsUndo',
                            value: function setAllowsUndo(allowsUndo) {
                                this._allowsUndo = allowsUndo;
                            }
                        },
                        {
                            key: 'redo',
                            value: function redo(event) {
                                if (this.undoManager().canRedo()) this.undoManager().redo();
                                event.preventDefault();
                            }
                        },
                        {
                            key: 'undo',
                            value: function undo(event) {
                                if (this.undoManager().canUndo()) this.undoManager().undo();
                                event.preventDefault();
                            }
                        },
                        {
                            key: 'undoManager',
                            value: function undoManager() {
                                return this._undoManager || (this._undoManager = new _undo_manager2['default']());
                            }
                        },
                        {
                            key: 'becomeFirstResponder',
                            value: function becomeFirstResponder() {
                                var _this3 = this;
                                this.element.focus();
                                this.rollbackInvalidChanges(function() {
                                    _this3.element.select();
                                    _this3._syncPlaceholder();
                                });
                            }
                        },
                        {
                            key: 'hasFocus',
                            value: function hasFocus() {
                                return this.element.ownerDocument.activeElement === this.element;
                            }
                        },
                        {
                            key: 'isEnabled',
                            value: function isEnabled() {
                                return this._enabled;
                            }
                        },
                        {
                            key: 'setEnabled',
                            value: function setEnabled(enabled) {
                                this._enabled = enabled;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'resignFirstResponder',
                            value: function resignFirstResponder(event) {
                                if (event !== undefined && event !== null) event.preventDefault();
                                this.element.blur();
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'disabledPlaceholder',
                            value: function disabledPlaceholder() {
                                return this._disabledPlaceholder;
                            }
                        },
                        {
                            key: 'setDisabledPlaceholder',
                            value: function setDisabledPlaceholder(disabledPlaceholder) {
                                this._disabledPlaceholder = disabledPlaceholder;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'focusedPlaceholder',
                            value: function focusedPlaceholder() {
                                return this._focusedPlaceholder;
                            }
                        },
                        {
                            key: 'setFocusedPlaceholder',
                            value: function setFocusedPlaceholder(focusedPlaceholder) {
                                this._focusedPlaceholder = focusedPlaceholder;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'placeholder',
                            value: function placeholder() {
                                return this._placeholder;
                            }
                        },
                        {
                            key: 'setPlaceholder',
                            value: function setPlaceholder(placeholder) {
                                this._placeholder = placeholder;
                                this.element.setAttribute('placeholder', this._placeholder);
                            }
                        },
                        {
                            key: 'unfocusedPlaceholder',
                            value: function unfocusedPlaceholder() {
                                return this._unfocusedPlaceholder;
                            }
                        },
                        {
                            key: 'setUnfocusedPlaceholder',
                            value: function setUnfocusedPlaceholder(unfocusedPlaceholder) {
                                this._unfocusedPlaceholder = unfocusedPlaceholder;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: '_applyChangeFromUndoManager',
                            value: function _applyChangeFromUndoManager(change) {
                                this.undoManager().proxyFor(this)._applyChangeFromUndoManager(change);
                                if (this.undoManager().isUndoing()) {
                                    this.setText(change.current.text);
                                    this.setSelectedRange(change.current.selectedRange);
                                } else {
                                    this.setText(change.proposed.text);
                                    this.setSelectedRange(change.proposed.selectedRange);
                                }
                                this._textDidChange();
                            }
                        },
                        {
                            key: '_click',
                            value: function _click() {
                                this._manualCaret = getCaret(this.element);
                                this._selectedRange = {
                                    start: this._manualCaret.start,
                                    length: this._manualCaret.end - this._manualCaret.start
                                };
                                this.selectionAffinity = null;
                            }
                        },
                        {
                            key: '_fireEvent',
                            value: function _fireEvent(eventType) {
                                var document1 = this.element.ownerDocument;
                                var window = document1.defaultView;
                                if (typeof window.CustomEvent === 'function') this.element.dispatchEvent(new window.CustomEvent(eventType, {}));
                                else {
                                    var _event = document1.createEvent('Event');
                                    _event.initEvent(eventType, false, false);
                                    this.element.dispatchEvent(_event);
                                }
                            }
                        },
                        {
                            key: '_focus',
                            value: function _focus() {
                                this._textFieldDidBeginEditing();
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: '_blur',
                            value: function _blur() {
                                this._textFieldDidEndEditing();
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: '_keyDown',
                            value: function _keyDown(event) {
                                var _this4 = this;
                                if (this._didEndEditingButKeptFocus) {
                                    this._textFieldDidBeginEditing();
                                    this._didEndEditingButKeptFocus = false;
                                }
                                var action = this._bindings.actionForEvent(event);
                                if (action) switch(action){
                                    case 'undo':
                                    case 'redo':
                                        this[action](event);
                                        break;
                                    default:
                                        this.rollbackInvalidChanges(function() {
                                            return _this4[action](event);
                                        });
                                        break;
                                }
                            }
                        },
                        {
                            key: '_keyPress',
                            value: function _keyPress(event) {
                                var _this5 = this;
                                var keyCode = event.keyCode;
                                if (!event.metaKey && !event.ctrlKey && keyCode !== _inputSim.KEYS.ENTER && keyCode !== _inputSim.KEYS.TAB && keyCode !== _inputSim.KEYS.BACKSPACE) {
                                    if (event.charCode !== 0) (function() {
                                        var newText = String.fromCharCode(event.charCode || event.keyCode);
                                        _this5._processChange({
                                            currentText: _this5.text(),
                                            proposedText: (0, _utils.replaceStringSelection)(newText, _this5.text(), _this5.selectedRange()),
                                            onSuccess: function onSuccess(change, changeTriggeredFormatting) {
                                                if (!changeTriggeredFormatting && event instanceof KeyboardEvent) {
                                                    // HACK(JoeTaylor) Use Browser's native input when using the formatter
                                                    // would not make a difference https://code.google.com/p/chromium/issues/detail?id=32865
                                                    if (!_this5._isDirty) {
                                                        _this5._valueOnFocus = change.current.text || '';
                                                        _this5._isDirty = true;
                                                    }
                                                    _this5.undoManager().proxyFor(_this5)._applyChangeFromUndoManager(change);
                                                    _this5._manualCaret = {
                                                        start: change.proposed.selectedRange.start,
                                                        end: change.proposed.selectedRange.start + change.proposed.selectedRange.length
                                                    };
                                                    _this5._needsKeyUpTextDidChangeTrigger = true;
                                                } else {
                                                    event.preventDefault();
                                                    _this5.rollbackInvalidChanges(function() {
                                                        return _this5.insertText(newText);
                                                    });
                                                }
                                                _this5._currentValue = change.proposed.text;
                                            },
                                            onFail: function onFail() {
                                                event.preventDefault();
                                                _this5.rollbackInvalidChanges(function() {
                                                    return _this5.insertText(newText);
                                                });
                                            }
                                        });
                                    })();
                                    else event.preventDefault();
                                }
                            }
                        },
                        {
                            key: '_keyUp',
                            value: function _keyUp(event) {
                                var _this6 = this;
                                if (this._needsKeyUpTextDidChangeTrigger) {
                                    this._textDidChange();
                                    this._needsKeyUpTextDidChangeTrigger = false;
                                }
                                var keyCode = event.keyCode;
                                // NOTE: Certain Androids on Chrome always return 229
                                // https://code.google.com/p/chromium/issues/detail?id=118639
                                if (keyCode === 229) (function() {
                                    // Text has already been changed at this point, so we check the previous text
                                    // to determine whether we need to undo the change.
                                    var previousText = _this6._currentValue || '';
                                    _this6._processChange({
                                        currentText: previousText,
                                        proposedText: _this6.text(),
                                        onSuccess: function onSuccess(change, changeTriggeredFormatting) {
                                            if (changeTriggeredFormatting) {
                                                var newText = change.proposed.text;
                                                _this6.setSelectedRange(change.proposed.selectedRange);
                                                _this6.setText(newText);
                                            }
                                            if (!_this6._isDirty) {
                                                _this6._valueOnFocus = change.current.text || '';
                                                _this6._isDirty = true;
                                            }
                                            _this6.undoManager().proxyFor(_this6)._applyChangeFromUndoManager(change);
                                            _this6._textDidChange();
                                            _this6._currentValue = change.proposed.text;
                                        },
                                        onFail: function onFail() {
                                            // Need to rollback the letter input in the Keyup event because it is not valid,
                                            // so we set text to the previous state (as collected from the UndoManager).
                                            _this6.setText(previousText);
                                        }
                                    });
                                })();
                                else this.rollbackInvalidChanges(function() {
                                    if (event.keyCode === _inputSim.KEYS.TAB) _this6.selectAll(event);
                                });
                            }
                        },
                        {
                            key: '_processChange',
                            value: function _processChange(_ref) {
                                var currentText = _ref.currentText;
                                var proposedText = _ref.proposedText;
                                var onSuccess = _ref.onSuccess;
                                var _ref$onFail = _ref.onFail;
                                var onFail = _ref$onFail === undefined ? function() {} : _ref$onFail;
                                var current = {
                                    text: currentText,
                                    selectedRange: this.selectedRange()
                                };
                                var proposed = {
                                    text: proposedText,
                                    selectedRange: {
                                        start: current.selectedRange.start + 1,
                                        length: 0
                                    }
                                };
                                var change = this.hasChangesAndIsValid(current, proposed);
                                var changeTriggeredFormatting = change && (change.proposed.text !== proposed.text || change.proposed.selectedRange.start !== proposed.selectedRange.start || change.proposed.selectedRange.length !== proposed.selectedRange.length);
                                if (change) onSuccess(change, changeTriggeredFormatting);
                                else onFail();
                            }
                        },
                        {
                            key: '_paste',
                            value: function _paste(event) {
                                var _this7 = this;
                                event.preventDefault();
                                this.rollbackInvalidChanges(function() {
                                    _this7.readSelectionFromPasteboard(event.clipboardData);
                                });
                            }
                        },
                        {
                            key: '_syncPlaceholder',
                            value: function _syncPlaceholder() {
                                if (!this._enabled) {
                                    var disabledPlaceholder = this._disabledPlaceholder;
                                    if (disabledPlaceholder !== undefined && disabledPlaceholder !== null) this.setPlaceholder(disabledPlaceholder);
                                } else if (this.hasFocus()) {
                                    var focusedPlaceholder = this._focusedPlaceholder;
                                    if (focusedPlaceholder !== undefined && focusedPlaceholder !== null) this.setPlaceholder(focusedPlaceholder);
                                } else {
                                    var unfocusedPlaceholder = this._unfocusedPlaceholder;
                                    if (unfocusedPlaceholder !== undefined && unfocusedPlaceholder !== null) this.setPlaceholder(unfocusedPlaceholder);
                                }
                            }
                        }
                    ]);
                    return TextField;
                }(_inputSim.Input);
                var TextFieldStateChange = function() {
                    /**
   * @param {TextField} field
   */ function TextFieldStateChange(field) {
                        _classCallCheck(this, TextFieldStateChange);
                        this.field = field;
                    }
                    /**
   * Builds a new {TextFieldStateChange} that will allow you to
   * compute differences, and see the current vs proposed changes.
   *
   * @param {TextField} field
   * @param {Function} callback called when you want changes to the field
   *    take place. Current will be calculated before this callback.
   *    Proposed will be calculated after this callback.
   *
   * @returns {Object} change object with current and proposed properties
   */ /**
   * Determines whether this field has changes.
   *
   * @returns {boolean} true if either the current text doesn't match the proposed text
   *    or the current selection range doesn't match the proposed selection range
   */ _createClass(TextFieldStateChange, [
                        {
                            key: 'hasChanges',
                            value: function hasChanges() {
                                this.recomputeDiff();
                                return this.current.text !== this.proposed.text || this.current.selectedRange.start !== this.proposed.selectedRange.start || this.current.selectedRange.length !== this.proposed.selectedRange.length;
                            }
                        },
                        {
                            key: 'recomputeDiff',
                            value: function recomputeDiff() {
                                if (this.proposed.text !== this.current.text) {
                                    var ctext = this.current.text;
                                    var ptext = this.proposed.text;
                                    var sharedPrefixLength = 0;
                                    var sharedSuffixLength = 0;
                                    var minTextLength = Math.min(ctext.length, ptext.length);
                                    var i = undefined;
                                    for(i = 0; i < minTextLength; i++){
                                        if (ptext[i] === ctext[i]) sharedPrefixLength = i + 1;
                                        else break;
                                    }
                                    for(i = 0; i < minTextLength - sharedPrefixLength; i++){
                                        if (ptext[ptext.length - 1 - i] === ctext[ctext.length - 1 - i]) sharedSuffixLength = i + 1;
                                        else break;
                                    }
                                    var inserted = {
                                        start: sharedPrefixLength,
                                        end: ptext.length - sharedSuffixLength
                                    };
                                    var deleted = {
                                        start: sharedPrefixLength,
                                        end: ctext.length - sharedSuffixLength
                                    };
                                    inserted.text = ptext.substring(inserted.start, inserted.end);
                                    deleted.text = ctext.substring(deleted.start, deleted.end);
                                    this.inserted = inserted;
                                    this.deleted = deleted;
                                } else {
                                    this.inserted = {
                                        start: this.proposed.selectedRange.start,
                                        end: this.proposed.selectedRange.start + this.proposed.selectedRange.length,
                                        text: ''
                                    };
                                    this.deleted = {
                                        start: this.current.selectedRange.start,
                                        end: this.current.selectedRange.start + this.current.selectedRange.length,
                                        text: ''
                                    };
                                }
                            }
                        }
                    ]);
                    return TextFieldStateChange;
                }();
                TextFieldStateChange.build = function(field, callback) {
                    var change = new this(field);
                    change.current = {
                        text: field.text(),
                        selectedRange: field.selectedRange()
                    };
                    callback();
                    change.proposed = {
                        text: field.text(),
                        selectedRange: field.selectedRange()
                    };
                    change.recomputeDiff();
                    return change;
                };
                exports['default'] = TextField;
                module1.exports = exports['default'];
            },
            {
                "./caret": 8,
                "./formatter": 14,
                "./undo_manager": 21,
                "./utils": 22,
                "input-sim": 1
            }
        ],
        21: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var _utils = _dereq_('./utils');
                /**
 * UndoManager is a general-purpose recorder of operations for undo and redo.
 *
 * Registering an undo action is done by specifying the changed object, along
 * with a method to invoke to revert its state and the arguments for that
 * method. When performing undo an UndoManager saves the operations reverted so
 * that you can redo the undos.
 */ var UndoManager = function() {
                    function UndoManager() {
                        _classCallCheck(this, UndoManager);
                        /** @private */ this._undos = [];
                        /** @private */ this._redos = [];
                        /** @private */ this._isUndoing = false;
                        /** @private */ this._isRedoing = false;
                    }
                    /**
   * Determines whether there are any undo actions on the stack.
   *
   * @returns {boolean}
   */ _createClass(UndoManager, [
                        {
                            key: 'canUndo',
                            value: function canUndo() {
                                return this._undos.length !== 0;
                            }
                        },
                        {
                            key: 'canRedo',
                            value: function canRedo() {
                                return this._redos.length !== 0;
                            }
                        },
                        {
                            key: 'isUndoing',
                            value: function isUndoing() {
                                return this._isUndoing;
                            }
                        },
                        {
                            key: 'isRedoing',
                            value: function isRedoing() {
                                return this._isRedoing;
                            }
                        },
                        {
                            key: 'registerUndo',
                            value: function registerUndo(target, selector) {
                                for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                                if (this._isUndoing) this._appendRedo.apply(this, [
                                    target,
                                    selector
                                ].concat(args));
                                else {
                                    if (!this._isRedoing) this._redos.length = 0;
                                    this._appendUndo.apply(this, [
                                        target,
                                        selector
                                    ].concat(args));
                                }
                            }
                        },
                        {
                            key: '_appendUndo',
                            value: function _appendUndo(target, selector) {
                                for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                                this._undos.push({
                                    target: target,
                                    selector: selector,
                                    args: args
                                });
                            }
                        },
                        {
                            key: '_appendRedo',
                            value: function _appendRedo(target, selector) {
                                for(var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
                                this._redos.push({
                                    target: target,
                                    selector: selector,
                                    args: args
                                });
                            }
                        },
                        {
                            key: 'undo',
                            value: function undo() {
                                if (!this.canUndo()) throw new Error('there are no registered undos');
                                var data = this._undos.pop();
                                var target = data.target;
                                var selector = data.selector;
                                var args = data.args;
                                this._isUndoing = true;
                                target[selector].apply(target, args);
                                this._isUndoing = false;
                            }
                        },
                        {
                            key: 'redo',
                            value: function redo() {
                                if (!this.canRedo()) throw new Error('there are no registered redos');
                                var data = this._redos.pop();
                                var target = data.target;
                                var selector = data.selector;
                                var args = data.args;
                                this._isRedoing = true;
                                target[selector].apply(target, args);
                                this._isRedoing = false;
                            }
                        },
                        {
                            key: 'proxyFor',
                            value: function proxyFor(target) {
                                var proxy = {};
                                var self = this;
                                function proxyMethod(selector) {
                                    return function() {
                                        for(var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                                        self.registerUndo.apply(self, [
                                            target,
                                            selector
                                        ].concat(args));
                                    };
                                }
                                (0, _utils.getAllPropertyNames)(target).forEach(function(selector) {
                                    // don't trigger anything that has a getter
                                    if ((0, _utils.hasGetter)(target, selector)) return;
                                    // don't try to proxy properties that aren't functions
                                    if (typeof target[selector] !== 'function') return;
                                    // set up a proxy function to register an undo
                                    proxy[selector] = proxyMethod(selector);
                                });
                                return proxy;
                            }
                        }
                    ]);
                    return UndoManager;
                }();
                exports['default'] = UndoManager;
                module1.exports = exports['default'];
            },
            {
                "./utils": 22
            }
        ],
        22: [
            function(_dereq_, module1, exports) {
                /**
 * @const
 * @private
 */ 'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                exports.isDigits = isDigits;
                exports.startsWith = startsWith;
                exports.endsWith = endsWith;
                exports.zpad = zpad;
                exports.zpad2 = zpad2;
                exports.bind = bind;
                exports.replaceStringSelection = replaceStringSelection;
                exports.forEach = forEach;
                exports.hasGetter = hasGetter;
                exports.getAllPropertyNames = getAllPropertyNames;
                function _toConsumableArray(arr) {
                    if (Array.isArray(arr)) {
                        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                        return arr2;
                    } else return Array.from(arr);
                }
                var DIGITS_PATTERN = /^\d*$/;
                /**
 * @const
 * @private
 */ var SURROUNDING_SPACE_PATTERN = /(^\s+|\s+$)/;
                /**
 * @param {string} string
 * @returns {boolean}
 */ function isDigits(string) {
                    return DIGITS_PATTERN.test(string);
                }
                /**
 * @param {string} prefix
 * @param {string} string
 * @returns {boolean}
 */ function startsWith(prefix, string) {
                    return string.slice(0, prefix.length) === prefix;
                }
                /**
 * @param {string} suffix
 * @param {string} string
 * @returns {boolean}
 */ function endsWith(suffix, string) {
                    return string.slice(string.length - suffix.length) === suffix;
                }
                /**
 * @param {string} string
 * @returns {string}
 */ var trim = typeof ''.trim === 'function' ? function(string) {
                    return string.trim();
                } : function(string) {
                    return string.replace(SURROUNDING_SPACE_PATTERN, '');
                };
                exports.trim = trim;
                /**
 * Will pad n with `0` up until length.
 *
 * @example
 *     zpad(16, '1234');
 *     // => 0000000000001234
 *
 * @param {number} length
 * @param {(string|number)} n
 * @returns {string}
 */ function zpad(length, n) {
                    var result = '' + n;
                    while(result.length < length)result = '0' + result;
                    return result;
                }
                /**
 * Will pad n with `0` up until length is 2.
 *
 * @example
 *     zpad2('2');
 *     // => 02
 *
 * @param {(string|number)} n
 * @returns {string}
 */ function zpad2(n) {
                    return zpad(2, n);
                }
                /**
 * PhantomJS 1.9 does not have Function.bind.
 *
 * @param {Function} fn
 * @param {*} context
 * @returns {*}
 */ function bind(fn, context) {
                    return fn.bind(context);
                }
                if (!Function.prototype.bind) Function.prototype.bind = function(context) {
                    for(var _len = arguments.length, prependedArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)prependedArgs[_key - 1] = arguments[_key];
                    var self = this;
                    return function() {
                        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        return self.apply(context, prependedArgs.concat(args));
                    };
                };
                /**
 * Replaces the characters within the selection with given text.
 *
 * @example
 *     // 12|34567|8
 *     replaceStringSelection('12345678', '00', { start: 2, length: 5 });
 *     // 12|00|8
 *
 * @param   {string} replacement
 * @param   {string} text
 * @param   {object} {start: number, length: number}
 * @returns {string}
 */ function replaceStringSelection(replacement, text, range) {
                    var end = range.start + range.length;
                    return text.substring(0, range.start) + replacement + text.substring(end);
                }
                var hasOwnProp = Object.prototype.hasOwnProperty;
                /**
 * @param {*} iterable
 * @param {Function} iterator
 */ function forEach(iterable, iterator) {
                    if (iterable && typeof iterable.forEach === 'function') iterable.forEach(iterator);
                    else if (({}).toString.call(iterable) === '[object Array]') for(var i = 0, l = iterable.length; i < l; i++)iterator.call(null, iterable[i], i, iterable);
                    else {
                        for(var key in iterable)if (hasOwnProp.call(iterable, key)) iterator.call(null, iterable[key], key, iterable);
                    }
                }
                var getOwnPropertyNames = function() {
                    var getOwnPropertyNames = Object.getOwnPropertyNames;
                    try {
                        Object.getOwnPropertyNames({}, 'sq');
                    } catch (e) {
                        // IE 8
                        getOwnPropertyNames = function(object) {
                            var result = [];
                            for(var key in object)if (hasOwnProp.call(object, key)) result.push(key);
                            return result;
                        };
                    }
                    return getOwnPropertyNames;
                }();
                var getPrototypeOf = Object.getPrototypeOf || function(object) {
                    return object.__proto__;
                };
                /**
 * @param {Object} object
 * @param {string} property
 * @returns {boolean}
 */ function hasGetter(object, property) {
                    // Skip if getOwnPropertyDescriptor throws (IE8)
                    try {
                        Object.getOwnPropertyDescriptor({}, 'sq');
                    } catch (e) {
                        return false;
                    }
                    var descriptor = undefined;
                    if (object && object.constructor && object.constructor.prototype) descriptor = Object.getOwnPropertyDescriptor(object.constructor.prototype, property);
                    if (!descriptor) descriptor = Object.getOwnPropertyDescriptor(object, property);
                    if (descriptor && descriptor.get) return true;
                    else return false;
                }
                /**
 * @param {Object} object
 * @returns {?string[]}
 */ function getAllPropertyNames(object) {
                    if (object === null || object === undefined) return [];
                    var result = getOwnPropertyNames(object);
                    var prototype = object.constructor && object.constructor.prototype;
                    while(prototype){
                        result.push.apply(result, _toConsumableArray(getOwnPropertyNames(prototype)));
                        prototype = getPrototypeOf(prototype);
                    }
                    return result;
                }
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});


function $5e640a0c964f3ee4$export$d5fa24fd308c2940({ value: value, children: children, disabled: disabled = false, formatter: formatter = new (0, $58cb02b9641cce25$exports.Formatter)(), maxlength: maxlength, placeholder: placeholder, readonly: readonly = false, type: type = "string", onTextChange: // eslint-disable-next-line @typescript-eslint/no-empty-function
onTextChange = ()=>{} }) {
    /**
   * Add field kit text field when MarketInputText has loaded. This is determined by
   * onMarketInputDidLoad. This was the most consistent way to ensure that the HTML
   * input was loaded.
   *
   * Other attempts included adding a ref and useEffect and adding
   * the field kit text field. In theory, it would have been called after first render
   * but HTML input in MarketInputText was occasionally returning `undefined` when
   * calling `getInputElement`
   */ const addFieldKit = (input)=>{
        if (value) input.value = formatter.format(value);
        const textField = new (0, $58cb02b9641cce25$exports.TextField)(input, formatter);
        /**
     * Forgo using the onMarketInputValueChange to handle text change and use
     * text field textDidChange
     */ const textDidChange = (field)=>onTextChange(field.value());
        textField.setDelegate({
            textDidChange: textDidChange
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$f8929a49510d767f), {
        "data-testid": "formatted-input-text",
        value: value && formatter ? formatter.format(value) : "",
        // NOTE(cvu): this is a hack because disabled="false" prevents the input field from being editable
        // TODO(cvu): Change once issue is fixed. Ticket: https://github.com/squareup/market/issues/4880
        disabled: disabled,
        maxlength: maxlength,
        readonly: readonly,
        placeholder: placeholder,
        onMarketInputDidLoad: (event)=>addFieldKit(event.detail.input),
        type: type,
        children: children
    });
}


function $c713dbee3e06984a$export$be4b7f1b3e13aead({ className: className, disabled: disabled = false, error: error, formatter: formatter, helper: helper, label: label, maxlength: maxlength, name: name, placeholder: placeholder, readonly: readonly = false, value: value, onTextChange: onTextChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$bf9d3c0d17a2f99e), {
        "data-testid": name,
        className: className,
        name: name,
        invalid: Boolean(error),
        // NOTE(cvu): this is a hack because disabled="false" prevents the input field from being editable
        // TODO(cvu): Change once issue is fixed. Ticket: https://github.com/squareup/market/issues/4880
        disabled: disabled,
        readonly: readonly,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e640a0c964f3ee4$export$d5fa24fd308c2940), {
                value: value,
                placeholder: placeholder,
                maxlength: maxlength,
                formatter: formatter,
                onTextChange: onTextChange,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: label,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                "data-testid": "error",
                slot: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                slot: "helper",
                style: {
                    marginBottom: 0
                },
                children: helper
            })
        ]
    });
}


var $19fc8f7d0d9a2516$export$ded0429a17534e2e;
var $19fc8f7d0d9a2516$export$ad966e170037b8a8;
var $19fc8f7d0d9a2516$export$34e0f9847d4c02dd;
var $19fc8f7d0d9a2516$export$f10e6b4aaa94c253;
var $19fc8f7d0d9a2516$export$dc6dff4b377d0f20;
var $19fc8f7d0d9a2516$export$775b4cc0f1f2bbce;
var $19fc8f7d0d9a2516$export$a9dcf7b529f2769a;
$19fc8f7d0d9a2516$export$ded0429a17534e2e = `_0sPYBa_CardCustomization_cardPreview`;
$19fc8f7d0d9a2516$export$ad966e170037b8a8 = `_0sPYBa_CardCustomization_cardPreviewContainer`;
$19fc8f7d0d9a2516$export$34e0f9847d4c02dd = `_0sPYBa_CardCustomization_container`;
$19fc8f7d0d9a2516$export$f10e6b4aaa94c253 = `_0sPYBa_CardCustomization_loadingIndicator`;
$19fc8f7d0d9a2516$export$dc6dff4b377d0f20 = `_0sPYBa_CardCustomization_pill`;
$19fc8f7d0d9a2516$export$775b4cc0f1f2bbce = `_0sPYBa_CardCustomization_signatureContent`;
$19fc8f7d0d9a2516$export$a9dcf7b529f2769a = `_0sPYBa_CardCustomization_signaturePreview`;


var $211b47b09eb34e54$export$48c2d0f2f545ac27;
var $211b47b09eb34e54$export$746c1c87f3ad3d31;
var $211b47b09eb34e54$export$8aade8ce2b5d7e87;
var $211b47b09eb34e54$export$e97739ba196b52a5;
var $211b47b09eb34e54$export$e57dd03da898490e;
$211b47b09eb34e54$export$48c2d0f2f545ac27 = `UHnzMG_CardPreview_preview`;
$211b47b09eb34e54$export$746c1c87f3ad3d31 = `UHnzMG_CardPreview_previewBack`;
$211b47b09eb34e54$export$8aade8ce2b5d7e87 = `UHnzMG_CardPreview_previewContainer`;
$211b47b09eb34e54$export$e97739ba196b52a5 = `UHnzMG_CardPreview_previewContainerRotate`;
$211b47b09eb34e54$export$e57dd03da898490e = `UHnzMG_CardPreview_previewFront`;







var $acw62 = parcelRequire("acw62");
// This value is copied from market
const $fb48b27410e45132$var$CORE_HORIZONTAL_REGULAR_THRESHOLD = 600;
function $fb48b27410e45132$export$f715c0e61b2c1a36() {
    const [windowDimensions, setWindowDimensions] = (0, $acw62.useState)({
        width: undefined,
        height: undefined,
        isMobile: false
    });
    (0, $acw62.useEffect)(()=>{
        function updateWindowDimensions() {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < $fb48b27410e45132$var$CORE_HORIZONTAL_REGULAR_THRESHOLD
            });
        }
        window.addEventListener("resize", updateWindowDimensions);
        updateWindowDimensions();
        return ()=>window.removeEventListener("resize", updateWindowDimensions);
    }, []);
    return windowDimensions;
}
const $fb48b27410e45132$export$ada05d935211d77e = /*#__PURE__*/ (0, $acw62.createContext)({
    width: undefined,
    height: undefined,
    isMobile: false
});
function $fb48b27410e45132$export$e6e3537859e84918({ children: children }) {
    const windowDimensions = $fb48b27410e45132$export$f715c0e61b2c1a36();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fb48b27410e45132$export$ada05d935211d77e.Provider, {
        value: windowDimensions,
        children: children
    });
}


var $f0367ad0a0e81232$export$2ba01fb71ed41cb6;
var $f0367ad0a0e81232$export$38e42c68cf43b5d4;
$f0367ad0a0e81232$export$2ba01fb71ed41cb6 = `KDRO4a_Screen_button`;
$f0367ad0a0e81232$export$38e42c68cf43b5d4 = `KDRO4a_Screen_header`;


function $77a799ee7a5a2b82$export$a98515d67472a41f({ buttons: buttons = [], content: content, title: title }) {
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const mobileViewport = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("header-30", $f0367ad0a0e81232$export$38e42c68cf43b5d4),
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                "data-testid": "main",
                children: content
            }),
            buttons?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$a2053447cfda9df3), {
                "data-testid": "footer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$98f7e185520106d0), {
                    alignment: "stack",
                    "data-testid": "button-group",
                    children: [
                        ...buttons
                    ]
                })
            }) : null
        ]
    });
    const desktopViewport = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
            "data-testid": "main",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("header-30", $f0367ad0a0e81232$export$38e42c68cf43b5d4),
                    children: title
                }),
                content,
                buttons?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$98f7e185520106d0), {
                    alignment: "left",
                    className: $f0367ad0a0e81232$export$2ba01fb71ed41cb6,
                    "data-testid": "button-group",
                    children: [
                        ...buttons
                    ]
                }) : null
            ]
        })
    });
    return windowDimensions.isMobile ? mobileViewport : desktopViewport;
}


const $76f6a20479f97bf3$var$SIGNATURE_FONT_SIZE = 32;
// The font list waits at most this long; a font still loading by then is left out.
const $76f6a20479f97bf3$var$SIGNATURE_FONT_LOAD_TIMEOUT_MS = 3000;
function $76f6a20479f97bf3$export$4eecc657670f7f54({ businessName: businessName, customizeSignatureActive: customizeSignatureActive, customSignatureInputError: customSignatureInputError, customSignatureInputHelper: customSignatureInputHelper, fontFamilies: fontFamilies, loading: loading, signatureInputText: signatureInputText, signatureText: signatureText, selectedFontFamily: selectedFontFamily, onCustomizeSignatureToggle: onCustomizeSignatureToggle, onNextClick: onNextClick, onSignatureFontChange: onSignatureFontChange, onSignatureTextChange: onSignatureTextChange }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "cardCustomization"
    });
    const [fontsLoaded, setFontsLoaded] = (0, $acw62.useState)(false);
    const [loadedFontFamilies, setLoadedFontFamilies] = (0, $acw62.useState)([]);
    const loadSignatureFont = async (font)=>{
        let timeoutId;
        const timeout = new Promise((resolve)=>{
            timeoutId = setTimeout(()=>resolve([]), $76f6a20479f97bf3$var$SIGNATURE_FONT_LOAD_TIMEOUT_MS);
        });
        try {
            const fontFaces = await Promise.race([
                document.fonts.load(`${$76f6a20479f97bf3$var$SIGNATURE_FONT_SIZE}px "${font}"`),
                timeout
            ]);
            // An empty result means no @font-face rule matched. That's final rather than worth retrying
            // because the font rules ship in the render-blocking stylesheet, so they're registered by now.
            return fontFaces.length > 0 ? font : null;
        } catch  {
            return null;
        } finally{
            clearTimeout(timeoutId);
        }
    };
    (0, $acw62.useEffect)(()=>{
        setFontsLoaded(false);
        Promise.all(fontFamilies.map(loadSignatureFont)).then((fonts)=>{
            const loadedFonts = fonts.filter((0, $e414140c55630b60$export$26128561c93f5847));
            setLoadedFontFamilies(loadedFonts);
            setFontsLoaded(true);
        });
    }, [
        fontFamilies
    ]);
    const onFontSelectionChange = (event)=>{
        const font = event.detail.value;
        onSignatureFontChange(font);
    };
    const cardSignatureList = fontsLoaded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $19fc8f7d0d9a2516$export$775b4cc0f1f2bbce),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                error: customSignatureInputError,
                helper: customSignatureInputHelper,
                name: t("customSignatureTextLabel"),
                label: t("customSignatureTextLabel"),
                value: signatureInputText,
                onTextChange: onSignatureTextChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$5f38cc4b3e71c577), {
                interactive: true,
                value: selectedFontFamily,
                children: loadedFontFamilies.map((fontFamily)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
                        value: fontFamily,
                        onMarketRowSelected: onFontSelectionChange,
                        "data-testid": "font-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                slot: "label",
                                style: {
                                    fontFamily: fontFamily
                                },
                                className: (0, $19fc8f7d0d9a2516$export$a9dcf7b529f2769a),
                                children: signatureText
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$3f5cc96cec366be4), {
                                slot: "control"
                            })
                        ]
                    }, fontFamily))
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$28c2b904b2ab5c88), {
        className: (0, $19fc8f7d0d9a2516$export$f10e6b4aaa94c253)
    });
    const buttons = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
            rank: "primary",
            isLoading: loading,
            onClick: onNextClick,
            children: t("nextButtonText")
        }, t("nextButtonText"))
    ];
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $19fc8f7d0d9a2516$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $19fc8f7d0d9a2516$export$ad966e170037b8a8),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $19fc8f7d0d9a2516$export$ded0429a17534e2e),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25a3c353e703cc79$export$35617c7a4abfbad0), {
                        className: (0, $211b47b09eb34e54$export$48c2d0f2f545ac27),
                        businessName: businessName,
                        boundingBox: (0, $74c7b72a71b76868$export$9a1b8f2a422bb03a),
                        estimatedFontSize: $76f6a20479f97bf3$var$SIGNATURE_FONT_SIZE,
                        fontFamily: selectedFontFamily,
                        nameOnCard: customizeSignatureActive ? signatureText : ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
                    selected: customizeSignatureActive,
                    onMarketRowSelected: ()=>onCustomizeSignatureToggle(true),
                    onMarketRowDeselected: ()=>onCustomizeSignatureToggle(false),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            slot: "label",
                            children: [
                                t("createCustomSignatureText"),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$2deb0c47cc93ce63), {
                                    size: "small",
                                    className: (0, $19fc8f7d0d9a2516$export$dc6dff4b377d0f20),
                                    children: t("optionalPillText")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$1df005bf392232de), {
                            slot: "control"
                        })
                    ]
                })
            }),
            customizeSignatureActive ? cardSignatureList : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77a799ee7a5a2b82$export$a98515d67472a41f), {
        buttons: buttons,
        content: content,
        title: t("title")
    });
}






/**
 * NOTE(cvu): To try to not bake a specific translations library into in the card customization workflow
 * and not require CardCustomizationComponent to not import or reference the workflow, an intermediary
 * place was needed to map the error states to translation strings. ConnectedCardCustomization was the best
 * place for it. But for the sake of allowing me to test these functions easier, I have moved these functions
 * into a separate file.
 */ 
const $d3c3b5d7e6f92cf0$export$e0eaa81363ef94db = (t)=>(customSignatureInputError, signatureInputText)=>{
        if (customSignatureInputError.length === 0) return "";
        switch(customSignatureInputError[0]){
            case (0, $d50f52fc18ffa921$export$b58c4be94c1619ca).ContainsEmoji:
                return t("customSignatureError.containsEmoji");
            case (0, $d50f52fc18ffa921$export$b58c4be94c1619ca).Empty:
                return t("customSignatureError.empty");
            case (0, $d50f52fc18ffa921$export$b58c4be94c1619ca).ExceededMaxLength:
                return t("customSignatureError.exceedsMaxLength", {
                    replace: {
                        overLimitAmount: signatureInputText.length - (0, $d50f52fc18ffa921$export$6bcdc49eab1cd857)
                    }
                });
        }
    };
const $d3c3b5d7e6f92cf0$export$a942d43ed793e30d = (t)=>(signatureText)=>{
        return t("customSignatureHelper", {
            replace: {
                charactersLeft: (0, $d50f52fc18ffa921$export$6bcdc49eab1cd857) - signatureText.length
            }
        });
    };
const $d3c3b5d7e6f92cf0$export$44fc99b272868206 = (t)=>(signatureText)=>signatureText || t("emptySignaturePlaceholder");


function $7079a22d48a3517c$export$10055180eae25861({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "cardCustomization"
    });
    const mapToProps = ({ state: state, dispatch: dispatch })=>({
            businessName: state.businessName,
            loading: state.cardCustomizationState.loading,
            customizeSignatureActive: state.cardCustomizationState.toggleCustomSignature,
            customSignatureInputError: (0, $d3c3b5d7e6f92cf0$export$e0eaa81363ef94db)(t)(state.cardCustomizationState.customSignatureInputError, state.cardCustomizationState.signatureInputText),
            customSignatureInputHelper: (0, $d3c3b5d7e6f92cf0$export$a942d43ed793e30d)(t)(state.cardCustomizationState.signatureText),
            signatureInputText: state.cardCustomizationState.signatureInputText,
            signatureText: (0, $d3c3b5d7e6f92cf0$export$44fc99b272868206)(t)(state.cardCustomizationState.signatureInputText),
            selectedFontFamily: state.cardCustomizationState.signatureFont,
            fontFamilies: (0, $8ac095e22cd80964$export$970f1491a494c331),
            onCustomizeSignatureToggle: (value)=>dispatch((0, $d50f52fc18ffa921$export$74d52cff822ce1fe)(value)),
            onNextClick: ()=>dispatch((0, $d50f52fc18ffa921$export$69864c1ae20800a8)()),
            onSignatureFontChange: (signatureFont)=>dispatch((0, $d50f52fc18ffa921$export$817cb1cc86775b9b)(signatureFont)),
            onSignatureTextChange: (signatureInputText)=>dispatch((0, $d50f52fc18ffa921$export$22e3bdf54f208610)(signatureInputText))
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76f6a20479f97bf3$export$4eecc657670f7f54), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}












const $ca1292c5dc2fbd33$export$e41c4cad2141beb = (callback)=>(event)=>{
        callback(event.detail.value);
    };
const $ca1292c5dc2fbd33$export$7e6c12e5558cec76 = (callback)=>(event)=>{
        callback?.(event.detail);
    };
const $ca1292c5dc2fbd33$export$f61b557f7731a103 = (callback)=>(event)=>{
        callback(event.detail.code);
    };
const $ca1292c5dc2fbd33$export$3a4e95f5f650d5aa = (callback)=>(_event)=>{
        callback?.();
    };


function $3517bb91938c0291$export$d55b50a564d0b931({ value: value, name: name, label: label, listRows: listRows, className: className, disabled: disabled = false, error: error, readonly: readonly = false, onSelectChange: onSelectChange }) {
    const onMarketSelectValueDidChange = (0, $ca1292c5dc2fbd33$export$7e6c12e5558cec76)(onSelectChange);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$bf9d3c0d17a2f99e), {
        className: className,
        name: name,
        invalid: Boolean(error),
        // TODO(cvu): this is a dumb hack because disabled="false" prevents the input field from being editable
        // TODO(cvu): file a bug with the market team
        disabled: disabled,
        readonly: readonly,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$29823418345456dd), {
            onMarketSelectValueDidChange: onMarketSelectValueDidChange,
            value: value,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$5f38cc4b3e71c577), {
                    slot: "list",
                    children: listRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                    slot: "error",
                    children: error
                })
            ]
        })
    });
}



/**
 * NOTE(cvu): COPIED FROM @banking DASHBOARD. DO NOT EDIT
 */ 
class $0d407af57388fa01$export$2e2bcd8739ae039 extends (0, $58cb02b9641cce25$exports.DelimitedTextFormatter) {
    constructor(){
        super("-", /* isLazy = */ true);
        this.maximumLength = 10;
    }
    hasDelimiterAtIndex(index) {
        return index === 5;
    }
    format(str) {
        if (/\d{5}-\d{4}/.test(str)) return super.format(str.replace(/-/, ""));
        return super.format(str);
    }
    isChangeValid(change, error) {
        if (/^\d*$/.test(change.inserted.text)) return super.isChangeValid(change, error);
        else return false;
    }
}


function $7da9a08062adf300$export$73974d1f547d9d48({ administrativeDistrictLevelOneList: administrativeDistrictLevelOneList, addressLineOne: addressLineOne, addressLineOneError: addressLineOneError, addressLineTwo: addressLineTwo, locality: locality, localityError: localityError, administrativeDistrictLevelOne: administrativeDistrictLevelOne, administrativeDistrictLevelOneError: administrativeDistrictLevelOneError, postalCode: postalCode, postalCodeError: postalCodeError, onAddressLineOneChange: onAddressLineOneChange, onAddressLineTwoChange: onAddressLineTwoChange, onLocalityChange: onLocalityChange, onAdministrativeDistrictLevelOneChange: onAdministrativeDistrictLevelOneChange, onPostalCodeChange: onPostalCodeChange }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("components", {
        keyPrefix: "address"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "market-grid-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "addressLineOne",
                label: t("label.addressLine1"),
                className: "market-grid-item-full",
                value: addressLineOne,
                error: addressLineOneError,
                onTextChange: onAddressLineOneChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "addressLineTwo",
                label: t("label.addressLine2"),
                className: "market-grid-item-full",
                value: addressLineTwo,
                onTextChange: onAddressLineTwoChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "locality",
                label: t("label.locality"),
                className: "market-grid-item-full",
                value: locality,
                error: localityError,
                onTextChange: onLocalityChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3517bb91938c0291$export$d55b50a564d0b931), {
                name: "administrativeDistrictLevelOne",
                label: t("label.administrativeDistrictLevel1"),
                listRows: administrativeDistrictLevelOneList.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
                        value: district,
                        children: district
                    }, district)),
                className: "market-grid-item-medium",
                value: administrativeDistrictLevelOne,
                error: administrativeDistrictLevelOneError,
                onSelectChange: onAdministrativeDistrictLevelOneChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "postalCode",
                label: t("label.postalCode"),
                className: "market-grid-item-medium",
                formatter: new (0, $0d407af57388fa01$export$2e2bcd8739ae039)(),
                value: postalCode,
                error: postalCodeError,
                onTextChange: onPostalCodeChange
            })
        ]
    });
}



function $6b060c5e2a8b2d89$export$4b61e541da9ec969({ administrativeDistrictLevelOneList: administrativeDistrictLevelOneList, addressLineOne: addressLineOne, addressLineOneError: addressLineOneError, addressLineTwo: addressLineTwo, loading: loading, locality: locality, localityError: localityError, administrativeDistrictLevelOne: administrativeDistrictLevelOne, administrativeDistrictLevelOneError: administrativeDistrictLevelOneError, postalCode: postalCode, postalCodeError: postalCodeError, onAddressLineOneChange: onAddressLineOneChange, onAddressLineTwoChange: onAddressLineTwoChange, onLocalityChange: onLocalityChange, onAdministrativeDistrictLevelOneChange: onAdministrativeDistrictLevelOneChange, onPostalCodeChange: onPostalCodeChange, onNextClick: onNextClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "shippingAddress"
    });
    const buttons = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
            rank: "primary",
            isLoading: loading,
            onClick: onNextClick,
            children: t("buttonContinueTitle")
        }, t("buttonContinueTitle"))
    ];
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7da9a08062adf300$export$73974d1f547d9d48), {
            administrativeDistrictLevelOneList: administrativeDistrictLevelOneList,
            addressLineOne: addressLineOne,
            addressLineOneError: addressLineOneError,
            addressLineTwo: addressLineTwo,
            locality: locality,
            localityError: localityError,
            administrativeDistrictLevelOne: administrativeDistrictLevelOne,
            administrativeDistrictLevelOneError: administrativeDistrictLevelOneError,
            postalCode: postalCode,
            postalCodeError: postalCodeError,
            onAddressLineOneChange: onAddressLineOneChange,
            onAddressLineTwoChange: onAddressLineTwoChange,
            onLocalityChange: onLocalityChange,
            onAdministrativeDistrictLevelOneChange: onAdministrativeDistrictLevelOneChange,
            onPostalCodeChange: onPostalCodeChange
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77a799ee7a5a2b82$export$a98515d67472a41f), {
        buttons: buttons,
        content: content,
        title: t("title")
    });
}





const $95fea94033a7ccce$export$375b49718dbd9ced = (t)=>(field, validationRecord)=>{
        if (validationRecord.valid) return "";
        switch(validationRecord.errors[field][0]){
            case (0, $a4c47930ee9facdd$export$804a92ba667853be).Empty:
                return t(`shippingAddress.errors.emptyField`, {
                    ns: "card-issuing",
                    replace: {
                        field: t(`address.label.${field}`, {
                            ns: "components"
                        })
                    }
                });
            case (0, $a9356ac90e965f5c$export$74e717fd56f132db).Invalid:
                return t(`shippingAddress.errors.invalidPostalCode`, {
                    ns: "card-issuing",
                    replace: {
                        field: t(`address.label.${field}`, {
                            ns: "components"
                        })
                    }
                });
        }
    };
function $95fea94033a7ccce$export$e6c073bff812bf4e({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getErrorStringFunc = $95fea94033a7ccce$export$375b49718dbd9ced(t);
    const mapToProps = ({ state: state, dispatch: dispatch })=>({
            administrativeDistrictLevelOneList: state.cardShippingState.countryAddressData ? (0, $a4c47930ee9facdd$export$7b943f50522d3fc4)(state.cardShippingState.countryAddressData) : [],
            addressLineOne: state.cardShippingState.address.addressLine1,
            addressLineOneError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AddressLine1, state.cardShippingState.validation),
            addressLineTwo: state.cardShippingState.address.addressLine2,
            loading: state.cardShippingState.loading || state.loading,
            locality: state.cardShippingState.address.locality,
            localityError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).Locality, state.cardShippingState.validation),
            administrativeDistrictLevelOne: state.cardShippingState.address.administrativeDistrictLevel1,
            administrativeDistrictLevelOneError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AdministrativeDistrictLevel1, state.cardShippingState.validation),
            postalCode: state.cardShippingState.address.postalCode,
            postalCodeError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).PostalCode, state.cardShippingState.validation),
            onAddressLineOneChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AddressLine1, value)),
            onAddressLineTwoChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AddressLine2, value)),
            onLocalityChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).Locality, value)),
            onAdministrativeDistrictLevelOneChange: ({ value: value })=>{
                // Value can string or array of any value. Asserting to ensure the value is a string
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(typeof value === "string", "Market select value is not a string");
                dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AdministrativeDistrictLevel1, value));
            },
            onPostalCodeChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).PostalCode, value)),
            onNextClick: ()=>dispatch((0, $a4c47930ee9facdd$export$848ce7d6602fe3bd)())
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b060c5e2a8b2d89$export$4b61e541da9ec969), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}







var $2fa5cd385f265c4c$export$2ba01fb71ed41cb6;
var $2fa5cd385f265c4c$export$34e0f9847d4c02dd;
var $2fa5cd385f265c4c$export$6d59db4903f20f7d;
var $2fa5cd385f265c4c$export$38e42c68cf43b5d4;
var $2fa5cd385f265c4c$export$79b7ea2066c6e4f9;
var $2fa5cd385f265c4c$export$c96745152eb2740f;
$2fa5cd385f265c4c$export$2ba01fb71ed41cb6 = `GdpZFa_CardOrderedConfirmation_button`;
$2fa5cd385f265c4c$export$34e0f9847d4c02dd = `GdpZFa_CardOrderedConfirmation_container`;
$2fa5cd385f265c4c$export$6d59db4903f20f7d = `GdpZFa_CardOrderedConfirmation_description`;
$2fa5cd385f265c4c$export$38e42c68cf43b5d4 = `GdpZFa_CardOrderedConfirmation_header`;
$2fa5cd385f265c4c$export$79b7ea2066c6e4f9 = `GdpZFa_CardOrderedConfirmation_subtext`;
$2fa5cd385f265c4c$export$c96745152eb2740f = `GdpZFa_CardOrderedConfirmation_subtitle`;


// TODO(cvu): pass card customization into this svg via prop

function $0a88d3f9b6a1b5a9$export$b5be2bc9038e471b() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "364",
        height: "245",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                xmlns: "http://www.w3.org/2000/svg",
                id: "c",
                clipRule: "evenodd",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "244",
                    height: "244",
                    x: "54.5",
                    y: ".5",
                    fill: "#fff",
                    fillOpacity: ".01",
                    rx: "122"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "244",
                height: "244",
                x: "54.5",
                y: ".5",
                fill: "#000",
                fillOpacity: ".04",
                rx: "122"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "244",
                height: "244",
                x: "54.5",
                y: ".5",
                fill: "url(#a)",
                fillOpacity: ".2",
                rx: "122"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "#006AFF",
                strokeLinecap: "round",
                strokeWidth: "3.17",
                d: "M115.713 107.915H10.864M115.713 107.915H10.864M141.988 107.915h-18.726"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#c)",
                filter: "url(#b)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "200",
                        height: "124.198",
                        x: "142.5",
                        y: "60.5",
                        fill: "#fff",
                        rx: "4.665"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#F1F3F5",
                        fillRule: "evenodd",
                        d: "M308.166 70.053a3.881 3.881 0 0 0-3.881 3.88v20.9a3.881 3.881 0 0 0 3.881 3.88h20.899a3.88 3.88 0 0 0 3.881-3.88v-20.9a3.88 3.88 0 0 0-3.881-3.88h-20.899Zm2.687 5.374c-.659 0-1.194.534-1.194 1.194v15.525c0 .66.535 1.194 1.194 1.194h15.525c.66 0 1.194-.535 1.194-1.194V76.62c0-.66-.534-1.194-1.194-1.194h-15.525Zm4.479 4.777a.896.896 0 0 0-.896.896v6.568c0 .495.401.896.896.896h6.568a.896.896 0 0 0 .896-.896V81.1a.896.896 0 0 0-.896-.895h-6.568Z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "url(#d)",
                        fillOpacity: ".3",
                        fillRule: "evenodd",
                        d: "M308.166 70.053a3.881 3.881 0 0 0-3.881 3.88v20.9a3.881 3.881 0 0 0 3.881 3.88h20.899a3.88 3.88 0 0 0 3.881-3.88v-20.9a3.88 3.88 0 0 0-3.881-3.88h-20.899Zm2.687 5.374c-.659 0-1.194.534-1.194 1.194v15.525c0 .66.535 1.194 1.194 1.194h15.525c.66 0 1.194-.535 1.194-1.194V76.62c0-.66-.534-1.194-1.194-1.194h-15.525Zm4.479 4.777a.896.896 0 0 0-.896.896v6.568c0 .495.401.896.896.896h6.568a.896.896 0 0 0 .896-.896V81.1a.896.896 0 0 0-.896-.895h-6.568Z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "url(#e)",
                        d: "M162.802 102.297h23.884v18.48h-23.884z",
                        opacity: ".8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#101314",
                        d: "M252.603 175.199v-6.219h.841v6.219h-.841Zm-2.016-5.923v-.764h4.873v.764h-4.873Zm7.317 6.019c-.452 0-.85-.109-1.194-.325a2.224 2.224 0 0 1-.784-.908 3.017 3.017 0 0 1-.277-1.309c0-.515.093-.974.277-1.375.185-.408.446-.73.784-.965a1.997 1.997 0 0 1 1.175-.354c.49 0 .901.109 1.232.325.331.217.58.506.745.87.172.356.258.757.258 1.203v.43h-4.079v-.64h3.583l-.287.048c-.006-.471-.14-.847-.401-1.127-.261-.281-.612-.421-1.051-.421-.299 0-.557.077-.774.229a1.377 1.377 0 0 0-.497.65c-.114.287-.172.637-.172 1.051l-.009.096c0 .388.067.719.2.993.134.268.312.475.535.621.23.14.475.21.736.21.318 0 .58-.063.783-.191.211-.133.376-.321.497-.563h.803a2.1 2.1 0 0 1-.793 1.07c-.37.254-.8.382-1.29.382Zm3.303-.096v-6.993H262v6.993h-.793Zm3.789.096c-.357 0-.675-.064-.955-.191a1.634 1.634 0 0 1-.66-.545 1.7 1.7 0 0 1-.286-.841h.774c.051.262.165.478.343.65.185.166.446.248.784.248.337 0 .611-.073.822-.219a.688.688 0 0 0 .315-.593c0-.248-.083-.43-.249-.544-.159-.121-.372-.204-.64-.249l-.707-.124a2.003 2.003 0 0 1-.678-.248 1.394 1.394 0 0 1-.487-.478 1.36 1.36 0 0 1-.172-.697c0-.281.076-.526.229-.736.159-.21.373-.373.64-.487.274-.121.58-.182.917-.182.491 0 .898.121 1.223.363.331.236.532.58.602 1.032h-.745a.859.859 0 0 0-.373-.535 1.243 1.243 0 0 0-.716-.2c-.3 0-.548.063-.745.191a.607.607 0 0 0-.287.535c0 .439.322.716.965.831l.659.114c.376.064.691.204.946.421.255.21.382.532.382.965 0 .293-.08.554-.239.783a1.634 1.634 0 0 1-.669.545 2.426 2.426 0 0 1-.993.191Zm5.056 0c-.484 0-.898-.112-1.241-.335a2.23 2.23 0 0 1-.793-.936 3.23 3.23 0 0 1-.268-1.347c0-.382.051-.732.153-1.051.102-.318.251-.592.449-.821.204-.236.446-.418.726-.545.287-.134.611-.201.974-.201.485 0 .899.115 1.242.344.344.223.606.532.784.927.185.388.277.838.277 1.347 0 .382-.051.732-.153 1.051a2.353 2.353 0 0 1-.459.831 2.137 2.137 0 0 1-.726.545c-.28.127-.601.191-.965.191Zm0-.717c.3 0 .561-.073.784-.22.223-.146.398-.359.525-.64.128-.286.191-.633.191-1.041 0-.611-.14-1.08-.42-1.404-.274-.332-.634-.497-1.08-.497a1.42 1.42 0 0 0-.783.22 1.456 1.456 0 0 0-.525.649c-.128.28-.191.624-.191 1.032 0 .611.136 1.083.41 1.414.281.325.644.487 1.089.487Zm3.396.621v-5.044h.716v.793h.077c.127-.249.315-.459.564-.631.254-.172.579-.258.974-.258.573 0 .997.172 1.271.516.28.338.42.806.42 1.405v3.219h-.793v-3.143c0-.471-.099-.802-.296-.994-.198-.191-.462-.286-.793-.286-.433 0-.768.143-1.003.43-.229.28-.344.646-.344 1.098v2.895h-.793Zm10.746.096c-.573 0-1.079-.14-1.519-.421a2.916 2.916 0 0 1-1.041-1.184c-.248-.516-.373-1.128-.373-1.835 0-.528.07-1.003.211-1.423.146-.427.35-.79.611-1.089.261-.3.57-.529.927-.688a2.92 2.92 0 0 1 1.184-.239c.51 0 .946.086 1.309.258.37.172.666.411.889.717.223.305.369.659.439 1.06h-.86c-.102-.414-.302-.729-.602-.946-.293-.216-.684-.325-1.175-.325-.293 0-.57.061-.831.182a1.917 1.917 0 0 0-.669.535 2.624 2.624 0 0 0-.439.841 3.532 3.532 0 0 0-.162 1.117c0 .555.092 1.032.277 1.433.184.402.436.711.754.927.319.21.675.315 1.07.315.484 0 .873-.114 1.166-.343.293-.23.516-.545.669-.946h.831a2.757 2.757 0 0 1-.917 1.49c-.459.376-1.042.564-1.749.564Zm5.824 0c-.484 0-.898-.112-1.242-.335a2.237 2.237 0 0 1-.793-.936 3.245 3.245 0 0 1-.267-1.347c0-.382.051-.732.153-1.051.102-.318.251-.592.449-.821.204-.236.446-.418.726-.545a2.27 2.27 0 0 1 .974-.201c.484 0 .898.115 1.242.344.344.223.605.532.784.927.184.388.277.838.277 1.347 0 .382-.051.732-.153 1.051a2.353 2.353 0 0 1-.459.831 2.137 2.137 0 0 1-.726.545c-.28.127-.602.191-.965.191Zm0-.717c.3 0 .561-.073.784-.22.223-.146.398-.359.525-.64.127-.286.191-.633.191-1.041 0-.611-.14-1.08-.42-1.404-.274-.332-.634-.497-1.08-.497-.293 0-.554.073-.783.22a1.464 1.464 0 0 0-.526.649c-.127.28-.191.624-.191 1.032 0 .611.137 1.083.411 1.414.28.325.643.487 1.089.487Zm3.396.621v-5.044h.716v.793h.077a1.71 1.71 0 0 1 .563-.631c.255-.172.58-.258.975-.258.573 0 .997.172 1.27.516.281.338.421.806.421 1.405v3.219h-.793v-3.143c0-.471-.099-.802-.296-.994-.198-.191-.462-.286-.793-.286-.433 0-.768.143-1.003.43-.23.28-.344.646-.344 1.098v2.895h-.793Zm7.037 0c-.433 0-.761-.143-.984-.43-.223-.286-.334-.672-.334-1.156v-4.643h.793v4.643c0 .293.06.513.181.66.128.14.303.21.526.21h.64v.716h-.822Zm-2.216-4.375v-.669h3.038v.669h-3.038Zm4.07 4.375v-5.044h.717v.879h.076c.07-.28.229-.497.478-.65.254-.153.554-.229.898-.229h.477v.716h-.582c-.363 0-.666.134-.908.402-.242.267-.363.633-.363 1.098v2.828h-.793Zm4.873.096c-.478 0-.86-.137-1.147-.411-.28-.28-.42-.634-.42-1.061 0-.471.159-.831.477-1.079.325-.255.749-.401 1.271-.44l1.357-.095v-.583a.897.897 0 0 0-.124-.478.79.79 0 0 0-.363-.305 1.45 1.45 0 0 0-.583-.105c-.274 0-.507.063-.698.191a.884.884 0 0 0-.382.554h-.802c.044-.287.153-.535.324-.745a1.65 1.65 0 0 1 .66-.497c.274-.121.573-.182.898-.182.395 0 .729.058 1.003.172.28.115.493.287.64.516.146.223.22.5.22.831v3.621h-.717v-.821h-.076a1.501 1.501 0 0 1-.593.678 1.813 1.813 0 0 1-.945.239Zm.181-.688c.261 0 .494-.064.698-.191.203-.128.363-.306.477-.535.121-.229.182-.494.182-.793v-.277l-1.194.086c-.37.025-.644.118-.822.277a.778.778 0 0 0-.258.611c0 .236.08.433.239.593.159.152.385.229.678.229Zm5.526.688c-.471 0-.879-.115-1.223-.344a2.272 2.272 0 0 1-.783-.936 3.162 3.162 0 0 1-.277-1.338c0-.497.092-.943.277-1.337.185-.395.446-.707.783-.937.344-.229.752-.344 1.223-.344.567 0 1.032.137 1.395.411.363.274.583.656.659 1.147h-.793a1.142 1.142 0 0 0-.439-.612c-.204-.153-.478-.229-.822-.229-.28 0-.535.079-.764.239a1.529 1.529 0 0 0-.526.659c-.127.28-.191.615-.191 1.003 0 .58.14 1.041.421 1.385.28.344.633.516 1.06.516.338 0 .608-.083.812-.248a1.53 1.53 0 0 0 .459-.612h.793c-.089.332-.23.615-.421.851a1.834 1.834 0 0 1-.697.544 2.32 2.32 0 0 1-.946.182Zm4.845-.096c-.433 0-.761-.143-.984-.43-.223-.286-.334-.672-.334-1.156v-4.643h.792v4.643c0 .293.061.513.182.66.127.14.303.21.525.21h.641v.716h-.822Zm-2.217-4.375v-.669h3.039v.669h-3.039Zm6.087 4.471c-.484 0-.898-.112-1.242-.335a2.23 2.23 0 0 1-.793-.936 3.23 3.23 0 0 1-.268-1.347c0-.382.051-.732.153-1.051.102-.318.252-.592.449-.821.204-.236.446-.418.726-.545.287-.134.612-.201.975-.201.484 0 .898.115 1.242.344.344.223.605.532.783.927.185.388.277.838.277 1.347 0 .382-.051.732-.153 1.051a2.367 2.367 0 0 1-.458.831c-.198.229-.44.411-.726.545a2.318 2.318 0 0 1-.965.191Zm0-.717c.299 0 .56-.073.783-.22.223-.146.398-.359.525-.64.128-.286.192-.633.192-1.041 0-.611-.141-1.08-.421-1.404-.274-.332-.634-.497-1.079-.497a1.42 1.42 0 0 0-.784.22 1.456 1.456 0 0 0-.525.649c-.128.28-.191.624-.191 1.032 0 .611.137 1.083.41 1.414.281.325.644.487 1.09.487Zm3.395.621v-5.044h.717v.879h.076c.07-.28.229-.497.478-.65.254-.153.554-.229.898-.229h.477v.716h-.582c-.363 0-.666.134-.908.402-.242.267-.363.633-.363 1.098v2.828h-.793Zm5.198.096c-.357 0-.676-.064-.956-.191a1.631 1.631 0 0 1-.659-.545 1.701 1.701 0 0 1-.287-.841h.774c.051.262.166.478.344.65.185.166.446.248.784.248.337 0 .611-.073.821-.219a.688.688 0 0 0 .315-.593c0-.248-.082-.43-.248-.544-.159-.121-.373-.204-.64-.249l-.707-.124a1.995 1.995 0 0 1-.678-.248 1.397 1.397 0 0 1-.488-.478 1.37 1.37 0 0 1-.172-.697c0-.281.077-.526.23-.736a1.54 1.54 0 0 1 .64-.487c.274-.121.579-.182.917-.182.49 0 .898.121 1.223.363.331.236.532.58.602 1.032h-.745a.863.863 0 0 0-.373-.535 1.246 1.246 0 0 0-.717-.2c-.299 0-.547.063-.745.191a.606.606 0 0 0-.286.535c0 .439.321.716.965.831l.659.114c.376.064.691.204.946.421.254.21.382.532.382.965 0 .293-.08.554-.239.783a1.634 1.634 0 0 1-.669.545 2.433 2.433 0 0 1-.993.191Z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: "#000",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "5",
                        strokeOpacity: ".9",
                        strokeWidth: "1.194",
                        d: "m228.081 130.83-.262 28.505m5.411-17.66c.266 4.51-4.625 6.204-8.292 7.883v.089c5.762 1.327 12.856 3.008 17.021 7.518m-2.855-11.36c-2.161-.718-5.225 6.254-2.465 6.421 2.007.084 2.203-3.808 2.661-5.441-1.145 2.236.775 9.764 4.068 1.414-2.332 2.19 3.566 11.224 5.495-8.079-.529 5.618-1.031 9.165 1.227 11.501 1.923 2.003 4.882 1.073 5.45-1.315 1.894-7.963.584-18.025-.985-17.894-1.572.132-2.62 9.015-.855 16.142.559 2.257 2.007 4.506 4.684 4.923 3.011.501 2.676-2.503 3.513-4.34.251 1.085.251 2.42 1.589 2.587 1.504.25 1.923-2.003 2.927-2.003.418 0 .837.835 1.255.919.67.25.753-.084 1.421-.334 4.014-1.251 3.623-.013 7.805-.013m-31.64-3.157c2.927-.501 5.855-.752 8.866-.835m28.785-8.155c1.593-3.073-4.672-2.649-5.841-.318-2.655 5.299 7.647 9.431 8.921 13.881 1.912 6.675-9.983 6.887-13.699 4.344-2.336-1.696-.425-2.755 1.698-3.39m17.58.123c1.364.164 6.852.305 8.028-3.278 1.162-3.544-6.914-2.447-9.468-1.399-.829.341-2.627 1.133-2.575 2.468.108 2.754 7.528 2.622 11.413 1.62 3.886-1.002 4.796-1.95 5.25-2.937-.984.164-1.06 2.222-.303 2.88.985.823 1.364-.494 1.969-1.235.151.659.303 1.235.606 1.81.757-.576 1.136-2.057 2.197-1.974.909 0 .808 1.049 1.717 1.131.833.082 1.637-2.244 4.648-2.112-1.703-.327-4.91 1.764-2.749 2.483 2.291.587 2.669-1.913 2.972-2.901.304-1.069 1.364-8.052.151-8.875-.908-.576-1.06 1.153-1.136 1.893-.227 2.304.531 6.489 2.046 8.217 1.514 1.809 5.377 2.468 6.666-.33.985-2.222-1.743-3.538-2.046-1.069-.606 4.689 4.571 3.047 6.194 1.601 2.751-2.45 2.259-17.435.458-17.541-1.635-.097-5.008 19.109 7.366 20.676m-45.677-3.952c-1.066 3.282.685 10.351 2.578 12.079 0 0 .131-5.357-2.128-8.264m15.229-7.395c.075-.082.075-.247.075-.412m-61.264-1.464c.075-.082.075-.246.075-.412"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "200.583",
                        height: "124.781",
                        x: "142.208",
                        y: "60.209",
                        stroke: "url(#f)",
                        strokeOpacity: ".05",
                        strokeWidth: ".583",
                        rx: "4.956"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "#006AFF",
                strokeLinecap: "round",
                strokeWidth: "3.17",
                d: "M6.962 130.54h2.669M18.64 130.54h11.427M40.535 130.54h89.522M6.962 130.54h2.669M18.64 130.54h11.427M40.535 130.54h89.522M69.73 152.437h7.778M28.128 152.437h33.323M85.787 152.437h90.251"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                filter: "url(#g)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "244",
                    height: "244",
                    x: "54.5",
                    y: ".5",
                    fill: "#fff",
                    fillOpacity: ".01",
                    rx: "122"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "a",
                        x1: "176.5",
                        x2: "176.5",
                        y1: ".5",
                        y2: "244.5",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopOpacity: ".05"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "f",
                        x1: "242.5",
                        x2: "242.5",
                        y1: "60.5",
                        y2: "184.698",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopOpacity: ".14"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                        id: "b",
                        width: "227.166",
                        height: "172.365",
                        x: "128.917",
                        y: "57.916",
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect1_dropShadow_2547_130233",
                                result: "effect2_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "8"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect2_dropShadow_2547_130233",
                                result: "effect3_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "18"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "5.5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect3_dropShadow_2547_130233",
                                result: "effect4_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "32"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "6.5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect4_dropShadow_2547_130233",
                                result: "effect5_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect5_dropShadow_2547_130233",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                        id: "g",
                        width: "256",
                        height: "244",
                        x: "42.5",
                        y: ".5",
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dx: "-12"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "6.5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                k2: "-1",
                                k3: "1",
                                operator: "arithmetic"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_2547_130233"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                        id: "d",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientTransform: "rotate(45 67.581 402.33) scale(40.533)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pattern", {
                        id: "e",
                        width: "1",
                        height: "1",
                        patternContentUnits: "objectBoundingBox",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                            xlinkHref: "#h",
                            transform: "scale(.0073 .00943)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                        xlinkHref: "data:image/png;base64,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",
                        id: "h",
                        width: "137",
                        height: "106"
                    })
                ]
            })
        ]
    });
}



function $fbe5020f1b3e8361$export$35d0ea5f90a48237({ estimateArrivalDate: estimateArrivalDate, onDoneClick: onDoneClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "cardConfirmation"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: (0, $2fa5cd385f265c4c$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, $2fa5cd385f265c4c$export$38e42c68cf43b5d4),
                children: t("title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a88d3f9b6a1b5a9$export$b5be2bc9038e471b), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $2fa5cd385f265c4c$export$6d59db4903f20f7d),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: (0, $2fa5cd385f265c4c$export$c96745152eb2740f),
                        children: t("subtitle")
                    }),
                    estimateArrivalDate.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $2fa5cd385f265c4c$export$79b7ea2066c6e4f9), "paragraph-20"),
                        children: t("estimateArrivalText", {
                            replace: {
                                estimateArrivalDate: estimateArrivalDate
                            }
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                className: (0, $2fa5cd385f265c4c$export$2ba01fb71ed41cb6),
                rank: "primary",
                onClick: onDoneClick,
                children: t("doneButtonText")
            })
        ]
    });
}


function $9faa4f23fc8da724$export$69dff73d12ee9b83({ dispatch: dispatch }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe5020f1b3e8361$export$35d0ea5f90a48237), {
        cardCustomization: "",
        estimateArrivalDate: "",
        onDoneClick: ()=>dispatch((0, $b2490fa107d6478d$export$848ce7d6602fe3bd)())
    });
}










var $ea9696031b0ed501$exports = {};

$parcel$export($ea9696031b0ed501$exports, "description", () => $ea9696031b0ed501$export$6d59db4903f20f7d, (v) => $ea9696031b0ed501$export$6d59db4903f20f7d = v);
$parcel$export($ea9696031b0ed501$exports, "inputFields", () => $ea9696031b0ed501$export$2daf5cbeed728edf, (v) => $ea9696031b0ed501$export$2daf5cbeed728edf = v);
var $ea9696031b0ed501$export$6d59db4903f20f7d;
var $ea9696031b0ed501$export$2daf5cbeed728edf;
$ea9696031b0ed501$export$6d59db4903f20f7d = `HvIZVq_VerifyName_description`;
$ea9696031b0ed501$export$2daf5cbeed728edf = `HvIZVq_VerifyName_inputFields`;



function $ed393ea70cbc6d28$export$f9233de0a874ce72({ firstName: firstName, firstNameError: firstNameError, lastName: lastName, lastNameError: lastNameError, loading: loading, onFirstNameChange: onFirstNameChange, onLastNameChange: onLastNameChange, onNextClick: onNextClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "verifyName"
    });
    const button = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
            rank: "primary",
            isLoading: loading,
            onClick: onNextClick,
            children: t("buttonText")
        }, t("buttonText"))
    ];
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ea9696031b0ed501$exports))).description, "paragraph-30"),
                children: t("description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ea9696031b0ed501$exports))).inputFields,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                        name: "firsName",
                        label: t("firstName.label"),
                        className: "market-grid-item-full",
                        value: firstName,
                        error: firstNameError,
                        onTextChange: onFirstNameChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                        name: "lastName",
                        label: t("lastName.label"),
                        className: "market-grid-item-full",
                        value: lastName,
                        error: lastNameError,
                        onTextChange: onLastNameChange
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77a799ee7a5a2b82$export$a98515d67472a41f), {
        buttons: button,
        content: content,
        title: t("title")
    });
}


const $95484e46f870a5c7$export$375b49718dbd9ced = (t)=>(field, validationRecord)=>{
        if (validationRecord.valid) return "";
        switch(validationRecord.errors[field][0]){
            case (0, $c27a3102df5220b7$export$e4493d7100331504).VERIFY_NAME_ERROR_EMPTY:
                return t(`${field}.error.empty`);
        }
    };
function $95484e46f870a5c7$export$83868f3de121e0f3({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "verifyName"
    });
    const getErrorStringFunc = $95484e46f870a5c7$export$375b49718dbd9ced(t);
    const mapToProps = ({ state: state, dispatch: dispatch })=>({
            firstName: state.verifyNameState[(0, $c27a3102df5220b7$export$a455218a85c89869).FirstName],
            firstNameError: getErrorStringFunc((0, $c27a3102df5220b7$export$a455218a85c89869).FirstName, state.verifyNameState.validation),
            lastName: state.verifyNameState[(0, $c27a3102df5220b7$export$a455218a85c89869).LastName],
            lastNameError: getErrorStringFunc((0, $c27a3102df5220b7$export$a455218a85c89869).LastName, state.verifyNameState.validation),
            loading: state.verifyNameState.loading,
            onFirstNameChange: (value)=>dispatch((0, $c27a3102df5220b7$export$49d8151683dabb69)((0, $c27a3102df5220b7$export$a455218a85c89869).FirstName, value)),
            onLastNameChange: (value)=>dispatch((0, $c27a3102df5220b7$export$49d8151683dabb69)((0, $c27a3102df5220b7$export$a455218a85c89869).LastName, value)),
            onNextClick: ()=>dispatch((0, $c27a3102df5220b7$export$69864c1ae20800a8)())
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed393ea70cbc6d28$export$f9233de0a874ce72), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}



parcelRequire("acw62");
const $336d8037eb9512f1$var$SvgActionX = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M1.71 13.71 7 8.41l5.29 5.3 1.42-1.42L8.41 7l5.3-5.29L12.29.29 7 5.59 1.71.29.29 1.71 5.59 7l-5.3 5.29z"
        })
    });
var $336d8037eb9512f1$export$2e2bcd8739ae039 = $336d8037eb9512f1$var$SvgActionX;



parcelRequire("acw62");
const $6c454853b38ed92b$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M.293 7.293a1 1 0 0 0 0 1.414l7 7 1.414-1.414L3.414 9H15V7H3.414l5.293-5.293L7.293.293z",
            clipRule: "evenodd"
        })
    });
var $6c454853b38ed92b$export$2e2bcd8739ae039 = $6c454853b38ed92b$var$SvgArrowLeft;





/**
 * Market considers modals (full and partial), dialog and blade as DialogElements.
 */ 

var $acw62 = parcelRequire("acw62");
const $c552822fec5ee486$export$db7975a4146cc3db = (Component)=>{
    // TODO(cvu): decide if we should disable this for the whole project later
    // eslint-disable-next-line react/display-name
    return ({ active: active, onActiveChange: onActiveChange, children: children })=>{
        const [_active, setActive] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            setActive(active ?? false);
        }, [
            active
        ]);
        (0, $acw62.useEffect)(()=>{
            if (onActiveChange) onActiveChange(_active);
        }, [
            _active
        ]);
        const onMarketDialogDismissed = ()=>{
            setActive(false);
        };
        return _active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            onMarketDialogDismissed: onMarketDialogDismissed,
            children: children
        }) : null;
    };
};


const $c5c53dc05f5ac83c$export$da81b8c087817043 = (0, $c552822fec5ee486$export$db7975a4146cc3db)((0, $61293f7622d5ba04$export$9be6f02cefaea425));


var $524129e4974f2735$export$a7db06668cad9adb;
var $524129e4974f2735$export$140756403827ba10;
$524129e4974f2735$export$a7db06668cad9adb = `uFNLba_CardIssuingModal_content`;
$524129e4974f2735$export$140756403827ba10 = `uFNLba_CardIssuingModal_navIcon`;


function $e787d7fbfea89ae1$export$433accab5d13d26f({ active: active, isNavButtonVisible: isNavButtonVisible, children: children, IconSVGComponent: IconSVGComponent, onActiveChange: onActiveChange, onNavButtonClick: onNavButtonClick }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c5c53dc05f5ac83c$export$da81b8c087817043), {
        active: active,
        onActiveChange: onActiveChange,
        children: [
            isNavButtonVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                    rank: "secondary",
                    slot: "navigation",
                    onClick: onNavButtonClick,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconSVGComponent, {
                        slot: "icon",
                        className: (0, $524129e4974f2735$export$140756403827ba10)
                    })
                })
            }) : null,
            children
        ]
    });
}





parcelRequire("acw62");
const $cb30999c39860334$var$SvgAlertX = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M0 9a9 9 0 1 1 18.001.001A9 9 0 0 1 0 9m2 0c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7m7-1.41 2.29-2.3 1.42 1.42L10.41 9l2.3 2.29-1.42 1.42L9 10.42l-2.29 2.29-1.42-1.42L7.59 9l-2.3-2.29 1.42-1.42z",
            clipRule: "evenodd"
        })
    });
var $cb30999c39860334$export$2e2bcd8739ae039 = $cb30999c39860334$var$SvgAlertX;



var $2fc14e6bd3984098$exports = {};

$parcel$export($2fc14e6bd3984098$exports, "button", () => $2fc14e6bd3984098$export$2ba01fb71ed41cb6, (v) => $2fc14e6bd3984098$export$2ba01fb71ed41cb6 = v);
$parcel$export($2fc14e6bd3984098$exports, "container", () => $2fc14e6bd3984098$export$34e0f9847d4c02dd, (v) => $2fc14e6bd3984098$export$34e0f9847d4c02dd = v);
$parcel$export($2fc14e6bd3984098$exports, "description", () => $2fc14e6bd3984098$export$6d59db4903f20f7d, (v) => $2fc14e6bd3984098$export$6d59db4903f20f7d = v);
$parcel$export($2fc14e6bd3984098$exports, "grey", () => $2fc14e6bd3984098$export$e4c89085febbc618, (v) => $2fc14e6bd3984098$export$e4c89085febbc618 = v);
$parcel$export($2fc14e6bd3984098$exports, "icon", () => $2fc14e6bd3984098$export$1ca1ec8b29a4ce27, (v) => $2fc14e6bd3984098$export$1ca1ec8b29a4ce27 = v);
$parcel$export($2fc14e6bd3984098$exports, "title", () => $2fc14e6bd3984098$export$fb184b623420d9be, (v) => $2fc14e6bd3984098$export$fb184b623420d9be = v);
var $2fc14e6bd3984098$export$2ba01fb71ed41cb6;
var $2fc14e6bd3984098$export$34e0f9847d4c02dd;
var $2fc14e6bd3984098$export$6d59db4903f20f7d;
var $2fc14e6bd3984098$export$e4c89085febbc618;
var $2fc14e6bd3984098$export$1ca1ec8b29a4ce27;
var $2fc14e6bd3984098$export$fb184b623420d9be;
$2fc14e6bd3984098$export$2ba01fb71ed41cb6 = `yw5C6G_Alert_button`;
$2fc14e6bd3984098$export$34e0f9847d4c02dd = `yw5C6G_Alert_container`;
$2fc14e6bd3984098$export$6d59db4903f20f7d = `yw5C6G_Alert_description`;
$2fc14e6bd3984098$export$e4c89085febbc618 = `yw5C6G_Alert_grey`;
$2fc14e6bd3984098$export$1ca1ec8b29a4ce27 = `yw5C6G_Alert_icon`;
$2fc14e6bd3984098$export$fb184b623420d9be = `yw5C6G_Alert_title`;



var $06f269f6a0cbba3c$export$2ddc1882e756bb44 = /*#__PURE__*/ function(AlertColor) {
    AlertColor["Grey"] = "grey";
    return AlertColor;
}({});
var $06f269f6a0cbba3c$export$4a143c8822a09fb4 = /*#__PURE__*/ function(AlertIcon) {
    AlertIcon["X"] = "X";
    return AlertIcon;
}({});
function $06f269f6a0cbba3c$export$caec2af78bcc877f({ buttonText: buttonText, color: color, description: description, icon: icon, title: title, onButtonClick: onButtonClick }) {
    const getIcon = (icon, color)=>{
        switch(icon){
            case "X":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb30999c39860334$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).icon, (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports)))[color])
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).container,
        children: [
            getIcon(icon, color),
            title?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).title,
                children: title
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            description?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).description,
                children: description
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            buttonText?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                rank: "primary",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).button,
                onClick: onButtonClick,
                children: buttonText
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}



function $51ac4cb382475bb7$export$ea52035eac03daf0({ onButtonClick: onButtonClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site", {
        keyPrefix: "error.flow"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f269f6a0cbba3c$export$caec2af78bcc877f), {
        buttonText: t("buttonText"),
        color: (0, $06f269f6a0cbba3c$export$2ddc1882e756bb44).Grey,
        description: t("description"),
        icon: (0, $06f269f6a0cbba3c$export$4a143c8822a09fb4).X,
        title: t("title"),
        onButtonClick: onButtonClick
    });
}





function $1b1a454b8bd0f7d6$export$c781be0ae6db134e({ onButtonClick: onButtonClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "error.ineligibility"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f269f6a0cbba3c$export$caec2af78bcc877f), {
        buttonText: t("buttonText"),
        color: (0, $06f269f6a0cbba3c$export$2ddc1882e756bb44).Grey,
        description: t("description"),
        icon: (0, $06f269f6a0cbba3c$export$4a143c8822a09fb4).X,
        onButtonClick: onButtonClick
    });
}


function $bd61bc2ba06a0509$export$cee179dbf81603ea({ state: state, dispatch: dispatch }) {
    const getNavIcon = (state)=>(0, $b2490fa107d6478d$export$477b3fce3049067a)(state) ? (0, $336d8037eb9512f1$export$2e2bcd8739ae039) : (0, $6c454853b38ed92b$export$2e2bcd8739ae039);
    const getChildren = (state)=>{
        const { current: current } = state.navigation;
        switch(current){
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).VerifyName:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95484e46f870a5c7$export$83868f3de121e0f3), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7079a22d48a3517c$export$10055180eae25861), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress:
                switch(state.cardShippingState.screen){
                    case (0, $a4c47930ee9facdd$export$a98515d67472a41f).EnterAddress:
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95fea94033a7ccce$export$e6c073bff812bf4e), {
                            state: state,
                            dispatch: dispatch
                        });
                }
                break;
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9faa4f23fc8da724$export$69dff73d12ee9b83), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).Error:
                switch(state.error){
                    case (0, $b2490fa107d6478d$export$99337e8421d6e839).Ineligible:
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b1a454b8bd0f7d6$export$c781be0ae6db134e), {
                            onButtonClick: ()=>dispatch((0, $b2490fa107d6478d$export$2085928ad4455e61)(false))
                        });
                    case (0, $b2490fa107d6478d$export$99337e8421d6e839).Generic:
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ac4cb382475bb7$export$ea52035eac03daf0), {
                            onButtonClick: ()=>dispatch((0, $b2490fa107d6478d$export$2085928ad4455e61)(false))
                        });
                }
        }
    };
    const mapToProps = ({ state: state, dispatch: dispatch })=>{
        return {
            active: state.modalOpen,
            children: getChildren(state),
            IconSVGComponent: getNavIcon(state),
            isNavButtonVisible: (0, $b2490fa107d6478d$export$f3db0dc3a05c157d)(state),
            onActiveChange: (value)=>dispatch((0, $b2490fa107d6478d$export$2085928ad4455e61)(value)),
            onNavButtonClick: (0, $b2490fa107d6478d$export$477b3fce3049067a)(state) ? ()=>dispatch((0, $b2490fa107d6478d$export$34ed016b7ffc8a51)()) : ()=>dispatch((0, $b2490fa107d6478d$export$ecbea34edac74891)())
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e787d7fbfea89ae1$export$433accab5d13d26f), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}




var $acw62 = parcelRequire("acw62");

var $jPIgV = parcelRequire("jPIgV");
parcelRequire("5o0ob");
var $4BZ7p = parcelRequire("4BZ7p");
var $i34zz = parcelRequire("i34zz");
var $fvmH2 = parcelRequire("fvmH2");

var $l73hA = parcelRequire("l73hA");

var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $4BZ7p = parcelRequire("4BZ7p");
var $7tMaX = parcelRequire("7tMaX");
var $i34zz = parcelRequire("i34zz");
var $lll06 = parcelRequire("lll06");

var $l73hA = parcelRequire("l73hA");

var $4ya6m = parcelRequire("4ya6m");
class $7c707cd517dbc514$export$bdb31e4c69f480ca {
    constructor({ key: key }){
        this.key = key;
        (0, $4BZ7p.assignReadOnly)(this, 'key', key);
        (0, $7tMaX.cookies).set((0, $4ya6m.CookieNames).enabled, 'allowed');
        if ((0, $7tMaX.cookies).get((0, $4ya6m.CookieNames).enabled) === 'allowed') {
            (0, $7tMaX.cookies).remove((0, $4ya6m.CookieNames).enabled);
            this.store = (0, $7tMaX.cookies);
        } else this.store = (0, $lll06.ls);
    }
    get(key) {
        return this.store.get(`${key}_${this.key}`);
    }
    set(key, val) {
        this.store.set(`${key}_${this.key}`, val);
    }
    remove(key) {
        this.store.remove(`${key}_${this.key}`);
    }
    getEntityType() {
        // Looks for entity type from store WITH API key suffix
        const entityFromCurrentStore = this.get((0, $4ya6m.StoreNames).userEntityType);
        // Looks for entity type from legacy store
        const entityFromLegacyStore = this.store.get((0, $4ya6m.LegacyStoreNames).userEntityType);
        let entityType;
        if ((0, $i34zz.isEntity)(entityFromCurrentStore)) entityType = entityFromCurrentStore;
        else if ((0, $i34zz.isEntity)(entityFromLegacyStore)) entityType = entityFromLegacyStore;
        else entityType = (0, $4ya6m.EntityTypes).anonVisitor;
        return entityType;
    }
    getEntityId() {
        // Generate AVT if user ends up being an anonymous visitor
        const avt = (0, $l73hA.getAndSetAvtSafe)();
        // Get entity ID from store WITH API key suffix
        const idFromCurrentStore = this.get((0, $4ya6m.StoreNames).userEntityId);
        // Get entity ID from legacy store
        const idFromLegacyStore = this.store.get((0, $4ya6m.LegacyStoreNames).userEntityId);
        let id;
        if ((0, $i34zz.isEntityId)(idFromCurrentStore)) id = idFromCurrentStore;
        else if ((0, $i34zz.isEntityId)(idFromLegacyStore)) id = idFromLegacyStore;
        else id = avt;
        return id;
    }
    getEntityTraits() {
        // Get traits from legacy store
        const traitsFromLegacyStore = (0, $lll06.ls).get((0, $4ya6m.LegacyLSNames).userEntityTraits);
        // Get traits from store WITH API key suffix
        const traitsFromCurrentStore = (0, $lll06.ls).get(`${(0, $4ya6m.LSNames).userEntityTraits}_${this.key}`);
        const legacyTraits = (0, $i34zz.isTraits)(traitsFromLegacyStore) ? traitsFromLegacyStore : {};
        const currentStoreTraits = (0, $i34zz.isTraits)(traitsFromCurrentStore) ? traitsFromCurrentStore : {};
        // new store should overwrite legacy store
        const traits = Object.assign(Object.assign({}, legacyTraits), currentStoreTraits);
        return traits;
    }
    setEntityId(passedId, type) {
        // persist id in new store keys
        this.set((0, $4ya6m.StoreNames).userEntityId, passedId);
        // persist id in legacy store keys
        this.store.set((0, $4ya6m.LegacyStoreNames).userEntityId, passedId);
        if (type === (0, $4ya6m.EntityTypes).anonVisitor && (0, $i34zz.isUUID)(passedId)) this.store.set((0, $4ya6m.LegacyStoreNames).anonId, passedId);
    }
    setEntity(passedEntity) {
        this.set((0, $4ya6m.StoreNames).userEntityType, passedEntity);
        this.store.set((0, $4ya6m.LegacyStoreNames).userEntityType, passedEntity);
    }
    setEntityTraits(traits) {
        // only set new keys in localStorage
        // old traits shouldn't be used by application logic
        (0, $lll06.ls).set(`${(0, $4ya6m.LSNames).userEntityTraits}_${this.key}`, traits);
    }
}


/**
 * The only reason we're not using a private property is because of the size
 * that would add to the bundle when compiled. It really doesn't matter, though,
 * if this is shared between instances of `User` because it's just a wrapper
 * around cookies and localStorage.
 */ let $fd3bbd181df177da$var$store;
class $fd3bbd181df177da$export$1f44aaf2ec115b54 {
    // set default entity, id, and traits
    constructor({ key: key }){
        // Reinitializing in the constructor is easier
        // to write tests with a fresh store instance.
        // This makes no difference to the functionality
        // of the persistentStore in actual use
        $fd3bbd181df177da$var$store = new (0, $7c707cd517dbc514$export$bdb31e4c69f480ca)({
            key: key
        });
        // try to find entityType and id from storage
        const id = $fd3bbd181df177da$var$store.getEntityId();
        const entityType = $fd3bbd181df177da$var$store.getEntityType();
        const traits = $fd3bbd181df177da$var$store.getEntityTraits();
        this._identify(id, entityType, traits);
    }
    _setEntityId(passedId) {
        (0, $4BZ7p.assignReadOnly)(this, 'entityId', passedId);
        $fd3bbd181df177da$var$store.setEntityId(passedId, this.entityType);
    }
    _setEntityType(passedEntity) {
        (0, $4BZ7p.assignReadOnly)(this, 'entityType', passedEntity);
        $fd3bbd181df177da$var$store.setEntity(passedEntity);
    }
    _setEntityTraits(passedTraits) {
        const newTraits = Object.assign(Object.assign({}, this.entityTraits), passedTraits);
        (0, $4BZ7p.assignReadOnly)(this, 'entityTraits', newTraits);
        $fd3bbd181df177da$var$store.setEntityTraits(newTraits);
    }
    /**
     * Set user identity without making a network call.
     * Useful for testing.
     */ _identify(id, type, traits) {
        if ((0, $l73hA.entityIdAndTypeMatch)(id, type)) {
            // entity needs to be set before id as setId require to know entity
            this._setEntityType(type);
            if (type === (0, $4ya6m.EntityTypes).anonVisitor) // _savt is always the source of truth for anonymous_visitor
            this._setEntityId((0, $l73hA.getAndSetAvtSafe)(id));
            else this._setEntityId(id);
        // if entity and type are mismatched and identify
        // was not previously called (hence entity and id
        // being falsey), default to anonymous and AVT. Rely
        // on a new identify call in application logic to fix.
        } else if (!this.entityType || !this.entityId) {
            this._setEntityType((0, $4ya6m.EntityTypes).anonVisitor);
            this._setEntityId((0, $l73hA.getAndSetAvtSafe)());
        }
        // even if user identity is a mismatch,
        // we should still set traits
        if (!traits) return;
        if ((0, $i34zz.isTraits)(traits)) this._setEntityTraits(traits);
        else (0, $fvmH2.warn)("The third argument traits is not of type 'object'. Traits were not set.");
    }
}



var $5sKyw = parcelRequire("5sKyw");
function $740c4c84f29b8527$export$2e841e6398be3d56(callback) {
    let unloaded = false; // prevents double firing if both are supported
    function pageHideHandler() {
        if (unloaded) return;
        unloaded = true;
        callback('hidden');
    }
    function visibilityChangeHandler() {
        if (document.visibilityState === 'hidden') {
            if (unloaded) return;
            unloaded = true;
            callback('hidden');
        } else {
            unloaded = false;
            callback('visible');
        }
    }
    window.addEventListener('pagehide', pageHideHandler);
    document.addEventListener('visibilitychange', visibilityChangeHandler);
    return {
        pageHideHandler: pageHideHandler,
        visibilityChangeHandler: visibilityChangeHandler
    };
}



var $4ya6m = parcelRequire("4ya6m");
// eslint-disable-next-line import/extensions -- Node ESM requires explicit subpath extensions for crypto-js.

var $33Dov = parcelRequire("33Dov");

var $WS9F7 = parcelRequire("WS9F7");
function $f3da5185d7000480$export$2e2bcd8739ae039(payloadStr, apiKey) {
    const key = apiKey.replaceAll('-', '');
    const hash = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(payloadStr, key);
    return `v1:${(0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify(hash)}`;
}


parcelRequire("5o0ob");
var $fvmH2 = parcelRequire("fvmH2");
var $i34zz = parcelRequire("i34zz");
var $f6qDi = parcelRequire("f6qDi");
var $3EKNW = parcelRequire("3EKNW");
parcelRequire("5o0ob");
var $fvmH2 = parcelRequire("fvmH2");
var $i34zz = parcelRequire("i34zz");
var $lll06 = parcelRequire("lll06");

var $4ya6m = parcelRequire("4ya6m");
const $629312d497386cff$export$45b7810513497e4d = 1;
const $629312d497386cff$export$50df8a7fb6541d03 = 3;
const $629312d497386cff$export$ead12e3e0660470 = 3000;
function $629312d497386cff$export$d7542945cc215dfe(buffer) {
    // const size = encodeURI(JSON.stringify(buffer)).split(/%..|./).length - 1;
    const size = encodeURI(JSON.stringify(buffer)).length - 1;
    return size / 1024;
}
function $629312d497386cff$export$abebcb2d74fab1a8(key) {
    const items = (0, $lll06.ls).get(`${(0, $4ya6m.LsKeysV1).items}_${key}`);
    return (0, $i34zz.isArray)(items) ? items : [];
}
function $629312d497386cff$export$97cf1c62313c79c4({ items: items, key: key }) {
    const existing = $629312d497386cff$export$abebcb2d74fab1a8(key);
    const all = [
        ...items,
        ...existing
    ];
    (0, $lll06.ls).set(`${(0, $4ya6m.LsKeysV1).items}_${key}`, JSON.stringify(all));
}
function $629312d497386cff$export$781d5e5499c99070(key) {
    const stored = (0, $lll06.ls).get(`${(0, $4ya6m.LsKeysV1).seen}_${key}`);
    return (0, $i34zz.isObject)(stored) ? stored : {};
}
function $629312d497386cff$export$c6af13f8f71f6b84({ memory: memory, key: key }) {
    const stored = $629312d497386cff$export$781d5e5499c99070(key);
    (0, $lll06.ls).set(`${(0, $4ya6m.LsKeysV1).seen}_${key}`, JSON.stringify(Object.assign(Object.assign({}, stored), memory)));
}
function $629312d497386cff$export$712ea50be43a7858(events) {
    const result = [];
    let index = 0;
    const sentAt = new Date().toISOString();
    events.forEach((event)=>{
        const eventWithSentAt = Object.assign(Object.assign({}, event), {
            sentAt: sentAt
        });
        const size = (result[index] ? $629312d497386cff$export$d7542945cc215dfe(result[index]) : 0) + $629312d497386cff$export$d7542945cc215dfe(eventWithSentAt);
        if (size >= 1000) index++;
        if (result[index]) result[index].push(eventWithSentAt);
        else result[index] = [
            eventWithSentAt
        ];
    });
    return result;
}
function $629312d497386cff$export$cd7f480d6b8286c3(key) {
    (0, $lll06.ls).remove(key);
}
function $629312d497386cff$var$expired(lockExpirationTime) {
    return Date.now() >= lockExpirationTime;
}
function $629312d497386cff$export$1b347e5c2ee97123({ onUnlock: onUnlock, attempt: attempt = 0, key: key }) {
    const lockTimeout = 50;
    const rawLock = (0, $lll06.ls).get(`${(0, $4ya6m.LsKeysV1).lockKey}_${key}`);
    const lock = rawLock ? rawLock : null;
    const allowed = lock === null || $629312d497386cff$var$expired(lock);
    if (allowed) {
        (0, $lll06.ls).set(`${(0, $4ya6m.LsKeysV1).lockKey}_${key}`, JSON.stringify(Date.now() + lockTimeout));
        onUnlock();
        (0, $lll06.ls).remove(`${(0, $4ya6m.LsKeysV1).lockKey}_${key}`);
        return;
    }
    if (!allowed && attempt < 3) setTimeout(()=>{
        $629312d497386cff$export$1b347e5c2ee97123({
            onUnlock: onUnlock,
            key: key,
            attempt: attempt + 1
        });
    }, lockTimeout);
    else (0, $fvmH2.error)('Unable to retrieve lock');
}
function $629312d497386cff$export$6b599d9330014be8(event) {
    const { parameters: parameters } = Object.assign({}, event);
    delete parameters.cdf_entity;
    delete parameters.cdf_action;
    const stringVal = JSON.stringify(parameters);
    return stringVal;
}
function $629312d497386cff$export$603f2ce0a793fc75(markMessageId) {
    window.performance.mark(`cdp-${markMessageId}-started`);
}
function $629312d497386cff$export$7eb88f405fe7c2a2(markMessageId) {
    window.performance.mark(`cdp-${markMessageId}-ended`);
    const measureRequest = window.performance.measure(`cdp-${markMessageId}-measure`, `cdp-${markMessageId}-started`, `cdp-${markMessageId}-ended`);
    window.performance.clearMarks(`cdp-${markMessageId}-started`);
    window.performance.clearMarks(`cdp-${markMessageId}-ended`);
    window.performance.clearMeasures(`cdp-${markMessageId}-measure`);
    return measureRequest.duration;
}
function $629312d497386cff$export$899197a9171f756b({ batchId: batchId, batchSize: batchSize, cdpVersion: cdpVersion }) {
    window.dispatchEvent(new CustomEvent((0, $4ya6m.EmittedEvents).BatchSent, {
        detail: {
            batchId: batchId,
            batchSize: batchSize,
            cdpVersion: cdpVersion
        }
    }));
}
function $629312d497386cff$export$ef3d0060d9491aed({ batchId: batchId, batchSize: batchSize, rejectedMessages: rejectedMessages = [], requestLatency: requestLatency, httpStatus: httpStatus, cdpVersion: cdpVersion }) {
    window.dispatchEvent(new CustomEvent((0, $4ya6m.EmittedEvents).BatchCompleted, {
        detail: {
            batchId: batchId,
            batchSize: batchSize,
            requestLatency: requestLatency,
            rejectedMessages: rejectedMessages,
            httpStatus: httpStatus,
            cdpVersion: cdpVersion
        }
    }));
}
function $629312d497386cff$export$d91c5634c7604c1a({ batchId: batchId, batchSize: batchSize, requestLatency: requestLatency, cdpVersion: cdpVersion }) {
    window.dispatchEvent(new CustomEvent((0, $4ya6m.EmittedEvents).BatchFailed, {
        detail: {
            batchId: batchId,
            batchSize: batchSize,
            requestLatency: requestLatency,
            cdpVersion: cdpVersion
        }
    }));
}


// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/unifiedeventing/messages/context.proto
/* eslint-disable */ const $672932446cb1cea7$export$a79d2123b1e05cb = "squareup.unifiedeventing.messages";
var $672932446cb1cea7$export$2ae7309d7f3e0809;
(function(BuildType) {
    BuildType[BuildType["UNKNOWN_BUILD_TYPE"] = 0] = "UNKNOWN_BUILD_TYPE";
    BuildType[BuildType["APP_STORE"] = 1] = "APP_STORE";
    BuildType[BuildType["BETA"] = 2] = "BETA";
    BuildType[BuildType["DEVELOPMENT"] = 3] = "DEVELOPMENT";
    BuildType[BuildType["DEMO_APP"] = 4] = "DEMO_APP";
    BuildType[BuildType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($672932446cb1cea7$export$2ae7309d7f3e0809 || ($672932446cb1cea7$export$2ae7309d7f3e0809 = {}));
var $672932446cb1cea7$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["UNKNOWN_ENVIRONMENT"] = 0] = "UNKNOWN_ENVIRONMENT";
    Environment[Environment["PRODUCTION"] = 1] = "PRODUCTION";
    Environment[Environment["TEST_PRODUCTION"] = 2] = "TEST_PRODUCTION";
    Environment[Environment["STAGING"] = 3] = "STAGING";
    Environment[Environment["TEST_STAGING"] = 4] = "TEST_STAGING";
    Environment[Environment["OTHER"] = 5] = "OTHER";
    Environment[Environment["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($672932446cb1cea7$export$7dc6752a22ab011a || ($672932446cb1cea7$export$7dc6752a22ab011a = {}));
var $672932446cb1cea7$export$4a868a35d3b57055;
(function(NetworkType) {
    NetworkType[NetworkType["UNKNOWN_NETWORK"] = 0] = "UNKNOWN_NETWORK";
    NetworkType[NetworkType["BLUETOOTH"] = 1] = "BLUETOOTH";
    NetworkType[NetworkType["WIFI"] = 2] = "WIFI";
    NetworkType[NetworkType["CELLULAR"] = 3] = "CELLULAR";
    NetworkType[NetworkType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($672932446cb1cea7$export$4a868a35d3b57055 || ($672932446cb1cea7$export$4a868a35d3b57055 = {}));
var $672932446cb1cea7$export$5bfb06329165f70f;
(function(OperatingSystemName) {
    OperatingSystemName[OperatingSystemName["UNKNOWN_OS"] = 0] = "UNKNOWN_OS";
    OperatingSystemName[OperatingSystemName["IOS"] = 1] = "IOS";
    OperatingSystemName[OperatingSystemName["ANDROID"] = 2] = "ANDROID";
    OperatingSystemName[OperatingSystemName["WEB"] = 3] = "WEB";
    OperatingSystemName[OperatingSystemName["WINDOWS"] = 4] = "WINDOWS";
    OperatingSystemName[OperatingSystemName["MAC_OS"] = 5] = "MAC_OS";
    OperatingSystemName[OperatingSystemName["LINUX"] = 6] = "LINUX";
    OperatingSystemName[OperatingSystemName["IOS_WEB"] = 7] = "IOS_WEB";
    OperatingSystemName[OperatingSystemName["ANDROID_WEB"] = 8] = "ANDROID_WEB";
    OperatingSystemName[OperatingSystemName["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($672932446cb1cea7$export$5bfb06329165f70f || ($672932446cb1cea7$export$5bfb06329165f70f = {}));
var $672932446cb1cea7$export$2bc34ef97fee356d;
(function(ScreenOrientation) {
    ScreenOrientation[ScreenOrientation["UNKNOWN_SCREEN_ORIENTATION"] = 0] = "UNKNOWN_SCREEN_ORIENTATION";
    ScreenOrientation[ScreenOrientation["PORTRAIT"] = 1] = "PORTRAIT";
    ScreenOrientation[ScreenOrientation["LANDSCAPE"] = 2] = "LANDSCAPE";
    ScreenOrientation[ScreenOrientation["SQUARE"] = 3] = "SQUARE";
    ScreenOrientation[ScreenOrientation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($672932446cb1cea7$export$2bc34ef97fee356d || ($672932446cb1cea7$export$2bc34ef97fee356d = {}));



var $4ya6m = parcelRequire("4ya6m");
function $27b7fec2ec13fa58$export$c8b991e0914875d1(context, environment) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        device: {
            screen_orientation: (0, $672932446cb1cea7$export$2bc34ef97fee356d).UNKNOWN_SCREEN_ORIENTATION,
            is_tablet: false
        },
        network: {
            type: context.network.type,
            ip_address: context.network.ipAddress
        },
        library: context.library,
        geo: {
            country_code: context.locale.countryCode,
            language: context.locale.language,
            latitude: 0,
            longitude: 0
        },
        os: {
            name: $27b7fec2ec13fa58$export$bf1209a9bea794d8(context.os.name),
            public_version: (_a = context.os.version) !== null && _a !== void 0 ? _a : '',
            build_id: '',
            incremental_version: '',
            security_version: ''
        },
        app: {
            registry_name: (_c = (_b = context.application) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '',
            public_version: (_e = (_d = context.application) === null || _d === void 0 ? void 0 : _d.version) !== null && _e !== void 0 ? _e : '',
            build_type: (0, $672932446cb1cea7$export$2ae7309d7f3e0809).UNKNOWN_BUILD_TYPE,
            browser_name: (_f = context.browser.name) !== null && _f !== void 0 ? _f : '',
            browser_version: (_g = context.browser.version) !== null && _g !== void 0 ? _g : '',
            height_px: context.browser.height,
            width_px: context.browser.width,
            environment: $27b7fec2ec13fa58$export$57570b1603cf6adb(environment),
            is_super_pos: false,
            user_agent: context.userAgent
        },
        subject: {
            person_token: (_h = context.subject.personToken) !== null && _h !== void 0 ? _h : '',
            merchant_token: (_j = context.subject.merchantToken) !== null && _j !== void 0 ? _j : '',
            anonymous_token: (_k = context.subject.anonymousToken) !== null && _k !== void 0 ? _k : '',
            unit_token: (_l = context.subject.unitToken) !== null && _l !== void 0 ? _l : '',
            employment_token: (_m = context.subject.employmentToken) !== null && _m !== void 0 ? _m : '',
            credential_token: (_o = context.subject.credentialToken) !== null && _o !== void 0 ? _o : ''
        },
        session: {
            token: context.session.token,
            start_time_millis: context.session.startTimeMillis,
            is_impersonating: context.session.isImpersonating
        },
        page: {
            path: context.page.path,
            referrer: context.page.referrer,
            search: context.page.search,
            title: context.page.title,
            url: context.page.url
        }
    };
}
function $27b7fec2ec13fa58$export$57570b1603cf6adb(env) {
    switch(env){
        case (0, $4ya6m.Environments).stage:
            return (0, $672932446cb1cea7$export$7dc6752a22ab011a).STAGING;
        case (0, $4ya6m.Environments).production:
            return (0, $672932446cb1cea7$export$7dc6752a22ab011a).PRODUCTION;
        default:
            return (0, $672932446cb1cea7$export$7dc6752a22ab011a).OTHER;
    }
}
function $27b7fec2ec13fa58$export$bf1209a9bea794d8(osName) {
    switch(osName){
        case 'Android':
            return (0, $672932446cb1cea7$export$5bfb06329165f70f).ANDROID_WEB;
        case 'iOS':
            return (0, $672932446cb1cea7$export$5bfb06329165f70f).IOS_WEB;
        case 'Windows':
            return (0, $672932446cb1cea7$export$5bfb06329165f70f).WINDOWS;
        case 'Mac OS':
            return (0, $672932446cb1cea7$export$5bfb06329165f70f).MAC_OS;
        case 'Linux':
        case 'Ubuntu':
        case 'Fedora':
        case 'Arch':
        case 'Debian':
        case 'CentOS':
        case 'Mint':
        case 'RedHat':
        case 'VectorLinux':
            return (0, $672932446cb1cea7$export$5bfb06329165f70f).LINUX;
        default:
            return (0, $672932446cb1cea7$export$5bfb06329165f70f).UNKNOWN_OS;
    }
}



var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $i34zz = parcelRequire("i34zz");
function $ca170cd16ede12af$export$d7d96948c398f9d2(message) {
    if ((0, $i34zz.isSchemaMessage)(message)) return (0, $4ya6m.CdpVersion).V2;
    return (0, $4ya6m.CdpVersion).V1;
}


var $8724debf7a85666b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8724debf7a85666b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $8724debf7a85666b$export$1a39c19cecd1c26 {
    constructor({ url: url, environment: environment, batchSize: batchSize = (0, $629312d497386cff$export$45b7810513497e4d), maxTimeBetweenFlushes: maxTimeBetweenFlushes = (0, $629312d497386cff$export$ead12e3e0660470), logEventsToConsole: logEventsToConsole = false, maxRetryAttempts: maxRetryAttempts = (0, $629312d497386cff$export$50df8a7fb6541d03), key: key, useAnalyticsProxy: useAnalyticsProxy = false }){
        this.eventListeners = {
            pageHide: [],
            visibilityChange: []
        };
        this.maxRetryAttempts = maxRetryAttempts;
        this.url = url;
        this.environment = environment;
        this.logEventsToConsole = logEventsToConsole;
        this.pageUnloaded = false;
        this.batchSize = batchSize;
        this.maxTimeBetweenFlushes = maxTimeBetweenFlushes;
        this.queue = [];
        this.eventsAttempts = {};
        this.key = key;
        this.useAnalyticsProxy = useAnalyticsProxy;
        // recover pending events and events attempt data from localstorage
        (0, $629312d497386cff$export$1b347e5c2ee97123)({
            onUnlock: ()=>{
                let saved = [];
                let lastSeen = {};
                try {
                    saved = (0, $629312d497386cff$export$abebcb2d74fab1a8)(this.key);
                    lastSeen = (0, $629312d497386cff$export$781d5e5499c99070)(this.key);
                    (0, $629312d497386cff$export$cd7f480d6b8286c3)(`${(0, $4ya6m.LsKeysV1).items}_${this.key}`);
                    (0, $629312d497386cff$export$cd7f480d6b8286c3)(`${(0, $4ya6m.LsKeysV1).seen}_${this.key}`);
                    this.queue = [
                        ...saved,
                        ...this.queue
                    ];
                    this.eventsAttempts = Object.assign(Object.assign({}, lastSeen), this.eventsAttempts);
                } catch (err) {
                    (0, $fvmH2.error)(err);
                }
            },
            key: this.key
        });
        this.setupEventListeners();
    }
    setupEventListeners() {
        // add onPageLeave event listener, to flush queue
        // onPageLeave will trigger on: tab away, close tab, switch to other app (mobile)
        const { pageHideHandler: pageHideHandler, visibilityChangeHandler: visibilityChangeHandler } = (0, $740c4c84f29b8527$export$2e841e6398be3d56)((visibilityState)=>{
            if (visibilityState === 'hidden') {
                this.pageUnloaded = true;
                // keepalive requests have a limit of 64kb requst size
                // https://javascript.info/fetch-api#:~:text=We%20can't%20send%20megabytes,for%20keepalive%20requests%20is%2064KB.
                if (this.length > 0) this.flushUpTo64kb();
            } else this.pageUnloaded = false;
        });
        const persistEventsHandler = ()=>{
            // we deliberately want to use the less powerful 'pagehide' API to only persist on events
            // where the cdp.js instance gets destroyed upon closing tab or page refresh, and not on tab away.
            if (this.length > 0) {
                const items = [
                    ...this.queue
                ];
                (0, $629312d497386cff$export$1b347e5c2ee97123)({
                    onUnlock: ()=>{
                        (0, $629312d497386cff$export$97cf1c62313c79c4)({
                            items: items,
                            key: this.key
                        });
                        (0, $629312d497386cff$export$c6af13f8f71f6b84)({
                            memory: this.eventsAttempts,
                            key: this.key
                        });
                    },
                    key: this.key
                });
            }
        };
        window.addEventListener('pagehide', persistEventsHandler);
        // Store the handlers so they can be removed on teardown
        this.eventListeners.pageHide.push(pageHideHandler, persistEventsHandler);
        this.eventListeners.visibilityChange.push(visibilityChangeHandler);
    }
    removeEventListeners() {
        this.eventListeners.pageHide.forEach((handler)=>{
            window.removeEventListener('pagehide', handler);
        });
        this.eventListeners.pageHide = [];
        this.eventListeners.visibilityChange.forEach((handler)=>{
            document.removeEventListener('visibilitychange', handler);
        });
        this.eventListeners.visibilityChange = [];
    }
    scheduleFlush() {
        if (this.schedule) return;
        this.schedule = setTimeout(()=>{
            this.schedule = undefined;
            this.flush();
        }, this.maxTimeBetweenFlushes);
    }
    push(...events) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            const filteredEvents = events.filter((event)=>{
                const attempts = this.updateRetryAttempt(event);
                const keepMessage = attempts <= this.maxRetryAttempts && !this.includesMessage(event);
                if (!keepMessage) window.dispatchEvent(new CustomEvent((0, $4ya6m.EmittedEvents).DoNotRetry, {
                    detail: {
                        message: event,
                        attempts: attempts,
                        cdpVersion: (0, $ca170cd16ede12af$export$d7d96948c398f9d2)(event)
                    }
                }));
                return keepMessage;
            });
            this.queue.push(...filteredEvents);
            this.queue = this.queue.sort((a, b)=>this.getRetryAttempt(a) - this.getRetryAttempt(b));
            const batchSizeLimitReached = this.length >= this.batchSize;
            yield batchSizeLimitReached || this.pageUnloaded ? this.flush() : this.scheduleFlush();
        });
    }
    getRetryAttempt(event) {
        var _a;
        return (_a = this.eventsAttempts[event.messageId]) !== null && _a !== void 0 ? _a : 0;
    }
    updateRetryAttempt(event) {
        this.eventsAttempts[event.messageId] = this.getRetryAttempt(event) + 1;
        return this.getRetryAttempt(event);
    }
    includesMessage(event) {
        return this.queue.includes(event) || Boolean(this.queue.some((i)=>i.messageId === event.messageId));
    }
    get length() {
        return this.queue.length;
    }
    backToQueue(batch) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            batch.forEach((event)=>{
                // eslint-disable-next-line no-param-reassign
                event.sentAt = null;
            });
            yield this.push(...batch);
        });
    }
    createUnifiedEventingMessage(message) {
        // For anonymous visitors, CDP sends an empty entity ID, but Sawmill's UE
        // ingest requires a non-empty entity_id, so fall back to the anonymous ID.
        // Note: `entityId` may be `''` OR absent here — `clean()` (see
        // messages/message.ts `call()`) strips empty-string fields before the
        // message reaches the queue, so a strict `=== ''` check misses it. Use a
        // falsy check so both the empty-string and stripped (`undefined`) cases
        // are covered.
        const entityId = message.entityType === (0, $4ya6m.EntityTypes).anonVisitor && !message.entityId ? message.anonymousId : message.entityId;
        const baseMessage = {
            context: (0, $27b7fec2ec13fa58$export$c8b991e0914875d1)(message.context, this.environment),
            message_id: message.messageId,
            entity_type: message.entityType,
            entity_id: entityId,
            timestamp: new Date(message.timestamp).getTime()
        };
        if ((0, $i34zz.isTrackWithSchema)(message)) return Object.assign(Object.assign({}, baseMessage), {
            track: {
                event_name: message.event.name,
                properties: (0, $629312d497386cff$export$6b599d9330014be8)(message.event)
            }
        });
        if ((0, $i34zz.isIdentifyWithSchema)(message)) return Object.assign(Object.assign({}, baseMessage), {
            identify: {
                traits: this.stringifySchemaTraits(message.identify.traits)
            }
        });
        if ((0, $i34zz.isGroupWithSchema)(message)) return Object.assign(Object.assign({}, baseMessage), {
            group: {
                group_id: message.groupId,
                remove_group: message.removeGroup,
                traits: this.stringifySchemaTraits(message.group.traits)
            }
        });
        throw new Error('unsupported Unified Eventing message');
    }
    stringifySchemaTraits(traits) {
        var _a;
        return JSON.stringify((_a = (0, $f6qDi.unwrapSchemaObject)(traits)) !== null && _a !== void 0 ? _a : {});
    }
    sendBatch(batch) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            if (batch.length === 0) return;
            if (this.useAnalyticsProxy) yield this.sendMessages(batch);
            else {
                const cdpMessages = [];
                const ueMessages = [];
                for (const message of batch)if ((0, $i34zz.isSchemaMessage)(message)) ueMessages.push({
                    apiMessage: message,
                    unifiedEventingMessage: this.createUnifiedEventingMessage(message)
                });
                else cdpMessages.push(message);
                yield Promise.all([
                    this.sendCdpMessages(cdpMessages),
                    this.sendUeMessages(ueMessages)
                ].filter(Boolean));
            }
        });
    }
    sendMessages(apiMessageBatch) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            const cdpMessages = [];
            const paeMessages = [];
            apiMessageBatch.forEach((message)=>{
                if ((0, $i34zz.isSchemaMessage)(message) === false) cdpMessages.push(message);
                else paeMessages.push({
                    apiMessage: message,
                    unifiedEventingMessage: this.createUnifiedEventingMessage(message)
                });
            });
            // build cdp batch if needed
            let cdpEvents = undefined;
            if (cdpMessages.length > 0) {
                const batch = cdpMessages; // JSON object must be named batch
                const payloadStr = JSON.stringify({
                    batch: batch
                });
                const apiKey = cdpMessages[0].apiKey;
                const requestSignature = (0, $f3da5185d7000480$export$2e2bcd8739ae039)(payloadStr, apiKey);
                const authKey = window.btoa(`${apiKey}:`);
                cdpEvents = {
                    payload: payloadStr,
                    authorization: `Basic ${authKey}`,
                    xCdpBatchId: requestSignature
                };
            }
            const markMessageId = apiMessageBatch[0].messageId;
            (0, $629312d497386cff$export$603f2ce0a793fc75)(markMessageId);
            const batchId = (0, $5sKyw.default)();
            const request = {
                cdpEvents: cdpEvents,
                paeEvents: paeMessages.map((m)=>m.unifiedEventingMessage),
                eventStreamV1Events: [],
                eventStreamV2Events: []
            };
            (0, $629312d497386cff$export$899197a9171f756b)({
                batchId: batchId,
                batchSize: cdpMessages.length + paeMessages.length,
                cdpVersion: (0, $4ya6m.CdpVersion).V1
            });
            yield fetch(this.url.proxy, {
                keepalive: this.pageUnloaded,
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'post',
                body: JSON.stringify(request)
            }).then((resp)=>$8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
                    const requestLatency = (0, $629312d497386cff$export$7eb88f405fe7c2a2)(markMessageId);
                    (0, $629312d497386cff$export$ef3d0060d9491aed)({
                        batchId: batchId,
                        batchSize: (0, $629312d497386cff$export$712ea50be43a7858).length,
                        requestLatency: requestLatency,
                        httpStatus: resp.status,
                        cdpVersion: (0, $4ya6m.CdpVersion).V1
                    });
                    if (resp.status === 429 || resp.status >= 500) yield this.handleResponse(resp, apiMessageBatch);
                    else if (resp.status < 400) {
                        const data = yield resp.json();
                        // the proxy succeeds, but the eventing services may have errors,
                        // inspect them
                        if ('cdp_ingest_response' in data) {
                            const cdpResponse = Object.assign(Object.assign({}, resp), {
                                status: data.cdp_ingest_response.response_code,
                                statusText: data.cdp_ingest_response.error_message
                            });
                            yield this.handleResponse(cdpResponse, cdpMessages);
                        }
                        if ('pae_response' in data) {
                            let rejectedMessages = [];
                            if (data.pae_response.errors !== undefined && data.pae_response.errors.length > 0) rejectedMessages = data.pae_response.errors.map((_a)=>{
                                var { message_id: message_id } = _a, args = $8724debf7a85666b$var$__rest(_a, [
                                    "message_id"
                                ]);
                                return Object.assign({
                                    messageId: message_id
                                }, args);
                            });
                            yield this.handleResponse(resp, paeMessages.map((m)=>m.apiMessage), rejectedMessages);
                            (0, $fvmH2.logRejectedMessages)(rejectedMessages);
                        }
                    }
                })).catch((e)=>$8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
                    const requestLatency = (0, $629312d497386cff$export$7eb88f405fe7c2a2)(markMessageId);
                    (0, $629312d497386cff$export$d91c5634c7604c1a)({
                        batchId: batchId,
                        batchSize: (0, $629312d497386cff$export$712ea50be43a7858).length,
                        requestLatency: requestLatency,
                        cdpVersion: (0, $4ya6m.CdpVersion).Proxy
                    });
                    (0, $fvmH2.warn)(e);
                    // back to queue only for the ones that failed. Parse response for details
                    yield this.backToQueue(apiMessageBatch);
                }));
        });
    }
    sendCdpMessages(apiMessageBatch) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            if (apiMessageBatch.length === 0) return;
            const batch = [];
            apiMessageBatch.forEach((message)=>{
                if (!(0, $i34zz.isSchemaMessage)(message)) batch.push(message);
            });
            if (batch.length !== apiMessageBatch.length) (0, $fvmH2.throwError)('there are Unified Eventing Messages in the batch');
            const payloadStr = JSON.stringify({
                batch: batch
            });
            const apiKey = batch[0].apiKey;
            const requestSignature = (0, $f3da5185d7000480$export$2e2bcd8739ae039)(payloadStr, apiKey);
            const authKey = window.btoa(`${apiKey}:`);
            const markMessageId = batch[0].messageId;
            (0, $629312d497386cff$export$603f2ce0a793fc75)(markMessageId);
            const batchId = (0, $5sKyw.default)();
            (0, $629312d497386cff$export$899197a9171f756b)({
                batchId: batchId,
                batchSize: batch.length,
                cdpVersion: (0, $4ya6m.CdpVersion).V1
            });
            yield fetch(this.url.v1, {
                keepalive: this.pageUnloaded,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CDP-Batch-ID': requestSignature,
                    authorization: `Basic ${authKey}`
                },
                method: 'post',
                body: payloadStr
            }).then((resp)=>{
                const requestLatency = (0, $629312d497386cff$export$7eb88f405fe7c2a2)(markMessageId);
                (0, $629312d497386cff$export$ef3d0060d9491aed)({
                    batchId: batchId,
                    batchSize: batch.length,
                    requestLatency: requestLatency,
                    httpStatus: resp.status,
                    cdpVersion: (0, $4ya6m.CdpVersion).V1
                });
                this.handleResponse(resp, batch);
            }).catch((e)=>{
                const requestLatency = (0, $629312d497386cff$export$7eb88f405fe7c2a2)(markMessageId);
                (0, $629312d497386cff$export$d91c5634c7604c1a)({
                    batchId: batchId,
                    batchSize: batch.length,
                    requestLatency: requestLatency,
                    cdpVersion: (0, $4ya6m.CdpVersion).V1
                });
                (0, $fvmH2.warn)(e);
                this.backToQueue(batch);
            });
        });
    }
    sendUeMessages(messages) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            if (messages.length === 0) return;
            const request = {
                ue_messages: messages.map((m)=>m.unifiedEventingMessage),
                sent_at: Date.now()
            };
            const batch = messages.map((m)=>m.apiMessage);
            const batchId = (0, $5sKyw.default)();
            (0, $629312d497386cff$export$899197a9171f756b)({
                batchId: batchId,
                batchSize: batch.length,
                cdpVersion: (0, $4ya6m.CdpVersion).V2
            });
            const markMessageId = messages[0].unifiedEventingMessage.message_id;
            (0, $629312d497386cff$export$603f2ce0a793fc75)(markMessageId);
            const url = this.url.v2;
            yield fetch(url, {
                keepalive: this.pageUnloaded,
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'post',
                body: JSON.stringify(request)
            }).then((resp)=>$8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
                    const requestLatency = (0, $629312d497386cff$export$7eb88f405fe7c2a2)(markMessageId);
                    let rejectedMessages = [];
                    if (resp.ok) {
                        const data = yield resp.json();
                        if ('errors' in data) rejectedMessages = data.errors.map((_a)=>{
                            var { message_id: message_id } = _a, args = $8724debf7a85666b$var$__rest(_a, [
                                "message_id"
                            ]);
                            return Object.assign({
                                messageId: message_id
                            }, args);
                        });
                    }
                    (0, $629312d497386cff$export$ef3d0060d9491aed)({
                        batchId: batchId,
                        batchSize: messages.length,
                        requestLatency: requestLatency,
                        rejectedMessages: rejectedMessages,
                        httpStatus: resp.status,
                        cdpVersion: (0, $4ya6m.CdpVersion).V2
                    });
                    this.handleResponse(resp, batch, rejectedMessages);
                    (0, $fvmH2.logRejectedMessages)(rejectedMessages);
                })).catch((e)=>{
                const requestLatency = (0, $629312d497386cff$export$7eb88f405fe7c2a2)(markMessageId);
                (0, $629312d497386cff$export$d91c5634c7604c1a)({
                    batchId: batchId,
                    batchSize: messages.length,
                    requestLatency: requestLatency,
                    cdpVersion: (0, $4ya6m.CdpVersion).V2
                });
                (0, $fvmH2.warn)(e);
                this.backToQueue(batch);
            });
        });
    }
    handleResponse(resp_1, batch_1) {
        return $8724debf7a85666b$var$__awaiter(this, arguments, void 0, function*(resp, batch, rejectedMessages = []) {
            // we don't want to retry if we get i.e 401 which indicates an invalid signature
            if (resp.status === 429 || resp.status >= 500) yield this.backToQueue(batch);
            else batch.forEach((message)=>{
                let convertedContext = undefined;
                if ((0, $i34zz.isSchemaMessage)(message)) convertedContext = (0, $27b7fec2ec13fa58$export$c8b991e0914875d1)(message.context, this.environment);
                const rejectedMessage = rejectedMessages.filter(({ messageId: messageId })=>messageId === message.messageId).pop();
                const isMessageSuccessful = resp.status < 400 && !rejectedMessage;
                const schemaError = rejectedMessage ? {
                    reason: rejectedMessage.reason,
                    type: rejectedMessage.type
                } : {};
                const eventType = isMessageSuccessful ? (0, $4ya6m.EmittedEvents).DeliverySuccess : (0, $4ya6m.EmittedEvents).DeliveryFailure;
                const eventOptions = {
                    detail: Object.assign({
                        cdpVersion: (0, $ca170cd16ede12af$export$d7d96948c398f9d2)(message),
                        message: Object.assign(Object.assign({}, message), {
                            context: convertedContext !== null && convertedContext !== void 0 ? convertedContext : message.context
                        }),
                        status: resp.status
                    }, schemaError)
                };
                // Emit event to allow listeners to react to success/failure
                window.dispatchEvent(new CustomEvent(eventType, eventOptions));
                // Log successful events to console if enabled
                if (resp.status < 400 && this.logEventsToConsole) {
                    if ((0, $i34zz.isSchemaMessage)(message)) (0, $fvmH2.logEvent)(message, convertedContext);
                    else (0, $fvmH2.logEvent)(message);
                    if (message.apiMethod === 'track') (0, $3EKNW.warnAboutExcessiveColumns)(message);
                }
            });
        });
    }
    flushUpTo64kb() {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            const batchedEvents = [];
            let currPayloadSize = 0;
            const sentAt = new Date().toISOString();
            while(this.queue.length > 0){
                const eventWithSentAt = Object.assign(Object.assign({}, this.queue[0]), {
                    sentAt: sentAt
                });
                const currEventSize = (0, $629312d497386cff$export$d7542945cc215dfe)(eventWithSentAt);
                // set limit to 45 to give room for the rest of the request i.e headers
                if (currPayloadSize + currEventSize > 45) break;
                this.queue.shift();
                batchedEvents.push(eventWithSentAt);
                currPayloadSize += currEventSize;
            }
            yield this.sendBatch(batchedEvents);
        });
    }
    flush() {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            if (this.queue.length > 0) {
                const events = this.queue;
                this.queue = [];
                yield Promise.all((0, $629312d497386cff$export$712ea50be43a7858)(events).map((batchedEvents)=>this.sendBatch(batchedEvents)));
            }
        });
    }
}




var $5sKyw = parcelRequire("5sKyw");

var $l73hA = parcelRequire("l73hA");
var $9b8221f76ec3a444$exports = {};
$parcel$export($9b8221f76ec3a444$exports, "makeContextObj", () => $787adfe79aa608a3$export$6c5004d5490ddf9e);
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");

var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
function $0a3ea60d32b203ad$export$2afae91a33db1d52() {
    const queryParams = $0a3ea60d32b203ad$var$getQuery();
    return Object.assign(Object.assign({}, $0a3ea60d32b203ad$var$getTrackCookieData()), {
        utmCampaign: queryParams.utm_campaign,
        utmContent: queryParams.utm_content,
        utmMedium: queryParams.utm_medium,
        utmSource: queryParams.utm_source,
        utmTerm: queryParams.utm_term,
        trackCookieBase64: $0a3ea60d32b203ad$var$getTrackCookiesBase64()
    });
}
function $0a3ea60d32b203ad$var$getQuery() {
    if (window.location.search.length === 0) return {};
    const obj = {};
    const query = window.location.search.slice(1);
    const pairs = query.split('&');
    for (const pair of pairs){
        const [key, value] = pair.split('=');
        const decodedKey = decodeURIComponent(key);
        const decodedVal = decodeURIComponent(value);
        obj[decodedKey] = decodedVal;
    }
    return obj;
}
function $0a3ea60d32b203ad$var$getTrackCookieData() {
    const trackCookieArray = $0a3ea60d32b203ad$var$getTrackCookieDataArray();
    const trackCookieObject = {};
    if (trackCookieArray.length > 0) trackCookieArray.forEach((keyValStr)=>{
        const paramKey = keyValStr.split(/[=_-]/)[0];
        if (paramKey in (0, $jPIgV.cookiePrefixMap)) {
            // parse and set marketing param data
            const readableParamName = (0, $jPIgV.cookiePrefixMap)[paramKey];
            readableParamName.forEach((param)=>{
                trackCookieObject[param] = keyValStr;
            });
        } else // parse and set gclid related data
        if (keyValStr.includes('gclid=')) {
            const kvs = keyValStr.split('|');
            kvs.forEach((kv)=>{
                const [key, val] = kv.split('=').slice(0, 2);
                if (key && val && (0, $jPIgV.gclidKeySet).has(key)) trackCookieObject[key] = val;
            });
        }
    });
    return trackCookieObject;
}
function $0a3ea60d32b203ad$var$getTrackCookieDataArray() {
    const trackCookieVal = $0a3ea60d32b203ad$var$getTrackCookiesBase64();
    if (trackCookieVal) try {
        return window.JSON.parse(window.atob(trackCookieVal));
    } catch (_a) {
        return [];
    }
    return [];
}
// gets decoded 'track_cookie' which is an array
// This cookie is a list of marketing fields to collect.
// Where this cookie is set: https://github.com/squareup/xms/blob/main/app/controllers/marketing_tracking_controller.rb#L11C5-L29
// Business context for this cookie: https://docs.google.com/document/d/1PMNf8K9aV7EmaVFXMTzzJQmBFqeKEhuW5rqxj-h6R_Q/edit
function $0a3ea60d32b203ad$var$getTrackCookiesBase64() {
    const value = (0, $7tMaX.cookies).get((0, $4ya6m.CookieNames).trackCookie);
    if (value) try {
        return decodeURIComponent(value.split('--')[0]);
    } catch (_a) {
        return '';
    }
    return '';
}


// These helper functions are pulled
// from Segment's open source code
function $44e59744a5cbd3d4$export$4a68843152603124(search) {
    const canon = $44e59744a5cbd3d4$export$6885068ab384f932();
    if (canon) return canon.includes('?') ? canon : canon + (search !== null && search !== void 0 ? search : '');
    const url = window.location.href;
    const i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
}
function $44e59744a5cbd3d4$export$5e8a4ad862d86f90() {
    const canon = $44e59744a5cbd3d4$export$6885068ab384f932();
    if (!canon) return window.location.pathname;
    const parts = canon.split('.');
    const lastPartOfString = String(parts.at(-1));
    const i = lastPartOfString.indexOf('/');
    return lastPartOfString.slice(i);
}
function $44e59744a5cbd3d4$export$6885068ab384f932() {
    const tags = document.getElementsByTagName('link');
    for(let i = 0, tag; tag = tags[i]; i++){
        if (tag.getAttribute('rel') === 'canonical') return tag.getAttribute('href');
    }
    return null;
}



var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");
const $cd2f0f4c1dae1055$export$71998e95cfdeda6f = (()=>{
    const names = [];
    [
        (0, $4ya6m.StoreNames),
        (0, $4ya6m.CookieNames),
        (0, $4ya6m.LegacyStoreNames)
    ].forEach((obj)=>{
        for(const cookieKey in obj){
            const cookieName = obj[cookieKey];
            names.push(cookieName);
        }
    });
    return names;
})();
function $cd2f0f4c1dae1055$export$70ac24b0f6c7dc9c() {
    return Object.fromEntries(Object.entries((0, $7tMaX.cookies).get()).filter(([key])=>key === '_ga'));
}



// These helper functions are pulled
// from Segment's open source code
function $16c4560839fd69fc$export$b255f37afd2ff5f6() {
    const referrer = document.referrer;
    // try catch ensures that the string is a valid URL
    try {
        const refUrl = new URL(referrer);
        return {
            referrer: referrer,
            referrerHost: refUrl.host,
            referrerPath: refUrl.pathname,
            referrerSearch: refUrl.search
        };
    } catch (_a) {
        return {
            referrer: referrer
        };
    }
}




function $208157b8af005556$export$79f13b4cfaaf0d09() {
    // Currently only Chrome OS provides a means of determining the exact type of connection
    // Navigator.connection.effectiveType only (roughly) communicates speed and rtt
    // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType
    // cdp-ingest will fill in ip address if the client doesn't provide it
    return {
        type: (0, $672932446cb1cea7$export$4a868a35d3b57055).UNKNOWN_NETWORK,
        ipAddress: ''
    };
}


function $5189b9e29af607d9$export$28055d25e3f96ec1(messageOptions) {
    var _a, _b, _c, _d;
    const pageSessionToken = (_b = (_a = messageOptions.page) === null || _a === void 0 ? void 0 : _a.session_token) !== null && _b !== void 0 ? _b : '';
    const normalizedPageSessionToken = typeof pageSessionToken === 'string' ? pageSessionToken : JSON.stringify(pageSessionToken);
    const pageStartTimeMillis = (_d = (_c = messageOptions.page) === null || _c === void 0 ? void 0 : _c.startTimeMillis) !== null && _d !== void 0 ? _d : 0;
    const normalizedPageStartTimeMillis = typeof pageStartTimeMillis === 'number' ? pageStartTimeMillis : 0;
    return {
        token: normalizedPageSessionToken,
        startTimeMillis: normalizedPageStartTimeMillis
    };
}



var $86Wyx = parcelRequire("86Wyx");
const $0ebeec0c4d01ce76$export$1eb6b8b126069c1b = 2097152;
function $0ebeec0c4d01ce76$export$e62c8bdf49504150(object) {
    for(const k in object){
        const key = k;
        if (typeof object[key] === 'object' && object[key] !== null) $0ebeec0c4d01ce76$export$e62c8bdf49504150(object[key]);
        else if (typeof object[key] === 'string') {
            const value = object[key];
            if (value.length > $0ebeec0c4d01ce76$export$1eb6b8b126069c1b) {
                const truncatedValue = value.slice(0, $0ebeec0c4d01ce76$export$1eb6b8b126069c1b);
                Object.defineProperty(object, key, {
                    value: truncatedValue,
                    writable: true,
                    configurable: true,
                    enumerable: true
                });
            }
        }
    }
}


let $787adfe79aa608a3$var$metrics = null;
function $787adfe79aa608a3$export$6c5004d5490ddf9e() {
    if ($787adfe79aa608a3$var$metrics === null) $787adfe79aa608a3$var$metrics = (0, (/*@__PURE__*/$parcel$interopDefault($86Wyx)))(window.navigator.userAgent);
    const contextObj = Object.assign(Object.assign({}, this.options.app ? {
        app: this.options.app
    } : {}), {
        application: this.application,
        browser: {
            name: $787adfe79aa608a3$var$metrics.browser.name,
            version: $787adfe79aa608a3$var$metrics.browser.version,
            height: window.innerHeight,
            width: window.innerWidth
        },
        campaign: (0, $0a3ea60d32b203ad$export$2afae91a33db1d52)(),
        cookies: (0, $cd2f0f4c1dae1055$export$70ac24b0f6c7dc9c)(),
        library: {
            name: (0, $jPIgV.LIBRARY_NAME),
            version: (0, $jPIgV.LIBRARY_VERSION)
        },
        locale: {
            countryCode: window.navigator.language.split('-')[1],
            language: window.navigator.language
        },
        network: (0, $208157b8af005556$export$79f13b4cfaaf0d09)(),
        os: {
            name: $787adfe79aa608a3$var$metrics.os.name,
            version: $787adfe79aa608a3$var$metrics.os.version
        },
        page: Object.assign({
            path: (0, $44e59744a5cbd3d4$export$5e8a4ad862d86f90)(),
            referrer: document.referrer,
            search: location.search,
            title: document.title,
            url: (0, $44e59744a5cbd3d4$export$4a68843152603124)(location.search),
            realPath: window.location.pathname,
            realUrl: window.location.href
        }, this.options.page),
        referrer: (0, $16c4560839fd69fc$export$b255f37afd2ff5f6)(),
        session: (0, $5189b9e29af607d9$export$28055d25e3f96ec1)(this.options),
        subject: this.makeContextSubject(),
        traits: this.user.entityTraits,
        userAgent: window.navigator.userAgent
    });
    (0, $0ebeec0c4d01ce76$export$e62c8bdf49504150)(contextObj);
    return contextObj;
}




var $hNQFu = parcelRequire("hNQFu");
$parcel$exportWildcard($9b8221f76ec3a444$exports, $hNQFu);


var $hNQFu = parcelRequire("hNQFu");
parcelRequire("5o0ob");
var $i34zz = parcelRequire("i34zz");

var $lfTBe = parcelRequire("lfTBe");
/* eslint-disable @typescript-eslint/no-explicit-any,no-param-reassign */ // This is based on https://github.com/voodoocreation/ts-deepmerge/blob/master/src/index.ts but embedded directly
// for more control and smaller install footprint.

var $i34zz = parcelRequire("i34zz");
function $bad08ba8e8d78b41$var$merge(...objects) {
    return objects.reduce((result, current)=>{
        if (Array.isArray(current)) throw new TypeError('Arguments provided to ts-deepmerge must be objects, not arrays.');
        Object.keys(current).forEach((key)=>{
            if ([
                '__proto__',
                'constructor',
                'prototype'
            ].includes(key)) return;
            if (Array.isArray(result[key]) && Array.isArray(current[key])) result[key] = $bad08ba8e8d78b41$var$merge.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
            else if ((0, $i34zz.isObject)(result[key]) && (0, $i34zz.isObject)(current[key])) result[key] = $bad08ba8e8d78b41$var$merge(result[key], current[key]);
            else result[key] = current[key];
        });
        return result;
    }, {});
}
const $bad08ba8e8d78b41$var$defaultOptions = {
    mergeArrays: true
};
$bad08ba8e8d78b41$var$merge.options = $bad08ba8e8d78b41$var$defaultOptions;
$bad08ba8e8d78b41$var$merge.withOptions = (options, ...objects)=>{
    $bad08ba8e8d78b41$var$merge.options = Object.assign({
        mergeArrays: true
    }, options);
    const result = $bad08ba8e8d78b41$var$merge(...objects);
    $bad08ba8e8d78b41$var$merge.options = $bad08ba8e8d78b41$var$defaultOptions;
    return result;
};
var $bad08ba8e8d78b41$export$2e2bcd8739ae039 /* eslint-enable @typescript-eslint/no-explicit-any,no-param-reassign */  = $bad08ba8e8d78b41$var$merge;



var $4ya6m = parcelRequire("4ya6m");
/**
 * Takes properties from second object and assigns them to first if not found in the first.
 * Mutates first object, returns nothing
 */ function $76eec1bf4cde68f4$export$d4cd6183e892663c(obj1, obj2) {
    const keys = Object.keys(obj2);
    for (const key of keys)if (obj1[key] === undefined) // eslint-disable-next-line no-param-reassign
    obj1[key] = obj2[key];
}


class $5f721bab78e7c1d2$export$2e2bcd8739ae039 {
    constructor({ queue: queue, user: user, application: application, apiKey: apiKey }){
        this.queue = queue;
        this.user = user;
        this.apiKey = apiKey;
        this.properties = {};
        this.options = {};
        this.integrations = {};
        this.application = application;
        // these functions need reference to this context
        this.entityMatch = (0, $hNQFu.entityMatch).bind(this);
        this.makeContextObj = (0, $787adfe79aa608a3$export$6c5004d5490ddf9e).bind(this);
        this.makeContextSubject = (0, $hNQFu.makeContextSubject).bind(this);
        this.getProp = (0, $hNQFu.getProp).bind(this);
    }
    call(msg, options) {
        var _a;
        if (((0, $i34zz.isTrack)(msg) || (0, $i34zz.isPage)(msg)) && msg.properties) this.properties = msg.properties;
        this.integrations = (_a = options.integrations) !== null && _a !== void 0 ? _a : {};
        this.options = options;
        const message = (0, $lfTBe.default)(this.makePayload(msg, options.overrides));
        window.dispatchEvent(new CustomEvent((0, $4ya6m.EmittedEvents).Invoke, {
            detail: {
                message: message,
                cdpVersion: (0, $ca170cd16ede12af$export$d7d96948c398f9d2)(message)
            }
        }));
        this.queue.push(message);
    }
    /**
     * Payload Documentation
     * {@link  https://zeroheight.com/55c402603/v/latest/p/61d3c0-data-api-reference/b/37f1b1}
     */ makePayload(msg, overrides) {
        const context = this.makeContextObj();
        if ((0, $i34zz.isIdentify)(msg)) // if identify, remove traits from context object
        delete context.traits;
        // if page, copy context.page to properties
        if ((0, $i34zz.isPage)(msg) && msg.properties) {
            /* eslint-disable no-param-reassign */ msg.properties.name = msg.name;
            msg.properties.category = msg.category;
            /* eslint-enable no-param-reassign */ (0, $76eec1bf4cde68f4$export$d4cd6183e892663c)(msg.properties, context.page);
        }
        if (!(0, $i34zz.isSchemaMessage)(msg)) // eslint-disable-next-line no-param-reassign
        msg.apiKey = this.apiKey;
        const payload = Object.assign(Object.assign({}, msg), {
            anonymousId: (0, $l73hA.getAndSetAvtSafe)(),
            entityType: this.user.entityType,
            entityId: this.user.entityType === (0, $4ya6m.EntityTypes).anonVisitor ? '' // CDP does not expect an entity ID if type is anonVisitor
             : this.user.entityId,
            context: context,
            integrations: this.integrations,
            messageId: (0, $5sKyw.default)(),
            originalTimestamp: new Date().toISOString(),
            sentAt: null,
            timestamp: new Date().toISOString()
        });
        return (0, $bad08ba8e8d78b41$export$2e2bcd8739ae039)(payload, overrides !== null && overrides !== void 0 ? overrides : {});
    }
}


class $4530a0811e382d39$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ apiKey: apiKey, eventName: eventName, properties: properties = {}, options: options = {} }) {
        this.call({
            apiKey: apiKey,
            properties: properties,
            eventName: eventName,
            apiMethod: 'track'
        }, options);
    }
}



class $49d49fe11063b2c9$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ event: event, options: options = {} }) {
        this.call({
            event: event,
            apiMethod: 'trackWithSchema'
        }, options);
    }
}



class $e029523b7e4ed9b6$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ apiKey: apiKey, traits: traits = {}, options: options = {} }) {
        this.call({
            apiKey: apiKey,
            traits: traits,
            apiMethod: 'identify'
        }, options);
    }
}



class $0a3a9563611064e5$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ identify: identify, options: options = {} }) {
        this.call({
            identify: identify,
            apiMethod: 'identifyWithSchema'
        }, options);
    }
}



class $3d1b628e06db0d94$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ apiKey: apiKey, pageCategory: pageCategory, pageName: pageName, properties: properties = {}, options: options = {} }) {
        this.call({
            apiKey: apiKey,
            properties: properties,
            apiMethod: 'page',
            name: pageName,
            category: pageCategory
        }, options);
    }
}



class $240633c0466106e8$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ apiKey: apiKey, groupId: groupId, traits: traits = {}, options: options = {} }) {
        this.call({
            apiKey: apiKey,
            groupId: groupId,
            traits: traits,
            apiMethod: 'group'
        }, options);
    }
}



class $68674487ba958ae6$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire({ groupId: groupId, group: group, removeGroup: removeGroup, options: options = {} }) {
        this.call({
            groupId: groupId,
            group: group,
            removeGroup: removeGroup,
            apiMethod: 'groupWithSchema'
        }, options);
    }
}



var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $4BZ7p = parcelRequire("4BZ7p");
var $i34zz = parcelRequire("i34zz");
var $fvmH2 = parcelRequire("fvmH2");
var $hLZet = parcelRequire("hLZet");
var $f6qDi = parcelRequire("f6qDi");

var $i34zz = parcelRequire("i34zz");

var $l73hA = parcelRequire("l73hA");
class $39aefecf4ce2d04e$export$f15b3b9a7d41d3aa {
    constructor({ apiKey: apiKey, application: application, environment: environment, batchSize: batchSize, maxRetryAttempts: maxRetryAttempts, maxTimeBetweenFlushes: maxTimeBetweenFlushes, logEventsToConsole: logEventsToConsole = (0, $4ya6m.LogEventsToConsole).default, useSameOrigin: useSameOrigin = false, useAnalyticsProxy: useAnalyticsProxy = false }){
        this.key = apiKey;
        this.version = (0, $jPIgV.LIBRARY_VERSION);
        this.name = (0, $jPIgV.LIBRARY_NAME);
        this.user = new (0, $fd3bbd181df177da$export$1f44aaf2ec115b54)({
            key: apiKey !== null && apiKey !== void 0 ? apiKey : application.name
        });
        this.application = application;
        (0, $4BZ7p.assignReadOnly)(this, 'key', this.key);
        (0, $4BZ7p.assignReadOnly)(this, 'version', this.version);
        (0, $4BZ7p.assignReadOnly)(this, 'name', this.name);
        (0, $4BZ7p.assignReadOnly)(this, 'user', this.user);
        (0, $4BZ7p.assignReadOnly)(this, 'application', this.application);
        let url;
        switch(environment){
            case (0, $4ya6m.Environments).production:
                url = {
                    v1: "https://api.squareup.com/v1/cdp/batch" /* CDP_URL.production */ ,
                    v2: "https://api.squareup.com/1.0/unifiedevents/batch" /* CDP_V2_URL.production */ ,
                    proxy: "https://api.squareup.com/1.0/log/analyticsEvent" /* PROXY_URL.production */ 
                };
                this.environment = (0, $4ya6m.Environments).production;
                (0, $4BZ7p.assignReadOnly)(this, 'environment', (0, $4ya6m.Environments).production);
                break;
            case (0, $4ya6m.Environments).localDev:
                url = {
                    v1: "http://localhost:3000/v1/cdp/batch" /* CDP_URL.development */ ,
                    v2: "http://localhost:3000/1.0/unifiedevents/batch" /* CDP_V2_URL.development */ ,
                    proxy: "http://localhost:3000/1.0/log/analyticsEvent" /* PROXY_URL.development */ 
                };
                this.environment = (0, $4ya6m.Environments).localDev;
                (0, $4BZ7p.assignReadOnly)(this, 'environment', (0, $4ya6m.Environments).development);
                break;
            default:
                url = {
                    v1: "https://api.squarestagingexternal.com/v1/cdp/batch" /* CDP_URL.stage */ ,
                    v2: "https://api.squareupstaging.com/1.0/unifiedevents/batch" /* CDP_V2_URL.stage */ ,
                    proxy: "https://api.squareupstaging.com/1.0/log/analyticsEvent" /* PROXY_URL.stage */ 
                };
                this.environment = (0, $4ya6m.Environments).stage;
                (0, $4BZ7p.assignReadOnly)(this, 'environment', (0, $4ya6m.Environments).stage);
                break;
        }
        if (useSameOrigin) {
            this.url = {
                v1: `${window.location.origin}/v1/cdp/batch`,
                v2: `${window.location.origin}/1.0/unifiedevents/batch`,
                proxy: `${window.location.origin}/1.0/log/analyticsEvent`
            };
            (0, $4BZ7p.assignReadOnly)(this.url, 'v1', `${window.location.origin}/v1/cdp/batch`);
            (0, $4BZ7p.assignReadOnly)(this.url, 'v2', `${window.location.origin}/1.0/unifiedevents/batch`);
            (0, $4BZ7p.assignReadOnly)(this.url, 'proxy', `${window.location.origin}/1.0/log/analyticsEvent`);
        } else {
            this.url = url;
            (0, $4BZ7p.assignReadOnly)(this.url, 'v1', url.v1);
            (0, $4BZ7p.assignReadOnly)(this.url, 'v2', url.v2);
        }
        this.queue = new (0, $8724debf7a85666b$export$1a39c19cecd1c26)({
            url: this.url,
            environment: this.environment,
            batchSize: batchSize,
            maxRetryAttempts: maxRetryAttempts,
            maxTimeBetweenFlushes: maxTimeBetweenFlushes,
            key: apiKey !== null && apiKey !== void 0 ? apiKey : application.name,
            useAnalyticsProxy: useAnalyticsProxy
        });
        (0, $4BZ7p.assignReadOnly)(this, 'queue', this.queue);
        this.setConfig('logEventsToConsole', logEventsToConsole);
    }
    setConfig(setting, value) {
        if (setting === undefined || value === undefined) (0, $fvmH2.throwError)(`No value passed for "${setting}"`);
        switch(setting){
            case 'maxRetryAttempts':
            case 'batchSize':
            case 'maxTimeBetweenFlushes':
                if (!Number.isNaN(Number(value))) {
                    this.queue[setting] = Number(value);
                    return;
                }
                break;
            case 'logEventsToConsole':
                if (Object.values((0, $4ya6m.LogEventsToConsole)).includes(value)) {
                    this.queue[setting] = (0, $fvmH2.shouldLogEventsToConsole)(value, this.environment);
                    return;
                }
                break;
            default:
                (0, $fvmH2.throwError)(`"${setting}" is not a valid setting`);
        }
        (0, $fvmH2.throwError)(`Invalid value passed for "${setting}"`);
    }
    getConfig(setting) {
        switch(setting){
            case 'maxRetryAttempts':
            case 'batchSize':
            case 'maxTimeBetweenFlushes':
                return this.queue[setting];
            case 'name':
            case 'version':
            case 'environment':
                return this[setting];
            case 'logEventsToConsole':
                return this.queue.logEventsToConsole;
            default:
        }
        return undefined;
    }
    get hasActiveEventListeners() {
        return Boolean(this.queue.eventListeners.pageHide.length > 0 || this.queue.eventListeners.visibilityChange.length > 0);
    }
    /**
     * Remove all event listeners so a library instance can be safely deleted
     */ removeEventListeners() {
        this.queue.removeEventListeners();
    }
    /**
     * Backwards compatible track function.
     * Use the trackStrict method if writing new API calls.
     */ track(eventName, properties, options, callbackFn) {
        // check that event name is a valid non-empty string
        if (!(0, $i34zz.isString)(eventName) || !eventName.trim()) (0, $fvmH2.throwError)('"eventName" argument is required.');
        // Argument reshuffling code copied from data-api.js
        /* eslint-disable no-param-reassign */ if ((0, $i34zz.isFunction)(options)) {
            callbackFn = options;
            options = undefined;
        }
        if ((0, $i34zz.isFunction)(properties)) {
            callbackFn = properties;
            options = undefined;
            properties = {};
        }
        /* eslint-enable no-param-reassign */ if (properties && !(0, $i34zz.isRecord)(properties)) (0, $fvmH2.warn)('Argument "properties" is not an object. Use the trackStrict method which has consistent method arguments.');
        this.trackStrict({
            eventName: eventName,
            eventProps: (0, $i34zz.isRecord)(properties) ? properties : {},
            options: options !== null && options !== void 0 ? options : {}
        });
        (0, $hLZet.timeout)(callbackFn);
        return this;
    }
    /**
     * Type safe track function
     */ trackStrict(trackArgs) {
        const { eventName: eventName, eventProps: eventProps, options: options } = trackArgs;
        if (this.key === undefined) (0, $fvmH2.throwError)('API key is required for track events');
        new (0, $4530a0811e382d39$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application,
            apiKey: this.key
        }).fire({
            apiKey: this.key,
            eventName: eventName,
            properties: eventProps !== null && eventProps !== void 0 ? eventProps : {},
            options: options
        });
    }
    trackWithSchema(event, options) {
        new (0, $49d49fe11063b2c9$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application
        }).fire({
            event: event,
            options: options
        });
    }
    parseSchemaTraits(traits) {
        const parsedTraits = (0, $f6qDi.unwrapSchemaObject)(traits);
        return (0, $i34zz.isTraits)(parsedTraits) ? parsedTraits : undefined;
    }
    withSchemaEntityType(options, entityType) {
        var _a;
        if (((_a = options === null || options === void 0 ? void 0 : options.overrides) === null || _a === void 0 ? void 0 : _a.entityType) !== undefined) return options;
        return Object.assign(Object.assign({}, options), {
            overrides: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.overrides), {
                entityType: entityType
            })
        });
    }
    identifyWithSchema(identifyArgs, options) {
        var _a, _b, _c;
        const entityId = (_a = options === null || options === void 0 ? void 0 : options.overrides) === null || _a === void 0 ? void 0 : _a.entityId;
        const entityType = (_c = (_b = options === null || options === void 0 ? void 0 : options.overrides) === null || _b === void 0 ? void 0 : _b.entityType) !== null && _c !== void 0 ? _c : identifyArgs.identify.entity;
        const schemaOptions = this.withSchemaEntityType(options, identifyArgs.identify.entity);
        if ((0, $i34zz.isString)(entityId) && (0, $i34zz.isEntity)(entityType)) this.user._identify(entityId, entityType, this.parseSchemaTraits(identifyArgs.identify.traits));
        new (0, $0a3a9563611064e5$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application
        }).fire({
            identify: identifyArgs.identify,
            options: schemaOptions
        });
    }
    /**
     * Backwards compatible identify function.
     * Use the identifyStrict method if writing new API calls.
     */ identify(// no validation for entity Id or Type as this will default
    // to anonymous with AVT if values here are incorrect
    entityId, entityType, traits, options, callbackFn) {
        // Argument reshuffling code copied from data-api.js
        /* eslint-disable no-param-reassign */ if ((0, $i34zz.isFunction)(options)) {
            callbackFn = options;
            options = null;
        }
        if ((0, $i34zz.isFunction)(traits)) {
            callbackFn = traits;
            options = null;
            traits = null;
        }
        /* eslint-enable no-param-reassign */ if (traits && !(0, $i34zz.isTraits)(traits)) (0, $fvmH2.warn)('Argument "traits" is not an object. Use the identifyStrict method which has consistent method arguments.');
        this.identifyStrict({
            entityId: entityId,
            entityType: entityType,
            traits: (0, $i34zz.isTraits)(traits) ? traits : {},
            options: options !== null && options !== void 0 ? options : {}
        });
        (0, $hLZet.timeout)(callbackFn);
        return this;
    }
    /**
     * Type safe track function
     */ identifyStrict(identifyArgs) {
        if (this.key === undefined) (0, $fvmH2.throwError)('API key is required for identify events');
        const { entityId: entityId, entityType: entityType, traits: traits, options: options } = identifyArgs;
        this.user._identify(entityId, entityType, traits);
        new (0, $e029523b7e4ed9b6$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application,
            apiKey: this.key
        }).fire({
            apiKey: this.key,
            traits: this.user.entityTraits,
            options: options
        });
    }
    /**
     * Backwards compatible page function.
     * Use the pageStrict method if writing new API calls.
     */ page(pageCategory, pageName, properties, options, callbackFn) {
        // Argument reshuffling code copied from data-api.js
        /* eslint-disable no-param-reassign */ if ((0, $i34zz.isFunction)(options)) {
            callbackFn = options;
            options = null;
        }
        if ((0, $i34zz.isFunction)(properties)) {
            callbackFn = properties;
            options = properties = null;
        }
        if ((0, $i34zz.isFunction)(pageName)) {
            callbackFn = pageName;
            options = properties = pageName = undefined;
        }
        if ((0, $i34zz.isObject)(pageCategory)) {
            options = pageName;
            properties = pageCategory;
            pageName = pageCategory = undefined;
        }
        if ((0, $i34zz.isObject)(pageName)) {
            options = properties;
            properties = pageName;
            pageName = undefined;
        }
        if ((0, $i34zz.isString)(pageCategory) && !(0, $i34zz.isString)(pageName)) {
            pageName = pageCategory;
            pageCategory = undefined;
        }
        /* eslint-enable no-param-reassign */ if (pageCategory && !(0, $i34zz.isString)(pageCategory)) (0, $fvmH2.warn)('Argument "pageCategory" is not a string. Use the pageStrict method which has consistent method arguments.');
        if (pageName && !(0, $i34zz.isString)(pageName)) (0, $fvmH2.warn)('Argument "pageName" is not a string. Use the pageStrict method which has consistent method arguments.');
        if (properties && !(0, $i34zz.isRecord)(properties)) (0, $fvmH2.warn)('Argument "properties" is not an object. Use the pageStrict method which has consistent method arguments.');
        if (options && !(0, $i34zz.isRecord)(options)) (0, $fvmH2.warn)('Argument "options" is not an object. Use the pageStrict method which has consistent method arguments.');
        this.pageStrict({
            pageCategory: (0, $i34zz.isString)(pageCategory) ? pageCategory : undefined,
            pageName: (0, $i34zz.isString)(pageName) ? pageName : undefined,
            eventProps: (0, $i34zz.isRecord)(properties) ? properties : undefined,
            options: (0, $i34zz.isRecord)(options) ? options : undefined
        });
        (0, $hLZet.timeout)(callbackFn);
        return this;
    }
    /**
     * Type safe page function
     */ pageStrict(pageArgs) {
        const { pageCategory: pageCategory, pageName: pageName, eventProps: eventProps, options: options } = pageArgs;
        if (this.key === undefined) (0, $fvmH2.throwError)('API key is required for page events');
        new (0, $3d1b628e06db0d94$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application,
            apiKey: this.key
        }).fire({
            apiKey: this.key,
            pageCategory: pageCategory,
            pageName: pageName,
            properties: eventProps !== null && eventProps !== void 0 ? eventProps : {},
            options: options
        });
    }
    /**
     * Unsupported group function. Reach out to #proj-cdp-js
     * if you intend to use this function.
     */ group(groupId, traits, options) {
        this.groupStrict({
            groupId: groupId,
            traits: traits,
            options: options
        });
        return this;
    }
    groupStrict(groupArgs) {
        if (this.key === undefined) (0, $fvmH2.throwError)('API key is required for group events');
        const { groupId: groupId, traits: traits, options: options } = groupArgs;
        new (0, $240633c0466106e8$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application,
            apiKey: this.key
        }).fire({
            apiKey: this.key,
            groupId: groupId,
            traits: traits,
            options: options
        });
    }
    groupWithSchema(groupArgs, options) {
        const schemaOptions = this.withSchemaEntityType(options, groupArgs.group.entity);
        new (0, $68674487ba958ae6$export$2e2bcd8739ae039)({
            queue: this.queue,
            user: this.user,
            application: this.application
        }).fire({
            groupId: groupArgs.groupId,
            group: groupArgs.group,
            removeGroup: groupArgs.removeGroup,
            options: schemaOptions
        });
    }
}
var $39aefecf4ce2d04e$export$2e2bcd8739ae039 = $39aefecf4ce2d04e$export$f15b3b9a7d41d3aa;


var $4ya6m = parcelRequire("4ya6m");

const $d0d964ae431b09d8$var$API_KEY_STAGING = "832421b1-5d5b-4b01-bfd5-caa9fb405c7d";
const $d0d964ae431b09d8$var$API_KEY_PRODUCTION = "0ad09861-154b-4304-b1e1-84b23026a89e";
const $d0d964ae431b09d8$var$getApiKey = (environment)=>{
    switch(environment){
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Development:
            return "TEST_API_KEY";
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Staging:
            return $d0d964ae431b09d8$var$API_KEY_STAGING;
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Production:
            return $d0d964ae431b09d8$var$API_KEY_PRODUCTION;
        default:
            throw new Error("Unsupported environment for CDP");
    }
};
const $d0d964ae431b09d8$var$getEnvironment = (environment)=>{
    switch(environment){
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Development:
            return (0, $4ya6m.Environments).localDev;
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Staging:
            return (0, $4ya6m.Environments).stage;
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Production:
            return (0, $4ya6m.Environments).production;
        default:
            throw new Error("Unsupported environment for CDP");
    }
};
const $d0d964ae431b09d8$export$ba9fd443d3b686ce = (environment)=>new (0, $39aefecf4ce2d04e$export$f15b3b9a7d41d3aa)({
        apiKey: $d0d964ae431b09d8$var$getApiKey(environment),
        application: {
            name: "bb-web"
        },
        environment: $d0d964ae431b09d8$var$getEnvironment(environment)
    });
const $d0d964ae431b09d8$export$d66a1788a2497e64 = (personToken)=>({
        entityType: (0, $4ya6m.EntityTypes).person,
        entityId: personToken
    });


const $e4f881c141a2f86c$var$CdpContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
function $e4f881c141a2f86c$export$a2c75276dce92780({ environment: environment, personToken: personToken, children: children }) {
    const [cdp, setCdp] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const cdp = (0, $d0d964ae431b09d8$export$ba9fd443d3b686ce)(environment);
        cdp.identifyStrict((0, $d0d964ae431b09d8$export$d66a1788a2497e64)(personToken));
        setCdp(cdp);
    }, []);
    return cdp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4f881c141a2f86c$var$CdpContext.Provider, {
        value: cdp,
        children: children
    }) : null;
}
const $e4f881c141a2f86c$export$b2b9e07b4a5e09bc = ()=>{
    const cdp = (0, $acw62.useContext)($e4f881c141a2f86c$var$CdpContext);
    if (!cdp) throw new Error("Trying to use CDP hook but CDP instance has been be created");
    return cdp;
};




var $acw62 = parcelRequire("acw62");
const $6a9ee46bb299cc77$var$UserContext = /*#__PURE__*/ (0, $acw62.createContext)([
    undefined,
    ()=>undefined
]);
function $6a9ee46bb299cc77$export$88f24fd8fcfab6ca({ initialUser: initialUser, children: children }) {
    // TODO(cvu): Handle responsibility of re-fetching person data into UserContext
    // Tech debt ticket: https://jira.sqprod.co/browse/SQCARD-2840
    const [user, setUser] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (initialUser) {
            if (user) throw new Error("User already set. Please use `setUser` from context to update User");
            setUser(initialUser);
        }
    }, [
        initialUser
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a9ee46bb299cc77$var$UserContext.Provider, {
        value: [
            user,
            setUser
        ],
        children: children
    });
}
const $6a9ee46bb299cc77$export$23bbbc4533528f03 = ()=>(0, $acw62.useContext)($6a9ee46bb299cc77$var$UserContext);






var $615d179a8c27ee51$export$4f67169e154cee8f;
$615d179a8c27ee51$export$4f67169e154cee8f = `C6iQuq_ActionCardListItem_mobileAction`;


var $f3a85f73b7c64a2a$export$8654921a6a5908fc;
var $f3a85f73b7c64a2a$export$7466047bb510a932;
var $f3a85f73b7c64a2a$export$120ff0929b202a6d;
var $f3a85f73b7c64a2a$export$7c29df341f8f08e0;
$f3a85f73b7c64a2a$export$8654921a6a5908fc = `QapKMW_CardList_cardImage`;
$f3a85f73b7c64a2a$export$7466047bb510a932 = `QapKMW_CardList_cardImageContainer`;
$f3a85f73b7c64a2a$export$120ff0929b202a6d = `QapKMW_CardList_row`;
$f3a85f73b7c64a2a$export$7c29df341f8f08e0 = `QapKMW_CardList_rowContainer`;





parcelRequire("acw62");
const $55dd9b3900c1b5df$var$SvgUnclaimedCard = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 63",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 99,
                height: 62,
                x: 0.5,
                y: 0.5,
                fill: "#000",
                fillOpacity: 0.03,
                rx: 3.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#fff",
                d: "M51 38.5v-6h6v-2h-6v-6h-2v6h-6v2h6v6z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 99,
                height: 62,
                x: 0.5,
                y: 0.5,
                stroke: "url(#unclaimed-card_svg__a)",
                strokeDasharray: "8 3",
                rx: 3.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                    id: "unclaimed-card_svg__a",
                    x1: 50,
                    x2: 50,
                    y1: 1,
                    y2: 62,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            stopOpacity: 0.05
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: 1,
                            stopOpacity: 0.14
                        })
                    ]
                })
            })
        ]
    });
var $55dd9b3900c1b5df$export$2e2bcd8739ae039 = $55dd9b3900c1b5df$var$SvgUnclaimedCard;


const $c132a48b6eaf5d4b$export$4d2ca89a51f2af83 = (cardListItemProps)=>{
    return "buttonText" in cardListItemProps;
};
function $c132a48b6eaf5d4b$export$50fc1233c883cd6d({ buttonText: buttonText, cardImage: cardImage, subtext: subtext, title: title, onItemClick: onItemClick }) {
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
        class: $f3a85f73b7c64a2a$export$120ff0929b202a6d,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "leading-accessory",
                className: $f3a85f73b7c64a2a$export$7466047bb510a932,
                children: cardImage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
                    className: $f3a85f73b7c64a2a$export$8654921a6a5908fc,
                    businessName: cardImage.businessName,
                    signatureDataUri: cardImage?.signatureUri
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55dd9b3900c1b5df$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                slot: "label",
                children: title
            }),
            windowDimensions.isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $615d179a8c27ee51$export$4f67169e154cee8f),
                slot: "subtext",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: subtext
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        onClick: onItemClick,
                        children: buttonText
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        slot: "subtext",
                        children: subtext
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                        slot: "control",
                        rank: "primary",
                        onClick: onItemClick,
                        children: buttonText
                    })
                ]
            })
        ]
    });
}








function $20057657b35eb547$export$9156e7ca4e0589e5({ cardImage: cardImage, subtext: subtext, title: title, onItemClick: onItemClick }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
        class: $f3a85f73b7c64a2a$export$120ff0929b202a6d,
        interactive: true,
        transient: true,
        variant: "drill",
        onClick: onItemClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "leading-accessory",
                className: $f3a85f73b7c64a2a$export$7466047bb510a932,
                children: cardImage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
                    className: $f3a85f73b7c64a2a$export$8654921a6a5908fc,
                    businessName: cardImage.businessName,
                    signatureDataUri: cardImage?.signatureUri
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55dd9b3900c1b5df$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                slot: "label",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                slot: "subtext",
                children: subtext
            })
        ]
    });
}


function $95a30c6e0ec76fc2$export$bb29c16f5612603e({ cardListItems: cardListItems }) {
    const getCardListItemComponent = (props)=>{
        return (0, $c132a48b6eaf5d4b$export$4d2ca89a51f2af83)(props) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c132a48b6eaf5d4b$export$50fc1233c883cd6d), {
            ...props
        }, props.cardToken) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20057657b35eb547$export$9156e7ca4e0589e5), {
            ...props
        }, props.cardToken);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f3a85f73b7c64a2a$export$7c29df341f8f08e0),
        children: cardListItems.map((card)=>getCardListItemComponent(card))
    });
}


var $22e7bf8618bb78d1$export$5736b3a32ef5fe55;
var $22e7bf8618bb78d1$export$252465da46a2ae40;
var $22e7bf8618bb78d1$export$38e42c68cf43b5d4;
var $22e7bf8618bb78d1$export$1ca1ec8b29a4ce27;
var $22e7bf8618bb78d1$export$acf4eaf431084f78;
var $22e7bf8618bb78d1$export$523fb3936f49e028;
$22e7bf8618bb78d1$export$5736b3a32ef5fe55 = `-pzsaG_CardHome_desktopCardLists`;
$22e7bf8618bb78d1$export$252465da46a2ae40 = `-pzsaG_CardHome_emptyState`;
$22e7bf8618bb78d1$export$38e42c68cf43b5d4 = `-pzsaG_CardHome_header`;
$22e7bf8618bb78d1$export$1ca1ec8b29a4ce27 = `-pzsaG_CardHome_icon`;
$22e7bf8618bb78d1$export$acf4eaf431084f78 = `-pzsaG_CardHome_iconContainer`;
$22e7bf8618bb78d1$export$523fb3936f49e028 = `-pzsaG_CardHome_page`;


/**
 * This version of this util file uses the models defined in bb-debit. This will replace the current util
 * once have completely migrated to bb-debit
 */ 

/**
 * This version of this util file uses the models defined in bb-debit. This will replace the current util
 * once have completely migrated to bb-debit
 */ const $12d982416c644898$export$dbbc3f17800c9c64 = (customization)=>{
    const { imageBytes: imageBytes, mimeType: mimeType } = customization;
    if (imageBytes == null || mimeType == null) return "";
    if (imageBytes.length === 0 || mimeType.length === 0) return "";
    const imageString = $12d982416c644898$export$31da71098e0122bc(imageBytes);
    return `data:${mimeType};base64,${imageString}`;
};
const $12d982416c644898$export$31da71098e0122bc = (bytes)=>{
    const bin = bytes.reduce((arr, byte)=>{
        arr.push(String.fromCharCode(byte));
        return arr;
    }, []).join("");
    return btoa(bin);
};



const $1f03a6bc7d91b109$export$af0ed80290d14473 = (card)=>card.fulfillment?.cardCustomization?.cardTexts?.find((cardText)=>cardText.type === (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME)?.text ?? "";
const $1f03a6bc7d91b109$export$f0d76c98e43e3f03 = (card)=>card.fulfillment?.cardCustomization?.cardTexts?.find((cardText)=>cardText.type === (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME)?.text ?? "";
const $1f03a6bc7d91b109$export$461358cf94db3eb1 = (cardCustomization)=>{
    if (cardCustomization) return (0, $12d982416c644898$export$dbbc3f17800c9c64)(cardCustomization);
    return "";
};
const $1f03a6bc7d91b109$export$7f1de93407df59b0 = (card)=>{
    return card.securityCode || "";
};
const $1f03a6bc7d91b109$export$1bbc5be1c1af00a7 = (card)=>{
    const expiration = card.expirationData?.expiration;
    if (!expiration) return "";
    const formatter = new (0, $58cb02b9641cce25$exports.ExpiryDateFormatter)();
    return formatter.format({
        month: expiration.monthOfYear,
        year: expiration.year
    });
};
const $1f03a6bc7d91b109$export$eb37d3dae2bf604a = (card)=>{
    return card.fullPan || "";
};
const $1f03a6bc7d91b109$export$8e48b4074de9a9df = (card)=>card?.status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVATABLE;
const $1f03a6bc7d91b109$export$8a4b2f4654e557c3 = (0, $32d23a4e2afcf5bf$export$90f2e2c209b42f72).create({
    paths: [
        "id",
        "status",
        "card_brand",
        "fulfillment",
        "last_four",
        "full_pan",
        "security_code",
        "can_digital_spend",
        "balance_id",
        "relationship",
        "expiration_data"
    ]
});



const $3263116ab73aeb84$export$3d0307c837ed757 = (t)=>(cards, customizationMap, activationCallback)=>cards.map((card)=>$3263116ab73aeb84$var$createActivatableCardListItem(card, customizationMap.get(card.id) ?? null, t, activationCallback));
function $3263116ab73aeb84$var$createActivatableCardListItem(card, customization, t, activationCallback) {
    const cardImage = $3263116ab73aeb84$export$58d4d1c2211d37f3(card, customization ?? undefined);
    return {
        buttonText: t("cardList.existingCard.activateCard.buttonText"),
        cardImage: cardImage,
        cardToken: card.id,
        subtext: t("cardList.existingCard.lastFourPanText", {
            replace: {
                lastFourPan: card.lastFour
            }
        }),
        title: cardImage.businessName,
        onItemClick: ()=>activationCallback(card)
    };
}
const $3263116ab73aeb84$export$7b36776e8ade4f1a = (navigate, t)=>(cards, customizationMap)=>cards.map((card)=>{
            const customization = customizationMap.get(card.id) ?? null;
            return $3263116ab73aeb84$var$createCardListItem(card, customization, navigate, t);
        });
function $3263116ab73aeb84$var$createCardListItem(card, customization, navigate, t) {
    const cardImage = $3263116ab73aeb84$export$58d4d1c2211d37f3(card, customization ?? undefined);
    return {
        cardImage: cardImage,
        cardToken: card.id,
        subtext: t("cardList.existingCard.lastFourPanText", {
            replace: {
                lastFourPan: card.lastFour
            }
        }),
        title: cardImage.businessName,
        onItemClick: ()=>navigate(`/card/${card.id}/settings`)
    };
}
const $3263116ab73aeb84$export$58d4d1c2211d37f3 = (card, customization)=>({
        businessName: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card),
        signatureUri: (0, $1f03a6bc7d91b109$export$461358cf94db3eb1)(customization)
    });
const $3263116ab73aeb84$export$e6312e49a41c0ec6 = (cards)=>cards.reduce(([accActivatableCards, accClaimedCards], card)=>{
        if (card.status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVATABLE) accActivatableCards.push(card);
        else accClaimedCards.push(card);
        return [
            accActivatableCards,
            accClaimedCards
        ];
    }, [
        [],
        []
    ]);



parcelRequire("acw62");
const $3fe9fa928f0c0d60$var$SvgAlertNoEntry = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m7 9c0 1.57-.53 3.02-1.4 4.18L4.82 3.4C5.98 2.53 7.43 2 9 2c3.86 0 7 3.14 7 7M2 9c0-1.57.53-3.02 1.4-4.18l9.78 9.78C12.02 15.47 10.57 16 9 16c-3.86 0-7-3.14-7-7"
        })
    });
var $3fe9fa928f0c0d60$export$2e2bcd8739ae039 = $3fe9fa928f0c0d60$var$SvgAlertNoEntry;




async function $a5705b90962ee2ab$var$fetchCardsAndInvitations(cardManagementService, bankingWebService, externalBizbankService, t, navigate) {
    // Fetch all Cards and OpenCardInvitations
    const [cardsResponse, invitationsResponse] = await Promise.all([
        cardManagementService.listCards((0, $d272bac0a1712861$export$1f9ff0d796a08011).create()),
        bankingWebService.listOpenCardInvitations((0, $2a6a68ea1459b895$export$498c8f0ad968f111).create())
    ]);
    const cards = [
        ...cardsResponse.cards ?? []
    ];
    // Fetch the CardCustomization, which contains the Signature, for each Card
    // Put the CardCustomizations in a Map for easy access when rendering the cards
    const customizationEntries = await Promise.all(cards.map(async (card)=>{
        const token = card.fulfillment?.cardCustomization?.id;
        if (!token) return [
            card.id,
            null
        ];
        const res = await externalBizbankService.getCardCustomization((0, $3f73c216104868a6$export$1a963d2655841b69).create({
            customizationToken: token
        }));
        return [
            card.id,
            res.cardCustomization ?? null
        ];
    }));
    const customizationMap = new Map(customizationEntries);
    // Separate ActivatableCards from ClaimedCards
    // Create lists of ActionCardListItemProps and CardListItemProps for display
    const [activatableCards, claimedCards] = (0, $3263116ab73aeb84$export$e6312e49a41c0ec6)(cards);
    const activatableCardsListItems = (0, $3263116ab73aeb84$export$3d0307c837ed757)(t)(activatableCards, customizationMap, (card)=>navigate(`/activate-card/${card.id}`));
    const cardsListItems = (0, $3263116ab73aeb84$export$7b36776e8ade4f1a)(navigate, t)(claimedCards, customizationMap);
    return {
        activatableCardsListItems: activatableCardsListItems,
        cardsListItems: cardsListItems,
        cardInvitations: [
            ...invitationsResponse.openCardInvitations ?? []
        ]
    };
}
function $a5705b90962ee2ab$export$1f8c1c7183c9c5f7({ bankingWebCardService: bankingWebCardService, bankingWebComplianceService: bankingWebComplianceService, bankingWebService: bankingWebService, cardManagementService: cardManagementService, externalBizbankService: externalBizbankService, personProfileService: personProfileService, userCardInvitationService: userCardInvitationService, webService: webService }) {
    const cdp = (0, $e4f881c141a2f86c$export$b2b9e07b4a5e09bc)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("common");
    const [user, setUser] = (0, $6a9ee46bb299cc77$export$23bbbc4533528f03)();
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const { isMobile: isMobile } = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [cardInvitations, setCardInvitations] = (0, $acw62.useState)([]);
    const [activatableCardsListItems, setActivatableCardsListItems] = (0, $acw62.useState)([]);
    const [cardsListItems, setCardsListItems] = (0, $acw62.useState)([]);
    const [cardIssuingState, cardIssuingDispatch, cardIssuingWorkflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        bankingWebCardService: bankingWebCardService,
        bankingWebComplianceService: bankingWebComplianceService,
        cardManagementService: cardManagementService,
        personProfileService: personProfileService,
        sentry: {
            captureException: $f2b90654edf2c0a1$export$f5282963edea4a68
        },
        textRenderer: (0, $74c7b72a71b76868$export$2e2bcd8739ae039),
        userCardInvitationService: userCardInvitationService,
        uuid: $5sKyw.default,
        webService: webService
    }, $b2490fa107d6478d$export$e6a0daad8304de(), $b2490fa107d6478d$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        // Initialize the workflow
        cardIssuingWorkflow.states.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(({ done: done })=>done)).subscribe((state)=>{
            personProfileService.getPersonProfile((0, $3f95b099726a1553$export$2ad677b174787c25).create())// TODO(cvu): Figure out how to move the responsibility of re-fetching person data into UserContext
            // Going to leave this for now. Tech debt ticket: https://jira.sqprod.co/browse/SQCARD-2840
            .then((response)=>{
                const profile = response.profile;
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(profile, "Profile does not exist in GetPersonProfileResponse");
                setUser((0, $f52070b5f7ea08cf$export$f0f3a5c436134bc0)(profile));
                navigate(`/card/${state.cardToken}/settings`);
            });
        });
        // Initialize analytics
        (0, $4bc04b71b868732d$export$2e2bcd8739ae039)(cardIssuingWorkflow.updates).subscribe((params)=>{
            cdp.trackStrict(params);
        });
        // Fetch all Cards and Invitations
        const getCards = async ()=>{
            const { activatableCardsListItems: activatableCardsListItems, cardsListItems: cardsListItems, cardInvitations: cardInvitations } = await $a5705b90962ee2ab$var$fetchCardsAndInvitations(cardManagementService, bankingWebService, externalBizbankService, t, navigate);
            setActivatableCardsListItems(activatableCardsListItems);
            setCardsListItems(cardsListItems);
            setCardInvitations(cardInvitations);
            setLoading(false);
        };
        getCards();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (loading) return;
        // Open ordering flow if the person only has one invitation and no cards.
        if (cardInvitations.length === 1 && activatableCardsListItems.length === 0 && cardsListItems.length === 0) {
            cardIssuingDispatch($b2490fa107d6478d$export$c81c36414a1e3192(cardInvitations[0].balanceId, cardInvitations[0].name, cardInvitations[0].cardInvitationToken, user || {
                personToken: "",
                name: {
                    first: "",
                    last: ""
                }
            }, true));
            cardIssuingDispatch($b2490fa107d6478d$export$2085928ad4455e61(true));
        }
    }, [
        loading
    ]);
    const cardInvitationListItems = cardInvitations.map((cardInvitation)=>({
            buttonText: t("cardList.newCard.orderCard.buttonText"),
            cardToken: cardInvitation.cardInvitationToken,
            subtext: t("cardList.newCard.subtext"),
            title: cardInvitation.name,
            onItemClick: ()=>{
                cardIssuingDispatch($b2490fa107d6478d$export$c81c36414a1e3192(cardInvitation.balanceId, cardInvitation.name, cardInvitation.cardInvitationToken, user || {
                    personToken: "",
                    name: {
                        first: "",
                        last: ""
                    }
                }, cardsListItems.length === 0));
                cardIssuingDispatch($b2490fa107d6478d$export$2085928ad4455e61(true));
            }
        }));
    const allListItems = [
        ...cardInvitationListItems,
        ...activatableCardsListItems,
        ...cardsListItems
    ];
    const hasListItems = allListItems.length > 0;
    // Render content based on the state of the Card lists
    const renderContent = ()=>{
        if (!hasListItems) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $22e7bf8618bb78d1$export$252465da46a2ae40,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $22e7bf8618bb78d1$export$acf4eaf431084f78,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fe9fa928f0c0d60$export$2e2bcd8739ae039), {
                        className: $22e7bf8618bb78d1$export$1ca1ec8b29a4ce27
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t("cardHome.emptyState")
                })
            ]
        });
        else if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a30c6e0ec76fc2$export$bb29c16f5612603e), {
            cardListItems: allListItems
        });
        else {
            const actionableItems = [
                ...cardInvitationListItems,
                ...activatableCardsListItems
            ];
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $22e7bf8618bb78d1$export$5736b3a32ef5fe55,
                children: [
                    actionableItems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a30c6e0ec76fc2$export$bb29c16f5612603e), {
                        cardListItems: actionableItems
                    }),
                    cardsListItems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a30c6e0ec76fc2$export$bb29c16f5612603e), {
                        cardListItems: cardsListItems
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $10b264b7e14b606b$export$6955bcca4cd3539f), {
                loading: loading,
                className: $22e7bf8618bb78d1$export$523fb3936f49e028,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("header-30", $22e7bf8618bb78d1$export$38e42c68cf43b5d4),
                        children: t("cardHome.list.header")
                    }),
                    renderContent(),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$910ae8079b2c2852), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd61bc2ba06a0509$export$cee179dbf81603ea), {
                state: cardIssuingState,
                dispatch: cardIssuingDispatch
            })
        ]
    });
}



const $88be25437d5209b9$export$13f025e534889db5 = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $a5705b90962ee2ab$export$1f8c1c7183c9c5f7), {
    bankingWebCardService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).BANKING_WEB_CARD_SERVICE,
    bankingWebComplianceService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).BANKING_WEB_COMPLIANCE_SERVICE,
    bankingWebService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).BANKING_WEB_SERVICE,
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE,
    externalBizbankService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).EXTERNAL_BIZBANK_SERVICE,
    personProfileService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).PERSON_PROFILE_SERVICE,
    userCardInvitationService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).USER_CARD_INVITATION_SERVICE,
    webService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).WEB_SERVICE
});








var $acw62 = parcelRequire("acw62");










var $6f7a3101dc7a9683$export$8d6d009d1f06226e;
var $6f7a3101dc7a9683$export$3914d6a81335784f;
var $6f7a3101dc7a9683$export$38e42c68cf43b5d4;
var $6f7a3101dc7a9683$export$15c60d712917cee6;
$6f7a3101dc7a9683$export$8d6d009d1f06226e = `Y5a8AW_PageHeader_backButton`;
$6f7a3101dc7a9683$export$3914d6a81335784f = `Y5a8AW_PageHeader_backButtonIcon`;
$6f7a3101dc7a9683$export$38e42c68cf43b5d4 = `Y5a8AW_PageHeader_header`;
$6f7a3101dc7a9683$export$15c60d712917cee6 = `Y5a8AW_PageHeader_headerTitle`;


function $0cb7d9ae27028ab3$export$53f1cd6809577fc5({ breadcrumb: breadcrumb, title: title }) {
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    // FIXME(cvu): replace with whatever svg solution we figure out later
    const backArrowSvg = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8H1M1 8L8 1M1 8L8 15",
            stroke: "black",
            strokeOpacity: "0.9",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $6f7a3101dc7a9683$export$38e42c68cf43b5d4),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cec2af50e95548c$export$a6c7ac8248d6e38a), {
                ...breadcrumb.link,
                children: windowDimensions.isMobile ? // For some reason adding classnames makes market button styles go weird if icon only button
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                    rank: "secondary",
                    slot: "navigation",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $6f7a3101dc7a9683$export$3914d6a81335784f),
                        slot: "icon",
                        children: backArrowSvg
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                    className: (0, $6f7a3101dc7a9683$export$8d6d009d1f06226e),
                    rank: "secondary",
                    slot: "navigation",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $6f7a3101dc7a9683$export$3914d6a81335784f),
                            slot: "icon",
                            children: backArrowSvg
                        }),
                        breadcrumb.title
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("heading-20", (0, $6f7a3101dc7a9683$export$15c60d712917cee6)),
                children: title
            })
        ]
    });
}







var $f85882ff218eecf6$export$4d6040b341c06f0d = /*#__PURE__*/ function(CardSettingError) {
    CardSettingError[CardSettingError["None"] = 0] = "None";
    CardSettingError[CardSettingError["Generic"] = 1] = "Generic";
    return CardSettingError;
}({});
const $f85882ff218eecf6$export$36d128238e6b60f5 = {
    card: null,
    cardCustomization: null,
    error: 0,
    loading: true,
    showCardDetails: false,
    toggleLoading: {
        lockCard: false,
        showCardDetails: false
    }
};
const $f85882ff218eecf6$export$e6a0daad8304de = (overrides = {})=>({
        ...$f85882ff218eecf6$export$36d128238e6b60f5,
        ...overrides
    });
var $f85882ff218eecf6$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Initialize"] = "INITIALIZE";
    ActionType["GetCardCustomizationReceived"] = "GET_CARD_CUSTOMIZATION_RECEIVED";
    ActionType["GetCardCustomizationRejected"] = "GET_CARD_CUSTOMIZATION_REJECTED";
    ActionType["LockCardReceived"] = "LOCK_CARD_RECEIVED";
    ActionType["LockCardRejected"] = "LOCK_CARD_REJECTED";
    ActionType["RetrieveCardReceived"] = "RETRIEVE_CARD_RECEIVED";
    ActionType["RetrieveCardRejected"] = "RETRIEVE_CARD_REJECTED";
    ActionType["UnlockCardReceived"] = "UNLOCK_CARD_RECEIVED";
    ActionType["UnlockCardRejected"] = "UNLOCK_CARD_REJECTED";
    ActionType["UserClickActivateCard"] = "USER_CLICK_ACTIVATE_CARD";
    ActionType["UserClickResetPin"] = "USER_CLICK_RESET_PIN";
    ActionType["UserToggleCardDetails"] = "USER_TOGGLE_CARD_DETAILS";
    ActionType["UserToggleLockCard"] = "USER_TOGGLE_LOCK_CARD";
    return ActionType;
}({});
const $f85882ff218eecf6$export$c81c36414a1e3192 = (cardToken)=>({
        type: "INITIALIZE",
        cardToken: cardToken
    });
const $f85882ff218eecf6$export$e4cfa67b45b8795 = (response)=>({
        type: "GET_CARD_CUSTOMIZATION_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$bc7f28f58cbf0d00 = (error)=>({
        type: "GET_CARD_CUSTOMIZATION_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$1bbe87ab8acfab84 = (response)=>({
        type: "LOCK_CARD_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$8e3fd900d5c185c6 = (error)=>({
        type: "LOCK_CARD_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$212307bd3d2bba11 = (response)=>({
        type: "RETRIEVE_CARD_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$d0acd6b8d53632a7 = (error)=>({
        type: "RETRIEVE_CARD_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$5664b27f394d381d = (response)=>({
        type: "UNLOCK_CARD_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$29aa61d5efabae5c = (error)=>({
        type: "UNLOCK_CARD_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$4b6cffd9a01ae17 = ()=>({
        type: "USER_CLICK_ACTIVATE_CARD"
    });
const $f85882ff218eecf6$export$95b3c069ab4a2752 = ()=>({
        type: "USER_CLICK_RESET_PIN"
    });
const $f85882ff218eecf6$export$f74d2d3c457dc478 = (value)=>({
        type: "USER_TOGGLE_CARD_DETAILS",
        value: value
    });
const $f85882ff218eecf6$export$d395068d63fb6384 = (value)=>({
        type: "USER_TOGGLE_LOCK_CARD",
        value: value
    });
function $f85882ff218eecf6$var$handleInitialize(context, action) {
    const { cardToken: cardToken } = action;
    const work = ()=>context.cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
            cardToken: cardToken,
            fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
        })).then($f85882ff218eecf6$export$212307bd3d2bba11, $f85882ff218eecf6$export$d0acd6b8d53632a7);
    return [
        $f85882ff218eecf6$export$36d128238e6b60f5,
        work
    ];
}
function $f85882ff218eecf6$var$handleGetCardCustomizationReceived(context, state, action) {
    const cardCustomization = action.response.cardCustomization ?? (0, $3f73c216104868a6$export$4eecc657670f7f54).create();
    return [
        {
            ...state,
            cardCustomization: cardCustomization,
            loading: false
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleGetCardCustomizationRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings: Fetching card customization failed ${error}`);
    return [
        {
            ...state,
            error: 1,
            loading: false
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleLockCardReceived(context, state, action) {
    const { errors: errors } = action.response;
    if (errors.length > 0) {
        context.sentry.captureException("Card settings [LockCardReceivedAction]: Failed to lock card");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const cardToken = state.card?.id;
    if (cardToken == null) {
        context.sentry.captureException("Card settings [LockCardReceivedAction]: Missing card token");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const work = ()=>context.cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
            cardToken: cardToken,
            fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
        })).then($f85882ff218eecf6$export$212307bd3d2bba11, $f85882ff218eecf6$export$d0acd6b8d53632a7);
    return [
        state,
        work
    ];
}
function $f85882ff218eecf6$var$handleLockCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings [LockCardRejectedAction]: Failed to lock card ${error}`);
    return [
        {
            ...state,
            error: 1,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: false
            }
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleRetrieveCardReceived(context, state, action) {
    const { card: card } = action.response;
    if (card == null) {
        context.sentry.captureException("Card settings: Missing card");
        return [
            {
                ...state,
                error: 1,
                loading: false,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const nextState = {
        ...state,
        card: card,
        loading: false,
        toggleLoading: {
            ...state.toggleLoading,
            lockCard: false
        }
    };
    const customizationToken = card.fulfillment?.cardCustomization?.id;
    if (!customizationToken) return [
        nextState,
        null
    ];
    const work = ()=>context.externalBizbankService.getCardCustomization((0, $3f73c216104868a6$export$1a963d2655841b69).create({
            customizationToken: customizationToken
        })).then($f85882ff218eecf6$export$e4cfa67b45b8795, $f85882ff218eecf6$export$bc7f28f58cbf0d00);
    return [
        nextState,
        work
    ];
}
function $f85882ff218eecf6$var$handleRetrieveCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings: Fetching card failed ${error}`);
    return [
        {
            ...state,
            error: 1,
            loading: false,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: false
            }
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleUnlockCardReceived(context, state, action) {
    const { errors: errors } = action.response;
    if (errors.length > 0) {
        context.sentry.captureException("Card settings [UnlockCardReceivedAction]: Failed to unlock card");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const cardToken = state.card?.id;
    if (cardToken == null) {
        context.sentry.captureException("Card settings [UnlockCardReceivedAction]: Missing card token");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const work = ()=>context.cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
            cardToken: cardToken,
            fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
        })).then($f85882ff218eecf6$export$212307bd3d2bba11, $f85882ff218eecf6$export$d0acd6b8d53632a7);
    return [
        state,
        work
    ];
}
function $f85882ff218eecf6$var$handleUnlockCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings [UnlockCardRejectedAction]: Failed to unlock card ${error}`);
    return [
        {
            ...state,
            error: 1,
            loading: false
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleUserToggleCardDetails(state, action) {
    const { value: value } = action;
    return [
        {
            ...state,
            showCardDetails: value
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleUserToggleLockCard(context, state, action) {
    const { value: value } = action;
    const cardToken = state.card?.id;
    if (cardToken == null) {
        context.sentry.captureException("Card setting [UserToggleLockCardAction]: Missing card token");
        return [
            {
                ...state,
                error: 1
            },
            null
        ];
    }
    if (value) {
        const work = ()=>context.cardManagementService.lockCard((0, $d272bac0a1712861$export$ea294dc182de2c2c).create({
                cardToken: cardToken
            })).then($f85882ff218eecf6$export$1bbe87ab8acfab84, $f85882ff218eecf6$export$8e3fd900d5c185c6);
        return [
            {
                ...state,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: true
                }
            },
            work
        ];
    }
    const work = ()=>context.cardManagementService.unlockCard((0, $d272bac0a1712861$export$708d55e385ca855d).create({
            cardToken: cardToken
        })).then($f85882ff218eecf6$export$5664b27f394d381d, $f85882ff218eecf6$export$29aa61d5efabae5c);
    return [
        {
            ...state,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: true
            }
        },
        work
    ];
}
/**
 * Noop is purely to have the action be called and the side effect will
 * outside the workflow.
 */ function $f85882ff218eecf6$var$noop(state) {
    return [
        state,
        null
    ];
}
const $f85882ff218eecf6$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "INITIALIZE":
                return $f85882ff218eecf6$var$handleInitialize(context, action);
            case "GET_CARD_CUSTOMIZATION_RECEIVED":
                return $f85882ff218eecf6$var$handleGetCardCustomizationReceived(context, state, action);
            case "GET_CARD_CUSTOMIZATION_REJECTED":
                return $f85882ff218eecf6$var$handleGetCardCustomizationRejected(context, state, action);
            case "LOCK_CARD_RECEIVED":
                return $f85882ff218eecf6$var$handleLockCardReceived(context, state, action);
            case "LOCK_CARD_REJECTED":
                return $f85882ff218eecf6$var$handleLockCardRejected(context, state, action);
            case "RETRIEVE_CARD_RECEIVED":
                return $f85882ff218eecf6$var$handleRetrieveCardReceived(context, state, action);
            case "RETRIEVE_CARD_REJECTED":
                return $f85882ff218eecf6$var$handleRetrieveCardRejected(context, state, action);
            case "UNLOCK_CARD_RECEIVED":
                return $f85882ff218eecf6$var$handleUnlockCardReceived(context, state, action);
            case "UNLOCK_CARD_REJECTED":
                return $f85882ff218eecf6$var$handleUnlockCardRejected(context, state, action);
            case "USER_CLICK_ACTIVATE_CARD":
                return $f85882ff218eecf6$var$noop(state);
            case "USER_CLICK_RESET_PIN":
                return $f85882ff218eecf6$var$noop(state);
            case "USER_TOGGLE_CARD_DETAILS":
                return $f85882ff218eecf6$var$handleUserToggleCardDetails(state, action);
            case "USER_TOGGLE_LOCK_CARD":
                return $f85882ff218eecf6$var$handleUserToggleLockCard(context, state, action);
        }
    };
const $f85882ff218eecf6$var$cardSettings = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($f85882ff218eecf6$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $f85882ff218eecf6$export$2e2bcd8739ae039 = $f85882ff218eecf6$var$cardSettings;
















function $81bb7444e996fcbd$export$79391ed63190e48d({ cardholder: cardholder, className: className, cvc: cvc, expirationDate: expirationDate, fullPan: fullPan }) {
    // Add space after every four digits. This only works for Visa and Mastercard
    const formatFullPan = fullPan.replace(/(.{4})/g, "$1 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "335",
        height: "208",
        viewBox: "0 0 335 208",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "335",
                height: "208",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "20",
                width: "335",
                height: "32",
                fill: "url(#paint0_linear_555_74960)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "19",
                y: "141",
                fill: "#101314",
                children: formatFullPan
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "19",
                y: "165",
                fill: "#101314",
                children: [
                    "EXP ",
                    expirationDate
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "108",
                y: "165",
                fill: "#101314",
                children: [
                    "CVC ",
                    cvc
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "19",
                y: "189",
                fill: "#101314",
                children: cardholder
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "272",
                cy: "171",
                r: "17",
                fill: "url(#paint1_linear_555_74960)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "294",
                cy: "171",
                r: "17",
                fill: "url(#paint2_linear_555_74960)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M283 183.962C286.671 180.844 289 176.194 289 171C289 165.806 286.671 161.156 283 158.038C279.329 161.156 277 165.806 277 171C277 176.194 279.329 180.844 283 183.962Z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "paint0_linear_555_74960",
                        x1: "-0.500023",
                        y1: "202.5",
                        x2: "333",
                        y2: "-131",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#A2AAAD"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0.635359",
                                stopColor: "#C2C7CA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A4ABAE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "paint1_linear_555_74960",
                        x1: "255",
                        y1: "188",
                        x2: "289",
                        y2: "154",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#6D6E71"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0.491713",
                                stopColor: "#5A5B5D"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#77787B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "paint2_linear_555_74960",
                        x1: "277",
                        y1: "188",
                        x2: "311",
                        y2: "154",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#C7C8CA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0.502762",
                                stopColor: "#B1B3B6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C7C8CA"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



function $d559914ba3bc587b$export$115f017852a4bb7c({ businessName: businessName, cardholder: cardholder, cvc: cvc, expirationDate: expirationDate, fullPan: fullPan, showCardDetails: showCardDetails = false, signatureDataUri: signatureDataUri }) {
    const previewContainerClassName = showCardDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($211b47b09eb34e54$export$8aade8ce2b5d7e87, $211b47b09eb34e54$export$e97739ba196b52a5) : $211b47b09eb34e54$export$8aade8ce2b5d7e87;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: previewContainerClassName,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($211b47b09eb34e54$export$48c2d0f2f545ac27, $211b47b09eb34e54$export$e57dd03da898490e),
                businessName: businessName,
                signatureDataUri: signatureDataUri
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81bb7444e996fcbd$export$79391ed63190e48d), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($211b47b09eb34e54$export$48c2d0f2f545ac27, $211b47b09eb34e54$export$746c1c87f3ad3d31),
                cardholder: cardholder,
                cvc: cvc,
                expirationDate: expirationDate,
                fullPan: fullPan
            })
        ]
    });
}


var $bd48c8ef11defcf4$exports = {};

$parcel$export($bd48c8ef11defcf4$exports, "container", () => $bd48c8ef11defcf4$export$34e0f9847d4c02dd, (v) => $bd48c8ef11defcf4$export$34e0f9847d4c02dd = v);
$parcel$export($bd48c8ef11defcf4$exports, "listContainer", () => $bd48c8ef11defcf4$export$1b9b24bdbcc25a11, (v) => $bd48c8ef11defcf4$export$1b9b24bdbcc25a11 = v);
$parcel$export($bd48c8ef11defcf4$exports, "preview", () => $bd48c8ef11defcf4$export$48c2d0f2f545ac27, (v) => $bd48c8ef11defcf4$export$48c2d0f2f545ac27 = v);
$parcel$export($bd48c8ef11defcf4$exports, "previewContainer", () => $bd48c8ef11defcf4$export$8aade8ce2b5d7e87, (v) => $bd48c8ef11defcf4$export$8aade8ce2b5d7e87 = v);
$parcel$export($bd48c8ef11defcf4$exports, "previewContainerWithSecondary", () => $bd48c8ef11defcf4$export$8eeea050e4b2a94c, (v) => $bd48c8ef11defcf4$export$8eeea050e4b2a94c = v);
var $bd48c8ef11defcf4$export$34e0f9847d4c02dd;
var $bd48c8ef11defcf4$export$1b9b24bdbcc25a11;
var $bd48c8ef11defcf4$export$48c2d0f2f545ac27;
var $bd48c8ef11defcf4$export$8aade8ce2b5d7e87;
var $bd48c8ef11defcf4$export$8eeea050e4b2a94c;
$bd48c8ef11defcf4$export$34e0f9847d4c02dd = `WTltza_PreviewContentCard_container`;
$bd48c8ef11defcf4$export$1b9b24bdbcc25a11 = `WTltza_PreviewContentCard_listContainer`;
$bd48c8ef11defcf4$export$48c2d0f2f545ac27 = `WTltza_PreviewContentCard_preview`;
$bd48c8ef11defcf4$export$8aade8ce2b5d7e87 = `WTltza_PreviewContentCard_previewContainer`;
$bd48c8ef11defcf4$export$8eeea050e4b2a94c = `WTltza_PreviewContentCard_previewContainerWithSecondary`;


function $034af6c0eb5c10e4$export$7ffad9c53e8a82d9({ card: card, cardCustomization: cardCustomization, children: children, showCardDetails: showCardDetails = false, previewSecondaryContent: previewSecondaryContent }) {
    const previewContainerClassName = previewSecondaryContent == null ? (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).previewContainer : (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).previewContainer, (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).previewContainerWithSecondary);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: previewContainerClassName,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).preview,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d559914ba3bc587b$export$115f017852a4bb7c), {
                            cardholder: (0, $1f03a6bc7d91b109$export$f0d76c98e43e3f03)(card),
                            cvc: (0, $1f03a6bc7d91b109$export$7f1de93407df59b0)(card),
                            expirationDate: (0, $1f03a6bc7d91b109$export$1bbc5be1c1af00a7)(card),
                            fullPan: (0, $1f03a6bc7d91b109$export$eb37d3dae2bf604a)(card),
                            businessName: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card),
                            showCardDetails: showCardDetails,
                            signatureDataUri: (0, $1f03a6bc7d91b109$export$461358cf94db3eb1)(cardCustomization)
                        }),
                        previewSecondaryContent
                    ]
                })
            }),
            children ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).listContainer,
                children: children
            }) : null
        ]
    });
}




var $e710467a0b08d0a7$export$8837f4fc672e936d;
$e710467a0b08d0a7$export$8837f4fc672e936d = `ccjoFG_List_list`;




var $e90df8fac1d740f0$exports = {};

$parcel$export($e90df8fac1d740f0$exports, "activityIndicator", () => $e90df8fac1d740f0$export$1d20b5855c758fab, (v) => $e90df8fac1d740f0$export$1d20b5855c758fab = v);
$parcel$export($e90df8fac1d740f0$exports, "icon", () => $e90df8fac1d740f0$export$1ca1ec8b29a4ce27, (v) => $e90df8fac1d740f0$export$1ca1ec8b29a4ce27 = v);
$parcel$export($e90df8fac1d740f0$exports, "iconContainer", () => $e90df8fac1d740f0$export$acf4eaf431084f78, (v) => $e90df8fac1d740f0$export$acf4eaf431084f78 = v);
var $e90df8fac1d740f0$export$1d20b5855c758fab;
var $e90df8fac1d740f0$export$1ca1ec8b29a4ce27;
var $e90df8fac1d740f0$export$acf4eaf431084f78;
$e90df8fac1d740f0$export$1d20b5855c758fab = `_0qYKCG_ListItem_activityIndicator`;
$e90df8fac1d740f0$export$1ca1ec8b29a4ce27 = `_0qYKCG_ListItem_icon`;
$e90df8fac1d740f0$export$acf4eaf431084f78 = `_0qYKCG_ListItem_iconContainer`;


var $67b4545ba4ea2391$export$18f8036a6dc5f3a5 = /*#__PURE__*/ function(ListControl) {
    ListControl["TOGGLE"] = "TOGGLE";
    return ListControl;
}({});
function $67b4545ba4ea2391$export$a7b06bfba60a8a78({ Icon: Icon, text: text, subtext: subtext, control: control, hidden: hidden = false, loading: loading = false, value: value = false, action: action }) {
    const ToggleComponent = ()=>{
        if (control === "TOGGLE") return loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$28c2b904b2ab5c88), {
            slot: "trailing-accessory",
            size: "small",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e90df8fac1d740f0$exports))).activityIndicator
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$b2dd8e9aed9c0935), {
            slot: "control"
        });
        return null;
    };
    return hidden ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
        onClick: action,
        variant: control ? "regular" : "drill",
        selected: value,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "leading-accessory",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e90df8fac1d740f0$exports))).iconContainer,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e90df8fac1d740f0$exports))).icon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                slot: "label",
                children: text
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ToggleComponent, {}),
            subtext && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                slot: "subtext",
                children: subtext
            })
        ]
    }, text);
}


function $155fca31ba7836a3$export$54c2e3dc7acea9f5({ items: items }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$5f38cc4b3e71c577), {
        className: (0, $e710467a0b08d0a7$export$8837f4fc672e936d),
        transient: true,
        name: "card-settings-list",
        children: items.map(({ Icon: Icon, text: text, subtext: subtext, control: control, hidden: hidden, loading: loading, value: value, action: action })=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67b4545ba4ea2391$export$a7b06bfba60a8a78), {
                Icon: Icon,
                text: text,
                subtext: subtext,
                control: control,
                hidden: hidden,
                loading: loading,
                value: value,
                action: action
            }, text);
        })
    });
}




var $9ea98b0e574b2c69$export$9261782d08389607;
$9ea98b0e574b2c69$export$9261782d08389607 = `zfQBuG_ContentCard_contentCard`;


function $9572a2cf9fb2ccf8$export$f631859cab12b342({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $9ea98b0e574b2c69$export$9261782d08389607), className),
        children: children
    });
}



var $e3e42df70a20556d$exports = {};

$parcel$export($e3e42df70a20556d$exports, "button", () => $e3e42df70a20556d$export$2ba01fb71ed41cb6, (v) => $e3e42df70a20556d$export$2ba01fb71ed41cb6 = v);
$parcel$export($e3e42df70a20556d$exports, "container", () => $e3e42df70a20556d$export$34e0f9847d4c02dd, (v) => $e3e42df70a20556d$export$34e0f9847d4c02dd = v);
$parcel$export($e3e42df70a20556d$exports, "disclaimer", () => $e3e42df70a20556d$export$daa7d8bf68093807, (v) => $e3e42df70a20556d$export$daa7d8bf68093807 = v);
$parcel$export($e3e42df70a20556d$exports, "divider", () => $e3e42df70a20556d$export$e8c9778bf415dd08, (v) => $e3e42df70a20556d$export$e8c9778bf415dd08 = v);
$parcel$export($e3e42df70a20556d$exports, "helpHeader", () => $e3e42df70a20556d$export$fbf96866ee135169, (v) => $e3e42df70a20556d$export$fbf96866ee135169 = v);
var $e3e42df70a20556d$export$2ba01fb71ed41cb6;
var $e3e42df70a20556d$export$34e0f9847d4c02dd;
var $e3e42df70a20556d$export$daa7d8bf68093807;
var $e3e42df70a20556d$export$e8c9778bf415dd08;
var $e3e42df70a20556d$export$fbf96866ee135169;
$e3e42df70a20556d$export$2ba01fb71ed41cb6 = `dY9jpq_CardManagement_button`;
$e3e42df70a20556d$export$34e0f9847d4c02dd = `dY9jpq_CardManagement_container`;
$e3e42df70a20556d$export$daa7d8bf68093807 = `dY9jpq_CardManagement_disclaimer`;
$e3e42df70a20556d$export$e8c9778bf415dd08 = `dY9jpq_CardManagement_divider`;
$e3e42df70a20556d$export$fbf96866ee135169 = `dY9jpq_CardManagement_helpHeader`;



function $65a7b64dd007d7b7$export$7aa52cf130c2f005({ card: card, cardCustomization: cardCustomization, cardSettings: cardSettings, helpSettings: helpSettings, showCardDetails: showCardDetails, onActivateCardClick: onActivateCardClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-settings");
    const previewSecondaryContent = (0, $1f03a6bc7d91b109$export$8e48b4074de9a9df)(card) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
        rank: "primary",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).button,
        onClick: onActivateCardClick,
        children: t("button.activateCard")
    }) : undefined;
    const showCardSettings = cardSettings.length > 0 && cardSettings.some((setting)=>!setting.hidden);
    const isUsSeller = card?.fulfillment?.address?.countryCode === (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $034af6c0eb5c10e4$export$7ffad9c53e8a82d9), {
                card: card,
                cardCustomization: cardCustomization,
                previewSecondaryContent: previewSecondaryContent,
                showCardDetails: showCardDetails,
                children: showCardSettings ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155fca31ba7836a3$export$54c2e3dc7acea9f5), {
                    items: cardSettings
                }) : null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$2bf53bba4802f0ae), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).divider
            }),
            helpSettings.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9572a2cf9fb2ccf8$export$f631859cab12b342), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).helpHeader,
                        children: t("section.help.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155fca31ba7836a3$export$54c2e3dc7acea9f5), {
                        items: helpSettings
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            isUsSeller && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).disclaimer,
                children: t("section.settings.disclaimer")
            })
        ]
    });
}


//#region \0rolldown/runtime.js
var $1f14c967a58ea158$var$e = (e, t)=>()=>(t || (e((t = {
            exports: {}
        }).exports, t), e = null), t.exports), $1f14c967a58ea158$export$b6032183171af19f = /* @__PURE__ */ function(e) {
    return e.NOT_SUPPLIED = "NOT_SUPPLIED", e.PIE = "PIE", e.CAPITAL = "CAPITAL", e.SQUARE_CONSOLE = "SQUARE_CONSOLE", e.TIDAL = "TIDAL", e.SHOP = "SHOP", e.CASH = "CASH", e;
}({}), $1f14c967a58ea158$var$n = "application/json", $1f14c967a58ea158$var$r = "application/json", $1f14c967a58ea158$var$i = "/1.0/features/get-flags", $1f14c967a58ea158$var$a = "/services/squareup.cls.api.ExternalClientLogicService/Evaluate", $1f14c967a58ea158$var$o = "/1.0/features/get-flags-sandbox", $1f14c967a58ea158$var$s = $1f14c967a58ea158$export$b6032183171af19f.PIE, $1f14c967a58ea158$var$c = /* @__PURE__ */ $1f14c967a58ea158$var$e((e)=>{
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
    function r(e, n, r) {
        var i = null;
        if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for(var a in r = {}, n)a !== "key" && (r[a] = n[a]);
        else r = n;
        return n = r.ref, {
            $$typeof: t,
            type: e,
            key: i,
            ref: n === void 0 ? null : n,
            props: r
        };
    }
    e.Fragment = n, e.jsx = r, e.jsxs = r;
}), $1f14c967a58ea158$var$l = /* @__PURE__ */ $1f14c967a58ea158$var$e((e)=>{
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
    function m(e) {
        return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
    }
    var h = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function() {},
        enqueueReplaceState: function() {},
        enqueueSetState: function() {}
    }, g = Object.assign, _ = {};
    function v(e, t, n) {
        this.props = e, this.context = t, this.refs = _, this.updater = n || h;
    }
    v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
        if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, e, t, "setState");
    }, v.prototype.forceUpdate = function(e) {
        this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    };
    function y() {}
    y.prototype = v.prototype;
    function b(e, t, n) {
        this.props = e, this.context = t, this.refs = _, this.updater = n || h;
    }
    var x = b.prototype = new y();
    x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
    var S = Array.isArray;
    function C() {}
    var w = {
        H: null,
        A: null,
        T: null,
        S: null
    }, T = Object.prototype.hasOwnProperty;
    function E(e, n, r) {
        var i = r.ref;
        return {
            $$typeof: t,
            type: e,
            key: n,
            ref: i === void 0 ? null : i,
            props: r
        };
    }
    function D(e, t) {
        return E(e.type, t, e.props);
    }
    function O(e) {
        return typeof e == "object" && !!e && e.$$typeof === t;
    }
    function k(e) {
        var t = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + e.replace(/[=:]/g, function(e) {
            return t[e];
        });
    }
    var A = /\/+/g;
    function j(e, t) {
        return typeof e == "object" && e && e.key != null ? k("" + e.key) : t.toString(36);
    }
    function M(e) {
        switch(e.status){
            case "fulfilled":
                return e.value;
            case "rejected":
                throw e.reason;
            default:
                switch(typeof e.status == "string" ? e.then(C, C) : (e.status = "pending", e.then(function(t) {
                    e.status === "pending" && (e.status = "fulfilled", e.value = t);
                }, function(t) {
                    e.status === "pending" && (e.status = "rejected", e.reason = t);
                })), e.status){
                    case "fulfilled":
                        return e.value;
                    case "rejected":
                        throw e.reason;
                }
        }
        throw e;
    }
    function N(e, r, i, a, o) {
        var s = typeof e;
        (s === "undefined" || s === "boolean") && (e = null);
        var c = !1;
        if (e === null) c = !0;
        else switch(s){
            case "bigint":
            case "string":
            case "number":
                c = !0;
                break;
            case "object":
                switch(e.$$typeof){
                    case t:
                    case n:
                        c = !0;
                        break;
                    case d:
                        return c = e._init, N(c(e._payload), r, i, a, o);
                }
        }
        if (c) return o = o(e), c = a === "" ? "." + j(e, 0) : a, S(o) ? (i = "", c != null && (i = c.replace(A, "$&/") + "/"), N(o, r, i, "", function(e) {
            return e;
        })) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(A, "$&/") + "/") + c)), r.push(o)), 1;
        c = 0;
        var l = a === "" ? "." : a + ":";
        if (S(e)) for(var u = 0; u < e.length; u++)a = e[u], s = l + j(a, u), c += N(a, r, i, s, o);
        else if (u = m(e), typeof u == "function") for(e = u.call(e), u = 0; !(a = e.next()).done;)a = a.value, s = l + j(a, u++), c += N(a, r, i, s, o);
        else if (s === "object") {
            if (typeof e.then == "function") return N(M(e), r, i, a, o);
            throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
        }
        return c;
    }
    function P(e, t, n) {
        if (e == null) return e;
        var r = [], i = 0;
        return N(e, r, "", "", function(e) {
            return t.call(n, e, i++);
        }), r;
    }
    function F(e) {
        if (e._status === -1) {
            var t = e._result;
            t = t(), t.then(function(t) {
                (e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
            }, function(t) {
                (e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
            }), e._status === -1 && (e._status = 0, e._result = t);
        }
        if (e._status === 1) return e._result.default;
        throw e._result;
    }
    var I = typeof reportError == "function" ? reportError : function(e) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
            var t = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
                error: e
            });
            if (!window.dispatchEvent(t)) return;
        }
        console.error(e);
    }, L = {
        map: P,
        forEach: function(e, t, n) {
            P(e, function() {
                t.apply(this, arguments);
            }, n);
        },
        count: function(e) {
            var t = 0;
            return P(e, function() {
                t++;
            }), t;
        },
        toArray: function(e) {
            return P(e, function(e) {
                return e;
            }) || [];
        },
        only: function(e) {
            if (!O(e)) throw Error("React.Children.only expected to receive a single React element child.");
            return e;
        }
    };
    e.Activity = f, e.Children = L, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
        __proto__: null,
        c: function(e) {
            return w.H.useMemoCache(e);
        }
    }, e.cache = function(e) {
        return function() {
            return e.apply(null, arguments);
        };
    }, e.cacheSignal = function() {
        return null;
    }, e.cloneElement = function(e, t, n) {
        if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
        var r = g({}, e.props), i = e.key;
        if (t != null) for(a in t.key !== void 0 && (i = "" + t.key), t)!T.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
        var a = arguments.length - 2;
        if (a === 1) r.children = n;
        else if (1 < a) {
            for(var o = Array(a), s = 0; s < a; s++)o[s] = arguments[s + 2];
            r.children = o;
        }
        return E(e.type, i, r);
    }, e.createContext = function(e) {
        return e = {
            $$typeof: s,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        }, e.Provider = e, e.Consumer = {
            $$typeof: o,
            _context: e
        }, e;
    }, e.createElement = function(e, t, n) {
        var r, i = {}, a = null;
        if (t != null) for(r in t.key !== void 0 && (a = "" + t.key), t)T.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
        var o = arguments.length - 2;
        if (o === 1) i.children = n;
        else if (1 < o) {
            for(var s = Array(o), c = 0; c < o; c++)s[c] = arguments[c + 2];
            i.children = s;
        }
        if (e && e.defaultProps) for(r in o = e.defaultProps, o)i[r] === void 0 && (i[r] = o[r]);
        return E(e, a, i);
    }, e.createRef = function() {
        return {
            current: null
        };
    }, e.forwardRef = function(e) {
        return {
            $$typeof: c,
            render: e
        };
    }, e.isValidElement = O, e.lazy = function(e) {
        return {
            $$typeof: d,
            _payload: {
                _status: -1,
                _result: e
            },
            _init: F
        };
    }, e.memo = function(e, t) {
        return {
            $$typeof: u,
            type: e,
            compare: t === void 0 ? null : t
        };
    }, e.startTransition = function(e) {
        var t = w.T, n = {};
        w.T = n;
        try {
            var r = e(), i = w.S;
            i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(C, I);
        } catch (e) {
            I(e);
        } finally{
            t !== null && n.types !== null && (t.types = n.types), w.T = t;
        }
    }, e.unstable_useCacheRefresh = function() {
        return w.H.useCacheRefresh();
    }, e.use = function(e) {
        return w.H.use(e);
    }, e.useActionState = function(e, t, n) {
        return w.H.useActionState(e, t, n);
    }, e.useCallback = function(e, t) {
        return w.H.useCallback(e, t);
    }, e.useContext = function(e) {
        return w.H.useContext(e);
    }, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
        return w.H.useDeferredValue(e, t);
    }, e.useEffect = function(e, t) {
        return w.H.useEffect(e, t);
    }, e.useEffectEvent = function(e) {
        return w.H.useEffectEvent(e);
    }, e.useId = function() {
        return w.H.useId();
    }, e.useImperativeHandle = function(e, t, n) {
        return w.H.useImperativeHandle(e, t, n);
    }, e.useInsertionEffect = function(e, t) {
        return w.H.useInsertionEffect(e, t);
    }, e.useLayoutEffect = function(e, t) {
        return w.H.useLayoutEffect(e, t);
    }, e.useMemo = function(e, t) {
        return w.H.useMemo(e, t);
    }, e.useOptimistic = function(e, t) {
        return w.H.useOptimistic(e, t);
    }, e.useReducer = function(e, t, n) {
        return w.H.useReducer(e, t, n);
    }, e.useRef = function(e) {
        return w.H.useRef(e);
    }, e.useState = function(e) {
        return w.H.useState(e);
    }, e.useSyncExternalStore = function(e, t, n) {
        return w.H.useSyncExternalStore(e, t, n);
    }, e.useTransition = function() {
        return w.H.useTransition();
    }, e.version = "19.2.8";
}), $1f14c967a58ea158$var$u = /* @__PURE__ */ $1f14c967a58ea158$var$e((e, t)=>{}), $1f14c967a58ea158$var$d = /* @__PURE__ */ $1f14c967a58ea158$var$e((e, t)=>{
    t.exports = $1f14c967a58ea158$var$l();
}), $1f14c967a58ea158$var$f = /* @__PURE__ */ $1f14c967a58ea158$var$e((e)=>{});
/* @__PURE__ */ $1f14c967a58ea158$var$e((e, t)=>{
    t.exports = $1f14c967a58ea158$var$c();
})();
//#endregion
//#region ../../../node_modules/.pnpm/js-cookie@3.0.8/node_modules/js-cookie/dist/js.cookie.mjs
function $1f14c967a58ea158$var$p(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t];
        for(var r in n)r !== "__proto__" && (e[r] = n[r]);
    }
    return e;
}
var $1f14c967a58ea158$var$m = {
    read: function(e) {
        return e[0] === "\"" && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(e) {
        return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $1f14c967a58ea158$var$h(e, t) {
    function n(n, r, i) {
        if (!(typeof document > "u")) {
            i = $1f14c967a58ea158$var$p({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires &&= i.expires.toUTCString(), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var a = "";
            for(var o in i)i[o] && (a += "; " + o, i[o] !== !0 && (a += "=" + i[o].split(";")[0]));
            return document.cookie = n + "=" + e.write(r, n) + a;
        }
    }
    function r(t) {
        if (!(typeof document > "u" || arguments.length && !t)) {
            for(var n = document.cookie ? document.cookie.split("; ") : [], r = {}, i = 0; i < n.length; i++){
                var a = n[i].split("="), o = a.slice(1).join("=");
                try {
                    var s = decodeURIComponent(a[0]);
                    if (s in r || (r[s] = e.read(o, s)), t === s) break;
                } catch  {}
            }
            return t ? r[t] : r;
        }
    }
    return Object.create({
        set: n,
        get: r,
        remove: function(e, t) {
            n(e, "", $1f14c967a58ea158$var$p({}, t, {
                expires: -1
            }));
        },
        withAttributes: function(e) {
            return $1f14c967a58ea158$var$h(this.converter, $1f14c967a58ea158$var$p({}, this.attributes, e));
        },
        withConverter: function(e) {
            return $1f14c967a58ea158$var$h($1f14c967a58ea158$var$p({}, this.converter, e), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(t)
        },
        converter: {
            value: Object.freeze(e)
        }
    });
}
var $1f14c967a58ea158$var$g = $1f14c967a58ea158$var$h($1f14c967a58ea158$var$m, {
    path: "/"
});
//#endregion
//#region ../../shared/util-api-client/dist/index.js
function $1f14c967a58ea158$var$_(e) {
    if (e[0] === "/") {
        let { protocol: t, host: n } = window.location;
        return `${t}//${n}${e}`;
    }
    return e;
}
async function $1f14c967a58ea158$var$v(...e) {
    return fetch(...e);
}
async function $1f14c967a58ea158$var$y(e, t = {}, n = []) {
    let r = typeof e == "string" ? $1f14c967a58ea158$var$_(e) : e, i = {
        ...t
    }, a = (e)=>$1f14c967a58ea158$var$v(r, e);
    return !n || !n.length ? a(i) : n.concat().reverse().reduce((e, t)=>t(e), a)(i);
}
var $1f14c967a58ea158$var$b = /([\p{Alpha}\p{N}_]|$)/u, $1f14c967a58ea158$var$x = /[_.\- ]+/;
RegExp("^" + $1f14c967a58ea158$var$x.source), new RegExp($1f14c967a58ea158$var$x.source + $1f14c967a58ea158$var$b.source, "gu"), RegExp("\\d+" + $1f14c967a58ea158$var$b.source, "gu");
var $1f14c967a58ea158$var$S = (e)=>typeof e == "object" && !!e, $1f14c967a58ea158$var$C = (e)=>$1f14c967a58ea158$var$S(e) && !(e instanceof RegExp) && !(e instanceof Error) && !(e instanceof Date), $1f14c967a58ea158$var$w = Symbol("mapObjectSkip"), $1f14c967a58ea158$var$T = (e, t, n, r = /* @__PURE__ */ new WeakMap())=>{
    if (n = {
        deep: !1,
        target: {},
        ...n
    }, r.has(e)) return r.get(e);
    r.set(e, n.target);
    let { target: i } = n;
    delete n.target;
    let a = (e)=>e.map((e)=>$1f14c967a58ea158$var$C(e) ? $1f14c967a58ea158$var$T(e, t, n, r) : e);
    if (Array.isArray(e)) return a(e);
    for (let [o, s] of Object.entries(e)){
        let c = t(o, s, e);
        if (c === $1f14c967a58ea158$var$w) continue;
        let [l, u, { shouldRecurse: d = !0 } = {}] = c;
        l !== "__proto__" && (n.deep && d && $1f14c967a58ea158$var$C(u) && (u = Array.isArray(u) ? a(u) : $1f14c967a58ea158$var$T(u, t, n, r)), i[l] = u);
    }
    return i;
}, $1f14c967a58ea158$var$E = class extends Map {
    #e = 0;
    #t = /* @__PURE__ */ new Map();
    #n = /* @__PURE__ */ new Map();
    #r;
    #i;
    #a;
    constructor(e = {}){
        if (super(), !(e.maxSize && e.maxSize > 0)) throw TypeError("`maxSize` must be a number greater than 0");
        if (typeof e.maxAge == "number" && e.maxAge === 0) throw TypeError("`maxAge` must be a number greater than 0");
        this.#r = e.maxSize, this.#i = e.maxAge || Infinity, this.#a = e.onEviction;
    }
    get __oldCache() {
        return this.#n;
    }
    #o(e) {
        if (typeof this.#a == "function") for (let [t, n] of e)this.#a(t, n.value);
    }
    #s(e, t) {
        return typeof t.expiry == "number" && t.expiry <= Date.now() ? (typeof this.#a == "function" && this.#a(e, t.value), this.delete(e)) : !1;
    }
    #c(e, t) {
        if (this.#s(e, t) === !1) return t.value;
    }
    #l(e, t) {
        return t.expiry ? this.#c(e, t) : t.value;
    }
    #u(e, t) {
        let n = t.get(e);
        return this.#l(e, n);
    }
    #d(e, t) {
        this.#t.set(e, t), this.#e++, this.#e >= this.#r && (this.#e = 0, this.#o(this.#n), this.#n = this.#t, this.#t = /* @__PURE__ */ new Map());
    }
    #f(e, t) {
        this.#n.delete(e), this.#d(e, t);
    }
    *#p() {
        for (let e of this.#n){
            let [t, n] = e;
            this.#t.has(t) || this.#s(t, n) === !1 && (yield e);
        }
        for (let e of this.#t){
            let [t, n] = e;
            this.#s(t, n) === !1 && (yield e);
        }
    }
    get(e) {
        if (this.#t.has(e)) {
            let t = this.#t.get(e);
            return this.#l(e, t);
        }
        if (this.#n.has(e)) {
            let t = this.#n.get(e);
            if (this.#s(e, t) === !1) return this.#f(e, t), t.value;
        }
    }
    set(e, t, { maxAge: n = this.#i } = {}) {
        let r = typeof n == "number" && n !== Infinity ? Date.now() + n : void 0;
        return this.#t.has(e) ? this.#t.set(e, {
            value: t,
            expiry: r
        }) : this.#d(e, {
            value: t,
            expiry: r
        }), this;
    }
    has(e) {
        return this.#t.has(e) ? !this.#s(e, this.#t.get(e)) : this.#n.has(e) ? !this.#s(e, this.#n.get(e)) : !1;
    }
    peek(e) {
        if (this.#t.has(e)) return this.#u(e, this.#t);
        if (this.#n.has(e)) return this.#u(e, this.#n);
    }
    delete(e) {
        let t = this.#t.delete(e);
        return t && this.#e--, this.#n.delete(e) || t;
    }
    clear() {
        this.#t.clear(), this.#n.clear(), this.#e = 0;
    }
    resize(e) {
        if (!(e && e > 0)) throw TypeError("`maxSize` must be a number greater than 0");
        let t = [
            ...this.#p()
        ], n = t.length - e;
        n < 0 ? (this.#t = new Map(t), this.#n = /* @__PURE__ */ new Map(), this.#e = t.length) : (n > 0 && this.#o(t.slice(0, n)), this.#n = new Map(t.slice(n)), this.#t = /* @__PURE__ */ new Map(), this.#e = 0), this.#r = e;
    }
    *keys() {
        for (let [e] of this)yield e;
    }
    *values() {
        for (let [, e] of this)yield e;
    }
    *[Symbol.iterator]() {
        for (let e of this.#t){
            let [t, n] = e;
            this.#s(t, n) === !1 && (yield [
                t,
                n.value
            ]);
        }
        for (let e of this.#n){
            let [t, n] = e;
            this.#t.has(t) || this.#s(t, n) === !1 && (yield [
                t,
                n.value
            ]);
        }
    }
    *entriesDescending() {
        let e = [
            ...this.#t
        ];
        for(let t = e.length - 1; t >= 0; --t){
            let [n, r] = e[t];
            this.#s(n, r) === !1 && (yield [
                n,
                r.value
            ]);
        }
        e = [
            ...this.#n
        ];
        for(let t = e.length - 1; t >= 0; --t){
            let [n, r] = e[t];
            this.#t.has(n) || this.#s(n, r) === !1 && (yield [
                n,
                r.value
            ]);
        }
    }
    *entriesAscending() {
        for (let [e, t] of this.#p())yield [
            e,
            t.value
        ];
    }
    get size() {
        if (!this.#e) return this.#n.size;
        let e = 0;
        for (let t of this.#n.keys())this.#t.has(t) || e++;
        return Math.min(this.#e + e, this.#r);
    }
    get maxSize() {
        return this.#r;
    }
    entries() {
        return this.entriesAscending();
    }
    forEach(e, t = this) {
        for (let [n, r] of this.entriesAscending())e.call(t, r, n, this);
    }
    get [Symbol.toStringTag]() {
        return "QuickLRU";
    }
    toString() {
        return `QuickLRU(${this.size}/${this.maxSize})`;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return this.toString();
    }
};
new $1f14c967a58ea158$var$E({
    maxSize: 1e5
}), new $1f14c967a58ea158$var$E({
    maxSize: 1e5
});
var $1f14c967a58ea158$var$D = (e)=>new Promise((t)=>setTimeout(t, e)), $1f14c967a58ea158$var$O = (e, t)=>t.includes(e.status), $1f14c967a58ea158$var$k = $1f14c967a58ea158$var$A();
function $1f14c967a58ea158$var$A(e = {}) {
    let t = {
        maxRetries: 3,
        retryDelay: 1e3,
        retryStatusCodes: [
            429,
            500,
            502,
            503,
            504
        ],
        ...e
    };
    return (e)=>async (n)=>{
            for(let r = 0; r <= t.maxRetries; r++)try {
                let i = await e(n);
                if ($1f14c967a58ea158$var$O(i, t.retryStatusCodes)) {
                    if (r === t.maxRetries) throw Error(`Request failed with status ${i.status} after ${t.maxRetries} retries`);
                    await $1f14c967a58ea158$var$D(t.retryDelay);
                    continue;
                }
                return i;
            } catch (e) {
                if (r === t.maxRetries || !(e instanceof TypeError)) throw e;
                await $1f14c967a58ea158$var$D(t.retryDelay);
            }
            throw Error("Max retries exceeded");
        };
}
//#endregion
//#region src/utils/feature-relay/csrf-header.ts
function $1f14c967a58ea158$var$j() {
    let e = $1f14c967a58ea158$var$g.get("_js_csrf");
    return e === void 0 ? null : {
        "x-csrf-token": e
    };
}
//#endregion
//#region src/rpc/evaluate-cls.ts
function $1f14c967a58ea158$var$M(e = "") {
    return `${e.endsWith("/") ? e.slice(0, -1) : e}${$1f14c967a58ea158$var$a}`;
}
function $1f14c967a58ea158$var$N({ merchantToken: e, userAgent: t, toggleKeys: n, experimentToggleKeys: r }) {
    let i = {};
    return e && (i.context = t ? {
        merchant_token: e,
        user_agent: t
    } : {
        merchant_token: e
    }), n && n.length > 0 && (i.toggle_keys = [
        ...n
    ]), r && r.length > 0 && (i.experiment_toggle_keys = [
        ...r
    ]), i;
}
async function $1f14c967a58ea158$export$35e99e18fc534f86({ merchantToken: e, userAgent: t, toggleKeys: i, experimentToggleKeys: a, origin: o, headers: s, withCredentials: c = !0 }) {
    let l = $1f14c967a58ea158$var$M(o), u = $1f14c967a58ea158$var$N({
        merchantToken: e,
        userAgent: t,
        toggleKeys: i,
        experimentToggleKeys: a
    }), d = await $1f14c967a58ea158$var$y(l, {
        method: "POST",
        headers: {
            Accept: $1f14c967a58ea158$var$n,
            "Content-Type": $1f14c967a58ea158$var$r,
            ...$1f14c967a58ea158$var$j(),
            ...s
        },
        body: JSON.stringify(u),
        credentials: c ? "include" : "same-origin"
    }, [
        $1f14c967a58ea158$var$k
    ]);
    if (!d.ok) throw Error(`CLS Evaluate JSON request failed with status code ${d.status}`);
    return d.json();
}
function $1f14c967a58ea158$var$F(e) {
    return typeof e == "object" && e ? e : {};
}
function $1f14c967a58ea158$var$I(e, t, n) {
    let r = $1f14c967a58ea158$var$F(e);
    return $1f14c967a58ea158$var$F(r[t] ?? r[n]);
}
function $1f14c967a58ea158$export$b5290e9a58aec812(e) {
    return e === "SUCCESS" || e === 1;
}
function $1f14c967a58ea158$var$R(e, t) {
    let n = $1f14c967a58ea158$var$F($1f14c967a58ea158$var$I(e, "toggle_results", "toggleResults")[t]), r = $1f14c967a58ea158$var$F(n.value);
    return $1f14c967a58ea158$export$b5290e9a58aec812(n.status) && typeof r.on == "boolean" ? {
        resolved: !0,
        value: r.on
    } : {
        resolved: !1
    };
}
function $1f14c967a58ea158$var$z(e, t) {
    let n = $1f14c967a58ea158$var$F($1f14c967a58ea158$var$I(e, "experiment_results", "experimentResults")[t]), r = $1f14c967a58ea158$var$F(n.value);
    return $1f14c967a58ea158$export$b5290e9a58aec812(n.status) && typeof r.variant == "string" ? {
        resolved: !0,
        value: r.variant
    } : {
        resolved: !1
    };
}
function $1f14c967a58ea158$export$c94c403a9674ec79(e, t, n) {
    let r = $1f14c967a58ea158$var$R(e, t);
    return r.resolved ? r.value : n;
}
function $1f14c967a58ea158$export$4273ebb30a87fc4c(e, t, n) {
    let r = $1f14c967a58ea158$var$z(e, t);
    return r.resolved ? r.value : n;
}
function $1f14c967a58ea158$export$e5d701792e880b25({ toggleConfigs: e, experimentConfigs: t, response: n }) {
    let r = {}, i = [];
    for (let t of e){
        let e = $1f14c967a58ea158$var$R(n, t.key);
        e.resolved ? r[t.key] = e.value : (i.push(t.key), r[t.key] = t.defaultValue);
    }
    for (let e of t){
        let t = $1f14c967a58ea158$var$z(n, e.key);
        t.resolved ? r[e.key] = t.value : (i.push(e.key), r[e.key] = e.defaultValue);
    }
    return {
        values: r,
        failedKeys: i
    };
}
//#endregion
//#region src/types/feature-relay-protos/data-type.ts
var $1f14c967a58ea158$export$45c69700ee30a78c = /* @__PURE__ */ function(e) {
    return e.BOOLEAN = "BOOLEAN", e.INTEGER = "INTEGER", e.DOUBLE = "DOUBLE", e.STRING = "STRING", e.JSON = "JSON", e;
}({}), $1f14c967a58ea158$export$96e9906d6d93a972 = /* @__PURE__ */ function(e) {
    return e.UNKNOWN = "UNKNOWN", e.SUCCESS = "SUCCESS", e.SDK_ERROR = "SDK_ERROR", e.INVALID_REQUEST = "INVALID_REQUEST", e.NOT_FOUND = "NOT_FOUND", e.WRONG_TYPE = "WRONG_TYPE", e.SERVICE_NOT_READY = "SERVICE_NOT_READY", e;
}({}), $1f14c967a58ea158$export$f435f793048e7a0f = /* @__PURE__ */ function(e) {
    return e.UNIT = "UNIT", e.MERCHANT = "MERCHANT", e.DEVICE_ID = "DEVICE_ID", e.ANONYMOUS_VISITOR = "ANONYMOUS_VISITOR", e.PERSON = "PERSON", e;
}({}), $1f14c967a58ea158$export$264ad599d7cef668 = /* @__PURE__ */ function(e) {
    return e.UNKNOWN = "unknown", e.SQUARE = "square", e.REGISTER = "register", e.DASHBOARD = "dashboard", e.RETAIL = "retail", e.RESTAURANT = "restaurant", e.INVOICES = "invoices", e.APPOINTMENTS = "appointments", e.READERSDK = "readersdk", e.KDS = "kds", e.SIGNIN = "signin", e.SINGLE_BINARY = "single_binary", e.TERMINALAPI = "terminalapi", e.WEEBLY = "weebly", e.TERMINAL = "terminal", e.TERMINAL_API = "terminal_api", e.KDS_EXPO = "kds_expo", e.PAYROLL = "payroll", e.CARDCASE = "cardcase", e.RESTAURANT_MOBILE = "restaurant_mobile", e.BALANCE = "balance", e.FNBKIOSK = "fnbkiosk", e.GO = "go", e;
}({});
//#endregion
//#region src/utils/feature-relay/build-request-url.ts
function $1f14c967a58ea158$var$re(e = "") {
    return `${e.endsWith("/") ? e.slice(0, -1) : e}${e.includes("https://squareupsandbox.com") ? $1f14c967a58ea158$var$o : $1f14c967a58ea158$var$i}`;
}
//#endregion
//#region src/rpc/get-flags.ts
async function $1f14c967a58ea158$export$d5815430bcc75df0({ flagRequests: e, userToken: t, origin: i, headers: a, withCredentials: o, project: c = $1f14c967a58ea158$var$s, userAttributes: l, onInvalidUserAttribute: u }) {
    let d = {
        project: c,
        flag_requests: e,
        user_token: t,
        user_attributes: {
            user_attributes: $1f14c967a58ea158$var$se(l, u)
        }
    }, f = await $1f14c967a58ea158$var$y($1f14c967a58ea158$var$re(i), {
        method: "POST",
        headers: {
            Accept: $1f14c967a58ea158$var$n,
            "Content-Type": $1f14c967a58ea158$var$r,
            ...$1f14c967a58ea158$var$j(),
            ...a
        },
        body: JSON.stringify(d),
        credentials: o ? "include" : "same-origin"
    }, [
        $1f14c967a58ea158$var$k
    ]);
    if (!f.ok) throw Error(`Request failed with status code ${f.status}`);
    let p = await f.json();
    if (p.status !== $1f14c967a58ea158$export$96e9906d6d93a972.SUCCESS) throw Error(`Request to retrieve feature flags failed with status ${p.status}`);
    return p.flag_responses ?? [];
}
var $1f14c967a58ea158$var$ie = [
    "string_value",
    "int_value",
    "bool_value",
    "double_value"
];
function $1f14c967a58ea158$var$ae(e) {
    return $1f14c967a58ea158$var$ie.some((t)=>{
        let n = e[t];
        return n == null ? !1 : typeof n == "number" ? Number.isFinite(n) : !0;
    });
}
function $1f14c967a58ea158$export$6b1458d9ee1597c4(e = [], t) {
    let n = [];
    for (let r of e)if ($1f14c967a58ea158$var$ae(r)) n.push(r);
    else try {
        t?.({
            attributeName: r.name
        });
    } catch  {}
    return n;
}
function $1f14c967a58ea158$var$se(e = [], t) {
    let n = $1f14c967a58ea158$export$6b1458d9ee1597c4(e, t);
    return n.some((e)=>e.name === "platform") || n.push({
        name: "platform",
        string_value: "web"
    }), n;
}
//#endregion
//#region src/utils/feature-relay/is-boolean-flag-response.ts
function $1f14c967a58ea158$var$G(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.BOOLEAN && typeof e.flag_name == "string";
}
//#endregion
//#region src/utils/feature-relay/is-double-flag-response.ts
function $1f14c967a58ea158$var$ce(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.DOUBLE && typeof e.flag_name == "string";
}
//#endregion
//#region src/utils/feature-relay/is-integer-flag-response.ts
function $1f14c967a58ea158$var$le(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.INTEGER && typeof e.flag_name == "string";
}
//#endregion
//#region src/utils/feature-relay/is-json-flag-response.ts
function $1f14c967a58ea158$var$K(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.JSON && typeof e.flag_name == "string";
}
//#endregion
//#region src/utils/feature-relay/is-string-flag-response.ts
function $1f14c967a58ea158$var$q(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.STRING && typeof e.flag_name == "string";
}
//#endregion
//#region src/utils/feature-relay/read-flag-value-from-response.ts
function $1f14c967a58ea158$export$bd729e45c45d1b14(e, t) {
    if (e.status === $1f14c967a58ea158$export$96e9906d6d93a972.SUCCESS) {
        if ($1f14c967a58ea158$var$G(e)) return e.bool_value;
        if ($1f14c967a58ea158$var$le(e)) return e.int_value;
        if ($1f14c967a58ea158$var$ce(e)) return e.double_value;
        if ($1f14c967a58ea158$var$q(e)) return e.string_value;
        if ($1f14c967a58ea158$var$K(e)) {
            if (!e.string_value) return;
            try {
                return JSON.parse(e.string_value);
            } catch  {
                typeof t == "function" && t({
                    flagKey: e.flag_name,
                    stringifiedValue: e.string_value
                });
                return;
            }
        }
    }
}
//#endregion
//#region src/client/client.ts
function $1f14c967a58ea158$var$ue(e) {
    let t = /* @__PURE__ */ new Map();
    for (let n of Object.values(e)){
        let e = {
            value: void 0,
            config: n
        };
        t.set(n.key, e);
    }
    return t;
}
function $1f14c967a58ea158$var$de(e) {
    let { key: t, flagType: n } = e;
    return {
        flag_name: t,
        flag_type: n
    };
}
function $1f14c967a58ea158$var$fe({ flagConfig: e, flagResponse: t, onIncorrectFlagType: n, onMalformedJsonFlagValue: r }) {
    return t.status === $1f14c967a58ea158$export$96e9906d6d93a972.WRONG_TYPE ? (typeof n == "function" && n({
        flagKey: e.key,
        expectedType: e.flagType
    }), e.defaultValue) : $1f14c967a58ea158$export$bd729e45c45d1b14(t, r);
}
function $1f14c967a58ea158$var$pe(e, t) {
    if (typeof t == "function") for (let [n, { config: r, value: i }] of e)i === void 0 && t({
        flagKey: n,
        flagType: r.flagType
    });
}
var $1f14c967a58ea158$var$me = "Clients require a `userToken` to retrieve flags from the Feature Relay service via `loadFlags`. Be sure to invoke `createFeatureRelayClient` with a valid `userToken` instance.";
function $1f14c967a58ea158$export$4c027c4176fa384({ project: e = $1f14c967a58ea158$var$s, flagConfigs: t, origin: n, headers: r, withCredentials: i, userAttributes: a, userToken: o, merchantToken: c, userAgent: l = "dashboard", offlineMode: u, onIncorrectFlagType: d, onMalformedJsonFlagValue: f, onMissingFlagValue: p, onUnexpectedFlagValue: m, onInvalidUserAttribute: h, onClsError: g }) {
    let _ = $1f14c967a58ea158$var$ue(t), v = !1, y = !1, b = [], x = [], S = [];
    for (let e of Object.values(t))e.source?.name === "CLS" ? e.flagType === $1f14c967a58ea158$export$45c69700ee30a78c.STRING ? S.push(e) : x.push(e) : b.push(e);
    let C = [
        ...x,
        ...S
    ];
    function w() {
        let e = {};
        for (let t of C)e[t.key] = t.defaultValue;
        return e;
    }
    function T(e) {
        if (g !== void 0) try {
            g(e);
        } catch  {}
    }
    async function E() {
        if (C.length === 0) return {};
        if (c === void 0 || c.length === 0) return w();
        try {
            let { values: e, failedKeys: t } = $1f14c967a58ea158$export$e5d701792e880b25({
                toggleConfigs: x,
                experimentConfigs: S,
                response: await $1f14c967a58ea158$export$35e99e18fc534f86({
                    merchantToken: c,
                    userAgent: l,
                    toggleKeys: x.map((e)=>e.key),
                    experimentToggleKeys: S.map((e)=>e.key),
                    origin: n,
                    headers: r,
                    withCredentials: i
                })
            });
            return t.length > 0 && T(/* @__PURE__ */ Error(`CLS evaluate did not resolve values for keys: ${t.join(", ")}`)), e;
        } catch (e) {
            return T(e instanceof Error ? e : Error(String(e))), w();
        }
    }
    function D(e) {
        for (let t of C){
            let n = _.get(t.key);
            n !== void 0 && _.set(t.key, {
                ...n,
                value: e[t.key]
            });
        }
    }
    function O(e) {
        if (v = !0, y) throw Error("Bootstrapping flags after `loadFlags` has been invoked is not supported. Instantiate a different client instance if both bootstrapped and client-loaded feature flags are required.");
        for(let n in e){
            let r = t[n]?.key ?? "", i = _.get(r);
            if (i === void 0) {
                typeof m == "function" && m({
                    flagKey: n,
                    value: e[n]
                });
                continue;
            }
            _.set(r, {
                config: i.config,
                value: e[n]
            });
        }
        $1f14c967a58ea158$var$pe(_, p);
    }
    async function k() {
        if (y = !0, v) throw Error("Loading flags after `boostrapFlags` has been invoked is not supported. Instantiate a different client instance if both bootstrapped and client-loaded feature flags are required.");
        if (b.length > 0 && o === void 0) throw TypeError($1f14c967a58ea158$var$me);
        if (u) return;
        let t = E();
        if (b.length > 0) {
            if (o === void 0) throw TypeError($1f14c967a58ea158$var$me);
            let t = await $1f14c967a58ea158$export$d5815430bcc75df0({
                project: e,
                flagRequests: b.map($1f14c967a58ea158$var$de),
                origin: n,
                headers: r,
                withCredentials: i,
                userAttributes: a,
                userToken: o,
                onInvalidUserAttribute: h
            });
            for (let e of t){
                let t = _.get(e.flag_name);
                if (!t) {
                    typeof m == "function" && m({
                        dataType: e.flag_type,
                        flagKey: e.flag_name,
                        value: $1f14c967a58ea158$export$bd729e45c45d1b14(e)
                    });
                    continue;
                }
                let n = $1f14c967a58ea158$var$fe({
                    flagConfig: t.config,
                    flagResponse: e,
                    onIncorrectFlagType: d,
                    onMalformedJsonFlagValue: f
                });
                _.set(t.config.key, {
                    ...t,
                    value: n
                });
            }
        }
        D(await t), $1f14c967a58ea158$var$pe(_, p);
    }
    function A(e) {
        let t = _.get(e.key);
        if (!t) throw Error(`Attempted to read a flag (${e.key}) that has not been configured. Make sure you're using the correct client instance, or that you've included this flag when instantiating the client.`);
        if (!v && !y) throw Error("You have not yet fetched values for your flags. Retrieve flag values with the `loadFlags` method, or bootstrap values with the `bootstrapFlags` method.");
        let n = e.getMock();
        return n.isSet ? n.value : u ? e.defaultValue : t.value ?? e.defaultValue;
    }
    return {
        bootstrapFlags: O,
        getFlagValue: A,
        loadFlags: k
    };
}
//#endregion
//#region src/flag-creators/with-mockable-value.ts
function $1f14c967a58ea158$var$ge(e) {
    let t = {
        isSet: !1,
        value: void 0
    };
    return {
        ...e,
        getMock () {
            return t;
        },
        setMockValue (e) {
            if (t.isSet) throw Error("A mock value has been re-set with out being cleared. This may be an indication of state leaking between tests. Clear mock values with `.clearMockValue()` before re-setting.");
            t = {
                value: e,
                isSet: !0
            };
        },
        clearMockValue () {
            t = {
                value: void 0,
                isSet: !1
            };
        }
    };
}
//#endregion
//#region src/flag-creators/create-flag.ts
function $1f14c967a58ea158$var$Y({ key: e, defaultValue: t, flagType: n, source: r }) {
    if (e.length === 0) throw Error("Feature flag configuration instances require non-empty key");
    return $1f14c967a58ea158$var$ge({
        key: e,
        defaultValue: t,
        flagType: n,
        source: r
    });
}
//#endregion
//#region src/flag-creators/create-boolean-flag.ts
function $1f14c967a58ea158$export$b36941f86f577b21({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.BOOLEAN
    });
}
//#endregion
//#region src/flag-creators/create-integer-flag.ts
function $1f14c967a58ea158$export$4fa9630feb8c5be5({ key: e, defaultValue: t }) {
    if (!Number.isInteger(t)) throw TypeError(`You supplied a non-integer default value to the ${e} flag.To create a flag with support for decimal values, use createDoubleFlag.`);
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.INTEGER
    });
}
//#endregion
//#region src/flag-creators/create-double-flag.ts
function $1f14c967a58ea158$export$cca336e59540c09c({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.DOUBLE
    });
}
//#endregion
//#region src/flag-creators/create-string-flag.ts
function $1f14c967a58ea158$export$2fc7b3a447bc1bcb({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.STRING
    });
}
//#endregion
//#region src/flag-creators/create-json-flag.ts
function $1f14c967a58ea158$export$ef7cd1fbde911956({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.JSON
    });
}
//#endregion
//#region src/flag-creators/create-cls-toggle.ts
function $1f14c967a58ea158$export$79d0d2e98a2f216a({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.BOOLEAN,
        source: {
            name: "CLS"
        }
    });
}
//#endregion
//#region src/flag-creators/create-cls-experiment-toggle.ts
function $1f14c967a58ea158$export$5c792d5852cf0832({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$Y({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.STRING,
        source: {
            name: "CLS"
        }
    });
}


const $3ffd6dbaf72645e1$export$33fb1db36da5c5ad = {
    canToggleLockCard: (0, $1f14c967a58ea158$export$b36941f86f577b21)({
        key: "banking-microsite-toggle-card-lock",
        defaultValue: true
    }),
    canUpdatePin: (0, $1f14c967a58ea158$export$b36941f86f577b21)({
        key: "banking-web-enable-update-pin",
        defaultValue: true
    })
};




parcelRequire("acw62");
const $3de42ffd7affe746$var$SvgActionEye = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 14",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M.09 6.58C1.97 2.52 5.77 0 10 0s8.03 2.52 9.91 6.58c.12.26.12.57 0 .84C18.03 11.48 14.23 14 10 14S1.97 11.48.09 7.42c-.12-.26-.12-.57 0-.84M2.11 7c1.61 3.1 4.6 5 7.89 5s6.28-1.9 7.89-5c-1.61-3.1-4.6-5-7.89-5S3.72 3.9 2.11 7M6 7c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4m2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2",
            clipRule: "evenodd"
        })
    });
var $3de42ffd7affe746$export$2e2bcd8739ae039 = $3de42ffd7affe746$var$SvgActionEye;



parcelRequire("acw62");
const $20c5e8324d8e54d7$var$SvgActionLockOff = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M9 9h7c1.66 0 3 1.34 3 3v7c0 1.66-1.34 3-3 3H8c-1.66 0-3-1.34-3-3v-7c0-1.3.84-2.4 2-2.82V7c0-2.76 2.24-5 5-5 1.38 0 2.63.56 3.53 1.47l-1.41 1.41C13.58 4.34 12.83 4 12 4c-1.65 0-3 1.35-3 3zm7 11c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm-2.5-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
            clipRule: "evenodd"
        })
    });
var $20c5e8324d8e54d7$export$2e2bcd8739ae039 = $20c5e8324d8e54d7$var$SvgActionLockOff;



parcelRequire("acw62");
const $68c25860e8f03803$var$SvgActionLockOn = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M17 7v2.18c1.16.42 2 1.52 2 2.82v7c0 1.66-1.34 3-3 3H8c-1.66 0-3-1.34-3-3v-7c0-1.3.84-2.4 2-2.82V7c0-2.76 2.24-5 5-5s5 2.24 5 5m-2 0c0-1.65-1.35-3-3-3S9 5.35 9 7v2h6zm1 13c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm-2.5-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
            clipRule: "evenodd"
        })
    });
var $68c25860e8f03803$export$2e2bcd8739ae039 = $68c25860e8f03803$var$SvgActionLockOn;



parcelRequire("acw62");
const $098aefa0dee8a062$var$SvgActionMessage = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 19 19",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M1 8.999C1 4.029 5.03 0 10 0s9 4.03 9 8.999c0 .574-.06 1.129-.16 1.661a9.02 9.02 0 0 1-4.295 6.102h-.002a8.95 8.95 0 0 1-8.847.131L4.2 17.36.48 18.52l1.16-3.72.467-1.494A8.9 8.9 0 0 1 1 8.999M10 2a7 7 0 0 0-7 6.999c0 1.343.384 2.592 1.043 3.658l.24.388-.758 2.43.08-.024 2.349-.733.387.238a6.946 6.946 0 0 0 7.19.082 7.02 7.02 0 0 0 3.344-4.746C16.955 9.865 17 9.434 17 9A7 7 0 0 0 10 2",
            clipRule: "evenodd"
        })
    });
var $098aefa0dee8a062$export$2e2bcd8739ae039 = $098aefa0dee8a062$var$SvgActionMessage;



parcelRequire("acw62");
const $5107a4283e5093ff$var$SvgArrowDualRotatingArrows = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 22,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M1.77 16.01c.04-.04.07-.09.11-.13l1.31-1.31A5.9 5.9 0 0 1 2 11c0-3.31 2.69-6 6-6h1.59L8.3 6.29 9.71 7.7l3-3a.996.996 0 0 0 0-1.41l-3-3L8.3 1.7 9.59 3H8c-4.41 0-8 3.59-8 8 0 1.85.62 3.6 1.77 5.01M14 11c0 3.31-2.69 6-6 6H6.41l1.29-1.29-1.41-1.41-3 3a.996.996 0 0 0 0 1.41l3 3L7.7 20.3 6.41 19H8c4.41 0 8-3.59 8-8 0-1.85-.62-3.6-1.77-5.01-.04.04-.07.09-.11.13l-1.31 1.31A5.9 5.9 0 0 1 14 11"
        })
    });
var $5107a4283e5093ff$export$2e2bcd8739ae039 = $5107a4283e5093ff$var$SvgArrowDualRotatingArrows;



parcelRequire("acw62");
const $cac23a2dd1647340$var$SvgAlertQuestionMarkCircle = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-2a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 9 14M6 6.75C6 5.23 7.35 4 9 4s3 1.23 3 2.75c0 1.11-.66 1.77-1.19 2.29-.53.53-.81.83-.81 1.46H8c0-1.48.8-2.28 1.388-2.868L9.4 7.62c.44-.43.6-.61.6-.87C10 6.34 9.54 6 9 6s-1 .34-1 .75z",
            clipRule: "evenodd"
        })
    });
var $cac23a2dd1647340$export$2e2bcd8739ae039 = $cac23a2dd1647340$var$SvgAlertQuestionMarkCircle;



parcelRequire("acw62");
const $92250f559716e808$var$SvgFinanceCardSwipe = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 14",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M17 0H3C1.34 0 0 1.34 0 3v8c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3m1 11c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V6h16zM2 4V3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v1z"
        })
    });
var $92250f559716e808$export$2e2bcd8739ae039 = $92250f559716e808$var$SvgFinanceCardSwipe;




/**
 * This file is used to define the card management items and their actions.
 *
 * This file may change when the actions are implemented
 */ /**
 * These are the status in which the card is activated and the majority of settings
 * are accessible to the user.
 */ const $b4caa49c14bbb322$var$ACTIVE_CARD_STATES = [
    (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVE,
    (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED
];
const $b4caa49c14bbb322$export$602235b7817de594 = (status)=>{
    if (status == null) return false;
    return $b4caa49c14bbb322$var$ACTIVE_CARD_STATES.includes(status);
};
const $b4caa49c14bbb322$export$2fcbf09f7363273b = (t)=>(state, dispatch)=>({
            Icon: (0, $3de42ffd7affe746$export$2e2bcd8739ae039),
            text: t("section.settings.actions.showCardDetails"),
            control: (0, $67b4545ba4ea2391$export$18f8036a6dc5f3a5).TOGGLE,
            hidden: state.card?.status !== (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVE,
            value: state.showCardDetails,
            action: ()=>dispatch((0, $f85882ff218eecf6$export$f74d2d3c457dc478)(!state.showCardDetails))
        });
const $b4caa49c14bbb322$export$130c3b3bd8381d24 = (t, getFlagValue)=>(state, dispatch)=>{
        const status = state.card?.status;
        return {
            Icon: status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED ? (0, $20c5e8324d8e54d7$export$2e2bcd8739ae039) : (0, $68c25860e8f03803$export$2e2bcd8739ae039),
            text: status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED ? t("section.settings.actions.toggleLockCard.unlock") : t("section.settings.actions.toggleLockCard.lock"),
            control: (0, $67b4545ba4ea2391$export$18f8036a6dc5f3a5).TOGGLE,
            hidden: getFlagValue((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad).canToggleLockCard) === false || !$b4caa49c14bbb322$export$602235b7817de594(status),
            loading: state.toggleLoading.lockCard,
            value: status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED,
            action: ()=>dispatch((0, $f85882ff218eecf6$export$d395068d63fb6384)(!(status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED)))
        };
    };
const $b4caa49c14bbb322$export$5a00c9fa00a5082b = (t, getFlagValue)=>(state, dispatch)=>({
            Icon: (0, $5107a4283e5093ff$export$2e2bcd8739ae039),
            text: t("section.settings.actions.resetPin"),
            hidden: getFlagValue((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad).canUpdatePin) === false || !$b4caa49c14bbb322$export$602235b7817de594(state.card?.status),
            action: ()=>dispatch((0, $f85882ff218eecf6$export$95b3c069ab4a2752)())
        });
const $b4caa49c14bbb322$export$86fc0ee5ddebf360 = (t, getFlagValue)=>(state, dispatch)=>[
            $b4caa49c14bbb322$export$2fcbf09f7363273b(t)(state, dispatch),
            $b4caa49c14bbb322$export$130c3b3bd8381d24(t, getFlagValue)(state, dispatch),
            $b4caa49c14bbb322$export$5a00c9fa00a5082b(t, getFlagValue)(state, dispatch)
        ];
const $b4caa49c14bbb322$export$5699e2a53bd86cbe = (t)=>[
        {
            Icon: (0, $92250f559716e808$export$2e2bcd8739ae039),
            text: t("section.help.actions.cardHelp"),
            action: ()=>{
                // TODO(cvu): implement card management actions
                console.log("card help");
            }
        },
        {
            Icon: (0, $cac23a2dd1647340$export$2e2bcd8739ae039),
            text: t("section.help.actions.supportArticles"),
            action: ()=>{
                // TODO(cvu): implement card management actions
                console.log("support articles");
            }
        },
        {
            Icon: (0, $098aefa0dee8a062$export$2e2bcd8739ae039),
            text: t("section.help.actions.contactUs"),
            action: ()=>{
                // TODO(cvu): implement card management actions
                console.log("contact us");
            }
        }
    ];



var $acw62 = parcelRequire("acw62");



const $68b24b260ef7a1f3$export$132644df149d36c1 = (flagConfigs, userToken)=>({
        project: (0, $1f14c967a58ea158$export$b6032183171af19f).PIE,
        flagConfigs: flagConfigs,
        origin: (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039).origin,
        withCredentials: true,
        offlineMode: false,
        userToken: userToken
    });
var $68b24b260ef7a1f3$export$2e2bcd8739ae039 = $68b24b260ef7a1f3$export$132644df149d36c1;


function $ea440760c63f6861$export$43f174d627cf7c49(flagConfigs, userToken) {
    const [client, setClient] = (0, $acw62.useState)();
    const [flagsLoaded, setFlagsLoaded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const client = (0, $1f14c967a58ea158$export$4c027c4176fa384)((0, $68b24b260ef7a1f3$export$2e2bcd8739ae039)(flagConfigs, userToken));
        setClient(client);
    }, []);
    (0, $acw62.useEffect)(()=>{
        // NOTE(cvu): Load flags can throw an error. I am going to let it throw for now.
        client?.loadFlags().then(()=>{
            setFlagsLoaded(true);
        });
    }, [
        client
    ]);
    const getFlagValue = (flag)=>{
        if (!flagsLoaded) throw new Error("Flags have not been loaded, please call 'loadFlags' before fetching flag");
        return client?.getFlagValue(flag);
    };
    return {
        flagsLoaded: flagsLoaded,
        getFlagValue: getFlagValue
    };
}




function $cc584424654c833c$export$e314053f2db92863({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-settings");
    const launchDarklyClient = (0, $ea440760c63f6861$export$43f174d627cf7c49)((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad), {
        token: "anonymousUser",
        type: (0, $1f14c967a58ea158$export$f435f793048e7a0f).ANONYMOUS_VISITOR
    });
    return launchDarklyClient.flagsLoaded && launchDarklyClient.getFlagValue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65a7b64dd007d7b7$export$7aa52cf130c2f005), {
        card: state.card || (0, $d272bac0a1712861$export$60332b2344f7fe41).create(),
        cardCustomization: state.cardCustomization || undefined,
        cardSettings: (0, $b4caa49c14bbb322$export$86fc0ee5ddebf360)(t, launchDarklyClient.getFlagValue)(state, dispatch),
        helpSettings: [],
        showCardDetails: state.showCardDetails,
        onActivateCardClick: ()=>dispatch((0, $f85882ff218eecf6$export$4b6cffd9a01ae17)())
    }) : null;
}





const $46e9f01d04e1602b$var$openCardActivationModal = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, action])=>action.type === (0, $f85882ff218eecf6$export$e4a712fff93fb00f).UserClickActivateCard), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>({
            to: "activate-card",
            state: {
                cardActivation: {
                    done: false
                }
            }
        })));
const $46e9f01d04e1602b$var$openResetPinModal = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, action])=>action.type === (0, $f85882ff218eecf6$export$e4a712fff93fb00f).UserClickResetPin), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>({
            to: "reset-pin"
        })));
const $46e9f01d04e1602b$var$navigation = (source)=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(...[
        $46e9f01d04e1602b$var$openCardActivationModal,
        $46e9f01d04e1602b$var$openResetPinModal
    ].map((transition)=>source.pipe(transition))).pipe((0, $4707859e785b3da6$export$18aef43295bbe906)());
var $46e9f01d04e1602b$export$2e2bcd8739ae039 = $46e9f01d04e1602b$var$navigation;


function $f754305549e0f040$export$2239573305b2aa49({ cardManagementService: cardManagementService, externalBizbankService: externalBizbankService }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-settings");
    const { cardToken: cardToken } = (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)();
    const location = (0, $baf2581b6f4e4c0a$export$45d76561a5302f2b)();
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const [cardSettingsState, cardSettingsDispatch, cardSettingsWorkflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        cardManagementService: cardManagementService,
        externalBizbankService: externalBizbankService,
        sentry: {
            captureException: $f2b90654edf2c0a1$export$f5282963edea4a68
        }
    }, $f85882ff218eecf6$export$e6a0daad8304de(), $f85882ff218eecf6$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        const subscriptions = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscriptions.add(cardSettingsWorkflow.updates.pipe((0, $46e9f01d04e1602b$export$2e2bcd8739ae039)).subscribe((nav)=>navigate(nav.to, nav.options)));
        return ()=>{
            subscriptions.unsubscribe();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (cardToken != null) cardSettingsDispatch($f85882ff218eecf6$export$c81c36414a1e3192(cardToken));
    }, [
        cardToken
    ]);
    (0, $acw62.useEffect)(()=>{
        // refetch the card data if card activation is completed
        if (location.state?.cardActivation?.done && cardToken != null) cardSettingsDispatch($f85882ff218eecf6$export$c81c36414a1e3192(cardToken));
    }, [
        location
    ]);
    const breadcrumb = {
        title: t("routes.overview", {
            ns: "site"
        }),
        link: {
            to: "/"
        }
    };
    const headerElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cb7d9ae27028ab3$export$53f1cd6809577fc5), {
        breadcrumb: breadcrumb,
        title: cardSettingsState.card ? (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(cardSettingsState.card) : ""
    });
    return cardSettingsState.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$28c2b904b2ab5c88), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $10b264b7e14b606b$export$6955bcca4cd3539f), {
        header: headerElement,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc584424654c833c$export$e314053f2db92863), {
                state: cardSettingsState,
                dispatch: cardSettingsDispatch
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$910ae8079b2c2852), {})
        ]
    });
}


const $ffa5c35d73b6afd6$export$fdf04d45b6511766 = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $f754305549e0f040$export$2239573305b2aa49), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE,
    externalBizbankService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).EXTERNAL_BIZBANK_SERVICE
});






var $acw62 = parcelRequire("acw62");










var $a81baa7b3cd02573$export$484fa93d7befe621;
var $a81baa7b3cd02573$export$acf4eaf431084f78;
var $a81baa7b3cd02573$export$70a5d6cdc959e89c;
$a81baa7b3cd02573$export$484fa93d7befe621 = `qaDDfW_CardStatus_cardDetailsButton`;
$a81baa7b3cd02573$export$acf4eaf431084f78 = `qaDDfW_CardStatus_iconContainer`;
$a81baa7b3cd02573$export$70a5d6cdc959e89c = `qaDDfW_CardStatus_statusTrackerContainer`;




var $c7723983a8e93402$exports = {};

$parcel$export($c7723983a8e93402$exports, "icon", () => $c7723983a8e93402$export$1ca1ec8b29a4ce27, (v) => $c7723983a8e93402$export$1ca1ec8b29a4ce27 = v);
$parcel$export($c7723983a8e93402$exports, "iconContainer", () => $c7723983a8e93402$export$acf4eaf431084f78, (v) => $c7723983a8e93402$export$acf4eaf431084f78 = v);
$parcel$export($c7723983a8e93402$exports, "iconCurrent", () => $c7723983a8e93402$export$6a5f1703c8ba8b15, (v) => $c7723983a8e93402$export$6a5f1703c8ba8b15 = v);
$parcel$export($c7723983a8e93402$exports, "iconEmphasis", () => $c7723983a8e93402$export$9935ad3322fea53, (v) => $c7723983a8e93402$export$9935ad3322fea53 = v);
$parcel$export($c7723983a8e93402$exports, "label", () => $c7723983a8e93402$export$1237798dc640739a, (v) => $c7723983a8e93402$export$1237798dc640739a = v);
$parcel$export($c7723983a8e93402$exports, "labelCompleted", () => $c7723983a8e93402$export$9ac6f9b4edc3f60a, (v) => $c7723983a8e93402$export$9ac6f9b4edc3f60a = v);
$parcel$export($c7723983a8e93402$exports, "labelContainer", () => $c7723983a8e93402$export$a1b12bea82a67f51, (v) => $c7723983a8e93402$export$a1b12bea82a67f51 = v);
$parcel$export($c7723983a8e93402$exports, "progressBar", () => $c7723983a8e93402$export$9d1298853f0e77f7, (v) => $c7723983a8e93402$export$9d1298853f0e77f7 = v);
$parcel$export($c7723983a8e93402$exports, "progressBarCompleted", () => $c7723983a8e93402$export$dafac656802d4b04, (v) => $c7723983a8e93402$export$dafac656802d4b04 = v);
$parcel$export($c7723983a8e93402$exports, "progressContainer", () => $c7723983a8e93402$export$2612087cf48ded35, (v) => $c7723983a8e93402$export$2612087cf48ded35 = v);
$parcel$export($c7723983a8e93402$exports, "progressSegment", () => $c7723983a8e93402$export$2f1a7971962a5dcd, (v) => $c7723983a8e93402$export$2f1a7971962a5dcd = v);
var $c7723983a8e93402$export$1ca1ec8b29a4ce27;
var $c7723983a8e93402$export$acf4eaf431084f78;
var $c7723983a8e93402$export$6a5f1703c8ba8b15;
var $c7723983a8e93402$export$9935ad3322fea53;
var $c7723983a8e93402$export$1237798dc640739a;
var $c7723983a8e93402$export$9ac6f9b4edc3f60a;
var $c7723983a8e93402$export$a1b12bea82a67f51;
var $c7723983a8e93402$export$9d1298853f0e77f7;
var $c7723983a8e93402$export$dafac656802d4b04;
var $c7723983a8e93402$export$2612087cf48ded35;
var $c7723983a8e93402$export$2f1a7971962a5dcd;
$c7723983a8e93402$export$1ca1ec8b29a4ce27 = `kIK7lG_StatusTracker_icon`;
$c7723983a8e93402$export$acf4eaf431084f78 = `kIK7lG_StatusTracker_iconContainer`;
$c7723983a8e93402$export$6a5f1703c8ba8b15 = `kIK7lG_StatusTracker_iconCurrent`;
$c7723983a8e93402$export$9935ad3322fea53 = `kIK7lG_StatusTracker_iconEmphasis`;
$c7723983a8e93402$export$1237798dc640739a = `kIK7lG_StatusTracker_label`;
$c7723983a8e93402$export$9ac6f9b4edc3f60a = `kIK7lG_StatusTracker_labelCompleted`;
$c7723983a8e93402$export$a1b12bea82a67f51 = `kIK7lG_StatusTracker_labelContainer`;
$c7723983a8e93402$export$9d1298853f0e77f7 = `kIK7lG_StatusTracker_progressBar`;
$c7723983a8e93402$export$dafac656802d4b04 = `kIK7lG_StatusTracker_progressBarCompleted`;
$c7723983a8e93402$export$2612087cf48ded35 = `kIK7lG_StatusTracker_progressContainer`;
$c7723983a8e93402$export$2f1a7971962a5dcd = `kIK7lG_StatusTracker_progressSegment`;


function $cd1f284c3beac8a4$export$4232ddc329592180({ currentStepIndex: currentStepIndex, steps: steps }) {
    const generateIconProgressSegments = (index, currentStepIndex)=>{
        const progressBarStyles = currentStepIndex >= index ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressBar, (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressBarCompleted) : (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressBar;
        const iconStyles = currentStepIndex >= index ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).icon, (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).iconCurrent) : (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).icon;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressSegment,
            children: [
                index !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: progressBarStyles
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).iconContainer,
                    children: [
                        index === currentStepIndex ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).iconEmphasis
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: iconStyles
                        })
                    ]
                })
            ]
        }, index);
    };
    const getLabelStyles = (index, currentStepIndex)=>currentStepIndex >= index ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("semibold-20", (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).label, (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).labelCompleted) : (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("semibold-20", (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).label);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressContainer,
                children: steps.map((step, index)=>generateIconProgressSegments(index, currentStepIndex))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).labelContainer,
                children: steps.map((step, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: getLabelStyles(index, currentStepIndex),
                        children: step
                    }, index))
            })
        ]
    });
}





var $bd8ab4d7b3f60bfa$export$f9f3bb5fa67216a9 = /*#__PURE__*/ function(StepIndex) {
    StepIndex[StepIndex["Printing"] = 0] = "Printing";
    StepIndex[StepIndex["Shipping"] = 1] = "Shipping";
    StepIndex[StepIndex["Activatable"] = 2] = "Activatable";
    return StepIndex;
}({});
const $bd8ab4d7b3f60bfa$export$e6c736e769e1d104 = (t)=>(estimatedDeliveryDate)=>[
            {
                title: t("stepPrinting.title"),
                description: t("stepPrinting.description", {
                    replace: {
                        estimatedDeliveryDate: estimatedDeliveryDate
                    }
                }),
                trackerLabels: {
                    trackerLabelCurrent: t("stepPrinting.stepText"),
                    trackerLabelCompleted: t("stepPrinting.completedStepText")
                }
            },
            {
                title: t("stepOnTheWay.title"),
                description: t("stepOnTheWay.description", {
                    replace: {
                        estimatedDeliveryDate: estimatedDeliveryDate
                    }
                }),
                trackerLabels: {
                    trackerLabelCurrent: t("stepOnTheWay.stepText")
                }
            },
            {
                title: t("stepActivate.title"),
                description: t("stepActivate.description"),
                trackerLabels: {
                    trackerLabelCurrent: t("stepActivate.stepText")
                }
            }
        ];
const $bd8ab4d7b3f60bfa$export$47fdefecd3e5b7fc = (steps, currentStepIndex)=>steps.map((step, index)=>{
        if (currentStepIndex === index) return step.trackerLabels.trackerLabelCurrent;
        // Default to current step label if completed label does not exist
        return step.trackerLabels.trackerLabelCompleted || step.trackerLabels.trackerLabelCurrent;
    });
const $bd8ab4d7b3f60bfa$export$6da507a69b4a760 = (fulfillmentShippingStatus)=>{
    // NOTE(cvu): Staging does not have ShippingStatus. This is here temporarily
    // so staging doesn't break.
    // TODO(cvu): Remove this when we have shipping status
    if (!fulfillmentShippingStatus) return 0;
    const shippingStatus = (0, $d272bac0a1712861$export$b2a48b6a70d75edb).FulfillmentStatus;
    if (fulfillmentShippingStatus === shippingStatus.FULFILLMENT_STATUS_PROCESSING) return 0;
    if (fulfillmentShippingStatus === shippingStatus.FULFILLMENT_STATUS_SHIPPED) return 1;
    // TODO(cvu): add condition of after end number of dates have passed or some activatable state check condition
    if (fulfillmentShippingStatus === shippingStatus.FULFILLMENT_STATUS_DELIVERED) return 2;
    throw new Error("Unknown card fulfillment shipping status");
};
const $bd8ab4d7b3f60bfa$export$875e999ecf0156c7 = (t)=>(card)=>{
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(card, "Card is undefined/null");
        const { expirationData: expirationData, fulfillment: fulfillment, fullPan: fullPan, securityCode: securityCode } = card;
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(fullPan, "Missing full pan");
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(expirationData, "Missing expiration data");
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(securityCode, "Missing security code");
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(fulfillment, "Missing fulfillment");
        const { address: address, status: status } = fulfillment;
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(address, "Missing address");
        const trackerStepIndex = $bd8ab4d7b3f60bfa$export$6da507a69b4a760(status);
        // TODO(cvu): calculate this somewhere
        const estimatedDeliveryDate = "ESTIMATE_DATE";
        const steps = $bd8ab4d7b3f60bfa$export$e6c736e769e1d104(t)(estimatedDeliveryDate);
        const step = steps[trackerStepIndex];
        return {
            cardPreview: {
                businessName: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card),
                cardholder: (0, $1f03a6bc7d91b109$export$f0d76c98e43e3f03)(card),
                cvc: (0, $1f03a6bc7d91b109$export$7f1de93407df59b0)(card),
                expirationDate: (0, $1f03a6bc7d91b109$export$1bbc5be1c1af00a7)(card),
                fullPan: (0, $1f03a6bc7d91b109$export$eb37d3dae2bf604a)(card),
                signatureDataUri: (0, $1f03a6bc7d91b109$export$461358cf94db3eb1)()
            },
            address: address,
            description: step.description,
            title: step.title,
            trackerLabels: $bd8ab4d7b3f60bfa$export$47fdefecd3e5b7fc(steps, trackerStepIndex),
            trackerStepIndex: trackerStepIndex
        };
    };


const $098dac6bfd59e01c$export$9ab766ce7f4c1f3c = (address)=>{
    const { addressLine1: addressLine1, addressLine2: addressLine2, locality: locality, administrativeDistrictLevel1: administrativeDistrictLevel1, postalCode: postalCode } = address;
    const lineOne = addressLine2 ? `${addressLine1}, ${addressLine2}` : addressLine1;
    const lineTwo = `${locality}, ${administrativeDistrictLevel1} ${postalCode}`;
    return [
        lineOne,
        lineTwo
    ];
};




parcelRequire("acw62");
const $6d4efe3506892de5$var$SvgActionEyeSlash = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 18",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#7B61FF",
                fillRule: "evenodd",
                d: "M14.548 14.96h.002l2.75 2.75 1.41-1.41-2.4-2.4c1.5-1.12 2.75-2.63 3.6-4.47.12-.27.12-.58 0-.84C18.03 4.52 14.23 2 10 2c-1.61 0-3.15.37-4.55 1.04L2.71.29 1.294 1.706l10.724 10.725.002-.001.99.99h-.002zM9.49 7.07l2.44 2.44c.04-.16.07-.33.07-.51 0-1.1-.9-2-2-2-.18 0-.35.03-.51.07m3.94 3.95 1.43 1.43A9.6 9.6 0 0 0 17.89 9c-1.61-3.1-4.6-5-7.89-5-1.05 0-2.06.21-3.01.58l.99.99C8.57 5.22 9.26 5 10 5c2.21 0 4 1.79 4 4 0 .74-.21 1.43-.57 2.02",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#7B61FF",
                d: "M9.751 12.992 6.008 9.25a4 4 0 0 0 3.743 3.743"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#7B61FF",
                d: "M3.617 6.858A9.6 9.6 0 0 0 2.11 9c1.61 3.1 4.6 5 7.89 5q.366 0 .725-.033l1.739 1.738c-.795.193-1.62.295-2.464.295-4.23 0-8.03-2.52-9.91-6.58-.12-.26-.12-.57 0-.84A11.8 11.8 0 0 1 2.2 5.441z"
            })
        ]
    });
var $6d4efe3506892de5$export$2e2bcd8739ae039 = $6d4efe3506892de5$var$SvgActionEyeSlash;




function $62342eb4086d381f$export$490c7ce941281ba8({ cardManagementService: cardManagementService, externalBizbankService: externalBizbankService }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-status");
    const { cardToken: cardToken } = (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)();
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const [card, setCard] = (0, $acw62.useState)((0, $d272bac0a1712861$export$60332b2344f7fe41).create());
    const [cardCustomization, setCardCustomization] = (0, $acw62.useState)(null);
    const [cardStatusState, setCardStatusState] = (0, $acw62.useState)(null);
    const [showCardDetails, setShowCardDetails] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!cardToken) return;
        try {
            (async ()=>{
                const retrieveCardResponse = await cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
                    cardToken: cardToken,
                    fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
                }));
                const card = retrieveCardResponse.card;
                setCardStatusState((0, $bd8ab4d7b3f60bfa$export$875e999ecf0156c7)(t)(card));
                if (card) {
                    setCard(card);
                    const customizationToken = card.fulfillment?.cardCustomization?.id;
                    if (customizationToken) {
                        const res = await externalBizbankService.getCardCustomization((0, $3f73c216104868a6$export$1a963d2655841b69).create({
                            customizationToken: customizationToken
                        }));
                        setCardCustomization(res.cardCustomization ?? null);
                    }
                }
            })();
        } catch (error) {
            (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error, {
                contexts: {
                    info: {
                        message: "Fetching Card or CardCustomization failed.",
                        cardToken: cardToken
                    }
                }
            });
        }
    }, [
        cardToken
    ]);
    const breadcrumb = {
        title: t("routes.overview", {
            ns: "site"
        }),
        link: {
            to: "/"
        }
    };
    const headerElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cb7d9ae27028ab3$export$53f1cd6809577fc5), {
        breadcrumb: breadcrumb,
        title: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card)
    });
    const getTrackerContents = (isMobile, cardStatusState)=>{
        if (cardStatusState === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        const onShowCardDetailsClick = ()=>{
            setShowCardDetails(!showCardDetails);
        };
        const showDetailsButton = (showCardDetails)=>{
            if (showCardDetails) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                className: (0, $a81baa7b3cd02573$export$484fa93d7befe621),
                onClick: onShowCardDetailsClick,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: "icon",
                        className: (0, $a81baa7b3cd02573$export$acf4eaf431084f78),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d4efe3506892de5$export$2e2bcd8739ae039), {})
                    }),
                    t("hideCardNumberButtonText")
                ]
            });
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                className: (0, $a81baa7b3cd02573$export$484fa93d7befe621),
                onClick: onShowCardDetailsClick,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: "icon",
                        className: (0, $a81baa7b3cd02573$export$acf4eaf431084f78),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3de42ffd7affe746$export$2e2bcd8739ae039), {})
                    }),
                    t("showCardNumberButtonText")
                ]
            });
        };
        const [formattedLine1, formattedLine2] = (0, $098dac6bfd59e01c$export$9ab766ce7f4c1f3c)(cardStatusState.address);
        const { title: title, description: description, trackerLabels: trackerLabels, trackerStepIndex: trackerStepIndex, cardPreview: cardPreview } = cardStatusState;
        const contents = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $a81baa7b3cd02573$export$70a5d6cdc959e89c),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "semibold-30",
                    children: description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: formattedLine1
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: formattedLine2
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd1f284c3beac8a4$export$4232ddc329592180), {
                    steps: trackerLabels,
                    currentStepIndex: trackerStepIndex
                })
            ]
        });
        if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d559914ba3bc587b$export$115f017852a4bb7c), {
                    ...cardPreview,
                    showCardDetails: showCardDetails
                }),
                showDetailsButton(showCardDetails),
                contents
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $034af6c0eb5c10e4$export$7ffad9c53e8a82d9), {
            card: card,
            cardCustomization: cardCustomization || undefined,
            previewSecondaryContent: showDetailsButton(showCardDetails),
            showCardDetails: showCardDetails,
            children: contents
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10b264b7e14b606b$export$6955bcca4cd3539f), {
        header: headerElement,
        children: getTrackerContents(windowDimensions.isMobile, cardStatusState)
    });
}


const $b9b8f95d28dd1cc4$export$cc5a44eb2bffd45a = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $62342eb4086d381f$export$490c7ce941281ba8), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE,
    externalBizbankService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).EXTERNAL_BIZBANK_SERVICE
});






var $72623ab6bcb0a33b$exports = {};
'use strict';
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;



var $acw62 = parcelRequire("acw62");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe334ae3892c74f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





var $acw62 = parcelRequire("acw62");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $262dc4fd22993153$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $262dc4fd22993153$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $262dc4fd22993153$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($262dc4fd22993153$export$a87138b73900f5b((0, $acw62.version)) && (0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $262dc4fd22993153$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error, {
        ...hint,
        captureContext: {
            contexts: {
                react: {
                    componentStack: componentStack
                }
            }
        }
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $262dc4fd22993153$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $262dc4fd22993153$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $8921079907ea55d7$export$6ef4c0367e27f2d5 = 'unknown';
const $8921079907ea55d7$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8921079907ea55d7$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        $8921079907ea55d7$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $8921079907ea55d7$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        // TODO(v9): Remove this check and type `componentStack` to be React.ErrorInfo['componentStack'].
        const passedInComponentStack = componentStack == null ? undefined : componentStack;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, passedInComponentStack);
            const eventId = (0, $262dc4fd22993153$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, passedInComponentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($8921079907ea55d7$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === 'function') element = $acw62.createElement(fallback, {
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($acw62.isValidElement(element)) return element;
            if (fallback) (0, $fe334ae3892c74f1$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('fallback did not produce a valid ReactElement');
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === 'function') return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8921079907ea55d7$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8921079907ea55d7$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($8921079907ea55d7$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $acw62.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(Wrapped, WrappedComponent);
    return Wrapped;
}






var $78e63bfb11f97634$export$5ea928c9faf85bd3;
$78e63bfb11f97634$export$5ea928c9faf85bd3 = `-K8hva_Error_alert`;


function $577020a59df1a3ff$export$edf27be85e5f6da0() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site", {
        keyPrefix: "error.page"
    });
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const onButtonClick = ()=>{
        // refresh page
        navigate(0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $78e63bfb11f97634$export$5ea928c9faf85bd3,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f269f6a0cbba3c$export$caec2af78bcc877f), {
            buttonText: t("buttonText"),
            color: (0, $06f269f6a0cbba3c$export$2ddc1882e756bb44).Grey,
            description: t("description"),
            icon: (0, $06f269f6a0cbba3c$export$4a143c8822a09fb4).X,
            title: t("title"),
            onButtonClick: onButtonClick
        })
    });
}





parcelRequire("acw62");
const $07558121fd9459b9$var$SvgSquareLogo = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#000",
                fillOpacity: 0.9,
                d: "M19.989 0H4.011A4.01 4.01 0 0 0 0 4.01v15.978A4.01 4.01 0 0 0 4.011 24h15.978A4.01 4.01 0 0 0 24 19.988V4.01A4.01 4.01 0 0 0 19.989 0m-.353 18.371a1.266 1.266 0 0 1-1.265 1.266H5.631a1.266 1.266 0 0 1-1.265-1.266V5.63a1.265 1.265 0 0 1 1.265-1.266h12.74a1.266 1.266 0 0 1 1.265 1.266z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#000",
                fillOpacity: 0.9,
                d: "M9.45 15.256a.727.727 0 0 1-.726-.729V9.441a.726.726 0 0 1 .726-.73h5.1a.727.727 0 0 1 .726.73v5.086a.725.725 0 0 1-.726.729z"
            })
        ]
    });
var $07558121fd9459b9$export$2e2bcd8739ae039 = $07558121fd9459b9$var$SvgSquareLogo;



parcelRequire("acw62");
const $807caacbf22c63a9$var$SvgQuestionMark = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#000",
            fillOpacity: 0.9,
            fillRule: "evenodd",
            d: "M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-2a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 9 14M6 6.75C6 5.23 7.35 4 9 4s3 1.23 3 2.75c0 1.11-.66 1.77-1.19 2.29-.53.53-.81.83-.81 1.46H8c0-1.48.8-2.28 1.388-2.868L9.4 7.62c.44-.43.6-.61.6-.87C10 6.34 9.54 6 9 6s-1 .34-1 .75z",
            clipRule: "evenodd"
        })
    });
var $807caacbf22c63a9$export$2e2bcd8739ae039 = $807caacbf22c63a9$var$SvgQuestionMark;






var $c0ba15911c7a95e9$export$d0f464870998e995;
$c0ba15911c7a95e9$export$d0f464870998e995 = `vZph2q_AccountDropdown_accountName`;


function $86cb485473df5872$export$f82a7981da43931a({ accountName: accountName, options: options }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$55e40bf6ba98f173), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "semibold-20",
                slot: "trigger",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: $c0ba15911c7a95e9$export$d0f464870998e995,
                    children: accountName
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$a00ed319fc43be46), {
                slot: "popover",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$5f38cc4b3e71c577), {
                    transient: true,
                    children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$14eeaa98ef1abeb2), {
                            size: "small",
                            onClick: option.callback,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                slot: "label",
                                children: option.name
                            })
                        }, option.name))
                })
            })
        ]
    });
}


var $8fda1502fcc70b61$exports = {};

$8fda1502fcc70b61$exports["container"] = `KsVgLq_AppNavBar_container`;
$8fda1502fcc70b61$exports["help"] = `KsVgLq_AppNavBar_help`;
$8fda1502fcc70b61$exports["icon"] = `KsVgLq_AppNavBar_icon`;
$8fda1502fcc70b61$exports["navContent"] = `KsVgLq_AppNavBar_navContent`;
$8fda1502fcc70b61$exports["navTopOffset"] = `KsVgLq_AppNavBar_navTopOffset`;
$8fda1502fcc70b61$exports["right"] = `KsVgLq_AppNavBar_right`;
for(let key in $a3b0f2fdf3961f6f$exports)if (key in $8fda1502fcc70b61$exports) $8fda1502fcc70b61$exports[key] += ' ' + $a3b0f2fdf3961f6f$exports[key];
else $8fda1502fcc70b61$exports[key] = $a3b0f2fdf3961f6f$exports[key];


function $f9e218b81ec54d12$export$ad89b3f114c71ca({ user: user }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site");
    const accountDropdownOptions = [
        {
            name: t("navigation.accountDropdownOptions.personalSettings"),
            callback: ()=>{
                window.location.href = `${0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039}help`;
            }
        },
        {
            name: t("navigation.accountDropdownOptions.signOut"),
            callback: ()=>{
                window.location.href = `${0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039}logout`;
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: $8fda1502fcc70b61$exports.navTopOffset,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $8fda1502fcc70b61$exports.container,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: $8fda1502fcc70b61$exports.navContent,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "semibold-20",
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07558121fd9459b9$export$2e2bcd8739ae039), {
                            className: $8fda1502fcc70b61$exports.icon
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $8fda1502fcc70b61$exports.right,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: $8fda1502fcc70b61$exports.help,
                                    href: `${(0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039)}help`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $807caacbf22c63a9$export$2e2bcd8739ae039), {
                                        className: $8fda1502fcc70b61$exports.icon
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86cb485473df5872$export$f82a7981da43931a), {
                                    accountName: (0, $f52070b5f7ea08cf$export$155800cbebf9d04f)(user),
                                    options: accountDropdownOptions
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}




function $becdf5d7bd69726e$export$be92b6f5f03c0fe9() {
    const [user] = (0, $6a9ee46bb299cc77$export$23bbbc4533528f03)();
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const navBar = windowDimensions.isMobile ? null : user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e218b81ec54d12$export$ad89b3f114c71ca), {
        user: user
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            navBar,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8921079907ea55d7$export$e926676385687eaf), {
                fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $577020a59df1a3ff$export$edf27be85e5f6da0), {}),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b6caee6a6f10651$export$910ae8079b2c2852), {})
            })
        ]
    });
}






const $eb322dd52f4d040c$export$fcd084e6273b1578 = (Component, propsToParam)=>// eslint-disable-next-line react/display-name
    (props)=>{
        const params = (0, $baf2581b6f4e4c0a$export$99eaa27ddbbb95ef)();
        const paramsMappedToProps = Object.entries(propsToParam).reduce((acc, [propName, paramName])=>{
            const paramString = paramName;
            const value = params[paramString];
            if (value == null) throw new Error(`param '${paramString}' does not exist`);
            return {
                ...acc,
                [propName]: value
            };
        }, {});
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ...paramsMappedToProps
        });
    };





var $acw62 = parcelRequire("acw62");



var $5sKyw = parcelRequire("5sKyw");








/**
 * Set pin workflow to set/reset pin.
 */ const $41708348d2f204d8$var$PIN_LENGTH = 4;
var $41708348d2f204d8$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen["SetPin"] = "SCREEN_SET_PIN";
    Screen["ConfirmPin"] = "SCREEN_CONFIRM_PIN";
    return Screen;
}({});
var $41708348d2f204d8$export$edf27be85e5f6da0 = /*#__PURE__*/ function(Error) {
    Error["WeakPin"] = "ERROR_WEAK_PIN";
    Error["InvalidPinMatch"] = "ERROR_INVALID_PIN_MATCH";
    Error["GenericError"] = "ERROR_GENERIC";
    return Error;
}({});
var $41708348d2f204d8$export$54d4c18dc78a26d4 = /*#__PURE__*/ function(ValueError) {
    ValueError["InvalidLength"] = "VALUE_ERROR_INVALID_LENGTH";
    return ValueError;
}({});
const $41708348d2f204d8$export$36d128238e6b60f5 = {
    cardToken: "",
    confirmPin: "",
    confirmPinError: [],
    error: [],
    loading: false,
    pin: "",
    pinError: []
};
const $41708348d2f204d8$export$e6a0daad8304de = (overrides = {})=>({
        ...$41708348d2f204d8$export$36d128238e6b60f5,
        ...overrides
    });
var $41708348d2f204d8$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Done"] = "SET_PIN_DONE";
    ActionType["Initialize"] = "SET_PIN_INITIALIZE";
    ActionType["SetPin"] = "SET_PIN_SET_PIN";
    ActionType["SetPinReceived"] = "SET_PIN_RECEIVED";
    ActionType["SetPinRejected"] = "SET_PIN_REJECTED";
    ActionType["UserChangeConfirmPin"] = "SET_PIN_USER_CHANGE_CONFIRM_PIN";
    ActionType["UserChangePin"] = "SET_PIN_USER_CHANGE_PIN";
    return ActionType;
}({});
const $41708348d2f204d8$export$8789045e6aca717c = ()=>({
        type: "SET_PIN_DONE"
    });
const $41708348d2f204d8$export$c81c36414a1e3192 = (cardToken)=>({
        type: "SET_PIN_INITIALIZE",
        cardToken: cardToken
    });
const $41708348d2f204d8$export$b128ee3182fea17d = ()=>({
        type: "SET_PIN_SET_PIN"
    });
const $41708348d2f204d8$export$18ce6532235c33d5 = (response)=>({
        type: "SET_PIN_RECEIVED",
        response: response
    });
const $41708348d2f204d8$export$b482c06046986f66 = (error)=>({
        type: "SET_PIN_REJECTED",
        error: error
    });
const $41708348d2f204d8$export$7fccafb1bae4775a = (confirmPin)=>({
        type: "SET_PIN_USER_CHANGE_CONFIRM_PIN",
        confirmPin: confirmPin
    });
const $41708348d2f204d8$export$6e1c9a50e77df720 = (pin)=>({
        type: "SET_PIN_USER_CHANGE_PIN",
        pin: pin
    });
function $41708348d2f204d8$var$handleSetPin(context, state) {
    const { cardToken: cardToken, pin: pin, confirmPin: confirmPin } = state;
    const pinError = [];
    const confirmPinError = [];
    const error = [];
    if (pin.length !== $41708348d2f204d8$var$PIN_LENGTH) pinError.push("VALUE_ERROR_INVALID_LENGTH");
    if (confirmPin.length !== $41708348d2f204d8$var$PIN_LENGTH) confirmPinError.push("VALUE_ERROR_INVALID_LENGTH");
    if (pin.length === $41708348d2f204d8$var$PIN_LENGTH && confirmPin.length === $41708348d2f204d8$var$PIN_LENGTH && pin !== confirmPin) error.push("ERROR_INVALID_PIN_MATCH");
    const hasError = confirmPinError.length || error.length || pinError.length;
    const work = ()=>{
        if (hasError) return null;
        return context.setPin((0, $d272bac0a1712861$export$6129867d2a9d1edf).create({
            cardToken: cardToken,
            pin: pin
        })).then($41708348d2f204d8$export$18ce6532235c33d5, $41708348d2f204d8$export$b482c06046986f66);
    };
    return [
        {
            ...state,
            confirmPinError: confirmPinError,
            error: error,
            loading: !hasError,
            pinError: pinError
        },
        work
    ];
}
function $41708348d2f204d8$var$handleSetPinReceived(_context, state, action) {
    const { errors: errors } = action.response;
    if (errors.length === 0) return [
        {
            ...state,
            loading: false
        },
        $41708348d2f204d8$export$8789045e6aca717c
    ];
    // Client will handle one error at a time, the first one.
    switch(errors[0]){
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_INVALID_CARD_TOKEN:
            return [
                {
                    ...state,
                    confirmPinError: [
                        "VALUE_ERROR_INVALID_LENGTH"
                    ],
                    pinError: [
                        "VALUE_ERROR_INVALID_LENGTH"
                    ],
                    loading: false
                },
                null
            ];
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_WEAK_PIN:
            return [
                {
                    ...state,
                    error: [
                        ...state.error,
                        "ERROR_WEAK_PIN"
                    ],
                    loading: false
                },
                null
            ];
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_UNAUTHORIZED:
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_DO_NOT_USE:
            return [
                {
                    ...state,
                    error: [
                        ...state.error,
                        "ERROR_GENERIC"
                    ],
                    loading: false
                },
                null
            ];
    }
}
function $41708348d2f204d8$var$handleSetPinRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`SetPin error - ${error}`);
    return [
        {
            ...state,
            error: [
                ...state.error,
                "ERROR_GENERIC"
            ],
            loading: false
        },
        null
    ];
}
function $41708348d2f204d8$var$handleUserChangeConfirmPin(state, action) {
    const { confirmPin: confirmPin } = action;
    return [
        {
            ...state,
            confirmPin: confirmPin,
            confirmPinError: []
        },
        null
    ];
}
function $41708348d2f204d8$var$handleUserChangePin(state, action) {
    const { pin: pin } = action;
    return [
        {
            ...state,
            pin: pin,
            pinError: []
        },
        null
    ];
}
const $41708348d2f204d8$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "SET_PIN_DONE":
                // noop action to watch for done
                return [
                    state,
                    null
                ];
            case "SET_PIN_INITIALIZE":
                return [
                    {
                        ...$41708348d2f204d8$export$36d128238e6b60f5,
                        cardToken: action.cardToken
                    },
                    null
                ];
            case "SET_PIN_SET_PIN":
                return $41708348d2f204d8$var$handleSetPin(context, state);
            case "SET_PIN_RECEIVED":
                return $41708348d2f204d8$var$handleSetPinReceived(context, state, action);
            case "SET_PIN_REJECTED":
                return $41708348d2f204d8$var$handleSetPinRejected(context, state, action);
            case "SET_PIN_USER_CHANGE_CONFIRM_PIN":
                return $41708348d2f204d8$var$handleUserChangeConfirmPin(state, action);
            case "SET_PIN_USER_CHANGE_PIN":
                return $41708348d2f204d8$var$handleUserChangePin(state, action);
        }
    };
const $41708348d2f204d8$var$setPin = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($41708348d2f204d8$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $41708348d2f204d8$export$2e2bcd8739ae039 = $41708348d2f204d8$var$setPin;





var $91a4cf0fed9238a4$export$6b43b4121596bf23 = /*#__PURE__*/ function(CardDetailsInputError) {
    CardDetailsInputError["Empty"] = "CARD_DETAIL_INPUT_ERROR_EMPTY";
    return CardDetailsInputError;
}({});
var $91a4cf0fed9238a4$export$8e65f9a47a3365d = /*#__PURE__*/ function(CardDetailsError) {
    CardDetailsError["InvalidCvcExpiryDate"] = "CARD_DETAILS_ERROR_INVALID_CVC_EXPIRY_DATE";
    return CardDetailsError;
}({});
var $91a4cf0fed9238a4$export$73ffda178c022f15 = /*#__PURE__*/ function(CardActivationError) {
    CardActivationError[CardActivationError["None"] = 0] = "None";
    CardActivationError[CardActivationError["Generic"] = 1] = "Generic";
    return CardActivationError;
}({});
var $91a4cf0fed9238a4$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["Details"] = 0] = "Details";
    Screen[Screen["Pin"] = 1] = "Pin";
    Screen[Screen["Success"] = 2] = "Success";
    Screen[Screen["Error"] = 3] = "Error";
    return Screen;
}({});
const $91a4cf0fed9238a4$export$36d128238e6b60f5 = {
    cardDetailsValidationErrors: {
        cvc: [],
        expiryDate: [],
        cardDetails: []
    },
    cardToken: "",
    cvcValue: "",
    done: false,
    error: 0,
    expiryDateValue: null,
    isLoading: false,
    modalOpen: false,
    screen: 0,
    setPinState: $41708348d2f204d8$export$e6a0daad8304de()
};
const $91a4cf0fed9238a4$export$e6a0daad8304de = (overrides = {})=>({
        ...$91a4cf0fed9238a4$export$36d128238e6b60f5,
        ...overrides
    });
var $91a4cf0fed9238a4$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["ActivateCardReceived"] = "ACTIVATE_CARD_RECEIVED";
    ActionType["ActivateCardRejected"] = "ACTIVATE_CARD_REJECTED";
    ActionType["Done"] = "Done";
    ActionType["Initialize"] = "INITIALIZE";
    ActionType["NavigateToScreen"] = "NAVIGATE_TO_SCREEN";
    ActionType["SetError"] = "SET_ERROR";
    ActionType["ToggleLoading"] = "TOGGLE_LOADING";
    ActionType["ToggleModal"] = "TOGGLE_MODAL";
    ActionType["UserChangeCvc"] = "USER_CHANGE_CVC";
    ActionType["UserChangeExpiryDate"] = "USER_CHANGE_EXPIRY_DATE";
    ActionType["UserClickNext"] = "USER_CLICK_NEXT";
    return ActionType;
}({});
const $91a4cf0fed9238a4$export$5c8fbc33f44710ab = (response)=>({
        type: "ACTIVATE_CARD_RECEIVED",
        response: response
    });
const $91a4cf0fed9238a4$export$ddaa186bd434f499 = (error)=>({
        type: "ACTIVATE_CARD_REJECTED",
        error: error
    });
const $91a4cf0fed9238a4$export$8789045e6aca717c = ()=>({
        type: "Done"
    });
const $91a4cf0fed9238a4$export$a7b94443be12fd7b = (screen)=>({
        type: "NAVIGATE_TO_SCREEN",
        screen: screen
    });
const $91a4cf0fed9238a4$export$c81c36414a1e3192 = (cardToken)=>({
        type: "INITIALIZE",
        cardToken: cardToken
    });
const $91a4cf0fed9238a4$export$8f12bad0f165bfad = (error)=>({
        type: "SET_ERROR",
        error: error
    });
const $91a4cf0fed9238a4$export$e125175ee6544919 = (value)=>({
        type: "TOGGLE_LOADING",
        value: value
    });
const $91a4cf0fed9238a4$export$2085928ad4455e61 = (value)=>({
        type: "TOGGLE_MODAL",
        value: value
    });
const $91a4cf0fed9238a4$export$6e6290200ceb68b4 = (value)=>({
        type: "USER_CHANGE_CVC",
        value: value
    });
const $91a4cf0fed9238a4$export$b758c0ba8238b576 = (value)=>({
        type: "USER_CHANGE_EXPIRY_DATE",
        value: value
    });
const $91a4cf0fed9238a4$export$69864c1ae20800a8 = ()=>({
        type: "USER_CLICK_NEXT"
    });
// Update
// =============================================================================
function $91a4cf0fed9238a4$var$handleActivateCardReceived(context, state, action) {
    const { error: error } = action.response;
    if (error === (0, $d272bac0a1712861$export$7dde42e884f2d048).ActivateCardError.ACTIVATE_CARD_ERROR_INVALID_CVV_OR_EXPIRATION) {
        const { cardDetailsValidationErrors: cardDetailsValidationErrors } = state;
        return [
            {
                ...state,
                cardDetailsValidationErrors: {
                    ...cardDetailsValidationErrors,
                    cardDetails: [
                        ...cardDetailsValidationErrors.cardDetails,
                        "CARD_DETAILS_ERROR_INVALID_CVC_EXPIRY_DATE"
                    ]
                },
                isLoading: false
            },
            null
        ];
    }
    return context.canUpdatePin ? [
        {
            ...state,
            screen: 1,
            isLoading: false
        },
        ()=>$41708348d2f204d8$export$c81c36414a1e3192(state.cardToken)
    ] : [
        {
            ...state,
            screen: 2,
            isLoading: false
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleActivateCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$91a4cf0fed9238a4$export$8f12bad0f165bfad(1)
    ];
}
function $91a4cf0fed9238a4$var$handleInitialize(context, state, action) {
    const { cardToken: cardToken } = action;
    if (cardToken.length === 0) {
        context.sentry.captureException("Card activation: card token is empty string");
        return [
            {
                ...$91a4cf0fed9238a4$export$36d128238e6b60f5,
                modalOpen: true
            },
            ()=>$91a4cf0fed9238a4$export$8f12bad0f165bfad(1)
        ];
    }
    return [
        {
            ...$91a4cf0fed9238a4$export$36d128238e6b60f5,
            cardToken: cardToken,
            modalOpen: true
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleNavigateToScreen(state, action) {
    const { screen: screen } = action;
    return [
        {
            ...state,
            screen: screen
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleSetError(state, action) {
    const { error: error } = action;
    return [
        {
            ...state,
            error: error,
            screen: 3
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleToggleLoading(state, action) {
    const { value: value } = action;
    return [
        {
            ...state,
            isLoading: value
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleToggleModal(context, state, action) {
    const { value: value } = action;
    const nextAction = state.screen === 2 ? $91a4cf0fed9238a4$export$8789045e6aca717c : null;
    return [
        {
            ...state,
            modalOpen: value
        },
        nextAction
    ];
}
function $91a4cf0fed9238a4$var$handleUserChangeCvc(state, action) {
    const { value: value } = action;
    const cardDetailsValidationErrors = {
        ...state.cardDetailsValidationErrors,
        cardDetails: [],
        cvc: []
    };
    return [
        {
            ...state,
            cvcValue: value,
            cardDetailsValidationErrors: cardDetailsValidationErrors
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleUserChangeExpiryDate(state, action) {
    const { value: value } = action;
    const cardDetailsValidationErrors = {
        ...state.cardDetailsValidationErrors,
        cardDetails: [],
        expiryDate: []
    };
    return [
        {
            ...state,
            expiryDateValue: value,
            cardDetailsValidationErrors: cardDetailsValidationErrors
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleUserClickNext(context, state) {
    const { screen: screen, cvcValue: cvcValue, expiryDateValue: expiryDateValue } = state;
    switch(screen){
        case 0:
            {
                const expiryDateErrors = expiryDateValue === null ? [
                    "CARD_DETAIL_INPUT_ERROR_EMPTY"
                ] : [];
                const cvcErrors = cvcValue.length === 0 ? [
                    "CARD_DETAIL_INPUT_ERROR_EMPTY"
                ] : [];
                if (expiryDateErrors.length || cvcErrors.length) return [
                    {
                        ...state,
                        cardDetailsValidationErrors: {
                            ...state.cardDetailsValidationErrors,
                            cvc: cvcErrors,
                            expiryDate: expiryDateErrors
                        }
                    },
                    null
                ];
                const { cardToken: cardToken } = state;
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(expiryDateValue, "expiryDateValue is null");
                const work = ()=>context.cardManagementService.activateCard((0, $d272bac0a1712861$export$7e4385b3b341704b).create({
                        cardToken: cardToken,
                        cvv: cvcValue,
                        expiration: (0, $63d33be972ac5a3a$export$b707805e12671f51).create({
                            monthOfYear: expiryDateValue.month,
                            year: expiryDateValue.year
                        })
                    })).then($91a4cf0fed9238a4$export$5c8fbc33f44710ab, $91a4cf0fed9238a4$export$ddaa186bd434f499);
                return [
                    {
                        ...state,
                        isLoading: true
                    },
                    work
                ];
            }
        case 1:
            return [
                {
                    ...state,
                    screen: 2
                },
                null
            ];
        case 2:
            return [
                state,
                $91a4cf0fed9238a4$export$8789045e6aca717c
            ];
        case 3:
            return [
                state,
                null
            ];
    }
}
const $91a4cf0fed9238a4$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "ACTIVATE_CARD_RECEIVED":
                return $91a4cf0fed9238a4$var$handleActivateCardReceived(context, state, action);
            case "ACTIVATE_CARD_REJECTED":
                return $91a4cf0fed9238a4$var$handleActivateCardRejected(context, state, action);
            case "Done":
                return [
                    {
                        ...state,
                        done: true,
                        modalOpen: false
                    },
                    null
                ];
            case "INITIALIZE":
                return $91a4cf0fed9238a4$var$handleInitialize(context, state, action);
            case "NAVIGATE_TO_SCREEN":
                return $91a4cf0fed9238a4$var$handleNavigateToScreen(state, action);
            case "SET_ERROR":
                return $91a4cf0fed9238a4$var$handleSetError(state, action);
            case "TOGGLE_LOADING":
                return $91a4cf0fed9238a4$var$handleToggleLoading(state, action);
            case "TOGGLE_MODAL":
                return $91a4cf0fed9238a4$var$handleToggleModal(context, state, action);
            case "USER_CHANGE_CVC":
                return $91a4cf0fed9238a4$var$handleUserChangeCvc(state, action);
            case "USER_CHANGE_EXPIRY_DATE":
                return $91a4cf0fed9238a4$var$handleUserChangeExpiryDate(state, action);
            case "USER_CLICK_NEXT":
                return $91a4cf0fed9238a4$var$handleUserClickNext(context, state);
            case $41708348d2f204d8$export$e4a712fff93fb00f.Done:
            case $41708348d2f204d8$export$e4a712fff93fb00f.Initialize:
            case $41708348d2f204d8$export$e4a712fff93fb00f.SetPin:
            case $41708348d2f204d8$export$e4a712fff93fb00f.SetPinReceived:
            case $41708348d2f204d8$export$e4a712fff93fb00f.SetPinRejected:
            case $41708348d2f204d8$export$e4a712fff93fb00f.UserChangeConfirmPin:
            case $41708348d2f204d8$export$e4a712fff93fb00f.UserChangePin:
                {
                    const update = $41708348d2f204d8$export$722fbec263ad908a({
                        sentry: context.sentry,
                        setPin: context.setPin,
                        uuid: context.uuid
                    });
                    const [nextState, nextActions] = update(state.setPinState, action);
                    return [
                        {
                            ...state,
                            setPinState: nextState
                        },
                        action.type === $41708348d2f204d8$export$e4a712fff93fb00f.Done ? $91a4cf0fed9238a4$export$69864c1ae20800a8 : nextActions
                    ];
                }
        }
    };
const $91a4cf0fed9238a4$var$debitCardActivation = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($91a4cf0fed9238a4$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $91a4cf0fed9238a4$export$2e2bcd8739ae039 = $91a4cf0fed9238a4$var$debitCardActivation;












var $9ba2892e041037f1$export$2ba01fb71ed41cb6;
var $9ba2892e041037f1$export$2daf5cbeed728edf;
var $9ba2892e041037f1$export$d3baea09c0a68887;
var $9ba2892e041037f1$export$f22da7240b7add18;
$9ba2892e041037f1$export$2ba01fb71ed41cb6 = `FTqktG_CardActivationEnterDetails_button`;
$9ba2892e041037f1$export$2daf5cbeed728edf = `FTqktG_CardActivationEnterDetails_inputFields`;
$9ba2892e041037f1$export$d3baea09c0a68887 = `FTqktG_CardActivationEnterDetails_inputFieldsContainer`;
$9ba2892e041037f1$export$f22da7240b7add18 = `FTqktG_CardActivationEnterDetails_main`;


function $272930093305839e$export$f2c5c7ab1f242baa({ cardDetailsError: cardDetailsError, cvc: cvc, cvcError: cvcError, expiryDate: expiryDate, expiryDateError: expiryDateError, loading: loading = false, onCvcChange: onCvcChange, onExpiryDateChange: onExpiryDateChange, onNextClick: onNextClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-activation", {
        keyPrefix: "enterDetails"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$95abf1952846aff4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: t("title")
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: $9ba2892e041037f1$export$f22da7240b7add18,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "paragraph-30",
                        children: t("description")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $61293f7622d5ba04$export$bf9d3c0d17a2f99e), {
                        className: $9ba2892e041037f1$export$d3baea09c0a68887,
                        invalid: cardDetailsError.length > 0,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: $9ba2892e041037f1$export$2daf5cbeed728edf,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                        error: expiryDateError,
                                        formatter: new (0, $58cb02b9641cce25$exports.ExpiryDateFormatter)(),
                                        label: t("inputLabelExpiryDate"),
                                        name: t("inputLabelExpiryDate"),
                                        value: expiryDate || undefined,
                                        onTextChange: onExpiryDateChange
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                        error: cvcError,
                                        label: t("inputLabelCVC"),
                                        maxlength: 4,
                                        name: t("inputLabelCVC"),
                                        value: cvc,
                                        onTextChange: onCvcChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                slot: "error",
                                children: cardDetailsError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                        className: $9ba2892e041037f1$export$2ba01fb71ed41cb6,
                        rank: "primary",
                        isLoading: loading,
                        onClick: onNextClick,
                        children: t("buttonText")
                    })
                ]
            })
        ]
    });
}


const $5defc9b8dec84daf$var$getCardDetailsErrorText = (t)=>(errors)=>{
        for(let i = 0; i < errors.length; i++){
            const error = errors[i];
            switch(error){
                case (0, $91a4cf0fed9238a4$export$8e65f9a47a3365d).InvalidCvcExpiryDate:
                    return t("errors.cardDetailsDoesNotMatch");
            }
        }
        return "";
    };
const $5defc9b8dec84daf$var$getCvcErrorText = (t)=>(errors)=>{
        for(let i = 0; i < errors.length; i++){
            const error = errors[i];
            switch(error){
                case (0, $91a4cf0fed9238a4$export$6b43b4121596bf23).Empty:
                    return t("errors.cvcEmpty");
            }
        }
        return "";
    };
const $5defc9b8dec84daf$var$getExpiryDateErrorText = (t)=>(errors)=>{
        for(let i = 0; i < errors.length; i++){
            const error = errors[i];
            switch(error){
                case (0, $91a4cf0fed9238a4$export$6b43b4121596bf23).Empty:
                    return t("errors.expiryDateEmpty");
            }
        }
        return "";
    };
const $5defc9b8dec84daf$export$14cd645e3e4b4681 = (t)=>(errors)=>{
        const cvcError = $5defc9b8dec84daf$var$getCvcErrorText(t)(errors.cvc);
        const expiryDateError = $5defc9b8dec84daf$var$getExpiryDateErrorText(t)(errors.expiryDate);
        return {
            // Prioritize input error over screen error
            cardDetailsError: cvcError === "" && expiryDateError === "" ? $5defc9b8dec84daf$var$getCardDetailsErrorText(t)(errors.cardDetails) : "",
            cvcError: cvcError,
            expiryDateError: expiryDateError
        };
    };
function $5defc9b8dec84daf$export$5d4f271475ebc706({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-activation", {
        keyPrefix: "enterDetails"
    });
    const { cardDetailsError: cardDetailsError, cvcError: cvcError, expiryDateError: expiryDateError } = $5defc9b8dec84daf$export$14cd645e3e4b4681(t)(state.cardDetailsValidationErrors);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $272930093305839e$export$f2c5c7ab1f242baa), {
        cardDetailsError: cardDetailsError,
        cvc: state.cvcValue,
        cvcError: cvcError,
        expiryDate: state.expiryDateValue,
        expiryDateError: expiryDateError,
        loading: state.isLoading,
        onCvcChange: (value)=>dispatch((0, $91a4cf0fed9238a4$export$6e6290200ceb68b4)(value)),
        onExpiryDateChange: (value)=>dispatch((0, $91a4cf0fed9238a4$export$b758c0ba8238b576)(value)),
        onNextClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$69864c1ae20800a8)())
    });
}






parcelRequire("acw62");
const $0a5ae922de365778$var$SvgConfirmation = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 88,
        height: 88,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 88,
                height: 88,
                fill: "#006AFF",
                fillOpacity: 0.1,
                rx: 44
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#006AFF",
                fillRule: "evenodd",
                d: "M26 44c0-9.94 8.06-18 18-18s18 8.06 18 18-8.06 18-18 18-18-8.06-18-18m4 0c0 7.72 6.28 14 14 14s14-6.28 14-14-6.28-14-14-14-14 6.28-14 14m7.42-2.4L42 46.18l8.62-8.58 2.82 2.82-10 10c-.4.38-.9.58-1.42.58s-1.02-.18-1.42-.58l-6-6z",
                clipRule: "evenodd"
            })
        ]
    });
var $0a5ae922de365778$export$2e2bcd8739ae039 = $0a5ae922de365778$var$SvgConfirmation;


var $700ab6bfc2f3c54a$export$2ba01fb71ed41cb6;
var $700ab6bfc2f3c54a$export$34e0f9847d4c02dd;
var $700ab6bfc2f3c54a$export$6d59db4903f20f7d;
var $700ab6bfc2f3c54a$export$46e4a324ac90507f;
$700ab6bfc2f3c54a$export$2ba01fb71ed41cb6 = `LPNBGa_CardActivationConfirmation_button`;
$700ab6bfc2f3c54a$export$34e0f9847d4c02dd = `LPNBGa_CardActivationConfirmation_container`;
$700ab6bfc2f3c54a$export$6d59db4903f20f7d = `LPNBGa_CardActivationConfirmation_description`;
$700ab6bfc2f3c54a$export$46e4a324ac90507f = `LPNBGa_CardActivationConfirmation_heading`;



function $6b654f6b05c2e118$export$2ed00321646e1191({ onDoneClick: onDoneClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-activation", {
        keyPrefix: "confirmation"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $700ab6bfc2f3c54a$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a5ae922de365778$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("heading-30", (0, $700ab6bfc2f3c54a$export$46e4a324ac90507f)),
                children: t("title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("paragraph-30", (0, $700ab6bfc2f3c54a$export$6d59db4903f20f7d)),
                children: t("description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                className: (0, $700ab6bfc2f3c54a$export$2ba01fb71ed41cb6),
                rank: "primary",
                onClick: onDoneClick,
                children: t("buttonText")
            })
        ]
    });
}





function $a8e20f7a92ec925f$export$6181f13aeb5b530f({ children: children, onClose: onClose }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$4fa994bc91bf3e1), {
        onMarketDialogDismissed: (0, $ca1292c5dc2fbd33$export$3a4e95f5f650d5aa)(onClose),
        children: children
    });
}







var $64ecc05438fc4dba$export$2ba01fb71ed41cb6;
var $64ecc05438fc4dba$export$6d59db4903f20f7d;
var $64ecc05438fc4dba$export$a3bc9b8ed74fc;
var $64ecc05438fc4dba$export$6210fa4921d2a466;
var $64ecc05438fc4dba$export$7b388ca536128c6d;
var $64ecc05438fc4dba$export$f22da7240b7add18;
var $64ecc05438fc4dba$export$9f616b728e5a5e80;
$64ecc05438fc4dba$export$2ba01fb71ed41cb6 = `_14oPQW_SetPin_button`;
$64ecc05438fc4dba$export$6d59db4903f20f7d = `_14oPQW_SetPin_description`;
$64ecc05438fc4dba$export$a3bc9b8ed74fc = `_14oPQW_SetPin_error`;
$64ecc05438fc4dba$export$6210fa4921d2a466 = `_14oPQW_SetPin_form`;
$64ecc05438fc4dba$export$7b388ca536128c6d = `_14oPQW_SetPin_inputs`;
$64ecc05438fc4dba$export$f22da7240b7add18 = `_14oPQW_SetPin_main`;
$64ecc05438fc4dba$export$9f616b728e5a5e80 = `_14oPQW_SetPin_market-button`;



parcelRequire("acw62");
const $3180af4f14c2cd8a$var$SvgAlertExclaimationCircle = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M12 21c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9m0-16c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11 7h2v6.5h-2z",
            clipRule: "evenodd"
        })
    });
var $3180af4f14c2cd8a$export$2e2bcd8739ae039 = $3180af4f14c2cd8a$var$SvgAlertExclaimationCircle;


var $ebc0db443cea3b36$export$eec9628ef2c503b1 = /*#__PURE__*/ function(SetPinType) {
    SetPinType["CREATE"] = "CREATE_PIN";
    SetPinType["RESET"] = "RESET_PIN";
    return SetPinType;
}({});
var $ebc0db443cea3b36$export$742f06b032aee827 = /*#__PURE__*/ function(SetPinError) {
    SetPinError["WeakPin"] = "ERROR_WEAK_PIN";
    SetPinError["InvalidPinMatch"] = "ERROR_INVALID_PIN_MATCH";
    SetPinError["GenericError"] = "ERROR_GENERIC";
    return SetPinError;
}({});
var $ebc0db443cea3b36$export$54d4c18dc78a26d4 = /*#__PURE__*/ function(ValueError) {
    ValueError["InvalidLength"] = "VALUE_ERROR_INVALID_LENGTH";
    return ValueError;
}({});
function $ebc0db443cea3b36$export$16fd8f17ceae9f7e({ confirmPin: confirmPin, confirmPinError: confirmPinError, loading: loading = false, pin: pin, pinError: pinError, setPinError: setPinError, showNav: showNav = false, type: type, onConfirmPinChange: onConfirmPinChange, onPinChange: onPinChange, onNavClick: onNavClick, onSubmit: onSubmit }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("pin");
    const getHeader = (type)=>{
        switch(type){
            case "CREATE_PIN":
                return t("title.create");
            case "RESET_PIN":
                return t("title.reset");
        }
    };
    const getButton = (type)=>{
        switch(type){
            case "CREATE_PIN":
                return t("submit.continue");
            case "RESET_PIN":
                return t("submit.save");
        }
    };
    const getConfirmPinError = (error)=>{
        switch(error){
            case "VALUE_ERROR_INVALID_LENGTH":
                return t("error.validInput");
            case undefined:
                return undefined;
            default:
                throw new Error("Unsupported error type");
        }
    };
    const getPinError = (error)=>{
        switch(error){
            case "VALUE_ERROR_INVALID_LENGTH":
                return t("error.validInput");
            case undefined:
                return undefined;
            default:
                throw new Error("Unsupported error type");
        }
    };
    const getSetPinError = (error)=>{
        switch(error){
            case "ERROR_GENERIC":
                return t("error.generic");
            case "ERROR_INVALID_PIN_MATCH":
                return t("error.notMatch");
            case "ERROR_WEAK_PIN":
                return t("error.weak");
            case undefined:
                return undefined;
            default:
                throw new Error("Unsupported error type");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$95abf1952846aff4), {
                showNavigation: showNav,
                onMarketHeaderNavigate: onNavClick,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: getHeader(type)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: $64ecc05438fc4dba$export$f22da7240b7add18,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "paragraph-30",
                        children: t("description")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        "data-testid": "form-pin",
                        className: $64ecc05438fc4dba$export$6210fa4921d2a466,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                error: getPinError(pinError),
                                label: t("inputLabel.pin"),
                                name: t("inputLabel.pin"),
                                type: "number",
                                value: pin,
                                onTextChange: onPinChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                error: getConfirmPinError(confirmPinError),
                                label: t("inputLabel.confirmPin"),
                                name: t("inputLabel.confirmPin"),
                                type: "number",
                                value: confirmPin,
                                onTextChange: onConfirmPinChange
                            })
                        ]
                    }),
                    setPinError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $64ecc05438fc4dba$export$a3bc9b8ed74fc,
                        "data-testid": "error-message",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3180af4f14c2cd8a$export$2e2bcd8739ae039), {}),
                            getSetPinError(setPinError)
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$862a33790ffda48f), {
                        className: $64ecc05438fc4dba$export$2ba01fb71ed41cb6,
                        rank: "primary",
                        isLoading: loading,
                        onClick: onSubmit,
                        children: getButton(type)
                    })
                ]
            })
        ]
    });
}





function $45b78035b1c1170e$export$1f17c7406440bd8e({ state: state, dispatch: dispatch, showNav: showNav, type: type, onNavClick: onNavClick }) {
    /**
   * These error seem very similar but the errors in workflow and the component
   * may diverge. We do not want to couple presentational and functionality
   */ const mapValueError = (error)=>{
        switch(error){
            case (0, $41708348d2f204d8$export$54d4c18dc78a26d4).InvalidLength:
                return (0, $ebc0db443cea3b36$export$54d4c18dc78a26d4).InvalidLength;
        }
    };
    const mapSetPinError = (error)=>{
        switch(error){
            case (0, $41708348d2f204d8$export$edf27be85e5f6da0).GenericError:
                return (0, $ebc0db443cea3b36$export$742f06b032aee827).GenericError;
            case (0, $41708348d2f204d8$export$edf27be85e5f6da0).InvalidPinMatch:
                return (0, $ebc0db443cea3b36$export$742f06b032aee827).InvalidPinMatch;
            case (0, $41708348d2f204d8$export$edf27be85e5f6da0).WeakPin:
                return (0, $ebc0db443cea3b36$export$742f06b032aee827).WeakPin;
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc0db443cea3b36$export$16fd8f17ceae9f7e), {
        type: type,
        confirmPin: state.confirmPin,
        confirmPinError: state.confirmPinError.length ? mapValueError(state.confirmPinError[0]) : undefined,
        loading: state.loading,
        pin: state.pin,
        pinError: state.pinError.length ? mapValueError(state.pinError[0]) : undefined,
        setPinError: state.error.length ? mapSetPinError(state.error[0]) : undefined,
        showNav: showNav,
        onConfirmPinChange: (confirmPin)=>dispatch((0, $41708348d2f204d8$export$7fccafb1bae4775a)(confirmPin)),
        onPinChange: (pin)=>dispatch((0, $41708348d2f204d8$export$6e1c9a50e77df720)(pin)),
        onNavClick: onNavClick,
        onSubmit: ()=>dispatch((0, $41708348d2f204d8$export$b128ee3182fea17d)())
    });
}


function $d4b4a79186728168$export$e4086be69ab38865({ state: state, dispatch: dispatch }) {
    const getChildren = (state)=>{
        switch(state.screen){
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Details:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5defc9b8dec84daf$export$5d4f271475ebc706), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Pin:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45b78035b1c1170e$export$1f17c7406440bd8e), {
                    state: state.setPinState,
                    dispatch: dispatch,
                    showNav: true,
                    type: (0, $ebc0db443cea3b36$export$eec9628ef2c503b1).CREATE,
                    onNavClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$2085928ad4455e61)(false))
                });
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Success:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b654f6b05c2e118$export$2ed00321646e1191), {
                    onDoneClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$69864c1ae20800a8)())
                });
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Error:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ac4cb382475bb7$export$ea52035eac03daf0), {
                    onButtonClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$2085928ad4455e61)(false))
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8e20f7a92ec925f$export$6181f13aeb5b530f), {
        active: state.modalOpen,
        onClose: ()=>dispatch((0, $91a4cf0fed9238a4$export$2085928ad4455e61)(false)),
        children: getChildren(state)
    });
}





const $66549f7d84306a62$var$redirectAfterClose = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[prevState, state], action])=>action.type === (0, $91a4cf0fed9238a4$export$e4a712fff93fb00f).Done || // Only on open -> closed: the header X and the modal dismiss both toggle it closed.
        action.type === (0, $91a4cf0fed9238a4$export$e4a712fff93fb00f).ToggleModal && prevState.modalOpen && !state.modalOpen), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_, state], _action])=>{
        const done = state.screen === (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Success || state.done;
        // redirects to card settings if card is activated successfully
        // otherwise redirect back to parent route
        const to = done ? `/card/${state.cardToken}/settings` : "../.";
        const locationState = done ? {
            cardActivation: {
                // Handle case where user closes modal on success screen
                done: state.screen === (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Success || state.done
            }
        } : undefined;
        return {
            to: to,
            options: {
                replace: true,
                state: locationState
            }
        };
    }));
const $66549f7d84306a62$var$navigation = (source)=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(...[
        $66549f7d84306a62$var$redirectAfterClose
    ].map((transition)=>source.pipe(transition))).pipe((0, $4707859e785b3da6$export$18aef43295bbe906)());
var $66549f7d84306a62$export$2e2bcd8739ae039 = $66549f7d84306a62$var$navigation;


function $6c405fcdac0fc35b$export$d5dbd6e4860c3b3c({ cardManagementService: cardManagementService, cardToken: cardToken }) {
    const launchDarklyClient = (0, $ea440760c63f6861$export$43f174d627cf7c49)((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad), {
        token: "anonymousUser",
        type: (0, $1f14c967a58ea158$export$f435f793048e7a0f).ANONYMOUS_VISITOR
    });
    const loadingIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$28c2b904b2ab5c88), {});
    return launchDarklyClient.flagsLoaded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6c405fcdac0fc35b$export$cc77469cad146b51, {
        canUpdatePin: launchDarklyClient.getFlagValue((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad).canUpdatePin)?.valueOf() ?? false,
        cardManagementService: cardManagementService,
        cardToken: cardToken
    }) : loadingIndicator;
}
function $6c405fcdac0fc35b$export$cc77469cad146b51({ canUpdatePin: canUpdatePin, cardManagementService: cardManagementService, cardToken: cardToken }) {
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    const [state, dispatch, workflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        cardManagementService: cardManagementService,
        canUpdatePin: canUpdatePin,
        sentry: {
            captureException: $f2b90654edf2c0a1$export$f5282963edea4a68
        },
        setPin: cardManagementService.setPin.bind(cardManagementService),
        uuid: $5sKyw.default
    }, $91a4cf0fed9238a4$export$e6a0daad8304de(), $91a4cf0fed9238a4$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        const subscriptions = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscriptions.add(workflow.updates.pipe((0, $66549f7d84306a62$export$2e2bcd8739ae039)).subscribe((nav)=>navigate(nav.to, nav.options)));
        dispatch($91a4cf0fed9238a4$export$c81c36414a1e3192(cardToken));
        return ()=>{
            subscriptions.unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4b4a79186728168$export$e4086be69ab38865), {
        state: state,
        dispatch: dispatch
    });
}


const $d75344a988d25c32$var$InjectedWorkflowContainedCardActivationModal = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $6c405fcdac0fc35b$export$d5dbd6e4860c3b3c), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE
});
const $d75344a988d25c32$export$9e7f6294aedab850 = (0, $eb322dd52f4d040c$export$fcd084e6273b1578)($d75344a988d25c32$var$InjectedWorkflowContainedCardActivationModal, {
    cardToken: "cardToken"
});







var $acw62 = parcelRequire("acw62");






var $5sKyw = parcelRequire("5sKyw");




function $70708f7aebe7b790$export$6e2f6812128e86b8({ cardManagementService: cardManagementService, cardToken: cardToken, type: type }) {
    // NOTE(cvu): hardcoding navigation back only for set/reset pin.
    const navigate = (0, $baf2581b6f4e4c0a$export$9770f232ac06a008)();
    // The header X fires both onMarketHeaderNavigate and onMarketDialogDismissed.
    const closed = (0, $acw62.useRef)(false);
    const onNavClick = ()=>{
        if (closed.current) return;
        closed.current = true;
        navigate(`/card/${cardToken}/settings`, {
            replace: true
        });
    };
    const [state, dispatch, workflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        sentry: {
            captureException: $f2b90654edf2c0a1$export$f5282963edea4a68
        },
        setPin: cardManagementService.setPin.bind(cardManagementService),
        uuid: $5sKyw.default
    }, $41708348d2f204d8$export$e6a0daad8304de(), $41708348d2f204d8$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        const subscriptions = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscriptions.add(workflow.updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, action])=>action.type === $41708348d2f204d8$export$e4a712fff93fb00f.Done)).subscribe(()=>onNavClick()));
        dispatch($41708348d2f204d8$export$c81c36414a1e3192(cardToken));
        return ()=>{
            subscriptions.unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$4fa994bc91bf3e1), {
        onMarketDialogDismissed: (0, $ca1292c5dc2fbd33$export$3a4e95f5f650d5aa)(onNavClick),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45b78035b1c1170e$export$1f17c7406440bd8e), {
            state: state,
            dispatch: dispatch,
            showNav: true,
            type: type,
            onNavClick: onNavClick
        })
    });
}


const $056f39cb2284108a$var$InjectedWorkflowContainedSetPinModal = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $70708f7aebe7b790$export$6e2f6812128e86b8), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE
});
const $056f39cb2284108a$export$e69d35ecf5312a84 = (0, $eb322dd52f4d040c$export$fcd084e6273b1578)($056f39cb2284108a$var$InjectedWorkflowContainedSetPinModal, {
    cardToken: "cardToken"
});



/**
 * PageRouter is used to handle which page and elements render at certain routes.
 */ const $b3c1eeb19c22229f$var$router = (0, $5cec2af50e95548c$export$1f3f55432a00e06d)([
    {
        path: "",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $becdf5d7bd69726e$export$be92b6f5f03c0fe9), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88be25437d5209b9$export$13f025e534889db5), {}),
                children: [
                    {
                        path: "/activate-card/:cardToken",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d75344a988d25c32$export$9e7f6294aedab850), {})
                    }
                ]
            },
            {
                path: "/card/:cardToken/settings",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa5c35d73b6afd6$export$fdf04d45b6511766), {}),
                children: [
                    {
                        path: "/card/:cardToken/settings/activate-card",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d75344a988d25c32$export$9e7f6294aedab850), {})
                    },
                    {
                        path: "/card/:cardToken/settings/reset-pin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056f39cb2284108a$export$e69d35ecf5312a84), {
                            type: (0, $ebc0db443cea3b36$export$eec9628ef2c503b1).RESET
                        })
                    }
                ]
            },
            {
                path: "/card/:cardToken/status",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9b8f95d28dd1cc4$export$cc5a44eb2bffd45a), {})
            }
        ]
    }
]);
var $b3c1eeb19c22229f$export$2e2bcd8739ae039 = $b3c1eeb19c22229f$var$router;







function $cd93687958c8007e$export$86fbec116b87613f({ bootstrap: bootstrap, diContainer: diContainer }) {
    // TODO(cvu): figure out what the actual title should be
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site");
    const title = t("title");
    (0, $acw62.useEffect)(()=>{
        document.title = title;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e79fd8d87f78889$export$4dda1981a34a6aa4), {
        value: diContainer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb48b27410e45132$export$e6e3537859e84918), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a9ee46bb299cc77$export$88f24fd8fcfab6ca), {
                initialUser: bootstrap.user,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4f881c141a2f86c$export$a2c75276dce92780), {
                    environment: (0, $078609d239e2b7c3$export$57570b1603cf6adb)(),
                    personToken: bootstrap.user.personToken,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1faf284ef8693bcb$export$323e4fc2fa4753fb), {
                        router: (0, $b3c1eeb19c22229f$export$2e2bcd8739ae039)
                    })
                })
            })
        })
    });
}


function $3c39250b670ce798$export$f6a06b563a614935({ diContainer: diContainer }) {
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [authenticated, setAuthenticated] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const webService = diContainer.WEB_SERVICE;
        webService.getBootstrap((0, $fce501362cc81cfc$export$fed1fc70f4110737).create()).then((response)=>{
            if (response.unauthenticated) window.location.replace(new URL(`/login?return_to=${window.location.href}`, (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039)));
            else {
                const { authenticated: authenticated } = response;
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(authenticated, "Missing authenticated from bootstrap");
                const { authorized: authorized, unauthorized: unauthorized } = authenticated;
                if (authorized) setAuthenticated(response.authenticated);
                else {
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(unauthorized, "Missing authorization values");
                    window.location.replace(new URL(`/launchpad`, (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039)));
                }
            }
        }, (0, $f2b90654edf2c0a1$export$f5282963edea4a68));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (authenticated != null) setLoading(false);
    }, [
        authenticated
    ]);
    // TODO(cvu): make better loading
    const loadingIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61293f7622d5ba04$export$28c2b904b2ab5c88), {});
    return loading ? loadingIndicator : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
        fallback: loadingIndicator,
        children: authenticated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {
            bootstrap: (0, $214b3af3bfc0d570$export$8f5519c5909517b3)(authenticated),
            diContainer: diContainer
        }) : null
    });
}


(async function() {
    (0, $3Tvfn.defineCustomElements)(window);
    document.body.className = (0, $27bb0e5b34358db8$export$32180ef41b15b513);
    (0, $d457a61013135fd1$export$1f7656c617418e15)((0, $078609d239e2b7c3$export$57570b1603cf6adb)());
    // TODO(cvu): decide if this simple dependency container is sufficient or should we use package like rsdi
    const diContainer = await (0, $701d006d22a68e04$export$e9bcd07a423f60d8)();
    const container = document.getElementById("app");
    if (container == null) throw new Error("application failed to mount due to missing HTMLElement with 'app' id");
    (0, $7e96a608cb33bf79$exports.createRoot)(container).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c39250b670ce798$export$f6a06b563a614935), {
        diContainer: diContainer
    }));
})();


//# sourceMappingURL=banking_web.3e22c7c8.js.map
